import { UntypedFormGroup, FormControl, UntypedFormControl, Validators } from '@angular/forms';
import * as i0 from '@angular/core';
import { Injectable, Directive, Inject, Component, LOCALE_ID, inject, NgModule } from '@angular/core';
import uuid from 'uuid/v4';
import { __decorate } from 'tslib';
import * as i1 from '@ngxs/store';
import { createSelector, Action, Selector, State, Select } from '@ngxs/store';
import memoizee from 'memoizee';
import { Observable, BehaviorSubject, ReplaySubject, Subject, fromEvent, from, firstValueFrom, of, forkJoin, Subscription, combineLatest, EMPTY, identity, map as map$1 } from 'rxjs';
import { takeUntil, shareReplay, startWith, map, distinctUntilChanged, take, catchError, switchMap, tap, timeout, skipWhile, filter, debounceTime, skip, finalize, first, publishLast, refCount, withLatestFrom, combineLatestWith } from 'rxjs/operators';
import * as i1$1 from '@ng-bootstrap/ng-bootstrap';
import * as i2 from '@angular/platform-browser';
import * as i3 from '@angular/common';
import { DOCUMENT, formatCurrency, getCurrencySymbol, APP_BASE_HREF, CommonModule } from '@angular/common';
import CryptoJS from 'crypto-js';
import dayjs from 'dayjs';
import { patch, updateItem, iif, insertItem, compose, removeItem, append } from '@ngxs/store/operators';
import * as i1$2 from '@angular/common/http';
import { HttpParams, HttpHeaders, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import * as i2$1 from '@angular/router';
import 'dayjs/locale/es-mx';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjsissameorafter from 'dayjs/plugin/isSameOrAfter';
import dayjsissameorbefore from 'dayjs/plugin/isSameOrBefore';
import dayjslocaledata from 'dayjs/plugin/localeData';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import dayjsminmax from 'dayjs/plugin/minMax';
import dayjstimezone from 'dayjs/plugin/timezone';
import dayjsutc from 'dayjs/plugin/utc';
import _range from 'lodash.range';
import _isString from 'lodash.isstring';
import _get from 'lodash.get';
import _isObjectLike from 'lodash.isobjectlike';
import _merge from 'lodash.merge';
import _isEqual from 'lodash.isequal';
import _isMatch from 'lodash.ismatch';
import _sortBy from 'lodash.sortby';
import _cloneDeep from 'lodash.clonedeep';
import _flatMap from 'lodash.flatmap';
import * as i1$3 from 'ngx-spinner';
import { parsePhoneNumber } from 'libphonenumber-js/min';
import downloadjs from 'downloadjs';
import { Call, Device } from '@twilio/voice-sdk';
import _set from 'lodash.set';

class VnextFormGroup extends UntypedFormGroup {
}
class VnextFormControl extends FormControl {
    constructor(name, formState, validatorOrOpts, asyncValidator) {
        super(formState, validatorOrOpts, asyncValidator);
        this.name = name;
    }
    static create({ name, formState, validatorOrOpts, asyncValidator }) {
        return new VnextFormControl(name, formState, validatorOrOpts, asyncValidator);
    }
}

var SiteType;
(function (SiteType) {
    SiteType["CONSUMER"] = "consumer";
    SiteType["CALL_CENTER"] = "call center";
    SiteType["BROKER"] = "broker";
})(SiteType || (SiteType = {}));
var ConsumerSiteType;
(function (ConsumerSiteType) {
    ConsumerSiteType["RETENTION"] = "retention";
    ConsumerSiteType["ANONYMOUS"] = "anonymous";
    ConsumerSiteType["QUOTING"] = "quoting";
})(ConsumerSiteType || (ConsumerSiteType = {}));

const API_AUTH_STATUS = 'api-auth-status';
var AUTH_STATUS_CODES;
(function (AUTH_STATUS_CODES) {
    AUTH_STATUS_CODES["UNAUTHORIZED"] = "unauthorized";
    AUTH_STATUS_CODES["JWT_LOADING"] = "auth-jwt-loading";
    AUTH_STATUS_CODES["JWT_LOADED"] = "auth-jwt-loaded";
    AUTH_STATUS_CODES["JWT_SAVED"] = "auth-jwt-saved";
    AUTH_STATUS_CODES["JWT_ERROR"] = "auth-jwt-error";
})(AUTH_STATUS_CODES || (AUTH_STATUS_CODES = {}));

class AddErrors {
    constructor(errors) {
        this.errors = errors;
    }
}
AddErrors.type = '[Runtime] Add Error';
class ClearErrors {
    constructor(errorIds) {
        this.errorIds = errorIds;
    }
}
ClearErrors.type = '[Runtime] Clear Error';
class ClearPageErrors {
    constructor(pageId) {
        this.pageId = pageId;
    }
}
ClearPageErrors.type = '[Runtime] Clear Page Errors';
class ClearWidgetErrors {
    constructor(widgetId) {
        this.widgetId = widgetId;
    }
}
ClearWidgetErrors.type = '[Runtime] Clear Widget Errors';
class RegisterRuntimeWidget {
    constructor(widgetId, props) {
        this.widgetId = widgetId;
        this.props = props;
    }
}
RegisterRuntimeWidget.type = '[Runtime] Register Runtime Widget';
class DeregisterRuntimeWidget {
    constructor(widgetId) {
        this.widgetId = widgetId;
    }
}
DeregisterRuntimeWidget.type = '[Runtime] Deregister Runtime Widget';
class UpdateRuntimeWidgetProp {
    constructor(widgetId, prop, value) {
        this.widgetId = widgetId;
        this.prop = prop;
        this.value = value;
    }
}
UpdateRuntimeWidgetProp.type = '[Runtime] Update Runtime Widget Prop';
class SetAuthStatus {
    constructor(authStatus) {
        this.authStatus = authStatus;
    }
}
SetAuthStatus.type = '[Runtime] Set Auth Status';
class ResetRuntimeState {
    constructor(runtimeReset) {
        this.runtimeReset = runtimeReset;
    }
}
ResetRuntimeState.type = '[Runtime] Reset';
class SetConsumerSiteType {
    constructor(siteType) {
        this.siteType = siteType;
    }
}
SetConsumerSiteType.type = '[Runtime] Set Consumer Site Type';
class SetSSOResult {
    constructor(ssoResult) {
        this.ssoResult = ssoResult;
    }
}
SetSSOResult.type = '[RunTime] Set SSO Result';
class SetRedirectedFromPlanCompareApi {
    constructor(redirectStatus) {
        this.redirectStatus = redirectStatus;
    }
}
SetRedirectedFromPlanCompareApi.type = '[RunTime] Set Redirect From Plan Compare API';
class SetAuthType {
    constructor(authType) {
        this.authType = authType;
    }
}
SetAuthType.type = '[RunTime] Set AuthType';
class SetSendToBeneficiaryWithoutAgentForPlanCompareApi {
    constructor(sendToBeneStatus) {
        this.sendToBeneStatus = sendToBeneStatus;
    }
}
SetSendToBeneficiaryWithoutAgentForPlanCompareApi.type = '[RunTime] Set Send To Beneficiary Without Agent For Plan Compare API';
class SetStorageId {
    constructor(storageId) {
        this.storageId = storageId;
    }
}
SetStorageId.type = '[RunTime] Set Storage Id For Plan Compare API';
class SetIsPurl {
    constructor(isPurl) {
        this.isPurl = isPurl;
    }
}
SetIsPurl.type = '[RunTime] Set PURL For Session Agent';
class SetRedirectPageTag {
    constructor(redirectPageTag) {
        this.redirectPageTag = redirectPageTag;
    }
}
SetRedirectPageTag.type = '[RunTime] Set Redirect Page Tag';
class SetSignAndSubmitWithoutAgentForPlanCompareApi {
    constructor(signAndSubmitStatus) {
        this.signAndSubmitStatus = signAndSubmitStatus;
    }
}
SetSignAndSubmitWithoutAgentForPlanCompareApi.type = '[RunTime] Set Sign And Submit Without Agent For Plan Compare API';

var RuntimeState_1;
const RUNTIME_DEFAULTS = {
    errors: [],
    // saving the auth status to state for tracking purposes and in case we ever need to drive
    // certain display elements off of state. this reflects the state of the jwt token but
    // ultimately the jwt is what should be used for authentication
    authStatus: AUTH_STATUS_CODES.UNAUTHORIZED,
    consumerSiteType: ConsumerSiteType.ANONYMOUS,
    ssoResult: null,
    redirectedFromPlanCompareApi: false,
    sendToBeneficiaryWithoutAgentForPlanCompareApi: false,
    storageId: '',
    authType: "anonymous" /* AuthType.ANONYMOUS */,
    isPurl: false,
    redirectPageTag: null,
    sendSignAndSubmitWithoutAgentForPlanCompareApi: false
};
let RuntimeState = RuntimeState_1 = class RuntimeState {
    static errors(state) {
        return state.errors;
    }
    static authStatus(state) {
        return state.authStatus;
    }
    static consumerSiteType(state) {
        return state.consumerSiteType;
    }
    static ssoResult(state) {
        return state.ssoResult;
    }
    static ssoState(ssoResult) {
        return ssoResult?.state;
    }
    static ssoDeliveryMethod(ssoState) {
        return ssoState?.deliverymethod;
    }
    static authType(state) {
        return state.authType;
    }
    static isRedirectedFromPlanCompareApi(state) {
        return state.redirectedFromPlanCompareApi;
    }
    static isSendToBeneficiaryWithoutAgentForPlanCompareApi(state) {
        return state.sendToBeneficiaryWithoutAgentForPlanCompareApi;
    }
    static storageId(state) {
        return state.storageId;
    }
    static redirectPageTag(state) {
        return state.redirectPageTag;
    }
    // Verification flow: kept for backwards compatibility with multi factor authentication
    static isPurlRedirectEnabled(redirectPageTag) {
        return !!redirectPageTag;
    }
    static isPurl(state) {
        return state.isPurl;
    }
    static isSignAndSubmitWithoutAgentForPlanCompareApi(state) {
        return state.sendSignAndSubmitWithoutAgentForPlanCompareApi;
    }
    static pageErrors(pageId) {
        return createSelector([RuntimeState_1.errors], (errors) => errors.filter(error => error.pageId === pageId));
    }
    static widgetErrors(widgetId) {
        return createSelector([RuntimeState_1.errors], (errors) => errors.filter(error => error.widgetId === widgetId));
    }
    addErrors(ctx, { errors }) {
        const { setState, getState } = ctx;
        const state = getState();
        // TODO: if matching widgetId and property replace error
        // TODO: make property required then
        // const newErrors = [...state.errors, ...errors];
        setState({ ...state, errors });
    }
    clearPageErrors(ctx, { pageId }) {
        const { setState, getState } = ctx;
        const state = getState();
        const updatedErrors = state.errors.reduce((errors, error) => {
            if (error.pageId !== pageId) {
                errors.push(error);
            }
            return errors;
        }, []);
        setState({ ...state, errors: updatedErrors });
    }
    clearWidgetErrors(ctx, { widgetId }) {
        const { setState, getState } = ctx;
        const state = getState();
        const updatedErrors = state.errors.reduce((errors, error) => {
            if (error.widgetId !== widgetId) {
                errors.push(error);
            }
            return errors;
        }, []);
        setState({ ...state, errors: updatedErrors });
    }
    setAuthStatus(ctx, { authStatus }) {
        ctx.patchState({ authStatus });
    }
    resetRuntimeState(ctx, { runtimeReset }) {
        const { setState, getState } = ctx;
        const { authStatus, authType, redirectPageTag } = getState();
        // don't want to recheck for SSO values when we are resetting state
        // we also do not want to reacquire the jwt token if it hasn't expired on reset
        if (!runtimeReset.resetPurl) {
            RUNTIME_DEFAULTS.isPurl = true;
            RUNTIME_DEFAULTS.redirectPageTag = redirectPageTag;
        }
        setState({ ...RUNTIME_DEFAULTS, authStatus, authType });
    }
    setConsumerSiteType(ctx, { siteType }) {
        ctx.patchState({ consumerSiteType: siteType });
    }
    setSSOResult(ctx, { ssoResult }) {
        ctx.patchState({ ssoResult });
    }
    setAuthType(ctx, { authType }) {
        ctx.patchState({ authType });
    }
    setIsPurl(ctx, { isPurl }) {
        ctx.patchState({ isPurl });
    }
    setRedirectPageTag(ctx, { redirectPageTag }) {
        ctx.patchState({ redirectPageTag });
    }
    setRedirectFromPlanCompareApi(ctx, { redirectStatus }) {
        ctx.patchState({ redirectedFromPlanCompareApi: redirectStatus });
    }
    setSendToBeneficiaryWithoutAgentForPlanCompareApi(ctx, { sendToBeneStatus }) {
        ctx.patchState({ sendToBeneficiaryWithoutAgentForPlanCompareApi: sendToBeneStatus });
    }
    setStorageId(ctx, { storageId }) {
        ctx.patchState({ storageId });
    }
    setSignAndSubmitWithoutAgentForPlanCompareApi(ctx, { signAndSubmitStatus }) {
        ctx.patchState({ sendSignAndSubmitWithoutAgentForPlanCompareApi: signAndSubmitStatus });
    }
};
RuntimeState.ɵfac = function RuntimeState_Factory(t) { return new (t || RuntimeState)(); };
RuntimeState.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: RuntimeState, factory: RuntimeState.ɵfac });
__decorate([
    Action(AddErrors)
], RuntimeState.prototype, "addErrors", null);
__decorate([
    Action(ClearPageErrors)
], RuntimeState.prototype, "clearPageErrors", null);
__decorate([
    Action(ClearWidgetErrors)
], RuntimeState.prototype, "clearWidgetErrors", null);
__decorate([
    Action(SetAuthStatus)
], RuntimeState.prototype, "setAuthStatus", null);
__decorate([
    Action(ResetRuntimeState)
], RuntimeState.prototype, "resetRuntimeState", null);
__decorate([
    Action(SetConsumerSiteType)
], RuntimeState.prototype, "setConsumerSiteType", null);
__decorate([
    Action(SetSSOResult)
], RuntimeState.prototype, "setSSOResult", null);
__decorate([
    Action(SetAuthType)
], RuntimeState.prototype, "setAuthType", null);
__decorate([
    Action(SetIsPurl)
], RuntimeState.prototype, "setIsPurl", null);
__decorate([
    Action(SetRedirectPageTag)
], RuntimeState.prototype, "setRedirectPageTag", null);
__decorate([
    Action(SetRedirectedFromPlanCompareApi)
], RuntimeState.prototype, "setRedirectFromPlanCompareApi", null);
__decorate([
    Action(SetSendToBeneficiaryWithoutAgentForPlanCompareApi)
], RuntimeState.prototype, "setSendToBeneficiaryWithoutAgentForPlanCompareApi", null);
__decorate([
    Action(SetStorageId)
], RuntimeState.prototype, "setStorageId", null);
__decorate([
    Action(SetSignAndSubmitWithoutAgentForPlanCompareApi)
], RuntimeState.prototype, "setSignAndSubmitWithoutAgentForPlanCompareApi", null);
__decorate([
    Selector()
], RuntimeState, "errors", null);
__decorate([
    Selector()
], RuntimeState, "authStatus", null);
__decorate([
    Selector()
], RuntimeState, "consumerSiteType", null);
__decorate([
    Selector()
], RuntimeState, "ssoResult", null);
__decorate([
    Selector([RuntimeState_1.ssoResult])
], RuntimeState, "ssoState", null);
__decorate([
    Selector([RuntimeState_1.ssoState])
], RuntimeState, "ssoDeliveryMethod", null);
__decorate([
    Selector()
], RuntimeState, "authType", null);
__decorate([
    Selector()
], RuntimeState, "isRedirectedFromPlanCompareApi", null);
__decorate([
    Selector()
], RuntimeState, "isSendToBeneficiaryWithoutAgentForPlanCompareApi", null);
__decorate([
    Selector()
], RuntimeState, "storageId", null);
__decorate([
    Selector()
], RuntimeState, "redirectPageTag", null);
__decorate([
    Selector([RuntimeState_1.redirectPageTag])
], RuntimeState, "isPurlRedirectEnabled", null);
__decorate([
    Selector()
], RuntimeState, "isPurl", null);
__decorate([
    Selector()
], RuntimeState, "isSignAndSubmitWithoutAgentForPlanCompareApi", null);
RuntimeState = RuntimeState_1 = __decorate([
    State({
        name: 'runtime',
        defaults: RUNTIME_DEFAULTS
    })
    /**
     * The runtime state of the application that isn't related to configuration and doesn't warrant its own store.
     * This will be things like errors and the toggled state of certain components IF the user would like to persist
     * these things to persist the state across pages.
     *
     * TODO: do we leverage this for live edit or no? probably can just use the config store
     */
], RuntimeState);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RuntimeState, [{
        type: Injectable
    }], null, { addErrors: [], clearPageErrors: [], clearWidgetErrors: [], setAuthStatus: [], resetRuntimeState: [], setConsumerSiteType: [], setSSOResult: [], setAuthType: [], setIsPurl: [], setRedirectPageTag: [], setRedirectFromPlanCompareApi: [], setSendToBeneficiaryWithoutAgentForPlanCompareApi: [], setStorageId: [], setSignAndSubmitWithoutAgentForPlanCompareApi: [] }); })();

/**
 * A service for validating the widgets on a page.
 * Must be injected at the page level rather than the root level so
 * each page manages its own errors.
 */
class WidgetValidationService {
    constructor(store) {
        this.store = store;
        this.validators = [];
    }
    getWidgetErrors$(widgetId) {
        return this.store.select(RuntimeState.widgetErrors(widgetId));
    }
    removeWidgetValidator(validatorId) {
        this.validators = this.validators.filter(validator => validator.validatorId !== validatorId);
    }
    addWidgetValidator(validator) {
        this.validators.push(validator);
    }
    /**
     * Runs validation on all widgets on the current page
     *
     * @param options - optional, contains the following options:
     *
     *  pageId - optional, will be included in output errors
     *
     *  widgetIds - optional, if provided only widgets with matching ids will be validated
     *
     * @returns an array of errors, if any
     */
    validate(options) {
        const errors = [];
        const { widgetIds, pageId } = { ...options };
        this.validators.forEach(validator => {
            if (!widgetIds || widgetIds.includes(validator.widgetId)) {
                const validatorErrors = validator.validator();
                if (validatorErrors && validatorErrors.length) {
                    errors.push(...validatorErrors.map(error => {
                        if (pageId) {
                            return { ...error, pageId };
                        }
                        return error;
                    }));
                }
            }
        });
        return errors;
    }
}
WidgetValidationService.ɵfac = function WidgetValidationService_Factory(t) { return new (t || WidgetValidationService)(i0.ɵɵinject(i1.Store)); };
WidgetValidationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: WidgetValidationService, factory: WidgetValidationService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WidgetValidationService, [{
        type: Injectable
    }], function () { return [{ type: i1.Store }]; }, null); })();
class ValidateOptions {
}

var DeactivationGuardStatus;
(function (DeactivationGuardStatus) {
    DeactivationGuardStatus["ENABLED"] = "enabled";
    DeactivationGuardStatus["SKIP_NEXT_CAN_DEACTIVATE_CHECK"] = "skip-next-can-deactivate-check";
})(DeactivationGuardStatus || (DeactivationGuardStatus = {}));
const reductiveGuardChain = async (guards) => guards
    // Place the guards flagged with "checkLast" at the end of the list
    .sort((guardA, guardB) => {
    if (guardA.checkLast) {
        return 1;
    }
    if (guardB.checkLast) {
        return -1;
    }
    return 0;
})
    .reduce((chain, guard) => chain.then(async (canResolve) => (canResolve ? guard.canDeactivate() : Promise.resolve(false))), Promise.resolve(true));
/*
 * A service for adding widget scoped deactivation guards. Runs the promise
 * chain in order and if any return false then the chain cannot deactivate
 */
class DeactivationGuardService {
    constructor() {
        this.status = DeactivationGuardStatus.ENABLED;
        this.guards = [];
    }
    addDeactivationGuard(guard) {
        this.guards.push(guard);
    }
    setDeactivationGuardStatus(status) {
        this.status = status;
    }
    async canDeactivate() {
        // When enabled, we will check all Deactivation guards. Otherwise, we will skip all checks (until next call) and resume navigation
        const canDeactivateResult = this.status === DeactivationGuardStatus.ENABLED ? reductiveGuardChain(this.guards) : Promise.resolve(true);
        return canDeactivateResult.then(result => {
            // After we skipped the next canDeactivate() checks, we enable the Deactivation guard again to resume checking onward
            if (this.status === DeactivationGuardStatus.SKIP_NEXT_CAN_DEACTIVATE_CHECK) {
                this.setDeactivationGuardStatus(DeactivationGuardStatus.ENABLED);
            }
            return result;
        });
    }
}
DeactivationGuardService.ɵfac = function DeactivationGuardService_Factory(t) { return new (t || DeactivationGuardService)(); };
DeactivationGuardService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DeactivationGuardService, factory: DeactivationGuardService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DeactivationGuardService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

class ConfigurablePage {
    constructor(widgetValidationService, deactivationGuardService) {
        this.widgetValidationService = widgetValidationService;
        this.deactivationGuardService = deactivationGuardService;
        this.pageId = uuid();
    }
    validate() {
        return this.widgetValidationService.validate({ pageId: this.pageId });
    }
    async canDeactivate() {
        return this.deactivationGuardService.canDeactivate();
    }
}
ConfigurablePage.ɵfac = function ConfigurablePage_Factory(t) { return new (t || ConfigurablePage)(i0.ɵɵdirectiveInject(WidgetValidationService), i0.ɵɵdirectiveInject(DeactivationGuardService)); };
ConfigurablePage.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ConfigurablePage });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfigurablePage, [{
        type: Directive
    }], function () { return [{ type: WidgetValidationService }, { type: DeactivationGuardService }]; }, null); })();

const TIMEOUT_ERROR = 'TimeoutError';

const WIDGET_VALIDATE_METHOD = 'validateWidget';
function widgetCanValidate(component) {
    return component[WIDGET_VALIDATE_METHOD] !== undefined;
}

var PageTags;
(function (PageTags) {
    PageTags["ACCESSIBILITY_STATEMENT"] = "AccessibilityStatement";
    PageTags["ADD_NEW_AGENT"] = "AddNewAgent";
    PageTags["ADD_NEW_PROFILE"] = "AddNewProfile";
    PageTags["ADD_NEW_RETIREFLO"] = "AddNewRetireFlo";
    PageTags["AGENT_ACCOUNT_OVERVIEW"] = "Agent_Account_Overview";
    PageTags["AGENT_DASHBOARD"] = "AgentDashboard";
    PageTags["AGENT_ENROLLINFO"] = "AgentEnrollInfo";
    PageTags["AGENT_LOGIN"] = "Agent_Login";
    PageTags["AGENT_SEARCH"] = "AgentSearch";
    PageTags["AGENT_SOA"] = "AgentSOA";
    PageTags["AGENT_TRAINING_MATERIALS"] = "AgentTrainingMaterials";
    PageTags["AGENT_VIEW_PROFILE"] = "AgentViewProfile";
    PageTags["ANCILLARY_FORM"] = "AncillaryForm";
    PageTags["ANCILLARY_CONFIRMATION"] = "AncillaryConfirmation";
    PageTags["AUTH_SUCCESS_START"] = "AuthSuccessStart";
    PageTags["BENEFICIARY_LOGIN"] = "BeneficiaryLogin";
    PageTags["BENEFICIARY_AUTHENTICATION"] = "BeneficiaryAuthentication";
    PageTags["BENEFICIARY_VERIFICATION"] = "BeneficiaryVerification";
    PageTags["CONSUMER_ACCOUNT_SUMMARY"] = "ConsumerAccountSummary";
    PageTags["REPORTS_SUMMARY"] = "ReportsSummary";
    PageTags["PLAN_SMART"] = "PlanSmart";
    PageTags["DENTAL_CONFIRMATION"] = "DentalConfirmation";
    PageTags["DRUG_SEARCH"] = "DrugSearch";
    PageTags["ENROLLMENT"] = "Enrollment";
    PageTags["ENROLLMENT_CONFIRMATION"] = "Enrollment_Confirmation";
    PageTags["ENROLLMENT_DENTAL"] = "Enrollment_Dental";
    PageTags["FORGOT_PASSWORD"] = "LoginRecover";
    PageTags["FORGOT_USERNAME"] = "UsernameRecover";
    PageTags["GENERIC_FORM"] = "GenericForm";
    PageTags["STANDALONE_FORM"] = "StandaloneEnrollmentForm";
    PageTags["STANDALONE_ANCILLARY_FORM"] = "StandaloneAncillaryForm";
    PageTags["STANDALONE_CONFIRMATION"] = "StandaloneConfirmation";
    PageTags["GET_SALESFORCE_TOKEN"] = "GetToken";
    PageTags["GLOSSARY"] = "Glossary";
    PageTags["GUIDED_HELP_GETTING_STARTED"] = "GuidedHelp_GettingStarted";
    PageTags["SHOPPING_PREFERENCES"] = "ShoppingPreferences";
    PageTags["GUIDED_HELP_HEALTH"] = "GuidedHelp_Health";
    PageTags["GUIDED_HELP_OTHER_PREFERENCES"] = "GuidedHelp_OtherPreferences";
    PageTags["GUIDED_HELP_PHARMACY_SEARCH"] = "GuidedHelp_PharmacySearch";
    PageTags["GUIDED_HELP_PLAN_LIST"] = "GuidedHelp_PlanList";
    PageTags["GUIDED_HELP_PLAN_PREFERENCES"] = "GuidedHelp_PlanPreferences";
    PageTags["GUIDED_HELP_PRESCRIPTIONS"] = "GuidedHelp_Prescriptions";
    PageTags["GUIDED_HELP_PROVIDER_SEARCH"] = "GuidedHelp_ProviderSearch";
    PageTags["GUIDED_HELP_ELIGIBILITY"] = "GuidedHelp_Eligibility";
    PageTags["GUIDED_HELP_CURRENT_PLAN"] = "GuidedHelp_CurrentPlan";
    PageTags["HELPFUL_TOOLS"] = "HelpfulTools";
    PageTags["HELPFUL_TOOLS_PHARMACYSEARCH"] = "HelpfulToolsPharmacySearch";
    PageTags["HRA_FORM"] = "HRAForm";
    PageTags["HRA_CONFIRMATION"] = "HRAConfirmation";
    PageTags["HOME"] = "Home";
    PageTags["MEDIGAP_INTERIM"] = "EnrollMedigapPage";
    PageTags["MEMBER_PROFILE_PAGE"] = "MemberProfilePage";
    PageTags["PAGE_NOT_FOUND"] = "PageNotFound";
    PageTags["PHARMACY_SEARCH"] = "PharmacySearch";
    PageTags["PIN_HOME"] = "PinHome";
    PageTags["PLAN_COMPARISON"] = "ComparePlans";
    PageTags["PLAN_DETAILS"] = "PlanDetails";
    PageTags["PLAN_LIST"] = "PlanList";
    PageTags["PLAN_LIST_MEDSUP_FORM"] = "PlanListMedSupForm";
    PageTags["PRIVACY_POLICY"] = "PrivacyPolicy";
    PageTags["PROFILE_SEARCH"] = "profileSearch";
    PageTags["QUOTE_SUMMARY"] = "QuoteSummary";
    PageTags["MEMBER_RECORDINGS"] = "MemberRecordings";
    PageTags["RESET_PASSWORD"] = "PasswordReset";
    PageTags["RETENTION"] = "Retention";
    PageTags["RETENTION_SUMMARY"] = "RetentionSummary";
    PageTags["SHARE_PRESCRIPTIONS"] = "SharePrescriptions";
    PageTags["SHOPPING_CART"] = "ShoppingCart";
    PageTags["SOA"] = "SOA";
    PageTags["SOA_FORM"] = "SOAForm";
    PageTags["TERMS"] = "Terms";
    PageTags["HOSPITAL_INDEMNITY_VIEW_QUOTE"] = "HospitalIndemnityViewQuote";
    PageTags["BROWSER_DENIED"] = "BrowserDenied";
    PageTags["COMPLETED_ENROLLMENTS"] = "CompletedEnrollments";
    PageTags["GROUP_MESSAGE"] = "GroupMessage";
    PageTags["AGENT_SUBSCRIPTION"] = "AgentSubscription";
    PageTags["SUBSCRIPTION_CONFIRMATION"] = "SubscriptionConfirmation";
    PageTags["RETIRE_FLO_SURVEY"] = "RetireFloSurvey";
    PageTags["SUPPLEMENTAL_BENEFITS"] = "SupplementalBenefits";
    PageTags["ENROLLMENT_EXPIRED"] = "EnrollmentExpired";
})(PageTags || (PageTags = {}));

var SubsidySelected;
(function (SubsidySelected) {
    SubsidySelected[SubsidySelected["DONT_KNOW"] = 0] = "DONT_KNOW";
    SubsidySelected[SubsidySelected["MEDICAID"] = 1] = "MEDICAID";
    SubsidySelected[SubsidySelected["SSI"] = 2] = "SSI";
    SubsidySelected[SubsidySelected["PARTIAL"] = 3] = "PARTIAL";
    SubsidySelected[SubsidySelected["NONE"] = 4] = "NONE";
    SubsidySelected[SubsidySelected["MSP"] = 5] = "MSP";
    SubsidySelected[SubsidySelected["FULL"] = 6] = "FULL";
})(SubsidySelected || (SubsidySelected = {}));
const SUBSIDY_PERCENT = [25, 50, 75, 100];

/**
 * Marks a class as a platform configuration type.
 * Type information about classes with this decorator will be exported to platform
 * so we know how to configure them on that end.
 * @param constructor
 */
function PlatformType(constructor) {
    return class extends constructor {
    };
}

class EnvironmentService {
    constructor(environment) {
        EnvironmentService.environment = environment;
    }
    static setEnvironment(environment) {
        EnvironmentService.environment = environment;
    }
    static getEnvironment() {
        if (!EnvironmentService.environment) {
            // This was a trace but this caused a huge level of performance impact during testing
            // Change this back to a trace for local development if needed
            console.log('no environment, returning empty object');
            return {};
        }
        else {
            return EnvironmentService.environment;
        }
    }
}
EnvironmentService.environment = undefined;
EnvironmentService.ɵfac = function EnvironmentService_Factory(t) { return new (t || EnvironmentService)(i0.ɵɵinject('environment')); };
EnvironmentService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: EnvironmentService, factory: EnvironmentService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnvironmentService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['environment']
            }] }]; }, null); })();

/**
 * A decorator for overwriting functions that make external service calls in live edit
 * returnValue - an optional return value for the decorated method
 * @param returnValue what will be returned from the function in place of its normal behavior
 */
function LiveEditInactive(returnValue) {
    return (target, propertyKey, descriptor) => {
        const originalMethod = descriptor.value;
        descriptor.value = function (...args) {
            if (!EnvironmentService.getEnvironment().liveedit) {
                const result = originalMethod.apply(this, args);
                return result;
            }
            else {
                if (returnValue) {
                    return returnValue;
                }
                else {
                    return;
                }
            }
        };
        return descriptor;
    };
}

// Decorates functions we wish to memoize. Will cause issues if the function decorated is
// not a pure function. In order to turn on cache profiling during development do the following:
// 1) import memprofile from 'memoizee/profile';
// 2) Add profileName: key to the memoizee options object
// 3) Add console.log(memprofile.log()); in the descriptor value function or whereever you wish
// to see profile logging output
function Memoize(config) {
    return function (target, key, descriptor) {
        const oldFunction = descriptor.value;
        const newFunction = memoizee(oldFunction, {
            normalizer: args => {
                try {
                    return JSON.stringify(args);
                }
                catch {
                    console.log(`Unable to stringify arguments for ${key}`);
                    return null;
                }
            }
        });
        descriptor.value = function () {
            return newFunction.apply(this, arguments);
        };
    };
}

function MemoizeObservable(options) {
    return function (target, key, descriptor) {
        // Unique symbol value to register a cleanup callback in the cached observable.
        const disposeSymbol = Symbol('___dispose');
        // Unique symbol value to register a unique ID in a parameter that cannot be stringified, like functions and observables, during the execution of the normalizer callback.
        const memoizedIdSymbol = Symbol('___memoizedId');
        const newOptions = {
            normalizer: (args) => {
                try {
                    const processedArguments = Array.from(args).map(argument => {
                        if (argument instanceof Observable ||
                            argument instanceof BehaviorSubject ||
                            argument instanceof ReplaySubject ||
                            argument instanceof Subject ||
                            argument instanceof Function) {
                            if (!argument[memoizedIdSymbol]) {
                                argument[memoizedIdSymbol] = uuid();
                            }
                            return argument[memoizedIdSymbol];
                        }
                        else {
                            return argument;
                        }
                    });
                    return JSON.stringify(processedArguments);
                }
                catch {
                    console.error(`Unable to stringify arguments for ${key}`);
                    return null;
                }
            },
            ...options,
            // Callback to be called on each value removed from the cache.
            // Useful in case we configure an expiration period of time for given call's cache (or when cleared manually)
            dispose(value) {
                // Completes the cached observable.
                value?.[disposeSymbol]?.();
            }
        };
        const oldFunction = descriptor.value;
        const newFunction = memoizee(oldFunction, newOptions);
        descriptor.value = function () {
            const result$ = newFunction.apply(this, arguments);
            const expired$ = new Subject();
            const sharedResult$ = result$.pipe(takeUntil(expired$), shareReplay(1));
            sharedResult$[disposeSymbol] = () => expired$.next(null);
            return sharedResult$;
        };
    };
}

class BootstrapBreakPoints {
    static get isXS() {
        return BootstrapBreakPoints.width >= 0 && BootstrapBreakPoints.width < 576;
    }
    static get isSM() {
        return BootstrapBreakPoints.width >= 576 && BootstrapBreakPoints.width < 768;
    }
    static get isMD() {
        return BootstrapBreakPoints.width >= 768 && BootstrapBreakPoints.width < 992;
    }
    static get isLG() {
        return BootstrapBreakPoints.width >= 992 && BootstrapBreakPoints.width < 1024;
    }
    static get isXL() {
        return BootstrapBreakPoints.width >= 1024;
    }
    static get isStrictXL() {
        return BootstrapBreakPoints.width >= 1200;
    }
}

var BreakPoint;
(function (BreakPoint) {
    BreakPoint["EXTRA_SMALL"] = "EXTRA_SMALL";
    BreakPoint["COMPACT"] = "COMPACT";
    BreakPoint["MEDIUM"] = "MEDIUM";
    BreakPoint["LARGE"] = "LARGE";
    BreakPoint["EXTRA_LARGE"] = "EXTRA_LARGE";
})(BreakPoint || (BreakPoint = {}));
const resizeEventName = 'resize';
const resizeEvent$ = fromEvent(window, resizeEventName).pipe(startWith(new Event(resizeEventName)), map(event => event?.target?.innerWidth ?? window?.innerWidth), shareReplay(1));
const isWidthWithinSelectedBreakpoint = (breakpoint, width) => {
    let result = false;
    if (width !== undefined && width !== null) {
        BootstrapBreakPoints.width = width;
        if (breakpoint === BreakPoint.EXTRA_SMALL) {
            result = BootstrapBreakPoints.isXS;
        }
        else if (breakpoint === BreakPoint.COMPACT) {
            result = BootstrapBreakPoints.isXS || BootstrapBreakPoints.isSM;
        }
        else if (breakpoint === BreakPoint.MEDIUM) {
            result = BootstrapBreakPoints.isMD;
        }
        else if (breakpoint === BreakPoint.LARGE) {
            result = BootstrapBreakPoints.isLG;
        }
        else if (breakpoint === BreakPoint.EXTRA_LARGE) {
            result = BootstrapBreakPoints.isStrictXL;
        }
    }
    return result;
};
const responsiveLayouts = Object.values(BreakPoint).reduce((layouts, breakpoint) => {
    layouts[breakpoint] = resizeEvent$.pipe(map(width => isWidthWithinSelectedBreakpoint(breakpoint, width)), distinctUntilChanged(), shareReplay(1));
    return layouts;
}, {});
function ResponsiveLayout(breakpoint) {
    return function (target, propertyKey, descriptor) {
        Object.defineProperty(target, propertyKey, {
            ...descriptor,
            value: responsiveLayouts[breakpoint]
        });
    };
}

function ConfirmationModalComponent_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function ConfirmationModalComponent_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.cancel()); });
    i0.ɵɵelementEnd();
} }
function ConfirmationModalComponent_ng_container_6_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 10);
    i0.ɵɵlistener("click", function ConfirmationModalComponent_ng_container_6_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r8.cancel()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r7.cancelButton, " ");
} }
function ConfirmationModalComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ConfirmationModalComponent_ng_container_6_button_1_Template, 2, 1, "button", 9);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.cancelButton);
} }
function ConfirmationModalComponent_ng_template_7_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 12);
    i0.ɵɵlistener("click", function ConfirmationModalComponent_ng_template_7_button_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r11.cancel()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r10.cancelButton, " ");
} }
function ConfirmationModalComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ConfirmationModalComponent_ng_template_7_button_0_Template, 2, 1, "button", 11);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r3.cancelButton);
} }
function ConfirmationModalComponent_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 13);
    i0.ɵɵlistener("click", function ConfirmationModalComponent_button_9_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r13.confirm()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.confirmButton, " ");
} }
const _c0 = function (a0, a1) { return { "justify-content-center text-center d-block": a0, "justify-content-start": a1 }; };
class ConfirmationModalComponent {
    constructor(activeModal, domSanitizer) {
        this.activeModal = activeModal;
        this.domSanitizer = domSanitizer;
        this.hideCloseButton = false;
    }
    cancel() {
        this.activeModal.dismiss();
        if (this.cancelAction) {
            this.cancelAction();
        }
    }
    confirm() {
        this.activeModal.close();
        if (this.confirmAction) {
            this.confirmAction();
        }
    }
    // TODO:  We need to refactor the vnext-widgets pipes dependecy chain to decouple it from
    // vnext-widgets as shared components in vnext-shared do not have access to these dependencies.
    // Move pipes into vnext-shared at later time.
    allowSafeHtml(html) {
        // Note: DOM sanitizer here is to allow inline styles in input.
        return this.domSanitizer.bypassSecurityTrustHtml(html);
    }
}
ConfirmationModalComponent.ɵfac = function ConfirmationModalComponent_Factory(t) { return new (t || ConfirmationModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal), i0.ɵɵdirectiveInject(i2.DomSanitizer)); };
ConfirmationModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ConfirmationModalComponent, selectors: [["ng-component"]], decls: 10, vars: 10, consts: [[1, "modal-header", "Spa_Style_InactiveTabAndModal"], ["ngbAutofocus", "", "type", "button", "class", "close fas fa-times update-zipcode-modal-button", "aria-label", "Close", 3, "click", 4, "ngIf"], ["id", "modalHeaderTitle", 1, "Spa_Style_H4"], [1, "Spa_Style_Primary_Color", "modal-body", 3, "innerHtml"], [1, "modal-footer", 3, "ngClass"], [4, "ngIf", "ngIfElse"], ["showFocusOnCancel", ""], ["ngbAutofocus", "", "type", "button", "class", "btn Spa_Style_PrimaryButton ml-auto update-zipcode-modal-button", 3, "click", 4, "ngIf"], ["ngbAutofocus", "", "type", "button", "aria-label", "Close", 1, "close", "fas", "fa-times", "update-zipcode-modal-button", 3, "click"], ["type", "button", "class", "btn Spa_Style_SecondaryButton mr-auto update-zipcode-modal-button", 3, "click", 4, "ngIf"], ["type", "button", 1, "btn", "Spa_Style_SecondaryButton", "mr-auto", "update-zipcode-modal-button", 3, "click"], ["ngbAutofocus", "", "type", "button", "class", "btn Spa_Style_SecondaryButton mr-auto update-zipcode-modal-button", 3, "click", 4, "ngIf"], ["ngbAutofocus", "", "type", "button", 1, "btn", "Spa_Style_SecondaryButton", "mr-auto", "update-zipcode-modal-button", 3, "click"], ["ngbAutofocus", "", "type", "button", 1, "btn", "Spa_Style_PrimaryButton", "ml-auto", "update-zipcode-modal-button", 3, "click"]], template: function ConfirmationModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, ConfirmationModalComponent_button_1_Template, 1, 0, "button", 1);
        i0.ɵɵelementStart(2, "h2", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(4, "div", 3);
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵtemplate(6, ConfirmationModalComponent_ng_container_6_Template, 2, 1, "ng-container", 5);
        i0.ɵɵtemplate(7, ConfirmationModalComponent_ng_template_7_Template, 1, 1, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(9, ConfirmationModalComponent_button_9_Template, 2, 1, "button", 7);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r2 = i0.ɵɵreference(8);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.hideCloseButton);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.title);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("innerHtml", ctx.prompt ? ctx.allowSafeHtml(ctx.prompt) : "", i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c0, ctx.singleButtonOnCenter, !ctx.singleButtonOnCenter));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.confirmButton)("ngIfElse", _r2);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.confirmButton);
    } }, dependencies: [i3.NgClass, i3.NgIf], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfirmationModalComponent, [{
        type: Component,
        args: [{ template: "<!-- This modal is in vnext-shared, while every other modal is in widgets.\r\n     Possible TODO: Move the modal header/footer components to shared? Or refactor this instead? -->\r\n<div class=\"modal-header Spa_Style_InactiveTabAndModal\">\r\n  <button ngbAutofocus type=\"button\" class=\"close fas fa-times update-zipcode-modal-button\" aria-label=\"Close\" (click)=\"cancel()\" *ngIf=\"!hideCloseButton\"></button>\r\n  <h2 id=\"modalHeaderTitle\" class=\"Spa_Style_H4\">{{ title }}</h2>\r\n</div>\r\n<div class=\"Spa_Style_Primary_Color modal-body\" [innerHtml]=\"prompt ? allowSafeHtml(prompt) : ''\"></div>\r\n<div\r\n  class=\"modal-footer\"\r\n  [ngClass]=\"{ 'justify-content-center text-center d-block': singleButtonOnCenter, 'justify-content-start': !singleButtonOnCenter }\"\r\n>\r\n  <ng-container *ngIf=\"confirmButton; else showFocusOnCancel\">\r\n    <button *ngIf=\"cancelButton\" type=\"button\" class=\"btn Spa_Style_SecondaryButton mr-auto update-zipcode-modal-button\" (click)=\"cancel()\">\r\n      {{ cancelButton }}\r\n    </button>\r\n  </ng-container>\r\n  <ng-template #showFocusOnCancel>\r\n    <button ngbAutofocus *ngIf=\"cancelButton\" type=\"button\" class=\"btn Spa_Style_SecondaryButton mr-auto update-zipcode-modal-button\" (click)=\"cancel()\">\r\n      {{ cancelButton }}\r\n    </button>\r\n  </ng-template>\r\n  <button ngbAutofocus *ngIf=\"confirmButton\" type=\"button\" class=\"btn Spa_Style_PrimaryButton ml-auto update-zipcode-modal-button\" (click)=\"confirm()\">\r\n    {{ confirmButton }}\r\n  </button>\r\n</div>\r\n" }]
    }], function () { return [{ type: i1$1.NgbActiveModal }, { type: i2.DomSanitizer }]; }, null); })();

function MessageOnlyModalComponent_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵlistener("click", function MessageOnlyModalComponent_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.cancel()); });
    i0.ɵɵelementEnd();
} }
class MessageOnlyModalComponent {
    constructor(activeModal) {
        this.activeModal = activeModal;
        this.hideCloseButton = false;
    }
    cancel() {
        this.activeModal.dismiss();
        if (this.cancelAction) {
            this.cancelAction();
        }
    }
}
MessageOnlyModalComponent.ɵfac = function MessageOnlyModalComponent_Factory(t) { return new (t || MessageOnlyModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal)); };
MessageOnlyModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MessageOnlyModalComponent, selectors: [["ng-component"]], decls: 7, vars: 3, consts: [[1, "modal-header", "Spa_Style_InactiveTabAndModal"], ["ngbAutofocus", "", "type", "button", "class", "close fas fa-times", "aria-label", "Close", 3, "click", 4, "ngIf"], ["id", "modalHeaderTitle", 1, "Spa_Style_H4"], [1, "Spa_Style_Primary_Color", "modal-body"], [1, "py-3"], ["ngbAutofocus", "", "type", "button", "aria-label", "Close", 1, "close", "fas", "fa-times", 3, "click"]], template: function MessageOnlyModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, MessageOnlyModalComponent_button_1_Template, 1, 0, "button", 1);
        i0.ɵɵelementStart(2, "h2", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(4, "div", 3)(5, "p", 4);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.hideCloseButton);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.title);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.prompt);
    } }, dependencies: [i3.NgIf], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MessageOnlyModalComponent, [{
        type: Component,
        args: [{ template: "<!-- This modal is in vnext-shared, while every other modal is in widgets.\r\n     Possible TODO: Move the modal header/footer components to shared? Or refactor this instead? -->\r\n<div class=\"modal-header Spa_Style_InactiveTabAndModal\">\r\n  <button ngbAutofocus type=\"button\" class=\"close fas fa-times\" aria-label=\"Close\" (click)=\"cancel()\" *ngIf=\"!hideCloseButton\"></button>\r\n  <h2 id=\"modalHeaderTitle\" class=\"Spa_Style_H4\">{{ title }}</h2>\r\n</div>\r\n\r\n<div class=\"Spa_Style_Primary_Color modal-body\">\r\n  <p class=\"py-3\">{{ prompt }}</p>\r\n</div>\r\n" }]
    }], function () { return [{ type: i1$1.NgbActiveModal }]; }, null); })();

const VNEXT_MODAL_EXPORTS = [];
const VNEXT_MODAL_DECLARATIONS = [ConfirmationModalComponent, MessageOnlyModalComponent];
const VNEXT_MODAL_ENTRY_COMPONENTS = [ConfirmationModalComponent, MessageOnlyModalComponent];

var AgentContext;
(function (AgentContext) {
    AgentContext[AgentContext["NOT_INITIALIZED"] = 0] = "NOT_INITIALIZED";
    AgentContext[AgentContext["LOGGED_IN"] = 1] = "LOGGED_IN";
    AgentContext[AgentContext["LOGGED_OUT"] = 2] = "LOGGED_OUT";
    AgentContext[AgentContext["IN_CONTEXT"] = 3] = "IN_CONTEXT";
    AgentContext[AgentContext["BANNED_FROM_SESSION"] = 4] = "BANNED_FROM_SESSION"; //  Agent resolver cannot automatically log in for remaining user session
})(AgentContext || (AgentContext = {}));
var AgentError;
(function (AgentError) {
    AgentError[AgentError["NO_ERROR"] = 0] = "NO_ERROR";
    AgentError[AgentError["MAX_ATTEMPTS"] = 1] = "MAX_ATTEMPTS";
    AgentError[AgentError["INVALID_CREDENTIALS"] = 2] = "INVALID_CREDENTIALS";
})(AgentError || (AgentError = {}));

var HttpStatusCode;
(function (HttpStatusCode) {
    HttpStatusCode[HttpStatusCode["CONTINUE"] = 100] = "CONTINUE";
    HttpStatusCode[HttpStatusCode["SWITCHING_PROTOCOL"] = 101] = "SWITCHING_PROTOCOL";
    HttpStatusCode[HttpStatusCode["OK"] = 200] = "OK";
    HttpStatusCode[HttpStatusCode["CREATED"] = 201] = "CREATED";
    HttpStatusCode[HttpStatusCode["ACCEPTED"] = 202] = "ACCEPTED";
    HttpStatusCode[HttpStatusCode["NON_AUTHORITATIVE_INFORMATION"] = 203] = "NON_AUTHORITATIVE_INFORMATION";
    HttpStatusCode[HttpStatusCode["NO_CONTENT"] = 204] = "NO_CONTENT";
    HttpStatusCode[HttpStatusCode["RESET_CONTENT"] = 205] = "RESET_CONTENT";
    HttpStatusCode[HttpStatusCode["PARTIAL_CONTENT"] = 206] = "PARTIAL_CONTENT";
    HttpStatusCode[HttpStatusCode["MULTIPLE_CHOICES"] = 300] = "MULTIPLE_CHOICES";
    HttpStatusCode[HttpStatusCode["AMBIGUOUS"] = 300] = "AMBIGUOUS";
    HttpStatusCode[HttpStatusCode["MOVED_PERMANENTLY"] = 301] = "MOVED_PERMANENTLY";
    HttpStatusCode[HttpStatusCode["MOVED"] = 301] = "MOVED";
    HttpStatusCode[HttpStatusCode["FOUND"] = 302] = "FOUND";
    HttpStatusCode[HttpStatusCode["REDIRECT"] = 302] = "REDIRECT";
    HttpStatusCode[HttpStatusCode["SEE_OTHER"] = 303] = "SEE_OTHER";
    HttpStatusCode[HttpStatusCode["REDIRECT_METHOD"] = 303] = "REDIRECT_METHOD";
    HttpStatusCode[HttpStatusCode["NOT_MODIFIED"] = 304] = "NOT_MODIFIED";
    HttpStatusCode[HttpStatusCode["USE_PROXY"] = 305] = "USE_PROXY";
    HttpStatusCode[HttpStatusCode["UNUSED"] = 306] = "UNUSED";
    HttpStatusCode[HttpStatusCode["TEMPORARY_REDIRECT"] = 307] = "TEMPORARY_REDIRECT";
    HttpStatusCode[HttpStatusCode["REDIRECT_KEEP_VERB"] = 307] = "REDIRECT_KEEP_VERB";
    HttpStatusCode[HttpStatusCode["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    HttpStatusCode[HttpStatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    HttpStatusCode[HttpStatusCode["PAYMENT_REQUIRED"] = 402] = "PAYMENT_REQUIRED";
    HttpStatusCode[HttpStatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    HttpStatusCode[HttpStatusCode["NOT_FOUND"] = 404] = "NOT_FOUND";
    HttpStatusCode[HttpStatusCode["METHOD_NOT_ALLOWED"] = 405] = "METHOD_NOT_ALLOWED";
    HttpStatusCode[HttpStatusCode["NOT_ACCEPTABLE"] = 406] = "NOT_ACCEPTABLE";
    HttpStatusCode[HttpStatusCode["PROXY_AUTHENTICATION_REQUIRED"] = 407] = "PROXY_AUTHENTICATION_REQUIRED";
    HttpStatusCode[HttpStatusCode["REQUEST_TIMEOUT"] = 408] = "REQUEST_TIMEOUT";
    HttpStatusCode[HttpStatusCode["CONFLICT"] = 409] = "CONFLICT";
    HttpStatusCode[HttpStatusCode["GONE"] = 410] = "GONE";
    HttpStatusCode[HttpStatusCode["LENGTH_REQUIRED"] = 411] = "LENGTH_REQUIRED";
    HttpStatusCode[HttpStatusCode["PRECONDITION_FAILED"] = 412] = "PRECONDITION_FAILED";
    HttpStatusCode[HttpStatusCode["REQUEST_ENTITY_TOO_LARGE"] = 413] = "REQUEST_ENTITY_TOO_LARGE";
    HttpStatusCode[HttpStatusCode["REQUEST_URI_TOO_LONG"] = 414] = "REQUEST_URI_TOO_LONG";
    HttpStatusCode[HttpStatusCode["UNSUPPORTED_MEDIA_TYPE"] = 415] = "UNSUPPORTED_MEDIA_TYPE";
    HttpStatusCode[HttpStatusCode["REQUESTED_RANGE_NOT_SATISFIABLE"] = 416] = "REQUESTED_RANGE_NOT_SATISFIABLE";
    HttpStatusCode[HttpStatusCode["EXPECTATION_FAILED"] = 417] = "EXPECTATION_FAILED";
    HttpStatusCode[HttpStatusCode["UPGRADE_REQUIRED"] = 426] = "UPGRADE_REQUIRED";
    HttpStatusCode[HttpStatusCode["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
    HttpStatusCode[HttpStatusCode["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
    HttpStatusCode[HttpStatusCode["NOT_IMPLEMENTED"] = 501] = "NOT_IMPLEMENTED";
    HttpStatusCode[HttpStatusCode["BAD_GATEWAY"] = 502] = "BAD_GATEWAY";
    HttpStatusCode[HttpStatusCode["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
    HttpStatusCode[HttpStatusCode["GATEWAY_TIMEOUT"] = 504] = "GATEWAY_TIMEOUT";
    HttpStatusCode[HttpStatusCode["HTTP_VERSION_NOT_SUPPORTED"] = 505] = "HTTP_VERSION_NOT_SUPPORTED";
})(HttpStatusCode || (HttpStatusCode = {}));

/**
 * The interface for a link.
 * href - the href for the link. this will be used for external links
 * or if the tag is not present
 * tag - the page tag is used to look up the link href
 * validateWidgets - if true, the widgets on the current page will
 * be validated before allowing the user to leave the page
 */
let Link = class Link {
};
Link = __decorate([
    PlatformType
], Link);
var LinkType;
(function (LinkType) {
    LinkType["INTERNAL"] = "internal";
    LinkType["EXTERNAL"] = "external";
})(LinkType || (LinkType = {}));
var TargetType;
(function (TargetType) {
    // Opens in a new window or tab
    TargetType["BLANK"] = "_blank";
    // Opens in the same frame as it was clicked
    TargetType["SELF"] = "_self";
    // Opens in the parent frame (generally only used for iframes)
    TargetType["PARENT"] = "_parent";
    // Opens in the full body of the window (generally only used for iframes)
    TargetType["TOP"] = "_top";
})(TargetType || (TargetType = {}));

class LiveEditProp {
}

class QuestionMetaDataModel {
}
var MedSupFormErrorTypes;
(function (MedSupFormErrorTypes) {
    MedSupFormErrorTypes["NO_VALUE"] = "noValue";
    MedSupFormErrorTypes["REQUIRED"] = "Required";
    MedSupFormErrorTypes["INVALID"] = "Invalid";
    MedSupFormErrorTypes["FUTURE_DATE"] = "FutureDate";
    MedSupFormErrorTypes["PAST_DATE"] = "PastDate";
    MedSupFormErrorTypes["BEFORE_DOB"] = "BeforeDOB";
    MedSupFormErrorTypes["BEFORE_PART_A_EFFECTIVE_DATE"] = "BeforePartAEffectiveDate";
    MedSupFormErrorTypes["AFTER_PART_B_EFFECTIVE_DATE"] = "AfterPartBEffectiveDate";
})(MedSupFormErrorTypes || (MedSupFormErrorTypes = {}));
class MedSupEmitData {
}
class MedSupCheckboxModel {
    constructor() {
        this.selected = false;
        this.disabled = false;
    }
}
var MedSupPaymentMethod;
(function (MedSupPaymentMethod) {
    MedSupPaymentMethod["BI_MONTHLY"] = "bi-monthly";
    MedSupPaymentMethod["MONTHLY"] = "monthly";
    MedSupPaymentMethod["QUARTERLY"] = "quarterly";
    MedSupPaymentMethod["SEMI_ANNUALLY"] = "semi-annually";
    MedSupPaymentMethod["ANNUALLY"] = "annually";
    MedSupPaymentMethod["LUMP_SUM"] = "lumpsum";
})(MedSupPaymentMethod || (MedSupPaymentMethod = {}));

var ModalEventType;
(function (ModalEventType) {
    ModalEventType["REDIRECT"] = "Redirect";
    ModalEventType["CROSSSELL_APPLY"] = "CrossSell Apply";
})(ModalEventType || (ModalEventType = {}));
class ModalEvent {
}

var NOTICE_TYPE;
(function (NOTICE_TYPE) {
    NOTICE_TYPE["SUCCESS"] = "success";
    NOTICE_TYPE["INFO"] = "info";
    NOTICE_TYPE["WARN"] = "warn";
    NOTICE_TYPE["ERROR"] = "error";
})(NOTICE_TYPE || (NOTICE_TYPE = {}));
class NoticeMessage {
}
var MESSAGE_SOURCE;
(function (MESSAGE_SOURCE) {
    MESSAGE_SOURCE["CLIENT"] = "client";
    MESSAGE_SOURCE["SERVER"] = "server";
})(MESSAGE_SOURCE || (MESSAGE_SOURCE = {}));
class Notice {
}

var PlanTypeAbbreviation;
(function (PlanTypeAbbreviation) {
    PlanTypeAbbreviation["ALL"] = "ALL";
    PlanTypeAbbreviation["ALL_COMM"] = "ALL_COMM";
    PlanTypeAbbreviation["ALL_MEDICARE"] = "ALL_MEDICARE";
    PlanTypeAbbreviation["HMO"] = "HMO";
    PlanTypeAbbreviation["IND"] = "IND";
    PlanTypeAbbreviation["MA"] = "MA";
    PlanTypeAbbreviation["MAPD"] = "MAPD";
    PlanTypeAbbreviation["PDP"] = "PDP";
    PlanTypeAbbreviation["PFFS"] = "PFFS";
    PlanTypeAbbreviation["POS"] = "POS";
    PlanTypeAbbreviation["PPO"] = "PPO";
    PlanTypeAbbreviation["MEDIGAP"] = "MEDIGAP";
    PlanTypeAbbreviation["ALL_MEDICARE_PLUS_GAP"] = "ALL_MEDICARE_PLUS_GAP";
    PlanTypeAbbreviation["RIDER"] = "RIDER";
    PlanTypeAbbreviation["QHP"] = "QHP";
    PlanTypeAbbreviation["NQHP"] = "NQHP";
    PlanTypeAbbreviation["DENTAL"] = "DENTAL";
    PlanTypeAbbreviation["VISION"] = "VISION";
    PlanTypeAbbreviation["SG"] = "SG";
    PlanTypeAbbreviation["LG"] = "LG";
    PlanTypeAbbreviation["LIFE"] = "LIFE";
    PlanTypeAbbreviation["STD"] = "STD";
    PlanTypeAbbreviation["LTD"] = "LTD";
    PlanTypeAbbreviation["ADD"] = "ADD";
    PlanTypeAbbreviation["CI"] = "CI";
    PlanTypeAbbreviation["VLIFE"] = "VLIFE";
    PlanTypeAbbreviation["ADDL_LIFE"] = "ADDL_LIFE";
    PlanTypeAbbreviation["VSTD"] = "VSTD";
    PlanTypeAbbreviation["VLTD"] = "VLTD";
    PlanTypeAbbreviation["HC"] = "HC";
    PlanTypeAbbreviation["AC"] = "AC";
    PlanTypeAbbreviation["TLIFE"] = "TLIFE";
    PlanTypeAbbreviation["PEDDENTAL"] = "PEDDENTAL";
    PlanTypeAbbreviation["STM"] = "STM";
    PlanTypeAbbreviation["MEDICAID"] = "MEDICAID";
    PlanTypeAbbreviation["MEDICAIDSPECIAL"] = "MEDICAIDSPECIAL";
    PlanTypeAbbreviation["MEDICAIDDENTAL"] = "MEDICAIDDENTAL";
    PlanTypeAbbreviation["CHIP"] = "CHIP";
    PlanTypeAbbreviation["CHIPDENTAL"] = "CHIPDENTAL";
    PlanTypeAbbreviation["ALL_ANCILLARY"] = "ALL_ANCILLARY";
    PlanTypeAbbreviation["ALL_COMM_PLUS_ANCILLARY"] = "ALL_COMM_PLUS_ANCILLARY";
    PlanTypeAbbreviation["ALL_MEDICAID"] = "ALL_MEDICAID";
})(PlanTypeAbbreviation || (PlanTypeAbbreviation = {}));

class VoiceSignatureSection {
    constructor() {
        this.containsPlanBenefitsTable = false;
    }
}
class VoiceSignatureStatement {
    constructor() {
        this.inputType = 'checkbox';
    }
}
class PlanBenefitsTableItem {
}

class InitializeConfig {
    constructor(config) {
        this.config = config;
    }
}
InitializeConfig.type = '[AppConfig] Init';
// for setting config for live edit on the fly
class SetConfig {
    constructor(config) {
        this.config = config;
    }
}
SetConfig.type = '[AppConfig] Set';
class InitializeLocales {
}
InitializeLocales.type = '[AppConfig] Init Locales';
class InitializeWeglotLocales {
}
InitializeWeglotLocales.type = '[AppConfig] Init Weglot Locales';
class SetLocale {
    constructor(locale) {
        this.locale = locale;
    }
}
SetLocale.type = '[AppConfig] Set Locale';
class SetWeglotLocale {
    constructor(locale) {
        this.locale = locale;
    }
}
SetWeglotLocale.type = '[AppConfig] Set Weglot Locale';
class SetDefaultWeglotLocale {
    constructor(locale) {
        this.locale = locale;
    }
}
SetDefaultWeglotLocale.type = '[AppConfig] Set Default Weglot Locale';
class SetSupportedWeglotLanguages {
    constructor(weglotLanguages) {
        this.weglotLanguages = weglotLanguages;
    }
}
SetSupportedWeglotLanguages.type = '[AppConfig] Set Supported Weglot Languages';
// TODO: eventually complete for live edit... might be in runtime store however... might need to reconcile the two stores
class ExportConfig {
}
ExportConfig.type = '[AppConfig] Export Config';
class UpdateResource {
    constructor(liveEditUpdate) {
        this.liveEditUpdate = liveEditUpdate;
    }
}
UpdateResource.type = '[AppConfig] Update Resource';
class UpdatePlatformResource {
    constructor(shortSiteId, changeSetId, liveEditUpdate) {
        this.shortSiteId = shortSiteId;
        this.changeSetId = changeSetId;
        this.liveEditUpdate = liveEditUpdate;
    }
}
UpdatePlatformResource.type = '[AppConfig] Update Platform Resource';
class SetAppConfigLoading {
    constructor(loading) {
        this.loading = loading;
    }
}
SetAppConfigLoading.type = '[AppConfig] Loading';
class SetAppConfigLoaded {
    constructor(loaded) {
        this.loaded = loaded;
    }
}
SetAppConfigLoaded.type = '[AppConfig] Loaded';
class UpdateConfigResource {
    constructor(resourceBundle) {
        this.resourceBundle = resourceBundle;
    }
}
UpdateConfigResource.type = '[AppConfig] Update Config Resource';
class SetClientId {
    constructor(clientId) {
        this.clientId = clientId;
    }
}
SetClientId.type = '[AppConfig] Set Client Id';

class ConfigService {
    constructor(config) {
        ConfigService.config = config;
    }
    static setConfig(config) {
        ConfigService.config = config;
    }
    static getConfig() {
        if (!ConfigService.config) {
            return {};
        }
        else {
            return ConfigService.config;
        }
    }
}
ConfigService.config = undefined;
ConfigService.ɵfac = function ConfigService_Factory(t) { return new (t || ConfigService)(i0.ɵɵinject('config')); };
ConfigService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ConfigService, factory: ConfigService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfigService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['config']
            }] }]; }, null); })();

class RoutesUtilityService {
    static sanitizeUrl(url) {
        let separator = '?';
        if (url && url.indexOf('#') > url.indexOf('?')) {
            separator = '#';
        }
        let sanitizedUrl = url ? url.split(separator)[0].replace(/^\/?/g, '') : null;
        if (EnvironmentService.getEnvironment().liveedit) {
            const urlSegments = sanitizedUrl ? sanitizedUrl.split('/') : [];
            let liveEditUrlIndex;
            sanitizedUrl = urlSegments.reduce((pageNameUrl, segment, segmentIndex) => {
                if (segment === 'liveedit') {
                    liveEditUrlIndex = segmentIndex;
                    return pageNameUrl;
                    // the url segments immediately succeeding the liveedit segment are identifiers for live edit and should not
                    // be used in matching router paths
                }
                else if (typeof liveEditUrlIndex !== 'undefined' &&
                    (segmentIndex === liveEditUrlIndex + 1 || segmentIndex === liveEditUrlIndex + 2)) {
                    return pageNameUrl;
                }
                else {
                    return `${pageNameUrl ? pageNameUrl + '/' : ''}` + segment;
                }
            }, '');
        }
        return sanitizedUrl;
    }
    static pageNameURLMatch(pageName, url) {
        return pageName ? pageName.toLowerCase() === RoutesUtilityService.sanitizeUrl(url).toLowerCase() : false;
    }
    static pageNameURLStartWith(pageName, url) {
        return url && pageName ? RoutesUtilityService.sanitizeUrl(url).toLowerCase().startsWith(pageName.toLowerCase()) : false;
    }
}
__decorate([
    Memoize()
], RoutesUtilityService, "sanitizeUrl", null);
__decorate([
    Memoize()
], RoutesUtilityService, "pageNameURLMatch", null);
__decorate([
    Memoize()
], RoutesUtilityService, "pageNameURLStartWith", null);

class LoadTestData {
    constructor(testData) {
        this.testData = testData;
    }
}
LoadTestData.type = '[Application] Load Test Data';
// This will take an object that gets overlayed on to our application store
class LoadSessionData {
    constructor(session) {
        this.session = session;
    }
}
LoadSessionData.type = '[Application] Load Session Data';
class SetApplicationState {
    constructor(state) {
        this.state = state;
    }
}
SetApplicationState.type = '[Application] Set Application State';

class UpdateConsumerSiteUrls {
    constructor(consumerSiteUrls) {
        this.consumerSiteUrls = consumerSiteUrls;
    }
}
UpdateConsumerSiteUrls.type = '[Site] Update Consumer Site URLs';
class SetSiteId {
    constructor(siteId) {
        this.siteId = siteId;
    }
}
SetSiteId.type = '[Site] Set Site Id';
class SetMarkSessionForCheck {
    constructor(markSessionForCheck) {
        this.markSessionForCheck = markSessionForCheck;
    }
}
SetMarkSessionForCheck.type = '[Site] Set Mark Session For Check';
class SetContactInfoConfig {
    constructor(sharedConfigResource) {
        this.sharedConfigResource = sharedConfigResource;
    }
}
SetContactInfoConfig.type = '[Site] Set Contact Info Config';

var AppConfigState_1;
const LIVE_EDIT_ROOT = 'liveedit/:shortSiteId/:changeSetId';
const APP_CONFIG_DEFAULTS = {
    siteId: '',
    clientId: '',
    shortSiteId: '',
    environment: '',
    urls: [],
    release: '',
    homepage: '',
    supportedLanguages: null,
    pages: [],
    resourceBundle: [],
    resourceMetadata: [],
    loading: false,
    loaded: false,
    locales: {
        current: '',
        default: ''
    },
    supportedWeglotLanguages: [],
    weglotLocales: {
        current: '',
        default: ''
    }
};
// TODO: group these keys somewhere
const SELECTED_LOCALE_STORAGE_KEY = 'selected_locale';
const SELECTED_WEGLOT_LOCALE_STORAGE_KEY = 'selected_weglot_locale';
// TODO: add some typing to page and pages
let AppConfigState = AppConfigState_1 = class AppConfigState {
    constructor(localeId, http) {
        this.localeId = localeId;
        this.http = http;
    }
    static isEnrollmentPage(page) {
        return (page?.tags &&
            (page.tags.includes(PageTags.ENROLLMENT) ||
                page.tags.includes(PageTags.STANDALONE_FORM) ||
                page.tags.includes(PageTags.STANDALONE_ANCILLARY_FORM) ||
                page.tags.includes(PageTags.GENERIC_FORM) ||
                page.tags.includes(PageTags.HRA_FORM) ||
                page.tags.includes(PageTags.ANCILLARY_FORM)));
    }
    static lookupPage(pages, url) {
        const sanitizedUrl = RoutesUtilityService.sanitizeUrl(url);
        const pageFound = pages.find(page => AppConfigState_1.pageLookupMatch(page, sanitizedUrl));
        return pageFound;
    }
    static pageLookupMatch(page, url) {
        if (AppConfigState_1.isEnrollmentPage(page)) {
            return this.enrollmentPageLookupMatch(page?.pageName, url);
        }
        return page?.pageName && url ? page.pageName.toLowerCase() === url.toLowerCase() : false;
    }
    static enrollmentPageLookupMatch(pageName, url) {
        const pageSegments = pageName?.split('/');
        if (pageSegments && url) {
            const sanitizeUrlSegments = url.replace(/^\//, '').split('/');
            // in enrollment, the url can have one more segment than the page, but all the segments up to that point must match
            return ((pageSegments.length === sanitizeUrlSegments.length || pageSegments.length === sanitizeUrlSegments.length - 1) &&
                pageSegments.every((pageSegment, pageSegmentIndex) => pageSegment === sanitizeUrlSegments[pageSegmentIndex]));
        }
        return false;
    }
    /**
     * Performance: finds a match in the resources map that is generated within the resources bundle.
     */
    static resourceMapMatch(resourcesMap, key, page, widget, pages) {
        const foundResources = resourcesMap[key?.toLowerCase()];
        const match = foundResources?.some(AppConfigState_1.resourceMatch(key, page, widget, pages)) ?? false;
        return match;
    }
    static mapResourceOverrides(resources, pageName, widgetName) {
        const defaultMap = { pageAndWidget: [], page: [], widget: [], siteDefaults: [] };
        // will map the proper overrides from a resource
        // from highest to lowest the precedence is.
        // page && widget > page > widget > site > default.
        return (resources?.reduce((overrides, resource) => {
            if (AppConfigState_1.matchingPage(resource, pageName) && AppConfigState_1.matchingWidget(resource, widgetName)) {
                overrides.pageAndWidget.push(resource);
            }
            else if (AppConfigState_1.matchingPage(resource, pageName)) {
                overrides.page.push(resource);
            }
            else if (AppConfigState_1.matchingWidget(resource, widgetName)) {
                overrides.widget.push(resource);
            }
            else if (!resource.widget && !resource.page) {
                overrides.siteDefaults.push(resource);
            }
            return overrides;
        }, defaultMap) ?? defaultMap);
    }
    static selectResourceOverrides(resourceOverridesMap) {
        const { pageAndWidget, page, widget, siteDefaults } = resourceOverridesMap;
        let resourceOverrides;
        // will grab the proper overrides from a resource
        // from highest to lowest the precedence is.
        // page && widget > page > widget > site > default.
        if (pageAndWidget.length) {
            resourceOverrides = pageAndWidget;
        }
        else if (page.length) {
            resourceOverrides = page;
        }
        else if (widget.length) {
            resourceOverrides = widget;
        }
        else if (siteDefaults.length) {
            resourceOverrides = siteDefaults;
        }
        return resourceOverrides;
    }
    static contents(url) {
        return createSelector([AppConfigState_1.page(url)], (page) => page.contents);
    }
    // TODO: tech debt - add type to response
    static convertToLiveEditUpdate(response) {
        // response is coming in as an array in case we decide to process multiple reversions at a time
        const responseValue = response[0];
        return {
            lang: responseValue.lang,
            pageName: responseValue.page,
            propName: responseValue.name,
            value: responseValue.value,
            zoneKey: undefined,
            widgetName: undefined
        };
    }
    static locales(state) {
        return state.locales;
    }
    static currentLocale(locales) {
        return locales.current;
    }
    static currentLocaleResourceBundle(currentLocale) {
        return AppConfigState_1.resourceBundle(currentLocale);
    }
    static defaultLocale(locales) {
        return locales.default;
    }
    static defaultLocaleResourceBundle(defaultLocale) {
        return AppConfigState_1.resourceBundle(defaultLocale);
    }
    static weglotLocales(state) {
        return state.weglotLocales;
    }
    static currentWeglotLocale(weglotLocales) {
        return weglotLocales.current;
    }
    static defaultWeglotLocale(weglotLocales) {
        return weglotLocales.default;
    }
    static defaultUrl(state) {
        return state.urls?.[0];
    }
    static siteId(state) {
        return state.siteId;
    }
    static resourceMetadata(state) {
        return state.resourceMetadata;
    }
    static resources(state) {
        return state.resourceBundle;
    }
    static resourcesMap(resourceBundle) {
        return resourceBundle.map(bundle => ({
            lang: bundle.lang,
            resourcesMap: bundle.resources?.reduce((resourcesMap, resource) => {
                if (resource.name) {
                    const resourceName = resource.name.toLowerCase();
                    if (!resourcesMap[resourceName]) {
                        resourcesMap[resourceName] = [resource];
                    }
                    else {
                        resourcesMap[resourceName].push(resource);
                    }
                }
                return resourcesMap;
            }, {}) ?? {}
        }));
    }
    /**
     * Finds the bundle a resource (key, page, widget) is actively using.
     */
    static findActiveBundle(state, key, page, widgetName) {
        const currentBundle = state.resourcesMap.find(resource => resource.lang === state.locales.current);
        const defaultBundle = state.resourcesMap.find(resource => resource.lang === state.locales.default);
        const universalBundle = state.resourcesMap.find(resource => resource.lang === null);
        let widgetResourceMapBundle;
        // look at current locale
        if (currentBundle?.resourcesMap) {
            widgetResourceMapBundle = AppConfigState_1.resourceMapMatch(currentBundle.resourcesMap, key, page, widgetName, state.pages)
                ? currentBundle
                : null;
        }
        if (!widgetResourceMapBundle && currentBundle !== defaultBundle) {
            // look at default locale
            if (defaultBundle?.resourcesMap) {
                widgetResourceMapBundle = AppConfigState_1.resourceMapMatch(defaultBundle.resourcesMap, key, page, widgetName, state.pages)
                    ? defaultBundle
                    : null;
            }
        }
        if (!widgetResourceMapBundle) {
            // look at universal locale
            if (universalBundle?.resourcesMap) {
                // TODO: will we need to coerce to a boolean or should this work fine?
                widgetResourceMapBundle = AppConfigState_1.resourceMapMatch(universalBundle.resourcesMap, key, page, widgetName, state.pages)
                    ? universalBundle
                    : null;
            }
        }
        return widgetResourceMapBundle;
    }
    static homepage(state) {
        return state.homepage;
    }
    static hrefByTag(pageTag) {
        return createSelector([AppConfigState_1.pages], (pages) => {
            const matchingPage = pages.find(page => (page.tags ? page.tags.includes(pageTag) : null));
            if (matchingPage) {
                return matchingPage.pageName;
            }
            return null;
        });
    }
    static loaded(state) {
        return state.loaded;
    }
    static loading(state) {
        return state.loading;
    }
    static page(url) {
        // TODO: move url replacement into a utility method
        return createSelector([AppConfigState_1.pages, AppConfigState_1.shortSiteId], (pages, shortSiteId) => AppConfigState_1.lookupPage(pages, url));
    }
    static pages(state) {
        return state.pages;
    }
    static clientId(state) {
        return state.clientId;
    }
    setClientId(ctx, { clientId }) {
        const { setState } = ctx;
        setState(patch({
            clientId
        }));
    }
    static prop(pageName, widgetName, zoneKey, propName, overrideKey) {
        return createSelector([AppConfigState_1.page(pageName)], (page) => {
            if (page.contents) {
                const zoneWidgets = page.contents[zoneKey];
                if (zoneWidgets?.length) {
                    const zoneWidgetsByName = zoneWidgets.filter(widget => widget.widget === widgetName);
                    const zoneWidget = zoneWidgetsByName.find(zWidget => zWidget.overrides && !!zWidget.overrides.find(override => override.prop === propName && override.value === overrideKey));
                    if (zoneWidget) {
                        const prop = zoneWidget.overrides.find(override => override.prop === propName && override.value === overrideKey);
                        if (prop) {
                            return prop;
                        }
                    }
                }
            }
            return null;
        });
    }
    /**
     * Creates a memoized selector for selecting the bundle a resource (key, page, widget) is currently using.
     */
    static widgetResourceBundle(key, page = null, widgetName = null) {
        return createSelector([AppConfigState_1.locales, AppConfigState_1.resourcesMap, AppConfigState_1.pages], (locales, resourcesMap, pages) => AppConfigState_1.findActiveBundle({ locales, resourcesMap, pages }, key, page, widgetName));
    }
    /**
     * Retrieves the override resource values given a resource key, page and widget
     */
    static resourceOverrides(key, pageName = null, widgetName = null) {
        return createSelector([AppConfigState_1.widgetResourceBundle(key, pageName, widgetName), AppConfigState_1.pages], (resourceMapBundle, pages) => {
            if (resourceMapBundle?.resourcesMap) {
                const foundResources = resourceMapBundle.resourcesMap[key?.toLowerCase()];
                const matchedResources = foundResources?.filter(AppConfigState_1.resourceMatch(key, pageName, widgetName, pages)) ?? [];
                const resourceOverridesMap = AppConfigState_1.mapResourceOverrides(matchedResources, pageName, widgetName);
                const resourceOverrides = AppConfigState_1.selectResourceOverrides(resourceOverridesMap);
                return resourceOverrides || null;
            }
        });
    }
    /**
     * Retrieves an override resource value given a resource key, page and widget
     */
    static resource(key, pageName = null, widgetName = null) {
        return createSelector([AppConfigState_1.resourceOverrides(key, pageName, widgetName)], resourceOverrides => {
            let resource = null;
            if (resourceOverrides?.length) {
                if (RoutesUtilityService.pageNameURLStartWith(PageTags.ENROLLMENT, pageName)) {
                    resource = resourceOverrides.sort((resourceA, resourceB) => (resourceA.page?.length > resourceB.page?.length ? -1 : 1))[0];
                }
                else {
                    resource = resourceOverrides[0];
                }
            }
            return resource;
        });
    }
    static matchingPage(resource, pageName) {
        if (RoutesUtilityService.pageNameURLStartWith(PageTags.ENROLLMENT, pageName)) {
            return this.enrollmentPageLookupMatch(resource.page, RoutesUtilityService.sanitizeUrl(pageName));
        }
        return resource.page === RoutesUtilityService.sanitizeUrl(pageName);
    }
    static matchingWidget(resource, widgetName) {
        return resource.widget === widgetName;
    }
    static resourceBundle(lang) {
        return createSelector([AppConfigState_1.resources], (resources) => resources.find(resource => resource.lang === lang));
    }
    /**
     * Selects the resource meta data for resource (key, page, widget). This gives us
     * additional information about live edit fields.
     */
    static resourceMeta(key, page = null, widget = null) {
        return createSelector([AppConfigState_1.resource(key, page, widget), AppConfigState_1.resourceMetadata], (resource, resourceMetadata) => {
            if (resourceMetadata) {
                const metadataMatch = resourceMetadata.find(resourceMeta => resourceMeta.name === resource.name);
                if (metadataMatch) {
                    return metadataMatch;
                }
            }
            return null;
        });
    }
    // TODO: need to account for page and widget here?
    static resourceSet() {
        return createSelector([AppConfigState_1.resources], (resourceBundles) => {
            const resourceSet = [];
            resourceBundles.forEach(bundle => {
                bundle.resources.forEach(resource => {
                    if (!resourceSet.includes(resource.name)) {
                        resourceSet.push(resource.name);
                    }
                });
            });
            return resourceSet;
        });
    }
    static environment(state) {
        return state.environment;
    }
    static shortSiteId(state) {
        return state.shortSiteId;
    }
    static supportedLanguages(state) {
        return state.supportedLanguages;
    }
    static supportedWeglotLanguages(state) {
        return state.supportedWeglotLanguages;
    }
    static widgetLanguage(key, page = null, widget = null) {
        // returning undefined here when no resourceBundle is found because null is the indicator for the universal bundle
        return createSelector([AppConfigState_1.widgetResourceBundle(key, page, widget)], (resourceMapBundle) => resourceMapBundle?.lang);
    }
    // Initializing config into state so we can leverage memoized selectors in our components
    initializeConfig(ctx, { config }) {
        const { setState, getState } = ctx;
        const state = getState();
        setState({ ...state, ...config, loading: false });
    }
    // Initializing application locales
    initializeLocales(ctx) {
        const { setState, getState } = ctx;
        const state = getState();
        const currentLocale = localStorage.getItem(SELECTED_LOCALE_STORAGE_KEY);
        // TODO: check browser locale
        const locales = {
            default: this.localeId,
            current: currentLocale ?? ''
        };
        setState({ ...state, locales });
    }
    initializeWeglotLocales(ctx) {
        const { setState, getState } = ctx;
        const state = getState();
        const currentLocale = localStorage.getItem(SELECTED_WEGLOT_LOCALE_STORAGE_KEY);
        const weglotLocales = {
            default: this.localeId,
            current: currentLocale ?? ''
        };
        setState({ ...state, weglotLocales });
    }
    ngxsOnInit(ctx) {
        ctx.dispatch(new InitializeLocales());
        ctx.dispatch(new InitializeWeglotLocales());
        const isLiveEdit = EnvironmentService.getEnvironment().liveedit;
        // initializing config to an empty object in live edit
        // this is because config is loaded dynamically from the platform DB in live edit
        const envConfig = isLiveEdit ? {} : ConfigService.getConfig();
        ctx.dispatch(new InitializeConfig(envConfig));
        if (!isLiveEdit) {
            ctx.dispatch(new SetSiteId(envConfig.siteId));
        }
    }
    // Overwriting in-memory config in live edit
    setConfig(ctx, { config }) {
        const { setState, getState } = ctx;
        const state = getState();
        // TODO: need to ignore siteId and such in liveedit since that will be a url param
        setState({ ...state, ...config, loading: false, loaded: true });
        if (config.testData) {
            ctx.dispatch(new LoadTestData(config.testData));
        }
    }
    setLocale(ctx, { locale }) {
        const { setState } = ctx;
        // using localStorage over a cookie because we don't need to send the locale cookie with each request
        localStorage.setItem(SELECTED_LOCALE_STORAGE_KEY, locale);
        setState(patch({
            locales: patch({
                current: locale
            })
        }));
    }
    setDefaultWeglotLocale(ctx, { locale }) {
        const { setState } = ctx;
        // using localStorage over a cookie because we don't need to send the locale cookie with each request
        localStorage.setItem(SELECTED_WEGLOT_LOCALE_STORAGE_KEY, locale);
        setState(patch({
            weglotLocales: patch({
                default: locale
            })
        }));
    }
    setWeglotLocale(ctx, { locale }) {
        const { setState } = ctx;
        // using localStorage over a cookie because we don't need to send the locale cookie with each request
        localStorage.setItem(SELECTED_WEGLOT_LOCALE_STORAGE_KEY, locale);
        setState(patch({
            weglotLocales: patch({
                current: locale
            })
        }));
    }
    setSupportedWeglotLanguages(ctx, { weglotLanguages }) {
        const { setState } = ctx;
        setState(patch({
            supportedWeglotLanguages: weglotLanguages
        }));
    }
    // Push changes to platform database
    updatePlatformResource(ctx, { shortSiteId, changeSetId, liveEditUpdate }) {
        return this.http
            .post(`${EnvironmentService.getEnvironment().LIVE_EDIT_CONFIG_URL}/${shortSiteId}/resources`, {
            changeSetId,
            changeSet: [
                {
                    lang: liveEditUpdate.lang,
                    zone: liveEditUpdate.zoneKey,
                    page: RoutesUtilityService.sanitizeUrl(liveEditUpdate.pageName),
                    name: liveEditUpdate.propName,
                    value: liveEditUpdate.value,
                    action: "save" /* LiveEditUpdateType.SAVE */
                }
            ]
        })
            .subscribe({
            next: response => {
                console.log(response);
            }
        });
        // TODO: will we receive a response if this works or doesn't? we should receive some sort of status and if it fails
        // we need to create a UPDATE_CONFIG_FAILED action so we can watch this and alert the user
    }
    updateResource(ctx, { liveEditUpdate }) {
        const { setState } = ctx;
        const { lang, propName, value, pageName } = liveEditUpdate;
        // TODO: test page resources
        if (typeof lang !== 'undefined') {
            setState(patch({
                resourceBundle: updateItem(resourceBundle => resourceBundle.lang === lang, patch({
                    resources: updateItem(item => item.name === propName && (!item.page || item.page === RoutesUtilityService.sanitizeUrl(pageName)), patch({ value }))
                }))
            }));
        }
    }
    updateConfigResource(ctx, { resourceBundle }) {
        const { setState } = ctx;
        if (resourceBundle.length) {
            resourceBundle.forEach(config => {
                if (config.resources.length) {
                    config.resources.forEach(configResource => {
                        setState(patch({
                            resourceBundle: updateItem(resourceBundle => resourceBundle.lang === config.lang, patch({
                                resources: iif(items => items.some(item => item.name === configResource.name), updateItem(item => item.name === configResource.name, patch({ value: configResource.value })), insertItem(configResource))
                            }))
                        }));
                    });
                }
            });
        }
    }
    setAppConfigLoading(ctx, { loading }) {
        const { patchState } = ctx;
        patchState({ loading });
    }
    setAppConfigLoaded(ctx, { loaded }) {
        const { patchState } = ctx;
        patchState({ loaded });
    }
};
/**
 * Creates a callback for iterating an array of resources and finding a match.
 */
AppConfigState.resourceMatch = (key, page, widget, pages) => resource => {
    const match = resource?.name &&
        key &&
        resource.name.toLowerCase() === key.toLowerCase() &&
        (!resource.page ||
            (AppConfigState_1.pageLookupMatch(AppConfigState_1.lookupPage(pages, resource.page), RoutesUtilityService.sanitizeUrl(page)) &&
                (!resource.widget || resource.widget === widget)));
    return match;
};
AppConfigState.ɵfac = function AppConfigState_Factory(t) { return new (t || AppConfigState)(i0.ɵɵinject(LOCALE_ID), i0.ɵɵinject(i1$2.HttpClient)); };
AppConfigState.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AppConfigState, factory: AppConfigState.ɵfac });
__decorate([
    Action(SetClientId)
], AppConfigState.prototype, "setClientId", null);
__decorate([
    Action(InitializeConfig)
], AppConfigState.prototype, "initializeConfig", null);
__decorate([
    Action(InitializeLocales)
], AppConfigState.prototype, "initializeLocales", null);
__decorate([
    Action(InitializeWeglotLocales)
], AppConfigState.prototype, "initializeWeglotLocales", null);
__decorate([
    Action(SetConfig)
], AppConfigState.prototype, "setConfig", null);
__decorate([
    Action(SetLocale)
], AppConfigState.prototype, "setLocale", null);
__decorate([
    Action(SetDefaultWeglotLocale)
], AppConfigState.prototype, "setDefaultWeglotLocale", null);
__decorate([
    Action(SetWeglotLocale)
], AppConfigState.prototype, "setWeglotLocale", null);
__decorate([
    Action(SetSupportedWeglotLanguages)
], AppConfigState.prototype, "setSupportedWeglotLanguages", null);
__decorate([
    Action(UpdatePlatformResource)
], AppConfigState.prototype, "updatePlatformResource", null);
__decorate([
    Action(UpdateResource)
], AppConfigState.prototype, "updateResource", null);
__decorate([
    Action(UpdateConfigResource)
], AppConfigState.prototype, "updateConfigResource", null);
__decorate([
    Action(SetAppConfigLoading)
], AppConfigState.prototype, "setAppConfigLoading", null);
__decorate([
    Action(SetAppConfigLoaded)
], AppConfigState.prototype, "setAppConfigLoaded", null);
__decorate([
    Memoize()
], AppConfigState, "isEnrollmentPage", null);
__decorate([
    Memoize()
], AppConfigState, "lookupPage", null);
__decorate([
    Memoize()
], AppConfigState, "pageLookupMatch", null);
__decorate([
    Memoize()
], AppConfigState, "enrollmentPageLookupMatch", null);
__decorate([
    Memoize()
], AppConfigState, "mapResourceOverrides", null);
__decorate([
    Memoize()
], AppConfigState, "selectResourceOverrides", null);
__decorate([
    Selector()
], AppConfigState, "locales", null);
__decorate([
    Selector([AppConfigState_1.locales])
], AppConfigState, "currentLocale", null);
__decorate([
    Selector([AppConfigState_1.currentLocale])
], AppConfigState, "currentLocaleResourceBundle", null);
__decorate([
    Selector([AppConfigState_1.locales])
], AppConfigState, "defaultLocale", null);
__decorate([
    Selector([AppConfigState_1.defaultLocale])
], AppConfigState, "defaultLocaleResourceBundle", null);
__decorate([
    Selector()
], AppConfigState, "weglotLocales", null);
__decorate([
    Selector([AppConfigState_1.weglotLocales])
], AppConfigState, "currentWeglotLocale", null);
__decorate([
    Selector([AppConfigState_1.weglotLocales])
], AppConfigState, "defaultWeglotLocale", null);
__decorate([
    Selector()
], AppConfigState, "defaultUrl", null);
__decorate([
    Selector()
], AppConfigState, "siteId", null);
__decorate([
    Selector()
], AppConfigState, "resourceMetadata", null);
__decorate([
    Selector()
], AppConfigState, "resources", null);
__decorate([
    Selector([AppConfigState_1.resources])
], AppConfigState, "resourcesMap", null);
__decorate([
    Selector()
], AppConfigState, "homepage", null);
__decorate([
    Selector()
], AppConfigState, "loaded", null);
__decorate([
    Selector()
], AppConfigState, "loading", null);
__decorate([
    Selector()
], AppConfigState, "pages", null);
__decorate([
    Selector()
], AppConfigState, "clientId", null);
__decorate([
    Selector()
], AppConfigState, "environment", null);
__decorate([
    Selector()
], AppConfigState, "shortSiteId", null);
__decorate([
    Selector()
], AppConfigState, "supportedLanguages", null);
__decorate([
    Selector()
], AppConfigState, "supportedWeglotLanguages", null);
AppConfigState = AppConfigState_1 = __decorate([
    State({
        name: 'appConfig',
        defaults: APP_CONFIG_DEFAULTS
    })
    /**
     * The config that is used to build our application.
     */
], AppConfigState);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AppConfigState, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [LOCALE_ID]
            }] }, { type: i1$2.HttpClient }]; }, { setClientId: [], initializeConfig: [], initializeLocales: [], initializeWeglotLocales: [], setConfig: [], setLocale: [], setDefaultWeglotLocale: [], setWeglotLocale: [], setSupportedWeglotLanguages: [], updatePlatformResource: [], updateResource: [], updateConfigResource: [], setAppConfigLoading: [], setAppConfigLoaded: [] }); })();

class NavigationContext {
    constructor() {
        this.urlParamsSubject$ = new BehaviorSubject({});
        this.queryParamsSubject$ = new BehaviorSubject({});
        // until we set this the app root is assumed to be the default
        this.urlSubject$ = new BehaviorSubject('/');
    }
    // Note: These should only be necessary for services not loaded into a router outlet
    // since they will not receive the ActivatedRoute information.
    getUrlParams$() {
        return this.urlParamsSubject$.asObservable();
    }
    getQueryParams$() {
        return this.queryParamsSubject$.asObservable();
    }
    getUrl$() {
        return this.urlSubject$.asObservable();
    }
    getUrlParams() {
        return this.urlParamsSubject$.getValue();
    }
    getQueryParams() {
        return this.queryParamsSubject$.getValue();
    }
    getUrl() {
        return this.urlSubject$.getValue();
    }
    setUrlParams(urlParams) {
        this.urlParamsSubject$.next(urlParams);
    }
    setQueryParams(queryParams) {
        this.queryParamsSubject$.next(queryParams);
    }
    setUrl(url) {
        this.urlSubject$.pipe(take(1)).subscribe(prevUrl => {
            if (prevUrl !== url) {
                this.urlSubject$.next(url);
            }
        });
    }
}
NavigationContext.ɵfac = function NavigationContext_Factory(t) { return new (t || NavigationContext)(); };
NavigationContext.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: NavigationContext, factory: NavigationContext.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavigationContext, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

class ExternalErrorLoggingService {
    log(error) {
        if (window.newrelic) {
            window.newrelic.noticeError(error);
        }
    }
}
ExternalErrorLoggingService.ɵfac = function ExternalErrorLoggingService_Factory(t) { return new (t || ExternalErrorLoggingService)(); };
ExternalErrorLoggingService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ExternalErrorLoggingService, factory: ExternalErrorLoggingService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExternalErrorLoggingService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

class AuthService {
    constructor(http, router, store, navigationContext, externalErrorLoggingService) {
        this.http = http;
        this.router = router;
        this.store = store;
        this.navigationContext = navigationContext;
        this.externalErrorLoggingService = externalErrorLoggingService;
        this._refreshAuthToken$ = new Subject();
        this.jwtSubject = new BehaviorSubject(null);
    }
    observeForJWT() {
        return this.jwtSubject.asObservable();
    }
    tokenRefreshEvent$() {
        return this._refreshAuthToken$.asObservable();
    }
    requestTokenRefresh() {
        this.store
            .dispatch(new SetAuthStatus(AUTH_STATUS_CODES.JWT_LOADING))
            .pipe(take(1))
            .subscribe(() => {
            this._refreshAuthToken$.next(null);
        });
    }
    generateRandomString(length) {
        let text = '';
        const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
        for (let i = 0; i < length; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        return text;
    }
    base64URL(string) {
        return string.toString(CryptoJS.enc.Base64).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
    }
    generateCodeChallenge() {
        const CODE_VERIFIER = this.generateRandomString(43);
        sessionStorage.setItem('code_verifier', CODE_VERIFIER);
        return this.base64URL(CryptoJS.SHA256(CODE_VERIFIER));
    }
    getRedirectURI(encode = true) {
        // grab the query params from the url
        const existingQueryParams = this.getQueryParams(window.location.href);
        let redirectUrl = window.location.href.split('?')[0];
        let index = 0;
        // looping over each param so we can choose to black list certain params if needed
        for (const [key, value] of Object.entries(existingQueryParams)) {
            if (value && value !== 'undefined') {
                if (index === 0) {
                    redirectUrl = `${redirectUrl}?${key}=${value}`;
                }
                else {
                    redirectUrl = `${redirectUrl}&${key}=${value}`;
                }
                index++;
            }
        }
        // encode the url so it can be stored as a query param
        return encode ? encodeURIComponent(redirectUrl) : redirectUrl;
    }
    async getJWT(shortSiteId) {
        // third param is headers if we need them
        const environment = EnvironmentService.getEnvironment();
        const JWT_URL = `${environment.AUTH_BASE_URL}/oauth2/v1/token`;
        return this.http
            .post(JWT_URL, {
            audience: environment.AUTH_BASE_URL,
            client_id: environment.liveedit ? shortSiteId : this.store.selectSnapshot(AppConfigState.shortSiteId),
            redirect_uri: this.getRedirectURI(false),
            grant_type: 'client_credentials'
        })
            .toPromise();
    }
    saveJWT(accessToken) {
        // this.authStatusListener.next(true);
        this.saveAuthData(accessToken);
    }
    logOut() {
        this.router.navigate(['/login']);
    }
    getApiTokenKey() {
        return `${AuthService.API_TOKEN_KEY}_token${EnvironmentService.getEnvironment()?.liveedit ? '' : `_${this.store.selectSnapshot(AppConfigState.shortSiteId)}`}`;
    }
    getApiTokenKeyExpiresAt() {
        return `${AuthService.API_TOKEN_KEY}_expires_at${EnvironmentService.getEnvironment()?.liveedit ? '' : `_${this.store.selectSnapshot(AppConfigState.shortSiteId)}`}`;
    }
    hasApiSession() {
        const token = localStorage.getItem(this.getApiTokenKey());
        if (token) {
            return true;
        }
        return false;
    }
    isApiTokenExpired() {
        const now = dayjs();
        const expiration = this.getExpiration();
        return !!now.isAfter(expiration);
    }
    isAuthenticatedForApiCalls() {
        const token = localStorage.getItem(this.getApiTokenKey());
        if (token) {
            const isExpired = this.isApiTokenExpired();
            if (isExpired) {
                this.clearAuthData();
                return false;
            }
            const authStatus = this.store.selectSnapshot(RuntimeState.authStatus);
            if (authStatus !== AUTH_STATUS_CODES.JWT_SAVED && authStatus !== AUTH_STATUS_CODES.JWT_LOADED) {
                this.store.dispatch(new SetAuthStatus(AUTH_STATUS_CODES.JWT_SAVED));
            }
            return true;
        }
        return false;
    }
    getExpiration() {
        const expiration = localStorage.getItem(this.getApiTokenKeyExpiresAt());
        const expiresAt = JSON.parse(expiration);
        const expirationTime = dayjs(expiresAt);
        return expirationTime.isValid() ? expirationTime : 0;
    }
    getToken() {
        return localStorage.getItem(this.getApiTokenKey());
    }
    saveAuthData(token) {
        localStorage.setItem(this.getApiTokenKey(), token.access_token);
        const expiresAt = dayjs().add(token.expires_in, 'second');
        localStorage.setItem(this.getApiTokenKeyExpiresAt(), JSON.stringify(expiresAt.valueOf()));
        this.setClientId();
        this.jwtSubject.next(token.access_token);
    }
    setClientId() {
        const token = this.getToken();
        let accessToken;
        if (token) {
            try {
                accessToken = JSON.parse(atob(token.split('.')[1]));
            }
            catch (error) {
                this.externalErrorLoggingService.log(error);
            }
        }
        const clientId = ('000' + (accessToken?.client_id ?? '')).slice(-3);
        this.store.dispatch(new SetClientId(clientId));
        return clientId;
    }
    getClientId() {
        const clientId = this.store.selectSnapshot(AppConfigState.clientId);
        if (clientId) {
            return clientId;
        }
        else {
            return this.setClientId();
        }
    }
    clearAuthData() {
        localStorage.removeItem(this.getApiTokenKey());
        localStorage.removeItem(this.getApiTokenKeyExpiresAt());
        this.jwtSubject.next(null);
    }
    isCurrentTokenValid() {
        const authToken = this.getToken();
        // TODO: set auth status to loaded if we have a token already
        const authStatus = this.store.selectSnapshot(RuntimeState.authStatus);
        const isLoadedTokenExpired = authStatus === AUTH_STATUS_CODES.JWT_LOADED || authStatus === AUTH_STATUS_CODES.JWT_SAVED;
        const invalidToken = authStatus === AUTH_STATUS_CODES.UNAUTHORIZED || (isLoadedTokenExpired && (!authToken || this.isApiTokenExpired()));
        return !invalidToken;
    }
    loadJWT$() {
        return from(this.loadJWT());
    }
    async loadJWT() {
        let shortSiteId;
        if (EnvironmentService.getEnvironment().liveedit) {
            const urlParams = this.navigationContext.getUrlParams();
            shortSiteId = urlParams.shortSiteId;
        }
        await this.store.dispatch(new SetAuthStatus(AUTH_STATUS_CODES.JWT_LOADING)).toPromise();
        try {
            const authToken = await this.getJWT(shortSiteId);
            this.saveJWT(authToken);
            await this.store.dispatch(new SetAuthStatus(AUTH_STATUS_CODES.JWT_SAVED)).toPromise();
            return Promise.resolve(true);
        }
        catch {
            return Promise.resolve(false);
        }
    }
    isJWTLoading() {
        return this.store.selectSnapshot(RuntimeState.authStatus) === AUTH_STATUS_CODES.JWT_LOADING;
    }
    /**
     * Used when we need to manually attempt to refresh the JWT. The current example usage is during twilio calls where
     * we won't necessarily call any API endpoints to benefit from the sliding refresh.
     */
    refreshJWT() {
        this.http.get(`${EnvironmentService.getEnvironment().WEB_SERVICE_BASE_URL}/v1/utility/tokenRefresh`).subscribe(() => { });
    }
    // ran into issues using the activated route to grab the params, went with a vanilla javascript solution instead
    // https://dev.to/ganeshmani/how-to-get-query-string-parameters-in-javascript-2019-4dm2
    getQueryParams(url) {
        const queryParams = {};
        // create an anchor tag to use the property called search
        const anchor = document.createElement('a');
        // assigning url to href of anchor tag
        anchor.href = url;
        // search property returns the query string of url
        const queryStrings = anchor.search.substring(1);
        const params = queryStrings.split('&');
        for (let i = 0; i < params.length; i++) {
            const pair = params[i].split('=');
            queryParams[pair[0]] = decodeURIComponent(pair[1]);
        }
        return queryParams;
    }
}
AuthService.API_TOKEN_KEY = 'api';
AuthService.ɵfac = function AuthService_Factory(t) { return new (t || AuthService)(i0.ɵɵinject(i1$2.HttpClient), i0.ɵɵinject(i2$1.Router), i0.ɵɵinject(i1.Store), i0.ɵɵinject(NavigationContext), i0.ɵɵinject(ExternalErrorLoggingService)); };
AuthService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AuthService, factory: AuthService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$2.HttpClient }, { type: i2$1.Router }, { type: i1.Store }, { type: NavigationContext }, { type: ExternalErrorLoggingService }]; }, null); })();

class APITokenGuard {
    constructor(authService) {
        this.authService = authService;
    }
    async canDeactivate(component) {
        const isAPITokenValid = this.authService.isCurrentTokenValid();
        const isTokenLoading = this.authService.isJWTLoading();
        if (!isTokenLoading && !isAPITokenValid) {
            return this.authService.loadJWT();
        }
        // if no jwt token then we should not navigated until this is refreshed as its jarring
        // to navigate, start the jwt acquisiton and refresh the page
        return !isTokenLoading;
    }
}
APITokenGuard.ɵfac = function APITokenGuard_Factory(t) { return new (t || APITokenGuard)(i0.ɵɵinject(AuthService)); };
APITokenGuard.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: APITokenGuard, factory: APITokenGuard.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(APITokenGuard, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: AuthService }]; }, null); })();

class CanDeactivateGuard {
    async canDeactivate(component) {
        return component.canDeactivate();
    }
}
CanDeactivateGuard.ɵfac = function CanDeactivateGuard_Factory(t) { return new (t || CanDeactivateGuard)(); };
CanDeactivateGuard.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CanDeactivateGuard, factory: CanDeactivateGuard.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CanDeactivateGuard, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

const ROUTER_EXTRAS_VALIDATE_KEY = 'validateWidgets';
class WidgetValidationGuard {
    constructor(router, store) {
        this.router = router;
        this.store = store;
    }
    canDeactivate(component) {
        if (this.shouldValidate()) {
            const errors = component.validate();
            if (errors && errors.length) {
                this.store.dispatch(new AddErrors(errors));
                return false;
            }
            this.store.dispatch(new ClearPageErrors(component.pageId));
        }
        return true;
    }
    /**
     * Looking to navigation extras for deciding whether or not to validate.
     * If no extras are supplied the transition will not validate by default.
     */
    shouldValidate() {
        const extras = this.router.getCurrentNavigation().extras;
        if (extras && extras.state) {
            return extras.state[ROUTER_EXTRAS_VALIDATE_KEY];
        }
        return false;
    }
}
WidgetValidationGuard.ɵfac = function WidgetValidationGuard_Factory(t) { return new (t || WidgetValidationGuard)(i0.ɵɵinject(i2$1.Router), i0.ɵɵinject(i1.Store)); };
WidgetValidationGuard.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: WidgetValidationGuard, factory: WidgetValidationGuard.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WidgetValidationGuard, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i2$1.Router }, { type: i1.Store }]; }, null); })();

var _a;
class ThemeStyle {
}
// OUTDATED HERE FOR LOOKUP PURPOSES ONLY
// export class ColorPalette {
//   static WHITE: string = '#fff';
//   static PRIMARY_DEFAULT: string = '#344157';
//   static PRIMARY_LIGHTER: string = '#e1e3e6';
//   static PRIMARY_LIGHT: string = '#858d9a';
//   static PRIMARY_DARK: string = '#2c374a';
//   static PRIMARY_DARKER: string = '#242e3d';
//   static SECONDARY_DEFAULT: string = '#40c0c5';
//   static SECONDARY_LIGHTER: string = '#e2f6f6';
//   static SECONDARY_LIGHT: string = '#8cd9dc';
//   static SECONDARY_DARK: string = '#36a3a7';
//   static SECONDARY_DARKER: string = '#2b8184';
//   static TERTIARY_DEFAULT: string = '#99cc55';
//   static TERTIARY_LIGHTER: string = '#f0f7e6';
//   static TERTIARY_LIGHT: string = '#c2e099';
//   static TERTIARY_DARK: string = '#82ad48';
//   static TERTIARY_DARKER: string = '#5f7e35';
//   static SUCCESS_DEFAULT: string = '#0d8a01';
//   static SUCCESS_LIGHTER: string = '#dbedd9';
//   static SUCCESS_LIGHT: string = '#6eb967';
//   static SUCCESS_DARK: string = '#0b7501';
//   static SUCCESS_DARKER: string = '#096010';
//   static WARN_DEFAULT: string = '#fcb215';
//   static WARN_LIGHTER: string = '#fff3dc';
//   static WARN_LIGHT: string = '#fdd173';
//   static WARN_DARK: string = '#d69712';
//   static WARN_DARKER: string = '#b07d0f';
//   static ERROR_DEFAULT: string = '#8f1e01';
//   static ERROR_LIGHTER: string = '#eeddd9';
//   static ERROR_LIGHT: string = '#bc7867';
//   static ERROR_DARK: string = '#7a1a01';
//   static ERROR_DARKER: string = '#641501';
//   static INFO_DEFAULT: string = '#3a9b9e';
//   static INFO_LIGHTER: string = '#e1f0f0';
//   static INFO_LIGHT: string = '#89c3c5';
//   static INFO_DARK: string = '#308183';
//   static INFO_DARKER: string = '#296d6f';
//   static GRAY_LIGHTEST: string = '#f5f5f5';
//   static GRAY_LIGHTER: string = '#dfdfdf';
//   static GRAY_LIGHT: string = '#bdbdbd';
//   static GRAY: string = '#666666';
//   static GRAY_DARK: string = '#404040';
//   static BLACK: string = '#1f1f1f';
//   static LINK: string = '#016c86';
//   static LINK_HOVER: string = '#014353';
//   static LINK_LIGHT: string = '#8cd9dc';
//   static LINK_HOVER_LIGHT: string = '#e2f6f6';
//   static COST: string = '#0d8a01';
//   static INPUT_SELECTED_LIGHT: string = '#dbedd9';
//   static INPUT_SELECTED_DARK: string = '#0d8a01';
// }
var ColorResourceKeys;
(function (ColorResourceKeys) {
    ColorResourceKeys["PRIMARY_TEXT"] = "Spa_Style_Primary";
    ColorResourceKeys["PRIMARY_BUTTON_TEXT"] = "Spa_Style_PrimaryButton_Text";
    ColorResourceKeys["SECONDARY_TEXT"] = "Spa_Style_Secondary_Text";
    ColorResourceKeys["SECONDARY_BUTTON_TEXT"] = "Spa_Style_SecondaryButton_Text";
    ColorResourceKeys["TERTIARY_BUTTON_BORDER"] = "Spa_Style_TertiaryButton_Border";
    ColorResourceKeys["PRIMARY_LINK"] = "Spa_Style_Primary_Link";
    ColorResourceKeys["PRIMARY_LINK_HOVER"] = "Spa_Style_Primary_Link_Hover";
    ColorResourceKeys["SECONDARY_LINK"] = "Spa_Style_Secondary_Link";
    ColorResourceKeys["ACCENT1"] = "Spa_Style_Accent1";
    ColorResourceKeys["ACCENT2"] = "Spa_Style_Accent2";
    ColorResourceKeys["ACCENT3"] = "Spa_Style_Accent3";
    ColorResourceKeys["ACCENT4"] = "Spa_Style_Accent4";
    ColorResourceKeys["ACCENT5"] = "Spa_Style_Accent5";
    ColorResourceKeys["ACCENT6"] = "Spa_Style_Accent6";
    ColorResourceKeys["GRAY1"] = "Spa_Style_Gray1";
    ColorResourceKeys["GRAY2"] = "Spa_Style_Gray2";
    ColorResourceKeys["GRAY4"] = "Spa_Style_Gray4";
    ColorResourceKeys["COST"] = "Spa_Style_Cost_Text";
    ColorResourceKeys["COST_BACKGROUND"] = "Spa_Style_Cost";
    ColorResourceKeys["TOGGLE"] = "Spa_Style_Toggle";
    ColorResourceKeys["BANNER_BACKGROUND"] = "Spa_Style_Banner";
    ColorResourceKeys["DISABLED_BACKGROUND"] = "Spa_Style_Disabled_Background";
})(ColorResourceKeys || (ColorResourceKeys = {}));
var Fonts;
(function (Fonts) {
    Fonts["TIMES_NEW_ROMAN"] = "Times new roman";
    Fonts["VERDANA"] = "Verdana";
    Fonts["ARIAL"] = "Arial";
    Fonts["DEFAULT"] = "DEFAULT";
})(Fonts || (Fonts = {}));
var FontSizeResourceKeys;
(function (FontSizeResourceKeys) {
    // According to Jess's naming:
    // Note (13px)
    FontSizeResourceKeys["SMALLER"] = "Spa_Style_Smaller";
    // "Normal"/Regular paragraph (14px), most things should be this, not the regular style
    FontSizeResourceKeys["SMALL"] = "Spa_Style_Small";
    // Intro paragraph (16px)
    FontSizeResourceKeys["REGULAR"] = "Spa_Style_Regular";
    // H3 (18px)
    FontSizeResourceKeys["LARGE"] = "Spa_Style_Large";
    // H2 (22px)
    FontSizeResourceKeys["LARGER"] = "Spa_Style_Larger";
    // H3 (32px)
    FontSizeResourceKeys["LARGEST"] = "Spa_Style_Largest";
})(FontSizeResourceKeys || (FontSizeResourceKeys = {}));
var FontWeightResourceKeys;
(function (FontWeightResourceKeys) {
    FontWeightResourceKeys["LIGHT"] = "Spa_Style_Light_Weight";
    FontWeightResourceKeys["REGULAR"] = "Spa_Style_Regular_Weight";
    FontWeightResourceKeys["SEMI_BOLD"] = "Spa_Style_Semi_Bold_Weight";
    FontWeightResourceKeys["BOLD"] = "Spa_Style_Bold_Weight";
})(FontWeightResourceKeys || (FontWeightResourceKeys = {}));
const STATIC_CSS_VAR_PREFIX = 'static-';
const SITE_BLACK = '#1f1f1f';
// note font resources are not configurable.
class AppThemeConfig {
    static setResources() {
        this.setCSSColorVariables();
        FontHelper.setCSSFontVariables();
        return [
            {
                deprecated: false,
                resourceKey: 'Spa_Style_NonCoveredPrescriptions_Icon',
                className: 'Spa_Style_NonCoveredPrescriptions_Icon',
                isIcon: true,
                styling: {
                    'color': {
                        default: AppThemeConfig.getColorValueByKey(ColorResourceKeys.ACCENT1),
                        hover: AppThemeConfig.getColorValueByKey(ColorResourceKeys.ACCENT1)
                    },
                    'content': { before: "'\\f057'" },
                    'font-weight': 900
                }
            },
            {
                resourceKey: 'Spa_Style_H1',
                deprecated: false,
                className: 'Spa_Style_H1',
                styling: {
                    color: AppThemeConfig.getColorValueByKey(ColorResourceKeys.PRIMARY_TEXT)
                },
                fontSize: FontSizeResourceKeys.LARGEST,
                fontWeight: FontWeightResourceKeys.LIGHT
            },
            {
                resourceKey: 'Spa_Style_H2',
                deprecated: false,
                className: 'Spa_Style_H2',
                styling: {
                    color: AppThemeConfig.getColorValueByKey(ColorResourceKeys.PRIMARY_TEXT)
                },
                fontSize: FontSizeResourceKeys.LARGER,
                fontWeight: FontWeightResourceKeys.REGULAR
            },
            {
                resourceKey: 'Spa_Style_H2_Light',
                deprecated: true,
                className: 'Spa_Style_H2_Light',
                styling: {
                    color: AppThemeConfig.getColorValueByKey(ColorResourceKeys.SECONDARY_TEXT)
                },
                fontSize: FontSizeResourceKeys.LARGER,
                fontWeight: FontWeightResourceKeys.REGULAR
            },
            {
                resourceKey: 'Spa_Style_H3',
                deprecated: false,
                className: 'Spa_Style_H3',
                styling: {
                    color: AppThemeConfig.getColorValueByKey(ColorResourceKeys.PRIMARY_TEXT)
                },
                fontSize: FontSizeResourceKeys.LARGE,
                fontWeight: FontWeightResourceKeys.BOLD
            },
            {
                resourceKey: 'Spa_Style_H4',
                deprecated: false,
                className: 'Spa_Style_H4',
                styling: {
                    color: AppThemeConfig.getColorValueByKey(ColorResourceKeys.PRIMARY_TEXT)
                },
                fontSize: FontSizeResourceKeys.REGULAR,
                fontWeight: FontWeightResourceKeys.BOLD
            },
            {
                resourceKey: 'Spa_Style_H4_Light',
                deprecated: true,
                className: 'Spa_Style_H4_Light',
                styling: {
                    color: AppThemeConfig.getColorValueByKey(ColorResourceKeys.SECONDARY_TEXT)
                },
                fontSize: FontSizeResourceKeys.REGULAR,
                fontWeight: FontWeightResourceKeys.BOLD
            },
            {
                resourceKey: 'Spa_Style_H5',
                deprecated: false,
                className: 'Spa_Style_H5',
                styling: {
                    color: AppThemeConfig.getColorValueByKey(ColorResourceKeys.PRIMARY_TEXT)
                },
                fontSize: FontSizeResourceKeys.SMALL,
                fontWeight: FontWeightResourceKeys.REGULAR
            },
            {
                resourceKey: 'Spa_Style_Link',
                deprecated: false,
                className: 'Spa_Style_Link',
                styling: {
                    'color': {
                        default: AppThemeConfig.getColorValueByKey(ColorResourceKeys.PRIMARY_LINK),
                        hover: AppThemeConfig.adjustColor(ColorResourceKeys.PRIMARY_LINK, -50),
                        cursor: 'pointer'
                    },
                    'text-decoration': {
                        default: 'underline',
                        hover: 'underline'
                    }
                },
                fontSize: FontSizeResourceKeys.SMALL,
                fontWeight: FontWeightResourceKeys.REGULAR
            },
            {
                resourceKey: 'Spa_Style_LinkOnDarkBackgrounds',
                deprecated: false,
                className: 'Spa_Style_LinkOnDarkBackgrounds',
                styling: {
                    color: {
                        default: AppThemeConfig.getColorValueByKey(ColorResourceKeys.SECONDARY_LINK),
                        hover: AppThemeConfig.adjustColor(ColorResourceKeys.SECONDARY_LINK, 50)
                    },
                    cursor: 'pointer'
                },
                fontSize: FontSizeResourceKeys.SMALL,
                fontWeight: FontWeightResourceKeys.REGULAR
            },
            {
                resourceKey: 'Spa_Style_CostPremiumLarge',
                deprecated: true,
                className: 'Spa_Style_CostPremiumLarge',
                styling: {
                    color: AppThemeConfig.getColorValueByKey(ColorResourceKeys.COST)
                },
                fontSize: FontSizeResourceKeys.LARGER,
                fontWeight: FontWeightResourceKeys.REGULAR
            },
            {
                resourceKey: 'Spa_Style_PrimaryButton',
                deprecated: false,
                className: 'Spa_Style_PrimaryButton',
                styling: {
                    'color': {
                        default: AppThemeConfig.getColorValueByKey(ColorResourceKeys.PRIMARY_BUTTON_TEXT),
                        hover: AppThemeConfig.getColorValueByKey(ColorResourceKeys.PRIMARY_BUTTON_TEXT)
                    },
                    'background-color': {
                        default: '#fcb215',
                        hover: '#de9400'
                    },
                    'border-color': {
                        default: '#ca8000',
                        hover: '#ca8000'
                    }
                },
                fontSize: FontSizeResourceKeys.REGULAR,
                fontWeight: FontWeightResourceKeys.SEMI_BOLD,
                isButton: true
            },
            {
                resourceKey: 'Spa_Style_SecondaryButton',
                deprecated: false,
                className: 'Spa_Style_SecondaryButton',
                styling: {
                    'color': {
                        default: AppThemeConfig.getColorValueByKey(ColorResourceKeys.SECONDARY_BUTTON_TEXT),
                        hover: AppThemeConfig.getColorValueByKey(ColorResourceKeys.SECONDARY_BUTTON_TEXT)
                    },
                    'background-color': {
                        default: '#f5f5f5',
                        hover: '#dfdfdf'
                    },
                    'border-color': {
                        default: '#bdbdbd',
                        hover: '#bdbdbd'
                    }
                },
                fontSize: FontSizeResourceKeys.REGULAR,
                fontWeight: FontWeightResourceKeys.SEMI_BOLD,
                isButton: true
            },
            {
                resourceKey: 'Spa_Style_TertiaryButton',
                deprecated: false,
                className: 'Spa_Style_TertiaryButton',
                styling: {
                    'color': {
                        default: AppThemeConfig.getColorValueByKey(ColorResourceKeys.PRIMARY_TEXT),
                        hover: AppThemeConfig.getColorValueByKey(ColorResourceKeys.PRIMARY_TEXT)
                    },
                    'background-color': {
                        default: '#ffffff',
                        hover: '#dfdfdf'
                    },
                    'border-color': {
                        default: AppThemeConfig.getColorValueByKey(ColorResourceKeys.TERTIARY_BUTTON_BORDER),
                        hover: AppThemeConfig.getColorValueByKey(ColorResourceKeys.TERTIARY_BUTTON_BORDER)
                    }
                },
                fontSize: FontSizeResourceKeys.REGULAR,
                fontWeight: FontWeightResourceKeys.SEMI_BOLD,
                isButton: true
            },
            {
                resourceKey: '<Spa_Style_ToolTip>',
                deprecated: false,
                className: 'Spa_Style_ToolTip',
                styling: {
                    'color': AppThemeConfig.getColorValueByKey(ColorResourceKeys.PRIMARY_TEXT),
                    'background-color': '#ffffff',
                    'border-color': AppThemeConfig.getColorValueByKey(ColorResourceKeys.PRIMARY_TEXT),
                    'text-align': 'left',
                    'padding': '14px 10px'
                },
                fontSize: FontSizeResourceKeys.SMALL,
                fontWeight: FontWeightResourceKeys.REGULAR
            },
            {
                resourceKey: 'Spa_Style_InactiveTabAndModal',
                deprecated: true,
                className: 'Spa_Style_InactiveTabAndModal',
                styling: {
                    'color': AppThemeConfig.getColorValueByKey(ColorResourceKeys.PRIMARY_TEXT),
                    'background-color': AppThemeConfig.getColorValueByKey(ColorResourceKeys.GRAY2)
                },
                fontSize: FontSizeResourceKeys.SMALL,
                fontWeight: FontWeightResourceKeys.REGULAR
            },
            {
                resourceKey: 'Spa_Style_ErrorBarAndIcon',
                deprecated: true,
                className: 'Spa_Style_ErrorBarAndIcon',
                isIcon: false,
                styling: {
                    color: AppThemeConfig.getColorValueByKey(ColorResourceKeys.ACCENT2)
                }
            },
            {
                resourceKey: 'Spa_Style_AddOnCoverageAndQuoteIcons',
                deprecated: true,
                className: 'Spa_Style_AddOnCoverageAndQuoteIcons',
                isIcon: false,
                styling: {
                    color: AppThemeConfig.getColorValueByKey(ColorResourceKeys.PRIMARY_LINK)
                }
            },
            {
                resourceKey: 'Spa_Style_InfoBackGround',
                deprecated: true,
                className: 'Spa_Style_InfoBackGround',
                styling: {
                    'background-color': AppThemeConfig.getColorValueByKey(ColorResourceKeys.TOGGLE),
                    'border-left-color': AppThemeConfig.adjustColor(ColorResourceKeys.TOGGLE, -50)
                }
            },
            {
                resourceKey: 'Spa_Style_InfoBarAndIconColor',
                deprecated: true,
                className: 'Spa_Style_InfoBarAndIconColor',
                styling: {
                    'background-color': AppThemeConfig.adjustColor(ColorResourceKeys.TOGGLE, -50),
                    'color': AppThemeConfig.adjustColor(ColorResourceKeys.TOGGLE, -50)
                }
            },
            {
                resourceKey: 'Spa_Style_WarningBackground',
                deprecated: true,
                className: 'Spa_Style_WarningBackground',
                styling: {
                    // 'background-color': ColorPalette.WARN_LIGHTER,
                    'border-left-color': AppThemeConfig.getColorValueByKey(ColorResourceKeys.ACCENT4)
                }
            },
            {
                resourceKey: 'Spa_Style_WarningBarAndHealthSlider',
                deprecated: true,
                className: 'Spa_Style_WarningBarAndHealthSlider',
                styling: {
                    'background-color': AppThemeConfig.getColorValueByKey(ColorResourceKeys.ACCENT4)
                }
            },
            {
                resourceKey: 'Spa_Style_ErrorBackground',
                deprecated: true,
                className: 'Spa_Style_ErrorBackground',
                styling: {
                    // 'background-color': ColorPalette.ERROR_LIGHTER,
                    'border-left-color': AppThemeConfig.getColorValueByKey(ColorResourceKeys.ACCENT2)
                }
            },
            {
                resourceKey: 'Spa_Style_ErrorBarAndIconColor',
                deprecated: true,
                className: 'Spa_Style_ErrorBarAndIconColor',
                styling: {
                    'background-color': AppThemeConfig.getColorValueByKey(ColorResourceKeys.ACCENT2)
                }
            },
            {
                resourceKey: 'Spa_Style_SuccessBarAndIconColor',
                deprecated: true,
                className: 'Spa_Style_SuccessBarAndIconColor',
                styling: {
                    'background-color': AppThemeConfig.getColorValueByKey(ColorResourceKeys.COST)
                }
            },
            {
                resourceKey: 'Spa_Style_SuccessBackground',
                deprecated: true,
                className: 'Spa_Style_SuccessBackground',
                styling: {
                    'background-color': AppThemeConfig.getColorValueByKey(ColorResourceKeys.COST_BACKGROUND),
                    'border-left-color': AppThemeConfig.getColorValueByKey(ColorResourceKeys.COST)
                }
            },
            {
                resourceKey: 'Spa_Style_Paragraph',
                deprecated: true,
                className: 'Spa_Style_Paragraph',
                styling: {
                    color: AppThemeConfig.getColorValueByKey(ColorResourceKeys.PRIMARY_TEXT)
                },
                fontSize: FontSizeResourceKeys.SMALL,
                fontWeight: FontWeightResourceKeys.REGULAR
            },
            {
                resourceKey: 'Spa_Style_Note',
                deprecated: true,
                className: 'Spa_Style_Note',
                styling: {
                    color: AppThemeConfig.getColorValueByKey(ColorResourceKeys.GRAY4)
                },
                fontSize: FontSizeResourceKeys.SMALLER,
                fontWeight: FontWeightResourceKeys.REGULAR
            },
            {
                resourceKey: 'Spa_Style_Label',
                deprecated: false,
                className: 'Spa_Style_Label',
                styling: {
                    color: AppThemeConfig.getColorValueByKey(ColorResourceKeys.PRIMARY_TEXT)
                },
                fontWeight: FontWeightResourceKeys.BOLD,
                fontSize: FontSizeResourceKeys.SMALL
            },
            {
                resourceKey: 'Spa_Style_H5_Note',
                deprecated: true,
                className: 'Spa_Style_H5_Note',
                styling: {
                    color: AppThemeConfig.getColorValueByKey(ColorResourceKeys.GRAY4)
                },
                fontWeight: FontWeightResourceKeys.SEMI_BOLD,
                fontSize: FontSizeResourceKeys.SMALL
            },
            {
                deprecated: false,
                resourceKey: 'Spa_Style_DetailsAndCompare_H3_Background',
                className: 'Spa_Style_DetailsAndCompare_H3_Background',
                styling: {
                    'background-color': AppThemeConfig.getColorValueByKey(ColorResourceKeys.GRAY2)
                }
            },
            {
                deprecated: false,
                resourceKey: 'Spa_Style_DetailsAndCompare_H2_Background',
                className: 'Spa_Style_DetailsAndCompare_H2_Background',
                styling: {
                    'background-color': AppThemeConfig.getColorValueByKey(ColorResourceKeys.ACCENT1)
                }
            },
            {
                deprecated: false,
                resourceKey: 'Spa_Style_DetailsAndCompare_H1_Text',
                className: 'Spa_Style_DetailsAndCompare_H1_Text',
                styling: {
                    color: '#ffffff'
                },
                fontSize: FontSizeResourceKeys.LARGEST,
                fontWeight: FontWeightResourceKeys.REGULAR
            },
            {
                deprecated: false,
                resourceKey: 'Spa_Style_HeaderTextLevel',
                className: 'Spa_Style_HeaderTextLevel',
                styling: {
                    color: '#000000'
                },
                fontSize: FontSizeResourceKeys.LARGE,
                fontWeight: FontWeightResourceKeys.SEMI_BOLD
            },
            {
                resourceKey: 'Spa_Style_DentistsIcon',
                deprecated: false,
                className: 'Spa_Style_DentistsIcon',
                isIcon: true,
                styling: {
                    'color': AppThemeConfig.getColorValueByKey(ColorResourceKeys.ACCENT1),
                    'content': { before: "'\\f5c9'" },
                    'font-weight': 900
                }
            },
            {
                resourceKey: 'Spa_Style_ProvidersIcon',
                deprecated: false,
                className: 'Spa_Style_ProvidersIcon',
                isIcon: true,
                styling: {
                    'color': AppThemeConfig.getColorValueByKey(ColorResourceKeys.ACCENT3),
                    'content': { before: "'\\f0f0'" },
                    'font-weight': 900
                }
            },
            {
                resourceKey: 'Spa_Style_PrescriptionsIcon',
                deprecated: false,
                className: 'Spa_Style_PrescriptionsIcon',
                isIcon: true,
                styling: {
                    'color': AppThemeConfig.getColorValueByKey(ColorResourceKeys.ACCENT4),
                    'content': { before: "'\\f46b'" },
                    'font-weight': 900
                }
            },
            {
                resourceKey: 'Spa_Style_HealthIcon',
                deprecated: false,
                className: 'Spa_Style_HealthIcon',
                isIcon: true,
                styling: {
                    'color': AppThemeConfig.getColorValueByKey(ColorResourceKeys.ACCENT2),
                    'content': { before: "'\\f21e'" },
                    'font-weight': 900
                }
            },
            {
                resourceKey: 'Spa_Style_OtherPreferencesIcon',
                deprecated: false,
                className: 'Spa_Style_OtherPreferencesIcon',
                isIcon: true,
                styling: {
                    'color': AppThemeConfig.getColorValueByKey(ColorResourceKeys.ACCENT6),
                    'content': { before: "'\\f03a'" },
                    'font-weight': 900
                }
            },
            {
                resourceKey: 'Spa_Style_CostIcon',
                deprecated: false,
                className: 'Spa_Style_CostIcon',
                isIcon: true,
                styling: {
                    'color': AppThemeConfig.getColorValueByKey(ColorResourceKeys.COST),
                    'content': { before: "'\\f155'" },
                    'font-weight': 900
                }
            },
            {
                resourceKey: 'Spa_Style_Electronic_Prescription_Icon',
                deprecated: false,
                className: 'Spa_Style_Electronic_Prescription_Icon',
                isIcon: true,
                styling: {
                    'color': AppThemeConfig.getColorValueByKey(ColorResourceKeys.ACCENT6),
                    'content': { before: "'\\f812'" },
                    'font-weight': 900
                }
            },
            {
                resourceKey: 'Spa_Style_Paragraph_Light',
                deprecated: true,
                className: 'Spa_Style_Paragraph_Light',
                styling: {
                    color: AppThemeConfig.getColorValueByKey(ColorResourceKeys.SECONDARY_TEXT)
                },
                fontSize: FontSizeResourceKeys.SMALL,
                fontWeight: FontWeightResourceKeys.REGULAR
            },
            {
                resourceKey: 'Spa_Style_CostPremiumSmall',
                deprecated: true,
                className: 'Spa_Style_CostPremiumSmall',
                styling: {
                    color: AppThemeConfig.getColorValueByKey(ColorResourceKeys.COST)
                },
                fontSize: FontSizeResourceKeys.LARGE,
                fontWeight: FontWeightResourceKeys.BOLD
            },
            {
                resourceKey: 'Spa_Style_RiderBackgroundAndBorderBeforeAdded',
                deprecated: true,
                className: 'Spa_Style_RiderBackgroundAndBorderBeforeAdded',
                styling: {
                    'background-color': AppThemeConfig.getColorValueByKey(ColorResourceKeys.GRAY1),
                    'border-color': AppThemeConfig.getColorValueByKey(ColorResourceKeys.GRAY1)
                }
            },
            {
                resourceKey: 'Spa_Style_BackgroundBoxRidersAfterAdded',
                deprecated: true,
                className: 'Spa_Style_BackgroundBoxRidersAfterAdded',
                styling: {
                    'background-color': AppThemeConfig.getColorValueByKey(ColorResourceKeys.SECONDARY_TEXT)
                }
            },
            {
                resourceKey: 'Spa_Style_BoxBorderRidersAfterAdded',
                deprecated: true,
                className: 'Spa_Style_BoxBorderRidersAfterAdded',
                styling: {
                    'border-color': AppThemeConfig.getColorValueByKey(ColorResourceKeys.ACCENT1)
                }
            },
            {
                resourceKey: 'Spa_Style_WidgetBorderColor',
                deprecated: true,
                className: 'Spa_Style_WidgetBorderColor',
                styling: {
                    'border-color': AppThemeConfig.getColorValueByKey(ColorResourceKeys.ACCENT1)
                }
            },
            {
                resourceKey: 'Spa_Style_PharmacyIcon',
                deprecated: false,
                className: 'Spa_Style_PharmacyIcon',
                isIcon: true,
                styling: {
                    'content': { before: "'\\f3c5'" },
                    'font-weight': 900,
                    'color': { default: AppThemeConfig.getColorValueByKey(ColorResourceKeys.ACCENT5) }
                }
            },
            {
                resourceKey: 'Spa_Style_EditIcon',
                deprecated: false,
                className: 'Spa_Style_EditIcon',
                isIcon: true,
                styling: {
                    'color': {
                        default: '#fcb215'
                    },
                    'content': { before: "'\\f044'" },
                    'font-weight': 900
                }
            },
            {
                resourceKey: 'Spa_Style_GettingStartedIcon',
                deprecated: false,
                className: 'Spa_Style_GettingStartedIcon',
                isIcon: true,
                styling: {
                    color: {
                        default: AppThemeConfig.getColorValueByKey(ColorResourceKeys.ACCENT1),
                        hover: AppThemeConfig.getColorValueByKey(ColorResourceKeys.ACCENT1)
                    },
                    content: { before: "'\\f4ff'" }
                }
            },
            {
                resourceKey: 'Spa_Style_SecondaryButtonSelected',
                deprecated: false,
                className: 'Spa_Style_SecondaryButtonSelected',
                styling: {
                    'color': {
                        default: AppThemeConfig.getColorValueByKey(ColorResourceKeys.PRIMARY_LINK),
                        hover: AppThemeConfig.getColorValueByKey(ColorResourceKeys.PRIMARY_LINK)
                    },
                    'border': `1px solid ${AppThemeConfig.adjustColor(ColorResourceKeys.TOGGLE, -80)}`,
                    'background-color': {
                        default: AppThemeConfig.getColorValueByKey(ColorResourceKeys.TOGGLE)
                    }
                },
                fontWeight: FontWeightResourceKeys.SEMI_BOLD,
                fontSize: FontSizeResourceKeys.REGULAR
            },
            {
                resourceKey: 'Spa_Style_SecondaryButtonDisabled',
                deprecated: false,
                className: 'Spa_Style_SecondaryButtonDisabled',
                styling: {
                    'color': {
                        default: AppThemeConfig.getColorValueByKey(ColorResourceKeys.PRIMARY_LINK),
                        hover: AppThemeConfig.getColorValueByKey(ColorResourceKeys.PRIMARY_LINK)
                    },
                    'border': `1px solid ${AppThemeConfig.adjustColor(ColorResourceKeys.TOGGLE, -80)}`,
                    'background-color': {
                        default: AppThemeConfig.adjustColor(ColorResourceKeys.TOGGLE, -30)
                    }
                },
                fontWeight: FontWeightResourceKeys.SEMI_BOLD,
                fontSize: FontSizeResourceKeys.REGULAR
            },
            {
                resourceKey: 'Spa_Style_IntroParagraph_SemiBold',
                deprecated: true,
                className: 'Spa_Style_IntroParagraph_SemiBold',
                styling: {
                    color: AppThemeConfig.getColorValueByKey(ColorResourceKeys.PRIMARY_TEXT)
                },
                fontWeight: FontWeightResourceKeys.SEMI_BOLD,
                fontSize: FontSizeResourceKeys.REGULAR
            },
            {
                resourceKey: 'Spa_Style_IntroParagraph',
                deprecated: true,
                className: 'Spa_Style_IntroParagraph',
                styling: {
                    color: AppThemeConfig.getColorValueByKey(ColorResourceKeys.PRIMARY_TEXT)
                },
                fontSize: FontSizeResourceKeys.REGULAR,
                fontWeight: FontWeightResourceKeys.REGULAR
            },
            {
                resourceKey: 'Spa_Style_IntroParagraph_Light',
                deprecated: true,
                className: 'Spa_Style_IntroParagraph_Light',
                styling: {
                    color: AppThemeConfig.getColorValueByKey(ColorResourceKeys.SECONDARY_TEXT)
                },
                fontSize: FontSizeResourceKeys.REGULAR,
                fontWeight: FontWeightResourceKeys.REGULAR
            },
            {
                resourceKey: 'Spa_Style_TooltipTextAndNumberIndicators',
                deprecated: true,
                className: 'Spa_Style_TooltipTextAndNumberIndicators',
                styling: {
                    color: { default: AppThemeConfig.getColorValueByKey(ColorResourceKeys.PRIMARY_TEXT) }
                },
                fontSize: FontSizeResourceKeys.SMALL,
                fontWeight: FontWeightResourceKeys.BOLD
            },
            {
                resourceKey: 'Spa_Style_HeaderTextLevel',
                deprecated: true,
                className: 'Spa_Style_HeaderTextLevel',
                styling: {
                    color: AppThemeConfig.getColorValueByKey(ColorResourceKeys.PRIMARY_TEXT)
                },
                fontSize: FontSizeResourceKeys.LARGE,
                fontWeight: FontWeightResourceKeys.SEMI_BOLD
            },
            {
                resourceKey: 'Spa_Style_Phase_Names_Text',
                deprecated: false,
                className: 'Spa_Style_Phase_Names_Text',
                styling: {
                    color: AppThemeConfig.getColorValueByKey(ColorResourceKeys.PRIMARY_TEXT)
                },
                fontSize: FontSizeResourceKeys.SMALLER,
                fontWeight: FontWeightResourceKeys.REGULAR
            },
            {
                resourceKey: 'Spa_Style_CheckmarksAndPreferredInNetwork',
                deprecated: true,
                className: 'Spa_Style_CheckmarksAndPreferredInNetwork',
                styling: {
                // color: ColorPalette.TERTIARY_DEFAULT
                }
            },
            {
                resourceKey: 'Spa_Style_DentalRiderIcon',
                className: 'Spa_Style_DentalRiderIcon',
                deprecated: false,
                isIcon: true,
                styling: {
                    'content': { before: "'\\f5c9'" },
                    'font-weight': 900
                },
                fontSize: FontSizeResourceKeys.SMALL
            },
            {
                resourceKey: 'Spa_Style_VisionRiderIcon',
                deprecated: false,
                className: 'Spa_Style_VisionRiderIcon',
                isIcon: true,
                styling: {
                    'content': { before: "'\\f530'" },
                    'font-weight': 900
                },
                fontSize: FontSizeResourceKeys.SMALL
            },
            {
                resourceKey: 'Spa_Style_HearingRiderIcon',
                className: 'Spa_Style_HearingRiderIcon',
                deprecated: false,
                isIcon: true,
                styling: {
                    'content': { before: "'\\f5f0'" },
                    'font-weight': 900
                },
                fontSize: FontSizeResourceKeys.SMALL
            },
            {
                resourceKey: 'Spa_Style_QuestionIcon',
                className: 'Spa_Style_QuestionIcon',
                deprecated: false,
                isIcon: true,
                styling: {
                    'color': AppThemeConfig.getColorValueByKey(ColorResourceKeys.GRAY4),
                    'content': { before: "'\\f059'" },
                    'font-weight': 900
                }
            },
            {
                resourceKey: 'Spa_Style_ErrorText',
                className: 'Spa_Style_ErrorText',
                deprecated: false,
                isIcon: false,
                styling: {
                    'color': AppThemeConfig.getColorValueByKey(ColorResourceKeys.ACCENT2),
                    'font-size': 'var(--Spa_Style_Small_Font)'
                }
            }
        ];
        // Do not add anymore resources. As of  12/16/19 we are simplifying our configuration
    }
    static getColorValueByKey(key) {
        const color = AppThemeConfig.colorResources.find(colorResource => colorResource.resourceKey === key);
        if (color) {
            return color.value;
        }
    }
    // https://stackoverflow.com/questions/5560248/programmatically-lighten-or-darken-a-hex-color-or-rgb-and-blend-colors
    // Negative darkens the color, positive lightens it
    static adjustColor(initialColor, amount, isHexValue = false) {
        let colorToShade;
        if (isHexValue) {
            colorToShade = initialColor;
        }
        else {
            colorToShade = AppThemeConfig.getColorValueByKey(initialColor);
        }
        const newColor = colorToShade
            .replace(/^#/, '')
            .replace(/../g, color => ('0' + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)).substr(-2));
        return `#${newColor}`;
    }
    /**
     * This function is intended to be done before we actually go out to get any resources, so that we have the original values available
     * in the handful of places we do not want config values to be used, such as box shadow or (usually) border colors. Basically anywhere
     * that we set a value in CSS file instead of using a class.
     */
    static setStaticVariables() {
        const styles = [];
        this.setCSSColorVariables(STATIC_CSS_VAR_PREFIX, this.defaultColorResources);
        // We are never supposed to actually use a raw #000 black on the site. For times where we may want "black" without also
        // semantically using primary color or something like that, we're adding this static var along with them.
        styles.push({ name: 'Spa_Style_Black', value: SITE_BLACK });
        // This color is for when we need to display an error on a background that is (statically) dark, as the normal error color
        // Would not show up on it well.
        styles.push({ name: 'Spa_Style_Error_On_Dark', value: '#e0a98a' });
        // This clor is a slightly modified warning sort of color, for use on light blue backgrounds. Other colors either look pretty
        // bad, or run into contrast problems that would make us non-WCAG compliant.
        styles.push({ name: 'Spa_Style_Warn_on_Blue', value: '#9b5c23' });
        // These are all resources from the ColorPalette that are in use for some reason or another. We should look at programatically
        // Creating them off of bases at some point (with this.adjustColor) or replacing them with something else all together.
        styles.push({ name: 'Spa_Style_Info', value: '#3a9b9e' });
        styles.push({ name: 'Spa_Style_Info_Dark', value: '#308183' });
        styles.push({ name: 'Spa_Style_Info_Darker', value: '#296d6f' });
        styles.push({ name: 'Spa_Style_Info_Light', value: '#89c3c5' });
        styles.push({ name: 'Spa_Style_Info_Lighter', value: '#e1f0f0' });
        styles.push({ name: 'Spa_Style_Warn_Dark', value: '#d69712' });
        styles.push({ name: 'Spa_Style_Warn_Darker', value: '#b07d0f' });
        styles.push({ name: 'Spa_Style_Warn_Lighter', value: '#fff3dc' });
        styles.push({ name: 'Spa_Style_Primary_Light', value: '#858d9a' });
        styles.push({ name: 'Spa_Style_Primary_Darker', value: '#242e3d' });
        styles.push({ name: 'Spa_Style_Link_Hover', value: '#014353' });
        this.appendStylesToDocument(`--${STATIC_CSS_VAR_PREFIX}`, styles);
    }
    static appendStylesToDocument(prefix, styles) {
        let styleElement = document.documentElement;
        // TODO: We're currently appending styles to the HTML tag, which is fine but not the most ideal.
        // It'd be nicer to have them in the head tag somewhere, which the following does, but the application then doesnt seem
        // to have access to them anymore. So we can hopefully improve this when research allows.
        /*
        const documentHead: HTMLHeadElement = document.head || document.getElementsByTagName('head')[0];
        let styleElement: HTMLStyleElement = document.querySelector('[siteVariables=siteVariables]');
        if (!styleElement) {
          styleElement = document.createElement('style');
          styleElement.setAttribute('siteVariables', 'siteVariables');
          documentHead.appendChild(styleElement);
        }
        */
        styles.forEach(style => {
            style.name = prefix + style.name;
            styleElement.style.setProperty(style.name, style.value);
        });
    }
    /**
     * Takes the list of resources, and adds a set of css variables to site for direct use of variables instead of requiring use of the various
     * Spa_Style_ classes
     * @param prefix A prefix added to the beginning of the resource name to explain how it differs from the base resource
     * @param colorResources Allows for the use of different resources than the model's primary set
     */
    static setCSSColorVariables(prefix = '', colorResources = this.colorResources) {
        const styles = colorResources.map(res => ({ name: res.resourceKey, value: res.value }));
        AppThemeConfig.appendStylesToDocument(`--${prefix}`, styles);
    }
}
_a = AppThemeConfig;
AppThemeConfig.defaultColorResources = [
    { resourceKey: ColorResourceKeys.PRIMARY_TEXT, value: SITE_BLACK },
    { resourceKey: ColorResourceKeys.PRIMARY_BUTTON_TEXT, value: SITE_BLACK },
    { resourceKey: ColorResourceKeys.SECONDARY_TEXT, value: '#ffffff' },
    { resourceKey: ColorResourceKeys.SECONDARY_BUTTON_TEXT, value: SITE_BLACK },
    { resourceKey: ColorResourceKeys.TERTIARY_BUTTON_BORDER, value: '#bdbdbd' },
    { resourceKey: ColorResourceKeys.PRIMARY_LINK, value: '#016c86' },
    { resourceKey: ColorResourceKeys.PRIMARY_LINK_HOVER, value: AppThemeConfig.adjustColor('#016c86', -50, true) },
    { resourceKey: ColorResourceKeys.SECONDARY_LINK, value: '#8cd9dc' },
    { resourceKey: ColorResourceKeys.ACCENT1, value: '#bdbdbd' },
    { resourceKey: ColorResourceKeys.ACCENT2, value: '#8f1e01' },
    { resourceKey: ColorResourceKeys.ACCENT3, value: '#40c0c5' },
    { resourceKey: ColorResourceKeys.ACCENT4, value: '#fcb215' },
    { resourceKey: ColorResourceKeys.ACCENT5, value: '#99cc55' },
    { resourceKey: ColorResourceKeys.ACCENT6, value: '#344157' },
    { resourceKey: ColorResourceKeys.GRAY1, value: '#f5f5f5' },
    { resourceKey: ColorResourceKeys.GRAY2, value: '#dfdfdf' },
    { resourceKey: ColorResourceKeys.GRAY4, value: '#666666' },
    { resourceKey: ColorResourceKeys.COST, value: '#057a01' },
    { resourceKey: ColorResourceKeys.COST_BACKGROUND, value: '#dbedd9' },
    { resourceKey: ColorResourceKeys.TOGGLE, value: '#e1f0f0' },
    { resourceKey: ColorResourceKeys.BANNER_BACKGROUND, value: '#f5f5f5' },
    { resourceKey: ColorResourceKeys.DISABLED_BACKGROUND, value: '#ededed' }
];
AppThemeConfig.colorResources = _a.defaultColorResources;
AppThemeConfig.resources = [];
AppThemeConfig.font = Fonts.DEFAULT;
AppThemeConfig.compact = false;
class FontHelper {
    static getFontForResourceSizes(resource, compact) {
        if (resource.fontSize) {
            return FontHelper.getFontSize(resource.fontSize, compact);
        }
    }
    static getFontSize(fontSize, compact) {
        const fontSizeSource = compact ? this.MOBILE_FONT_SIZE : this.DESKTOP_FONT_SIZE;
        return `font-size: ${fontSizeSource[fontSize]};`;
    }
    static getFontFamily(resource) {
        if (resource.isIcon) {
            return `font-family: "Font Awesome 5 Pro";`;
        }
        if (AppThemeConfig.font === Fonts.DEFAULT) {
            // edge case for defaults where we dont use weights
            if (resource.fontWeight) {
                return `font-family: ${FontHelper.DEFAULT_FONT_WEIGHT[resource.fontWeight]};`;
            }
            return `font-family: ${FontHelper.DEFAULT_FONT_WEIGHT[FontWeightResourceKeys.REGULAR]};`;
        }
        return AppThemeConfig.font;
    }
    /**
     * Unlike with colors, our font sizes are not configurable, so we can just create them directly without needing multiple versions
     * or different possible sources.
     * Thanks to that, the "_Font" suffix is to just let this resource exactly match the resources used in html files.
     */
    static setCSSFontVariables() {
        const fontSizes = FontHelper.DESKTOP_FONT_SIZE;
        const styles = [];
        Object.keys(fontSizes).forEach(fontSizeKey => {
            styles.push({ name: `--${fontSizeKey}_Font`, value: fontSizes[fontSizeKey] });
        });
        AppThemeConfig.appendStylesToDocument('', styles);
    }
}
FontHelper.DEFAULT_FONT_WEIGHT = {
    [FontWeightResourceKeys.LIGHT]: 'montserrat_light',
    [FontWeightResourceKeys.REGULAR]: 'montserratregular',
    [FontWeightResourceKeys.SEMI_BOLD]: 'montserrat_semibold',
    [FontWeightResourceKeys.BOLD]: 'montserrat_bold'
};
// Current only used to set CSS Vars, preferably would later get it into our class definitions
FontHelper.DESKTOP_FONT_SIZE = {
    [FontSizeResourceKeys.SMALLER]: '13px',
    [FontSizeResourceKeys.SMALL]: '14px',
    [FontSizeResourceKeys.REGULAR]: '16px',
    [FontSizeResourceKeys.LARGE]: '18px',
    [FontSizeResourceKeys.LARGER]: '22px',
    [FontSizeResourceKeys.LARGEST]: '32px'
};
FontHelper.MOBILE_FONT_SIZE = {
    ...FontHelper.DESKTOP_FONT_SIZE,
    [FontSizeResourceKeys.LARGEST]: '26px'
};

const SITE_YES_VALUE = 'Yes';
const SITE_NO_VALUE = 'No';
const MEDICARE_ELIGIBILITY_AGE = 65;
const INITIAL_ENROLLMENT_ELIGIBILITY_AGE = MEDICARE_ELIGIBILITY_AGE - 1;

var DaysDifferencePrecision;
(function (DaysDifferencePrecision) {
    DaysDifferencePrecision["DATE_ONLY"] = "DATE_ONLY";
    DaysDifferencePrecision["DATE_WITH_TIME"] = "DATE_WITH_TIME";
})(DaysDifferencePrecision || (DaysDifferencePrecision = {}));
dayjs.extend(dayjsutc);
dayjs.extend(dayjstimezone);
dayjs.extend(dayjsminmax);
dayjs.extend(dayjsissameorafter);
dayjs.extend(dayjsissameorbefore);
dayjs.extend(dayjslocaledata);
dayjs.extend(localizedFormat);
dayjs.extend(customParseFormat);
// Below month index are 1 based (i.e. 10 - October, 11 - November, 12 - December)
const ANNUAL_ENROLLMENT_PERIOD_MONTHS = [10, 11, 12];
var DatePipeFormats;
(function (DatePipeFormats) {
    DatePipeFormats["DATE"] = "MM/dd/yyyy";
    DatePipeFormats["DATETIME"] = "MM/dd/yyyy h:mm a";
})(DatePipeFormats || (DatePipeFormats = {}));
const HAS_TIMEZONE_SUFFIX_REGEX = /[Z]|[+-]\d{2}:?\d{2}/;
class DateUtilities {
    static formatIndexMonth(indexMonth) {
        return `0${indexMonth}`.slice(-2);
    }
    static getFormattedCurrentDate(format = DateUtilities.defaultFormat) {
        return dayjs().format(format);
    }
    /**
     * Returns formatted date in UTC datetime
     * @param date
     * @param format
     * @param locale
     */
    static getFormattedDate(date = new Date(), format = DateUtilities.defaultFormat, locale = 'en') {
        return DateUtilities.getCurrentLocaleUTCDate(date, locale).format(format);
    }
    /**
     * Returns date as dayjs.Dayjs in UTC datetime, given a locale
     * @param date
     * @param locale
     * @returns
     */
    static getCurrentLocaleUTCDate(date = new Date(), locale = 'en') {
        // need to use utc if we are merely processing a date without a timezone
        // as not doing so could create off by one day issues
        return dayjs.utc(date).locale(locale);
    }
    static convertToDateString(dateTime, format = DateUtilities.defaultFormat) {
        if (!dateTime) {
            return '';
        }
        return dayjs(dateTime).format(format).toString();
    }
    static convertToUnixTimestamp(date) {
        return dayjs(date).unix();
    }
    /**
     * Returns to timezone date (Limited to Los Angeles. Update vnext-core custom-webpack-config.json to add more time zones)
     * @param utcDate
     * @param timeZone
     * @param format
     */
    static convertToTimeZoneDate(date = new Date(), timeZone = DateUtilities.americaLosAngelesTimeZone, keepLocalTime) {
        if (!date || !timeZone) {
            return null;
        }
        return dayjs.utc(date).tz(timeZone, keepLocalTime);
    }
    /**
     * Returns formatted date in pacific time (includes daylight saving)
     * @param date
     * @param format
     */
    static getFormattedPTDate(date = new Date(), format = DateUtilities.defaultFormat) {
        // America/Los_Angeles takes daylight saving in consideration, while PST is locked to -8:00
        return DateUtilities.convertToTimeZoneDate(date)?.format(format);
    }
    static getDateFromString(date, inputFormat) {
        const inputDate = dayjs.utc(date, inputFormat);
        return inputDate.isValid() ? inputDate.toDate() : null;
    }
    static getPreviousDate(date = new Date(), subtractAmount, format = DateUtilities.defaultFormat, unit = 'day') {
        return dayjs(date).subtract(subtractAmount, unit).format(format);
    }
    static getFormattedDateFromString(date, inputFormat, outputFormat) {
        const inputDate = dayjs.utc(date, inputFormat);
        return inputDate.isValid() ? inputDate.format(outputFormat) : null;
    }
    static getFormattedDateTime(date = new Date(), format = DateUtilities.defaultDateTimeISOFormat, locale = 'en') {
        return dayjs(date).locale(locale).format(format);
    }
    static getDateFromUtc(date, format = DateUtilities.dateTimeFormat) {
        const utcDate = date.endsWith('Z') ? date : `${date}Z`;
        return DateUtilities.getFormattedPTDate(new Date(utcDate), format);
    }
    static isValidDate(date, format = DateUtilities.defaultFormat) {
        return DateUtilities.createDateObject(date, format).isValid();
    }
    static isValidFormat(date, format = DateUtilities.defaultFormat) {
        return !!dayjs(date, format, true)?.isValid();
    }
    static dateBefore(date1, date2, granularity, format = DateUtilities.defaultFormat) {
        return DateUtilities.createDateObject(date1, format).isBefore(date2, granularity);
    }
    static isDateBeforeSome(date, dateList) {
        return dateList.some(dateFromList => DateUtilities.dateBefore(date, dateFromList, 'date'));
    }
    static isPastMonth(date) {
        return DateUtilities.dateBefore(date, DateUtilities.getFormattedCurrentDate(), 'month');
    }
    static dateAfter(date1, date2, format = DateUtilities.defaultFormat) {
        const firstDate = DateUtilities.createDateObject(date1, format);
        const secondDate = DateUtilities.createDateObject(date2, format);
        return firstDate.isAfter(secondDate, 'date');
    }
    static isDateAfterSome(date, dateList) {
        return dateList.some(dateFromList => DateUtilities.dateAfter(date, dateFromList));
    }
    static getMaxDateFromList(dateList) {
        return dayjs
            .max(dateList.map(dateFromList => dayjs(dateFromList, DateUtilities.defaultDateTimeISOFormat)))
            .format(DateUtilities.defaultDateTimeISOFormat);
    }
    static isBeforeNthDayOfNextMonth(date, nextMonthDay) {
        const createdWhen = DateUtilities.convertToTimeZoneDate(date, DateUtilities.americaLosAngelesTimeZone, true);
        const currentDate = DateUtilities.convertToTimeZoneDate();
        const nextMonth = createdWhen.month() + 1;
        const nextMonthNthDay = DateUtilities.convertToTimeZoneDate(new Date(createdWhen.year(), nextMonth, nextMonthDay), DateUtilities.americaLosAngelesTimeZone, true);
        return this.dateAfter(nextMonthNthDay, currentDate, this.dateTimeFormat);
    }
    static dateTimeBefore(date1, date2, format = DateUtilities.defaultFormat) {
        const firstDate = DateUtilities.createDateObject(date1, format);
        return firstDate.isBefore(date2);
    }
    static dateTimeAfter(date1, date2) {
        const firstDate = DateUtilities.createDateObject(date1, DateUtilities.defaultDateTimeISOFormat);
        const secondDate = DateUtilities.createDateObject(date2, DateUtilities.defaultDateTimeISOFormat);
        return firstDate.isAfter(secondDate);
    }
    static dateIsInFuture(date, format = DateUtilities.defaultFormat) {
        const currentTime = dayjs();
        const isInFuture = DateUtilities.createDateObject(date, format).isAfter(currentTime, 'date');
        return isInFuture;
    }
    static dateIsSameOrInFuture(date1, date2, format = DateUtilities.defaultFormat) {
        const firstDate = DateUtilities.createDateObject(date1, format);
        const secondDate = DateUtilities.createDateObject(date2, format);
        return firstDate.isSameOrAfter(secondDate, 'date');
    }
    static dateIsSameOrBefore(date1, date2, format = DateUtilities.defaultFormat) {
        const firstDate = DateUtilities.createDateObject(date1, format);
        const secondDate = DateUtilities.createDateObject(date2, format);
        return firstDate.isSameOrBefore(secondDate, 'date');
    }
    static dateIsInFutureMonthRange(date, months, format = DateUtilities.defaultFormat) {
        const firstDate = DateUtilities.createDateObject(date, format);
        return firstDate.subtract(months, 'month').isBefore(dayjs(), 'date');
    }
    static dateIsInPastYearRange(date, years, format = DateUtilities.defaultFormat) {
        const firstDate = DateUtilities.createDateObject(date, format);
        return !firstDate.add(years, 'year').isBefore(dayjs(), 'date');
    }
    static dateIsInPastMonthRange(date, months, format = DateUtilities.defaultFormat) {
        const firstDate = DateUtilities.createDateObject(date, format);
        const monthYear = `${new Date().getFullYear().toString()}-${new Date().getMonth() + 1}`;
        const todaysDate = new Date(`${monthYear}-01`);
        todaysDate.setHours(0, 0, 0, 0);
        return !firstDate.add(months, 'month').isBefore(todaysDate, 'date');
    }
    static getDateTurns65GivenDateOfBirth(date, format = DateUtilities.defaultFormat) {
        const firstDate = DateUtilities.createDateObject(date, format);
        return firstDate.add(MEDICARE_ELIGIBILITY_AGE, 'year').format(format);
    }
    static getFirstOfFutureMonths(numMonths) {
        const listOfMonths = [];
        for (let i = 1; i <= numMonths; i++) {
            listOfMonths.push(dayjs()
                .add(i - 1, 'month')
                .startOf('month'));
        }
        return listOfMonths;
    }
    static getMonth(date) {
        return dayjs(date).month() + 1;
    }
    static getFirstOfNextMonth(date) {
        return dayjs(date).add(1, 'month').startOf('month').toDate();
    }
    static getFirstOfThisMonth(date) {
        return dayjs(date).startOf('month').toDate();
    }
    static getFirstOfTheMonthFormatted(date, format = DateUtilities.defaultFormat) {
        return dayjs(date).startOf('month').format(format);
    }
    static getFormattedFirstOfNextMonth(format) {
        return DateUtilities.getFormattedDate(DateUtilities.getFirstOfNextMonth(), format);
    }
    static getMonthsDifference(pastDate, futureDate) {
        return dayjs(futureDate).diff(pastDate, 'month');
    }
    static getDaysDifference(pastDate, futureDate, daysDifferencePrecision = DaysDifferencePrecision.DATE_WITH_TIME) {
        if (daysDifferencePrecision === DaysDifferencePrecision.DATE_ONLY) {
            return dayjs(futureDate).startOf('day').diff(dayjs(pastDate).startOf('day'), 'day');
        }
        return dayjs(futureDate).diff(pastDate, 'day');
    }
    static getSecondsDifference(pastDate, futureDate) {
        return dayjs(futureDate).diff(pastDate, 'second');
    }
    static getMinutesDifference(pastDate, futureDate) {
        return dayjs(futureDate).diff(pastDate, 'minute');
    }
    static getHoursDifference(pastDate, futureDate) {
        return dayjs(futureDate).diff(pastDate, 'hour');
    }
    static getLastDayOfYear(year, format = DateUtilities.defaultFormat) {
        return dayjs(`${DateUtilities.lastDayOfYearPrefix}${year}`, format);
    }
    static getFloorDateGivenMonthsRangeByYearEnd(monthsRange, year) {
        return DateUtilities.getLastDayOfYear(year).subtract(monthsRange, 'month');
    }
    static getFloorDateGivenMonthsRange(monthsRange) {
        return DateUtilities.getCurrentLocaleUTCDate().subtract(monthsRange, 'month');
    }
    static getCeilingYearGivenMonthsRange(monthsRange) {
        return DateUtilities.getCurrentLocaleUTCDate().add(monthsRange, 'month').year();
    }
    static getMonthsFromCurrentDateUntilCeiling(monthsRange) {
        const currentLocaleDate = DateUtilities.getCurrentLocaleUTCDate();
        const dateFloorMonth = currentLocaleDate.month();
        const dateCeiling = currentLocaleDate.add(monthsRange, 'month');
        const dateCeilingMonth = dateCeiling.month();
        if (dateCeilingMonth < dateFloorMonth) {
            return dayjs
                .months()
                .slice(dateFloorMonth, DateUtilities.lastMonthOfYear)
                .concat(dayjs.months().slice(DateUtilities.firstMonthOfYear, dateCeilingMonth + 1));
        }
        return dayjs.months().slice(dateFloorMonth, dateCeilingMonth + 1);
    }
    static getMonthsUntilEndOfYearFromFloor(dateFloor) {
        return dayjs.months().slice(dateFloor.month(), DateUtilities.lastMonthOfYear + 1);
    }
    static isDateWithinMonthsRange(date, monthsRange, year) {
        const dateFloor = DateUtilities.getFloorDateGivenMonthsRangeByYearEnd(monthsRange, year);
        return dayjs(date).isSameOrAfter(dateFloor, 'month');
    }
    static getMonthsFromFloorToCeil(maxPastMonths, maxFutureMonths) {
        const fromDate = dayjs().subtract(maxPastMonths, 'month');
        const toDate = dayjs().add(maxFutureMonths, 'month');
        return DateUtilities.getDateRange(fromDate, toDate);
    }
    static isTargetDateWithinDateRange(dateRange, targetDate, unit, format = DateUtilities.defaultFormat) {
        const unitDuration = unit || 'day';
        return dayjs(targetDate, format).isSameOrBefore(dayjs().add(dateRange, unitDuration));
    }
    static getNextBirthDay(dob, useFirstDayOfMonth, format = DateUtilities.defaultFormat) {
        const dateOfBirthObject = DateUtilities.createDateObject(dob, DateUtilities.defaultDateTimeISOFormat);
        const month = dateOfBirthObject.format('MM');
        const day = useFirstDayOfMonth ? '01' : dateOfBirthObject.format('DD');
        const year = dayjs().year();
        const bDay = dayjs(`${month}/${day}/${year}`, format);
        const alreadyHappened = dayjs().diff(bDay) >= 0;
        return alreadyHappened ? dayjs(`${month}/${day}/${year + 1}`, format) : bDay;
    }
    static getAge(dob) {
        return dayjs().diff(dayjs(dob), 'year');
    }
    static getAgeFromDate(dob, date, format = DateUtilities.defaultFormat) {
        const dateObject = DateUtilities.createDateObject(date, format);
        return dateObject.diff(dayjs(dob), 'year');
    }
    static getDaysUntilBirthDay(dob, useFirstDayOfMonth = false) {
        const nextBDay = DateUtilities.getNextBirthDay(dob, useFirstDayOfMonth);
        return Math.ceil(nextBDay.diff(dayjs(), 'day', true));
    }
    static getEndOfDate(date, format = DateUtilities.defaultDateTimeISOFormat) {
        return dayjs(date).startOf('day').add(1, 'day').subtract(1, 'second').format(format);
    }
    /**
     * This function by default will give you the first of every month including and after the current date, up until the end of the year.
     * Passing in a positive number will add that many more months after. A negative number will remove that many.
     * Note that this function will give you a smaller list as a year goes on, until it resets.
     */
    static getFutureMonthsForRestOfYear(numberOfMonthsPastYearEnd = 0) {
        const listOfMonths = [];
        const currentMonth = new Date().getMonth();
        const remainingNumberOfMonthsPastYearEnd = numberOfMonthsPastYearEnd + 12 - currentMonth;
        for (let i = 1; i < remainingNumberOfMonthsPastYearEnd; i++) {
            // Note, this date may look like it's the last day of the month,
            // but it's the first of the month in GMT, showing in your local time zone.
            // IE Jan 1st Midnight GMT would look like Dec 31st 6pm if you're working in CST
            const startOfMonth = dayjs().utc().add(i, 'month').startOf('month');
            listOfMonths.push(startOfMonth);
        }
        return listOfMonths;
    }
    /**
     *
     * By default, returns an array of the first of each month for the current year.
     * @param yearOffset adds or removes this much from the current year
     */
    static getMonthsOfYear(yearOffset = 0) {
        const listOfMonths = [];
        for (let i = 0; i < 12; i++) {
            const month = dayjs().utc().add(yearOffset, 'year').set('month', i).startOf('month');
            listOfMonths.push(month);
        }
        return listOfMonths;
    }
    static getYearsRange(maxPastMonths, maxFutureMonths) {
        const dateCeiling = DateUtilities.getCurrentLocaleUTCDate().add(maxFutureMonths, 'month');
        const dateCeilingYear = dateCeiling.year();
        const dateFloor = dateCeiling.subtract(maxPastMonths + maxFutureMonths, 'month');
        const dateFloorYear = dateFloor.year() - 1;
        return _range(dateCeilingYear, dateFloorYear, -1);
    }
    static getWholeMonths() {
        return dayjs.months();
    }
    static getStartOfDateInCurrentYear(date) {
        return dayjs(date).startOf('year').toDate();
    }
    static getStartOfDateInFutureYear(date) {
        return dayjs(date).add(1, 'year').startOf('year').toDate();
    }
    static getDateInLocaleFromString(date, format, locale) {
        return dayjs.utc(date).locale(locale).format(format);
    }
    /**
     * This could be an array of any sort, it just needs whatever is contained in the property listed to be an array of dayjs values.
     */
    static sortByOlderDate(array, property) {
        return array.sort((d1, d2) => dayjs(d1[property]).unix() - dayjs(d2[property]).unix());
    }
    static getDefaultDateTimeISOFormat(date) {
        const format = DateUtilities.defaultDateTimeISOFormat;
        return DateUtilities.getFormattedPTDate(new Date(date), format);
    }
    static isAEP(currentMonth) {
        return ANNUAL_ENROLLMENT_PERIOD_MONTHS.includes(currentMonth);
    }
    static getDefaultFormattedDate(ngbDate) {
        const month = ngbDate?.month?.toString().padStart(2, '0') || '00';
        const day = ngbDate?.day?.toString().padStart(2, '0') || '00';
        const year = ngbDate?.year?.toString() || '0000';
        return DateUtilities.defaultFormat.replace('MM', month).replace('DD', day).replace('YYYY', year);
    }
    static getElapsedTime(totalSeconds) {
        const seconds = totalSeconds % 60;
        const secondsAsString = `${seconds < 10 ? '0' : ''}${seconds}`;
        const minutes = Math.floor(totalSeconds / 60) % 60;
        const minutesAsString = `${minutes < 10 ? '0' : ''}${minutes}`;
        const hours = Math.floor(totalSeconds / 60 / 60) % 24;
        const days = Math.floor(hours / 24);
        const totalHours = hours + days * 24;
        const totalHoursAsString = `${totalHours < 10 ? '0' : ''}${totalHours}`;
        if (totalHoursAsString === '00') {
            return `${minutesAsString}:${secondsAsString}`;
        }
        return `${totalHoursAsString}:${minutesAsString}:${secondsAsString}`;
    }
    static parseDateToNgbDate(date) {
        let ngbDate = null;
        if (DateUtilities.isValidDate(date)) {
            const [month, day, year] = date.split('/');
            ngbDate = {
                month: parseInt(month, 10),
                day: parseInt(day, 10),
                year: parseInt(year, 10)
            };
        }
        return ngbDate;
    }
    static parseDayJSToNgbDate(date) {
        const ngbDate = {
            month: date.month() + 1,
            day: date.date(),
            year: date.year()
        };
        return ngbDate;
    }
    static getIndexMonth(month, locale) {
        if (locale) {
            const localDate = dayjs().locale(locale);
            const localeData = localDate.localeData().months();
            return localeData.findIndex(localeMonth => localeMonth.toLowerCase() === month.toLowerCase()) + 1;
        }
        return DateUtilities.getWholeMonths().findIndex(localeMonth => localeMonth.toLowerCase() === month.toLowerCase()) + 1;
    }
    /**
     * Takes a month year string and returns a Date. IE11 does not like date strings that do not meet
     * ISO 8601 formatting standards and thus we need to convert our month year string before returning
     * a new date to support IE11.
     * @param monthYear - A string representing a month year combination. For example, October 2021.
     */
    static monthYearToDate(monthYearDate, locale) {
        return new Date(DateUtilities.convertMonthYearStringToISOString(monthYearDate, locale));
    }
    // Some browsers do not handle non-ISO8601 formatted date strings so we will convert it here.
    static convertMonthYearStringToISOString(monthYearDate, locale) {
        const monthYear = monthYearDate.split(' ');
        const monthString = monthYear[0];
        const yearString = monthYear[1];
        return `${yearString}-${DateUtilities.formatIndexMonth(DateUtilities.getIndexMonth(monthString, locale))}T00:00:00`;
    }
    static getTimeDuration(startDate, endDate) {
        return endDate.getTime() - startDate.getTime();
    }
    static addDays(date, numberOfDays, format = DateUtilities.defaultFormat) {
        return dayjs(date).add(numberOfDays, 'day').format(format);
    }
    static getMedicareEligibilityAge() {
        return MEDICARE_ELIGIBILITY_AGE;
    }
    static secondsToMilliseconds(seconds) {
        return Number.parseInt(seconds.toFixed(), 10) * 1000;
    }
    static getDateRange(fromDate, toDate) {
        const ranges = [];
        const startOfRange = dayjs.min(fromDate, toDate);
        const endOfRange = dayjs.max(fromDate, toDate);
        let currentDate = dayjs(startOfRange);
        while (currentDate.isBefore(endOfRange, 'date') || currentDate.isSame(endOfRange, 'date')) {
            currentDate = currentDate.add(1, 'month');
            ranges.push(currentDate.format('MM/YYYY'));
        }
        return ranges;
    }
    // dayjs will give you an invalid date if you pass in a format string when using a Date object instead of a string
    // This will check if the date is a string or object, and convert the format to null when it's an object to avoid this
    static getFormatBasedOffOfDateType(date, format = DateUtilities.defaultFormat) {
        if (typeof date === 'string') {
            return format;
        }
        // We basically just want to skip a format entirely for an object. An empty string will result in an invalid date,
        // And a null will result in an error. An explict undefined will act as if nothing was passed in.
        return undefined;
    }
    // This wrapper helps us control forcing the use of getFormatBasedOffOfDateType for any time that we do not know for sure
    // If we have a string or a Date object for our date parameter.
    // Enable strict parsing now the format and input match exactly, including delimiters.
    static createDateObject(date, format = DateUtilities.defaultFormat) {
        const formatByType = DateUtilities.getFormatBasedOffOfDateType(date, format);
        const formattedDateObject = dayjs(date, formatByType, true);
        if (!formattedDateObject.isValid()) {
            console.error('Invalid date created', date, format);
        }
        return formattedDateObject;
    }
    static convertDateFormat(date, fromFormat = DateUtilities.defaultDateISOFormat, toFormat = DateUtilities.defaultFormat) {
        const parsedDate = dayjs(date, fromFormat, true);
        const formattedDate = parsedDate.format(toFormat);
        return formattedDate || '';
    }
    /**
     * Use this to prevent a date offset when we adjust for timezone. Will allow
     * an offset if the date string has a timezone suffix.
     * @param dateString - The string to convert to a non-offset date.
     * @returns - A date object with the time set to midnight.
     */
    static getNonOffsetDate(dateString) {
        const hasTimezoneSuffix = HAS_TIMEZONE_SUFFIX_REGEX.test(dateString);
        if (hasTimezoneSuffix) {
            return new Date(dateString);
        }
        else {
            const date = dayjs(dateString);
            return new Date(date.year(), date.month(), date.date());
        }
    }
}
DateUtilities.dateTimeFormat = 'MM/DD/YYYY h:mm a';
DateUtilities.defaultFormat = 'MM/DD/YYYY';
DateUtilities.defaultDateTimeISOFormat = 'YYYY-MM-DDTHH:mm:ss';
DateUtilities.defaultDateISOFormat = 'YYYY-MM-DD';
DateUtilities.americaLosAngelesTimeZone = 'America/Los_Angeles';
DateUtilities.firstMonthOfYear = 0;
DateUtilities.lastMonthOfYear = 11;
DateUtilities.lastDayOfYearPrefix = '12/31/';
__decorate([
    Memoize()
], DateUtilities, "secondsToMilliseconds", null);

class FetchPlansSuccess {
    constructor(planTypes) {
        this.planTypes = planTypes;
    }
}
FetchPlansSuccess.type = '[Plans] Fetch Success';
class FetchPlansError {
    constructor(error, planTypes) {
        this.error = error;
        this.planTypes = planTypes;
    }
}
FetchPlansError.type = '[Plans] Fetch Error';
class SelectPlanQuestions {
    constructor(sessionId, year, effectiveDate, productType, questions) {
        this.sessionId = sessionId;
        this.year = year;
        this.effectiveDate = effectiveDate;
        this.productType = productType;
        this.questions = questions;
    }
}
SelectPlanQuestions.type = '[Plans] Select Questions';
class UpdateAncillaryPlanQuestions {
    constructor(ancillaryQuestions) {
        this.ancillaryQuestions = ancillaryQuestions;
    }
}
UpdateAncillaryPlanQuestions.type = '[Plans] Update Ancillary Questions';
class UpdateAncillaryPlanAnswers {
    constructor(ancillaryQuestions) {
        this.ancillaryQuestions = ancillaryQuestions;
    }
}
UpdateAncillaryPlanAnswers.type = '[Plans] Update Ancillary Answers';
class FetchPlanQuestions {
    constructor(zipCode, fips, year, effectiveDate) {
        this.zipCode = zipCode;
        this.fips = fips;
        this.year = year;
        this.effectiveDate = effectiveDate;
    }
}
FetchPlanQuestions.type = '[Plans] Fetch Plan Questions';
class FetchPlanQuestionsError {
    constructor(error) {
        this.error = error;
    }
}
FetchPlanQuestionsError.type = '[Plans] Fetch Plan Questions Error';
class UpdateHospitalIndemnityPlanQuestions {
    constructor(hospitalIndemnityQuestions) {
        this.hospitalIndemnityQuestions = hospitalIndemnityQuestions;
    }
}
UpdateHospitalIndemnityPlanQuestions.type = '[Plans] Update Hospital Indemnity Questions';
class UpdateHospitalIndemnityPlanAnswers {
    constructor(hospitalIndemnityQuestions) {
        this.hospitalIndemnityQuestions = hospitalIndemnityQuestions;
    }
}
UpdateHospitalIndemnityPlanAnswers.type = '[Plans] Update Hospital Indemnity Answers';
class FetchHospitalIndemnityQuestions {
    constructor(zipCode, fips, year, effectiveDate) {
        this.zipCode = zipCode;
        this.fips = fips;
        this.year = year;
        this.effectiveDate = effectiveDate;
    }
}
FetchHospitalIndemnityQuestions.type = '[Plans] Fetch Hospital Indemnity Questions';
class FetchHospitalIndemnityQuestionsError {
    constructor(error) {
        this.error = error;
    }
}
FetchHospitalIndemnityQuestionsError.type = '[Plans] Fetch Hospital Indemnity Questions Error';
class UpdatePlansRiderBenefitCategories {
    constructor(planId, selectedRiderBenefitCategories) {
        this.planId = planId;
        this.selectedRiderBenefitCategories = selectedRiderBenefitCategories;
    }
}
UpdatePlansRiderBenefitCategories.type = '[Plans] Update Plans Rider Benefit Categories';
class UpdatePUFPlanSetting {
    constructor(includePUFPlans) {
        this.includePUFPlans = includePUFPlans;
    }
}
UpdatePUFPlanSetting.type = '[Plans] Update PUF Plan Setting';
class UpdateNonLicensedPlanSetting {
    constructor(includeNonLicensedPlans) {
        this.includeNonLicensedPlans = includeNonLicensedPlans;
    }
}
UpdateNonLicensedPlanSetting.type = '[Plans] Update Non Licensed Plan Setting';
class UpdatePlansQueuePosition {
    constructor(plansQueuePosition) {
        this.plansQueuePosition = plansQueuePosition;
    }
}
UpdatePlansQueuePosition.type = '[Plans] Update Queue Position';
class UpdatePlans {
    constructor(plans, planTypes) {
        this.plans = plans;
        this.planTypes = planTypes;
    }
}
UpdatePlans.type = '[Plans] Update Plans';
class UpdatePlanPharmacies {
    constructor(planPharmacies, planTypes, planIds) {
        this.planPharmacies = planPharmacies;
        this.planTypes = planTypes;
        this.planIds = planIds;
    }
}
UpdatePlanPharmacies.type = '[Plans] Update Plan Pharmacies';
class SetSortGroup {
    constructor(sortGroup) {
        this.sortGroup = sortGroup;
    }
}
SetSortGroup.type = '[Plans] Select Sort';
class ClearSortGroupSort {
    constructor(sortGroupIdentifier) {
        this.sortGroupIdentifier = sortGroupIdentifier;
    }
}
ClearSortGroupSort.type = '[Plans] Clear Sort Group Sort';
class UpdateSortGroup {
    constructor(sortGroupIdentifier, sort, isDirty) {
        this.sortGroupIdentifier = sortGroupIdentifier;
        this.sort = sort;
        this.isDirty = isDirty;
    }
}
UpdateSortGroup.type = '[Plans] Update Sort';
class ClearSort {
}
ClearSort.type = '[Plans] Clear Sort';
class SetFilterGroup {
    constructor(filterGroup) {
        this.filterGroup = filterGroup;
    }
}
SetFilterGroup.type = '[Plans] Set Filter Group';
class AddFilterToFilterGroups {
    constructor(filterGroupIdentifier, filter) {
        this.filterGroupIdentifier = filterGroupIdentifier;
        this.filter = filter;
    }
}
AddFilterToFilterGroups.type = '[Plans] Add Filter To Filter Group';
class RemoveFilterGroups {
    constructor(filterGroupIdentifier) {
        this.filterGroupIdentifier = filterGroupIdentifier;
    }
}
RemoveFilterGroups.type = '[Plans] Remove Filter Groups';
class ClearFilterGroupFilter {
    constructor(filterGroupIdentifier, filterKeyToClear) {
        this.filterGroupIdentifier = filterGroupIdentifier;
        this.filterKeyToClear = filterKeyToClear;
    }
}
ClearFilterGroupFilter.type = '[Plans] Clear Filter Group Filter';
class ClearFilterGroupFilters {
    constructor(filterGroupIdentifier) {
        this.filterGroupIdentifier = filterGroupIdentifier;
    }
}
ClearFilterGroupFilters.type = '[Plans] Clear Filter Group Filters';
class UpdateFilterGroupFilters {
    constructor(filterGroupIdentifier, filters) {
        this.filterGroupIdentifier = filterGroupIdentifier;
        this.filters = filters;
    }
}
UpdateFilterGroupFilters.type = '[Plans] Update Filter Group Filters';
class SetActiveTab {
    constructor(tabType) {
        this.tabType = tabType;
    }
}
SetActiveTab.type = '[Plans] Set Active Tab Data';
class SetActivePlanDetailsTab {
    constructor(tabType) {
        this.tabType = tabType;
    }
}
SetActivePlanDetailsTab.type = '[Plans] Set Active Plan Details Tab';
class ClearActiveTab {
}
ClearActiveTab.type = '[Plans] Clear Active Tab Data';
class SetDefaultTab {
    constructor(tabType) {
        this.tabType = tabType;
    }
}
SetDefaultTab.type = '[Plans] Set Default Tab Data';
class SelectPlanDetails {
    constructor(planWithDetails) {
        this.planWithDetails = planWithDetails;
    }
}
SelectPlanDetails.type = '[PlanDetails] Select';
class ResetPlansState {
    constructor(defaultPlanYear) {
        this.defaultPlanYear = defaultPlanYear;
    }
}
ResetPlansState.type = '[Plans] Reset';
class SetPlanComparePlanType {
    constructor(planType) {
        this.planType = planType;
    }
}
SetPlanComparePlanType.type = '[Plans] Set Plan Compare Plan Type';
class SetCompareGroup {
    constructor(compareGroup) {
        this.compareGroup = compareGroup;
    }
}
SetCompareGroup.type = '[Plans] Set Compare Group';
class AddPlanToCompareGroup {
    constructor(compareGroupIdentifier, plan) {
        this.compareGroupIdentifier = compareGroupIdentifier;
        this.plan = plan;
    }
}
AddPlanToCompareGroup.type = '[Plans] Add Plan To Compare Group';
class AddPlansToCompareGroup {
    constructor(compareGroupIdentifier, plans) {
        this.compareGroupIdentifier = compareGroupIdentifier;
        this.plans = plans;
    }
}
AddPlansToCompareGroup.type = '[Plans] Add Plans To Compare Group';
class RemovePlanFromCompareGroup {
    constructor(compareGroupIdentifier, plan) {
        this.compareGroupIdentifier = compareGroupIdentifier;
        this.plan = plan;
    }
}
RemovePlanFromCompareGroup.type = '[Plans] Remove Plan From Compare Group';
class RemovePlanFromCompareGroups {
    constructor(plan) {
        this.plan = plan;
    }
}
RemovePlanFromCompareGroups.type = '[Plans] Remove Plan From Compare Groups';
class RemoveAllPlansFromCompareGroup {
    constructor(compareGroupIdentifier) {
        this.compareGroupIdentifier = compareGroupIdentifier;
    }
}
RemoveAllPlansFromCompareGroup.type = '[Plans] Remove All Plans From Compare Group';
class UpdateFirstPlanInCompareGroup {
    constructor(compareGroupIdentifier, plan) {
        this.compareGroupIdentifier = compareGroupIdentifier;
        this.plan = plan;
    }
}
UpdateFirstPlanInCompareGroup.type = '[Plans] Update First Plan In Compare Group';
class SetPlansDirty {
    constructor(dirty, planTypes) {
        this.dirty = dirty;
        this.planTypes = planTypes;
    }
}
SetPlansDirty.type = '[Plans] Set Dirty';
class SetPlansLoading {
    constructor(loading, planTypes) {
        this.loading = loading;
        this.planTypes = planTypes;
    }
}
SetPlansLoading.type = '[Plans] Loading';
class SetPlanShortLoading {
    constructor(loading) {
        this.loading = loading;
    }
}
SetPlanShortLoading.type = '[Plans] Short Loading';
class SetQuoteGroup {
    constructor(quoteGroup) {
        this.quoteGroup = quoteGroup;
    }
}
SetQuoteGroup.type = '[Plans] Set Quote Group';
class AddPlanToQuoteGroup {
    constructor(quoteGroupIdentifier, plan) {
        this.quoteGroupIdentifier = quoteGroupIdentifier;
        this.plan = plan;
    }
}
AddPlanToQuoteGroup.type = '[Plans] Add Plan To Quote Group';
class UpdateFirstPlanInQuoteGroup {
    constructor(quoteGroupIdentifier, plan) {
        this.quoteGroupIdentifier = quoteGroupIdentifier;
        this.plan = plan;
    }
}
UpdateFirstPlanInQuoteGroup.type = '[Plans] Update First Plan In Quote Group';
class RemovePlanFromQuoteGroup {
    constructor(quoteGroupIdentifier, plan) {
        this.quoteGroupIdentifier = quoteGroupIdentifier;
        this.plan = plan;
    }
}
RemovePlanFromQuoteGroup.type = '[Plans] Remove Plan From Quote Group';
class RemovePlanFromQuoteGroups {
    constructor(plan) {
        this.plan = plan;
    }
}
RemovePlanFromQuoteGroups.type = '[Plans] Remove Plan From Quote Groups';
class SetTotalEstimatedCostAnnually {
    constructor(isTotalEstimatedCostAnnually) {
        this.isTotalEstimatedCostAnnually = isTotalEstimatedCostAnnually;
    }
}
SetTotalEstimatedCostAnnually.type = '[Plans] Update SetTotalEstimatedCostAnnually';
class SetActiveTabTotalCost {
    constructor(isActiveTabTotalCost) {
        this.isActiveTabTotalCost = isActiveTabTotalCost;
    }
}
SetActiveTabTotalCost.type = '[Plans] Update SetActiveTabTotalCost';
class SetActiveTabPrescription {
    constructor(isActiveTabPrescription) {
        this.isActiveTabPrescription = isActiveTabPrescription;
    }
}
SetActiveTabPrescription.type = '[Plans] Update SetActiveTabPrescription';
class SetActiveRateFactorPlanId {
    constructor(activeRateFactorPlanId) {
        this.activeRateFactorPlanId = activeRateFactorPlanId;
    }
}
SetActiveRateFactorPlanId.type = '[Plans] Set Active Rate Factor Plan Id';
class RemoveActiveRateFactorPlanId {
}
RemoveActiveRateFactorPlanId.type = '[Plans] Remove Active Rate Factor Plan Id';
class SetCSNPVisibility {
    constructor(cSNPVisibility) {
        this.cSNPVisibility = cSNPVisibility;
    }
}
SetCSNPVisibility.type = '[SNP Visibility] Set CSNP Visibility';
class SetDSNPVisibility {
    constructor(dSNPVisibility) {
        this.dSNPVisibility = dSNPVisibility;
    }
}
SetDSNPVisibility.type = '[SNP Visibility] Set DSNP Visibility';
class SetISNPVisibility {
    constructor(iSNPVisibility) {
        this.iSNPVisibility = iSNPVisibility;
    }
}
SetISNPVisibility.type = '[SNP Visibility] Set ISNP Visibility';
class SetAllSNPTypesVisibility {
    constructor(visibility) {
        this.visibility = visibility;
    }
}
SetAllSNPTypesVisibility.type = '[SNP Visibility] Set All SNP Visibility';
class SetVisibleSNPTypes {
    constructor(snpVisibility) {
        this.snpVisibility = snpVisibility;
    }
}
SetVisibleSNPTypes.type = '[SNP Visibility] Set Specific Visibility';
class UpdateSelectedPlanSubType {
    constructor(selectedPlanSubType) {
        this.selectedPlanSubType = selectedPlanSubType;
    }
}
UpdateSelectedPlanSubType.type = '[Plans] Update Selected Plan Sub Type';
class ClearSelectedPlanSubType {
}
ClearSelectedPlanSubType.type = '[Plans] Clear Selected Plan Sub Type';
class ResetPlanTypes {
    constructor(planTypes) {
        this.planTypes = planTypes;
    }
}
ResetPlanTypes.type = '[Plans] Reset Plan Types';
class InitializePlanTypeDataMap {
    constructor(activePlanTypes) {
        this.activePlanTypes = activePlanTypes;
    }
}
InitializePlanTypeDataMap.type = '[Plans] Initialize Plan Type Data Map';
class UpdatePlanTypeDataMap {
    constructor(activePlanTypes, planTypesToPreserve) {
        this.activePlanTypes = activePlanTypes;
        this.planTypesToPreserve = planTypesToPreserve;
    }
}
UpdatePlanTypeDataMap.type = '[Plans] Update Plan Type Data Map';
class SetPlanCounts {
    constructor(planCounts) {
        this.planCounts = planCounts;
    }
}
SetPlanCounts.type = '[Plans] Set Plan Counts';
class SetCoveredPreferences {
    constructor(preferences) {
        this.preferences = preferences;
    }
}
SetCoveredPreferences.type = '[Plans] Set Covered Preferences';
class SetPlanScores {
    constructor(planScores) {
        this.planScores = planScores;
    }
}
SetPlanScores.type = '[Plans] Set Plan Scores';
class UpdatePlanShortData {
    constructor(data, hasNewPlanCounts, hasNewPlanScores) {
        this.data = data;
        this.hasNewPlanCounts = hasNewPlanCounts;
        this.hasNewPlanScores = hasNewPlanScores;
    }
}
UpdatePlanShortData.type = '[Plans] Set Plan Short Data';
class SetSelectedPlanYear {
    constructor(selectedPlanYearType, selectedPlanYear) {
        this.selectedPlanYearType = selectedPlanYearType;
        this.selectedPlanYear = selectedPlanYear;
    }
}
SetSelectedPlanYear.type = '[Plans] Set Selected Plan Year';
class ResetPlanYearState {
}
ResetPlanYearState.type = '[Plans] Reset Plan Year State';
class ResetPlanSmart {
}
ResetPlanSmart.type = '[Plans] Reset Plan Smart';
class SetPlanSmartReports {
    constructor(planSmartReportResponse, planYear) {
        this.planSmartReportResponse = planSmartReportResponse;
        this.planYear = planYear;
    }
}
SetPlanSmartReports.type = '[Plans] Set Plan Smart Reports';
class FetchPlanSmartReports {
    constructor(agentGuid, planYear) {
        this.agentGuid = agentGuid;
        this.planYear = planYear;
    }
}
FetchPlanSmartReports.type = '[Plans] Fetch Plan Smart Reports';
class UpdatePlanSmartSort {
    constructor(planSmartSort, planYear) {
        this.planSmartSort = planSmartSort;
        this.planYear = planYear;
    }
}
UpdatePlanSmartSort.type = '[Plans] Update Plan Smart Sort';
class SetSelectedPlanSmartDetails {
    constructor(planSmartReportData) {
        this.planSmartReportData = planSmartReportData;
    }
}
SetSelectedPlanSmartDetails.type = '[Plans] Set Selected Plan Smart Details';
class ResetSelectedPlanSmartDetails {
}
ResetSelectedPlanSmartDetails.type = '[Plans] Reset Selected Plan Smart Details';
class SetPlanYearPermissionError {
    constructor(hasPlanYearPermissionError) {
        this.hasPlanYearPermissionError = hasPlanYearPermissionError;
    }
}
SetPlanYearPermissionError.type = '[Plans] Persist Plan Year Permission Error';
class FetchPlanSmartReportsError {
}
FetchPlanSmartReportsError.type = '[Plans] Fetch Plan Smart Report Error';
class AddFilterToPlanSmartFilterGroups {
    constructor(filter, planYear) {
        this.filter = filter;
        this.planYear = planYear;
    }
}
AddFilterToPlanSmartFilterGroups.type = '[Plans] Add Filter To Plan Smart Filter Group';
class ClearPlanSmartFilterGroupFilters {
    constructor(planYear) {
        this.planYear = planYear;
    }
}
ClearPlanSmartFilterGroupFilters.type = '[Plans] Clear Plan Smart Filter Group Filters';
class ClearPlanSmartFilterGroupWithKey {
    constructor(planYear, filterKeyToClear) {
        this.planYear = planYear;
        this.filterKeyToClear = filterKeyToClear;
    }
}
ClearPlanSmartFilterGroupWithKey.type = '[Plans] Clear Plan Smart Filter Group With Key';
class InitializePlanSmartFilterGroups {
    constructor(activePlanYears) {
        this.activePlanYears = activePlanYears;
    }
}
InitializePlanSmartFilterGroups.type = '[Plans] Initialize Plan Smart Filter Groups';
class FetchCarrierCounts {
    constructor(agentGuid, zip, fips, planYear, dualPlanYear) {
        this.agentGuid = agentGuid;
        this.zip = zip;
        this.fips = fips;
        this.planYear = planYear;
        this.dualPlanYear = dualPlanYear;
    }
}
FetchCarrierCounts.type = '[Plans] Fetch Carrier Counts';
class SetMedicareGroupPlanConfiguration {
    constructor(medicareGroupPlanConfiguration) {
        this.medicareGroupPlanConfiguration = medicareGroupPlanConfiguration;
    }
}
SetMedicareGroupPlanConfiguration.type = '[Member] Set Medicare Group Plan Configuration';
class SetCurrentPlanShort {
    constructor(currentPlanShort) {
        this.currentPlanShort = currentPlanShort;
    }
}
SetCurrentPlanShort.type = '[Plans] Set Current Plan Short';
class UpdateCurrentPlans {
    constructor(plans) {
        this.plans = plans;
    }
}
UpdateCurrentPlans.type = '[Plans] Update Current Plans';
class UpdateCurrentPlanPharmacies {
    constructor(planPharmacies) {
        this.planPharmacies = planPharmacies;
    }
}
UpdateCurrentPlanPharmacies.type = '[Plans] Update Current Plan Pharmacies';

var CultureCode;
(function (CultureCode) {
    CultureCode["ENGLISH_EN_US"] = "en-US";
    CultureCode["SPANISH_ES_MX"] = "es-MX";
    // Culture codes without a country suffix have so far only occurred on late (13.1+) iOS versions running Safari,
    // however there is the potential for these to spread into other Apple influenced systems such as Safari on desktop,
    // and Chrome on iOS (webkit based browsers).
    // The API will throw an exception if these are not first transformed to a full locale including the country suffix.
    CultureCode["ENGLISH_EN"] = "en";
    CultureCode["SPANISH_ES"] = "es";
})(CultureCode || (CultureCode = {}));
class LocaleService {
    // Do not add ConfigResourceService as a dependency. it will cause a circular reference
    constructor(store) {
        this.store = store;
    }
    setLocale(locale) {
        const currentLocale = this.getCurrentLocale();
        if (locale !== currentLocale) {
            // TODO: may need to still dispatch this first action so localStorage gets updated? I think it should be but that is also happening in this action besides setting the store.
            this.store.dispatch(new SetLocale(locale));
            this.store.dispatch(new SetPlansDirty(true));
        }
    }
    getCurrentLocale$() {
        return this.store.select(AppConfigState.currentLocale).pipe(distinctUntilChanged());
    }
    getCurrentLocale() {
        return this.store.selectSnapshot(AppConfigState.currentLocale);
    }
    getDefaultLocale() {
        return this.store.selectSnapshot(AppConfigState.defaultLocale);
    }
    isValidLocale(locale) {
        const supportedLocales = this.store.selectSnapshot(AppConfigState.supportedLanguages);
        return supportedLocales && supportedLocales.includes(locale);
    }
    isSpanishLocale(locale) {
        return locale === CultureCode.SPANISH_ES_MX || locale === CultureCode.SPANISH_ES;
    }
    getTransformedLocale(locale) {
        if (locale) {
            switch (locale.toLowerCase()) {
                case CultureCode.ENGLISH_EN:
                    return CultureCode.ENGLISH_EN_US;
                case CultureCode.SPANISH_ES:
                    return CultureCode.SPANISH_ES_MX;
                default:
                    return locale;
            }
        }
        return locale;
    }
    get getCountryCode$() {
        return this.getCurrentLocale$().pipe(map(currentLocale => {
            if (currentLocale) {
                return currentLocale.substr(3, 5);
            }
            return 'US';
        }));
    }
    getCountryCode() {
        return this.getCurrentLocale().substr(3, 5);
    }
}
LocaleService.LOCALE_ALIAS = {
    'en-US': 'English',
    'es-MX': 'Español'
};
LocaleService.LOCALE_ALIAS_ID = {
    'en-US': 1,
    'es-MX': 2
};
LocaleService.ɵfac = function LocaleService_Factory(t) { return new (t || LocaleService)(i0.ɵɵinject(i1.Store)); };
LocaleService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LocaleService, factory: LocaleService.ɵfac, providedIn: 'root' });
__decorate([
    MemoizeObservable()
], LocaleService.prototype, "getCurrentLocale$", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LocaleService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }]; }, { getCurrentLocale$: [] }); })();

var PlanType;
(function (PlanType) {
    PlanType[PlanType["PDP"] = 1] = "PDP";
    PlanType[PlanType["MAPD"] = 2] = "MAPD";
    PlanType[PlanType["MA"] = 4] = "MA";
    PlanType[PlanType["MEDICARE"] = 7] = "MEDICARE";
    PlanType[PlanType["MEDIGAP"] = 256] = "MEDIGAP";
    PlanType[PlanType["ALL_MEDICARE_PLUS_GAP"] = 263] = "ALL_MEDICARE_PLUS_GAP";
    PlanType[PlanType["RIDER"] = 512] = "RIDER";
    PlanType[PlanType["QHP"] = 1024] = "QHP";
    PlanType[PlanType["NQHP"] = 2048] = "NQHP";
    PlanType[PlanType["DENTAL"] = 4096] = "DENTAL";
    PlanType[PlanType["VISION"] = 8192] = "VISION";
    PlanType[PlanType["SG"] = 16384] = "SG";
    PlanType[PlanType["LG"] = 32768] = "LG";
    PlanType[PlanType["LIFE"] = 65536] = "LIFE";
    PlanType[PlanType["STD"] = 131072] = "STD";
    PlanType[PlanType["LTD"] = 262144] = "LTD";
    PlanType[PlanType["ADD"] = 524288] = "ADD";
    PlanType[PlanType["CI"] = 1048576] = "CI";
    PlanType[PlanType["VLIFE"] = 2097152] = "VLIFE";
    PlanType[PlanType["ADDL_LIFE"] = 4194304] = "ADDL_LIFE";
    PlanType[PlanType["VSTD"] = 8388608] = "VSTD";
    PlanType[PlanType["VLTD"] = 16777216] = "VLTD";
    PlanType[PlanType["HC"] = 33554432] = "HC";
    PlanType[PlanType["AC"] = 67108864] = "AC";
    PlanType[PlanType["TLIFE"] = 134217728] = "TLIFE";
    PlanType[PlanType["PEDDENTAL"] = 268435456] = "PEDDENTAL";
    PlanType[PlanType["STM"] = 536870912] = "STM";
    PlanType[PlanType["MEDICAID"] = 1073741824] = "MEDICAID";
    PlanType[PlanType["MEDICAIDSPECIAL"] = 2147483648] = "MEDICAIDSPECIAL";
    PlanType[PlanType["MEDICAIDDENTAL"] = 8589934592] = "MEDICAIDDENTAL";
    PlanType[PlanType["CHIP"] = 4294967296] = "CHIP";
    PlanType[PlanType["CHIPDENTAL"] = 17179869184] = "CHIPDENTAL";
    PlanType[PlanType["ALL_ANCILLARY"] = 268382208] = "ALL_ANCILLARY";
    PlanType[PlanType["ALL_COMM_PLUS_ANCILLARY"] = 1073741048] = "ALL_COMM_PLUS_ANCILLARY";
    PlanType[PlanType["ALL_MEDICAID"] = 33285996544] = "ALL_MEDICAID";
})(PlanType || (PlanType = {}));
const ANCILLARY_PLAN_TYPES = [PlanType.DENTAL, PlanType.VISION, PlanType.HC];
var PlanSubTypes;
(function (PlanSubTypes) {
    PlanSubTypes["Dental"] = "Dental Only";
    PlanSubTypes["DentalVision"] = "Dental/Vision";
    PlanSubTypes["DentalHearing"] = "Dental/Hearing";
    PlanSubTypes["DentalVisionHearing"] = "Dental/Vision/Hearing";
    PlanSubTypes["Vision"] = "Vision Only";
    PlanSubTypes["VisionDental"] = "Vision/Dental";
    PlanSubTypes["VisionHearing"] = "Vision/Hearing";
    PlanSubTypes["VisionDentalHearing"] = "Vision/Dental/Hearing";
    PlanSubTypes["Cost"] = "Cost";
    PlanSubTypes["HC"] = "HC";
    PlanSubTypes["HMO"] = "HMO";
    PlanSubTypes["HMOPOS"] = "HMOPOS";
    PlanSubTypes["LPPO"] = "LPPO";
    PlanSubTypes["MSA"] = "MSA";
    PlanSubTypes["PFFS"] = "PFFS";
    PlanSubTypes["PPO"] = "PPO";
    PlanSubTypes["RPPO"] = "RPPO";
})(PlanSubTypes || (PlanSubTypes = {}));
const CROSS_SELL_PLANS = [PlanType.PDP, PlanType.MEDIGAP];
const DENTAL_PLANS = [
    PlanSubTypes.Dental,
    PlanSubTypes.DentalVision,
    PlanSubTypes.DentalHearing,
    PlanSubTypes.DentalVisionHearing,
    PlanSubTypes.VisionDental,
    PlanSubTypes.VisionDentalHearing
];
const VISION_PLANS = [
    PlanSubTypes.Vision,
    PlanSubTypes.VisionDental,
    PlanSubTypes.VisionHearing,
    PlanSubTypes.VisionDentalHearing,
    PlanSubTypes.DentalVision,
    PlanSubTypes.DentalVisionHearing
];
const HEARING_PLANS = [
    PlanSubTypes.DentalHearing,
    PlanSubTypes.VisionHearing,
    PlanSubTypes.DentalVisionHearing,
    PlanSubTypes.VisionDentalHearing
];
const DENTAL_COMBO_PLANS = [PlanSubTypes.DentalVision, PlanSubTypes.DentalVisionHearing];
const VISION_COMBO_PLANS = [PlanSubTypes.VisionDental, PlanSubTypes.VisionDentalHearing];
const COMBO_PLANS = [...DENTAL_COMBO_PLANS, ...VISION_COMBO_PLANS];
const ANCILLARY_PLANS = [PlanTypeAbbreviation.DENTAL, PlanTypeAbbreviation.VISION];
const MEDICARE_PLAN_TYPES = [PlanTypeAbbreviation.MA, PlanTypeAbbreviation.MAPD, PlanTypeAbbreviation.PDP];
const MEDICARE_PLAN_TYPE_VALUES = [PlanType.MA, PlanType.MAPD, PlanType.PDP];
const NON_MEDICARE_PLAN_TYPE_VALUES = [PlanType.MEDIGAP, PlanType.DENTAL, PlanType.VISION, PlanType.HC];
const ALL_MEDICARE_PLAN_TYPE_VALUE = MEDICARE_PLAN_TYPE_VALUES.reduce((all, type) => all + type);
const NON_MEDICARE_PLAN_TYPES = [...ANCILLARY_PLANS, PlanTypeAbbreviation.MEDIGAP, PlanTypeAbbreviation.HC];
const PLANS_WITH_ALTERNATIVE_DRUGS = [PlanTypeAbbreviation.MAPD, PlanTypeAbbreviation.PDP];
const ALL_MEDICARE_PLUS_MEDIGAP_PLAN_TYPE_VALUES = [ALL_MEDICARE_PLAN_TYPE_VALUE, PlanType.MEDIGAP];
const ALL_MEDICARE_PLUS_MEDIGAP_PLAN_TYPE_VALUE = MEDICARE_PLAN_TYPE_VALUES.reduce((all, type) => all + type);
const PROVIDER_ENABLED_TYPES = [PlanType.MAPD, PlanType.MA];
const ANCILLARY_PLAN_SUBTYPES = [...DENTAL_PLANS, ...VISION_PLANS, ...HEARING_PLANS, PlanSubTypes.HC];
var SectionHeaderType;
(function (SectionHeaderType) {
    SectionHeaderType[SectionHeaderType["ZERO"] = 0] = "ZERO";
    SectionHeaderType[SectionHeaderType["ONE"] = 1] = "ONE";
    SectionHeaderType[SectionHeaderType["TWO"] = 2] = "TWO";
})(SectionHeaderType || (SectionHeaderType = {}));
var PlanExtraDataKey;
(function (PlanExtraDataKey) {
    PlanExtraDataKey["DISPLAY_SEP"] = "DisplaySEP";
    PlanExtraDataKey["ENROLLMENT_CONFIRMATION_CHARACTER_ARRAY"] = "Enrollment_Confirmation_CharacterArray";
    PlanExtraDataKey["ENROLLMENT_CONFIRMATION_DIGIT_ARRAY"] = "Enrollment_Confirmation_DigitArray";
    PlanExtraDataKey["ENROLLMENT_CONFIRMATION_FORMAT"] = "Enrollment_Confirmation_Format";
    PlanExtraDataKey["ENROLLMENT_CONFIRMATION_PREFIX"] = "Enrollment_Confirmation_Prefix";
    PlanExtraDataKey["ENROLLMENT_CONFIRMATION_SUFFIX"] = "Enrollment_Confirmation_Suffix";
    PlanExtraDataKey["ENROLLMENT_CONFIRMATION_PREFIX_SHORT"] = "Enrollment_Confirmation_Prefix_Short";
    PlanExtraDataKey["HRA"] = "HRA";
    PlanExtraDataKey["HRA_USER_TYPE"] = "HRAUserType";
    PlanExtraDataKey["HRA_EXTERNAL_URL"] = "HRAExternalURL";
    PlanExtraDataKey["HRA_ENROLLMENT_CONFIRMATION_CHARACTER_ARRAY"] = "HRA_Enrollment_Confirmation_CharacterArray";
    PlanExtraDataKey["HRA_ENROLLMENT_CONFIRMATION_DIGIT_ARRAY"] = "HRA_Enrollment_Confirmation_DigitArray";
    PlanExtraDataKey["HRA_ENROLLMENT_CONFIRMATION_FORMAT"] = "HRA_Enrollment_Confirmation_Format";
    PlanExtraDataKey["HRA_ENROLLMENT_CONFIRMATION_PREFIX"] = "HRA_Enrollment_Confirmation_Prefix";
    PlanExtraDataKey["HRA_ENROLLMENT_CONFIRMATION_SUFFIX"] = "HRA_Enrollment_Confirmation_Suffix";
    PlanExtraDataKey["HRA_COMPLETE_WITHIN_DAYS"] = "HRACompleteWithinDays";
    PlanExtraDataKey["PROFESSIONAL_ONLY"] = "ProfessionalOnly";
    PlanExtraDataKey["MODEL_DRUG_PROGRAM"] = "ModelDrugProgram";
    PlanExtraDataKey["RATING_TYPE"] = "RatingType";
    PlanExtraDataKey["ALLOW_CALL_RECORDING_MC"] = "AllowCallRecordingMC";
    PlanExtraDataKey["HC_NUMBER_OF_DAYS_COVERED"] = "HCNumberOfDaysCovered";
    PlanExtraDataKey["FIND_DENTIST_LINK"] = "FindDentistLink";
    PlanExtraDataKey["EDUCATIONAL_CONTENT"] = "EducationalContent";
    PlanExtraDataKey["RATING_METHOD"] = "RatingMethod";
    PlanExtraDataKey["DSNP_COVERAGE_CODES"] = "DSNPCoverageCode";
})(PlanExtraDataKey || (PlanExtraDataKey = {}));
var PlanHRAUserType;
(function (PlanHRAUserType) {
    PlanHRAUserType["NONE"] = "0";
    PlanHRAUserType["CONSUMER"] = "1";
    PlanHRAUserType["BROKER"] = "2";
    PlanHRAUserType["CONSUMER_AND_BROKER"] = "3";
    PlanHRAUserType["CALL_CENTER"] = "4";
    PlanHRAUserType["CONSUMER_AND_CALL_CENTER"] = "5";
    PlanHRAUserType["BROKER_AND_CALL_CENTER"] = "6";
    PlanHRAUserType["ALL"] = "7";
})(PlanHRAUserType || (PlanHRAUserType = {}));
const HRA_CONSUMER_TYPES = [PlanHRAUserType.CONSUMER, PlanHRAUserType.CONSUMER_AND_BROKER, PlanHRAUserType.CONSUMER_AND_CALL_CENTER];
const HRA_BROKER_TYPES = [PlanHRAUserType.BROKER, PlanHRAUserType.CONSUMER_AND_BROKER, PlanHRAUserType.BROKER_AND_CALL_CENTER];
const HRA_CALL_CENTER_TYPES = [
    PlanHRAUserType.CALL_CENTER,
    PlanHRAUserType.CONSUMER_AND_CALL_CENTER,
    PlanHRAUserType.BROKER_AND_CALL_CENTER
];
var PlanHRAType;
(function (PlanHRAType) {
    PlanHRAType["INTERNAL"] = "Internal";
    PlanHRAType["EXTERNAL"] = "External";
    PlanHRAType["NONE"] = "False";
})(PlanHRAType || (PlanHRAType = {}));
var RateFactorsStatus;
(function (RateFactorsStatus) {
    // Question applicable to the plan
    RateFactorsStatus[RateFactorsStatus["APPLICABLE"] = 0] = "APPLICABLE";
    // Question answered but rate factor not applied to the premium
    RateFactorsStatus[RateFactorsStatus["ANSWERED_BUT_NOT_APPLIED_TO_PREMIUM"] = 1] = "ANSWERED_BUT_NOT_APPLIED_TO_PREMIUM";
    // Question answered and rate factor applied to the premium
    RateFactorsStatus[RateFactorsStatus["ANSWERED_AND_APPLIED_TO_PREMIUM"] = 2] = "ANSWERED_AND_APPLIED_TO_PREMIUM";
})(RateFactorsStatus || (RateFactorsStatus = {}));
const ANSWERED_RATE_FACTOR_STATUSES = [
    RateFactorsStatus.ANSWERED_BUT_NOT_APPLIED_TO_PREMIUM,
    RateFactorsStatus.ANSWERED_AND_APPLIED_TO_PREMIUM
];
class Plan {
}
var PlanLabelCategory;
(function (PlanLabelCategory) {
    PlanLabelCategory[PlanLabelCategory["NONE"] = 0] = "NONE";
    PlanLabelCategory[PlanLabelCategory["CURRENT_PLAN"] = 1] = "CURRENT_PLAN";
    PlanLabelCategory[PlanLabelCategory["QUOTED_PLAN"] = 2] = "QUOTED_PLAN";
    PlanLabelCategory[PlanLabelCategory["NEXT_YEAR_PLAN"] = 3] = "NEXT_YEAR_PLAN";
    PlanLabelCategory[PlanLabelCategory["PLAN_OPTION"] = 4] = "PLAN_OPTION";
})(PlanLabelCategory || (PlanLabelCategory = {}));
const PINNED_LABEL_CATEGORIES = [
    PlanLabelCategory.CURRENT_PLAN,
    PlanLabelCategory.NEXT_YEAR_PLAN,
    PlanLabelCategory.QUOTED_PLAN,
    PlanLabelCategory.PLAN_OPTION
];
class PlanQueuePosition {
}
class PlanSmartReports {
}
class SortOption {
}
class PlanSmartSort {
}
class SelectedFilterTag {
}
class SubsidyInformation {
}
var PlanErrorMessage;
(function (PlanErrorMessage) {
    PlanErrorMessage["NOT_AVAILABLE"] = "Not available";
    PlanErrorMessage["RATES_CHANGED"] = "Rates changed";
})(PlanErrorMessage || (PlanErrorMessage = {}));
class PlansDemographicsOptions {
}
class PlansSearchOptions {
}
class PlansMiscOptions {
}
var ExternallyRatedDataFetchType;
(function (ExternallyRatedDataFetchType) {
    ExternallyRatedDataFetchType["PARALLEL"] = "parallel";
    // TODO: Implement parallel as future ERD needs arise, or remove it
    ExternallyRatedDataFetchType["SKIP"] = "skip";
    ExternallyRatedDataFetchType["SEQUENTIAL"] = "sequential"; // Do the regular call, and then do the externally rated data call
})(ExternallyRatedDataFetchType || (ExternallyRatedDataFetchType = {}));
class PlanFetchOptions {
    constructor() {
        this.externallyRatedDataFetchType = ExternallyRatedDataFetchType.SKIP;
    }
}
class PlanBenefitFilter {
}
class MonthCost {
}
class PlanDetailsCostEquation {
}
var PlanDetailsTabs;
(function (PlanDetailsTabs) {
    PlanDetailsTabs["PRESCRIPTIONS"] = "Prescriptions";
    PlanDetailsTabs["PLAN_DETAILS"] = "Plan Details";
    PlanDetailsTabs["HEALTH_COSTS"] = "Health costs";
    PlanDetailsTabs["TOTAL_COSTS"] = "Total costs";
})(PlanDetailsTabs || (PlanDetailsTabs = {}));
var PlanDetailsTabIdentifier;
(function (PlanDetailsTabIdentifier) {
    PlanDetailsTabIdentifier["PLAN_DETAILS"] = "plan-details-tab";
    PlanDetailsTabIdentifier["PRESCRIPTIONS"] = "plan-prescriptions-tab";
    PlanDetailsTabIdentifier["HEALTH_COSTS"] = "plan-health-costs-tab";
    PlanDetailsTabIdentifier["TOTAL_COSTS"] = "plan-total-costs-tab";
})(PlanDetailsTabIdentifier || (PlanDetailsTabIdentifier = {}));
var PlanDetailsCostLabels;
(function (PlanDetailsCostLabels) {
    PlanDetailsCostLabels["PREMIUM"] = "premium";
    PlanDetailsCostLabels["DRUG_COST"] = "drugCost";
    PlanDetailsCostLabels["HEALTH_COST"] = "healthCost";
    PlanDetailsCostLabels["TOTAL_ESTIMATED_COST"] = "totalEstimatedCost";
    PlanDetailsCostLabels["PLAN_FEES"] = "planFees";
})(PlanDetailsCostLabels || (PlanDetailsCostLabels = {}));
var PlanPreferenceLabels;
(function (PlanPreferenceLabels) {
    PlanPreferenceLabels["PRESCRIPTIONS"] = "prescription";
    PlanPreferenceLabels["TOTAL_DRUG_COSTS"] = "drugCost";
    PlanPreferenceLabels["HEALTH_COSTS"] = "healthCost";
    PlanPreferenceLabels["PHARMACY"] = "pharmacy";
    PlanPreferenceLabels["TOTAL_ESTIMATED_COST"] = "totalEstimatedCost";
    PlanPreferenceLabels["PROVIDERS"] = "providers";
})(PlanPreferenceLabels || (PlanPreferenceLabels = {}));
var SortLabels;
(function (SortLabels) {
    SortLabels["MEDICAL_PREMIUM"] = "medicalPremium";
    SortLabels["ANNUAL_PLAN_PREMIUM"] = "annualPlanPremium";
    SortLabels["PLAN_NAME"] = "planName";
    SortLabels["TOTAL_ESTIMATED_COST"] = "planAnnualCost.annualCost.totalEstimatedCost";
    SortLabels["PLAN_RATING"] = "planRating";
    SortLabels["ESTIMATED_DRUG_COSTS"] = "planAnnualCost.annualCost.totalAnnualDrugCostShare";
    SortLabels["SCORE"] = "score";
    SortLabels["MEDICAL_DEDUCTIBLE"] = "medicalDeductible";
    SortLabels["MAXIMUM_OUT_OF_POCKET_COST"] = "maximumOutOfPocketCost";
    SortLabels["CARRIER_NAME"] = "carrierName";
    SortLabels["CALCULATED_BASE_PLAN_PREMIUM"] = "calculatedBasePlanPremium";
})(SortLabels || (SortLabels = {}));
var PlanCompareLabels;
(function (PlanCompareLabels) {
    PlanCompareLabels["MEDICAL_DEDUCTIBLE"] = "medicalDeductible";
    PlanCompareLabels["MEDICAL_OUT_OF_POCKET_MAXIMUM"] = "medicalOutOfPocketMaximum";
    PlanCompareLabels["IN_NETWORK"] = "In Network";
})(PlanCompareLabels || (PlanCompareLabels = {}));
var PlanBenefitValueType;
(function (PlanBenefitValueType) {
    PlanBenefitValueType[PlanBenefitValueType["FLAT_TEXT"] = 1] = "FLAT_TEXT";
    PlanBenefitValueType[PlanBenefitValueType["BENEFIT_VALUE"] = 2] = "BENEFIT_VALUE";
    PlanBenefitValueType[PlanBenefitValueType["LINK"] = 3] = "LINK";
    PlanBenefitValueType[PlanBenefitValueType["DRUG_BENEFIT"] = 4] = "DRUG_BENEFIT";
})(PlanBenefitValueType || (PlanBenefitValueType = {}));
const PLAN_DIFFERENCES = 'planDifferences';
const PAYMENT_METHOD_RATE_FACTOR_IDENTIFIER = '[5, PaymentMethod]';
class PlansHttpResponse {
}
class PlanShort {
}
// maps plan type bitwise numbers to plan counts
class PlansShortHttpResponse {
}
var PlanSmartStatus;
(function (PlanSmartStatus) {
    PlanSmartStatus[PlanSmartStatus["INITIATE"] = 0] = "INITIATE";
    PlanSmartStatus[PlanSmartStatus["IN_PROGRESS"] = 1] = "IN_PROGRESS";
    PlanSmartStatus[PlanSmartStatus["COMPLETED"] = 2] = "COMPLETED";
})(PlanSmartStatus || (PlanSmartStatus = {}));
// maps plan type bitwise numbers to plan counts
class PlanCountsMap {
}
class PlanCompareStyleOptions {
}
class PlanComparePreferenceStyleOptions {
}
var PlanStatus;
(function (PlanStatus) {
    PlanStatus["NEW_PLAN"] = "NewPlan";
    PlanStatus["CURRENT_PLAN"] = "CurrentPlan";
    PlanStatus["NEXT_YEAR_PLAN"] = "NextYearPlan";
})(PlanStatus || (PlanStatus = {}));
var AgentSellingPermissionError;
(function (AgentSellingPermissionError) {
    AgentSellingPermissionError["NO_AGENT_PLAN_YEAR_PERMISSIONS"] = "NO_AGENT_PLAN_YEAR_PERMISSIONS";
    AgentSellingPermissionError["NO_ASP_ALP_TITLE"] = "NO_ALP_PLANS";
})(AgentSellingPermissionError || (AgentSellingPermissionError = {}));
var PlanSmartSortFields;
(function (PlanSmartSortFields) {
    PlanSmartSortFields["LAST_NAME"] = "memberRequest.lastName";
    PlanSmartSortFields["TOTAL_ESTIMATE"] = "memberRequest.planSavings";
})(PlanSmartSortFields || (PlanSmartSortFields = {}));
class PlanEnrollmentSetting {
}
var MedBenefitsType;
(function (MedBenefitsType) {
    MedBenefitsType["BENEFITS"] = "Benefits";
    MedBenefitsType["SNP"] = "SNP";
})(MedBenefitsType || (MedBenefitsType = {}));
class APIMedBenefitsItem {
}
var PlanDataKeys;
(function (PlanDataKeys) {
    PlanDataKeys["POST_ENROLLMENT_MESSAGES"] = "PostEnrollmentMessages";
})(PlanDataKeys || (PlanDataKeys = {}));
var PlanPharmacyNetworkKeywords;
(function (PlanPharmacyNetworkKeywords) {
    PlanPharmacyNetworkKeywords["PREFERRED"] = "preferred";
    PlanPharmacyNetworkKeywords["STANDARD"] = "standard";
    PlanPharmacyNetworkKeywords["MAILORDER"] = "mail order";
    PlanPharmacyNetworkKeywords["MAIL_ORDER"] = "mail-order";
    PlanPharmacyNetworkKeywords["RETAIL"] = "retail";
    PlanPharmacyNetworkKeywords["THIRTY"] = "thirty";
    PlanPharmacyNetworkKeywords["NUMERIC_THIRTY"] = "30";
    PlanPharmacyNetworkKeywords["NINETY"] = "ninety";
    PlanPharmacyNetworkKeywords["NUMERIC_NINETY"] = "90";
    PlanPharmacyNetworkKeywords["ONE_MONTH"] = "one month";
    PlanPharmacyNetworkKeywords["NUMERIC_ONE_MONTH"] = "1 month";
    PlanPharmacyNetworkKeywords["THREE_MONTH"] = "three month";
    PlanPharmacyNetworkKeywords["NUMERIC_THREE_MONTH"] = "3 month";
    PlanPharmacyNetworkKeywords["PREFERRED_SPANISH"] = "preferido";
    PlanPharmacyNetworkKeywords["STANDARD_SPANISH"] = "est\u00E1ndar";
    PlanPharmacyNetworkKeywords["MAILORDER_SPANISH"] = "pedido por correo";
    PlanPharmacyNetworkKeywords["RETAIL_SPANISH"] = "al por menor";
})(PlanPharmacyNetworkKeywords || (PlanPharmacyNetworkKeywords = {}));
class FetchPlanEnrollmentSettingsParams {
}
var SNPBaseType;
(function (SNPBaseType) {
    SNPBaseType[SNPBaseType["dSNP"] = 1] = "dSNP";
    SNPBaseType[SNPBaseType["iSNP"] = 2] = "iSNP";
    SNPBaseType[SNPBaseType["cSNP"] = 3] = "cSNP";
})(SNPBaseType || (SNPBaseType = {}));
const SNP_BASE_VALUES = [SNPBaseType.cSNP, SNPBaseType.dSNP, SNPBaseType.iSNP];
class PlanSNPCategoryItem {
}
var cSNPTypes;
(function (cSNPTypes) {
    cSNPTypes[cSNPTypes["CHRONIC_DEPENDENCE"] = 1] = "CHRONIC_DEPENDENCE";
    cSNPTypes[cSNPTypes["AUTOIMMUNE_DISORDERS"] = 2] = "AUTOIMMUNE_DISORDERS";
    cSNPTypes[cSNPTypes["CANCER"] = 3] = "CANCER";
    cSNPTypes[cSNPTypes["CARDIOVASCULAR"] = 4] = "CARDIOVASCULAR";
    cSNPTypes[cSNPTypes["CHRONIC_HEART_FAILURE"] = 5] = "CHRONIC_HEART_FAILURE";
    cSNPTypes[cSNPTypes["DEMENTIA"] = 6] = "DEMENTIA";
    cSNPTypes[cSNPTypes["DIABETES"] = 7] = "DIABETES";
    cSNPTypes[cSNPTypes["END_STAGE_LIVER"] = 8] = "END_STAGE_LIVER";
    cSNPTypes[cSNPTypes["END_STAGE_RENAL"] = 9] = "END_STAGE_RENAL";
    cSNPTypes[cSNPTypes["SEVERE_HEMATOLOGIC"] = 10] = "SEVERE_HEMATOLOGIC";
    cSNPTypes[cSNPTypes["HIV_AND_AIDS"] = 11] = "HIV_AND_AIDS";
    cSNPTypes[cSNPTypes["CHRONIC_LUNG"] = 12] = "CHRONIC_LUNG";
    cSNPTypes[cSNPTypes["CHRONIC_MENTAL_HEALTH"] = 13] = "CHRONIC_MENTAL_HEALTH";
    cSNPTypes[cSNPTypes["NEUROLOGIC"] = 14] = "NEUROLOGIC";
    cSNPTypes[cSNPTypes["STROKE"] = 15] = "STROKE";
})(cSNPTypes || (cSNPTypes = {}));
var iSNPTypes;
(function (iSNPTypes) {
    iSNPTypes[iSNPTypes["NURSING_HOME"] = 16] = "NURSING_HOME";
    iSNPTypes[iSNPTypes["REQUIRES_NURSING_CARE"] = 17] = "REQUIRES_NURSING_CARE";
})(iSNPTypes || (iSNPTypes = {}));
var DefaultEffectiveDateOption;
(function (DefaultEffectiveDateOption) {
    DefaultEffectiveDateOption["FIRST_MONTH_OF_CURRENT_PLAN_YEAR"] = "FIRST_MONTH_OF_CURRENT_PLAN_YEAR";
    DefaultEffectiveDateOption["FIRST_MONTH_OF_NEXT_PLAN_YEAR"] = "FIRST_MONTH_OF_NEXT_PLAN_YEAR";
    DefaultEffectiveDateOption["NEXT_MONTH"] = "NEXT_MONTH";
})(DefaultEffectiveDateOption || (DefaultEffectiveDateOption = {}));
const SNPSubType = {
    ...cSNPTypes,
    ...iSNPTypes
};
class SNPTypeOptions {
}
var DSNPCodes;
(function (DSNPCodes) {
    DSNPCodes["01"] = "QMB";
    DSNPCodes["02"] = "QMB+";
    DSNPCodes["03"] = "SLMB";
    DSNPCodes["04"] = "SLMB+";
    DSNPCodes["05"] = "QDWI";
    DSNPCodes["06"] = "QI";
    // There is intentionally no 07 right now
    DSNPCodes["08"] = "FBDE";
})(DSNPCodes || (DSNPCodes = {}));
class PlanTypeOptions {
}
var PlanExtraDataRatingType;
(function (PlanExtraDataRatingType) {
    PlanExtraDataRatingType["QUOTE_RATE_SERVICE"] = "QuoteRateService";
})(PlanExtraDataRatingType || (PlanExtraDataRatingType = {}));
const BASE_PLAN_HC_OPTION_NAMES = ['Hospital Confinement Benefits', 'Lump Sum Hospital Confinement Benefits'];
var BenefitType;
(function (BenefitType) {
    BenefitType["BENEFIT_AMOUNT"] = "Benefit Amount";
    BenefitType["BENEFIT_NOTES"] = "Benefit Notes";
})(BenefitType || (BenefitType = {}));
var BenefitNetworkStatus;
(function (BenefitNetworkStatus) {
    BenefitNetworkStatus["IN_NETWORK"] = "In Network";
    BenefitNetworkStatus["OUT_OF_NETWORK"] = "Out of Network";
})(BenefitNetworkStatus || (BenefitNetworkStatus = {}));
var MedSupPlanRatingMethod;
(function (MedSupPlanRatingMethod) {
    MedSupPlanRatingMethod["ATTAINED_AGE"] = "Attained Age";
    MedSupPlanRatingMethod["COMMUNITY_RATED"] = "Community Rated";
    MedSupPlanRatingMethod["ISSUE_AGE"] = "Issue Age";
})(MedSupPlanRatingMethod || (MedSupPlanRatingMethod = {}));
var PlanSource;
(function (PlanSource) {
    PlanSource["PLAN_SOURCE_UNKNOWN"] = "0";
    PlanSource["PLAN_SOURCE_CLAIMS"] = "1";
    PlanSource["PLAN_SOURCE_ELIGIBILITY_CHECK_PROFILE"] = "2";
    PlanSource["PLAN_SOURCE_ELIGIBILITY_CHECK_ENROLL"] = "3";
    PlanSource["PLAN_SOURCE_BANNER"] = "4";
    PlanSource["PLAN_SOURCE_PLAN_LIST"] = "5";
    PlanSource["PLAN_SOURCE_PLAN_DETAILS"] = "6";
    PlanSource["PLAN_SOURCE_PLAN_COMPARISON"] = "7";
    PlanSource["PLAN_SOURCE_CONFIRMATION"] = "8";
})(PlanSource || (PlanSource = {}));
class PlanConditionDetails {
}
var DVHType;
(function (DVHType) {
    DVHType["DENTAL"] = "Dental";
    DVHType["VISION"] = "Vision";
    DVHType["HEARING"] = "Hearing";
})(DVHType || (DVHType = {}));
var DVHStatus;
(function (DVHStatus) {
    DVHStatus["NONE"] = "0";
    DVHStatus["EMBEDDED"] = "1";
    DVHStatus["ADDON_ONLY"] = "2";
})(DVHStatus || (DVHStatus = {}));

class ResponsiveLayoutService {
    constructor(eventManager) {
        this.eventManager = eventManager;
        this.compactView$ = new BehaviorSubject(this.isCompact(window.innerWidth));
        this.mediumView$ = new BehaviorSubject(this.isMedium(window.innerWidth));
        this.extraSmall$ = new BehaviorSubject(this.isExtraSmall(window.innerWidth));
        this.eventManager.addGlobalEventListener('window', 'resize', this.onResize.bind(this));
    }
    get isCompact$() {
        return this.compactView$.asObservable();
    }
    get isMedium$() {
        return this.mediumView$.asObservable();
    }
    get isExtraSmall$() {
        return this.extraSmall$.asObservable();
    }
    onResize(event) {
        this.isExtraSmall(event.target.innerWidth) ? this.extraSmall$.next(true) : this.extraSmall$.next(false);
        this.isCompact(event.target.innerWidth) ? this.compactView$.next(true) : this.compactView$.next(false);
        this.isMedium(event.target.innerWidth) ? this.mediumView$.next(true) : this.mediumView$.next(false);
    }
    /**
     * Instead of calling this isMobile I went with compact since we care about responsive design and not
     * device design. Anyways this method will check to see if it's in the bootstrap defined break points
     * of XS or SM.
     */
    isExtraSmall(width) {
        BootstrapBreakPoints.width = width;
        return BootstrapBreakPoints.isXS;
    }
    isCompact(width) {
        BootstrapBreakPoints.width = width;
        return BootstrapBreakPoints.isXS || BootstrapBreakPoints.isSM;
    }
    isMedium(width) {
        BootstrapBreakPoints.width = width;
        return BootstrapBreakPoints.isMD;
    }
}
ResponsiveLayoutService.ɵfac = function ResponsiveLayoutService_Factory(t) { return new (t || ResponsiveLayoutService)(i0.ɵɵinject(i2.EventManager)); };
ResponsiveLayoutService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ResponsiveLayoutService, factory: ResponsiveLayoutService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ResponsiveLayoutService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i2.EventManager }]; }, null); })();

const GLOBAL_RESOURCES_KEY = 'globalResources';
const PLATFORM_OVERRIDES_KEY = 'platformOverrides';
const PRE_PROCESS_PROP_KEY = 'preProcessPropertyNames';

var DosageForm;
(function (DosageForm) {
    DosageForm["Tablets"] = "TAB";
    DosageForm["Capsules"] = "CAP";
    DosageForm["Chewables"] = "CHW";
    DosageForm["Vial"] = "INJ";
})(DosageForm || (DosageForm = {}));
var DosageFormDisplayText;
(function (DosageFormDisplayText) {
    DosageFormDisplayText["Tablets"] = "tablets";
    DosageFormDisplayText["Capsules"] = "capsules";
    DosageFormDisplayText["Chewables"] = "chewable tablets";
    DosageFormDisplayText["Vial"] = "vial";
    DosageFormDisplayText["Default"] = "";
})(DosageFormDisplayText || (DosageFormDisplayText = {}));

var PropertyType;
(function (PropertyType) {
    PropertyType["VALUE"] = "value";
    PropertyType["RESOURCE"] = "resource";
})(PropertyType || (PropertyType = {}));
var LiveEditType;
(function (LiveEditType) {
    LiveEditType["HTML"] = "html";
    LiveEditType["TEXT"] = "text";
})(LiveEditType || (LiveEditType = {}));

const DYNAMICALLY_UPDATED_RESOURCES = [
    'Spa_ContactUsModal_Address',
    'Spa_ContactUsModal_Email',
    'Spa_ContactUsModal_Hours',
    'Spa_ContactUsModal_Phone',
    'Spa_ClientName'
];

class SetTwilioPhoneNumber {
    constructor(phoneNumber) {
        this.phoneNumber = phoneNumber;
    }
}
SetTwilioPhoneNumber.type = '[Twilio] Set Phone Number';
class SetTwilioAuthCode {
    constructor(authCode) {
        this.authCode = authCode;
    }
}
SetTwilioAuthCode.type = '[Twilio] Set Auth Code';
class SetTwilioCallTrackingId {
    constructor(callTrackingID) {
        this.callTrackingID = callTrackingID;
    }
}
SetTwilioCallTrackingId.type = '[Twilio] Set Call Tracking Id';
class ResetTwilioState {
}
ResetTwilioState.type = '[Twilio] Reset State';

const TWILIO_DEFAULTS = {
    authCode: '',
    phoneNumber: '',
    callTrackingID: ''
};
class TwilioStateModel {
}
let TwilioState = class TwilioState {
    static phoneNumber(state) {
        return state.phoneNumber;
    }
    static authCode(state) {
        return state.authCode;
    }
    static callTrackingId(state) {
        return state.callTrackingID;
    }
    setTwilioPhoneNumber(ctx, { phoneNumber }) {
        ctx.patchState({ phoneNumber });
    }
    setTwilioAuthCode(ctx, { authCode }) {
        ctx.patchState({ authCode });
    }
    setTwilioCallTrackingId(ctx, { callTrackingID }) {
        ctx.patchState({ callTrackingID });
    }
    clearTwilioState(ctx) {
        ctx.setState(TWILIO_DEFAULTS);
    }
};
TwilioState.ɵfac = function TwilioState_Factory(t) { return new (t || TwilioState)(); };
TwilioState.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: TwilioState, factory: TwilioState.ɵfac });
__decorate([
    Action(SetTwilioPhoneNumber)
], TwilioState.prototype, "setTwilioPhoneNumber", null);
__decorate([
    Action(SetTwilioAuthCode)
], TwilioState.prototype, "setTwilioAuthCode", null);
__decorate([
    Action(SetTwilioCallTrackingId)
], TwilioState.prototype, "setTwilioCallTrackingId", null);
__decorate([
    Action(ResetTwilioState)
], TwilioState.prototype, "clearTwilioState", null);
__decorate([
    Selector()
], TwilioState, "phoneNumber", null);
__decorate([
    Selector()
], TwilioState, "authCode", null);
__decorate([
    Selector()
], TwilioState, "callTrackingId", null);
TwilioState = __decorate([
    State({
        name: 'twilio',
        defaults: TWILIO_DEFAULTS
    })
    /**
     * A store that holds the twilio data.
     */
], TwilioState);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TwilioState, [{
        type: Injectable
    }], null, { setTwilioPhoneNumber: [], setTwilioAuthCode: [], setTwilioCallTrackingId: [], clearTwilioState: [] }); })();

var ComparatorType;
(function (ComparatorType) {
    ComparatorType["EQUAL"] = "equal";
    ComparatorType["NOT_EQUAL"] = "notequal";
    ComparatorType["GREATER_THAN"] = "greaterthan";
    ComparatorType["GREATER_THAN_OR_EQUAL"] = "greaterthanorequal";
    ComparatorType["LESS_THAN"] = "lessthan";
    ComparatorType["LESS_THAN_OR_EQUAL"] = "lessthanorequal";
    ComparatorType["IN"] = "in";
    ComparatorType["IN_ARRAY"] = "inarray";
    ComparatorType["NOT_IN"] = "notin";
    ComparatorType["EXISTS"] = "exists";
    ComparatorType["NOT_EXISTS"] = "notexists";
    ComparatorType["BETWEEN"] = "between";
    ComparatorType["NOT_ANY_MULTI"] = "notanymulti";
    ComparatorType["PARTIAL_MATCH"] = "partialmatch";
    ComparatorType["MATCH_ALL"] = "matchall";
    ComparatorType["MATCH_ANY"] = "matchany";
    ComparatorType["MATCH_ANY_SETS"] = "matchanysets";
    // Custom compare type to compare for Filter Selection with Plans -> extraData object
    // {plan : { extraData: {name: "DSNPCoverageCode",  value: "02" }}}
    // {plan : { extraData: {name: "DSNPCoverageCode",  value: "02,03,18" }}}
    ComparatorType["CUSTOM_EXTRADATA_ARRAY_CONTAINS"] = "customextradataarraycontains";
})(ComparatorType || (ComparatorType = {}));
var OperatorType;
(function (OperatorType) {
    OperatorType["SUM"] = "sum";
    OperatorType["NOT_ANY"] = "notany";
})(OperatorType || (OperatorType = {}));
class Filter {
    constructor(config) {
        this.multiKeys = [];
        const { key, values, comparator, defaultReturnValue, visible = true, multiKeys, operatorType } = config;
        this.key = key;
        this.values = values;
        this.comparator = comparator ?? (values.length > 1 ? ComparatorType.IN : ComparatorType.EQUAL);
        this.defaultReturnValue = defaultReturnValue ?? true;
        this.visible = visible;
        this.multiKeys = multiKeys || [];
        this.operatorType = operatorType;
    }
}
/**
 * FilterGroup used to categorize sets of filters into meaningful groups, such as the filters for the MA, MAPD, PDP, or MEDIGAP tabs.
 * The FilterGroup contains a key, set of values, and comparator which double as a composite key for identifying a specific filter group
 * and are used to create primary filtering functionality.
 */
class FilterGroup {
}
var FilterKeyType;
(function (FilterKeyType) {
    FilterKeyType["PLAN_TYPE_SHORT"] = "planTypeAbbreviation";
    FilterKeyType["PLAN_SUB_TYPE"] = "planSubType";
    FilterKeyType["PLAN_CARRIER_NAME"] = "carrierName";
    FilterKeyType["PLAN_BENEFIT_NAME"] = "planDataFields";
    FilterKeyType["PLAN_MARKETING_NAME"] = "planMarketingName";
    FilterKeyType["PLAN_CARRIER_FILTER"] = "planCarrierFilter";
    FilterKeyType["PLAN_PREMIUM"] = "medicalPremium";
    FilterKeyType["PLAN_MEDICAL_DEDUCTIBLE"] = "medicalDeductible";
    FilterKeyType["PLAN_MAXIMUM_OUT_POCKET_COST"] = "maximumOutOfPocketCost";
    FilterKeyType["PLAN_PHARMACY_DEDUCTIBLE"] = "drugDeductible";
    FilterKeyType["PLAN_ISPUF"] = "isPUF";
    FilterKeyType["PLAN_IS_BLACKLISTED"] = "isBlacklistedPlan";
    FilterKeyType["PLAN_IS_NON_PERMISSIONED"] = "isNonPermissionedPlan";
    FilterKeyType["SNP_BASE_TYPE"] = "snpType";
    FilterKeyType["SNP_CATEGORY"] = "planSNPCategories.categoryId";
    FilterKeyType["MODEL_DRUG_PROGRAM"] = "ModelDrugProgram";
    FilterKeyType["DSNP_COVERAGE_CODES"] = "DSNPCoverageCode";
    FilterKeyType["PLAN_EXTRADATA"] = "extraData";
    FilterKeyType["ASP_CARRIER_NAME"] = "carrierId";
    FilterKeyType["ASP_PLAN_TYPE"] = "planTypeId";
    FilterKeyType["ASP_PLAN_YEAR"] = "planYear";
    FilterKeyType["PLAN_RATING"] = "planRating";
    FilterKeyType["ASP_SNP_TYPE"] = "snpTypes";
    FilterKeyType["ASP_STATE"] = "stateAbbrev";
    FilterKeyType["RIDERS_PLAN_SUB_TYPE"] = "riders.planSubType";
    FilterKeyType["PLAN_DRUG_PREMIUM"] = "drugPremium";
    FilterKeyType["PROVIDERS_NPI"] = "providers.npi";
    FilterKeyType["PROVIDERS_NPI_IN_NETWORK"] = "addressList.inNetwork";
    FilterKeyType["HIP_PLAN_DAYS"] = "numberOfDaysCovered";
    FilterKeyType["PLAN_TYPE_DESCRIPTION"] = "planTypeDescription";
    FilterKeyType["MEMBER_REQUEST_STATE"] = "memberRequest.state";
    FilterKeyType["MEMBER_REQUEST_QUOTE_SENT"] = "memberRequest.quoteSentDate";
    FilterKeyType["MEMBER_ENROLLMENT_APPLICATIONS"] = "memberRequest.enrollmentSubmittedDate";
    FilterKeyType["MEMBER_REQUEST_CARRIER_NAMES"] = "memberRequest.currentYearCarrierName";
    FilterKeyType["LOWEST_COST_PCP_IN_NETWORK_STATUS"] = "memberRequest.lowestCostPlanPCPInNetwork";
})(FilterKeyType || (FilterKeyType = {}));
var SNP_CATEGORY_FILTER_TYPES;
(function (SNP_CATEGORY_FILTER_TYPES) {
    SNP_CATEGORY_FILTER_TYPES["ID_IS_CSNP"] = "idIsCSNP";
    SNP_CATEGORY_FILTER_TYPES["ID_IS_ISNP"] = "idIsISNP";
})(SNP_CATEGORY_FILTER_TYPES || (SNP_CATEGORY_FILTER_TYPES = {}));
var PlanFilterAbbreviation;
(function (PlanFilterAbbreviation) {
    PlanFilterAbbreviation["SNP"] = "SNP";
    PlanFilterAbbreviation["LICENSE"] = "Licens";
    PlanFilterAbbreviation["MEDICAL_DEDUCTIBLE"] = "Ded-Med";
    PlanFilterAbbreviation["MEDICAL_OUT_POCKET_COST"] = "MOOP";
    PlanFilterAbbreviation["PRESCRIPTION_DEDUCTIBLE"] = "Ded-Rx";
    PlanFilterAbbreviation["PREMIUM_MEDICAL"] = "Prem-Med";
    PlanFilterAbbreviation["PREMIUM_PHARMACY"] = "Prem-Rx";
    PlanFilterAbbreviation["ADDON_COVERAGE"] = "AddOn";
    PlanFilterAbbreviation["ADDITIONAL_SAVING"] = "Savings";
    PlanFilterAbbreviation["CARRIER"] = "Carriers";
    PlanFilterAbbreviation["PLAN_SUBTYPES"] = "SubTypes";
    PlanFilterAbbreviation["PLANTYPE"] = "PlanType";
    PlanFilterAbbreviation["RATING"] = "Rating";
})(PlanFilterAbbreviation || (PlanFilterAbbreviation = {}));
var PharmacyFilterKeyType;
(function (PharmacyFilterKeyType) {
    PharmacyFilterKeyType["PHARMACY_24HR_SERVICE"] = "has24hrService";
    PharmacyFilterKeyType["PHARMACY_E_PRESCRIPTION"] = "hasEPrescriptions";
    PharmacyFilterKeyType["PHARMACY_HANDICAP_ACCESS"] = "hasHandicapAccess";
    PharmacyFilterKeyType["PHARMACY_DURABLE_EQUIPMENT"] = "hasDurableEquipment";
    PharmacyFilterKeyType["PHARMACY_MAIL_ORDER"] = "isMailOrder";
    PharmacyFilterKeyType["STANDARD"] = "isStandard";
    PharmacyFilterKeyType["PREFERRED"] = "isPreferred";
})(PharmacyFilterKeyType || (PharmacyFilterKeyType = {}));
var PharmacyFilterKeyAnalyticsName;
(function (PharmacyFilterKeyAnalyticsName) {
    PharmacyFilterKeyAnalyticsName["PHARMACY_24HR_SERVICE"] = "Open 24 hours";
    PharmacyFilterKeyAnalyticsName["PHARMACY_E_PRESCRIPTION"] = "e-prescribing";
    PharmacyFilterKeyAnalyticsName["PHARMACY_HANDICAP_ACCESS"] = "Handicap access";
    PharmacyFilterKeyAnalyticsName["PHARMACY_DURABLE_EQUIPMENT"] = "Durable medical equipment";
    PharmacyFilterKeyAnalyticsName["PHARMACY_MAIL_ORDER"] = "Mailorder";
    PharmacyFilterKeyAnalyticsName["STANDARD"] = "Standard in-network";
    PharmacyFilterKeyAnalyticsName["PREFERRED"] = "Preferred in-network";
})(PharmacyFilterKeyAnalyticsName || (PharmacyFilterKeyAnalyticsName = {}));
var ProviderFilterKeyType;
(function (ProviderFilterKeyType) {
    ProviderFilterKeyType["PROVIDER_INDIVIDUAL"] = "individual";
    ProviderFilterKeyType["PROVIDER_FACILITIES"] = "facilities";
    ProviderFilterKeyType["PROVIDER_VALUE_BASED_CARE"] = "value-based-care";
})(ProviderFilterKeyType || (ProviderFilterKeyType = {}));
const COST_FILTER_KEYS = [
    FilterKeyType.PLAN_MEDICAL_DEDUCTIBLE,
    FilterKeyType.PLAN_PHARMACY_DEDUCTIBLE,
    FilterKeyType.PLAN_MAXIMUM_OUT_POCKET_COST,
    FilterKeyType.PLAN_PREMIUM,
    FilterKeyType.PLAN_DRUG_PREMIUM
];
class PlanSmartFilter {
}
class PlanSmartFilterGroup {
}
var FilterKeyGroupName;
(function (FilterKeyGroupName) {
    FilterKeyGroupName["OOP"] = "OOP";
    FilterKeyGroupName["MEDICAL_DEDUCTIBLE"] = "MedicalDeductible";
    FilterKeyGroupName["PREMIUM"] = "Premium";
})(FilterKeyGroupName || (FilterKeyGroupName = {}));
var StaticFilterLabel;
(function (StaticFilterLabel) {
    StaticFilterLabel["OOP"] = "OOP";
    StaticFilterLabel["MEDICAL_DEDUCTIBLE"] = "Ded";
})(StaticFilterLabel || (StaticFilterLabel = {}));

class FilterUtilities {
    static matchFilterGroupCompositeKey(filterGroups, filterGroupCompositeKey) {
        return (filterGroups?.filter(storeFilterGroup => filterGroupCompositeKey.some(tabFilter => storeFilterGroup.groupKey &&
            tabFilter.key === storeFilterGroup.groupKey.key &&
            tabFilter.comparator === storeFilterGroup.groupKey.comparator &&
            // if we have tabs with more than one type, for example, ["DENTAL", "VISION"] and ["VISION", "DENTAL"]
            // the previous evaluation using Array.every() with an internal Array.includes() will return true for these two different filters.
            // isEqual resolves this by comparing ["DENTAL", "VISION"] against ["VISION", "DENTAL"], applying the right filter to the correct tab
            _isEqual(tabFilter.values, storeFilterGroup.groupKey.values))) ?? []);
    }
    /**
     * Returns subset of data filtered by given filters
     * @param data
     * @param filters
     */
    static filter(data, filters) {
        if (filters?.length) {
            return data?.filter(dataItem => filters.every(filter => {
                // Means that property is inside another object or array.
                const pathKeys = filter.key.split('.');
                // One filter can sync with only one other filter, the values can be multiple or none, but related to one filter.
                // uniqueSyncFilters will contain the filter we need to sync with
                const uniqueSyncFilters = FilterUtilities.getSyncFilter(filter.values);
                if (uniqueSyncFilters) {
                    const filterMatch = FilterUtilities.matchSyncedFilter(filters, uniqueSyncFilters, dataItem);
                    if ((filterMatch.performFilter && FilterUtilities.findKeyValueMatch(pathKeys, dataItem, filter)) || filterMatch.ignore) {
                        return true;
                    }
                }
                // Does not make sense to perform another match, because we already processed the data using the sync value.
                if (pathKeys.length > 1) {
                    if (FilterUtilities.findKeyValueMatch(pathKeys, dataItem, filter)) {
                        return true;
                    }
                }
                else {
                    if (FilterUtilities.filterHasPredicates(filter) &&
                        FilterUtilities.matchPredicatesList(dataItem, filter.values[0].predicates, filter.comparator)) {
                        return true;
                    }
                    else if (FilterUtilities.match(dataItem, filter)) {
                        return true;
                    }
                }
                return false;
            }));
        }
        return data;
    }
    /**
     * Checks if the filter defined in syncOtherActiveFilter has a match.
     */
    static matchSyncedFilter(filters, uniqueSyncFilters, data) {
        const filteredBySync = {
            ignore: false,
            performFilter: false
        };
        let syncFilter = filters.find(item => item.key === uniqueSyncFilters.key); // it means the filter we want to sync with is active
        const activeFilter = syncFilter?.values.includes(data[uniqueSyncFilters.key]);
        if (syncFilter) {
            if (uniqueSyncFilters.values.includes(data[uniqueSyncFilters.key]) && activeFilter) {
                filteredBySync.performFilter = true;
                return filteredBySync;
            }
            else if (activeFilter) {
                // We need to track cases where we have to avoid filtering data related to the filter we are syncronizing with
                //    because we want to filter only those values that are referred in the uniqueSyncFilters object.
                filteredBySync.ignore = true;
            }
        }
        return filteredBySync;
    }
    /**
     * Gets all the values from the syncOtherActiveFilter property from the form value.
     */
    static getSyncFilter(filterValues) {
        let filterToCompare;
        filterValues?.forEach(filter => {
            if (filter.syncOtherActiveFilter) {
                const syncOtherActiveFilter = filter.syncOtherActiveFilter;
                if (!filterToCompare) {
                    filterToCompare = FilterUtilities.createFilter(syncOtherActiveFilter);
                }
                else if (filterToCompare.values && !filterToCompare.values.includes(syncOtherActiveFilter.values)) {
                    filterToCompare.values.push(syncOtherActiveFilter.values);
                }
            }
        });
        return filterToCompare;
    }
    /**
     * Creates a new filter.
     */
    // @Memoize(): Do not memoize this function! Each creation should be evaluated separately.
    static createFilter(filter) {
        return new Filter({
            ...filter,
            values: filter.values ? [filter.values] : [],
            defaultReturnValue: !(filter.key === FilterKeyType.SNP_BASE_TYPE || filter.key === FilterKeyType.SNP_CATEGORY),
            visible: true,
            multiKeys: [],
            operatorType: filter.operatorType || null
        });
    }
    /**
     * Finds nested path.
     * @param data
     * @param filter
     */
    static findKeyValueMatch(keys, data, filter, otherActiveFilters) {
        const key = keys[0];
        if (Array.isArray(data[key])) {
            // we are assuming that there will be always two elements in an array because a last key cant contain an array
            const nextKey = keys[1];
            const subKeyFilter = { ...filter, key: nextKey };
            if (keys.length === 2 &&
                (filter.comparator === ComparatorType.MATCH_ALL ||
                    filter.comparator === ComparatorType.MATCH_ANY ||
                    filter.comparator === ComparatorType.MATCH_ANY_SETS)) {
                return FilterUtilities.matchArray(data[key], { ...filter, key: nextKey });
            }
            for (const item of data[key]) {
                if (Array.isArray(item[nextKey])) {
                    const updatedKeys = keys.splice(1, keys.length);
                    FilterUtilities.findKeyValueMatch(updatedKeys, item, subKeyFilter);
                }
                else if (FilterUtilities.match(item, subKeyFilter)) {
                    return true;
                }
            }
        }
        else {
            const subKeyFilter = { ...filter, key };
            if (typeof data[key] !== 'object') {
                return FilterUtilities.match(data, subKeyFilter);
            }
            if (keys.length > 1) {
                const updatedKeys = keys.splice(1, keys.length);
                return FilterUtilities.findKeyValueMatch(updatedKeys, data[key], subKeyFilter);
            }
            return FilterUtilities.match(data[key], subKeyFilter);
        }
        return false;
    }
    /**
     * Iterates over the filter keys to match with the data provided
     * Its being used for PROVIDERS_NPI FilterKeyType, as this filter requires to also match another
     * FilterKeyType - PROVIDERS_NPI_IN_NETWORK. One filter option has to match different data properties.
     * @param data
     * @param keys
     */
    static matchPredicatesList(data, predicates, comparatorType) {
        let isMatch = false;
        if (Array.isArray(data)) {
            for (const item of data) {
                if (comparatorType === ComparatorType.MATCH_ALL) {
                    isMatch = true;
                }
                for (const key of predicates) {
                    const predicateKey = key.key;
                    if (predicateKey.indexOf('.') > -1) {
                        // means some predicates may need to search deeper in the object. This is defined by the path
                        // defined from the target nested object
                        isMatch = FilterUtilities.matchDeeperPredicate(key, item);
                        break;
                    }
                    else {
                        if (comparatorType === ComparatorType.MATCH_ALL && item[predicateKey] !== key.value) {
                            isMatch = false;
                            break;
                        }
                        else if ((comparatorType === ComparatorType.MATCH_ANY || comparatorType === ComparatorType.MATCH_ANY_SETS) &&
                            item[predicateKey] === key.value) {
                            isMatch = true;
                            break;
                        }
                    }
                }
                if (isMatch) {
                    break;
                }
            }
        }
        else {
            for (const key of predicates) {
                isMatch = key.value === data[key.key];
                if (isMatch) {
                    break;
                }
            }
        }
        return isMatch;
    }
    /**
     * Checks if predicate is defined as a path, it will check for deeper properties.
     * @param predicate
     * @param data
     */
    static matchDeeperPredicate(predicate, data) {
        let match = false;
        const nextPath = predicate.key.slice(predicate.key.indexOf('.') + 1); // create a helper that will iterate deeper
        const newPredicate = { ...predicate, key: nextPath };
        const nextKey = predicate.key.split('.')[0];
        if (Array.isArray(data)) {
            for (const item of data) {
                if (predicate.key.indexOf('.') > -1) {
                    match = FilterUtilities.matchDeeperPredicate(newPredicate, item[nextKey]);
                }
                else {
                    match = predicate.value === item[predicate.key];
                }
                if (match) {
                    break;
                }
            }
        }
        else {
            if (predicate.key.indexOf('.') > -1) {
                match = FilterUtilities.matchDeeperPredicate(newPredicate, data[nextKey]);
            }
            else {
                match = predicate.value === data[predicate.key];
            }
        }
        return match;
    }
    /**
     * Checks if filter has predicates.
     * @param filter
     */
    static filterHasPredicates(filter) {
        return filter?.values?.some(item => item.predicates);
    }
    /**
     * Checks if some data matches the provided filter.
     * @param data
     * @param filter
     */
    static match(data, filter) {
        const defaultResult = filter.defaultReturnValue ?? true;
        const comparator = filter.comparator?.toLowerCase();
        const isExtraDataComparision = comparator === ComparatorType.CUSTOM_EXTRADATA_ARRAY_CONTAINS && data?.extraData;
        let comparatorTypes = {
            [ComparatorType.EXISTS]: ({ key }, dataObj) => dataObj.hasOwnProperty(key) && typeof dataObj[key] !== 'undefined' && dataObj[key] !== null,
            [ComparatorType.NOT_EXISTS]: ({ key }, dataObj) => !dataObj.hasOwnProperty(key) || typeof dataObj[key] === 'undefined' || dataObj[key] === null
        };
        if (FilterUtilities.dataExists(data, filter.key, isExtraDataComparision)) {
            comparatorTypes = {
                ...comparatorTypes,
                [ComparatorType.IN]: ({ key, values }, { [key]: value }) => values.includes(value),
                [ComparatorType.NOT_IN]: ({ key, values }, { [key]: value }) => !values.includes(value),
                [ComparatorType.IN_ARRAY]: ({ key, values }, { [key]: value }) => values.some(filterValue => value.some(valueItem => _isEqual(filterValue, valueItem))),
                [ComparatorType.EQUAL]: ({ key, values: [filterValue] }, { [key]: value }) => value === filterValue,
                [ComparatorType.NOT_EQUAL]: ({ key, values: [filterValue] }, { [key]: value }) => value !== filterValue,
                [ComparatorType.GREATER_THAN]: ({ key, values: [filterValue] }, { [key]: value }) => value > filterValue,
                [ComparatorType.GREATER_THAN_OR_EQUAL]: ({ key, values: [filterValue] }, { [key]: value }) => value >= filterValue,
                [ComparatorType.LESS_THAN]: ({ key, values: [filterValue] }, { [key]: value }) => value < filterValue,
                [ComparatorType.LESS_THAN_OR_EQUAL]: ({ key, values: [filterValue] }, { [key]: value }) => value <= filterValue,
                [ComparatorType.BETWEEN]: ({ key, values, multiKeys, operatorType }, value) => {
                    let calculatedValue = value[key];
                    if (multiKeys.length > 1) {
                        calculatedValue = FilterUtilities.applyMultiKeyOperation(value, multiKeys, operatorType);
                    }
                    return (calculatedValue !== null &&
                        calculatedValue !== undefined &&
                        values.some(valueItem => FilterUtilities.isNumberBetween(valueItem?.minValue, valueItem?.maxValue, calculatedValue)));
                },
                [ComparatorType.NOT_ANY_MULTI]: ({ key, values: [filterValue], multiKeys }, { [key]: value }) => FilterUtilities.applyMultiKeyOperation(data, multiKeys, OperatorType.NOT_ANY),
                [ComparatorType.PARTIAL_MATCH]: ({ key, values }, { [key]: value }) => values.find(element => value.filter(valueItem => _isMatch(valueItem, element))?.length === 0) ? false : true,
                [ComparatorType.CUSTOM_EXTRADATA_ARRAY_CONTAINS]: ({ key, values }, { [key]: value }) => {
                    // key here is an extraData keyname such as DSNPCoverageCode
                    // data is the object/plan passed into the match function
                    // values is an array whose object entries are the key name and the selected filter value
                    // extraDataItem will be the entry in the plan's extraData where the key name matches
                    const extraDataItem = data.extraData?.find(item => item.name === key);
                    return (extraDataItem &&
                        values.some(filterValue => {
                            // filterValue is the object the value attached to each checkbox that was selected is contained in.
                            // Such as DSNP checkbox values being 04, 06, etc
                            return extraDataItem.value?.includes(filterValue.value);
                        }));
                }
            };
        }
        return comparatorTypes[comparator]?.(filter, data) ?? defaultResult;
    }
    /**
     * Checks if some data matches the provided filter.
     * @param data
     * @param filter
     */
    static matchArray(data, filter) {
        const defaultResult = filter.defaultReturnValue ?? true;
        const comparator = filter.comparator?.toLowerCase();
        const comparatorTypes = {
            [ComparatorType.MATCH_ALL]: ({ key, values }, matchItems) => FilterUtilities.iterateOverArray(values, matchItems, key, ComparatorType.MATCH_ALL),
            [ComparatorType.MATCH_ANY]: ({ key, values }, matchItems) => FilterUtilities.iterateOverArray(values, matchItems, key, ComparatorType.MATCH_ANY),
            [ComparatorType.MATCH_ANY_SETS]: ({ key, values }, matchItems) => FilterUtilities.iterateOverArray(values, matchItems, key, ComparatorType.MATCH_ANY_SETS)
        };
        return comparatorTypes[comparator]?.(filter, data) ?? defaultResult;
    }
    static iterateOverArray(values, matchItems, key, type) {
        let matchedFilters = false;
        for (const value of values) {
            if (value.predicates) {
                matchedFilters = FilterUtilities.matchPredicatesList(matchItems, value.predicates, type);
            }
            else {
                matchedFilters = matchItems.find(item => item[key] === value);
            }
            if (type === ComparatorType.MATCH_ANY_SETS && matchedFilters) {
                return true;
            }
            if (type !== ComparatorType.MATCH_ANY_SETS && !matchedFilters) {
                return false;
            }
        }
        return matchedFilters;
    }
    /**
     * Checks if all data matches the provided filter.
     * @param filtersA
     * @param filtersB
     */
    static filterSetsMatch(filtersA, filtersB) {
        return _isEqual(_sortBy(filtersA, 'key'), _sortBy(filtersB, 'key'));
    }
    static getFilterGroup(filterGroups, filterGroupIdentifier) {
        const [filterGroupFound] = FilterUtilities.matchFilterGroupCompositeKey(filterGroups, filterGroupIdentifier);
        return filterGroupFound;
    }
    static getFiltersByFilterGroup(filterGroup, includeFilterGroup = true) {
        const filters = [];
        if (filterGroup) {
            // Create and add a filter from the composite key that also identifies the filter group
            if (includeFilterGroup) {
                filters.push(new Filter({ ...filterGroup.groupKey }));
            }
            filters.push(...filterGroup.filters);
        }
        return filters;
    }
    static isNumberBetween(minValue, maxValue, num) {
        return num >= minValue && num <= maxValue;
    }
    static applyMultiKeyOperation(data, multiKeys, operatorType) {
        if (multiKeys.length > 1) {
            switch (operatorType) {
                case OperatorType.SUM:
                    return multiKeys.reduce((preValue, key) => preValue + data[key], 0);
                case OperatorType.NOT_ANY:
                    return !multiKeys.reduce((prev, key) => prev || !!data[key], false);
                default:
                    return null;
            }
        }
        return null;
    }
    static dataExists(dataSource, keyName, isExtraData = false) {
        const data = isExtraData ? dataSource.extraData.find(item => item.name === keyName)?.value : dataSource[keyName];
        return typeof data !== 'undefined' && data !== null;
    }
}
__decorate([
    Memoize()
], FilterUtilities, "matchFilterGroupCompositeKey", null);
__decorate([
    Memoize()
], FilterUtilities, "filter", null);
__decorate([
    Memoize()
], FilterUtilities, "matchSyncedFilter", null);
__decorate([
    Memoize()
], FilterUtilities, "getSyncFilter", null);
__decorate([
    Memoize()
], FilterUtilities, "findKeyValueMatch", null);
__decorate([
    Memoize()
], FilterUtilities, "matchPredicatesList", null);
__decorate([
    Memoize()
], FilterUtilities, "match", null);
__decorate([
    Memoize()
], FilterUtilities, "matchArray", null);
__decorate([
    Memoize()
], FilterUtilities, "iterateOverArray", null);
__decorate([
    Memoize()
], FilterUtilities, "filterSetsMatch", null);
__decorate([
    Memoize()
], FilterUtilities, "getFilterGroup", null);
__decorate([
    Memoize()
], FilterUtilities, "getFiltersByFilterGroup", null);
__decorate([
    Memoize()
], FilterUtilities, "isNumberBetween", null);
__decorate([
    Memoize()
], FilterUtilities, "applyMultiKeyOperation", null);

class AgentLogin {
    constructor(agentData) {
        this.agentData = agentData;
    }
}
AgentLogin.type = '[Agent Login]';
class AgentLogout {
}
AgentLogout.type = '[Agent Login] Clear Agent data on Logout';
class ResetAgentState {
}
ResetAgentState.type = '[Agent] Reset';
class ResetAgentSellingPermissions {
}
ResetAgentSellingPermissions.type = '[Agent] Reset Agent Selling Permissions';
class SetAgentEmailAddress {
    constructor(emailAddress) {
        this.emailAddress = emailAddress;
    }
}
SetAgentEmailAddress.type = '[Agent] Set Email Address';
class SetAgentPhoneNumber {
    constructor(phoneNumber) {
        this.phoneNumber = phoneNumber;
    }
}
SetAgentPhoneNumber.type = '[Agent] Set Phone Number';
class SetAgentNotes {
    constructor(agentNotes) {
        this.agentNotes = agentNotes;
    }
}
SetAgentNotes.type = '[Agent] Set Agent Notes';
class UpdateAgent {
    constructor(agentData, agent) {
        this.agentData = agentData;
        this.agent = agent;
    }
}
UpdateAgent.type = '[Agent] Update Agent';
class SetAgentData {
    constructor(agent) {
        this.agent = agent;
    }
}
SetAgentData.type = '[Agent] Set AgentData';
class SetAgentError {
    constructor(error) {
        this.error = error;
    }
}
SetAgentError.type = '[Agent] Set Agent Error';
class SetAgentContext {
    constructor(context) {
        this.context = context;
    }
}
SetAgentContext.type = '[Agent] Set Agent Context';
class ClearAgentMemberSearch {
}
ClearAgentMemberSearch.type = '[Agent] Clear Member Search';
class SetMemberSearch {
    constructor(memberSearch) {
        this.memberSearch = memberSearch;
    }
}
SetMemberSearch.type = '[Agent] Set Member Search';
class UpdateMemberSearchEntries {
    constructor(updatedMemberSearchEntries) {
        this.updatedMemberSearchEntries = updatedMemberSearchEntries;
    }
}
UpdateMemberSearchEntries.type = '[Agent] Update Member Search Entries';
class FetchMemberProgressInfo {
    constructor(agentGuid, memberID) {
        this.agentGuid = agentGuid;
        this.memberID = memberID;
    }
}
FetchMemberProgressInfo.type = '[Agent] Fetch Member Progress Info';
class ClearSelectedMember {
}
ClearSelectedMember.type = '[Agent] Clear Selected Member';
class SelectedAgentGuid {
    constructor(selectedAgentGuid) {
        this.selectedAgentGuid = selectedAgentGuid;
    }
}
SelectedAgentGuid.type = '[Agent] Add Selected Agent Guid';
class SetPurlAgentUsername {
    constructor(purlAgentUsername) {
        this.purlAgentUsername = purlAgentUsername;
    }
}
SetPurlAgentUsername.type = '[Agent] Set PURL Agent Username';
class SetAgentLoading {
    constructor(loading) {
        this.loading = loading;
    }
}
SetAgentLoading.type = '[Agent] Loading';
class UpdateAgentProfilePicture {
    constructor(agentPictureUrl) {
        this.agentPictureUrl = agentPictureUrl;
    }
}
UpdateAgentProfilePicture.type = '[Agent] Update Profile Picture';
class UpdateAgentSellingPermissionsLoaded {
    constructor(aspLoaded) {
        this.aspLoaded = aspLoaded;
    }
}
UpdateAgentSellingPermissionsLoaded.type = '[Agent] Update Agent Selling Permissions Loaded';
class UpdateAgentSellingPermissions {
    constructor(agentSellingPermissions) {
        this.agentSellingPermissions = agentSellingPermissions;
    }
}
// TODO: Temporary action until API is updated and SPA-8624 is completed
UpdateAgentSellingPermissions.type = '[Agent] Update Agent Selling Permissions';
class AddFilterToASPFilterGroups {
    constructor(filterGroupIdentifier, filter) {
        this.filterGroupIdentifier = filterGroupIdentifier;
        this.filter = filter;
    }
}
AddFilterToASPFilterGroups.type = '[ASP] Add Filter To Filter Group';
class SetASPFilterGroup {
    constructor(filterGroup) {
        this.filterGroup = filterGroup;
    }
}
SetASPFilterGroup.type = '[ASP] Set Filter Group';
class ClearASPFilterGroupFilter {
    constructor(filterGroupIdentifier) {
        this.filterGroupIdentifier = filterGroupIdentifier;
    }
}
ClearASPFilterGroupFilter.type = '[ASP] Clear Filter Group Filter';
class ClearASPFilterWithKey {
    constructor(filterGroupIdentifier, filterKeyToClear) {
        this.filterGroupIdentifier = filterGroupIdentifier;
        this.filterKeyToClear = filterKeyToClear;
    }
}
ClearASPFilterWithKey.type = '[ASP] Clear Filter Based On Key';
class UpdateAgentAgencies {
    constructor(agencies) {
        this.agencies = agencies;
    }
}
UpdateAgentAgencies.type = '[Agent] Update Agencies';
class AddAgentSubscriptionInfo {
    constructor(agentSubscriptionPayload) {
        this.agentSubscriptionPayload = agentSubscriptionPayload;
    }
}
AddAgentSubscriptionInfo.type = '[Agent] Add Agent Subscription Info';
class ResetAgentSubscriptionInfo {
}
ResetAgentSubscriptionInfo.type = '[Agent] Reset Agent Subscription Info';
class FetchAgentAgencies {
    constructor(agentGuid) {
        this.agentGuid = agentGuid;
    }
}
FetchAgentAgencies.type = '[Agent] Fetch Agencies';
class AddAgentLicense {
    constructor(agentLicense) {
        this.agentLicense = agentLicense;
    }
}
AddAgentLicense.type = '[Agent] Add Agent License';
class SetTalkingPoints {
    constructor(talkingPoints) {
        this.talkingPoints = talkingPoints;
    }
}
SetTalkingPoints.type = '[Agent] Set Talking Point';
class SetRetireFloStatus {
    constructor(hasRetireFlo) {
        this.hasRetireFlo = hasRetireFlo;
    }
}
SetRetireFloStatus.type = '[Agent] Set RetireFlo Summary Flag';

class AgentHttpService {
    constructor(http) {
        this.http = http;
        this.environment = EnvironmentService.getEnvironment();
    }
    /**
     * Fetches agent by id and returns an observable of agent data
     * @param id - agentGuid
     */
    fetchAgent$(id, currentAgentGuid) {
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v1/agent/${id}?currentAgentId=${currentAgentGuid}`);
    }
    fetchCarriers$(includeAncillary = false) {
        const params = new HttpParams().set('includeAncillary', includeAncillary);
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Carriers`, { params });
    }
    /**
     * Fetches agent by id and returns a promise of agent data
     * @param id - agentGuid
     */
    async fetchAgent(id, currentAgentGuid) {
        return await this.fetchAgent$(id, currentAgentGuid).toPromise();
    }
    /**
     * Fetches agent by id and returns an observable of agent data
     * @param id - agentGuid
     */
    searchAgents$(id, agent) {
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/agent/${id}/AgentSearch`, agent);
    }
    agentLogin$(agent) {
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/agent`, agent);
    }
    async agentLogin(agent) {
        return await this.agentLogin$(agent).toPromise();
    }
    updateAgentSession$(agent) {
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/agent/${agent.agentGuid}`, agent, {
            params: { LoginAgentId: agent.agentGuid }
        });
    }
    updateViewedAgentSession$(agentGuid, agent, loginAgentId) {
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/agent/${agentGuid}`, agent, {
            params: { LoginAgentId: loginAgentId }
        });
    }
    validateAgentDetails$(payload) {
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Agent/ValidateAgentDetails`, payload);
    }
    getSubscriptionPricingOption$(productId) {
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Stripe/GetPricingOptions?productId=${productId}`);
    }
    getAgentSubscriptionStatus$(stripeSessionId) {
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Stripe/StripeSessionStatus?session_id=${stripeSessionId}`);
    }
    submitAgentInfo$(payload) {
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/agent/PCEdgeAgent`, payload);
    }
    getStripeCheckoutSession$(priceId) {
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Stripe/CreateStripeCheckoutSession?priceKey=${priceId}`, {});
    }
    getSubscriptionStatusEvents$(customerId) {
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Stripe/GetCustomerMetadata?customerId=${customerId}`);
    }
    createNewAgent$(agent) {
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/agent`, agent, {
            params: { LoginAgentId: agent.agentGuid, Create: 'true' }
        });
    }
    async updateAgentSession(agent) {
        return await this.updateAgentSession$(agent).toPromise();
    }
    memberProfileSearch$(agentGuid, body) {
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Agent/${agentGuid}/MemberProfileSearch`, body);
    }
    fetchAgentBeneficiaries$(agentGuid) {
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Agent/${agentGuid}/FetchAgentBeneficiaries`);
    }
    memberProfileDownload$(body) {
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/MemberSearch/Report`, body);
    }
    getTalkingPoints$() {
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v1/TalkingPoints`);
    }
    /**
     * Async: checks if the enroller has permission for a given plan by plan id.
     * @param agentGuid - the current agent guid
     * @param planId - the plan's plan id, plan.id
     * @param planYear - the plan's plan year
     * @param effectiveDate - effective date of enrollment or default
     * @param fips - the fips code of the zip selection
     */
    async checkAgentPlanPermissions(agentGuid, planId, planYear, effectiveDate, fips) {
        return await this.checkAgentPlanPermissions$(agentGuid, planId, planYear, effectiveDate, fips, true).toPromise();
    }
    /**
     * Checks if Agent has selling permission for plan, returns Observable.
     * @param agentGuid  - the current agent guid
     * @param planId - the plan's plan id, plan.id
     * @param planYear - the plan's plan year
     * @param effectiveDate - effective date of enrollment or default
     * @param fips - the fips code of the zip selection
     * @param checkEnrollerPermission - set to true to check if seller has enroll permission for plan
     */
    checkAgentPlanPermissions$(agentGuid, planId, planYear, effectiveDate, fips, checkEnrollerPermission) {
        const data = {
            planID: planId,
            planYear: planYear.toString(),
            effectiveDate,
            fips,
            checkEnrollerPermission
        };
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/agent/${agentGuid}/PlanPermissions`, data);
    }
    memberEnrollmentDocumentDownload$(transactionId, documentId) {
        const options = {
            headers: new HttpHeaders({ 'Accept': 'blob', 'Content-Type': 'application/json' }),
            responseType: 'blob'
        };
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Enroll/Action/Transactions/${transactionId}/files/download`, {
            fileId: documentId
        }, options);
    }
    /**
     * This Method will retrieve the agencies accessible to the agent
     * * @param agentGuid
     */
    fetchAgencies$(agentGuid) {
        const url = `${this.environment.WEB_SERVICE_BASE_URL}/v1/Agent/${agentGuid}/Agencies`;
        return this.http.get(url, { responseType: 'json' });
    }
    getAgentPurl$(baseUrl, agentUserName, encode, selectedStaticPurlYear, redirectPageTag, accountGuid, isBookmarkingEnabled) {
        const version = isBookmarkingEnabled ? 'v2' : 'v1';
        return this.http
            .post(`${this.environment.WEB_SERVICE_BASE_URL}/${version}/agent/personalUrl`, {
            username: agentUserName,
            baseUrl,
            encode,
            // If "PY" is provided, the API will generate a PURL based on the current site's URL using the static URL format:
            // https://PPCsiteUrl.destinationrx.com/PC/Agent/u/{base64agentUsername}/Consumer?{queryParams}
            ...(selectedStaticPurlYear !== undefined && selectedStaticPurlYear !== null && { PY: selectedStaticPurlYear }),
            ...(redirectPageTag ? { ptag: redirectPageTag } : {}),
            ...(accountGuid ? { accountGuid } : {})
        })
            .pipe(map(result => result.url));
    }
    async getAgentPurl(baseUrl, agentUserName, encode, selectedStaticPurlYear, redirectPageTag, accountGuid, isBookmarkingEnabled) {
        return await firstValueFrom(this.getAgentPurl$(baseUrl, agentUserName, encode, selectedStaticPurlYear, redirectPageTag, accountGuid, isBookmarkingEnabled));
    }
    getAgentRetireFloPurl$(baseUrl, agentUserName, encode, redirectPageTag, locale = 'en-US', isBookmarkingEnabled) {
        const version = isBookmarkingEnabled ? 'v2' : 'v1';
        return this.http
            .post(`${this.environment.WEB_SERVICE_BASE_URL}/${version}/agent/RetireFloPersonalUrl`, {
            username: agentUserName,
            baseUrl,
            encode,
            ptag: redirectPageTag,
            language: locale
        })
            .pipe(map(result => result.url));
    }
    async getAgentRetireFloPurl(baseUrl, agentUserName, encode, redirectPageTag, locale, isBookmarkingEnabled) {
        return await firstValueFrom(this.getAgentRetireFloPurl$(baseUrl, agentUserName, encode, redirectPageTag, locale, isBookmarkingEnabled));
    }
    getAgentPurlInformation$(purlId) {
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v2/agent/PersonalizedUrl/${purlId}`);
    }
    async getAgentPurlInformation(purlId) {
        return await firstValueFrom(this.getAgentPurlInformation$(purlId));
    }
    uploadProfile$(file, agentId) {
        const formData = new FormData();
        formData.append('formData', file, file.name);
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Agent/${agentId}/Upload`, formData);
    }
    async uploadProfile(file, agentId) {
        return await this.uploadProfile$(file, agentId).toPromise();
    }
    getAgentPictureIcon$(firstName, lastName) {
        const headers = new HttpHeaders({ Accept: 'application/json' });
        const params = new HttpParams().set('FirstName', firstName).set('LastName', lastName);
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Agent/PictureIcon`, { params, headers });
    }
    async getAgentPictureIcon(firstName, lastName) {
        return await this.getAgentPictureIcon$(firstName, lastName).toPromise();
    }
    updateAgentSellingPermissions$(agentId, sellingPermission) {
        return this.http
            .post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Agent/${agentId}/SetAgentPlanPermissions`, {
            ...sellingPermission,
            blacklist: false
        })
            .pipe(map(response => response.data));
    }
    async updateAgentSellingPermissions(agentId, sellingPermissions) {
        return await this.updateAgentSellingPermissions$(agentId, sellingPermissions).toPromise();
    }
    removeAgentSellingPermission$(agentId, sellingPermissions) {
        return this.http
            .post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Agent/${agentId}/DeleteAgentPlanPermissions`, {
            ...sellingPermissions
        })
            .pipe(map(response => response.data));
    }
    async removeAgentSellingPermission(agentId, sellingPermissions) {
        return await this.removeAgentSellingPermission$(agentId, sellingPermissions).toPromise();
    }
    getAgentSellingPermissions$(agentId, sellingPermissions, includeCrosswalk = false) {
        return this.http
            .post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Agent/${agentId}/RetrieveAgentPlanPermissions`, {
            includeCrosswalk,
            ...sellingPermissions
        })
            .pipe(map(response => response.data ?? []));
    }
    async getAgentSellingPermissions(agentId, sellingPermissions, includeCrosswalk = false) {
        return await this.getAgentSellingPermissions$(agentId, sellingPermissions, includeCrosswalk).toPromise();
    }
    fetchMemberProgressInfo$(agentGuid, memberId) {
        const params = new HttpParams().set('MemberId', memberId);
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Agent/${agentGuid}/RetrieveMemberProgressWithMemberID`, { params });
    }
    fetchRetireFloStatus$(agentGuid) {
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Agent/RetireFloStatus`, {
            userId: agentGuid
        });
    }
}
AgentHttpService.ɵfac = function AgentHttpService_Factory(t) { return new (t || AgentHttpService)(i0.ɵɵinject(i1$2.HttpClient)); };
AgentHttpService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AgentHttpService, factory: AgentHttpService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentHttpService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1$2.HttpClient }]; }, null); })();

var AgentState_1;
const AGENT_DEFAULTS = {
    purlAgentUsername: '',
    agentGuid: '',
    agentNotes: [],
    externalUserId: '',
    firstName: '',
    lastName: '',
    address1: '',
    address2: '',
    city: '',
    hours: '',
    state: '',
    zip: '',
    emailAddress: '',
    phoneNumber: '',
    ext: '',
    agencyName: '',
    npn: '',
    loading: false,
    loginError: AgentError.NO_ERROR,
    context: AgentContext.NOT_INITIALIZED,
    error: null,
    agentPlanYear: '',
    agentUserPermissions: [],
    agentRole: '',
    agencyID: '',
    agentID: '',
    userName: '',
    userPassword: '',
    isActive: true,
    expirationDate: '',
    siteAccess: true,
    resetPasswordRequired: false,
    memberSearch: [],
    agentSellingPermissions: [],
    data: null,
    fsr: '',
    aspRequired: false,
    isProfileAdmin: null,
    selectedAgentGuid: '',
    faxNumber: '',
    agentPictureURL: '',
    areAgentSellingPermissionsLoaded: false,
    aspFilterGroups: [],
    agencies: [],
    licenses: [],
    talkingPoints: [],
    retireFloSummary: null,
    subscription: null,
    customerID: '',
    subscriptionEvents: [],
    userPreferences: {
        favoriteBenefits: []
    },
    hasActiveAnalytics: false
};
class APIAgentStateModel {
}
class AgentStateModel extends APIAgentStateModel {
}
let AgentState = AgentState_1 = class AgentState {
    constructor(agentHttpService) {
        this.agentHttpService = agentHttpService;
    }
    static agentData(state) {
        return state.data;
    }
    static agentNotes(state) {
        return state.agentNotes;
    }
    static firstName(state) {
        return state.firstName;
    }
    static lastName(state) {
        return state.lastName;
    }
    static fullName(firstName, lastName) {
        return `${firstName} ${lastName}`;
    }
    static hours(state) {
        return state.hours;
    }
    static emailAddress(state) {
        return state.emailAddress;
    }
    static agentGuid(state) {
        return state.agentGuid;
    }
    static address1(state) {
        return state.address1;
    }
    static address2(state) {
        return state.address2;
    }
    static phoneNumber(state) {
        return state.phoneNumber;
    }
    static extension(state) {
        return state.ext;
    }
    static state(state) {
        return state.state;
    }
    static zip(state) {
        return state.zip;
    }
    static agencyName(state) {
        return state.agencyName;
    }
    static npn(state) {
        return state.npn;
    }
    static loading(state) {
        return state.loading;
    }
    static loginError(state) {
        return state.loginError;
    }
    static isLoggedIn(state) {
        return state.context === AgentContext.LOGGED_IN;
    }
    static isLoggedOut(state) {
        return state.context === AgentContext.LOGGED_OUT;
    }
    static inContext(state) {
        return state.context === AgentContext.IN_CONTEXT;
    }
    static isBannedFromSession(state) {
        return state.context === AgentContext.BANNED_FROM_SESSION;
    }
    static agencyID(state) {
        return state.agencyID;
    }
    static agentID(state) {
        return state.agentID;
    }
    static userName(state) {
        return state.userName;
    }
    static agentPlanYear(state) {
        return state.agentPlanYear;
    }
    static agentRole(state) {
        return state.agentRole;
    }
    static agentUserPermissions(state) {
        return state.agentUserPermissions;
    }
    static isActive(state) {
        return state.isActive;
    }
    static expirationDate(state) {
        return state.expirationDate;
    }
    static siteAccess(state) {
        return state.siteAccess;
    }
    static hasError(state) {
        return state.loginError !== AgentError.NO_ERROR;
    }
    static city(state) {
        return state.city;
    }
    static memberSearch(state) {
        return state.memberSearch;
    }
    static externalUserId(state) {
        return state.externalUserId;
    }
    static fsr(state) {
        return state.fsr;
    }
    static aspRequired(state) {
        return state.aspRequired;
    }
    static isProfileAdmin(state) {
        return state.isProfileAdmin;
    }
    static retireFloSummary(state) {
        return state.retireFloSummary;
    }
    static talkingPoints(state) {
        return state.talkingPoints;
    }
    static agentIsProfileAdmin(isProfileAdmin) {
        return isProfileAdmin?.toString() ?? null;
    }
    static selectedAgentGuid(state) {
        return state.selectedAgentGuid;
    }
    static purlAgentUsername(state) {
        return state.purlAgentUsername;
    }
    static agentPictureURL(state) {
        return state.agentPictureURL;
    }
    static agentSellingPermissions(state) {
        return state.agentSellingPermissions;
    }
    static aspFilterGroups(state) {
        return state.aspFilterGroups;
    }
    static agencies(state) {
        return state.agencies;
    }
    static licenses(state) {
        return state.licenses;
    }
    static agentSubscriptionData(state) {
        return state.subscription;
    }
    static agentSubscriptionEvents(state) {
        return state.subscriptionEvents;
    }
    static customerId(state) {
        return state.customerID;
    }
    static hasRetireFlo(retireFloSummary) {
        return !!retireFloSummary?.hasRetireFlo;
    }
    static userPreferences(state) {
        return state.userPreferences;
    }
    static favoriteBenefits(userPreferences) {
        return userPreferences?.favoriteBenefits ?? [];
    }
    static hasActiveAnalytics(state) {
        return state.hasActiveAnalytics;
    }
    // TODO: SPA-????? We will possibly update license numbers to be any state in the future
    // Leaving it specific as the exact way we would implement this is entirely in the air for now
    static californiaLicenseNumber(licenseType) {
        return createSelector([AgentState_1.licenses], (licenses) => licenses?.find(license => {
            const isCaliforniaLicense = license.state?.toLowerCase() === 'ca';
            if (licenseType) {
                return isCaliforniaLicense && license.licenseType === licenseType;
            }
            return isCaliforniaLicense && !license.licenseType;
        })?.license ?? '');
    }
    static getFilterGroup(filterGroupIdentifier) {
        return createSelector([AgentState_1.aspFilterGroups], (storeFilterGroups) => FilterUtilities.getFilterGroup(storeFilterGroups, filterGroupIdentifier));
    }
    static getFiltersByFilterGroup(filterGroupIdentifier) {
        return createSelector([AgentState_1.getFilterGroup(filterGroupIdentifier)], (storeFilterGroup) => FilterUtilities.getFiltersByFilterGroup(storeFilterGroup));
    }
    static getASPByFilterGroup(filterGroupIdentifier) {
        return createSelector([AgentState_1.agentSellingPermissions, AgentState_1.getFiltersByFilterGroup(filterGroupIdentifier)], (agentSellingPermissions, filters) => agentSellingPermissions?.length && filters?.length ? FilterUtilities.filter(agentSellingPermissions, filters) : []);
    }
    static uncompletedAgentNotes(type) {
        return createSelector([AgentState_1.agentNotes], (allNotes) => allNotes
            .filter(note => note.agentNoteActionType === type && !note.completedWhen)
            .sort((a, b) => dayjs(a.scheduledDate).unix() - dayjs(b.scheduledDate).unix()));
    }
    static areAgentSellingPermissionsLoaded(state) {
        return state.areAgentSellingPermissionsLoaded;
    }
    addAgentSubscriptionInfo(ctx, { agentSubscriptionPayload }) {
        ctx.patchState({ subscription: agentSubscriptionPayload });
    }
    resetAgentSubscriptionInfo(ctx) {
        ctx.patchState({
            subscription: null
        });
    }
    agentLogin(ctx, { agentData }) {
        const { patchState } = ctx;
        this.removeAgentSellingPermissions(agentData);
        patchState({
            context: AgentContext.LOGGED_IN,
            loginError: AgentError.NO_ERROR,
            loading: false,
            data: agentData,
            ...agentData?.data
        });
    }
    agentLogout({ patchState }) {
        patchState({ ...AGENT_DEFAULTS, context: AgentContext.LOGGED_OUT });
    }
    setAgentNotes(ctx, { agentNotes }) {
        ctx.patchState({ agentNotes });
    }
    updateAgent(ctx, { agentData, agent }) {
        this.removeAgentSellingPermissions(agentData, agent);
        ctx.patchState({ data: agentData, ...agent });
    }
    setAgent(ctx, { agent }) {
        this.removeAgentSellingPermissions(agent);
        ctx.patchState({
            data: agent,
            ...agent.data
        });
    }
    setTalkingPoints(ctx, { talkingPoints }) {
        ctx.patchState({ talkingPoints });
    }
    setHasRetireFlo(ctx, { hasRetireFlo }) {
        const { setState } = ctx;
        setState(patch({ retireFloSummary: patch({ hasRetireFlo }) }));
    }
    updateAgentSellingPermissionsLoaded(ctx, { aspLoaded }) {
        ctx.patchState({ areAgentSellingPermissionsLoaded: aspLoaded });
    }
    updateAgentAgencies(ctx, { agencies }) {
        ctx.patchState({ agencies });
    }
    fetchAgentAgencies$(ctx, { agentGuid }) {
        this.agentHttpService
            .fetchAgencies$(agentGuid)
            .pipe(catchError(() => of([])), map(agenciesFromApi => agenciesFromApi.reduce((agencies, agency) => {
            if (agency?.agencyName?.trim().length > 0) {
                agencies.push(agency);
            }
            return agencies;
        }, [])))
            .subscribe({
            next: agencies => {
                ctx.dispatch(new UpdateAgentAgencies(agencies));
            }
        });
    }
    setAgentError(ctx, { error }) {
        ctx.patchState({
            loginError: error
        });
    }
    setAgentContext(ctx, { context }) {
        ctx.patchState({
            context
        });
    }
    clearAgentMemberSearch(ctx) {
        ctx.patchState({
            memberSearch: []
        });
    }
    setMemberSearch(ctx, { memberSearch }) {
        ctx.patchState({
            memberSearch
        });
    }
    updateMemberSearchEntries(ctx, { updatedMemberSearchEntries }) {
        const updateMemberSearchEntriesOperation = updatedMemberSearchEntries.map(updatedMemberSearchEntry => updateItem(memberSearchEntry => memberSearchEntry.memberID === updatedMemberSearchEntry.memberID, patch({ ...updatedMemberSearchEntry })));
        ctx.setState(patch({
            memberSearch: compose(...updateMemberSearchEntriesOperation)
        }));
    }
    fetchMemberProgressInfo(ctx, { agentGuid, memberID }) {
        return this.agentHttpService
            .fetchMemberProgressInfo$(agentGuid, memberID)
            .pipe(switchMap(memberProgressInfo => ctx.dispatch(new UpdateMemberSearchEntries([{ memberID, memberProgressInfo }]))));
    }
    resetAgentState(ctx) {
        const { setState } = ctx;
        setState(AGENT_DEFAULTS);
    }
    resetAgentSellingPermissions(ctx) {
        ctx.patchState({
            agentSellingPermissions: [],
            areAgentSellingPermissionsLoaded: false
        });
    }
    /**
     * SelectedAgentGuid holds the agentGuid, whose account is currently viewed overview page in broker site.
     */
    addSelectAgentGuid(ctx, { selectedAgentGuid }) {
        ctx.patchState({
            selectedAgentGuid
        });
    }
    SetPurlAgentUsername(ctx, { purlAgentUsername }) {
        ctx.patchState({
            purlAgentUsername
        });
    }
    setAgentLoading(ctx, { loading }) {
        const { patchState } = ctx;
        patchState({ loading });
    }
    updateAgentProfilePicture(ctx, { agentPictureUrl }) {
        ctx.patchState({ agentPictureURL: agentPictureUrl });
    }
    updateAgentSellingPermissions(ctx, { agentSellingPermissions }) {
        ctx.patchState({ agentSellingPermissions, areAgentSellingPermissionsLoaded: true });
    }
    addFilterToFilterGroups({ setState }, { filterGroupIdentifier, filter }) {
        setState(patch({
            aspFilterGroups: updateItem(filterGroup => FilterUtilities.matchFilterGroupCompositeKey([filterGroup], filterGroupIdentifier).length > 0, patch({
                filters: compose(removeItem(existingFilter => existingFilter.key === filter.key), append([filter]))
            }))
        }));
    }
    clearAgentFilterGroupFilter({ setState }, { filterGroupIdentifier }) {
        setState(patch({
            aspFilterGroups: updateItem(filterGroup => FilterUtilities.matchFilterGroupCompositeKey([filterGroup], filterGroupIdentifier).length > 0, patch({
                filters: []
            }))
        }));
    }
    clearFilterGroupFilter({ setState }, { filterGroupIdentifier, filterKeyToClear }) {
        setState(patch({
            aspFilterGroups: updateItem(filterGroup => FilterUtilities.matchFilterGroupCompositeKey([filterGroup], filterGroupIdentifier).length > 0, patch({
                filters: removeItem(existingFilter => existingFilter.key === filterKeyToClear)
            }))
        }));
    }
    SetAgentFilterGroup({ setState }, { filterGroup }) {
        setState(patch({
            aspFilterGroups: compose(removeItem(existingFilterGroup => FilterUtilities.matchFilterGroupCompositeKey([existingFilterGroup], [new Filter({ ...filterGroup.groupKey })]).length > 0), append([filterGroup]))
        }));
    }
    addAgentLicense({ setState }, { agentLicense }) {
        setState(patch({
            licenses: iif(licenses => licenses.some(existingLicense => existingLicense.state === agentLicense.state && existingLicense.license === agentLicense.license), updateItem(existingLicense => existingLicense.state === agentLicense.state && existingLicense.license === agentLicense.license, agentLicense), insertItem(agentLicense))
        }));
    }
    removeAgentSellingPermissions(agentData, agent) {
        // Since we currently only get agentSellingPermissions from a specific endpoint, we do not want to update our store with the
        // null value we will only ever get from the general agent endpoints.
        if (agentData?.data) {
            delete agentData.data.agentSellingPermissions;
        }
        if (agent) {
            delete agent.agentSellingPermissions;
        }
    }
};
AgentState.ɵfac = function AgentState_Factory(t) { return new (t || AgentState)(i0.ɵɵinject(AgentHttpService)); };
AgentState.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AgentState, factory: AgentState.ɵfac });
__decorate([
    Action(AddAgentSubscriptionInfo)
], AgentState.prototype, "addAgentSubscriptionInfo", null);
__decorate([
    Action(ResetAgentSubscriptionInfo)
], AgentState.prototype, "resetAgentSubscriptionInfo", null);
__decorate([
    LiveEditInactive(),
    Action(AgentLogin)
], AgentState.prototype, "agentLogin", null);
__decorate([
    LiveEditInactive(),
    Action(AgentLogout)
], AgentState.prototype, "agentLogout", null);
__decorate([
    Action(SetAgentNotes)
], AgentState.prototype, "setAgentNotes", null);
__decorate([
    Action(UpdateAgent)
], AgentState.prototype, "updateAgent", null);
__decorate([
    Action(SetAgentData)
], AgentState.prototype, "setAgent", null);
__decorate([
    Action(SetTalkingPoints)
], AgentState.prototype, "setTalkingPoints", null);
__decorate([
    Action(SetRetireFloStatus)
], AgentState.prototype, "setHasRetireFlo", null);
__decorate([
    Action(UpdateAgentSellingPermissionsLoaded)
], AgentState.prototype, "updateAgentSellingPermissionsLoaded", null);
__decorate([
    Action(UpdateAgentAgencies)
], AgentState.prototype, "updateAgentAgencies", null);
__decorate([
    Action(FetchAgentAgencies)
], AgentState.prototype, "fetchAgentAgencies$", null);
__decorate([
    Action(SetAgentError)
], AgentState.prototype, "setAgentError", null);
__decorate([
    Action(SetAgentContext)
], AgentState.prototype, "setAgentContext", null);
__decorate([
    Action(ClearAgentMemberSearch)
], AgentState.prototype, "clearAgentMemberSearch", null);
__decorate([
    Action(SetMemberSearch)
], AgentState.prototype, "setMemberSearch", null);
__decorate([
    Action(UpdateMemberSearchEntries)
], AgentState.prototype, "updateMemberSearchEntries", null);
__decorate([
    Action(FetchMemberProgressInfo)
], AgentState.prototype, "fetchMemberProgressInfo", null);
__decorate([
    Action(ResetAgentState)
], AgentState.prototype, "resetAgentState", null);
__decorate([
    Action(ResetAgentSellingPermissions)
], AgentState.prototype, "resetAgentSellingPermissions", null);
__decorate([
    Action(SelectedAgentGuid)
], AgentState.prototype, "addSelectAgentGuid", null);
__decorate([
    Action(SetPurlAgentUsername)
], AgentState.prototype, "SetPurlAgentUsername", null);
__decorate([
    Action(SetAgentLoading)
], AgentState.prototype, "setAgentLoading", null);
__decorate([
    Action(UpdateAgentProfilePicture)
], AgentState.prototype, "updateAgentProfilePicture", null);
__decorate([
    Action(UpdateAgentSellingPermissions)
], AgentState.prototype, "updateAgentSellingPermissions", null);
__decorate([
    Action(AddFilterToASPFilterGroups)
], AgentState.prototype, "addFilterToFilterGroups", null);
__decorate([
    Action(ClearASPFilterGroupFilter)
], AgentState.prototype, "clearAgentFilterGroupFilter", null);
__decorate([
    Action(ClearASPFilterWithKey)
], AgentState.prototype, "clearFilterGroupFilter", null);
__decorate([
    Action(SetASPFilterGroup)
], AgentState.prototype, "SetAgentFilterGroup", null);
__decorate([
    Action(AddAgentLicense)
], AgentState.prototype, "addAgentLicense", null);
__decorate([
    Selector()
], AgentState, "agentData", null);
__decorate([
    Selector()
], AgentState, "agentNotes", null);
__decorate([
    Selector()
], AgentState, "firstName", null);
__decorate([
    Selector()
], AgentState, "lastName", null);
__decorate([
    Selector([AgentState_1.firstName, AgentState_1.lastName])
], AgentState, "fullName", null);
__decorate([
    Selector()
], AgentState, "hours", null);
__decorate([
    Selector()
], AgentState, "emailAddress", null);
__decorate([
    Selector()
], AgentState, "agentGuid", null);
__decorate([
    Selector()
], AgentState, "address1", null);
__decorate([
    Selector()
], AgentState, "address2", null);
__decorate([
    Selector()
], AgentState, "phoneNumber", null);
__decorate([
    Selector()
], AgentState, "extension", null);
__decorate([
    Selector()
], AgentState, "state", null);
__decorate([
    Selector()
], AgentState, "zip", null);
__decorate([
    Selector()
], AgentState, "agencyName", null);
__decorate([
    Selector()
], AgentState, "npn", null);
__decorate([
    Selector()
], AgentState, "loading", null);
__decorate([
    Selector()
], AgentState, "loginError", null);
__decorate([
    Selector()
], AgentState, "isLoggedIn", null);
__decorate([
    Selector()
], AgentState, "isLoggedOut", null);
__decorate([
    Selector()
], AgentState, "inContext", null);
__decorate([
    Selector()
], AgentState, "isBannedFromSession", null);
__decorate([
    Selector()
], AgentState, "agencyID", null);
__decorate([
    Selector()
], AgentState, "agentID", null);
__decorate([
    Selector()
], AgentState, "userName", null);
__decorate([
    Selector()
], AgentState, "agentPlanYear", null);
__decorate([
    Selector()
], AgentState, "agentRole", null);
__decorate([
    Selector()
], AgentState, "agentUserPermissions", null);
__decorate([
    Selector()
], AgentState, "isActive", null);
__decorate([
    Selector()
], AgentState, "expirationDate", null);
__decorate([
    Selector()
], AgentState, "siteAccess", null);
__decorate([
    Selector()
], AgentState, "hasError", null);
__decorate([
    Selector()
], AgentState, "city", null);
__decorate([
    Selector()
], AgentState, "memberSearch", null);
__decorate([
    Selector()
], AgentState, "externalUserId", null);
__decorate([
    Selector()
], AgentState, "fsr", null);
__decorate([
    Selector()
], AgentState, "aspRequired", null);
__decorate([
    Selector()
], AgentState, "isProfileAdmin", null);
__decorate([
    Selector()
], AgentState, "retireFloSummary", null);
__decorate([
    Selector()
], AgentState, "talkingPoints", null);
__decorate([
    Selector([AgentState_1.isProfileAdmin])
], AgentState, "agentIsProfileAdmin", null);
__decorate([
    Selector()
], AgentState, "selectedAgentGuid", null);
__decorate([
    Selector()
], AgentState, "purlAgentUsername", null);
__decorate([
    Selector()
], AgentState, "agentPictureURL", null);
__decorate([
    Selector()
], AgentState, "agentSellingPermissions", null);
__decorate([
    Selector()
], AgentState, "aspFilterGroups", null);
__decorate([
    Selector()
], AgentState, "agencies", null);
__decorate([
    Selector()
], AgentState, "licenses", null);
__decorate([
    Selector()
], AgentState, "agentSubscriptionData", null);
__decorate([
    Selector()
], AgentState, "agentSubscriptionEvents", null);
__decorate([
    Selector()
], AgentState, "customerId", null);
__decorate([
    Selector([AgentState_1.retireFloSummary])
], AgentState, "hasRetireFlo", null);
__decorate([
    Selector()
], AgentState, "userPreferences", null);
__decorate([
    Selector([AgentState_1.userPreferences])
], AgentState, "favoriteBenefits", null);
__decorate([
    Selector()
], AgentState, "hasActiveAnalytics", null);
__decorate([
    Selector()
], AgentState, "areAgentSellingPermissionsLoaded", null);
AgentState = AgentState_1 = __decorate([
    State({
        name: 'agent',
        defaults: AGENT_DEFAULTS
    })
    /**
     * A store that holds the agent data.
     */
], AgentState);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentState, [{
        type: Injectable
    }], function () { return [{ type: AgentHttpService }]; }, { addAgentSubscriptionInfo: [], resetAgentSubscriptionInfo: [], agentLogin: [], agentLogout: [], setAgentNotes: [], updateAgent: [], setAgent: [], setTalkingPoints: [], setHasRetireFlo: [], updateAgentSellingPermissionsLoaded: [], updateAgentAgencies: [], fetchAgentAgencies$: [], setAgentError: [], setAgentContext: [], clearAgentMemberSearch: [], setMemberSearch: [], updateMemberSearchEntries: [], fetchMemberProgressInfo: [], resetAgentState: [], resetAgentSellingPermissions: [], addSelectAgentGuid: [], SetPurlAgentUsername: [], setAgentLoading: [], updateAgentProfilePicture: [], updateAgentSellingPermissions: [], addFilterToFilterGroups: [], clearAgentFilterGroupFilter: [], clearFilterGroupFilter: [], SetAgentFilterGroup: [], addAgentLicense: [] }); })();

class AddDrugsToBlueButtonMedicineCabinet {
    constructor(cabinetEntry) {
        this.cabinetEntry = cabinetEntry;
    }
}
AddDrugsToBlueButtonMedicineCabinet.type = '[BlueButtonMedicineCabinet] Add Drugs';
class RemoveDrugFromBlueButtonMedicineCabinet {
    constructor(dosageID) {
        this.dosageID = dosageID;
    }
}
RemoveDrugFromBlueButtonMedicineCabinet.type = '[BlueButtonMedicineCabinet] Remove Drug';
class EditDrugInBlueButtonMedicineCabinet {
    constructor(dosageId, cabinetEntry) {
        this.dosageId = dosageId;
        this.cabinetEntry = cabinetEntry;
    }
}
EditDrugInBlueButtonMedicineCabinet.type = '[BlueButtonMedicineCabinet] Edit Drug';
class SetBlueButtonCabinetLoading {
    constructor(loading) {
        this.loading = loading;
    }
}
SetBlueButtonCabinetLoading.type = '[BlueButtonMedicineCabinet] Loading';
class SetPrescriptionSuccess {
}
SetPrescriptionSuccess.type = '[BlueButtonMedicineCabinet] Set Prescription Success';
class SetPrescriptionError {
    constructor(error) {
        this.error = error;
    }
}
SetPrescriptionError.type = '[BlueButtonMedicineCabinet] Set Prescription Error';
class ResetBlueButtonMedicineCabinet {
}
ResetBlueButtonMedicineCabinet.type = '[BlueButtonMedicineCabinet] Reset Medicine Cabinet';
class UpdateBlueButtonCabinetClaimStatus {
    constructor(isClaimUpdated) {
        this.isClaimUpdated = isClaimUpdated;
    }
}
UpdateBlueButtonCabinetClaimStatus.type = '[BlueButtonMedicineCabinet] Claim Updated';

class BlueButtonMedicineCabinetStateModel {
}
const MEDICINE_CABINET_DEFAULTS$1 = {
    blueButtonMedicineCabinet: [],
    error: null,
    loading: false,
    isClaimUpdated: false
};
let BlueButtonMedicineCabinetState = class BlueButtonMedicineCabinetState {
    static blueButtonMedicineCabinet(state) {
        return state.blueButtonMedicineCabinet;
    }
    static blueButtonFetchPrescriptionError(state) {
        return state.error;
    }
    static blueButtonLoading(state) {
        return state.loading;
    }
    static isClaimUpdated(state) {
        return state.isClaimUpdated;
    }
    setLoading({ patchState }, { loading }) {
        patchState({
            loading
        });
    }
    updateClaimStatus({ patchState }, { isClaimUpdated }) {
        patchState({
            isClaimUpdated
        });
    }
    setPrescriptionSuccess({ patchState }) {
        patchState({
            loading: false,
            error: null
        });
    }
    setPrescriptionError({ patchState }, { error }) {
        patchState({
            loading: false,
            error
        });
    }
    AddDrugDosage(ctx, action) {
        const cabinetEntry = action.cabinetEntry;
        ctx.setState(patch({
            blueButtonMedicineCabinet: cabinetEntry
        }));
    }
    EditDosage(ctx, action) {
        const cabinetEntry = action.cabinetEntry;
        ctx.setState(patch({
            blueButtonMedicineCabinet: updateItem(entry => entry.dosageID === action.dosageId, cabinetEntry)
        }));
    }
    RemoveDosage(ctx, action) {
        ctx.setState(patch({
            blueButtonMedicineCabinet: removeItem(entry => entry.dosageID === action.dosageID)
        }));
    }
    resetBlueButtonMedicineCabinet({ patchState }) {
        patchState({
            blueButtonMedicineCabinet: []
        });
    }
};
BlueButtonMedicineCabinetState.ɵfac = function BlueButtonMedicineCabinetState_Factory(t) { return new (t || BlueButtonMedicineCabinetState)(); };
BlueButtonMedicineCabinetState.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: BlueButtonMedicineCabinetState, factory: BlueButtonMedicineCabinetState.ɵfac });
__decorate([
    Action(SetBlueButtonCabinetLoading)
], BlueButtonMedicineCabinetState.prototype, "setLoading", null);
__decorate([
    Action(UpdateBlueButtonCabinetClaimStatus)
], BlueButtonMedicineCabinetState.prototype, "updateClaimStatus", null);
__decorate([
    Action(SetPrescriptionSuccess)
], BlueButtonMedicineCabinetState.prototype, "setPrescriptionSuccess", null);
__decorate([
    Action(SetPrescriptionError)
], BlueButtonMedicineCabinetState.prototype, "setPrescriptionError", null);
__decorate([
    Action(AddDrugsToBlueButtonMedicineCabinet)
], BlueButtonMedicineCabinetState.prototype, "AddDrugDosage", null);
__decorate([
    Action(EditDrugInBlueButtonMedicineCabinet)
], BlueButtonMedicineCabinetState.prototype, "EditDosage", null);
__decorate([
    Action(RemoveDrugFromBlueButtonMedicineCabinet)
], BlueButtonMedicineCabinetState.prototype, "RemoveDosage", null);
__decorate([
    Action(ResetBlueButtonMedicineCabinet)
], BlueButtonMedicineCabinetState.prototype, "resetBlueButtonMedicineCabinet", null);
__decorate([
    Selector()
], BlueButtonMedicineCabinetState, "blueButtonMedicineCabinet", null);
__decorate([
    Selector()
], BlueButtonMedicineCabinetState, "blueButtonFetchPrescriptionError", null);
__decorate([
    Selector()
], BlueButtonMedicineCabinetState, "blueButtonLoading", null);
__decorate([
    Selector()
], BlueButtonMedicineCabinetState, "isClaimUpdated", null);
BlueButtonMedicineCabinetState = __decorate([
    State({
        name: 'blueButtonMedicineCabinet',
        defaults: MEDICINE_CABINET_DEFAULTS$1
    })
], BlueButtonMedicineCabinetState);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BlueButtonMedicineCabinetState, [{
        type: Injectable
    }], null, { setLoading: [], updateClaimStatus: [], setPrescriptionSuccess: [], setPrescriptionError: [], AddDrugDosage: [], EditDosage: [], RemoveDosage: [], resetBlueButtonMedicineCabinet: [] }); })();

class SetConfirmationVisited {
}
SetConfirmationVisited.type = '[Confirmation] Set Visited Status';
class ResetConfirmationState {
}
ResetConfirmationState.type = '[Confirmation] Reset Confirmation State';
class UpdateHRAAPINativeTransactionID {
    constructor(hraAPINativeTransactionID) {
        this.hraAPINativeTransactionID = hraAPINativeTransactionID;
    }
}
UpdateHRAAPINativeTransactionID.type = '[Confirmation] Update HRA API Native Transaction ID';
class ResetHRAAPINativeTransactionID {
}
ResetHRAAPINativeTransactionID.type = '[Confirmation] Reset HRA API Native Transaction ID';

const CONFIRMATION_STORE_NAME = 'confirmation';
class ConfirmationStateModel {
}
const CONFIRMATION_DEFAULTS = {
    hasVisited: false,
    hraAPINativeTransactionID: ''
};
let ConfirmationState = class ConfirmationState {
    static hasVisited(state) {
        return state.hasVisited;
    }
    static hraAPINativeTransactionID(state) {
        return state.hraAPINativeTransactionID;
    }
    setHasVisited(ctx) {
        ctx.setState(patch({ hasVisited: true }));
    }
    resetConfirmationState(ctx) {
        ctx.setState(CONFIRMATION_DEFAULTS);
    }
    updateHRAAPINativeTransactionID(ctx, { hraAPINativeTransactionID }) {
        const { patchState } = ctx;
        patchState({
            hraAPINativeTransactionID
        });
    }
    resetHRAAPINativeTransactionID(ctx) {
        const { patchState } = ctx;
        patchState({
            hraAPINativeTransactionID: ''
        });
    }
};
ConfirmationState.ɵfac = function ConfirmationState_Factory(t) { return new (t || ConfirmationState)(); };
ConfirmationState.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ConfirmationState, factory: ConfirmationState.ɵfac });
__decorate([
    Action(SetConfirmationVisited)
], ConfirmationState.prototype, "setHasVisited", null);
__decorate([
    Action(ResetConfirmationState)
], ConfirmationState.prototype, "resetConfirmationState", null);
__decorate([
    Action(UpdateHRAAPINativeTransactionID)
], ConfirmationState.prototype, "updateHRAAPINativeTransactionID", null);
__decorate([
    Action(ResetHRAAPINativeTransactionID)
], ConfirmationState.prototype, "resetHRAAPINativeTransactionID", null);
__decorate([
    Selector()
], ConfirmationState, "hasVisited", null);
__decorate([
    Selector()
], ConfirmationState, "hraAPINativeTransactionID", null);
ConfirmationState = __decorate([
    State({
        name: CONFIRMATION_STORE_NAME,
        defaults: CONFIRMATION_DEFAULTS
    })
], ConfirmationState);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfirmationState, [{
        type: Injectable
    }], null, { setHasVisited: [], resetConfirmationState: [], updateHRAAPINativeTransactionID: [], resetHRAAPINativeTransactionID: [] }); })();

class SetDeepLinkingParams {
    constructor(params) {
        this.params = params;
    }
}
SetDeepLinkingParams.type = '[DeepLinkingParams] Set Deep Linking Parameters';
class SetTFN {
    constructor(TFN) {
        this.TFN = TFN;
    }
}
SetTFN.type = '[DeepLinkingParams] Set TFN';
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class ResetDeepLinkingParams {
}
ResetDeepLinkingParams.type = '[DeepLinkingParams] Reset Deep Linking Parameters';

class QuoteHttpResponse {
}
class QuoteHttpRequest {
}
class QuotePlanRequestData {
}
class DeliveryMethod {
}
var QuoteType;
(function (QuoteType) {
    QuoteType["QUICKQUOTE"] = "QUICKQUOTE";
    QuoteType["ENROLLMENTQUOTE"] = "ENROLLMENTQUOTE";
    QuoteType["PCAPIENROLLMENTQUOTE"] = "PCAPIENROLLMENTQUOTE";
    QuoteType["SASENROLLMENTQUOTE"] = "SASENROLLMENTQUOTE";
    QuoteType["SASPCAPIENROLLMENTQUOTE"] = "SASPCAPIENROLLMENTQUOTE";
    QuoteType["NONE"] = "";
})(QuoteType || (QuoteType = {}));
const QUOTE_TYPES_FROM_SEND_TO_BENEFICIARY_FLOW = [QuoteType.ENROLLMENTQUOTE, QuoteType.PCAPIENROLLMENTQUOTE];
const SIGN_AND_SUBMIT_QUOTE_TYPES = [QuoteType.SASENROLLMENTQUOTE, QuoteType.SASPCAPIENROLLMENTQUOTE];
const ALL_ENROLLMENT_QUOTE_TYPES = [
    QuoteType.ENROLLMENTQUOTE,
    QuoteType.PCAPIENROLLMENTQUOTE,
    QuoteType.SASENROLLMENTQUOTE,
    QuoteType.SASPCAPIENROLLMENTQUOTE
];
class Quote {
}
class QuoteExtraData {
}
class QuoteVideoData {
}
class QuotePlanPermission {
}
const UndefinedAgentGuid = '00000000-0000-0000-0000-000000000000';

var DeepLinkingParamsState_1;
const DEEP_LINKING_PARAMS_DEFAULTS = {
    ZIPCODE: '',
    COUNTYFIPS: '',
    PLANTYPE: '',
    PLANID: '',
    CULTURECODE: '',
    SSOVALUE: '',
    BENEFIRSTNAME: '',
    BENELASTNAME: '',
    BENEBIRTHDATE: '',
    BENEGENDER: '',
    BENECRMID: '',
    BENEADDR1: '',
    BENEADDR2: '',
    BENECITY: '',
    BENESTATE: '',
    BENEPHONE: '',
    BENECELLPHONE: '',
    BENEEMAIL: '',
    AGENTID: '',
    AGENCYNAME: '',
    AGENCYID: '',
    SOURCEID: '',
    PARTNERID: '',
    RETURNURL: '',
    UTM_SOURCE: '',
    UTM_MEDIUM: '',
    UTM_CAMPAIGN: '',
    TFN: '',
    CUSTOMTRACK1: '',
    CUSTOMTRACK2: '',
    CUSTOMTRACK3: '',
    CUSTOMTRACK4: '',
    CUSTOMTRACK5: '',
    CUSTOMFMO1: '',
    CUSTOMFMO2: '',
    CUSTOMFMO3: '',
    CUSTOMFMO4: '',
    CUSTOMFMO5: '',
    MILITARYRANK: '',
    MILITARYSTATUS: '',
    MILITARYBRANCH: '',
    MILITARYPREFIXCODE: '',
    POPULATEDDATA: '',
    PEGI: '',
    CHANNEL: '',
    SESSIONID: '',
    QUOTEID: '',
    AGENTGUID: '',
    QUOTETYPE: QuoteType.NONE
};
let DeepLinkingParamsState = DeepLinkingParamsState_1 = class DeepLinkingParamsState {
    static state(state) {
        return state;
    }
    static sourceId(state) {
        return state.SOURCEID;
    }
    static partnerId(state) {
        return state.PARTNERID;
    }
    static returnUrl(state) {
        return state.RETURNURL;
    }
    static utmSource(state) {
        return state.UTM_SOURCE;
    }
    static utmCampaign(state) {
        return state.UTM_CAMPAIGN;
    }
    static utmMedium(state) {
        return state.UTM_MEDIUM;
    }
    static utmContent(state) {
        return state.UTM_CONTENT;
    }
    static populatedData(state) {
        return state.POPULATEDDATA;
    }
    static ssoValue(state) {
        return state.SSOVALUE;
    }
    static pegi(state) {
        return state.PEGI;
    }
    static getDeepLinkingParam(key) {
        return createSelector([DeepLinkingParamsState_1.state], (params) => params[key] ?? '');
    }
    updateParams(ctx, { params }) {
        if (params) {
            const { patchState } = ctx;
            patchState(params);
        }
    }
    setTFN(ctx, { TFN }) {
        const { setState } = ctx;
        setState(patch({ TFN }));
    }
    resetParamsState(ctx) {
        const { setState } = ctx;
        setState(DEEP_LINKING_PARAMS_DEFAULTS);
    }
};
DeepLinkingParamsState.ɵfac = function DeepLinkingParamsState_Factory(t) { return new (t || DeepLinkingParamsState)(); };
DeepLinkingParamsState.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DeepLinkingParamsState, factory: DeepLinkingParamsState.ɵfac });
__decorate([
    Action(SetDeepLinkingParams)
], DeepLinkingParamsState.prototype, "updateParams", null);
__decorate([
    Action(SetTFN)
], DeepLinkingParamsState.prototype, "setTFN", null);
__decorate([
    Action(ResetDeepLinkingParams)
], DeepLinkingParamsState.prototype, "resetParamsState", null);
__decorate([
    Selector()
], DeepLinkingParamsState, "state", null);
__decorate([
    Selector()
], DeepLinkingParamsState, "sourceId", null);
__decorate([
    Selector()
], DeepLinkingParamsState, "partnerId", null);
__decorate([
    Selector()
], DeepLinkingParamsState, "returnUrl", null);
__decorate([
    Selector()
], DeepLinkingParamsState, "utmSource", null);
__decorate([
    Selector()
], DeepLinkingParamsState, "utmCampaign", null);
__decorate([
    Selector()
], DeepLinkingParamsState, "utmMedium", null);
__decorate([
    Selector()
], DeepLinkingParamsState, "utmContent", null);
__decorate([
    Selector()
], DeepLinkingParamsState, "populatedData", null);
__decorate([
    Selector()
], DeepLinkingParamsState, "ssoValue", null);
__decorate([
    Selector()
], DeepLinkingParamsState, "pegi", null);
DeepLinkingParamsState = DeepLinkingParamsState_1 = __decorate([
    State({
        name: 'deepLinkingParams',
        defaults: DEEP_LINKING_PARAMS_DEFAULTS
    })
], DeepLinkingParamsState);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DeepLinkingParamsState, [{
        type: Injectable
    }], null, { updateParams: [], setTFN: [], resetParamsState: [] }); })();

class Agent {
}
class Organization {
}
class AgentOfRecord {
}
class AgentData {
    constructor(agentData) {
        this.data = agentData.data;
        this.status = agentData.status;
    }
}
var StripeSessionStatus;
(function (StripeSessionStatus) {
    StripeSessionStatus["OPEN"] = "1";
    StripeSessionStatus["COMPLETE"] = "2";
    StripeSessionStatus["EXPIRED"] = "3";
    StripeSessionStatus["UNKNOWN"] = "4";
})(StripeSessionStatus || (StripeSessionStatus = {}));
var SubscriptionMetaData;
(function (SubscriptionMetaData) {
    SubscriptionMetaData["DELETED"] = "customer.subscription.deleted";
    SubscriptionMetaData["FAILED"] = "invoice.payment_failed";
    SubscriptionMetaData["ABORTED"] = "subscription_schedule.aborted";
    SubscriptionMetaData["CANCELED"] = "subscription_schedule.canceled";
    SubscriptionMetaData["UPDATED"] = "customer.subscription.updated";
})(SubscriptionMetaData || (SubscriptionMetaData = {}));
var SubscriptionDuration;
(function (SubscriptionDuration) {
    SubscriptionDuration[SubscriptionDuration["EVERY_THREE_MONTH"] = 0] = "EVERY_THREE_MONTH";
    SubscriptionDuration[SubscriptionDuration["ANNUALLY"] = 1] = "ANNUALLY";
    SubscriptionDuration[SubscriptionDuration["MONTHLY"] = 2] = "MONTHLY";
})(SubscriptionDuration || (SubscriptionDuration = {}));
var StripeConstant;
(function (StripeConstant) {
    StripeConstant["PUBLISHABLE_KEY_TEST"] = "pk_test_51PNfzT064exJIVkzmJslLpMFktExUftHN96nwM8kEW0EjxirTfX7U9cELfe9UKMOQE8N3nixdXqz5xV0vcTNzhei00SxsBUpGo";
    StripeConstant["PUBLISHABLE_KEY_LIVE"] = "pk_live_51PNfzT064exJIVkzDtxoWp6V3Vf5Yt6dU5a3xhHf6DzgiZyixx8BYZWT26lmR043Cq7ajZvY2ZvcuWFnwQsiZc8O001zyQLMyt";
    StripeConstant["PRODUCT_ID"] = "prod_QHUb3xeBLpR0qs";
})(StripeConstant || (StripeConstant = {}));
var SubscriptionDurationLabel;
(function (SubscriptionDurationLabel) {
    SubscriptionDurationLabel["MONTH"] = "month";
    SubscriptionDurationLabel["QUARTER"] = "quarter";
    SubscriptionDurationLabel["YEAR"] = "year";
})(SubscriptionDurationLabel || (SubscriptionDurationLabel = {}));
class ValidateAgentResponse {
}
class AgentValidData {
}
class AgentSubscriptionPayload {
}
class AgentsData {
    constructor(agentData) {
        this.data = agentData.data;
        this.status = agentData.status;
    }
}
/*
Predefined plan type permissions do not allow to select more
specific plan types when adding a permission. For example, if adding Medicare permissions
we can additionally specify if the permission applies to MA, MAPD, and/or PDP but
as Ancillary or MedSup is a predefined plan type we cannot add a permission to only dental or only vision
*/
const PREDEFINED_PERMISSION_PLAN = [PlanType.ALL_ANCILLARY, PlanType.MEDIGAP];
var AccountAddPermissionsInputs;
(function (AccountAddPermissionsInputs) {
    AccountAddPermissionsInputs["ADD_PERMISSION_TYPE"] = "permissionType";
    AccountAddPermissionsInputs["ADD_PLAN_YEAR"] = "planYear";
    AccountAddPermissionsInputs["ADD_CARRIER"] = "carrierID";
    AccountAddPermissionsInputs["ADD_STATES"] = "states";
    AccountAddPermissionsInputs["ADD_PLAN_TYPE"] = "planTypes";
    AccountAddPermissionsInputs["ADD_PRODUCER_ID"] = "crosswalkAgentID";
    AccountAddPermissionsInputs["ADD_SNP"] = "snpTypes";
})(AccountAddPermissionsInputs || (AccountAddPermissionsInputs = {}));
class APIBatchAgentSellingPermissions {
}
var SiteAccess;
(function (SiteAccess) {
    SiteAccess["REVOKE_ACCESS"] = "Revoke Access";
    SiteAccess["GRANT_ACCESS"] = "Grant access";
})(SiteAccess || (SiteAccess = {}));
const NEW_AGENT_EXCEPTION_DETAIL = 'Username already exists';
var AgentRole;
(function (AgentRole) {
    AgentRole["QUOTER"] = "Quoter";
    AgentRole["QUOTER_BROKER"] = "Quoter_Broker";
    AgentRole["QUOTER_ADMIN"] = "Quoter_Admin";
    AgentRole["QUOTER_AGENCY_ADMIN"] = "Quoter_AgencyAdmin";
    AgentRole["QUOTER_AGENCY"] = "Quoter_Agency";
    AgentRole["QUOTER_SINGLE_AGENCY"] = "Quoter_SingleAgency";
    AgentRole["ENROLLER"] = "Enroller";
    AgentRole["ENROLLER_AGENCY"] = "Enroller_Agency";
    AgentRole["ENROLLER_SINGLE_AGENCY"] = "Enroller_SingleAgency";
    AgentRole["ENROLLER_BROKER"] = "Enroller_Broker";
    AgentRole["ENROLLER_ADMIN"] = "Enroller_Admin";
    AgentRole["ENROLLER_AGENCY_ADMIN"] = "Enroller_AgencyAdmin";
})(AgentRole || (AgentRole = {}));
const ENROLLER_BASIC_ROLES = [AgentRole.ENROLLER, AgentRole.ENROLLER_AGENCY, AgentRole.ENROLLER_SINGLE_AGENCY];
const ENROLLER_NON_ADMIN_ROLES = [...ENROLLER_BASIC_ROLES, AgentRole.ENROLLER_BROKER];
const ENROLLER_ADMIN_ROLES = [AgentRole.ENROLLER_ADMIN, AgentRole.ENROLLER_AGENCY_ADMIN];
const ENROLLER_ROLES = [...ENROLLER_NON_ADMIN_ROLES, ...ENROLLER_ADMIN_ROLES];
const QUOTER_BASIC_ROLES = [AgentRole.QUOTER, AgentRole.QUOTER_AGENCY, AgentRole.QUOTER_SINGLE_AGENCY];
const QUOTER_NON_ADMIN_ROLES = [...QUOTER_BASIC_ROLES, AgentRole.QUOTER_BROKER];
const QUOTER_ADMIN_ROLES = [AgentRole.QUOTER_ADMIN, AgentRole.QUOTER_AGENCY_ADMIN];
const QUOTER_ROLES = [...QUOTER_NON_ADMIN_ROLES, ...QUOTER_ADMIN_ROLES];
const BASIC_ROLES = [...ENROLLER_BASIC_ROLES, ...QUOTER_BASIC_ROLES];
const ADMIN_ROLES = [...ENROLLER_ADMIN_ROLES, ...QUOTER_ADMIN_ROLES];
const AGENCY_ADMIN_ROLES = [AgentRole.ENROLLER_AGENCY_ADMIN, AgentRole.QUOTER_AGENCY_ADMIN];
const BROKER_ROLES = [AgentRole.ENROLLER_BROKER, AgentRole.QUOTER_BROKER];
var AgentUserPermission;
(function (AgentUserPermission) {
    AgentUserPermission["EDIT_ALL"] = "Edit_All";
    AgentUserPermission["EDIT_SELF"] = "Edit_Self";
    AgentUserPermission["EDIT_UNDER"] = "Edit_Under";
    AgentUserPermission["EDIT_ASSIGNED"] = "Edit_Assigned";
    AgentUserPermission["EDIT_ORG"] = "Edit_Org";
    AgentUserPermission["VIEW_ALL"] = "View_All";
    AgentUserPermission["VIEW_UNDER"] = "View_Under";
    AgentUserPermission["VIEW_ASSIGNED"] = "View_Assigned";
    AgentUserPermission["VIEW_ORG"] = "View_Org";
    AgentUserPermission["ENROLL"] = "Enroll";
    AgentUserPermission["ASSIGN_AGENT"] = "Assign_Agent";
})(AgentUserPermission || (AgentUserPermission = {}));
const SINGLE_AGENCY_PERMISSIONS = [AgentUserPermission.EDIT_ASSIGNED, AgentUserPermission.VIEW_ASSIGNED];
const BROKER_PERMISSIONS = [AgentUserPermission.EDIT_UNDER, AgentUserPermission.VIEW_UNDER];
const ADMIN_PERMISSIONS = [AgentUserPermission.EDIT_ALL, AgentUserPermission.VIEW_ALL];
const AGENCY_ADMIN_PERMISSIONS = [AgentUserPermission.EDIT_ORG, AgentUserPermission.VIEW_ORG];
class AgentEmailFooterData {
}
class APIGetAgentSellingPermissionResponse {
}
var TalkingPointPageType;
(function (TalkingPointPageType) {
    TalkingPointPageType[TalkingPointPageType["SHOPPING"] = 1] = "SHOPPING";
    TalkingPointPageType[TalkingPointPageType["ENROLLMENT"] = 2] = "ENROLLMENT";
})(TalkingPointPageType || (TalkingPointPageType = {}));
var AgentSearchResult;
(function (AgentSearchResult) {
    AgentSearchResult["INIT_RESULTS"] = "INIT_RESULTS";
    AgentSearchResult["NO_RESULTS"] = "NO_RESULTS";
    AgentSearchResult["NO_RESULTS_TIMEOUT"] = "NO_RESULTS_TIMEOUT";
    AgentSearchResult["RESULTS"] = "RESULTS";
})(AgentSearchResult || (AgentSearchResult = {}));
var AgentLicenseType;
(function (AgentLicenseType) {
    // Agent license sent by clients that do not have agents in our system. Returned from the initial /Enroll call during a PC API enrollment.
    AgentLicenseType["PC_API"] = "PC_API";
})(AgentLicenseType || (AgentLicenseType = {}));
class AgentLicense {
}
var AgentStaticPurlYear;
(function (AgentStaticPurlYear) {
    AgentStaticPurlYear[AgentStaticPurlYear["PLAN_YEAR"] = 1] = "PLAN_YEAR";
    AgentStaticPurlYear[AgentStaticPurlYear["DUAL_PLAN_YEAR"] = 2] = "DUAL_PLAN_YEAR";
})(AgentStaticPurlYear || (AgentStaticPurlYear = {}));
var RetireFloStatus;
(function (RetireFloStatus) {
    RetireFloStatus["SUSPENDED"] = "SUSPENDED";
    RetireFloStatus["ACTIVE"] = "ACTIVE";
    RetireFloStatus["INACTIVE"] = "INACTIVE";
    RetireFloStatus["NONEXISTENT"] = "NONEXISTENT";
})(RetireFloStatus || (RetireFloStatus = {}));

const ANCILLARY_FORM_TYPE = 'ancillary';
var EnrollmentFormTypeDisplayName;
(function (EnrollmentFormTypeDisplayName) {
    EnrollmentFormTypeDisplayName["HRA"] = "HRA";
})(EnrollmentFormTypeDisplayName || (EnrollmentFormTypeDisplayName = {}));
var EnrollmentFormType;
(function (EnrollmentFormType) {
    EnrollmentFormType[EnrollmentFormType["LONG"] = 0] = "LONG";
    EnrollmentFormType[EnrollmentFormType["SHORT"] = 1] = "SHORT";
    EnrollmentFormType[EnrollmentFormType["WAIVER"] = 2] = "WAIVER";
    EnrollmentFormType[EnrollmentFormType["DISENROLLMENT"] = 3] = "DISENROLLMENT";
    EnrollmentFormType[EnrollmentFormType["INTAKE_FORM"] = 4] = "INTAKE_FORM";
    EnrollmentFormType[EnrollmentFormType["EMPLOYER_APPLICATION"] = 6] = "EMPLOYER_APPLICATION";
    EnrollmentFormType[EnrollmentFormType["HRA"] = 7] = "HRA";
})(EnrollmentFormType || (EnrollmentFormType = {}));
class EnrollmentFormTypeUtillity {
    static toApiKeyName(formType) {
        let apiFormType;
        switch (formType) {
            case 0:
                apiFormType = 'LongForm';
                break;
            case 1:
                apiFormType = 'ShortForm';
                break;
            case 2:
                apiFormType = 'Waiver';
                break;
            case 3:
                apiFormType = 'Disenrollment';
                break;
            case 4:
                apiFormType = 'IntakeForm';
                break;
            case 6:
                apiFormType = 'EmployerApplication';
                break;
            case 7:
                apiFormType = 'HRAForm';
                break;
            default:
                apiFormType = '';
        }
        return apiFormType;
    }
}

// We have a lot of instances where variable names start with a capital to match with API expectations/results
// Since we have so many of those for enrollment, it makes sense to disable it to have better sight on other warnings
/**
 * The format for creating an initial enrollment transaction
 */
class EnrollmentTransactionRequest {
    // static factories to imply usage
    // TODO: hoping to eventually move some cross cutting functionality to these
    static createInitialTransaction(customInternal) {
        const initialTransaction = new EnrollmentTransactionRequest();
        initialTransaction.customInternal = customInternal;
        return initialTransaction;
    }
    static createUpdateTransaction(pageIndex, answers, formType, langID) {
        const updateTransaction = new EnrollmentTransactionRequest();
        updateTransaction.pageIndex = pageIndex;
        updateTransaction.answers = answers;
        updateTransaction.formType = formType;
        if (langID) {
            updateTransaction.langID = langID;
        }
        return updateTransaction;
    }
}
class Answer {
    constructor(name, value) {
        this.name = name;
        this.value = value;
    }
}
class CIFormInfo {
}
class DynamicData {
}
class StoringData {
}
class FormControlSetting {
}
class FormControlSettings {
}
class FOAMConfig {
}
class MedSupLockConfiguration {
}
class NextGenMedSupLockConfiguration {
}
class CustomInternal {
}
class CustomInternalWrapper {
}
var EnrollSystemType;
(function (EnrollSystemType) {
    EnrollSystemType[EnrollSystemType["OAM"] = 1] = "OAM";
    EnrollSystemType[EnrollSystemType["FOAM"] = 2] = "FOAM";
    EnrollSystemType[EnrollSystemType["PlatformToFOAM"] = 3] = "PlatformToFOAM";
    EnrollSystemType[EnrollSystemType["NextGen"] = 4] = "NextGen";
})(EnrollSystemType || (EnrollSystemType = {}));
var CoverageTypeEvent;
(function (CoverageTypeEvent) {
    CoverageTypeEvent["FULL_ENROLLMENT"] = "FULL_ENROLLMENT";
    CoverageTypeEvent["SOA"] = "SOA";
    CoverageTypeEvent["SOA_TEXT"] = "SOA_TEXT";
    CoverageTypeEvent["RENEWAL_ENROLLMENT"] = "RENEWAL_ENROLLMENT";
    CoverageTypeEvent["WAIVER"] = "WAIVER";
    CoverageTypeEvent["DISENROLLMENT"] = "DISENROLLMENT";
    CoverageTypeEvent["INTAKE"] = "INTAKE";
    CoverageTypeEvent["EMPLOYER_APPLICATION"] = "EMPLOYER_APPLICATION";
    CoverageTypeEvent["SOA_AGENT"] = "SOAAgent";
    CoverageTypeEvent["SOA_AGENT_PHONE"] = "SOAAgent_Phone";
})(CoverageTypeEvent || (CoverageTypeEvent = {}));
var FOAMHtmlDirectives;
(function (FOAMHtmlDirectives) {
    FOAMHtmlDirectives["IGNORE_FIELD"] = "SPAIgnoreHopeInput";
})(FOAMHtmlDirectives || (FOAMHtmlDirectives = {}));
var UserTypes;
(function (UserTypes) {
    UserTypes["ALL"] = "all";
    UserTypes["CALLCENTER"] = "callcenter";
    UserTypes["CONSUMER"] = "consumer";
    UserTypes["BROKER"] = "broker";
})(UserTypes || (UserTypes = {}));
var SOAUserType;
(function (SOAUserType) {
    SOAUserType["CONSUMER"] = "Consumer";
    SOAUserType["BROKER"] = "Agent";
    SOAUserType["BOTH"] = "Both";
})(SOAUserType || (SOAUserType = {}));
var SOAFormPage;
(function (SOAFormPage) {
    SOAFormPage["CONSUMER"] = "Consumer";
    SOAFormPage["AGENT"] = "Agent";
    SOAFormPage["OTHER"] = "Other";
})(SOAFormPage || (SOAFormPage = {}));
var UserTypeKeys;
(function (UserTypeKeys) {
    UserTypeKeys[UserTypeKeys["ALL"] = 0] = "ALL";
    UserTypeKeys[UserTypeKeys["CALLCENTER"] = 1] = "CALLCENTER";
    UserTypeKeys[UserTypeKeys["CONSUMER"] = 2] = "CONSUMER";
    UserTypeKeys[UserTypeKeys["BROKER"] = 3] = "BROKER";
    UserTypeKeys[UserTypeKeys["BROKER_SIGN_AND_SUBMIT"] = 4] = "BROKER_SIGN_AND_SUBMIT";
})(UserTypeKeys || (UserTypeKeys = {}));
const RECORDING_AVAILABLE_FORM_ANSWER = 'RecordingAvailable';
var CallRecordingAvailability;
(function (CallRecordingAvailability) {
    CallRecordingAvailability["AVAILABLE"] = "REC";
    CallRecordingAvailability["NONE"] = "";
})(CallRecordingAvailability || (CallRecordingAvailability = {}));
class UserTypeSettings {
}
class EnrollmentPDFResponse {
}
class MemberEnrollmentFile {
}
var EnrollmentType;
(function (EnrollmentType) {
    EnrollmentType["INTERNAL"] = "Internal";
    EnrollmentType["EXTERNAL"] = "External";
    EnrollmentType["MESSAGE_ONLY"] = "Message Only";
})(EnrollmentType || (EnrollmentType = {}));
var CustomUrlEvent;
(function (CustomUrlEvent) {
    CustomUrlEvent["USAA_ENROLLMENT"] = "event://Drx:Platform:Enrollment:USAAEnrollment;";
})(CustomUrlEvent || (CustomUrlEvent = {}));
class EnrollmentRequest {
}
class NextGenEnrollmentSettings {
}
class StandaloneEnrollmentSettings {
}
class NextGenEnrollmentConfigurations {
}
class NextGenEnrollmentSite {
}
class NextGenEnrollmentAgent {
}
class NextGenEnrollmentRequest {
}
class NextGenEnrollmentMedigapAnswers {
}
var CoverageEventType;
(function (CoverageEventType) {
    // Flag indicating that this is a "Full" enrollment using the long form.
    CoverageEventType[CoverageEventType["FullEnrollment"] = 0] = "FullEnrollment";
    // Flag indicating that this is a "Renewal" enrollment using the short form.
    CoverageEventType[CoverageEventType["RenewalEnrollment"] = 1] = "RenewalEnrollment";
    // Flag indicating that this is a "Waiver" enrollment - the beneficiary has chosen to forgo coverage.
    CoverageEventType[CoverageEventType["Waiver"] = 2] = "Waiver";
    // Flag indicating that this is a Dis-enrollment.
    CoverageEventType[CoverageEventType["Disenrollment"] = 3] = "Disenrollment";
    // Flag indicating that this is a Scope of Appointment (SOA) form.
    CoverageEventType[CoverageEventType["SOA"] = 4] = "SOA";
    // Flag indicating that this is a IFP Agent/Broker Intake Form.
    CoverageEventType[CoverageEventType["Intake"] = 5] = "Intake";
    // Flag indicating that this is a Employer Application Form.
    CoverageEventType[CoverageEventType["EmployerApplication"] = 6] = "EmployerApplication";
    // Flag indicating that this is a Scope of Appointment (SOA) form started fom text.
    CoverageEventType[CoverageEventType["SOAText"] = 7] = "SOAText";
    // Flag indicating that this is a HRA Form.
    CoverageEventType[CoverageEventType["HRA"] = 8] = "HRA";
    // Flag indicating that this is a AncillaryGeneric Form.
    CoverageEventType[CoverageEventType["AncillaryGeneric"] = 9] = "AncillaryGeneric";
    // Flag indicating that this is a Generic Form.
    CoverageEventType[CoverageEventType["Generic"] = 10] = "Generic";
    // Flag indicating that this SOA Form was completed by an Agent.
    CoverageEventType[CoverageEventType["SOAAgent"] = 11] = "SOAAgent";
    // Flag indicating that this SOA Form was completed by an Agent by phone.
    CoverageEventType[CoverageEventType["SOAAgent_Phone"] = 12] = "SOAAgent_Phone";
})(CoverageEventType || (CoverageEventType = {}));
class NextGenCompleteEnrollmentRequest {
}
class NextGenEnrollmentSession {
}
class NextGenEnrollmentSEPReasons {
}
class SEPGroup {
}
class SEPReason {
}
var AgentCallRecordingEnrollmentType;
(function (AgentCallRecordingEnrollmentType) {
    AgentCallRecordingEnrollmentType["ENROLLMENT"] = "Enrollment";
    AgentCallRecordingEnrollmentType["SOA"] = "SOA";
})(AgentCallRecordingEnrollmentType || (AgentCallRecordingEnrollmentType = {}));
class AgentCallRecording {
}
class EnrollmentRequestConfig {
}
// Preference information for Enrollment PDF.
class PreferencesJson {
}
class PreferencesEnrollmentRequest {
}
class MemberEnrollmentSummary {
}
class AgentEnrollmentSummary {
}
class PreferencesEnrollmentRequestItem {
}
class PreferencesEnrollmentSection {
}
class PreferencesEnrollmentItems {
}
class PreferencesEnrollmentItem {
}
var PreferenceSectionFormKey;
(function (PreferenceSectionFormKey) {
    PreferenceSectionFormKey["GENERAL"] = "General";
    PreferenceSectionFormKey["PRESCRIPTIONS"] = "Prescriptions";
    PreferenceSectionFormKey["PHARMACIES"] = "Pharmacies";
    PreferenceSectionFormKey["PROVIDERS"] = "Providers";
    PreferenceSectionFormKey["IP_ADDRESS"] = "IPAddress";
})(PreferenceSectionFormKey || (PreferenceSectionFormKey = {}));
var PreferencesFieldFormKey;
(function (PreferencesFieldFormKey) {
    PreferencesFieldFormKey["COVERAGE_TYPE"] = "CoverageType";
    PreferencesFieldFormKey["EXTRA_HELP"] = "ExtraHelp";
    PreferencesFieldFormKey["AGE_RANGE"] = "AgeRange";
    PreferencesFieldFormKey["DRUG_NAME"] = "DrugName";
    PreferencesFieldFormKey["BRAND_OR_GENERIC"] = "BrandOrGeneric";
    PreferencesFieldFormKey["DOSE_AND_FORM"] = "DoseAndForm";
    PreferencesFieldFormKey["QUANTITY_AND_FREQUENCY"] = "QuantityAndFrequency";
    PreferencesFieldFormKey["PACKAGE"] = "Package";
    PreferencesFieldFormKey["TIER_DESCRIPTION"] = "TierDescription";
    PreferencesFieldFormKey["PHARMACY_NAME"] = "PharmacyName";
    PreferencesFieldFormKey["PHARMACY_ADDRESS"] = "PharmacyAddress";
    PreferencesFieldFormKey["PHARMACY_ADDRESS2"] = "PharmacyAddress2";
    PreferencesFieldFormKey["PHARMACY_CITY_STATE_ZIP"] = "PharmacyCityStateZip";
    PreferencesFieldFormKey["PHARMACY_STATUS"] = "PharmacyStatus";
    PreferencesFieldFormKey["PROVIDER_NAME"] = "ProviderName";
    PreferencesFieldFormKey["PROVIDER_SPECIALTY"] = "ProviderSpecialty";
    PreferencesFieldFormKey["PROVIDER_PHONE_NUMBER"] = "ProviderPhoneNumber";
    PreferencesFieldFormKey["PROVIDER_ADDRESS"] = "ProviderAddress";
    PreferencesFieldFormKey["PROVIDER_ADDRESS2"] = "ProviderAddress2";
    PreferencesFieldFormKey["PROVIDER_CITY_STATE_ZIP"] = "ProviderCityStateZip";
    PreferencesFieldFormKey["PROVIDER_NETWORK_STATUS"] = "ProviderNetworkStatus";
    PreferencesFieldFormKey["IP_ADDRESS"] = "IPAddress";
    PreferencesFieldFormKey["SUBMITTED_BY"] = "SubmittedBy";
})(PreferencesFieldFormKey || (PreferencesFieldFormKey = {}));
var CrossSellEnrollmentTypes;
(function (CrossSellEnrollmentTypes) {
    CrossSellEnrollmentTypes["BOTH_INTERNAL"] = "Both Internal";
    CrossSellEnrollmentTypes["BOTH_EXTERNAL"] = "Both External";
    CrossSellEnrollmentTypes["BOTH_MESSAGE"] = "Both Message";
    CrossSellEnrollmentTypes["ONE_INTERNAL"] = "One Internal";
    CrossSellEnrollmentTypes["EXTERNAL_AND_MESSAGE"] = "External and Message";
    CrossSellEnrollmentTypes["NOT_CROSSSELL"] = "N/A";
})(CrossSellEnrollmentTypes || (CrossSellEnrollmentTypes = {}));
var CrossSellSendToBeneficiaryOptions;
(function (CrossSellSendToBeneficiaryOptions) {
    CrossSellSendToBeneficiaryOptions["BOTH_SENDTOBENE"] = "Both Send To Beneficiary";
    CrossSellSendToBeneficiaryOptions["ONE_SENDTOBENE"] = "One Send To Beneficiary";
    CrossSellSendToBeneficiaryOptions["NO_SENDTOBENE"] = "No Send To Beneficiary";
})(CrossSellSendToBeneficiaryOptions || (CrossSellSendToBeneficiaryOptions = {}));
class CrossSellPlanEnrollmentAttributes {
}
var EnrollmentFormErrors;
(function (EnrollmentFormErrors) {
    EnrollmentFormErrors["PLAN_NOT_IN_CART"] = "plan not in cart";
    EnrollmentFormErrors["UNKNOWN"] = "unknown";
})(EnrollmentFormErrors || (EnrollmentFormErrors = {}));
var EnrollmentUserType;
(function (EnrollmentUserType) {
    EnrollmentUserType["CONSUMER"] = "Consumer";
    EnrollmentUserType["BROKER"] = "Broker";
    EnrollmentUserType["CALL_CENTER"] = "CallCenter"; // TODO: Get confirmation from API on the exact value for this
})(EnrollmentUserType || (EnrollmentUserType = {}));
const PREPOPULATED_READONLY_CUSTOM_CLASS = 'prepopulatedDataEdit_profile';
class SessionExternalEnrollment {
}
class EnrollmentFormModel {
}
class EnrollmentForm {
}
class NextGenEnrollmentFormTransaction {
}
class NextGenTransactionExternalEnrollmentData {
}
class EnrollmentStateModel {
}
class FormVersionIdState {
}
class CreateTransactionHRAData {
}
class ExpirePartialPayload {
}

var SOATransactionEventType;
(function (SOATransactionEventType) {
    SOATransactionEventType["TEXT"] = "TEXT";
    SOATransactionEventType["EMAIL"] = "EMAIL";
    SOATransactionEventType["IN_PERSON"] = "IN PERSON";
    SOATransactionEventType["BY_PHONE"] = "BY PHONE";
})(SOATransactionEventType || (SOATransactionEventType = {}));
const SOA_COVERAGE_TYPE_EVENTS = [
    CoverageTypeEvent.SOA,
    CoverageTypeEvent.SOA_TEXT,
    CoverageTypeEvent.SOA_AGENT,
    CoverageTypeEvent.SOA_AGENT_PHONE
];
class SendSOAForm {
}
class SendSOAResult {
}

class SelectZipCode {
    constructor(zip) {
        this.zip = zip;
    }
}
SelectZipCode.type = '[Demographic] Select Zip';
class SetDemographicLoading {
    constructor(loadingState) {
        this.loadingState = loadingState;
    }
}
SetDemographicLoading.type = '[Demographic] Set Loading';
class SelectFIPS {
    constructor(fips) {
        this.fips = fips;
    }
}
SelectFIPS.type = '[Demographic] Select FIPS';
class FetchCountyData {
    constructor(zip) {
        this.zip = zip;
    }
}
FetchCountyData.type = '[Demographic] Fetch County Data';
class SelectSubsidySelected {
    constructor(subsidySelected) {
        this.subsidySelected = subsidySelected;
    }
}
SelectSubsidySelected.type = '[Demographic] Select Subsidy Selected';
class SelectSubsidyPercent {
    constructor(subsidyPercent) {
        this.subsidyPercent = subsidyPercent;
    }
}
SelectSubsidyPercent.type = '[Demographic] Select Subsidy Percent';
class ResetDemographicState {
}
ResetDemographicState.type = '[Demographic] Reset';
class SetAgeRange {
    constructor(ageRange) {
        this.ageRange = ageRange;
    }
}
SetAgeRange.type = '[Demographic] Set Age Range';
class SetHealthStatus {
    constructor(healthStatus) {
        this.healthStatus = healthStatus;
    }
}
SetHealthStatus.type = '[Demographic] Set Health Status';
class UpdateDemographics {
    constructor(demographics) {
        this.demographics = demographics;
    }
}
UpdateDemographics.type = '[Demographic] Update Demographics';
class UpdateDemographicSession {
    constructor(sessionId) {
        this.sessionId = sessionId;
    }
}
UpdateDemographicSession.type = '[Demographic] Update Demographic Session';
class SelectZipAndFIPS {
    constructor(zip, fips) {
        this.zip = zip;
        this.fips = fips;
    }
}
SelectZipAndFIPS.type = '[Demographic] Select Zip and FIPS';

class SetZipCode {
    constructor(zip) {
        this.zip = zip;
    }
}
SetZipCode.type = '[HelpfulTools] Set Zip Code';
class SetFipsCode {
    constructor(fips) {
        this.fips = fips;
    }
}
SetFipsCode.type = '[HelpfulTools] Set Fips Code';
class SetLocation {
    constructor(zip, fips) {
        this.zip = zip;
        this.fips = fips;
    }
}
SetLocation.type = '[HelpfulTools] Set Location';
class SetPlan {
    constructor(plan) {
        this.plan = plan;
    }
}
SetPlan.type = '[HelpfulTools] Set Plan';
class SetCountiesAndZipSelection {
    constructor(counties, countyZipSelection) {
        this.counties = counties;
        this.countyZipSelection = countyZipSelection;
    }
}
SetCountiesAndZipSelection.type = '[HelpfulTools] Set Counties and Zip Selection';
class FetchCounties {
    constructor(zip) {
        this.zip = zip;
    }
}
FetchCounties.type = '[HelpfulTools] Fetch Counties';
class SetPlansFetched {
    constructor(isPlansFetched) {
        this.isPlansFetched = isPlansFetched;
    }
}
SetPlansFetched.type = '[HelpfulTools] Set Plans Fetched';
class SetCurrentTab {
    constructor(tab) {
        this.tab = tab;
    }
}
SetCurrentTab.type = '[HelpfulTools] Set Current Tab';
class ResetHelpfulTools {
}
ResetHelpfulTools.type = '[HelpfulTools] Reset';

class DemographicHttpService {
    constructor(http, authService) {
        this.http = http;
        this.authService = authService;
    }
    retrieveCounties$(zipCode) {
        const headers = new HttpHeaders({
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        const environment = EnvironmentService.getEnvironment();
        if (!this.authService.isCurrentTokenValid()) {
            // Normally handled by the interceptor but the zip input is designed in such a way that if this fails the input
            // locks up until you manually clear it. As a result adding an additional check here until the zip input is refactored
            return this.authService
                .loadJWT$()
                .pipe(switchMap(() => this.http.get(`${environment.WEB_SERVICE_BASE_URL}/v1/counties/${zipCode}`, { headers })));
        }
        return this.http.get(`${environment.WEB_SERVICE_BASE_URL}/v1/counties/${zipCode}`, { headers });
    }
    async retrieveCounties(zipCode) {
        return this.retrieveCounties$(zipCode).toPromise();
    }
}
DemographicHttpService.ɵfac = function DemographicHttpService_Factory(t) { return new (t || DemographicHttpService)(i0.ɵɵinject(i1$2.HttpClient), i0.ɵɵinject(AuthService)); };
DemographicHttpService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DemographicHttpService, factory: DemographicHttpService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DemographicHttpService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1$2.HttpClient }, { type: AuthService }]; }, null); })();

const VOICE_SIGNATURE_ENROLLMENT_REQUEST_LABEL = 'Voice Signature';
class MemberSessionHttpService {
    constructor(http) {
        this.http = http;
        this.environment = EnvironmentService.getEnvironment();
        this.sessionUri = `${this.environment.WEB_SERVICE_BASE_URL}/v1/Session`;
    }
    /**
     * Create a new initial/blank member session
     * @returns an observable of the http post request
     */
    createAnonymousSession$() {
        return this.http.post(this.environment.MEMBER_SESSION_BASE_URL, {
        // no body needed on initial pass. we want a blank session
        });
    }
    createSession$(sessionData, memberId) {
        let options = {};
        if (memberId) {
            options = { params: { memberId } };
        }
        return this.http.post(`${this.environment.MEMBER_SESSION_BASE_URL}`, {
            ...sessionData
        }, options);
    }
    /**
     * Create a new full member session with provided data
     */
    registerNewAccount$(sessionId, accountData) {
        return this.http.post(`${this.environment.MEMBER_SESSION_BASE_URL}/${sessionId}/Register`, {
            ...accountData,
            passwordRegex: `${accountData.passwordRegex}`
        });
    }
    /**
     * Create a new full member session with provided data
     */
    async registerNewAccount(sessionId, accountData) {
        await firstValueFrom(this.registerNewAccount$(sessionId, accountData));
    }
    // retrieve a previously saved session
    fetchSession$(fetchMemberOptions) {
        if (fetchMemberOptions) {
            const params = new HttpParams()
                .set('isRetentionSession', `${!!(fetchMemberOptions.isRetentionView && !fetchMemberOptions.currentYearPlanId)}`)
                .set('includeEnrollmentHistory', `${!!fetchMemberOptions.isEnrollmentHistoryIncluded}`)
                .set('includeLastAccessedHistory', `${!!fetchMemberOptions.includeLastAccessedHistory}`)
                .set('includeSOA', `${!!fetchMemberOptions.includeSOA}`)
                .set('includeAgentCallHistory', `${!!fetchMemberOptions.includeAgentCallHistory}`)
                .set('includeMemberProgress', `${!!fetchMemberOptions.includeMemberProgress}`);
            return this.http.get(`${this.environment.MEMBER_SESSION_BASE_URL}/${fetchMemberOptions.sessionId}`, { params });
        }
        return of(null);
    }
    /**
     * Takes member session along with ssovalue and create session if user does not exist.
     * If user exist it will update user session with passed data.
     */
    createOrUpdateSessionWithSSOID$(memberSession) {
        return this.http.post(`${this.environment.MEMBER_SESSION_BASE_URL}`, memberSession);
    }
    /**
     * Tie sso with member
     */
    createSessionWithSSO$(sessionId, memberSession) {
        return this.http.post(`${this.sessionUri}?SessionId=${sessionId}`, memberSession);
    }
    fetchBeanProviderSettings$(sessionId, enrollmentSettingsParams) {
        return this.http.post(`${this.environment.MEMBER_SESSION_BASE_URL}/${sessionId}/BeanProvider`, {
            ...enrollmentSettingsParams
        });
    }
    fetchExternalHRALink$(sessionId, linkParams) {
        return this.http.post(`${this.environment.MEMBER_SESSION_BASE_URL}/${sessionId}/ExternalHRA`, {
            ...linkParams
        });
    }
    // update our existing session
    updateSession$(sessionId, updatedSession) {
        return this.http.post(`${this.environment.MEMBER_SESSION_BASE_URL}/${sessionId}`, {
            ...updatedSession
        });
    }
    /**
     * Update Session with agent note
     *
     * @param sessionId- session id of the session
     * @param memberAgentNotes- memberAgentNotes object
     *
     */
    createAgentNoteTask$(sessionId, memberAgentNotes) {
        return this.http.post(`${this.environment.MEMBER_SESSION_BASE_URL}/${sessionId}/AgentNote`, {
            userAgentGUID: memberAgentNotes.userAgentGUID,
            agentNoteActionType: memberAgentNotes.agentNoteActionType,
            description: memberAgentNotes.description,
            scheduledDate: memberAgentNotes.scheduledDate,
            completedWhen: memberAgentNotes.completedWhen,
            memberAgentNoteID: memberAgentNotes.memberAgentNoteID
        });
    }
    /**
     * Create quote and return auth code with querystring
     * @param sessionId - session id of the session
     * @param quote - quote object
     */
    createQuote$(sessionId, quote) {
        return this.http.post(`${this.sessionUri}/${sessionId}/Quote`, quote);
    }
    /**
     * Delete Select Rx Task with id
     *
     * @param sessionId- session id of the session
     * @param memberAgentNotes- memberAgentNotes object
     *
     */
    deleteSelectRxTask$(sessionId, memberAgentNotes) {
        return this.http.post(`${this.environment.MEMBER_SESSION_BASE_URL}/${sessionId}/DeleteSelectRxTask`, {
            memberAgentNoteID: memberAgentNotes.memberAgentNoteID
        });
    }
    /**
     * Update Session with agent note id to complete a task
     *
     * @param sessionId- session id of the session
     * @param agentNoteID- agentNote id to update the agent task
     * @param memberAgentNotes- memberAgentNotes object
     *
     */
    updateAgentNoteTask$(sessionId, agentNoteID, memberAgentNotes) {
        return this.http.post(`${this.environment.MEMBER_SESSION_BASE_URL}/${sessionId}/AgentNote/${agentNoteID}`, {
            completedWhen: memberAgentNotes.completedWhen
        });
    }
    updateAgentNoteTaskByTypes$(sessionId, noteTypes) {
        return this.http.post(`${this.environment.MEMBER_SESSION_BASE_URL}/${sessionId}/AgentNote/CloseTasks`, {
            AssociatedActionTypes: noteTypes
        });
    }
    // create a session given username password combination - Nova: LoginMember/LoginResult
    userNameAuthenticate$(userName, password) {
        return this.http.post(this.sessionUri, {
            UserName: userName,
            Password: password,
            AuthenticationType: "login" /* AuthType.LOGIN */
        });
    }
    // create a session using PIN and DOB, or using accountGuid when logging in from enrollment email - Nova: LoginAuthorization/AuthorizationResult
    pinAuthenticate$(authInfo, authType, TotpCode) {
        return this.http.post(this.sessionUri, {
            PINAuthenticationInfo: authInfo,
            AuthenticationType: authType,
            ...(TotpCode && { TotpCode })
        });
    }
    // create a session using PIN and DOB - Nova: LoginAuthorization/AuthorizationResult
    ssoAuthenticate$(ssoInfo, newMemberInfo) {
        const { ssoValue, ssoName, ssoZipCode } = ssoInfo;
        // TODO: add sso zip code
        return this.http.post(this.sessionUri, {
            ...newMemberInfo,
            // If we're making an sso request with both ssoValue and beneFirst/LastName, we do need to include that data here
            // As this request creates us a memberId, and not having the data at the point causes errors
            ...(ssoName && { ssoName }),
            ...(ssoValue && { ssoValue }),
            ...(ssoZipCode && { demographics: { zip: ssoZipCode } }) // TODO: test me
        });
    }
    // attempts to get user login information, returns data containing sessionId, expiration data, and status if successful
    retrieveMemberLoginToken$(userName, password, authType = "login" /* AuthType.LOGIN */, authInfo, newMemberInfo, totpCode) {
        if (authType === "pin" /* AuthType.PIN */ || authType === "totp" /* AuthType.TOTP */) {
            return this.pinAuthenticate$(authInfo.pinInfo, authType, totpCode);
        }
        if (authType === "sso" /* AuthType.SSO */) {
            return this.ssoAuthenticate$(authInfo.ssoInfo, newMemberInfo);
        }
        // Default case.
        return this.userNameAuthenticate$(userName, password);
    }
    createSOASession$(authInfo, authType, agentGuid, isSecurityDOBEnabled, dateOfBirth) {
        return this.http.post(this.sessionUri, {
            PINAuthenticationInfo: authInfo,
            AuthenticationType: authType,
            agentGuid,
            ...(isSecurityDOBEnabled && dateOfBirth && { Profile: { Birthdate: dateOfBirth } })
        });
    }
    async createSOASession(authInfo, authType, agentGuid, isSecurityDOBEnabled, dateOfBirth) {
        return await firstValueFrom(this.createSOASession$(authInfo, authType, agentGuid, isSecurityDOBEnabled, dateOfBirth), {
            defaultValue: undefined
        });
    }
    createQuoteSession$(authInfo, authType, quoteId, agentGuid, quoteType, showCurrentMonthMedigapQuote, isSecurityDOBEnabled, dateOfBirth) {
        return this.http.post(this.sessionUri, {
            PINAuthenticationInfo: authInfo,
            AuthenticationType: authType,
            quoteId,
            agentGuid,
            showCurrentMonthMedigapQuote,
            ...(quoteType && { quoteType }),
            ...(isSecurityDOBEnabled && dateOfBirth && { Profile: { Birthdate: dateOfBirth } })
        });
    }
    async createQuoteSession(authInfo, authType, quoteId, agentGuid, quoteType, showCurrentMonthMedigapQuote, isSecurityDOBEnabled, dateOfBirth) {
        return await firstValueFrom(this.createQuoteSession$(authInfo, authType, quoteId, agentGuid, quoteType, showCurrentMonthMedigapQuote, isSecurityDOBEnabled, dateOfBirth));
    }
    async retrieveMemberLoginToken(userName, password, authType, authInfo, newMemberInfo, totpCode) {
        return await firstValueFrom(this.retrieveMemberLoginToken$(userName, password, authType, authInfo, newMemberInfo, totpCode));
    }
    getMemberQuoteHistory$(id, agentGuid, planYear, medSupQuoteMonthsLimit) {
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v1/quote/member/${id}?agentGuid=${agentGuid || null}&planYear=${planYear}&medSupQuoteMonthsLimit=${medSupQuoteMonthsLimit}`);
    }
    async getMemberQuoteHistory(id, agentGuid, planYear, medSupQuoteMonthsLimit) {
        return await firstValueFrom(this.getMemberQuoteHistory$(id, agentGuid, planYear, medSupQuoteMonthsLimit), { defaultValue: [] });
    }
    getMemberQuotes$(sessionId) {
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v1/session/${sessionId}/quotes`);
    }
    async getMemberQuotes(sessionId) {
        return await firstValueFrom(this.getMemberQuotes$(sessionId), { defaultValue: [] });
    }
    getMemberDashboardNotes$(agentGuid, includeAgentNotes) {
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Agent/${agentGuid}?currentAgentId=${agentGuid}&includeAgentNotes=${includeAgentNotes}`);
    }
    getMemberSession$(sessionId) {
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v1/session/${sessionId}`);
    }
    getEnrollmentStatuses$(sessionId) {
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Session/${sessionId}/EnrollmentStatuses`);
    }
    getCompleteEnrollmentsStatuses$(sessionId) {
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Session/${sessionId}/CompletedEnrollmentHistory`);
    }
    /**
     * End API to get the enrolled application PDF with first page including broker info if applicable along with plan and member info.
     * @param sessionId - session id of the session.
     * @param transactionId - transactionId of enrolled transaction.
     * @param hidePdfAgentData - indicator whether to hide agent data from enrollment pdf.
     * @returns an observable of string which can be converted to pdf.
     */
    getGeneratedEnrollmentApplicationPDF$(sessionId, transactionId, locale = 'en-US', hidePdfAgentData = false) {
        return this.http
            .get(`${this.environment.MEMBER_SESSION_BASE_URL}/${sessionId}/Transaction/${transactionId}/GeneratePDF?language=${locale}&HideAgentData=${hidePdfAgentData}`)
            .pipe(map(response => response.PDF));
    }
    /**
     * End API to get the enrolled nextgen application PDF with first page including broker info if applicable along with plan and member info.
     * @param sessionId - session id of the session.
     * @param transactionGuid - transactionGuid of enrolled transaction.
     * @param hidePdfAgentData - indicator whether to hide agent data from enrollment pdf.
     * @returns an observable of string which can be converted to pdf.
     */
    getGeneratedNextGenEnrollmentApplicationPDF$(sessionId, transactionGuid, locale = 'en-US', hidePdfAgentData = false) {
        return this.http
            .get(`${this.environment.WEB_SERVICE_BASE_URL}/v2/Session/${sessionId}/Transaction/${transactionGuid}/GeneratePDF?language=${locale}&HideAgentData=${hidePdfAgentData}`)
            .pipe(map(response => response.PDF));
    }
    /**
     * Update the enrollment userForm type in session.
     * @param sessionId - session id of the session
     * @param transactionGuid - enrollment form transaction Guid (long format)
     * @param userType - userType as userType key value
     */
    updateEnrollmentUserType$(sessionId, transactionGuid, userType) {
        return this.http.post(`${this.environment.MEMBER_SESSION_BASE_URL}/${sessionId}/EnrollmentUserType`, {
            transactionGuid,
            userType
        });
    }
    async updateEnrollmentUserType(sessionId, transactionGuid, userType) {
        return await firstValueFrom(this.updateEnrollmentUserType$(sessionId, transactionGuid, userType));
    }
    /**
     * Update the Total cost effective date of user in session.
     * @param sessionId - session id of the session
     * @param totalCostEffectiveDate - Total cost effective date
     */
    updateTotalCostEffectiveDate$(sessionId, totalCostEffectiveDate) {
        const params = new HttpParams().set('TotalCostEffectiveDate', totalCostEffectiveDate);
        return this.http.post(`${this.sessionUri}/${sessionId}/TotalCostEffectiveDate`, null, { params, observe: 'response' });
    }
    async updateTotalCostEffectiveDate(sessionId, totalCostEffectiveDate) {
        return await firstValueFrom(this.updateTotalCostEffectiveDate$(sessionId, totalCostEffectiveDate));
    }
    getSessionByUniqueCode$(uniqueCode, agentGuid) {
        const params = new HttpParams().set('SessionId', uniqueCode);
        return this.http.post(`${this.environment.MEMBER_SESSION_BASE_URL}`, { agentGuid }, { params });
    }
    getSessionBySessionId$(sessionId, agentGuid) {
        const params = new HttpParams().set('SessionId', sessionId);
        return this.http.post(`${this.environment.MEMBER_SESSION_BASE_URL}`, { agentGuid }, { params });
    }
    getSessionBySSOCode$(ssoValue, agentGuid) {
        return this.http.post(`${this.environment.MEMBER_SESSION_BASE_URL}`, { agentGuid, ssoValue });
    }
    getMedicalCostDefault$(ageRange, healthStatus) {
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v1/MedicalCost/GetDefaults?ageRange=${ageRange}&healthStatus=${healthStatus}`);
    }
    getMedicalCosts$(sessionId) {
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v1/session/${sessionId}/MedicalCostCabinet`);
    }
    async getMedicalCosts(sessionId) {
        return await firstValueFrom(this.getMedicalCosts$(sessionId), { defaultValue: [] });
    }
    saveMedicalCosts$(medicalCost, sessionId) {
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/session/${sessionId}/MedicalCostCabinet`, medicalCost);
    }
    updateFavoriteSupplementalBenefits$(favoriteBenefits, sessionId) {
        const payload = { favoriteBenefits };
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/session/${sessionId}/UserPreferences`, payload);
    }
    saveEstimateHealthCost$(estimateHealthCost, sessionId) {
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/session/${sessionId}`, {
            demographic: { estimateHealthCost }
        });
    }
    checkMemberEligibility$(checkEligibilityPayload) {
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v2/Enroll/MemberEligibility`, checkEligibilityPayload);
    }
    checkMedicaidEligibility$(medicaidEligibilityPayload, sessionId) {
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/session/${sessionId}/MedicaidEligibility`, medicaidEligibilityPayload);
    }
    assignPrimaryAgent$(assigningAgentGuid, assignPrimaryAgentGuid, sessionId) {
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/session/${sessionId}/AssignPrimaryAgent/${assignPrimaryAgentGuid}`, { assigningAgentGuid });
    }
    reassignAgentForBeneficiary$(assigningAgentGuid, agentGuid, sessionId) {
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/session/${sessionId}/ReassignAgentForBeneficiaries/${agentGuid}`, { assigningAgentGuid });
    }
    reassignSelectRxTask$(memberAgentNoteID, userAgentGUID, sessionId) {
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/session/${sessionId}/ReassignSelectRxTask`, {
            memberAgentNoteID,
            userAgentGUID
        });
    }
    updateMemberProgress$(sessionId, memberProgressEvent) {
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/session/${sessionId}/UpdateMemberProgress?memberProgressEvent=${memberProgressEvent}`, {});
    }
    saveVoiceSignatureStatements$(sessionId, transactionGuid, voiceSignatureSections, locale) {
        const rootPreferences = this.mapToRootPreferencesJSON(voiceSignatureSections, locale);
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/session/${sessionId}/Enroll/${transactionGuid}/Preferences`, {
            preferencesJSON: rootPreferences
        });
    }
    mapToRootPreferencesJSON(voiceSignatureSections, locale) {
        const sections = voiceSignatureSections.map(voiceSignatureSection => ({
            _label: voiceSignatureSection.sectionName,
            items: this.createVoiceSignatureItems(voiceSignatureSection)
        }));
        const preferences = {
            _label: VOICE_SIGNATURE_ENROLLMENT_REQUEST_LABEL,
            _lang: locale,
            sections
        };
        return JSON.stringify({ root: { preferences: [preferences] } });
    }
    createVoiceSignatureItems(voiceSignatureSection) {
        return [
            {
                item: voiceSignatureSection.statements.map(statement => ({
                    _label: statement.value
                }))
            }
        ];
    }
    createAuthorizationCode$(sessionId, agentGuid, transactionGuid, deliverySettings) {
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Session/${sessionId}/CreateAuth`, {
            agentGuid,
            transactionGuid,
            deliverySettings
        });
    }
    validateAuthorizationCode$(sessionId, agentGuid, transactionGuid, authCode) {
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Session/${sessionId}/ValidateAuth`, {
            agentGuid,
            transactionGuid,
            authCode
        });
    }
    sendRetireFloSurvey$(sessionId, sendRetireFloSurvey) {
        return this.http.post(`${this.sessionUri}/${sessionId}/SendRetireFlo`, sendRetireFloSurvey);
    }
    getRetireFloSurvey$(sessionId, agentGuid, memberId, message) {
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Session/${sessionId}/GetRetireFloSurveyLink`, {
            sessionId,
            agentGuid,
            memberId,
            message
        });
    }
    updateMemberArchiveStatus$(sessionId, isArchived, memberId) {
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Session/${sessionId}/UpdateMemberArchiveStatus`, {
            isArchived,
            memberId
        });
    }
    getMemberNotifications$(sessionId) {
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v1/${sessionId}/MemberNotifications`);
    }
    createMemberNotification$(sessionId, payload) {
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/${sessionId}/MemberNotifications`, payload);
    }
    updateMemberNotification$(sessionId, notificationId, payload) {
        return this.http.put(`${this.environment.WEB_SERVICE_BASE_URL}/v1/${sessionId}/MemberNotifications/${notificationId}`, payload);
    }
    dismissMemberNotification$(sessionId, notificationId, status, currentDate) {
        let params = new HttpParams();
        if (status) {
            params = params.set('status', status);
        }
        if (currentDate) {
            params = params.set('currentDate', currentDate);
        }
        return this.http.delete(`${this.environment.WEB_SERVICE_BASE_URL}/v1/${sessionId}/MemberNotifications/${notificationId}`, {
            params
        });
    }
}
MemberSessionHttpService.ɵfac = function MemberSessionHttpService_Factory(t) { return new (t || MemberSessionHttpService)(i0.ɵɵinject(i1$2.HttpClient)); };
MemberSessionHttpService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MemberSessionHttpService, factory: MemberSessionHttpService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MemberSessionHttpService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1$2.HttpClient }]; }, null); })();

var DemographicState_1;
class APIDemographicStateModel {
    constructor(demographicStateModel) {
        this.zip = demographicStateModel.zip;
        this.fips = demographicStateModel.fips;
        this.countyName = demographicStateModel.countyName;
        this.effectiveDate = demographicStateModel.effectiveDate;
        this.ageRange = demographicStateModel.ageRange ? demographicStateModel.ageRange : null;
        this.healthStatus = demographicStateModel.healthStatus ? demographicStateModel.healthStatus : null;
        this.birthdate = demographicStateModel.birthdate;
        this.subsidySelected = demographicStateModel.subsidySelected;
        this.subsidyPercent = demographicStateModel.subsidyPercent;
        this.estimateHealthCost = demographicStateModel.estimateHealthCost || null;
    }
}
const DEMOGRAPHIC_STORE_NAME = 'demographic';
class DemographicStateModel extends APIDemographicStateModel {
}
const DEMOGRAPHIC_DEFAULTS = {
    zip: '',
    fips: '',
    countyName: '',
    counties: [],
    countyZipSelection: '',
    effectiveDate: '',
    ageRange: null,
    healthStatus: null,
    birthdate: '',
    subsidySelected: null,
    subsidyPercent: null,
    loading: false,
    error: null
};
// Note: number types are set to null sicne 0 is a valid value in many cases and will be treated as such by the API
let DemographicState = DemographicState_1 = class DemographicState {
    constructor(demographicsHttpService, memberSessionHttpService) {
        this.demographicsHttpService = demographicsHttpService;
        this.memberSessionHttpService = memberSessionHttpService;
    }
    static healthStatus(state) {
        return state.healthStatus !== null && state.healthStatus !== undefined ? state.healthStatus : null;
    }
    static birthdate(state) {
        return state.birthdate;
    }
    static selectedZipCode(state) {
        return state.zip;
    }
    static selectedFipsCode(state) {
        return state.fips;
    }
    static counties(state) {
        return state.counties;
    }
    // additional information about the selected county
    static selectedCounty(counties, selectedFipsCode) {
        return counties && counties.length && selectedFipsCode ? counties.find(county => county.countyFIPS === selectedFipsCode) : null;
    }
    static effectiveDate(state) {
        return state.effectiveDate;
    }
    static loading(state) {
        return state.loading;
    }
    static error(state) {
        return state.error;
    }
    static subsidySelected(state) {
        return state.subsidySelected;
    }
    static subsidyPercent(state) {
        return state.subsidyPercent;
    }
    static ageRange(state) {
        return state.ageRange !== null && state.ageRange !== undefined ? state.ageRange : null;
    }
    static healthCostEstimate(state) {
        return state.estimateHealthCost !== null && state.estimateHealthCost !== undefined ? state.estimateHealthCost : null;
    }
    static countyZipSelection(state) {
        return state.countyZipSelection;
    }
    selectZipCode(ctx, { zip }) {
        ctx.setState(patch({ zip }));
    }
    selectFipsCode(ctx, { fips }) {
        ctx.setState(patch({ fips }));
    }
    selectZipAndFipsCode(ctx, { zip, fips }) {
        ctx.setState(patch({ zip, fips }));
    }
    setDemographicLoading(ctx, { loadingState }) {
        const { patchState } = ctx;
        patchState({ loading: loadingState });
    }
    setAgeRange({ setState }, { ageRange }) {
        setState(patch({
            ageRange
        }));
    }
    setHealthStatus({ setState }, { healthStatus }) {
        setState(patch({
            healthStatus
        }));
    }
    selectSubsidySelected({ setState }, { subsidySelected }) {
        setState(patch({
            subsidySelected,
            subsidyPercent: null
        }));
    }
    selectSubsidyPercent({ setState }, { subsidyPercent }) {
        setState(patch({
            subsidySelected: SubsidySelected.PARTIAL,
            subsidyPercent
        }));
    }
    async fetchCountyData(ctx, { zip }) {
        const { getState, setState, patchState, dispatch } = ctx;
        patchState({ loading: true, error: null });
        const state = getState();
        const hasCounties = !!state.counties;
        const currentZip = state.countyZipSelection;
        let counties = [];
        if (hasCounties) {
            if (zip !== currentZip) {
                // fetch counties if new zip
                counties = await this.demographicsHttpService.retrieveCounties$(zip).toPromise();
            }
            else {
                // else grab counties if we have them, otherwise fetch counties
                counties = state.counties;
            }
        }
        else {
            counties = await this.demographicsHttpService.retrieveCounties$(zip).toPromise();
        }
        setState(patch({
            counties,
            countyZipSelection: zip,
            loading: false
        }));
        // Update helpful tools demographic state
        dispatch(new SetCountiesAndZipSelection(counties, zip));
    }
    resetDemographicsState(ctx) {
        const { setState } = ctx;
        setState(DEMOGRAPHIC_DEFAULTS);
    }
    updateDemographics(ctx, { demographics }) {
        const { patchState, dispatch } = ctx;
        const currentDemographics = ctx.getState();
        const updatedDemographics = _merge(_cloneDeep(currentDemographics), demographics);
        patchState({
            ...updatedDemographics
        });
        if (updatedDemographics?.zip) {
            dispatch(new FetchCountyData(updatedDemographics.zip));
        }
    }
    updateDemographicSession(ctx, { sessionId }) {
        const demographicStateModel = ctx.getState();
        const demographicApiModel = new APIDemographicStateModel(demographicStateModel);
        return this.memberSessionHttpService.updateSession$(sessionId, { demographic: demographicApiModel });
    }
};
DemographicState.ɵfac = function DemographicState_Factory(t) { return new (t || DemographicState)(i0.ɵɵinject(DemographicHttpService), i0.ɵɵinject(MemberSessionHttpService)); };
DemographicState.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DemographicState, factory: DemographicState.ɵfac });
__decorate([
    Action(SelectZipCode)
], DemographicState.prototype, "selectZipCode", null);
__decorate([
    Action(SelectFIPS)
], DemographicState.prototype, "selectFipsCode", null);
__decorate([
    Action(SelectZipAndFIPS)
], DemographicState.prototype, "selectZipAndFipsCode", null);
__decorate([
    Action(SetDemographicLoading)
], DemographicState.prototype, "setDemographicLoading", null);
__decorate([
    Action(SetAgeRange)
], DemographicState.prototype, "setAgeRange", null);
__decorate([
    Action(SetHealthStatus)
], DemographicState.prototype, "setHealthStatus", null);
__decorate([
    Action(SelectSubsidySelected)
], DemographicState.prototype, "selectSubsidySelected", null);
__decorate([
    Action(SelectSubsidyPercent)
], DemographicState.prototype, "selectSubsidyPercent", null);
__decorate([
    LiveEditInactive(),
    Action(FetchCountyData)
], DemographicState.prototype, "fetchCountyData", null);
__decorate([
    Action(ResetDemographicState)
], DemographicState.prototype, "resetDemographicsState", null);
__decorate([
    LiveEditInactive(),
    Action(UpdateDemographics)
], DemographicState.prototype, "updateDemographics", null);
__decorate([
    LiveEditInactive(),
    Action(UpdateDemographicSession)
], DemographicState.prototype, "updateDemographicSession", null);
__decorate([
    Selector()
], DemographicState, "healthStatus", null);
__decorate([
    Selector()
], DemographicState, "birthdate", null);
__decorate([
    Selector()
], DemographicState, "selectedZipCode", null);
__decorate([
    Selector()
], DemographicState, "selectedFipsCode", null);
__decorate([
    Selector()
], DemographicState, "counties", null);
__decorate([
    Selector([DemographicState_1.counties, DemographicState_1.selectedFipsCode])
], DemographicState, "selectedCounty", null);
__decorate([
    Selector()
], DemographicState, "effectiveDate", null);
__decorate([
    Selector()
], DemographicState, "loading", null);
__decorate([
    Selector()
], DemographicState, "error", null);
__decorate([
    Selector()
], DemographicState, "subsidySelected", null);
__decorate([
    Selector()
], DemographicState, "subsidyPercent", null);
__decorate([
    Selector()
], DemographicState, "ageRange", null);
__decorate([
    Selector()
], DemographicState, "healthCostEstimate", null);
__decorate([
    Selector()
], DemographicState, "countyZipSelection", null);
DemographicState = DemographicState_1 = __decorate([
    State({
        name: DEMOGRAPHIC_STORE_NAME,
        defaults: DEMOGRAPHIC_DEFAULTS
    })
    /**
     * A store the holds all the demographics data related to shopping for plans.
     */
], DemographicState);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DemographicState, [{
        type: Injectable
    }], function () { return [{ type: DemographicHttpService }, { type: MemberSessionHttpService }]; }, { selectZipCode: [], selectFipsCode: [], selectZipAndFipsCode: [], setDemographicLoading: [], setAgeRange: [], setHealthStatus: [], selectSubsidySelected: [], selectSubsidyPercent: [], fetchCountyData: [], resetDemographicsState: [], updateDemographics: [], updateDemographicSession: [] }); })();

class SelectMedSupQuestions {
    constructor(sessionId, year, effectiveDate, questions, millimanHealthInformation) {
        this.sessionId = sessionId;
        this.year = year;
        this.effectiveDate = effectiveDate;
        this.questions = questions;
        this.millimanHealthInformation = millimanHealthInformation;
    }
}
SelectMedSupQuestions.type = '[MedSup] Select Questions ';
class FetchMedSupQuestions {
    constructor(zipCode, fips, year, effectiveDate, isPartAEnabled) {
        this.zipCode = zipCode;
        this.fips = fips;
        this.year = year;
        this.effectiveDate = effectiveDate;
        this.isPartAEnabled = isPartAEnabled;
    }
}
FetchMedSupQuestions.type = '[MedSup] Fetch Questions';
class FetchDefaultMedSupQuestions {
    constructor(fips, year, effectiveDate, isPartAEnabled) {
        this.fips = fips;
        this.year = year;
        this.effectiveDate = effectiveDate;
        this.isPartAEnabled = isPartAEnabled;
    }
}
FetchDefaultMedSupQuestions.type = '[MedSup] Fetch Default Questions';
class FetchMedSupQuestionsSuccess {
}
FetchMedSupQuestionsSuccess.type = '[MedSup] Fetch Questions Success';
class FetchMedSupQuestionsError {
    constructor(error) {
        this.error = error;
    }
}
FetchMedSupQuestionsError.type = '[MedSup] Fetch Questions Error';
class SaveGIReasons {
    constructor(giReasons) {
        this.giReasons = giReasons;
    }
}
SaveGIReasons.type = '[MedSup] Save GI Reasons';
class ResetMedSupState {
}
ResetMedSupState.type = '[MedSup] Reset';
class UpdateMedSupSession {
    constructor(sessionId) {
        this.sessionId = sessionId;
    }
}
UpdateMedSupSession.type = '[MedSup] Update MedSup Session';
class InitializeMedSupAnswers {
    constructor(questions) {
        this.questions = questions;
    }
}
InitializeMedSupAnswers.type = '[MedSup] Initialize MedSup Answers';
class UpdateMedSupQuestions {
    constructor(questions) {
        this.questions = questions;
    }
}
UpdateMedSupQuestions.type = '[MedSup] Update MedSup Questions';
class UpdateMedSupAnswers {
    constructor(questions) {
        this.questions = questions;
    }
}
UpdateMedSupAnswers.type = '[MedSup] Update MedSup Answers';
class SetMedSupLoading {
    constructor(loading) {
        this.loading = loading;
    }
}
SetMedSupLoading.type = '[MedSup] Loading';

const GIREASONS_NO_REASON_KEY = 'noreason';
var GIREASONS_KEY;
(function (GIREASONS_KEY) {
    GIREASONS_KEY["YES"] = "Yes";
    GIREASONS_KEY["NO"] = "No";
})(GIREASONS_KEY || (GIREASONS_KEY = {}));
var GIREASONS_VALUES;
(function (GIREASONS_VALUES) {
    GIREASONS_VALUES["TRUE"] = "True";
    GIREASONS_VALUES["FALSE"] = "False";
})(GIREASONS_VALUES || (GIREASONS_VALUES = {}));

class CollectionUtilityService {
    static getUniqueItems({ 
    // List of items.
    items, 
    // Unique key. Used to determine the uniqueness of each item.
    // In some cases, it's preferred to use a key other than the item's ID (if exist) because it's very likely that it'd be unique already
    key, 
    // Check Uniqueness Condition will determine if an item is unique in the collection.
    // For example, if we want unique plans based on their name,
    // the "key" would be the planName, and if the uniqueness check passes, then it's added in the collection.
    // By default, check if the item doesn't exist in the collection.
    checkUniquenessCondition = item => !item, 
    // Flag used to allow duplicates in the collection.
    // When enabled, the function will check if a duplicate item should be added under the same "key" in the collection.
    allowDuplicates, 
    // Check Duplicates Condition will determine if an item is a valid duplicate in the collection.
    // If the evaluation is true, then the duplicate item is added under the same "key" in the collection.
    checkDuplicatesCondition }) {
        const uniqueItemsCollection = items.reduce((uniqueItems, item, index) => {
            const foundItem = uniqueItems[item[key]];
            // Add unique items when the uniqueness check passes
            if (checkUniquenessCondition(foundItem)) {
                uniqueItems[item[key]] = [{ index, item }];
            }
            // Add duplicate items when the duplicates check passes
            if (allowDuplicates && foundItem && checkDuplicatesCondition?.(uniqueItems[item[key]], item)) {
                uniqueItems[item[key]] = [...uniqueItems[item[key]], { index, item }];
            }
            return uniqueItems;
        }, {});
        // The collection's values results in an array of items' arrays.
        // We flat it first into an array of items and then sort them based on their original position.
        const sortedUniqueItems = items.length > 0 ? _sortBy(_flatMap(Object.values(uniqueItemsCollection)), ['index']) : [];
        // We return a list of unique items based on the "key".
        // It could also contain certain duplicates if allow duplicates flag is enabled
        return sortedUniqueItems.map(({ item }) => item);
    }
    static updateQuestionsAnswers(outdatedQuestions, updatedAnswers) {
        return outdatedQuestions.map(question => ({
            ...question,
            value: updatedAnswers[question.name] ?? question.value
        }));
    }
}
CollectionUtilityService.ɵfac = function CollectionUtilityService_Factory(t) { return new (t || CollectionUtilityService)(); };
CollectionUtilityService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CollectionUtilityService, factory: CollectionUtilityService.ɵfac, providedIn: 'root' });
__decorate([
    Memoize()
], CollectionUtilityService, "updateQuestionsAnswers", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CollectionUtilityService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

var QuestionModel;
(function (QuestionModel) {
    QuestionModel[QuestionModel["MedSup"] = 0] = "MedSup";
    QuestionModel[QuestionModel["Plan"] = 1] = "Plan";
})(QuestionModel || (QuestionModel = {}));

class MedSupQuestionHttpModel {
}
class MedSupAnswersHttpModel {
}
class MedSupAnswersSessionModel {
}
class MedSupQuestionSessionModel {
}
// maps questionKey to planQuestionId
var MedSupPlanQuestionIds;
(function (MedSupPlanQuestionIds) {
    MedSupPlanQuestionIds[MedSupPlanQuestionIds["Gender"] = 1] = "Gender";
    MedSupPlanQuestionIds[MedSupPlanQuestionIds["Tobacco"] = 4] = "Tobacco";
    MedSupPlanQuestionIds[MedSupPlanQuestionIds["PaymentMethod"] = 5] = "PaymentMethod";
    MedSupPlanQuestionIds[MedSupPlanQuestionIds["Household"] = 6] = "Household";
    MedSupPlanQuestionIds[MedSupPlanQuestionIds["EffectiveDate"] = 9] = "EffectiveDate";
    MedSupPlanQuestionIds[MedSupPlanQuestionIds["GuaranteedIssue"] = 10] = "GuaranteedIssue";
    MedSupPlanQuestionIds[MedSupPlanQuestionIds["Height"] = 11] = "Height";
    MedSupPlanQuestionIds[MedSupPlanQuestionIds["Weight"] = 12] = "Weight";
    MedSupPlanQuestionIds[MedSupPlanQuestionIds["ZipCode"] = 14] = "ZipCode";
    MedSupPlanQuestionIds[MedSupPlanQuestionIds["County_FIPS"] = 15] = "County_FIPS";
    MedSupPlanQuestionIds[MedSupPlanQuestionIds["DateOfBirth"] = 16] = "DateOfBirth";
    MedSupPlanQuestionIds[MedSupPlanQuestionIds["PartBEffectiveDate"] = 17] = "PartBEffectiveDate";
    MedSupPlanQuestionIds[MedSupPlanQuestionIds["Family"] = 18] = "Family";
    MedSupPlanQuestionIds[MedSupPlanQuestionIds["Relationship"] = 19] = "Relationship";
    MedSupPlanQuestionIds[MedSupPlanQuestionIds["PlanAge"] = 20] = "PlanAge";
    MedSupPlanQuestionIds[MedSupPlanQuestionIds["TermLength"] = 21] = "TermLength";
    MedSupPlanQuestionIds[MedSupPlanQuestionIds["MillimanUWTier"] = 22] = "MillimanUWTier";
    MedSupPlanQuestionIds[MedSupPlanQuestionIds["NewlyEligible"] = 23] = "NewlyEligible";
    MedSupPlanQuestionIds[MedSupPlanQuestionIds["AgeAsOfPartB"] = 24] = "AgeAsOfPartB";
    MedSupPlanQuestionIds[MedSupPlanQuestionIds["GIAdditional"] = 25] = "GIAdditional";
    MedSupPlanQuestionIds[MedSupPlanQuestionIds["PartAEffectiveDate"] = 26] = "PartAEffectiveDate";
    MedSupPlanQuestionIds[MedSupPlanQuestionIds["Disability"] = 28] = "Disability";
    MedSupPlanQuestionIds[MedSupPlanQuestionIds["EFTDiscount"] = 29] = "EFTDiscount";
    MedSupPlanQuestionIds[MedSupPlanQuestionIds["BenefitAmount"] = 30] = "BenefitAmount";
    MedSupPlanQuestionIds[MedSupPlanQuestionIds["HCDaysCovered"] = 31] = "HCDaysCovered";
    MedSupPlanQuestionIds[MedSupPlanQuestionIds["NBDIndicator"] = 32] = "NBDIndicator";
})(MedSupPlanQuestionIds || (MedSupPlanQuestionIds = {}));
// Medigap questions that cannot be sent with a blank answer, otherwise they could cause the request to fail
// POST /v1/session/sessionId:/MedigapAnswers (InvalidArgument): 400 Bad Request - "Exception on QuestionID: [1,4,6,9,16,17,25,26] Value: "
// This may not be the complete list
const NON_BLANK_MEDIGAP_ANSWERS = [
    MedSupPlanQuestionIds.DateOfBirth,
    MedSupPlanQuestionIds.EffectiveDate,
    MedSupPlanQuestionIds.Gender,
    MedSupPlanQuestionIds.Tobacco,
    MedSupPlanQuestionIds.Household,
    MedSupPlanQuestionIds.PartAEffectiveDate,
    MedSupPlanQuestionIds.PartBEffectiveDate,
    MedSupPlanQuestionIds.GIAdditional
];
var MedSupQuestionNames;
(function (MedSupQuestionNames) {
    MedSupQuestionNames["Disability"] = "Disability";
    MedSupQuestionNames["Gender"] = "Gender";
    MedSupQuestionNames["Tobacco"] = "Tobacco";
    MedSupQuestionNames["PaymentMethod"] = "PaymentMethod";
    MedSupQuestionNames["Household"] = "Household";
    MedSupQuestionNames["EffectiveDate"] = "EffectiveDate";
    MedSupQuestionNames["GuaranteedIssue"] = "GuaranteedIssue";
    MedSupQuestionNames["Height"] = "Height";
    MedSupQuestionNames["Weight"] = "Weight";
    MedSupQuestionNames["ZipCode"] = "ZipCode";
    MedSupQuestionNames["County_FIPS"] = "County_FIPS";
    MedSupQuestionNames["DateOfBirth"] = "DateOfBirth";
    MedSupQuestionNames["PartBEffectiveDate"] = "PartBEffectiveDate";
    MedSupQuestionNames["Family"] = "Family";
    MedSupQuestionNames["Relationship"] = "Relationship";
    MedSupQuestionNames["PlanAge"] = "PlanAge";
    MedSupQuestionNames["TermLength"] = "TermLength";
    MedSupQuestionNames["MillimanUWTier"] = "MillimanUWTier";
    MedSupQuestionNames["NewlyEligible"] = "NewlyEligible";
    MedSupQuestionNames["AgeAsOfPartB"] = "AgeAsOfPartB";
    MedSupQuestionNames["GIAdditional"] = "GIAdditional";
    MedSupQuestionNames["PartAEffectiveDate"] = "PartAEffectiveDate";
    MedSupQuestionNames["PlanSubType"] = "PlanSubType";
    MedSupQuestionNames["EFTDiscount"] = "EFTDiscount";
    MedSupQuestionNames["BenefitAmount"] = "BenefitAmount";
    MedSupQuestionNames["HCDaysCovered"] = "HCDaysCovered";
    MedSupQuestionNames["NBDIndicator"] = "NBDIndicator";
})(MedSupQuestionNames || (MedSupQuestionNames = {}));
const ZIP_AND_FIPS_QUESTION_NAMES = [MedSupQuestionNames.ZipCode, MedSupQuestionNames.County_FIPS];
class MedSupAnswersPlansHttpModel {
}
class HttpSelectedGIReason {
}
// the GI reasons we will save and ultimately pass to the enrollment custom internal object
class GIReason {
}
var MedSupKeyDefaults;
(function (MedSupKeyDefaults) {
    MedSupKeyDefaults["Spa_MedSupForm_DisabilityDescription_Text"] = "Were you Medicare eligible due to disability or ESRD, or did you turn 65 on or after January 1, 2020?";
    MedSupKeyDefaults["Spa_MedSupForm_DisabilityYes_Text"] = "Yes";
    MedSupKeyDefaults["Spa_MedSupForm_DisabilityNo_Text"] = "No";
    MedSupKeyDefaults["Spa_MedSupForm_GenderDescription_Text"] = "Gender";
    MedSupKeyDefaults["Spa_MedSupForm_GenderMale_Text"] = "Male";
    MedSupKeyDefaults["Spa_MedSupForm_GenderFemale_Text"] = "Female";
    MedSupKeyDefaults["Spa_MedSupForm_TobaccoDescription_Text"] = "Tobacco use?";
    MedSupKeyDefaults["Spa_MedSupForm_TobaccoSmoker_Text"] = "Yes";
    MedSupKeyDefaults["Spa_MedSupForm_TobaccoNonSmoker_Text"] = "No";
    MedSupKeyDefaults["Spa_MedSupForm_PaymentMethodDescription_Text"] = "Payment frequency";
    MedSupKeyDefaults["Spa_MedSupForm_PaymentMethodBiMonthly_Text"] = "Bi-Monthly";
    MedSupKeyDefaults["Spa_MedSupForm_PaymentMethodMonthly_Text"] = "Monthly";
    MedSupKeyDefaults["Spa_MedSupForm_PaymentMethodQuarterly_Text"] = "Quarterly";
    MedSupKeyDefaults["Spa_MedSupForm_PaymentMethodSemiAnnually_Text"] = "Semi-Annually";
    MedSupKeyDefaults["Spa_MedSupForm_PaymentMethodAnnually_Text"] = "Annually";
    MedSupKeyDefaults["Spa_MedSupForm_PaymentMethodLumpSum_Text"] = "Lump sum";
    MedSupKeyDefaults["Spa_MedSupForm_HouseholdDescription_Text"] = "Will you be signing up your spouse?";
    MedSupKeyDefaults["Spa_MedSupForm_HouseholdYes_Text"] = "Yes";
    MedSupKeyDefaults["Spa_MedSupForm_HouseholdNo_Text"] = "No";
    MedSupKeyDefaults["Spa_MedSupForm_EffectiveDateDescription_Text"] = "When would you like coverage to begin?";
    MedSupKeyDefaults["Spa_MedSupForm_GuaranteedIssueDescription_Text"] = "Do you qualify for Guaranteed Issue?";
    MedSupKeyDefaults["Spa_MedSupForm_GuaranteedIssueYes_Text"] = "Yes";
    MedSupKeyDefaults["Spa_MedSupForm_GuaranteedIssueNo_Text"] = "No";
    MedSupKeyDefaults["Spa_MedSupForm_HeightDescription_Text"] = "Height";
    MedSupKeyDefaults["Spa_MedSupForm_WeightDescription_Text"] = "Weight";
    MedSupKeyDefaults["Spa_MedSupForm_DateOfBirthDescription_Text"] = "Date of birth";
    MedSupKeyDefaults["Spa_MedSupForm_PartBEffectiveDateDescription_Text"] = "Part B Effective Date";
    MedSupKeyDefaults["Spa_MedSupForm_GIAdditionalDescription_Text"] = "Do any of these apply to you?";
    MedSupKeyDefaults["Spa_MedSupForm_GIAdditionalYes_Text"] = "Yes";
    MedSupKeyDefaults["Spa_MedSupForm_GIAdditionalNo_Text"] = "No";
    MedSupKeyDefaults["Spa_MedSupForm_PartAEffectiveDateDescription_Text"] = "Part A effective date";
    MedSupKeyDefaults["Spa_MedSupForm_EFTDiscountDescription_Text"] = "Will you be paying your premium via Electronic Funds Transfer (EFT) from your bank account?";
    MedSupKeyDefaults["Spa_MedSupForm_EFTDiscountYes_Text"] = "Yes";
    MedSupKeyDefaults["Spa_MedSupForm_EFTDiscountNo_Text"] = "No";
})(MedSupKeyDefaults || (MedSupKeyDefaults = {}));
const MEDSUP_YES_VALUE = 'Y';
const MEDSUP_NO_VALUE = 'N';
const MEDSUP_SIX_MONTHS_VALUE = 6;

class RateFactorsUtilityService {
    static hasAnswers(answers) {
        return (answers &&
            Object.keys(answers).filter(answerKey => !ZIP_AND_FIPS_QUESTION_NAMES.includes(answerKey)).length > 0);
    }
    static getAnswers(answers, hasAnswers) {
        const rateFactorAnswers = answers ?? {};
        return hasAnswers ? rateFactorAnswers : {};
    }
    static transformHttpModelToSessionModel(questions, questionModel) {
        return questions.map(question => {
            const defaultValue = '';
            const baseQuestionSessionModel = {
                questionId: question.planQuestionID,
                name: question.questionKey,
                text: question.defaultText,
                answerType: question.answerTypeField,
                answerList: question.enumValues,
                tooltip: question.tooltip,
                value: defaultValue,
                status: defaultValue,
                statusReason: defaultValue
            };
            const questionModels = {
                [QuestionModel.MedSup]: (currentQuestion) => ({
                    ...baseQuestionSessionModel,
                    value: currentQuestion.medigapAnswer?.value ?? defaultValue,
                    selectedGIReason: currentQuestion.selectedGIReason ?? {}
                }),
                [QuestionModel.Plan]: (currentQuestion) => ({
                    ...baseQuestionSessionModel,
                    value: currentQuestion.answer?.value ?? defaultValue
                })
            };
            return questionModels[questionModel](question);
        });
    }
    static transformSessionModelToHttpModel(questions, questionModel) {
        return questions.map(question => {
            const defaultValue = '';
            const baseQuestionHttpModel = {
                answerType: defaultValue,
                answerTypeField: question.answerType,
                defaultText: question.text,
                enumValues: question.answerList,
                planQuestionID: question.questionId,
                questionKey: question.name,
                tooltip: question.tooltip
            };
            const questionModels = {
                [QuestionModel.MedSup]: (currentQuestion) => ({
                    ...baseQuestionHttpModel,
                    medigapAnswer: {
                        questionID: currentQuestion.questionId,
                        value: RateFactorsUtilityService.getAnswerFromQuestion(currentQuestion)
                    },
                    selectedGIReason: currentQuestion.selectedGIReason
                }),
                [QuestionModel.Plan]: (currentQuestion) => ({
                    ...baseQuestionHttpModel,
                    answer: {
                        questionID: currentQuestion.questionId,
                        value: RateFactorsUtilityService.getAnswerFromQuestion(currentQuestion)
                    }
                })
            };
            return questionModels[questionModel](question);
        });
    }
    static getAnswerFromQuestion(question) {
        let questionAnswer = question.value;
        if (NON_BLANK_MEDIGAP_ANSWERS.includes(question.questionId) && !questionAnswer) {
            questionAnswer = null;
        }
        return questionAnswer;
    }
}
RateFactorsUtilityService.ɵfac = function RateFactorsUtilityService_Factory(t) { return new (t || RateFactorsUtilityService)(); };
RateFactorsUtilityService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: RateFactorsUtilityService, factory: RateFactorsUtilityService.ɵfac, providedIn: 'root' });
__decorate([
    Memoize()
], RateFactorsUtilityService, "hasAnswers", null);
__decorate([
    Memoize()
], RateFactorsUtilityService, "getAnswers", null);
__decorate([
    Memoize()
], RateFactorsUtilityService, "transformHttpModelToSessionModel", null);
__decorate([
    Memoize()
], RateFactorsUtilityService, "transformSessionModelToHttpModel", null);
__decorate([
    Memoize()
], RateFactorsUtilityService, "getAnswerFromQuestion", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RateFactorsUtilityService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

class UpdateMilliman {
    constructor(milliman) {
        this.milliman = milliman;
    }
}
UpdateMilliman.type = '[Milliman] Update Milliman';
class InvokeMillimanService {
    constructor(sessionId, transactionId, millimanRequest) {
        this.sessionId = sessionId;
        this.transactionId = transactionId;
        this.millimanRequest = millimanRequest;
    }
}
InvokeMillimanService.type = '[Milliman] Invoke Milliman Service';
class InitializeMilliman {
}
InitializeMilliman.type = '[Milliman] Initialize Milliman';
class ResetMillimanState {
}
ResetMillimanState.type = '[Milliman] Reset';
class ClearMillimanPremium {
}
ClearMillimanPremium.type = '[Milliman] Clear Premium';
class SetMillimanTier {
    constructor(millimanTier) {
        this.millimanTier = millimanTier;
    }
}
SetMillimanTier.type = '[Milliman] Set Milliman Tier';
class UpdateMillimanHealthInformation {
    constructor(healthInformation) {
        this.healthInformation = healthInformation;
    }
}
UpdateMillimanHealthInformation.type = '[Milliman] Update Health Information';
class SetMillimanLoading {
    constructor(loading) {
        this.loading = loading;
    }
}
SetMillimanLoading.type = '[Milliman] Loading';
class SetMillimanAuthorizationFields {
    constructor(applicantFullName, authorizeDate, authorizeUse) {
        this.applicantFullName = applicantFullName;
        this.authorizeDate = authorizeDate;
        this.authorizeUse = authorizeUse;
    }
}
SetMillimanAuthorizationFields.type = '[Milliman] Set Milliman Authorization Fields';
class SetMillimanApplicantId {
    constructor(applicantId, keyValue) {
        this.applicantId = applicantId;
        this.keyValue = keyValue;
    }
}
SetMillimanApplicantId.type = '[Milliman] Set Milliman Applicant Id';
class UpdateMillimanServiceCalledNow {
    constructor(serviceCalledNow) {
        this.serviceCalledNow = serviceCalledNow;
    }
}
UpdateMillimanServiceCalledNow.type = '[Milliman] Update Service Called Now';
class UpdateMillimanServiceCalledBefore {
    constructor(serviceCalledBefore) {
        this.serviceCalledBefore = serviceCalledBefore;
    }
}
UpdateMillimanServiceCalledBefore.type = '[Milliman] Update Service Called Before';
class UpdateMillimanServiceUWFlag {
    constructor(uwFlag) {
        this.uwFlag = uwFlag;
    }
}
UpdateMillimanServiceUWFlag.type = '[Milliman] Update uwFlag';

class MillimanRequest {
}
class MillimanResponse {
}
var MillimanTier;
(function (MillimanTier) {
    MillimanTier["P"] = "P";
    MillimanTier["T1"] = "T1";
    MillimanTier["T2"] = "T2";
    MillimanTier["T3"] = "T3";
})(MillimanTier || (MillimanTier = {}));
const MILLIMAN_INITIAL = {
    serviceCalledBefore: false,
    currentTier: MillimanTier.P
};
class MillimanHealthInformation {
}
const AUTHORIZATION_YES_VALUE = 'Y';
const AUTHORIZATION_NO_VALUE = 'N';
const MILLIMAN_SPINNER_NAME = 'millimanSpinner';

class MedSupHttpService {
    constructor(http) {
        this.http = http;
        this.environment = EnvironmentService.getEnvironment();
    }
    retrieveMedSupQuestions$(zipCode, countyFIPS, year, effectiveDate, isPartAEnabled) {
        const headers = new HttpHeaders({ Accept: 'application/json' });
        let params = new HttpParams()
            .set('fips', countyFIPS)
            .set('year', year)
            .set('effectiveDate', effectiveDate)
            .set('isPartAEnabled', `${isPartAEnabled}`);
        if (zipCode?.length) {
            params = params.set('zip', zipCode);
        }
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v1/plans/MedigapQuestions`, { params, headers });
    }
    sendMedSupQuestionsWithMilliman$(id, year, effectiveDate, medigapQuestions, millimanHealthInformation) {
        const medigapQuestionRequest = [];
        medigapQuestions.forEach(question => {
            // we cannot return a null answer, give a blank value for any questions we did not answer
            if (question.medigapAnswer === null || Object.keys(question.medigapAnswer).length === 0) {
                medigapQuestionRequest.push({
                    ...question,
                    medigapAnswer: {
                        questionID: question.planQuestionID,
                        value: ''
                    }
                });
            }
            else {
                medigapQuestionRequest.push(question);
            }
        });
        return this.http.post(`${this.environment.MEMBER_SESSION_BASE_URL}/${id}/MedigapAnswersWithMilliman?Year=${year}&EffectiveDate=${effectiveDate}`, { medigapQuestionRequest, millimanHealthInformation });
    }
    sendMedSupQuestions$(id, year, effectiveDate, medigapQuestionRequest) {
        const newRequest = [];
        medigapQuestionRequest.forEach(question => {
            // we cannot return a null answer, give a blank value for any questions we did not answer
            if (question.medigapAnswer === null || Object.keys(question.medigapAnswer).length === 0) {
                newRequest.push({
                    ...question,
                    medigapAnswer: {
                        questionID: question.planQuestionID,
                        value: ''
                    }
                });
            }
            else {
                newRequest.push(question);
            }
        });
        return this.http.post(`${this.environment.MEMBER_SESSION_BASE_URL}/${id}/MedigapAnswers?Year=${year}&EffectiveDate=${effectiveDate}`, newRequest);
    }
    async sendMedSupQuestions(id, year, effectiveDate, medigapQuestionRequest) {
        return this.sendMedSupQuestions$(id, year, effectiveDate, medigapQuestionRequest).toPromise();
    }
    async sendMedSupQuestionsWithMilliman(id, year, effectiveDate, medigapQuestionRequest, millimanHealthInformation) {
        return this.sendMedSupQuestionsWithMilliman$(id, year, effectiveDate, medigapQuestionRequest, millimanHealthInformation).toPromise();
    }
    invokeMedSupMillimanService$(sessionId, millimanRequest) {
        return this.http.post(`${this.environment.MEMBER_SESSION_BASE_URL}/${sessionId}/InvokeMilliman`, millimanRequest);
    }
    async invokeMedSupMillimanService(sessionId, millimanRequest) {
        return this.invokeMedSupMillimanService$(sessionId, millimanRequest).toPromise();
    }
    invokeMillimanService$(sessionId, transactionId, millimanRequest) {
        return this.http.post(`${this.environment.MEMBER_SESSION_BASE_URL}/${sessionId}/Transaction/${transactionId}/InvokeMilliman`, millimanRequest);
    }
    async invokeMillimanService(sessionId, transactionId, millimanRequest) {
        return this.invokeMillimanService$(sessionId, transactionId, millimanRequest).toPromise();
    }
}
MedSupHttpService.ɵfac = function MedSupHttpService_Factory(t) { return new (t || MedSupHttpService)(i0.ɵɵinject(i1$2.HttpClient)); };
MedSupHttpService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MedSupHttpService, factory: MedSupHttpService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedSupHttpService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1$2.HttpClient }]; }, null); })();

var MillimanState_1;
class MillimanStateModel extends MillimanResponse {
}
const MILLIMAN_DEFAULTS = {
    currentPremium: null,
    newPremium: null,
    currentTier: null,
    newTier: null,
    uwFlag: '',
    nbdIndicator: false,
    premiumChanged: false,
    serviceCalledBefore: false,
    serviceCalledNow: false,
    parametersDictionary: '',
    medigapAnswersUniqueNames: '',
    uniqueNamesForStaticValue: '',
    orderReference: '',
    invokedPlanId: '',
    healthInformation: null,
    applicantId: null,
    applicantFullName: null,
    authorizeDate: null,
    authorizeUse: null,
    keyValue: null,
    error: null,
    loaded: false,
    loading: false
};
const MILLIMAN_STORE_NAME = 'milliman';
let MillimanState = MillimanState_1 = class MillimanState {
    constructor(medSupHttpService) {
        this.medSupHttpService = medSupHttpService;
    }
    static milliman(state) {
        return state;
    }
    static newTier(state) {
        return state.newTier;
    }
    static currentTier(state) {
        return state.currentTier;
    }
    static serviceCalledNow(state) {
        return state.serviceCalledNow;
    }
    static serviceCalledBefore(state) {
        return state.serviceCalledBefore;
    }
    static hasMillimanServiceBeenCalled(serviceCalledNow, serviceCalledBefore) {
        return serviceCalledNow || serviceCalledBefore;
    }
    static uwFlag(state) {
        return state.uwFlag;
    }
    static currentPremium(state) {
        return state.currentPremium;
    }
    static newPremium(state) {
        return state.newPremium;
    }
    static loading(state) {
        return state.loading;
    }
    static premiumChanged(state) {
        return state.premiumChanged;
    }
    static millimanUWTier(newTier, currentTier) {
        return newTier || currentTier;
    }
    static error(state) {
        return state.error;
    }
    static applicantFullName(state) {
        return state.applicantFullName;
    }
    static applicantId(state) {
        return state.applicantId;
    }
    static keyValue(state) {
        return state.keyValue;
    }
    static authorizeDate(state) {
        return state.authorizeDate;
    }
    static authorizeUse(state) {
        return state.authorizeUse;
    }
    static invokedPlanId(state) {
        return state.invokedPlanId;
    }
    static healthInformation(state) {
        return state.healthInformation;
    }
    updateMilliman(ctx, { milliman }) {
        ctx.patchState({ ...milliman });
    }
    async invokeService(ctx, { sessionId, transactionId, millimanRequest }) {
        ctx.patchState({ loading: true, error: null });
        try {
            let millimanResponse;
            if (transactionId) {
                millimanResponse = await this.medSupHttpService.invokeMillimanService(sessionId, transactionId, millimanRequest);
            }
            else {
                millimanResponse = await this.medSupHttpService.invokeMedSupMillimanService(sessionId, millimanRequest);
            }
            if (millimanResponse) {
                millimanResponse = this.flagMillimanServiceAsInvoked(millimanResponse);
            }
            ctx.dispatch(new UpdateMilliman(millimanResponse));
        }
        catch (error) {
            ctx.patchState({ error });
        }
        finally {
            ctx.patchState({ loading: false });
        }
    }
    initializeMilliman(ctx) {
        ctx.dispatch(new UpdateMilliman(MILLIMAN_INITIAL));
    }
    resetMilliman(ctx) {
        ctx.setState(MILLIMAN_DEFAULTS);
    }
    setMillimanTier(ctx, { millimanTier }) {
        ctx.patchState({
            currentTier: millimanTier,
            newTier: millimanTier
        });
    }
    updateMillimanServiceCalledNow(ctx, { serviceCalledNow }) {
        ctx.patchState({ serviceCalledNow });
    }
    updateMillimanServiceCalledBefore(ctx, { serviceCalledBefore }) {
        ctx.patchState({ serviceCalledBefore });
    }
    updateMillimanServiceUWFlag(ctx, { uwFlag }) {
        ctx.patchState({ uwFlag });
    }
    clearMillimanPlanInfo(ctx) {
        const millimanModel = {
            currentPremium: MILLIMAN_DEFAULTS.currentPremium,
            newPremium: MILLIMAN_DEFAULTS.newPremium,
            premiumChanged: MILLIMAN_DEFAULTS.premiumChanged,
            invokedPlanId: MILLIMAN_DEFAULTS.invokedPlanId
        };
        ctx.dispatch(new UpdateMilliman(millimanModel));
    }
    updateMillimanHealthInformation(ctx, { healthInformation }) {
        ctx.patchState({ healthInformation });
    }
    setMillimanLoading(ctx, { loading }) {
        const { patchState } = ctx;
        patchState({ loading });
    }
    setMillimanAuthorizationFields(ctx, { applicantFullName, authorizeDate, authorizeUse }) {
        ctx.patchState({ applicantFullName, authorizeDate, authorizeUse });
    }
    setMillimanApplicantId(ctx, { applicantId, keyValue }) {
        ctx.patchState({ applicantId, keyValue });
    }
    flagMillimanServiceAsInvoked(millimanResponse) {
        // Update serviceCalledBefore so if milliman REST API is invoked again, it will not call external milliman service
        return {
            ...millimanResponse,
            serviceCalledBefore: true
        };
    }
};
MillimanState.ɵfac = function MillimanState_Factory(t) { return new (t || MillimanState)(i0.ɵɵinject(MedSupHttpService)); };
MillimanState.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MillimanState, factory: MillimanState.ɵfac });
__decorate([
    Action(UpdateMilliman)
], MillimanState.prototype, "updateMilliman", null);
__decorate([
    Action(InvokeMillimanService)
], MillimanState.prototype, "invokeService", null);
__decorate([
    Action(InitializeMilliman)
], MillimanState.prototype, "initializeMilliman", null);
__decorate([
    Action(ResetMillimanState)
], MillimanState.prototype, "resetMilliman", null);
__decorate([
    Action(SetMillimanTier)
], MillimanState.prototype, "setMillimanTier", null);
__decorate([
    Action(UpdateMillimanServiceCalledNow)
], MillimanState.prototype, "updateMillimanServiceCalledNow", null);
__decorate([
    Action(UpdateMillimanServiceCalledBefore)
], MillimanState.prototype, "updateMillimanServiceCalledBefore", null);
__decorate([
    Action(UpdateMillimanServiceUWFlag)
], MillimanState.prototype, "updateMillimanServiceUWFlag", null);
__decorate([
    Action(ClearMillimanPremium)
], MillimanState.prototype, "clearMillimanPlanInfo", null);
__decorate([
    Action(UpdateMillimanHealthInformation)
], MillimanState.prototype, "updateMillimanHealthInformation", null);
__decorate([
    Action(SetMillimanLoading)
], MillimanState.prototype, "setMillimanLoading", null);
__decorate([
    Action(SetMillimanAuthorizationFields)
], MillimanState.prototype, "setMillimanAuthorizationFields", null);
__decorate([
    Action(SetMillimanApplicantId)
], MillimanState.prototype, "setMillimanApplicantId", null);
__decorate([
    Selector()
], MillimanState, "milliman", null);
__decorate([
    Selector()
], MillimanState, "newTier", null);
__decorate([
    Selector()
], MillimanState, "currentTier", null);
__decorate([
    Selector()
], MillimanState, "serviceCalledNow", null);
__decorate([
    Selector()
], MillimanState, "serviceCalledBefore", null);
__decorate([
    Selector([MillimanState_1.serviceCalledNow, MillimanState_1.serviceCalledBefore])
], MillimanState, "hasMillimanServiceBeenCalled", null);
__decorate([
    Selector()
], MillimanState, "uwFlag", null);
__decorate([
    Selector()
], MillimanState, "currentPremium", null);
__decorate([
    Selector()
], MillimanState, "newPremium", null);
__decorate([
    Selector()
], MillimanState, "loading", null);
__decorate([
    Selector()
], MillimanState, "premiumChanged", null);
__decorate([
    Selector([MillimanState_1.newTier, MillimanState_1.currentTier])
], MillimanState, "millimanUWTier", null);
__decorate([
    Selector()
], MillimanState, "error", null);
__decorate([
    Selector()
], MillimanState, "applicantFullName", null);
__decorate([
    Selector()
], MillimanState, "applicantId", null);
__decorate([
    Selector()
], MillimanState, "keyValue", null);
__decorate([
    Selector()
], MillimanState, "authorizeDate", null);
__decorate([
    Selector()
], MillimanState, "authorizeUse", null);
__decorate([
    Selector()
], MillimanState, "invokedPlanId", null);
__decorate([
    Selector()
], MillimanState, "healthInformation", null);
MillimanState = MillimanState_1 = __decorate([
    State({
        name: MILLIMAN_STORE_NAME,
        defaults: MILLIMAN_DEFAULTS
    })
], MillimanState);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MillimanState, [{
        type: Injectable
    }], function () { return [{ type: MedSupHttpService }]; }, { updateMilliman: [], invokeService: [], initializeMilliman: [], resetMilliman: [], setMillimanTier: [], updateMillimanServiceCalledNow: [], updateMillimanServiceCalledBefore: [], updateMillimanServiceUWFlag: [], clearMillimanPlanInfo: [], updateMillimanHealthInformation: [], setMillimanLoading: [], setMillimanAuthorizationFields: [], setMillimanApplicantId: [] }); })();

var MedSupState_1;
class APIMedSupStateModel {
}
const MEDSUP_STORE_NAME = 'questions';
class MedSupStateModel extends APIMedSupStateModel {
}
const MEDSUP_DEFAULTS = {
    error: null,
    loading: false,
    // TODO: this is pretty confusing with the store also being named questions
    // we might be limited by the API but if we can rename this or the store that would be ideal
    questions: [],
    answers: {},
    giReasons: []
};
let MedSupState = MedSupState_1 = class MedSupState {
    constructor(medSupHttpService, memberSessionHttpService) {
        this.medSupHttpService = medSupHttpService;
        this.memberSessionHttpService = memberSessionHttpService;
    }
    static processMedSupQuestions(ctx, medSupData, answers) {
        const { patchState } = ctx;
        const questions = MedSupState_1.transformHttpModelToSessionModel(medSupData);
        patchState({
            questions: CollectionUtilityService.updateQuestionsAnswers(questions, answers)
        });
        ctx.dispatch(new FetchMedSupQuestionsSuccess());
    }
    static questions(state) {
        return state.questions;
    }
    static hasQuestions(questions) {
        return questions && Object.keys(questions).length > 0;
    }
    static getQuestionById(id) {
        return createSelector([MedSupState_1], (state) => state.questions?.find(question => question.questionId == id));
    }
    static rawAnswers() {
        return createSelector([MedSupState_1], (state) => state.answers);
    }
    static answers(answers, hasAnswers) {
        return RateFactorsUtilityService.getAnswers(answers, hasAnswers);
    }
    static answersAsHttpModel(answers, questions) {
        // Sometimes there could be a mismatch between questions loaded, and questions answered, if zip has changed since you answered.
        // This will then only return currently available questions that have answers available.
        const mappedQuestionData = questions.reduce((mappedQuestions, question) => {
            if (answers[question.name] !== undefined) {
                mappedQuestions.push({ questionID: question.questionId, value: answers[question.name] });
            }
            return mappedQuestions;
        }, []);
        return mappedQuestionData;
    }
    static giReasons(state) {
        return state.giReasons;
    }
    static hasAnswers() {
        return createSelector([MedSupState_1.rawAnswers()], (answers) => RateFactorsUtilityService.hasAnswers(answers));
    }
    static areAllMedSupQuestionsAnswered(questions, answers) {
        return questions.every(question => {
            if (question.questionId === MedSupPlanQuestionIds.EffectiveDate && answers[question.name]) {
                return !DateUtilities.isPastMonth(answers[question.name]);
            }
            return answers[question.name] !== undefined;
        });
    }
    static loading(state) {
        return state.loading;
    }
    static error(state) {
        return state.error;
    }
    static selectedGIReasonKey(hasAnswers, answers) {
        if (hasAnswers) {
            const selectedGIReason = answers.SelectedGIReason;
            // mispelling is due to it being named this in the API
            return selectedGIReason.Medigap_GaranteeIssue_AdvancedSetting_SelectedAnswer;
        }
        return null;
    }
    static millimanTierServiceCalled(serviceCalledNow, serviceCalledBefore, giReasons) {
        const hasSelectedReason = giReasons.some(giReason => giReason.selected && giReason.name !== GIREASONS_NO_REASON_KEY);
        return !!(serviceCalledNow || serviceCalledBefore || hasSelectedReason);
    }
    static giReason(reasonName) {
        return createSelector([MedSupState_1.giReasons], (giReasons) => giReasons.find(giReason => giReason.name === reasonName));
    }
    static giReasonValue(reasonName) {
        return createSelector([MedSupState_1.giReason(reasonName)], (giReason) => giReason?.value);
    }
    static isGIReasonSelected(reasonName) {
        return createSelector([MedSupState_1.giReason(reasonName)], (giReason) => !!giReason?.selected);
    }
    static formField(formFieldName) {
        return createSelector([MedSupState_1], (state) => (state.answers ? state.answers[formFieldName] : null));
    }
    static isMedSupQuestion(questionId) {
        return createSelector([MedSupState_1.questions], (medSupQuestions) => medSupQuestions.some(question => question.questionId === questionId));
    }
    static hasGIReasons(giReasons) {
        return !!giReasons?.length;
    }
    static transformHttpModelToSessionModel(questions) {
        return RateFactorsUtilityService.transformHttpModelToSessionModel(questions, QuestionModel.MedSup);
    }
    static transformSessionModelToHttpModel(questions) {
        return RateFactorsUtilityService.transformSessionModelToHttpModel(questions, QuestionModel.MedSup);
    }
    fetchMedSupQuestions(ctx, { zipCode, fips, year, effectiveDate, isPartAEnabled }) {
        const { getState, patchState } = ctx;
        // update ZipCode/County_FIPS answers when we fetch questions for a new selected zip code
        const answers = {
            ...MedSupState_1.rawAnswers()(getState()),
            [MedSupQuestionNames.ZipCode]: zipCode,
            [MedSupQuestionNames.County_FIPS]: fips
        };
        patchState({ loading: true, error: null, answers });
        this.medSupHttpService.retrieveMedSupQuestions$(zipCode, fips, year, effectiveDate, isPartAEnabled).subscribe({
            next: medSupData => {
                if (medSupData?.length) {
                    MedSupState_1.processMedSupQuestions(ctx, medSupData, answers);
                }
                else {
                    // We invoke this new one action because endpoint needs a zipcode parameter and we need
                    // to wait response from API to getting know if current zipcode has/hasn't Questions so that's why
                    // in this point of code we send all params without zipcode in order to endpoint get default questions
                    ctx.dispatch(new FetchDefaultMedSupQuestions(fips, year, effectiveDate, isPartAEnabled));
                }
            },
            error: error => ctx.dispatch(new FetchMedSupQuestionsError(error))
        });
    }
    fetchDefaultMedSupQuestions(ctx, { fips, year, effectiveDate, isPartAEnabled }) {
        const { getState, patchState } = ctx;
        const answers = MedSupState_1.rawAnswers()(getState());
        patchState({ loading: true, error: null });
        this.medSupHttpService.retrieveMedSupQuestions$(null, fips, year, effectiveDate, isPartAEnabled).subscribe({
            next: medSupData => {
                MedSupState_1.processMedSupQuestions(ctx, medSupData, answers);
            },
            error: error => ctx.dispatch(new FetchMedSupQuestionsError(error))
        });
    }
    fetchMedSupQuestionsSuccess({ patchState }) {
        patchState({
            loading: false
        });
    }
    fetchMedSupQuestionsError({ patchState }, { error }) {
        patchState({
            loading: false,
            error
        });
    }
    async selectQuestions(ctx, { sessionId, year, effectiveDate, questions, millimanHealthInformation }) {
        const { getState, patchState } = ctx;
        const currentAnswers = MedSupState_1.rawAnswers()(getState());
        const answers = questions.reduce((medSupAnswers, question) => {
            medSupAnswers[question.name] = question.value;
            return medSupAnswers;
        }, _cloneDeep(currentAnswers));
        patchState({
            questions,
            answers
        });
        if (millimanHealthInformation) {
            await this.medSupHttpService.sendMedSupQuestionsWithMilliman(sessionId, year, effectiveDate, MedSupState_1.transformSessionModelToHttpModel(questions), millimanHealthInformation);
        }
        else {
            await this.medSupHttpService.sendMedSupQuestions(sessionId, year, effectiveDate, MedSupState_1.transformSessionModelToHttpModel(questions));
        }
    }
    saveGIReasons(ctx, { giReasons }) {
        const { patchState } = ctx;
        patchState({
            giReasons
        });
    }
    resetMedSupState(ctx) {
        const { patchState } = ctx;
        patchState(MEDSUP_DEFAULTS);
    }
    updateProfileSession(ctx, { sessionId }) {
        return this.memberSessionHttpService.updateSession$(sessionId, { questions: ctx.getState() });
    }
    updateMedSupAnswers(ctx, { questions }) {
        const { getState, patchState } = ctx;
        const currentAnswers = MedSupState_1.rawAnswers()(getState());
        const medigapAnswers = questions.reduce((answers, question) => {
            answers[question.name] = question.value;
            return answers;
        }, _cloneDeep(currentAnswers));
        patchState({ answers: medigapAnswers });
    }
    initializeMedSupAnswers(ctx, { questions }) {
        ctx.dispatch(new UpdateMedSupAnswers(questions));
        if (questions.some(question => question.name === MedSupQuestionNames.MillimanUWTier)) {
            ctx.dispatch(new InitializeMilliman());
        }
    }
    setMedSupLoading(ctx, { loading }) {
        const { patchState } = ctx;
        patchState({ loading });
    }
};
MedSupState.ɵfac = function MedSupState_Factory(t) { return new (t || MedSupState)(i0.ɵɵinject(MedSupHttpService), i0.ɵɵinject(MemberSessionHttpService)); };
MedSupState.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MedSupState, factory: MedSupState.ɵfac });
__decorate([
    LiveEditInactive(),
    Action(FetchMedSupQuestions)
], MedSupState.prototype, "fetchMedSupQuestions", null);
__decorate([
    LiveEditInactive(),
    Action(FetchDefaultMedSupQuestions)
], MedSupState.prototype, "fetchDefaultMedSupQuestions", null);
__decorate([
    Action(FetchMedSupQuestionsSuccess)
], MedSupState.prototype, "fetchMedSupQuestionsSuccess", null);
__decorate([
    Action(FetchMedSupQuestionsError)
], MedSupState.prototype, "fetchMedSupQuestionsError", null);
__decorate([
    Action(SelectMedSupQuestions)
], MedSupState.prototype, "selectQuestions", null);
__decorate([
    Action(SaveGIReasons)
], MedSupState.prototype, "saveGIReasons", null);
__decorate([
    Action(ResetMedSupState)
], MedSupState.prototype, "resetMedSupState", null);
__decorate([
    Action(UpdateMedSupSession)
], MedSupState.prototype, "updateProfileSession", null);
__decorate([
    Action(UpdateMedSupAnswers)
], MedSupState.prototype, "updateMedSupAnswers", null);
__decorate([
    Action(InitializeMedSupAnswers)
], MedSupState.prototype, "initializeMedSupAnswers", null);
__decorate([
    Action(SetMedSupLoading)
], MedSupState.prototype, "setMedSupLoading", null);
__decorate([
    Selector()
], MedSupState, "questions", null);
__decorate([
    Selector([MedSupState_1.questions])
], MedSupState, "hasQuestions", null);
__decorate([
    Selector([MedSupState_1.rawAnswers(), MedSupState_1.hasAnswers()])
], MedSupState, "answers", null);
__decorate([
    Selector([MedSupState_1.answers, MedSupState_1.questions])
], MedSupState, "answersAsHttpModel", null);
__decorate([
    Selector()
], MedSupState, "giReasons", null);
__decorate([
    Selector([MedSupState_1.questions, MedSupState_1.answers])
], MedSupState, "areAllMedSupQuestionsAnswered", null);
__decorate([
    Selector()
], MedSupState, "loading", null);
__decorate([
    Selector()
], MedSupState, "error", null);
__decorate([
    Selector([MedSupState_1.hasAnswers(), MedSupState_1.answers])
], MedSupState, "selectedGIReasonKey", null);
__decorate([
    Selector([MillimanState.serviceCalledNow, MillimanState.serviceCalledBefore, MedSupState_1.giReasons])
], MedSupState, "millimanTierServiceCalled", null);
__decorate([
    Selector([MedSupState_1.giReasons])
], MedSupState, "hasGIReasons", null);
MedSupState = MedSupState_1 = __decorate([
    State({
        name: MEDSUP_STORE_NAME,
        defaults: MEDSUP_DEFAULTS,
        children: [MillimanState]
    })
], MedSupState);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedSupState, [{
        type: Injectable
    }], function () { return [{ type: MedSupHttpService }, { type: MemberSessionHttpService }]; }, { fetchMedSupQuestions: [], fetchDefaultMedSupQuestions: [], fetchMedSupQuestionsSuccess: [], fetchMedSupQuestionsError: [], selectQuestions: [], saveGIReasons: [], resetMedSupState: [], updateProfileSession: [], updateMedSupAnswers: [], initializeMedSupAnswers: [], setMedSupLoading: [] }); })();

class AddDrugToMedicineCabinet {
    constructor(cabinetEntry) {
        this.cabinetEntry = cabinetEntry;
    }
}
AddDrugToMedicineCabinet.type = '[MedicineCabinet] Add Drug';
class RemoveDrugFromMedicineCabinet {
    constructor(dosageID) {
        this.dosageID = dosageID;
    }
}
RemoveDrugFromMedicineCabinet.type = '[MedicineCabinet] Remove Drug';
class EditDrugInMedicineCabinet {
    constructor(prevDosageId, cabinetEntry) {
        this.prevDosageId = prevDosageId;
        this.cabinetEntry = cabinetEntry;
    }
}
EditDrugInMedicineCabinet.type = '[MedicineCabinet] Edit Drug';
class ResetMedicineCabinet {
}
ResetMedicineCabinet.type = '[MedicineCabinet] Reset';
class AddDrugsToMedicineCabinet {
    constructor(cabinetEntry) {
        this.cabinetEntry = cabinetEntry;
    }
}
AddDrugsToMedicineCabinet.type = '[MedicineCabinet] Add Drugs';
class ResetCabinetUpdatedStatus {
}
ResetCabinetUpdatedStatus.type = '[MedicineCabinet] Reset Cabinet Updated Status';
class SetDrugsToMedicineCabinet {
    constructor(cabinetEntry) {
        this.cabinetEntry = cabinetEntry;
    }
}
SetDrugsToMedicineCabinet.type = '[MedicineCabinet] Set Drugs';
class UpdateMedicineCabinetEntry {
    constructor(medicalConditionId, dosageId) {
        this.medicalConditionId = medicalConditionId;
        this.dosageId = dosageId;
    }
}
UpdateMedicineCabinetEntry.type = '[MedicineCabinet] Update Medicine Cabinet Entry';

class CompareUtilities {
    matchCompareGroupCompositeKey(compareGroups, compareGroupCompositeKey) {
        return compareGroups.filter(storeCompareGroup => compareGroupCompositeKey.every(tab => tab.groupKey &&
            storeCompareGroup.groupKey &&
            tab.groupKey.key === storeCompareGroup.groupKey.key &&
            tab.groupKey.comparator === storeCompareGroup.groupKey.comparator &&
            tab.groupKey.values.every(value => storeCompareGroup.groupKey.values.includes(value))));
    }
    compareGroupExists(compareGroups, compareGroupCompositeKey) {
        return this.matchCompareGroupCompositeKey(compareGroups, compareGroupCompositeKey).length > 0;
    }
}

class CompareGroup {
    constructor(key, values, comparator, item) {
        this.items = [];
        const comparatorValue = comparator ? comparator : values.length > 1 ? ComparatorType.IN : ComparatorType.EQUAL;
        this.groupKey = {
            key,
            values,
            comparator: comparatorValue
        };
        if (item) {
            this.items.push(item);
        }
    }
}

class PlansUtilityService {
    static getRiderData(plan) {
        return plan
            ? plan?.riders.map(rider => ({
                isSelected: rider.isRequiredRider,
                riderId: rider.planID,
                isRequired: rider.isRequiredRider
            }))
            : [];
    }
    static createShoppingCartEntry(plan, riders) {
        return plan
            ? {
                planId: plan.id,
                premium: plan.drugPremium,
                planType: PlanTypeAbbreviation[plan.planTypeAbbreviation],
                productType: '',
                planName: plan.planName,
                riders
            }
            : null;
    }
    static getRiderIds(cartItem) {
        return cartItem?.riders ? cartItem.riders.map(rider => rider.riderId) : [];
    }
    static includesMedicarePlans(planTypes) {
        return MEDICARE_PLAN_TYPE_VALUES.some(medicarePlanType => planTypes.includes(medicarePlanType));
    }
    static splitBitWise(input) {
        const asBinaryReversed = input.toString(2).split('').reverse();
        const bitComponentsArray = [];
        asBinaryReversed.forEach((bit, index) => {
            if (parseInt(bit, 10)) {
                bitComponentsArray.push(Math.pow(2, index));
            }
        });
        return bitComponentsArray;
    }
    static splitBitWiseArray(planTypes) {
        return (planTypes?.reduce((allPlanTypes, planType) => {
            const bitWisePlanTypes = PlansUtilityService.splitBitWise(+planType);
            return Array.from(new Set([...allPlanTypes, ...bitWisePlanTypes]));
        }, []) ?? []);
    }
    static toBitWiseString(planTypes) {
        const bitWise = planTypes?.reduce((total, planType) => {
            total += +planType;
            return total;
        }, 0) ?? 0;
        return bitWise.toString();
    }
    static getPlansOfType(plans, planType) {
        return plans.reduce((plansMap, plan) => {
            if (PlansUtilityService.isPlanOfType(plan, planType)) {
                plansMap[plan.id] = plan;
            }
            return plansMap;
        }, {});
    }
    static isPlanOfType(plan, planType) {
        if (PlansUtilityService.isAllMedicareType(planType)) {
            return PlansUtilityService.isSingleMedicareType(plan.planType);
        }
        return plan.planType === planType;
    }
    // eslint-disable-next-line complexity
    static mergePayloadPlanWithDetails(payloadPlan, detailedPlan) {
        const mergedPlan = { ...detailedPlan };
        // these are the fields that plan details clobbers so we need to preserve them from the plans payload
        // ideally we just get all the data we need back from the API in the details call so if that ever
        // happens we can remove this method
        const isCurrentYearPlan = payloadPlan?.isCurrentYearPlan;
        const isNextYearPlan = payloadPlan?.isNextYearPlan;
        const nextYearPlanOrdinal = payloadPlan?.nextYearPlanOrdinal;
        const modifiedNextYearPlanOrdinal = payloadPlan?.modifiedNextYearPlanOrdinal;
        const isPlanRolloverTerminated = payloadPlan?.isPlanRolloverTerminated;
        const isClientDefinedPlan = payloadPlan?.isClientDefinedPlan;
        const planLabelCategory = payloadPlan?.planLabelCategory;
        const planLabelCategoryOrdinal = payloadPlan?.planLabelCategoryOrdinal;
        if (isCurrentYearPlan !== undefined && isCurrentYearPlan !== null) {
            mergedPlan.isCurrentYearPlan = isCurrentYearPlan;
        }
        if (isNextYearPlan !== undefined && isNextYearPlan !== null) {
            mergedPlan.isNextYearPlan = isNextYearPlan;
        }
        if (nextYearPlanOrdinal !== undefined && nextYearPlanOrdinal !== null) {
            mergedPlan.nextYearPlanOrdinal = nextYearPlanOrdinal;
        }
        if (modifiedNextYearPlanOrdinal !== undefined && modifiedNextYearPlanOrdinal !== null) {
            mergedPlan.modifiedNextYearPlanOrdinal = modifiedNextYearPlanOrdinal;
        }
        if (isPlanRolloverTerminated !== undefined && isPlanRolloverTerminated !== null) {
            mergedPlan.isPlanRolloverTerminated = isPlanRolloverTerminated;
        }
        if (isClientDefinedPlan !== undefined && isClientDefinedPlan !== null) {
            mergedPlan.isClientDefinedPlan = isClientDefinedPlan;
        }
        if (planLabelCategory !== undefined &&
            planLabelCategory !== null &&
            (mergedPlan?.planLabelCategory === undefined || mergedPlan?.planLabelCategory === null)) {
            mergedPlan.planLabelCategory = planLabelCategory;
        }
        if (planLabelCategoryOrdinal !== undefined &&
            planLabelCategoryOrdinal !== null &&
            (mergedPlan?.planLabelCategoryOrdinal === undefined || mergedPlan?.planLabelCategoryOrdinal === null)) {
            mergedPlan.planLabelCategoryOrdinal = planLabelCategoryOrdinal;
        }
        return mergedPlan;
    }
    static isMedicarePlanType(planType) {
        return MEDICARE_PLAN_TYPES.includes(planType);
    }
    static convertToPlanType(planTypeAbbreviation, aggregateMedicareType = true) {
        if (planTypeAbbreviation) {
            if (aggregateMedicareType && PlansUtilityService.isMedicarePlanType(planTypeAbbreviation)) {
                return MEDICARE_PLAN_TYPE_VALUES.reduce((aggregateMedicarePlanType, medicarePlanTypeValue) => aggregateMedicarePlanType + medicarePlanTypeValue, 0);
            }
            switch (planTypeAbbreviation) {
                case PlanTypeAbbreviation.MEDIGAP:
                    return PlanType.MEDIGAP;
                case PlanTypeAbbreviation.DENTAL:
                    return PlanType.DENTAL;
                case PlanTypeAbbreviation.VISION:
                    return PlanType.VISION;
                case PlanTypeAbbreviation.HC:
                    return PlanType.HC;
                case PlanTypeAbbreviation.MA:
                    return PlanType.MA;
                case PlanTypeAbbreviation.MAPD:
                    return PlanType.MAPD;
                case PlanTypeAbbreviation.PDP:
                    return PlanType.PDP;
                default:
                    return null;
            }
        }
        return null;
    }
    static hasMedicareAllType(planTypes) {
        return !!planTypes?.some(planType => PlansUtilityService.isAllMedicareType(planType));
    }
    static hasAllMedicareTypes(planTypes) {
        return planTypes.every(planType => MEDICARE_PLAN_TYPE_VALUES.includes(planType));
    }
    static hasProviderType(planTypes) {
        return planTypes.some(planType => PROVIDER_ENABLED_TYPES.includes(planType));
    }
    static isAllMedicareType(planType) {
        return planType === ALL_MEDICARE_PLAN_TYPE_VALUE;
    }
    // checks if a plan type is a medicare type (1, 2, 4) but not any valid bitwise values (7)
    static isSingleMedicareType(planType) {
        return MEDICARE_PLAN_TYPE_VALUES.includes(planType);
    }
    // checks if a plan type is a non-medicare type (256, 4096, 8192, 33554432) but not any valid bitwise values
    static isSingleNonMedicareType(planType) {
        return NON_MEDICARE_PLAN_TYPE_VALUES.includes(planType);
    }
    static getPlanBucketKey(planType) {
        if (PlansUtilityService.isSingleMedicareType(planType)) {
            return ALL_MEDICARE_PLAN_TYPE_VALUE;
        }
        return planType;
    }
    static getUniquePlanTypes(searchPlanTypes) {
        return (searchPlanTypes?.reduce((allPlanTypes, planType) => {
            if (PlansUtilityService.isAllMedicareType(planType)) {
                MEDICARE_PLAN_TYPE_VALUES.forEach(medicarePlanType => {
                    if (!allPlanTypes.includes(medicarePlanType)) {
                        allPlanTypes.push(medicarePlanType);
                    }
                });
            }
            else {
                if (!allPlanTypes.includes(planType)) {
                    allPlanTypes.push(planType);
                }
            }
            return allPlanTypes;
        }, []) || []);
    }
    static isAgentSellingPermissionError(sellingPermissionError) {
        const errorBody = sellingPermissionError?.error;
        // TODO: test me!
        return (errorBody?.Status === HttpStatusCode.NOT_FOUND && Object.keys(AgentSellingPermissionError).some(asp => errorBody?.Title.includes(asp)));
    }
    static getAgentSellingPermissionErrorType(sellingPermissionError) {
        return sellingPermissionError?.error?.Title ?? null;
    }
    static getUpdatedPlanPharmacies(currentPlanPharmacies, planPharmacies) {
        if (currentPlanPharmacies?.length && planPharmacies?.length) {
            return currentPlanPharmacies.map(pharmacy => {
                const detailedPharmacy = planPharmacies.find(planPharmacy => planPharmacy.pharmacyId === pharmacy.pharmacyId);
                return PlansUtilityService.mergePayloadPharmaciesWithDetails(pharmacy, detailedPharmacy);
            });
        }
        return currentPlanPharmacies;
    }
    static mergePayloadPharmaciesWithDetails(payloadPlanPharmacy, detailedPharmacy) {
        const mergedPharmacy = { ...payloadPlanPharmacy };
        if (detailedPharmacy?.vaccineAdminFee) {
            mergedPharmacy.vaccineAdminFee = detailedPharmacy.vaccineAdminFee;
        }
        return mergedPharmacy;
    }
    static getPlanTypeName(planTypeId) {
        return PlanTypeAbbreviation[PlanType[planTypeId]];
    }
    /**
     * This function is for filtering out additional plans that are too complex for using our normal filtering system.
     * This should be attached to any function in this service that returns Plan[].
     * This should also be your last line of defense, for if you really can't seem to get the filter added in anywhere else.
     * @param plans The list of plans to be further filtered
     * @param skipAdditionalFiltering for if we ever need to conditionally skip this step and see what just the filters gets us
     */
    static filterAdditionalPlans(plans, hasMedSupAnswers, forceMedSupFormBeforePlansList, skipAdditionalFiltering = false) {
        return skipAdditionalFiltering
            ? plans
            : PlansUtilityService.filterPlansRequiringExternalRating(plans, hasMedSupAnswers, forceMedSupFormBeforePlansList, skipAdditionalFiltering);
    }
    static filterPlansRequiringExternalRating(plans, hasMedSupAnswers, forceMedSupFormBeforePlansList, skipAdditionalFiltering) {
        if (!forceMedSupFormBeforePlansList && !hasMedSupAnswers) {
            return plans ?? [];
        }
        return (plans?.filter(plan => !PlansUtilityService.planRequiresExternalRating(plan.extraData, plan.hasBeenExternallyRated, skipAdditionalFiltering)) ?? []);
    }
    static planRequiresExternalRating(planExtraData, planHasBeenExternallyRated, skipFlagCheck) {
        const planExtraDataValue = PlansUtilityService.getExtraDataValueByName(planExtraData, PlanExtraDataKey.RATING_TYPE);
        return (planExtraDataValue === PlanExtraDataRatingType.QUOTE_RATE_SERVICE && (skipFlagCheck ? true : planHasBeenExternallyRated !== true));
    }
    static getExtraDataValueByName(planExtraData, name, defaultValue) {
        return planExtraData?.find((extraData) => extraData.name === name)?.value ?? defaultValue;
    }
    static canSellPlan(plan) {
        let canSell = false;
        if (plan) {
            // On NOVA layer, plan list only needs to check isPUF
            // However plan details needs to use isPUF, isBlacklistedPlan, and isNonPermissionedPlan
            canSell = !plan.isPUF && !plan.isBlacklistedPlan && !plan.isNonPermissionedPlan;
        }
        return canSell;
    }
    static isPlanCommissionable(plan, isNonCommissionableFlagCheckEnabled) {
        // We consider the plan as commisionable by default unless it is explicitly marked otherwise
        let isCommisionable = true;
        if (plan) {
            isCommisionable = !isNonCommissionableFlagCheckEnabled || plan.commissionable !== false;
        }
        return isCommisionable;
    }
}
PlansUtilityService.ɵfac = function PlansUtilityService_Factory(t) { return new (t || PlansUtilityService)(); };
PlansUtilityService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PlansUtilityService, factory: PlansUtilityService.ɵfac, providedIn: 'root' });
__decorate([
    Memoize()
], PlansUtilityService, "includesMedicarePlans", null);
__decorate([
    Memoize()
], PlansUtilityService, "splitBitWise", null);
__decorate([
    Memoize()
], PlansUtilityService, "splitBitWiseArray", null);
__decorate([
    Memoize()
], PlansUtilityService, "toBitWiseString", null);
__decorate([
    Memoize()
], PlansUtilityService, "isMedicarePlanType", null);
__decorate([
    Memoize()
], PlansUtilityService, "convertToPlanType", null);
__decorate([
    Memoize()
], PlansUtilityService, "hasMedicareAllType", null);
__decorate([
    Memoize()
], PlansUtilityService, "hasAllMedicareTypes", null);
__decorate([
    Memoize()
], PlansUtilityService, "hasProviderType", null);
__decorate([
    Memoize()
], PlansUtilityService, "isAllMedicareType", null);
__decorate([
    Memoize()
], PlansUtilityService, "isSingleMedicareType", null);
__decorate([
    Memoize()
], PlansUtilityService, "isSingleNonMedicareType", null);
__decorate([
    Memoize()
], PlansUtilityService, "getPlanBucketKey", null);
__decorate([
    Memoize()
], PlansUtilityService, "getUniquePlanTypes", null);
__decorate([
    Memoize()
], PlansUtilityService, "planRequiresExternalRating", null);
__decorate([
    Memoize()
], PlansUtilityService, "getExtraDataValueByName", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlansUtilityService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

/**
 * Defines the interface for sorting an array of store objects
 */
var DataKeyType;
(function (DataKeyType) {
    DataKeyType["STRING"] = "string";
    DataKeyType["NUMERIC"] = "numeric";
    DataKeyType["NUMERIC_STRING"] = "numericString";
})(DataKeyType || (DataKeyType = {}));
var SortType;
(function (SortType) {
    SortType["ASCENDING"] = "ascending";
    SortType["DESCENDING"] = "descending";
})(SortType || (SortType = {}));
var SortPrimaryKey;
(function (SortPrimaryKey) {
    SortPrimaryKey["IS_CURRENT_YEAR_PLAN"] = "isCurrentYearPlan";
})(SortPrimaryKey || (SortPrimaryKey = {}));
class SortGroup {
    constructor(key, values, comparator, sort, isDirty) {
        const comparatorValue = comparator ? comparator : values.length > 1 ? ComparatorType.IN : ComparatorType.EQUAL;
        this.groupKey = {
            key,
            values,
            comparator: comparatorValue
        };
        if (sort) {
            this.sort = sort;
        }
        this.isDirty = isDirty;
    }
}
class Sort {
    constructor(primaryKey, dataKey, secondaryDataKey, dataKeyType, sortType, displayName, display, sortTransformer, secondarySortType, isDefault, order) {
        this.primaryKey = primaryKey;
        this.dataKey = dataKey;
        this.secondaryDataKey = secondaryDataKey;
        this.dataKeyType = dataKeyType;
        this.sortType = sortType;
        this.displayName = displayName;
        this.display = display;
        if (sortTransformer) {
            this.sortTransformer = sortTransformer;
        }
        if (secondarySortType) {
            this.secondarySortType = secondarySortType;
        }
        if (isDefault) {
            this.isDefault = isDefault;
        }
        if (order !== undefined && order !== null) {
            this.order = order;
        }
    }
    static create(sortProps) {
        return new Sort(sortProps.primaryKey || SortPrimaryKey.IS_CURRENT_YEAR_PLAN, sortProps.dataKey, sortProps.secondaryDataKey, sortProps.dataKeyType, sortProps.sortType, sortProps.displayName, sortProps.display, sortProps.sortTransformer, sortProps.secondarySortType, sortProps.isDefault, sortProps.order);
    }
}

class SortUtilities {
    static matchSortGroupCompositeKey(sortGroups, sortGroupCompositeKey) {
        return sortGroups.filter(storeSortGroup => sortGroupCompositeKey?.every(tabFilter => tabFilter.groupKey &&
            storeSortGroup.groupKey &&
            tabFilter.groupKey.key === storeSortGroup.groupKey.key &&
            tabFilter.groupKey.comparator === storeSortGroup.groupKey.comparator &&
            tabFilter.groupKey.values.every(value => storeSortGroup.groupKey.values.includes(value))));
    }
    static sort(dataSet, sort) {
        // need to do this in case we get an immutable array that we need to sort
        if (dataSet && sort) {
            SortUtilities.setTieSortKeys(sort.primaryKey, sort.secondaryDataKey);
            const sortedSet = [...dataSet];
            if (sort.dataKeyType === DataKeyType.NUMERIC) {
                sortedSet.sort(SortUtilities.numericSort(sort.primaryKey, sort.dataKey, sort.secondaryDataKey, sort.sortType, sort.secondarySortType, sort.sortTransformer));
            }
            else if (sort.dataKeyType === DataKeyType.STRING) {
                sortedSet.sort(SortUtilities.stringSort(sort.primaryKey, sort.dataKey, sort.secondaryDataKey, sort.sortType, sort.secondarySortType));
            }
            else if (sort.dataKeyType === DataKeyType.NUMERIC_STRING) {
                sortedSet.sort(SortUtilities.numericStringSort(sort.primaryKey, sort.dataKey, sort.secondaryDataKey, sort.sortType, sort.secondarySortType));
            }
            return sort.sortType === SortType.DESCENDING ? sortedSet.reverse() : sortedSet;
        }
        // if we didn't sort anything return the initial dataSet as to not change the reference
        return dataSet;
    }
    static stringSort(primaryKey, key, additionalSortKey, sortType, secondarySortType) {
        return (sortItemFirst, sortItemSecond) => {
            let firstValue = _get(sortItemFirst, primaryKey);
            let secondValue = _get(sortItemSecond, primaryKey);
            if (firstValue) {
                return sortType === SortType.DESCENDING ? 1 : -1;
            }
            if (secondValue) {
                return sortType === SortType.DESCENDING ? -1 : 1;
            }
            firstValue = _get(sortItemFirst, key);
            secondValue = _get(sortItemSecond, key);
            firstValue = firstValue ? firstValue.toUpperCase() : '';
            secondValue = secondValue ? secondValue.toUpperCase() : '';
            if (firstValue < secondValue) {
                return -1;
            }
            if (firstValue > secondValue) {
                return 1;
            }
            // If its exact match then sort alphabetically
            if (additionalSortKey) {
                return SortUtilities.sortWithAdditionalKey(sortItemFirst, sortItemSecond, additionalSortKey, sortType, secondarySortType);
            }
            return SortUtilities.tieSort(sortItemFirst, sortItemSecond, sortType);
        };
    }
    static numericSort(primaryKey, key, additionalSortKey, sortType, secondarySortType, sortTransformer) {
        return (sortItemFirst, sortItemSecond) => {
            let sortIndex = -1;
            const firstValue = _get(sortItemFirst, primaryKey);
            const secondValue = _get(sortItemSecond, primaryKey);
            if (firstValue) {
                return sortType === SortType.DESCENDING ? 1 : -1;
            }
            if (secondValue) {
                return sortType === SortType.DESCENDING ? -1 : 1;
            }
            if (sortTransformer) {
                sortIndex = sortTransformer([sortItemFirst]) - sortTransformer([sortItemSecond]);
            }
            else {
                sortIndex = _get(sortItemFirst, key) - _get(sortItemSecond, key);
            }
            // If its exact match then sort alphabetically
            if (sortIndex === 0 && additionalSortKey) {
                sortIndex = SortUtilities.sortWithAdditionalKey(sortItemFirst, sortItemSecond, additionalSortKey, sortType, secondarySortType);
            }
            else if (sortIndex == 0) {
                return SortUtilities.tieSort(sortItemFirst, sortItemSecond, sortType);
            }
            return sortIndex;
        };
    }
    static numericStringSort(primaryKey, key, additionalSortKey, sortType, secondarySortType, sortTransformer) {
        return (sortItemFirst, sortItemSecond) => {
            let sortIndex = -1;
            const firstValue = _get(sortItemFirst, primaryKey);
            const secondValue = _get(sortItemSecond, primaryKey);
            if (firstValue) {
                return sortType === SortType.DESCENDING ? 1 : -1;
            }
            if (secondValue) {
                return sortType === SortType.DESCENDING ? -1 : 1;
            }
            if (sortTransformer) {
                sortIndex = sortTransformer([sortItemFirst]) - sortTransformer([sortItemSecond]);
            }
            else {
                const firstItem = _get(sortItemFirst, key);
                const evaluatedFirstItem = firstItem.match(/(\d+)/g)?.length && firstItem.match(/(\d+)/g)[0];
                const secondItem = _get(sortItemSecond, key);
                const evaluatedSecondItem = secondItem.match(/(\d+)/g)?.length && secondItem.match(/(\d+)/g)[0];
                sortIndex = Number(evaluatedFirstItem) - Number(evaluatedSecondItem);
            }
            if (isNaN(sortIndex)) {
                sortIndex = SortUtilities.stringSort(primaryKey, key, additionalSortKey, sortType, secondarySortType)(sortItemFirst, sortItemSecond);
            }
            else if (sortIndex === 0 && additionalSortKey) {
                // If its exact match then sort alphabetically
                sortIndex = SortUtilities.sortWithAdditionalKey(sortItemFirst, sortItemSecond, additionalSortKey, sortType, secondarySortType);
            }
            return SortUtilities.tieSort(sortItemFirst, sortItemSecond, sortType);
        };
    }
    static sortWithAdditionalKey(sortItemFirst, sortItemSecond, additionalSortKey, sortType, secondarySortType) {
        const firstValue = _get(sortItemFirst, additionalSortKey);
        const secondValue = _get(sortItemSecond, additionalSortKey);
        if (firstValue < secondValue) {
            if (secondarySortType && sortType !== secondarySortType) {
                return 1;
            }
            return -1;
        }
        if (firstValue > secondValue) {
            if (secondarySortType && sortType !== secondarySortType) {
                return -1;
            }
            return 1;
        }
        return SortUtilities.tieSort(sortItemFirst, sortItemSecond, sortType);
    }
    static tieSort(sortItemFirst, sortItemSecond, sortType) {
        for (let sortKey of SortUtilities.tieSortKeys) {
            let descending = sortType === SortType.DESCENDING || sortKey.sortOverwriteType === SortType.DESCENDING;
            if (sortItemFirst[sortKey.key] > sortItemSecond[sortKey.key]) {
                return descending ? -1 : 1;
            }
            else if (sortItemFirst[sortKey.key] !== sortItemSecond[sortKey.key]) {
                return descending ? 1 : -1;
            }
        }
        return 0;
    }
    static setTieSortKeys(key, additionalSortKey) {
        SortUtilities.tieSortKeys = SortUtilities.tieSortKeysOverwrite.filter(sortKey => sortKey.key !== key || sortKey.key !== additionalSortKey);
    }
    static sortByDate(date1, date2) {
        return DateUtilities.dateIsSameOrBefore(date1, date2) ? -1 : 1;
    }
}
SortUtilities.tieSortKeysOverwrite = [
    {
        key: SortLabels.ANNUAL_PLAN_PREMIUM,
        sortOverwriteType: SortType.ASCENDING
    },
    {
        key: SortLabels.PLAN_RATING,
        sortOverwriteType: SortType.DESCENDING
    },
    {
        key: SortLabels.MAXIMUM_OUT_OF_POCKET_COST,
        sortOverwriteType: SortType.ASCENDING
    },
    {
        key: SortLabels.PLAN_NAME,
        sortOverwriteType: SortType.ASCENDING
    }
];
SortUtilities.tieSortKeys = [];
__decorate([
    Memoize()
], SortUtilities, "stringSort", null);
__decorate([
    Memoize()
], SortUtilities, "numericSort", null);
__decorate([
    Memoize()
], SortUtilities, "numericStringSort", null);
__decorate([
    Memoize()
], SortUtilities, "sortWithAdditionalKey", null);
__decorate([
    Memoize()
], SortUtilities, "tieSort", null);
__decorate([
    Memoize()
], SortUtilities, "sortByDate", null);

// Note: Taken from https://github.com/mailok/todo-ngxs/blob/master/src/app/store/operators/utils.ts
// until NGXS has native support for updating many items in a single state selector
function isPredicate(value) {
    return typeof value === 'function';
}
function findIndices(predicate, existing) {
    return existing.reduce((acc, it, i) => {
        const index = predicate(it) ? i : -1;
        return invalidIndex(index) ? acc : [...acc, index];
    }, []);
}
function isArrayNumber(value) {
    for (const i in value) {
        if (!isNumber(value[i])) {
            return false;
        }
    }
    return true;
}
function invalidIndexs(indices, existing) {
    for (const i in indices) {
        if (!existing[indices[i]] || !isNumber(indices[i]) || invalidIndex(indices[i])) {
            return true;
        }
    }
    return false;
}
function isStateOperator(value) {
    return typeof value === 'function';
}
function isNumber(value) {
    return typeof value === 'number';
}
function invalidIndex(index) {
    return Number.isNaN(index) || index === -1;
}
function isObject(value) {
    return typeof value === 'object';
}

/**
 * @param selector - Array of indices or a predicate function
 */
function removeItems(selector) {
    return function removeItemsOperator(existing) {
        if (!selector || !existing) {
            return existing;
        }
        if (isPredicate(selector)) {
            // We negate the selector to filter out those values that don't meet the criteria
            return existing.filter(it => !selector(it));
        }
        else if (isArrayNumber(selector) && !invalidIndexs(selector, existing)) {
            const indices = selector;
            return existing.reduce((acc, it, index) => {
                if (!indices.includes(index)) {
                    acc.push(it);
                }
                return acc;
            }, []);
        }
        return existing;
    };
}

// SPA-8767
var ProductType;
(function (ProductType) {
    ProductType["MEDICAL"] = "1";
    ProductType["DENTAL"] = "2";
    ProductType["VISION"] = "3";
    ProductType["HC"] = "8";
})(ProductType || (ProductType = {}));
var PlanYearResourceNames;
(function (PlanYearResourceNames) {
    PlanYearResourceNames["PLAN_YEAR"] = "PlanYear";
    PlanYearResourceNames["DUAL_PLAN_YEAR"] = "DualPlanYear";
})(PlanYearResourceNames || (PlanYearResourceNames = {}));
var PlanYearType;
(function (PlanYearType) {
    PlanYearType["CURRENT"] = "current";
    PlanYearType["DUAL"] = "dual";
})(PlanYearType || (PlanYearType = {}));
const ANCILLARY_PRODUCTS = [ProductType.DENTAL, ProductType.VISION];
class PlanQuestionHttpModel {
}
class PlanAnswersHttpModel {
}
class PlanQuestionSessionModel {
}
// TODO: This could be called PlanTypeData but that type name already exists
class PlanTypeMetadata {
}
class PlanTypePlanCountMap {
}
class PlanTypeMetadataMap {
}
class PharmacyMap {
}
const PLAN_ABBREVIATION_TYPE_MAP = {
    [PlanType.MA]: PlanTypeAbbreviation.MA,
    [PlanType.MAPD]: PlanTypeAbbreviation.MAPD,
    [PlanType.PDP]: PlanTypeAbbreviation.PDP,
    [PlanType.MEDIGAP]: PlanTypeAbbreviation.MEDIGAP,
    [PlanType.DENTAL]: PlanTypeAbbreviation.DENTAL,
    [PlanType.VISION]: PlanTypeAbbreviation.VISION,
    [PlanType.HC]: PlanTypeAbbreviation.HC
};
var LinkRoles;
(function (LinkRoles) {
    LinkRoles["LINK"] = "link";
    LinkRoles["BUTTON"] = "button";
})(LinkRoles || (LinkRoles = {}));

class AddProviders {
    constructor(providers) {
        this.providers = providers;
    }
}
AddProviders.type = '[Provider] Add Providers';
class RemoveProvider {
    constructor(provider) {
        this.provider = provider;
    }
}
RemoveProvider.type = '[Provider] Remove Provider';
class ResetProvider {
}
ResetProvider.type = '[Provider] Reset Provider';
class SetSelectedProviders {
    constructor(providers) {
        this.providers = providers;
    }
}
SetSelectedProviders.type = '[Provider] Set Selected Providers';
class SetSelectedProvider {
    constructor(provider) {
        this.provider = provider;
    }
}
SetSelectedProvider.type = '[Provider] Set Selected Provider';
class UpdateSelectedProviders {
    constructor(providers) {
        this.providers = providers;
    }
}
UpdateSelectedProviders.type = '[Provider] Update Selected Providers';
class SetProviders {
    constructor(providers) {
        this.providers = providers;
    }
}
SetProviders.type = '[Provider] Set Providers';
class SetIsProviderSearchLoaded {
    constructor(isProviderLoaded) {
        this.isProviderLoaded = isProviderLoaded;
    }
}
SetIsProviderSearchLoaded.type = '[Provider] Set Provider Search Loaded';
class ResetProviderSearchLoaded {
}
ResetProviderSearchLoaded.type = '[Provider] Reset Provider Search Loaded';
class AddPrimaryCareProvider {
    constructor(primaryCareProvider) {
        this.primaryCareProvider = primaryCareProvider;
    }
}
AddPrimaryCareProvider.type = '[Provider] Add Pcp';
class RemovePrimaryCareProvider {
}
RemovePrimaryCareProvider.type = '[Provider] Remove Pcp';
class SetProvidersDetails {
    constructor(providerDetail) {
        this.providerDetail = providerDetail;
    }
}
SetProvidersDetails.type = '[Provider] Set Providers Details';
class ResetProvidersDetails {
}
ResetProvidersDetails.type = '[Provider] Reset Providers Details';

class ProviderUtilityService {
    static isWhitelistedVBC(vbcid, vbcWhitelistedId) {
        if (vbcWhitelistedId?.length > 0 && vbcid) {
            return vbcWhitelistedId.split(',').includes(vbcid);
        }
        return true;
    }
    static isVbcFilterSelected(providerFilterStates, filterName) {
        return !!providerFilterStates?.some(providerFilterState => providerFilterState.checked && providerFilterState.defaultValue === filterName);
    }
    static getUniqueProvidersNpi(providers) {
        if (providers?.length) {
            const uniqueNpis = providers.reduce((uniqueNpisAcc, provider) => {
                for (const npi of provider.npis) {
                    uniqueNpisAcc.add(npi);
                }
                return uniqueNpisAcc;
            }, new Set());
            return Array.from(uniqueNpis);
        }
        return [];
    }
    static getUniqueProvidersCount(providers) {
        const uniqueProviderIds = ProviderUtilityService.getUniqueProviderIds(providers);
        return uniqueProviderIds?.length ?? 0;
    }
    static getUniqueProviderDetailsCount(providers) {
        const uniqueProviderIds = [...new Set(providers?.map(provider => provider.providerId))];
        return uniqueProviderIds?.length ?? 0;
    }
    static getUniqueProviderIds(providers) {
        if (providers?.length) {
            const uniqueIds = new Set(providers.map(provider => provider.id));
            return Array.from(uniqueIds);
        }
        return [];
    }
    static convertProviderToProviderAddress(provider) {
        return {
            ...provider,
            ...(provider.addressId !== null && provider.addressId !== undefined && { addressId: provider.addressId.toString() }),
            inNetwork: provider?.inNetwork ?? false
        };
    }
    static convertProviderToProviderDetails(provider) {
        return {
            ...provider,
            ...(provider.addressId !== null && provider.addressId !== undefined && { addressId: provider.addressId.toString() }),
            ...(provider.latitude !== null && provider.latitude !== undefined && { latitude: provider.latitude.toString() }),
            ...(provider.longitude !== null && provider.longitude !== undefined && { longitude: provider.longitude.toString() }),
            providerId: provider.providerID ?? provider.id,
            npi: provider.npis?.[0]?.toString() ?? '',
            inNetwork: provider.inNetwork ?? false
        };
    }
    static getCoverageProviderAddresses(selectedProvider, addresses, providersAcceptingNewPatients) {
        const providerAddresses = [];
        // On Zelis, the Networks response won't include out-of-network addresses.
        // If the selected provider's address is not part of the list, that means it is out-of-network. However, we still want to display the selected address.
        const selectedAddress = !addresses?.some(address => address.addressId?.toString() === selectedProvider.addressId?.toString())
            ? addresses?.concat(ProviderUtilityService.convertProviderToProviderAddress(selectedProvider))
            : addresses;
        selectedAddress?.forEach(addressDetail => {
            // In case that we don't have all the details from the API call, we'll fall back on the provider's basic details
            const isSelectedProviderAddress = addressDetail.addressId?.toString() === selectedProvider.addressId?.toString();
            const address1 = !addressDetail.addressLine1 && isSelectedProviderAddress ? selectedProvider.address1 : addressDetail.addressLine1;
            const address2 = !addressDetail.addressLine2 && isSelectedProviderAddress ? selectedProvider.address2 : addressDetail.addressLine2;
            const city = !addressDetail.city && isSelectedProviderAddress ? selectedProvider.city : addressDetail.city;
            const state = !addressDetail.state && isSelectedProviderAddress ? selectedProvider.state : addressDetail.state;
            const languages = !addressDetail.languages?.length && isSelectedProviderAddress ? selectedProvider.languages : addressDetail.languages;
            const acceptingNewPatients = !!providersAcceptingNewPatients?.find(provider => provider.firstName === selectedProvider.firstName &&
                provider.lastName === selectedProvider.lastName &&
                provider.addressId.toString() === selectedProvider.addressId?.toString())?.acceptingNewPatients;
            const fullAddressDetail = {
                ...addressDetail,
                city,
                state,
                address1,
                address2,
                addressLine1: address1,
                addressLine2: address2,
                acceptingNewPatients,
                languages: languages ?? []
            };
            if (isSelectedProviderAddress) {
                providerAddresses.unshift(fullAddressDetail);
            }
            else if (fullAddressDetail.inNetwork) {
                providerAddresses.push(fullAddressDetail);
            }
        });
        return providerAddresses;
    }
    static matchProviderDetailInfo(options) {
        const { providerDetails, selectedProvider, checkIfSameAddress, checkIfInNetwork } = options;
        return providerDetails?.find(providerDetail => 
        // On Zelis, some providers (like facilities) won't have an NPI available.
        // In those cases, the provider ID will be included and the NPI will be null.
        (providerDetail.providerId === selectedProvider.id ||
            (providerDetail.npi && selectedProvider.npis.includes(+providerDetail.npi))) &&
            (!checkIfSameAddress || providerDetail.addressId?.toString() === selectedProvider.addressId?.toString()) &&
            (!checkIfInNetwork || providerDetail.inNetwork));
    }
}
ProviderUtilityService.ɵfac = function ProviderUtilityService_Factory(t) { return new (t || ProviderUtilityService)(); };
ProviderUtilityService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ProviderUtilityService, factory: ProviderUtilityService.ɵfac, providedIn: 'root' });
__decorate([
    Memoize()
], ProviderUtilityService, "isWhitelistedVBC", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProviderUtilityService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

var ProviderState_1;
class ProviderStateModel {
}
const PROVIDER_DEFAULTS = {
    selectedProviders: [],
    providers: [],
    providerDetails: null,
    isProviderLoaded: false
};
let ProviderState = ProviderState_1 = class ProviderState {
    static flattenAndFormatProviders(rawProviders) {
        return (rawProviders?.reduce((formattedProviders, rawProvider) => {
            const providerAddressEntries = rawProvider.addresses?.length
                ? ProviderState_1.getProviderAddresses(rawProvider)
                : [rawProvider];
            formattedProviders.push(...providerAddressEntries.map(rawProvider => ProviderState_1.addDisplayFields(rawProvider)));
            return formattedProviders;
        }, []) ?? []);
    }
    static formatSelectedProviders(rawProviders) {
        return rawProviders?.map(rawProvider => ProviderState_1.addDisplayFields(rawProvider)) ?? [];
    }
    static addDisplayFields(rawProvider) {
        return {
            ...rawProvider,
            // On Zelis, facilities won't have a display name. Instead, we should use the organization name.
            displayName: !rawProvider.isIndividual && !rawProvider.displayName?.trim() ? rawProvider.organizationName : rawProvider.displayName,
            addresses: ProviderState_1.getProviderAddresses(rawProvider),
            specialtyDisplayName: [rawProvider.specialty, rawProvider.subSpecialty].filter(obj => !!obj).join(', ')
        };
    }
    static getProviderAddresses(provider) {
        return (provider?.addresses?.map(address => {
            return {
                ...provider,
                ...address,
                isPrimary: address.addressId?.toString() === provider.addressId?.toString() && !!provider.isPrimary
            };
        }) ?? []);
    }
    static rawSelectedProviders(state) {
        return state.selectedProviders;
    }
    static hasSelectedProviders(rawSelectedProviders) {
        return !!rawSelectedProviders?.length;
    }
    static selectedProvidersId(rawSelectedProviders) {
        return ProviderUtilityService.getUniqueProviderIds(rawSelectedProviders);
    }
    static selectedProvidersNpi(rawSelectedProviders) {
        return ProviderUtilityService.getUniqueProvidersNpi(rawSelectedProviders);
    }
    static selectedProviders(rawSelectedProviders) {
        return ProviderState_1.formatSelectedProviders(rawSelectedProviders);
    }
    static selectedPCP(selectedProviders) {
        return selectedProviders?.find(selectedProvider => selectedProvider.isPrimary) ?? null;
    }
    static hasSelectedPCP(selectedPCP) {
        return !!selectedPCP;
    }
    static rawProviders(state) {
        return state.providers;
    }
    static hasProviders(rawProviders) {
        return !!rawProviders?.length;
    }
    static flattenedProviders(rawProviders) {
        return ProviderState_1.flattenAndFormatProviders(rawProviders);
    }
    static providers(flattenedProviders) {
        return flattenedProviders ?? [];
    }
    static filterProviders(providerFilterStates, vbcWhitelistedId, individualProviderFilterLabel, facilitiesProviderFilterLabel, valueBasedCareProviderFilterLabel) {
        return createSelector([ProviderState_1.providers], (providers) => {
            const filteredProviders = [];
            if (providerFilterStates?.length) {
                const isVbcSelected = ProviderUtilityService.isVbcFilterSelected(providerFilterStates, valueBasedCareProviderFilterLabel);
                providerFilterStates.forEach(filterState => {
                    if (filterState.checked) {
                        switch (filterState.defaultValue) {
                            case individualProviderFilterLabel:
                                filteredProviders.push(...providers.filter(provider => isVbcSelected
                                    ? provider.valueBasedCare?.vbcid &&
                                        ProviderUtilityService.isWhitelistedVBC(provider.valueBasedCare.vbcid, vbcWhitelistedId) &&
                                        provider.isIndividual
                                    : provider.isIndividual));
                                break;
                            case facilitiesProviderFilterLabel:
                                filteredProviders.push(...providers.filter(provider => isVbcSelected
                                    ? provider.valueBasedCare?.vbcid &&
                                        ProviderUtilityService.isWhitelistedVBC(provider.valueBasedCare.vbcid, vbcWhitelistedId) &&
                                        !provider.isIndividual
                                    : !provider.isIndividual));
                                break;
                        }
                    }
                });
            }
            return filteredProviders;
        });
    }
    static filteredProviders(providerFilterStates, vbcWhitelistedId, individualProviderFilterLabel, facilitiesProviderFilterLabel, valueBasedCareProviderFilterLabel) {
        return createSelector([
            ProviderState_1.filterProviders(providerFilterStates, vbcWhitelistedId, individualProviderFilterLabel, facilitiesProviderFilterLabel, valueBasedCareProviderFilterLabel)
        ], (filteredProviders) => filteredProviders ?? []);
    }
    static selectedPrimaryCareProvider(state) {
        return state.primaryCareProvider;
    }
    static providerDetails(state) {
        return state.providerDetails;
    }
    static isProviderSearchLoaded(state) {
        return state.isProviderLoaded;
    }
    setSelectedProviders(ctx, action) {
        const providers = action.providers;
        ctx.setState(patch({
            selectedProviders: providers
        }));
    }
    setProviderDetails(ctx, action) {
        const providerDetails = action.providerDetail;
        ctx.setState(patch({
            providerDetails
        }));
    }
    resetProviderDetails(ctx) {
        ctx.setState(patch({
            providerDetails: null
        }));
    }
    resetProvider({ patchState }) {
        patchState({
            selectedProviders: []
        });
    }
    ResetProviderSearchLoaded({ patchState }) {
        patchState({
            isProviderLoaded: false
        });
    }
    addProviders(ctx, action) {
        const providers = action.providers;
        ctx.setState(patch({
            selectedProviders: append(providers)
        }));
    }
    AddPrimaryCareProvider(ctx, action) {
        const primaryCareProvider = action.primaryCareProvider;
        ctx.setState(patch({
            primaryCareProvider
        }));
    }
    RemovePrimaryCareProvider({ patchState }) {
        patchState({
            primaryCareProvider: null
        });
    }
    removeProvider(ctx, action) {
        ctx.setState(patch({
            selectedProviders: removeItem(provider => action.provider &&
                provider.id === action.provider.id &&
                provider.addressId?.toString() === action.provider.addressId?.toString())
        }));
    }
    UpdateSelectedProviders({ setState }, { providers }) {
        if (providers?.length) {
            const updateSelectedProvidersOperation = providers.map(provider => updateItem(selectedProvider => selectedProvider.id === provider.id && selectedProvider.addressId?.toString() === provider.addressId?.toString(), patch({ ...provider })));
            setState(patch({
                selectedProviders: compose(...updateSelectedProvidersOperation)
            }));
        }
    }
    setProviders(ctx, action) {
        const updatedProviders = action.providers;
        ctx.setState(patch({
            providers: updatedProviders
        }));
    }
    SetIsProviderSearchLoaded(ctx, action) {
        ctx.setState(patch({
            isProviderLoaded: action.isProviderLoaded
        }));
    }
};
ProviderState.ɵfac = function ProviderState_Factory(t) { return new (t || ProviderState)(); };
ProviderState.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ProviderState, factory: ProviderState.ɵfac });
__decorate([
    Action(SetSelectedProviders)
], ProviderState.prototype, "setSelectedProviders", null);
__decorate([
    Action(SetProvidersDetails)
], ProviderState.prototype, "setProviderDetails", null);
__decorate([
    Action(ResetProvidersDetails)
], ProviderState.prototype, "resetProviderDetails", null);
__decorate([
    Action(ResetProvider)
], ProviderState.prototype, "resetProvider", null);
__decorate([
    Action(ResetProviderSearchLoaded)
], ProviderState.prototype, "ResetProviderSearchLoaded", null);
__decorate([
    Action(AddProviders)
], ProviderState.prototype, "addProviders", null);
__decorate([
    Action(AddPrimaryCareProvider)
], ProviderState.prototype, "AddPrimaryCareProvider", null);
__decorate([
    Action(RemovePrimaryCareProvider)
], ProviderState.prototype, "RemovePrimaryCareProvider", null);
__decorate([
    Action(RemoveProvider)
], ProviderState.prototype, "removeProvider", null);
__decorate([
    Action(UpdateSelectedProviders)
], ProviderState.prototype, "UpdateSelectedProviders", null);
__decorate([
    Action(SetProviders)
], ProviderState.prototype, "setProviders", null);
__decorate([
    Action(SetIsProviderSearchLoaded)
], ProviderState.prototype, "SetIsProviderSearchLoaded", null);
__decorate([
    Selector()
], ProviderState, "rawSelectedProviders", null);
__decorate([
    Selector([ProviderState_1.rawSelectedProviders])
], ProviderState, "hasSelectedProviders", null);
__decorate([
    Selector([ProviderState_1.rawSelectedProviders])
], ProviderState, "selectedProvidersId", null);
__decorate([
    Selector([ProviderState_1.rawSelectedProviders])
], ProviderState, "selectedProvidersNpi", null);
__decorate([
    Selector([ProviderState_1.rawSelectedProviders])
], ProviderState, "selectedProviders", null);
__decorate([
    Selector([ProviderState_1.selectedProviders])
], ProviderState, "selectedPCP", null);
__decorate([
    Selector([ProviderState_1.selectedPCP])
], ProviderState, "hasSelectedPCP", null);
__decorate([
    Selector()
], ProviderState, "rawProviders", null);
__decorate([
    Selector([ProviderState_1.rawProviders])
], ProviderState, "hasProviders", null);
__decorate([
    Selector([ProviderState_1.rawProviders])
], ProviderState, "flattenedProviders", null);
__decorate([
    Selector([ProviderState_1.flattenedProviders])
], ProviderState, "providers", null);
__decorate([
    Selector()
], ProviderState, "selectedPrimaryCareProvider", null);
__decorate([
    Selector()
], ProviderState, "providerDetails", null);
__decorate([
    Selector()
], ProviderState, "isProviderSearchLoaded", null);
ProviderState = ProviderState_1 = __decorate([
    State({
        name: 'provider',
        defaults: PROVIDER_DEFAULTS
    })
], ProviderState);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProviderState, [{
        type: Injectable
    }], null, { setSelectedProviders: [], setProviderDetails: [], resetProviderDetails: [], resetProvider: [], ResetProviderSearchLoaded: [], addProviders: [], AddPrimaryCareProvider: [], RemovePrimaryCareProvider: [], removeProvider: [], UpdateSelectedProviders: [], setProviders: [], SetIsProviderSearchLoaded: [] }); })();

class PlanYearContextService {
    constructor() {
        this._hasPlanYearPermissionError$ = new BehaviorSubject(null);
    }
    setPlanYearPermissionMediatorError(hasError) {
        this._hasPlanYearPermissionError$.next(hasError);
    }
    // This is a mediator for setting the NGXS state because we need to be able to set
    // hasPlanYearPermissionError from the catch block of the http call. If looking to get
    // the latest value of hasPlanYearPermissionError grab the store value rather than this.
    getPlanYearPermissionMediatorError$() {
        return this._hasPlanYearPermissionError$.asObservable();
    }
}
PlanYearContextService.ɵfac = function PlanYearContextService_Factory(t) { return new (t || PlanYearContextService)(); };
PlanYearContextService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PlanYearContextService, factory: PlanYearContextService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanYearContextService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

class PlansHttpService {
    constructor(http, planYearContextService) {
        this.http = http;
        this.planYearContextService = planYearContextService;
        this.environment = EnvironmentService.getEnvironment();
    }
    retrievePlanQuestions$(zipCode, countyFIPS, year, effectiveDate, productType) {
        const headers = new HttpHeaders({ Accept: 'application/json' });
        const params = new HttpParams()
            .set('zip', zipCode)
            .set('fips', countyFIPS)
            .set('year', year)
            .set('effectiveDate', effectiveDate)
            .set('ProductType', productType);
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v1/plans/PlanQuestions`, {
            params,
            headers
        });
    }
    async retrievePlanQuestions(zipCode, countyFIPS, year, effectiveDate, productType) {
        return await this.retrievePlanQuestions$(zipCode, countyFIPS, year, effectiveDate, productType).toPromise();
    }
    setPlanAnswers$(id, year, effectiveDate, productType, planQuestionRequest) {
        // we cannot return a null answer, give a blank value for any questions we did not answer
        const questionRequest = planQuestionRequest.map(question => ({
            ...question,
            answer: question.answer ?? {
                questionID: question.planQuestionID,
                value: ''
            }
        }));
        return this.http.post(`${this.environment.MEMBER_SESSION_BASE_URL}/${id}/PlanAnswers?year=${year}&effectiveDate=${effectiveDate}&productTypeID=${productType}`, { questionRequest });
    }
    initiatePlanSmart$(planSmartPayload) {
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/PlanSmart/Init`, planSmartPayload);
    }
    fetchPlanSmartState$(agentGuid, planYear) {
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v1/PlanSmart/Status?agentGuid=${agentGuid}&planYear=${planYear}`);
    }
    fetchPlanSmartReports$(agentGuid, planYear) {
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/PlanSmart/Get?agentGuid=${agentGuid}&planYear=${planYear}`, {});
    }
    async setPlanAnswers(id, year, effectiveDate, productType, medigapQuestionRequest) {
        await this.setPlanAnswers$(id, year, effectiveDate, productType, medigapQuestionRequest).toPromise();
    }
    retrieveCurrentPlanInfo$(demographics, search, misc, planId, medicalCostInputs, includeBenefits) {
        const plansRequestBody = {
            demographics: {
                ...demographics,
                subsidySelected: demographics.subsidySelected === SubsidySelected.DONT_KNOW ? null : demographics.subsidySelected
            },
            search,
            ...misc,
            medicalCostInputs,
            includeBenefits
        };
        const headers = new HttpHeaders({ Accept: 'application/json' });
        const options = { headers, params: null };
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v2/BeneficiaryPreferences/CurrentPlanInfo?id=${planId}`, plansRequestBody, options);
    }
    retrievePlans$(demographics, search, misc, ids = [], medicalCostInputs, includeBenefits) {
        const plansRequestBody = {
            demographics: {
                ...demographics,
                subsidySelected: demographics.subsidySelected === SubsidySelected.DONT_KNOW ? null : demographics.subsidySelected
            },
            search,
            ...misc,
            medicalCostInputs,
            includeBenefits
        };
        const headers = new HttpHeaders({ Accept: 'application/json' });
        let options = { headers, params: null };
        if (ids?.length > 0) {
            options = { ...options, params: new HttpParams().set('id', ids.join(',')) };
        }
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/plans`, plansRequestBody, options).pipe(catchError((error) => {
            const errorBody = error?.error;
            const hasAgentPlanYearPermissionError = errorBody?.Title === AgentSellingPermissionError.NO_AGENT_PLAN_YEAR_PERMISSIONS;
            if (errorBody?.Status === HttpStatusCode.NOT_FOUND &&
                (errorBody?.Title === AgentSellingPermissionError.NO_ASP_ALP_TITLE || hasAgentPlanYearPermissionError)) {
                if (hasAgentPlanYearPermissionError) {
                    this.planYearContextService.setPlanYearPermissionMediatorError(true);
                }
                const errorResponse = new PlansHttpResponse();
                errorResponse.data = [];
                errorResponse.medicalBenefits = [];
                errorResponse.planPharmacyData = [];
                errorResponse.totalCount = 0;
                return of(errorResponse);
            }
            throw error;
        }));
    }
    retrievePlanShortData$(demographics, search, misc, includeExtendedProviderData, includeBenefits) {
        const plansRequestBody = {
            demographics: {
                ...demographics,
                subsidySelected: demographics.subsidySelected === SubsidySelected.DONT_KNOW ? null : demographics.subsidySelected
            },
            search,
            ...misc,
            includeExtendedProviderData,
            includeBenefits
        };
        const headers = new HttpHeaders({ Accept: 'application/json' });
        const options = { headers, params: null };
        return this.http
            .post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/plans/short`, plansRequestBody, options)
            .pipe(catchError((error) => {
            const errorBody = error?.error;
            if (errorBody?.Status === HttpStatusCode.NOT_FOUND && errorBody?.Title === AgentSellingPermissionError.NO_ASP_ALP_TITLE) {
                const errorResponse = new PlansShortHttpResponse();
                return of(errorResponse);
            }
            throw error;
        }));
    }
    async retrievePlans(demographics, search, misc, ids = []) {
        return await this.retrievePlans$(demographics, search, misc, ids).toPromise();
    }
    async trackPlanListInfo(appSessionID, memberID, siteID, agentID, zipCode, fipsCode, planType, planCount, topTenPlanID, filtersSelected, sortSelection, userActionType, bestMatchPlanId, bestMatchPlanType) {
        return await this.trackPlanListInfo$(appSessionID, memberID, siteID, agentID, zipCode, fipsCode, planType, planCount, topTenPlanID, filtersSelected, sortSelection, userActionType, bestMatchPlanId, bestMatchPlanType).toPromise();
    }
    trackPlanListInfo$(appSessionID, memberID, siteID, agentID, zipCode, fipsCode, planType, planCount, topTenPlanID, filtersSelected, sortSelection, userActionType, bestMatchPlanId, bestMatchPlanType) {
        const capturePlansRequestBody = {
            appSessionID,
            memberID,
            siteID,
            agentID,
            zipCode,
            fipsCode,
            planType,
            planCount,
            topTenPlanID,
            filtersSelected,
            sortSelection,
            userActionType,
            bestMatchPlanId,
            bestMatchPlanType
        };
        const environment = EnvironmentService.getEnvironment();
        const headers = new HttpHeaders({ Accept: 'application/json' });
        const options = { headers, params: null };
        return this.http.post(`${environment.WEB_SERVICE_BASE_URL}/v1/plans/PlanListInfoHistory`, capturePlansRequestBody, options);
    }
    getPlanEnrollmentSettings$(planId, requestParams) {
        const headers = new HttpHeaders();
        let params = new HttpParams();
        if (requestParams) {
            const { showUAT, formType, userType } = requestParams;
            params = params.set('showUAT', `${showUAT}`);
            if (formType !== null && formType !== undefined) {
                params = params.set('formType', `${formType}`);
            }
            if (userType !== null && userType !== undefined) {
                params = params.set('userType', `${userType}`);
            }
        }
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v1/plans/${planId}/EnrollmentSetting`, {
            params,
            headers
        });
    }
    async getPlanEnrollmentSettings(planId, requestParams) {
        return await this.getPlanEnrollmentSettings$(planId, requestParams).toPromise();
    }
    getMedBenefits$(demographicOptions, searchOptions, medigapAnswers, agentGuid, drugs, pharmacies, currentYearPlanID) {
        const headers = new HttpHeaders({ Accept: 'application/json' });
        const body = {
            demographics: demographicOptions,
            search: searchOptions,
            medigapAnswers,
            drugs,
            pharmacies,
            currentYearPlanID,
            agentGuid
        };
        const options = { headers, params: null };
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/plans/MedBenefits`, body, options);
    }
    async getMedBenefits(demographicOptions, searchOptions, medigapAnswers, agentGuid, drugs, pharmacies, currentYearPlanID) {
        return await this.getMedBenefits$(demographicOptions, searchOptions, medigapAnswers, agentGuid, drugs, pharmacies, currentYearPlanID).toPromise();
    }
    // name mediGapAnswers used to mimic API call exactly. It should actually just be the answers to every form, not just medsup.
    getExternallyRatedPlanData$(mediGapAnswers, planIDs) {
        const body = { mediGapAnswers, planIDs };
        const options = { headers: new HttpHeaders({ Accept: 'application/json' }), params: null };
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Plans/ExternalRatingService`, body, options);
    }
    async getExternallyRatedPlanData(mediGapAnswers, planIDs) {
        return await this.getExternallyRatedPlanData$(mediGapAnswers, planIDs).toPromise();
    }
    retrieveDrugAlternatives$(planId, demographics, drugs, pharmacies) {
        const plansRequestBody = {
            demographics,
            drugs,
            pharmacies
        };
        const headers = new HttpHeaders({ Accept: 'application/json' });
        const options = { headers, params: null };
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/plans/${planId}/DrugAlternatives`, plansRequestBody, options);
    }
    getPlanData$(planId, planDataKey, cultureCode) {
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Plans/${planId}/PlanData?requestedData=${planDataKey}${cultureCode ? `&cultureCode=${cultureCode}` : ''}`);
    }
    getPlansFees$(planIds) {
        const requestBody = { ids: planIds };
        const headers = new HttpHeaders({ Accept: 'application/json' });
        const options = { headers, params: null };
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/plans/PlanFees`, requestBody, options);
    }
    getCurrentPlanFilterGroup$(zip, countyFips, planYear, planType) {
        const requestBody = { zip, countyFips, planYear, planType };
        const headers = new HttpHeaders({ Accept: 'application/json' });
        const options = { headers, params: null };
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v2/BeneficiaryPreferences/Search`, requestBody, options);
    }
    updateCurrentPlanShort$(SessionID, currentPlanShort) {
        const requestBody = { ...currentPlanShort };
        const headers = new HttpHeaders({ Accept: 'application/json' });
        const options = { headers, params: null };
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v2/BeneficiaryPreferences/${SessionID}/CurrentPlan`, requestBody, options);
    }
    getCurrentPlanShort$(SessionID) {
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v2/BeneficiaryPreferences/${SessionID}/CurrentPlan`);
    }
    updateNextYearPlanShort$(SessionID, nextYearPlanShort) {
        const requestBody = { ...nextYearPlanShort };
        const headers = new HttpHeaders({ Accept: 'application/json' });
        const options = { headers, params: null };
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v2/BeneficiaryPreferences/${SessionID}/NextYearPlan`, requestBody, options);
    }
}
PlansHttpService.ɵfac = function PlansHttpService_Factory(t) { return new (t || PlansHttpService)(i0.ɵɵinject(i1$2.HttpClient), i0.ɵɵinject(PlanYearContextService)); };
PlansHttpService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PlansHttpService, factory: PlansHttpService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlansHttpService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1$2.HttpClient }, { type: PlanYearContextService }]; }, null); })();

class CarriersHttpService {
    constructor(http) {
        this.http = http;
        this.environment = EnvironmentService.getEnvironment();
    }
    carrierCount$(zip, fips, planYear, agentGuid) {
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Carriers/CarriersCount`, {
            zip,
            fips,
            planYear,
            agentGuid
        });
    }
}
CarriersHttpService.ɵfac = function CarriersHttpService_Factory(t) { return new (t || CarriersHttpService)(i0.ɵɵinject(i1$2.HttpClient)); };
CarriersHttpService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CarriersHttpService, factory: CarriersHttpService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CarriersHttpService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1$2.HttpClient }]; }, null); })();

var PlansState_1;
class APIPlanStateModel {
}
// TODO: Loading being controlled entirely by outside code means that there can (and have) been scenarios (such as plans list analytics)
// where something updates off of "loading" setting to false, but the payload has not actually been updated. We need to update loading
// so that it's more tightly controlled, probably by being set true only by the service calling out for the plans, and set false when
// the payload is updated, aka at the same time as loaded.
class PlansStateModel extends APIPlanStateModel {
}
const PLAN_TYPE_DATA_MAP_DEFAULTS = { loading: false, loaded: false, dirty: true, pharmacies: [], payload: {} };
const PLANS_DEFAULTS = {
    activePlansTabType: null,
    activePlanDetailsTabType: null,
    defaultPlansTabType: null,
    error: null,
    filterGroups: [],
    planTypeDataMap: {
        7: PLAN_TYPE_DATA_MAP_DEFAULTS
    },
    planCounts: {},
    planScores: {},
    planCoveredPreferences: {},
    planShortLoading: false,
    sortGroups: [],
    loadingAncillaryQuestions: false,
    ancillaryQuestions: [],
    ancillaryAnswers: {},
    loadingHospitalIndemnityQuestions: false,
    hospitalIndemnityQuestions: [],
    hospitalIndemnityAnswers: {},
    planComparePlanType: null,
    compareGroups: [],
    quoteGroups: [],
    includePUFPlans: false,
    includeNonLicensedPlans: false,
    isTotalEstimatedCostAnnually: true,
    isActiveTabTotalCost: false,
    isActiveTabPrescription: false,
    activeRateFactorPlanId: null,
    snpVisibility: { dSNP: null, iSNP: null, cSNP: null },
    selectedPlanSubType: '',
    plansQueuePosition: [],
    plansRiderBenefitCategories: {},
    daysBenefitMappings: [],
    selectedPlanYearType: PlanYearType.CURRENT,
    selectedPlanYear: null,
    planSmartReports: {},
    hasPlanYearPermissionError: false,
    planSmartSort: {},
    planSmartLoading: false,
    selectedPlanSmartDetails: null,
    planSmartFilterGroup: {},
    totalSiteCarrierCount: null,
    totalSitePlanCount: null,
    medicareGroupPlanConfiguration: null,
    planYearSiteCarrierCount: null,
    planYearSitePlanCount: null,
    dualPlanYearSiteCarrierCount: null,
    dualPlanYearSitePlanCount: null,
    currentPlanShort: null,
    currentPlanTypeDataMap: {
        7: PLAN_TYPE_DATA_MAP_DEFAULTS
    }
};
let PlansState = PlansState_1 = class PlansState {
    constructor(store, plansHttpService, carriersHttpService) {
        this.store = store;
        this.plansHttpService = plansHttpService;
        this.carriersHttpService = carriersHttpService;
        this.comparePlanUtilities = new CompareUtilities();
    }
    // IF we decide to call for multiple different plan types at once we will need to funnel these in to their
    // respect buckets by planType. Most of the this time this shouldn't happen but we need to account for it
    // We could also possibly do this when we call mergeResponseArray but we ideally don't want to directly
    // manipulate the response more than we have to
    static createPlanBuckets(plans, planTypes) {
        return (planTypes?.reduce((bucket, planType) => {
            bucket[planType] = PlansUtilityService.getPlansOfType(plans, planType);
            return bucket;
        }, {}) ?? {});
    }
    static getBestMatchPlan(filteredPlans, availableTabs, coverageTypeAbbreviation) {
        const plansWithScores = filteredPlans.filter(plan => !!plan.score && availableTabs.includes(plan.planTypeAbbreviation));
        if (plansWithScores?.length) {
            return PlansState_1.getHighestRatedPlan(plansWithScores, coverageTypeAbbreviation);
        }
        return null;
    }
    static getComparePlanData(plan) {
        return { id: plan.id, planTypeAbbreviation: plan.planTypeAbbreviation };
    }
    static getHighestRatedPlan(plansWithScores, coverageTypeAbbreviation) {
        let isBestPlanMatch = false;
        const highestRatedPlanFound = plansWithScores.reduce((prevPlan, currentPlan) => {
            let highestRatedPlan = prevPlan;
            const currentPlanScore = currentPlan?.score ?? 0;
            const prevPlanScore = prevPlan?.score ?? 0;
            const currentPlanTotalEstimatedCost = currentPlan?.planAnnualCost?.annualCost?.totalEstimatedCost ?? 0;
            const prevPlanTotalEstimatedCost = prevPlan?.planAnnualCost?.annualCost?.totalEstimatedCost ?? 0;
            if (currentPlanScore) {
                if (currentPlanScore > prevPlanScore) {
                    highestRatedPlan = currentPlan;
                    isBestPlanMatch = true;
                }
                else if (prevPlanScore === currentPlanScore) {
                    // If 2+ plans are tied in score and totalEstimatedCost on different plan type but user has answered ‘interested coverage type'
                    // and only one of the tied plans is on that page, we can conclude that one is the ‘best match plan'.
                    // If the tie is in ‘interested coverage type' or  across plan types but nothing else is answered,
                    // we don’t have enough information to indicate a 'best match’
                    if (prevPlanTotalEstimatedCost === currentPlanTotalEstimatedCost) {
                        if (coverageTypeAbbreviation && currentPlan.planTypeAbbreviation === coverageTypeAbbreviation) {
                            if (currentPlan.planTypeAbbreviation !== prevPlan.planTypeAbbreviation) {
                                highestRatedPlan = currentPlan;
                                isBestPlanMatch = true;
                            }
                            else {
                                // if currentPlan has the same plan type as previous higuest rated plan, then there is no best match
                                isBestPlanMatch = false;
                            }
                        }
                        else {
                            isBestPlanMatch = false;
                        }
                    }
                    else if (currentPlanTotalEstimatedCost < prevPlanTotalEstimatedCost) {
                        highestRatedPlan = currentPlan;
                        isBestPlanMatch = true;
                    }
                }
            }
            return highestRatedPlan;
        });
        return isBestPlanMatch ? highestRatedPlanFound : null;
    }
    static isPlanTypeLoading(planType, planTypeDataMap) {
        const planTypeKey = PlansUtilityService.getPlanBucketKey(planType);
        const planTypeData = planTypeDataMap[planTypeKey];
        return planTypeData ? !!planTypeData.loading : false;
    }
    static isPlanTypeLoaded(planType, planTypeDataMap) {
        const planTypeKey = PlansUtilityService.getPlanBucketKey(planType);
        const planTypeData = planTypeDataMap[planTypeKey];
        return planTypeData ? !!planTypeData.loaded : false;
    }
    static isPlanTypeDirty(planType, planTypeDataMap) {
        const planTypeKey = PlansUtilityService.getPlanBucketKey(planType);
        const planTypeData = planTypeDataMap[planTypeKey];
        return planTypeData ? !!planTypeData.dirty : true;
    }
    // NOTE: Only to be used for live edit. We should normally be accessing this
    // via selectors/actions in the rest of the application.
    static getDefaultPlanTypeDataMap() {
        return _cloneDeep(PLANS_DEFAULTS.planTypeDataMap);
    }
    // Specific to live edit for now. Could expand the use of this but we need to explicitly
    // know the planTypes that were called for and not just returned so we can't use this as
    // a replacement for patching the store since we could call for multiple plan types and only
    // get plans for the one type back. If we are deriving from the plan types in plans list we will
    // not remove plans for the one type as we will have no indicator they have changed.
    static mapToPlanTypeMetadataMap(plans) {
        const allPlanTypes = plans.map(plan => plan.planType);
        const planTypes = Array.from(new Set(allPlanTypes));
        const hasMedicareTypes = planTypes.some(planType => PlansUtilityService.isSingleMedicareType(planType));
        let planBucketTypes = planTypes;
        if (hasMedicareTypes) {
            planBucketTypes = planTypes.filter(type => !MEDICARE_PLAN_TYPE_VALUES.includes(type));
            planBucketTypes.push(ALL_MEDICARE_PLAN_TYPE_VALUE);
        }
        const planBuckets = PlansState_1.createPlanBuckets(plans, planBucketTypes);
        const planTypeDataMap = PlansState_1.getDefaultPlanTypeDataMap();
        Object.keys(planBuckets).forEach(key => {
            planTypeDataMap[+key].payload = planBuckets[key];
            planTypeDataMap[+key].dirty = false;
            planTypeDataMap[+key].loaded = true;
            planTypeDataMap[+key].loading = false;
        });
        return planTypeDataMap;
    }
    static reformatPlanSmartResponse(planSmartResponse) {
        planSmartResponse?.data.forEach(reportDetail => {
            const planSmartResults = reportDetail?.planSmartResults || [];
            if (planSmartResults.length && reportDetail?.memberRequest) {
                const currentYearPlan = planSmartResults.find(planSmartResult => planSmartResult.isCurrentYearPlan);
                const lowestCostPlanPCPInNetwork = planSmartResults.some(planSmartResult => planSmartResult.isLowestCostPlan && planSmartResult.considerPCPInNetwork);
                reportDetail.memberRequest = {
                    ...reportDetail.memberRequest,
                    currentYearCarrierName: currentYearPlan?.carrierName || '',
                    lowestCostPlanPCPInNetwork
                };
            }
        });
        return planSmartResponse;
    }
    static filterPlans(plans, filters) {
        let result = [];
        if (plans.length > 0 && filters.length > 0) {
            const filteredPlans = FilterUtilities.filter(plans, filters);
            result = PlansState_1.checkAndRemoveDuplicatedComboPlans({ plans: filteredPlans, filters });
        }
        return result;
    }
    static loadingAncillaryQuestions(state) {
        return state.loadingAncillaryQuestions;
    }
    static ancillaryQuestions(state) {
        return state.ancillaryQuestions;
    }
    static hasAncillaryQuestions(state) {
        return state.ancillaryQuestions?.length > 0;
    }
    static rawAncillaryAnswers() {
        return createSelector([PlansState_1], (state) => state.ancillaryAnswers);
    }
    static ancillaryAnswers(ancillaryAnswers, hasAncillaryAnswers) {
        return RateFactorsUtilityService.getAnswers(ancillaryAnswers, hasAncillaryAnswers);
    }
    static hasAncillaryAnswers() {
        return createSelector([PlansState_1.rawAncillaryAnswers()], (ancillaryAnswers) => RateFactorsUtilityService.hasAnswers(ancillaryAnswers));
    }
    static areAllAncillaryQuestionsAnswered(ancillaryQuestions, ancillaryAnswers) {
        return ancillaryQuestions.every(question => {
            if (question.questionId === MedSupPlanQuestionIds.EffectiveDate && ancillaryAnswers[question.name]) {
                return !DateUtilities.isPastMonth(ancillaryAnswers[question.name]);
            }
            return ancillaryAnswers[question.name] !== undefined;
        });
    }
    static loadingHospitalIndemnityQuestions(state) {
        return state.loadingHospitalIndemnityQuestions;
    }
    static hospitalIndemnityQuestions(state) {
        return state.hospitalIndemnityQuestions;
    }
    static hasHospitalIndemnityQuestions(hospitalIndemnityQuestions) {
        return hospitalIndemnityQuestions?.length > 0;
    }
    static rawHospitalIndemnityAnswers() {
        return createSelector([PlansState_1], (state) => state.hospitalIndemnityAnswers);
    }
    static hospitalIndemnityAnswers(hospitalIndemnityAnswers, hasHospitalIndemnityAnswers) {
        return RateFactorsUtilityService.getAnswers(hospitalIndemnityAnswers, hasHospitalIndemnityAnswers);
    }
    static daysBenefitMappings(state) {
        return state.daysBenefitMappings;
    }
    static planSmartReports(state) {
        return state.planSmartReports;
    }
    static planSmartSorts(state) {
        return state.planSmartSort;
    }
    static selectedPlanSmartDetails(state) {
        return state.selectedPlanSmartDetails;
    }
    static selectedPlanYearType(state) {
        return state.selectedPlanYearType;
    }
    static selectedPlanYear(state) {
        return state.selectedPlanYear ? `${state.selectedPlanYear}` : null;
    }
    static hasPlanYearPermissionError(state) {
        return state.hasPlanYearPermissionError;
    }
    static hasHospitalIndemnityAnswers() {
        return createSelector([PlansState_1.rawHospitalIndemnityAnswers()], (hospitalIndemnityAnswers) => RateFactorsUtilityService.hasAnswers(hospitalIndemnityAnswers));
    }
    static areAllHospitalIndemnityQuestionsAnswered(questionMetaDataModel) {
        // Getting the sorted questions (filtered by resource metadata) will prevent us from checking the upcoming rate factors (future story)
        // questionId: 30, name: "BenefitAmount"
        // questionId: 31, name: "HCDaysCovered"
        return createSelector([PlansState_1.sortedHospitalIndemnityQuestions(questionMetaDataModel), PlansState_1.hospitalIndemnityAnswers], (hospitalIndemnityQuestions, hospitalIndemnityAnswers) => hospitalIndemnityQuestions.every(question => {
            if (question.questionId === MedSupPlanQuestionIds.EffectiveDate && hospitalIndemnityAnswers[question.name]) {
                return !DateUtilities.isPastMonth(hospitalIndemnityAnswers[question.name]);
            }
            return hospitalIndemnityAnswers[question.name] !== undefined;
        }));
    }
    static plansRiderBenefitCategories(state) {
        return state.plansRiderBenefitCategories;
    }
    static selectedPlansRiderBenefitCategoryIds(plansRiderBenefitCategories) {
        return Object.values(plansRiderBenefitCategories).reduce((riderIds, selectedRiderBenefitCategory) => [
            ...riderIds,
            ...selectedRiderBenefitCategory.map(riderBenefitCategory => riderBenefitCategory.selectedRiderId)
        ], []);
    }
    static hospitalIndemnityAnswersMap(hospitalIndemnityQuestions, hospitalIndemnityAnswers) {
        return hospitalIndemnityQuestions.reduce((answersMap, question) => {
            answersMap[question.name] = {
                questionID: question.questionId,
                value: hospitalIndemnityAnswers[question.name]
            };
            return answersMap;
        }, {});
    }
    static planTypesLoaded() {
        return createSelector([PlansState_1.planTypeDataMap()], (planTypeDataMap) => {
            const planTypeDataMapKeys = Object.keys(planTypeDataMap);
            return planTypeDataMapKeys.reduce((loadedPlanTypes, key) => {
                if (planTypeDataMap[key]?.loaded) {
                    loadedPlanTypes.push(+key);
                }
                return loadedPlanTypes;
            }, []);
        });
    }
    static planTypesDirty() {
        return createSelector([PlansState_1.planTypeDataMap()], (planTypeDataMap) => {
            const planTypeDataMapKeys = Object.keys(planTypeDataMap);
            return planTypeDataMapKeys.reduce((loadedPlanTypes, key) => {
                if (planTypeDataMap[key]?.dirty) {
                    loadedPlanTypes.push(+key);
                }
                return loadedPlanTypes;
            }, []);
        });
    }
    static sortedHospitalIndemnityQuestions(questionMetaDataModel) {
        return createSelector([PlansState_1.hospitalIndemnityQuestions], (hospitalIndemnityQuestions) => {
            const sorted = [];
            questionMetaDataModel.forEach(resourceQuestionData => {
                const item = hospitalIndemnityQuestions.find(filteredQuestion => filteredQuestion.name === resourceQuestionData.key);
                if (item) {
                    sorted.push(item);
                }
            });
            return sorted;
        });
    }
    static filteredHospitalIndemnityQuestionMetaData(questionMetaDataModel) {
        return createSelector([PlansState_1.hospitalIndemnityQuestions], (hospitalIndemnityQuestions) => questionMetaDataModel.filter(questionMetaData => hospitalIndemnityQuestions.some(question => question.name === questionMetaData.key)));
    }
    static hospitalIndemnityQuestionMetaDataMap(questionMetaDataModel) {
        return createSelector([PlansState_1.filteredHospitalIndemnityQuestionMetaData(questionMetaDataModel)], (filteredHospitalIndemnityQuestions) => filteredHospitalIndemnityQuestions.reduce((questionsMap, question) => {
            questionsMap[question.key] = question;
            return questionsMap;
        }, {}));
    }
    static snpVisibility(state) {
        return state.snpVisibility;
    }
    static hiddenSNPTypes(snpVisibility) {
        const { dSNP, cSNP, iSNP } = snpVisibility;
        const hiddenSNPTypes = [];
        if (!dSNP) {
            hiddenSNPTypes.push(SNPBaseType.dSNP);
        }
        if (!cSNP) {
            hiddenSNPTypes.push(SNPBaseType.cSNP);
        }
        if (!iSNP) {
            hiddenSNPTypes.push(SNPBaseType.iSNP);
        }
        return hiddenSNPTypes;
    }
    static payload(planTypeDataMap) {
        if (planTypeDataMap) {
            const planTypeDataMapValues = Object.values(planTypeDataMap);
            if (Array.isArray(planTypeDataMapValues) && planTypeDataMapValues?.length) {
                return planTypeDataMapValues.reduce((allPlans, planTypeData) => ({ ...allPlans, ...(planTypeData?.payload ?? {}) }), {});
            }
        }
        return {};
    }
    static plansMap(payload, planScores, planCoveredPreferences, providerDetails) {
        if (payload) {
            return Object.values(payload).reduce((allPlans, plan) => {
                const score = planScores?.[plan.id];
                const coveredPreferences = planCoveredPreferences?.[plan.id];
                const providers = providerDetails?.plans?.find(providerPlan => providerPlan.id === plan.id)?.providers;
                if (score || coveredPreferences || providers) {
                    allPlans[plan.id] = {
                        ...plan,
                        ...(score && { score }),
                        ...(coveredPreferences && { coveredPreferences }),
                        ...(providers && { providers })
                    };
                }
                else {
                    allPlans[plan.id] = plan;
                }
                return allPlans;
            }, {});
        }
        return {};
    }
    static currentPlansMap(currentPlanPayload, planScores, planCoveredPreferences, providerDetails) {
        return PlansState_1.plansMap(currentPlanPayload, planScores, planCoveredPreferences, providerDetails);
    }
    static plans(plansMap) {
        return plansMap ? Object.values(plansMap) : [];
    }
    static pharmaciesMap(planTypeDataMap) {
        if (planTypeDataMap) {
            const planTypeDataMapEntries = Object.entries(planTypeDataMap);
            if (Array.isArray(planTypeDataMapEntries) && planTypeDataMapEntries?.length) {
                return planTypeDataMapEntries.reduce((allPharmacies, [planType, planTypeData]) => {
                    allPharmacies[planType] = planTypeData?.pharmacies ?? [];
                    return allPharmacies;
                }, {});
            }
        }
        return {};
    }
    static rawCurrentPlanTypeDataMap() {
        return createSelector([PlansState_1], (state) => state.currentPlanTypeDataMap);
    }
    static currentPlanPayload(planTypeDataMap) {
        if (planTypeDataMap) {
            const planTypeDataMapValues = Object.values(planTypeDataMap);
            if (Array.isArray(planTypeDataMapValues) && planTypeDataMapValues.length) {
                return planTypeDataMapValues.reduce((allPlans, planTypeData) => ({ ...allPlans, ...(planTypeData?.payload ?? {}) }), {});
            }
        }
        return {};
    }
    static currentPlans(plansMap) {
        return plansMap ? Object.values(plansMap) : [];
    }
    static pharmacies(pharmaciesMap) {
        if (pharmaciesMap) {
            const pharmaciesMapValues = Object.values(pharmaciesMap);
            if (Array.isArray(pharmaciesMapValues) && pharmaciesMapValues?.length) {
                return pharmaciesMapValues.reduce((allPharmacies, pharmacies) => allPharmacies.concat(pharmacies), []);
            }
        }
        return [];
    }
    static plansQueuePosition(state) {
        return state.plansQueuePosition;
    }
    static plansFilteredBySNPVisibility(plans, hiddenSNPTypes) {
        return plans?.filter(plan => !hiddenSNPTypes.includes(plan.snpType)) ?? [];
    }
    // Was running in to an issue where this was returning the application state rather
    // than the state slice when not using a dynamic selector so we will need to leave this.
    static rawPlanTypeDataMap() {
        return createSelector([PlansState_1], (state) => state.planTypeDataMap);
    }
    static medicareGroupPlanConfiguration(state) {
        return state.medicareGroupPlanConfiguration;
    }
    static medicareGroupPlanFilterConfiguration(medicareGroupPlanConfiguration) {
        return this.applyMedicareGroupPlanFilters(medicareGroupPlanConfiguration);
    }
    static planTypeDataMap() {
        return createSelector([PlansState_1.rawPlanTypeDataMap(), PlansState_1.medicareGroupPlanConfiguration, PlansState_1.medicareGroupPlanFilterConfiguration], (rawPlanTypeDataMap, medicareGroupPlanConfiguration, medicareGroupPlanFilterConfiguration) => {
            if (medicareGroupPlanConfiguration) {
                // Using reduce to transform the plans into the filteredPlans structure
                const filteredPlans = Object.keys(rawPlanTypeDataMap).reduce((planTypeData, planType) => {
                    // Initialize the structure for each plan type
                    planTypeData[planType] = {
                        ...rawPlanTypeDataMap[planType],
                        payload: Object.values(rawPlanTypeDataMap[planType].payload ?? {}).reduce((plansMap, plan) => {
                            if (medicareGroupPlanFilterConfiguration.some(config => plan.contractId === config.contractId &&
                                plan.planId === config.planId &&
                                plan.segmentId === config.segmentId &&
                                plan.planYear === config.planYear)) {
                                plansMap[plan.id] = plan;
                            }
                            return plansMap;
                        }, {})
                    };
                    return planTypeData;
                }, {});
                return filteredPlans;
            }
            return rawPlanTypeDataMap;
        });
    }
    static applyMedicareGroupPlanFilters(medicareGroupPlanConfiguration) {
        return (medicareGroupPlanConfiguration?.plans?.filter(config => config.contractId && config.planId && config.segmentId && config.planYear) ??
            [] // Fallback to an empty array if the result of the filter is undefined
        );
    }
    static planTypeMetadata(planTypeKey) {
        return createSelector([PlansState_1.planTypeDataMap()], (planTypeDataMap) => planTypeDataMap?.[planTypeKey] ?? null);
    }
    static plansByType(searchPlanTypes) {
        const planTypes = PlansUtilityService.getUniquePlanTypes(searchPlanTypes);
        return createSelector([PlansState_1.plans], (plans) => plans?.filter(plan => planTypes.includes(plan.planType)));
    }
    static pharmaciesByPlanType(planTypeKey) {
        return createSelector([PlansState_1.planTypeMetadata(planTypeKey)], (planTypeMetadata) => planTypeMetadata?.pharmacies ?? []);
    }
    static storePlanTypes(planTypeDataMap) {
        return planTypeDataMap ? Object.keys(planTypeDataMap).map(planType => +planType) : [];
    }
    static filterGroups(state) {
        return state.filterGroups;
    }
    static sortGroups(state) {
        return state.sortGroups;
    }
    static activePlanDetailsTabType(state) {
        return state.activePlanDetailsTabType;
    }
    static activeTabType(state) {
        return state.activePlansTabType;
    }
    static defaultTabType(state) {
        return state.defaultPlansTabType;
    }
    static planComparePlanType(state) {
        return state.planComparePlanType;
    }
    static compareGroupsWithPlanIds(state) {
        return state.compareGroups;
    }
    static planSmartLoading(state) {
        return state.planSmartLoading;
    }
    static compareGroups(plansMap, currentPlans, compareGroupsWithPlanIds) {
        const combinedPlansMap = {
            ...plansMap,
            ...currentPlans.reduce((map, plan) => {
                map[plan.id] = plan;
                return map;
            }, {})
        };
        return compareGroupsWithPlanIds.map((compareGroupWithPlanIds) => ({
            ...compareGroupWithPlanIds,
            items: compareGroupWithPlanIds.items.reduce((selectedPlans, selectedPlan) => {
                const foundPlan = combinedPlansMap?.[selectedPlan.id];
                if (foundPlan) {
                    selectedPlans.push(foundPlan);
                }
                return selectedPlans;
            }, [])
        }));
    }
    static quoteGroups(state) {
        return state.quoteGroups;
    }
    static includePUFPlans(state) {
        return state.includePUFPlans;
    }
    static includeNonLicensedPlans(state) {
        return state.includeNonLicensedPlans;
    }
    static isTotalEstimatedCostAnnually(state) {
        return state.isTotalEstimatedCostAnnually;
    }
    static activeRateFactorPlanId(state) {
        return state.activeRateFactorPlanId;
    }
    static activeRateFactorPlan(plansMap, activeRateFactorPlanId) {
        return plansMap?.[activeRateFactorPlanId];
    }
    static isActiveTabTotalCost(state) {
        return state.isActiveTabTotalCost;
    }
    static planCounts() {
        return createSelector([PlansState_1], (state) => state.planCounts);
    }
    static arePlanCountsLoaded(planCounts) {
        return !!Object.keys(planCounts).length;
    }
    static planScores() {
        return createSelector([PlansState_1], (state) => state.planScores);
    }
    static isActiveTabPrescription(state) {
        return state.isActiveTabPrescription;
    }
    static planCoveredPreferences() {
        return createSelector([PlansState_1], (state) => state.planCoveredPreferences);
    }
    static planShortLoading(state) {
        return state.planShortLoading;
    }
    static currentPlanShort(state) {
        return state.currentPlanShort;
    }
    static currentPlansFilteredByActiveTab(plans, activeTabType) {
        return plans.filter(plan => plan.planTypeAbbreviation === activeTabType);
    }
    static activeTabTotalPlanPremiums(plans, activeTabType) {
        return (plans?.reduce((totalPlanPremiums, plan) => {
            if (activeTabType === plan.planTypeAbbreviation) {
                if (activeTabType === PlanTypeAbbreviation.MEDIGAP) {
                    totalPlanPremiums.push(plan.medicalPremium);
                }
                else {
                    totalPlanPremiums.push(plan.drugPremium + plan.medicalPremium);
                }
            }
            return totalPlanPremiums;
        }, []) ?? []);
    }
    static availableTabs(filterGroups) {
        const availableTabs = filterGroups.reduce((tabs, filterGroup) => {
            if (filterGroup.groupKey.key === FilterKeyType.PLAN_TYPE_SHORT) {
                tabs.add(filterGroup.groupKey.values[0]);
            }
            return tabs;
        }, new Set());
        return Array.from(availableTabs);
    }
    static loading(planType) {
        return createSelector([PlansState_1.planTypeDataMap()], (planTypeDataMap) => {
            if (planType) {
                return PlansState_1.isPlanTypeLoading(planType, planTypeDataMap);
            }
            const planTypeDataMapValues = Object.values(planTypeDataMap);
            if (planTypeDataMapValues?.length) {
                return planTypeDataMapValues.some(data => !!data?.loading);
            }
            return false;
        });
    }
    static planTypesLoading(planTypes) {
        return createSelector([PlansState_1.planTypeDataMap()], (planTypeDataMap) => planTypes.some(planType => PlansState_1.isPlanTypeLoading(planType, planTypeDataMap)));
    }
    static loaded(planType) {
        return createSelector([PlansState_1.planTypeDataMap()], (planTypeDataMap) => {
            if (planType) {
                return PlansState_1.isPlanTypeLoaded(planType, planTypeDataMap);
            }
            const planTypeDataMapValues = Object.values(planTypeDataMap);
            if (planTypeDataMapValues?.length) {
                return planTypeDataMapValues.every(data => !!data?.loaded);
            }
            return false;
        });
    }
    static arePlanTypesLoaded(planTypes) {
        return createSelector([PlansState_1.planTypeDataMap()], (planTypeDataMap) => planTypes.every(planType => PlansState_1.isPlanTypeLoaded(planType, planTypeDataMap)));
    }
    static dirty(planType) {
        return createSelector([PlansState_1.planTypeDataMap()], (planTypeDataMap) => {
            if (planType) {
                return PlansState_1.isPlanTypeDirty(planType, planTypeDataMap);
            }
            const planTypeDataMapValues = Object.values(planTypeDataMap);
            if (planTypeDataMapValues?.length) {
                return planTypeDataMapValues.some(data => !!data?.dirty);
            }
            return true;
        });
    }
    static arePlanTypesDirty(planTypes) {
        return createSelector([PlansState_1.planTypeDataMap()], (planTypeDataMap) => planTypes.some(planType => PlansState_1.isPlanTypeDirty(planType, planTypeDataMap)));
    }
    static getAPIPharmacyInfoForPlan(planId) {
        return createSelector([PlansState_1.pharmacies], (pharmacies) => pharmacies.map(pharmacy => ({
            ...pharmacy,
            isRetail: !!pharmacy?.isRetail?.includes(planId),
            isInNetwork: !!pharmacy?.isInNetwork?.includes(planId),
            isPreferred: !!pharmacy?.isPreferred?.includes(planId),
            isMailOrder: !!pharmacy?.isMailOrder?.includes(planId)
        })));
    }
    static isAncillaryQuestion(questionId) {
        return createSelector([PlansState_1.ancillaryQuestions], (ancillaryQuestions) => ancillaryQuestions.some(question => question.questionId === questionId));
    }
    static isHospitalIndemnityQuestion(questionId) {
        return createSelector([PlansState_1.hospitalIndemnityQuestions], (hospitalIndemnityQuestions) => hospitalIndemnityQuestions.some(question => question.questionId === questionId));
    }
    static bestMatchPlan(coverageType) {
        return createSelector([PlansState_1.plansFilteredBySNPVisibility, PlansState_1.availableTabs], (filteredPlans, availableTabs) => PlansState_1.getBestMatchPlan(filteredPlans, availableTabs, coverageType));
    }
    static bestMatchPlanId(coverageType) {
        return createSelector([PlansState_1.bestMatchPlan(coverageType)], (bestMatchPlan) => bestMatchPlan?.id);
    }
    static bestCoverageTabAbbreviation(coverageType) {
        return createSelector([PlansState_1.bestMatchPlan(coverageType)], (bestMatchPlan) => bestMatchPlan?.planTypeAbbreviation);
    }
    static hasPlanType(planType) {
        return createSelector([PlansState_1.plans], (plans) => plans.some(plan => plan.planTypeAbbreviation === planType));
    }
    static plansByPlanTypeAbbreviation(planType) {
        return createSelector([PlansState_1.plans], (plans) => plans.filter(plan => plan.planTypeAbbreviation === planType));
    }
    static planCountByType(planType) {
        return createSelector([PlansState_1.planCounts()], (planCounts) => planCounts?.[planType] ?? 0);
    }
    static getActiveTabFilters(planListTabsData) {
        return createSelector([PlansState_1.activeTabType], (activeTabType) => {
            const filters = [];
            const activeTab = planListTabsData?.find(tab => tab.tabTypes[0] === activeTabType);
            if (activeTab) {
                filters.push(new Filter({ key: FilterKeyType.PLAN_TYPE_SHORT, values: activeTab.tabTypes }));
                if ([...ANCILLARY_PLANS, PlanTypeAbbreviation.HC].includes(activeTabType)) {
                    filters.push(new Filter({ key: FilterKeyType.PLAN_PREMIUM, values: [], comparator: ComparatorType.EXISTS, visible: false }), ...(activeTab.filters?.map(filter => new Filter({ ...filter })) ?? []));
                }
            }
            return filters;
        });
    }
    static getPlansUsingActiveTabFilters(planListTabsData) {
        return createSelector([PlansState_1.plansFilteredBySNPVisibility, PlansState_1.getActiveTabFilters(planListTabsData)], (plans, filters) => PlansState_1.filterPlans(plans, filters) ?? []);
    }
    static showSellablePlanFilter(planListTabsData) {
        return createSelector([PlansState_1.getPlansUsingActiveTabFilters(planListTabsData)], (plans) => plans?.some(
        // SPA-14249: As per conversation with BAs, currently there are no PUF ancillary plans.
        // In consequence, for non Medicare plans we also have to check if they are non permissioned (ASP).
        // For Medicare plans, based on code comments and the previous logic: on NOVA layer, plan list only needs to check if the plan is PUF
        plan => plan.isPUF || (NON_MEDICARE_PLAN_TYPES.includes(plan.planTypeAbbreviation) && plan.isNonPermissionedPlan)) ?? false);
    }
    static getFilterGroup(filterGroupIdentifier) {
        return createSelector([PlansState_1.filterGroups], (storeFilterGroups) => FilterUtilities.getFilterGroup(storeFilterGroups, filterGroupIdentifier));
    }
    static getFiltersByFilterGroup(filterGroupIdentifier, includeFilterGroup = true) {
        return createSelector([PlansState_1.getFilterGroup(filterGroupIdentifier)], (storeFilterGroup) => FilterUtilities.getFiltersByFilterGroup(storeFilterGroup, includeFilterGroup));
    }
    static getPlansByFilterList(filters) {
        return createSelector([PlansState_1.plansFilteredBySNPVisibility], (plans) => PlansState_1.filterPlans(plans, filters));
    }
    static getFilteredAdditionalPlansByFilterList(filterGroupIdentifier, forceMedSupFormBeforePlansList, skipAdditionalFiltering = false) {
        return createSelector([PlansState_1.getPlansByFilterList(filterGroupIdentifier), MedSupState.hasAnswers()], (plans, hasMedSupAnswers) => PlansUtilityService.filterAdditionalPlans(plans, hasMedSupAnswers, forceMedSupFormBeforePlansList, skipAdditionalFiltering));
    }
    static getPlansByFilterGroup(filterGroupIdentifier) {
        return createSelector([PlansState_1.plansFilteredBySNPVisibility, PlansState_1.getFiltersByFilterGroup(filterGroupIdentifier)], (plans, filters) => PlansState_1.filterPlans(plans, filters));
    }
    static getFilteredAdditionalPlansByFilterGroup(filterGroupIdentifier, forceMedSupFormBeforePlansList, skipAdditionalFiltering = false) {
        return createSelector([PlansState_1.getPlansByFilterGroup(filterGroupIdentifier), MedSupState.hasAnswers()], (plans, hasMedSupAnswers) => PlansUtilityService.filterAdditionalPlans(plans, hasMedSupAnswers, forceMedSupFormBeforePlansList, skipAdditionalFiltering));
    }
    static getPayloadByFilterGroup(filterGroupIdentifier) {
        return createSelector([PlansState_1.plans, PlansState_1.getFiltersByFilterGroup(filterGroupIdentifier)], (plans, filters) => PlansState_1.filterPlans(plans, filters));
    }
    static getPlanCountByFilterGroup(filterGroupIdentifier, forceMedSupFormBeforePlansList, skipAdditionalFiltering = false) {
        return createSelector([PlansState_1.getFilteredAdditionalPlansByFilterGroup(filterGroupIdentifier, forceMedSupFormBeforePlansList, skipAdditionalFiltering)], (plans) => {
            if (plans?.length) {
                const currentYearPlans = plans.filter(plan => plan.isCurrentYearPlan);
                return plans.length - currentYearPlans.length;
            }
            return 0;
        });
    }
    static getPlanTypePlanCountMapByFilterGroup(tabs, forceMedSupFormBeforePlansList, skipAdditionalFiltering = false) {
        return createSelector(tabs.map(tab => PlansState_1.getPlanCountByFilterGroup(tab.filters, forceMedSupFormBeforePlansList, skipAdditionalFiltering)), (...planCountPerTab) => tabs.reduce((planCountMap, tab, index) => {
            const tabPlanType = PlansUtilityService.convertToPlanType(tab.tabTypes[0], false);
            planCountMap[tabPlanType] = planCountPerTab?.[index] ?? 0;
            return planCountMap;
        }, {}));
    }
    static getFilteredAdditionalPayloadByFilterGroup(filterGroupIdentifier, forceMedSupFormBeforePlansList, skipAdditionalFiltering = false) {
        return createSelector([PlansState_1.getPayloadByFilterGroup(filterGroupIdentifier), MedSupState.hasAnswers()], (plans, hasMedSupAnswers) => PlansUtilityService.filterAdditionalPlans(plans, hasMedSupAnswers, forceMedSupFormBeforePlansList, skipAdditionalFiltering));
    }
    static hasSelectedFilters(filterGroupIdentifier, includeFilterGroup = true) {
        return createSelector([PlansState_1.getFiltersByFilterGroup(filterGroupIdentifier, includeFilterGroup)], (filters) => filters?.filter(filter => filter.visible).length > 0);
    }
    static getPlansByCarrierName(carrierName) {
        return createSelector([PlansState_1.plansFilteredBySNPVisibility], (plans) => plans.length ? plans.filter(plan => plan.carrierName === carrierName) : []);
    }
    static getPlansWithOptions(planTypeOptions) {
        return createSelector([PlansState_1.getPlansByPlanType(planTypeOptions.planTypeAbbreviation)], (plans) => plans.filter(plan => {
            const filterByMarketingName = planTypeOptions.planMarketingNameEnabled && plan.planMarketingName === planTypeOptions.carrierName;
            // While filtering plans by carrier organizationName, we may run into very rare case of plans that
            // don't have a carrier organizationName,so we resort to carrierName
            const filterByCarrierName = plan.carrierInformation?.organizationName === planTypeOptions.carrierName || plan.carrierName === planTypeOptions.carrierName;
            return plan.planTypeAbbreviation === planTypeOptions.planTypeAbbreviation && (filterByMarketingName || filterByCarrierName);
        }));
    }
    static plan(planId) {
        return createSelector([PlansState_1.plansMap], (plansMap) => plansMap?.[planId]);
    }
    static currentPlan(planId) {
        return createSelector([PlansState_1.currentPlansMap], (plansMap) => plansMap?.[planId]);
    }
    static getPlansMapByIds(planIds) {
        return createSelector([PlansState_1.plansMap], (plansMap) => planIds.reduce((selectedPlansMap, planId) => {
            const selectedPlan = plansMap?.[planId];
            if (selectedPlan) {
                selectedPlansMap[planId] = selectedPlan;
            }
            return selectedPlansMap;
        }, {}));
    }
    static plansByIds(planIds) {
        return createSelector([PlansState_1.getPlansMapByIds(planIds)], (plansMap) => Object.values(plansMap));
    }
    // TODO: possibly use something like a lodash _get if we anticipate lookup paths being deeply nested
    // dynamics selectors are probably the way we will handle value provider lookups
    static planAttribute(planId, key) {
        // chaining selectors here
        return createSelector([PlansState_1.plan(planId)], (plan) => plan?.[key]);
    }
    // takes a plans property and returns the unique set of values across plans of active type for this property
    static filterKeys(property) {
        // chaining selectors here
        return createSelector([PlansState_1.plansFilteredBySNPVisibility, PlansState_1.activeTabType], (plans, activeTabType) => plans.reduce((planKeys, plan) => {
            const propValue = plan[property];
            if (!planKeys.includes(propValue) && plan[FilterKeyType.PLAN_TYPE_SHORT] === activeTabType) {
                planKeys.push(propValue);
            }
            return planKeys;
        }, []));
    }
    static getSortGroup(sortGroupIdentifier) {
        return createSelector([PlansState_1.sortGroups], (storeSortGroups) => SortUtilities.matchSortGroupCompositeKey(storeSortGroups, sortGroupIdentifier));
    }
    static getSortBySortGroup(sortGroupIdentifier) {
        return createSelector([PlansState_1.getSortGroup(sortGroupIdentifier)], (storeSortGroups) => storeSortGroups?.[0]?.sort);
    }
    static getPlansByFilterAndSortGroup(filterGroupIdentifier, sortGroupIdentifier, sortTransformerBindFn) {
        return createSelector([PlansState_1.getPlansByFilterGroup(filterGroupIdentifier), PlansState_1.getSortBySortGroup(sortGroupIdentifier)], (plans, sort) => {
            let result = [];
            if (plans.length > 0) {
                const selectedPlans = PlansState_1.checkAndRemoveDuplicatedComboPlans({ plans, filters: filterGroupIdentifier });
                const newSortItem = sort
                    ? new Sort(sort.primaryKey, sort.dataKey, sort.secondaryDataKey, sort.dataKeyType, sort.sortType, sort.displayName, sort.display, sortTransformerBindFn(sort.dataKey), sort.secondarySortType, sort.isDefault, sort.order)
                    : null;
                result = newSortItem ? SortUtilities.sort(selectedPlans, newSortItem) : selectedPlans;
            }
            return result;
        });
    }
    static getFilteredAdditionalPlansByFilterAndSortGroup(filterGroupIdentifier, sortGroupIdentifier, forceMedSupFormBeforePlansList, sortTransformerBindFn, skipAdditionalFiltering = false) {
        return createSelector([
            PlansState_1.getPlansByFilterAndSortGroup(filterGroupIdentifier, sortGroupIdentifier, sortTransformerBindFn),
            MedSupState.hasAnswers(),
            PlansState_1.currentPlans
        ], (plans, hasMedSupAnswers, currentPlans) => {
            const additionalPlans = PlansUtilityService.filterAdditionalPlans(plans, hasMedSupAnswers, forceMedSupFormBeforePlansList, skipAdditionalFiltering);
            const additionalPlanIds = new Set(additionalPlans.map(p => p.id));
            const additionalPlanTypes = new Set(additionalPlans.map(p => p.planType).filter((type) => type != null));
            // Filter out currentPlans that are already in additionalPlans
            const uniqueCurrentPlans = currentPlans.filter(p => !additionalPlanIds.has(p.id) && additionalPlanTypes.has(p.planType));
            return [...additionalPlans, ...uniqueCurrentPlans];
        });
    }
    static checkAndRemoveDuplicatedComboPlans(options) {
        const { plans, filters, planType } = options;
        // Consider the tab's first type value as the main type
        const planTypeAbbreviation = planType ?? filters?.find(({ key }) => key === FilterKeyType.PLAN_TYPE_SHORT)?.values[0];
        let result = plans;
        if (planTypeAbbreviation && ANCILLARY_PLANS.includes(planTypeAbbreviation)) {
            const checkUniquenessCondition = (foundItem) => !foundItem ||
                // for Dental tab: replace any duplicated Visual combo plan with the Dental combo plan version
                (planTypeAbbreviation === PlanTypeAbbreviation.DENTAL &&
                    foundItem.every(({ item }) => VISION_COMBO_PLANS.includes(item.planSubType))) ||
                // for Vision tab: replace any duplicated Dental combo plan with the Vision combo plan version
                (planTypeAbbreviation === PlanTypeAbbreviation.VISION &&
                    foundItem.every(({ item }) => DENTAL_COMBO_PLANS.includes(item.planSubType)));
            const checkDuplicatesCondition = (foundItem, duplicatePlan) => foundItem.every(({ item }) => item.id !== duplicatePlan.id) &&
                // for Dental tab: keep any duplicated Dental combo plan
                ((planTypeAbbreviation === PlanTypeAbbreviation.DENTAL && DENTAL_COMBO_PLANS.includes(duplicatePlan.planSubType)) ||
                    // for Vision tab: replace any duplicated Vision combo plan
                    (planTypeAbbreviation === PlanTypeAbbreviation.VISION && VISION_COMBO_PLANS.includes(duplicatePlan.planSubType)));
            const uniqueItemsOptions = {
                items: plans,
                key: 'planName',
                allowDuplicates: true,
                checkUniquenessCondition,
                checkDuplicatesCondition
            };
            result = CollectionUtilityService.getUniqueItems(uniqueItemsOptions);
        }
        return result;
    }
    static getPlansByPlanType(planTypeAbbreviation) {
        return createSelector([PlansState_1.plansFilteredBySNPVisibility], (plans) => {
            let result = [];
            if (plans.length > 0) {
                const filteredPlans = plans.filter(plan => plan.planTypeAbbreviation === planTypeAbbreviation);
                result = PlansState_1.checkAndRemoveDuplicatedComboPlans({ plans: filteredPlans, planType: planTypeAbbreviation });
            }
            return result;
        });
    }
    static transformHttpModelToSessionModel(questions) {
        return RateFactorsUtilityService.transformHttpModelToSessionModel(questions, QuestionModel.Plan);
    }
    static transformSessionModelToHttpModel(questions) {
        return RateFactorsUtilityService.transformSessionModelToHttpModel(questions, QuestionModel.Plan);
    }
    static selectedPlanSubType(state) {
        return state.selectedPlanSubType;
    }
    static planSmartFilterGroup(state) {
        return state.planSmartFilterGroup;
    }
    static totalSiteCarrierCount(state) {
        return state.totalSiteCarrierCount;
    }
    static totalSitePlanCount(state) {
        return state.totalSitePlanCount;
    }
    static getFiltersByPlanSmartFilterGroup(planYear) {
        return createSelector([PlansState_1.planSmartFilterGroup], (planSmartFilterGroup) => planSmartFilterGroup?.[planYear]?.planSmartFilters || []);
    }
    static getPlanSmartReportData(planYear) {
        return createSelector([PlansState_1.planSmartReports], (planSmartReport) => planSmartReport?.[planYear]?.data || []);
    }
    static getPlansSmartReportByFilterGroup(planYear) {
        return createSelector([PlansState_1.getPlanSmartReportData(planYear), PlansState_1.getFiltersByPlanSmartFilterGroup(planYear)], (planSmartReportData, filters) => {
            let result = planSmartReportData;
            if (planSmartReportData.length > 0 && filters.length > 0) {
                result = FilterUtilities.filter(planSmartReportData, filters);
            }
            return result;
        });
    }
    static carrierInformation(id) {
        return createSelector([PlansState_1.plan(id)], (plan) => plan?.carrierInformation ?? null);
    }
    static carrierAddress(id) {
        return createSelector([PlansState_1.carrierInformation(id)], (carrierInformation) => carrierInformation?.carrierAddress ?? null);
    }
    fetchPlanQuestions(ctx, { zipCode, fips, year, effectiveDate }) {
        const { getState, patchState } = ctx;
        // update ZipCode/County_FIPS answers when we fetch questions for a new selected zip code
        const ancillaryAnswers = {
            ...PlansState_1.rawAncillaryAnswers()(getState()),
            [MedSupQuestionNames.ZipCode]: zipCode,
            [MedSupQuestionNames.County_FIPS]: fips
        };
        patchState({ loadingAncillaryQuestions: true, error: null, ancillaryAnswers });
        forkJoin([
            this.plansHttpService.retrievePlanQuestions$(zipCode, fips, year, effectiveDate, ProductType.DENTAL),
            this.plansHttpService.retrievePlanQuestions$(zipCode, fips, year, effectiveDate, ProductType.VISION)
        ]).subscribe({
            next: ([dentalQuestions, visionQuestions]) => {
                const options = {
                    items: PlansState_1.transformHttpModelToSessionModel([...dentalQuestions, ...visionQuestions]),
                    key: 'questionId'
                };
                const questions = CollectionUtilityService.getUniqueItems(options);
                patchState({ loadingAncillaryQuestions: false });
                ctx.dispatch(new UpdateAncillaryPlanQuestions(CollectionUtilityService.updateQuestionsAnswers(questions, ancillaryAnswers)));
            },
            error: error => ctx.dispatch(new FetchPlanQuestionsError(error))
        });
    }
    fetchPlanQuestionsError({ patchState }, { error }) {
        patchState({ loadingAncillaryQuestions: false, error });
    }
    updateAncillaryPlanQuestions(ctx, { ancillaryQuestions }) {
        const { patchState } = ctx;
        patchState({ ancillaryQuestions });
    }
    updateAncillaryPlanAnswers(ctx, { ancillaryQuestions }) {
        const { getState, patchState } = ctx;
        const currentAnswers = PlansState_1.rawAncillaryAnswers()(getState());
        const ancillaryAnswers = ancillaryQuestions.reduce((answers, question) => {
            answers[question.name] = question.value;
            return answers;
        }, _cloneDeep(currentAnswers));
        patchState({ ancillaryAnswers });
    }
    fetchHospitalIndemnityQuestions(ctx, { zipCode, fips, year, effectiveDate }) {
        const { getState, patchState } = ctx;
        // update ZipCode/County_FIPS answers when we fetch questions for a new selected zip code
        const hospitalIndemnityAnswers = {
            ...PlansState_1.rawHospitalIndemnityAnswers()(getState()),
            [MedSupQuestionNames.ZipCode]: zipCode,
            [MedSupQuestionNames.County_FIPS]: fips
        };
        patchState({ loadingHospitalIndemnityQuestions: true, error: null, hospitalIndemnityAnswers });
        this.plansHttpService.retrievePlanQuestions$(zipCode, fips, year, effectiveDate, ProductType.HC).subscribe({
            next: hospitalIndemnityQuestions => {
                const daysBenefitMappings = this.getDaysBenefitMappings(hospitalIndemnityQuestions);
                patchState({
                    loadingHospitalIndemnityQuestions: false,
                    hospitalIndemnityQuestions: CollectionUtilityService.updateQuestionsAnswers(PlansState_1.transformHttpModelToSessionModel(hospitalIndemnityQuestions), hospitalIndemnityAnswers),
                    daysBenefitMappings
                });
            },
            error: error => ctx.dispatch(new FetchHospitalIndemnityQuestionsError(error))
        });
    }
    fetchHospitalIndemnityQuestionsError({ patchState }, { error }) {
        patchState({ loadingHospitalIndemnityQuestions: false, error });
    }
    updateHospitalIndemnityPlanQuestions(ctx, { hospitalIndemnityQuestions }) {
        const { patchState } = ctx;
        patchState({ hospitalIndemnityQuestions });
    }
    updateHospitalIndemnityPlanAnswers(ctx, { hospitalIndemnityQuestions }) {
        const { getState, patchState } = ctx;
        const currentAnswers = PlansState_1.rawHospitalIndemnityAnswers()(getState());
        const hospitalIndemnityAnswers = hospitalIndemnityQuestions.reduce((answers, question) => {
            answers[question.name] = question.value;
            return answers;
        }, _cloneDeep(currentAnswers));
        patchState({ hospitalIndemnityAnswers });
    }
    async selectQuestions(ctx, { sessionId, year, effectiveDate, productType, questions }) {
        if (productType === ProductType.HC) {
            ctx.dispatch([new UpdateHospitalIndemnityPlanQuestions(questions), new UpdateHospitalIndemnityPlanAnswers(questions)]);
        }
        else {
            ctx.dispatch([new UpdateAncillaryPlanQuestions(questions), new UpdateAncillaryPlanAnswers(questions)]);
        }
        await this.plansHttpService.setPlanAnswers(sessionId, year, effectiveDate, productType, PlansState_1.transformSessionModelToHttpModel(questions));
    }
    fetchPlansSuccess({ setState }, { planTypes }) {
        setState(patch({
            error: null
        }));
        if (planTypes?.length) {
            planTypes.forEach(planType => {
                const planTypeKey = PlansUtilityService.getPlanBucketKey(planType);
                if (planTypeKey) {
                    setState(patch({
                        planTypeDataMap: patch({
                            [planTypeKey]: patch({
                                loaded: true,
                                loading: false,
                                dirty: false
                            })
                        })
                    }));
                }
            });
        }
    }
    fetchPlansError({ setState }, { error, planTypes }) {
        // TODO: marked for removal but seeing a very odd situation for SCS-46863 where the error returned
        // may be preventing session storage from serializing. We don't seem to use error for anything so
        // we may never add it back and work to remove it from other areas of code.
        console.error('Fetch plans error: ', error);
        if (planTypes?.length) {
            planTypes.forEach(planType => {
                const planTypeKey = PlansUtilityService.getPlanBucketKey(planType);
                if (planTypeKey) {
                    setState(patch({
                        planTypeDataMap: patch({
                            [planTypeKey]: patch({
                                loading: false,
                                dirty: true
                            })
                        })
                    }));
                }
            });
        }
    }
    updatePUFPlanSettings({ patchState }, { includePUFPlans }) {
        patchState({
            includePUFPlans
        });
    }
    updateNonLicensedPlanSettings({ patchState }, { includeNonLicensedPlans }) {
        patchState({
            includeNonLicensedPlans
        });
    }
    updatePlansQueuePosition(ctx, { plansQueuePosition }) {
        if (plansQueuePosition) {
            const { patchState } = ctx;
            patchState({
                plansQueuePosition
            });
        }
    }
    updatePlans(ctx, { plans, planTypes }) {
        const { setState } = ctx;
        if (planTypes?.length) {
            const planBuckets = PlansState_1.createPlanBuckets(plans, planTypes);
            const planTypeDataMapPatchValue = planTypes.reduce((patchValue, planTypeKey) => {
                patchValue[planTypeKey] = patch({
                    loaded: true,
                    loading: false,
                    dirty: false,
                    payload: planBuckets[planTypeKey]
                });
                return patchValue;
            }, {});
            setState(patch({
                planTypeDataMap: patch(planTypeDataMapPatchValue)
            }));
        }
    }
    updateCurrentPlans(ctx, { plans }) {
        const { setState } = ctx;
        if (plans?.length) {
            const planTypeDataMapPatchValue = PlansState_1.mapToPlanTypeMetadataMap(plans);
            setState(patch({
                currentPlanTypeDataMap: patch(planTypeDataMapPatchValue)
            }));
        }
    }
    updateCurrentPlanPharmacies(ctx, { planPharmacies }) {
        const { setState } = ctx;
        if (planPharmacies) {
            setState(patch({
                currentPlanTypeDataMap: patch({
                    [ALL_MEDICARE_PLAN_TYPE_VALUE]: patch({
                        pharmacies: planPharmacies
                    })
                })
            }));
        }
    }
    updatePlanPharmacies(ctx, { planPharmacies, planTypes, planIds }) {
        const { setState } = ctx;
        let updatedPharmacies;
        // These only ever relate to medicare types so if the planType includes a medicare type then just overwrite these
        // IF we ever want pharmacies on non-Medicare plans we will need to refactor where we get plans requests to keep
        // the plan type and create a map to pass in here
        if (PlansUtilityService.hasMedicareAllType(planTypes)) {
            // if we are making a plan details call we need to handle updating pharmacies differently
            if (planIds?.length) {
                const currentPlanPharmacies = this.store.selectSnapshot(PlansState_1.pharmaciesByPlanType(ALL_MEDICARE_PLAN_TYPE_VALUE));
                if (!currentPlanPharmacies?.length) {
                    // if we do not have any current pharmacies then we can push this to our pharmacy list
                    // this should only happen in deep linking to plan details/compare. if we go to plan
                    // details/compare from the plans list page then nothing should change about pharmacies
                    updatedPharmacies = planPharmacies;
                }
                else {
                    // Update pharmacy data when we select it from guided help and navigate to detail page from plan list
                    // currently we only need to update vaccineAdminFee which we received from plan API at plan detail page.
                    updatedPharmacies = PlansUtilityService.getUpdatedPlanPharmacies(currentPlanPharmacies, planPharmacies);
                }
                // if we are making a details call and we already have pharmacies we will use those as API
                // has ensured us that passing in a planId should never modify what is returned for pharmacies
            }
            else {
                // when we aren't making a plan details call we just save the planPharmacies as normal
                updatedPharmacies = planPharmacies;
            }
            // pharmacies should be coming back as an empty array rather than null so this still
            // does allow for clearing pharmacy data
            if (updatedPharmacies) {
                setState(patch({
                    planTypeDataMap: patch({
                        [ALL_MEDICARE_PLAN_TYPE_VALUE]: patch({
                            pharmacies: updatedPharmacies
                        })
                    })
                }));
            }
        }
    }
    setSortGroup({ setState }, { sortGroup }) {
        setState(patch({
            sortGroups: compose(removeItem(existingSortGroup => SortUtilities.matchSortGroupCompositeKey([existingSortGroup], [new SortGroup(sortGroup.groupKey.key, sortGroup.groupKey.values, sortGroup.groupKey.comparator)]).length > 0), append([sortGroup]))
        }));
    }
    clearSortGroupSort({ setState }, { sortGroupIdentifier }) {
        setState(patch({
            sortGroups: updateItem(sortGroup => SortUtilities.matchSortGroupCompositeKey([sortGroup], sortGroupIdentifier).length > 0, patch({
                sort: {}
            }))
        }));
    }
    updateSortGroup({ setState }, { sortGroupIdentifier, sort, isDirty }) {
        setState(patch({
            sortGroups: updateItem(sortGroup => SortUtilities.matchSortGroupCompositeKey([sortGroup], sortGroupIdentifier).length > 0, patch({
                sort,
                ...(isDirty ? { isDirty: !!isDirty } : {})
            }))
        }));
    }
    clearSort({ patchState }, {}) {
        patchState({
            sortGroups: null
        });
    }
    setFilterGroup({ setState }, { filterGroup }) {
        setState(patch({
            filterGroups: compose(removeItem(existingFilterGroup => FilterUtilities.matchFilterGroupCompositeKey([existingFilterGroup], [new Filter({ ...filterGroup.groupKey })]).length > 0), append([filterGroup]))
        }));
    }
    addFilterToFilterGroups({ setState }, { filterGroupIdentifier, filter }) {
        setState(patch({
            filterGroups: updateItem(filterGroup => FilterUtilities.matchFilterGroupCompositeKey([filterGroup], filterGroupIdentifier).length > 0, patch({
                filters: compose(removeItem(existingFilter => existingFilter.key === filter.key), append([filter]))
            }))
        }));
    }
    clearPlanSmartFilterGroupWithKey({ setState }, { planYear, filterKeyToClear }) {
        setState(patch({
            planSmartFilterGroup: patch({
                [planYear]: patch({
                    planSmartFilters: removeItem(existingFilter => existingFilter.key === filterKeyToClear)
                })
            })
        }));
    }
    clearPlanSmartFilterGroupFilters({ setState }, { planYear }) {
        setState(patch({
            planSmartFilterGroup: patch({
                [planYear]: patch({
                    planSmartFilters: []
                })
            })
        }));
    }
    initializePlanSmartFilterGroups(ctx, { activePlanYears }) {
        const { setState } = ctx;
        const planSmartFilterGroupDefaults = this.getPlanSmartFilterGroupDefaults(activePlanYears);
        setState(patch({
            planSmartFilterGroup: planSmartFilterGroupDefaults
        }));
    }
    addFilterToPlanSmartFilterGroups({ getState, patchState }, { filter, planYear }) {
        const state = getState();
        const newPlanSmartFilterGroup = _cloneDeep(state.planSmartFilterGroup);
        const { planSmartFilters } = newPlanSmartFilterGroup[planYear];
        const filteredPlanSmartFilters = planSmartFilters.filter(existingFilter => existingFilter.key !== filter.key);
        newPlanSmartFilterGroup[planYear].planSmartFilters = [...filteredPlanSmartFilters, filter];
        patchState({ planSmartFilterGroup: newPlanSmartFilterGroup });
    }
    clearFilterGroupFilter({ setState }, { filterGroupIdentifier, filterKeyToClear }) {
        setState(patch({
            filterGroups: updateItem(filterGroup => FilterUtilities.matchFilterGroupCompositeKey([filterGroup], filterGroupIdentifier).length > 0, patch({
                filters: removeItem(existingFilter => existingFilter.key === filterKeyToClear && existingFilter.visible !== false)
            }))
        }));
    }
    clearFilterGroupFilters({ setState }, { filterGroupIdentifier }) {
        setState(patch({
            filterGroups: updateItem(filterGroup => FilterUtilities.matchFilterGroupCompositeKey([filterGroup], filterGroupIdentifier).length > 0, patch({
                filters: removeItems(existingFilter => existingFilter.visible !== false)
            }))
        }));
    }
    updateFilterGroupFilters({ setState }, { filterGroupIdentifier, filters }) {
        setState(patch({
            filterGroups: updateItem(filterGroup => FilterUtilities.matchFilterGroupCompositeKey([filterGroup], filterGroupIdentifier).length > 0, patch({
                filters
            }))
        }));
    }
    removeFilterGroups({ setState }, { filterGroupIdentifier }) {
        setState(patch({
            filterGroups: removeItem(filterGroup => FilterUtilities.matchFilterGroupCompositeKey([filterGroup], filterGroupIdentifier).length > 0)
        }));
    }
    setActiveTab({ patchState }, { tabType }) {
        patchState({
            activePlansTabType: tabType
        });
    }
    setActivePlanDetailsTab({ patchState }, { tabType }) {
        patchState({
            activePlanDetailsTabType: tabType
        });
    }
    clearActiveTab({ patchState }) {
        patchState({
            activePlansTabType: null
        });
    }
    setDefaultActiveTab({ patchState }, { tabType }) {
        patchState({
            defaultPlansTabType: tabType
        });
    }
    selectPlanDetails({ setState }, { planWithDetails }) {
        const planType = planWithDetails.planType;
        const planTypeBucket = PlansUtilityService.includesMedicarePlans([planType]) ? ALL_MEDICARE_PLAN_TYPE_VALUE : planType;
        const payloadPlan = this.store.selectSnapshot(PlansState_1.plan(planWithDetails.id));
        let updatedPlan = planWithDetails;
        if (payloadPlan) {
            updatedPlan = PlansUtilityService.mergePayloadPlanWithDetails(payloadPlan, planWithDetails);
        }
        setState(patch({
            planTypeDataMap: patch({
                [planTypeBucket]: patch({
                    payload: patch({
                        [updatedPlan.id]: updatedPlan
                    })
                })
            })
        }));
    }
    setPlanComparePlanType({ patchState }, { planType }) {
        patchState({
            planComparePlanType: planType
        });
    }
    setCompareGroup({ setState }, { compareGroup }) {
        setState(patch({
            compareGroups: compose(removeItem(existingGroup => this.comparePlanUtilities.compareGroupExists([existingGroup], [new CompareGroup(compareGroup.groupKey.key, compareGroup.groupKey.values, compareGroup.groupKey.comparator)])), append([compareGroup]))
        }));
    }
    addPlanToCompareGroup({ setState }, { compareGroupIdentifier, plan }) {
        setState(patch({
            compareGroups: updateItem(compareGroup => this.comparePlanUtilities.compareGroupExists([compareGroup], compareGroupIdentifier), patch({
                items: compose(removeItem(existingPlan => existingPlan.id === plan.id), append([PlansState_1.getComparePlanData(plan)]))
            }))
        }));
    }
    removePlanFromCompareGroup({ setState }, { compareGroupIdentifier, plan }) {
        setState(patch({
            compareGroups: updateItem(compareGroup => this.comparePlanUtilities.compareGroupExists([compareGroup], compareGroupIdentifier), patch({
                items: removeItem(existingPlan => existingPlan.id === plan.id)
            }))
        }));
    }
    removePlanFromCompareGroups(ctx, { plan }) {
        const { compareGroups } = ctx.getState();
        if (compareGroups?.length) {
            compareGroups.forEach(compareGroup => {
                ctx.dispatch(new RemovePlanFromCompareGroup([compareGroup], plan));
            });
        }
    }
    addPlansToCompareGroup({ setState }, { compareGroupIdentifier, plans }) {
        setState(patch({
            compareGroups: updateItem(compareGroup => this.comparePlanUtilities.compareGroupExists([compareGroup], compareGroupIdentifier), patch({
                items: append(plans.map((plan) => PlansState_1.getComparePlanData(plan)))
            }))
        }));
    }
    removeAllPlansFromCompareGroup({ setState }, { compareGroupIdentifier }) {
        setState(patch({
            compareGroups: updateItem(compareGroup => this.comparePlanUtilities.compareGroupExists([compareGroup], compareGroupIdentifier), patch({
                items: []
            }))
        }));
    }
    updateFirstPlanInCompareGroup({ setState }, { compareGroupIdentifier, plan }) {
        setState(patch({
            compareGroups: updateItem(compareGroup => this.comparePlanUtilities.compareGroupExists([compareGroup], compareGroupIdentifier), patch({
                items: compose(removeItem(existingPlan => existingPlan.id === plan.id || existingPlan.planTypeAbbreviation !== PlanTypeAbbreviation.HC), insertItem(PlansState_1.getComparePlanData(plan), 0))
            }))
        }));
    }
    setPlansDirty({ setState }, { dirty, planTypes }) {
        // if we call this without specifying plan types we will dirty all plans
        const planTypesToDirty = planTypes?.length ? planTypes : this.store.selectSnapshot(PlansState_1.storePlanTypes);
        planTypesToDirty.forEach(planType => {
            const planTypeKey = PlansUtilityService.getPlanBucketKey(planType);
            if (planTypeKey) {
                setState(patch({
                    planTypeDataMap: patch({
                        [planTypeKey]: patch({
                            dirty
                        })
                    })
                }));
            }
        });
    }
    resetPlanTypes({ setState }, { planTypes }) {
        if (planTypes?.length) {
            const patchPlanTypeDataMapValue = planTypes.reduce((patchValue, planTypeKey) => {
                patchValue[planTypeKey] = patch(PLAN_TYPE_DATA_MAP_DEFAULTS);
                return patchValue;
            }, {});
            setState(patch({
                planTypeDataMap: patch(patchPlanTypeDataMapValue)
            }));
        }
        else {
            const activePlanTypes = this.getDefaultPlanTypeDataMap();
            setState(patch({
                planTypeDataMap: this.getActivePlanTypesDefaults(activePlanTypes)
            }));
        }
    }
    resetPlansState(ctx, { defaultPlanYear }) {
        const { getState, setState } = ctx;
        const { selectedPlanYearType, selectedPlanYear, planSmartReports } = getState();
        const resetPlanYearType = defaultPlanYear ? PlanYearType.CURRENT : selectedPlanYearType;
        const resetPlanYear = defaultPlanYear || selectedPlanYear;
        const activePlanTypes = this.getDefaultPlanTypeDataMap();
        const planTypeDataMapDefaults = this.getActivePlanTypesDefaults(activePlanTypes);
        setState({
            ...PLANS_DEFAULTS,
            selectedPlanYearType: resetPlanYearType,
            selectedPlanYear: resetPlanYear,
            planTypeDataMap: planTypeDataMapDefaults,
            planSmartReports
        });
    }
    setLoading({ setState }, { loading, planTypes }) {
        if (planTypes?.length) {
            planTypes.forEach(planType => {
                const planTypeKey = PlansUtilityService.getPlanBucketKey(planType);
                if (planTypeKey) {
                    setState(patch({
                        planTypeDataMap: patch({
                            [planTypeKey]: patch({
                                loading
                            })
                        })
                    }));
                }
            });
        }
    }
    setPlanShortLoading({ patchState }, { loading }) {
        patchState({ planShortLoading: loading });
    }
    setQuoteGroup({ setState }, { quoteGroup }) {
        setState(patch({
            quoteGroups: compose(removeItem(existingGroup => this.comparePlanUtilities.compareGroupExists([existingGroup], [new CompareGroup(quoteGroup.groupKey.key, quoteGroup.groupKey.values, quoteGroup.groupKey.comparator)])), append([quoteGroup]))
        }));
    }
    addPlanToQuoteGroup({ setState }, { quoteGroupIdentifier, plan }) {
        setState(patch({
            quoteGroups: updateItem(quoteGroup => this.comparePlanUtilities.compareGroupExists([quoteGroup], quoteGroupIdentifier), patch({
                items: compose(removeItem(existingPlan => existingPlan.id === plan.id), append([plan]))
            }))
        }));
    }
    updateFirstPlanInQuoteGroup({ setState }, { quoteGroupIdentifier, plan }) {
        setState(patch({
            quoteGroups: updateItem(quoteGroup => this.comparePlanUtilities.compareGroupExists([quoteGroup], quoteGroupIdentifier), patch({
                items: compose(removeItem(0), insertItem(plan, 0))
            }))
        }));
    }
    removePlanFromQuoteGroup({ setState }, { quoteGroupIdentifier, plan }) {
        setState(patch({
            quoteGroups: updateItem(quoteGroup => this.comparePlanUtilities.compareGroupExists([quoteGroup], quoteGroupIdentifier), patch({
                items: removeItem(existingPlan => existingPlan.id === plan.id)
            }))
        }));
    }
    removePlanFromQuoteGroups(ctx, { plan }) {
        const { quoteGroups } = ctx.getState();
        if (quoteGroups?.length) {
            quoteGroups.forEach(quoteGroup => {
                ctx.dispatch(new RemovePlanFromQuoteGroup([quoteGroup], plan));
            });
        }
    }
    setTotalEstimatedCostAnnually({ patchState }, { isTotalEstimatedCostAnnually }) {
        patchState({
            isTotalEstimatedCostAnnually
        });
    }
    setIsActiceTabTotalCost({ patchState }, { isActiveTabTotalCost }) {
        patchState({
            isActiveTabTotalCost
        });
    }
    setSelectedPlanYear({ getState, patchState }, { selectedPlanYearType, selectedPlanYear }) {
        const { planYearSiteCarrierCount, planYearSitePlanCount, dualPlanYearSiteCarrierCount, dualPlanYearSitePlanCount } = getState();
        patchState({
            selectedPlanYearType,
            selectedPlanYear,
            totalSiteCarrierCount: selectedPlanYearType === PlanYearType.CURRENT ? planYearSiteCarrierCount : dualPlanYearSiteCarrierCount,
            totalSitePlanCount: selectedPlanYearType === PlanYearType.CURRENT ? planYearSitePlanCount : dualPlanYearSitePlanCount
        });
    }
    setPlanYearPermissionError({ patchState }, { hasPlanYearPermissionError }) {
        patchState({
            hasPlanYearPermissionError
        });
    }
    SetPlanSmartReports({ setState }, { planSmartReportResponse, planYear }) {
        setState(patch({
            planSmartReports: patch({
                [planYear]: planSmartReportResponse
            }),
            planSmartLoading: false
        }));
    }
    fetchPlanSmartReportsError({ patchState }) {
        patchState({ planSmartLoading: false });
    }
    fetchPlanSmartReports({ dispatch, patchState }, { agentGuid, planYear }) {
        patchState({ planSmartLoading: true });
        this.plansHttpService.fetchPlanSmartReports$(agentGuid, planYear).subscribe({
            next: planSmartResponse => dispatch(new SetPlanSmartReports(PlansState_1.reformatPlanSmartResponse(planSmartResponse), planYear)),
            error: () => dispatch(new FetchPlanSmartReportsError())
        });
    }
    UpdatePlanSmartSort({ setState }, { planSmartSort, planYear }) {
        setState(patch({
            planSmartSort: patch({
                [planYear]: planSmartSort
            })
        }));
    }
    SetSelectedPlanSmartDetails({ setState }, { planSmartReportData }) {
        setState(patch({
            selectedPlanSmartDetails: planSmartReportData
        }));
    }
    ResetSelectedPlanSmartDetails({ patchState }) {
        patchState({
            selectedPlanSmartDetails: null
        });
    }
    ResetPlanSmart({ patchState }) {
        patchState({
            planSmartReports: {},
            planSmartSort: {}
        });
    }
    setIsActiveTabPrescription({ patchState }, { isActiveTabPrescription }) {
        patchState({
            isActiveTabPrescription
        });
    }
    setActiveRateFactorPlanId({ patchState }, { activeRateFactorPlanId }) {
        patchState({
            activeRateFactorPlanId
        });
    }
    removeActiveRateFactorPlanId({ patchState }) {
        patchState({
            activeRateFactorPlanId: null
        });
    }
    setCSNPVisibility(ctx, { cSNPVisibility }) {
        const { setState } = ctx;
        setState(patch({ snpVisibility: patch({ cSNP: cSNPVisibility }) }));
    }
    setDSNPVisibility(ctx, { dSNPVisibility }) {
        const { setState } = ctx;
        setState(patch({ snpVisibility: patch({ dSNP: dSNPVisibility }) }));
    }
    setISNPVisibility(ctx, { iSNPVisibility }) {
        const { setState } = ctx;
        setState(patch({ snpVisibility: patch({ iSNP: iSNPVisibility }) }));
    }
    setAllSNPTypesVisibility({ patchState }, { visibility }) {
        patchState({ snpVisibility: { cSNP: visibility, dSNP: visibility, iSNP: visibility } });
    }
    setVisibleSNPTypes({ patchState }, { snpVisibility }) {
        patchState({ snpVisibility });
    }
    updateSelectedPlanSubType(ctx, { selectedPlanSubType }) {
        const { getState, setState } = ctx;
        const oldPlanSubType = PlansState_1.selectedPlanSubType(getState());
        setState(patch({
            selectedPlanSubType
        }));
        setState(patch({
            planTypeDataMap: patch({
                // Only applies to medigap for now. If we ever need to accomodate more plan
                // types then we will pass in planTypes to this action like we do the others
                [PlanType.MEDIGAP]: patch({
                    dirty: selectedPlanSubType !== oldPlanSubType
                })
            })
        }));
    }
    clearSelectedPlanSubType(ctx) {
        const { patchState } = ctx;
        patchState({
            selectedPlanSubType: ''
        });
    }
    updatePlansRiderBenefitCategories(ctx, { planId, selectedRiderBenefitCategories }) {
        const { setState } = ctx;
        setState(patch({
            plansRiderBenefitCategories: patch({ [planId]: selectedRiderBenefitCategories })
        }));
    }
    setPlanCounts(ctx, { planCounts }) {
        const { setState } = ctx;
        setState(patch({
            planCounts
        }));
    }
    setCoveredPreferences(ctx, { preferences }) {
        const { setState } = ctx;
        setState(patch({
            planCoveredPreferences: preferences
        }));
    }
    setPlanScores(ctx, { planScores }) {
        const { setState } = ctx;
        setState(patch({
            planScores
        }));
    }
    updatePlanShortData(ctx, { data, hasNewPlanCounts, hasNewPlanScores }) {
        const { countByType, totalCount, ...planShortData } = data;
        if (hasNewPlanCounts) {
            ctx.dispatch(new SetPlanCounts(_cloneDeep(countByType)));
        }
        if (hasNewPlanScores) {
            const planScores = this.mapShortPlanField(planShortData.data, 'score');
            ctx.dispatch(new SetPlanScores(planScores));
            // Covered preferences and provider details will only be derived when planScores
            // is set to true so only update them in that case
            const preferences = this.mapShortPlanField(planShortData.data, 'coveredPreferences');
            // TODO: when we remove preferences we would want to clear this out or will that auto happen with the removal?
            ctx.dispatch(new SetCoveredPreferences(preferences));
        }
    }
    // Initializing plan type data map. We now need to do this as we aren't loading plans as a single unit but on a per plan type basis
    // and because of that we need to know what tabs are supported in the site as we are initializing the plans state
    initializePlanTypeDataMap(ctx, { activePlanTypes }) {
        const { setState } = ctx;
        const planTypeDataMapDefaults = this.getActivePlanTypesDefaults(activePlanTypes);
        setState(patch({
            planTypeDataMap: planTypeDataMapDefaults
        }));
    }
    // for updating the plan type data map with additional plan type defaults. used in the
    // case of live edit where we create the plan type data map using mock data before we
    // initialize on the basis of the tab configuration
    updatePlanTypeDataMap(ctx, { activePlanTypes, planTypesToPreserve }) {
        const { setState } = ctx;
        const planTypeDataMapDefaults = this.getActivePlanTypesDefaults(activePlanTypes);
        const currentPlanTypeDataMap = this.store.selectSnapshot(PlansState_1.planTypeDataMap());
        planTypesToPreserve?.forEach(planType => {
            const planTypeMetadata = currentPlanTypeDataMap?.[planType];
            if (planTypeMetadata) {
                planTypeDataMapDefaults[planType] = planTypeMetadata;
            }
        });
        setState(patch({
            planTypeDataMap: planTypeDataMapDefaults
        }));
    }
    resetPlanYearState(ctx) {
        const { patchState } = ctx;
        this.store.dispatch(new ResetProvidersDetails());
        this.store.dispatch(new ResetPlanTypes([ALL_MEDICARE_PLAN_TYPE_VALUE]));
        // TODO: need to update sort or filter groups?
        patchState({
            planScores: {},
            planCounts: {},
            plansQueuePosition: [],
            planCoveredPreferences: {}
        });
    }
    fetchCarrierCounts(ctx, { agentGuid, zip, fips, planYear, dualPlanYear }) {
        if (zip && fips && planYear) {
            const calls = [this.carriersHttpService.carrierCount$(zip, fips, planYear, agentGuid)];
            if (dualPlanYear) {
                calls.push(this.carriersHttpService.carrierCount$(zip, fips, dualPlanYear, agentGuid));
            }
            const { selectedPlanYear } = ctx.getState();
            forkJoin(calls).subscribe({
                next: ([planYearSiteCounts, dualPlanYearSiteCounts]) => {
                    const planYearSiteCarrierCount = planYearSiteCounts?.carrierCount ?? 0;
                    const planYearSitePlanCount = planYearSiteCounts?.planCount ?? 0;
                    let dualPlanYearSiteCarrierCount = null;
                    let dualPlanYearSitePlanCount = null;
                    if (dualPlanYearSiteCounts) {
                        dualPlanYearSiteCarrierCount = dualPlanYearSiteCounts?.carrierCount ?? 0;
                        dualPlanYearSitePlanCount = dualPlanYearSiteCounts?.planCount ?? 0;
                    }
                    ctx.patchState({
                        planYearSiteCarrierCount,
                        planYearSitePlanCount,
                        dualPlanYearSiteCarrierCount,
                        dualPlanYearSitePlanCount,
                        totalSiteCarrierCount: selectedPlanYear === planYear ? planYearSiteCarrierCount : dualPlanYearSiteCarrierCount,
                        totalSitePlanCount: selectedPlanYear === planYear ? planYearSitePlanCount : dualPlanYearSitePlanCount
                    });
                }
            });
        }
    }
    SetMedicareGroupPlanConfiguration(ctx, { medicareGroupPlanConfiguration }) {
        const { patchState } = ctx;
        patchState({ medicareGroupPlanConfiguration });
    }
    SetCurrentPlanShort(ctx, { currentPlanShort }) {
        const { patchState } = ctx;
        patchState({ currentPlanShort });
    }
    getActivePlanTypesDefaults(activePlanTypes) {
        return activePlanTypes.reduce((dataMap, planType) => {
            dataMap[planType] = { ...PLAN_TYPE_DATA_MAP_DEFAULTS };
            return dataMap;
        }, {});
    }
    getDefaultPlanTypeDataMap() {
        const planListTabs = this.store.selectSnapshot(AppConfigState.resource('Spa_PlanList_Tabs_Data'))?.value ?? [];
        const activeTabTypes = planListTabs.map(tab => tab.tabTypes[0]);
        return Array.from(new Set(activeTabTypes.map(tabTypeAbbreviation => PlansUtilityService.convertToPlanType(tabTypeAbbreviation))));
    }
    ngxsAfterBootstrap(ctx) {
        const activePlanTypes = this.getDefaultPlanTypeDataMap();
        // if active plan Types don't match here then re-init
        const storePlanTypes = this.store.selectSnapshot(PlansState_1.storePlanTypes);
        // bootstrap is called on every page reload and if we already have plan types we do not want
        // to re-initialize this as this will clobber any existing plan data we have. if we have new
        // plan types at this point we are either loading the first time OR Spa_PlanList_Tabs_Data has
        // changed for some reason. Both are valid cases for initializing the planTypeDataMap
        if (!_isEqual(activePlanTypes, storePlanTypes)) {
            if (EnvironmentService.getEnvironment().liveedit) {
                ctx.dispatch(new UpdatePlanTypeDataMap(activePlanTypes, storePlanTypes));
            }
            else {
                ctx.dispatch(new InitializePlanTypeDataMap(activePlanTypes));
            }
        }
    }
    mapShortPlanField(shortPlans, key) {
        return (shortPlans?.reduce((planMap, shortPlan) => {
            planMap[shortPlan.id] = shortPlan[key];
            return planMap;
        }, {}) ?? {});
    }
    getDaysBenefitMappings(questions) {
        const daysCoveredQuestion = questions.find(question => question.questionKey === MedSupQuestionNames.HCDaysCovered);
        return daysCoveredQuestion?.daysBenefitMappings ?? [];
    }
    getPlanSmartFilterGroupDefaults(activePlanYears) {
        return (activePlanYears?.reduce((dataMap, planYear) => {
            dataMap[planYear] = { planSmartFilters: [] };
            return dataMap;
        }, {}) || {});
    }
};
PlansState.ɵfac = function PlansState_Factory(t) { return new (t || PlansState)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(PlansHttpService), i0.ɵɵinject(CarriersHttpService)); };
PlansState.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PlansState, factory: PlansState.ɵfac });
__decorate([
    LiveEditInactive(),
    Action(FetchPlanQuestions)
], PlansState.prototype, "fetchPlanQuestions", null);
__decorate([
    Action(FetchPlanQuestionsError)
], PlansState.prototype, "fetchPlanQuestionsError", null);
__decorate([
    Action(UpdateAncillaryPlanQuestions)
], PlansState.prototype, "updateAncillaryPlanQuestions", null);
__decorate([
    Action(UpdateAncillaryPlanAnswers)
], PlansState.prototype, "updateAncillaryPlanAnswers", null);
__decorate([
    LiveEditInactive(),
    Action(FetchHospitalIndemnityQuestions)
], PlansState.prototype, "fetchHospitalIndemnityQuestions", null);
__decorate([
    Action(FetchHospitalIndemnityQuestionsError)
], PlansState.prototype, "fetchHospitalIndemnityQuestionsError", null);
__decorate([
    Action(UpdateHospitalIndemnityPlanQuestions)
], PlansState.prototype, "updateHospitalIndemnityPlanQuestions", null);
__decorate([
    Action(UpdateHospitalIndemnityPlanAnswers)
], PlansState.prototype, "updateHospitalIndemnityPlanAnswers", null);
__decorate([
    Action(SelectPlanQuestions)
], PlansState.prototype, "selectQuestions", null);
__decorate([
    Action(FetchPlansSuccess)
], PlansState.prototype, "fetchPlansSuccess", null);
__decorate([
    Action(FetchPlansError)
], PlansState.prototype, "fetchPlansError", null);
__decorate([
    Action(UpdatePUFPlanSetting)
], PlansState.prototype, "updatePUFPlanSettings", null);
__decorate([
    Action(UpdateNonLicensedPlanSetting)
], PlansState.prototype, "updateNonLicensedPlanSettings", null);
__decorate([
    Action(UpdatePlansQueuePosition)
], PlansState.prototype, "updatePlansQueuePosition", null);
__decorate([
    Action(UpdatePlans)
], PlansState.prototype, "updatePlans", null);
__decorate([
    Action(UpdateCurrentPlans)
], PlansState.prototype, "updateCurrentPlans", null);
__decorate([
    Action(UpdateCurrentPlanPharmacies)
], PlansState.prototype, "updateCurrentPlanPharmacies", null);
__decorate([
    Action(UpdatePlanPharmacies)
], PlansState.prototype, "updatePlanPharmacies", null);
__decorate([
    Action(SetSortGroup)
], PlansState.prototype, "setSortGroup", null);
__decorate([
    Action(ClearSortGroupSort)
], PlansState.prototype, "clearSortGroupSort", null);
__decorate([
    Action(UpdateSortGroup)
], PlansState.prototype, "updateSortGroup", null);
__decorate([
    Action(ClearSort)
], PlansState.prototype, "clearSort", null);
__decorate([
    Action(SetFilterGroup)
], PlansState.prototype, "setFilterGroup", null);
__decorate([
    Action(AddFilterToFilterGroups)
], PlansState.prototype, "addFilterToFilterGroups", null);
__decorate([
    Action(ClearPlanSmartFilterGroupWithKey)
], PlansState.prototype, "clearPlanSmartFilterGroupWithKey", null);
__decorate([
    Action(ClearPlanSmartFilterGroupFilters)
], PlansState.prototype, "clearPlanSmartFilterGroupFilters", null);
__decorate([
    Action(InitializePlanSmartFilterGroups)
], PlansState.prototype, "initializePlanSmartFilterGroups", null);
__decorate([
    Action(AddFilterToPlanSmartFilterGroups)
], PlansState.prototype, "addFilterToPlanSmartFilterGroups", null);
__decorate([
    Action(ClearFilterGroupFilter)
], PlansState.prototype, "clearFilterGroupFilter", null);
__decorate([
    Action(ClearFilterGroupFilters)
], PlansState.prototype, "clearFilterGroupFilters", null);
__decorate([
    Action(UpdateFilterGroupFilters)
], PlansState.prototype, "updateFilterGroupFilters", null);
__decorate([
    Action(RemoveFilterGroups)
], PlansState.prototype, "removeFilterGroups", null);
__decorate([
    Action(SetActiveTab)
], PlansState.prototype, "setActiveTab", null);
__decorate([
    Action(SetActivePlanDetailsTab)
], PlansState.prototype, "setActivePlanDetailsTab", null);
__decorate([
    Action(ClearActiveTab)
], PlansState.prototype, "clearActiveTab", null);
__decorate([
    Action(SetDefaultTab)
], PlansState.prototype, "setDefaultActiveTab", null);
__decorate([
    Action(SelectPlanDetails)
], PlansState.prototype, "selectPlanDetails", null);
__decorate([
    Action(SetPlanComparePlanType)
], PlansState.prototype, "setPlanComparePlanType", null);
__decorate([
    Action(SetCompareGroup)
], PlansState.prototype, "setCompareGroup", null);
__decorate([
    Action(AddPlanToCompareGroup)
], PlansState.prototype, "addPlanToCompareGroup", null);
__decorate([
    Action(RemovePlanFromCompareGroup)
], PlansState.prototype, "removePlanFromCompareGroup", null);
__decorate([
    Action(RemovePlanFromCompareGroups)
], PlansState.prototype, "removePlanFromCompareGroups", null);
__decorate([
    Action(AddPlansToCompareGroup)
], PlansState.prototype, "addPlansToCompareGroup", null);
__decorate([
    Action(RemoveAllPlansFromCompareGroup)
], PlansState.prototype, "removeAllPlansFromCompareGroup", null);
__decorate([
    Action(UpdateFirstPlanInCompareGroup)
], PlansState.prototype, "updateFirstPlanInCompareGroup", null);
__decorate([
    Action(SetPlansDirty)
], PlansState.prototype, "setPlansDirty", null);
__decorate([
    Action(ResetPlanTypes)
], PlansState.prototype, "resetPlanTypes", null);
__decorate([
    Action(ResetPlansState)
], PlansState.prototype, "resetPlansState", null);
__decorate([
    Action(SetPlansLoading)
], PlansState.prototype, "setLoading", null);
__decorate([
    Action(SetPlanShortLoading)
], PlansState.prototype, "setPlanShortLoading", null);
__decorate([
    Action(SetQuoteGroup)
], PlansState.prototype, "setQuoteGroup", null);
__decorate([
    Action(AddPlanToQuoteGroup)
], PlansState.prototype, "addPlanToQuoteGroup", null);
__decorate([
    Action(UpdateFirstPlanInQuoteGroup)
], PlansState.prototype, "updateFirstPlanInQuoteGroup", null);
__decorate([
    Action(RemovePlanFromQuoteGroup)
], PlansState.prototype, "removePlanFromQuoteGroup", null);
__decorate([
    Action(RemovePlanFromQuoteGroups)
], PlansState.prototype, "removePlanFromQuoteGroups", null);
__decorate([
    Action(SetTotalEstimatedCostAnnually)
], PlansState.prototype, "setTotalEstimatedCostAnnually", null);
__decorate([
    Action(SetActiveTabTotalCost)
], PlansState.prototype, "setIsActiceTabTotalCost", null);
__decorate([
    Action(SetSelectedPlanYear)
], PlansState.prototype, "setSelectedPlanYear", null);
__decorate([
    Action(SetPlanYearPermissionError)
], PlansState.prototype, "setPlanYearPermissionError", null);
__decorate([
    Action(SetPlanSmartReports)
], PlansState.prototype, "SetPlanSmartReports", null);
__decorate([
    Action(FetchPlanSmartReportsError)
], PlansState.prototype, "fetchPlanSmartReportsError", null);
__decorate([
    Action(FetchPlanSmartReports)
], PlansState.prototype, "fetchPlanSmartReports", null);
__decorate([
    Action(UpdatePlanSmartSort)
], PlansState.prototype, "UpdatePlanSmartSort", null);
__decorate([
    Action(SetSelectedPlanSmartDetails)
], PlansState.prototype, "SetSelectedPlanSmartDetails", null);
__decorate([
    Action(ResetSelectedPlanSmartDetails)
], PlansState.prototype, "ResetSelectedPlanSmartDetails", null);
__decorate([
    Action(ResetPlanSmart)
], PlansState.prototype, "ResetPlanSmart", null);
__decorate([
    Action(SetActiveTabPrescription)
], PlansState.prototype, "setIsActiveTabPrescription", null);
__decorate([
    Action(SetActiveRateFactorPlanId)
], PlansState.prototype, "setActiveRateFactorPlanId", null);
__decorate([
    Action(RemoveActiveRateFactorPlanId)
], PlansState.prototype, "removeActiveRateFactorPlanId", null);
__decorate([
    Action(SetCSNPVisibility)
], PlansState.prototype, "setCSNPVisibility", null);
__decorate([
    Action(SetDSNPVisibility)
], PlansState.prototype, "setDSNPVisibility", null);
__decorate([
    Action(SetISNPVisibility)
], PlansState.prototype, "setISNPVisibility", null);
__decorate([
    Action(SetAllSNPTypesVisibility)
], PlansState.prototype, "setAllSNPTypesVisibility", null);
__decorate([
    Action(SetVisibleSNPTypes)
], PlansState.prototype, "setVisibleSNPTypes", null);
__decorate([
    Action(UpdateSelectedPlanSubType)
], PlansState.prototype, "updateSelectedPlanSubType", null);
__decorate([
    Action(ClearSelectedPlanSubType)
], PlansState.prototype, "clearSelectedPlanSubType", null);
__decorate([
    Action(UpdatePlansRiderBenefitCategories)
], PlansState.prototype, "updatePlansRiderBenefitCategories", null);
__decorate([
    Action(SetPlanCounts)
], PlansState.prototype, "setPlanCounts", null);
__decorate([
    Action(SetCoveredPreferences)
], PlansState.prototype, "setCoveredPreferences", null);
__decorate([
    Action(SetPlanScores)
], PlansState.prototype, "setPlanScores", null);
__decorate([
    Action(UpdatePlanShortData)
], PlansState.prototype, "updatePlanShortData", null);
__decorate([
    Action(InitializePlanTypeDataMap)
], PlansState.prototype, "initializePlanTypeDataMap", null);
__decorate([
    Action(UpdatePlanTypeDataMap)
], PlansState.prototype, "updatePlanTypeDataMap", null);
__decorate([
    Action(ResetPlanYearState)
], PlansState.prototype, "resetPlanYearState", null);
__decorate([
    Action(FetchCarrierCounts)
], PlansState.prototype, "fetchCarrierCounts", null);
__decorate([
    Action(SetMedicareGroupPlanConfiguration)
], PlansState.prototype, "SetMedicareGroupPlanConfiguration", null);
__decorate([
    Action(SetCurrentPlanShort)
], PlansState.prototype, "SetCurrentPlanShort", null);
__decorate([
    Selector()
], PlansState, "loadingAncillaryQuestions", null);
__decorate([
    Selector()
], PlansState, "ancillaryQuestions", null);
__decorate([
    Selector()
], PlansState, "hasAncillaryQuestions", null);
__decorate([
    Selector([PlansState_1.rawAncillaryAnswers(), PlansState_1.hasAncillaryAnswers()])
], PlansState, "ancillaryAnswers", null);
__decorate([
    Selector([PlansState_1.ancillaryQuestions, PlansState_1.ancillaryAnswers])
], PlansState, "areAllAncillaryQuestionsAnswered", null);
__decorate([
    Selector()
], PlansState, "loadingHospitalIndemnityQuestions", null);
__decorate([
    Selector()
], PlansState, "hospitalIndemnityQuestions", null);
__decorate([
    Selector([PlansState_1.hospitalIndemnityQuestions])
], PlansState, "hasHospitalIndemnityQuestions", null);
__decorate([
    Selector([PlansState_1.rawHospitalIndemnityAnswers(), PlansState_1.hasHospitalIndemnityAnswers()])
], PlansState, "hospitalIndemnityAnswers", null);
__decorate([
    Selector()
], PlansState, "daysBenefitMappings", null);
__decorate([
    Selector()
], PlansState, "planSmartReports", null);
__decorate([
    Selector()
], PlansState, "planSmartSorts", null);
__decorate([
    Selector()
], PlansState, "selectedPlanSmartDetails", null);
__decorate([
    Selector()
], PlansState, "selectedPlanYearType", null);
__decorate([
    Selector()
], PlansState, "selectedPlanYear", null);
__decorate([
    Selector()
], PlansState, "hasPlanYearPermissionError", null);
__decorate([
    Selector()
], PlansState, "plansRiderBenefitCategories", null);
__decorate([
    Selector([PlansState_1.plansRiderBenefitCategories])
], PlansState, "selectedPlansRiderBenefitCategoryIds", null);
__decorate([
    Selector([PlansState_1.hospitalIndemnityQuestions, PlansState_1.hospitalIndemnityAnswers])
], PlansState, "hospitalIndemnityAnswersMap", null);
__decorate([
    Selector()
], PlansState, "snpVisibility", null);
__decorate([
    Selector([PlansState_1.snpVisibility])
], PlansState, "hiddenSNPTypes", null);
__decorate([
    Selector([PlansState_1.planTypeDataMap()])
], PlansState, "payload", null);
__decorate([
    Selector([PlansState_1.payload, PlansState_1.planScores(), PlansState_1.planCoveredPreferences(), ProviderState.providerDetails])
], PlansState, "plansMap", null);
__decorate([
    Selector([PlansState_1.currentPlanPayload, PlansState_1.planScores(), PlansState_1.planCoveredPreferences(), ProviderState.providerDetails])
], PlansState, "currentPlansMap", null);
__decorate([
    Selector([PlansState_1.plansMap])
], PlansState, "plans", null);
__decorate([
    Selector([PlansState_1.planTypeDataMap()])
], PlansState, "pharmaciesMap", null);
__decorate([
    Selector([PlansState_1.rawCurrentPlanTypeDataMap()])
], PlansState, "currentPlanPayload", null);
__decorate([
    Selector([PlansState_1.currentPlanPayload])
], PlansState, "currentPlans", null);
__decorate([
    Selector([PlansState_1.pharmaciesMap])
], PlansState, "pharmacies", null);
__decorate([
    Selector()
], PlansState, "plansQueuePosition", null);
__decorate([
    Selector([PlansState_1.plans, PlansState_1.hiddenSNPTypes])
], PlansState, "plansFilteredBySNPVisibility", null);
__decorate([
    Selector()
], PlansState, "medicareGroupPlanConfiguration", null);
__decorate([
    Selector([PlansState_1.medicareGroupPlanConfiguration])
], PlansState, "medicareGroupPlanFilterConfiguration", null);
__decorate([
    Selector([PlansState_1.planTypeDataMap()])
], PlansState, "storePlanTypes", null);
__decorate([
    Selector()
], PlansState, "filterGroups", null);
__decorate([
    Selector()
], PlansState, "sortGroups", null);
__decorate([
    Selector()
], PlansState, "activePlanDetailsTabType", null);
__decorate([
    Selector()
], PlansState, "activeTabType", null);
__decorate([
    Selector()
], PlansState, "defaultTabType", null);
__decorate([
    Selector()
], PlansState, "planComparePlanType", null);
__decorate([
    Selector()
], PlansState, "compareGroupsWithPlanIds", null);
__decorate([
    Selector()
], PlansState, "planSmartLoading", null);
__decorate([
    Selector([PlansState_1.plansMap, PlansState_1.currentPlans, PlansState_1.compareGroupsWithPlanIds])
], PlansState, "compareGroups", null);
__decorate([
    Selector()
], PlansState, "quoteGroups", null);
__decorate([
    Selector()
], PlansState, "includePUFPlans", null);
__decorate([
    Selector()
], PlansState, "includeNonLicensedPlans", null);
__decorate([
    Selector()
], PlansState, "isTotalEstimatedCostAnnually", null);
__decorate([
    Selector()
], PlansState, "activeRateFactorPlanId", null);
__decorate([
    Selector([PlansState_1.plansMap, PlansState_1.activeRateFactorPlanId])
], PlansState, "activeRateFactorPlan", null);
__decorate([
    Selector()
], PlansState, "isActiveTabTotalCost", null);
__decorate([
    Selector([PlansState_1.planCounts()])
], PlansState, "arePlanCountsLoaded", null);
__decorate([
    Selector()
], PlansState, "isActiveTabPrescription", null);
__decorate([
    Selector()
], PlansState, "planShortLoading", null);
__decorate([
    Selector()
], PlansState, "currentPlanShort", null);
__decorate([
    Selector([PlansState_1.currentPlans, PlansState_1.activeTabType])
], PlansState, "currentPlansFilteredByActiveTab", null);
__decorate([
    Selector([PlansState_1.plansFilteredBySNPVisibility, PlansState_1.activeTabType])
], PlansState, "activeTabTotalPlanPremiums", null);
__decorate([
    Selector([PlansState_1.filterGroups])
], PlansState, "availableTabs", null);
__decorate([
    Selector()
], PlansState, "selectedPlanSubType", null);
__decorate([
    Selector()
], PlansState, "planSmartFilterGroup", null);
__decorate([
    Selector()
], PlansState, "totalSiteCarrierCount", null);
__decorate([
    Selector()
], PlansState, "totalSitePlanCount", null);
PlansState = PlansState_1 = __decorate([
    State({
        name: 'plans',
        defaults: PLANS_DEFAULTS
    })
    /**
     * A store for holding the plans available to the consumer.
     */
], PlansState);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlansState, [{
        type: Injectable
    }], function () { return [{ type: i1.Store }, { type: PlansHttpService }, { type: CarriersHttpService }]; }, { fetchPlanQuestions: [], fetchPlanQuestionsError: [], updateAncillaryPlanQuestions: [], updateAncillaryPlanAnswers: [], fetchHospitalIndemnityQuestions: [], fetchHospitalIndemnityQuestionsError: [], updateHospitalIndemnityPlanQuestions: [], updateHospitalIndemnityPlanAnswers: [], selectQuestions: [], fetchPlansSuccess: [], fetchPlansError: [], updatePUFPlanSettings: [], updateNonLicensedPlanSettings: [], updatePlansQueuePosition: [], updatePlans: [], updateCurrentPlans: [], updateCurrentPlanPharmacies: [], updatePlanPharmacies: [], setSortGroup: [], clearSortGroupSort: [], updateSortGroup: [], clearSort: [], setFilterGroup: [], addFilterToFilterGroups: [], clearPlanSmartFilterGroupWithKey: [], clearPlanSmartFilterGroupFilters: [], initializePlanSmartFilterGroups: [], addFilterToPlanSmartFilterGroups: [], clearFilterGroupFilter: [], clearFilterGroupFilters: [], updateFilterGroupFilters: [], removeFilterGroups: [], setActiveTab: [], setActivePlanDetailsTab: [], clearActiveTab: [], setDefaultActiveTab: [], selectPlanDetails: [], setPlanComparePlanType: [], setCompareGroup: [], addPlanToCompareGroup: [], removePlanFromCompareGroup: [], removePlanFromCompareGroups: [], addPlansToCompareGroup: [], removeAllPlansFromCompareGroup: [], updateFirstPlanInCompareGroup: [], setPlansDirty: [], resetPlanTypes: [], resetPlansState: [], setLoading: [], setPlanShortLoading: [], setQuoteGroup: [], addPlanToQuoteGroup: [], updateFirstPlanInQuoteGroup: [], removePlanFromQuoteGroup: [], removePlanFromQuoteGroups: [], setTotalEstimatedCostAnnually: [], setIsActiceTabTotalCost: [], setSelectedPlanYear: [], setPlanYearPermissionError: [], SetPlanSmartReports: [], fetchPlanSmartReportsError: [], fetchPlanSmartReports: [], UpdatePlanSmartSort: [], SetSelectedPlanSmartDetails: [], ResetSelectedPlanSmartDetails: [], ResetPlanSmart: [], setIsActiveTabPrescription: [], setActiveRateFactorPlanId: [], removeActiveRateFactorPlanId: [], setCSNPVisibility: [], setDSNPVisibility: [], setISNPVisibility: [], setAllSNPTypesVisibility: [], setVisibleSNPTypes: [], updateSelectedPlanSubType: [], clearSelectedPlanSubType: [], updatePlansRiderBenefitCategories: [], setPlanCounts: [], setCoveredPreferences: [], setPlanScores: [], updatePlanShortData: [], initializePlanTypeDataMap: [], updatePlanTypeDataMap: [], resetPlanYearState: [], fetchCarrierCounts: [], SetMedicareGroupPlanConfiguration: [], SetCurrentPlanShort: [] }); })();

class SetPreferences {
    constructor(preferences) {
        this.preferences = preferences;
    }
}
SetPreferences.type = '[Preferences] Set Preferences';
class LoadPreferences {
    constructor(sessionId) {
        this.sessionId = sessionId;
    }
}
LoadPreferences.type = '[Preferences] Load Preferences';
class ResetPreferencesUpdatedStatus {
}
ResetPreferencesUpdatedStatus.type = '[Preferences] Reset Preferences Updated Status';
class ResetPreferences {
}
ResetPreferences.type = '[Preferences] Reset Preferences';

class PreferencesHttpService {
    constructor(http) {
        this.http = http;
        this.environment = EnvironmentService.getEnvironment();
    }
    savePreferenceQuestionAnswers$(sessionId, preferences) {
        return this.http.post(`${this.environment.MEMBER_SESSION_BASE_URL}/${sessionId}/Preferences`, {
            Preferences: preferences
        });
    }
    async savePreferenceQuestionAnswers(sessionId, preferences) {
        return this.savePreferenceQuestionAnswers$(sessionId, preferences).toPromise();
    }
    getPreferenceQuestionAnswers$(sessionId) {
        return this.http.get(`${this.environment.MEMBER_SESSION_BASE_URL}/${sessionId}/Preferences`);
    }
    async getPreferenceQuestionAnswers(sessionId) {
        return this.getPreferenceQuestionAnswers$(sessionId).toPromise();
    }
    getPersonalizedBenefits$(planYear) {
        const headers = new HttpHeaders({ 'Accept': 'application/json', 'Content-Type': 'application/json' });
        const url = `${this.environment.WEB_SERVICE_BASE_URL}/v2/BeneficiaryPreferences/PersonalizedBenefits?planYear=${planYear}`;
        return this.http.get(url, { headers });
    }
}
PreferencesHttpService.ɵfac = function PreferencesHttpService_Factory(t) { return new (t || PreferencesHttpService)(i0.ɵɵinject(i1$2.HttpClient)); };
PreferencesHttpService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PreferencesHttpService, factory: PreferencesHttpService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PreferencesHttpService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1$2.HttpClient }]; }, null); })();

var PreferencesState_1;
const PREFERENCES_STORE_NAME = 'preferences';
class PreferencesStateModel {
}
const PREFERENCES_DEFAULTS = {
    preferences: [],
    isUpdated: false
};
let PreferencesState = PreferencesState_1 = class PreferencesState {
    constructor(preferencesHttpService) {
        this.preferencesHttpService = preferencesHttpService;
    }
    static isUpdated(state) {
        return state.isUpdated;
    }
    static preferences(state) {
        return state.preferences;
    }
    static hasPreferences(preferences) {
        return preferences?.length ? true : false;
    }
    async loadPreferences(ctx, { sessionId }) {
        try {
            const preferencesModel = await this.preferencesHttpService.getPreferenceQuestionAnswers(sessionId);
            const hasPreferences = preferencesModel.preferences && preferencesModel.preferences.length ? true : false;
            if (hasPreferences) {
                ctx.patchState({
                    preferences: preferencesModel.preferences
                });
            }
        }
        catch {
            return Promise.resolve();
        }
    }
    setPreferences(ctx, { preferences }) {
        ctx.patchState({
            preferences,
            isUpdated: true
        });
    }
    resetPreferencesUpdatedStatus(ctx) {
        ctx.patchState({
            isUpdated: false
        });
    }
    resetPreferences(ctx) {
        ctx.setState(PREFERENCES_DEFAULTS);
    }
};
PreferencesState.ɵfac = function PreferencesState_Factory(t) { return new (t || PreferencesState)(i0.ɵɵinject(PreferencesHttpService)); };
PreferencesState.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PreferencesState, factory: PreferencesState.ɵfac });
__decorate([
    Action(LoadPreferences)
], PreferencesState.prototype, "loadPreferences", null);
__decorate([
    Action(SetPreferences)
], PreferencesState.prototype, "setPreferences", null);
__decorate([
    Action(ResetPreferencesUpdatedStatus)
], PreferencesState.prototype, "resetPreferencesUpdatedStatus", null);
__decorate([
    Action(ResetPreferences)
], PreferencesState.prototype, "resetPreferences", null);
__decorate([
    Selector()
], PreferencesState, "isUpdated", null);
__decorate([
    Selector()
], PreferencesState, "preferences", null);
__decorate([
    Selector([PreferencesState_1.preferences])
], PreferencesState, "hasPreferences", null);
PreferencesState = PreferencesState_1 = __decorate([
    State({
        name: PREFERENCES_STORE_NAME,
        defaults: PREFERENCES_DEFAULTS
    })
], PreferencesState);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PreferencesState, [{
        type: Injectable
    }], function () { return [{ type: PreferencesHttpService }]; }, { loadPreferences: [], setPreferences: [], resetPreferencesUpdatedStatus: [], resetPreferences: [] }); })();

class UpdateProfile {
    constructor(profile) {
        this.profile = profile;
    }
}
UpdateProfile.type = '[Profile] Update Profile';
class ResetProfileState {
}
ResetProfileState.type = '[Profile] Reset';
class UpdateProfileSession {
    constructor(sessionId, profile) {
        this.sessionId = sessionId;
        this.profile = profile;
    }
}
UpdateProfileSession.type = '[Profile] Update Profile Session';
class UpdateProfileEncryptedHICN {
    constructor(hicn, hicnKeyValue) {
        this.hicn = hicn;
        this.hicnKeyValue = hicnKeyValue;
    }
}
UpdateProfileEncryptedHICN.type = '[Profile] Update Profile Encrypted HICN';
class UpdateProfileIsArchived {
    constructor(isArchived) {
        this.isArchived = isArchived;
    }
}
UpdateProfileIsArchived.type = '[Profile] Update Profile IsArchived';
class FetchProfileCountyData {
    constructor(zip) {
        this.zip = zip;
    }
}
FetchProfileCountyData.type = '[Profile] Fetch County Data';

class MemberProgressEventType {
}
var GenderCode;
(function (GenderCode) {
    GenderCode[GenderCode["MALE"] = 1] = "MALE";
    GenderCode[GenderCode["FEMALE"] = 2] = "FEMALE";
    GenderCode[GenderCode["NOT_PROVIDED"] = 0] = "NOT_PROVIDED";
})(GenderCode || (GenderCode = {}));
var GenderValue;
(function (GenderValue) {
    GenderValue["MALE"] = "M";
    GenderValue["FEMALE"] = "F";
})(GenderValue || (GenderValue = {}));
var GenderType;
(function (GenderType) {
    GenderType["MALE"] = "1";
    GenderType["FEMALE"] = "2";
})(GenderType || (GenderType = {}));
var Gender;
(function (Gender) {
    Gender["MALE"] = "Male";
    Gender["FEMALE"] = "Female";
    Gender["NOT_PROVIDED"] = "Not Provided";
})(Gender || (Gender = {}));
var TobaccoUse;
(function (TobaccoUse) {
    TobaccoUse["NON_SMOKER"] = "Non-Smoker";
    TobaccoUse["SMOKER"] = "Smoker";
})(TobaccoUse || (TobaccoUse = {}));
var MaritalStatusValue;
(function (MaritalStatusValue) {
    MaritalStatusValue["SINGLE"] = "Single";
    MaritalStatusValue["MARRIED"] = "Married";
    MaritalStatusValue["WIDOWED"] = "Widowed";
    MaritalStatusValue["NOT_PROVIDED"] = "Not Provided";
})(MaritalStatusValue || (MaritalStatusValue = {}));
var MaritalStatusCode;
(function (MaritalStatusCode) {
    MaritalStatusCode[MaritalStatusCode["SINGLE"] = 2] = "SINGLE";
    MaritalStatusCode[MaritalStatusCode["MARRIED"] = 1] = "MARRIED";
    MaritalStatusCode[MaritalStatusCode["WIDOWED"] = 5] = "WIDOWED";
    MaritalStatusCode[MaritalStatusCode["NOT_PROVIDED"] = 0] = "NOT_PROVIDED";
})(MaritalStatusCode || (MaritalStatusCode = {}));
var MaritalStatusType;
(function (MaritalStatusType) {
    MaritalStatusType["SINGLE"] = "2";
    MaritalStatusType["MARRIED"] = "1";
    MaritalStatusType["WIDOWED"] = "5";
})(MaritalStatusType || (MaritalStatusType = {}));
var ProfileDisplayValue;
(function (ProfileDisplayValue) {
    ProfileDisplayValue["GENDER"] = "gender";
    ProfileDisplayValue["MARITAL_STATUS"] = "maritalStatus";
})(ProfileDisplayValue || (ProfileDisplayValue = {}));
var MemberSourceValue;
(function (MemberSourceValue) {
    MemberSourceValue["CONSUMER"] = "Consumer";
    MemberSourceValue["BROKER"] = "Broker";
    MemberSourceValue["CLAIMS"] = "Claims";
    MemberSourceValue["CALL_CENTER"] = "CallCenter";
})(MemberSourceValue || (MemberSourceValue = {}));
var PhoneNumberType;
(function (PhoneNumberType) {
    PhoneNumberType["MOBILE"] = "Mobile";
    PhoneNumberType["PRIMARY"] = "Primary";
    PhoneNumberType["BOTH"] = "Both";
})(PhoneNumberType || (PhoneNumberType = {}));

var ProfileState_1;
class APIProfileStateModel {
    constructor(profileStateModel) {
        this.firstName = profileStateModel.firstName;
        this.middleInitial = profileStateModel.middleInitial;
        this.lastName = profileStateModel.lastName;
        this.birthdate = profileStateModel.birthdate;
        this.emailAddress = profileStateModel.emailAddress;
        this.addresses = profileStateModel.addresses;
        this.hicn = profileStateModel.hicn;
        this.hicnKeyValue = profileStateModel.hicnKeyValue;
        this.homePhone = profileStateModel.homePhone;
        this.workPhone = profileStateModel.workPhone;
        this.cellPhone = profileStateModel.cellPhone;
        this.gender = profileStateModel.gender;
        this.maritalStatus = profileStateModel.maritalStatus;
        this.crmid = profileStateModel.crmid;
        this.customField1 = profileStateModel.customField1;
        this.customField2 = profileStateModel.customField2;
        this.customField3 = profileStateModel.customField3;
        this.customField4 = profileStateModel.customField4;
        this.customField5 = profileStateModel.customField5;
        this.memberSource = profileStateModel.memberSource;
        this.isRetentionMember = profileStateModel.isRetentionMember;
        this.isMedicareEligible = profileStateModel.isMedicareEligible;
        this.isDSNPEligible = profileStateModel.isDSNPEligible;
        this.lastCheckedDate = profileStateModel.lastCheckedDate;
        this.medicaidId = profileStateModel.medicaidId;
        this.medicaidCheckStatus = profileStateModel.medicaidCheckStatus;
        this.isMedicaidEligible = profileStateModel.isMedicaidEligible;
        this.eligibilityLevel = profileStateModel.eligibilityLevel;
        this.medicaidLastCheckedDate = profileStateModel.medicaidLastCheckedDate;
        this.medicaidStateSelection = profileStateModel.medicaidStateSelection;
        this.clientMessage = profileStateModel.clientMessage;
        this.accountGuid = profileStateModel.accountGuid;
        this.medicaidCarrierName = profileStateModel.medicaidCarrierName;
        this.isArchived = profileStateModel.isArchived;
    }
}
const PROFILE_STORE_NAME = 'profile';
class ProfileStateModel extends APIProfileStateModel {
}
const PROFILE_DEFAULTS = {
    firstName: '',
    middleInitial: '',
    lastName: '',
    birthdate: '',
    emailAddress: '',
    addresses: [],
    hicn: '',
    hicnKeyValue: '',
    homePhone: '',
    workPhone: '',
    cellPhone: '',
    gender: 0,
    maritalStatus: 0,
    crmid: '',
    customField1: '',
    customField2: '',
    customField3: '',
    customField4: '',
    customField5: '',
    memberStatus: '',
    isRetentionMember: false,
    counties: [],
    countyZipSelection: '',
    medicaidId: '',
    medicaidCheckStatus: '',
    isMedicaidEligible: false,
    eligibilityLevel: '',
    medicaidLastCheckedDate: '',
    medicaidStateSelection: '',
    clientMessage: '',
    accountGuid: '',
    medicaidCarrierName: '',
    isArchived: false
};
let ProfileState = ProfileState_1 = class ProfileState {
    constructor(demographicsHttpService, memberSessionHttpService, store) {
        this.demographicsHttpService = demographicsHttpService;
        this.memberSessionHttpService = memberSessionHttpService;
        this.store = store;
    }
    static firstName(state) {
        return state.firstName;
    }
    static middleInitial(state) {
        return state.middleInitial;
    }
    static lastName(state) {
        return state.lastName;
    }
    static birthdate(state) {
        return state.birthdate;
    }
    static crmid(state) {
        return state.crmid;
    }
    static isRetentionMember(state) {
        return state.isRetentionMember;
    }
    static memberSource(state) {
        return state.memberSource;
    }
    static isArchived(state) {
        return state.isArchived;
    }
    static isRetentionMemberFromSource(memberSourceValue) {
        return createSelector([ProfileState_1.isRetentionMember, ProfileState_1.memberSource], (isRetentionMember, memberSource) => isRetentionMember && memberSource === memberSourceValue);
    }
    static fullName(firstName, lastName) {
        return `${firstName} ${lastName}`.trim();
    }
    static hasFullName(fullName) {
        return !!fullName;
    }
    static emailAddress(state) {
        return state.emailAddress;
    }
    static addresses(state) {
        const addresses = [...state.addresses];
        return (addresses?.sort((addressA, addressB) => {
            if (addressA.isPrimaryAddress) {
                return -1;
            }
            else if (addressB.isPrimaryAddress) {
                return 1;
            }
            return 0;
        }) ?? []);
    }
    static primaryAddress(addresses) {
        return addresses?.find(address => address.isPrimaryAddress);
    }
    static address1(primaryAddress) {
        return primaryAddress?.address1 ?? '';
    }
    static address2(primaryAddress) {
        return primaryAddress?.address2 ?? '';
    }
    static city(primaryAddress) {
        return primaryAddress?.city ?? '';
    }
    static state(primaryAddress) {
        return primaryAddress?.state ?? '';
    }
    static zip(primaryAddress) {
        return primaryAddress?.zip ?? '';
    }
    static county(primaryAddress) {
        return primaryAddress?.countyFips ?? '';
    }
    static counties(state) {
        return state.counties;
    }
    static selectedPrimaryAddressCounty(counties, selectedFipsCode) {
        return counties?.find(county => county.countyFIPS === selectedFipsCode);
    }
    static selectedProfileCounty(counties, selectedFipsCode) {
        return counties?.find(county => county.countyFIPS === selectedFipsCode);
    }
    static hicnKeyValue(state) {
        return state.hicnKeyValue;
    }
    static hicn(state) {
        return state.hicn;
    }
    static homePhone(state) {
        return state.homePhone;
    }
    static workPhone(state) {
        return state.workPhone;
    }
    static cellPhone(state) {
        return state.cellPhone;
    }
    static genderCode(state) {
        return state.gender;
    }
    static gender(gender) {
        switch (gender) {
            case GenderCode.NOT_PROVIDED:
                return Gender.NOT_PROVIDED;
            case GenderCode.MALE:
                return Gender.MALE;
            case GenderCode.FEMALE:
                return Gender.FEMALE;
            default:
                return Gender.NOT_PROVIDED;
        }
    }
    static genderValue(gender) {
        switch (gender) {
            case GenderCode.MALE:
                return GenderValue.MALE;
            case GenderCode.FEMALE:
                return GenderValue.FEMALE;
            default:
                return null;
        }
    }
    static maritalStatus(state) {
        switch (state.maritalStatus) {
            case MaritalStatusCode.NOT_PROVIDED:
                return MaritalStatusValue.NOT_PROVIDED;
            case MaritalStatusCode.SINGLE:
                return MaritalStatusValue.SINGLE;
            case MaritalStatusCode.MARRIED:
                return MaritalStatusValue.MARRIED;
            case MaritalStatusCode.WIDOWED:
                return MaritalStatusValue.WIDOWED;
            default:
                return MaritalStatusValue.NOT_PROVIDED;
        }
    }
    static medicaidId(state) {
        return state.medicaidId;
    }
    static medicaidCheckStatus(state) {
        return state.medicaidCheckStatus;
    }
    static isMedicaidEligible(state) {
        return state.isMedicaidEligible;
    }
    static medicaidEligibilityLevel(state) {
        return state.eligibilityLevel;
    }
    static medicaidLastCheckedDate(state) {
        return state.medicaidLastCheckedDate;
    }
    static medicaidStateSelection(state) {
        return state.medicaidStateSelection;
    }
    static medicaidClientMessage(state) {
        return state.clientMessage;
    }
    static accountGuid(state) {
        return state.accountGuid;
    }
    static medicaidCarrierName(state) {
        return state.medicaidCarrierName;
    }
    updateProfile(ctx, { profile }) {
        const { patchState } = ctx;
        const currentProfile = ctx.getState();
        const updatedProfile = _merge(_cloneDeep(currentProfile), profile);
        patchState({
            ...updatedProfile
        });
    }
    resetProfileState(ctx) {
        const { setState } = ctx;
        setState(PROFILE_DEFAULTS);
    }
    updateProfileSession(ctx, { sessionId, profile }) {
        this.memberSessionHttpService.updateSession$(sessionId, { profile }).subscribe({
            next: updatedMemberSession => {
                if (updatedMemberSession?.profile?.accountGuid) {
                    const currentProfile = ctx.getState();
                    if (currentProfile.accountGuid !== updatedMemberSession.profile.accountGuid) {
                        ctx.dispatch(new UpdateProfile({ accountGuid: updatedMemberSession.profile.accountGuid }));
                    }
                }
            }
        });
    }
    updateProfileEncryptedHICN(ctx, { hicn, hicnKeyValue }) {
        const { patchState } = ctx;
        patchState({
            hicn,
            hicnKeyValue
        });
    }
    updateProfileIsArchived(ctx, { isArchived }) {
        const { patchState } = ctx;
        patchState({
            isArchived
        });
    }
    async fetchProfileCountyData(ctx, { zip }) {
        const { setState } = ctx;
        const profileStateModel = ctx.getState();
        const currentCounties = profileStateModel.counties;
        const countyZipSelection = profileStateModel.countyZipSelection;
        let counties = [];
        // grab counties if we have them, otherwise fetch counties
        if (currentCounties?.length && zip === countyZipSelection) {
            counties = currentCounties;
        }
        else {
            const demographicsZipSelection = this.store.selectSnapshot(DemographicState.countyZipSelection);
            if (demographicsZipSelection === zip) {
                counties = this.store.selectSnapshot(DemographicState.counties);
            }
            else {
                counties = await this.demographicsHttpService.retrieveCounties$(zip).toPromise();
            }
        }
        setState(patch({
            counties,
            countyZipSelection: zip
        }));
    }
};
ProfileState.ɵfac = function ProfileState_Factory(t) { return new (t || ProfileState)(i0.ɵɵinject(DemographicHttpService), i0.ɵɵinject(MemberSessionHttpService), i0.ɵɵinject(i1.Store)); };
ProfileState.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ProfileState, factory: ProfileState.ɵfac });
__decorate([
    LiveEditInactive(),
    Action(UpdateProfile)
], ProfileState.prototype, "updateProfile", null);
__decorate([
    Action(ResetProfileState)
], ProfileState.prototype, "resetProfileState", null);
__decorate([
    LiveEditInactive(),
    Action(UpdateProfileSession)
], ProfileState.prototype, "updateProfileSession", null);
__decorate([
    Action(UpdateProfileEncryptedHICN)
], ProfileState.prototype, "updateProfileEncryptedHICN", null);
__decorate([
    Action(UpdateProfileIsArchived)
], ProfileState.prototype, "updateProfileIsArchived", null);
__decorate([
    LiveEditInactive(),
    Action(FetchProfileCountyData)
], ProfileState.prototype, "fetchProfileCountyData", null);
__decorate([
    Selector()
], ProfileState, "firstName", null);
__decorate([
    Selector()
], ProfileState, "middleInitial", null);
__decorate([
    Selector()
], ProfileState, "lastName", null);
__decorate([
    Selector()
], ProfileState, "birthdate", null);
__decorate([
    Selector()
], ProfileState, "crmid", null);
__decorate([
    Selector()
], ProfileState, "isRetentionMember", null);
__decorate([
    Selector()
], ProfileState, "memberSource", null);
__decorate([
    Selector()
], ProfileState, "isArchived", null);
__decorate([
    Selector([ProfileState_1.firstName, ProfileState_1.lastName])
], ProfileState, "fullName", null);
__decorate([
    Selector([ProfileState_1.fullName])
], ProfileState, "hasFullName", null);
__decorate([
    Selector()
], ProfileState, "emailAddress", null);
__decorate([
    Selector()
], ProfileState, "addresses", null);
__decorate([
    Selector([ProfileState_1.addresses])
], ProfileState, "primaryAddress", null);
__decorate([
    Selector([ProfileState_1.primaryAddress])
], ProfileState, "address1", null);
__decorate([
    Selector([ProfileState_1.primaryAddress])
], ProfileState, "address2", null);
__decorate([
    Selector([ProfileState_1.primaryAddress])
], ProfileState, "city", null);
__decorate([
    Selector([ProfileState_1.primaryAddress])
], ProfileState, "state", null);
__decorate([
    Selector([ProfileState_1.primaryAddress])
], ProfileState, "zip", null);
__decorate([
    Selector([ProfileState_1.primaryAddress])
], ProfileState, "county", null);
__decorate([
    Selector()
], ProfileState, "counties", null);
__decorate([
    Selector([ProfileState_1.counties, ProfileState_1.county])
], ProfileState, "selectedPrimaryAddressCounty", null);
__decorate([
    Selector([ProfileState_1.counties, DemographicState.selectedFipsCode])
], ProfileState, "selectedProfileCounty", null);
__decorate([
    Selector()
], ProfileState, "hicnKeyValue", null);
__decorate([
    Selector()
], ProfileState, "hicn", null);
__decorate([
    Selector()
], ProfileState, "homePhone", null);
__decorate([
    Selector()
], ProfileState, "workPhone", null);
__decorate([
    Selector()
], ProfileState, "cellPhone", null);
__decorate([
    Selector()
], ProfileState, "genderCode", null);
__decorate([
    Selector([ProfileState_1.genderCode])
], ProfileState, "gender", null);
__decorate([
    Selector([ProfileState_1.genderCode])
], ProfileState, "genderValue", null);
__decorate([
    Selector()
], ProfileState, "maritalStatus", null);
__decorate([
    Selector()
], ProfileState, "medicaidId", null);
__decorate([
    Selector()
], ProfileState, "medicaidCheckStatus", null);
__decorate([
    Selector()
], ProfileState, "isMedicaidEligible", null);
__decorate([
    Selector()
], ProfileState, "medicaidEligibilityLevel", null);
__decorate([
    Selector()
], ProfileState, "medicaidLastCheckedDate", null);
__decorate([
    Selector()
], ProfileState, "medicaidStateSelection", null);
__decorate([
    Selector()
], ProfileState, "medicaidClientMessage", null);
__decorate([
    Selector()
], ProfileState, "accountGuid", null);
__decorate([
    Selector()
], ProfileState, "medicaidCarrierName", null);
ProfileState = ProfileState_1 = __decorate([
    State({
        name: 'profile',
        defaults: PROFILE_DEFAULTS
    })
    /**
     * A store the holds the users profile data.
     */
], ProfileState);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProfileState, [{
        type: Injectable
    }], function () { return [{ type: DemographicHttpService }, { type: MemberSessionHttpService }, { type: i1.Store }]; }, { updateProfile: [], resetProfileState: [], updateProfileSession: [], updateProfileEncryptedHICN: [], updateProfileIsArchived: [], fetchProfileCountyData: [] }); })();

class ResetShoppingCartState {
}
ResetShoppingCartState.type = '[ShoppingCart] Reset';
class SelectPlan {
    constructor(plan, clearTransaction) {
        this.plan = plan;
        this.clearTransaction = clearTransaction;
    }
}
SelectPlan.type = '[ShoppingCart] Select Plan';
class SelectPlanWithBundle {
    constructor(plan, newItem, planRiders, clearTransaction) {
        this.plan = plan;
        this.newItem = newItem;
        this.planRiders = planRiders;
        this.clearTransaction = clearTransaction;
    }
}
SelectPlanWithBundle.type = '[ShoppingCart] Select Plan with Bundle';
class UpdatePlanWithBundle {
    constructor(plan, newItem, planRiders, clearTransaction) {
        this.plan = plan;
        this.newItem = newItem;
        this.planRiders = planRiders;
        this.clearTransaction = clearTransaction;
    }
}
UpdatePlanWithBundle.type = '[ShoppingCart] Update Plan with Bundle';
class InsertPlanWithBundle {
    constructor(plan, newItem, planRiders, clearTransaction) {
        this.plan = plan;
        this.newItem = newItem;
        this.planRiders = planRiders;
        this.clearTransaction = clearTransaction;
    }
}
InsertPlanWithBundle.type = '[ShoppingCart] Insert Plan with Bundle';
class InsertPlan {
    constructor(plan, newItem, riderIds, clearTransaction) {
        this.plan = plan;
        this.newItem = newItem;
        this.riderIds = riderIds;
        this.clearTransaction = clearTransaction;
    }
}
InsertPlan.type = '[ShoppingCart] Insert Plan';
class ClearCartTransaction {
    constructor(planId, clearTransaction = true) {
        this.planId = planId;
        this.clearTransaction = clearTransaction;
    }
}
ClearCartTransaction.type = '[ShoppingCart] Clear Cart Transaction Data';
class UpdatePlan {
    constructor(plan) {
        this.plan = plan;
    }
}
UpdatePlan.type = '[ShoppingCart] Update Plan';
class RemovePlan {
    constructor(planId) {
        this.planId = planId;
    }
}
RemovePlan.type = '[ShoppingCart] Remove Plan';
class RemovePlans {
}
RemovePlans.type = '[ShoppingCart] Remove Plans';
class SelectRider {
    constructor(riderId) {
        this.riderId = riderId;
    }
}
SelectRider.type = '[ShoppingCart] Select Rider';
class RemoveRider {
    constructor(riderId) {
        this.riderId = riderId;
    }
}
RemoveRider.type = '[ShoppingCart] Remove Rider';
class RemoveRiders {
}
RemoveRiders.type = '[ShoppingCart] Remove Riders';
class UpdateShoppingCartAPIModel {
    constructor(shoppingCart) {
        this.shoppingCart = shoppingCart;
    }
}
UpdateShoppingCartAPIModel.type = '[ShoppingCart] Update API Model';
class UpdateCartSession {
    constructor(sessionId) {
        this.sessionId = sessionId;
    }
}
UpdateCartSession.type = '[ShoppingCart] Update Session';
class UpdateShoppingCartPlanPremium {
    constructor(planId, medicalMonthlyPremium, drugMonthlyPremium) {
        this.planId = planId;
        this.medicalMonthlyPremium = medicalMonthlyPremium;
        this.drugMonthlyPremium = drugMonthlyPremium;
    }
}
UpdateShoppingCartPlanPremium.type = '[ShoppingCart] Update Shopping Cart Plan Premium';
class SetShoppingCartLoading {
    constructor(loading) {
        this.loading = loading;
    }
}
SetShoppingCartLoading.type = '[ShoppingCart] Loading';

class CreateTransaction {
    constructor(sessionId, planId, transactionData, planYear, isSiteLive, isReviewSite, allowSamePlanEnrollment, quoteId, enrollmentKey, hraData, formType, originalTransactionGUID, callRecordingCode, isPurl = false, planRanking, bestMatchPlanId, bestMatchPlanType, isAncillary = false, callRecordingAvailable = false, isTestingSite = false) {
        this.sessionId = sessionId;
        this.planId = planId;
        this.transactionData = transactionData;
        this.planYear = planYear;
        this.isSiteLive = isSiteLive;
        this.isReviewSite = isReviewSite;
        this.allowSamePlanEnrollment = allowSamePlanEnrollment;
        this.quoteId = quoteId;
        this.enrollmentKey = enrollmentKey;
        this.hraData = hraData;
        this.formType = formType;
        this.originalTransactionGUID = originalTransactionGUID;
        this.callRecordingCode = callRecordingCode;
        this.isPurl = isPurl;
        this.planRanking = planRanking;
        this.bestMatchPlanId = bestMatchPlanId;
        this.bestMatchPlanType = bestMatchPlanType;
        this.isAncillary = isAncillary;
        this.callRecordingAvailable = callRecordingAvailable;
        this.isTestingSite = isTestingSite;
    }
}
CreateTransaction.type = '[Enrollment] Create Transaction';
class CreateNextGenTransaction {
    constructor(nextGenEnrollmentRequest, callRecordingAvailable) {
        this.nextGenEnrollmentRequest = nextGenEnrollmentRequest;
        this.callRecordingAvailable = callRecordingAvailable;
    }
}
CreateNextGenTransaction.type = '[Enrollment] Create NextGen Transaction';
class CompleteNextGenEnrollment {
    constructor(nextGenEnrollmentRequest, transactionId, planCount) {
        this.nextGenEnrollmentRequest = nextGenEnrollmentRequest;
        this.transactionId = transactionId;
        this.planCount = planCount;
    }
}
CompleteNextGenEnrollment.type = '[Enrollment] Complete NextGen Transaction';
class UpdateTransaction {
    constructor(transactionData, enrollmentKey) {
        this.transactionData = transactionData;
        this.enrollmentKey = enrollmentKey;
    }
}
UpdateTransaction.type = '[Enrollment] Update Transaction';
class UpdateNextGenTransaction {
    constructor(answersMap, enrollmentKey) {
        this.answersMap = answersMap;
        this.enrollmentKey = enrollmentKey;
    }
}
UpdateNextGenTransaction.type = '[Enrollment] Update NextGen Transaction';
class FetchTransaction {
    constructor(transactionId, enrollmentKey) {
        this.transactionId = transactionId;
        this.enrollmentKey = enrollmentKey;
    }
}
FetchTransaction.type = '[Enrollment] Fetch Transaction';
class FetchNextGenTransaction {
    constructor(sessionId, transactionId, enrollmentKey) {
        this.sessionId = sessionId;
        this.transactionId = transactionId;
        this.enrollmentKey = enrollmentKey;
    }
}
FetchNextGenTransaction.type = '[Enrollment] Fetch NextGen Transaction';
class ClearTransaction {
    constructor(enrollmentKey) {
        this.enrollmentKey = enrollmentKey;
    }
}
ClearTransaction.type = '[Enrollment] Clear Transaction';
class FetchNextGenSepReasons {
    constructor(planId, carrierId, planYear, language, planType, displaySEPReasons) {
        this.planId = planId;
        this.carrierId = carrierId;
        this.planYear = planYear;
        this.language = language;
        this.planType = planType;
        this.displaySEPReasons = displaySEPReasons;
    }
}
FetchNextGenSepReasons.type = '[Enrollment] Fetch NextGen Sep Reasons';
class CompleteEnrollment {
    constructor(sessionId, transactionId, planYear, enrollmentRequest, enrollmentKey, planCount) {
        this.sessionId = sessionId;
        this.transactionId = transactionId;
        this.planYear = planYear;
        this.enrollmentRequest = enrollmentRequest;
        this.enrollmentKey = enrollmentKey;
        this.planCount = planCount;
    }
}
CompleteEnrollment.type = '[Enrollment] Complete Enrollment';
class SetFormLoading {
    constructor(loading, loaded, enrollmentKey) {
        this.loading = loading;
        this.loaded = loaded;
        this.enrollmentKey = enrollmentKey;
    }
}
SetFormLoading.type = '[Enrollment] Set Form Loading';
class SetNextGenFormLoading {
    constructor(enrollmentKey, loading) {
        this.enrollmentKey = enrollmentKey;
        this.loading = loading;
    }
}
SetNextGenFormLoading.type = '[Enrollment] Set NextGen Form Loading';
class SetNextGenFormLoaded {
    constructor(enrollmentKey, loaded) {
        this.enrollmentKey = enrollmentKey;
        this.loaded = loaded;
    }
}
SetNextGenFormLoaded.type = '[Enrollment] Set NextGen Form Loaded';
class SetConfirmationDataLoading {
    constructor(confirmationDataLoading, enrollmentKey) {
        this.confirmationDataLoading = confirmationDataLoading;
        this.enrollmentKey = enrollmentKey;
    }
}
SetConfirmationDataLoading.type = '[Enrollment] Set Confirmation Data Loading';
class SetPageVisited {
    constructor(requestedPageIndex, enrollmentKey) {
        this.requestedPageIndex = requestedPageIndex;
        this.enrollmentKey = enrollmentKey;
    }
}
SetPageVisited.type = '[Enrollment] Set Page Visited';
class SetPageComplete {
    constructor(requestedPageIndex, enrollmentKey) {
        this.requestedPageIndex = requestedPageIndex;
        this.enrollmentKey = enrollmentKey;
    }
}
SetPageComplete.type = '[Enrollment] Set Page Complete';
class SetPageSkipped {
    constructor(pageIndex, skipped, enrollmentKey) {
        this.pageIndex = pageIndex;
        this.skipped = skipped;
        this.enrollmentKey = enrollmentKey;
    }
}
SetPageSkipped.type = '[Enrollment] Set Page Skipped';
class SetActiveEnrollmentKey {
    constructor(activeKey) {
        this.activeKey = activeKey;
    }
}
SetActiveEnrollmentKey.type = '[Enrollment] Set Active Enrollment Key';
class SetCurrentFormVersionId {
    constructor(formVersionId) {
        this.formVersionId = formVersionId;
    }
}
SetCurrentFormVersionId.type = '[Enrollment] Set Current Form Version Id';
class SetPreviousFormVersionId {
    constructor(formVersionId) {
        this.formVersionId = formVersionId;
    }
}
SetPreviousFormVersionId.type = '[Enrollment] Set Previous Form Version Id';
class SetPCAPICustomPlanPremium {
    constructor(customPlanPremium) {
        this.customPlanPremium = customPlanPremium;
    }
}
SetPCAPICustomPlanPremium.type = '[Enrollment] Set PC API Custom Plan Premium';
class SetCrossSellEnrollmentTypes {
    constructor(enrollmentTypes) {
        this.enrollmentTypes = enrollmentTypes;
    }
}
SetCrossSellEnrollmentTypes.type = '[Enrollment] Set CrossSell Enrollment Types';
class FetchFormPageInfo {
    constructor(enrollmentKey) {
        this.enrollmentKey = enrollmentKey;
    }
}
FetchFormPageInfo.type = '[Enrollment] Fetch Form Page Info';
class FetchFormPageHtml {
    constructor(requestedPageIndex, enrollmentKey, locale, planYear) {
        this.requestedPageIndex = requestedPageIndex;
        this.enrollmentKey = enrollmentKey;
        this.locale = locale;
        this.planYear = planYear;
    }
}
FetchFormPageHtml.type = '[Enrollment] Fetch Form Page Html';
class ResetActiveEnrollmentKey {
}
ResetActiveEnrollmentKey.type = '[Enrollment] Reset Active Enrollment Key';
class ResetCrossSellEnrollmentTypes {
}
ResetCrossSellEnrollmentTypes.type = '[Enrollment] Reset CrossSell Enrollment Types';
class ResetEnrollmentState {
    constructor(overrideDefaults = {}) {
        this.overrideDefaults = overrideDefaults;
    }
}
ResetEnrollmentState.type = '[Enrollment] Reset';
class UpdateSelectedFormType {
    constructor(selectedFormType, enrollmentKey, hasNextGenForm) {
        this.selectedFormType = selectedFormType;
        this.enrollmentKey = enrollmentKey;
        this.hasNextGenForm = hasNextGenForm;
    }
}
UpdateSelectedFormType.type = '[Enrollment] Update Next Requested Form Type';
class UpdateNextGenSelectedFormType {
    constructor(selectedFormType, enrollmentKey) {
        this.selectedFormType = selectedFormType;
        this.enrollmentKey = enrollmentKey;
    }
}
UpdateNextGenSelectedFormType.type = '[Enrollment] Update Next NextGen Requested Form Type';
class UpdateHopeSelectedFormType {
    constructor(selectedFormType, enrollmentKey) {
        this.selectedFormType = selectedFormType;
        this.enrollmentKey = enrollmentKey;
    }
}
UpdateHopeSelectedFormType.type = '[Enrollment] Update Next Hope Requested Form Type';
class UpdateUserFormType {
    constructor(userFormType, enrollmentKey, isFormSignAndSubmitOnly) {
        this.userFormType = userFormType;
        this.enrollmentKey = enrollmentKey;
        this.isFormSignAndSubmitOnly = isFormSignAndSubmitOnly;
    }
}
UpdateUserFormType.type = '[Enrollment] Update User Form Type';
class UpdateHopeUserFormType {
    constructor(userFormType, enrollmentKey) {
        this.userFormType = userFormType;
        this.enrollmentKey = enrollmentKey;
    }
}
UpdateHopeUserFormType.type = '[Enrollment] Update Hope User Form Type';
class UpdateNextGenUserFormType {
    constructor(userFormType, enrollmentKey, isFormSignAndSubmitOnly) {
        this.userFormType = userFormType;
        this.enrollmentKey = enrollmentKey;
        this.isFormSignAndSubmitOnly = isFormSignAndSubmitOnly;
    }
}
UpdateNextGenUserFormType.type = '[Enrollment] Update NextGen User Form Type';
class CreateHopeTransactions {
    constructor(transactions, enrollmentKey) {
        this.transactions = transactions;
        this.enrollmentKey = enrollmentKey;
    }
}
CreateHopeTransactions.type = '[Enrollment] Create Hope Transactions';
class CreatePlanCompareApiTransaction {
    constructor(sessionId, planId, storageId, planYear, isSiteLive, isReviewSite, createdIPAddress, partnerID, sourceID, destinationAppID, enrollmentKey) {
        this.sessionId = sessionId;
        this.planId = planId;
        this.storageId = storageId;
        this.planYear = planYear;
        this.isSiteLive = isSiteLive;
        this.isReviewSite = isReviewSite;
        this.createdIPAddress = createdIPAddress;
        this.partnerID = partnerID;
        this.sourceID = sourceID;
        this.destinationAppID = destinationAppID;
        this.enrollmentKey = enrollmentKey;
    }
}
CreatePlanCompareApiTransaction.type = '[Enrollment] Create Plan Compare Api Transaction';
class CreatePlanCompareApiNextGenTransaction {
    constructor(nextGenEnrollmentRequest) {
        this.nextGenEnrollmentRequest = nextGenEnrollmentRequest;
    }
}
CreatePlanCompareApiNextGenTransaction.type = '[Enrollment] Create Plan Compare Api NextGen Transaction';
class SetFormPagesDirty {
    constructor(enrollmentKey) {
        this.enrollmentKey = enrollmentKey;
    }
}
SetFormPagesDirty.type = '[Enrollment] Set Form Pages Dirty';
class ClearFormPagesLoading {
    constructor(enrollmentKey) {
        this.enrollmentKey = enrollmentKey;
    }
}
ClearFormPagesLoading.type = '[Enrollment] Clear Form Pages Loading';
class UpdateHRAParentInfo {
    constructor(hraParentPlan, hraParentEnrollmentConfirmationNumber) {
        this.hraParentPlan = hraParentPlan;
        this.hraParentEnrollmentConfirmationNumber = hraParentEnrollmentConfirmationNumber;
    }
}
UpdateHRAParentInfo.type = '[Enrollment] Update HRA plan';
class ClearHRAParentInfo {
}
ClearHRAParentInfo.type = '[Enrollment] Clear HRA plan';
class SetEnrollmentHistorySelectedPlan {
    constructor(plan) {
        this.plan = plan;
    }
}
SetEnrollmentHistorySelectedPlan.type = '[Enrollment] Set Enrollment History Selected Plan';
class ClearEnrollmentHistorySelectedPlan {
}
ClearEnrollmentHistorySelectedPlan.type = '[Enrollment] Clear Enrollment History Selected Plan';
class SetCallRecordingAvailable {
}
SetCallRecordingAvailable.type = '[Enrollment] Set Call Recording Available';
class ClearCallRecordingAvailable {
}
ClearCallRecordingAvailable.type = '[Enrollment] Clear Call Recording Available';
class UpdateCMSApprovalCode {
    constructor(formCMSApprovalCode, enrollmentKey) {
        this.formCMSApprovalCode = formCMSApprovalCode;
        this.enrollmentKey = enrollmentKey;
    }
}
UpdateCMSApprovalCode.type = '[Enrollment] Set CMS Approval Code';

// Note: Taken from https://github.com/mailok/todo-ngxs/blob/master/src/app/store/operators/update-many-items.ts
// until NGXS has native support for updating many items in a single state selector
/**
 * @param selector - Array of indices or a predicate function
 * that can be provided in `Array.prototype.findIndex`
 * @param operatorOrValue - New value under the `selector` index or a
 * function that can be applied to an existing value
 */
function updateItems(selector, operatorOrValue) {
    return function updateItemsOperator(existing) {
        let indices = [];
        if (!selector || !operatorOrValue) {
            return existing;
        }
        if (!existing) {
            return existing;
        }
        if (isPredicate(selector)) {
            indices = findIndices(selector, existing);
        }
        else if (isArrayNumber(selector)) {
            indices = selector;
        }
        if (invalidIndexs(indices, existing)) {
            return existing;
        }
        let values = {};
        if (isStateOperator(operatorOrValue)) {
            values = indices.reduce((acc, it) => ({ ...acc, [it]: operatorOrValue(existing[it]) }), {});
        }
        else {
            values = indices.reduce((acc, it) => isObject(existing[it]) ? { ...acc, [it]: { ...existing[it], ...operatorOrValue } } : { ...acc, [it]: operatorOrValue }, {});
        }
        const clone = [...existing];
        const keys = Object.keys(values);
        for (const i in keys) {
            clone[keys[i]] = values[keys[i]];
        }
        return clone;
    };
}

var ShoppingCartState_1;
const SHOPPING_CART_STORE_NAME = 'shoppingCart';
class APIShoppingCartRiderModel {
}
class APIShoppingCartModel {
}
class APIShoppingCartStateModel {
}
class ShoppingCartStateModel extends APIShoppingCartStateModel {
}
const SHOPPING_CART_DEFAULTS = {
    // shoppingCart is a small subset of the data that is supposed to match what we send/get from the API.
    shoppingCart: [],
    loading: false,
    // selectedPlans are the entire Plan objects from the plans call.
    selectedPlans: []
};
let ShoppingCartState = ShoppingCartState_1 = class ShoppingCartState {
    constructor(store, memberSessionHttpService) {
        this.store = store;
        this.memberSessionHttpService = memberSessionHttpService;
    }
    static selectCartAPIState(state) {
        return state.shoppingCart;
    }
    // Gets all selectedRiderIds across all plans
    static selectedRiderIds(shoppingCart) {
        let selectedRiderIds = [];
        if (shoppingCart) {
            selectedRiderIds = shoppingCart.reduce((cartRiderIds, cartPlan) => {
                cartRiderIds.push(...cartPlan.riders.filter(rider => rider.isSelected || rider.isRequired).map(selectedRider => selectedRider.riderId));
                return cartRiderIds;
            }, []);
        }
        return [...new Set(selectedRiderIds)];
    }
    static shoppingCartPlanIds(shoppingCart) {
        return shoppingCart?.map(cartPlan => cartPlan.planId) ?? [];
    }
    static shoppingCartPlanTypeAbbreviations(shoppingCart) {
        const uniquePlanTypes = new Set(shoppingCart?.map(cartPlan => cartPlan?.planType?.toUpperCase()));
        return Array.from(uniquePlanTypes);
    }
    static selectedPlans(state) {
        return state.selectedPlans;
    }
    static selectedPlanIds(selectedPlans) {
        return selectedPlans && selectedPlans.length ? selectedPlans.map(plan => plan.id) : [];
    }
    /**
     * @deprecated Need to leave this for backwards compatability. DO NOT USE in new development.
     */
    static selectedPlan(selectedPlans) {
        return selectedPlans && selectedPlans.length ? selectedPlans[0] : null;
    }
    static selectedPlanRiderIds(planId) {
        return createSelector([ShoppingCartState_1.selectCartAPIState], (shoppingCart) => {
            const selectedPlan = shoppingCart.find(plan => plan.planId === planId);
            if (selectedPlan && selectedPlan.riders) {
                return selectedPlan.riders.reduce((selectedRiders, rider) => {
                    if (rider.isSelected || rider.isRequired) {
                        selectedRiders.push(rider.riderId);
                    }
                    return selectedRiders;
                }, []);
            }
            return [];
        });
    }
    static selectedPlanMonthlyPremium(planId) {
        return createSelector([ShoppingCartState_1.selectedPlanById(planId)], (selectedPlan) => {
            if (selectedPlan) {
                if (selectedPlan.planType === PlanType.MEDIGAP) {
                    return selectedPlan.medicalPremium;
                }
                return selectedPlan.drugPremium + selectedPlan.medicalPremium;
            }
            return 0;
        });
    }
    static selectedPlanById(planId) {
        return createSelector([ShoppingCartState_1.selectedPlans, EnrollmentState.enrollmentHistorySelectedPlan], (selectedPlans, enrollmentHistorySelectedPlan) => {
            const selectedPlan = [...selectedPlans, ...(enrollmentHistorySelectedPlan ? [enrollmentHistorySelectedPlan] : [])].find(plan => plan.id === planId);
            return selectedPlan ? selectedPlan : null;
        });
    }
    static selectedPlanDisplaySEP(planId) {
        return createSelector([ShoppingCartState_1.selectedPlanById(planId), AppConfigState.resource('Enrollment_Display_SEP', null, null)], (selectedPlan, sepDefault) => {
            if (!selectedPlan || !selectedPlan.extraData) {
                return false;
            }
            const displaySEPExtraData = selectedPlan.extraData.find(eData => eData.name === PlanExtraDataKey.DISPLAY_SEP);
            if (displaySEPExtraData && displaySEPExtraData.value !== null) {
                return displaySEPExtraData.value.toLowerCase() === 'true' ? true : false;
            }
            return sepDefault && sepDefault.value === true;
        });
    }
    static selectedPlanRiders(planId) {
        return createSelector([ShoppingCartState_1.selectedPlanById(planId), ShoppingCartState_1.selectedRiderIds], (selectedPlan, selectedRiderIds) => selectedPlan?.riders?.filter(rider => selectedRiderIds.includes(rider.planID)) ?? []);
    }
    static selectedRiders(selectedPlans, selectedRiderIds) {
        if (selectedPlans) {
            return selectedPlans
                .map(plan => plan.riders)
                .reduce((acc, val) => acc.concat(val), []) // flattens into a single array of all riders in IE safe way
                .filter(rider => selectedRiderIds.includes(rider.planID));
        }
        return [];
    }
    updatePlan({ setState }, { plan }) {
        setState(patch({
            selectedPlans: updateItem(selectedPlan => selectedPlan.id === plan.id, plan)
        }));
    }
    selectPlan({ dispatch, getState, setState }, { plan, clearTransaction = true }) {
        const shoppingCart = getState().shoppingCart;
        const planRiders = plan.riders.filter(rider => rider.isRequiredRider);
        if (!shoppingCart.map(cartItem => cartItem.planId).includes(plan.id)) {
            const riders = plan.riders.map(rider => ({
                isSelected: rider.isRequiredRider,
                riderId: rider.planID,
                isRequired: rider.isRequiredRider
            }));
            const newItem = {
                planId: plan.id,
                premium: plan.drugPremium,
                planType: PlanTypeAbbreviation[plan.planTypeAbbreviation],
                productType: '',
                planName: plan.planName,
                riders
            };
            setState(patch({
                shoppingCart: [newItem]
            }));
        }
        // TODO: is this even neccessary? seems like this is just with required riders as its initially set
        const riderIds = planRiders.map(rider => rider.planID);
        setState(patch({
            selectedPlans: [plan],
            shoppingCart: updateItem((cartItem) => cartItem.planId === plan.id, patch({
                riders: updateItems(rider => riderIds.includes(rider.riderId), patch({ isSelected: true }))
            }))
        }));
        if (clearTransaction) {
            dispatch(new ClearCartTransaction(plan.id, clearTransaction));
        }
    }
    insertPlan({ dispatch, getState, setState }, { plan, newItem, riderIds, clearTransaction = true }) {
        const shoppingCart = getState().shoppingCart;
        if (shoppingCart && plan && (!shoppingCart.length || !shoppingCart.find(cartItem => cartItem.planId === plan.id))) {
            setState(patch({
                shoppingCart: insertItem(newItem)
            }));
            setState(patch({
                shoppingCart: updateItem(cartItem => cartItem.planId === newItem.planId, patch({
                    riders: updateItems(rider => riderIds.includes(rider.riderId), patch({ isSelected: true }))
                }))
            }));
        }
        if (plan) {
            const selectedPlan = this.store.selectSnapshot(ShoppingCartState_1.selectedPlanById(plan.id));
            if (!selectedPlan) {
                setState(patch({
                    selectedPlans: insertItem(plan)
                }));
                if (clearTransaction) {
                    dispatch(new ClearCartTransaction(plan.id, clearTransaction));
                }
            }
        }
    }
    selectPlanWithBundle({ dispatch, setState }, { plan, newItem, planRiders, clearTransaction = true }) {
        setState(patch({
            selectedPlans: [plan],
            shoppingCart: [newItem]
        }));
        const riderIds = planRiders.map(rider => rider.planID);
        setState(patch({
            shoppingCart: updateItem(cartItem => cartItem.planId === newItem.planId, patch({
                riders: updateItems(rider => riderIds.includes(rider.riderId), patch({ isSelected: true }))
            }))
        }));
        dispatch(new ClearCartTransaction(plan.id, clearTransaction));
    }
    updatePlanWithBundle({ dispatch, setState }, { plan, newItem, planRiders, clearTransaction = true }) {
        setState(patch({
            selectedPlans: updateItem(cartPlan => cartPlan.planType === plan.planType, plan),
            shoppingCart: updateItem(cartItem => PlanType[cartItem.planType] === plan.planType, newItem)
        }));
        if (plan.planType === PlanType.MEDIGAP) {
            const riderIds = planRiders.map(rider => rider.planID);
            setState(patch({
                shoppingCart: updateItem(cartItem => cartItem.planId === newItem.planId, patch({
                    riders: updateItems(rider => riderIds.includes(rider.riderId), patch({ isSelected: true }))
                }))
            }));
        }
        dispatch(new ClearCartTransaction(plan.id, clearTransaction));
    }
    // TODO: can we remove this and just use InsertPlan?
    insertPlanWithBundle({ dispatch, getState, setState }, { plan, newItem, planRiders, clearTransaction = true }) {
        const shoppingCart = getState().shoppingCart;
        if (shoppingCart && (!shoppingCart.length || !shoppingCart.find(cartItem => cartItem.planId === plan.id))) {
            setState(patch({
                shoppingCart: insertItem(newItem)
            }));
        }
        const selectedPlan = this.store.selectSnapshot(ShoppingCartState_1.selectedPlanById(plan.id));
        if (!selectedPlan) {
            setState(patch({
                selectedPlans: insertItem(plan)
            }));
            if (plan.planType === PlanType.MEDIGAP) {
                const riderIds = planRiders.map(rider => rider.planID);
                setState(patch({
                    shoppingCart: updateItem(cartItem => cartItem.planId === newItem.planId, patch({
                        riders: updateItems(rider => riderIds.includes(rider.riderId), patch({ isSelected: true }))
                    }))
                }));
            }
        }
        dispatch(new ClearCartTransaction(plan.id, clearTransaction));
    }
    removePlan({ getState, setState }, { planId }) {
        const selectedPlan = getState().shoppingCart.find(selectedPlan => selectedPlan.planId === planId);
        if (selectedPlan) {
            const ridersToRemove = selectedPlan.riders ? selectedPlan.riders : [];
            setState(patch({
                shoppingCart: removeItem(cartItem => cartItem.planId === planId),
                selectedPlans: removeItem(selectedPlan => selectedPlan.id === planId)
            }));
            ridersToRemove.forEach(rider => this.store.dispatch(new RemoveRider(rider.riderId)));
        }
    }
    removeAllPlans({ patchState }) {
        patchState({
            shoppingCart: [],
            selectedPlans: []
        });
    }
    selectRider({ getState, setState }, { riderId }) {
        const shoppingCart = getState().shoppingCart;
        let foundPlanId;
        shoppingCart.forEach(selectedPlan => selectedPlan.riders.forEach(foundRider => {
            if (foundRider.riderId === riderId) {
                foundPlanId = selectedPlan.planId;
            }
        }));
        setState(patch({
            shoppingCart: updateItem(cartItem => cartItem.planId === foundPlanId, patch({
                riders: updateItem(rider => rider.riderId === riderId, patch({ isSelected: true }))
            }))
        }));
    }
    removeRider({ getState, setState }, { riderId }) {
        const shoppingCart = getState().shoppingCart;
        let foundPlanId;
        shoppingCart.forEach(selectedPlan => selectedPlan.riders.forEach(foundRider => {
            if (foundRider.riderId === riderId) {
                foundPlanId = selectedPlan.planId;
            }
        }));
        setState(patch({
            shoppingCart: updateItem(cartItem => cartItem.planId === foundPlanId, patch({
                riders: updateItem(rider => rider.riderId === riderId, patch({ isSelected: false }))
            }))
        }));
    }
    removeAllRiders({ getState, patchState }) {
        const shoppingCart = getState().shoppingCart;
        shoppingCart.forEach(selectedPlan => selectedPlan.riders.forEach(rider => (rider.isSelected = false)));
        patchState({
            shoppingCart
        });
    }
    resetState(ctx) {
        const { setState } = ctx;
        setState(SHOPPING_CART_DEFAULTS);
    }
    updateAPIModel({ patchState }, { shoppingCart }) {
        patchState({
            shoppingCart
        });
    }
    updateProfileSession(ctx, { sessionId }) {
        const shoppingCartStateModel = ctx.getState();
        return this.memberSessionHttpService.updateSession$(sessionId, { shoppingCart: shoppingCartStateModel.shoppingCart });
    }
    updateShoppingCartPlanPremium(ctx, { planId, medicalMonthlyPremium, drugMonthlyPremium }) {
        const currentPlan = this.store.selectSnapshot(ShoppingCartState_1.selectedPlanById(planId));
        const currentMedicalPremium = currentPlan && currentPlan.medicalPremium ? currentPlan.medicalPremium : 0;
        const currentDrugPremium = currentPlan && currentPlan.drugPremium ? currentPlan.drugPremium : 0;
        const medicalPremium = typeof medicalMonthlyPremium !== 'undefined' && medicalMonthlyPremium !== null ? medicalMonthlyPremium : currentMedicalPremium;
        const drugPremium = typeof drugMonthlyPremium !== 'undefined' && drugMonthlyPremium !== null ? drugMonthlyPremium : currentDrugPremium;
        ctx.setState(patch({
            selectedPlans: updateItem(plan => plan.id === planId, patch({
                medicalPremium,
                drugPremium,
                annualPlanPremium: (medicalPremium + drugPremium) * 12
            }))
        }));
    }
    setShoppingCartLoading(ctx, { loading }) {
        const { patchState } = ctx;
        patchState({ loading });
    }
    clearTransaction(planId) {
        // if we select a new plan then it invalidates the enrollment transaction we previously may have acquired
        this.store.dispatch(new ClearTransaction(planId));
        // should also clear milliman premium and premium has changed flag
        this.store.dispatch(new ClearMillimanPremium());
    }
};
ShoppingCartState.ɵfac = function ShoppingCartState_Factory(t) { return new (t || ShoppingCartState)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(MemberSessionHttpService)); };
ShoppingCartState.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ShoppingCartState, factory: ShoppingCartState.ɵfac });
__decorate([
    Action(UpdatePlan)
], ShoppingCartState.prototype, "updatePlan", null);
__decorate([
    Action(SelectPlan)
], ShoppingCartState.prototype, "selectPlan", null);
__decorate([
    Action(InsertPlan)
], ShoppingCartState.prototype, "insertPlan", null);
__decorate([
    Action(SelectPlanWithBundle)
], ShoppingCartState.prototype, "selectPlanWithBundle", null);
__decorate([
    Action(UpdatePlanWithBundle)
], ShoppingCartState.prototype, "updatePlanWithBundle", null);
__decorate([
    Action(InsertPlanWithBundle)
], ShoppingCartState.prototype, "insertPlanWithBundle", null);
__decorate([
    Action(RemovePlan)
], ShoppingCartState.prototype, "removePlan", null);
__decorate([
    Action(RemovePlans)
], ShoppingCartState.prototype, "removeAllPlans", null);
__decorate([
    Action(SelectRider)
], ShoppingCartState.prototype, "selectRider", null);
__decorate([
    Action(RemoveRider)
], ShoppingCartState.prototype, "removeRider", null);
__decorate([
    Action(RemoveRiders)
], ShoppingCartState.prototype, "removeAllRiders", null);
__decorate([
    Action(ResetShoppingCartState)
], ShoppingCartState.prototype, "resetState", null);
__decorate([
    Action(UpdateShoppingCartAPIModel)
], ShoppingCartState.prototype, "updateAPIModel", null);
__decorate([
    LiveEditInactive(),
    Action(UpdateCartSession)
], ShoppingCartState.prototype, "updateProfileSession", null);
__decorate([
    LiveEditInactive(),
    Action(UpdateShoppingCartPlanPremium)
], ShoppingCartState.prototype, "updateShoppingCartPlanPremium", null);
__decorate([
    Action(SetShoppingCartLoading)
], ShoppingCartState.prototype, "setShoppingCartLoading", null);
__decorate([
    Action(ClearCartTransaction)
], ShoppingCartState.prototype, "clearTransaction", null);
__decorate([
    Selector()
], ShoppingCartState, "selectCartAPIState", null);
__decorate([
    Selector([ShoppingCartState_1.selectCartAPIState])
], ShoppingCartState, "selectedRiderIds", null);
__decorate([
    Selector([ShoppingCartState_1.selectCartAPIState])
], ShoppingCartState, "shoppingCartPlanIds", null);
__decorate([
    Selector([ShoppingCartState_1.selectCartAPIState])
], ShoppingCartState, "shoppingCartPlanTypeAbbreviations", null);
__decorate([
    Selector()
], ShoppingCartState, "selectedPlans", null);
__decorate([
    Selector([ShoppingCartState_1.selectedPlans])
], ShoppingCartState, "selectedPlanIds", null);
__decorate([
    Selector([ShoppingCartState_1.selectedPlans])
], ShoppingCartState, "selectedPlan", null);
__decorate([
    Selector([ShoppingCartState_1.selectedPlans, ShoppingCartState_1.selectedRiderIds])
], ShoppingCartState, "selectedRiders", null);
ShoppingCartState = ShoppingCartState_1 = __decorate([
    State({
        name: SHOPPING_CART_STORE_NAME,
        defaults: SHOPPING_CART_DEFAULTS
    })
], ShoppingCartState);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ShoppingCartState, [{
        type: Injectable
    }], function () { return [{ type: i1.Store }, { type: MemberSessionHttpService }]; }, { updatePlan: [], selectPlan: [], insertPlan: [], selectPlanWithBundle: [], updatePlanWithBundle: [], insertPlanWithBundle: [], removePlan: [], removeAllPlans: [], selectRider: [], removeRider: [], removeAllRiders: [], resetState: [], updateAPIModel: [], updateProfileSession: [], updateShoppingCartPlanPremium: [], setShoppingCartLoading: [], clearTransaction: [] }); })();

class CreateSession {
    constructor(agentGuid, originalAppId, sourceSiteId, isPurl) {
        this.agentGuid = agentGuid;
        this.originalAppId = originalAppId;
        this.sourceSiteId = sourceSiteId;
        this.isPurl = isPurl;
    }
}
CreateSession.type = '[Member] Create Session';
class CreateFullSession {
    constructor(member) {
        this.member = member;
    }
}
CreateFullSession.type = '[Member] Create Full Session';
class FetchSession {
    constructor(fetchMemberOptions) {
        this.fetchMemberOptions = fetchMemberOptions;
    }
}
FetchSession.type = '[Member] Fetch Session';
class UpdateSession {
    constructor(sessionId, memberApiModel) {
        this.sessionId = sessionId;
        this.memberApiModel = memberApiModel;
    }
}
UpdateSession.type = '[Member] Update Session';
class FetchEnrollmentPlanSettings {
    constructor(planId, requestParams) {
        this.planId = planId;
        this.requestParams = requestParams;
    }
}
FetchEnrollmentPlanSettings.type = '[Member] Fetch Enrollment Plan Settings';
class FetchEnrollmentSettings {
    constructor(sessionId, enrollmentSettingsParams) {
        this.sessionId = sessionId;
        this.enrollmentSettingsParams = enrollmentSettingsParams;
    }
}
FetchEnrollmentSettings.type = '[Member] Fetch Enrollment Settings';
class ValidateMemberLogin {
    constructor(userName, password) {
        this.userName = userName;
        this.password = password;
    }
}
ValidateMemberLogin.type = '[Member] Validate Login';
class MemberLogin {
    constructor(userName, loginToken, dateOfBirth) {
        this.userName = userName;
        this.loginToken = loginToken;
        this.dateOfBirth = dateOfBirth;
    }
}
MemberLogin.type = '[Member] Login';
class MemberLoginSuccess {
}
MemberLoginSuccess.type = '[Member] Login Success';
class MemberLoginError {
    constructor(error) {
        this.error = error;
    }
}
MemberLoginError.type = '[Member] Login Error';
class FetchMemberLoginTokenSuccess {
}
FetchMemberLoginTokenSuccess.type = '[Member] Fetch Login Token Success';
class FetchMemberLoginTokenError {
}
FetchMemberLoginTokenError.type = '[Member] Fetch Login Token Error';
class MemberLogout {
}
MemberLogout.type = '[Member] Logout';
class ResetMemberState {
}
ResetMemberState.type = '[Member] Reset';
class UpdateMemberEnrollments {
    constructor(enrollments) {
        this.enrollments = enrollments;
    }
}
UpdateMemberEnrollments.type = '[Member] Update Member Enrollments';
class SaveAndUpdateMemberDosage {
    constructor(sessionId, dosage) {
        this.sessionId = sessionId;
        this.dosage = dosage;
    }
}
SaveAndUpdateMemberDosage.type = '[Member] Save And Update Dosage';
class LogoutMemberAgent {
}
LogoutMemberAgent.type = '[Member] Logout Agent';
class AddMemberAgentNote {
    constructor(sessionId, memberAgentNote) {
        this.sessionId = sessionId;
        this.memberAgentNote = memberAgentNote;
    }
}
AddMemberAgentNote.type = '[Member] Add Member Agent Notes';
class UpdateMemberAgentNote {
    constructor(sessionId, agentNoteID, memberAgentNote) {
        this.sessionId = sessionId;
        this.agentNoteID = agentNoteID;
        this.memberAgentNote = memberAgentNote;
    }
}
UpdateMemberAgentNote.type = '[Member] Update Member Agent Notes';
class DeleteSelectRxTask {
    constructor(sessionId, memberAgentNote) {
        this.sessionId = sessionId;
        this.memberAgentNote = memberAgentNote;
    }
}
DeleteSelectRxTask.type = '[Member] Delete SelectRx Task';
class SaveSearchedMemberData {
    constructor(firstName, lastName, phoneNumber, emailAddress, dateOfBirth) {
        this.firstName = firstName;
        this.lastName = lastName;
        this.phoneNumber = phoneNumber;
        this.emailAddress = emailAddress;
        this.dateOfBirth = dateOfBirth;
    }
}
SaveSearchedMemberData.type = '[Member] Set Member Details';
class SetMemberLoading {
    constructor(loading) {
        this.loading = loading;
    }
}
SetMemberLoading.type = '[Member] Loading';
class UpdateTotalCostEffectiveDate {
    constructor(totalCostEffectiveDate) {
        this.totalCostEffectiveDate = totalCostEffectiveDate;
    }
}
UpdateTotalCostEffectiveDate.type = '[Member] Update Total Cost Effective Date';
class ResetTotalCostEffectiveDate {
}
ResetTotalCostEffectiveDate.type = '[Member] Reset Total Cost Effective Date';
class SetIsCostByEffectiveDate {
    constructor(costByEffectiveDate) {
        this.costByEffectiveDate = costByEffectiveDate;
    }
}
SetIsCostByEffectiveDate.type = '[Member] Set Cost By Effective Date';
class SetMemberProgressInfo {
    constructor(memberProgressInfo) {
        this.memberProgressInfo = memberProgressInfo;
    }
}
SetMemberProgressInfo.type = '[Member] Set Member Progress Status';
class UpdateEnrollmentSettings {
    constructor(enrollmentSettings) {
        this.enrollmentSettings = enrollmentSettings;
    }
}
UpdateEnrollmentSettings.type = '[Member] Update Enrollment Settings';
class UpdateMedigapAnswers {
    constructor(medigapAnswers) {
        this.medigapAnswers = medigapAnswers;
    }
}
UpdateMedigapAnswers.type = '[Member] Update Medigap Answers';
class SetPartAEffectiveDate {
    constructor(partAEffectiveDate) {
        this.partAEffectiveDate = partAEffectiveDate;
    }
}
SetPartAEffectiveDate.type = '[Member] Set Part A Effective Date';
class SetPartBEffectiveDate {
    constructor(partBEffectiveDate) {
        this.partBEffectiveDate = partBEffectiveDate;
    }
}
SetPartBEffectiveDate.type = '[Member] Set Part B Effective Date';
class SetMedicalCostInputs {
    constructor(medicalCostInputs) {
        this.medicalCostInputs = medicalCostInputs;
    }
}
SetMedicalCostInputs.type = '[Member] Set Medical Cost Inputs';
class SetFavoriteBenefits {
    constructor(userPreferences) {
        this.userPreferences = userPreferences;
    }
}
SetFavoriteBenefits.type = '[Member] Set Favorite benefits';
class UpdateMedigapAnswersSession {
    constructor(sessionId) {
        this.sessionId = sessionId;
    }
}
UpdateMedigapAnswersSession.type = '[Member] Update MedigapAnswers Session';
class SetAgentOfRecordLoading {
    constructor(loading) {
        this.loading = loading;
    }
}
SetAgentOfRecordLoading.type = '[Member] Set Agent Of Record Loading';
class UpdateAgentOfRecord {
    constructor(agentData) {
        this.agentData = agentData;
    }
}
UpdateAgentOfRecord.type = '[Member] Update Agent Of Record';
class UpdateAgentGuid {
    constructor(agentGuid) {
        this.agentGuid = agentGuid;
    }
}
UpdateAgentGuid.type = '[Member] Update Agent Guid';
class AddDrugToMemberState {
    constructor(cabinetEntry) {
        this.cabinetEntry = cabinetEntry;
    }
}
AddDrugToMemberState.type = '[MemberState] Add Drug';
class RemoveDrugFromMemberState {
    constructor(dosageID) {
        this.dosageID = dosageID;
    }
}
RemoveDrugFromMemberState.type = '[MemberState] Remove Drug';

class BeanProviderSettings {
}
class BlueButtonInfo {
}
class EnrollmentConfig {
}
class ExternalEnrollment {
}
class EnrollmentSettingsPayload {
}
class DashboardAgentNotesPayload extends Agent {
}
class MemberCoverage {
}
class MemberAgentNotes {
    constructor() {
        this.createdWhen = '';
        this.memberAgentNoteID = '';
        this.memberId = '';
        this.agentName = '';
        this.modifiedWhen = '';
        this.scheduledDate = '';
        this.completedWhen = '';
    }
}
class MemberQuoteHistory {
}
class QuotedPlanInfo {
}
class MemberSessionResponse {
}
var MemberAgentTaskStatus;
(function (MemberAgentTaskStatus) {
    MemberAgentTaskStatus["COMPLETE"] = "COMPLETE";
    MemberAgentTaskStatus["OPEN"] = "OPEN";
})(MemberAgentTaskStatus || (MemberAgentTaskStatus = {}));
var MemberStatus;
(function (MemberStatus) {
    MemberStatus["UNKNOWN"] = "Unknown";
    MemberStatus["CREATED"] = "Created";
    MemberStatus["UPDATED"] = "Updated";
    MemberStatus["FAILED"] = "Failed";
})(MemberStatus || (MemberStatus = {}));
var NoteActionTypeName;
(function (NoteActionTypeName) {
    NoteActionTypeName["Other"] = "Other";
    NoteActionTypeName["Enrollment"] = "Enrollment";
    NoteActionTypeName["Quote"] = "Quote";
    NoteActionTypeName["ScopeOfAppointment"] = "Scope of Appointment";
    NoteActionTypeName["BlueButton"] = "Blue Button";
    NoteActionTypeName["SelectRx"] = "SelectRx";
    NoteActionTypeName["RetireFlo"] = "RetireFlo";
})(NoteActionTypeName || (NoteActionTypeName = {}));
var NoteActionType;
(function (NoteActionType) {
    NoteActionType[NoteActionType["Note"] = 0] = "Note";
    NoteActionType[NoteActionType["OtherTask"] = 1] = "OtherTask";
    NoteActionType[NoteActionType["EnrollmentTask"] = 2] = "EnrollmentTask";
    NoteActionType[NoteActionType["QuoteTask"] = 3] = "QuoteTask";
    NoteActionType[NoteActionType["SOATask"] = 4] = "SOATask";
    NoteActionType[NoteActionType["BlueButtonTask"] = 5] = "BlueButtonTask";
    NoteActionType[NoteActionType["SOANote"] = 6] = "SOANote";
    NoteActionType[NoteActionType["SelectRx"] = 7] = "SelectRx";
    NoteActionType[NoteActionType["RetireFlo"] = 8] = "RetireFlo";
})(NoteActionType || (NoteActionType = {}));
var IntegrationType;
(function (IntegrationType) {
    IntegrationType[IntegrationType["INLINE"] = 0] = "INLINE";
    IntegrationType[IntegrationType["IFRAME"] = 1] = "IFRAME";
    IntegrationType[IntegrationType["POPUP"] = 2] = "POPUP";
    IntegrationType[IntegrationType["UNKNOWN"] = 99] = "UNKNOWN";
})(IntegrationType || (IntegrationType = {}));
var EnrollActionType;
(function (EnrollActionType) {
    EnrollActionType[EnrollActionType["NONE"] = 0] = "NONE";
    EnrollActionType[EnrollActionType["URL"] = 1] = "URL";
    EnrollActionType[EnrollActionType["MESSAGE"] = 2] = "MESSAGE";
    EnrollActionType[EnrollActionType["URL_AND_MESSAGE"] = 3] = "URL_AND_MESSAGE";
})(EnrollActionType || (EnrollActionType = {}));
var MemberProgressStatus;
(function (MemberProgressStatus) {
    MemberProgressStatus[MemberProgressStatus["PROFILE_CREATED"] = 1] = "PROFILE_CREATED";
    MemberProgressStatus[MemberProgressStatus["PROVIDER_UPDATED"] = 2] = "PROVIDER_UPDATED";
    MemberProgressStatus[MemberProgressStatus["PRESCRIPTION_UPDATED"] = 3] = "PRESCRIPTION_UPDATED";
    MemberProgressStatus[MemberProgressStatus["PHARMACIES_UPDATED"] = 4] = "PHARMACIES_UPDATED";
    MemberProgressStatus[MemberProgressStatus["QUOTE_SENT"] = 5] = "QUOTE_SENT";
    MemberProgressStatus[MemberProgressStatus["PLAN_IN_CART"] = 6] = "PLAN_IN_CART";
    MemberProgressStatus[MemberProgressStatus["SEND_TO_BENEFICIARY"] = 7] = "SEND_TO_BENEFICIARY";
    MemberProgressStatus[MemberProgressStatus["ENROLLMENT_STARTED"] = 8] = "ENROLLMENT_STARTED";
    MemberProgressStatus[MemberProgressStatus["ENROLLMENT_COMPLETED"] = 9] = "ENROLLMENT_COMPLETED";
})(MemberProgressStatus || (MemberProgressStatus = {}));

class DrugsHttpService {
    constructor(http) {
        this.http = http;
        this.environment = EnvironmentService.getEnvironment();
    }
    retrieveDrugs$(searchTerm, autoComplete, maxCount) {
        const headers = new HttpHeaders({ 'Accept': 'application/json', 'Content-Type': 'application/json' });
        const params = new HttpParams()
            .set('filter.searchTerm', searchTerm)
            .set('filter.autoComplete', `${autoComplete}`)
            .set('filter.maxCount', maxCount.toString());
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Drugs`, { params, headers });
    }
    async retrieveDrugs(searchTerm, autoComplete, maxCount) {
        return this.retrieveDrugs$(searchTerm, autoComplete, maxCount).toPromise();
    }
    saveDrugs$(sessionId, drugs) {
        const options = {
            headers: new HttpHeaders({ Accept: 'application/json' })
        };
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Session/${sessionId}/Drugs`, drugs, options);
    }
    async saveDrugs(sessionId, drugs) {
        return this.saveDrugs$(sessionId, drugs).toPromise();
    }
    saveDrug$(sessionId, drug) {
        const options = {
            headers: new HttpHeaders({ Accept: 'application/json' })
        };
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Session/${sessionId}/Drugs/`, [drug], options);
    }
    async saveDrug(sessionId, drug) {
        return this.saveDrug$(sessionId, drug).toPromise();
    }
    updateDrugs$(sessionId, drugs) {
        const options = {
            headers: new HttpHeaders({ Accept: 'application/json' })
        };
        return this.http.put(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Session/${sessionId}/Drugs/`, drugs, options);
    }
    async updateDrugs(sessionId, drugs) {
        return this.updateDrugs$(sessionId, drugs).toPromise();
    }
    updateDrug$(sessionId, drugRecordId, drug) {
        const options = {
            headers: new HttpHeaders({ Accept: 'application/json' })
        };
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Session/${sessionId}/Drugs/${drugRecordId}`, drug, options);
    }
    async updateDrug(sessionId, drugRecordId, drug) {
        return this.updateDrug$(sessionId, drugRecordId, drug).toPromise();
    }
    deleteDrug$(sessionId, drugRecordId) {
        return this.http.delete(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Session/${sessionId}/Drugs/${drugRecordId}`);
    }
    async deleteDrug(sessionId, drugRecordId) {
        return this.deleteDrug$(sessionId, drugRecordId).toPromise();
    }
    deleteAllDrugs$(sessionId) {
        return this.http.delete(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Session/${sessionId}/Drugs/`);
    }
    async deleteAllDrugs(sessionId) {
        return this.deleteAllDrugs$(sessionId).toPromise();
    }
    getAllDrugsInCabinet$(sessionId) {
        const headers = new HttpHeaders({ 'Accept': 'application/json', 'Content-Type': 'application/json' });
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Session/${sessionId}/cabinet`, {
            params: {},
            headers
        });
    }
    async getAllDrugsInCabinet(sessionId) {
        return this.getAllDrugsInCabinet$(sessionId).toPromise();
    }
    retrieveDrugDetails$(drugId, showCommonConditions) {
        const headers = new HttpHeaders({ 'Accept': 'application/json', 'Content-Type': 'application/json' });
        const params = new HttpParams().set('DrugID', drugId).set('IncludeConditions', !!showCommonConditions);
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Drugs/${drugId}`, { params, headers });
    }
}
DrugsHttpService.ɵfac = function DrugsHttpService_Factory(t) { return new (t || DrugsHttpService)(i0.ɵɵinject(i1$2.HttpClient)); };
DrugsHttpService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DrugsHttpService, factory: DrugsHttpService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DrugsHttpService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1$2.HttpClient }]; }, null); })();

class ProfileContextService {
    constructor() {
        this._hicnValue$ = new BehaviorSubject('');
    }
    setHICNValue(hicn) {
        this._hicnValue$.next(hicn);
    }
    getHICNValue$() {
        return this._hicnValue$.asObservable();
    }
}
ProfileContextService.ɵfac = function ProfileContextService_Factory(t) { return new (t || ProfileContextService)(); };
ProfileContextService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ProfileContextService, factory: ProfileContextService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProfileContextService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

var MemberState_1;
const MEMBER_DEFAULTS = {
    reqid: '',
    sessionId: '',
    ssoName: '',
    ssoValue: '',
    blUserName: '',
    expires: '',
    userName: '',
    status: '',
    statusReason: '',
    agentGuid: '',
    enrollmentPlanSettings: null,
    enrollmentPlanSettingsLoading: false,
    // bean provider settings
    enrollmentSettings: null,
    externalEnrollments: [],
    loading: false,
    loaded: false,
    error: null,
    loginError: false,
    isLoggedIn: false,
    memberMessages: [],
    memberCoverages: [],
    dosages: [],
    currentYearPlanID: '',
    memberAgentNotes: [],
    isEnrollmentHistoryIncluded: false,
    enrollments: [],
    memberID: '',
    memberSavedPlans: [],
    blueButtonInfo: null,
    firstName: '',
    lastName: '',
    phoneNumber: '',
    emailAddress: '',
    dateOfBirth: '',
    totalCostEffectiveDate: null,
    costByEffectiveDate: false,
    medigapAnswers: {},
    medicalCostInputs: [],
    agentCallRecords: [],
    agentOfRecord: {
        agentData: null,
        loading: false,
        loaded: false
    },
    memberProgressInfo: {
        transferCode: '',
        memberProgressList: []
    },
    userPreferences: {
        favoriteBenefits: []
    }
};
class APIMemberStateModel {
    constructor(memberModel) {
        this.reqid = memberModel.reqid;
        this.sessionId = memberModel.sessionId;
        this.ssoName = memberModel.ssoName;
        this.ssoValue = memberModel.ssoValue;
        this.blUserName = memberModel.blUserName;
        this.expires = memberModel.expires;
        this.userName = memberModel.userName;
        this.status = memberModel.status;
        this.statusReason = memberModel.statusReason;
        this.agentGuid = memberModel.agentGuid;
        this.memberID = memberModel.memberID;
        this.memberMessages = memberModel.memberMessages;
        this.memberCoverages = memberModel.memberCoverages;
        this.currentYearPlanID = memberModel.currentYearPlanID;
        this.dosages = memberModel.dosages;
        this.blueButtonInfo = memberModel.blueButtonInfo;
        this.totalCostEffectiveDate = memberModel.totalCostEffectiveDate;
        this.costByEffectiveDate = memberModel.costByEffectiveDate;
        this.medigapAnswers = memberModel.medigapAnswers;
        this.medicalCostInputs = memberModel.medicalCostInputs;
    }
}
const MEMBER_STORE_NAME = 'member';
class MemberStateModel extends APIMemberStateModel {
}
/**
 * Encapsulating all our child stores in here so we can dynamically look up
 * memoized properties from any store.
 */
let MemberState = MemberState_1 = class MemberState {
    constructor(memberSessionHttpService, plansHttpService, drugsHttpService, store, profileContextService) {
        this.memberSessionHttpService = memberSessionHttpService;
        this.plansHttpService = plansHttpService;
        this.drugsHttpService = drugsHttpService;
        this.store = store;
        this.profileContextService = profileContextService;
    }
    /**
     * A function to determine if a plan enrollment settings entry has a unique key.
     * This will be used to determine if we should add a new plan enrollment settings
     * entry or update an existing one.
     * @param existing
     * @param incoming
     * @returns
     */
    static matchesCompositeKey(enrollmentSettingA, enrollmentSettingB) {
        return (enrollmentSettingA.planIds.join(',') === enrollmentSettingB.planIds.join(',') &&
            enrollmentSettingA.userType === enrollmentSettingB.userType &&
            enrollmentSettingA.isConsumerUrlSiteSettings === enrollmentSettingB.isConsumerUrlSiteSettings &&
            enrollmentSettingA.foamFormType === enrollmentSettingB.foamFormType);
    }
    static session(state) {
        return state;
    }
    static enrollmentPlanSettings(state) {
        return state.enrollmentPlanSettings;
    }
    static enrollmentSettings(state) {
        return state.enrollmentSettings;
    }
    static blueButtonInfo(state) {
        return state.blueButtonInfo;
    }
    static sessionId(state) {
        return state.sessionId;
    }
    static memberID(state) {
        return state.memberID;
    }
    static memberAgentNotes(state) {
        return state.memberAgentNotes;
    }
    static isEnrollmentHistoryIncluded(state) {
        return state.isEnrollmentHistoryIncluded;
    }
    static memberEnrollments(state) {
        return state.enrollments;
    }
    static userPreferences(state) {
        return state.userPreferences;
    }
    static favoriteBenefits(userPreferences) {
        return userPreferences?.favoriteBenefits ?? [];
    }
    static memberPlanEnrollments(isPPCSite) {
        return createSelector([MemberState_1.memberEnrollments], (enrollments) => enrollments?.filter(enrollment => {
            const isSOAEnrollment = SOA_COVERAGE_TYPE_EVENTS.includes(enrollment.coverageTypeEvent);
            const isPartialEnrollment = !enrollment.completedWhen;
            // SPA-12632: hide partial ancillary plan enrollments on consumer sites
            if (!isPPCSite && isPartialEnrollment) {
                return !isSOAEnrollment && !ANCILLARY_PLAN_TYPES.includes(enrollment.planTypeID);
            }
            return !isSOAEnrollment;
        }) ?? []);
    }
    static memberEnrollmentByNativeTransactionId(nativeTransactionID) {
        return createSelector([MemberState_1.memberEnrollments], (enrollments) => enrollments?.find(enrollment => enrollment.nativeTransactionID === nativeTransactionID) ?? null);
    }
    // if no matches then default to long form per Anu
    static planEnrollmentSettings(planID) {
        return createSelector([MemberState_1.enrollmentPlanSettings], (planEnrollmentSettings) => {
            const planIDEnrollmentSettings = planEnrollmentSettings?.filter(planEnrollmentSetting => planEnrollmentSetting.planIds.includes(planID));
            const numberOfEnrollmentSettings = planIDEnrollmentSettings?.length;
            if (numberOfEnrollmentSettings > 1) {
                const longFormEnrollmentSettings = planIDEnrollmentSettings?.find(planIDEnrollmentSetting => planIDEnrollmentSetting?.foamFormType === EnrollmentFormType.LONG);
                return longFormEnrollmentSettings ?? planIDEnrollmentSettings[0];
            }
            else if (numberOfEnrollmentSettings === 1) {
                return planIDEnrollmentSettings[0];
            }
            // we set formId to the active enrollment key so if the 'planID' is the formId and enrollment settings have been loaded we can get this here
            const hraPlanEnrollmentSettings = planEnrollmentSettings?.find(planEnrollmentSetting => planEnrollmentSetting.formId === planID && planEnrollmentSetting.foamFormType === EnrollmentFormType.HRA);
            return hraPlanEnrollmentSettings ?? null;
        });
    }
    static getPlanEnrollmentSettingsByType(planID, selectedFormType, userType, isFormSignAndSubmitOnly) {
        return createSelector([MemberState_1.enrollmentPlanSettings], (planEnrollmentSettings) => {
            const userTypeString = UserTypeKeys[userType]?.toLowerCase() ?? '';
            return (planEnrollmentSettings?.find(planEnrollmentSetting => {
                const enrollmentSettingUserType = planEnrollmentSetting.userType?.toLowerCase() ?? '';
                return (planEnrollmentSetting.planIds.includes(planID) &&
                    (selectedFormType === undefined || selectedFormType === null
                        ? true
                        : planEnrollmentSetting.foamFormType === selectedFormType) &&
                    (userType === undefined ||
                        userType === null ||
                        (userTypeString === UserTypes.BROKER
                            ? (enrollmentSettingUserType === UserTypes.BROKER || enrollmentSettingUserType === UserTypes.ALL) &&
                                !planEnrollmentSetting.isConsumerUrlSiteSettings
                            : enrollmentSettingUserType === userTypeString || enrollmentSettingUserType === UserTypes.ALL)) &&
                    (!isFormSignAndSubmitOnly || planEnrollmentSetting.formSignAndSubmitOnly));
            }) ?? null);
        });
    }
    /**
     * Determines if the plan has a next gen form or a HOPE form. When this returns null it means that not plan enrollment
     * settings has been found for the planID and we cannot determine form type from enrollment settings.
     */
    static planHasNextGenForm(planID) {
        return createSelector([MemberState_1.planEnrollmentSettings(planID)], (planEnrollmentSettings) => planEnrollmentSettings
            ? !!(planEnrollmentSettings.enrollSystemType === EnrollSystemType.NextGen && planEnrollmentSettings.formVersionId)
            : null);
    }
    static planHasNextGenHRAForm(formId, planId) {
        return createSelector([MemberState_1.enrollmentPlanHRASettings(formId, planId)], (planEnrollmentHRASettings) => planEnrollmentHRASettings?.length ? !!(planEnrollmentHRASettings[0].enrollSystemType === EnrollSystemType.NextGen) : null);
    }
    static medicalCostInputs(state) {
        return state.medicalCostInputs;
    }
    static userName(state) {
        return state.userName;
    }
    static firstName(state) {
        return state.firstName;
    }
    static lastName(state) {
        return state.lastName;
    }
    static phoneNumber(state) {
        return state.phoneNumber;
    }
    static emailAddress(state) {
        return state.emailAddress;
    }
    static medigapAnswers(state) {
        return state.medigapAnswers;
    }
    static dateOfBirth(state) {
        return state.dateOfBirth;
    }
    static totalCostEffectiveDate(state) {
        return state.totalCostEffectiveDate;
    }
    static costByEffectiveDate(state) {
        return state.costByEffectiveDate;
    }
    static agentCallRecords(state) {
        return state.agentCallRecords ?? [];
    }
    static demographic(state) {
        return state.demographic;
    }
    static demographicEstimateHealthCost(demographic) {
        return demographic?.estimateHealthCost;
    }
    static zip(demographic) {
        return demographic.zip;
    }
    static fips(demographic) {
        return demographic.fips;
    }
    static memberEnrollmentByPlanId(planId) {
        return createSelector([MemberState_1.memberEnrollments], (enrollments) => enrollments?.find(enrollment => enrollment.planID === planId));
    }
    static memberEnrollmentsByPlanIds(planIds) {
        return createSelector([MemberState_1.memberEnrollments], (enrollments) => {
            const filteredEnrollments = [];
            if (planIds) {
                planIds.forEach(planId => {
                    enrollments.filter(enrollment => enrollment.planID === planId).forEach(enrollment => filteredEnrollments.push(enrollment));
                });
            }
            return filteredEnrollments;
        });
    }
    static isMemberEnrollmentExpired(planId) {
        return createSelector([MemberState_1.memberEnrollmentByPlanId(planId)], (enrollment) => {
            if (enrollment) {
                const { isExpired, expirationDate } = enrollment;
                let isEnrollmentExpired = isExpired;
                if (!isEnrollmentExpired) {
                    const currentDateTime = DateUtilities.getFormattedCurrentDate(DateUtilities.defaultDateTimeISOFormat);
                    isEnrollmentExpired = DateUtilities.dateTimeBefore(expirationDate, currentDateTime);
                }
                return isEnrollmentExpired;
            }
            return null;
        });
    }
    static enrollmentPlanSettingsLoading(state) {
        return state.enrollmentPlanSettingsLoading;
    }
    static enrollmentPlanSettingsLoaded(planId) {
        return createSelector([MemberState_1.enrollmentPlanSettings], (planEnrollmentSettings) => !!planEnrollmentSettings?.some(planEnrollmentSetting => !!planEnrollmentSetting?.planIds?.includes(planId)));
    }
    static enrollmentPlanSettingsLoadedByFormType(planId, selectedFormType) {
        return createSelector([MemberState_1.getPlanEnrollmentSettingsByType(planId, selectedFormType)], (planEnrollmentSetting) => {
            return !!planEnrollmentSetting;
        });
    }
    static enrollmentPlanHRASettings(formId, planId) {
        return createSelector([MemberState_1.enrollmentPlanSettings], (planEnrollmentSettings) => planEnrollmentSettings?.filter(planEnrollmentSetting => planEnrollmentSetting.foamFormType === 7 &&
            (!formId || planEnrollmentSetting.formId === formId) &&
            (!planId || !!planEnrollmentSetting?.planIds.includes(planId))));
    }
    static enrollmentPlanHRASettingsLoaded(formId, planId) {
        return createSelector([MemberState_1.enrollmentPlanHRASettings(formId, planId)], (planEnrollmentSettings) => !!planEnrollmentSettings?.length);
    }
    static currentYearPlanId(state) {
        return state.currentYearPlanID;
    }
    static loading(state) {
        return state.loading;
    }
    static loaded(state) {
        return state.loaded;
    }
    static loginError(state) {
        return state.loginError;
    }
    static isLoggedIn(state) {
        return state.isLoggedIn;
    }
    static agentGuid(state) {
        return state.agentGuid;
    }
    static dosages(state) {
        return state.dosages;
    }
    static isEligibleForSelectRxTasks(dosages) {
        return dosages?.length >= 8;
    }
    static agentOfRecord(state) {
        return state.agentOfRecord;
    }
    static memberProgressInfo(state) {
        return state.memberProgressInfo;
    }
    static externalEnrollments(state) {
        return state.externalEnrollments;
    }
    static memberAgentTasks(notes) {
        return notes
            .filter(note => note.agentNoteActionType === NoteActionType.OtherTask ||
            note.agentNoteActionType === NoteActionType.EnrollmentTask ||
            note.agentNoteActionType === NoteActionType.QuoteTask ||
            note.agentNoteActionType === NoteActionType.SOATask ||
            note.agentNoteActionType === NoteActionType.BlueButtonTask ||
            note.agentNoteActionType === NoteActionType.SelectRx ||
            note.agentNoteActionType === NoteActionType.RetireFlo)
            .sort((task1, task2) => {
            if (task1.completedWhen === null && task2.completedWhen !== null) {
                return -1;
            }
            if (task1.completedWhen !== null && task2.completedWhen === null) {
                return 1;
            }
            if (DateUtilities.dateBefore(DateUtilities.getFormattedDate(new Date(task1.scheduledDate)), DateUtilities.getFormattedDate(new Date(task2.scheduledDate)))) {
                return -1;
            }
            if (DateUtilities.dateAfter(DateUtilities.getFormattedDate(new Date(task1.scheduledDate)), DateUtilities.getFormattedDate(new Date(task2.scheduledDate)))) {
                return 1;
            }
            if (DateUtilities.dateBefore(DateUtilities.getFormattedDate(new Date(task1.completedWhen)), DateUtilities.getFormattedDate(new Date(task2.completedWhen)))) {
                return -1;
            }
            return 0;
        });
    }
    AddDrugDosage(ctx, action) {
        const cabinetEntry = action.cabinetEntry;
        const id = cabinetEntry.dosageID;
        const state = ctx.getState();
        const dosage = state.dosages;
        // Add a drug dosage iff it isn't already in the medicine cabinet.
        if (dosage.findIndex(dosage => dosage.dosageId === id) === -1) {
            ctx.setState(patch({
                dosages: insertItem(cabinetEntry.dosage)
            }));
        }
        else {
            ctx.setState(patch({
                dosages: updateItem(entry => entry.dosageId === id, cabinetEntry.dosage)
            }));
        }
    }
    RemoveDosage(ctx, action) {
        ctx.setState(patch({
            dosages: removeItem(entry => entry.dosageId === action.dosageID)
        }));
    }
    async createFullSession(ctx, { member }) {
        const { patchState } = ctx;
        patchState({ loading: true, loaded: false, error: null });
        try {
            const session = await this.memberSessionHttpService.createSession$(member, member.memberID).toPromise();
            patchState({
                loading: false,
                loaded: true,
                memberID: session.memberID,
                sessionId: session.sessionId,
                ssoValue: session.ssoValue,
                expires: session.expires,
                status: session.status,
                memberProgressInfo: session.memberProgressInfo
            });
        }
        catch (error) {
            patchState({ loading: false, loaded: false, error });
        }
    }
    async createSession(ctx, { agentGuid, originalAppId, sourceSiteId, isPurl }) {
        const { patchState } = ctx;
        patchState({ loading: true, loaded: false, error: null });
        let session;
        if (agentGuid) {
            session = await firstValueFrom(this.memberSessionHttpService.createSession$({ agentGuid, sourceSiteId, originalAppId, isPurl }));
        }
        else {
            session = await firstValueFrom(this.memberSessionHttpService.createAnonymousSession$());
        }
        patchState({
            loading: false,
            loaded: true,
            memberID: session.memberID,
            sessionId: session.sessionId,
            ssoValue: session.ssoValue,
            expires: session.expires,
            status: session.status,
            memberProgressInfo: session.memberProgressInfo
        });
    }
    setSearchCriteria(ctx, { firstName, lastName, phoneNumber, emailAddress, dateOfBirth }) {
        ctx.setState(patch({ firstName, lastName, phoneNumber, emailAddress, dateOfBirth }));
    }
    updateSession(ctx, { sessionId, memberApiModel }) {
        return this.memberSessionHttpService
            .updateSession$(sessionId, memberApiModel)
            .pipe(tap(this.updateSessionCallback(sessionId, ctx, false)));
    }
    fetchSession$(ctx, { fetchMemberOptions }) {
        const { patchState } = ctx;
        patchState({ loading: true, loaded: false, error: null });
        if (fetchMemberOptions) {
            return this.memberSessionHttpService.fetchSession$(fetchMemberOptions).pipe(tap(this.updateSessionCallback(fetchMemberOptions.sessionId, ctx, fetchMemberOptions.isMemberInitialLoad ?? false, fetchMemberOptions.isEnrollmentHistoryIncluded ?? false)), catchError(error => {
                patchState({ loading: false, loaded: false, error });
                return of(error);
            }));
        }
        return of(null);
    }
    async fetchEnrollmentPlanSettings(ctx, { planId, requestParams }) {
        const { getState, patchState } = ctx;
        patchState({ enrollmentPlanSettingsLoading: true, error: null });
        const enrollmentPlanSettings = await this.plansHttpService.getPlanEnrollmentSettings$(planId, requestParams).toPromise();
        const currentState = getState();
        const currentEnrollmentPlanSettings = [...(currentState.enrollmentPlanSettings || [])];
        enrollmentPlanSettings.forEach(newSetting => {
            const index = currentEnrollmentPlanSettings.findIndex(existing => MemberState_1.matchesCompositeKey(existing, newSetting));
            if (index !== -1) {
                currentEnrollmentPlanSettings[index] = newSetting;
            }
            else {
                currentEnrollmentPlanSettings.push(newSetting);
            }
        });
        patchState({
            enrollmentPlanSettingsLoading: false,
            enrollmentPlanSettings: currentEnrollmentPlanSettings
        });
    }
    fetchEnrollmentSettings(ctx, { sessionId, enrollmentSettingsParams }) {
        const { patchState } = ctx;
        patchState({ loading: true, loaded: false, error: null });
        this.memberSessionHttpService
            .fetchBeanProviderSettings$(sessionId, enrollmentSettingsParams)
            .pipe(take(1))
            .subscribe({
            next: (enrollmentSettings) => {
                patchState({
                    loading: false,
                    loaded: true,
                    enrollmentSettings: enrollmentSettings[0]
                });
            },
            error: (error) => {
                patchState({
                    error,
                    loading: false
                });
            }
        });
    }
    updateEnrollmentSettings(ctx, { enrollmentSettings }) {
        const { patchState } = ctx;
        patchState({
            enrollmentSettings
        });
    }
    updateMedigapAnswersSession(ctx, { sessionId }) {
        const { getState } = ctx;
        const memberModel = getState();
        const memberApiModel = new APIMemberStateModel(memberModel);
        return this.memberSessionHttpService.updateSession$(sessionId, { medigapAnswers: memberApiModel.medigapAnswers });
    }
    memberLogin(ctx, { userName, loginToken, dateOfBirth }) {
        const { patchState } = ctx;
        const { sessionId, ssoValue, expires, status, profile } = loginToken;
        patchState({
            userName,
            ...(sessionId && { sessionId }),
            ...(ssoValue && { ssoValue }),
            ...(expires && { expires }),
            ...(status && { status }),
            ...(dateOfBirth && { dateOfBirth })
        });
        if (profile) {
            ctx.dispatch(new UpdateProfile(profile));
        }
    }
    fetchMemberLoginTokenSuccess({ patchState }) {
        patchState({
            isLoggedIn: true,
            loading: false,
            loginError: false
        });
    }
    fetchMemberLoginTokenError({ patchState }) {
        patchState({
            isLoggedIn: false,
            loading: false,
            loginError: true
        });
    }
    memberLoginTokenSuccess({ patchState }) {
        patchState({
            isLoggedIn: true,
            loading: false,
            loginError: false
        });
    }
    memberLoginTokenError({ patchState }, { error }) {
        patchState({
            loading: false,
            loginError: true,
            error
        });
    }
    memberLogout(ctx) {
        const { patchState } = ctx;
        patchState({
            loading: false,
            loginError: false,
            isLoggedIn: false
        });
    }
    resetMemberState(ctx) {
        const { patchState } = ctx;
        // using patch instead of setState due to having child stores
        patchState(MEMBER_DEFAULTS);
    }
    updateMemberEnrollments(ctx, { enrollments }) {
        const { patchState } = ctx;
        patchState({ enrollments: [...enrollments] });
    }
    SetMedicalCostInputs(ctx, { medicalCostInputs }) {
        const { patchState } = ctx;
        patchState({ medicalCostInputs: [...medicalCostInputs] });
    }
    SetFavoriteBenefits(ctx, { userPreferences }) {
        const current = ctx.getState().userPreferences || {};
        ctx.patchState({
            userPreferences: {
                ...current,
                favoriteBenefits: userPreferences?.favoriteBenefits ?? []
            }
        });
    }
    saveAndUpdateMemberDosage({ setState, dispatch }, { sessionId, dosage }) {
        this.drugsHttpService.saveDrug$(sessionId, dosage).subscribe({
            next: () => {
                setState(patch({
                    dosages: updateItem(memberDosage => memberDosage.dosageId === dosage.dosageId, patch({ conditionId: dosage.conditionId }))
                }));
                dispatch(new UpdateMedicineCabinetEntry(dosage.conditionId, dosage.dosageId));
            }
        });
    }
    logoutMemberAgent(ctx) {
        ctx.patchState({ agentGuid: MEMBER_DEFAULTS.agentGuid });
    }
    async addMemberAgentNote({ patchState }, { sessionId, memberAgentNote }) {
        const memberAgentNotes = await this.memberSessionHttpService.createAgentNoteTask$(sessionId, memberAgentNote).toPromise();
        patchState({ memberAgentNotes });
        return memberAgentNotes;
    }
    async updateMemberAgentNote({ patchState }, { sessionId, agentNoteID, memberAgentNote }) {
        const memberAgentNotes = await this.memberSessionHttpService.updateAgentNoteTask$(sessionId, agentNoteID, memberAgentNote).toPromise();
        patchState({ memberAgentNotes });
        return memberAgentNotes;
    }
    async deleteSelectRxTask({ patchState }, { sessionId, memberAgentNote }) {
        const memberAgentNotes = await this.memberSessionHttpService.deleteSelectRxTask$(sessionId, memberAgentNote).toPromise();
        patchState({ memberAgentNotes });
        return memberAgentNotes;
    }
    setMemberLoading(ctx, { loading }) {
        const { patchState } = ctx;
        patchState({ loading });
    }
    updateTotalCostEffectiveDate(ctx, { totalCostEffectiveDate }) {
        ctx.patchState({
            totalCostEffectiveDate
        });
    }
    resetTotalCostEffectiveDate(ctx) {
        ctx.patchState({
            totalCostEffectiveDate: null
        });
    }
    updateCostByEffectiveDate(ctx, { costByEffectiveDate }) {
        ctx.patchState({
            costByEffectiveDate
        });
    }
    setMemberProgressInfo(ctx, { memberProgressInfo }) {
        ctx.patchState({
            memberProgressInfo
        });
    }
    UpdateMedigapAnswers(ctx, { medigapAnswers }) {
        const { setState } = ctx;
        const { partAEffectiveDate, partBEffectiveDate, dateOfBirth, effectiveDate, ...modifiedMedigapAnswers } = medigapAnswers;
        setState(patch({
            medigapAnswers: patch({
                ...(medigapAnswers.partAEffectiveDate && {
                    partAEffectiveDate: DateUtilities.convertToDateString(medigapAnswers.partAEffectiveDate)
                }),
                ...(medigapAnswers.partBEffectiveDate && {
                    partBEffectiveDate: DateUtilities.convertToDateString(medigapAnswers.partBEffectiveDate)
                }),
                ...(medigapAnswers.dateOfBirth && {
                    dateOfBirth: DateUtilities.convertToDateString(medigapAnswers.dateOfBirth)
                }),
                ...(medigapAnswers.effectiveDate && {
                    effectiveDate: DateUtilities.convertToDateString(medigapAnswers.effectiveDate)
                }),
                ...modifiedMedigapAnswers
            })
        }));
    }
    SetPartAEffectiveDate(ctx, { partAEffectiveDate }) {
        const { setState } = ctx;
        setState(patch({
            medigapAnswers: patch({
                partAEffectiveDate
            })
        }));
    }
    SetPartBEffectiveDate(ctx, { partBEffectiveDate }) {
        const { setState } = ctx;
        setState(patch({
            medigapAnswers: patch({
                partBEffectiveDate
            })
        }));
    }
    SetAgentOfRecordLoading(ctx, { loading }) {
        const { setState } = ctx;
        setState(patch({
            agentOfRecord: patch({
                loading
            })
        }));
    }
    UpdateAgentOfRecord(ctx, { agentData }) {
        const { patchState } = ctx;
        const agentOfRecord = { agentData, loading: false, loaded: true };
        patchState({ agentOfRecord });
    }
    UpdateAgentGuid(ctx, { agentGuid }) {
        const { patchState } = ctx;
        patchState({ agentGuid });
    }
    setMissingDemographicZip(isMemberInitialLoad) {
        const demographicZip = this.store.selectSnapshot(DemographicState.selectedZipCode);
        const profileAddresses = this.store.selectSnapshot(ProfileState.addresses);
        if ((!demographicZip || isMemberInitialLoad) && profileAddresses?.length) {
            const primaryAddress = profileAddresses.find(address => address.isPrimaryAddress);
            const primaryZip = primaryAddress?.zip ?? '';
            const primaryFips = primaryAddress?.countyFips ?? '';
            const secondaryAddress = profileAddresses.find(address => !address.isPrimaryAddress);
            const secondaryZip = secondaryAddress?.zip ?? '';
            const secondaryFips = secondaryAddress?.countyFips ?? '';
            const selectedZip = primaryZip || secondaryZip;
            const selectedFips = primaryFips || secondaryFips || this.store.selectSnapshot(DemographicState.selectedFipsCode);
            this.store.dispatch(new SelectZipAndFIPS(selectedZip, selectedFips));
        }
    }
    checkDemographicsForAgeRangeUpdate(demographic) {
        // SPA-6371
        // If the session gets updated at any point, particularly on prescriptions guided help init with blue button enabled,
        // The age range will be set back to the value from the API, which is not getting updated.
        // To let the age range selection persist in the current session as desired, we ignore this...
        // Unless the birthday for some reason is different, then we should actually need to make sure we're up to date.
        const currentBirthday = this.store.selectSnapshot(DemographicState.birthdate);
        if (currentBirthday && currentBirthday === demographic.birthdate) {
            // No birthdate change, change this object's ageRange back to what it previously was
            demographic.ageRange = this.store.selectSnapshot(DemographicState.ageRange);
        }
        return demographic;
    }
    // we need to modify how we update member store when we are getting partial state back from the new update session call
    // we will not be getting complete data so we need to deep merge the data
    updateSessionCallback(sessionId, ctx, isMemberInitialLoad, isEnrollmentHistoryIncluded) {
        return session => {
            // Removing questions from session because MedSupState has same name
            // and will be overwritten with invalid data if questions is left in
            const { questions, demographic, medigapAnswers, preferences, profile, shoppingCart, totalCostEffectiveDate, memberProgressInfo, ...modifiedSession } = session;
            const medSupQuestionsSessionModel = questions
                ? MedSupState.transformHttpModelToSessionModel(questions)
                : [];
            const planQuestionsSessionModel = questions
                ? MedSupState.transformHttpModelToSessionModel(questions)
                : [];
            if (demographic) {
                ctx.dispatch(new UpdateDemographics(this.checkDemographicsForAgeRangeUpdate(demographic)));
            }
            // Session model just has preferences = [], while we have PreferencesState = {preferences:[]}, so we need to tweak this slightly
            if (preferences) {
                this.store.dispatch(new SetPreferences(preferences));
            }
            ctx.dispatch(new InitializeMedSupAnswers(medSupQuestionsSessionModel));
            if (medigapAnswers) {
                ctx.dispatch(new UpdateMedigapAnswers(medigapAnswers));
            }
            if (totalCostEffectiveDate) {
                ctx.dispatch(new UpdateTotalCostEffectiveDate(DateUtilities.convertToDateString(totalCostEffectiveDate)));
            }
            if (memberProgressInfo?.transferCode || memberProgressInfo?.memberProgressList) {
                ctx.dispatch(new SetMemberProgressInfo(memberProgressInfo));
            }
            ctx.dispatch(new UpdateAncillaryPlanAnswers(planQuestionsSessionModel));
            ctx.dispatch(new UpdateHospitalIndemnityPlanAnswers(planQuestionsSessionModel));
            this.setMissingDemographicZip(isMemberInitialLoad);
            if (profile) {
                ctx.dispatch(new UpdateProfile(profile));
                this.profileContextService.setHICNValue(profile.hicn);
            }
            if (shoppingCart) {
                ctx.dispatch(new ResetShoppingCartState());
                ctx.dispatch(new UpdateShoppingCartAPIModel(shoppingCart));
                shoppingCart.forEach(cartItem => {
                    const plan = this.store.selectSnapshot(PlansState.plan(cartItem.planId));
                    if (plan) {
                        const plansSelectedRiderIds = cartItem.riders
                            ? cartItem.riders.filter(rider => rider.isSelected || rider.isRequired).map(selectedRider => selectedRider.riderId)
                            : [];
                        ctx.dispatch(new InsertPlan(plan, cartItem, plansSelectedRiderIds, false));
                    }
                });
            }
            if (modifiedSession.enrollments?.some(enrollment => enrollment.caLicenseNumber) &&
                !this.store.selectSnapshot(AgentState.inContext) &&
                this.store.selectSnapshot(RuntimeState.isRedirectedFromPlanCompareApi)) {
                ctx.dispatch(modifiedSession.enrollments.reduce((actions, enrollment) => {
                    if (enrollment.caLicenseNumber) {
                        const agentLicense = {
                            state: 'CA',
                            license: enrollment.caLicenseNumber,
                            licenseType: AgentLicenseType.PC_API
                        };
                        actions.push(new AddAgentLicense(agentLicense));
                    }
                    return actions;
                }, []));
            }
            ctx.patchState({
                loading: false,
                loaded: true,
                sessionId,
                ...modifiedSession,
                // SPA-18795: We don't pass the `isEnrollmentHistoryIncluded` flag on member session updates so we don't want to override the previous flag in those cases.
                ...(isEnrollmentHistoryIncluded !== undefined && { isEnrollmentHistoryIncluded })
            });
        };
    }
};
MemberState.ɵfac = function MemberState_Factory(t) { return new (t || MemberState)(i0.ɵɵinject(MemberSessionHttpService), i0.ɵɵinject(PlansHttpService), i0.ɵɵinject(DrugsHttpService), i0.ɵɵinject(i1.Store), i0.ɵɵinject(ProfileContextService)); };
MemberState.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MemberState, factory: MemberState.ɵfac });
__decorate([
    Action(AddDrugToMemberState)
], MemberState.prototype, "AddDrugDosage", null);
__decorate([
    Action(RemoveDrugFromMemberState)
], MemberState.prototype, "RemoveDosage", null);
__decorate([
    LiveEditInactive(),
    Action(CreateFullSession)
], MemberState.prototype, "createFullSession", null);
__decorate([
    LiveEditInactive(),
    Action(CreateSession)
], MemberState.prototype, "createSession", null);
__decorate([
    Action(SaveSearchedMemberData)
], MemberState.prototype, "setSearchCriteria", null);
__decorate([
    LiveEditInactive(),
    Action(UpdateSession)
], MemberState.prototype, "updateSession", null);
__decorate([
    LiveEditInactive(),
    Action(FetchSession)
], MemberState.prototype, "fetchSession$", null);
__decorate([
    LiveEditInactive(),
    Action(FetchEnrollmentPlanSettings)
], MemberState.prototype, "fetchEnrollmentPlanSettings", null);
__decorate([
    LiveEditInactive(),
    Action(FetchEnrollmentSettings)
], MemberState.prototype, "fetchEnrollmentSettings", null);
__decorate([
    LiveEditInactive(),
    Action(UpdateEnrollmentSettings)
], MemberState.prototype, "updateEnrollmentSettings", null);
__decorate([
    LiveEditInactive(),
    Action(UpdateMedigapAnswersSession)
], MemberState.prototype, "updateMedigapAnswersSession", null);
__decorate([
    Action(MemberLogin)
], MemberState.prototype, "memberLogin", null);
__decorate([
    Action(FetchMemberLoginTokenSuccess)
], MemberState.prototype, "fetchMemberLoginTokenSuccess", null);
__decorate([
    Action(FetchMemberLoginTokenError)
], MemberState.prototype, "fetchMemberLoginTokenError", null);
__decorate([
    Action(MemberLoginSuccess)
], MemberState.prototype, "memberLoginTokenSuccess", null);
__decorate([
    Action(MemberLoginError)
], MemberState.prototype, "memberLoginTokenError", null);
__decorate([
    Action(MemberLogout)
], MemberState.prototype, "memberLogout", null);
__decorate([
    Action(ResetMemberState)
], MemberState.prototype, "resetMemberState", null);
__decorate([
    Action(UpdateMemberEnrollments)
], MemberState.prototype, "updateMemberEnrollments", null);
__decorate([
    Action(SetMedicalCostInputs)
], MemberState.prototype, "SetMedicalCostInputs", null);
__decorate([
    Action(SetFavoriteBenefits)
], MemberState.prototype, "SetFavoriteBenefits", null);
__decorate([
    Action(SaveAndUpdateMemberDosage)
], MemberState.prototype, "saveAndUpdateMemberDosage", null);
__decorate([
    Action(LogoutMemberAgent)
], MemberState.prototype, "logoutMemberAgent", null);
__decorate([
    Action(AddMemberAgentNote)
], MemberState.prototype, "addMemberAgentNote", null);
__decorate([
    Action(UpdateMemberAgentNote)
], MemberState.prototype, "updateMemberAgentNote", null);
__decorate([
    Action(DeleteSelectRxTask)
], MemberState.prototype, "deleteSelectRxTask", null);
__decorate([
    Action(SetMemberLoading)
], MemberState.prototype, "setMemberLoading", null);
__decorate([
    Action(UpdateTotalCostEffectiveDate)
], MemberState.prototype, "updateTotalCostEffectiveDate", null);
__decorate([
    Action(ResetTotalCostEffectiveDate)
], MemberState.prototype, "resetTotalCostEffectiveDate", null);
__decorate([
    Action(SetIsCostByEffectiveDate)
], MemberState.prototype, "updateCostByEffectiveDate", null);
__decorate([
    Action(SetMemberProgressInfo)
], MemberState.prototype, "setMemberProgressInfo", null);
__decorate([
    Action(UpdateMedigapAnswers)
], MemberState.prototype, "UpdateMedigapAnswers", null);
__decorate([
    Action(SetPartAEffectiveDate)
], MemberState.prototype, "SetPartAEffectiveDate", null);
__decorate([
    Action(SetPartBEffectiveDate)
], MemberState.prototype, "SetPartBEffectiveDate", null);
__decorate([
    Action(SetAgentOfRecordLoading)
], MemberState.prototype, "SetAgentOfRecordLoading", null);
__decorate([
    Action(UpdateAgentOfRecord)
], MemberState.prototype, "UpdateAgentOfRecord", null);
__decorate([
    Action(UpdateAgentGuid)
], MemberState.prototype, "UpdateAgentGuid", null);
__decorate([
    Selector()
], MemberState, "session", null);
__decorate([
    Selector()
], MemberState, "enrollmentPlanSettings", null);
__decorate([
    Selector()
], MemberState, "enrollmentSettings", null);
__decorate([
    Selector()
], MemberState, "blueButtonInfo", null);
__decorate([
    Selector()
], MemberState, "sessionId", null);
__decorate([
    Selector()
], MemberState, "memberID", null);
__decorate([
    Selector()
], MemberState, "memberAgentNotes", null);
__decorate([
    Selector()
], MemberState, "isEnrollmentHistoryIncluded", null);
__decorate([
    Selector()
], MemberState, "memberEnrollments", null);
__decorate([
    Selector()
], MemberState, "userPreferences", null);
__decorate([
    Selector([MemberState_1.userPreferences])
], MemberState, "favoriteBenefits", null);
__decorate([
    Selector()
], MemberState, "medicalCostInputs", null);
__decorate([
    Selector()
], MemberState, "userName", null);
__decorate([
    Selector()
], MemberState, "firstName", null);
__decorate([
    Selector()
], MemberState, "lastName", null);
__decorate([
    Selector()
], MemberState, "phoneNumber", null);
__decorate([
    Selector()
], MemberState, "emailAddress", null);
__decorate([
    Selector()
], MemberState, "medigapAnswers", null);
__decorate([
    Selector()
], MemberState, "dateOfBirth", null);
__decorate([
    Selector()
], MemberState, "totalCostEffectiveDate", null);
__decorate([
    Selector()
], MemberState, "costByEffectiveDate", null);
__decorate([
    Selector()
], MemberState, "agentCallRecords", null);
__decorate([
    Selector()
], MemberState, "demographic", null);
__decorate([
    Selector([MemberState_1.demographic])
], MemberState, "demographicEstimateHealthCost", null);
__decorate([
    Selector([MemberState_1.demographic])
], MemberState, "zip", null);
__decorate([
    Selector([MemberState_1.demographic])
], MemberState, "fips", null);
__decorate([
    Selector()
], MemberState, "enrollmentPlanSettingsLoading", null);
__decorate([
    Selector()
], MemberState, "currentYearPlanId", null);
__decorate([
    Selector()
], MemberState, "loading", null);
__decorate([
    Selector()
], MemberState, "loaded", null);
__decorate([
    Selector()
], MemberState, "loginError", null);
__decorate([
    Selector()
], MemberState, "isLoggedIn", null);
__decorate([
    Selector()
], MemberState, "agentGuid", null);
__decorate([
    Selector()
], MemberState, "dosages", null);
__decorate([
    Selector([MemberState_1.dosages])
], MemberState, "isEligibleForSelectRxTasks", null);
__decorate([
    Selector()
], MemberState, "agentOfRecord", null);
__decorate([
    Selector()
], MemberState, "memberProgressInfo", null);
__decorate([
    Selector()
], MemberState, "externalEnrollments", null);
__decorate([
    Selector([MemberState_1.memberAgentNotes])
], MemberState, "memberAgentTasks", null);
MemberState = MemberState_1 = __decorate([
    State({
        name: MEMBER_STORE_NAME,
        defaults: MEMBER_DEFAULTS,
        children: [DemographicState, PreferencesState, ProfileState, MedSupState, ShoppingCartState]
    })
], MemberState);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MemberState, [{
        type: Injectable
    }], function () { return [{ type: MemberSessionHttpService }, { type: PlansHttpService }, { type: DrugsHttpService }, { type: i1.Store }, { type: ProfileContextService }]; }, { AddDrugDosage: [], RemoveDosage: [], createFullSession: [], createSession: [], setSearchCriteria: [], updateSession: [], fetchSession$: [], fetchEnrollmentPlanSettings: [], fetchEnrollmentSettings: [], updateEnrollmentSettings: [], updateMedigapAnswersSession: [], memberLogin: [], fetchMemberLoginTokenSuccess: [], fetchMemberLoginTokenError: [], memberLoginTokenSuccess: [], memberLoginTokenError: [], memberLogout: [], resetMemberState: [], updateMemberEnrollments: [], SetMedicalCostInputs: [], SetFavoriteBenefits: [], saveAndUpdateMemberDosage: [], logoutMemberAgent: [], addMemberAgentNote: [], updateMemberAgentNote: [], deleteSelectRxTask: [], setMemberLoading: [], updateTotalCostEffectiveDate: [], resetTotalCostEffectiveDate: [], updateCostByEffectiveDate: [], setMemberProgressInfo: [], UpdateMedigapAnswers: [], SetPartAEffectiveDate: [], SetPartBEffectiveDate: [], SetAgentOfRecordLoading: [], UpdateAgentOfRecord: [], UpdateAgentGuid: [] }); })();

class EnrollmentHttpService {
    constructor(http) {
        this.http = http;
        this.environment = EnvironmentService.getEnvironment();
    }
    startNextGenTransaction$(payload) {
        return this.http.post(`${EnvironmentService.getEnvironment().WEB_SERVICE_BASE_URL}/v2/Enroll/Start`, payload);
    }
    fetchTransaction$(transactionId) {
        return this.http.get(`${this.environment.ENROLLMENT_FORM_BASE_URL}/Transactions/${transactionId}`);
    }
    fetchNextGenTransaction$(sessionId, transactionId) {
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v2/Enroll/${sessionId}/Transaction/${transactionId}`);
    }
    fetchFormVersionInfo$(formId, isUAT = false) {
        const params = new HttpParams().set('showUAT', isUAT);
        return this.http
            .get(`${this.environment.WEB_SERVICE_BASE_URL}/v2/Enroll/FormVersion/${formId}`, {
            params
        })
            .pipe(map(({ formVersion, formVersionId }) => ({ formId, formVersion, formVersionId })));
    }
    generatePDF$(transactionId, planYear, locale = 'en-US') {
        return this.http
            .get(`${this.environment.ENROLLMENT_FORM_BASE_URL}/Transaction/${transactionId}/EnrollmentPDF?planYear=${planYear}&language=${locale}`)
            .pipe(map(response => response.PDF));
    }
    validateEnrollment$(payload, validationType) {
        const headers = new HttpHeaders({ Accept: 'application/json' });
        const params = new HttpParams().set('validation', validationType);
        return this.http
            .post(`${this.environment.WEB_SERVICE_BASE_URL}/v2/Enroll/Validations`, payload, { params, headers })
            .pipe(timeout(10000));
    }
    async validateEnrollment(payload, validationType) {
        return await firstValueFrom(this.validateEnrollment$(payload, validationType), { defaultValue: null });
    }
    checkMemberEligibility$(payload) {
        const headers = new HttpHeaders({ Accept: 'application/json' });
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v2/Enroll/MemberEligibility`, payload, {
            headers
        });
    }
    async checkMemberEligibility(payload) {
        return await firstValueFrom(this.checkMemberEligibility$(payload), { defaultValue: null });
    }
    uploadFiles$(payload) {
        const { transactionGuid, files, existingFilesCount, maxFilesAllowed, maxFileSize } = payload;
        const formData = new FormData();
        let params = new HttpParams().set('existingFilesCount', existingFilesCount);
        if (maxFilesAllowed) {
            params = params.set('maxFilesCount', maxFilesAllowed);
        }
        if (maxFileSize) {
            params = params.set('maxFileSize', maxFileSize);
        }
        files.forEach((file, index) => {
            formData.append(`file${index}`, file, file.name);
        });
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v2/Enroll/Action/Transactions/${transactionGuid}/files/upload`, formData, { params });
    }
    async uploadFiles(payload) {
        return await firstValueFrom(this.uploadFiles$(payload), { defaultValue: null });
    }
    deleteUploadedFile$(payload) {
        const { transactionGuid, fileId } = payload;
        return this.http.delete(`${this.environment.WEB_SERVICE_BASE_URL}/v2/Enroll/Action/Transactions/${transactionGuid}/files/${fileId}/delete`);
    }
    async deleteUploadedFile(payload) {
        return await firstValueFrom(this.deleteUploadedFile$(payload), { defaultValue: null });
    }
    downloadFile$(transactionGUID, fileId) {
        const options = {
            headers: new HttpHeaders({ Accept: 'blob' }),
            responseType: 'blob'
        };
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v2/Enroll/Action/Transactions/${transactionGUID}/files/${fileId}/download`, options);
    }
    async downloadFile(transactionGUID, fileId) {
        return await firstValueFrom(this.downloadFile$(fileId, transactionGUID), { defaultValue: null });
    }
    updateExpirationDate$(transactionGUID, payload) {
        const headers = new HttpHeaders({ Accept: 'application/json' });
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v2/Enroll/${transactionGUID}/ExpirationDate`, payload, {
            headers
        });
    }
}
EnrollmentHttpService.ɵfac = function EnrollmentHttpService_Factory(t) { return new (t || EnrollmentHttpService)(i0.ɵɵinject(i1$2.HttpClient)); };
EnrollmentHttpService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: EnrollmentHttpService, factory: EnrollmentHttpService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnrollmentHttpService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1$2.HttpClient }]; }, null); })();

class StringFormatUtilityService {
    capitalizeFirstLetter(stringToCapitalize) {
        if (stringToCapitalize) {
            return stringToCapitalize.charAt(0).toUpperCase() + stringToCapitalize.substring(1);
        }
        return '';
    }
    capitalizeName(name) {
        const names = name?.split(' ');
        let capitalizedName = '';
        names?.forEach((namePart, index) => {
            const lowerCasePart = namePart.toLowerCase();
            const completePart = this.capitalizeFirstLetter(lowerCasePart);
            capitalizedName += index > 0 ? ` ${completePart}` : `${completePart}`;
        });
        return capitalizedName;
    }
    convertToCamelCase(stringToConvert, preserveAcronyms = false) {
        if (stringToConvert) {
            const specialCharactersRegex = /[_-]/g;
            const camelCaseFragmentRegex = /([a-z])(?=[A-Z])/g;
            const acronymFragmentRegex = /(?=[A-Z][a-z]|\d)/g;
            const upperCaseCharactersRegex = /^[A-Z]+$/;
            // Replaces all special characters with whitespace, keeps any captured lower case character followed by an upper case character,
            // removes all whitespace from both ends of the string and converts to lowercase
            const lowerCasedString = stringToConvert
                .replace(specialCharactersRegex, ' ')
                .replace(camelCaseFragmentRegex, '$1 ')
                .replace(acronymFragmentRegex, ' ')
                .trim();
            const splittedWords = lowerCasedString
                .split(' ')
                .reduce((selectedWords, word) => (word ? selectedWords.concat(word) : selectedWords), []);
            splittedWords[0] = splittedWords[0]?.toLowerCase() ?? '';
            // Return string to camelCase
            return splittedWords.reduce((camelCasedString, word) => {
                if (preserveAcronyms && upperCaseCharactersRegex.test(word)) {
                    return camelCasedString + word;
                }
                return camelCasedString + this.capitalizeFirstLetter(word.toLowerCase());
            });
        }
        return '';
    }
    lowercaseFirstCharacter(stringToConvert) {
        if (stringToConvert) {
            return stringToConvert.charAt(0).toLowerCase() + stringToConvert.slice(1);
        }
        return '';
    }
}
StringFormatUtilityService.ɵfac = function StringFormatUtilityService_Factory(t) { return new (t || StringFormatUtilityService)(); };
StringFormatUtilityService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: StringFormatUtilityService, factory: StringFormatUtilityService.ɵfac, providedIn: 'root' });
__decorate([
    Memoize()
], StringFormatUtilityService.prototype, "capitalizeFirstLetter", null);
__decorate([
    Memoize()
], StringFormatUtilityService.prototype, "capitalizeName", null);
__decorate([
    Memoize()
], StringFormatUtilityService.prototype, "convertToCamelCase", null);
__decorate([
    Memoize()
], StringFormatUtilityService.prototype, "lowercaseFirstCharacter", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StringFormatUtilityService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, { capitalizeFirstLetter: [], capitalizeName: [], convertToCamelCase: [], lowercaseFirstCharacter: [] }); })();

var EnrollmentState_1;
const ENROLLMENT_DEFAULTS = {
    activeEnrollmentKey: '',
    customPlanPremium: null,
    crossSellEnrollmentTypes: CrossSellEnrollmentTypes.NOT_CROSSSELL,
    enrollmentForms: [],
    nextGenEnrollmentForms: [],
    hraParentPlan: null,
    hraParentEnrollmentConfirmationNumber: '',
    enrollmentHistorySelectedPlan: null,
    callRecordingAvailable: false,
    enrollmentPlanCount: -1,
    formVersionIdState: {
        previousFormVersionId: '',
        currentFormVersionId: ''
    }
};
let EnrollmentState = EnrollmentState_1 = class EnrollmentState {
    constructor(httpClient, enrollmentHttpService, localeService, store, stringFormatUtilityService, externalErrorLoggingService) {
        this.httpClient = httpClient;
        this.enrollmentHttpService = enrollmentHttpService;
        this.localeService = localeService;
        this.store = store;
        this.stringFormatUtilityService = stringFormatUtilityService;
        this.externalErrorLoggingService = externalErrorLoggingService;
    }
    static getAgentCallRecordsByTransactionGUID(agentCallRecords, transactionGUID) {
        if (transactionGUID) {
            return (agentCallRecords
                ?.reduce((selectedAgentCallRecords, agentCallRecord) => {
                if (!!agentCallRecord.enrollments.length &&
                    agentCallRecord.enrollments.some(enrollment => enrollment.nativeTransactionID === transactionGUID)) {
                    const { enrollments, ...agentCallRecordModified } = agentCallRecord;
                    return [...selectedAgentCallRecords, agentCallRecordModified];
                }
                return selectedAgentCallRecords;
            }, [])
                ?.sort((agentCallRecordA, agentCallRecordB) => new Date(agentCallRecordB.timestamp).getTime() - new Date(agentCallRecordA.timestamp).getTime()) ?? []);
        }
        return [];
    }
    static activeEnrollmentKey(state) {
        return state.activeEnrollmentKey;
    }
    static customPlanPremium(state) {
        return state.customPlanPremium;
    }
    static callRecordingAvailable(state) {
        return state.callRecordingAvailable;
    }
    static recordingAvailable(callRecordingAvailable) {
        return callRecordingAvailable ? CallRecordingAvailability.AVAILABLE : CallRecordingAvailability.NONE;
    }
    static crossSellEnrollmentTypes(state) {
        return state.crossSellEnrollmentTypes;
    }
    static enrollmentForms(state) {
        return state.enrollmentForms;
    }
    static nextGenEnrollmentForms(state) {
        return state.nextGenEnrollmentForms;
    }
    static hraPlan(state) {
        return state.hraParentPlan;
    }
    static enrollmentHistorySelectedPlan(state) {
        return state.enrollmentHistorySelectedPlan;
    }
    static hraPlanId(hraParentPlan) {
        return hraParentPlan?.id;
    }
    static hraParentEnrollmentConfirmationNumber(state) {
        return state.hraParentEnrollmentConfirmationNumber;
    }
    static enrollmentPlanCount(state) {
        return state.enrollmentPlanCount;
    }
    static getFormVersionIdState(state) {
        return state.formVersionIdState;
    }
    static previousFormVersionId(formVersionIdState) {
        return formVersionIdState?.previousFormVersionId ?? '';
    }
    static currentFormVersionId(formVersionIdState) {
        return formVersionIdState?.currentFormVersionId ?? '';
    }
    static hasFormVersionIdChanged(previousFormVersionId, currentFormVersionId) {
        return !!previousFormVersionId && !!currentFormVersionId && previousFormVersionId !== currentFormVersionId;
    }
    // An HRA enrollment does not use the planId as the activeEnrollmentKey,
    // as that would be a duplicate key as the main plan the HRA is a part of.
    // It instead uses the formId, but some parts of the code still assume activeEnrollmentKey is a planId
    // Since obfsucated planIds are alphaNumerical and formIds are GUIDs, we can test that format to determine what the key is.
    static activePlanId(activeEnrollmentKey, hraPlanId) {
        return activeEnrollmentKey.includes('-') && hraPlanId ? hraPlanId : activeEnrollmentKey;
    }
    static enrollmentFormUserType(enrollmentKey) {
        return createSelector([EnrollmentState_1.enrollmentForms], (enrollmentForms) => enrollmentForms?.find(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey) ?? null);
    }
    static form(enrollmentKey) {
        return createSelector([EnrollmentState_1.enrollmentFormUserType(enrollmentKey)], (enrollmentFormUserType) => enrollmentFormUserType?.form);
    }
    // TODO: may be extraneous but I am anticipating multiple plans so going to leave it for now
    static nextGenEnrollmentFormTransaction(enrollmentKey) {
        return createSelector([EnrollmentState_1.nextGenEnrollmentForms], (nextGenEnrollmentForms) => nextGenEnrollmentForms?.find(form => form.enrollmentKey === enrollmentKey));
    }
    static nextGenTransactionExternalEnrollmentData(enrollmentKey) {
        return createSelector([EnrollmentState_1.nextGenEnrollmentFormTransaction(enrollmentKey)], (transaction) => transaction?.externalEnrollment);
    }
    static nextGenTransactionExternalEnrollmentUserType(enrollmentKey) {
        return createSelector([EnrollmentState_1.nextGenTransactionExternalEnrollmentData(enrollmentKey)], (externalEnrollment) => externalEnrollment?.enrollmentUserType ?? null);
    }
    static hasNextGenEnrollmentFormTransaction(enrollmentKey) {
        return createSelector([EnrollmentState_1.nextGenEnrollmentForms], (nextGenEnrollmentForms) => !!nextGenEnrollmentForms?.some(form => form.enrollmentKey === enrollmentKey));
    }
    static nextGenEnrollmentPrefillData(enrollmentKey) {
        return createSelector([EnrollmentState_1.nextGenEnrollmentFormTransaction(enrollmentKey)], (form) => form?.prefillData ?? {});
    }
    static hopeEnrollmentAnswers(enrollmentKey) {
        return createSelector([EnrollmentState_1.transaction(enrollmentKey)], (transaction) => transaction?.answers ?? []);
    }
    static transaction(enrollmentKey) {
        return createSelector([EnrollmentState_1.form(enrollmentKey)], (form) => form?.transaction);
    }
    static transactionId(enrollmentKey) {
        return createSelector([
            MemberState.planHasNextGenForm(enrollmentKey),
            EnrollmentState_1.nextGenTransactionSID(enrollmentKey),
            EnrollmentState_1.hopeTransactionId(enrollmentKey)
        ], (hasNextGenForm, nextGenTransactionSID, hopeTransactionSID) => {
            if (hasNextGenForm !== null) {
                return hasNextGenForm ? nextGenTransactionSID : hopeTransactionSID;
            }
            else {
                // if we don't have plan enrollment settings return the first truthy transaction SID found for the enrollmentKey
                // I would not expect both of these to have values since a particular enrollment key should not be using both systems
                // in the same application context
                return nextGenTransactionSID ?? hopeTransactionSID;
            }
        });
    }
    static hopeTransactionId(enrollmentKey) {
        return createSelector([EnrollmentState_1.transaction(enrollmentKey)], (transaction) => transaction?.transactionSID);
    }
    static nextGenTransactionSID(enrollmentKey) {
        return createSelector([EnrollmentState_1.nextGenEnrollmentFormTransaction(enrollmentKey)], (transaction) => transaction?.transactionSID);
    }
    static transactionGUID(enrollmentKey) {
        return createSelector([
            MemberState.planHasNextGenForm(enrollmentKey),
            EnrollmentState_1.nextGenTransactionId(enrollmentKey),
            EnrollmentState_1.hopeTransactionGUID(enrollmentKey)
        ], (hasNextGenForm, nextGenTransactionGUID, hopeTransactionGUID) => {
            if (hasNextGenForm !== null) {
                return hasNextGenForm ? nextGenTransactionGUID : hopeTransactionGUID;
            }
            else {
                // if we don't have plan enrollment settings return the first truthy transaction number found for the enrollmentKey
                // I would not expect both of these to have values since a particular enrollment key should not be using both systems
                // in the same application context
                return nextGenTransactionGUID ?? hopeTransactionGUID;
            }
        });
    }
    static hopeTransactionGUID(enrollmentKey) {
        return createSelector([EnrollmentState_1.transaction(enrollmentKey)], (transaction) => transaction?.transactionGUID);
    }
    static nextGenTransactionId(enrollmentKey) {
        return createSelector([EnrollmentState_1.nextGenEnrollmentFormTransaction(enrollmentKey)], (transaction) => transaction?.transactionGUID);
    }
    static confirmationNumber(enrollmentKey) {
        return createSelector([
            MemberState.planHasNextGenForm(enrollmentKey),
            EnrollmentState_1.nextGenConfirmationNumber(enrollmentKey),
            EnrollmentState_1.hopeConfirmationNumber(enrollmentKey)
        ], (hasNextGenForm, nextGenTransactionConfirmationNumber, hopeTransactionConfirmationNumber) => {
            if (hasNextGenForm !== null) {
                return hasNextGenForm ? nextGenTransactionConfirmationNumber : hopeTransactionConfirmationNumber;
            }
            else {
                // if we don't have plan enrollment settings return the first truthy confirmation number found for the enrollmentKey
                // I would not expect both of these to have values since a particular enrollment key should not be using both systems
                // in the same application context
                return nextGenTransactionConfirmationNumber ?? hopeTransactionConfirmationNumber;
            }
        });
    }
    static hopeConfirmationNumber(enrollmentKey) {
        return createSelector([EnrollmentState_1.transaction(enrollmentKey)], (transaction) => transaction?.confirmationNumber);
    }
    static nextGenConfirmationNumber(enrollmentKey) {
        return createSelector([EnrollmentState_1.nextGenEnrollmentFormTransaction(enrollmentKey)], (transaction) => transaction?.confirmationNumber);
    }
    static status(enrollmentKey) {
        return createSelector([
            MemberState.planHasNextGenForm(enrollmentKey),
            EnrollmentState_1.nextGenTransactionStatus(enrollmentKey),
            EnrollmentState_1.hopeTransactionStatus(enrollmentKey)
        ], (hasNextGenForm, nextGenEnrollmentFormTransactionStatus, hopeEnrollmentFormTransactionStatus) => {
            if (hasNextGenForm !== null) {
                return hasNextGenForm ? nextGenEnrollmentFormTransactionStatus : hopeEnrollmentFormTransactionStatus;
            }
            else {
                // if we don't have plan enrollment settings return the first truthy transaction status found for the enrollmentKey
                // I would not expect both of these to have values since a particular enrollment key should not be using both systems
                // in the same application context
                return nextGenEnrollmentFormTransactionStatus ?? hopeEnrollmentFormTransactionStatus;
            }
        });
    }
    static hopeTransactionStatus(enrollmentKey) {
        return createSelector([EnrollmentState_1.transaction(enrollmentKey)], (transaction) => transaction?.status);
    }
    static nextGenTransactionStatus(enrollmentKey) {
        return createSelector([EnrollmentState_1.nextGenEnrollmentFormTransaction(enrollmentKey)], (transaction) => transaction?.status);
    }
    static formLoaded(enrollmentKey) {
        return createSelector([EnrollmentState_1.form(enrollmentKey)], (form) => !!form?.loaded);
    }
    static formLoading(enrollmentKey) {
        return createSelector([EnrollmentState_1.form(enrollmentKey)], (form) => !!form?.loading);
    }
    static nextGenFormLoaded(enrollmentKey) {
        return createSelector([EnrollmentState_1.nextGenEnrollmentFormTransaction(enrollmentKey)], (form) => !!form?.loaded);
    }
    static nextGenFormLoading(enrollmentKey) {
        return createSelector([EnrollmentState_1.nextGenEnrollmentFormTransaction(enrollmentKey)], (form) => !!form?.loading);
    }
    static confirmationDataLoading(enrollmentKey) {
        return createSelector([EnrollmentState_1.form(enrollmentKey)], (form) => !!form?.confirmationDataLoading);
    }
    static isPCApiEnrollment(enrollmentKey) {
        return createSelector([
            MemberState.planHasNextGenForm(enrollmentKey),
            EnrollmentState_1.isPCApiNextGenEnrollment(enrollmentKey),
            EnrollmentState_1.isPCApiHopeEnrollment(enrollmentKey)
        ], (hasNextGenForm, isPCApiNextGenEnrollment, isPCApiHopeEnrollment) => {
            if (hasNextGenForm !== null) {
                return hasNextGenForm ? isPCApiNextGenEnrollment : isPCApiHopeEnrollment;
            }
            else {
                // if we don't have plan enrollment settings return the first truthy PCAPI enrollment status found for the enrollmentKey
                // I would not expect both of these to have values since a particular enrollment key should not be using both systems
                // in the same application context
                return isPCApiNextGenEnrollment ?? isPCApiHopeEnrollment;
            }
        });
    }
    static isPCApiHopeEnrollment(enrollmentKey) {
        return createSelector([EnrollmentState_1.form(enrollmentKey)], (form) => !!form?.isPCApiEnrollment);
    }
    static isPCApiNextGenEnrollment(enrollmentKey) {
        return createSelector([EnrollmentState_1.nextGenEnrollmentFormTransaction(enrollmentKey)], (transaction) => !!transaction?.isPCApiEnrollment);
    }
    static isNextGenEnrollmentStarted(enrollmentKey) {
        return createSelector([EnrollmentState_1.nextGenEnrollmentFormTransaction(enrollmentKey)], (transaction) => !!transaction?.isEnrollmentStarted);
    }
    static style(enrollmentKey) {
        return createSelector([EnrollmentState_1.form(enrollmentKey)], (form) => form?.style);
    }
    static script(enrollmentKey) {
        return createSelector([EnrollmentState_1.form(enrollmentKey)], (form) => form?.script);
    }
    static answer(enrollmentKey, name) {
        return createSelector([
            MemberState.planHasNextGenForm(enrollmentKey),
            EnrollmentState_1.nextGenAnswer(enrollmentKey, name),
            EnrollmentState_1.hopeAnswer(enrollmentKey, name)
        ], (hasNextGenForm, nextGenAnswer, hopeAnswer) => {
            if (hasNextGenForm !== null) {
                return hasNextGenForm ? nextGenAnswer : hopeAnswer;
            }
            else {
                // if we don't have plan enrollment settings return the first truthy enrollment answer found for the enrollmentKey
                // I would not expect both of these to have values since a particular enrollment key should not be using both systems
                // in the same application context
                return nextGenAnswer ?? hopeAnswer;
            }
        });
    }
    static hopeAnswer(enrollmentKey, name) {
        return createSelector([EnrollmentState_1.hopeEnrollmentAnswers(enrollmentKey)], (hopeEnrollmentFormAnswers) => {
            const selectedAnswer = hopeEnrollmentFormAnswers?.find(answer => answer.name === name);
            return selectedAnswer !== undefined ? selectedAnswer : null;
        });
    }
    static nextGenAnswer(enrollmentKey, name) {
        return createSelector([EnrollmentState_1.nextGenEnrollmentPrefillData(enrollmentKey)], (nextGenEnrollmentFormPrefillData) => {
            const lowercaseName = name.toLowerCase();
            const [, value] = Object.entries(nextGenEnrollmentFormPrefillData).find(([key]) => key.toLowerCase() === lowercaseName) ?? [];
            let selectedAnswer;
            if (value !== undefined) {
                selectedAnswer = { name, value };
            }
            return selectedAnswer !== undefined ? selectedAnswer : null;
        });
    }
    static formPageInfo(enrollmentKey) {
        return createSelector([EnrollmentState_1.form(enrollmentKey)], (form) => form?.pageInfo);
    }
    static formPages(enrollmentKey) {
        return createSelector([EnrollmentState_1.formPageInfo(enrollmentKey)], (pageInfo) => {
            const pages = pageInfo?.pages;
            return pages || [];
        });
    }
    static page(enrollmentKey, pageName) {
        return createSelector([EnrollmentState_1.formPages(enrollmentKey)], (pages) => {
            const pageByName = pages ? pages.find(page => pageName && page.pageName.toLowerCase() === pageName.toLowerCase()) : null;
            return pageByName;
        });
    }
    static formPageLoading(enrollmentKey, pageName) {
        return createSelector([EnrollmentState_1.page(enrollmentKey, pageName)], (pageByName) => pageByName && pageByName.loading);
    }
    static pageDirty(enrollmentKey, pageName) {
        return createSelector([EnrollmentState_1.page(enrollmentKey, pageName)], (pageByName) => pageByName && pageByName.dirty);
    }
    static pageSkipped(enrollmentKey, pageName) {
        return createSelector([EnrollmentState_1.page(enrollmentKey, pageName)], (pageByName) => pageByName && pageByName.skipped);
    }
    static pageHtml(enrollmentKey, pageName) {
        return createSelector([EnrollmentState_1.page(enrollmentKey, pageName)], (pageByName) => pageByName?.pageHtml);
    }
    static pageIndex(enrollmentKey, pageName) {
        return createSelector([EnrollmentState_1.page(enrollmentKey, pageName)], (pageByName) => pageByName?.pageIndex && +pageByName.pageIndex);
    }
    static pageName(enrollmentKey, pageIndex) {
        return createSelector([EnrollmentState_1.formPages(enrollmentKey)], (pages) => {
            const pageByIndex = pages.find(page => +page.pageIndex === pageIndex);
            return pageByIndex?.pageName;
        });
    }
    static selectedFormType(enrollmentKey) {
        return createSelector([
            MemberState.planHasNextGenForm(enrollmentKey),
            EnrollmentState_1.nextGenEnrollmentFormTransaction(enrollmentKey),
            EnrollmentState_1.enrollmentFormUserType(enrollmentKey)
        ], (hasNextGenForm, nextGenEnrollmentFormTransaction, hopeEnrollmentForm) => {
            if (hasNextGenForm !== null) {
                return hasNextGenForm ? nextGenEnrollmentFormTransaction?.selectedFormType ?? 0 : hopeEnrollmentForm?.selectedFormType;
            }
            else {
                // if we don't have plan enrollment settings return the first truthy selectedFormType found for the enrollmentKey
                // I would not expect both of these to have values since a particular enrollment key should not be using both systems
                // in the same application context
                return nextGenEnrollmentFormTransaction?.selectedFormType ?? hopeEnrollmentForm?.selectedFormType ?? 0;
            }
        });
    }
    static selectedUserFormType(enrollmentKey) {
        return createSelector([
            MemberState.planHasNextGenForm(enrollmentKey),
            EnrollmentState_1.nextGenEnrollmentFormTransaction(enrollmentKey),
            EnrollmentState_1.enrollmentFormUserType(enrollmentKey)
        ], (hasNextGenForm, nextGenEnrollmentFormTransaction, hopeEnrollmentForm) => {
            if (hasNextGenForm !== null) {
                return hasNextGenForm ? nextGenEnrollmentFormTransaction?.userFormType : hopeEnrollmentForm?.userFormType;
            }
            else {
                // if we don't have plan enrollment settings return the first truthy userFormType found for the enrollmentKey
                // I would not expect both of these to have values since a particular enrollment key should not be using both systems
                // in the same application context
                return nextGenEnrollmentFormTransaction?.userFormType ?? hopeEnrollmentForm?.userFormType;
            }
        });
    }
    static isNextGenFormSignAndSubmitOnly(enrollmentKey) {
        return createSelector([EnrollmentState_1.nextGenEnrollmentFormTransaction(enrollmentKey)], (nextGenEnrollmentFormTransaction) => {
            return !!nextGenEnrollmentFormTransaction?.isFormSignAndSubmitOnly;
        });
    }
    static hopeCMSApprovalCode(enrollmentKey) {
        return createSelector([EnrollmentState_1.formPageInfo(enrollmentKey)], (pageInfo) => pageInfo?.formCMSApprovalCode);
    }
    static nextGenFormCMSApprovalCode(enrollmentKey) {
        return createSelector([EnrollmentState_1.nextGenEnrollmentFormTransaction(enrollmentKey)], (form) => form?.formCMSApprovalCode);
    }
    static nextGenEnrollmentSepReasons(enrollmentKey) {
        return createSelector([EnrollmentState_1.nextGenEnrollmentFormTransaction(enrollmentKey)], (form) => {
            return form?.sepReasons;
        });
    }
    static agentCallRecordsByTransactionGUID(transactionGUID) {
        return createSelector([MemberState.agentCallRecords], (agentCallRecords) => EnrollmentState_1.getAgentCallRecordsByTransactionGUID(agentCallRecords, transactionGUID));
    }
    async completeNextGenEnrollment(ctx, { nextGenEnrollmentRequest, transactionId, planCount }) {
        const { getState, setState } = ctx;
        const enrollmentKey = nextGenEnrollmentRequest.enrollmentKey ?? nextGenEnrollmentRequest.planId;
        const state = getState();
        const currentEnrollmentPlanCount = state.enrollmentPlanCount;
        setState(patch({
            enrollmentPlanCount: currentEnrollmentPlanCount === -1 ? planCount : currentEnrollmentPlanCount,
            nextGenEnrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey, patch({
                loading: true,
                loaded: false
            }))
        }));
        const nextGenCompleteEnrollmentFormResponse = await this.httpClient
            .post(`${EnvironmentService.getEnvironment().WEB_SERVICE_BASE_URL}/v2/Enroll/${transactionId}/Submit`, nextGenEnrollmentRequest)
            .toPromise();
        setState(patch({
            nextGenEnrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey, patch({
                loaded: true,
                loading: false,
                ...nextGenCompleteEnrollmentFormResponse,
                // we have to assign confirmation number to prefill data because we use the
                // _enrollmentAnswer_.|activeEnrollmentKey|.ConfirmationNumber.value dynamic selector
                // to look this up in multiple places
                prefillData: patch({
                    confirmationNumber: nextGenCompleteEnrollmentFormResponse.confirmationNumber
                })
            }))
        }));
        // TODO: account for multiple enrollments?
        return await Promise.resolve(nextGenCompleteEnrollmentFormResponse);
    }
    // TODO: This will need to be updated or a new complete created for nextgen forms, right now transaction
    // and the forms structure in source is not conducive to saving nextgen stuff
    async completeEnrollment(ctx, { sessionId, transactionId, planYear, enrollmentRequest, enrollmentKey, planCount }) {
        const { setState, getState } = ctx;
        const state = getState();
        const currentEnrollmentPlanCount = state.enrollmentPlanCount;
        setState(patch({
            enrollmentPlanCount: currentEnrollmentPlanCount === -1 ? planCount : currentEnrollmentPlanCount,
            enrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey, patch({
                form: patch({
                    loading: true,
                    loaded: false
                })
            }))
        }));
        const transaction = await this.httpClient
            .post(`${EnvironmentService.getEnvironment().MEMBER_SESSION_BASE_URL}/${sessionId}/Transaction/${transactionId}/CompleteEnrollment?planYear=${planYear}`, enrollmentRequest)
            .toPromise();
        setState(patch({
            enrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey, patch({
                form: patch({
                    transaction,
                    loading: false,
                    loaded: true
                })
            }))
        }));
    }
    async setNextGenFormLoaded(ctx, { enrollmentKey, loaded }) {
        const { setState } = ctx;
        setState(patch({
            nextGenEnrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey, patch({
                loaded
            }))
        }));
    }
    async setNextGenFormLoading(ctx, { enrollmentKey, loading }) {
        const { setState } = ctx;
        setState(patch({
            nextGenEnrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey, patch({
                loading
            }))
        }));
    }
    async createNextGenFormTransaction(ctx, { nextGenEnrollmentRequest, callRecordingAvailable }) {
        const { setState } = ctx;
        const state = ctx.getState();
        const { plan, standaloneEnrollmentData } = nextGenEnrollmentRequest;
        let enrollmentKey;
        if (nextGenEnrollmentRequest?.isHRA) {
            enrollmentKey = nextGenEnrollmentRequest.enrollmentSettings?.formId;
        }
        else {
            enrollmentKey = standaloneEnrollmentData?.isStandaloneRequest ? standaloneEnrollmentData.formId : plan?.id;
        }
        const hasEnrollmentForm = !!state?.nextGenEnrollmentForms?.some(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey);
        this.updateOrInsertNextGenEnrollmentFormItem({
            ctx,
            enrollmentKey,
            ...(hasEnrollmentForm && {
                patchedEnrollmentFormItem: {
                    loading: true,
                    loaded: false
                }
            }),
            ...(!hasEnrollmentForm && {
                enrollmentItem: {
                    loading: true,
                    loaded: false,
                    enrollmentKey
                }
            })
        });
        const nextGenEnrollmentFormTransaction = await this.enrollmentHttpService
            .startNextGenTransaction$(nextGenEnrollmentRequest)
            .toPromise();
        // Check if there's an existing cms code for this planId already as that action goes off before this one
        const formCMSApprovalCode = this.store.selectSnapshot(EnrollmentState_1.nextGenFormCMSApprovalCode(enrollmentKey));
        setState(patch({
            nextGenEnrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey, patch({
                ...nextGenEnrollmentFormTransaction,
                enrollmentKey,
                loading: false,
                loaded: true,
                isEnrollmentStarted: true,
                formCMSApprovalCode
            })),
            callRecordingAvailable
        }));
        return await Promise.resolve(nextGenEnrollmentFormTransaction);
    }
    async createFormTransaction(ctx, { sessionId, planId, transactionData, planYear, isSiteLive, isReviewSite, allowSamePlanEnrollment, quoteId, enrollmentKey, hraData, formType, originalTransactionGUID, callRecordingCode, isPurl, planRanking, bestMatchPlanId, bestMatchPlanType, callRecordingAvailable, isTestingSite }) {
        const { setState } = ctx;
        const state = ctx.getState();
        const effectiveEnrollmentKey = enrollmentKey || planId;
        const hasEnrollmentForm = !!state?.enrollmentForms?.some(enrollmentForm => enrollmentForm.enrollmentKey === effectiveEnrollmentKey);
        this.updateOrInsertEnrollmentFormItem({
            ctx,
            enrollmentKey: effectiveEnrollmentKey,
            ...(hasEnrollmentForm && {
                patchedEnrollmentFormItem: {
                    form: patch({
                        loading: true,
                        loaded: false
                    })
                }
            }),
            ...(!hasEnrollmentForm && {
                formItem: {
                    loading: true,
                    loaded: false
                },
                enrollmentItem: {
                    enrollmentKey: effectiveEnrollmentKey
                }
            })
        });
        let requestBody = {
            payload: transactionData,
            isMedigap: transactionData.isMedigap,
            isSiteLive,
            isReviewSite,
            isHRA: hraData.isHRA,
            formType,
            OriginalTransactionGUID: originalTransactionGUID,
            callRecordingCode,
            isPurl,
            planRanking,
            bestMatchPlanId,
            bestMatchPlanType,
            isTestingSite,
            isExternalEnrollment: hraData.isDirectAPIEnrollment && hraData.isHRA,
            isPCAPIHRAEnrollment: hraData.isDirectAPIEnrollment && hraData.isHRA,
            storageID: hraData.storageId,
            hraType: hraData.hraType
        };
        if (quoteId) {
            requestBody = { ...requestBody, quoteID: quoteId };
        }
        const transaction = await this.httpClient
            .post(`${EnvironmentService.getEnvironment().MEMBER_SESSION_BASE_URL}/${sessionId}/Plans/${planId}/Enroll?planYear=${planYear}&AllowSamePlanEnrollment=${allowSamePlanEnrollment}`, requestBody)
            .pipe(catchError(err => {
            if (err) {
                throw err;
            }
            return of(err);
        }))
            .toPromise();
        setState(patch({
            enrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === effectiveEnrollmentKey, patch({
                form: patch({
                    transaction: transaction,
                    loading: false,
                    loaded: true
                })
            })),
            callRecordingAvailable
        }));
    }
    clearTransaction(ctx, { enrollmentKey }) {
        const { setState } = ctx;
        setState(patch({
            enrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey, patch({
                form: patch({
                    transaction: null,
                    loading: false,
                    loaded: false
                })
            }))
        }));
    }
    async updateFormTransaction(ctx, { transactionData, enrollmentKey }) {
        const { setState, getState } = ctx;
        const state = getState();
        setState(patch({
            enrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey, patch({
                form: patch({
                    loading: true,
                    loaded: false
                })
            }))
        }));
        const enrollmentForm = state.enrollmentForms.find(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey);
        if (enrollmentForm?.form?.transaction?.transactionSID) {
            // returns one transaction... not the entire list like some other calls
            const transaction = await this.httpClient
                .post(`${EnvironmentService.getEnvironment().ENROLLMENT_FORM_BASE_URL}/Transactions/${enrollmentForm.form.transaction.transactionSID}`, {
                ...transactionData
            })
                .toPromise()
                .catch(err => {
                console.error(err);
            });
            if (transactionData?.answers?.length && transaction) {
                if (transaction.answers?.some(answer => transactionData.answers.some(updatedAnswer => updatedAnswer.name === answer.name))) {
                    transaction.answers = transaction.answers.reduce((updatedAnswers, answer) => {
                        const selectedAnswer = transactionData.answers.find(updatedAnswer => updatedAnswer.name === answer.name);
                        return updatedAnswers.concat(selectedAnswer ?? answer);
                    }, []);
                }
                else {
                    transaction.answers = transaction.answers?.concat(transactionData.answers) ?? transactionData.answers;
                }
            }
            setState(patch({
                enrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey, patch({
                    form: patch({
                        // When we update the transaction for a page it invalidates the html for that page
                        // This is because we are receiving the input values from the html call and thus
                        // need to get new html that reflects the previously input values
                        pageInfo: patch({
                            pages: updateItems(page => page.dirty === false, patch({
                                dirty: true
                            }))
                        }),
                        transaction: transaction,
                        loading: false,
                        loaded: true
                    })
                }))
            }));
        }
    }
    async updateNextGenFormTransaction(ctx, { answersMap, enrollmentKey }) {
        const { setState } = ctx;
        setState(patch({
            nextGenEnrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey, patch({
                prefillData: patch({
                    ...Object.entries(answersMap).reduce((acc, [key, value]) => {
                        const camelCasedName = this.stringFormatUtilityService.convertToCamelCase(key, true);
                        acc[camelCasedName] = value;
                        return acc;
                    }, {})
                }),
                loading: true,
                loaded: false
            }))
        }));
        const transactionGUID = this.store.selectSnapshot(EnrollmentState_1.nextGenTransactionId(enrollmentKey));
        try {
            await this.httpClient
                .post(`${EnvironmentService.getEnvironment().WEB_SERVICE_BASE_URL}/V2/Enroll/${transactionGUID}/Answers`, answersMap)
                .toPromise();
            setState(patch({
                nextGenEnrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey, patch({
                    loading: false,
                    loaded: true
                }))
            }));
            return await Promise.resolve('updated');
        }
        catch (error) {
            return await Promise.resolve(error);
        }
    }
    async fetchTransaction(ctx, { transactionId, enrollmentKey }) {
        const { setState } = ctx;
        const state = ctx.getState();
        const hasEnrollmentForm = !!state?.enrollmentForms?.some(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey);
        this.updateOrInsertEnrollmentFormItem({
            ctx,
            enrollmentKey,
            ...(hasEnrollmentForm && {
                patchedEnrollmentFormItem: {
                    form: patch({
                        loading: true,
                        loaded: false
                    })
                }
            }),
            ...(!hasEnrollmentForm && {
                formItem: {
                    loading: true,
                    loaded: false
                },
                enrollmentItem: {
                    enrollmentKey
                }
            })
        });
        // returns one transaction... not the entire list like some other calls
        const transaction = await this.enrollmentHttpService.fetchTransaction$(transactionId).toPromise();
        setState(patch({
            enrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey, patch({
                form: patch({
                    transaction,
                    loading: false,
                    loaded: true
                })
            }))
        }));
        return await Promise.resolve(transaction);
    }
    async fetchNextGenTransaction(ctx, { sessionId, transactionId, enrollmentKey }) {
        const { setState } = ctx;
        const state = ctx.getState();
        const hasEnrollmentForm = !!state?.nextGenEnrollmentForms?.some(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey);
        this.updateOrInsertNextGenEnrollmentFormItem({
            ctx,
            enrollmentKey,
            ...(hasEnrollmentForm && {
                patchedEnrollmentFormItem: {
                    loading: true,
                    loaded: false
                }
            }),
            ...(!hasEnrollmentForm && {
                enrollmentItem: {
                    loading: true,
                    loaded: false,
                    enrollmentKey
                }
            })
        });
        // returns one transaction... not the entire list like some other calls
        const nextGenEnrollmentFormTransaction = await this.enrollmentHttpService
            .fetchNextGenTransaction$(sessionId, transactionId)
            .toPromise();
        setState(patch({
            nextGenEnrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey, patch({
                ...nextGenEnrollmentFormTransaction,
                loading: false,
                loaded: true,
                // we have to assign confirmation number to prefill data because we use the
                // _enrollmentAnswer_.|activeEnrollmentKey|.ConfirmationNumber.value dynamic selector
                // to look this up in multiple places
                prefillData: patch({
                    ...nextGenEnrollmentFormTransaction.prefillData,
                    confirmationNumber: nextGenEnrollmentFormTransaction.confirmationNumber
                })
            }))
        }));
        return await Promise.resolve(nextGenEnrollmentFormTransaction);
    }
    async fetchNextGenSepReasons(ctx, { planId, carrierId, planYear, language, planType, displaySEPReasons }) {
        const { setState } = ctx;
        try {
            setState(patch({
                nextGenEnrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === planId, patch({
                    loading: true,
                    loaded: false
                }))
            }));
            const nextGenEnrollmentSEPReasons$ = this.httpClient.get(`${EnvironmentService.getEnvironment().WEB_SERVICE_BASE_URL}/v2/Enroll/SEPReasons?planId=${planId}&carrierId=${carrierId}&planYear=${planYear}&language=${language}&planType=${planType}&isSEPEnabledForPlan=${displaySEPReasons}`);
            const sepReasons = await nextGenEnrollmentSEPReasons$.toPromise();
            setState(patch({
                nextGenEnrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === planId, patch({
                    sepReasons,
                    loading: false,
                    loaded: true
                }))
            }));
            return await Promise.resolve(sepReasons);
        }
        catch (error) {
            this.externalErrorLoggingService.log(error);
            // Whenever there is no data from sep reasons set on config BE returns a 500,
            // BA says this will be very unlikely and if there is an error it must
            // be data error but even in that case, that should not stop enrollment
            // so question will stay hidden with this default config
            const defaultSepReasons = {
                sepEnabled: false,
                otherReasonEnabled: false,
                sepReasons: [],
                sepGroups: []
            };
            setState(patch({
                nextGenEnrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === planId, patch({
                    sepReasons: defaultSepReasons,
                    loading: false,
                    loaded: true
                }))
            }));
            return await Promise.resolve(defaultSepReasons);
        }
    }
    async setFormLoading(ctx, { loading, loaded, enrollmentKey }) {
        const { setState } = ctx;
        setState(patch({
            enrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey, patch({
                form: patch({
                    loading,
                    loaded
                })
            }))
        }));
    }
    setConfirmationDataLoading(ctx, { confirmationDataLoading, enrollmentKey }) {
        const { setState } = ctx;
        setState(patch({
            enrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey, patch({
                form: patch({
                    confirmationDataLoading
                })
            }))
        }));
    }
    setFormPagesDirty(ctx, { enrollmentKey }) {
        const { setState } = ctx;
        setState(patch({
            enrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey, patch({
                form: patch({
                    pageInfo: patch({
                        pages: updateItems(page => page.dirty === false, patch({
                            dirty: true
                        }))
                    })
                })
            }))
        }));
    }
    clearFormPagesLoading(ctx, { enrollmentKey }) {
        const { setState } = ctx;
        setState(patch({
            enrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey, patch({
                form: patch({
                    pageInfo: patch({
                        pages: updateItems(page => page.loading === true, patch({
                            loading: false
                        }))
                    })
                })
            }))
        }));
    }
    async fetchFormPageHtml(ctx, { requestedPageIndex, enrollmentKey, locale = 'en-US', planYear }) {
        const { setState, getState } = ctx;
        const state = getState();
        setState(patch({
            enrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey, patch({
                form: patch({
                    pageInfo: patch({
                        pages: updateItem(page => page.pageIndex === requestedPageIndex, patch({
                            loading: true
                        }))
                    })
                })
            }))
        }));
        const enrollmentForm = state.enrollmentForms.find(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey);
        if (state && enrollmentForm?.form?.transaction?.transactionSID) {
            const pageHtml = await this.httpClient
                .get(`${EnvironmentService.getEnvironment().ENROLLMENT_FORM_BASE_URL}/Transactions/${enrollmentForm.form.transaction.transactionSID}/Form?page=${requestedPageIndex}&isReviewEdit=False&language=${this.localeService.getTransformedLocale(locale)}&planYear=${planYear}`, { responseType: 'text' })
                .toPromise();
            setState(patch({
                enrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey, patch({
                    form: patch({
                        pageInfo: patch({
                            pages: updateItem(page => page.pageIndex === requestedPageIndex, patch({
                                pageHtml,
                                loading: false,
                                dirty: false
                            }))
                        })
                    })
                }))
            }));
        }
        else {
            setState(patch({
                enrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey, patch({
                    form: patch({
                        pageInfo: patch({
                            pages: updateItem(page => page.pageIndex === requestedPageIndex, patch({
                                loading: false
                            }))
                        })
                    })
                }))
            }));
        }
    }
    async setPageVisited(ctx, { requestedPageIndex, enrollmentKey }) {
        const { setState } = ctx;
        setState(patch({
            enrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey, patch({
                form: patch({
                    pageInfo: patch({
                        pages: updateItem(page => page.pageIndex === requestedPageIndex, patch({
                            visited: true
                        }))
                    })
                })
            }))
        }));
    }
    async setPageComplete(ctx, { requestedPageIndex, enrollmentKey }) {
        const { setState } = ctx;
        setState(patch({
            enrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey, patch({
                form: patch({
                    pageInfo: patch({
                        pages: updateItem(page => page.pageIndex === requestedPageIndex, patch({
                            completed: true
                        }))
                    })
                })
            }))
        }));
    }
    async setPageSkipped(ctx, { pageIndex, skipped, enrollmentKey }) {
        const { setState } = ctx;
        setState(patch({
            enrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey, patch({
                form: patch({
                    pageInfo: patch({
                        pages: updateItem(page => page.pageIndex === pageIndex, patch({
                            skipped
                        }))
                    })
                })
            }))
        }));
    }
    async fetchFormPageInfo(ctx, { enrollmentKey }) {
        const { setState, getState } = ctx;
        const state = getState();
        setState(patch({
            enrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey, patch({
                form: patch({
                    loading: true,
                    loaded: false
                })
            }))
        }));
        const enrollmentForm = state.enrollmentForms.find(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey);
        if (state && enrollmentForm?.form?.transaction?.transactionSID) {
            const pageInfo = await this.httpClient
                .get(`${EnvironmentService.getEnvironment().ENROLLMENT_FORM_BASE_URL}/Transactions/${enrollmentForm.form.transaction.transactionSID}/Form/Info?showIdentifiers=true`)
                .toPromise();
            setState(patch({
                enrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey, patch({
                    form: patch({
                        pageInfo,
                        loading: false,
                        loaded: true
                    })
                }))
            }));
        }
    }
    resetEnrollmentState(ctx, { overrideDefaults }) {
        const { getState, setState } = ctx;
        // For tracking the last form to load since we need to know if we need to hard reload the
        // page in order to reload the nextgen form web component
        const { formVersionIdState } = getState();
        setState({ ...ENROLLMENT_DEFAULTS, formVersionIdState, ...overrideDefaults });
    }
    resetActiveEnrollmentKey({ patchState }) {
        patchState({
            activeEnrollmentKey: ''
        });
    }
    resetCrossSellEnrollmentTypes({ patchState }) {
        patchState({
            crossSellEnrollmentTypes: CrossSellEnrollmentTypes.NOT_CROSSSELL
        });
    }
    setActiveEnrollmentKey(ctx, { activeKey }) {
        const { patchState } = ctx;
        patchState({ activeEnrollmentKey: activeKey });
    }
    setCurrentFormVersionIdState(ctx, { formVersionId }) {
        const { setState, getState } = ctx;
        const { formVersionIdState } = getState();
        if (formVersionId !== formVersionIdState.currentFormVersionId) {
            setState(patch({
                formVersionIdState: {
                    previousFormVersionId: formVersionIdState.currentFormVersionId,
                    currentFormVersionId: formVersionId
                }
            }));
        }
    }
    setPreviousFormVersionIdState(ctx, { formVersionId }) {
        const { setState, getState } = ctx;
        const { formVersionIdState } = getState();
        if (formVersionId !== formVersionIdState.previousFormVersionId) {
            setState(patch({
                formVersionIdState: {
                    ...formVersionIdState,
                    previousFormVersionId: formVersionId
                }
            }));
        }
    }
    setPCAPICustomPlanPremium(ctx, { customPlanPremium }) {
        const { patchState } = ctx;
        patchState({ customPlanPremium });
    }
    setcrossSellEnrollmentTypes(ctx, { enrollmentTypes }) {
        const { patchState } = ctx;
        patchState({ crossSellEnrollmentTypes: enrollmentTypes });
    }
    updateSelectedFormType(ctx, { selectedFormType, enrollmentKey, hasNextGenForm }) {
        if (hasNextGenForm || this.store.selectSnapshot(MemberState.planHasNextGenForm(enrollmentKey))) {
            return ctx.dispatch(new UpdateNextGenSelectedFormType(selectedFormType, enrollmentKey));
        }
        return ctx.dispatch(new UpdateHopeSelectedFormType(selectedFormType, enrollmentKey));
    }
    updateNextGenSelectedFormType(ctx, { selectedFormType, enrollmentKey }) {
        const state = ctx.getState();
        const hasEnrollmentForm = !!state?.nextGenEnrollmentForms?.some(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey);
        this.updateOrInsertNextGenEnrollmentFormItem({
            ctx,
            enrollmentKey,
            ...(hasEnrollmentForm && {
                patchedEnrollmentFormItem: {
                    selectedFormType
                }
            }),
            ...(!hasEnrollmentForm && {
                formItem: {},
                enrollmentItem: {
                    enrollmentKey,
                    selectedFormType
                }
            })
        });
    }
    updateHopeSelectedFormType(ctx, { selectedFormType, enrollmentKey }) {
        const state = ctx.getState();
        const hasEnrollmentForm = !!state?.enrollmentForms?.some(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey);
        this.updateOrInsertEnrollmentFormItem({
            ctx,
            enrollmentKey,
            ...(hasEnrollmentForm && {
                patchedEnrollmentFormItem: {
                    selectedFormType
                }
            }),
            ...(!hasEnrollmentForm && {
                formItem: {},
                enrollmentItem: {
                    enrollmentKey,
                    selectedFormType
                }
            })
        });
    }
    updateUserFormType(ctx, { userFormType, enrollmentKey, isFormSignAndSubmitOnly }) {
        if (this.store.selectSnapshot(MemberState.planHasNextGenForm(enrollmentKey))) {
            return ctx.dispatch(new UpdateNextGenUserFormType(userFormType, enrollmentKey, isFormSignAndSubmitOnly));
        }
        return ctx.dispatch(new UpdateHopeUserFormType(userFormType, enrollmentKey));
    }
    updateHopeUserFormType(ctx, { userFormType, enrollmentKey }) {
        const state = ctx.getState();
        const hasEnrollmentForm = !!state?.enrollmentForms?.some(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey);
        this.updateOrInsertEnrollmentFormItem({
            ctx,
            enrollmentKey,
            ...(hasEnrollmentForm && {
                patchedEnrollmentFormItem: {
                    userFormType
                }
            }),
            ...(!hasEnrollmentForm && {
                formItem: {},
                enrollmentItem: {
                    enrollmentKey,
                    userFormType
                }
            })
        });
    }
    updateNextGenUserFormType(ctx, { userFormType, enrollmentKey, isFormSignAndSubmitOnly }) {
        const state = ctx.getState();
        const hasEnrollmentForm = !!state?.nextGenEnrollmentForms?.some(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey);
        this.updateOrInsertNextGenEnrollmentFormItem({
            ctx,
            enrollmentKey,
            ...(hasEnrollmentForm && {
                patchedEnrollmentFormItem: {
                    userFormType,
                    isFormSignAndSubmitOnly
                }
            }),
            ...(!hasEnrollmentForm && {
                formItem: {},
                enrollmentItem: {
                    enrollmentKey,
                    userFormType,
                    isFormSignAndSubmitOnly
                }
            })
        });
    }
    async createHopeTransactions(ctx, { transactions, enrollmentKey }) {
        const { setState } = ctx;
        const state = ctx.getState();
        const hasEnrollmentForm = !!state?.enrollmentForms?.some(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey);
        this.updateOrInsertEnrollmentFormItem({
            ctx,
            enrollmentKey,
            ...(hasEnrollmentForm && {
                patchedEnrollmentFormItem: {
                    form: patch({
                        loading: true,
                        loaded: false,
                        transaction: null,
                        error: null
                    })
                }
            }),
            ...(!hasEnrollmentForm && {
                formItem: {
                    loading: true,
                    loaded: false,
                    transaction: null,
                    error: null
                },
                enrollmentItem: {
                    enrollmentKey
                }
            })
        });
        try {
            const createdTransactions = await this.httpClient
                .post(`${EnvironmentService.getEnvironment().ENROLLMENT_FORM_BASE_URL}/transactions`, transactions)
                .toPromise();
            const createdTransaction = createdTransactions?.length ? createdTransactions[0] : null;
            setState(patch({
                enrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey, patch({
                    form: patch({
                        transaction: createdTransaction,
                        loading: false,
                        loaded: true
                    })
                }))
            }));
        }
        catch (err) {
            setState(patch({
                enrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey, patch({
                    form: patch({
                        error: err,
                        loading: false,
                        loaded: true
                    })
                }))
            }));
        }
    }
    async createPlanCompareApiTransaction(ctx, { sessionId, planId, storageId, planYear, isSiteLive, isReviewSite, createdIPAddress, partnerID, sourceID, destinationAppID, enrollmentKey }) {
        const { setState } = ctx;
        const state = ctx.getState();
        const effectiveEnrollmentKey = enrollmentKey || planId;
        const hasEnrollmentForm = !!state?.enrollmentForms?.some(enrollmentForm => enrollmentForm.enrollmentKey === effectiveEnrollmentKey);
        this.updateOrInsertEnrollmentFormItem({
            ctx,
            enrollmentKey: effectiveEnrollmentKey,
            ...(hasEnrollmentForm && {
                patchedEnrollmentFormItem: {
                    form: patch({
                        loading: true,
                        loaded: false
                    })
                }
            }),
            ...(!hasEnrollmentForm && {
                formItem: {
                    loading: true,
                    loaded: false
                },
                enrollmentItem: {
                    enrollmentKey: effectiveEnrollmentKey
                }
            })
        });
        const requestBody = {
            isExternalEnrollment: true,
            storageID: storageId,
            isSiteLive,
            isReviewSite,
            payload: {
                createdIPAddress
            },
            partnerID,
            sourceID,
            destinationAppID
        };
        const transaction = await this.httpClient
            .post(`${EnvironmentService.getEnvironment().MEMBER_SESSION_BASE_URL}/${sessionId}/Plans/${planId}/Enroll?planYear=${planYear}`, requestBody)
            .toPromise();
        setState(patch({
            enrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === effectiveEnrollmentKey, patch({
                form: patch({
                    hraUserType: transaction.hraUserType,
                    transaction,
                    loading: false,
                    loaded: true,
                    isPCApiEnrollment: true
                })
            }))
        }));
    }
    async createPlanCompareApiNextGenTransaction(ctx, { nextGenEnrollmentRequest }) {
        const { setState } = ctx;
        const state = ctx.getState();
        const enrollmentKey = nextGenEnrollmentRequest.plan.id;
        const hasEnrollmentForm = !!state?.nextGenEnrollmentForms?.some(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey);
        this.updateOrInsertNextGenEnrollmentFormItem({
            ctx,
            enrollmentKey,
            ...(hasEnrollmentForm && {
                patchedEnrollmentFormItem: {
                    loading: true,
                    loaded: false
                }
            }),
            ...(!hasEnrollmentForm && {
                enrollmentItem: {
                    loading: true,
                    loaded: false,
                    enrollmentKey
                }
            })
        });
        const nextGenEnrollmentFormTransaction = await this.enrollmentHttpService
            .startNextGenTransaction$(nextGenEnrollmentRequest)
            .toPromise();
        // Check if there's an existing cms code for this planId already as that action goes off before this one
        const formCMSApprovalCode = this.store.selectSnapshot(EnrollmentState_1.nextGenFormCMSApprovalCode(enrollmentKey));
        setState(patch({
            nextGenEnrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey, patch({
                ...nextGenEnrollmentFormTransaction,
                enrollmentKey,
                loading: false,
                loaded: true,
                isPCApiEnrollment: true,
                isEnrollmentStarted: true,
                formCMSApprovalCode
            }))
        }));
        return await Promise.resolve(nextGenEnrollmentFormTransaction);
    }
    UpdateHRAParentInfo(ctx, { hraParentPlan, hraParentEnrollmentConfirmationNumber }) {
        const { patchState } = ctx;
        patchState({ hraParentPlan, hraParentEnrollmentConfirmationNumber });
    }
    SetEnrollmentHistorySelectedPlan(ctx, { plan }) {
        const { patchState } = ctx;
        patchState({ enrollmentHistorySelectedPlan: plan });
    }
    ClearEnrollmentHistorySelectedPlan({ patchState }) {
        patchState({
            enrollmentHistorySelectedPlan: null
        });
    }
    ClearHRAParentPlan({ patchState }) {
        patchState({
            hraParentPlan: null,
            hraParentEnrollmentConfirmationNumber: ''
        });
    }
    setCallRecordingAvailable({ patchState }) {
        patchState({
            callRecordingAvailable: true
        });
    }
    clearCallRecordingAvailable({ patchState }) {
        patchState({
            callRecordingAvailable: false
        });
    }
    // Only used for next gen, as the code is just a property on those forms and we need to slot it in manually
    updateCMSApprovalCode(ctx, { formCMSApprovalCode, enrollmentKey }) {
        const { setState } = ctx;
        const currentForm = this.store.selectSnapshot(EnrollmentState_1.nextGenEnrollmentFormTransaction(enrollmentKey));
        if (currentForm) {
            setState(patch({
                nextGenEnrollmentForms: updateItem(form => form.enrollmentKey === enrollmentKey, patch({
                    formCMSApprovalCode
                }))
            }));
        }
        else {
            setState(patch({
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                nextGenEnrollmentForms: insertItem({
                    enrollmentKey,
                    formCMSApprovalCode
                })
            }));
        }
    }
    createEnrollmentFormItem(enrollmentFormItem, formItem) {
        const isPCApiEnrollment = this.store.selectSnapshot(RuntimeState.isRedirectedFromPlanCompareApi);
        const defaultForm = {
            style: '',
            script: '',
            transaction: null,
            pageInfo: { formID: '', formCMSApprovalCode: '', formVersion: '', pages: [], publicFormID: '' },
            error: null,
            loading: false,
            loaded: false,
            isPCApiEnrollment,
            confirmationDataLoading: false
        };
        const defaultEnrollmentForm = {
            enrollmentKey: '',
            form: defaultForm,
            selectedFormType: 0,
            userFormType: null
        };
        return {
            ...defaultEnrollmentForm,
            ...(enrollmentFormItem.enrollmentKey && { enrollmentKey: enrollmentFormItem.enrollmentKey }),
            ...(enrollmentFormItem.selectedFormType && { selectedFormType: enrollmentFormItem.selectedFormType }),
            ...(enrollmentFormItem.userFormType && { userFormType: enrollmentFormItem.userFormType }),
            ...(formItem && {
                form: {
                    ...defaultForm,
                    ...(formItem.loading && { loading: formItem.loading }),
                    ...(formItem.loaded && { loaded: formItem.loaded }),
                    ...(formItem.transaction && { transaction: formItem.transaction }),
                    ...(formItem.error && { error: formItem.error })
                }
            })
        };
    }
    createNextGenEnrollmentFormItem(nextGenEnrollmentFormItem) {
        const isPCApiEnrollment = this.store.selectSnapshot(RuntimeState.isRedirectedFromPlanCompareApi);
        const defaultEnrollmentForm = {
            enrollmentKey: '',
            loading: false,
            loaded: false,
            isPCApiEnrollment,
            selectedFormType: 0,
            userFormType: null
        };
        return {
            ...defaultEnrollmentForm,
            ...(nextGenEnrollmentFormItem.enrollmentKey && { enrollmentKey: nextGenEnrollmentFormItem.enrollmentKey }),
            ...(nextGenEnrollmentFormItem.loading && { loading: nextGenEnrollmentFormItem.loading }),
            ...(nextGenEnrollmentFormItem.loaded && { loaded: nextGenEnrollmentFormItem.loaded }),
            ...(nextGenEnrollmentFormItem.userFormType && { userFormType: nextGenEnrollmentFormItem.userFormType }),
            ...(nextGenEnrollmentFormItem.selectedFormType && { selectedFormType: nextGenEnrollmentFormItem.selectedFormType })
        };
    }
    updateOrInsertEnrollmentFormItem(options) {
        const { ctx, enrollmentKey, patchedEnrollmentFormItem, enrollmentItem, formItem } = options;
        const { setState } = ctx;
        if (patchedEnrollmentFormItem) {
            setState(patch({
                enrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey, patch(patchedEnrollmentFormItem))
            }));
        }
        else if (enrollmentItem && formItem) {
            // Add enrollmentForm entry if there is not one already for the enrollmentKey
            const newItem = this.createEnrollmentFormItem(enrollmentItem, formItem);
            setState(patch({
                enrollmentForms: insertItem(newItem)
            }));
        }
    }
    updateOrInsertNextGenEnrollmentFormItem(options) {
        const { ctx, enrollmentKey, patchedEnrollmentFormItem, enrollmentItem } = options;
        const { setState } = ctx;
        if (patchedEnrollmentFormItem) {
            setState(patch({
                nextGenEnrollmentForms: updateItem(enrollmentForm => enrollmentForm.enrollmentKey === enrollmentKey, patch(patchedEnrollmentFormItem))
            }));
        }
        else if (enrollmentItem) {
            // Add enrollmentForm entry if there is not one already for the enrollmentKey
            const newItem = this.createNextGenEnrollmentFormItem(enrollmentItem);
            setState(patch({
                nextGenEnrollmentForms: insertItem(newItem)
            }));
        }
    }
};
EnrollmentState.ɵfac = function EnrollmentState_Factory(t) { return new (t || EnrollmentState)(i0.ɵɵinject(i1$2.HttpClient), i0.ɵɵinject(EnrollmentHttpService), i0.ɵɵinject(LocaleService), i0.ɵɵinject(i1.Store), i0.ɵɵinject(StringFormatUtilityService), i0.ɵɵinject(ExternalErrorLoggingService)); };
EnrollmentState.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: EnrollmentState, factory: EnrollmentState.ɵfac });
__decorate([
    Action(CompleteNextGenEnrollment)
], EnrollmentState.prototype, "completeNextGenEnrollment", null);
__decorate([
    Action(CompleteEnrollment)
], EnrollmentState.prototype, "completeEnrollment", null);
__decorate([
    Action(SetNextGenFormLoaded)
], EnrollmentState.prototype, "setNextGenFormLoaded", null);
__decorate([
    Action(SetNextGenFormLoading)
], EnrollmentState.prototype, "setNextGenFormLoading", null);
__decorate([
    Action(CreateNextGenTransaction)
], EnrollmentState.prototype, "createNextGenFormTransaction", null);
__decorate([
    Action(CreateTransaction)
], EnrollmentState.prototype, "createFormTransaction", null);
__decorate([
    Action(ClearTransaction)
], EnrollmentState.prototype, "clearTransaction", null);
__decorate([
    Action(UpdateTransaction)
], EnrollmentState.prototype, "updateFormTransaction", null);
__decorate([
    Action(UpdateNextGenTransaction)
], EnrollmentState.prototype, "updateNextGenFormTransaction", null);
__decorate([
    Action(FetchTransaction)
], EnrollmentState.prototype, "fetchTransaction", null);
__decorate([
    Action(FetchNextGenTransaction)
], EnrollmentState.prototype, "fetchNextGenTransaction", null);
__decorate([
    Action(FetchNextGenSepReasons)
], EnrollmentState.prototype, "fetchNextGenSepReasons", null);
__decorate([
    Action(SetFormLoading)
], EnrollmentState.prototype, "setFormLoading", null);
__decorate([
    Action(SetConfirmationDataLoading)
], EnrollmentState.prototype, "setConfirmationDataLoading", null);
__decorate([
    LiveEditInactive(),
    Action(SetFormPagesDirty)
], EnrollmentState.prototype, "setFormPagesDirty", null);
__decorate([
    LiveEditInactive(),
    Action(ClearFormPagesLoading)
], EnrollmentState.prototype, "clearFormPagesLoading", null);
__decorate([
    LiveEditInactive(),
    Action(FetchFormPageHtml)
], EnrollmentState.prototype, "fetchFormPageHtml", null);
__decorate([
    Action(SetPageVisited)
], EnrollmentState.prototype, "setPageVisited", null);
__decorate([
    Action(SetPageComplete)
], EnrollmentState.prototype, "setPageComplete", null);
__decorate([
    Action(SetPageSkipped)
], EnrollmentState.prototype, "setPageSkipped", null);
__decorate([
    Action(FetchFormPageInfo)
], EnrollmentState.prototype, "fetchFormPageInfo", null);
__decorate([
    Action(ResetEnrollmentState)
], EnrollmentState.prototype, "resetEnrollmentState", null);
__decorate([
    Action(ResetActiveEnrollmentKey)
], EnrollmentState.prototype, "resetActiveEnrollmentKey", null);
__decorate([
    Action(ResetCrossSellEnrollmentTypes)
], EnrollmentState.prototype, "resetCrossSellEnrollmentTypes", null);
__decorate([
    Action(SetActiveEnrollmentKey)
], EnrollmentState.prototype, "setActiveEnrollmentKey", null);
__decorate([
    Action(SetCurrentFormVersionId)
], EnrollmentState.prototype, "setCurrentFormVersionIdState", null);
__decorate([
    Action(SetPreviousFormVersionId)
], EnrollmentState.prototype, "setPreviousFormVersionIdState", null);
__decorate([
    Action(SetPCAPICustomPlanPremium)
], EnrollmentState.prototype, "setPCAPICustomPlanPremium", null);
__decorate([
    Action(SetCrossSellEnrollmentTypes)
], EnrollmentState.prototype, "setcrossSellEnrollmentTypes", null);
__decorate([
    Action(UpdateSelectedFormType)
], EnrollmentState.prototype, "updateSelectedFormType", null);
__decorate([
    Action(UpdateNextGenSelectedFormType)
], EnrollmentState.prototype, "updateNextGenSelectedFormType", null);
__decorate([
    Action(UpdateHopeSelectedFormType)
], EnrollmentState.prototype, "updateHopeSelectedFormType", null);
__decorate([
    Action(UpdateUserFormType)
], EnrollmentState.prototype, "updateUserFormType", null);
__decorate([
    Action(UpdateHopeUserFormType)
], EnrollmentState.prototype, "updateHopeUserFormType", null);
__decorate([
    Action(UpdateNextGenUserFormType)
], EnrollmentState.prototype, "updateNextGenUserFormType", null);
__decorate([
    Action(CreateHopeTransactions)
], EnrollmentState.prototype, "createHopeTransactions", null);
__decorate([
    Action(CreatePlanCompareApiTransaction)
], EnrollmentState.prototype, "createPlanCompareApiTransaction", null);
__decorate([
    Action(CreatePlanCompareApiNextGenTransaction)
], EnrollmentState.prototype, "createPlanCompareApiNextGenTransaction", null);
__decorate([
    Action(UpdateHRAParentInfo)
], EnrollmentState.prototype, "UpdateHRAParentInfo", null);
__decorate([
    Action(SetEnrollmentHistorySelectedPlan)
], EnrollmentState.prototype, "SetEnrollmentHistorySelectedPlan", null);
__decorate([
    Action(ClearEnrollmentHistorySelectedPlan)
], EnrollmentState.prototype, "ClearEnrollmentHistorySelectedPlan", null);
__decorate([
    Action(ClearHRAParentInfo)
], EnrollmentState.prototype, "ClearHRAParentPlan", null);
__decorate([
    Action(SetCallRecordingAvailable)
], EnrollmentState.prototype, "setCallRecordingAvailable", null);
__decorate([
    Action(ClearCallRecordingAvailable)
], EnrollmentState.prototype, "clearCallRecordingAvailable", null);
__decorate([
    Action(UpdateCMSApprovalCode)
], EnrollmentState.prototype, "updateCMSApprovalCode", null);
__decorate([
    Selector()
], EnrollmentState, "activeEnrollmentKey", null);
__decorate([
    Selector()
], EnrollmentState, "customPlanPremium", null);
__decorate([
    Selector()
], EnrollmentState, "callRecordingAvailable", null);
__decorate([
    Selector([EnrollmentState_1.callRecordingAvailable])
], EnrollmentState, "recordingAvailable", null);
__decorate([
    Selector()
], EnrollmentState, "crossSellEnrollmentTypes", null);
__decorate([
    Selector()
], EnrollmentState, "enrollmentForms", null);
__decorate([
    Selector()
], EnrollmentState, "nextGenEnrollmentForms", null);
__decorate([
    Selector()
], EnrollmentState, "hraPlan", null);
__decorate([
    Selector()
], EnrollmentState, "enrollmentHistorySelectedPlan", null);
__decorate([
    Selector([EnrollmentState_1.hraPlan])
], EnrollmentState, "hraPlanId", null);
__decorate([
    Selector()
], EnrollmentState, "hraParentEnrollmentConfirmationNumber", null);
__decorate([
    Selector()
], EnrollmentState, "enrollmentPlanCount", null);
__decorate([
    Selector()
], EnrollmentState, "getFormVersionIdState", null);
__decorate([
    Selector([EnrollmentState_1.getFormVersionIdState])
], EnrollmentState, "previousFormVersionId", null);
__decorate([
    Selector([EnrollmentState_1.getFormVersionIdState])
], EnrollmentState, "currentFormVersionId", null);
__decorate([
    Selector([EnrollmentState_1.previousFormVersionId, EnrollmentState_1.currentFormVersionId])
], EnrollmentState, "hasFormVersionIdChanged", null);
__decorate([
    Selector([EnrollmentState_1.activeEnrollmentKey, EnrollmentState_1.hraPlanId])
], EnrollmentState, "activePlanId", null);
EnrollmentState = EnrollmentState_1 = __decorate([
    State({
        name: 'enrollment',
        defaults: ENROLLMENT_DEFAULTS
    })
    /**
     * A store the holds all the demographics data related to shopping for plans.
     */
], EnrollmentState);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnrollmentState, [{
        type: Injectable
    }], function () { return [{ type: i1$2.HttpClient }, { type: EnrollmentHttpService }, { type: LocaleService }, { type: i1.Store }, { type: StringFormatUtilityService }, { type: ExternalErrorLoggingService }]; }, { completeNextGenEnrollment: [], completeEnrollment: [], setNextGenFormLoaded: [], setNextGenFormLoading: [], createNextGenFormTransaction: [], createFormTransaction: [], clearTransaction: [], updateFormTransaction: [], updateNextGenFormTransaction: [], fetchTransaction: [], fetchNextGenTransaction: [], fetchNextGenSepReasons: [], setFormLoading: [], setConfirmationDataLoading: [], setFormPagesDirty: [], clearFormPagesLoading: [], fetchFormPageHtml: [], setPageVisited: [], setPageComplete: [], setPageSkipped: [], fetchFormPageInfo: [], resetEnrollmentState: [], resetActiveEnrollmentKey: [], resetCrossSellEnrollmentTypes: [], setActiveEnrollmentKey: [], setCurrentFormVersionIdState: [], setPreviousFormVersionIdState: [], setPCAPICustomPlanPremium: [], setcrossSellEnrollmentTypes: [], updateSelectedFormType: [], updateNextGenSelectedFormType: [], updateHopeSelectedFormType: [], updateUserFormType: [], updateHopeUserFormType: [], updateNextGenUserFormType: [], createHopeTransactions: [], createPlanCompareApiTransaction: [], createPlanCompareApiNextGenTransaction: [], UpdateHRAParentInfo: [], SetEnrollmentHistorySelectedPlan: [], ClearEnrollmentHistorySelectedPlan: [], ClearHRAParentPlan: [], setCallRecordingAvailable: [], clearCallRecordingAvailable: [], updateCMSApprovalCode: [] }); })();

var DataLayerGlobalVariable;
(function (DataLayerGlobalVariable) {
    DataLayerGlobalVariable["ZIP"] = "data-Global-Zip";
    DataLayerGlobalVariable["COUNTY_FIPS"] = "data-Global-CountyFIPS";
    DataLayerGlobalVariable["MEMBER_ASSIST_CODE"] = "data-Global-MemberAssistCode";
    DataLayerGlobalVariable["MEMBER_ID"] = "data-Global-MemberID";
    DataLayerGlobalVariable["MEMBER_PREF_COVERAGE"] = "data-Global-MemberPref-Coverage";
    DataLayerGlobalVariable["MEMBER_PREF_SUBSIDY"] = "data-Global-MemberPref-Subsidy";
    DataLayerGlobalVariable["MEMBER_PREF_HEALTH"] = "data-Global-MemberPref-Health";
    DataLayerGlobalVariable["MEMBER_PREF_AGE"] = "data-Global-MemberPref-Age";
    DataLayerGlobalVariable["EXTERNAL_MEMBER_ID"] = "data-Global-ExternalMemberID";
    DataLayerGlobalVariable["EXTERNAL_REFERENCE_ID"] = "data-Global-ExternalReferenceID";
    DataLayerGlobalVariable["TRANSACTION_GUID"] = "data-Global-TransactionGUID";
    DataLayerGlobalVariable["AGENT_GUID"] = "data-Global-AgentGUID";
    DataLayerGlobalVariable["AGENT_IS_PROFILE_ADMIN"] = "data-Global-AgentIsProfileAdmin";
    DataLayerGlobalVariable["LANGUAGE_SELECTION"] = "data-LanguageSelection";
    DataLayerGlobalVariable["LANGUAGE_ID"] = "data-Global-LangID";
    DataLayerGlobalVariable["SITE_ID"] = "data-Global-SiteID";
    DataLayerGlobalVariable["SITE_URL"] = "data-Global-SiteURL";
    DataLayerGlobalVariable["SITE_CHANNEL"] = "data-Global-SiteChannel";
    DataLayerGlobalVariable["PAGE_VIEW_ID"] = "data-PageviewID";
    DataLayerGlobalVariable["BROWSER_SESSION_ID"] = "data-Global-BrowserSessionID";
    DataLayerGlobalVariable["SELECTED_PHARMACY"] = "data-Global-SelectedPharmacy";
    DataLayerGlobalVariable["SITE_HAS_GUIDED_HELP_INFO"] = "data-Global-SiteHasGuidedHelpInfo";
    DataLayerGlobalVariable["APP_SESSION_ID"] = "data-Global-AppSessionID";
    DataLayerGlobalVariable["USER_NAME"] = "data-Global-Username";
    DataLayerGlobalVariable["USER_ID_METHOD"] = "data-Global-UserIdMethod";
    DataLayerGlobalVariable["CLIENT_ID"] = "data-Global-ClientID";
    DataLayerGlobalVariable["CLIENT_GAID"] = "data-Global-ClientGAID";
    DataLayerGlobalVariable["PROVIDER_COUNT"] = "data-Global-ProviderCount";
    DataLayerGlobalVariable["PLANS_SORT_SELECTION"] = "data-PlansSortSelection";
    DataLayerGlobalVariable["PLANS_COST_MONTH"] = "data-PlansCostMonth";
    DataLayerGlobalVariable["PLANS_COST_BASED_ON"] = "data-Plans-CostsBasedOn";
    DataLayerGlobalVariable["RIDER_NAME"] = "data-RiderName";
    DataLayerGlobalVariable["RIDER_PLANID"] = "data-RiderPlanID";
    DataLayerGlobalVariable["RIDER_PLANTYPE"] = "data-RiderPlanType";
    DataLayerGlobalVariable["PAGE_TAB_NAME"] = "data-PageTabName";
    DataLayerGlobalVariable["PLANS_COUNT"] = "data-PlansCount";
    DataLayerGlobalVariable["PLAN_ID"] = "data-PlanID";
    DataLayerGlobalVariable["PLAN_CARRIER"] = "data-PlanCarrier";
    DataLayerGlobalVariable["PLAN_TYPE"] = "data-PlanType";
    DataLayerGlobalVariable["PLAN_TYPE_BEST_MATCH"] = "data-PlanType-BestMatch";
    DataLayerGlobalVariable["PLAN_ID_BEST_MATCH"] = "data-PlanID-BestMatch";
    DataLayerGlobalVariable["PLAN_TOTAL_ANNUAL_COST"] = "data-PlanTotalAnnualCost";
    DataLayerGlobalVariable["FORM_VERSION"] = "data-FormVersion";
    DataLayerGlobalVariable["ENROLLMENT_CONFIRMATION_NUMBER"] = "data-EnrollmentConfirmationNum";
    DataLayerGlobalVariable["ENROLLMENT_METHOD"] = "data-EnrollmentMethod";
    DataLayerGlobalVariable["PLAN_ID_CURRENT"] = "data-PlanIdCurrent";
    DataLayerGlobalVariable["PLAN_ID_NEXT_YEAR"] = "data-PlanIdNextYear";
    DataLayerGlobalVariable["PLAN_ID_NEXT_YEAR2"] = "data-PlanIdNextYearOption2";
    DataLayerGlobalVariable["PLAN_STATUS"] = "data-PlanStatus";
    DataLayerGlobalVariable["PLAN_ID_ENROLLED"] = "data-PlanID-Enrolled";
    DataLayerGlobalVariable["PLAN_PCP_ELIGIBILITY"] = "data-Plan-PcpEligibility";
    DataLayerGlobalVariable["HRA_FORM_LINK_AVAILABLE"] = "data-Plan-HRA-FormAvailable";
    DataLayerGlobalVariable["HRA_DAYS_POST_ENROLLMENT"] = "data-Plan-HRA-DaysPostEnrollment";
    DataLayerGlobalVariable["HRA_HOSTED_STATUS"] = "data-Plan-HRA-HostedStatus";
    DataLayerGlobalVariable["DRUG_NAME"] = "data-DrugName";
    DataLayerGlobalVariable["DRUG_IS_BRANDED_OR_GENERIC"] = "data-DrugIsBrandOrGeneric";
    DataLayerGlobalVariable["DRUG_CONDITION"] = "data-DrugCondition";
    DataLayerGlobalVariable["DRUG_COUNT"] = "data-Global-DrugCount";
    DataLayerGlobalVariable["PHARMACY_NABP"] = "data-PharmacyNABP";
    DataLayerGlobalVariable["VIEW_PAGE"] = "view-Page";
    DataLayerGlobalVariable["PAGE_PATH"] = "data-PagePath";
    DataLayerGlobalVariable["EVENT"] = "event";
    DataLayerGlobalVariable["EVENT_ID"] = "data-EventID";
    DataLayerGlobalVariable["VIEW_MODAL"] = "view-Modal";
    DataLayerGlobalVariable["MODAL_NAME"] = "data-ModalName";
    DataLayerGlobalVariable["MEDSUP_QUESTIONS"] = "RateFactorQuestionnaire-MedSup";
    DataLayerGlobalVariable["DENTAL_QUESTIONS"] = "RateFactorQuestionnaire-Dental";
    DataLayerGlobalVariable["VISION_QUESTIONS"] = "RateFactorQuestionnaire-Vision";
    DataLayerGlobalVariable["HC_QUESTIONS"] = "RateFactorQuestionnaire-HIP";
    DataLayerGlobalVariable["PROFILE_SEARCH_FIELDS"] = "data-ProfileSearchFields";
    DataLayerGlobalVariable["PROFILE_SEARCHBY_TRANSFER_CODE"] = "data-ProfileSearchByTransferCode";
    DataLayerGlobalVariable["AGENT_SEARCH_FIELDS"] = "data-AgentSearchFields";
    DataLayerGlobalVariable["PROVIDER_LOCATIONS"] = "ProviderLocations";
    DataLayerGlobalVariable["PROVIDER_LOCATIONS_STATUS"] = "data-ProviderLocationStatus";
    DataLayerGlobalVariable["QUOTE_ID"] = "data-QuoteID";
    DataLayerGlobalVariable["SEND_QUOTE_VIA"] = "data-SendQuoteVia";
    DataLayerGlobalVariable["SEND_APP_VIA"] = "data-SendAppVia";
    DataLayerGlobalVariable["APP_ID"] = "data-AppID";
    DataLayerGlobalVariable["SEND_APP_ID"] = "data-SendApp-ID";
    DataLayerGlobalVariable["SOA_ID"] = "data-SOA-ID";
    DataLayerGlobalVariable["BLUEBUTTON_RETURN_STATUS"] = "data-BlueButtonReturnStatus";
    DataLayerGlobalVariable["BLUEBUTTON_RETURN_DRUG_COUNT"] = "data-BlueButtonReturnDrugCount";
    DataLayerGlobalVariable["BLUEBUTTON_RETURN_LOADTIME"] = "data-BlueButtonReturnLoadTime";
    DataLayerGlobalVariable["HEADER_SWITCH_SITE_LABEL"] = "data-Header-SwitchSite-Label";
    DataLayerGlobalVariable["PROVIDER_SEARCH_FIELDS"] = "data-ProviderSearchFields";
    DataLayerGlobalVariable["PROVIDER_FILTER"] = "data-ProviderFilter";
    DataLayerGlobalVariable["OTHER_PREFERENCES_PAGE_NUMBER"] = "data-OtherPref-PgNum";
    DataLayerGlobalVariable["OTHER_PREFERENCES_QUESTION_CATEGORY_IDS"] = "data-OtherPref-QuestionCatIDs";
    DataLayerGlobalVariable["OTHER_PREFERENCES_RESPONDED_QUESTIONS"] = "data-OtherPref-RespondedQs";
    DataLayerGlobalVariable["TRAINING_MATERIAL_NAME"] = "data-TrainingMaterialName";
    DataLayerGlobalVariable["TRAINING_MATERIAL_URL"] = "data-TrainingMaterialUrl";
    DataLayerGlobalVariable["PROFILE_TASK_TYPE"] = "data-ProfileTaskType";
    DataLayerGlobalVariable["CALL_RECORDING_BEGIN_VIA"] = "data-CallRecording-BeginVia";
    DataLayerGlobalVariable["CALL_RECORDING_END_VIA"] = "data-CallRecording-EndVia";
    DataLayerGlobalVariable["CALL_RECORDING_TRACKING_ID"] = "data-CallRecording-TrackingID";
    DataLayerGlobalVariable["CALL_RECORDING_DURATION"] = "data-CallRecording-Duration";
    DataLayerGlobalVariable["REPORT_SEARCH_BEGIN_DATE"] = "data-Reports-Search-BeginDate";
    DataLayerGlobalVariable["REPORT_SEARCH_END_DATE"] = "data-Reports-Search-EndDate";
    DataLayerGlobalVariable["REPORT_SEARCH_TYPE"] = "data-Reports-Search-ReportType";
    DataLayerGlobalVariable["REPORT_SEARCH_ENROLLMENT_TYPE"] = "data-Reports-Search-EnrollmentType";
    DataLayerGlobalVariable["REPORT_SEARCH_FIELD_VALIDATION"] = "data-Reports-Search-FieldValidation";
    DataLayerGlobalVariable["REPORT_DOWNLOAD_COUNT"] = "data-reportDownloadCount";
    DataLayerGlobalVariable["PLANS_COUNT_NON_LICENSED"] = "data-PlansCount-NonLicensed";
    DataLayerGlobalVariable["PLAN_NON_LICENSED"] = "data-PlanNonLicensed";
    DataLayerGlobalVariable["REPORT_SEARCH_RESULT_COUNT"] = "data-Reports-SearchResultsCount";
    DataLayerGlobalVariable["REPORT_SEARCH_RESULT_LOAD_TIME"] = "data-Reports-SearchResultsLoadTime";
    DataLayerGlobalVariable["PLANS_COST_EFF_DATE_SELECTION"] = "PlansCostEffDateSelection";
    DataLayerGlobalVariable["REMOVED_PLAN_ID"] = "data-RemovedPlanID";
    DataLayerGlobalVariable["REMOVED_PLAN_TYPE"] = "data-RemovedPlanType";
    DataLayerGlobalVariable["CSNP_PLAN_COUNT"] = "data-PlansCount-cSNP";
    DataLayerGlobalVariable["DSNP_PLAN_COUNT"] = "data-PlansCount-dSNP";
    DataLayerGlobalVariable["ISNP_PLAN_COUNT"] = "data-PlansCount-iSNP";
    DataLayerGlobalVariable["DATA_PLAN_SUBTYPE_SELECTION"] = "data-PlanSubTypeSelection";
    DataLayerGlobalVariable["PHARMACY_FILTER_ADDED"] = "data-PharmacyFilterAdded";
    DataLayerGlobalVariable["PHARMACY_FILTER_REMOVED"] = "data-PharmacyFilterRemoved";
    DataLayerGlobalVariable["PLANTYPE_ADDON"] = "data-PlanTypeForAddOn";
    DataLayerGlobalVariable["PLAN_CARRIER_ADDON"] = "data-PlanCarrierForAddOn";
    DataLayerGlobalVariable["PLAN_ID_ADDON"] = "data-PlanIdForAddOn";
    DataLayerGlobalVariable["PHARMACY_SEARCH_FIELDS"] = "data-PharmacySearchFields";
    DataLayerGlobalVariable["CROSS_SELL_DISPLAYED"] = "data-CrossSellDisplayed";
    DataLayerGlobalVariable["CROSS_SELL_MEDSUP"] = "CrossSell-MedSup";
    DataLayerGlobalVariable["CROSS_SELL_PDP"] = "CrossSell-PDP";
    DataLayerGlobalVariable["CROSS_SELL_ENROLLMENT"] = "data-CrossSellEnrollment";
    DataLayerGlobalVariable["CROSS_SELL_CONTINUE_ENROLLMENT"] = "data-CrossSell-ContinueEnrollment";
    DataLayerGlobalVariable["PERSONALIZED_VIDEO_IS_PRESENT"] = "data-PersonalizedVideo-IsPresent";
    DataLayerGlobalVariable["HEALTH_COST_CALC_ISPRESENT"] = "data-HealthCostCalc-IsPresent";
    DataLayerGlobalVariable["MEMBER_PREF_HEALTH_COST_CALC"] = "data-Global-MemberPref-HealthCostCalc";
    DataLayerGlobalVariable["ENROLLMENT_PLAN_COUNT"] = "data-EnrollmentPlanCount";
    DataLayerGlobalVariable["ENROLLMENT_CONTINUE_BUTTON_PRESENT"] = "data-MultiPlan-Continue";
    DataLayerGlobalVariable["SITE_PLAN_YEAR"] = "data-Global-SitePlanYear";
    DataLayerGlobalVariable["PLAN_YEAR_MODAL_HAS_WARNING_MESSAGE"] = "data-PlanYearModal-HasWarningMsg";
    DataLayerGlobalVariable["PLAN_NAME"] = "data-PlanName";
    DataLayerGlobalVariable["PLAN_PREMIUM_MONTHLY"] = "data-PlanPremiumMonthly";
    DataLayerGlobalVariable["PROFILE_SEARCH_TRANSFER_CODE_ISPRESENT"] = "data-ProfileSearch-TransferCodeIsPresent";
    DataLayerGlobalVariable["PROFILE_PROGRESS_TRACKER_STATUS_NAMEPC"] = "data-ProfileProgressTracker-StatusNamePC";
    DataLayerGlobalVariable["PROFILE_PROGRESS_TRACKER_STATUS_NAMEUI"] = "data-ProfileProgressTracker-StatusNameUI";
    DataLayerGlobalVariable["PROFILE_PROGRESS_TRACKER_STATUS_TYPE"] = "data-ProfileProgressTracker-StatusType";
    DataLayerGlobalVariable["PROFILE_PROGRESS_TACKER_STATUS_DATE"] = "data-ProfileProgressTracker-StatusDate";
    DataLayerGlobalVariable["PROFILE_PROGRESS_TRACKER_ISPRESENT"] = "data-ProfileProgressTracker-IsPresent";
    DataLayerGlobalVariable["TALKING_POINTS_ISPRESENT"] = "data-TalkingPoints-IsPresent";
    DataLayerGlobalVariable["TALKING_POINTS_DEFAULT"] = "data-TalkingPoints-Default";
    DataLayerGlobalVariable["TALKING_POINTS_SELECTION"] = "data-TalkingPoints-Selection";
    DataLayerGlobalVariable["PLANS_COUNT_VBC"] = "data-PlansCount-VBC";
    DataLayerGlobalVariable["PLAN_PROVIDER_VBC_STATUS"] = "data-PlanProviderVBCstatus";
    DataLayerGlobalVariable["REMOVED_PLAN_PROVIDER_VBC_STATUS"] = "data-RemovedPlanProviderVBCstatus";
    DataLayerGlobalVariable["PROVIDER_SEARCH_OPTION_GENERAL_PRACTICE"] = "data-ProviderSearchOption-GeneralPractice";
    DataLayerGlobalVariable["PROVIDER_SEARCH_OPTION_VBC"] = "data-ProviderSearchOption-VBC";
    DataLayerGlobalVariable["PROVIDER_STATUS_PCP"] = "data-ProviderStatus-PCP";
    DataLayerGlobalVariable["PROVIDER_STATUS_NEW_PATIENT"] = "data-ProviderStatus-NewPatient";
    DataLayerGlobalVariable["VBC_ATTESTATION_IS_PRESENT"] = "data-VBCattestation-IsPresent";
    DataLayerGlobalVariable["VBC_ORG_NAME"] = "data-VBC-OrgName";
    DataLayerGlobalVariable["PROVIDER_FILTER_VBC_ORG_NAME"] = "data-ProviderFilter-VBCOrgName";
    DataLayerGlobalVariable["PROVIDER_VBC_ORG_NAME"] = "data-Provider-VBCOrgName";
    DataLayerGlobalVariable["PROVIDER_STATUS_VBC"] = "data-ProviderStatus-VBC";
    DataLayerGlobalVariable["ENROLLMENT_FORM_NAME"] = "data-EnrollmentFormName";
    DataLayerGlobalVariable["ENROLLMENT_FORM_TYPE"] = "data-EnrollmentFormType";
    DataLayerGlobalVariable["FIND_PROVIDER_LINK_TYPE"] = "data-FindProvider-LinkType";
    DataLayerGlobalVariable["PLAN_FILTERS_APPLIED"] = "data-Plans-FiltersApplied";
    DataLayerGlobalVariable["PLAN_FILTER_REMOVED"] = "data-Plans-FilterRemoved";
    DataLayerGlobalVariable["CURRENT_PLAN_TYPE"] = "data-Global-MemberPref-CurrentPlanType";
    DataLayerGlobalVariable["CURRENT_PLAN_ID"] = "data-Global-MemberPref-CurrentPlanID";
})(DataLayerGlobalVariable || (DataLayerGlobalVariable = {}));
var DataLayerEvent;
(function (DataLayerEvent) {
    DataLayerEvent["CLICK_ENROLLMENT_EDIT_STATE"] = "click-Enrollment-EditState";
    DataLayerEvent["CLICK_ENROLLMENT_EDIT_ZIP"] = "click-Enrollment-EditZip";
    DataLayerEvent["CLICK_ENROLLMENT_FIND_PROVIDER"] = "click-Enrollment-FindProvider";
    DataLayerEvent["CLICK_SNP_PLAN_DISPLAY_EVENT"] = "click-Plans-SNP-Display";
    DataLayerEvent["CLICK_SNP_PLAN_HIDE_EVENT"] = "click-Plans-SNP-Hide";
    DataLayerEvent["CLICK_SNP_PLAN_EXTRA_HELP_OPEN_MODAL_EVENT"] = "click-Plans-SNP-ExtraHelp-OpenModal";
    DataLayerEvent["CLICK_SNP_PLAN_EXTRA_HELP_APPLY_ONLINE_EVENT"] = "click-Plans-SNP-ExtraHelp-ApplyOnline";
    DataLayerEvent["CLICK_SNP_PLAN_EXTRA_HELP_PREFERENCES_EVENT"] = "click-Plans-SNP-ExtraHelp-Preferences";
    DataLayerEvent["CLICK_SNP_PLAN_EXTRA_HELP_CHECK_ELIGIBILITY_EVENT"] = "click-Plans-SNP-ExtraHelp-CheckEligibility";
    DataLayerEvent["CLICK_SNP_PLAN_EXTRA_HELP_TOOLTIP_EVENT"] = "click-Plans-SNP-ExtraHelp-ToolTip";
    DataLayerEvent["CLICK_PLANS_REMOVE_FROM_QUOTE"] = "click-Plans-RemoveFromQuote";
    DataLayerEvent["CLICK_PLAN_CHANGE_COST_EFF_DATE"] = "click-Plans-ChangeCostEffDate";
    DataLayerEvent["CLICK_HOME_ENTER_PREFERENCES"] = "click-Home-EnterPreferences";
    DataLayerEvent["CLICK_HOME_VIEW_PLANS"] = "click-Home-ViewPlans";
    DataLayerEvent["CLICK_HEADER_CHANGE_LANGUAGE"] = "click-Header-ChangeLanguage";
    DataLayerEvent["CLICK_HEADER_CONTACT_US"] = "click-Header-ContactUs";
    DataLayerEvent["CLICK_HEADER_LOGIN"] = "click-Header-Login";
    DataLayerEvent["CLICK_HEADER_CREATE_ACCOUNT"] = "click-Header-CreateAccount";
    DataLayerEvent["CASE_CREATE_ACCOUNT_SUCCESS"] = "case-CreateAccount-Success";
    DataLayerEvent["CLICK_HEADER_SWITCH_SITE"] = "click-Header-SwitchSite";
    DataLayerEvent["CLICK_HEADER_LOGIN_MEMBER_PORTAL"] = "click-Header-Login-MemberPortal";
    DataLayerEvent["CASE_LOGIN_SUCCESS"] = "case-Login-Success";
    DataLayerEvent["CASE_LOGOUT_SUCCESS"] = "case-Logout-Success";
    DataLayerEvent["CLICK_PLANS_ADDPREFERENCES"] = "click-Plans-AddPreferences";
    DataLayerEvent["CLICK_PLANS_SORT"] = "click-Plans-Sort";
    DataLayerEvent["CLICK_PLANS_GET_QUOTE"] = "click-Plans-GetQuote";
    DataLayerEvent["CLICK_PLANS_CART_ADD"] = "click-Plans-CartAdd";
    DataLayerEvent["CLICK_PLANS_VIEW_DETAILS"] = "click-Plans-ViewDetails";
    DataLayerEvent["CLICK_PLANS_VIEW_RIDER_DETAILS"] = "click-Plans-ViewRiderDetails";
    DataLayerEvent["CLICK_PLANS_COMPARE"] = "click-Plans-Compare";
    DataLayerEvent["CLICK_PLANS_ADD_OR_EDIT_DRUGS"] = "click-Plans-AddOrEditDrugs";
    DataLayerEvent["CLICK_PLANS_ADD_OR_EDIT_PHARMACY"] = "click-Plans-AddOrEditPharmacy";
    DataLayerEvent["CLICK_PLANS_EXPAND_COST_BREAKDOWN"] = "click-Plans-ExpandCostBreakdown";
    DataLayerEvent["CLICK_PLANS_VIEW_NON_LICENSED"] = "click-Plans-ViewNonLicensed";
    DataLayerEvent["CLICK_PLANS_SAVE_ON_DRUGS"] = "click-Plans-SaveOnDrugs";
    DataLayerEvent["CLICK_PLANS_DRUG_ALTERNATIVES_VIEW"] = "click-Plans-DrugAlternatives-View";
    DataLayerEvent["CLICK_PLANS_DRUG_ALTERNATIVES_CHANGE_CONDITION"] = "click-Plans-DrugAlternatives-ChangeCondition";
    DataLayerEvent["CLICK_PLANS_DRUG_ALTERNATIVES_CHANGE_CONDITION_CONFIRM"] = "click-Plans-DrugAlternatives-ChangeCondition-Confirm";
    DataLayerEvent["CLICK_PLANS_DRUG_ALTERNATIVES_PREVIOUS_PAGE"] = "click-Plans-DrugAlternatives-PreviousPage";
    DataLayerEvent["CLICK_CART_ADD_RIDER"] = "click-Cart-AddRider";
    DataLayerEvent["CLICK_CART_REMOVE_PLAN"] = "click-Cart-RemovePlan";
    DataLayerEvent["CLICK_CART_CHANGE_PLAN"] = "click-Cart-ChangePlan";
    DataLayerEvent["CLICK_CART_VIEW_PLANDETAILS"] = "click-Cart-ViewPlanDetails";
    DataLayerEvent["CLICK_CART_ENROLL"] = "click-Cart-Enroll";
    DataLayerEvent["CLICK_EXTERNAL_ENROLL_NOTIFICATION_OPEN"] = "click-External-Enroll-Notification-Open";
    DataLayerEvent["CLICK_EXTERNAL_ENROLL_NOTIFICATION_CONTINUE"] = "click-External-Enroll-Notification-Continue";
    DataLayerEvent["CLICK_EXTERNAL_ENROLL_NOTIFICATION_CANCEL"] = "click-External-Enroll-Notification-Cancel";
    DataLayerEvent["CLICK_MESSAGEONLY_ENROLL_NOTIFICATION_OPEN"] = "click-MessageOnly-Enroll-Notification-Open";
    DataLayerEvent["CLICK_MESSAGEONLY_ENROLL_NOTIFICATION_CLOSE"] = "click-MessageOnly-Enroll-Notification-Close";
    DataLayerEvent["CLICK_ENROLLMENT_SHOPFORSOMEONEELSE"] = "click-Enrollment-ShopForSomeoneElse";
    DataLayerEvent["CLICK_ENROLLMENT_EMAIL_CONFIRMATION"] = "click-Enrollment-EmailConfirmation";
    DataLayerEvent["CLICK_CART_VIEW_RIDERDETAILS"] = "click-Cart-ViewRiderDetails";
    DataLayerEvent["CLICK_ENROLLMENT_VIEW_APPLICATION"] = "click-Enrollment-ViewApplication";
    DataLayerEvent["CLICK_PREFERENCES_ADD_DRUG"] = "click-Preferences-AddDrug";
    DataLayerEvent["CLICK_PREFERENCES_CONTINUE"] = "click-Preferences-Continue";
    DataLayerEvent["CLICK_PREFERENCES_SKIP"] = "click-Preferences-Skip";
    DataLayerEvent["CLICK_PREFERENCES_GO_TO_PLANS"] = "click-Preferences-GoToPlans";
    DataLayerEvent["CLICK_PREFERENCES_PHARMACY_FILTER_ADD"] = "click-Preferences-PharmacyFilterAdd";
    DataLayerEvent["CLICK_PREFERENCES_PHARMACY_FILTER_REMOVE"] = "click-Preferences-PharmacyFilterRemove";
    DataLayerEvent["VIEW_PAGE"] = "view-Page";
    DataLayerEvent["VIEW_MODAL"] = "view-Modal";
    DataLayerEvent["CLICK_PLANS_KEEP_PLAN"] = "click-Plans-KeepPlan";
    DataLayerEvent["CLICK_HOME_CONTINUE_WITHOUT_PIN"] = "click-Home-ContinueWithoutPin";
    DataLayerEvent["CLICK_HOME_GET_STARTED"] = "click-Home-GetStarted";
    DataLayerEvent["CLICK_PLANS_EDIT_PREFERENCES"] = "click-Plans-EditPreferences";
    DataLayerEvent["CLICK_ENROLLMENT_FORM_SWITCH_TO_SHORT"] = "click-Enrollment-FormSwitchToShort";
    DataLayerEvent["CLICK_ENROLLMENT_FORM_SWITCH_TO_LONG"] = "click-Enrollment-FormSwitchToLong";
    DataLayerEvent["CLICK_SOA_EMAIL_FORM"] = "click-SOA-EmailForm";
    DataLayerEvent["CLICK_SOA_PRINT_FORM"] = "click-SOA-PrintForm";
    DataLayerEvent["CLICK_SOA_UPLOAD_FORM"] = "click-SOA-UploadForm";
    DataLayerEvent["CLICK_SOA_COMPLETE_FORM"] = "click-SOA-CompleteForm";
    DataLayerEvent["CLICK_SOA_SUBMIT_FORM"] = "click-SOA-SubmitForm";
    DataLayerEvent["CLICK_PROFILE_SEARCH"] = "click-ProfileSearch";
    DataLayerEvent["CLICK_PROFILE_ADD_NOTE"] = "click-ProfileAddNote";
    DataLayerEvent["CLICK_PROFILE_ADD_TASK"] = "click-ProfileAddTask";
    DataLayerEvent["CLICK_PROFILE_TASK_COMPLETE"] = "click-ProfileTaskComplete";
    DataLayerEvent["CLICK_AGENT_SEARCH"] = "click-AgentSearch";
    DataLayerEvent["CLICK_AGENT_PICTURE_UPLOAD"] = "click-AgentPictureUpload";
    DataLayerEvent["CLICK_PLANS_ADD_TO_QUOTE"] = "click-Plans-AddToQuote";
    DataLayerEvent["CLICK_PLANS_ADD_OR_EDIT_OTHER_PREFERENCES"] = "click-Plans-AddOrEditOtherPref";
    DataLayerEvent["CLICK_PLANS_SEND_QUOTE"] = "click-Plans-SendQuote";
    DataLayerEvent["CLICK_BPML_COPY_LINK"] = "click-BPML-CopyLink";
    DataLayerEvent["CLICK_BPML_COPY_LINK_DUAL_PLAN_YEAR"] = "click-BPML-CopyLink-DualPlanYear";
    DataLayerEvent["CLICK_ENROLLMENT_SEND_APP"] = "click-Enrollment-SendApp";
    DataLayerEvent["CLICK_SOA_TEXT_FORM"] = "click-SOA-TextForm";
    DataLayerEvent["CLICK_BLUEBUTTON_SENDEMAIL"] = "click-BlueButton-SendEmail";
    DataLayerEvent["CASE_BLUEBUTTON_RETURN"] = "case-BlueButton-Return";
    DataLayerEvent["CLICK_BLUEBUTTON_RETURN_CLOSE"] = "click-BlueButton-ReturnClose";
    DataLayerEvent["CLICK_BLUEBUTTON_REFRESH_START"] = "click-BlueButton-RefreshStart";
    DataLayerEvent["CASE_BLUEBUTTON_REFRESH_COMPLETE"] = "case-BlueButton-RefreshComplete";
    DataLayerEvent["CLICK_BLUEBUTTON_CONTINUE_TO_PRESCRIPTIONS"] = "click-BlueButton-ContinueToPrescriptions";
    DataLayerEvent["CLICK_BLUEBUTTON_MODAL_OPEN"] = "click-BlueButton-ModalOpen";
    DataLayerEvent["CLICK_BLUEBUTTON_MODAL_CANCEL"] = "click-BlueButton-ModalCancel";
    DataLayerEvent["CLICK_BLUEBUTTON_MODAL_CONFIRM_LEAVE"] = "click-BlueButton-ModalConfirmLeave";
    DataLayerEvent["CLICK_PREFERENCES_PROVIDER_SEARCH"] = "click-Preferences-ProviderSearch";
    DataLayerEvent["CLICK_PREFERENCES_PROVIDER_FILTER_VIEW"] = "click-Preferences-ProviderFilterView";
    DataLayerEvent["CLICK_PREFERENCES_PROVIDER_ADD"] = "click-Preferences-ProviderAdd";
    DataLayerEvent["CLICK_PREFERENCES_PROVIDER_REMOVE"] = "click-Preferences-ProviderRemove";
    DataLayerEvent["CLICK_PREFERENCES_PROVIDER_SET_AS_PRIMARY"] = "click-Preferences-ProviderSetAsPrimary";
    DataLayerEvent["CLICK_PLANS_ADD_OR_EDIT_PROVIDER"] = "click-Plans-AddOrEditProviders";
    DataLayerEvent["CLICK_PLANS_ADD_OR_EDIT_PRESCRIPTION"] = "click-Plans-AddOrEditPrescription";
    DataLayerEvent["CLICK_PREFERENCES_PROVIDER_FILTER_ADD"] = "click-Preferences-ProviderFilterAdd";
    DataLayerEvent["CLICK_PREFERENCES_PROVIDER_FILTER_REMOVE"] = "click-Preferences-ProviderFilterRemove";
    DataLayerEvent["CLICK_PREFERENCES_PHARMACY_SEARCH"] = "click-Preferences-PharmacySearch";
    DataLayerEvent["CLICK_PREFERENCES_PHARMACY_ADD"] = "click-Preferences-PharmacyAdd";
    DataLayerEvent["CLICK_PREFERENCES_PHARMACY_REMOVE"] = "click-Preferences-PharmacyRemove";
    DataLayerEvent["CLICK_PREFERENCES_PHARMACY_SWITCH_PRIMARY"] = "click-Preferences-PharmacySwitchPrimary";
    DataLayerEvent["CLICK_TRAINING_MATERIAL_LINK"] = "click-TrainingMaterialsLink";
    DataLayerEvent["CLICK_HRA_ENTER_FORM"] = "click-HRA-EnterForm";
    DataLayerEvent["CLICK_CALL_RECORDING_MODAL_OPEN"] = "click-CallRecording-ModalOpen";
    DataLayerEvent["CLICK_CALL_RECORDING_MODAL_CANCEL"] = "click-CallRecording-ModalCancel";
    DataLayerEvent["CLICK_CALL_RECORDING_INVITE_VIA_TEXT"] = "click-CallRecording-InviteViaText";
    DataLayerEvent["CLICK_CALL_RECORDING_INVITE_VIA_EMAIL"] = "click-CallRecording-InviteViaEmail";
    DataLayerEvent["CLICK_CALL_RECORDING_INVITE_VIA_CALL"] = "click-CallRecording-InviteViaCall";
    DataLayerEvent["CLICK_CALL_RECORDING_SKIP_RECORDING"] = "click-CallRecording-SkipRecording";
    DataLayerEvent["CLICK_CALL_RECORDING_CONTINUE_APPLYING"] = "click-CallRecording-ContinueApplying";
    DataLayerEvent["CASE_CALL_RECORDING_CALL_BEGIN"] = "case-CallRecording-CallBegin";
    DataLayerEvent["CASE_CALL_RECORDING_CALL_END"] = "case-CallRecording-CallEnd";
    DataLayerEvent["CLICK_CALL_RECORDING_PLAYBACK"] = "click-CallRecording-PlayBack";
    DataLayerEvent["CLICK_REPORT_SEARCH"] = "click-Reports-Search";
    DataLayerEvent["CLICK_REPORT_DOWNLOAD"] = "click-Reports-DownloadResults";
    DataLayerEvent["CASE_REPORT_SEARCH_RESULT_RETURN"] = "case-Reports-SearchResultsReturned";
    DataLayerEvent["CLICK_PLAN_RATE_FACTOR_QUESTIONNAIRE_COMPLETE"] = "click-Plans-RateFactorQuestionnaire-Complete";
    DataLayerEvent["CLICK_HEADER_CREATE_ACCOUNT_FROM_NUDGE"] = "click-Header-CreateAccountFromNudge";
    DataLayerEvent["CLICK_ACCOUNT_CONTINUE_ENROLLMENT"] = "click-Account-ContinueEnrollment";
    DataLayerEvent["CLICK_ACCOUNT_VIEW_PLANS"] = "click-Account-ViewPlans";
    DataLayerEvent["CLICK_ENROLLMENT_SAVE_AND_EXIT"] = "click-Enrollment-SaveAndExit";
    DataLayerEvent["CLICK_PLANS_COSTS_BASED_ON"] = "click-Plans-CostsBasedOn";
    DataLayerEvent["CLICK_PLANS_RECALCULATE_RATES_MEDSUP"] = "click-Plans-RecalculateRates-MedSup";
    DataLayerEvent["CLICK_PLANS_ADDONCOVERAGE"] = "click-Plans-AddOnCoverage";
    DataLayerEvent["CLICK_PLANS_SELECT_HEALTH_PLAN_ADDON_COVERAGE"] = "click-Plans-SelectHealthPlanForAddOnCoverage";
    DataLayerEvent["CLICK_HEADER_FORGOT_USERNAME"] = "click-Header-ForgotUsername";
    DataLayerEvent["CLICK_HEADER_FORGOT_PASSWORD"] = "click-Header-ForgotPassword";
    DataLayerEvent["CLICK_MODAL_CROSS_SELL_SHOP_PLANS"] = "click-Cart-CrossSell-ShopPlans";
    DataLayerEvent["CLICK_MODAL_CROSS_SELL_GO_TO_CART"] = "click-Modal-CrossSell-GoToCart";
    DataLayerEvent["CLICK_MODAL_CROSS_SELL_CLOSE"] = "click-Modal-CrossSell-Close";
    DataLayerEvent["CLICK_ENROLLMENT_CROSS_SELL_CONTINUE_APPLYING"] = "click-Enrollment-CrossSell-ContinueApplying";
    DataLayerEvent["CLICK_PREF_HEALTHCOST_CALC_OPEN"] = "click-Preferences-HealthCostCalc-Open";
    DataLayerEvent["CLICK_PREF_HEALTHCOST_CALC_EDIT"] = "click-Preferences-HealthCostCalc-Edit";
    DataLayerEvent["CLICK_PREF_HEALTHCOST_CALC_SAVE"] = "click-Preferences-HealthCostCalc-Save";
    DataLayerEvent["CLICK_PREF_HEALTHCOST_CALC_RESTORE_DEFAULT"] = "click-Preferences-HealthCostCalc-RestoreDefault";
    DataLayerEvent["CLICK_PLANS_ADD_OR_EDIT_HEALTH"] = "click-Plans-AddOrEditHealth";
    DataLayerEvent["CLICK_SOA_INPERSON_START"] = "click-SOA-InPerson-Start";
    DataLayerEvent["CLICK_SOA_INPERSON_CONTINUE"] = "click-SOA-InPerson-Continue";
    DataLayerEvent["CLICK_SOA_SUBMIT_FORM_BY_AGENT"] = "click-SOA-SubmitFormByAgent";
    DataLayerEvent["CLICK_PERSONALIZED_VIDEO_CONTACT_US"] = "click-PersonalizedVideo-ContactUs";
    DataLayerEvent["CLICK_PERSONALIZED_VIDEO_HOME_ENTER_PREFERENCES"] = "click-PersonalizedVideo-Home-EnterPreferences";
    DataLayerEvent["CLICK_PERSONALIZED_VIDEO_PLANS_CART_ADD"] = "click-PersonalizedVideo-Plans-CartAdd";
    DataLayerEvent["CLICK_PERSONALIZED_VIDEO_PLANS_VIEW_DETAILS"] = "click-PersonalizedVideo-Plans-ViewDetails";
    DataLayerEvent["CLICK_PERSONALIZED_VIDEO_PLANS_ADD_PREFERENCES"] = "click-PersonalizedVideo-Plans-AddPreferences";
    DataLayerEvent["CLICK_CALL_RECORDING_END_CALL_MODAL_OPEN"] = "click-CallRecording-EndCallModalOpen";
    DataLayerEvent["CLICK_CALL_RECORDING_END_CALL_MODAL_CANCEL"] = "click-CallRecording-EndCallModalCancel";
    DataLayerEvent["CLICK_CALL_RECORDING_END_CALL_MODAL_DIFFERENT_SESSION"] = "click-CallRecording-EndCallDifferentSession";
    DataLayerEvent["CLICK_CALL_RECORDING_DOWNLOAD_RECORDING"] = "click-CallRecording-DownloadRecording";
    DataLayerEvent["CLICK_PLAN_YEAR_MODAL_OPEN"] = "click-PlanYear-ModalOpen";
    DataLayerEvent["CLICK_PLAN_YEAR_MODAL_CONTINUE"] = "click-PlanYear-ModalContinue";
    DataLayerEvent["CLICK_PROFILE_AGENT_REASSIGN_OPEN_MODAL"] = "click-Profile-AgentReassign-OpenModal";
    DataLayerEvent["CLICK_PROFILE_AGENT_REASSIGN_ASSIGN_TO_ME"] = "click-Profile-AgentReassign-AssignToMe";
    DataLayerEvent["CLICK_PROFILE_AGENT_REASSIGN_SEARCH_PROFILES"] = "click-Profile-AgentReassign-SearchProfiles";
    DataLayerEvent["CLICK_PROFILE_AGENT_REASSIGN_SEARCH_AGAIN"] = "click-Profile-AgentReassign-SearchAgain";
    DataLayerEvent["CLICK_PROFILE_AGENT_REASSIGN_CONTINUE"] = "click-Profile-AgentReassign-Continue";
    DataLayerEvent["CLICK_PROFILE_PROGRESS_TRACKER"] = "click-ProfileProgressTracker";
    DataLayerEvent["CLICK_PROFILE_PURL_PLUS_COPY_LINK"] = "click-Profile-PurlPlus-CopyLink";
    DataLayerEvent["CLICK_TALKING_POINTS"] = "click-TalkingPoints";
    DataLayerEvent["CLICK_VBC_ATTESTATION_SEND_INFO"] = "click-VBCattestation-SendInfo";
    DataLayerEvent["CLICK_VBC_ATTESTATION_SCHEDULE_APPT"] = "click-VBCattestation-ScheduleAppt";
    DataLayerEvent["CLICK_VBC_ATTESTATION_TAKE_TOUR"] = "click-VBCattestation-TakeTour";
    DataLayerEvent["CLICK_PLANS_FILTERS_MODAL_OPEN"] = "click-Plans-Filters-ModalOpen";
    DataLayerEvent["CLICK_PLANS_FILTERS_APPLY"] = "click-Plans-Filters-Apply";
    DataLayerEvent["CLICK_PLANS_FILTERS_MODAL_CLEAR_ALL"] = "click-Plans-Filters-ModalClearAll";
    DataLayerEvent["CLICK_PLANS_FILTERS_MODAL_CANCEL"] = "click-Plans-Filters-ModalCancel";
    DataLayerEvent["CLICK_PLANS_FILTERS_REMOVE"] = "click-Plans-Filters-Remove";
    DataLayerEvent["CLICK_AGENT_BOOK_REASSIGN_OPEN_MODAL"] = "click-Agent-BookReassign-OpenModal";
    DataLayerEvent["CLICK_AGENT_BOOK_REASSIGN_SEARCH_PROFILES"] = "click-Agent-BookReassign-SearchProfiles";
    DataLayerEvent["CLICK_AGENT_BOOK_REASSIGN_SEARCH_AGAIN"] = "click-Agent-BookReassign-SearchAgain";
    DataLayerEvent["CLICK_AGENT_BOOK_REASSIGN_SEARCH_CONTINUE"] = "click-Agent-BookReassign-Continue";
    DataLayerEvent["CLICK_AGENT_BOOK_REASSIGN_SEARCH_ASSIGN_TO_ME"] = "click-Agent-BookReassign-AssignToMe";
    DataLayerEvent["CLICK_PREFERENCES_CURRENT_PLAN_OPEN"] = "click-Preferences-CurrentPlan-Open";
    DataLayerEvent["CLICK_PREFERENCES_CURRENT_PLAN_CANCEL"] = "click-Preferences-CurrentPlan-Cancel";
    DataLayerEvent["CLICK_PREFERENCES_CURRENT_PLAN_UPDATE"] = "click-Preferences-CurrentPlan-Update";
    DataLayerEvent["CLICK_PREFERENCES_PROVIDERS_OPEN"] = "click-Preferences-Providers-Open";
    DataLayerEvent["CLICK_PREFERENCES_PHARMACIES_OPEN"] = "click-Preferences-Pharmacies-Open";
    DataLayerEvent["CLICK_PREFERENCES_PRESCRIPTIONS_OPEN"] = "click-Preferences-Prescriptions-Open";
    DataLayerEvent["CLICK_PREFERENCES_ELIGIBILITY_OPEN"] = "click-Preferences-Eligibility-Open";
    DataLayerEvent["CLICK_PREFERENCES_HEALTH_OPEN"] = "click-Preferences-Health-Open";
    DataLayerEvent["CLICK_PREFERENCES_SUPP_BENEFITS_OPEN"] = "click-Preferences-SuppBenefits-Open";
    DataLayerEvent["CLICK_PREFERENCES_BLUE_BUTTON_OPEN"] = "click-Preferences-BlueButton-Open";
})(DataLayerEvent || (DataLayerEvent = {}));
const CLICK_EVENT_PREFIX = 'click-';
const CASE_EVENT_PREFIX = 'case-';
const NON_VIEW_PAGE_EVENT_PREFIXES = [CLICK_EVENT_PREFIX, CASE_EVENT_PREFIX, DataLayerEvent.VIEW_MODAL];
var UTMParameter;
(function (UTMParameter) {
    UTMParameter["UTM_SOURCE"] = "utm_source";
    UTMParameter["UTM_MEDIUM"] = "utm_medium";
    UTMParameter["UTM_CAMPAIGN"] = "utm_campaign";
    UTMParameter["UTM_CONTENT"] = "utm_content";
})(UTMParameter || (UTMParameter = {}));
const UTM_PARAMETER_KEYS = Object.values(UTMParameter);
var UTMValue;
(function (UTMValue) {
    UTMValue["UTM_CAMPAIGN_SOA"] = "soa";
    UTMValue["UTM_CAMPAIGN_QUICK_QUOTE"] = "qq";
    UTMValue["UTM_CAMPAIGN_APPLICATION"] = "app";
    UTMValue["UTM_CAMPAIGN_SOA_DONE"] = "soa-done";
    UTMValue["UTM_CAMPAIGN_APPLICATION_DONE"] = "app-done";
    UTMValue["UTM_CAMPAIGN_BLUEBUTTON_DONE"] = "bb-done";
    UTMValue["UTM_CAMPAIGN_PURL"] = "bpml";
    UTMValue["UTM_SOURCE_PLAN_COMPARE"] = "pc1";
    UTMValue["UTM_MEDIUM_EMAIL"] = "email";
    UTMValue["UTM_MEDIUM_SMS"] = "sms";
})(UTMValue || (UTMValue = {}));
var SendAppVia;
(function (SendAppVia) {
    SendAppVia["EMAIL"] = "Email";
    SendAppVia["TEXT"] = "Text";
    SendAppVia["DELIMITER"] = "|";
})(SendAppVia || (SendAppVia = {}));
var AnalyticsActionType;
(function (AnalyticsActionType) {
    AnalyticsActionType["PAGELOAD"] = "pageload";
    AnalyticsActionType["FILTER"] = "filter";
    AnalyticsActionType["SORT"] = "sort";
})(AnalyticsActionType || (AnalyticsActionType = {}));
class FiltersInfo {
}
var SendQuoteVia;
(function (SendQuoteVia) {
    SendQuoteVia["EMAIL"] = "Email";
    SendQuoteVia["TEXT"] = "Text";
    SendQuoteVia["DELIMITER"] = "|";
})(SendQuoteVia || (SendQuoteVia = {}));
const GOOGLE_ANALYTICS_NOT_APPLICABLE = 'n/a';
const GOOGLE_ANALYTICS_NONE = 'none';
const OUTSIDE_LICENSED_AREA = 'OutsideLicensedArea';
const NO_PLANS_COUNT = '0';
const NO_DRUGS_COUNT = '0';
const GOOGLE_ANALYTICS_YES = 'Yes';
const GOOGLE_ANALYTICS_NO = 'No';
const FILTER_ABBREVIATION_DELIMITER = '|';
const ENROLLMENT_ON_BEHALF_OF_BENEFICIARY = 'OnBehalfOfBeneficiary';
const ENROLLMENT_SEND_TO_BENEFICIARY = 'SendToBeneficiary';
const BRAND_SWAPPED_TO_GENERIC = 'brandSwappedToGeneric';
const VBC_ORG = 'VBC Org';

class SetGoogleDataLayerTag {
    constructor(googleDataLayerTag) {
        this.googleDataLayerTag = googleDataLayerTag;
    }
}
SetGoogleDataLayerTag.type = '[GoogleDataLayerTag] Set Google Data Layer Tag';

const tags$1 = {
    [DataLayerGlobalVariable.SITE_URL]: null,
    [DataLayerGlobalVariable.SITE_ID]: null,
    [DataLayerGlobalVariable.SITE_CHANNEL]: null,
    [DataLayerGlobalVariable.AGENT_GUID]: null,
    [DataLayerGlobalVariable.AGENT_IS_PROFILE_ADMIN]: null,
    [DataLayerGlobalVariable.COUNTY_FIPS]: null,
    [DataLayerGlobalVariable.LANGUAGE_ID]: null,
    [DataLayerGlobalVariable.MEMBER_ID]: null,
    [DataLayerGlobalVariable.EXTERNAL_MEMBER_ID]: GOOGLE_ANALYTICS_NOT_APPLICABLE,
    [DataLayerGlobalVariable.EXTERNAL_REFERENCE_ID]: GOOGLE_ANALYTICS_NOT_APPLICABLE,
    [DataLayerGlobalVariable.SELECTED_PHARMACY]: null,
    [DataLayerGlobalVariable.SITE_HAS_GUIDED_HELP_INFO]: null,
    [DataLayerGlobalVariable.TRANSACTION_GUID]: null,
    [DataLayerGlobalVariable.ZIP]: null,
    [DataLayerGlobalVariable.EVENT]: null,
    [DataLayerGlobalVariable.RIDER_NAME]: null,
    [DataLayerGlobalVariable.RIDER_PLANID]: null,
    [DataLayerGlobalVariable.RIDER_PLANTYPE]: null,
    [DataLayerGlobalVariable.APP_SESSION_ID]: null,
    [DataLayerGlobalVariable.USER_NAME]: null,
    [DataLayerGlobalVariable.USER_ID_METHOD]: null,
    [DataLayerGlobalVariable.CLIENT_ID]: null,
    [DataLayerGlobalVariable.CLIENT_GAID]: null,
    [DataLayerGlobalVariable.APP_ID]: null,
    [DataLayerGlobalVariable.PROVIDER_COUNT]: null,
    [DataLayerGlobalVariable.DRUG_COUNT]: NO_DRUGS_COUNT,
    [DataLayerGlobalVariable.MEMBER_PREF_COVERAGE]: null,
    [DataLayerGlobalVariable.MEMBER_PREF_SUBSIDY]: null,
    [DataLayerGlobalVariable.MEMBER_PREF_HEALTH]: null,
    [DataLayerGlobalVariable.MEMBER_PREF_AGE]: null,
    [DataLayerGlobalVariable.PLANS_COST_BASED_ON]: null,
    [DataLayerGlobalVariable.MEMBER_ASSIST_CODE]: GOOGLE_ANALYTICS_NOT_APPLICABLE,
    [DataLayerGlobalVariable.MEMBER_PREF_HEALTH_COST_CALC]: GOOGLE_ANALYTICS_NO,
    [DataLayerGlobalVariable.SITE_PLAN_YEAR]: null
};
let GoogleTagManagerState = class GoogleTagManagerState {
    constructor() {
        this.dataTags = {
            [DataLayerGlobalVariable.SITE_URL]: null,
            [DataLayerGlobalVariable.SITE_ID]: null,
            [DataLayerGlobalVariable.SITE_CHANNEL]: null,
            [DataLayerGlobalVariable.AGENT_GUID]: null,
            [DataLayerGlobalVariable.AGENT_IS_PROFILE_ADMIN]: null,
            [DataLayerGlobalVariable.COUNTY_FIPS]: null,
            [DataLayerGlobalVariable.LANGUAGE_ID]: null,
            [DataLayerGlobalVariable.MEMBER_ID]: null,
            [DataLayerGlobalVariable.EXTERNAL_MEMBER_ID]: GOOGLE_ANALYTICS_NOT_APPLICABLE,
            [DataLayerGlobalVariable.EXTERNAL_REFERENCE_ID]: GOOGLE_ANALYTICS_NOT_APPLICABLE,
            [DataLayerGlobalVariable.SELECTED_PHARMACY]: null,
            [DataLayerGlobalVariable.SITE_HAS_GUIDED_HELP_INFO]: null,
            [DataLayerGlobalVariable.TRANSACTION_GUID]: null,
            [DataLayerGlobalVariable.ZIP]: null,
            [DataLayerGlobalVariable.EVENT]: null,
            [DataLayerGlobalVariable.RIDER_NAME]: null,
            [DataLayerGlobalVariable.RIDER_PLANID]: null,
            [DataLayerGlobalVariable.RIDER_PLANTYPE]: null,
            [DataLayerGlobalVariable.APP_SESSION_ID]: null,
            [DataLayerGlobalVariable.USER_NAME]: null,
            [DataLayerGlobalVariable.USER_ID_METHOD]: null,
            [DataLayerGlobalVariable.CLIENT_ID]: null,
            [DataLayerGlobalVariable.CLIENT_GAID]: null,
            [DataLayerGlobalVariable.APP_ID]: null,
            [DataLayerGlobalVariable.PROVIDER_COUNT]: null,
            [DataLayerGlobalVariable.DRUG_COUNT]: NO_DRUGS_COUNT,
            [DataLayerGlobalVariable.MEMBER_PREF_COVERAGE]: null,
            [DataLayerGlobalVariable.MEMBER_PREF_SUBSIDY]: null,
            [DataLayerGlobalVariable.MEMBER_PREF_HEALTH]: null,
            [DataLayerGlobalVariable.MEMBER_PREF_AGE]: null,
            [DataLayerGlobalVariable.PLANS_COST_BASED_ON]: null,
            [DataLayerGlobalVariable.MEMBER_ASSIST_CODE]: GOOGLE_ANALYTICS_NOT_APPLICABLE,
            [DataLayerGlobalVariable.MEMBER_PREF_HEALTH_COST_CALC]: GOOGLE_ANALYTICS_NO,
            [DataLayerGlobalVariable.SITE_PLAN_YEAR]: null
        };
    }
    static googleDataLayerTag(state) {
        if (state) {
            return state;
        }
        return null;
    }
    setGoogleDataLayerTag(ctx, { googleDataLayerTag }) {
        ctx.patchState({
            ...googleDataLayerTag
        });
    }
};
GoogleTagManagerState.ɵfac = function GoogleTagManagerState_Factory(t) { return new (t || GoogleTagManagerState)(); };
GoogleTagManagerState.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: GoogleTagManagerState, factory: GoogleTagManagerState.ɵfac });
__decorate([
    Action(SetGoogleDataLayerTag)
], GoogleTagManagerState.prototype, "setGoogleDataLayerTag", null);
__decorate([
    Selector()
], GoogleTagManagerState, "googleDataLayerTag", null);
GoogleTagManagerState = __decorate([
    State({
        name: 'googleDataLayerTag',
        defaults: tags$1
    })
], GoogleTagManagerState);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GoogleTagManagerState, [{
        type: Injectable
    }], function () { return []; }, { setGoogleDataLayerTag: [] }); })();

class SetCoverageType {
    constructor(coverageType) {
        this.coverageType = coverageType;
    }
}
SetCoverageType.type = '[GuidedHelp] Set Coverage Type';
class RemoveCoverageType {
}
RemoveCoverageType.type = '[GuidedHelp] Remove Coverage Type';
class SetVisited {
}
SetVisited.type = '[GuidedHelp] Set Visited';
class ResetGuidedHelpState {
}
ResetGuidedHelpState.type = '[GuidedHelp] Reset';
class SetHealthCostEstimate {
    constructor(isSelected) {
        this.isSelected = isSelected;
    }
}
SetHealthCostEstimate.type = '[Health] Set Health Estimated Status';
class SetGuidedHelpDirty {
    constructor(dirty) {
        this.dirty = dirty;
    }
}
SetGuidedHelpDirty.type = '[GuidedHelp] Set Guided Help Dirty';

class GuidedHelpStateModel {
}
const GUIDED_HELP_DEFAULTS = {
    selectedCoverageType: null,
    visited: false,
    dirty: false,
    isHealthCostEstimated: null
};
let GuidedHelpState = class GuidedHelpState {
    static selectedCoverageType(state) {
        return state.selectedCoverageType;
    }
    static hasVisited(state) {
        return state.visited;
    }
    static isHealthCostEstimated(state) {
        return state.isHealthCostEstimated;
    }
    static isDirty(state) {
        return state.dirty;
    }
    setCoverageType({ setState }, { coverageType }) {
        setState(patch({
            selectedCoverageType: coverageType
        }));
    }
    removeCoverageType({ patchState }) {
        patchState({
            selectedCoverageType: null
        });
    }
    resetGuidedHelpState(ctx) {
        const { setState } = ctx;
        setState(GUIDED_HELP_DEFAULTS);
    }
    setVisited({ patchState }) {
        patchState({
            visited: true
        });
    }
    setHasHealthCostEstimated(ctx, { isSelected }) {
        ctx.setState(patch({ isHealthCostEstimated: isSelected }));
    }
    setGuidedHelpDirty({ patchState }, { dirty }) {
        patchState({
            dirty
        });
    }
};
GuidedHelpState.ɵfac = function GuidedHelpState_Factory(t) { return new (t || GuidedHelpState)(); };
GuidedHelpState.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: GuidedHelpState, factory: GuidedHelpState.ɵfac });
__decorate([
    Action(SetCoverageType)
], GuidedHelpState.prototype, "setCoverageType", null);
__decorate([
    Action(RemoveCoverageType)
], GuidedHelpState.prototype, "removeCoverageType", null);
__decorate([
    Action(ResetGuidedHelpState)
], GuidedHelpState.prototype, "resetGuidedHelpState", null);
__decorate([
    Action(SetVisited)
], GuidedHelpState.prototype, "setVisited", null);
__decorate([
    Action(SetHealthCostEstimate)
], GuidedHelpState.prototype, "setHasHealthCostEstimated", null);
__decorate([
    Action(SetGuidedHelpDirty)
], GuidedHelpState.prototype, "setGuidedHelpDirty", null);
__decorate([
    Selector()
], GuidedHelpState, "selectedCoverageType", null);
__decorate([
    Selector()
], GuidedHelpState, "hasVisited", null);
__decorate([
    Selector()
], GuidedHelpState, "isHealthCostEstimated", null);
__decorate([
    Selector()
], GuidedHelpState, "isDirty", null);
GuidedHelpState = __decorate([
    State({
        name: 'guidedHelp',
        defaults: GUIDED_HELP_DEFAULTS
    })
], GuidedHelpState);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GuidedHelpState, [{
        type: Injectable
    }], null, { setCoverageType: [], removeCoverageType: [], resetGuidedHelpState: [], setVisited: [], setHasHealthCostEstimated: [], setGuidedHelpDirty: [] }); })();

var HelpfulToolsTabs;
(function (HelpfulToolsTabs) {
    HelpfulToolsTabs["Prescriptions"] = "Prescriptions";
    HelpfulToolsTabs["Pharmacy"] = "Pharmacy";
    HelpfulToolsTabs["Providers"] = "Providers";
})(HelpfulToolsTabs || (HelpfulToolsTabs = {}));
class HelpfulToolsData {
}
class HelpfulToolsSearchTab {
}

class HelpfulToolsStateModel {
}
const HELPFUL_TOOLS_STORE_NAME = 'helpfulTools';
const HELPFUL_TOOLS_DEFAULTS = {
    zip: '',
    fips: '',
    counties: [],
    countyZipSelection: '',
    isPlansFetched: false,
    plan: null,
    tab: HelpfulToolsTabs.Prescriptions
};
let HelpfulToolsState = class HelpfulToolsState {
    constructor(demographicsService) {
        this.demographicsService = demographicsService;
    }
    static selectedZipCode(state) {
        return state.zip;
    }
    static selectedFipsCode(state) {
        return state.fips;
    }
    static selectedPlan(state) {
        return state.plan;
    }
    static countyZipSelection(state) {
        return state.countyZipSelection;
    }
    static selectedTab(state) {
        return state.tab;
    }
    static counties(state) {
        return state.counties;
    }
    static isPlansFetched(state) {
        return state.isPlansFetched;
    }
    // Add / update zip
    setZipCode(ctx, { zip }) {
        ctx.setState(patch({ zip }));
    }
    // Add / update fips
    setFipsCode(ctx, { fips }) {
        ctx.setState(patch({ fips }));
    }
    // Add / update zip and fips
    setLocation(ctx, { zip, fips }) {
        ctx.setState(patch({ zip, fips }));
    }
    // Add / update plan
    setPlan(ctx, { plan }) {
        ctx.setState(patch({ plan }));
    }
    // Set current tab
    setTab(ctx, { tab }) {
        ctx.setState(patch({ tab }));
    }
    // Reset state container
    resetHelpfulTools(ctx) {
        ctx.setState(HELPFUL_TOOLS_DEFAULTS);
    }
    setPlansFetched(ctx, { isPlansFetched }) {
        ctx.setState(patch({ isPlansFetched }));
    }
    // Sets the counties and county zip selection
    setCounties(ctx, { counties, countyZipSelection }) {
        ctx.setState(patch({ counties, countyZipSelection }));
    }
    // Fetches counties for helpful tools.
    async fetchCounties(ctx, { zip }) {
        const state = ctx.getState();
        const currentZip = state.countyZipSelection;
        const hasCounties = !!state.counties;
        let counties = [];
        if (hasCounties) {
            // fetch counties if new zip
            if (zip !== currentZip) {
                counties = await this.demographicsService.retrieveCounties$(zip).toPromise();
            }
            else {
                // else grab counties if we have them, otherwise fetch counties
                counties = state.counties;
            }
        }
        else {
            // otherwise fetch counties
            counties = await this.demographicsService.retrieveCounties$(zip).toPromise();
        }
        ctx.setState(patch({
            counties,
            countyZipSelection: zip
        }));
    }
};
HelpfulToolsState.ɵfac = function HelpfulToolsState_Factory(t) { return new (t || HelpfulToolsState)(i0.ɵɵinject(DemographicHttpService)); };
HelpfulToolsState.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: HelpfulToolsState, factory: HelpfulToolsState.ɵfac });
__decorate([
    Action(SetZipCode)
], HelpfulToolsState.prototype, "setZipCode", null);
__decorate([
    Action(SetFipsCode)
], HelpfulToolsState.prototype, "setFipsCode", null);
__decorate([
    Action(SetLocation)
], HelpfulToolsState.prototype, "setLocation", null);
__decorate([
    Action(SetPlan)
], HelpfulToolsState.prototype, "setPlan", null);
__decorate([
    Action(SetCurrentTab)
], HelpfulToolsState.prototype, "setTab", null);
__decorate([
    Action(ResetHelpfulTools)
], HelpfulToolsState.prototype, "resetHelpfulTools", null);
__decorate([
    Action(SetPlansFetched)
], HelpfulToolsState.prototype, "setPlansFetched", null);
__decorate([
    Action(SetCountiesAndZipSelection)
], HelpfulToolsState.prototype, "setCounties", null);
__decorate([
    Action(FetchCounties)
], HelpfulToolsState.prototype, "fetchCounties", null);
__decorate([
    Selector()
], HelpfulToolsState, "selectedZipCode", null);
__decorate([
    Selector()
], HelpfulToolsState, "selectedFipsCode", null);
__decorate([
    Selector()
], HelpfulToolsState, "selectedPlan", null);
__decorate([
    Selector()
], HelpfulToolsState, "countyZipSelection", null);
__decorate([
    Selector()
], HelpfulToolsState, "selectedTab", null);
__decorate([
    Selector()
], HelpfulToolsState, "counties", null);
__decorate([
    Selector()
], HelpfulToolsState, "isPlansFetched", null);
HelpfulToolsState = __decorate([
    State({
        name: HELPFUL_TOOLS_STORE_NAME,
        defaults: HELPFUL_TOOLS_DEFAULTS
    })
], HelpfulToolsState);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HelpfulToolsState, [{
        type: Injectable
    }], function () { return [{ type: DemographicHttpService }]; }, { setZipCode: [], setFipsCode: [], setLocation: [], setPlan: [], setTab: [], resetHelpfulTools: [], setPlansFetched: [], setCounties: [], fetchCounties: [] }); })();

var JsonAnalyticsGlobalVariable;
(function (JsonAnalyticsGlobalVariable) {
    JsonAnalyticsGlobalVariable["AGE_RANGE"] = "AgeRange";
    JsonAnalyticsGlobalVariable["DOSAGES_COUNT"] = "DosagesCount";
    JsonAnalyticsGlobalVariable["CONFIRMATION_ID"] = "ConfirmationID";
    JsonAnalyticsGlobalVariable["PLAN_NAME"] = "PlanName";
    JsonAnalyticsGlobalVariable["PLAN_TYPE"] = "PlanType";
    JsonAnalyticsGlobalVariable["MONTHLY_PREMIUM"] = "MonthlyPremium";
    JsonAnalyticsGlobalVariable["ZIP_CODE"] = "ZipCode";
    JsonAnalyticsGlobalVariable["APPLICATION_DATE"] = "ApplicationDate";
    JsonAnalyticsGlobalVariable["REQUESTED_EFFECTIVE_DATE"] = "RequestedEffectiveDate";
    JsonAnalyticsGlobalVariable["PLAN_STARS"] = "PlanStars";
})(JsonAnalyticsGlobalVariable || (JsonAnalyticsGlobalVariable = {}));

class SetJsonAnalyticsDataLayerTag {
    constructor(jsonAnalyticsTag) {
        this.jsonAnalyticsTag = jsonAnalyticsTag;
    }
}
SetJsonAnalyticsDataLayerTag.type = '[JsonAnalyticsTag] Set Json Analytics Data Layer Tag';

const tags = {
    [JsonAnalyticsGlobalVariable.AGE_RANGE]: null,
    [JsonAnalyticsGlobalVariable.APPLICATION_DATE]: null,
    [JsonAnalyticsGlobalVariable.CONFIRMATION_ID]: null,
    [JsonAnalyticsGlobalVariable.DOSAGES_COUNT]: null,
    [JsonAnalyticsGlobalVariable.REQUESTED_EFFECTIVE_DATE]: null,
    [JsonAnalyticsGlobalVariable.MONTHLY_PREMIUM]: null,
    [JsonAnalyticsGlobalVariable.PLAN_NAME]: null,
    [JsonAnalyticsGlobalVariable.PLAN_TYPE]: null,
    [JsonAnalyticsGlobalVariable.PLAN_STARS]: null,
    [JsonAnalyticsGlobalVariable.ZIP_CODE]: null
};
let JsonAnalyticsTagManagerState = class JsonAnalyticsTagManagerState {
    constructor() {
        this.dataTags = {
            [JsonAnalyticsGlobalVariable.AGE_RANGE]: null,
            [JsonAnalyticsGlobalVariable.APPLICATION_DATE]: null,
            [JsonAnalyticsGlobalVariable.CONFIRMATION_ID]: null,
            [JsonAnalyticsGlobalVariable.DOSAGES_COUNT]: null,
            [JsonAnalyticsGlobalVariable.REQUESTED_EFFECTIVE_DATE]: null,
            [JsonAnalyticsGlobalVariable.MONTHLY_PREMIUM]: null,
            [JsonAnalyticsGlobalVariable.PLAN_NAME]: null,
            [JsonAnalyticsGlobalVariable.PLAN_TYPE]: null,
            [JsonAnalyticsGlobalVariable.PLAN_STARS]: null,
            [JsonAnalyticsGlobalVariable.ZIP_CODE]: null
        };
    }
    static jsonAnalyticsDataLayerTag(state) {
        if (state) {
            return state;
        }
        return null;
    }
    setJsonAnalyticsDataLayerTag(ctx, { jsonAnalyticsTag }) {
        ctx.patchState({
            ...jsonAnalyticsTag
        });
    }
};
JsonAnalyticsTagManagerState.ɵfac = function JsonAnalyticsTagManagerState_Factory(t) { return new (t || JsonAnalyticsTagManagerState)(); };
JsonAnalyticsTagManagerState.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: JsonAnalyticsTagManagerState, factory: JsonAnalyticsTagManagerState.ɵfac });
__decorate([
    Action(SetJsonAnalyticsDataLayerTag)
], JsonAnalyticsTagManagerState.prototype, "setJsonAnalyticsDataLayerTag", null);
__decorate([
    Selector()
], JsonAnalyticsTagManagerState, "jsonAnalyticsDataLayerTag", null);
JsonAnalyticsTagManagerState = __decorate([
    State({
        name: 'jsonAnalyticsDataLayerTag',
        defaults: tags
    })
], JsonAnalyticsTagManagerState);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JsonAnalyticsTagManagerState, [{
        type: Injectable
    }], function () { return []; }, { setJsonAnalyticsDataLayerTag: [] }); })();

class SetMapCenter {
    constructor(center) {
        this.center = center;
    }
}
SetMapCenter.type = '[Map] Set Map Center';
class SetIsOptimalZoomEnabled {
    constructor(isOptimalZoomEnabled) {
        this.isOptimalZoomEnabled = isOptimalZoomEnabled;
    }
}
SetIsOptimalZoomEnabled.type = '[Map] Set OptimalZoomEnabled';
class SetOptimalZoom {
    constructor(optimalZoom) {
        this.optimalZoom = optimalZoom;
    }
}
SetOptimalZoom.type = '[Map] Set Optimal Zoom Level';
class ResetOptimalZoom {
}
ResetOptimalZoom.type = '[Map] Reset Optimal Zoom';

class MapStateModel {
}
const MAP_DEFAULTS = {
    centerByZipcode: { lat: null, lng: null },
    isOptimalZoomEnabled: false,
    optimalZoom: null
};

let MapState = class MapState {
    static getMapCenterByZipcode(state) {
        return state.centerByZipcode;
    }
    static isOptimalZoomEnabled(state) {
        return state.isOptimalZoomEnabled;
    }
    static optimalZoom(state) {
        return state.optimalZoom;
    }
    SetMapCenter(ctx, action) {
        const { setState } = ctx;
        const center = action.center;
        setState(patch({
            centerByZipcode: center
        }));
    }
    setIsOptimalZoomEnabled(ctx, action) {
        ctx.patchState({
            isOptimalZoomEnabled: action.isOptimalZoomEnabled
        });
    }
    setOptimalZoom(ctx, action) {
        ctx.patchState({
            optimalZoom: action.optimalZoom
        });
    }
    resetOptimalZoom({ patchState }) {
        patchState({
            optimalZoom: null
        });
    }
};
MapState.ɵfac = function MapState_Factory(t) { return new (t || MapState)(); };
MapState.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MapState, factory: MapState.ɵfac });
__decorate([
    Action(SetMapCenter)
], MapState.prototype, "SetMapCenter", null);
__decorate([
    Action(SetIsOptimalZoomEnabled)
], MapState.prototype, "setIsOptimalZoomEnabled", null);
__decorate([
    Action(SetOptimalZoom)
], MapState.prototype, "setOptimalZoom", null);
__decorate([
    Action(ResetOptimalZoom)
], MapState.prototype, "resetOptimalZoom", null);
__decorate([
    Selector()
], MapState, "getMapCenterByZipcode", null);
__decorate([
    Selector()
], MapState, "isOptimalZoomEnabled", null);
__decorate([
    Selector()
], MapState, "optimalZoom", null);
MapState = __decorate([
    State({
        name: 'map',
        defaults: MAP_DEFAULTS
    })
], MapState);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MapState, [{
        type: Injectable
    }], null, { SetMapCenter: [], setIsOptimalZoomEnabled: [], setOptimalZoom: [], resetOptimalZoom: [] }); })();

var MedicineCabinetState_1;
class MedicineCabinetStateModel {
}
const MEDICINE_CABINET_DEFAULTS = {
    medicineCabinet: [],
    hasUpdates: false
};
let MedicineCabinetState = MedicineCabinetState_1 = class MedicineCabinetState {
    static medicineCabinet(state) {
        return state.medicineCabinet;
    }
    static hasUpdates(state) {
        return state.hasUpdates;
    }
    static dosage(dosageId) {
        return createSelector([MedicineCabinetState_1.medicineCabinet], (medicineCabinet) => medicineCabinet.find(medicineCabinetEntry => medicineCabinetEntry.dosageID === dosageId)?.dosage);
    }
    static medicineCabinetConditionId(dosageId) {
        return createSelector([MedicineCabinetState_1.dosage(dosageId)], (dosage) => dosage?.conditionId ?? 0);
    }
    AddDrugDosage(ctx, action) {
        const cabinetEntry = action.cabinetEntry;
        const id = cabinetEntry.dosageID;
        const state = ctx.getState();
        const cabinet = state.medicineCabinet;
        // Add a drug dosage iff it isn't already in the medicine cabinet.
        if (cabinet.findIndex(dosage => dosage.dosageID === id) === -1) {
            ctx.setState(patch({
                medicineCabinet: insertItem(cabinetEntry),
                hasUpdates: true
            }));
        }
        else {
            ctx.setState(patch({
                medicineCabinet: updateItem(entry => entry.dosageID === id, cabinetEntry),
                hasUpdates: true
            }));
        }
    }
    EditDosage(ctx, action) {
        const cabinetEntry = action.cabinetEntry;
        const previousDosageId = action.prevDosageId;
        ctx.setState(patch({
            medicineCabinet: updateItem(entry => entry.dosageID === previousDosageId, cabinetEntry),
            hasUpdates: true
        }));
    }
    RemoveDosage(ctx, action) {
        ctx.setState(patch({
            medicineCabinet: removeItem(entry => entry.dosageID === action.dosageID),
            hasUpdates: true
        }));
    }
    resetMedicineCabinetState(ctx) {
        const { setState } = ctx;
        setState(MEDICINE_CABINET_DEFAULTS);
    }
    AddDrugsToMedicineCabinet(ctx, action) {
        const cabinetEntry = action.cabinetEntry;
        ctx.setState(patch({
            medicineCabinet: append(cabinetEntry)
        }));
    }
    resetCabinetUpdatedStatus(ctx) {
        ctx.setState(patch({
            hasUpdates: false
        }));
    }
    SetDrugsToMedicineCabinet(ctx, action) {
        const cabinetEntry = action.cabinetEntry;
        ctx.setState(patch({
            medicineCabinet: cabinetEntry
        }));
    }
    UpdateMedicineCabinetEntry({ setState }, { medicalConditionId, dosageId }) {
        setState(patch({
            medicineCabinet: updateItem(medicineCabinetEntry => medicineCabinetEntry.dosageID === dosageId, patch({
                dosage: patch({
                    conditionId: medicalConditionId
                })
            }))
        }));
    }
};
MedicineCabinetState.ɵfac = function MedicineCabinetState_Factory(t) { return new (t || MedicineCabinetState)(); };
MedicineCabinetState.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MedicineCabinetState, factory: MedicineCabinetState.ɵfac });
__decorate([
    Action(AddDrugToMedicineCabinet)
], MedicineCabinetState.prototype, "AddDrugDosage", null);
__decorate([
    Action(EditDrugInMedicineCabinet)
], MedicineCabinetState.prototype, "EditDosage", null);
__decorate([
    Action(RemoveDrugFromMedicineCabinet)
], MedicineCabinetState.prototype, "RemoveDosage", null);
__decorate([
    Action(ResetMedicineCabinet)
], MedicineCabinetState.prototype, "resetMedicineCabinetState", null);
__decorate([
    Action(AddDrugsToMedicineCabinet)
], MedicineCabinetState.prototype, "AddDrugsToMedicineCabinet", null);
__decorate([
    Action(ResetCabinetUpdatedStatus)
], MedicineCabinetState.prototype, "resetCabinetUpdatedStatus", null);
__decorate([
    Action(SetDrugsToMedicineCabinet)
], MedicineCabinetState.prototype, "SetDrugsToMedicineCabinet", null);
__decorate([
    Action(UpdateMedicineCabinetEntry)
], MedicineCabinetState.prototype, "UpdateMedicineCabinetEntry", null);
__decorate([
    Selector()
], MedicineCabinetState, "medicineCabinet", null);
__decorate([
    Selector()
], MedicineCabinetState, "hasUpdates", null);
MedicineCabinetState = MedicineCabinetState_1 = __decorate([
    State({
        name: 'medicineCabinet',
        defaults: MEDICINE_CABINET_DEFAULTS
    })
], MedicineCabinetState);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedicineCabinetState, [{
        type: Injectable
    }], null, { AddDrugDosage: [], EditDosage: [], RemoveDosage: [], resetMedicineCabinetState: [], AddDrugsToMedicineCabinet: [], resetCabinetUpdatedStatus: [], SetDrugsToMedicineCabinet: [], UpdateMedicineCabinetEntry: [] }); })();

class RemovePharmacy {
    constructor(pharmacy) {
        this.pharmacy = pharmacy;
    }
}
RemovePharmacy.type = '[Pharmacy] Remove Pharmacy';
class ResetPharmacy {
}
ResetPharmacy.type = '[Pharmacy] Reset Pharmacy';
class ResetSelectedPharmacies {
}
ResetSelectedPharmacies.type = '[Pharmacy] Reset Selected Pharmacies';
class UpdateActivePharmacyTab {
    constructor(activePharmacyTabType) {
        this.activePharmacyTabType = activePharmacyTabType;
    }
}
UpdateActivePharmacyTab.type = '[Pharmacy] Update Active Pharmacy Tab';
class SetPharmacies {
    constructor(pharmacy) {
        this.pharmacy = pharmacy;
    }
}
SetPharmacies.type = '[Pharmacy] Set Pharmacies';
class SetSelectedPharmacy {
    constructor(pharmacy) {
        this.pharmacy = pharmacy;
    }
}
SetSelectedPharmacy.type = '[Pharmacy] Set Selected Pharmacy';
class UpdatePharmacies {
    constructor(pharmacy) {
        this.pharmacy = pharmacy;
    }
}
UpdatePharmacies.type = '[Pharmacy] Update Pharmacies';
class UpdateDigitalPharmacies {
    constructor(pharmacies) {
        this.pharmacies = pharmacies;
    }
}
UpdateDigitalPharmacies.type = '[Pharmacy] Update Digital Pharmacies';
class AddFilterToPharmacyFilterGroups {
    constructor(filterGroupIdentifier, filter) {
        this.filterGroupIdentifier = filterGroupIdentifier;
        this.filter = filter;
    }
}
AddFilterToPharmacyFilterGroups.type = '[Pharmacy] Add Filter To Filter Group';
class SetPharmacyFilterGroup {
    constructor(filterGroup) {
        this.filterGroup = filterGroup;
    }
}
SetPharmacyFilterGroup.type = '[Pharmacy] Set Filter Group';
class ClearPharmacyFilterGroupFilter {
    constructor(filterGroupIdentifier) {
        this.filterGroupIdentifier = filterGroupIdentifier;
    }
}
ClearPharmacyFilterGroupFilter.type = '[Pharmacy] Clear Filter Group Filter';
class ClearPharmacyFilterWithKey {
    constructor(filterGroupIdentifier, filterKeyToClear) {
        this.filterGroupIdentifier = filterGroupIdentifier;
        this.filterKeyToClear = filterKeyToClear;
    }
}
ClearPharmacyFilterWithKey.type = '[Pharmacy] Clear Filter based on Key';
class UpdateIsMailOrderSelected {
    constructor(isMailOrder) {
        this.isMailOrder = isMailOrder;
    }
}
UpdateIsMailOrderSelected.type = '[Pharmacy] Update Is Mail Order';
class FetchDigitalPharmacies {
}
FetchDigitalPharmacies.type = '[Pharmacy] Fetch Digital Pharmacies';

class PharmacyInfo {
}
class APIPlanPharmacyInfo extends PharmacyInfo {
}
class APIPharmacyInfo extends PharmacyInfo {
}
var PharmacyType$1;
(function (PharmacyType) {
    PharmacyType[PharmacyType["Retail"] = 0] = "Retail";
    PharmacyType[PharmacyType["MailOrder"] = 1] = "MailOrder";
})(PharmacyType$1 || (PharmacyType$1 = {}));
var PharmacyTabType;
(function (PharmacyTabType) {
    PharmacyTabType["RETAIL"] = "Retail";
    PharmacyTabType["DIGITAL"] = "Digital";
})(PharmacyTabType || (PharmacyTabType = {}));
var NumberOfPharmacies;
(function (NumberOfPharmacies) {
    NumberOfPharmacies[NumberOfPharmacies["Minimum"] = 2] = "Minimum";
    NumberOfPharmacies[NumberOfPharmacies["Maximum"] = 5] = "Maximum";
    NumberOfPharmacies[NumberOfPharmacies["Default"] = 3] = "Default";
})(NumberOfPharmacies || (NumberOfPharmacies = {}));

class PharmacyHttpService {
    constructor(http) {
        this.http = http;
        this.environment = EnvironmentService.getEnvironment();
    }
    retrievePharmacy$(zip, limit, planId) {
        const environment = EnvironmentService.getEnvironment();
        const headers = new HttpHeaders({ 'Accept': 'application/json', 'Content-Type': 'application/json' });
        let params = new HttpParams().set('filter.zip', zip).set('filter.maxCount', limit);
        if (planId) {
            params = params.set('filter.planId', planId);
        }
        return this.http.get(`${environment.WEB_SERVICE_BASE_URL}/v1/Pharmacies`, { params, headers });
    }
    retrievePharmacyFromLocation$(latitude, longitude, limit, radius, planId, pharmacyName) {
        const headers = new HttpHeaders({ 'Accept': 'application/json', 'Content-Type': 'application/json' });
        let params = new HttpParams()
            .set('filter.latitude', latitude)
            .set('filter.longitude', longitude)
            .set('filter.pharmacySearchType', '1')
            .set('filter.maxCount', limit);
        if (radius) {
            params = params.set('filter.radius', radius);
        }
        // adding plan id will return In-network pharmacies only
        if (planId) {
            params = params.set('filter.planId', planId);
        }
        if (pharmacyName) {
            params = params.set('filter.pharmacyName', pharmacyName);
        }
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Pharmacies`, { params, headers });
    }
    retrieveDigitalPharmacies$() {
        const headers = new HttpHeaders({ 'Accept': 'application/json', 'Content-Type': 'application/json' });
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Pharmacies/DigitalPharmacies`, { headers });
    }
    savePharmacy$(sessionId, pharmacyNABP, isMail, isPrimary) {
        const options = {
            headers: new HttpHeaders({ Accept: 'application/json' })
        };
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Session/${sessionId}/Pharmacies/${pharmacyNABP}?isPrimary=${isPrimary}`, { isMail }, options);
    }
    async savePharmacy(sessionId, pharmacyNABP, isMail, isPrimary) {
        return this.savePharmacy$(sessionId, pharmacyNABP, isMail, isPrimary).toPromise();
    }
    deletePharmacy$(sessionId, pharmacyNABP) {
        return this.http.delete(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Session/${sessionId}/Pharmacies/${pharmacyNABP}`);
    }
    async deletePharmacy(sessionId, pharmacyNABP) {
        return this.deletePharmacy$(sessionId, pharmacyNABP).toPromise();
    }
    deletePharmacies$(sessionId) {
        return this.http.delete(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Session/${sessionId}/Pharmacies`);
    }
    async deletePharmacies(sessionId) {
        return this.deletePharmacies$(sessionId).toPromise();
    }
    getPharmacies$(sessionId) {
        const headers = new HttpHeaders({ 'Accept': 'application/json', 'Content-Type': 'application/json' });
        const params = {};
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Session/${sessionId}/Pharmacies/`, {
            params,
            headers
        });
    }
    async getPharmacies(sessionId) {
        return this.getPharmacies$(sessionId).toPromise();
    }
}
PharmacyHttpService.ɵfac = function PharmacyHttpService_Factory(t) { return new (t || PharmacyHttpService)(i0.ɵɵinject(i1$2.HttpClient)); };
PharmacyHttpService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PharmacyHttpService, factory: PharmacyHttpService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PharmacyHttpService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$2.HttpClient }]; }, null); })();

var PharmacyState_1;
class PharmacyStateModel {
}
const PHARMACY_DEFAULTS = {
    selectedPharmacies: [],
    selectedPharmacy: null,
    pharmacies: [],
    digitalPharmacies: [],
    filterGroups: [],
    isMailOrderSelected: false,
    activePharmacyTabType: PharmacyTabType.RETAIL
};
let PharmacyState = PharmacyState_1 = class PharmacyState {
    constructor(pharmacyHttpService) {
        this.pharmacyHttpService = pharmacyHttpService;
    }
    static selectedPharmacies(state) {
        return state.selectedPharmacies;
    }
    static selectedPharmacy(state) {
        return state.selectedPharmacy;
    }
    static filterGroups(state) {
        return state.filterGroups;
    }
    static pharmacies(state) {
        return state.pharmacies;
    }
    static isMailOrderSelected(state) {
        return state.isMailOrderSelected;
    }
    static rawDigitalPharmacies(state) {
        return state.digitalPharmacies;
    }
    static digitalPharmacies(rawDigitalPharmacies) {
        let sortedPharmacies = [];
        if (rawDigitalPharmacies?.length) {
            // We make a shallow copy to prevent a "TypeError: Cannot assign to read only property '0' of object '[object Array]'"
            // when we mutate the array with ".sort()"
            sortedPharmacies = [...rawDigitalPharmacies].sort((pharmacy, anotherPharmacy) => pharmacy.name.toUpperCase() > anotherPharmacy.name.toUpperCase() ? 1 : -1);
        }
        return sortedPharmacies;
    }
    static primaryPharmacy(selectedPharmacies) {
        const selectedPharmacy = selectedPharmacies.find(pharmacy => pharmacy.isPrimaryPharmacy === true);
        if (selectedPharmacy) {
            return selectedPharmacy;
        }
        if (selectedPharmacies.length > 0) {
            return selectedPharmacies[0];
        }
        return null;
    }
    static activePharmacyTab(state) {
        return state.activePharmacyTabType;
    }
    static getFilterGroup(filterGroupIdentifier) {
        return createSelector([PharmacyState_1.filterGroups], (storeFilterGroups) => FilterUtilities.getFilterGroup(storeFilterGroups, filterGroupIdentifier));
    }
    static getFiltersByFilterGroup(filterGroupIdentifier) {
        return createSelector([PharmacyState_1.getFilterGroup(filterGroupIdentifier)], (storeFilterGroup) => FilterUtilities.getFiltersByFilterGroup(storeFilterGroup));
    }
    static getPharmacyByFilterGroup(filterGroupIdentifier) {
        return createSelector([PharmacyState_1.pharmacies, PharmacyState_1.getFiltersByFilterGroup(filterGroupIdentifier)], (pharmacies, filters) => pharmacies.length && filters.length ? FilterUtilities.filter(pharmacies, filters) : []);
    }
    static selectedAPIPharmacyInfo(selectedPharmacies, selectedPharmacy) {
        const pharmacies = [];
        if (selectedPharmacies) {
            selectedPharmacies.map(pharmacy => {
                pharmacies.push({ pharmacyNABP: pharmacy.nabp, isMailOrder: pharmacy.isMailOrder });
            });
        }
        else if (selectedPharmacy) {
            pharmacies.push({
                pharmacyNABP: selectedPharmacy.nabp,
                isMailOrder: selectedPharmacy.isMailOrder
            });
        }
        return pharmacies;
    }
    setPharmacies(ctx, action) {
        const pharmacy = action.pharmacy;
        ctx.setState(patch({
            selectedPharmacies: append(pharmacy)
        }));
    }
    updateActiveTab({ patchState }, { activePharmacyTabType }) {
        patchState({ activePharmacyTabType });
    }
    setSelectedPharmacy(ctx, action) {
        const pharmacy = action.pharmacy;
        ctx.setState(patch({
            selectedPharmacy: pharmacy
        }));
    }
    removePharmacy(ctx, action) {
        ctx.setState(patch({
            selectedPharmacies: removeItem(entry => entry.pharmacyId === action.pharmacy.pharmacyId)
        }));
    }
    resetSelectedPharmacies({ patchState }) {
        patchState({
            selectedPharmacies: [],
            selectedPharmacy: null
        });
    }
    resetPharmacy({ patchState }) {
        patchState({
            selectedPharmacies: [],
            selectedPharmacy: null,
            pharmacies: [],
            digitalPharmacies: [],
            isMailOrderSelected: false
        });
    }
    addFilterToFilterGroups({ setState }, { filterGroupIdentifier, filter }) {
        setState(patch({
            filterGroups: updateItem(filterGroup => FilterUtilities.matchFilterGroupCompositeKey([filterGroup], filterGroupIdentifier).length > 0, patch({
                filters: compose(removeItem(existingFilter => existingFilter.key === filter.key), append([filter]))
            }))
        }));
    }
    clearPharmacyFilterGroupFilter({ setState }, { filterGroupIdentifier }) {
        setState(patch({
            filterGroups: updateItem(filterGroup => FilterUtilities.matchFilterGroupCompositeKey([filterGroup], filterGroupIdentifier).length > 0, patch({
                filters: []
            }))
        }));
    }
    clearFilterGroupFilter({ setState }, { filterGroupIdentifier, filterKeyToClear }) {
        setState(patch({
            filterGroups: updateItem(filterGroup => FilterUtilities.matchFilterGroupCompositeKey([filterGroup], filterGroupIdentifier).length > 0, patch({
                filters: removeItem(existingFilter => existingFilter.key === filterKeyToClear)
            }))
        }));
    }
    SetPharmacyFilterGroup({ setState }, { filterGroup }) {
        setState(patch({
            filterGroups: compose(removeItem(existingFilterGroup => FilterUtilities.matchFilterGroupCompositeKey([existingFilterGroup], [new Filter({ ...filterGroup.groupKey })]).length > 0), append([filterGroup]))
        }));
    }
    updatePharmacies(ctx, action) {
        const updatedPharmacies = action.pharmacy;
        if (updatedPharmacies?.length) {
            updatedPharmacies?.forEach(pharmacy => {
                if (pharmacy?.isStandard === null || pharmacy?.isStandard === undefined) {
                    pharmacy.isStandard = !pharmacy.isPreferred;
                }
            });
        }
        ctx.setState(patch({
            pharmacies: updatedPharmacies
        }));
    }
    updateDigitalPharmacies(ctx, { pharmacies }) {
        ctx.setState(patch({
            digitalPharmacies: pharmacies
        }));
    }
    fetchDigitalPharmacies(ctx) {
        this.pharmacyHttpService.retrieveDigitalPharmacies$().subscribe({
            next: pharmacies => {
                ctx.dispatch(new UpdateDigitalPharmacies(pharmacies ?? []));
            }
        });
    }
    updateIsMailOrderSelected(ctx, action) {
        ctx.setState(patch({
            isMailOrderSelected: action.isMailOrder
        }));
    }
};
PharmacyState.ɵfac = function PharmacyState_Factory(t) { return new (t || PharmacyState)(i0.ɵɵinject(PharmacyHttpService)); };
PharmacyState.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PharmacyState, factory: PharmacyState.ɵfac });
__decorate([
    Action(SetPharmacies)
], PharmacyState.prototype, "setPharmacies", null);
__decorate([
    Action(UpdateActivePharmacyTab)
], PharmacyState.prototype, "updateActiveTab", null);
__decorate([
    Action(SetSelectedPharmacy)
], PharmacyState.prototype, "setSelectedPharmacy", null);
__decorate([
    Action(RemovePharmacy)
], PharmacyState.prototype, "removePharmacy", null);
__decorate([
    Action(ResetSelectedPharmacies)
], PharmacyState.prototype, "resetSelectedPharmacies", null);
__decorate([
    Action(ResetPharmacy)
], PharmacyState.prototype, "resetPharmacy", null);
__decorate([
    Action(AddFilterToPharmacyFilterGroups)
], PharmacyState.prototype, "addFilterToFilterGroups", null);
__decorate([
    Action(ClearPharmacyFilterGroupFilter)
], PharmacyState.prototype, "clearPharmacyFilterGroupFilter", null);
__decorate([
    Action(ClearPharmacyFilterWithKey)
], PharmacyState.prototype, "clearFilterGroupFilter", null);
__decorate([
    Action(SetPharmacyFilterGroup)
], PharmacyState.prototype, "SetPharmacyFilterGroup", null);
__decorate([
    Action(UpdatePharmacies)
], PharmacyState.prototype, "updatePharmacies", null);
__decorate([
    Action(UpdateDigitalPharmacies)
], PharmacyState.prototype, "updateDigitalPharmacies", null);
__decorate([
    Action(FetchDigitalPharmacies)
], PharmacyState.prototype, "fetchDigitalPharmacies", null);
__decorate([
    Action(UpdateIsMailOrderSelected)
], PharmacyState.prototype, "updateIsMailOrderSelected", null);
__decorate([
    Selector()
], PharmacyState, "selectedPharmacies", null);
__decorate([
    Selector()
], PharmacyState, "selectedPharmacy", null);
__decorate([
    Selector()
], PharmacyState, "filterGroups", null);
__decorate([
    Selector()
], PharmacyState, "pharmacies", null);
__decorate([
    Selector()
], PharmacyState, "isMailOrderSelected", null);
__decorate([
    Selector()
], PharmacyState, "rawDigitalPharmacies", null);
__decorate([
    Selector([PharmacyState_1.rawDigitalPharmacies])
], PharmacyState, "digitalPharmacies", null);
__decorate([
    Selector([PharmacyState_1.selectedPharmacies])
], PharmacyState, "primaryPharmacy", null);
__decorate([
    Selector()
], PharmacyState, "activePharmacyTab", null);
__decorate([
    Selector([PharmacyState_1.selectedPharmacies, PharmacyState_1.selectedPharmacy])
], PharmacyState, "selectedAPIPharmacyInfo", null);
PharmacyState = PharmacyState_1 = __decorate([
    State({
        name: 'pharmacy',
        defaults: PHARMACY_DEFAULTS
    })
], PharmacyState);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PharmacyState, [{
        type: Injectable
    }], function () { return [{ type: PharmacyHttpService }]; }, { setPharmacies: [], updateActiveTab: [], setSelectedPharmacy: [], removePharmacy: [], resetSelectedPharmacies: [], resetPharmacy: [], addFilterToFilterGroups: [], clearPharmacyFilterGroupFilter: [], clearFilterGroupFilter: [], SetPharmacyFilterGroup: [], updatePharmacies: [], updateDigitalPharmacies: [], fetchDigitalPharmacies: [], updateIsMailOrderSelected: [] }); })();

class SetBeneficiaryQuoteDetails {
    constructor(ssoName, agentGuid, quoteId, quickQuoteGuid, sourceSiteId) {
        this.ssoName = ssoName;
        this.agentGuid = agentGuid;
        this.quoteId = quoteId;
        this.quickQuoteGuid = quickQuoteGuid;
        this.sourceSiteId = sourceSiteId;
    }
}
SetBeneficiaryQuoteDetails.type = '[Quote] Set Beneficiary Details';
class SetSourceSiteId {
    constructor(sourceSiteId) {
        this.sourceSiteId = sourceSiteId;
    }
}
SetSourceSiteId.type = '[Quote] Set Source Site Id';
class SetOriginalAppId {
    constructor(originalAppId) {
        this.originalAppId = originalAppId;
    }
}
SetOriginalAppId.type = '[Quote] Set Original App Id of Purl';
class SetEnrollmentQuote {
    constructor(enrollmentQuote) {
        this.enrollmentQuote = enrollmentQuote;
    }
}
SetEnrollmentQuote.type = '[Quote] Set Enrollment Quote';
class ResetBeneficiaryQuoteDetails {
}
ResetBeneficiaryQuoteDetails.type = '[Quote] Reset Beneficiary Details';
class SetBeneficiaryPlanIds {
    constructor(planIds) {
        this.planIds = planIds;
    }
}
SetBeneficiaryPlanIds.type = '[Quote] Set Beneficiary PlanIds';
class SetBeneficiaryAgent {
    constructor(agentGuid) {
        this.agentGuid = agentGuid;
    }
}
SetBeneficiaryAgent.type = '[Quote] Set Beneficiary Agent';
class FetchQuoteInfo {
    constructor(quoteId, agentGuid, quoteType) {
        this.quoteId = quoteId;
        this.agentGuid = agentGuid;
        this.quoteType = quoteType;
    }
}
FetchQuoteInfo.type = '[Quote] Fetch Quote Info';
class SetQuotePlanIds {
    constructor(planIds) {
        this.planIds = planIds;
    }
}
SetQuotePlanIds.type = '[Quote] Set PlanIds';
class SetQuoteVideoURL {
    constructor(quoteVideoURL) {
        this.quoteVideoURL = quoteVideoURL;
    }
}
SetQuoteVideoURL.type = '[Quote] Set Quote Video URL';
class ResetQuoteState {
}
ResetQuoteState.type = '[Quote] Reset Quote State';
class SetDisplayQuoteLabel {
    constructor(display) {
        this.display = display;
    }
}
SetDisplayQuoteLabel.type = '[Quote] Set Display Quote Label';

class QuoteHttpService {
    constructor(http) {
        this.http = http;
        this.environment = EnvironmentService.getEnvironment();
        this.quoteUri = `${this.environment.WEB_SERVICE_BASE_URL}/v1/Quote`;
    }
    getQuoteInfo$(quoteId, agentGuid, quoteType) {
        const headers = new HttpHeaders({ 'Accept': 'application/json', 'Content-Type': 'application/json' });
        let params = new HttpParams();
        if (agentGuid) {
            params = params.set('agentGuid', agentGuid);
        }
        else {
            params = params.set('agentGuid', UndefinedAgentGuid);
        }
        if (quoteType) {
            params = params.set('quoteType', quoteType);
        }
        return this.http.get(`${this.quoteUri}/${quoteId}`, { params, headers });
    }
    getQuoteInfoForMember$(memberId, agentGuid, planYear, quoteType) {
        const params = new HttpParams().set('agentGuid', agentGuid);
        if (planYear) {
            params.set('planYear', planYear);
        }
        if (quoteType) {
            params.set('quoteType', quoteType);
        }
        return this.http.get(`${this.quoteUri}/${memberId}`, { params: new HttpParams().set('agentGuid', agentGuid) });
    }
    updateQuoteAccessedDate$(quoteId, memberId) {
        return this.http.post(`${this.quoteUri}/${quoteId}/UpdateAccessedDate`, { memberId });
    }
}
QuoteHttpService.ɵfac = function QuoteHttpService_Factory(t) { return new (t || QuoteHttpService)(i0.ɵɵinject(i1$2.HttpClient)); };
QuoteHttpService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: QuoteHttpService, factory: QuoteHttpService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(QuoteHttpService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1$2.HttpClient }]; }, null); })();

var QuoteBeneficiaryState_1;
const QUOTE_DEFAULTS = {
    ssoName: '',
    agentGuid: '',
    quoteId: '',
    quickQuoteGuid: '',
    planIds: null,
    enrollmentQuote: null,
    quoteInfos: null,
    sourceSiteId: '',
    quoteVideoURL: '',
    displayQuoteLabel: false,
    originalAppId: null
};
class QuoteStateModel {
}
let QuoteBeneficiaryState = QuoteBeneficiaryState_1 = class QuoteBeneficiaryState {
    constructor(quoteHttpService) {
        this.quoteHttpService = quoteHttpService;
    }
    static getAgentGuid(state) {
        return state.agentGuid;
    }
    static getSsoName(state) {
        return state.ssoName;
    }
    static getQuoteId(state) {
        return state.quoteId;
    }
    static getQuickQuoteGuid(state) {
        return state.quickQuoteGuid;
    }
    static getSourceSiteId(state) {
        return state.sourceSiteId;
    }
    static getOriginalAppId(state) {
        return state.originalAppId;
    }
    static getPlanIds(state) {
        return state.planIds;
    }
    static getEnrollmentQuote(state) {
        return state.enrollmentQuote;
    }
    static getQuoteInfos(state) {
        return state.quoteInfos;
    }
    static getQuoteInfo(quoteInfos) {
        return quoteInfos?.length ? quoteInfos[0] : null;
    }
    static getQuoteType(quoteInfo) {
        return quoteInfo?.quoteType;
    }
    static getQuoteVideoURL(state) {
        return state.quoteVideoURL;
    }
    static getDisplayQuoteLabel(state) {
        return state.displayQuoteLabel;
    }
    setEnrollmentQuote(ctx, { enrollmentQuote }) {
        ctx.setState(patch({ enrollmentQuote }));
    }
    setBeneficiaryQuoteDetails(ctx, { ssoName, agentGuid, quoteId, quickQuoteGuid, sourceSiteId }) {
        ctx.setState(patch({ ssoName, agentGuid, quoteId, quickQuoteGuid, sourceSiteId }));
    }
    setSourceSiteId(ctx, { sourceSiteId }) {
        ctx.setState(patch({ sourceSiteId }));
    }
    setOriginalAppId(ctx, { originalAppId }) {
        ctx.setState(patch({ originalAppId }));
    }
    resetBeneficiaryQuoteDetails(ctx) {
        const { setState } = ctx;
        setState(QUOTE_DEFAULTS);
    }
    setBeneficiaryPlanIds({ patchState }, { planIds }) {
        patchState({ planIds });
    }
    setBeneficiaryAgent({ patchState }, { agentGuid }) {
        patchState({ agentGuid: agentGuid || QUOTE_DEFAULTS.agentGuid });
    }
    async fetchQuoteInfo({ patchState }, { quoteId, agentGuid, quoteType }) {
        const quoteInfos = await firstValueFrom(this.quoteHttpService.getQuoteInfo$(quoteId, agentGuid, quoteType));
        patchState({ quoteInfos });
    }
    setQuotePlanIds({ patchState }, { planIds }) {
        patchState({ planIds });
    }
    setQuoteVideoURL({ patchState }, { quoteVideoURL }) {
        patchState({ quoteVideoURL });
    }
    resetState(ctx) {
        const { setState } = ctx;
        setState(QUOTE_DEFAULTS);
    }
    setDisplayQuoteLabel({ patchState }, { display }) {
        patchState({ displayQuoteLabel: display });
    }
};
QuoteBeneficiaryState.ɵfac = function QuoteBeneficiaryState_Factory(t) { return new (t || QuoteBeneficiaryState)(i0.ɵɵinject(QuoteHttpService)); };
QuoteBeneficiaryState.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: QuoteBeneficiaryState, factory: QuoteBeneficiaryState.ɵfac });
__decorate([
    Action(SetEnrollmentQuote)
], QuoteBeneficiaryState.prototype, "setEnrollmentQuote", null);
__decorate([
    Action(SetBeneficiaryQuoteDetails)
], QuoteBeneficiaryState.prototype, "setBeneficiaryQuoteDetails", null);
__decorate([
    Action(SetSourceSiteId)
], QuoteBeneficiaryState.prototype, "setSourceSiteId", null);
__decorate([
    Action(SetOriginalAppId)
], QuoteBeneficiaryState.prototype, "setOriginalAppId", null);
__decorate([
    Action(ResetBeneficiaryQuoteDetails)
], QuoteBeneficiaryState.prototype, "resetBeneficiaryQuoteDetails", null);
__decorate([
    Action(SetBeneficiaryPlanIds)
], QuoteBeneficiaryState.prototype, "setBeneficiaryPlanIds", null);
__decorate([
    Action(SetBeneficiaryAgent)
], QuoteBeneficiaryState.prototype, "setBeneficiaryAgent", null);
__decorate([
    Action(FetchQuoteInfo)
], QuoteBeneficiaryState.prototype, "fetchQuoteInfo", null);
__decorate([
    Action(SetQuotePlanIds)
], QuoteBeneficiaryState.prototype, "setQuotePlanIds", null);
__decorate([
    Action(SetQuoteVideoURL)
], QuoteBeneficiaryState.prototype, "setQuoteVideoURL", null);
__decorate([
    Action(ResetQuoteState)
], QuoteBeneficiaryState.prototype, "resetState", null);
__decorate([
    Action(SetDisplayQuoteLabel)
], QuoteBeneficiaryState.prototype, "setDisplayQuoteLabel", null);
__decorate([
    Selector()
], QuoteBeneficiaryState, "getAgentGuid", null);
__decorate([
    Selector()
], QuoteBeneficiaryState, "getSsoName", null);
__decorate([
    Selector()
], QuoteBeneficiaryState, "getQuoteId", null);
__decorate([
    Selector()
], QuoteBeneficiaryState, "getQuickQuoteGuid", null);
__decorate([
    Selector()
], QuoteBeneficiaryState, "getSourceSiteId", null);
__decorate([
    Selector()
], QuoteBeneficiaryState, "getOriginalAppId", null);
__decorate([
    Selector()
], QuoteBeneficiaryState, "getPlanIds", null);
__decorate([
    Selector()
], QuoteBeneficiaryState, "getEnrollmentQuote", null);
__decorate([
    Selector()
], QuoteBeneficiaryState, "getQuoteInfos", null);
__decorate([
    Selector([QuoteBeneficiaryState_1.getQuoteInfos])
], QuoteBeneficiaryState, "getQuoteInfo", null);
__decorate([
    Selector([QuoteBeneficiaryState_1.getQuoteInfo])
], QuoteBeneficiaryState, "getQuoteType", null);
__decorate([
    Selector()
], QuoteBeneficiaryState, "getQuoteVideoURL", null);
__decorate([
    Selector()
], QuoteBeneficiaryState, "getDisplayQuoteLabel", null);
QuoteBeneficiaryState = QuoteBeneficiaryState_1 = __decorate([
    State({
        name: 'quote',
        defaults: QUOTE_DEFAULTS
    })
], QuoteBeneficiaryState);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(QuoteBeneficiaryState, [{
        type: Injectable
    }], function () { return [{ type: QuoteHttpService }]; }, { setEnrollmentQuote: [], setBeneficiaryQuoteDetails: [], setSourceSiteId: [], setOriginalAppId: [], resetBeneficiaryQuoteDetails: [], setBeneficiaryPlanIds: [], setBeneficiaryAgent: [], fetchQuoteInfo: [], setQuotePlanIds: [], setQuoteVideoURL: [], resetState: [], setDisplayQuoteLabel: [] }); })();

var SiteState_1;
const SITE_DEFAULTS = {
    consumerSiteUrls: [],
    siteId: '',
    markSessionForCheck: false,
    sharedConfigResource: null,
    isSharedResourceUpdated: false
};
let SiteState = SiteState_1 = class SiteState {
    static consumerSiteUrls(state) {
        return state.consumerSiteUrls;
    }
    static selectedPlanYearConsumerSiteUrl(planYear, consumerSiteUrls) {
        const foundUrl = consumerSiteUrls?.find(url => `${url.planYear}` === `${planYear}`);
        return foundUrl?.url ?? '';
    }
    static siteId(state) {
        return state.siteId;
    }
    static markSessionForCheck(state) {
        return state.markSessionForCheck;
    }
    static sharedConfigResource(state) {
        return state.sharedConfigResource;
    }
    static isSharedResourcesUpdated(state) {
        return state.isSharedResourceUpdated;
    }
    updateConsumerSiteUrls(ctx, { consumerSiteUrls }) {
        const { patchState } = ctx;
        patchState({ consumerSiteUrls });
    }
    setSiteId(ctx, { siteId }) {
        const state = ctx.getState();
        const currentSiteId = state.siteId;
        ctx.patchState({ siteId, markSessionForCheck: !!currentSiteId && currentSiteId !== siteId });
    }
    setMarkSessionForCheck(ctx, { markSessionForCheck }) {
        ctx.patchState({ markSessionForCheck });
    }
    setContactInfoConfig(ctx, { sharedConfigResource }) {
        ctx.patchState({ sharedConfigResource, isSharedResourceUpdated: true });
    }
};
SiteState.ɵfac = function SiteState_Factory(t) { return new (t || SiteState)(); };
SiteState.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SiteState, factory: SiteState.ɵfac });
__decorate([
    Action(UpdateConsumerSiteUrls)
], SiteState.prototype, "updateConsumerSiteUrls", null);
__decorate([
    Action(SetSiteId)
], SiteState.prototype, "setSiteId", null);
__decorate([
    Action(SetMarkSessionForCheck)
], SiteState.prototype, "setMarkSessionForCheck", null);
__decorate([
    Action(SetContactInfoConfig)
], SiteState.prototype, "setContactInfoConfig", null);
__decorate([
    Selector()
], SiteState, "consumerSiteUrls", null);
__decorate([
    Selector([PlansState.selectedPlanYear, SiteState_1.consumerSiteUrls])
], SiteState, "selectedPlanYearConsumerSiteUrl", null);
__decorate([
    Selector()
], SiteState, "siteId", null);
__decorate([
    Selector()
], SiteState, "markSessionForCheck", null);
__decorate([
    Selector()
], SiteState, "sharedConfigResource", null);
__decorate([
    Selector()
], SiteState, "isSharedResourcesUpdated", null);
SiteState = SiteState_1 = __decorate([
    State({
        name: 'site',
        defaults: SITE_DEFAULTS
    })
    /**
     * A store for site specific data such as urls or ids.
     */
], SiteState);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SiteState, [{
        type: Injectable
    }], null, { updateConsumerSiteUrls: [], setSiteId: [], setMarkSessionForCheck: [], setContactInfoConfig: [] }); })();

var SOAActivityType;
(function (SOAActivityType) {
    SOAActivityType["PARTIAL"] = "Partial";
    SOAActivityType["COMPLETED"] = "Completed";
    SOAActivityType["UPLOADED_FILE"] = "Uploaded File";
    SOAActivityType["STARTED_TEXT"] = "Started Text";
    SOAActivityType["STARTED_EMAIL"] = "Started Email";
    SOAActivityType["STARTED_IN_PERSON"] = "Started In Person";
    SOAActivityType["PARTIAL_IN_PERSON"] = "Partial In Person";
    SOAActivityType["COMPLETED_IN_PERSON"] = "Completed In Person";
    SOAActivityType["STARTED_BY_PHONE"] = "Started By Phone";
    SOAActivityType["PARTIAL_BY_PHONE"] = "Partial By Phone";
    SOAActivityType["COMPLETED_BY_PHONE"] = "Completed By Phone";
})(SOAActivityType || (SOAActivityType = {}));
const STARTED_BY_AGENT_SOA_ACTIVITY_TYPES = [SOAActivityType.STARTED_IN_PERSON, SOAActivityType.STARTED_BY_PHONE];
const STARTED_BY_AGENT_PARTIAL_SOA_ACTIVITY_TYPES = [
    SOAActivityType.PARTIAL_IN_PERSON,
    SOAActivityType.PARTIAL_BY_PHONE
];
const IN_PROGRESS_AGENT_SOA_ACTIVITY_TYPES = [
    ...STARTED_BY_AGENT_SOA_ACTIVITY_TYPES,
    ...STARTED_BY_AGENT_PARTIAL_SOA_ACTIVITY_TYPES
];
const CONSUMER_STARTED_SOA_ACTIVITY_TYPES = [SOAActivityType.STARTED_TEXT, SOAActivityType.STARTED_EMAIL];
const COMPLETED_SOA_ACTIVITY_TYPES = [
    SOAActivityType.COMPLETED,
    SOAActivityType.COMPLETED_IN_PERSON,
    SOAActivityType.COMPLETED_BY_PHONE
];
const ALLOWED_SOA_TILE_ACTIVITY_TYPES = [...CONSUMER_STARTED_SOA_ACTIVITY_TYPES, ...COMPLETED_SOA_ACTIVITY_TYPES];

class SOAUtilityService {
    static transformNextGenTransactionPrefillDataToAnswers(nextGenEnrollmentFormPrefillData) {
        return nextGenEnrollmentFormPrefillData
            ? Object.entries(nextGenEnrollmentFormPrefillData).map(([name, value]) => ({ name, value }))
            : [];
    }
    static isTextSOA(transaction) {
        return transaction?.soaActivityType === CoverageTypeEvent.SOA_TEXT;
    }
    static isAgentSOA(transaction) {
        return transaction?.soaActivityType === CoverageTypeEvent.SOA_AGENT;
    }
    static isAgentByPhoneSOA(transaction) {
        return transaction?.soaActivityType === CoverageTypeEvent.SOA_AGENT_PHONE;
    }
    static isCompletedSOA(transaction) {
        return !!transaction?.confirmationNumber;
    }
    static isPartialSOA(transaction, plansValue) {
        return !transaction?.confirmationNumber && plansValue?.length > 0;
    }
    static isPartialAgentSOA(transaction, plansValue) {
        return this.isAgentSOA(transaction) && this.isPartialSOA(transaction, plansValue);
    }
    static isPartialAgentByPhoneSOA(transaction, plansValue) {
        return this.isAgentByPhoneSOA(transaction) && this.isPartialSOA(transaction, plansValue);
    }
    static getSOAPlanTypeListFromAnswer(soaPlanType) {
        if (typeof soaPlanType === 'string' && soaPlanType.length > 0) {
            return soaPlanType.split(',');
        }
        return Array.isArray(soaPlanType) ? soaPlanType : [];
    }
    static getSOAPlans(soaPlanTypes) {
        return (soaPlanTypes?.reduce((soaPlans, soaPlanType, index) => {
            if (index === 0) {
                return soaPlanType;
            }
            else if (index === soaPlanTypes.length - 1) {
                return `${soaPlans} and ${soaPlanType}`;
            }
            else {
                return `${soaPlans}, ${soaPlanType}`;
            }
        }, '') ?? '');
    }
    static replaceTextReplacementVariables(message, activity, memberPhone, memberName) {
        if (message) {
            const soaEmail = activity.email || '';
            const soaDateInMMddyyyy = activity.date ? DateUtilities.getFormattedPTDate(new Date(activity.date), DateUtilities.defaultFormat) : ''; // Convert soaDate from UTC to Pacific Time (PT)
            return message
                .replace('<soaMemberName>', memberName)
                .replace('<soaEmail>', soaEmail)
                .replace('<phone>', SOAUtilityService.getFormattedPhoneNumber(memberPhone))
                .replace('<soaDate>', soaDateInMMddyyyy);
        }
        return '';
    }
    static getFormattedPhoneNumber(phone) {
        return phone?.length === 10 ? `(${phone.substring(0, 3)}) ${phone.substring(3, 6)}-${phone.substring(6, 10)}` : '';
    }
    static sortSOAByCreationDate(soaActivity1, soaActivity2) {
        return SortUtilities.sortByDate(soaActivity1.createdWhen, soaActivity2.createdWhen);
    }
}
SOAUtilityService.ɵfac = function SOAUtilityService_Factory(t) { return new (t || SOAUtilityService)(); };
SOAUtilityService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SOAUtilityService, factory: SOAUtilityService.ɵfac, providedIn: 'root' });
__decorate([
    Memoize()
], SOAUtilityService, "getSOAPlans", null);
__decorate([
    Memoize()
], SOAUtilityService, "replaceTextReplacementVariables", null);
__decorate([
    Memoize()
], SOAUtilityService, "getFormattedPhoneNumber", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SOAUtilityService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

class FetchSOATransactions {
    constructor(sessionId, enrollments) {
        this.sessionId = sessionId;
        this.enrollments = enrollments;
    }
}
FetchSOATransactions.type = '[SOA] Fetch SOA Transactions';
class FetchSOATransactionsSuccess {
}
FetchSOATransactionsSuccess.type = '[SOA] Fetch SOA Transactions Success';
class FetchSOATransactionsError {
    // eslint-disable-next-line n/handle-callback-err
    constructor(error) {
        this.error = error;
    }
}
FetchSOATransactionsError.type = '[SOA] Fetch SOA Transactions Error';
class FetchSOADocuments {
    constructor(ownerId) {
        this.ownerId = ownerId;
    }
}
FetchSOADocuments.type = '[SOA] Fetch SOA Documents';
class FetchSOADocumentsSuccess {
}
FetchSOADocumentsSuccess.type = '[SOA] Fetch SOA Documents Success';
class FetchSOADocumentsError {
    // eslint-disable-next-line n/handle-callback-err
    constructor(error) {
        this.error = error;
    }
}
FetchSOADocumentsError.type = '[SOA] Fetch SOA Documents Error';
class ResetSOAState {
}
ResetSOAState.type = '[SOA] Reset SOA State';
class UpdateSOAState {
    constructor(soa) {
        this.soa = soa;
    }
}
UpdateSOAState.type = '[SOA] Update SOA State';
class SetNextGenSOAFormLoading {
    constructor(transactionId, loading) {
        this.transactionId = transactionId;
        this.loading = loading;
    }
}
SetNextGenSOAFormLoading.type = '[SOA] Set NextGen SOA Form Loading';
class SetNextGenSOAFormLoaded {
    constructor(transactionId, loaded) {
        this.transactionId = transactionId;
        this.loaded = loaded;
    }
}
SetNextGenSOAFormLoaded.type = '[SOA] Set NextGen SOA Form Loaded';
class AddSOATransaction {
    constructor(sessionId, enrollment) {
        this.sessionId = sessionId;
        this.enrollment = enrollment;
    }
}
AddSOATransaction.type = '[SOA] Add SOA Transaction';
class UpdateSOATransactionAnswers {
    constructor(transactionId, pageAnswers, pageAnswersMap) {
        this.transactionId = transactionId;
        this.pageAnswers = pageAnswers;
        this.pageAnswersMap = pageAnswersMap;
    }
}
UpdateSOATransactionAnswers.type = '[SOA] Update SOA Transaction Answers';
class UpdateNextGenSOATransactionAnswers {
    constructor(transactionId, pageAnswersMap) {
        this.transactionId = transactionId;
        this.pageAnswersMap = pageAnswersMap;
    }
}
UpdateNextGenSOATransactionAnswers.type = '[SOA] Update NextGen SOA Transaction Answers';
class UpdateHopeSOATransactionAnswers {
    constructor(transactionId, pageAnswers) {
        this.transactionId = transactionId;
        this.pageAnswers = pageAnswers;
    }
}
UpdateHopeSOATransactionAnswers.type = '[SOA] Update HOPE SOA Transaction Answers';
class AddSOADocument {
    constructor(document, ownerId) {
        this.document = document;
        this.ownerId = ownerId;
    }
}
AddSOADocument.type = '[SOA] Add SOA Document';
class SetSOALoading {
    constructor(loading) {
        this.loading = loading;
    }
}
SetSOALoading.type = '[SOA] Loading';
class SetHasValidCompletedSOA {
    constructor(hasValidCompletedSOA) {
        this.hasValidCompletedSOA = hasValidCompletedSOA;
    }
}
SetHasValidCompletedSOA.type = '[SOA] Set has valid completed SOA';
class CompleteNextGenSOATransaction {
    constructor(nextGenEnrollmentRequest, transactionId) {
        this.nextGenEnrollmentRequest = nextGenEnrollmentRequest;
        this.transactionId = transactionId;
    }
}
CompleteNextGenSOATransaction.type = '[Enrollment] Complete NextGen SOA Transaction';

class RegexPattern {
}
/// <summary>
/// Regular Expression to determine if a string contains only letters
/// </summary>
RegexPattern.ALPHA = /[^a-zA-Z]/;
/// <summary>
/// Regular Expression to determine if a string contains letters and numbers
/// </summary>
RegexPattern.ALPHA_NUMERIC = /[^a-zA-Z0-9]/;
/// <summary>
/// Regular Expression to determine if a string contains letters, numbers and whitespace
/// </summary>
RegexPattern.ALPHA_NUMERIC_SPACE = /[^a-zA-Z0-9s]/;
/// <summary>
/// Regular Expression to determine if a string is properly formatted as an American Express credit card number
/// </summary>
RegexPattern.CREDIT_CARD_AMERICAN_EXPRESS = /^(?:(?:[3][4|7])(?:\d{13}))$/;
/// <summary>
/// Regular Expression to determine if a string is properly formatted as a Carte Blanche credit card number
/// </summary>
RegexPattern.CREDIT_CARD_CARTE_BLANCHE = /^(?:(?:[3](?:[0][0-5]|[6|8]))(?:\d{11,12}))$/;
/// <summary>
/// Regular Expression to determine if a string is properly formatted as a Diners Club credit card number
/// </summary>
RegexPattern.CREDIT_CARD_DINERS_CLUB = /^(?:(?:[3](?:[0][0-5]|[6|8]))(?:\d{11,12}))$/;
/// <summary>
/// Regular Expression to determine if a string is properly formatted as a Discover credit card number
/// </summary>
RegexPattern.CREDIT_CARD_DISCOVER = /^(?:(?:6011)(?:\d{12}))$/;
/// <summary>
/// Regular Expression to determine if a string is properly formatted as an En Route credit card number
/// </summary>
RegexPattern.CREDIT_CARD_EN_ROUTE = /^(?:(?:[2](?:014|149))(?:\d{11}))$/;
/// <summary>
/// Regular Expression to determine if a string is properly formatted as a JCB credit card number
/// </summary>
RegexPattern.CREDIT_CARD_JCB = /^(?:(?:(?:2131|1800)(?:\d{11}))$|^(?:(?:3)(?:\d{15})))$/;
/// <summary>
/// Regular Expression to determine if a string is properly formatted as a MasterCard credit card number
/// </summary>
RegexPattern.CREDIT_CARD_MASTER_CARD = /^(?:(?:[5][1-5])(?:\d{14}))$/;
/// <summary>
/// Regular Expression to determine if a string is formated a non-numeric credit card strip data
/// </summary>
RegexPattern.CREDIT_CARD_STRIP_NON_NUMERIC = /(-|s|D)*/;
/// <summary>
/// Regular Expression to determine if a string is properly formatted as a Visa credit card number
/// </summary>
RegexPattern.CREDIT_CARD_VISA = /^(?:(?:[4])(?:\d{12}|\d{15}))$/;
/// <summary>
/// Regular Expression to determine if a string is a properly formatted e-mail address
/// </summary>
RegexPattern.EMAIL = /^([0-9a-zA-Z]+[-._+&])*[0-9a-zA-Z]+@([-0-9a-zA-Z]+[.])+[a-zA-Z]{2,6}$/;
/// <summary>
/// Regular Expression to determine if a string is properly formatted as a GUID
/// </summary>
RegexPattern.GUID = /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/;
/// <summary>
/// Regular Expression to determine if a string is properly formatted as a IP Address
/// </summary>
RegexPattern.IP_ADDRESS = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?).){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
/// <summary>
/// Regular Expression to determine if a string is all lower case
/// </summary>
RegexPattern.LOWER_CASE = /^[a-z]+$/;
/// <summary>
/// Regular Expression to determine if a string is numeric
/// </summary>
RegexPattern.NUMERIC = /[^0-9]/;
/// <summary>
/// Regular Expression to determine if a string is a properly formatted Social Security Number (xxx-xx-xxxx)
/// </summary>
RegexPattern.SOCIAL_SECURITY = /^\d{3}[-]?\d{2}[-]?\d{4}$/;
/// <summary>
/// Regular Expression to determine if a string could be used as a strong password
/// </summary>
RegexPattern.STRONG_PASSWORD = /(?=^.{8,255}$)((?=.*d)(?=.*[A-Z])(?=.*[a-z])|(?=.*d)(?=.*[^A-Za-z0-9])(?=.*[a-z])|(?=.*[^A-Za-z0-9])(?=.*[A-Z])(?=.*[a-z])|(?=.*d)(?=.*[A-Z])(?=.*[^A-Za-z0-9]))^.*/;
/// <summary>
/// Regular Expression to determine if a string is all upper case
/// </summary>
RegexPattern.UPPER_CASE = /^[A-Z]+$/;
/// <summary>
/// Regular Expression to determine if a string is a properly formatted URL
/// </summary>
RegexPattern.URL = /^^(ht|f)tp(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&%\$#_=]*)?$/;
/// <summary>
/// Regular Expression to determine if a string is a properly formatted as US Currency
/// </summary>
RegexPattern.US_CURRENCY = /^$(([1-9]d*|([1-9]\d{0,2}(,\d{3})*))(.\d{1,2})?|(.\d{1,2}))$|^$[0](.00)?$/;
/// <summary>
/// Regular Expression to determine if a string is a properly formatted US Telephone Number
/// </summary>
RegexPattern.US_TELEPHONE = /^[01]?[- .]?(([2-9]\d{2})|[2-9]\d{2})[- .]?\d{3}[- .]?\d{4}$/;
/// <summary>
/// Regular Expression to determine if a string is a properly formatted US Zip Code (5 character only)
/// </summary>
RegexPattern.US_ZIPCODE = /^\d{5}$/;
/// <summary>
/// Regular Expression to determine if a string is a properly formatted US Zip Code + 4
/// </summary>
RegexPattern.US_ZIPCODE_PLUS_FOUR = /^\d{5}((-|s)?\d{4})$/;
/// <summary>
/// Regular Expression to determine if a string is a properly formatted US Zip Code + Optional 4
/// </summary>
RegexPattern.US_ZIPCODE_PLUS_FOUR_OPTIONAL = /^\d{5}((-|s)?\d{4})?$/;
/// <summary>
/// Regular Expression to determine if a string is a Med Category ID (Benefit ID Reference)
/// </summary>
RegexPattern.MED_CATEGORY_ID = /^<<MedCategoryID=(\d+?)>>$/;
/// <summary>
/// Regular Expression to determine if a string is a properly formatted US phone number. Example: (###) ###-####
/// </summary>
RegexPattern.US_FORMATTED_PHONE_NUMBER = /^\([2-9]\d{2}\)[ ]\d{3}[-]\d{4}$/;
/// <summary>
/// Regular Expression to determine if a string is a Medicare number
/// </summary>
RegexPattern.MBI_PATTERN = /^[1-9][AC-HJKMNP-RT-Yac-hjkmnp-rt-y][AC-HJKMNP-RT-Yac-hjkmnp-rt-y0-9][0-9][AC-HJKMNP-RT-Yac-hjkmnp-rt-y][AC-HJKMNP-RT-Yac-hjkmnp-rt-y0-9][0-9][AC-HJKMNP-RT-Yac-hjkmnp-rt-y]{2}[0-9]{2}$/;

class SpinnerService {
    constructor(spinner) {
        this.spinner = spinner;
        this.loaderText$ = new Subject();
        this.registeredEvents = new Set();
        this.hideSpinnerDelay = 200;
    }
    // Second parameter (name) can't be null, because that's causing a non show up Spinner
    show(event, name, loaderText) {
        if (event) {
            if (!this.registeredEvents.size) {
                this.clearSpinnerTimeouts();
                if (loaderText) {
                    this.setLoaderText(loaderText);
                }
                this.spinner.show(name);
            }
            this.registeredEvents.add(event);
        }
    }
    hide(event, name) {
        if (event) {
            this.registeredEvents.delete(event);
            if (!this.registeredEvents.size) {
                this.clearSpinnerTimeouts();
                this.hideSpinnerTimeout = setTimeout(() => {
                    this.setLoaderText(null);
                    this.spinner.hide(name);
                    this.hideSpinnerTimeout = null;
                }, this.hideSpinnerDelay);
            }
        }
    }
    reset() {
        this.registeredEvents.clear();
        this.spinner.hide();
        this.clearSpinnerTimeouts();
    }
    getRegisteredEvents() {
        return [...this.registeredEvents];
    }
    getLoaderText$() {
        return this.loaderText$.asObservable();
    }
    getLoaderMessage(url, loaderMessages = []) {
        const urlSplitted = url.split('?')?.[0] ?? '';
        return loaderMessages.find(loaderMessage => `/${loaderMessage.page}` === urlSplitted)?.value ?? '';
    }
    setLoaderText(loaderText) {
        this.loaderText$.next(loaderText);
    }
    clearSpinnerTimeouts() {
        if (this.hideSpinnerTimeout) {
            clearTimeout(this.hideSpinnerTimeout);
            this.hideSpinnerTimeout = null;
        }
    }
}
SpinnerService.ɵfac = function SpinnerService_Factory(t) { return new (t || SpinnerService)(i0.ɵɵinject(i1$3.NgxSpinnerService)); };
SpinnerService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SpinnerService, factory: SpinnerService.ɵfac, providedIn: 'root' });
__decorate([
    Memoize()
], SpinnerService.prototype, "getLoaderMessage", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SpinnerService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1$3.NgxSpinnerService }]; }, { getLoaderMessage: [] }); })();

class NavigationUtilityService {
    constructor(store, navigationContext, location, spinnerService, document) {
        this.store = store;
        this.navigationContext = navigationContext;
        this.location = location;
        this.spinnerService = spinnerService;
        this.document = document;
        this._setFocusHeaderElement$ = new Subject();
        this.headerElementFocused$ = this._setFocusHeaderElement$.asObservable();
    }
    constructRouterLink(link) {
        if (link?.tag) {
            return `['${this.constructHref(link.tag)}']`;
        }
        return null;
    }
    constructHref(pageTag) {
        return this.store.selectSnapshot(AppConfigState.hrefByTag(pageTag));
    }
    addHrefToUrl(url, pageTag, queryString) {
        const baseUrl = `${url}/${this.constructHref(pageTag)}`;
        if (queryString) {
            return queryString.startsWith('?') ? `${baseUrl}${queryString}` : `${baseUrl}?${queryString}`;
        }
        return baseUrl;
    }
    isHomePage(url) {
        const homepage = this.store.selectSnapshot(AppConfigState.homepage);
        return RoutesUtilityService.pageNameURLMatch(homepage, url);
    }
    setFocusToMainContent() {
        this._setFocusHeaderElement$.next(null);
    }
    constructNavigationLink(link) {
        const environment = EnvironmentService.getEnvironment();
        if (!environment.liveedit) {
            const linkHref = link.type === LinkType.EXTERNAL ? link.href : `/${this.constructHref(link.tag)}`;
            return linkHref;
        }
    }
    // use any time we need an absolute url that accounts for base href
    constructAbsoluteUrl(pageTag) {
        const origin = this.document.location.origin;
        const href = this.location.prepareExternalUrl(`/${this.constructHref(pageTag)}`);
        return `${origin}${href}`;
    }
    // TODO: may need to convert all uses of this method to constructAbsoluteUrl
    // TODO: need to look at individual use cases to make that determination however
    constructFullHref(pageTag) {
        const baseUrl = this.store.selectSnapshot(AppConfigState.defaultUrl);
        return `${baseUrl}/${this.constructHref(pageTag)}`;
    }
    openLinkInNewWindow(link) {
        if (!link.href) {
            return;
        }
        if (link.type !== LinkType.EXTERNAL) {
            window.open(link.href);
            return;
        }
        if (link.windowHeight && link.windowWidth) {
            const windowSize = `width=${link.windowWidth},height=${link.windowHeight}`;
            window.open(link.href, 'mywin', windowSize);
            return;
        }
        window.open(link.href, 'mywin');
    }
    pageTagURLMatch(pageTag, url) {
        const page = this.getPage(url);
        return page && page.tags.includes(pageTag);
    }
    getPage(url) {
        return this.store.selectSnapshot(AppConfigState.page(RoutesUtilityService.sanitizeUrl(url)));
    }
    getCurrentPage() {
        return this.getPage(this.navigationContext.getUrl());
    }
    isValidUrl(url) {
        return RegexPattern.URL.test(url.trim());
    }
    getOrigin() {
        return this.document.location.origin;
    }
    getLoaderTextByPageTag(loaderMessages = [], pageTag) {
        // We add Slash at begining of target page Href because constructHref does not include it and
        // by another hand, Angular Route Event Url Does it, so that's why we include it (the slash) here
        const pageHref = `/${this.constructHref(pageTag)}`;
        return this.spinnerService.getLoaderMessage(pageHref, loaderMessages);
    }
    // don't memoize this for the time being. ActivatedRouteSnapshot has a circular reference
    // in some cases which fails the JSON.stringify
    areRoutesEqual(urlTree, route) {
        if (urlTree && route) {
            return (this.normalizePath(urlTree.toString()) === this.normalizePath(this.getPath(route)) &&
                _isEqual(urlTree.queryParams, route.queryParams));
        }
        return false;
    }
    getPath(route) {
        return route?.url?.map(urlSegment => urlSegment.path).join('/') ?? '';
    }
    normalizePath(path = '') {
        return path ? path.replace(/^\/|\/$/g, '') : '';
    }
}
NavigationUtilityService.ɵfac = function NavigationUtilityService_Factory(t) { return new (t || NavigationUtilityService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(NavigationContext), i0.ɵɵinject(i3.Location), i0.ɵɵinject(SpinnerService), i0.ɵɵinject(DOCUMENT)); };
NavigationUtilityService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: NavigationUtilityService, factory: NavigationUtilityService.ɵfac, providedIn: 'root' });
__decorate([
    Memoize()
], NavigationUtilityService.prototype, "normalizePath", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavigationUtilityService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }, { type: NavigationContext }, { type: i3.Location }, { type: SpinnerService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { normalizePath: [] }); })();

class GuaranteedIssueReasonsService {
    constructor(store) {
        this.store = store;
    }
    getGuaranteedIssueReasonValue(keyName) {
        return this.store.selectSnapshot(MedSupState.giReasonValue(keyName));
    }
}
GuaranteedIssueReasonsService.ɵfac = function GuaranteedIssueReasonsService_Factory(t) { return new (t || GuaranteedIssueReasonsService)(i0.ɵɵinject(i1.Store)); };
GuaranteedIssueReasonsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: GuaranteedIssueReasonsService, factory: GuaranteedIssueReasonsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GuaranteedIssueReasonsService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }]; }, null); })();

class ProfileFunctionService {
    constructor(store) {
        this.store = store;
    }
    getProfileDisplayValue(keyName) {
        if (keyName === ProfileDisplayValue.GENDER) {
            return this.store.selectSnapshot(ProfileState.gender);
        }
        if (keyName === ProfileDisplayValue.MARITAL_STATUS) {
            return this.store.selectSnapshot(ProfileState.maritalStatus);
        }
    }
}
ProfileFunctionService.ɵfac = function ProfileFunctionService_Factory(t) { return new (t || ProfileFunctionService)(i0.ɵɵinject(i1.Store)); };
ProfileFunctionService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ProfileFunctionService, factory: ProfileFunctionService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProfileFunctionService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }]; }, null); })();

const customInternalValueMapping = {
    gender: [
        { answers: ['Male', GenderCode.MALE, GenderCode.MALE.toString()], customInternalValue: 'M' },
        { answers: ['Female', GenderCode.FEMALE, GenderCode.FEMALE.toString()], customInternalValue: 'F' }
    ],
    tobacco: [
        { answers: ['Smoker'], customInternalValue: 'Yes' },
        { answers: ['Non-Smoker'], customInternalValue: 'No' }
    ]
};
class EnrollmentFunctionService {
    constructor(store) {
        this.store = store;
    }
    getCustomInternalValue(keyName, answerValue) {
        if (keyName) {
            const answerMapping = customInternalValueMapping[keyName];
            if (answerMapping) {
                const answerValueMapping = answerMapping.find(answerMap => answerMap.answers.find(answer => this.formatAnswerForCompare(answer) === this.formatAnswerForCompare(answerValue)));
                return answerValueMapping ? answerValueMapping.customInternalValue : answerValue;
            }
        }
        return '';
    }
    getActiveEnrollmentKey() {
        return this.store.selectSnapshot(EnrollmentState.activeEnrollmentKey);
    }
    getActivePlanId() {
        return this.store.selectSnapshot(EnrollmentState.activePlanId);
    }
    getActiveEnrollmentConfirmationNumber() {
        const activeEnrollmentKey = this.getActiveEnrollmentKey();
        return this.store.selectSnapshot(EnrollmentState.confirmationNumber(activeEnrollmentKey));
    }
    getTransactionId(enrollmentKey) {
        return this.store.selectSnapshot(EnrollmentState.transactionId(enrollmentKey));
    }
    fetchTransaction$(enrollmentKey, transactionId = this.getTransactionId(enrollmentKey)) {
        return this.store.dispatch(new FetchTransaction(transactionId, enrollmentKey));
    }
    getEnrollmentAnswer(name, activeEnrollmentKey = this.getActiveEnrollmentKey()) {
        return this.store.selectSnapshot(EnrollmentState.answer(activeEnrollmentKey, name))?.value ?? '';
    }
    getEnrollmentAnswer$(name, activeEnrollmentKey = this.getActiveEnrollmentKey()) {
        return this.store.select(EnrollmentState.answer(activeEnrollmentKey, name)).pipe(map(answer => {
            return answer?.value ?? '';
        }));
    }
    getNextGenEnrollmentAnswer(name, activeEnrollmentKey = this.getActiveEnrollmentKey()) {
        return this.store.selectSnapshot(EnrollmentState.nextGenAnswer(activeEnrollmentKey, name))?.value ?? '';
    }
    formatAnswerForCompare(answer) {
        return typeof answer === 'string' ? answer.toLowerCase() : answer;
    }
}
EnrollmentFunctionService.ɵfac = function EnrollmentFunctionService_Factory(t) { return new (t || EnrollmentFunctionService)(i0.ɵɵinject(i1.Store)); };
EnrollmentFunctionService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: EnrollmentFunctionService, factory: EnrollmentFunctionService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnrollmentFunctionService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }]; }, null); })();

class MedSupFunctionService {
    constructor(store) {
        this.store = store;
    }
    /**
     * Determines if the beneficiary should be treated as age 65 based on effective date.
     * This is based off member profile and optionally MedSup information if provided.
     * Handed age straddling case of 1st of month birthdays being able to apply for the previous
     * month effective date and still be considered 65.
     * @returns boolean - true or false
     */
    age65AsOfEffectiveDate() {
        const medsupBirthDate = this.store.selectSnapshot(MedSupState.formField('DateOfBirth'));
        const demographicBirthDate = this.store.selectSnapshot(DemographicState.birthdate);
        const profileBirthDate = this.store.selectSnapshot(ProfileState.birthdate);
        const birthDate = medsupBirthDate || demographicBirthDate || profileBirthDate;
        const effectiveDate = this.store.selectSnapshot(MedSupState.formField('EffectiveDate'));
        const nextMonthEffectiveDate = DateUtilities.getFirstOfNextMonth(effectiveDate);
        return birthDate && effectiveDate && DateUtilities.getAgeFromDate(birthDate, nextMonthEffectiveDate) >= 65;
    }
    /**
     * Determines if the beneficiary turned 65 in the same month or no more than 6 months prior to the
     * first day of the requested effective date month.  This is based off MedSup Answers provided.
     * Handed age straddling case of 1st of month birthdays being able to apply for the previous
     * month effective date and still be considered 65.
     * @param dateOfBirth optional date of birth (with default formatting, MM/DD/YYYY)
     * @param effectiveDate optional effective date (with default formatting, MM/DD/YYYY)
     * @returns string 'Y' or 'N'
     */
    getAge65InLast6MonthsOfEffectiveDate(dateOfBirth = this.getDateOfBirth(), effectiveDate = this.getMedSupEffectiveDate()) {
        if (dateOfBirth && effectiveDate) {
            const currentAge = DateUtilities.getAge(dateOfBirth);
            if (currentAge === MEDICARE_ELIGIBILITY_AGE) {
                const dateEligible = DateUtilities.getDateTurns65GivenDateOfBirth(dateOfBirth);
                const firstOfEffectiveDateMonth = DateUtilities.getFirstOfTheMonthFormatted(effectiveDate);
                const monthDifference = DateUtilities.getMonthsDifference(dateEligible, firstOfEffectiveDateMonth);
                const isDateEligibleSameBeforeOrSameMonthAsEffectiveDate = monthDifference === 0 || DateUtilities.dateIsSameOrBefore(dateEligible, effectiveDate);
                if (isDateEligibleSameBeforeOrSameMonthAsEffectiveDate) {
                    if (monthDifference < MEDSUP_SIX_MONTHS_VALUE) {
                        return MEDSUP_YES_VALUE;
                    }
                }
            }
            if (currentAge === INITIAL_ENROLLMENT_ELIGIBILITY_AGE) {
                const nextMonthEffectiveDate = DateUtilities.getFirstOfNextMonth(effectiveDate);
                if (DateUtilities.getAgeFromDate(dateOfBirth, nextMonthEffectiveDate) === MEDICARE_ELIGIBILITY_AGE) {
                    return MEDSUP_YES_VALUE;
                }
            }
        }
        return MEDSUP_NO_VALUE;
    }
    /**
     * Determines if the beneficiary’s Part B effective date is in the same month or no more than
     * 6 months prior to the first day of the requested effective date month. This is based
     * off MedSup answers provided.
     * @param medicarePartBEffectiveDate optional part B effective date (with default formatting, MM/DD/YYYY)
     * @param effectiveDate optional effective date (with default formatting, MM/DD/YYYY)
     * @returns string 'Y' or 'N'
     */
    getMedicarePartBInLast6Months(medicarePartBEffectiveDate = this.getMedicarePartBEffectiveDate(), effectiveDate = this.getMedSupEffectiveDate()) {
        if (medicarePartBEffectiveDate && effectiveDate) {
            const firstOfEffectiveDateMonth = DateUtilities.getFirstOfTheMonthFormatted(effectiveDate);
            const monthDifference = DateUtilities.getMonthsDifference(medicarePartBEffectiveDate, firstOfEffectiveDateMonth);
            const isPartBSameBeforeOrSameMonthAsEffectiveDate = monthDifference === 0 || DateUtilities.dateIsSameOrBefore(medicarePartBEffectiveDate, firstOfEffectiveDateMonth);
            if (isPartBSameBeforeOrSameMonthAsEffectiveDate) {
                if (monthDifference <= MEDSUP_SIX_MONTHS_VALUE) {
                    return MEDSUP_YES_VALUE;
                }
            }
        }
        return MEDSUP_NO_VALUE;
    }
    getDateOfBirth() {
        return this.store.selectSnapshot(MedSupState.formField('DateOfBirth'));
    }
    getMedSupEffectiveDate() {
        return this.store.selectSnapshot(MedSupState.formField('EffectiveDate'));
    }
    getMedicarePartBEffectiveDate() {
        return this.store.selectSnapshot(MedSupState.formField('PartBEffectiveDate'));
    }
}
MedSupFunctionService.ɵfac = function MedSupFunctionService_Factory(t) { return new (t || MedSupFunctionService)(i0.ɵɵinject(i1.Store)); };
MedSupFunctionService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MedSupFunctionService, factory: MedSupFunctionService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedSupFunctionService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }]; }, null); })();

class CurrencyUtilityService {
    getCurrency(premium) {
        const locale = 'en-US';
        const currencyCode = 'USD';
        const digitsInfo = '1.2-2';
        return formatCurrency(premium, locale, getCurrencySymbol(currencyCode, 'wide'), currencyCode, digitsInfo);
    }
}
CurrencyUtilityService.ɵfac = function CurrencyUtilityService_Factory(t) { return new (t || CurrencyUtilityService)(); };
CurrencyUtilityService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CurrencyUtilityService, factory: CurrencyUtilityService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CurrencyUtilityService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

var CurrencyFormat;
(function (CurrencyFormat) {
    CurrencyFormat["NONE"] = "NONE";
    CurrencyFormat["CURRENCY"] = "CURRENCY";
})(CurrencyFormat || (CurrencyFormat = {}));
/**
 * A service for exposing function expressions that can be called to resolve values
 * in the configuration json.
 */
class DynamicFunctionService {
    constructor(giReasonsService, profileFunctionService, enrollmentFunctionService, medSupFunctionService, store, navigationContext, currencyUtilityService) {
        this.giReasonsService = giReasonsService;
        this.profileFunctionService = profileFunctionService;
        this.enrollmentFunctionService = enrollmentFunctionService;
        this.medSupFunctionService = medSupFunctionService;
        this.store = store;
        this.navigationContext = navigationContext;
        this.currencyUtilityService = currencyUtilityService;
        this.functions = {
            // thought about adding this to the StoreResourceService selectorKeyMap but decided to put this here as it is parameterized,
            // returns a raw value rather than an object that further dot notation is required for and involves data that does not
            // exclusively reside in in the store
            gireasonvalue: this.giReasonsService.getGuaranteedIssueReasonValue.bind(this.giReasonsService),
            getprofiledisplayvalue: this.profileFunctionService.getProfileDisplayValue.bind(this.profileFunctionService),
            getcustominternalvalue: this.enrollmentFunctionService.getCustomInternalValue.bind(this.enrollmentFunctionService),
            displaysep: () => this.getPlanDisplaySEP(),
            getselectedplanpremium: isCurrency => this.getMonthlyPlanPremium(isCurrency),
            getplandetailsproperty: propertyName => this.getPlanDetailsProperty(propertyName),
            gethighestpremiumonactivetab: () => this.getCurrency(Math.max(...this.store.selectSnapshot(PlansState.activeTabTotalPlanPremiums))),
            getlowestpremiumonactivetab: () => this.getCurrency(Math.min(...this.store.selectSnapshot(PlansState.activeTabTotalPlanPremiums))),
            getselectedplaneffectivedate: planYear => this.getEffectiveDate(planYear),
            age65asofeffectivedate: () => this.medSupFunctionService.age65AsOfEffectiveDate(),
            getconfirmationnumber: () => this.getActiveEnrollmentConfirmationNumber(),
            getauthorizeuse: () => this.getAuthorizeUse(),
            getmedicarepartbinlast6months: () => this.medSupFunctionService.getMedicarePartBInLast6Months(),
            getage65inlast6months: () => this.medSupFunctionService.getAge65InLast6MonthsOfEffectiveDate(),
            getenrollingcarrieraddress: () => this.getEnrollingCarrierAddress()
        };
    }
    getPlanDisplaySEP() {
        let planId = this.enrollmentFunctionService.getActiveEnrollmentKey();
        if (!planId) {
            const selectedPlan = this.store.selectSnapshot(ShoppingCartState.selectedPlan);
            planId = selectedPlan ? selectedPlan.id : null;
        }
        return this.store.selectSnapshot(ShoppingCartState.selectedPlanDisplaySEP(planId));
    }
    getPlanDetailsProperty(propertyName) {
        const planId = this.navigationContext.getQueryParams().id;
        if (planId) {
            const plan = this.store.selectSnapshot(PlansState.plan(planId));
            if (plan) {
                return plan[propertyName];
            }
        }
    }
    getCurrency(premium) {
        return this.currencyUtilityService.getCurrency(premium);
    }
    getMonthlyPlanPremium(isCurrency) {
        const activePlanId = this.enrollmentFunctionService.getActivePlanId();
        const planId = activePlanId || this.store.selectSnapshot(ShoppingCartState.selectedPlan)?.id;
        const planPremium = this.store.selectSnapshot(ShoppingCartState.selectedPlanMonthlyPremium(planId));
        if (isCurrency === CurrencyFormat.NONE) {
            return planPremium.toString();
        }
        return this.getCurrency(planPremium);
    }
    getDefaultFormattedDate(planYear) {
        if (planYear) {
            // During AEP, use 1/1/<planYear>
            // After AEP, use today's date since that is when agent is enrolling member in plan (SCS-28414)
            // Ex: If today is 1/20 and agent selling permission expires 2/1, agent should still be able to sell until expiration
            const currentDate = new Date();
            const planYearDate = new Date(+planYear, 0, 1);
            return currentDate < planYearDate
                ? DateUtilities.getFormattedDate(planYearDate)
                : DateUtilities.getFormattedFirstOfNextMonth(DateUtilities.defaultFormat);
        }
    }
    getEffectiveDate(planYear = new Date().getFullYear()) {
        const activePlanId = this.enrollmentFunctionService.getActivePlanId();
        const planId = activePlanId || this.store.selectSnapshot(ShoppingCartState.selectedPlan).id;
        const planType = this.store.selectSnapshot(ShoppingCartState.selectedPlanById(planId)).planType;
        switch (planType) {
            case PlanType.MEDIGAP:
                return this.store.selectSnapshot(MedSupState.formField('EffectiveDate'));
            case PlanType.MA:
            case PlanType.MAPD:
            case PlanType.PDP:
                return this.getDefaultFormattedDate(planYear);
            default:
                return null;
        }
    }
    getActiveEnrollmentConfirmationNumber() {
        return this.enrollmentFunctionService.getActiveEnrollmentConfirmationNumber();
    }
    getAuthorizeUse() {
        const isAuthorized = this.store.selectSnapshot(MillimanState.authorizeUse);
        return isAuthorized ? AUTHORIZATION_YES_VALUE : AUTHORIZATION_NO_VALUE;
    }
    getEnrollingCarrierAddress() {
        const activeEnrollmentKey = this.enrollmentFunctionService.getActiveEnrollmentKey();
        const carrierAddress = this.store.selectSnapshot(PlansState.carrierAddress(activeEnrollmentKey));
        return `${carrierAddress.address1 + ' '}${carrierAddress.address2 ? carrierAddress.address2 + ' ' : ''}${carrierAddress.city + ','}${' ' + carrierAddress.state}${' ' + carrierAddress.zip}`;
    }
}
DynamicFunctionService.ɵfac = function DynamicFunctionService_Factory(t) { return new (t || DynamicFunctionService)(i0.ɵɵinject(GuaranteedIssueReasonsService), i0.ɵɵinject(ProfileFunctionService), i0.ɵɵinject(EnrollmentFunctionService), i0.ɵɵinject(MedSupFunctionService), i0.ɵɵinject(i1.Store), i0.ɵɵinject(NavigationContext), i0.ɵɵinject(CurrencyUtilityService)); };
DynamicFunctionService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DynamicFunctionService, factory: DynamicFunctionService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DynamicFunctionService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GuaranteedIssueReasonsService }, { type: ProfileFunctionService }, { type: EnrollmentFunctionService }, { type: MedSupFunctionService }, { type: i1.Store }, { type: NavigationContext }, { type: CurrencyUtilityService }]; }, null); })();

class PhoneUtilityService {
    constructor(localeService) {
        this.localeService = localeService;
    }
    parsePhoneNumber(phoneNumber, countryCode) {
        if (!phoneNumber) {
            return '';
        }
        let parsedNumber;
        const country = countryCode ?
            countryCode : this.localeService.getCountryCode();
        try {
            parsedNumber = parsePhoneNumber(phoneNumber, country);
            return parsePhoneNumber(phoneNumber, country).formatNational();
        }
        catch (e) {
            console.warn('Could not parse phone number', e);
            return `${parsedNumber || phoneNumber}`;
        }
    }
    formatPhoneNumberWithExtension(phone, ext) {
        return this.getNationalPhoneNumber(this.parsePhoneNumberWithExtension(phone, ext), this.localeService.getCountryCode());
    }
    parsePhoneNumberWithExtension(phone, ext) {
        if (phone) {
            if (ext) {
                return `${phone}x${ext}`;
            }
            return phone;
        }
        return '';
    }
    getNationalPhoneNumber(phoneNumber, country = 'US') {
        if (!phoneNumber) {
            return '';
        }
        const parsedPhone = parsePhoneNumber(phoneNumber, country);
        return parsedPhone && parsedPhone.isValid && parsedPhone.number ? parsedPhone.formatNational() : '';
    }
    getE164PhoneNumber(phoneNumber, country = 'US') {
        if (!phoneNumber) {
            return null;
        }
        const parsedPhone = parsePhoneNumber(phoneNumber, country);
        return parsedPhone && parsedPhone.isValid && parsedPhone.number ? parsedPhone.number.toString() : null;
    }
}
PhoneUtilityService.ɵfac = function PhoneUtilityService_Factory(t) { return new (t || PhoneUtilityService)(i0.ɵɵinject(LocaleService)); };
PhoneUtilityService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PhoneUtilityService, factory: PhoneUtilityService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PhoneUtilityService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: LocaleService }]; }, null); })();

/**
 * A service for exposing function expressions that can be called to resolve values
 * in the configuration json.
 */
class UtilityFunctionService {
    constructor(navigationUtilityService, dynamicFunctionService, phoneService, localeService) {
        this.navigationUtilityService = navigationUtilityService;
        this.dynamicFunctionService = dynamicFunctionService;
        this.phoneService = phoneService;
        this.localeService = localeService;
        this.formatString = (value, format) => {
            if (value && format === 'uppercase') {
                return `${value}`.toUpperCase();
            }
            return `${value}`;
        };
        this.getDate = (value, format) => DateUtilities.getFormattedPTDate(new Date(value), format);
        // Display in custom internal as pacific time. Platform resource condition runs on pacific time.
        this.getCurrentDate = (format) => DateUtilities.getFormattedPTDate(new Date(), format);
        this.getTransformedLocale = (locale) => this.localeService.getTransformedLocale(locale);
        this.functions = {
            'string.format': this.formatString,
            'datetime.now': this.getCurrentDate,
            'date.format': DateUtilities.getFormattedDate.bind(DateUtilities),
            'url.pagebytag': this.navigationUtilityService.constructHref.bind(this.navigationUtilityService),
            'url.fullurlbytag': this.navigationUtilityService.constructFullHref.bind(this.navigationUtilityService),
            'color.get': AppThemeConfig.getColorValueByKey.bind(AppThemeConfig),
            'phone': this.phoneService.parsePhoneNumber.bind(this.phoneService),
            ...this.dynamicFunctionService.functions
        };
    }
    getUtilityFunction(name) {
        if (name) {
            const utilityFunction = this.functions[name.toLowerCase()];
            if (utilityFunction) {
                return utilityFunction;
            }
        }
        return null;
    }
}
UtilityFunctionService.ɵfac = function UtilityFunctionService_Factory(t) { return new (t || UtilityFunctionService)(i0.ɵɵinject(NavigationUtilityService), i0.ɵɵinject(DynamicFunctionService), i0.ɵɵinject(PhoneUtilityService), i0.ɵɵinject(LocaleService)); };
UtilityFunctionService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: UtilityFunctionService, factory: UtilityFunctionService.ɵfac, providedIn: 'root' });
__decorate([
    Memoize()
], UtilityFunctionService.prototype, "getUtilityFunction", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UtilityFunctionService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: NavigationUtilityService }, { type: DynamicFunctionService }, { type: PhoneUtilityService }, { type: LocaleService }]; }, { getUtilityFunction: [] }); })();

class SOAHttpService {
    constructor(http, utilityFunctionService) {
        this.http = http;
        this.utilityFunctionService = utilityFunctionService;
        this.environment = EnvironmentService.getEnvironment();
    }
    startSOATransaction$(sessionId, soaFormId, soaEnrollmentRequest, planYear) {
        const options = { headers: new HttpHeaders({ Accept: 'application/json' }) };
        return this.http.post(`${this.environment.MEMBER_SESSION_BASE_URL}/${sessionId}/SOA/${soaFormId}/Enroll?planYear=${planYear}`, soaEnrollmentRequest, options);
    }
    getFormInfo$(tid) {
        return this.http.get(`${EnvironmentService.getEnvironment().ENROLLMENT_FORM_BASE_URL}/Transactions/${tid}/Form/Info?showIdentifiers=true`);
    }
    getFormPage$(tid, pageName, locale = 'en-US', planYear) {
        return this.http.get(`${EnvironmentService.getEnvironment().ENROLLMENT_FORM_BASE_URL}/Transactions/${tid}/Form?pageName=${pageName}&isReviewEdit=False&language=${this.utilityFunctionService.getTransformedLocale(locale)}&planYear=${planYear}`, { responseType: 'text' });
    }
    completeTransaction$(tid, enrollmentRequest) {
        return this.http.post(`${EnvironmentService.getEnvironment().ENROLLMENT_FORM_BASE_URL}/Transactions/${tid}`, enrollmentRequest);
    }
    finishTransaction$(sessionId, transactionId, enrollmentSettings, planYear, externalEnrollment, isSiteLive, isReviewSite, callRecordingCode) {
        return this.http.post(`${EnvironmentService.getEnvironment().MEMBER_SESSION_BASE_URL}/${sessionId}/Transaction/${transactionId}/CompleteEnrollment?planYear=${planYear}`, { payload: enrollmentSettings, externalEnrollment, isSiteLive, isReviewSite, callRecordingCode });
    }
    uploadDocument$(document, ownerId) {
        const formData = new FormData();
        formData.append('filename', document, document.name);
        return this.http.post(`${this.environment.SOA_BASE_URL}/${ownerId}/Upload`, formData);
    }
    async uploadDocument(document, ownerId) {
        return await this.uploadDocument$(document, ownerId).toPromise();
    }
    getDocumentList$(ownerId) {
        return this.http.get(`${this.environment.SOA_BASE_URL}/${ownerId}/Documents`);
    }
    async getDocumentList(ownerId) {
        return await this.getDocumentList$(ownerId).toPromise();
    }
    downloadDocument$(documentId, ownerId) {
        return this.http
            .get(`${this.environment.SOA_BASE_URL}/${ownerId}/Download/${documentId}`)
            .pipe(map(response => response.Data));
    }
    async downloadDocument(documentId, ownerId) {
        return await this.downloadDocument$(documentId, ownerId).toPromise();
    }
}
SOAHttpService.ɵfac = function SOAHttpService_Factory(t) { return new (t || SOAHttpService)(i0.ɵɵinject(i1$2.HttpClient), i0.ɵɵinject(UtilityFunctionService)); };
SOAHttpService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SOAHttpService, factory: SOAHttpService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SOAHttpService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1$2.HttpClient }, { type: UtilityFunctionService }]; }, null); })();

var SOAState_1;
const SOA_DEFAULT = {
    loading: false,
    loaded: false,
    error: null,
    transactions: [],
    documents: [],
    createdWhen: null,
    hasValidCompletedSOA: false
};
class SOAStateModel {
}
const SOA_STORE_NAME = 'soa';
let SOAState = SOAState_1 = class SOAState {
    constructor(store, httpClient, enrollmentHttpService, soaHttpService, stringFormatUtilityService) {
        this.store = store;
        this.httpClient = httpClient;
        this.enrollmentHttpService = enrollmentHttpService;
        this.soaHttpService = soaHttpService;
        this.stringFormatUtilityService = stringFormatUtilityService;
    }
    static mapSOATransactionToActivity(transaction, email, soaPlanTypeUniqueName, soaBeneficiaryConfirmationCodeUniqueName, allAgentCallRecords) {
        const lowerCaseSOAPlanTypeUniqueName = soaPlanTypeUniqueName.toLowerCase();
        const lowerCaseSOABeneficiaryConfirmationCodeUniqueName = soaBeneficiaryConfirmationCodeUniqueName.toLowerCase();
        const answers = transaction.answers ?? SOAUtilityService.transformNextGenTransactionPrefillDataToAnswers(transaction.prefillData);
        const plans = answers?.find(answer => answer.name.toLowerCase() === lowerCaseSOAPlanTypeUniqueName);
        const plansValue = SOAUtilityService.getSOAPlanTypeListFromAnswer(plans?.value);
        const soaBeneficiaryConfirmationCode = transaction.soaBeneficiaryCode ??
            answers?.find(answer => answer.name.toLowerCase() === lowerCaseSOABeneficiaryConfirmationCodeUniqueName)?.value ??
            null;
        const agentCallRecords = EnrollmentState.getAgentCallRecordsByTransactionGUID(allAgentCallRecords, transaction.transactionGUID);
        let activityType;
        if (SOAUtilityService.isAgentSOA(transaction) && SOAUtilityService.isCompletedSOA(transaction)) {
            activityType = SOAActivityType.COMPLETED_IN_PERSON;
        }
        else if (SOAUtilityService.isAgentByPhoneSOA(transaction) && SOAUtilityService.isCompletedSOA(transaction)) {
            activityType = SOAActivityType.COMPLETED_BY_PHONE;
        }
        else if (SOAUtilityService.isPartialAgentSOA(transaction, plansValue)) {
            activityType = SOAActivityType.PARTIAL_IN_PERSON;
        }
        else if (SOAUtilityService.isPartialAgentByPhoneSOA(transaction, plansValue)) {
            activityType = SOAActivityType.PARTIAL_BY_PHONE;
        }
        else if (SOAUtilityService.isCompletedSOA(transaction)) {
            activityType = SOAActivityType.COMPLETED;
        }
        else if (SOAUtilityService.isPartialSOA(transaction, plansValue)) {
            activityType = SOAActivityType.PARTIAL;
        }
        else if (SOAUtilityService.isTextSOA(transaction)) {
            activityType = SOAActivityType.STARTED_TEXT;
        }
        else if (SOAUtilityService.isAgentSOA(transaction)) {
            activityType = SOAActivityType.STARTED_IN_PERSON;
        }
        else if (SOAUtilityService.isAgentByPhoneSOA(transaction)) {
            activityType = SOAActivityType.STARTED_BY_PHONE;
        }
        else {
            activityType = SOAActivityType.STARTED_EMAIL;
        }
        const activity = {
            type: activityType,
            plans: plansValue,
            planYear: transaction.planYear,
            soaBeneficiaryConfirmationCode,
            date: activityType === SOAActivityType.STARTED_EMAIL || activityType === SOAActivityType.STARTED_TEXT
                ? transaction.createdWhen
                : transaction.modifiedWhen,
            transactionId: transaction.transactionGUID,
            transactionSId: transaction.transactionSID,
            publicFormID: transaction.publicFormID,
            confirmationNumber: transaction.confirmationNumber,
            email,
            agentCallRecords,
            enrollSystemType: transaction.enrollSystemType,
            createdWhen: transaction.createdWhen,
            completedWhen: transaction.completedWhen
        };
        return activity;
    }
    static soaState(state) {
        return state;
    }
    static createdWhen(state) {
        return state.createdWhen;
    }
    static transactions(state) {
        return state.transactions;
    }
    static documents(state) {
        return state.documents;
    }
    static hasValidCompletedSOA(state) {
        return !!state.hasValidCompletedSOA;
    }
    static loading(state) {
        return state.loading;
    }
    static nextGenTransactionPrefillData(transactionId) {
        return createSelector([SOAState_1.transactionById(transactionId)], (transaction) => transaction?.prefillData ?? {});
    }
    static transactionById(transactionId) {
        return createSelector([SOAState_1.transactions], (transactions) => transactions?.find(transaction => transaction.transactionGUID === transactionId || transaction.transactionSID === transactionId));
    }
    static nextGenSOAFormLoading(transactionSID) {
        return createSelector([SOAState_1.transactionById(transactionSID)], (transaction) => !!transaction?.loading);
    }
    static nextGenSOAFormLoaded(transactionSID) {
        return createSelector([SOAState_1.transactionById(transactionSID)], (transaction) => !!transaction?.loaded);
    }
    static transactionAnswers(transactionSID) {
        return createSelector([SOAState_1.transactionById(transactionSID)], (transaction) => transaction?.answers ?? SOAUtilityService.transformNextGenTransactionPrefillDataToAnswers(transaction?.prefillData) ?? []);
    }
    static answer(transactionId, name) {
        return createSelector([SOAState_1.transactionAnswers(transactionId)], (transactionAnswers) => {
            const selectedAnswer = transactionAnswers?.find(answer => answer.name === name);
            return selectedAnswer !== undefined ? selectedAnswer : null;
        });
    }
    static soaActivities(soaPlanTypeUniqueName, soaBeneficiaryConfirmationCodeUniqueName, isAdmin = false) {
        const defaultSelectors = [SOAState_1.transactions, ProfileState.emailAddress];
        return createSelector(isAdmin ? [...defaultSelectors, MemberState.agentCallRecords] : defaultSelectors, (transactions, memberEmail, agentCallRecords) => transactions.map(transaction => SOAState_1.mapSOATransactionToActivity(transaction, memberEmail, soaPlanTypeUniqueName, soaBeneficiaryConfirmationCodeUniqueName, agentCallRecords)));
    }
    static soaActivity(transactionId, soaPlanTypeUniqueName, soaBeneficiaryConfirmationCodeUniqueName, isAdmin = false) {
        return createSelector([SOAState_1.soaActivities(soaPlanTypeUniqueName, soaBeneficiaryConfirmationCodeUniqueName, isAdmin)], (soaActivities) => soaActivities?.find(soaActivity => soaActivity.transactionId === transactionId || soaActivity.transactionSId === transactionId));
    }
    async fetchSOATransactions(ctx, { sessionId, enrollments }) {
        const { patchState } = ctx;
        patchState({
            loading: true,
            loaded: false,
            error: null
        });
        // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
        return await this.fetchTransactions(sessionId, enrollments)
            .then(transactions => {
            patchState({ transactions });
            ctx.dispatch(new FetchSOATransactionsSuccess());
        })
            .catch(error => {
            ctx.dispatch(new FetchSOATransactionsError(error));
        });
    }
    fetchSOATransactionsSuccess({ patchState }) {
        patchState({
            loaded: true,
            loading: false,
            error: null
        });
    }
    fetchSOATransactionsError({ patchState }, { error }) {
        patchState({
            loaded: false,
            loading: false,
            error
        });
    }
    async setNextGenSOAFormLoading(ctx, { transactionId, loading }) {
        const { setState } = ctx;
        setState(patch({
            transactions: updateItem(transaction => transaction.transactionGUID === transactionId || transaction.transactionSID === transactionId, patch({ loading }))
        }));
    }
    async setNextGenSOAFormLoaded(ctx, { transactionId, loaded }) {
        const { setState } = ctx;
        setState(patch({
            transactions: updateItem(transaction => transaction.transactionGUID === transactionId || transaction.transactionSID === transactionId, patch({ loaded }))
        }));
    }
    async fetchSOADocuments(ctx, { ownerId }) {
        const { patchState } = ctx;
        try {
            const documents = await this.soaHttpService.getDocumentList(ownerId);
            patchState({
                documents: [...documents]
            });
            ctx.dispatch(new FetchSOADocumentsSuccess());
        }
        catch (error) {
            ctx.dispatch(new FetchSOADocumentsError(error));
        }
    }
    fetchSOADocumentsSuccess({ patchState }) {
        patchState({
            loaded: true,
            loading: false,
            error: null
        });
    }
    fetchSOADocumentsError({ patchState }, { error }) {
        patchState({
            loaded: false,
            loading: false,
            error
        });
    }
    resetSOAState({ patchState }) {
        patchState(SOA_DEFAULT);
    }
    updateSOAState({ patchState }, { soa }) {
        patchState({ ...soa });
    }
    async addSOATransaction(ctx, { sessionId, enrollment }) {
        const transaction = await (enrollment.enrollSystemType === EnrollSystemType.NextGen
            ? this.fetchNextGenTransaction$(sessionId, enrollment.nativeTransactionID).toPromise()
            : this.fetchTransaction$(enrollment.nativeTransactionID).toPromise());
        const soaTransaction = this.mapToSOATransaction(enrollment, transaction);
        ctx.setState(patch({ transactions: insertItem(soaTransaction), createdWhen: soaTransaction.createdWhen }));
    }
    async updateSOATransactionAnswers(ctx, { transactionId, pageAnswers, pageAnswersMap }) {
        if (pageAnswersMap) {
            ctx.dispatch(new UpdateNextGenSOATransactionAnswers(transactionId, pageAnswersMap));
        }
        else if (pageAnswers) {
            ctx.dispatch(new UpdateHopeSOATransactionAnswers(transactionId, pageAnswers));
        }
    }
    async updateNextGenSOATransactionAnswers({ setState }, { transactionId, pageAnswersMap }) {
        const prefillData = patch({
            ...Object.entries(pageAnswersMap).reduce((acc, [key, value]) => {
                const camelCasedName = this.stringFormatUtilityService.convertToCamelCase(key, true);
                acc[camelCasedName] = value;
                return acc;
            }, {})
        });
        setState(patch({
            transactions: updateItem(transaction => transaction.transactionGUID === transactionId || transaction.transactionSID === transactionId, patch({ prefillData, loading: true, loaded: false }))
        }));
        const transactionGUID = this.store.selectSnapshot(SOAState_1.transactionById(transactionId))?.transactionGUID;
        if (transactionGUID) {
            await this.httpClient
                .post(`${EnvironmentService.getEnvironment().WEB_SERVICE_BASE_URL}/V2/Enroll/${transactionGUID}/Answers`, pageAnswersMap)
                .toPromise();
            setState(patch({
                transactions: updateItem(transaction => transaction.transactionGUID === transactionId || transaction.transactionSID === transactionId, patch({ loading: false, loaded: true }))
            }));
        }
    }
    async updateHopeSOATransactionAnswers({ setState }, { transactionId, pageAnswers }) {
        const currentAnswers = this.store.selectSnapshot(SOAState_1.transactionAnswers(transactionId));
        const answers = currentAnswers.reduce((answers, currentAnswer) => {
            const updatedAnswer = pageAnswers?.find(pageAnswer => pageAnswer.name === currentAnswer.name);
            if (updatedAnswer) {
                answers.push(updatedAnswer);
            }
            else {
                answers.push(currentAnswer);
            }
            return answers;
        }, []);
        setState(patch({
            transactions: updateItem(transaction => transaction.transactionGUID === transactionId || transaction.transactionSID === transactionId, patch({ answers }))
        }));
    }
    async addSOADocument(ctx, { document, ownerId }) {
        const response = await this.soaHttpService.uploadDocument(document, ownerId);
        ctx.dispatch(new FetchSOADocuments(ownerId));
        return response;
    }
    setSOALoading(ctx, { loading }) {
        const { patchState } = ctx;
        patchState({ loading });
    }
    setHasValidCompletedSOA(ctx, { hasValidCompletedSOA }) {
        const { patchState } = ctx;
        patchState({ hasValidCompletedSOA });
    }
    async completeNextGenEnrollment(ctx, { nextGenEnrollmentRequest, transactionId }) {
        const { setState } = ctx;
        setState(patch({
            transactions: updateItem(transaction => transaction.transactionGUID === transactionId || transaction.transactionSID === transactionId, patch({
                loading: true,
                loaded: false
            }))
        }));
        const nextGenCompleteEnrollmentFormResponse = await this.httpClient
            .post(`${EnvironmentService.getEnvironment().WEB_SERVICE_BASE_URL}/v2/Enroll/${transactionId}/Submit`, nextGenEnrollmentRequest)
            .toPromise();
        setState(patch({
            transactions: updateItem(transaction => transaction.transactionGUID === transactionId || transaction.transactionSID === transactionId, patch({
                loaded: true,
                loading: false,
                ...nextGenCompleteEnrollmentFormResponse,
                // we have to assign confirmation number to prefill data because we use the
                // _enrollmentAnswer_.|activeEnrollmentKey|.ConfirmationNumber.value dynamic selector
                // to look this up in multiple places
                prefillData: patch({
                    confirmationNumber: nextGenCompleteEnrollmentFormResponse.confirmationNumber
                })
            }))
        }));
        // TODO: account for multiple enrollments?
        return nextGenCompleteEnrollmentFormResponse;
    }
    fetchTransaction$(transactionId) {
        return this.enrollmentHttpService.fetchTransaction$(transactionId);
    }
    fetchNextGenTransaction$(sessionId, transactionId) {
        return this.enrollmentHttpService.fetchNextGenTransaction$(sessionId, transactionId);
    }
    async fetchTransactions(sessionId, enrollments) {
        return await Promise.all(
        // eslint-disable-next-line @typescript-eslint/promise-function-async
        enrollments?.map(enrollment => (enrollment.enrollSystemType === EnrollSystemType.NextGen
            ? this.fetchNextGenTransaction$(sessionId, enrollment.nativeTransactionID).toPromise()
            : this.fetchTransaction$(enrollment.nativeTransactionID).toPromise()).then(transaction => this.mapToSOATransaction(enrollment, transaction))) ?? []);
    }
    mapToSOATransaction(enrollment, transaction) {
        return {
            ...enrollment,
            answers: transaction?.answers ?? null,
            prefillData: transaction?.prefillData ?? null,
            transactionGUID: transaction?.transactionGUID ?? enrollment.nativeTransactionID ?? null,
            transactionSID: transaction?.transactionSID ?? enrollment.transactionSID ?? null,
            publicFormID: transaction?.publicFormID ?? null,
            soaActivityType: enrollment.coverageTypeEvent,
            ...(enrollment.enrollSystemType === EnrollSystemType.NextGen && { loading: false, loaded: true })
        };
    }
};
SOAState.ɵfac = function SOAState_Factory(t) { return new (t || SOAState)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(i1$2.HttpClient), i0.ɵɵinject(EnrollmentHttpService), i0.ɵɵinject(SOAHttpService), i0.ɵɵinject(StringFormatUtilityService)); };
SOAState.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SOAState, factory: SOAState.ɵfac });
__decorate([
    Action(FetchSOATransactions)
], SOAState.prototype, "fetchSOATransactions", null);
__decorate([
    Action(FetchSOATransactionsSuccess)
], SOAState.prototype, "fetchSOATransactionsSuccess", null);
__decorate([
    Action(FetchSOATransactionsError)
], SOAState.prototype, "fetchSOATransactionsError", null);
__decorate([
    Action(SetNextGenSOAFormLoading)
], SOAState.prototype, "setNextGenSOAFormLoading", null);
__decorate([
    Action(SetNextGenSOAFormLoaded)
], SOAState.prototype, "setNextGenSOAFormLoaded", null);
__decorate([
    LiveEditInactive(),
    Action(FetchSOADocuments)
], SOAState.prototype, "fetchSOADocuments", null);
__decorate([
    Action(FetchSOADocumentsSuccess)
], SOAState.prototype, "fetchSOADocumentsSuccess", null);
__decorate([
    Action(FetchSOADocumentsError)
], SOAState.prototype, "fetchSOADocumentsError", null);
__decorate([
    Action(ResetSOAState)
], SOAState.prototype, "resetSOAState", null);
__decorate([
    Action(UpdateSOAState)
], SOAState.prototype, "updateSOAState", null);
__decorate([
    LiveEditInactive(),
    Action(AddSOATransaction)
], SOAState.prototype, "addSOATransaction", null);
__decorate([
    Action(UpdateSOATransactionAnswers)
], SOAState.prototype, "updateSOATransactionAnswers", null);
__decorate([
    Action(UpdateNextGenSOATransactionAnswers)
], SOAState.prototype, "updateNextGenSOATransactionAnswers", null);
__decorate([
    Action(UpdateHopeSOATransactionAnswers)
], SOAState.prototype, "updateHopeSOATransactionAnswers", null);
__decorate([
    LiveEditInactive(),
    Action(AddSOADocument)
], SOAState.prototype, "addSOADocument", null);
__decorate([
    Action(SetSOALoading)
], SOAState.prototype, "setSOALoading", null);
__decorate([
    Action(SetHasValidCompletedSOA)
], SOAState.prototype, "setHasValidCompletedSOA", null);
__decorate([
    Action(CompleteNextGenSOATransaction)
], SOAState.prototype, "completeNextGenEnrollment", null);
__decorate([
    Selector()
], SOAState, "soaState", null);
__decorate([
    Selector()
], SOAState, "createdWhen", null);
__decorate([
    Selector()
], SOAState, "transactions", null);
__decorate([
    Selector()
], SOAState, "documents", null);
__decorate([
    Selector()
], SOAState, "hasValidCompletedSOA", null);
__decorate([
    Selector()
], SOAState, "loading", null);
SOAState = SOAState_1 = __decorate([
    State({
        name: SOA_STORE_NAME,
        defaults: SOA_DEFAULT
    })
], SOAState);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SOAState, [{
        type: Injectable
    }], function () { return [{ type: i1.Store }, { type: i1$2.HttpClient }, { type: EnrollmentHttpService }, { type: SOAHttpService }, { type: StringFormatUtilityService }]; }, { fetchSOATransactions: [], fetchSOATransactionsSuccess: [], fetchSOATransactionsError: [], setNextGenSOAFormLoading: [], setNextGenSOAFormLoaded: [], fetchSOADocuments: [], fetchSOADocumentsSuccess: [], fetchSOADocumentsError: [], resetSOAState: [], updateSOAState: [], addSOATransaction: [], updateSOATransactionAnswers: [], updateNextGenSOATransactionAnswers: [], updateHopeSOATransactionAnswers: [], addSOADocument: [], setSOALoading: [], setHasValidCompletedSOA: [], completeNextGenEnrollment: [] }); })();

var ApplicationState_1;
/**
 * Encapsulating all our child stores in here so we can dynamically look up
 * memoized properties from any store.
 */
let ApplicationState = ApplicationState_1 = class ApplicationState {
    static property(prop) {
        return createSelector([ApplicationState_1], (state) => _get(state, prop));
    }
    // patches the state in the following ways
    // object test value to object state - merge the objects
    // array test value to array state - use test value array
    // array test value to object state - map array test value to payload field of object
    // object test value to array state - invalid mapping. ignore test value
    // primitive test value to primitive state value - use test value
    getPatchValue(stateValue, testValue) {
        if (_isObjectLike(stateValue)) {
            if (_isObjectLike(testValue)) {
                if (Array.isArray(stateValue)) {
                    if (Array.isArray(testValue)) {
                        // if both values are arrays use the test array
                        return [...testValue];
                    }
                    else {
                        // testValue is an object that we are trying to map to an array
                        // wrap this in an array
                        return [testValue];
                    }
                }
                else {
                    // state value is an object
                    if (Array.isArray(testValue)) {
                        // this is always plans data in the current iteration...
                        // TODO: think if this is ok and perhaps add a comment this is only to be used in live edit for now
                        return { ...stateValue, planTypeDataMap: PlansState.mapToPlanTypeMetadataMap(testValue) };
                    }
                    else {
                        // we are mapping object to object so merge
                        return _merge({}, stateValue, testValue);
                    }
                }
            }
        }
        else {
            // state value is not object like so we can only map other primitives to it
            if (!_isObjectLike(testValue)) {
                // if both values are not objects just return the test value
                return testValue;
            }
        }
        // return the original state value by default
        return stateValue;
    }
    // loads test data in a live edit application
    loadTestData(ctx, { testData }) {
        const { getState, patchState } = ctx;
        const state = getState();
        Object.keys(testData).forEach(key => {
            // if(state[key]) {
            // TODO: any additional checks? is there a better way to change this?
            // Depending on our specific needs for test data this may need to change over time
            // Should be good for just loading basic test data in though
            patchState({
                [key]: this.getPatchValue(state[key], testData[key])
            });
            // }
        });
    }
    // Currently this is essentially the same as load test data but forking as I have a feeling these
    // will evolve differently and I would like the seperate action names for console logging
    loadSessionData(ctx, { session }) {
        const { getState, patchState } = ctx;
        const state = getState();
        Object.keys(session).forEach(key => {
            if (state[key]) {
                patchState({
                    [key]: this.getPatchValue(state[key], session[key])
                });
            }
        });
    }
    setApplicationState({ setState }, { state }) {
        setState(state);
    }
};
ApplicationState.ɵfac = function ApplicationState_Factory(t) { return new (t || ApplicationState)(); };
ApplicationState.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApplicationState, factory: ApplicationState.ɵfac });
__decorate([
    Action(LoadTestData)
], ApplicationState.prototype, "loadTestData", null);
__decorate([
    Action(LoadSessionData)
], ApplicationState.prototype, "loadSessionData", null);
__decorate([
    Action(SetApplicationState)
], ApplicationState.prototype, "setApplicationState", null);
ApplicationState = ApplicationState_1 = __decorate([
    State({
        name: 'application',
        defaults: {},
        children: [
            AppConfigState,
            AgentState,
            MemberState,
            PlansState,
            RuntimeState,
            EnrollmentState,
            MedicineCabinetState,
            ConfirmationState,
            PharmacyState,
            ProviderState,
            GuidedHelpState,
            HelpfulToolsState,
            SOAState,
            MapState,
            QuoteBeneficiaryState,
            DeepLinkingParamsState,
            GoogleTagManagerState,
            BlueButtonMedicineCabinetState,
            JsonAnalyticsTagManagerState,
            ProviderState,
            TwilioState,
            SiteState
        ]
    })
], ApplicationState);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApplicationState, [{
        type: Injectable
    }], null, { loadTestData: [], loadSessionData: [], setApplicationState: [] }); })();

const DYNAMIC_SELECTOR_VALUE_REGEX = /\|.*?\|/;
/**
 * A service for app config resource operations
 */
class StoreResourceService {
    constructor(store) {
        this.store = store;
    }
    /**
     * Looking for a store value
     * @param prop
     */
    lookupStoreValue(prop) {
        // TODO: at some point in the future we may want to consider a more sophisticated syntax for querying the store
        // This isn't a short term goal however as this solution should cover 95% or more of the cases we will typically
        // encounter and the effort to create a query language is large
        // if we are dealing with a derived store property then replace and look up
        const selectorKey = Object.keys(StoreResourceService.selectorKeyMap).find(key => prop.startsWith(`${key}`));
        const selectorMatch = selectorKey ? StoreResourceService.selectorKeyMap[selectorKey] : null;
        if (selectorMatch && selectorMatch.selector) {
            let selectedObject = null;
            let propertyLookupIndex = 0;
            if (selectorMatch.isDynamicSelector) {
                const numberOfParameters = selectorMatch.parameters || 1;
                const propertyFragments = prop.split('.');
                const params = propertyFragments.reduce((selectorParams, property, index) => {
                    if (index > 0 && index <= numberOfParameters) {
                        const isDynamicSelectorParam = DYNAMIC_SELECTOR_VALUE_REGEX.test(property);
                        // TODO: it might be overkill to recurse here as for dynamic selector params we may just want none dynamic selectors
                        // would be very complicated to truly recurce here without creating a true query language
                        const resolvedParam = isDynamicSelectorParam ? this.lookupStoreValue(property.replace(/\|(.*)\|/, '_$1_')) : property;
                        selectorParams.push(resolvedParam);
                    }
                    return selectorParams;
                }, []);
                selectedObject = this.store.selectSnapshot(selectorMatch.selector(...params));
                propertyLookupIndex = prop.indexOf(propertyFragments[params.length]) + propertyFragments[params.length].length;
            }
            else {
                selectedObject = this.store.selectSnapshot(selectorMatch.selector);
                propertyLookupIndex = prop.indexOf('.');
            }
            if (propertyLookupIndex > 0) {
                return _get(selectedObject, prop.substring(propertyLookupIndex + 1));
            }
            return selectedObject;
        }
        return this.store.selectSnapshot(this.getMemoizedResource(prop));
    }
    getResourceObserver(prop) {
        return this.store.select(this.getMemoizedResource(prop));
    }
    getMemoizedResource(prop) {
        return ApplicationState.property(prop);
    }
}
// selectors that return objects we can further use dot notation to dive into
StoreResourceService.selectorKeyMap = {
    _selectedPlans_: { selector: ShoppingCartState.selectedPlanById, isDynamicSelector: true, parameters: 1 },
    _selectedPlan_: { selector: ShoppingCartState.selectedPlan, isDynamicSelector: false },
    _activeEnrollmentKey_: { selector: EnrollmentState.activeEnrollmentKey, isDynamicSelector: false },
    _enrollmentAnswer_: { selector: EnrollmentState.answer, isDynamicSelector: true, parameters: 2 },
    _recordingAvailable_: { selector: EnrollmentState.recordingAvailable, isDynamicSelector: false },
    _millimanUWTier_: { selector: MillimanState.millimanUWTier, isDynamicSelector: false },
    _millimanTierServiceCalled_: { selector: MedSupState.millimanTierServiceCalled, isDynamicSelector: false },
    _medSupMillimanServiceCalled_: { selector: MillimanState.hasMillimanServiceBeenCalled, isDynamicSelector: false },
    _selectedCounty_: { selector: DemographicState.selectedCounty, isDynamicSelector: false },
    _nextGenEnrollmentForms_: { selector: EnrollmentState.nextGenEnrollmentFormTransaction, isDynamicSelector: true, parameters: 1 }
};
StoreResourceService.ɵfac = function StoreResourceService_Factory(t) { return new (t || StoreResourceService)(i0.ɵɵinject(i1.Store)); };
StoreResourceService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: StoreResourceService, factory: StoreResourceService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StoreResourceService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.Store }]; }, null); })();

class ResourceHttpService {
    constructor(http) {
        this.http = http;
        this.environment = EnvironmentService.getEnvironment();
    }
    getContactInfoConfigResource$(sourceSiteId) {
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v2/Agent/SharedResources/${sourceSiteId}`);
    }
}
ResourceHttpService.ɵfac = function ResourceHttpService_Factory(t) { return new (t || ResourceHttpService)(i0.ɵɵinject(i1$2.HttpClient)); };
ResourceHttpService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ResourceHttpService, factory: ResourceHttpService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ResourceHttpService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1$2.HttpClient }]; }, null); })();

var ValueProviderType;
(function (ValueProviderType) {
    ValueProviderType["NESTED"] = "nested";
    ValueProviderType["SESSION"] = "session";
})(ValueProviderType || (ValueProviderType = {}));
const NESTED_RESOURCE_REGEX = /\[\[(.*?)\]\]/;
const SESSION_RESOURCE_REGEX = /{{\[(.*?)\]}}/;
const EVALUATED_REGEX = /{{(.*?)(\(.*?\))?}}/;
const MAX_RECURSION_DEPTH = 5;
const CONFIG_DATE_FORMAT = 'MM-dd-yyyy';
var RESOURCE_ENVIRONMENT;
(function (RESOURCE_ENVIRONMENT) {
    RESOURCE_ENVIRONMENT["STAGING"] = "STG";
})(RESOURCE_ENVIRONMENT || (RESOURCE_ENVIRONMENT = {}));
/**
 * A service for app config resource operations
 */
class ConfigResourceService {
    constructor(store, storeResourceService, utilityFunctionService, navigationContext, localeService, resourceHttpService) {
        this.store = store;
        this.storeResourceService = storeResourceService;
        this.utilityFunctionService = utilityFunctionService;
        this.navigationContext = navigationContext;
        this.localeService = localeService;
        this.resourceHttpService = resourceHttpService;
        this.providerAlreadyRegistered = (providers, provider) => providers.find(currentValueProvider => currentValueProvider.type === provider.type && currentValueProvider.resourceKey === provider.resourceKey);
        this.liveEdit = EnvironmentService.getEnvironment().liveedit;
    }
    // look up a resource value given our override property
    lookupPropertyValue(prop, widgetName) {
        if (prop) {
            let value;
            if (prop.type === PropertyType.VALUE) {
                value = prop.value;
            }
            else if (typeof prop.value === 'string') {
                value = this.lookupResourceValue(prop.value, widgetName);
            }
            return this.processValueProviders(value, widgetName);
        }
        return null;
    }
    // get all the information needed to look up a provided value
    getValueProviderMeta(prop, widgetName, pageName) {
        if (prop) {
            if (prop.type === PropertyType.VALUE) {
                // If we have a value type then the string is the only thing we need
                // to parse for value providers
                return prop.value;
            }
            if (typeof prop.value === 'string') {
                // if we have a resource we need to get the resource object
                // to add value providers for potential conditional resources
                return this.getResourceLookupObject(this.lookupResource(prop.value, widgetName, pageName));
            }
        }
        return null;
    }
    // gets the conditions object or resource name for looking up resource information
    getResourceLookupObject(resource) {
        if (resource) {
            return resource.conditions ? resource : resource.value;
        }
        else {
            // no corresponding resource for this prop, page and widget
            return null;
        }
    }
    // retrieve a resource as it is in the config json
    lookupResource(resourceKey, widgetName, pageName) {
        return this.store.selectSnapshot(this.getMemoizedResource(resourceKey, widgetName, pageName));
    }
    // retrieve a resource as it is in the config json
    lookupResourceMetadata(resourceKey, widgetName) {
        const ret = this.store.selectSnapshot(AppConfigState.resourceMeta(resourceKey, this.navigationContext.getUrl(), widgetName));
        return ret;
    }
    /**
     * Gets the value of a resource by key and widget and processes any value provider lookups.
     * @param resourceKey
     * @param resourceDefault
     * @param widgetName
     * @param returnSelector
     * @param pageName - Use this when you want to target a specific page scoped resource. Typically this should
     * be avoided as we default to navigationContext.getUrl to get the current url but this is set on NavigationEnd
     * so if you are looking to get a page scoped resource in a resolver or guard OR are interested in a page scoped
     * resource from a page the user currently does not reside on you will need to use this. WARNING: This should NOT
     * be used in a wide spread fashion and is more for one off scenarios or scenarios involving page scoped
     * guard/resolver resources.
     */
    getProcessedResourceValue(resourceKey, widgetName, resourceDefault, returnSelector = false, pageName) {
        const valueProviders = this.retrieveValueProviders({ prop: resourceKey, value: resourceKey, type: PropertyType.RESOURCE }, widgetName);
        if (valueProviders?.length) {
            return this.getFreshProcessedResourceValue(resourceKey, widgetName, resourceDefault, returnSelector, pageName);
        }
        else {
            const locale = this.localeService.getCurrentLocale();
            return this.getCachedProcessedResourceValue(resourceKey, widgetName, resourceDefault, returnSelector, pageName, locale);
        }
    }
    getFreshProcessedResourceValue(resourceKey, widgetName, resourceDefault, returnSelector = false, pageName) {
        const resourceValue = this.lookupResourceValue(resourceKey, widgetName, pageName);
        let result = this.processValueProviders(resourceValue, widgetName, returnSelector);
        if (result === null || result === undefined) {
            // no resource found
            // assign default after processing for nested values or ordinal/display keys
            result = this.processValueProviders(resourceDefault, widgetName, returnSelector);
        }
        return result;
    }
    getCachedProcessedResourceValue(resourceKey, widgetName, resourceDefault, returnSelector = false, pageName, locale // merely for memoizing values on a per locale basis
    ) {
        return this.getFreshProcessedResourceValue(resourceKey, widgetName, resourceDefault, returnSelector, pageName);
    }
    // get a resource value
    // will look through condition mappings in order and return the value for the
    // first condition to resolve to true. otherwise this will return the resources value
    getValue(resource) {
        if (resource && resource.conditions) {
            const conditionValue = this.evaluateConditions(resource);
            if (typeof conditionValue !== 'undefined' && conditionValue !== null) {
                return conditionValue;
            }
        }
        // if this is a resource property and no conditions were found
        // or if this is a value resource use the default value
        return resource.value;
    }
    // get an observer for a resource so we can subscribe to resource updates
    // and refresh the page when appropriate
    getResourceObserver(prop, widgetName) {
        return this.store.select(this.getMemoizedResource(prop, widgetName));
    }
    // interacting with the NGXS store to get our memoized selector
    getMemoizedResource(prop, widgetName, pageName) {
        return AppConfigState.resource(prop, pageName ?? this.navigationContext.getUrl(), widgetName);
    }
    // processing value providers in order
    processValueProviders(value, widgetName, returnSelector = false, whiteListedResourceKeys = []) {
        // recursively process arrays and objects for resources
        if (Array.isArray(value)) {
            value = this.processArray(value, widgetName);
        }
        else if (typeof value === 'object' && value !== null) {
            value = Object.keys(value).reduce((obj, key) => {
                obj[key] = this.processValueProviders(value[key], widgetName, returnSelector);
                return obj;
            }, {});
        }
        else if (_isString(value)) {
            value = this.resolveValueProviders(value, widgetName, NESTED_RESOURCE_REGEX, 0, returnSelector, whiteListedResourceKeys);
            // if we got an object/array from a resource lookup then we need to recurse
            // so we can process nested properties
            if (!_isString(value)) {
                return this.processValueProviders(value, widgetName, returnSelector);
            }
            value = this.resolveValueProviders(value, widgetName, SESSION_RESOURCE_REGEX, 0, returnSelector);
            value = this.resolveValueProviders(value, widgetName, EVALUATED_REGEX, 0, returnSelector);
        }
        return value;
    }
    lookupTypeValue(type, match, widgetName) {
        let typeValue;
        if (type === NESTED_RESOURCE_REGEX) {
            typeValue = this.lookupResourceValue(match[1], widgetName);
        }
        else if (type === SESSION_RESOURCE_REGEX) {
            typeValue = this.storeResourceService.lookupStoreValue(match[1]);
        }
        else if (type === EVALUATED_REGEX) {
            const parameters = match[2] ? this.getEvaluatedParameters(match[2]) : [];
            const utilityFunction = this.utilityFunctionService.getUtilityFunction(match[1]);
            if (utilityFunction) {
                typeValue = utilityFunction(...parameters);
            }
        }
        return typeValue;
    }
    /**
     * Scans our text value for value providers and resolves them in turn.
     * whiteListedResourceKeys - A list of resource keys that should be resolved. If empty then all
     * resource keys in a given string will be resolved (this is the default behavior). This only
     * applies to NESTED_RESOURCE_REGEX lookups. This means store values and utility function calls
     * will be resolved regardless of what is passed in the white list of resource keys.
     */
    resolveValueProviders(value, widgetName, type, depth = 0, returnSelector = false, whiteListedResourceKeys = []) {
        if (_isString(value) && depth <= MAX_RECURSION_DEPTH) {
            let result = '';
            let offset = 0;
            let match;
            let lookupValueFound = false;
            let whiteListMatch = false;
            while ((match = type.exec(value.substr(offset))) !== null) {
                if (match.index > 0) {
                    result += value.substr(offset, match.index);
                }
                let typeValue;
                // Used when we have a large string with multiple resource lookups, only some of which
                // we care to resolve. This is primarily only expected to be used in one IE use case
                // relating to email processing but technically we now have a hook to only process what we want
                if (whiteListedResourceKeys.length && !whiteListedResourceKeys.includes(match[1])) {
                    typeValue = match[0];
                    whiteListMatch = true;
                }
                else {
                    typeValue = this.lookupTypeValue(type, match, widgetName);
                    if (returnSelector && !(_isString(typeValue) && typeValue.trim().length !== 0) && !typeValue) {
                        typeValue = match[0];
                    }
                }
                if (typeof typeValue !== 'undefined' && typeValue !== null) {
                    lookupValueFound = true;
                    // if we are resolving a non-string value and we do not have a result yet then make the result that value
                    // type otherwise we will just append the stringified version of the return type to the string as it is
                    // being used as a display value
                    if (result || typeof typeValue === 'string') {
                        result += typeValue;
                    }
                    else {
                        result = typeValue;
                    }
                }
                else {
                    lookupValueFound = false;
                }
                offset += match.index + match[0].length;
            }
            if (offset < value.length) {
                result += value.substr(offset);
            }
            // if we are unable to resolve a lookup value then return the result to prevent
            // infinite recursion and visually signal to the user which lookup values are
            // the issue
            if (lookupValueFound && typeof result === 'string' && type.exec(result) !== null && !returnSelector && !whiteListMatch) {
                result = this.resolveValueProviders(result, widgetName, type, (depth += 1));
            }
            return result;
        }
        if (depth > MAX_RECURSION_DEPTH) {
            console.log('Max recursion depth exceeded. This can be a sign of a circular reference. Value at time of exception: ' + value);
            return '';
        }
        return value;
    }
    // if our function has parameters lets parse them so we can use them
    getEvaluatedParameters(paramMatch) {
        let evalParams = [];
        // remove parentheses and quotations from evaluated parameters
        evalParams = paramMatch.slice(1, -1).replace(/'/g, '').split(', ');
        return evalParams;
    }
    // scanning conditions and text values for any references to resource, session,
    // or function value providers so we can create subscribers and subscribe to updates
    retrieveValueProviders(prop, widgetName) {
        const pageName = this.navigationContext.getUrl();
        if (this.liveEdit) {
            // since the app config is dynamic in live edit as it can be modified
            // by the package call and live edit update calls we cannot get a cached
            // value and must check for value providers every time
            return this.retrieveFreshValueProviders(prop, widgetName, pageName);
        }
        // in non live edit scenarios we can reasonably cache this function even though
        // it is not pure because the config.json should not change
        const locale = this.localeService.getCurrentLocale();
        return this.retrieveCachedValueProviders(prop, widgetName, pageName, locale);
    }
    // This function is not pure but we are memoizing it because it should be pure based on
    // the state of the config.json and we will gain some performance by treating this as such.
    // Proceed with caution on changing this or using it as a standalone outside of ConfigurableWidget
    retrieveCachedValueProviders(prop, widgetName, pageName, locale) {
        return this.getValueProviders(prop, widgetName, pageName);
    }
    retrieveFreshValueProviders(prop, widgetName, pageName) {
        return this.getValueProviders(prop, widgetName, pageName);
    }
    // See note on retrieveCachedValueProviders
    getValueProviders(prop, widgetName, pageName) {
        const resourceValue = this.getValueProviderMeta(prop, widgetName, pageName);
        if (resourceValue?.conditions) {
            return this.scanConditionsForValueProviders(resourceValue, widgetName, pageName);
        }
        else {
            return this.parseForValueProviders(resourceValue, 0, widgetName, pageName);
        }
    }
    getConditionProviders(condition) {
        const providers = [];
        // if we can get an actual value then we will parse it as we are supposed to
        if (condition) {
            const left = condition.left;
            const right = condition.right;
            if (condition.values && condition.type) {
                if (condition.type === "Resource" /* ValueType.Resource */) {
                    const resourceValueProvider = { type: ValueProviderType.NESTED, resourceKey: condition.values[0] };
                    if (!this.providerAlreadyRegistered(providers, resourceValueProvider)) {
                        providers.push(resourceValueProvider);
                    }
                }
                else if (condition.type === "Session" /* ValueType.Session */ || condition.type === "ValueProviders" /* ValueType.ValueProviders */) {
                    const sessionValueProvider = { type: ValueProviderType.SESSION, resourceKey: condition.values[0] };
                    if (!this.providerAlreadyRegistered(providers, sessionValueProvider)) {
                        providers.push(sessionValueProvider);
                    }
                }
            }
            else if (left && right) {
                const leftProviders = this.getConditionProviders(left);
                const rightProviders = this.getConditionProviders(right);
                if (leftProviders) {
                    for (let i = 0, n = leftProviders.length; i < n; ++i) {
                        const leftProvider = leftProviders[i];
                        if (!this.providerAlreadyRegistered(providers, leftProvider)) {
                            providers.push(leftProvider);
                        }
                    }
                }
                if (rightProviders) {
                    for (let i = 0, n = rightProviders.length; i < n; ++i) {
                        const rightProvider = rightProviders[i];
                        if (!this.providerAlreadyRegistered(providers, rightProvider)) {
                            providers.push(rightProvider);
                        }
                    }
                }
            }
        }
        return providers;
    }
    scanConditionsForValueProviders(resource, widgetName, pageName) {
        const valueProviders = [];
        const conditions = resource.conditions;
        for (let i = 0, n = conditions.length; i < n; ++i) {
            const condition = conditions[i];
            if (condition) {
                const conditionProviders = this.getConditionProviders(condition.condition);
                if (conditionProviders) {
                    for (let i = 0, n = conditionProviders.length; i < n; ++i) {
                        const cProvider = conditionProviders[i];
                        if (!this.providerAlreadyRegistered(valueProviders, cProvider)) {
                            valueProviders.push(cProvider);
                        }
                    }
                }
                const conditionValueProviders = this.parseForValueProviders(condition.value, 0, widgetName, pageName);
                if (conditionValueProviders) {
                    for (let i = 0, n = conditionValueProviders.length; i < n; ++i) {
                        const cvProvider = conditionValueProviders[i];
                        if (!this.providerAlreadyRegistered(valueProviders, cvProvider)) {
                            valueProviders.push(cvProvider);
                        }
                    }
                }
            }
        }
        if (resource.value) {
            const defaultValueProviders = this.parseForValueProviders(resource.value, 0, widgetName, pageName);
            if (defaultValueProviders) {
                for (let i = 0, n = defaultValueProviders.length; i < n; ++i) {
                    const dvProvider = defaultValueProviders[i];
                    if (!this.providerAlreadyRegistered(valueProviders, dvProvider)) {
                        valueProviders.push(dvProvider);
                    }
                }
            }
        }
        return valueProviders;
    }
    // parse a string for value providers by name and type so we can set up an observer for each
    // one so that the page automatically updates when their value changes
    parseForValueProviders(resourceValue, depth = 0, widgetName, pageName) {
        const resourceValueProviders = [];
        // recursively process arrays and objects for resources
        if (typeof resourceValue === 'object' && resourceValue !== null) {
            const resourceKeys = Object.keys(resourceValue);
            for (let i = 0, n = resourceKeys.length; i < n; ++i) {
                const key = resourceKeys[i];
                // depth remains the same as it is used to limit nesting resources
                const valueProviders = this.parseForValueProviders(resourceValue[key], depth, widgetName, pageName);
                for (let i = 0, n = valueProviders.length; i < n; ++i) {
                    const valueProvider = valueProviders[i];
                    // only push non-existing value providers
                    if (!resourceValueProviders.some(resourceValueProvider => resourceValueProvider.resourceKey === valueProvider.resourceKey && resourceValueProvider.type === valueProvider.type)) {
                        resourceValueProviders.push(valueProvider);
                    }
                }
            }
        }
        else if (_isString(resourceValue) && depth <= MAX_RECURSION_DEPTH) {
            let offset = 0;
            let match;
            // check for nested resources
            // TODO: if config has a circular reference this will bomb out currently
            while ((match = NESTED_RESOURCE_REGEX.exec(resourceValue.substr(offset))) !== null) {
                // match[1] is the second capture group and should be the text within the brackets as long as the regex doesn't change
                const valueProviderRegistered = resourceValueProviders.find(currentValueProvider => currentValueProvider.type === ValueProviderType.NESTED && currentValueProvider.resourceKey === match[1]);
                // check this so we don't register the same value providers twice
                if (!valueProviderRegistered) {
                    resourceValueProviders.push({ type: ValueProviderType.NESTED, resourceKey: match[1] });
                    // check for nested value providers
                    const nestedValueProviders = this.parseForValueProviders(this.lookupResourceValue(match[1], widgetName, pageName), (depth += 1), widgetName, pageName);
                    for (let i = 0, n = nestedValueProviders.length; i < n; ++i) {
                        const nestedValueProvider = nestedValueProviders[i];
                        const nestedProviderRegistered = resourceValueProviders.find(currentValueProvider => currentValueProvider.type === nestedValueProvider.type &&
                            currentValueProvider.resourceKey === nestedValueProvider.resourceKey);
                        // check this so we don't register the same value providers twice
                        if (!nestedProviderRegistered) {
                            resourceValueProviders.push(nestedValueProvider);
                        }
                    }
                }
                // start checking next chunk for value provider strings
                offset += match.index + match[0].length;
            }
            // check for session resources
            while ((match = SESSION_RESOURCE_REGEX.exec(resourceValue.substr(offset))) !== null) {
                resourceValueProviders.push({ type: ValueProviderType.SESSION, resourceKey: match[1] });
                offset += match.index + match[0].length;
            }
        }
        if (depth > MAX_RECURSION_DEPTH) {
            // log error
            console.log('Max recursion depth exceeded. This can be a sign of a circular reference. Value at time of exception: ' +
                JSON.stringify(resourceValueProviders));
            return [];
        }
        return resourceValueProviders;
    }
    // getting the value from a condition node for evaluation
    // if a condition references itself at any point we return null from
    // the method to prevent infinite recursion
    retrieveConditionValue(resourceName, widgetName, type, values) {
        const value = values[0];
        if (typeof value === 'undefined' || value === null) {
            return null;
        }
        if (type === "Boolean" /* ValueType.Boolean */) {
            // if we have anything passed in but true or 'true' then the value will be false
            // we expect string values from platform as of now but coding this defensively
            // so boolean values don't break this if ever passed to us now or in the future
            if (!value) {
                return false;
            }
            return `${value}`.toLowerCase() === 'true';
        }
        else if (type === "String" /* ValueType.String */) {
            return values.length > 1 ? values : value;
        }
        else if (type === "Integer" /* ValueType.Integer */) {
            const intValue = +value;
            return isNaN(intValue) ? null : intValue;
        }
        else if (type === "DateTime" /* ValueType.DateTime */) {
            return new Date(value);
        }
        else if (type === "Resource" /* ValueType.Resource */) {
            if (resourceName === value) {
                console.log(`Self reference found in ${value} resource`);
                return null;
            }
            return this.lookupPropertyValue({ prop: value, type: PropertyType.RESOURCE, value }, widgetName);
        }
        else if (type === "ValueProviders" /* ValueType.ValueProviders */ || type === "Session" /* ValueType.Session */) {
            return this.getValueProviderConditionValue(value);
        }
    }
    evaluateConditions(resource, widgetName) {
        const conditions = resource.conditions;
        if (conditions) {
            const match = conditions.find(conditionMap => this.evaluateCondition(resource.name, widgetName, conditionMap.condition));
            if (typeof match?.value !== 'undefined') {
                return match.value;
            }
        }
        return null;
    }
    evaluateCondition(resourceName, widgetName, condition) {
        const left = condition.left;
        const right = condition.right;
        const nodeType = condition.nodeType;
        if (nodeType) {
            let leftValue = left.type && left.values
                ? this.retrieveConditionValue(resourceName, widgetName, left.type, left.values)
                : this.evaluateCondition(resourceName, widgetName, left);
            let rightValue = right.type && right.values
                ? this.retrieveConditionValue(resourceName, widgetName, right.type, right.values)
                : this.evaluateCondition(resourceName, widgetName, right);
            // we can source a date from different locations including date time functions
            // and datetime values. if we are attempting a comparison with a date we need
            // to make sure we have a uniform basis for comparison
            if (left.type === "DateTime" /* ValueType.DateTime */ || right.type === "DateTime" /* ValueType.DateTime */) {
                leftValue = leftValue instanceof Date ? leftValue : new Date(leftValue);
                rightValue = rightValue instanceof Date ? rightValue : new Date(rightValue);
            }
            return this.evaluateConditionPredicate(leftValue, rightValue, nodeType);
        }
        // value not found
        return null;
    }
    fetchContactResource$(sourceSiteId) {
        return this.resourceHttpService.getContactInfoConfigResource$(sourceSiteId);
    }
    updateConfigResource(resourceBundle) {
        this.store.dispatch(new UpdateConfigResource(resourceBundle));
    }
    setContactInfoConfig(sharedResources) {
        this.store.dispatch(new SetContactInfoConfig(sharedResources));
    }
    isDynamicResourceAllowed(resourceName) {
        return DYNAMICALLY_UPDATED_RESOURCES.includes(resourceName);
    }
    evaluateConditionPredicate(leftValue, rightValue, nodeType) {
        if (nodeType === "AndAlso" /* ConditionNodeType.AndAlso */) {
            return leftValue && rightValue;
        }
        else if (nodeType === "Equal" /* ConditionNodeType.Equal */) {
            // if the left value and right value are different types this will fail as we are using strict equality
            // this is preferable as we don't want to rely on javascript type conversion as it can give us some odd results
            return leftValue === rightValue;
        }
        else if (nodeType === "GreaterThan" /* ConditionNodeType.GreaterThan */) {
            return leftValue > rightValue;
        }
        else if (nodeType === "GreaterThanOrEqual" /* ConditionNodeType.GreaterThanOrEqual */) {
            return leftValue >= rightValue;
        }
        else if (nodeType === "In" /* ConditionNodeType.In */) {
            // if rightValue is not an array you don't get to use In
            return Array.isArray(rightValue) ? rightValue.includes(leftValue) : false;
        }
        else if (nodeType === "LessThan" /* ConditionNodeType.LessThan */) {
            return leftValue < rightValue;
        }
        else if (nodeType === "LessThanOrEqual" /* ConditionNodeType.LessThanOrEqual */) {
            return leftValue <= rightValue;
        }
        else if (nodeType === "NotEqual" /* ConditionNodeType.NotEqual */) {
            return leftValue !== rightValue;
        }
        else if (nodeType === "NotIn" /* ConditionNodeType.NotIn */) {
            // if rightValue is not an array you don't get to use NotIn
            return Array.isArray(rightValue) ? !rightValue.includes(leftValue) : false;
        }
        else if (nodeType === "OrElse" /* ConditionNodeType.OrElse */) {
            return leftValue || rightValue;
        }
        return null;
    }
    // the list of all available resources
    getAvailableResource$() {
        return this.store.select(AppConfigState.resourceSet());
    }
    getEnvironment() {
        return this.store.selectSnapshot(AppConfigState.environment);
    }
    isTestingSite() {
        return this.getEnvironment() === RESOURCE_ENVIRONMENT.STAGING;
    }
    updateResource$(liveEditProp) {
        return this.store.dispatch(new UpdateResource(liveEditProp));
    }
    getLiveEditProp(pageName, widgetName, zoneKey, propName, overrideKey) {
        const liveEditProp = {};
        let resourceToEdit;
        // check if we have an override prop
        const prop = this.store.selectSnapshot(AppConfigState.prop(pageName, widgetName, zoneKey, propName, overrideKey));
        // if so lets check for a resource associated with this override
        if (prop) {
            // should only be updating resources, not value overrides, in live edit
            if (prop.type === PropertyType.RESOURCE && typeof prop.value === 'string') {
                resourceToEdit = this.lookupResource(prop.value, widgetName);
            }
            else {
                return null;
            }
        }
        else {
            // if we don't have an override let's look for a fallback resource to use
            resourceToEdit = this.lookupResource(propName, widgetName);
        }
        if (resourceToEdit) {
            // if we decide to allow live edit value updates in the future this will have to
            // change but that doesn't seem to be a priority
            liveEditProp.prop = { prop: resourceToEdit.name, value: resourceToEdit.name, type: PropertyType.RESOURCE };
            liveEditProp.resource = resourceToEdit;
            const metadata = this.lookupResourceMetadata(resourceToEdit.name, widgetName);
            if (metadata) {
                liveEditProp.metadata = metadata;
            }
            else {
                console.log('No metadata found for ' + resourceToEdit.name);
                return null;
            }
            const resourceLang = this.store.selectSnapshot(AppConfigState.widgetLanguage(resourceToEdit.name, pageName, widgetName));
            if (typeof resourceLang !== 'undefined') {
                liveEditProp.lang = resourceLang;
            }
            else {
                console.log('Unable to find resource lang for ' + resourceToEdit.name);
            }
        }
        else {
            console.log(`No resource found for: pageName: ${pageName} widgetName: ${widgetName} zoneKey: ${zoneKey} propName: ${propName}`);
            return null;
        }
        return liveEditProp;
    }
    // retrieve a resource value by resource key
    lookupResourceValue(resourceKey, widgetName, pageName) {
        const resource = this.lookupResource(resourceKey, widgetName, pageName);
        return resource ? this.getValue(resource) : null;
    }
    // most of the time array display values will be booleans but if they are strings
    // we need to treat them as booleans rather than performing a simple truthy check
    // in case if display is not mean to be a boolean property then we need to verify its value that either its a true or not equal to false
    shouldDisplayArrayValue(display) {
        return typeof display === 'string' ? display.toLowerCase() === 'true' || display.toLowerCase() !== 'false' : !!display;
    }
    processArray(array, widgetName) {
        if (!array || array.length === 0) {
            return array;
        }
        let processedArray = [];
        processedArray = array.reduce((arr, item) => {
            const processedItem = this.processValueProviders(item, widgetName);
            const itemValue = typeof processedItem !== 'undefined' && processedItem !== null ? processedItem : item;
            if (typeof itemValue.display !== 'undefined') {
                const shouldDisplayArrayValue = this.shouldDisplayArrayValue(itemValue.display);
                if (shouldDisplayArrayValue) {
                    arr.push(itemValue);
                }
            }
            else {
                arr.push(itemValue);
            }
            return arr;
        }, []);
        processedArray.sort((a, b) => {
            const ordinalA = a.ordinal;
            const ordinalB = b.ordinal;
            if (ordinalA === ordinalB) {
                return 0;
            }
            // no ordinal sorts after everything
            if (typeof ordinalA === 'undefined') {
                return 1;
            }
            // a is not null so it has a numeric and thus it goes before ordinalB when its null
            if (typeof ordinalB === 'undefined') {
                return -1;
            }
            return ordinalA < ordinalB ? -1 : 1;
        });
        return processedArray;
    }
    getValueProviderConditionValue(value) {
        const valueProviderString = value || '';
        const openParensIndex = valueProviderString.indexOf('(');
        const closeParensIndex = valueProviderString.indexOf(')');
        const functionName = openParensIndex > 0 ? valueProviderString.substring(0, openParensIndex) : valueProviderString;
        const utilityFunction = this.utilityFunctionService.getUtilityFunction(functionName);
        if (utilityFunction) {
            const isValidParamsString = openParensIndex > 0 && closeParensIndex > openParensIndex;
            const paramsString = isValidParamsString ? valueProviderString.substring(openParensIndex + 1, closeParensIndex) : '';
            const params = paramsString.split(',');
            const trimmedParams = params.map(param => this.trimString(param));
            return utilityFunction(...trimmedParams);
        }
        return this.storeResourceService.lookupStoreValue(value);
    }
    trimString(param) {
        if (param) {
            const trimmedParam = param.trim();
            const startChar = trimmedParam.substring(0, 1);
            const endCharIndex = trimmedParam.length - 1;
            const endChar = trimmedParam.substring(endCharIndex, param.length);
            if ((startChar === "'" && endChar === "'") || (startChar === '"' && endChar === '"')) {
                return trimmedParam.substring(1, endCharIndex);
            }
        }
        return param;
    }
}
ConfigResourceService.ɵfac = function ConfigResourceService_Factory(t) { return new (t || ConfigResourceService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(StoreResourceService), i0.ɵɵinject(UtilityFunctionService), i0.ɵɵinject(NavigationContext), i0.ɵɵinject(LocaleService), i0.ɵɵinject(ResourceHttpService)); };
ConfigResourceService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ConfigResourceService, factory: ConfigResourceService.ɵfac, providedIn: 'root' });
__decorate([
    Memoize()
], ConfigResourceService.prototype, "getCachedProcessedResourceValue", null);
__decorate([
    Memoize()
], ConfigResourceService.prototype, "getEvaluatedParameters", null);
__decorate([
    Memoize()
], ConfigResourceService.prototype, "retrieveCachedValueProviders", null);
__decorate([
    Memoize()
], ConfigResourceService.prototype, "evaluateConditionPredicate", null);
__decorate([
    Memoize()
], ConfigResourceService.prototype, "trimString", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfigResourceService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.Store }, { type: StoreResourceService }, { type: UtilityFunctionService }, { type: NavigationContext }, { type: LocaleService }, { type: ResourceHttpService }]; }, { getCachedProcessedResourceValue: [], getEvaluatedParameters: [], retrieveCachedValueProviders: [], evaluateConditionPredicate: [], trimString: [] }); })();

class DecoupledArrayItemsIdentifiers {
}
const EXTERNAL_RATING_SERVICE_IDENTIFIERS = {
    data: 'planID',
    requestData: 'planIDs',
    key: 'mediGapAnswers'
};

class CacheContext {
    constructor() {
        this._bustCache$ = new Subject();
    }
    bustCache() {
        this._bustCache$.next(null);
    }
    observeForCacheBust$() {
        return this._bustCache$.asObservable();
    }
}
CacheContext.ɵfac = function CacheContext_Factory(t) { return new (t || CacheContext)(); };
CacheContext.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CacheContext, factory: CacheContext.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CacheContext, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

class DecoupledArrayItemsCacheService {
    constructor(cacheContext) {
        this.cacheContext = cacheContext;
        /**
         * This cache is for when we need to update the cache with values, without the est the values came in being important.
         * I.E. if we added ids 1,2,3 and 4 in one call, and then we ask for just ids 1 and 3, the cache will provide those
         * instead of returning nothing like the default cache would, as no previous request for just 1 and 3 was made.
         *
         * Essentially, all the items cached are decoupled from the request and from each other.
         */
        this.cache = new Map();
        this.subscriptions = new Subscription();
        this.bustCache$ = this.cacheContext.observeForCacheBust$();
        this.subscriptions.add(this.bustCache$.subscribe({
            next: () => {
                this.bustCache();
            }
        }));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    updateCache(data, dataIdentifier, key) {
        data.forEach(item => {
            this.cache.set(JSON.stringify({ [dataIdentifier]: item[dataIdentifier], key }), item);
        });
    }
    fetchFromCache(dataValue, dataIdentifier, key) {
        return this.cache.get(JSON.stringify({ [dataIdentifier]: dataValue, key }));
    }
    getValuesByRequest(request, identifiers) {
        const keyData = request?.body[identifiers.key] ?? [];
        const dataFromRequestByIdentifier = request?.body[identifiers.requestData] ?? [];
        return dataFromRequestByIdentifier.reduce((cachedDataByIdentifier, dataValue) => {
            const cachedData = this.fetchFromCache(dataValue, identifiers.data, keyData);
            if (cachedData) {
                cachedDataByIdentifier.push(cachedData);
            }
            return cachedDataByIdentifier;
        }, []);
    }
    getCacheFromExternallyRatedPlansCache(req) {
        const newBody = this.getValuesByRequest(req, EXTERNAL_RATING_SERVICE_IDENTIFIERS);
        if (newBody.length === req.body[EXTERNAL_RATING_SERVICE_IDENTIFIERS.requestData]?.length) {
            return new HttpResponse({ body: newBody, headers: req.headers });
        }
    }
    updateExternallyRatedPlansCacheByRequest(req, stateEvent) {
        const externalRatingData = stateEvent?.body;
        const medSupAnswers = req?.body[EXTERNAL_RATING_SERVICE_IDENTIFIERS.key];
        if (externalRatingData?.length && medSupAnswers?.length) {
            this.updateCache(externalRatingData, EXTERNAL_RATING_SERVICE_IDENTIFIERS.data, medSupAnswers);
        }
    }
    bustCache() {
        this.cache.clear();
    }
}
DecoupledArrayItemsCacheService.ɵfac = function DecoupledArrayItemsCacheService_Factory(t) { return new (t || DecoupledArrayItemsCacheService)(i0.ɵɵinject(CacheContext)); };
DecoupledArrayItemsCacheService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DecoupledArrayItemsCacheService, factory: DecoupledArrayItemsCacheService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DecoupledArrayItemsCacheService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: CacheContext }]; }, null); })();

const EXTERNAL_RATING_SERVICE = 'Plans/ExternalRatingService';
const CUSTOM_CACHED_URLS = [EXTERNAL_RATING_SERVICE];
class VNextCustomCacheService {
    constructor(decoupledArrayItemsCacheService) {
        this.decoupledArrayItemsCacheService = decoupledArrayItemsCacheService;
    }
    isSupportedServiceUrl(endpointUrl) {
        return CUSTOM_CACHED_URLS.includes(endpointUrl);
    }
    getCacheFromCustomCacheService(req, endpointUrl) {
        switch (endpointUrl) {
            case EXTERNAL_RATING_SERVICE:
                return this.getItemsFromExternallyRatedPlansCache(req);
            // Add more custom cache options here in the future
            default:
                break;
        }
    }
    setCustomCache(req, stateEvent, endpointUrl) {
        switch (endpointUrl) {
            case EXTERNAL_RATING_SERVICE:
                this.updateExternallyRatedPlansCacheByRequest(req, stateEvent);
            // Add more custom cache options here in the future
            default:
                break;
        }
    }
    getItemsFromExternallyRatedPlansCache(req) {
        return this.decoupledArrayItemsCacheService.getCacheFromExternallyRatedPlansCache(req);
    }
    updateExternallyRatedPlansCacheByRequest(req, stateEvent) {
        return this.decoupledArrayItemsCacheService.updateExternallyRatedPlansCacheByRequest(req, stateEvent);
    }
}
VNextCustomCacheService.ɵfac = function VNextCustomCacheService_Factory(t) { return new (t || VNextCustomCacheService)(i0.ɵɵinject(DecoupledArrayItemsCacheService)); };
VNextCustomCacheService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: VNextCustomCacheService, factory: VNextCustomCacheService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VNextCustomCacheService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DecoupledArrayItemsCacheService }]; }, null); })();

const CACHED_URLS = {
    GET: [
        'EnrollmentSetting',
        'counties',
        'Carriers',
        'Drugs',
        'Pharmacies',
        'MedigapQuestions',
        'PlanQuestions',
        'sites/ConsumerSiteUrls',
        'Enroll/SEPReasons',
        'Enroll/FormVersion'
    ],
    POST: ['Providers/Networks', 'Providers/ProviderLanguages', 'Plans/MedBenefits', 'DrugAlternatives', 'Providers/ValueBasedCareProviders']
};
const POSITION_INDICATOR_REGEX = /v[0-9]+\//; // Matches v followed by a number and a slash, e.g., v1/ or v2/
class CacheInterceptor {
    constructor(configResourceService, vnextCustomCacheService, cacheContext) {
        this.configResourceService = configResourceService;
        this.vnextCustomCacheService = vnextCustomCacheService;
        this.cacheContext = cacheContext;
        this.cache = new Map();
        this.subscriptions = new Subscription();
        this.isCachingEnabled = this.isCachingFeatureEnabled();
        this.bustCache$ = this.cacheContext.observeForCacheBust$();
        this.subscriptions.add(this.bustCache$.subscribe({
            next: () => {
                this.bustCache();
            }
        }));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    intercept(req, next) {
        // check if request is valid for caching
        if (!this.isCachingEnabled || !this.isValidRequestURLForInterceptor(req.url, req.method)) {
            return next.handle(req);
        }
        let cachedResponse;
        const endpointUrl = this.getEndpointUrl(req.url);
        if (this.vnextCustomCacheService.isSupportedServiceUrl(endpointUrl)) {
            cachedResponse = this.vnextCustomCacheService.getCacheFromCustomCacheService(req, endpointUrl);
        }
        else {
            const requestCacheKey = {
                url: req.urlWithParams,
                body: req.body
            };
            // CacheKey object is stringified to be handled as the key of the Cache Map
            cachedResponse = this.cache.get(JSON.stringify(requestCacheKey));
        }
        // if we have a previously cached result, return it and avoid goging through HTTP request
        if (cachedResponse) {
            return of(cachedResponse.clone());
        }
        // else, make HTTP request and cache result using request url and body as Map key
        return next.handle(req).pipe(tap(stateEvent => {
            if (stateEvent instanceof HttpResponse) {
                if (this.vnextCustomCacheService.isSupportedServiceUrl(endpointUrl)) {
                    this.vnextCustomCacheService.setCustomCache(req, stateEvent, endpointUrl);
                }
                else {
                    this.setDefaultCache(req, stateEvent);
                }
            }
        }));
    }
    setDefaultCache(req, stateEvent) {
        this.cache.set(JSON.stringify({
            url: req.urlWithParams,
            body: req.body
        }), stateEvent.clone());
    }
    getEndpointUrl(requestUrl) {
        const match = requestUrl.match(POSITION_INDICATOR_REGEX);
        if (match) {
            const position = match.index + match[0].length;
            return requestUrl.substring(position);
        }
        return '';
    }
    isCachingFeatureEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Cache_REST_API_Requests', widgetName, true);
    }
    isValidRequestURLForInterceptor(requestUrl, requestMethod) {
        if (this.isValidRequestMethod(requestMethod)) {
            const endpointUrl = this.getEndpointUrl(requestUrl);
            if (endpointUrl) {
                // get API url after v1/ in the route
                // get allowed urls using requestMethod from CACHED_URLS
                for (const url of CACHED_URLS[requestMethod]) {
                    // test if endpointUrl is in the whitelisted array
                    if (new RegExp(url).test(endpointUrl)) {
                        return true;
                    }
                }
            }
            // URL wasn't in the regular white list, check if it's in the customly handled URLS
            return this.vnextCustomCacheService.isSupportedServiceUrl(endpointUrl);
        }
        return false;
    }
    // validates if requestMethod is included in the list of cached URLs
    isValidRequestMethod(requestMethod) {
        return Object.keys(CACHED_URLS).includes(requestMethod);
    }
    bustCache() {
        this.cache.clear();
    }
}
CacheInterceptor.ɵfac = function CacheInterceptor_Factory(t) { return new (t || CacheInterceptor)(i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(VNextCustomCacheService), i0.ɵɵinject(CacheContext)); };
CacheInterceptor.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CacheInterceptor, factory: CacheInterceptor.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CacheInterceptor, [{
        type: Injectable
    }], function () { return [{ type: ConfigResourceService }, { type: VNextCustomCacheService }, { type: CacheContext }]; }, null); })();

var WordType;
(function (WordType) {
    WordType[WordType["OTHER"] = 0] = "OTHER";
    WordType[WordType["TEXT"] = 1] = "TEXT";
    WordType[WordType["VALUE"] = 2] = "VALUE";
    WordType[WordType["PLACEHOLDER"] = 3] = "PLACEHOLDER";
    WordType[WordType["META_CONTENT"] = 4] = "META_CONTENT";
    WordType[WordType["IFRAME_SRC"] = 5] = "IFRAME_SRC";
    WordType[WordType["IMG_SRC"] = 6] = "IMG_SRC";
    WordType[WordType["IMG_ALT"] = 7] = "IMG_ALT";
    WordType[WordType["PDF_HREF"] = 8] = "PDF_HREF";
    WordType[WordType["PAGE_TITLE"] = 9] = "PAGE_TITLE";
    WordType[WordType["EXTERNAL_LINK"] = 10] = "EXTERNAL_LINK";
})(WordType || (WordType = {}));
var LanguageLocaleMap;
(function (LanguageLocaleMap) {
    LanguageLocaleMap["af"] = "af-ZA";
    LanguageLocaleMap["ak"] = "ak-GH";
    LanguageLocaleMap["sq"] = "sq-AL";
    LanguageLocaleMap["am"] = "am-ET";
    LanguageLocaleMap["ar"] = "ar-SA";
    LanguageLocaleMap["hy"] = "hy-AM";
    LanguageLocaleMap["as"] = "as-IN";
    LanguageLocaleMap["az"] = "az-AZ";
    LanguageLocaleMap["bm"] = "bm-ML";
    LanguageLocaleMap["ba"] = "ba-RU";
    LanguageLocaleMap["eu"] = "eu-ES";
    LanguageLocaleMap["be"] = "be-BY";
    LanguageLocaleMap["bn"] = "bn-BD";
    LanguageLocaleMap["bs"] = "bs-BA";
    LanguageLocaleMap["br"] = "pt-BR";
    LanguageLocaleMap["bg"] = "bg-BG";
    LanguageLocaleMap["my"] = "my-MM";
    LanguageLocaleMap["ca"] = "ca-ES";
    LanguageLocaleMap["cb"] = "ceb-PH";
    LanguageLocaleMap["km"] = "km-KH";
    LanguageLocaleMap["ny"] = "ny-MW";
    LanguageLocaleMap["co"] = "co-FR";
    LanguageLocaleMap["hr"] = "hr-HR";
    LanguageLocaleMap["cs"] = "cs-CZ";
    LanguageLocaleMap["da"] = "da-DK";
    LanguageLocaleMap["nl"] = "nl-NL";
    LanguageLocaleMap["en"] = "en-US";
    LanguageLocaleMap["eo"] = "eo-EO";
    LanguageLocaleMap["et"] = "et-EE";
    LanguageLocaleMap["fj"] = "fj-FJ";
    LanguageLocaleMap["fl"] = "fil-PH";
    LanguageLocaleMap["fi"] = "fi-FI";
    LanguageLocaleMap["fr"] = "fr-FR";
    LanguageLocaleMap["fc"] = "fr-CA";
    LanguageLocaleMap["gl"] = "gl-ES";
    LanguageLocaleMap["ka"] = "ka-GE";
    LanguageLocaleMap["de"] = "de-DE";
    LanguageLocaleMap["el"] = "el-GR";
    LanguageLocaleMap["gu"] = "gu-IN";
    LanguageLocaleMap["ht"] = "ht-HT";
    LanguageLocaleMap["ha"] = "ha-NG";
    LanguageLocaleMap["hw"] = "haw-US";
    LanguageLocaleMap["he"] = "he-IL";
    LanguageLocaleMap["hi"] = "hi-IN";
    LanguageLocaleMap["hm"] = "hmn-CN";
    LanguageLocaleMap["hu"] = "hu-HU";
    LanguageLocaleMap["is"] = "is-IS";
    LanguageLocaleMap["ig"] = "ig-NG";
    LanguageLocaleMap["id"] = "id-ID";
    LanguageLocaleMap["iu"] = "iu-CA";
    LanguageLocaleMap["ga"] = "ga-IE";
    LanguageLocaleMap["it"] = "it-IT";
    LanguageLocaleMap["ja"] = "ja-JP";
    LanguageLocaleMap["jv"] = "jv-ID";
    LanguageLocaleMap["kn"] = "kn-IN";
    LanguageLocaleMap["kk"] = "kk-KZ";
    LanguageLocaleMap["rw"] = "rw-RW";
    LanguageLocaleMap["ko"] = "ko-KR";
    LanguageLocaleMap["ku"] = "ku-TR";
    LanguageLocaleMap["ky"] = "ky-KG";
    LanguageLocaleMap["lo"] = "lo-LA";
    LanguageLocaleMap["la"] = "la-VA";
    LanguageLocaleMap["lv"] = "lv-LV";
    LanguageLocaleMap["lt"] = "lt-LT";
    LanguageLocaleMap["lg"] = "lg-UG";
    LanguageLocaleMap["lb"] = "lb-LU";
    LanguageLocaleMap["mk"] = "mk-MK";
    LanguageLocaleMap["mg"] = "mg-MG";
    LanguageLocaleMap["ms"] = "ms-MY";
    LanguageLocaleMap["ml"] = "ml-IN";
    LanguageLocaleMap["mt"] = "mt-MT";
    LanguageLocaleMap["mr"] = "mr-IN";
    LanguageLocaleMap["mn"] = "mn-MN";
    LanguageLocaleMap["mi"] = "mi-NZ";
    LanguageLocaleMap["ne"] = "ne-NP";
    LanguageLocaleMap["no"] = "no-NO";
    LanguageLocaleMap["or"] = "or-IN";
    LanguageLocaleMap["om"] = "om-ET";
    LanguageLocaleMap["ps"] = "ps-AF";
    LanguageLocaleMap["fa"] = "fa-IR";
    LanguageLocaleMap["pl"] = "pl-PL";
    LanguageLocaleMap["pt"] = "pt-PT";
    LanguageLocaleMap["pa"] = "pa-IN";
    LanguageLocaleMap["ro"] = "ro-RO";
    LanguageLocaleMap["ru"] = "ru-RU";
    LanguageLocaleMap["sm"] = "sm-WS";
    LanguageLocaleMap["gd"] = "gd-GB";
    LanguageLocaleMap["sr"] = "sr-RS";
    LanguageLocaleMap["sa"] = "sr-Latn-RS";
    LanguageLocaleMap["sn"] = "sn-ZW";
    LanguageLocaleMap["zh"] = "zh-CN";
    LanguageLocaleMap["sd"] = "sd-PK";
    LanguageLocaleMap["si"] = "si-LK";
    LanguageLocaleMap["sk"] = "sk-SK";
    LanguageLocaleMap["sl"] = "sl-SI";
    LanguageLocaleMap["so"] = "so-SO";
    LanguageLocaleMap["st"] = "st-ZA";
    LanguageLocaleMap["es"] = "es-MX";
    LanguageLocaleMap["su"] = "su-ID";
    LanguageLocaleMap["sw"] = "sw-KE";
    LanguageLocaleMap["sv"] = "sv-SE";
    LanguageLocaleMap["tl"] = "tl-PH";
    LanguageLocaleMap["ty"] = "ty-PF";
    LanguageLocaleMap["tg"] = "tg-TJ";
    LanguageLocaleMap["ta"] = "ta-IN";
    LanguageLocaleMap["tt"] = "tt-RU";
    LanguageLocaleMap["te"] = "te-IN";
    LanguageLocaleMap["th"] = "th-TH";
    LanguageLocaleMap["bo"] = "bo-CN";
    LanguageLocaleMap["ti"] = "ti-ET";
    LanguageLocaleMap["to"] = "to-TO";
    LanguageLocaleMap["tw"] = "zh-TW";
    LanguageLocaleMap["tr"] = "tr-TR";
    LanguageLocaleMap["tk"] = "tk-TM";
    LanguageLocaleMap["uk"] = "uk-UA";
    LanguageLocaleMap["ur"] = "ur-PK";
    LanguageLocaleMap["ug"] = "ug-CN";
    LanguageLocaleMap["uz"] = "uz-UZ";
    LanguageLocaleMap["vi"] = "vi-VN";
    LanguageLocaleMap["cy"] = "cy-GB";
    LanguageLocaleMap["fy"] = "fy-NL";
    LanguageLocaleMap["xh"] = "xh-ZA";
    LanguageLocaleMap["yi"] = "yi-001";
    LanguageLocaleMap["yo"] = "yo-NG";
    LanguageLocaleMap["zu"] = "zu-ZA"; // Zulu (South Africa)
})(LanguageLocaleMap || (LanguageLocaleMap = {}));

class WeglotService {
    constructor(store, configResourceService, localeService) {
        this.store = store;
        this.configResourceService = configResourceService;
        this.localeService = localeService;
    }
    getCurrentLocale$() {
        return this.store.select(AppConfigState.currentWeglotLocale).pipe(distinctUntilChanged());
    }
    getCurrentLocale() {
        return this.store.selectSnapshot(AppConfigState.currentWeglotLocale);
    }
    getDefaultLocale() {
        return this.store.selectSnapshot(AppConfigState.defaultWeglotLocale);
    }
    getCurrentWeglotLanguageOrDefaultLanguage() {
        return this.getLanguageCodeByLocale(this.getCurrentWeglotLocaleOrDefault());
    }
    getCurrentWeglotLocaleOrDefault() {
        const weglotMultiLanguageEnabled = this.configResourceService.getProcessedResourceValue('Spa_Weglot_MultiLanguage_Enabled', null, false);
        return weglotMultiLanguageEnabled ? this.getCurrentLocale() : this.localeService.getCurrentLocale();
    }
    initializeWeglot(weglotMultiLanguageEnabled) {
        if (weglotMultiLanguageEnabled && window.initializeWeglot) {
            window.initializeWeglot();
            this.setupWeglotListeners();
        }
    }
    setLocale(locale) {
        const currentLocale = this.getCurrentLocale();
        if (locale && locale !== currentLocale) {
            this.store.dispatch(new SetWeglotLocale(locale));
        }
    }
    setDefaultLocale() {
        const siteDefaultLocale = this.configResourceService.getProcessedResourceValue('Spa_Site_Default_Locale', null, 'en-US');
        if (siteDefaultLocale) {
            this.store.dispatch(new SetDefaultWeglotLocale(siteDefaultLocale));
        }
    }
    getLanguageCodeByLocale(locale) {
        const localeLength = locale?.length;
        // we use this for both weglot and PC1 built in translation it seems... the former will pass in a
        // 2 digit language code like es while the latter will pass in the fully qualified code like es-MX
        // looks like we have to account for both and thus the next line
        const entry = localeLength === 2 ? locale : Object.entries(LanguageLocaleMap).find(([, value]) => value === locale)?.[0];
        return entry ?? null;
    }
    switchLanguage(languageCode) {
        const currentLocale = this.getCurrentLocale();
        const languageLocale = LanguageLocaleMap[languageCode] || languageCode;
        if (languageCode && languageLocale !== currentLocale) {
            window.Weglot.switchTo(languageCode);
            this.store.dispatch(new SetWeglotLocale(languageLocale));
        }
    }
    getTranslatedText$(text, exclusions = [], wordType = WordType.TEXT) {
        // Generate unique placeholders for each exclusion, if any
        const placeholders = exclusions.map((_, index) => `PLACEHOLDER_${index}_${new Date().getTime()}`);
        // Temporarily replace exclusions with their corresponding placeholders
        let processedText = text;
        exclusions.forEach((exclusion, index) => {
            processedText = processedText.replace(new RegExp(exclusion, 'g'), placeholders[index]);
        });
        if (window.Weglot?.translate) {
            const languageTo = this.getLanguageCodeByLocale(this.getCurrentLocale()) || 'en';
            const wordsToTranslate = [{ t: wordType, w: processedText }];
            return new Observable(observer => {
                window.Weglot.translate({
                    words: wordsToTranslate,
                    languageTo
                }, function (translatedContent) {
                    let translatedText = translatedContent.join('');
                    // Restore the excluded texts by replacing the placeholders with the original texts
                    placeholders.forEach((placeholder, index) => {
                        translatedText = translatedText.replace(new RegExp(placeholder, 'g'), exclusions[index]);
                    });
                    observer.next(translatedText);
                    observer.complete();
                });
            });
        }
        else {
            // If Weglot is not initialized, return the original text
            return from([text]);
        }
    }
    setCurrentLocale() {
        const currentLocale = this.getCurrentLocale();
        if (!currentLocale) {
            const lang = window.Weglot.getCurrentLang();
            const locale = LanguageLocaleMap[lang] || lang;
            this.store.dispatch(new SetWeglotLocale(locale));
        }
        else {
            const languageCode = this.getLanguageCodeByLocale(currentLocale);
            window.Weglot.switchTo(languageCode);
        }
    }
    setSupportedWeglotLanguages() {
        if (window.Weglot?.options?.languages) {
            const weglotLanguages = [];
            const availableLanguages = window.Weglot.options.languages
                .map(function (language) {
                return language.language_to;
            })
                .concat(window.Weglot.options.language_from);
            availableLanguages.forEach(languageCode => {
                const locale = LanguageLocaleMap[languageCode] || languageCode;
                const name = window.Weglot.getLanguageName(languageCode);
                weglotLanguages.push({ name, locale, languageCode });
            });
            weglotLanguages?.sort((a, b) => {
                if (a.languageCode === 'en')
                    return -1;
                if (b.languageCode === 'en')
                    return 1;
                return 0;
            });
            this.store.dispatch(new SetSupportedWeglotLanguages(weglotLanguages));
        }
    }
    setupWeglotListeners() {
        window.Weglot.on('initialized', () => {
            this.setCurrentLocale();
            this.setSupportedWeglotLanguages();
        });
    }
}
WeglotService.ɵfac = function WeglotService_Factory(t) { return new (t || WeglotService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(LocaleService)); };
WeglotService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: WeglotService, factory: WeglotService.ɵfac, providedIn: 'root' });
__decorate([
    MemoizeObservable()
], WeglotService.prototype, "getCurrentLocale$", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WeglotService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.Store }, { type: ConfigResourceService }, { type: LocaleService }]; }, { getCurrentLocale$: [] }); })();

class LanguageInterceptor {
    constructor(weglotService) {
        this.weglotService = weglotService;
        /*
         * WHITELIST CONFIGURATION FOR URL MATCHING
         * ----------------------------------------
         * This array includes both static paths and RegExp patterns to cater to different URL matching needs.
         * Static paths are directly matched against the request URL for exact matches.
         * RegExp patterns, especially in the form of regex literals, are utilized for dynamic segments within URLs,
         * offering flexible matching capabilities.
         *
         * HELP GUIDE ON EXTENDING THE WHITELIST:
         *
         * STATIC PATHS:
         * - Directly add the endpoint if it does not include dynamic segments.
         *   Example: Adding 'agent/personalUrl' matches requests to "/agent/personalUrl".
         *
         * - Ensure the path is relative to the base URL of your API.
         *
         * REGEXP PATTERNS FOR DYNAMIC SEGMENTS:
         * Following the ESLint 'prefer-regex-literals' rule, use regex literals for static patterns to improve
         * performance and readability. More details on this rule can be found at:
         * https://eslint.org/docs/latest/rules/prefer-regex-literals
         *
         * - To match one or more digits, suitable for numeric identifiers, use regex literals like `/\d+/`.
         *   Example: `/counties/\d+/` matches "/counties/123".
         *
         * - For alphanumeric session IDs, regex literals like `/[a-zA-Z0-9]+/` can be used.
         *   Example: `/Session/[a-zA-Z0-9]+/TotalCostEffectiveDate` matches "/Session/ABC123/TotalCostEffectiveDate".
         *
         * - To match GUIDs in the standard format, use regex literals formatted as `/[a-fA-F0-9\-]{36}/`.
         *   Example: `/Agent/[a-fA-F0-9\-]{36}/` matches "/Agent/123e4567-e89b-12d3-a456-426614174000".
         *
         * Note: When dynamic patterns or variables are involved, creating RegExp objects with the constructor might be necessary. However,
         * for static patterns, prefer regex literals to align with ESLint recommendations and enhance code quality.
         *
         * The current whitelist configuration:
         */
        this.whitelist = [
            // -------------------
            // STATIC PATHS
            // -------------------
            // Direct matches for specific endpoints:
            'agent/personalUrl',
            'Messages/SendMFA',
            'email',
            'PlanSmart/SendEmail' // Matches requests for sending PlanSmart emails.
            // ---------------------------
            // DYNAMIC URL PATTERNS
            // ---------------------------
            // Uncomment as needed for URLs with dynamic segments. Prefer regex literals for static patterns
            // to improve readability and performance, in line with ESLint's 'prefer-regex-literals' rule.
            // More info: https://eslint.org/docs/latest/rules/prefer-regex-literals
            // Matches URLs with numeric county IDs (/counties/{countyId}).
            // Note: Ensure slashes are escaped within regex literals.
            // /counties\/\d+/,
            // Matches session URLs with a dynamic alphanumeric session ID (/Session/{sessionId}/TotalCostEffectiveDate).
            // Note: The leading slash must be escaped in regex literals.
            // /\/Session\/[a-zA-Z0-9]+\/TotalCostEffectiveDate/,
            // Matches agent URLs with a dynamic GUID (/Agent/{agentId}).
            // GUID format includes hyphens and hexadecimal characters.
            // /\/Agent\/[a-fA-F0-9\-]{36}/,
        ];
    }
    intercept(req, next) {
        /*
         * For the current implementation, we're performing a straightforward string comparison
         * to determine if the request URL matches any entry in the whitelist. This approach suits
         * scenarios where the whitelist consists solely of static URLs.
         */
        const isWhitelisted = this.whitelist.some(entry => req.url.includes(entry));
        /* TODO: In the future, to accommodate dynamic URL segments within the whitelist (e.g., URLs
         * containing numeric IDs or GUIDs), we'll need to enhance the logic below. This would involve
         * checking if each whitelist entry is a string or a RegExp object and using the appropriate
         * method to determine a match. Uncomment and adjust the following code as needed:
         */
        // const isWhitelisted = this.whitelist.some(entry => (typeof entry === 'string' ? req.url.includes(entry) : entry.test(req.url)));
        if (isWhitelisted) {
            // Retrieve the current language setting from the WeglotService
            const language = this.weglotService.getCurrentWeglotLanguageOrDefaultLanguage();
            let modifiedReq = req;
            if (req.method === 'GET') {
                // For GET requests, add 'language' in url params
                modifiedReq = req.clone({
                    params: req.params.append('language', language)
                });
            }
            else if (req.body &&
                typeof req.body === 'object' &&
                !(req.body instanceof FormData) &&
                !(req.body instanceof Blob) &&
                !(req.body instanceof ArrayBuffer)) {
                // For non-GET requests, add 'language' based on the body type
                const modifiedBody = { ...req.body, language };
                modifiedReq = req.clone({
                    body: modifiedBody
                });
            }
            return next.handle(modifiedReq);
        }
        // Pass through non-whitelisted requests without modifications
        return next.handle(req);
    }
}
LanguageInterceptor.ɵfac = function LanguageInterceptor_Factory(t) { return new (t || LanguageInterceptor)(i0.ɵɵinject(WeglotService)); };
LanguageInterceptor.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LanguageInterceptor, factory: LanguageInterceptor.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LanguageInterceptor, [{
        type: Injectable
    }], function () { return [{ type: WeglotService }]; }, null); })();

var AuthorizationCodeSignatureModalSectionNames;
(function (AuthorizationCodeSignatureModalSectionNames) {
    AuthorizationCodeSignatureModalSectionNames["SEND_AUTHORIZATION_CODE"] = "send-authorization-code";
    AuthorizationCodeSignatureModalSectionNames["VERIFY_AUTHORIZATION_CODE"] = "verify-authorization-code";
    AuthorizationCodeSignatureModalSectionNames["AGREE_TO_TERMS_AND_CONDITIONS_APPLICANT"] = "agree-to-terms-and-conditions-applicant";
    AuthorizationCodeSignatureModalSectionNames["AGENT_SIGNATURE"] = "agent-signature";
    AuthorizationCodeSignatureModalSectionNames["AGREE_TO_TERMS_AND_CONDITIONS_AGENT"] = "agree-to-terms-and-conditions-agent";
})(AuthorizationCodeSignatureModalSectionNames || (AuthorizationCodeSignatureModalSectionNames = {}));
var AuthorizationCodeSignatureModalFieldNames;
(function (AuthorizationCodeSignatureModalFieldNames) {
    AuthorizationCodeSignatureModalFieldNames["CONTACT_TYPE_FIELD_NAME"] = "request-authorization-code-on";
    AuthorizationCodeSignatureModalFieldNames["PHONE_FIELD_NAME"] = "phone-number";
    AuthorizationCodeSignatureModalFieldNames["EMAIL_FIELD_NAME"] = "email";
    AuthorizationCodeSignatureModalFieldNames["VERIFY_AUTHORIZATION_CODE_FIELD_NAME"] = "verify-authorization-code";
    AuthorizationCodeSignatureModalFieldNames["AGREE_TO_TERMS_AND_CONDITIONS_APPLICANT"] = "agree-to-terms-and-conditions-applicant";
    AuthorizationCodeSignatureModalFieldNames["AGREE_TO_TERMS_AND_CONDITIONS_AGENT"] = "agree-to-terms-and-conditions-agent";
})(AuthorizationCodeSignatureModalFieldNames || (AuthorizationCodeSignatureModalFieldNames = {}));
var InputTypes;
(function (InputTypes) {
    InputTypes["CHECKBOX"] = "checkbox";
    InputTypes["RADIO"] = "radio";
    InputTypes["EMAIL"] = "email";
    InputTypes["PHONE"] = "phone";
    InputTypes["TEXT"] = "text";
})(InputTypes || (InputTypes = {}));
var ExternalContactTypes;
(function (ExternalContactTypes) {
    ExternalContactTypes["EMAIL"] = "email";
    ExternalContactTypes["TEXT"] = "text";
})(ExternalContactTypes || (ExternalContactTypes = {}));
var AuthorizationCodeStatementActions;
(function (AuthorizationCodeStatementActions) {
    AuthorizationCodeStatementActions["SEND_AUTHORIZATION_CODE"] = "send-authorization-code";
    AuthorizationCodeStatementActions["VERIFY_AUTHORIZATION_CODE"] = "verify-authorization-code";
})(AuthorizationCodeStatementActions || (AuthorizationCodeStatementActions = {}));
var AuthorizationCodeVerificationStatus;
(function (AuthorizationCodeVerificationStatus) {
    AuthorizationCodeVerificationStatus["VALID"] = "VALID";
    AuthorizationCodeVerificationStatus["INVALID"] = "INVALID";
    AuthorizationCodeVerificationStatus["ERROR"] = "ERROR";
})(AuthorizationCodeVerificationStatus || (AuthorizationCodeVerificationStatus = {}));
const HEALTH_INFORMATION_AUTHORIZATION_DOCUMENT_NAME = 'Health Information Authorization';

var DOMEvent;
(function (DOMEvent) {
    DOMEvent["MOUSE_ENTER"] = "mouseenter";
    DOMEvent["MOUSE_LEAVE"] = "mouseleave";
    DOMEvent["FOCUS"] = "focus";
    DOMEvent["BLUR"] = "blur";
    DOMEvent["CLICK"] = "click";
})(DOMEvent || (DOMEvent = {}));
var DOMKeyboardKeyCode;
(function (DOMKeyboardKeyCode) {
    DOMKeyboardKeyCode[DOMKeyboardKeyCode["ENTER"] = 13] = "ENTER";
    DOMKeyboardKeyCode[DOMKeyboardKeyCode["SPACE"] = 32] = "SPACE";
    DOMKeyboardKeyCode[DOMKeyboardKeyCode["ESC"] = 27] = "ESC";
    DOMKeyboardKeyCode[DOMKeyboardKeyCode["TAB"] = 9] = "TAB";
    DOMKeyboardKeyCode[DOMKeyboardKeyCode["PAGEUP"] = 33] = "PAGEUP";
    DOMKeyboardKeyCode[DOMKeyboardKeyCode["PAGEDOWN"] = 34] = "PAGEDOWN";
    DOMKeyboardKeyCode[DOMKeyboardKeyCode["END"] = 35] = "END";
    DOMKeyboardKeyCode[DOMKeyboardKeyCode["HOME"] = 36] = "HOME";
    DOMKeyboardKeyCode[DOMKeyboardKeyCode["ARROWLEFT"] = 37] = "ARROWLEFT";
    DOMKeyboardKeyCode[DOMKeyboardKeyCode["ARROWUP"] = 38] = "ARROWUP";
    DOMKeyboardKeyCode[DOMKeyboardKeyCode["ARROWRIGHT"] = 39] = "ARROWRIGHT";
    DOMKeyboardKeyCode[DOMKeyboardKeyCode["ARROWDOWN"] = 40] = "ARROWDOWN";
})(DOMKeyboardKeyCode || (DOMKeyboardKeyCode = {}));
var DOMKeyboardCode;
(function (DOMKeyboardCode) {
    DOMKeyboardCode["ENTER"] = "Enter";
    DOMKeyboardCode["SPACE"] = "Space";
    DOMKeyboardCode["ESC"] = "Escape";
    DOMKeyboardCode["TAB"] = "Tab";
    DOMKeyboardCode["PAGE_UP"] = "PageUp";
    DOMKeyboardCode["PAGE_DOWN"] = "PageDown";
    DOMKeyboardCode["END"] = "Home";
    DOMKeyboardCode["HOME"] = "End";
    DOMKeyboardCode["ARROW_LEFT"] = "ArrowLeft";
    DOMKeyboardCode["ARROW_UP"] = "ArrowUp";
    DOMKeyboardCode["ARROW_RIGHT"] = "ArrowRight";
    DOMKeyboardCode["ARROW_DOWN"] = "ArrowDown";
})(DOMKeyboardCode || (DOMKeyboardCode = {}));

var FormEvent;
(function (FormEvent) {
    FormEvent["Blur"] = "blur";
    FormEvent["Change"] = "change";
    FormEvent["Submit"] = "submit";
})(FormEvent || (FormEvent = {}));

const ACCOUNT_OVERVIEW = 'account-overview';

class VBCProvider {
}
class VBCAttestation {
}
class VBCAttestationPayload {
}
class VBCProviders {
}
class VBCRequestPayload {
}
class ProviderNpi {
}
class VBCVideoResponse {
}
class VBCVideoPayload {
}
class SelectedProvider {
}
class SelectedProviderIds {
}
class ProviderHttpResponse {
}
class ProviderRequestBody {
}
class APIUserProvider {
}
class PrimaryCareProvider {
}
var ProvidersLinkType;
(function (ProvidersLinkType) {
    ProvidersLinkType[ProvidersLinkType["INTERNAL"] = 0] = "INTERNAL";
    ProvidersLinkType[ProvidersLinkType["EXTERNAL"] = 1] = "EXTERNAL";
    ProvidersLinkType[ProvidersLinkType["NO_LINK"] = 2] = "NO_LINK";
    ProvidersLinkType[ProvidersLinkType["INTERNAL_AND_EXTERNAL"] = 3] = "INTERNAL_AND_EXTERNAL";
})(ProvidersLinkType || (ProvidersLinkType = {}));
// “1” if there are any out of network locations selected that have in network additional locations
// “0” in all other cases
var ProviderLocationStatus;
(function (ProviderLocationStatus) {
    ProviderLocationStatus["ADDITIONAL_LOCATION_INNETWORK_NOT_EXISTS"] = "0";
    ProviderLocationStatus["ADDITIONAL_LOCATION_INNETWORK_EXISTS"] = "1";
})(ProviderLocationStatus || (ProviderLocationStatus = {}));

class AgentInfo {
}

var GuidedHelpLinkStatus;
(function (GuidedHelpLinkStatus) {
    GuidedHelpLinkStatus["CLEAN"] = "clean";
    GuidedHelpLinkStatus["DIRTY"] = "dirty";
    GuidedHelpLinkStatus["SELECTED"] = "selected";
})(GuidedHelpLinkStatus || (GuidedHelpLinkStatus = {}));
var CoverageType;
(function (CoverageType) {
    CoverageType["MEDICAL_ONLY"] = "Medical only";
    CoverageType["PRESCRIPTION_DRUG"] = "Prescription drug";
    CoverageType["MEDICAL_AND_PRESCRIPTION_DRUG"] = "Medical and prescription drug";
    CoverageType["I_DONT_KNOW"] = "I don't know";
})(CoverageType || (CoverageType = {}));
var GuidedHelpSections;
(function (GuidedHelpSections) {
    GuidedHelpSections["GET_STARTED"] = "Get started";
    GuidedHelpSections["HEALTH"] = "Health";
    GuidedHelpSections["PRESCRIPTIONS"] = "Prescriptions";
    GuidedHelpSections["PHARMACY"] = "Pharmacy";
    GuidedHelpSections["PREFERENCES"] = "Other preferences";
})(GuidedHelpSections || (GuidedHelpSections = {}));
var GuidedHelpAgeSelection;
(function (GuidedHelpAgeSelection) {
    GuidedHelpAgeSelection[GuidedHelpAgeSelection["MEMBER_AGE_UNDER_65"] = 6] = "MEMBER_AGE_UNDER_65";
    GuidedHelpAgeSelection[GuidedHelpAgeSelection["MEMBER_AGE_65_69"] = 5] = "MEMBER_AGE_65_69";
    GuidedHelpAgeSelection[GuidedHelpAgeSelection["MEMBER_AGE_70_74"] = 4] = "MEMBER_AGE_70_74";
    GuidedHelpAgeSelection[GuidedHelpAgeSelection["MEMBER_AGE_75_79"] = 3] = "MEMBER_AGE_75_79";
    GuidedHelpAgeSelection[GuidedHelpAgeSelection["MEMBER_AGE_80_84"] = 2] = "MEMBER_AGE_80_84";
    GuidedHelpAgeSelection[GuidedHelpAgeSelection["MEMBER_AGE_85_OVER"] = 1] = "MEMBER_AGE_85_OVER";
})(GuidedHelpAgeSelection || (GuidedHelpAgeSelection = {}));
var GuidedHelpHealthStatus;
(function (GuidedHelpHealthStatus) {
    GuidedHelpHealthStatus[GuidedHelpHealthStatus["MEMBER_HEALTH_EXCELLENT"] = 1] = "MEMBER_HEALTH_EXCELLENT";
    GuidedHelpHealthStatus[GuidedHelpHealthStatus["MEMBER_HEALTH_VERY_GOOD"] = 2] = "MEMBER_HEALTH_VERY_GOOD";
    // the above don't get used but they are usable values for nova
    GuidedHelpHealthStatus[GuidedHelpHealthStatus["MEMBER_HEALTH_GOOD"] = 3] = "MEMBER_HEALTH_GOOD";
    GuidedHelpHealthStatus[GuidedHelpHealthStatus["MEMBER_HEALTH_FAIR"] = 4] = "MEMBER_HEALTH_FAIR";
    GuidedHelpHealthStatus[GuidedHelpHealthStatus["MEMBER_HEALTH_POOR"] = 5] = "MEMBER_HEALTH_POOR";
})(GuidedHelpHealthStatus || (GuidedHelpHealthStatus = {}));
var GuidedHelpMapStyleEnum;
(function (GuidedHelpMapStyleEnum) {
    GuidedHelpMapStyleEnum["Spa_Style_Accent2_Color"] = "Spa_Style_Accent2_Color";
    GuidedHelpMapStyleEnum["Spa_Style_Accent3_Color"] = "Spa_Style_Accent3_Color";
    GuidedHelpMapStyleEnum["Spa_Style_Accent5_Color"] = "Spa_Style_Accent5_Color";
    GuidedHelpMapStyleEnum["Spa_Style_Accent2_Background"] = "Spa_Style_Accent2_Background";
    GuidedHelpMapStyleEnum["Spa_Style_Accent3_Background"] = "Spa_Style_Accent3_Background";
    GuidedHelpMapStyleEnum["Spa_Style_Accent5_Background"] = "Spa_Style_Accent5_Background";
    GuidedHelpMapStyleEnum["Spa_Style_TooltipTextAndNumberIndicators"] = "Spa_Style_TooltipTextAndNumberIndicators";
    GuidedHelpMapStyleEnum["Spa_Map_Pin_Indicator"] = "indicator";
})(GuidedHelpMapStyleEnum || (GuidedHelpMapStyleEnum = {}));
var EstimateHealthCostFlag;
(function (EstimateHealthCostFlag) {
    EstimateHealthCostFlag[EstimateHealthCostFlag["Edited"] = 1] = "Edited";
    EstimateHealthCostFlag[EstimateHealthCostFlag["Default"] = 2] = "Default";
    EstimateHealthCostFlag[EstimateHealthCostFlag["OptOut"] = 3] = "OptOut";
})(EstimateHealthCostFlag || (EstimateHealthCostFlag = {}));
var HealthCostsDurationValues;
(function (HealthCostsDurationValues) {
    HealthCostsDurationValues["YES"] = "yes";
    HealthCostsDurationValues["NO"] = "no";
})(HealthCostsDurationValues || (HealthCostsDurationValues = {}));
var PrimaryCareProviderToggleValues;
(function (PrimaryCareProviderToggleValues) {
    PrimaryCareProviderToggleValues["YES"] = "yes";
    PrimaryCareProviderToggleValues["NO"] = "no";
})(PrimaryCareProviderToggleValues || (PrimaryCareProviderToggleValues = {}));
var NewPatientToggleValues;
(function (NewPatientToggleValues) {
    NewPatientToggleValues["YES"] = "yes";
    NewPatientToggleValues["NO"] = "no";
})(NewPatientToggleValues || (NewPatientToggleValues = {}));
var PreferenceBannerSectionType;
(function (PreferenceBannerSectionType) {
    PreferenceBannerSectionType["PROVIDERS"] = "PROVIDERS";
    PreferenceBannerSectionType["PHARMACY"] = "PHARMACY";
    PreferenceBannerSectionType["PRESCRIPTIONS"] = "PRESCRIPTIONS";
    PreferenceBannerSectionType["ELIGIBILITY"] = "ELIGIBILITY";
    PreferenceBannerSectionType["HEALTH"] = "HEALTH";
    PreferenceBannerSectionType["CURRENT_PLAN"] = "CURRENT_PLAN";
    PreferenceBannerSectionType["SUPPLEMENTAL_BENEFITS"] = "SUPPLEMENTAL_BENEFITS";
})(PreferenceBannerSectionType || (PreferenceBannerSectionType = {}));

var MFA_CONTACT_TYPES;
(function (MFA_CONTACT_TYPES) {
    MFA_CONTACT_TYPES[MFA_CONTACT_TYPES["EMAIL"] = 1] = "EMAIL";
    MFA_CONTACT_TYPES[MFA_CONTACT_TYPES["PHONE"] = 2] = "PHONE";
})(MFA_CONTACT_TYPES || (MFA_CONTACT_TYPES = {}));
var MultiFactorAuthenticationStep;
(function (MultiFactorAuthenticationStep) {
    MultiFactorAuthenticationStep["CONTACT_YOUR_AGENT"] = "contact-your-agent";
    MultiFactorAuthenticationStep["SELECT_CONTACT_METHOD"] = "select-contact-method";
    MultiFactorAuthenticationStep["ENTER_VERIFICATION_CODE"] = "enter-verification-code";
    MultiFactorAuthenticationStep["PIN_LOCKED"] = "pin-locked";
})(MultiFactorAuthenticationStep || (MultiFactorAuthenticationStep = {}));

var VerificationStep;
(function (VerificationStep) {
    VerificationStep["CONTACT_YOUR_AGENT"] = "contact-your-agent";
    VerificationStep["SELECT_VERIFICATION_METHOD"] = "select-verification-method";
    VerificationStep["ENTER_VERIFICATION_CODE"] = "enter-verification-code";
    VerificationStep["ENTER_PASSPHRASE"] = "enter-passphrase";
    VerificationStep["PIN_LOCKED"] = "pin-locked";
    VerificationStep["CONSUMER_LOGIN"] = "consumer-login";
    VerificationStep["CONSUMER_FORGOT_PASSWORD"] = "consumer-forgot-password";
    VerificationStep["CONSUMER_FORGOT_USERNAME"] = "consumer-forgot-username";
})(VerificationStep || (VerificationStep = {}));

class SetHidePdfAgentData {
    constructor(hidePdfAgentData) {
        this.hidePdfAgentData = hidePdfAgentData;
    }
}
SetHidePdfAgentData.type = '[UI] Set Pdf Agent Data Display';
class SetGuidedHelpNavigationLinks {
    constructor(guidedHelpLinks) {
        this.guidedHelpLinks = guidedHelpLinks;
    }
}
SetGuidedHelpNavigationLinks.type = '[UI] Set Guided Help Links';
class SetAgentHeader {
    constructor(showAgentHeader) {
        this.showAgentHeader = showAgentHeader;
    }
}
SetAgentHeader.type = '[UI] Set Agent Header Display';
class SetAgentMiniCart {
    constructor(showAgentMiniCart) {
        this.showAgentMiniCart = showAgentMiniCart;
    }
}
SetAgentMiniCart.type = '[UI] Set Agent Mini Cart Display';
class SetMeetAgent {
    constructor(showMeetAgent) {
        this.showMeetAgent = showMeetAgent;
    }
}
SetMeetAgent.type = '[UI] Set Agent Show Meeting';
class SetAgentPictureDisplay {
    constructor(showAgentProfilePicture) {
        this.showAgentProfilePicture = showAgentProfilePicture;
    }
}
SetAgentPictureDisplay.type = '[UI] Set Agent Profile Picture Display';
class SetOverrideActiveTab {
    constructor(overrideActiveTab) {
        this.overrideActiveTab = overrideActiveTab;
    }
}
SetOverrideActiveTab.type = '[UI] Set Override Active Tab';
class SetIsSelectedEffectiveDate {
    constructor(isSelectedEffectiveDate) {
        this.isSelectedEffectiveDate = isSelectedEffectiveDate;
    }
}
SetIsSelectedEffectiveDate.type = '[UI] Update Effective Date Selection Dropdown';
class ResetGuidedHelpNavigationLinkStatus {
}
ResetGuidedHelpNavigationLinkStatus.type = '[UI] Reset Guided Help Navigation Link Status';
class SetSelectedContactMethod {
    constructor(selectedContactMethod) {
        this.selectedContactMethod = selectedContactMethod;
    }
}
SetSelectedContactMethod.type = '[UI] Set Selected Contact Method';
class SetCurrentAuthenticationStep {
    constructor(currentAuthenticationStep) {
        this.currentAuthenticationStep = currentAuthenticationStep;
    }
}
SetCurrentAuthenticationStep.type = '[UI] Set Current Authentication Step';
class ResetCurrentAuthenticationStep {
}
ResetCurrentAuthenticationStep.type = '[UI] Reset Current Authentication Step';
class ResetMultiFactorAuthenticationStep {
}
ResetMultiFactorAuthenticationStep.type = '[UI] Reset Multi-Factor Authentication Step';
class SetSelectedVerificationMethod {
    constructor(selectedVerificationMethod) {
        this.selectedVerificationMethod = selectedVerificationMethod;
    }
}
SetSelectedVerificationMethod.type = '[UI] Set Selected Verification Method';
class SetCurrentVerificationStep {
    constructor(currentVerificationStep) {
        this.currentVerificationStep = currentVerificationStep;
    }
}
SetCurrentVerificationStep.type = '[UI] Set Current Verification Step';
class ResetCurrentVerificationStep {
}
ResetCurrentVerificationStep.type = '[UI] Reset Current Verification Step';
class ResetVerificationStep {
}
ResetVerificationStep.type = '[UI] Reset Verification Step';

var UiState_1;
class UiStateModel {
}
const DEFAULT_MULTI_FACTOR_AUTHENTICATION = {
    currentAuthenticationStep: MultiFactorAuthenticationStep.SELECT_CONTACT_METHOD,
    selectedContactMethod: null
};
const DEFAULT_VERIFICATION = {
    currentVerificationStep: VerificationStep.SELECT_VERIFICATION_METHOD,
    selectedVerificationMethod: null
};
let UiState = UiState_1 = class UiState {
    static guidedHelpLinks(state) {
        return state.guidedHelpLinks;
    }
    static agentUI(state) {
        return state.agent;
    }
    static plansUI(state) {
        return state.plans;
    }
    static showMeetWithAgentSection(agent) {
        return agent.showMeetAgent;
    }
    static showAgentHeader(agent) {
        return agent.showAgentHeader;
    }
    static showAgentMiniCart(agent) {
        return agent.showAgentMiniCart;
    }
    static showAgentProfilePicture(agent) {
        return agent.showAgentProfilePicture;
    }
    static hidePdfAgentData(agent) {
        return agent.hidePdfAgentData;
    }
    static overrideActiveTab(plans) {
        return plans.overrideActiveTab;
    }
    static isSelectedEffectiveDate(plans) {
        return plans.isSelectedEffectiveDate;
    }
    static multiFactorAuthenticationUI(state) {
        return state.multiFactorAuthentication;
    }
    static currentAuthenticationStep(multiFactorAuthentication) {
        return multiFactorAuthentication.currentAuthenticationStep;
    }
    static selectedContactMethod(multiFactorAuthentication) {
        return multiFactorAuthentication.selectedContactMethod;
    }
    static isCurrentAuthenticationStep(authenticationStep) {
        return createSelector([UiState_1.currentAuthenticationStep], (currentAuthenticationStep) => currentAuthenticationStep === authenticationStep);
    }
    static verificationUI(state) {
        return state.verification;
    }
    static currentVerificationStep(verification) {
        return verification.currentVerificationStep;
    }
    static selectedVerificationMethod(verification) {
        return verification.selectedVerificationMethod;
    }
    static isCurrentVerificationStep(verificationSteps) {
        return createSelector([UiState_1.currentVerificationStep], (currentVerificationStep) => !!verificationSteps?.includes(currentVerificationStep));
    }
    setHidePdfAgentData(ctx, { hidePdfAgentData }) {
        const { setState } = ctx;
        setState(patch({
            agent: patch({
                hidePdfAgentData
            })
        }));
    }
    setGuidedHelpLinks({ patchState }, { guidedHelpLinks }) {
        patchState({
            guidedHelpLinks
        });
    }
    resetGuidedHelpNavigationLinkStatus({ getState, patchState }) {
        const links = getState()?.guidedHelpLinks;
        const updatedLinks = links.map(link => ({ ...link, status: GuidedHelpLinkStatus.CLEAN }));
        patchState({
            guidedHelpLinks: updatedLinks
        });
    }
    setAgentPictureDisplay(ctx, { showAgentProfilePicture }) {
        const { setState } = ctx;
        setState(patch({
            agent: patch({
                showAgentProfilePicture
            })
        }));
    }
    setAgentHeader(ctx, { showAgentHeader }) {
        const { setState } = ctx;
        setState(patch({
            agent: patch({
                showAgentHeader
            })
        }));
    }
    setAgentMiniCart(ctx, { showAgentMiniCart }) {
        const { setState } = ctx;
        setState(patch({
            agent: patch({
                showAgentMiniCart
            })
        }));
    }
    setMeetAgent(ctx, { showMeetAgent }) {
        const { setState } = ctx;
        setState(patch({
            agent: patch({
                showMeetAgent
            })
        }));
    }
    setOverrideActiveTab(ctx, { overrideActiveTab }) {
        const { setState } = ctx;
        setState(patch({
            plans: patch({
                overrideActiveTab
            })
        }));
    }
    setIsSelectedEffectiveDate(ctx, { isSelectedEffectiveDate }) {
        const { setState } = ctx;
        setState(patch({
            plans: patch({
                isSelectedEffectiveDate
            })
        }));
    }
    setCurrentAuthenticationStep(ctx, { currentAuthenticationStep }) {
        const { setState } = ctx;
        setState(patch({
            multiFactorAuthentication: patch({
                currentAuthenticationStep
            })
        }));
    }
    resetCurrentAuthenticationStep(ctx) {
        const { setState } = ctx;
        setState(patch({
            multiFactorAuthentication: patch({
                currentAuthenticationStep: DEFAULT_MULTI_FACTOR_AUTHENTICATION.currentAuthenticationStep
            })
        }));
    }
    setSelectedContactMethod(ctx, { selectedContactMethod }) {
        const { setState } = ctx;
        setState(patch({
            multiFactorAuthentication: patch({
                selectedContactMethod
            })
        }));
    }
    resetMultiFactorAuthenticationStep(ctx) {
        const { setState } = ctx;
        setState(patch({
            multiFactorAuthentication: DEFAULT_MULTI_FACTOR_AUTHENTICATION
        }));
    }
    setCurrentVerificationStep(ctx, { currentVerificationStep }) {
        const { setState } = ctx;
        setState(patch({
            verification: patch({
                currentVerificationStep
            })
        }));
    }
    resetCurrentVerificationStep(ctx) {
        const { setState } = ctx;
        setState(patch({
            verification: patch({
                currentVerificationStep: DEFAULT_VERIFICATION.currentVerificationStep
            })
        }));
    }
    setSelectedVerificationMethod(ctx, { selectedVerificationMethod }) {
        const { setState } = ctx;
        setState(patch({
            verification: patch({
                selectedVerificationMethod
            })
        }));
    }
    resetVerificationStep(ctx) {
        const { setState } = ctx;
        setState(patch({
            verification: DEFAULT_VERIFICATION
        }));
    }
};
UiState.ɵfac = function UiState_Factory(t) { return new (t || UiState)(); };
UiState.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: UiState, factory: UiState.ɵfac });
__decorate([
    Action(SetHidePdfAgentData)
], UiState.prototype, "setHidePdfAgentData", null);
__decorate([
    Action(SetGuidedHelpNavigationLinks)
], UiState.prototype, "setGuidedHelpLinks", null);
__decorate([
    Action(ResetGuidedHelpNavigationLinkStatus)
], UiState.prototype, "resetGuidedHelpNavigationLinkStatus", null);
__decorate([
    Action(SetAgentPictureDisplay)
], UiState.prototype, "setAgentPictureDisplay", null);
__decorate([
    Action(SetAgentHeader)
], UiState.prototype, "setAgentHeader", null);
__decorate([
    Action(SetAgentMiniCart)
], UiState.prototype, "setAgentMiniCart", null);
__decorate([
    Action(SetMeetAgent)
], UiState.prototype, "setMeetAgent", null);
__decorate([
    Action(SetOverrideActiveTab)
], UiState.prototype, "setOverrideActiveTab", null);
__decorate([
    Action(SetIsSelectedEffectiveDate)
], UiState.prototype, "setIsSelectedEffectiveDate", null);
__decorate([
    Action(SetCurrentAuthenticationStep)
], UiState.prototype, "setCurrentAuthenticationStep", null);
__decorate([
    Action(ResetCurrentAuthenticationStep)
], UiState.prototype, "resetCurrentAuthenticationStep", null);
__decorate([
    Action(SetSelectedContactMethod)
], UiState.prototype, "setSelectedContactMethod", null);
__decorate([
    Action(ResetMultiFactorAuthenticationStep)
], UiState.prototype, "resetMultiFactorAuthenticationStep", null);
__decorate([
    Action(SetCurrentVerificationStep)
], UiState.prototype, "setCurrentVerificationStep", null);
__decorate([
    Action(ResetCurrentVerificationStep)
], UiState.prototype, "resetCurrentVerificationStep", null);
__decorate([
    Action(SetSelectedVerificationMethod)
], UiState.prototype, "setSelectedVerificationMethod", null);
__decorate([
    Action(ResetVerificationStep)
], UiState.prototype, "resetVerificationStep", null);
__decorate([
    Selector()
], UiState, "guidedHelpLinks", null);
__decorate([
    Selector()
], UiState, "agentUI", null);
__decorate([
    Selector()
], UiState, "plansUI", null);
__decorate([
    Selector([UiState_1.agentUI])
], UiState, "showMeetWithAgentSection", null);
__decorate([
    Selector([UiState_1.agentUI])
], UiState, "showAgentHeader", null);
__decorate([
    Selector([UiState_1.agentUI])
], UiState, "showAgentMiniCart", null);
__decorate([
    Selector([UiState_1.agentUI])
], UiState, "showAgentProfilePicture", null);
__decorate([
    Selector([UiState_1.agentUI])
], UiState, "hidePdfAgentData", null);
__decorate([
    Selector([UiState_1.plansUI])
], UiState, "overrideActiveTab", null);
__decorate([
    Selector([UiState_1.plansUI])
], UiState, "isSelectedEffectiveDate", null);
__decorate([
    Selector()
], UiState, "multiFactorAuthenticationUI", null);
__decorate([
    Selector([UiState_1.multiFactorAuthenticationUI])
], UiState, "currentAuthenticationStep", null);
__decorate([
    Selector([UiState_1.multiFactorAuthenticationUI])
], UiState, "selectedContactMethod", null);
__decorate([
    Selector()
], UiState, "verificationUI", null);
__decorate([
    Selector([UiState_1.verificationUI])
], UiState, "currentVerificationStep", null);
__decorate([
    Selector([UiState_1.verificationUI])
], UiState, "selectedVerificationMethod", null);
UiState = UiState_1 = __decorate([
    State({
        name: 'ui',
        defaults: {
            guidedHelpLinks: [],
            agent: {
                showMeetAgent: true,
                showAgentHeader: true,
                showAgentMiniCart: true,
                showAgentProfilePicture: false,
                hidePdfAgentData: false
            },
            plans: {
                overrideActiveTab: true,
                isSelectedEffectiveDate: false
            },
            multiFactorAuthentication: DEFAULT_MULTI_FACTOR_AUTHENTICATION,
            verification: DEFAULT_VERIFICATION
        }
    })
], UiState);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UiState, [{
        type: Injectable
    }], null, { setHidePdfAgentData: [], setGuidedHelpLinks: [], resetGuidedHelpNavigationLinkStatus: [], setAgentPictureDisplay: [], setAgentHeader: [], setAgentMiniCart: [], setMeetAgent: [], setOverrideActiveTab: [], setIsSelectedEffectiveDate: [], setCurrentAuthenticationStep: [], resetCurrentAuthenticationStep: [], setSelectedContactMethod: [], resetMultiFactorAuthenticationStep: [], setCurrentVerificationStep: [], resetCurrentVerificationStep: [], setSelectedVerificationMethod: [], resetVerificationStep: [] }); })();

var DemographicStateType;
(function (DemographicStateType) {
    DemographicStateType[DemographicStateType["STATE"] = 1] = "STATE";
    DemographicStateType[DemographicStateType["TERRITORY"] = 2] = "TERRITORY";
})(DemographicStateType || (DemographicStateType = {}));
var StateAbbreviation;
(function (StateAbbreviation) {
    StateAbbreviation["AL"] = "AL";
    StateAbbreviation["AK"] = "AK";
    StateAbbreviation["AS"] = "AS";
    StateAbbreviation["AZ"] = "AZ";
    StateAbbreviation["AR"] = "AR";
    StateAbbreviation["CA"] = "CA";
    StateAbbreviation["CO"] = "CO";
    StateAbbreviation["CT"] = "CT";
    StateAbbreviation["DE"] = "DE";
    StateAbbreviation["DC"] = "DC";
    StateAbbreviation["FM"] = "FM";
    StateAbbreviation["FL"] = "FL";
    StateAbbreviation["GA"] = "GA";
    StateAbbreviation["GU"] = "GU";
    StateAbbreviation["HI"] = "HI";
    StateAbbreviation["ID"] = "ID";
    StateAbbreviation["IL"] = "IL";
    StateAbbreviation["IN"] = "IN";
    StateAbbreviation["IA"] = "IA";
    StateAbbreviation["KS"] = "KS";
    StateAbbreviation["KY"] = "KY";
    StateAbbreviation["LA"] = "LA";
    StateAbbreviation["ME"] = "ME";
    StateAbbreviation["MH"] = "MH";
    StateAbbreviation["MD"] = "MD";
    StateAbbreviation["MA"] = "MA";
    StateAbbreviation["MI"] = "MI";
    StateAbbreviation["MN"] = "MN";
    StateAbbreviation["MS"] = "MS";
    StateAbbreviation["MO"] = "MO";
    StateAbbreviation["MT"] = "MT";
    StateAbbreviation["NE"] = "NE";
    StateAbbreviation["NV"] = "NV";
    StateAbbreviation["NH"] = "NH";
    StateAbbreviation["NJ"] = "NJ";
    StateAbbreviation["NM"] = "NM";
    StateAbbreviation["NY"] = "NY";
    StateAbbreviation["NC"] = "NC";
    StateAbbreviation["ND"] = "ND";
    StateAbbreviation["MP"] = "MP";
    StateAbbreviation["OH"] = "OH";
    StateAbbreviation["OK"] = "OK";
    StateAbbreviation["OR"] = "OR";
    StateAbbreviation["PW"] = "PW";
    StateAbbreviation["PA"] = "PA";
    StateAbbreviation["PR"] = "PR";
    StateAbbreviation["RI"] = "RI";
    StateAbbreviation["SC"] = "SC";
    StateAbbreviation["SD"] = "SD";
    StateAbbreviation["TN"] = "TN";
    StateAbbreviation["TX"] = "TX";
    StateAbbreviation["UT"] = "UT";
    StateAbbreviation["VT"] = "VT";
    StateAbbreviation["VI"] = "VI";
    StateAbbreviation["VA"] = "VA";
    StateAbbreviation["WA"] = "WA";
    StateAbbreviation["WV"] = "WV";
    StateAbbreviation["WI"] = "WI";
    StateAbbreviation["WY"] = "WY";
})(StateAbbreviation || (StateAbbreviation = {}));
const DemographicStates = [
    {
        StateName: 'Alabama',
        StateAbbrev: StateAbbreviation.AL,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Alaska',
        StateAbbrev: StateAbbreviation.AK,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Arizona',
        StateAbbrev: StateAbbreviation.AZ,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'American Samoa',
        StateAbbrev: StateAbbreviation.AS,
        StateType: DemographicStateType.TERRITORY
    },
    {
        StateName: 'Arkansas',
        StateAbbrev: StateAbbreviation.AR,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'California',
        StateAbbrev: StateAbbreviation.CA,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Colorado',
        StateAbbrev: StateAbbreviation.CO,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Connecticut',
        StateAbbrev: StateAbbreviation.CT,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Delaware',
        StateAbbrev: StateAbbreviation.DE,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'District of Columbia',
        StateAbbrev: StateAbbreviation.DC,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Florida',
        StateAbbrev: StateAbbreviation.FL,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Georgia',
        StateAbbrev: StateAbbreviation.GA,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Guam',
        StateAbbrev: StateAbbreviation.GU,
        StateType: DemographicStateType.TERRITORY
    },
    {
        StateName: 'Hawaii',
        StateAbbrev: StateAbbreviation.HI,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Idaho',
        StateAbbrev: StateAbbreviation.ID,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Illinois',
        StateAbbrev: StateAbbreviation.IL,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Indiana',
        StateAbbrev: StateAbbreviation.IN,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Iowa',
        StateAbbrev: StateAbbreviation.IA,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Kansas',
        StateAbbrev: StateAbbreviation.KS,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Kentucky',
        StateAbbrev: StateAbbreviation.KY,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Louisiana',
        StateAbbrev: StateAbbreviation.LA,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Maine',
        StateAbbrev: StateAbbreviation.ME,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Maryland',
        StateAbbrev: StateAbbreviation.MD,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Massachusetts',
        StateAbbrev: StateAbbreviation.MA,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Michigan',
        StateAbbrev: StateAbbreviation.MI,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Minnesota',
        StateAbbrev: StateAbbreviation.MN,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Mississippi',
        StateAbbrev: StateAbbreviation.MS,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Missouri',
        StateAbbrev: StateAbbreviation.MO,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Montana',
        StateAbbrev: StateAbbreviation.MT,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Nebraska',
        StateAbbrev: StateAbbreviation.NE,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Nevada',
        StateAbbrev: StateAbbreviation.NV,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'New Hampshire',
        StateAbbrev: StateAbbreviation.NH,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'New Jersey',
        StateAbbrev: StateAbbreviation.NJ,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'New Mexico',
        StateAbbrev: StateAbbreviation.NM,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'New York',
        StateAbbrev: StateAbbreviation.NY,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'North Carolina',
        StateAbbrev: StateAbbreviation.NC,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'North Dakota',
        StateAbbrev: StateAbbreviation.ND,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Northern Mariana Islands',
        StateAbbrev: StateAbbreviation.MP,
        StateType: DemographicStateType.TERRITORY
    },
    {
        StateName: 'Ohio',
        StateAbbrev: StateAbbreviation.OH,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Oklahoma',
        StateAbbrev: StateAbbreviation.OK,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Oregon',
        StateAbbrev: StateAbbreviation.OR,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Pennsylvania',
        StateAbbrev: StateAbbreviation.PA,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Puerto Rico',
        StateAbbrev: StateAbbreviation.PR,
        StateType: DemographicStateType.TERRITORY
    },
    {
        StateName: 'Rhode Island',
        StateAbbrev: StateAbbreviation.RI,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'South Carolina',
        StateAbbrev: StateAbbreviation.SC,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'South Dakota',
        StateAbbrev: StateAbbreviation.SD,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Tennessee',
        StateAbbrev: StateAbbreviation.TN,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Texas',
        StateAbbrev: StateAbbreviation.TX,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Utah',
        StateAbbrev: StateAbbreviation.UT,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Vermont',
        StateAbbrev: StateAbbreviation.VT,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Virgin Islands',
        StateAbbrev: StateAbbreviation.VI,
        StateType: DemographicStateType.TERRITORY
    },
    {
        StateName: 'Virginia',
        StateAbbrev: StateAbbreviation.VA,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Washington',
        StateAbbrev: StateAbbreviation.WA,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'West Virginia',
        StateAbbrev: StateAbbreviation.WV,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Wisconsin',
        StateAbbrev: StateAbbreviation.WI,
        StateType: DemographicStateType.STATE
    },
    {
        StateName: 'Wyoming',
        StateAbbrev: StateAbbreviation.WY,
        StateType: DemographicStateType.STATE
    }
];

class Attachment {
}
class Email {
    constructor(emailTo, emailFrom, subject, body, useSecureEmail = true, ccTo, attachments) {
        this.emailTo = emailTo;
        this.emailFrom = emailFrom;
        this.subject = subject;
        this.body = body;
        this.useSecureEmail = useSecureEmail;
        this.ccTo = ccTo;
        this.attachments = attachments;
    }
}
var ResetType;
(function (ResetType) {
    ResetType["CONSUMER"] = "consumer";
    ResetType["AGENT"] = "broker";
})(ResetType || (ResetType = {}));
class EmailRecoveryRequest extends Email {
}
class EmailDocument {
}
var EmailNames;
(function (EmailNames) {
    EmailNames["APPLICATION"] = "enrollmentApplication.html";
    EmailNames["AGENT_CONFIRMATION"] = "agentconfirmation.html";
    EmailNames["PASSWORD_RESET"] = "password-reset.html";
    EmailNames["AGENT_FORGOT_USERNAME"] = "agent-forgot-username.html";
    EmailNames["CONFIRMATION_WITH_BROKER"] = "confirmationWithBroker.html";
    EmailNames["ACCESS_CODE"] = "quoteAccessCode.html";
    EmailNames["VIEW_QUOTE"] = "viewQuote.html";
    EmailNames["SOA_CONSUMER"] = "soa-consumer-email.html";
    EmailNames["SOA_AGENT"] = "soa-agent-email.html";
    EmailNames["GENERIC_FORM_CONFIRMATION"] = "generic-form-confirmation.html";
    EmailNames["CONNECT_TO_MYMEDICARE"] = "connectToMyMedicare.html";
    EmailNames["BLUE_BUTTON_AGENT"] = "blueButtonAgentEmail.html";
    EmailNames["CONSUMER_PASSWORD_RESET"] = "consumer-password-reset.html";
    EmailNames["YOUR_AGENT_HAS_INVITED"] = "your-agent-has-invited.html";
    EmailNames["HRA_CONSUMER"] = "hraConfirmationConsumer.html";
    EmailNames["HRA_BROKER"] = "hraConfirmationBroker.html";
    EmailNames["CONSUMER_FORGOT_USERNAME"] = "consumer-forgot-username.html";
    EmailNames["MFA_ACCESS_CODE"] = "mfa-code.html";
    EmailNames["ELECTRONIC_SIGNATURE_AUTH_CODE"] = "electronicSignatureAuthCode.html";
    EmailNames["PCEDGE_AGENTS_EMAIL"] = "pcedge-agents-email.html";
    EmailNames["VERIFICATION_ACCESS_CODE"] = "verification-code.html";
    EmailNames["SIGN_AND_SUBMIT"] = "sign-and-submit.html";
})(EmailNames || (EmailNames = {}));
// Normally we would write these as EQUAL_TO = something, but doing it this way prevents us from having to refactor
// the values in the email templates, which have values such as EQUALTO, that need to match the name.
var EmailComparator;
(function (EmailComparator) {
    EmailComparator["EQUALTO"] = "EQUALTO";
    EmailComparator["NOTEQUALTO"] = "NOTEQUALTO";
    EmailComparator["GREATERTHAN"] = "GREATERTHAN";
    EmailComparator["LESSTHAN"] = "LESSTHAN";
    EmailComparator["GREATERTHANEQUALTO"] = "GREATERTHANEQUALTO";
    EmailComparator["LESSTHANEQUALTO"] = "LESSTHANEQUALTO";
    EmailComparator["EXIST"] = "EXIST";
    EmailComparator["NOTEXIST"] = "NOTEXIST";
})(EmailComparator || (EmailComparator = {}));

var PasswordResetUserType;
(function (PasswordResetUserType) {
    PasswordResetUserType["AGENT"] = "Agent";
    PasswordResetUserType["CONSUMER"] = "Consumer";
})(PasswordResetUserType || (PasswordResetUserType = {}));
class GenerateResetHashReturnModel {
}
var ResetHashRequestType;
(function (ResetHashRequestType) {
    ResetHashRequestType["USER_NAME"] = "UserName";
    ResetHashRequestType["EMAIL_ADDRESS"] = "EmailAddress";
    ResetHashRequestType["RESET_HASH"] = "ResetHash";
})(ResetHashRequestType || (ResetHashRequestType = {}));

var SpinnerEvent;
(function (SpinnerEvent) {
    SpinnerEvent["AUTHENTICATION_LOADING"] = "authentication.loading";
    SpinnerEvent["NAVIGATE_TO_ENROLLMENT"] = "NavigateToEnrollment";
    SpinnerEvent["PLANS_LOADING"] = "plans.loading";
    SpinnerEvent["DEMOGRAPHICS_LOADING"] = "demographics.loading";
    SpinnerEvent["SOA_LOADING"] = "soa.loading";
    SpinnerEvent["PHARMACIES_LOADING"] = "pharmacies.loading";
    SpinnerEvent["PROVIDERS_LOADING"] = "providers.loading";
    SpinnerEvent["ENROLLMENT_FORM_LOADING"] = "enrollmentForm.loading";
    SpinnerEvent["MILLIMAN_LOADING"] = "milliman.loading";
    SpinnerEvent["MEMBER_LOADING"] = "member.loading";
    SpinnerEvent["BLUE_BUTTON_LOADING"] = "bluebutton.loading";
    SpinnerEvent["BENEFICIARY_FORM_SUBMIT"] = "BeneficiaryFormSubmit";
    SpinnerEvent["SHOPPING_CART_PLANS_ENROLLMENT_SETTINGS_LOADING"] = "ShoppingCartPlansEnrollmentSettings.loading";
    SpinnerEvent["SHOPPING_CART_LOADING"] = "ShoppingCart.loading";
    SpinnerEvent["BACK_TO_SHOPPING"] = "BackToShopping";
    SpinnerEvent["ENROLLMENT_LOADING"] = "enrollment.loading";
    SpinnerEvent["GENERIC_FORM_LOADING"] = "genericForm.loading";
    SpinnerEvent["EXTERNAL_HRA_LOADING"] = "external-hra.loading";
    SpinnerEvent["HRA_CONFIRMATION_LOADING"] = "hraConfirmationFormLoading.loading";
    SpinnerEvent["HRA_FORM_LOADING"] = "hraFormLoading.loading";
    SpinnerEvent["STANDALONE_FORM_LOADING"] = "standaloneForm.loading";
    SpinnerEvent["STANDALONE_FORM_INIT_TRANSACTION"] = "standaloneFormInitTransaction";
    SpinnerEvent["GENERIC_FORM_INIT_TRANSACTION"] = "genericFormInitTransaction";
    SpinnerEvent["SUBMITTED_FORM_LOADING"] = "submittedForm.loading";
    SpinnerEvent["DOWNLOAD_RESOURCE_LOADING"] = "downloadResource.loading";
    SpinnerEvent["SEND_EMAIL_LOADING"] = "sendEmail.loading";
    SpinnerEvent["APP_CONFIG_LOADING"] = "appConfig.loading";
    SpinnerEvent["PLAN_SMART_LOADING"] = "planSmart.loading";
    SpinnerEvent["NAVIGATION"] = "Navigation";
    SpinnerEvent["VBC_ATTESTATION_LOADING"] = "vbcAttestation.loading";
    SpinnerEvent["AGENT_SEARCH_LOADING"] = "agentSearch.loading";
    SpinnerEvent["QUOTE_LOADING"] = "quote.loading";
    SpinnerEvent["SUBSCRIPTION_LOADING"] = "subscription.loading";
    SpinnerEvent["INITIALIZE_SURVEY_VIEW"] = "initialize.survey";
    SpinnerEvent["FORM_NAVIGATION_VIEW"] = "initialize.formNavigation";
    SpinnerEvent["REASSIGN_AGENT_BENEFICIARY_LOADING"] = "reassignAgentBeneficiary.loading";
    SpinnerEvent["PREFERENCE_BANNER_PROVIDER_LOADING"] = "preferenceBanner.provider.loading";
    SpinnerEvent["FETCHAGENTBENEFICIARIES"] = "fetchAgentBeneficiaries";
    SpinnerEvent["EDIT_EXPIRING_PARTIAL_LOADING"] = "editExpiringPartial.loading";
    SpinnerEvent["EDIT_MEMBER_PROFILE_STATUS_LOADING"] = "editMemberProfileStatus.loading";
})(SpinnerEvent || (SpinnerEvent = {}));

class FormPostService {
    postToUrl(url, payload, newWindow) {
        if (url) {
            const form = this.initializeForm(url, newWindow);
            if (payload && Object.keys(payload).length) {
                this.setFormData(form, payload);
            }
            this.submitForm(form);
        }
    }
    initializeForm(action, isNewWindow) {
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = action;
        if (isNewWindow) {
            form.target = '_blank';
        }
        return form;
    }
    setFormData(form, payload) {
        if (form && payload) {
            for (const property in payload) {
                if (payload.hasOwnProperty(property)) {
                    const field = document.createElement('input');
                    field.setAttribute('type', 'hidden');
                    field.setAttribute('name', property);
                    field.setAttribute('value', payload[property]);
                    form.appendChild(field);
                }
            }
        }
    }
    submitForm(form) {
        document.body.appendChild(form);
        try {
            form.submit();
        }
        finally {
            document.body.removeChild(form);
        }
    }
}
FormPostService.ɵfac = function FormPostService_Factory(t) { return new (t || FormPostService)(); };
FormPostService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FormPostService, factory: FormPostService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormPostService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

class ShoppingRecordingContextService {
    constructor() {
        this.callInProgress$ = new BehaviorSubject(false);
        this.callRecentlyEnded$ = new BehaviorSubject(false);
        this.endCallConfirmationModalMustDisplay$ = new BehaviorSubject(false);
        this.endCallConfirmationModalIsOpen$ = new BehaviorSubject(false);
    }
    getCallInProgress$() {
        return this.callInProgress$.asObservable();
    }
    getCallRecentlyEnded$() {
        return this.callRecentlyEnded$.asObservable();
    }
    startCall() {
        this.callInProgress$.next(true);
        this.callRecentlyEnded$.next(false);
    }
    endCall() {
        setTimeout(() => {
            this.callRecentlyEnded$.next(false);
            this.callInProgress$.next(false);
        }, 5000);
        this.callRecentlyEnded$.next(true);
    }
    displayEndCallConfirmationModal() {
        this.endCallConfirmationModalMustDisplay$.next(true);
    }
    hideEndCallConfirmationModal() {
        this.endCallConfirmationModalMustDisplay$.next(false);
    }
    getEndCallConfirmationModalMustDisplayContext$() {
        return this.endCallConfirmationModalMustDisplay$.asObservable();
    }
    setEndCallConfirmationModalOpen(isModalOpen) {
        this.endCallConfirmationModalIsOpen$.next(isModalOpen);
    }
    getEndCallConfirmationModalOpenContext$() {
        return this.endCallConfirmationModalIsOpen$.asObservable();
    }
}
ShoppingRecordingContextService.ɵfac = function ShoppingRecordingContextService_Factory(t) { return new (t || ShoppingRecordingContextService)(); };
ShoppingRecordingContextService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ShoppingRecordingContextService, factory: ShoppingRecordingContextService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ShoppingRecordingContextService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

class CryptoUtilityService {
    constructor() {
        this.keySize = 256;
        this.iterations = 100;
    }
    static generateSecureRandomNumber(range) {
        const { min, max } = range;
        let randomNumber;
        /**
         * Currently, we're using CryptoJS v3.x.x. This is the implementation available in v4.x.x
         *
         * CryptoJS 4.0.0 Release Notes (https://github.com/brix/crypto-js/blob/4.1.1/core.js#L64-L69):
         * In this version Math.random() has been replaced by the random methods of the native crypto module.
         * For this reason CryptoJS might not run in some JavaScript environments without native crypto module. Such as IE 10 or before or React Native.
         *
         * MDN > Web APIs > Crypto (https://developer.mozilla.org/en-US/docs/Web/API/Crypto):
         * You should avoid using the Web Crypto API on insecure contexts, even though the Crypto interface is present on insecure contexts, as is the crypto property.
         * In addition, the Crypto method "getRandomValues()" is available on insecure contexts, but the subtle property is not.
         * In general, you probably should just treat Crypto as available only on secure contexts.
         */
        if (window?.isSecureContext && typeof crypto?.getRandomValues === 'function') {
            try {
                randomNumber = crypto.getRandomValues(new Uint32Array(1))?.[0];
            }
            catch (err) {
                console.error('Native crypto module could not be used to get secure random number.', err);
            }
        }
        // This is necessary to translate from a random integer to a floating point from 0 to 1.
        // Otherwise, we will use "Math.random()" for insecure contexts or contexts without the native crypto module.
        const randomFloat = randomNumber !== null && randomNumber !== undefined ? randomNumber / (CryptoUtilityService.MAX_UINT32 + 1) : Math.random();
        return Math.floor(randomFloat * (max - min + 1)) + min;
    }
    encrypt(plainText, password) {
        const salt = CryptoJS.lib.WordArray.random(16);
        const iv = CryptoJS.lib.WordArray.random(16);
        const key = CryptoJS.PBKDF2(password, salt, {
            keySize: this.keySize / 32,
            iterations: this.iterations
        });
        const encrypted = CryptoJS.AES.encrypt(plainText, key, {
            iv
        });
        return CryptoJS.enc.Base64.stringify(salt.concat(iv).concat(encrypted.ciphertext));
    }
    decrypt(message, password) {
        const messageWords = CryptoJS.enc.Base64.parse(message).words;
        const salt = CryptoJS.lib.WordArray.create(messageWords.slice(0, 4));
        const iv = CryptoJS.lib.WordArray.create(messageWords.slice(4, 8));
        const encrypted = CryptoJS.lib.WordArray.create(messageWords.slice(8));
        const key = CryptoJS.PBKDF2(password, salt, {
            keySize: this.keySize / 32,
            iterations: this.iterations
        });
        const decrypted = CryptoJS.AES.decrypt({ ciphertext: encrypted }, key, {
            iv
        });
        return decrypted;
    }
}
CryptoUtilityService.MAX_UINT32 = 0xffffffff;
CryptoUtilityService.ɵfac = function CryptoUtilityService_Factory(t) { return new (t || CryptoUtilityService)(); };
CryptoUtilityService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CryptoUtilityService, factory: CryptoUtilityService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CryptoUtilityService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

class GoogleTagManagerService {
    constructor(store) {
        this.store = store;
        this.isDataLayerInitialized = false;
        this.isGtmLoadEventPushed = window.dataLayerDrx?.some(dataTag => dataTag.event === this.gtmLoadEvent) ?? false;
        // Emits updated "window.dataLayerDrx" after each push
        this.dataLayerDrxValueChanges$ = new Subject();
        this.gtmLoadEvent = 'gtm.load';
        this.browserSessionId = 'vnext-browser-session-id';
        this.dataLayerDrxQueue = [];
        this.subscriptions = new Subscription();
        this.base36 = 36;
        // Range used to generate a random decimal number equivalent to a 6 character Base36 string
        this.decimalRange = {
            // Equivalent to (Base36) 100000
            min: 60466176,
            // Equivalent to (Base36) zzzzzz
            max: 2176782335
        };
        const googleDataTag = this.store.selectSnapshot(GoogleTagManagerState.googleDataLayerTag);
        this.tags = googleDataTag ? this.getDefaultsWithTag(googleDataTag) : this.getDefaultsWithoutTag();
        if (!this.isGtmLoadEventPushed) {
            // We patch the data layer's "push()" method to react on each change
            this.patchDataLayerPushMethod();
            this.subscriptions.add(this.dataLayerDrxValueChanges$
                .pipe(
            // Skip data layer changes until "gtm.load" event has been pushed
            skipWhile(dataLayerDrx => !dataLayerDrx?.some(dataTag => dataTag.event === this.gtmLoadEvent)))
                .subscribe({
                next: dataLayerDrx => {
                    // We don't want to keep queueing anymore now that "gtm.load" event has been pushed.
                    this.isGtmLoadEventPushed = true;
                    // Push all queued data in the same order to the data layer
                    while (this.dataLayerDrxQueue.length) {
                        const dataTag = this.dataLayerDrxQueue.shift();
                        if (dataTag) {
                            this.addToDataLayer(dataTag);
                        }
                    }
                    // We complete the subscription after pushing all queued data into the data layer.
                    // Any subsequent push will be added directly into the data layer.
                    this.dataLayerDrxValueChanges$.complete();
                }
            }));
        }
    }
    set googleDataLayerTags(dataTag) {
        Object.keys(DataLayerGlobalVariable)
            .map(key => DataLayerGlobalVariable[key])
            .forEach(key => {
            if (dataTag[key] !== null && dataTag[key] !== undefined) {
                this.tags[key] = dataTag[key];
            }
        });
        this.addToDataLayer(dataTag);
    }
    get googleDataLayerTags() {
        return this.tags;
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    setGoogleDataLayerTag(key, value) {
        this.tags[key] = value;
        this.addToDataLayer({
            [key]: value
        });
    }
    addToDataLayer(dataTag) {
        let dataLayerDrx = this.tags;
        if (dataTag && this.isDataLayerInitialized) {
            dataLayerDrx = dataTag;
        }
        else {
            this.isDataLayerInitialized = true;
        }
        this.addUniqueID(dataLayerDrx);
        this.addBrowserSessionID(dataLayerDrx);
        // Push directly into the data layer if "gtm.load" event has been pushed
        if (this.isGtmLoadEventPushed) {
            const globalDataLayer = window.dataLayerDrx;
            if (globalDataLayer) {
                globalDataLayer.push(dataLayerDrx);
                this.updateGlobalDataTags(dataLayerDrx);
            }
        }
        // Otherwise, add it to the queue
        else {
            this.dataLayerDrxQueue.push(dataLayerDrx);
        }
    }
    updateGlobalDataTags(dataTag) {
        const storeDataTags = this.store.selectSnapshot(GoogleTagManagerState.googleDataLayerTag);
        let dataTagUpdated = false;
        Object.keys(DataLayerGlobalVariable)
            .map(key => DataLayerGlobalVariable[key])
            .forEach(key => {
            if (Object.prototype.hasOwnProperty.call(storeDataTags, key)) {
                this.globalTags = { ...this.globalTags, [key]: storeDataTags[key] ? storeDataTags[key] : this.tags[key] };
                if (dataTag[key] !== null && dataTag[key] !== undefined) {
                    this.globalTags[key] = dataTag[key];
                    dataTagUpdated = true;
                }
            }
        });
        if (dataTagUpdated) {
            this.store.dispatch(new SetGoogleDataLayerTag(this.globalTags));
        }
    }
    // Generates a random ID.
    // This ID will be a unix timestamp down to the second, plus a random 6 character hexatridecimal (Base36) string. Example value: "1669852423.hxa0z9"
    generateRandomID() {
        const currentUnixTimestamp = DateUtilities.convertToUnixTimestamp();
        const randomNumber = CryptoUtilityService.generateSecureRandomNumber(this.decimalRange);
        const randomBase36String = randomNumber?.toString(this.base36);
        return `${currentUnixTimestamp}.${randomBase36String}`;
    }
    addUniqueID(dataLayerDrx) {
        // Adding an event ID for every non-Pageview event that happens
        if (NON_VIEW_PAGE_EVENT_PREFIXES.some(eventPrefix => this.matchEvent(eventPrefix, dataLayerDrx?.event)) &&
            // Prevents overwriting the original timestamp (added when queueing) when moving the push from the queue to the data layer
            !dataLayerDrx[DataLayerGlobalVariable.EVENT_ID]) {
            dataLayerDrx[DataLayerGlobalVariable.EVENT_ID] = this.generateRandomID();
        }
        else if (this.matchEvent(DataLayerEvent.VIEW_PAGE, dataLayerDrx?.event) && !dataLayerDrx[DataLayerGlobalVariable.PAGE_VIEW_ID]) {
            dataLayerDrx[DataLayerGlobalVariable.PAGE_VIEW_ID] = this.generateRandomID();
        }
    }
    containsEvent(event, dataLayer) {
        const dataLayerDrx = dataLayer ?? window.dataLayerDrx;
        return dataLayerDrx?.some(dataTag => dataTag.event === event) ?? false;
    }
    addBrowserSessionID(dataTag) {
        if (this.matchEvent(DataLayerEvent.VIEW_PAGE, dataTag?.event) &&
            // Prevents overwriting the original timestamp (added when queueing) when moving the push from the queue to the data layer
            !dataTag[DataLayerGlobalVariable.BROWSER_SESSION_ID] &&
            // Check if the data layer doesn't contain any "view-page" events. If so, this would be the first one so we can add the browser session ID.
            !this.containsEvent(DataLayerEvent.VIEW_PAGE)) {
            dataTag[DataLayerGlobalVariable.BROWSER_SESSION_ID] = this.getBrowserSessionId();
        }
    }
    getBrowserSessionId() {
        let sessionId = sessionStorage.getItem(this.browserSessionId);
        if (!sessionId) {
            sessionId = this.generateRandomID();
            sessionStorage.setItem(this.browserSessionId, sessionId);
        }
        return sessionId;
    }
    matchEvent(eventPrefix, event) {
        if (event) {
            const eventRegex = new RegExp(`^${eventPrefix}`);
            return eventRegex.test(event);
        }
        return false;
    }
    // eslint-disable-next-line complexity
    getDefaultsWithTag(googleDataTag) {
        return {
            [DataLayerGlobalVariable.SITE_URL]: googleDataTag[DataLayerGlobalVariable.SITE_URL]
                ? googleDataTag[DataLayerGlobalVariable.SITE_URL]
                : null,
            [DataLayerGlobalVariable.SITE_ID]: googleDataTag[DataLayerGlobalVariable.SITE_ID]
                ? googleDataTag[DataLayerGlobalVariable.SITE_ID]
                : null,
            [DataLayerGlobalVariable.SITE_CHANNEL]: googleDataTag[DataLayerGlobalVariable.SITE_CHANNEL]
                ? googleDataTag[DataLayerGlobalVariable.SITE_CHANNEL]
                : null,
            [DataLayerGlobalVariable.AGENT_GUID]: googleDataTag[DataLayerGlobalVariable.AGENT_GUID]
                ? googleDataTag[DataLayerGlobalVariable.AGENT_GUID]
                : null,
            [DataLayerGlobalVariable.AGENT_IS_PROFILE_ADMIN]: googleDataTag[DataLayerGlobalVariable.AGENT_IS_PROFILE_ADMIN]
                ? googleDataTag[DataLayerGlobalVariable.AGENT_IS_PROFILE_ADMIN]
                : null,
            [DataLayerGlobalVariable.COUNTY_FIPS]: googleDataTag[DataLayerGlobalVariable.COUNTY_FIPS]
                ? googleDataTag[DataLayerGlobalVariable.COUNTY_FIPS]
                : null,
            [DataLayerGlobalVariable.LANGUAGE_ID]: googleDataTag[DataLayerGlobalVariable.LANGUAGE_ID]
                ? googleDataTag[DataLayerGlobalVariable.LANGUAGE_ID]
                : null,
            [DataLayerGlobalVariable.MEMBER_ID]: googleDataTag[DataLayerGlobalVariable.MEMBER_ID]
                ? googleDataTag[DataLayerGlobalVariable.MEMBER_ID]
                : null,
            [DataLayerGlobalVariable.EXTERNAL_MEMBER_ID]: googleDataTag[DataLayerGlobalVariable.EXTERNAL_MEMBER_ID]
                ? googleDataTag[DataLayerGlobalVariable.EXTERNAL_MEMBER_ID]
                : GOOGLE_ANALYTICS_NOT_APPLICABLE,
            [DataLayerGlobalVariable.EXTERNAL_REFERENCE_ID]: googleDataTag[DataLayerGlobalVariable.EXTERNAL_REFERENCE_ID]
                ? googleDataTag[DataLayerGlobalVariable.EXTERNAL_REFERENCE_ID]
                : GOOGLE_ANALYTICS_NOT_APPLICABLE,
            [DataLayerGlobalVariable.SELECTED_PHARMACY]: googleDataTag[DataLayerGlobalVariable.SELECTED_PHARMACY]
                ? googleDataTag[DataLayerGlobalVariable.SELECTED_PHARMACY]
                : null,
            [DataLayerGlobalVariable.PLANS_COST_BASED_ON]: googleDataTag[DataLayerGlobalVariable.PLANS_COST_BASED_ON]
                ? googleDataTag[DataLayerGlobalVariable.PLANS_COST_BASED_ON]
                : null,
            [DataLayerGlobalVariable.SITE_HAS_GUIDED_HELP_INFO]: googleDataTag[DataLayerGlobalVariable.SITE_HAS_GUIDED_HELP_INFO]
                ? googleDataTag[DataLayerGlobalVariable.SITE_HAS_GUIDED_HELP_INFO]
                : null,
            [DataLayerGlobalVariable.TRANSACTION_GUID]: googleDataTag[DataLayerGlobalVariable.TRANSACTION_GUID]
                ? googleDataTag[DataLayerGlobalVariable.TRANSACTION_GUID]
                : null,
            [DataLayerGlobalVariable.ZIP]: googleDataTag[DataLayerGlobalVariable.ZIP] ? googleDataTag[DataLayerGlobalVariable.ZIP] : null,
            [DataLayerGlobalVariable.EVENT]: googleDataTag[DataLayerGlobalVariable.EVENT] ? googleDataTag[DataLayerGlobalVariable.EVENT] : null,
            [DataLayerGlobalVariable.RIDER_NAME]: googleDataTag[DataLayerGlobalVariable.RIDER_NAME]
                ? googleDataTag[DataLayerGlobalVariable.RIDER_NAME]
                : null,
            [DataLayerGlobalVariable.RIDER_PLANID]: googleDataTag[DataLayerGlobalVariable.RIDER_PLANID]
                ? googleDataTag[DataLayerGlobalVariable.RIDER_PLANID]
                : null,
            [DataLayerGlobalVariable.RIDER_PLANTYPE]: googleDataTag[DataLayerGlobalVariable.RIDER_PLANTYPE]
                ? googleDataTag[DataLayerGlobalVariable.RIDER_PLANTYPE]
                : null,
            [DataLayerGlobalVariable.APP_SESSION_ID]: googleDataTag[DataLayerGlobalVariable.APP_SESSION_ID]
                ? googleDataTag[DataLayerGlobalVariable.APP_SESSION_ID]
                : null,
            [DataLayerGlobalVariable.USER_NAME]: googleDataTag[DataLayerGlobalVariable.USER_NAME]
                ? googleDataTag[DataLayerGlobalVariable.USER_NAME]
                : null,
            [DataLayerGlobalVariable.USER_ID_METHOD]: googleDataTag[DataLayerGlobalVariable.USER_ID_METHOD]
                ? googleDataTag[DataLayerGlobalVariable.USER_ID_METHOD]
                : null,
            [DataLayerGlobalVariable.CLIENT_ID]: googleDataTag[DataLayerGlobalVariable.CLIENT_ID]
                ? googleDataTag[DataLayerGlobalVariable.CLIENT_ID]
                : null,
            [DataLayerGlobalVariable.CLIENT_GAID]: googleDataTag[DataLayerGlobalVariable.CLIENT_GAID]
                ? googleDataTag[DataLayerGlobalVariable.CLIENT_GAID]
                : null,
            [DataLayerGlobalVariable.APP_ID]: googleDataTag[DataLayerGlobalVariable.APP_ID]
                ? googleDataTag[DataLayerGlobalVariable.APP_ID]
                : null,
            [DataLayerGlobalVariable.PROVIDER_COUNT]: googleDataTag[DataLayerGlobalVariable.PROVIDER_COUNT]
                ? googleDataTag[DataLayerGlobalVariable.PROVIDER_COUNT]
                : null,
            [DataLayerGlobalVariable.DRUG_COUNT]: googleDataTag[DataLayerGlobalVariable.DRUG_COUNT]
                ? googleDataTag[DataLayerGlobalVariable.DRUG_COUNT]
                : null,
            [DataLayerGlobalVariable.MEMBER_PREF_COVERAGE]: googleDataTag[DataLayerGlobalVariable.MEMBER_PREF_COVERAGE]
                ? googleDataTag[DataLayerGlobalVariable.MEMBER_PREF_COVERAGE]
                : null,
            [DataLayerGlobalVariable.MEMBER_PREF_SUBSIDY]: googleDataTag[DataLayerGlobalVariable.MEMBER_PREF_SUBSIDY] ?? null,
            [DataLayerGlobalVariable.MEMBER_PREF_HEALTH]: googleDataTag[DataLayerGlobalVariable.MEMBER_PREF_HEALTH]
                ? googleDataTag[DataLayerGlobalVariable.MEMBER_PREF_HEALTH]
                : null,
            [DataLayerGlobalVariable.MEMBER_PREF_AGE]: googleDataTag[DataLayerGlobalVariable.MEMBER_PREF_AGE]
                ? googleDataTag[DataLayerGlobalVariable.MEMBER_PREF_AGE]
                : null,
            [DataLayerGlobalVariable.MEMBER_ASSIST_CODE]: googleDataTag[DataLayerGlobalVariable.MEMBER_ASSIST_CODE]
                ? googleDataTag[DataLayerGlobalVariable.MEMBER_ASSIST_CODE]
                : GOOGLE_ANALYTICS_NOT_APPLICABLE,
            [DataLayerGlobalVariable.MEMBER_PREF_HEALTH_COST_CALC]: googleDataTag[DataLayerGlobalVariable.MEMBER_PREF_HEALTH_COST_CALC]
                ? googleDataTag[DataLayerGlobalVariable.MEMBER_PREF_HEALTH_COST_CALC]
                : GOOGLE_ANALYTICS_NO,
            [DataLayerGlobalVariable.SITE_PLAN_YEAR]: googleDataTag[DataLayerGlobalVariable.SITE_PLAN_YEAR]
                ? googleDataTag[DataLayerGlobalVariable.SITE_PLAN_YEAR]
                : null
        };
    }
    getDefaultsWithoutTag() {
        return {
            [DataLayerGlobalVariable.SITE_URL]: null,
            [DataLayerGlobalVariable.SITE_ID]: null,
            [DataLayerGlobalVariable.SITE_CHANNEL]: null,
            [DataLayerGlobalVariable.AGENT_GUID]: null,
            [DataLayerGlobalVariable.AGENT_IS_PROFILE_ADMIN]: null,
            [DataLayerGlobalVariable.COUNTY_FIPS]: null,
            [DataLayerGlobalVariable.LANGUAGE_ID]: null,
            [DataLayerGlobalVariable.MEMBER_ID]: null,
            [DataLayerGlobalVariable.EXTERNAL_MEMBER_ID]: GOOGLE_ANALYTICS_NOT_APPLICABLE,
            [DataLayerGlobalVariable.EXTERNAL_REFERENCE_ID]: GOOGLE_ANALYTICS_NOT_APPLICABLE,
            [DataLayerGlobalVariable.SELECTED_PHARMACY]: null,
            [DataLayerGlobalVariable.PLANS_COST_BASED_ON]: null,
            [DataLayerGlobalVariable.SITE_HAS_GUIDED_HELP_INFO]: null,
            [DataLayerGlobalVariable.TRANSACTION_GUID]: null,
            [DataLayerGlobalVariable.ZIP]: null,
            [DataLayerGlobalVariable.EVENT]: null,
            [DataLayerGlobalVariable.RIDER_NAME]: null,
            [DataLayerGlobalVariable.RIDER_PLANID]: null,
            [DataLayerGlobalVariable.RIDER_PLANTYPE]: null,
            [DataLayerGlobalVariable.APP_SESSION_ID]: null,
            [DataLayerGlobalVariable.USER_NAME]: null,
            [DataLayerGlobalVariable.USER_ID_METHOD]: null,
            [DataLayerGlobalVariable.CLIENT_ID]: null,
            [DataLayerGlobalVariable.CLIENT_GAID]: null,
            [DataLayerGlobalVariable.PROVIDER_COUNT]: null,
            [DataLayerGlobalVariable.DRUG_COUNT]: NO_DRUGS_COUNT,
            [DataLayerGlobalVariable.MEMBER_PREF_COVERAGE]: null,
            [DataLayerGlobalVariable.MEMBER_PREF_SUBSIDY]: null,
            [DataLayerGlobalVariable.MEMBER_PREF_HEALTH]: null,
            [DataLayerGlobalVariable.MEMBER_PREF_AGE]: null,
            [DataLayerGlobalVariable.MEMBER_ASSIST_CODE]: GOOGLE_ANALYTICS_NOT_APPLICABLE,
            [DataLayerGlobalVariable.MEMBER_PREF_HEALTH_COST_CALC]: GOOGLE_ANALYTICS_NO,
            [DataLayerGlobalVariable.SITE_PLAN_YEAR]: null
        };
    }
    patchDataLayerPushMethod() {
        const dataLayerDrx = window.dataLayerDrx;
        if (dataLayerDrx?.push) {
            // Store the original "push()" method.
            const originalDataLayerDrxPushMethod = dataLayerDrx.push;
            // Replace it with our reactive method. The original method won't be restored afterwards.
            // The reason for that is to prevent analytics tools like "Analytics Debugger" (that also patch this method) to break.
            dataLayerDrx.push = (...items) => {
                // Call the original "push()" method to add data into the data layer
                const result = originalDataLayerDrxPushMethod.apply(dataLayerDrx, items);
                // Emit the updated data layer if "gtm.load" event hasn't been pushed.
                if (!this.isGtmLoadEventPushed) {
                    this.dataLayerDrxValueChanges$.next(dataLayerDrx);
                }
                return result;
            };
        }
    }
}
GoogleTagManagerService.ɵfac = function GoogleTagManagerService_Factory(t) { return new (t || GoogleTagManagerService)(i0.ɵɵinject(i1.Store)); };
GoogleTagManagerService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: GoogleTagManagerService, factory: GoogleTagManagerService.ɵfac, providedIn: 'root' });
__decorate([
    Memoize()
], GoogleTagManagerService.prototype, "matchEvent", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GoogleTagManagerService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }]; }, { matchEvent: [] }); })();

class AgentCallRecordingNavigationService {
    constructor(modalService, configResourceService, store, shoppingRecordingContextService, analyticsService) {
        this.modalService = modalService;
        this.configResourceService = configResourceService;
        this.store = store;
        this.shoppingRecordingContextService = shoppingRecordingContextService;
        this.analyticsService = analyticsService;
    }
    async handleExternalNavigationForCallRecordingInProgress() {
        const recordingInProgress = await this.shoppingRecordingContextService.getCallInProgress$().pipe(take(1)).toPromise();
        if (recordingInProgress) {
            const endCallConfirmationModal = this.setupEndCallConfirmationModal();
            return endCallConfirmationModal.result
                .then(() => {
                this.shoppingRecordingContextService.endCall();
                return true;
            })
                .catch(() => false);
        }
        return true;
    }
    setupEndCallConfirmationModal() {
        const modalTitle = this.configResourceService.getProcessedResourceValue('Spa_AgentCallRecordingLeaving_Title', null, 'End Call Recording');
        const modalPrompt = this.configResourceService
            .getProcessedResourceValue('Spa_AgentCallRecordingLeaving_Label', null, `You are leaving <member>'s session. Click to end the call or click “Cancel” to continue call.`)
            .replace('<member>', this.getMemberFullName());
        const modalCancel = this.configResourceService.getProcessedResourceValue('Spa_Site_Cancel', null, 'Cancel');
        const endCall = this.getEndCallText();
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_CALL_RECORDING_END_CALL_MODAL_OPEN
        };
        const confirmationModal = this.modalService.open(ConfirmationModalComponent, { centered: true });
        confirmationModal.componentInstance.title = modalTitle;
        confirmationModal.componentInstance.prompt = modalPrompt;
        confirmationModal.componentInstance.cancelButton = modalCancel;
        confirmationModal.componentInstance.confirmButton = endCall;
        confirmationModal.componentInstance.cancelAction = () => {
            this.analyticsService.googleDataLayerTags = {
                [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_CALL_RECORDING_END_CALL_MODAL_CANCEL
            };
        };
        confirmationModal.componentInstance.confirmAction = () => {
            this.analyticsService.googleDataLayerTags = {
                [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_CALL_RECORDING_END_CALL_MODAL_DIFFERENT_SESSION
            };
        };
        return confirmationModal;
    }
    getMemberFullName() {
        return this.store.selectSnapshot(ProfileState.fullName);
    }
    getEndCallText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallEndCall_Title', widgetName, 'End call');
    }
}
AgentCallRecordingNavigationService.ɵfac = function AgentCallRecordingNavigationService_Factory(t) { return new (t || AgentCallRecordingNavigationService)(i0.ɵɵinject(i1$1.NgbModal), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(i1.Store), i0.ɵɵinject(ShoppingRecordingContextService), i0.ɵɵinject(GoogleTagManagerService)); };
AgentCallRecordingNavigationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AgentCallRecordingNavigationService, factory: AgentCallRecordingNavigationService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentCallRecordingNavigationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$1.NgbModal }, { type: ConfigResourceService }, { type: i1.Store }, { type: ShoppingRecordingContextService }, { type: GoogleTagManagerService }]; }, null); })();

class NavigationService {
    constructor(router, modalService, navigationUtilityService, configResourceService, location, formPostService, agentCallRecordingNavigationService, store) {
        this.router = router;
        this.modalService = modalService;
        this.navigationUtilityService = navigationUtilityService;
        this.configResourceService = configResourceService;
        this.location = location;
        this.formPostService = formPostService;
        this.agentCallRecordingNavigationService = agentCallRecordingNavigationService;
        this.store = store;
    }
    backToPrevious() {
        this.location.back();
    }
    async navigate(link) {
        const environment = EnvironmentService.getEnvironment();
        // doing this to prevent routing during liveedit
        // attempted this using a deactivation guard but we are listening to RoutesRecognized events to monitor
        // shortSiteId and changeSetId and the order of routing events was before the full url was constructed
        // leaving us without these values and unable to post liveedit changes to the server
        if (!environment.liveedit) {
            const { href, type, target, validateWidgets } = link;
            const linkHref = this.navigationUtilityService.constructNavigationLink(link);
            if ((type === undefined || type === LinkType.INTERNAL) && linkHref) {
                return await this.router.navigateByUrl(`${linkHref}`, validateWidgets !== undefined && { state: { [ROUTER_EXTRAS_VALIDATE_KEY]: validateWidgets } });
            }
            if (type === LinkType.EXTERNAL && href && typeof window !== 'undefined') {
                const targetAttribute = target || TargetType.BLANK;
                const checkCallRecordingInProgress = targetAttribute === TargetType.SELF;
                // Case: when the linked document opens in the same browser tab, check if there is a call recording in progress
                // to prompt the user with the End call recording modal before continuing
                if (checkCallRecordingInProgress) {
                    return await this.agentCallRecordingNavigationService
                        .handleExternalNavigationForCallRecordingInProgress()
                        .then(async (displayNavigateModal) => {
                        if (displayNavigateModal) {
                            return await this.handleExternalNavigation(href, targetAttribute, link);
                        }
                        return false;
                    })
                        .catch(() => false);
                }
                return await this.handleExternalNavigation(href, targetAttribute, link);
            }
        }
    }
    async navigateByPageTag(pageTag, navigationExtras) {
        const environment = EnvironmentService.getEnvironment();
        if (!environment.liveedit) {
            const tagHref = this.navigationUtilityService.constructHref(pageTag);
            if (tagHref) {
                // return this.router.navigateByUrl(tagHref, extras); // angular docs say this should work, but no...
                // https://github.com/angular/angular/issues/18798 provides some context and the workaround we're using
                return await this.router.navigate([tagHref], navigationExtras);
            }
            return await Promise.resolve(false);
        }
    }
    async constructUrlTreeFromPageTag(pageTag, navigationExtras) {
        const href = this.navigationUtilityService.constructHref(pageTag);
        return this.router.createUrlTree(href?.split('/') ?? [], navigationExtras);
    }
    async navigateTo404() {
        return await this.navigate({ title: '404', href: '404' });
    }
    getCurrentPageBaseUrl() {
        return this.router.url.split('?')[0];
    }
    getNavigationExtrasStateValue(stateKey) {
        const navigation = this.router.getCurrentNavigation();
        let value;
        if (navigation?.extras) {
            const state = navigation.extras.state;
            if (state) {
                value = state[stateKey];
            }
        }
        return value;
    }
    navigateToRetireFlo(baseUrl, retireFloSignUpFlag, agentGuid = this.store.selectSnapshot(AgentState.agentGuid)) {
        const agentFirstName = this.store.selectSnapshot(AgentState.firstName);
        const agentLastName = this.store.selectSnapshot(AgentState.lastName);
        const agentEmailAddress = this.store.selectSnapshot(AgentState.emailAddress);
        let returnUrl = window.location.toString();
        if (!returnUrl.includes('?checkRetireFloStatus=true')) {
            returnUrl = `${returnUrl}?checkRetireFloStatus=true`;
        }
        let queryParams = `?connectureGuid=${agentGuid}&connectureReturnUrl=${returnUrl}`;
        if (retireFloSignUpFlag) {
            queryParams += `&agentFirstName=${agentFirstName}&agentLastName=${agentLastName}&agentEmail=${agentEmailAddress}`;
        }
        window.open(baseUrl + queryParams, TargetType.SELF);
    }
    navigateToRetireFloSurvey(url) {
        window.open(url, TargetType.BLANK);
    }
    navigateToLmsInNewTab(agentGuid) {
        const baseUrl = this.store.selectSnapshot(AppConfigState.defaultUrl);
        const lmsUrl = `/o/saml2/client/lms/${agentGuid}`;
        window.open(baseUrl + lmsUrl, TargetType.BLANK);
    }
    navigateToActiveAnalyticsInNewTab() {
        const activeAnalyticsUrl = this.configResourceService.getProcessedResourceValue('Spa_ActiveAnalytics_BaseUrl');
        if (activeAnalyticsUrl && this.navigationUtilityService.isValidUrl(activeAnalyticsUrl)) {
            window.open(activeAnalyticsUrl, TargetType.BLANK);
        }
    }
    /**
     * Use this to reload the current route instead of location.reload(); for most cases. Since we set values
     * to session storage after a setTimeout for performance purposes there can be scenarios where we are not
     * able to set the values we need after the reload in the store by the time the page reloads effectively
     * throwing away various NGXS store dispatchs and session storage updates.
     */
    reloadCurrentRoute() {
        this.router.navigateByUrl(this.router.url, { onSameUrlNavigation: 'reload', skipLocationChange: true });
    }
    async navigateToExternalEnrollment(url, integrationType) {
        const targetAttribute = integrationType === IntegrationType.POPUP ? TargetType.BLANK : TargetType.SELF;
        return await this.navigateToExternalSite(url, targetAttribute, false);
    }
    async navigateByPageTagToNewTab(pageTag, navigationExtras) {
        const baseUrl = this.store.selectSnapshot(AppConfigState.defaultUrl);
        const urlTree = await this.constructUrlTreeFromPageTag(pageTag, navigationExtras);
        const link = this.router.serializeUrl(urlTree);
        window.open(baseUrl + link, TargetType.BLANK);
    }
    openNavigateToExternalSiteModal() {
        const options = {
            ariaLabelledBy: 'modalHeaderTitle',
            centered: true
        };
        const confirmationModal = this.modalService.open(ConfirmationModalComponent, options);
        confirmationModal.componentInstance.title =
            this.configResourceService.getProcessedResourceValue('Spa_ExternalSiteModal_Title') || 'You are now leaving the site';
        confirmationModal.componentInstance.prompt =
            this.configResourceService.getProcessedResourceValue('Spa_ExternalSiteModal_Prompt') ||
                'You are about to go to an external website. Would you like to continue?';
        confirmationModal.componentInstance.cancelButton =
            this.configResourceService.getProcessedResourceValue('Spa_ExternalSiteModal_Cancel') || 'Cancel';
        confirmationModal.componentInstance.confirmButton =
            this.configResourceService.getProcessedResourceValue('Spa_ExternalSiteModal_Continue') || 'Continue';
        return confirmationModal;
    }
    async handleExternalNavigation(href, targetAttribute, link) {
        if (this.isWarningNeeded(href)) {
            return await this.openNavigateToExternalSiteModal()
                .result.then(async () => await this.navigateToExternalSite(href, targetAttribute, link.isPost, link.postData))
                .catch(() => false);
        }
        return await this.navigateToExternalSite(href, targetAttribute, link.isPost, link.postData);
    }
    isWarningNeeded(url) {
        const baseUrlValue = this.navigationUtilityService.getOrigin();
        const externalSiteWarningEnabled = !!this.configResourceService.getProcessedResourceValue('Spa_ExternalSiteWarning_Enabled');
        if (!externalSiteWarningEnabled) {
            return false;
        }
        if (!url.startsWith('http://') && !url.startsWith('https://') && !url.startsWith('//')) {
            return false;
        }
        const vanityUrls = this.configResourceService.getProcessedResourceValue('Spa_UrlWhitelist') || [];
        if (!vanityUrls.includes(baseUrlValue)) {
            vanityUrls.push(baseUrlValue);
        }
        const contentServerUrl = this.configResourceService.getProcessedResourceValue('ContentServerUrl', null, 'https://content.destinationrx.com/ContentServer/DRxProductContent');
        // any call to our own content server should skip external warning popup, so add that to our vanity list
        if (!vanityUrls.includes(contentServerUrl)) {
            vanityUrls.push(contentServerUrl);
        }
        const vanityUrlsWithTrailingWildCard = _flatMap(vanityUrls, vanityUrl => {
            if (!vanityUrl.endsWith('*')) {
                let extraVanityUrl = vanityUrl;
                if (!vanityUrl.endsWith('/')) {
                    extraVanityUrl = `${extraVanityUrl}/`;
                }
                extraVanityUrl = `${extraVanityUrl}*`;
                return [extraVanityUrl, vanityUrl];
            }
            return [vanityUrl];
        });
        const removeProtocolRegex = /^https?:\/\//i;
        const urlWithoutProtocol = url.replace(removeProtocolRegex, '');
        const isVanityUrl = vanityUrlsWithTrailingWildCard.some(vanityUrl => this.matchRule(urlWithoutProtocol, vanityUrl.replace(removeProtocolRegex, '')));
        return !isVanityUrl;
    }
    // match rule method from https://stackoverflow.com/questions/26246601/wildcard-string-comparison-in-javascript
    matchRule(value, rule) {
        const escapeRegex = (str) => str.replace(/([.*+?^=!:${}()|\[\]\/\\])/gi, '\\$1');
        return new RegExp(`^${rule.split('*').map(escapeRegex).join('.*')}$`).test(value);
    }
    async navigateToExternalSite(href, targetAttribute, isPost, postData) {
        if (isPost) {
            this.formPostService.postToUrl(href, postData, targetAttribute === TargetType.BLANK);
        }
        else {
            window.open(href, targetAttribute);
        }
        return await Promise.resolve(true);
    }
}
NavigationService.ɵfac = function NavigationService_Factory(t) { return new (t || NavigationService)(i0.ɵɵinject(i2$1.Router), i0.ɵɵinject(i1$1.NgbModal), i0.ɵɵinject(NavigationUtilityService), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(i3.Location), i0.ɵɵinject(FormPostService), i0.ɵɵinject(AgentCallRecordingNavigationService), i0.ɵɵinject(i1.Store)); };
NavigationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: NavigationService, factory: NavigationService.ɵfac, providedIn: 'root' });
__decorate([
    LiveEditInactive()
], NavigationService.prototype, "backToPrevious", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavigationService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i2$1.Router }, { type: i1$1.NgbModal }, { type: NavigationUtilityService }, { type: ConfigResourceService }, { type: i3.Location }, { type: FormPostService }, { type: AgentCallRecordingNavigationService }, { type: i1.Store }]; }, { backToPrevious: [] }); })();

/**
 * For dealing with plan year resources and plan year resource derived values.
 */
class PlanYearResourceService {
    constructor(configResourceService, store) {
        this.configResourceService = configResourceService;
        this.store = store;
        this.isConsumerSiteIdEnabled = this.configResourceService.getProcessedResourceValue('Spa_ConsumerSiteID_Enabled', null, false);
        this.isDualPlanYearSite =
            !!this.configResourceService.getProcessedResourceValue(PlanYearResourceNames.DUAL_PLAN_YEAR) &&
                !!this.configResourceService.getProcessedResourceValue('Spa_DualPlanYear_Enabled', null, true);
        this.allowedPlanYears = this.isDualPlanYearSite ? [this.getDualPlanYear(), this.getCurrentPlanYear()] : [this.getCurrentPlanYear()];
    }
    getIsDualPlanYearSite() {
        return this.isDualPlanYearSite;
    }
    getCurrentPlanYear() {
        return this.configResourceService.getProcessedResourceValue(PlanYearResourceNames.PLAN_YEAR);
    }
    getDualPlanYear() {
        return this.configResourceService.getProcessedResourceValue(PlanYearResourceNames.DUAL_PLAN_YEAR);
    }
    getIsHeaderPlanYearBadgeEnabled(widgetName, pageName) {
        return this.configResourceService.getProcessedResourceValue('Spa_HeaderFooter_PlanYearBadge_Enabled', widgetName, false, false, pageName);
    }
    getIsDualPlanYearPurlEnabled() {
        return (this.getIsDualPlanYearSite() &&
            this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_Purl_DualPlanYear_Enabled', null, false));
    }
    getPlanYearMap() {
        return {
            [PlanYearType.DUAL]: this.getDualPlanYear(),
            [PlanYearType.CURRENT]: this.getCurrentPlanYear()
        };
    }
    getPlanYearType(planYear) {
        return this.getPlanYearTypeMap()?.[planYear];
    }
    initializeSelectedPlanYear() {
        const selectedPlanYear = this.getSelectedPlanYear();
        if (!selectedPlanYear) {
            this.setSelectedPlanYear(PlanYearType.CURRENT);
        }
    }
    setSelectedPlanYear(selectedPlanYearType) {
        const selectedPlanYear = this.configResourceService.getProcessedResourceValue(!this.getIsDualPlanYearSite() || selectedPlanYearType === PlanYearType.CURRENT
            ? PlanYearResourceNames.PLAN_YEAR
            : PlanYearResourceNames.DUAL_PLAN_YEAR);
        this.store.dispatch(new SetSelectedPlanYear(selectedPlanYearType, selectedPlanYear));
    }
    getSelectedPlanYear$() {
        return this.store.select(PlansState.selectedPlanYear);
    }
    getSelectedPlanYear() {
        return this.store.selectSnapshot(PlansState.selectedPlanYear);
    }
    getUnselectedPlanYear$() {
        return this.getSelectedPlanYearType$().pipe(map(selectedPlanYearType => this.getOppositePlanYearFromPlanYearMap(selectedPlanYearType)));
    }
    getUnselectedPlanYear() {
        const selectedPlanYearType = this.getSelectedPlanYearType();
        return this.getOppositePlanYearFromPlanYearMap(selectedPlanYearType);
    }
    getSelectedPlanYearType$() {
        return this.store.select(PlansState.selectedPlanYearType);
    }
    getSelectedPlanYearType() {
        return this.store.selectSnapshot(PlansState.selectedPlanYearType);
    }
    getUnselectedPlanYearType$() {
        return this.getSelectedPlanYearType$().pipe(map(selectedPlanYearType => this.getOppositePlanYearType(selectedPlanYearType)));
    }
    getUnselectedPlanYearType() {
        const selectedPlanYearType = this.getSelectedPlanYearType();
        return this.getOppositePlanYearType(selectedPlanYearType);
    }
    isAgentPermissionPlanYearSelectionJsonEnabled() {
        return this.configResourceService.getProcessedResourceValue('Spa_Agent_Permission_PlanYearSelectionJson_Enabled', null, false);
    }
    getAllowedAgentPlanYears() {
        const agentPlanYearSelectionJson = this.configResourceService.getProcessedResourceValue('Spa_Agent_Permission_PlanYearSelection_Json', null, false);
        return agentPlanYearSelectionJson?.map(planYearSelection => +planYearSelection.value) ?? [];
    }
    // Defines whether an agent selling permission is allowed based on plan year configuration
    isPermissionAllowed(permission) {
        if (!permission.planYear) {
            return true;
        }
        else if (this.isAgentPermissionPlanYearSelectionJsonEnabled()) {
            const allowedPlanYears = this.getAllowedAgentPlanYears();
            return !!allowedPlanYears?.includes(permission.planYear);
        }
        else {
            const currentYear = parseInt(this.getSelectedPlanYear(), 0);
            return permission.planYear >= currentYear;
        }
    }
    isDualPlanYear(selectedPlanYear) {
        return this.getIsDualPlanYearSite() && selectedPlanYear === this.getDualPlanYear();
    }
    isAllowedPlanYear(selectedPlanYear) {
        return this.allowedPlanYears.includes(selectedPlanYear);
    }
    getSelectedStaticPlanYear(selectedPlanYearType = this.getSelectedPlanYearType()) {
        // Based on the logic in PURL PLus and Agent Account Overview, for Current Plan Year PURL, we only send the static PY when Spa_ConsumerSiteID_Enabled is enabled.
        // For Dual Plan Year PURL, we don't send the static PY but this could change in the future if we want the same generated structure for both PURL links.
        return selectedPlanYearType === PlanYearType.CURRENT && this.isConsumerSiteIdEnabled ? AgentStaticPurlYear.PLAN_YEAR : null;
    }
    getOppositePlanYearType(planYearType) {
        return planYearType === PlanYearType.CURRENT ? PlanYearType.DUAL : PlanYearType.CURRENT;
    }
    getOppositePlanYearFromPlanYearMap(selectedPlanYearType) {
        const planYearMap = this.getPlanYearMap();
        const unselectedPlanYear = planYearMap[this.getOppositePlanYearType(selectedPlanYearType)];
        if (unselectedPlanYear) {
            return `${unselectedPlanYear}`;
        }
        return '';
    }
    getPlanYearTypeMap() {
        return {
            [this.getDualPlanYear()]: PlanYearType.DUAL,
            [this.getCurrentPlanYear()]: PlanYearType.CURRENT
        };
    }
}
PlanYearResourceService.ɵfac = function PlanYearResourceService_Factory(t) { return new (t || PlanYearResourceService)(i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(i1.Store)); };
PlanYearResourceService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PlanYearResourceService, factory: PlanYearResourceService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanYearResourceService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ConfigResourceService }, { type: i1.Store }]; }, null); })();

class SiteHttpService {
    constructor(http) {
        this.http = http;
        this.environment = EnvironmentService.getEnvironment();
    }
    getConsumerSiteUrls$() {
        return this.http.get(`${this.environment.LIVE_EDIT_CONFIG_URL}/ConsumerSiteUrls`);
    }
}
SiteHttpService.ɵfac = function SiteHttpService_Factory(t) { return new (t || SiteHttpService)(i0.ɵɵinject(i1$2.HttpClient)); };
SiteHttpService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SiteHttpService, factory: SiteHttpService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SiteHttpService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1$2.HttpClient }]; }, null); })();

class SiteService {
    constructor(store, configResourceService, navigationUtilityService, planYearResourceService, siteHttpService, document, baseHref) {
        this.store = store;
        this.configResourceService = configResourceService;
        this.navigationUtilityService = navigationUtilityService;
        this.planYearResourceService = planYearResourceService;
        this.siteHttpService = siteHttpService;
        this.document = document;
        this.baseHref = baseHref;
        this.isRetentionSummaryProfileEnabled = this.configResourceService.getProcessedResourceValue('Spa_RetentionSummary_Profile_Enabled', null, false);
    }
    isPPCSite(siteType = this.getSiteType()) {
        return siteType && (siteType.toLowerCase() === SiteType.BROKER || siteType.toLowerCase() === SiteType.CALL_CENTER);
    }
    consumerSiteTypeSnapshot() {
        return this.store.selectSnapshot(RuntimeState.consumerSiteType);
    }
    isRetentionView$() {
        return of(this.isRetentionView());
    }
    isRetentionView(memberSourceValue = MemberSourceValue.CLAIMS) {
        return (this.consumerSiteTypeSnapshot() === ConsumerSiteType.RETENTION ||
            (this.isRetentionSummaryProfileEnabled &&
                this.isPPCSite() &&
                this.store.selectSnapshot(ProfileState.isRetentionMemberFromSource(memberSourceValue))));
    }
    isQuotingSite$() {
        return of(this.isQuotingSite());
    }
    isQuotingSite() {
        return this.consumerSiteTypeSnapshot() === ConsumerSiteType.QUOTING;
    }
    isRetentionSite() {
        return this.consumerSiteTypeSnapshot() === ConsumerSiteType.RETENTION;
    }
    setConsumerSiteType(siteType) {
        this.store.dispatch(new SetConsumerSiteType(siteType));
    }
    getSiteType() {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_SiteType');
    }
    getSitePlanYear() {
        return +this.planYearResourceService.getSelectedPlanYear();
    }
    getSiteLogoTag$() {
        const isRetentionView = this.isRetentionView();
        const isQuotingSite = this.isQuotingSite();
        const page = this.navigationUtilityService.getCurrentPage();
        if (page?.tags?.includes(PageTags.ENROLLMENT_CONFIRMATION)) {
            if (isRetentionView) {
                return of(PageTags.RETENTION);
            }
            if (isQuotingSite) {
                return of(PageTags.HOME);
            }
        }
        const isMemberLoggedIn = this.store.selectSnapshot(MemberState.isLoggedIn);
        if (isRetentionView && isMemberLoggedIn) {
            return of(this.getRetentionSummaryRedirectPage());
        }
        if (isRetentionView) {
            return of(PageTags.RETENTION);
        }
        if (isQuotingSite && isMemberLoggedIn) {
            return of(this.getQuoteSummaryRedirectPage());
        }
        if (isQuotingSite) {
            return of(PageTags.BENEFICIARY_LOGIN);
        }
        return of(null);
    }
    getSiteUserType(siteType) {
        if (siteType === SiteType.BROKER) {
            return UserTypeKeys.BROKER;
        }
        if (siteType === SiteType.CALL_CENTER) {
            return UserTypeKeys.CALLCENTER;
        }
        if (siteType === SiteType.CONSUMER) {
            return UserTypeKeys.CONSUMER;
        }
        return UserTypeKeys.ALL;
    }
    getSiteUserTypeValue(siteType) {
        const siteUserType = siteType || this.getSiteType().toLowerCase();
        if (siteUserType === SiteType.BROKER) {
            return UserTypes.BROKER;
        }
        if (siteUserType === SiteType.CALL_CENTER) {
            return UserTypes.CALLCENTER;
        }
        if (siteUserType === SiteType.CONSUMER) {
            return UserTypes.CONSUMER;
        }
        return UserTypes.ALL;
    }
    initializeConsumerSiteUrls() {
        this.siteHttpService
            .getConsumerSiteUrls$()
            .pipe(take(1))
            .subscribe({
            next: consumerSiteUrls => {
                this.store.dispatch(new UpdateConsumerSiteUrls(consumerSiteUrls));
            }
        });
    }
    getConsumerSiteUrls() {
        return this.store.selectSnapshot(SiteState.consumerSiteUrls);
    }
    getSiteId() {
        return this.store.selectSnapshot(AppConfigState.siteId);
    }
    getConsumerSiteUrls$() {
        return this.store.select(SiteState.consumerSiteUrls);
    }
    getSelectedPlanYearConsumerSiteUrl() {
        return this.store.selectSnapshot(SiteState.selectedPlanYearConsumerSiteUrl);
    }
    getSiteBaseUrl() {
        return `${this.document.location.origin}${this.baseHref}`;
    }
    getBaseConsumerSiteUrl(widgetName) {
        let baseUrl = this.configResourceService.getProcessedResourceValue('URL_ConsumerSite', widgetName, 'http://localhost:4200');
        const isConsumerSiteIdEnabled = this.configResourceService.getProcessedResourceValue('Spa_ConsumerSiteID_Enabled', null, false);
        if (isConsumerSiteIdEnabled) {
            const selectedPlanYearConsumerSiteUrl = this.getSelectedPlanYearConsumerSiteUrl();
            if (selectedPlanYearConsumerSiteUrl) {
                baseUrl = selectedPlanYearConsumerSiteUrl;
            }
        }
        return baseUrl;
    }
    initializeContactInfoResource() {
        const sharedConfigResource = this.store.selectSnapshot(SiteState.sharedConfigResource);
        if (sharedConfigResource) {
            this.store.dispatch(new UpdateConfigResource(sharedConfigResource.resourceBundle));
        }
    }
    getQuoteSummaryRedirectPage() {
        const isRedirectToPlanListEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_QuotingAndRetention_RedirectToPlanList_Enabled', null, false);
        return isRedirectToPlanListEnabled ? PageTags.PLAN_LIST : PageTags.QUOTE_SUMMARY;
    }
    getRetentionSummaryRedirectPage() {
        const isRedirectToPlanListEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_QuotingAndRetention_RedirectToPlanList_Enabled', null, false);
        const retentionDefaultPageTag = this.configResourceService.getProcessedResourceValue('Spa_RetentionSite_Custom_Navigation_PageTag', PageTags.RETENTION_SUMMARY);
        return isRedirectToPlanListEnabled ? PageTags.PLAN_LIST : retentionDefaultPageTag;
    }
}
SiteService.ɵfac = function SiteService_Factory(t) { return new (t || SiteService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(NavigationUtilityService), i0.ɵɵinject(PlanYearResourceService), i0.ɵɵinject(SiteHttpService), i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(APP_BASE_HREF)); };
SiteService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SiteService, factory: SiteService.ɵfac, providedIn: 'root' });
__decorate([
    Memoize()
], SiteService.prototype, "getSiteBaseUrl", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SiteService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }, { type: ConfigResourceService }, { type: NavigationUtilityService }, { type: PlanYearResourceService }, { type: SiteHttpService }, { type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [APP_BASE_HREF]
            }] }]; }, { getSiteBaseUrl: [] }); })();

class BrowserSupportService {
    browserIsSafari14() {
        const checkForBrowserRegex = new RegExp(/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//);
        return checkForBrowserRegex.test(navigator.userAgent) && Number(navigator.userAgent.match(checkForBrowserRegex)[2]) >= 14;
    }
    browserIsIE11() {
        return !!window.MSInputMethodContext && !!document.documentMode;
    }
}
BrowserSupportService.ɵfac = function BrowserSupportService_Factory(t) { return new (t || BrowserSupportService)(); };
BrowserSupportService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: BrowserSupportService, factory: BrowserSupportService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BrowserSupportService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

class Base64UtilityService {
    encodeText(stringToEncode) {
        return btoa(stringToEncode);
    }
    decodeText(stringToDecode) {
        return atob(stringToDecode);
    }
}
Base64UtilityService.ɵfac = function Base64UtilityService_Factory(t) { return new (t || Base64UtilityService)(); };
Base64UtilityService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: Base64UtilityService, factory: Base64UtilityService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(Base64UtilityService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

class FileDownloadUtilityService {
    constructor(browserSupportService, base64UtilityService) {
        this.browserSupportService = browserSupportService;
        this.base64UtilityService = base64UtilityService;
    }
    /**
     * This method is use to download the file.
     * @param data - As string of dataURI or blob to be processed on data for the file to be downloaded.
     * @param fileName - As string of file name to provide on download.
     * @param contentType - As string of file content-type to be download.
     */
    downloadFile(data, fileName, contentType) {
        // check if browser is safari and if browser version is 14+
        // data should be of type string
        if (this.browserSupportService.browserIsSafari14() && typeof data === 'string') {
            this.downloadFileForSafari(data, fileName, contentType);
        }
        else {
            // else download using dataURL
            const download = downloadjs;
            download(data, fileName, contentType);
        }
    }
    downloadFileForSafari(data, fileName, contentType) {
        try {
            let blobPDF;
            const typeBase64Data = `data:${contentType};base64,`;
            if (data.includes(typeBase64Data)) {
                const base64Data = data.replace(typeBase64Data, '');
                blobPDF = this.base64toBlob(base64Data, contentType);
            }
            else {
                const textEncoder = new TextEncoder();
                const encodedData = textEncoder.encode(data);
                blobPDF = new Blob([encodedData], { type: contentType });
            }
            const url = URL.createObjectURL(blobPDF);
            // download file using blob since base64 encoded string not working in iOS v14+
            const downloadLink = document.createElement('a');
            downloadLink.href = url;
            downloadLink.download = fileName;
            downloadLink.click();
        }
        catch (error) {
            console.error(error);
        }
    }
    // convert base64 encoded string to blob
    base64toBlob(base64Data, contentType = '') {
        const binaryData = this.base64UtilityService.decodeText(base64Data);
        const arrayBuffer = new Uint8Array(binaryData.length);
        for (let i = 0; i < binaryData.length; i++) {
            arrayBuffer[i] = binaryData.charCodeAt(i);
        }
        return new Blob([arrayBuffer], { type: contentType });
    }
    convertToCsv(dataList, headerList) {
        const data = typeof dataList !== 'object' ? JSON.parse(dataList) : dataList;
        let str = '';
        let row = '';
        for (const index in headerList) {
            row += headerList[index] + ', ';
        }
        row = row.slice(0, -1);
        str += row + '\r\n';
        for (let i = 0; i < data.length; i++) {
            let line = '';
            for (const index in data[i]) {
                if (line != '') {
                    line += ',';
                }
                line += data[i][index];
            }
            str += line + '\r\n';
        }
        return str;
    }
}
FileDownloadUtilityService.ɵfac = function FileDownloadUtilityService_Factory(t) { return new (t || FileDownloadUtilityService)(i0.ɵɵinject(BrowserSupportService), i0.ɵɵinject(Base64UtilityService)); };
FileDownloadUtilityService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FileDownloadUtilityService, factory: FileDownloadUtilityService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FileDownloadUtilityService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: BrowserSupportService }, { type: Base64UtilityService }]; }, null); })();

class PasswordResetHttpService {
    constructor(http) {
        this.http = http;
        this.environment = EnvironmentService.getEnvironment();
    }
    generateRecoveryHash$(input, requestType, userType, firstName = null) {
        let params = new HttpParams().set('requestType', requestType).set(`${requestType}`, input).set('userType', userType);
        if (firstName && userType === PasswordResetUserType.CONSUMER && requestType === ResetHashRequestType.EMAIL_ADDRESS) {
            params = params.append('firstName', firstName);
        }
        const headers = new HttpHeaders();
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Login/Recover`, { params, headers });
    }
    async generateRecoveryHash(input, requestType, userType, firstName = null) {
        return this.generateRecoveryHash$(input, requestType, userType, firstName).toPromise();
    }
    /**
     *
     * @param hashValidityTime The time in minutes the hash is valid for
     */
    validateRecoveryHash$(resetHash, hashValidityTime, userType) {
        const params = new HttpParams()
            .set('requestType', 'ResetHash')
            .set('resetHash', resetHash)
            .set('resetHashValidityTime', `${hashValidityTime}`)
            .set('userType', userType);
        const headers = new HttpHeaders();
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Login/Recover`, { params, headers });
    }
    async validateRecoveryHash(resetHash, hashValidityTime, userType) {
        return this.validateRecoveryHash$(resetHash, hashValidityTime, userType).toPromise();
    }
    resetPassword$(userName, newPassword, domain, userType, resetHash) {
        const consumerBody = { userName, newPassword, domain, userType, resetHash };
        const agentBody = { userName, newPassword, domain, userType };
        const body = userType === PasswordResetUserType.CONSUMER ? consumerBody : agentBody;
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Login/ResetPassword`, body);
    }
    async resetPassword(userName, newPassword, domain, userType, resetHash) {
        return this.resetPassword$(userName, newPassword, domain, userType, resetHash).toPromise();
    }
}
PasswordResetHttpService.ɵfac = function PasswordResetHttpService_Factory(t) { return new (t || PasswordResetHttpService)(i0.ɵɵinject(i1$2.HttpClient)); };
PasswordResetHttpService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PasswordResetHttpService, factory: PasswordResetHttpService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PasswordResetHttpService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1$2.HttpClient }]; }, null); })();

class PasswordResetService {
    constructor(passwordResetHttpService) {
        this.passwordResetHttpService = passwordResetHttpService;
    }
    /**
     * Used for both consumer and agent, and for both username and password recoveries.
     * @param input email or username value
     * @param requestType email or username type
     * @param userType agent or consumer
     * @param firstName used for consumer username recovery only
     * @returns GenerateResetHashReturnModel
     */
    async generateRecoveryHash(input, requestType = ResetHashRequestType.USER_NAME, userType = PasswordResetUserType.CONSUMER, firstName = null) {
        return this.passwordResetHttpService.generateRecoveryHash(input, requestType, userType, firstName);
    }
    /**
     * Checks if the provided hash is still valid, as determined by the API
     *
     * @param recoveryHash The hash provided by a previous call to check
     * @param validityTime How long the hash is valid for, starting when the hash was created, in minutes.
     * IE if you created the hash at 1:00pm, and passed in 60 here, it would become invalid after 2:00pm
     *
     * @returns a promise that resolves when the API call is finished. This returns an error to catch if the hash was not valid.
     */
    async validateRecoveryHash(recoveryHash, validityTime, userType) {
        return this.passwordResetHttpService.validateRecoveryHash(recoveryHash, validityTime, userType);
    }
    async resetPassword(userName, newPassword, domain, userType, resetHash) {
        return this.passwordResetHttpService.resetPassword(userName, newPassword, domain, userType, resetHash);
    }
}
PasswordResetService.ɵfac = function PasswordResetService_Factory(t) { return new (t || PasswordResetService)(i0.ɵɵinject(PasswordResetHttpService)); };
PasswordResetService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PasswordResetService, factory: PasswordResetService.ɵfac, providedIn: 'root' });
__decorate([
    LiveEditInactive()
], PasswordResetService.prototype, "generateRecoveryHash", null);
__decorate([
    LiveEditInactive()
], PasswordResetService.prototype, "validateRecoveryHash", null);
__decorate([
    LiveEditInactive()
], PasswordResetService.prototype, "resetPassword", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PasswordResetService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: PasswordResetHttpService }]; }, { generateRecoveryHash: [], validateRecoveryHash: [], resetPassword: [] }); })();

class EmailHttpService {
    constructor(http) {
        this.http = http;
        this.environment = EnvironmentService.getEnvironment();
    }
    sendEmail$(email) {
        const options = { headers: new HttpHeaders({ Accept: 'application/json' }) };
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/email`, email, options);
    }
    getEmail$(fileName) {
        // TODO update this with environment var when git repo querying is implemented
        return this.http.get(`assets/emails/dist/${fileName}`, { responseType: 'text' });
    }
    recoverPassword$(request) {
        const options = { headers: new HttpHeaders({ Accept: 'application/json' }) };
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/email/recover`, request, options);
    }
}
EmailHttpService.ɵfac = function EmailHttpService_Factory(t) { return new (t || EmailHttpService)(i0.ɵɵinject(i1$2.HttpClient)); };
EmailHttpService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: EmailHttpService, factory: EmailHttpService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EmailHttpService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1$2.HttpClient }]; }, null); })();

const EMAIL_INPUT_REGEX = /{\|(.*?)\|}/;
const SIMPLE_STRING_REGEX = /^'.*'$/;
class EmailService {
    constructor(emailHttpService, configResourceService) {
        this.emailHttpService = emailHttpService;
        this.configResourceService = configResourceService;
    }
    async sendEmail(emailFileName, to, subject, inputs) {
        return this.sendEmail$(emailFileName, to, subject, inputs).toPromise();
    }
    /**
     * Creates an observable than when subscribed to, turned into a promise, or otherwise actived,
     * will send out an email. If the observable is never activated, no email will ever be sent.
     * If you don't need to use the result in an observable chain, and don't want to worry about that, use sendEmail() instead.
     */
    sendEmail$(emailFileName, to, subject, inputs) {
        return this.getProcessedEmail$(emailFileName, to, subject, inputs).pipe(switchMap(email => this.emailHttpService.sendEmail$(email)));
    }
    async recoverPassword(resetType, to, subject, resetRequest, resetPasswordUrl, inputs) {
        return this.recoverPassword$(resetType, to, subject, resetRequest, resetPasswordUrl, inputs).toPromise();
    }
    recoverPassword$(resetType, to, subject, resetRequest, resetPasswordUrl, inputs) {
        const emailFileName = this.getResetEmailFileName(resetType);
        return this.getProcessedEmail$(emailFileName, to, subject, inputs).pipe(switchMap(email => {
            const emailRecoveryRequest = this.getEmailRecoveryRequest(email, resetRequest, resetPasswordUrl);
            return this.emailHttpService.recoverPassword$(emailRecoveryRequest);
        }));
    }
    getFormattedEmailHeader(widgetName) {
        const emailHeader = this.configResourceService.getProcessedResourceValue('Spa_Site_EmailHeader', widgetName, 'Hi {{[member.profile.firstName]}},');
        const lastIndexComma = emailHeader.lastIndexOf(',');
        if (lastIndexComma !== -1) {
            return `${emailHeader.slice(0, lastIndexComma).trim()},`;
        }
        return emailHeader.trim();
    }
    getDocumentHtml(documents) {
        let element = '<div style="display:table;margin-left:24px;margin-top:10px;">';
        documents.forEach(document => {
            element += `\n<a style="display:block;color:#016c86;font-size:14px;font-weight:100;"
      href="${document.url}"><strong style="color:#016c86;font-weight:300;">${document.name}</strong></a><br />`;
        });
        element += '</div>';
        return element;
    }
    getPrimaryButtonColor(widgetName) {
        const colorValue = this.configResourceService.getProcessedResourceValue('Spa_Style_PrimaryButton', widgetName, AppThemeConfig.getColorValueByKey(ColorResourceKeys.ACCENT4));
        return colorValue.startsWith('#') ? colorValue : `#${colorValue}`;
    }
    processComparisonValue(value) {
        if (typeof value !== 'undefined' && value !== null) {
            const stringValue = `${value}`;
            return stringValue && stringValue.toLowerCase() === 'false' ? '' : stringValue;
        }
        return value;
    }
    getProcessedEmailTemplate$(emailFileName, inputs) {
        return this.emailHttpService
            .getEmail$(emailFileName)
            .pipe(map(emailTemplate => this.createProcessedEmailTemplate(emailTemplate, inputs)));
    }
    getProcessedEmail$(emailFileName, to, subject, inputs) {
        return this.emailHttpService
            .getEmail$(emailFileName)
            .pipe(map(emailTemplate => this.createProcessedEmail(emailTemplate, to, subject, inputs)));
    }
    getEmailRecoveryRequest(email, resetRequest, resetPasswordUrl) {
        const emailRecoveryRequest = {
            baseUrl: resetPasswordUrl,
            resetRequest,
            emailTo: email.emailTo,
            emailFrom: email.emailFrom,
            ccTo: email.ccTo,
            subject: email.subject,
            body: email.body,
            attachments: email.attachments,
            useSecureEmail: email.useSecureEmail
        };
        return emailRecoveryRequest;
    }
    getResetEmailFileName(resetType) {
        if (resetType === ResetType.AGENT) {
            return EmailNames.PASSWORD_RESET;
        }
        if (resetType === ResetType.CONSUMER) {
            return EmailNames.CONSUMER_PASSWORD_RESET;
        }
        return null;
    }
    createProcessedEmailTemplate(emailTemplate, inputs) {
        const conditionalProcessedEmail = this.preProcessEmailTemplate(emailTemplate, inputs);
        return this.processEmail(conditionalProcessedEmail, inputs);
    }
    createProcessedEmail(emailTemplate, to, subject, inputs) {
        const processedEmailTemplate = this.createProcessedEmailTemplate(emailTemplate, inputs);
        const from = this.configResourceService.getProcessedResourceValue('Spa_Site_Email_FromAddress', null, 'Do.Not.Reply@drx.com');
        const email = new Email(to, from, subject, processedEmailTemplate);
        return email;
    }
    processEmail(emailTemplate, inputs) {
        let processedEmail = this.configResourceService.processValueProviders(emailTemplate);
        processedEmail = this.processEmailInputs(processedEmail, inputs);
        return processedEmail;
    }
    // This could be memoized, but memoizing the entire email HTML is probably not worth it?
    processEmailInputs(html, inputs) {
        let processedHtml = html;
        if (inputs?.length) {
            inputs.forEach(input => {
                const regex = new RegExp(`\\{\\|${input.key}\\|\\}`, 'g');
                processedHtml = processedHtml.replace(regex, input.value);
            });
        }
        return processedHtml;
    }
    /**
     * Preprocessing this now rather than post-processing because html resources mess
     * up html parsing when used with escaped strings. Now rather than resolving the
     * value providers and then processing as html we are processing our conditional
     * functions first. Not doing so will result in janky html like:
     * <mj-vnext-conditional left="<h2 style="border:2px solid Tomato;">Html section below the authorization email body
     * section in the quote access code email.</h2>" comparator="EXIST">
     */
    preProcessEmailTemplate(htmlString, inputs) {
        // There is an issue with IE we are accounting for here. If we do not process the values for the resources assigned to
        // bgColor IE will derive a hex value from the resource string for bgColor when we call domparser.parseFromString. In an
        // effort to prevent this and possibly other related issue I processing only the whitelisted resources prior to dom parsing.
        const preProcessedEmailWithValues = this.configResourceService.processValueProviders(htmlString, undefined, undefined, [
            'Spa_Style_PrimaryButton'
        ]);
        const domparser = new DOMParser();
        const document = domparser.parseFromString(preProcessedEmailWithValues, 'text/html');
        let conditionals = document.getElementsByTagName('mj-vnext-conditional');
        while (conditionals.length) {
            this.processConditional(conditionals[0], inputs);
            conditionals = document.getElementsByTagName('mj-vnext-conditional');
        }
        return document.documentElement.outerHTML;
    }
    // Possibly enhancements include adding the ability to use &&, ||, >, and <
    processConditional(conditional, inputs) {
        const leftOperand = conditional && conditional.getAttribute('left');
        const comparator = conditional && EmailComparator[conditional.getAttribute('comparator')];
        const rightOperand = conditional && conditional.getAttribute('right');
        const comparisonResult = this.processComparison(leftOperand, comparator, rightOperand, inputs);
        if (comparisonResult) {
            // if we have a predicate that evaluates to true then we can show the contained block
            conditional.outerHTML = conditional.innerHTML;
        }
        else {
            // if not then we should remove the contained block from the email template
            conditional.outerHTML = '';
        }
    }
    processComparison(leftOperand, comparator, rightOperand, inputs) {
        let leftValue;
        let rightValue;
        if (EMAIL_INPUT_REGEX.test(leftOperand)) {
            leftValue = this.processEmailInputs(leftOperand, inputs);
        }
        else {
            leftValue = this.configResourceService.processValueProviders(leftOperand);
        }
        if (rightOperand) {
            if (SIMPLE_STRING_REGEX.test(rightOperand)) {
                rightValue = rightOperand.replace(/'/g, '');
            }
            else if (EMAIL_INPUT_REGEX.test(rightOperand)) {
                rightValue = this.processEmailInputs(rightOperand, inputs);
            }
            else {
                rightValue = this.configResourceService.processValueProviders(rightOperand);
            }
        }
        // Since processEmail() is called before postProcessEmailTemplate(), string literals are being returned causing boolean false to return as "false"
        // This breaks EXIST, NOTEXIST, and default scenario below
        leftValue = this.processComparisonValue(leftValue);
        rightValue = this.processComparisonValue(rightValue);
        return this.testComparisonValues(comparator, leftValue, rightValue);
    }
    testComparisonValues(comparator, leftValue, rightValue) {
        switch (comparator) {
            case EmailComparator.EQUALTO: {
                const processedLeftValue = typeof leftValue === 'string' ? leftValue.toLowerCase() : leftValue;
                const processedRightValue = typeof rightValue === 'string' ? rightValue.toLowerCase() : rightValue;
                return processedLeftValue === processedRightValue;
            }
            case EmailComparator.NOTEQUALTO: {
                const processedLeftValue = typeof leftValue === 'string' ? leftValue.toLowerCase() : leftValue;
                const processedRightValue = typeof rightValue === 'string' ? rightValue.toLowerCase() : rightValue;
                return processedLeftValue === processedRightValue;
            }
            case EmailComparator.GREATERTHAN: {
                return +leftValue > +rightValue;
            }
            case EmailComparator.LESSTHAN: {
                return +leftValue < +rightValue;
            }
            case EmailComparator.GREATERTHANEQUALTO: {
                return +leftValue >= +rightValue;
            }
            case EmailComparator.LESSTHANEQUALTO: {
                return +leftValue <= +rightValue;
            }
            case EmailComparator.EXIST: {
                return !!leftValue;
            }
            case EmailComparator.NOTEXIST: {
                return !leftValue;
            }
            default:
                return !!leftValue;
        }
    }
}
EmailService.ɵfac = function EmailService_Factory(t) { return new (t || EmailService)(i0.ɵɵinject(EmailHttpService), i0.ɵɵinject(ConfigResourceService)); };
EmailService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: EmailService, factory: EmailService.ɵfac, providedIn: 'root' });
__decorate([
    Memoize()
], EmailService.prototype, "getDocumentHtml", null);
__decorate([
    Memoize()
], EmailService.prototype, "processComparisonValue", null);
__decorate([
    Memoize()
], EmailService.prototype, "getEmailRecoveryRequest", null);
__decorate([
    Memoize()
], EmailService.prototype, "getResetEmailFileName", null);
__decorate([
    Memoize()
], EmailService.prototype, "testComparisonValues", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EmailService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: EmailHttpService }, { type: ConfigResourceService }]; }, { getDocumentHtml: [], processComparisonValue: [], getEmailRecoveryRequest: [], getResetEmailFileName: [], testComparisonValues: [] }); })();

class MessageHttpService {
    constructor(http) {
        this.http = http;
        this.environment = EnvironmentService.getEnvironment();
        this.messagesUri = `${this.environment.WEB_SERVICE_BASE_URL}/v1/Messages`;
    }
    sendText$(textMessage) {
        return this.http.post(`${this.messagesUri}/text`, textMessage);
    }
    getShortUrl$(url) {
        return this.http.post(`${this.messagesUri}/shortUrl`, url);
    }
}
MessageHttpService.ɵfac = function MessageHttpService_Factory(t) { return new (t || MessageHttpService)(i0.ɵɵinject(i1$2.HttpClient)); };
MessageHttpService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MessageHttpService, factory: MessageHttpService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MessageHttpService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1$2.HttpClient }]; }, null); })();

class MessagesService {
    constructor(messageHttpService) {
        this.messageHttpService = messageHttpService;
    }
    sendText$(phoneNumber, message) {
        return this.messageHttpService.sendText$({ phoneNumber, message });
    }
    getShortUrl$(url, clientName) {
        const shortUrlRequest = { url, clientName };
        return this.messageHttpService.getShortUrl$(shortUrlRequest).pipe(map(url => url.shortUrl));
    }
    async getShortUrl(url, clientName) {
        return await firstValueFrom(this.getShortUrl$(url, clientName));
    }
}
MessagesService.ɵfac = function MessagesService_Factory(t) { return new (t || MessagesService)(i0.ɵɵinject(MessageHttpService)); };
MessagesService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MessagesService, factory: MessagesService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MessagesService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: MessageHttpService }]; }, null); })();

class AgentService {
    constructor(store, configResourceService, navigationService, agentHttpService, siteService, spinnerService, memberSessionHttpService, fileUtilityService, localeService, phoneUtilityService, passwordResetService, planYearResourceService, enrollmentFunctionService, externalErrorLoggingService, emailService, weglotService, messagesService, cacheContext) {
        this.store = store;
        this.configResourceService = configResourceService;
        this.navigationService = navigationService;
        this.agentHttpService = agentHttpService;
        this.siteService = siteService;
        this.spinnerService = spinnerService;
        this.memberSessionHttpService = memberSessionHttpService;
        this.fileUtilityService = fileUtilityService;
        this.localeService = localeService;
        this.phoneUtilityService = phoneUtilityService;
        this.passwordResetService = passwordResetService;
        this.planYearResourceService = planYearResourceService;
        this.enrollmentFunctionService = enrollmentFunctionService;
        this.externalErrorLoggingService = externalErrorLoggingService;
        this.emailService = emailService;
        this.weglotService = weglotService;
        this.messagesService = messagesService;
        this.cacheContext = cacheContext;
        this.agentImageURL = '';
        this.resetRequiredError = 'User account is locked. Password rest required.';
        this.planCompareApiUseAgentDataFromCustomInternalEnabled = this.configResourceService.getProcessedResourceValue('Spa_PCAPIEnrollment_UseAgentDataFromCustomInternal_Enabled', null, true);
        this._searchMemberAgentResult$ = new BehaviorSubject(AgentSearchResult.INIT_RESULTS);
        this._searchAgentResult$ = new BehaviorSubject(AgentSearchResult.INIT_RESULTS);
    }
    isAgentLoggedIn() {
        return this.store.selectSnapshot(AgentState.isLoggedIn);
    }
    getIsAgentInContext() {
        return this.store.selectSnapshot(AgentState.inContext);
    }
    getAgentEmailAddress() {
        const emailAddress = this.store.selectSnapshot(AgentState.emailAddress);
        return emailAddress || '';
    }
    getAgentInContextGuid$() {
        return this.store.select(AgentState.agentGuid);
    }
    getAgentInContextGuid() {
        return this.store.selectSnapshot(AgentState.agentGuid);
    }
    getCreatingAgentGuid() {
        return this.store.selectSnapshot(MemberState.agentGuid);
    }
    getSelectedAgentGuid() {
        return this.store.selectSnapshot(AgentState.selectedAgentGuid);
    }
    getAgentOfRecord$() {
        return this.store.select(MemberState.agentOfRecord);
    }
    getAgentOfRecord() {
        return this.store.selectSnapshot(MemberState.agentOfRecord);
    }
    getAgentProgressEvents$() {
        return this.store.select(MemberState.memberProgressInfo);
    }
    getAgentProgressEvents() {
        return this.store.selectSnapshot(MemberState.memberProgressInfo);
    }
    getAgentPlanYear() {
        return this.store.selectSnapshot(AgentState.agentPlanYear);
    }
    getAgentPlanYear$() {
        return this.store.select(AgentState.agentPlanYear);
    }
    getAgentRole() {
        return this.store.selectSnapshot(AgentState.agentRole);
    }
    getAgentUserPermissions() {
        return this.store.selectSnapshot(AgentState.agentUserPermissions);
    }
    getBrokerEmail$() {
        return this.store.select(AgentState.emailAddress);
    }
    getBrokerEmail() {
        return this.store.selectSnapshot(AgentState.emailAddress);
    }
    getBrokerLastName$() {
        return this.store.select(AgentState.lastName);
    }
    getBrokerFirstName$() {
        return this.store.select(AgentState.firstName);
    }
    getBrokerFullName$() {
        return this.store.select(AgentState.fullName);
    }
    getBrokerFullName() {
        return this.store.selectSnapshot(AgentState.fullName);
    }
    getBrokerAgencyName$() {
        return this.store.select(AgentState.agencyName);
    }
    getBrokerAgencyName() {
        return this.store.selectSnapshot(AgentState.agencyName);
    }
    getBrokerPhoneNumber$() {
        return this.store.select(AgentState.phoneNumber);
    }
    getBrokerPhoneNumber() {
        return this.store.selectSnapshot(AgentState.phoneNumber);
    }
    getAgentUserPermissions$() {
        return this.store.select(AgentState.agentUserPermissions);
    }
    getAgentFirstName() {
        return this.store.selectSnapshot(AgentState.firstName);
    }
    getAgentLastName() {
        return this.store.selectSnapshot(AgentState.lastName);
    }
    getAgentFullNameFromEnrollment(enrollmentKey) {
        const agentFirstName = this.enrollmentFunctionService.getEnrollmentAnswer('AgentFirstName', enrollmentKey);
        const agentLastName = this.enrollmentFunctionService.getEnrollmentAnswer('AgentLastName', enrollmentKey);
        return `${agentFirstName} ${agentLastName}`.trim();
    }
    getAgentUserName() {
        return this.store.selectSnapshot(AgentState.userName);
    }
    getAgentNPN() {
        return this.store.selectSnapshot(AgentState.npn);
    }
    getAgentNPNFromEnrollment(enrollmentKey) {
        return this.enrollmentFunctionService.getEnrollmentAnswer('AgentNPN', enrollmentKey);
    }
    getAgentUserPreferences$() {
        return this.store.select(AgentState.userPreferences);
    }
    agentHasActiveAnalytics$() {
        return this.store.select(AgentState.hasActiveAnalytics);
    }
    agentHasActiveAnalytics() {
        return this.store.selectSnapshot(AgentState.hasActiveAnalytics);
    }
    isPlanCompareApiAgentDataEnabled() {
        return (this.getIsPlanCompareApiUseAgentDataFromCustomInternalEnabled() &&
            this.isRedirectedFromPlanCompareApi() &&
            !this.getIsAgentInContext());
    }
    getPlanCompareApiAgentData(enrollmentKey) {
        const planCompareApiAgentData = {
            agentName: this.getAgentFullNameFromEnrollment(enrollmentKey),
            agentNPN: this.getAgentNPNFromEnrollment(enrollmentKey),
            californiaLicenseNumber: this.getCaliforniaLicenseNumber(AgentLicenseType.PC_API)
        };
        return planCompareApiAgentData;
    }
    getAgencyId() {
        return this.store.selectSnapshot(AgentState.agencyID);
    }
    getAgencyName() {
        const storeAgencyName = this.store.selectSnapshot(AgentState.agencyName);
        return storeAgencyName || '';
    }
    getAgentSiteAccess() {
        return this.store.selectSnapshot(AgentState.siteAccess);
    }
    getAgentExpirationDate() {
        return this.store.selectSnapshot(AgentState.expirationDate);
    }
    getAgentSubscriptionEvents() {
        return this.store.selectSnapshot(AgentState.agentSubscriptionEvents);
    }
    getAgentId() {
        return this.store.selectSnapshot(AgentState.agentID);
    }
    getAgentIsActive() {
        return this.store.selectSnapshot(AgentState.isActive);
    }
    getAgentPhone() {
        return this.store.selectSnapshot(AgentState.phoneNumber);
    }
    getAgentExtension() {
        return this.store.selectSnapshot(AgentState.extension);
    }
    getAgentZip() {
        return this.store.selectSnapshot(AgentState.zip);
    }
    getAgentState() {
        return this.store.selectSnapshot(AgentState.state);
    }
    getAgentCity() {
        return this.store.selectSnapshot(AgentState.city);
    }
    getAgentAddress1() {
        return this.store.selectSnapshot(AgentState.address1);
    }
    getAgentAddress2() {
        return this.store.selectSnapshot(AgentState.address2);
    }
    getSiteAccess() {
        return this.store.selectSnapshot(AgentState.siteAccess);
    }
    getAgentExternalUserId() {
        return this.store.selectSnapshot(AgentState.externalUserId);
    }
    getAgentFsr() {
        return this.store.selectSnapshot(AgentState.fsr);
    }
    getASPRequired() {
        return this.store.selectSnapshot(AgentState.aspRequired);
    }
    getASPAllowAccessToAllPlanYears() {
        // If agentPlanYear is null/undefined/empty we allow access to all plan years
        return !this.getASPAgentPlanYear();
    }
    getASPAgentPlanYear() {
        return this.store.selectSnapshot(AgentState.agentPlanYear);
    }
    getIsProfileAdmin() {
        return this.store.selectSnapshot(AgentState.isProfileAdmin);
    }
    isBannedFromSession() {
        return this.store.selectSnapshot(AgentState.isBannedFromSession);
    }
    areAgentSellingPermissionsLoaded() {
        return this.store.selectSnapshot(AgentState.areAgentSellingPermissionsLoaded);
    }
    getAgentLicenses() {
        return this.store.selectSnapshot(AgentState.licenses);
    }
    getIsPlanCompareApiUseAgentDataFromCustomInternalEnabled() {
        return this.planCompareApiUseAgentDataFromCustomInternalEnabled;
    }
    isRedirectedFromPlanCompareApi() {
        return this.store.selectSnapshot(RuntimeState.isRedirectedFromPlanCompareApi);
    }
    getCaliforniaLicenseNumber(licenseType) {
        // TODO: SPA-????? We will possibly update license numbers to be any state in the future
        // Leaving it specific as the exact way we would implement this is entirely in the air for now
        return this.store.selectSnapshot(AgentState.californiaLicenseNumber(licenseType));
    }
    getAgentData$() {
        return this.store.select(AgentState.agentData);
    }
    getAgentData() {
        return this.store.selectSnapshot(AgentState.agentData);
    }
    getAgentHasRetireFlo$() {
        return this.store.select(AgentState.hasRetireFlo);
    }
    getAgentHasRetireFlo() {
        return this.store.selectSnapshot(AgentState.hasRetireFlo);
    }
    getTalkingPoints$() {
        return this.store.select(AgentState.talkingPoints);
    }
    getTalkingPoints() {
        return this.store.selectSnapshot(AgentState.talkingPoints);
    }
    setTalkingPoints(talkingPoints) {
        this.store.dispatch(new SetTalkingPoints(talkingPoints));
    }
    setRetireFloStatus(hasRetireFlo) {
        this.store.dispatch(new SetRetireFloStatus(hasRetireFlo));
    }
    isDisplayRecordingLinkEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Profile_AgentCallRecording_DisplayRecordingLink_Enabled', widgetName, false);
    }
    getSearchTimeoutMessageText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Search_Timeout_Message_Text', widgetName, `
        <div class="d-flex justify-content-center col-12">
          <div class="Spa_Style_Paragraph Spa_Style_Large_Font font-weight-bold mx-auto no-search-result-text">
            Too many results
          </div>
        </div>

        <div class="d-flex justify-content-center col-12 mt-2">
          <div class="Spa_Style_Paragraph Spa_Style_Regular_Font mx-auto no-search-result-text">
            Please specify additional search criteria to return results
          </div>
        </div>
      `);
    }
    /**
     * @param agentGuid the GUID of the agent being fetched
     * @param currentAgentGuid the GUID of the agent in session
     * @param getAgentSellingPermissions should the retrieveAgentSellingPermissions endpoint be hit?
     * @returns data fetched from the Agent API
     */
    fetchAgent$(agentGuid, currentAgentGuid, loadAgentSellingPermissions = false) {
        if (agentGuid && currentAgentGuid) {
            return this.agentHttpService.fetchAgent$(agentGuid, currentAgentGuid).pipe(switchMap(agentData => loadAgentSellingPermissions
                ? this.getAgentSellingPermissions$(agentGuid).pipe(switchMap(aspData => of(agentData)))
                : of(agentData)), filter(agentData => this.configResourceService.getProcessedResourceValue('Spa_Site_SiteType') !== SiteType.CONSUMER ||
                this.isSiteAccessAvailable(agentData)), catchError(error => {
                if (error instanceof HttpErrorResponse) {
                    if (error.status === HttpStatusCode.UNAUTHORIZED) {
                        if (this.siteService.isQuotingSite()) {
                            this.agentLogout(true);
                        }
                    }
                }
                return of(null);
            }));
        }
        return of(null);
    }
    fetchAgentOfRecord$(agentGuid) {
        const assignedAgentGuid = agentGuid ?? this.getCreatingAgentGuid();
        const currentAgentGuid = this.getAgentInContextGuid();
        if (!assignedAgentGuid && currentAgentGuid) {
            // When assigned agentGuid is null, then set the Agent of Record information null
            return this.store.dispatch(new UpdateAgentOfRecord(null));
        }
        this.store.dispatch(new SetAgentOfRecordLoading(true));
        return this.agentHttpService.fetchAgent$(assignedAgentGuid, currentAgentGuid).pipe(
        // we don't have to dispatch SetAgentOfRecordLoading(false)
        switchMap(agentData => this.store.dispatch(new UpdateAgentOfRecord(agentData)).pipe(map(() => agentData))), catchError(error => {
            this.externalErrorLoggingService.log(error);
            return this.store.dispatch(new SetAgentOfRecordLoading(false));
        }));
    }
    fetchCarriers$(includeAncillary) {
        return this.agentHttpService.fetchCarriers$(includeAncillary);
    }
    isSiteAccessAvailable(agentData) {
        if (!agentData?.data ||
            (agentData.data &&
                (agentData.data.isActive === false ||
                    agentData.data.siteAccess === false ||
                    (agentData.data.expirationDate && !DateUtilities.dateIsInFuture(new Date(agentData.data.expirationDate)))))) {
            if (this.siteService.isQuotingSite()) {
                this.agentLogout(true);
            }
            this.store.dispatch(new ResetAgentState());
            return false;
        }
        // TODO is there a more appropriate place for this?
        this.setAgentContext(AgentContext.IN_CONTEXT);
        return true;
    }
    memberSearchResult$() {
        return this._searchMemberAgentResult$.asObservable();
    }
    setMemberSearchResult(memberSearchResult) {
        this._searchMemberAgentResult$.next(memberSearchResult);
    }
    memberProfileSearch$(agentGuid, searchCriteria, milliseconds) {
        let memberProfileSearch$ = this.agentHttpService.memberProfileSearch$(agentGuid, searchCriteria);
        if (milliseconds) {
            memberProfileSearch$ = memberProfileSearch$.pipe(timeout(milliseconds));
        }
        return memberProfileSearch$.pipe(map((memberSearch) => {
            this.store.dispatch(new SetMemberSearch(memberSearch));
            return memberSearch || [];
        }));
    }
    fetchAgentBeneficiaries$(agentGuid, milliseconds) {
        let fetchAgentBeneficiaries$ = this.agentHttpService.fetchAgentBeneficiaries$(agentGuid);
        if (milliseconds) {
            fetchAgentBeneficiaries$ = fetchAgentBeneficiaries$.pipe(timeout(milliseconds));
        }
        return fetchAgentBeneficiaries$.pipe(map((memberSearch) => {
            return memberSearch || [];
        }));
    }
    getAgentSearchResult$() {
        return this._searchAgentResult$.asObservable();
    }
    setAgentSearchResult(agentSearchResult) {
        this._searchAgentResult$.next(agentSearchResult);
    }
    searchAgents$(agentGuid, agentData, milliseconds) {
        if (agentGuid && agentData) {
            const agentSearchData = {
                firstName: agentData.firstName,
                lastName: agentData.lastName,
                userName: agentData.userName,
                organizationName: agentData.agencyName,
                isActive: agentData.isActive,
                npn: agentData.npn
            };
            let searchAgents$ = this.agentHttpService.searchAgents$(agentGuid, agentSearchData);
            if (milliseconds) {
                searchAgents$ = searchAgents$.pipe(timeout(milliseconds));
            }
            return searchAgents$;
        }
        return of(null);
    }
    fetchMemberProgressInfo$(memberId) {
        const agentGuid = this.getAgentInContextGuid();
        return this.store.dispatch(new FetchMemberProgressInfo(agentGuid, memberId));
    }
    createNewAgent$(agent) {
        return this.agentHttpService.createNewAgent$({
            agentGuid: agent.agentGuid || this.store.selectSnapshot(AgentState.agentGuid),
            ...agent
        });
    }
    agentLogin$(agent, loadAgentSellingPermissions = false) {
        return this.agentHttpService.agentLogin$(agent).pipe(catchError(error => of(error)), switchMap(agentData => {
            const agentGuid = agentData?.data?.agentGuid;
            const customerId = agentData?.data?.customerID;
            const additionalAgentDataRequests = [];
            if (customerId) {
                additionalAgentDataRequests.push(this.getSubscriptionStatusEvents$(customerId));
            }
            if (loadAgentSellingPermissions) {
                additionalAgentDataRequests.push(this.getAgentSellingPermissions$(agentGuid));
            }
            additionalAgentDataRequests.push(this.fetchAgenciesAndSave$(agentGuid));
            return forkJoin(additionalAgentDataRequests).pipe(switchMap(additionalAgentDataRequests => of({ agentData, additionalAgentDataRequests })));
        }), switchMap(returnData => {
            const agentData = returnData?.agentData;
            const subscriptionEvents = agentData?.data?.customerID
                ? returnData?.additionalAgentDataRequests?.[0]?.Events
                : [];
            if (agentData.data) {
                agentData.data.subscriptionEvents = subscriptionEvents || [];
                this.store.dispatch(new AgentLogin(agentData));
                this.store.dispatch(new SetAuthType(agentData.data.ssoRequest ? "sso" /* AuthType.SSO */ : "login" /* AuthType.LOGIN */));
                return of(agentData.data);
            }
            const error = returnData?.agentData;
            if (error.error.Status === HttpStatusCode.UNAUTHORIZED && error.error.Detail === this.resetRequiredError) {
                this.passwordResetService
                    .generateRecoveryHash(agent.userName, ResetHashRequestType.USER_NAME, PasswordResetUserType.AGENT)
                    .then(hashReturn => {
                    this.navigationService.navigateByPageTag(PageTags.RESET_PASSWORD, {
                        queryParams: {
                            r: hashReturn.resetHash,
                            u: hashReturn.userName,
                            e: hashReturn.emailAddress,
                            t: PasswordResetUserType.AGENT
                        }
                    });
                });
            }
            // throwing the error response allows components to still handle the error as they would normally
            // I.E. to display 'invalid credentials' messages without worrying about what happens here
            throw error;
        }));
    }
    fetchAgencies$(agentGuid) {
        return this.store.dispatch(new FetchAgentAgencies(agentGuid));
    }
    getAgencies() {
        return this.store.selectSnapshot(AgentState.agencies);
    }
    getAgencies$() {
        return this.store.select(AgentState.agencies);
    }
    isAgencyHierarchyEnabled() {
        // Format for this key is different than normal due to being created and used by the API team
        return this.configResourceService.getProcessedResourceValue('AgencyHierarchy_Enabled', null, false);
    }
    fetchAgenciesAndSave$(agentGuid) {
        if (agentGuid) {
            const isPPCSite = this.siteService.isPPCSite();
            if (isPPCSite && this.isAgencyHierarchyEnabled()) {
                return this.fetchAgencies$(agentGuid);
            }
        }
        return of([]);
    }
    fetchAgenciesForSelectedUser$(selectedAgentGuid) {
        if (selectedAgentGuid) {
            const isPPCSite = this.siteService.isPPCSite();
            if (isPPCSite && this.isAgencyHierarchyEnabled()) {
                this.agentHttpService.fetchAgencies$(selectedAgentGuid).pipe(catchError(() => of([])));
            }
        }
        return of([]);
    }
    async resetAgentLogout(isValidPurlAgentLogout = false) {
        const isPurl = this.isPurl();
        if (!isPurl || isValidPurlAgentLogout) {
            await this.store.dispatch(new AgentLogout()).toPromise();
        }
    }
    async agentLogout(redirectAfterLogout = true, isValidPurlAgentLogout = false) {
        this.cacheContext.bustCache();
        await this.store.dispatch(new LogoutMemberAgent()).toPromise();
        await this.resetAgentLogout(isValidPurlAgentLogout);
        if (redirectAfterLogout) {
            if (this.siteService.isQuotingSite()) {
                this.navigationService.navigateByPageTag(this.configResourceService.getProcessedResourceValue('Spa_Site_AgentLogout_RedirectPageTag', null, PageTags.HOME));
            }
            else {
                this.navigationService.navigateByPageTag(this.configResourceService.getProcessedResourceValue('Spa_Site_AgentLogout_RedirectPageTag', null, PageTags.AGENT_LOGIN));
            }
        }
    }
    setAgentContext(context) {
        this.store.dispatch(new SetAgentContext(context));
    }
    updateAgentSession$(agent) {
        return this.agentHttpService.updateAgentSession$({
            agentRole: agent.agentRole || this.store.selectSnapshot(AgentState.agentRole),
            agentGuid: agent.agentGuid || this.store.selectSnapshot(AgentState.agentGuid),
            ...agent,
            siteAccess: true,
            isActive: true
        });
    }
    disableAgent$(agent) {
        return this.agentHttpService.updateAgentSession$(agent);
    }
    updateRetireFloBookOfBusinessAccessAndStore$(agent) {
        const loginAgentId = this.getAgentInContextGuid();
        const selectedAgentGuid = this.getSelectedAgentGuid();
        return this.updateViewedAgentSession$(selectedAgentGuid, agent, loginAgentId);
    }
    updateAgent$(agentData) {
        return this.store.dispatch(new UpdateAgent(agentData, agentData.data)).pipe(map(() => agentData));
    }
    updateAgentSessionAndStore$(agent) {
        return this.updateAgentSession$(agent).pipe(switchMap(agentData => this.updateAgent$(agentData)));
    }
    updateViewedAgentSession$(agentGuid, agent, loginAgentId) {
        if (agentGuid === loginAgentId) {
            return this.agentHttpService
                .updateViewedAgentSession$(agentGuid, { ...agent }, loginAgentId)
                .pipe(switchMap(agentData => this.updateAgent$(agentData)));
        }
        return this.agentHttpService.updateViewedAgentSession$(agentGuid, { ...agent }, loginAgentId);
    }
    validateAgentDetails$(payload) {
        return this.agentHttpService.validateAgentDetails$(payload);
    }
    getSubscriptionPricingOption$(productId) {
        return this.agentHttpService.getSubscriptionPricingOption$(productId);
    }
    getAgentSubscriptionStatus$(stripeSessionId) {
        return this.agentHttpService.getAgentSubscriptionStatus$(stripeSessionId);
    }
    getStripeCheckoutSession$(priceId) {
        return this.agentHttpService.getStripeCheckoutSession$(priceId);
    }
    getSubscriptionStatusEvents$(customerId) {
        return this.agentHttpService.getSubscriptionStatusEvents$(customerId);
    }
    submitAgentInfo$(payload) {
        return this.agentHttpService.submitAgentInfo$(payload);
    }
    resetAgentState() {
        if (!this.isPurl()) {
            this.store.dispatch(new ResetAgentState());
        }
    }
    openMemberDocument$(transactionId, fileId) {
        return this.agentHttpService.memberEnrollmentDocumentDownload$(transactionId, fileId);
    }
    getDefaultPageTag() {
        const defaultLanding = this.configResourceService.getProcessedResourceValue('Spa_AgentLogin_PageTagAfterLogin', null);
        if (defaultLanding) {
            return defaultLanding;
        }
        const isProfileSearchEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_Profile_Enabled', null, true);
        const isAgentDashboardEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_AgentDashboard_Enabled', null, false);
        if (isAgentDashboardEnabled) {
            return PageTags.AGENT_DASHBOARD;
        }
        else if (isProfileSearchEnabled) {
            return PageTags.PROFILE_SEARCH;
        }
        else {
            return PageTags.PLAN_LIST;
        }
    }
    getAgentPhoneAndHours(formattedPhone, agencyHours) {
        return formattedPhone && agencyHours ? `${formattedPhone} | ${agencyHours}` : `${formattedPhone}${agencyHours}`;
    }
    getCreditedAgentEmailFooterData(agentData) {
        const formattedPhone = this.phoneUtilityService.formatPhoneNumberWithExtension(agentData?.phoneNumber, agentData?.ext);
        const agencyHours = agentData?.agencyHours ?? '';
        const californiaLicenseNumber = agentData?.licenses?.find(license => license.state?.toLowerCase() === 'ca')?.license ?? '';
        const agentFullName = agentData ? agentData.firstName.concat(' ', agentData.lastName) : '';
        return {
            agentName: agentFullName,
            agencyName: agentData?.agencyName ?? '',
            agentEmail: agentData?.emailAddress ?? '',
            agentPhoneAndHours: this.getAgentPhoneAndHours(formattedPhone, agencyHours),
            agentPictureURL: agentData?.agentPictureURL ?? '',
            agentNPN: agentData?.npn ?? '',
            californiaLicenseNumber
        };
    }
    async getAgentEmailFooterData() {
        await this.getAgentPictureIcon();
        const agencyHours = this.store.selectSnapshot(AgentState.hours) || '';
        const agentPhoneNumber = this.getAgentPhone();
        const extensionPhone = this.getAgentExtension();
        const formattedPhone = this.phoneUtilityService.formatPhoneNumberWithExtension(agentPhoneNumber, extensionPhone);
        const agentNPN = this.getAgentNPN();
        const californiaLicenseNumber = this.getCaliforniaLicenseNumber();
        return {
            agentName: this.store.selectSnapshot(AgentState.fullName),
            agencyName: this.getAgencyName(),
            agentEmail: this.getAgentEmailAddress(),
            agentPhoneAndHours: this.getAgentPhoneAndHours(formattedPhone, agencyHours),
            agentPictureURL: this.agentImageURL,
            agentNPN,
            californiaLicenseNumber
        };
    }
    async getAgentPictureIcon() {
        this.agentImageURL = this.store.selectSnapshot(AgentState.agentPictureURL) || '';
        const firstName = this.getAgentFirstName();
        const lastName = this.getAgentLastName();
        if (!this.agentImageURL && firstName && lastName) {
            const icon = await this.agentHttpService.getAgentPictureIcon(firstName, lastName);
            if (icon?.url) {
                this.store.dispatch(new UpdateAgentProfilePicture(icon.url));
                this.agentImageURL = icon.url;
            }
        }
        return this.agentImageURL;
    }
    // transactionID will be the transactionSID for HOPE forms and transactionGUID for nextgen forms
    downloadEnrollmentApplicationPDF(transactionID, confirmationNumber, planHasNextGenForm = false) {
        const hidePdfAgentData = this.store.selectSnapshot(UiState.hidePdfAgentData);
        const sessionId = this.store.selectSnapshot(MemberState.session).sessionId;
        if (sessionId && transactionID && confirmationNumber) {
            this.spinnerService.show(SpinnerEvent.DOWNLOAD_RESOURCE_LOADING);
            const generatePDFSubscription$ = planHasNextGenForm
                ? this.memberSessionHttpService.getGeneratedNextGenEnrollmentApplicationPDF$(sessionId, transactionID, this.localeService.getCurrentLocale(), hidePdfAgentData)
                : this.memberSessionHttpService.getGeneratedEnrollmentApplicationPDF$(sessionId, transactionID, this.localeService.getCurrentLocale(), hidePdfAgentData);
            generatePDFSubscription$.subscribe({
                next: data => {
                    const contentType = 'application/pdf';
                    const dataURI = `data:${contentType};base64,${data}`;
                    const fileName = `EnrollmentApplication#${confirmationNumber}.pdf`;
                    this.fileUtilityService.downloadFile(dataURI, fileName, contentType);
                    this.spinnerService.hide(SpinnerEvent.DOWNLOAD_RESOURCE_LOADING);
                },
                error: () => {
                    this.spinnerService.hide(SpinnerEvent.DOWNLOAD_RESOURCE_LOADING);
                }
            });
        }
    }
    getPlanPermissionEffectiveDate(planType) {
        const planYear = this.planYearResourceService.getSelectedPlanYear();
        switch (planType) {
            case PlanType.MEDIGAP:
                return this.store.selectSnapshot(MedSupState.formField('EffectiveDate'));
            case PlanType.MA:
            case PlanType.MAPD:
            case PlanType.PDP:
                if (planYear) {
                    // During AEP, use 1/1/<planYear>
                    // After AEP, use today's date since that is when agent is enrolling member in plan (SCS-28414)
                    // Ex: If today is 1/20 and agent selling permission expires 2/1, agent should still be able to sell until expiration
                    const currentDate = new Date();
                    const planYearDate = new Date(+planYear, 0, 1);
                    return currentDate < planYearDate ? DateUtilities.getFormattedDate(planYearDate) : DateUtilities.getFormattedDate(currentDate);
                }
            default:
                return null;
        }
    }
    updateAgentProfilePicture(profilePictureUrl) {
        this.store.dispatch(new UpdateAgentProfilePicture(profilePictureUrl));
    }
    async getAgentPurl(baseUrl, agentUserName, encode, selectedStaticPurlYear, redirectPageTag, accountGuid) {
        const isPurlBookmarkingEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_PurlBookmarking_Enabled', null, true);
        return await this.agentHttpService.getAgentPurl(baseUrl, agentUserName, encode, selectedStaticPurlYear, redirectPageTag, accountGuid, isPurlBookmarkingEnabled);
    }
    async getAgentRetireFloPurl(baseUrl, agentUserName, encode, redirectPageTag) {
        const locale = this.localeService.getCurrentLocale();
        const isPurlBookmarkingEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_PurlBookmarking_Enabled', null, true);
        return await this.agentHttpService.getAgentRetireFloPurl(baseUrl, agentUserName, encode, redirectPageTag, locale, isPurlBookmarkingEnabled);
    }
    async getAgentPurlInformation(purlId) {
        return await this.agentHttpService.getAgentPurlInformation(purlId);
    }
    async banAgentFromSession(isValidPurlAgentLogout = false) {
        await this.agentLogout(false, isValidPurlAgentLogout);
        this.setAgentContext(AgentContext.BANNED_FROM_SESSION);
        this.store.dispatch(new SetPlansDirty(true));
    }
    async uploadProfile(file, agentId) {
        return await this.agentHttpService.uploadProfile(file, agentId);
    }
    updateAgentState(agentData) {
        this.store.dispatch(new SetAgentData(agentData));
    }
    keepAgentInContext(queryParams) {
        const isConsumerSiteType = this.configResourceService.getProcessedResourceValue('Spa_Site_SiteType') === SiteType.CONSUMER;
        const removeAgentInContext = this.configResourceService.getProcessedResourceValue('Spa_Site_Remove_Agent_Context', null, false);
        if (isConsumerSiteType) {
            if (Object.keys(queryParams).length && !removeAgentInContext) {
                return !!queryParams.AgentGuid;
            }
            else {
                return !removeAgentInContext;
            }
        }
        return true;
    }
    async removeAgentSellingPermission(agentId, permission) {
        const permissionToRemove = {
            carrierID: permission.carrierId,
            states: [permission.stateAbbrev],
            planTypes: [permission.planTypeId],
            planYear: permission.planYear?.toString(),
            crosswalkAgentID: permission.producerId,
            snpTypes: permission.snpTypes
        };
        return await this.agentHttpService
            .removeAgentSellingPermission$(agentId, permissionToRemove)
            .pipe(switchMap(data => this.getAgentSellingPermissions$(agentId, null, true)))
            .toPromise();
    }
    getAgentSellingPermissions$(agentId, sellingPermissionsFilter, includeCrosswalk = false) {
        let postBody = {};
        if (sellingPermissionsFilter) {
            postBody = { ...sellingPermissionsFilter };
        }
        return this.agentHttpService.getAgentSellingPermissions$(agentId, postBody, includeCrosswalk).pipe(map(data => {
            const mappedData = data.map(permission => {
                const stateName = DemographicStates.find(state => state.StateAbbrev === permission.state)?.StateName;
                const planYear = permission.startEffectiveDate === null ? null : new Date(permission?.startEffectiveDate)?.getFullYear();
                const item = {
                    carrierId: permission.carrierID,
                    planTypeId: permission.planType,
                    stateAbbrev: permission.state,
                    snpTypes: permission.snpTypes,
                    producerId: permission.crosswalkAgentID,
                    planYear,
                    stateName
                };
                return item;
            });
            this.store.dispatch(new UpdateAgentSellingPermissions(mappedData));
            return mappedData;
        }));
    }
    async getAgentSellingPermissions(agentId, sellingPermissionsFilter, includeCrosswalk = false) {
        return await this.getAgentSellingPermissions$(agentId, sellingPermissionsFilter, includeCrosswalk).toPromise();
    }
    async updateAgentSellingPermissions(agentId, sellingPermissions) {
        return await this.agentHttpService
            .updateAgentSellingPermissions$(agentId, sellingPermissions)
            .pipe(switchMap(async () => await this.getAgentSellingPermissions(agentId, null, true)))
            .toPromise();
    }
    isPurl$() {
        return this.store.select(RuntimeState.isPurl);
    }
    isPurl() {
        return this.store.selectSnapshot(RuntimeState.isPurl);
    }
    isPurlRedirectEnabled() {
        return this.store.selectSnapshot(RuntimeState.isPurlRedirectEnabled);
    }
    getPURLAgentUsername() {
        return this.store.selectSnapshot(AgentState.purlAgentUsername);
    }
    getAgentPlanYears() {
        const agentPlanYear = this.getAgentPlanYear();
        if (agentPlanYear) {
            return agentPlanYear.split(',').map(planYear => +planYear);
        }
        return [];
    }
    fetchTalkingPoints() {
        this.agentHttpService
            .getTalkingPoints$()
            .pipe(take(1))
            .subscribe(talkingPoints => {
            this.setTalkingPoints(talkingPoints);
        });
    }
    fetchRetireFloStatus() {
        const agentGuid = this.getAgentInContextGuid();
        this.agentHttpService.fetchRetireFloStatus$(agentGuid).subscribe(retireFloStatusResponse => {
            this.setRetireFloStatus(retireFloStatusResponse.status === RetireFloStatus.ACTIVE);
        });
    }
    agentInContextHasAccessToViewAllPlanYears() {
        const agentPlanYears = this.getAgentPlanYears();
        if (agentPlanYears?.length) {
            const planYear = this.planYearResourceService.getCurrentPlanYear();
            const dualPlanYear = this.planYearResourceService.getDualPlanYear();
            return agentPlanYears?.includes(planYear) || agentPlanYears?.includes(dualPlanYear);
        }
        // null or '' means allow then to access all plan years. this was done for backwards compatability
        // and agents will specifically need to be restricted if limiting their permissions is desired
        return true;
    }
    async sendAccessCodeEmail(authCode, emailAddress, subject, agentData) {
        let agentFooterData;
        if (agentData) {
            agentFooterData = this.getCreditedAgentEmailFooterData(agentData);
        }
        else {
            agentFooterData = await this.getAgentEmailFooterData();
        }
        const emailHeader = this.emailService.getFormattedEmailHeader();
        let agentName;
        let agentNPN;
        let californiaLicenseNumber;
        if (this.isPlanCompareApiAgentDataEnabled()) {
            const planCompareApiAgentData = this.getPlanCompareApiAgentData();
            ({ agentName, agentNPN, californiaLicenseNumber } = planCompareApiAgentData);
        }
        else {
            agentName = agentFooterData.agentName;
            agentNPN = agentFooterData.agentNPN;
            californiaLicenseNumber = agentFooterData.californiaLicenseNumber;
        }
        const inputs = [
            { key: 'authorizationCode', value: authCode },
            { key: 'agentName', value: agentName },
            { key: 'agencyName', value: agentFooterData.agencyName },
            { key: 'agentNPN', value: agentNPN },
            { key: 'agentEmail', value: agentFooterData.agentEmail },
            { key: 'agentPhoneAndHours', value: agentFooterData.agentPhoneAndHours },
            { key: 'agentPictureURL', value: agentFooterData.agentPictureURL },
            { key: 'emailHeader', value: emailHeader },
            { key: 'californiaLicenseNumber', value: californiaLicenseNumber }
        ];
        this.emailService.sendEmail(EmailNames.ACCESS_CODE, [emailAddress], subject, inputs);
    }
    async sendAuthCodeText(phoneNumber, authCode, message, widgetName) {
        const weglotMultiLanguageEnabled = this.configResourceService.getProcessedResourceValue('Spa_Weglot_MultiLanguage_Enabled', null, false);
        if (weglotMultiLanguageEnabled) {
            message = await this.weglotService.getTranslatedText$(message, ['<authCode>']).toPromise();
        }
        message = message ? message.replace('<authCode>', authCode) : '';
        return await this.messagesService.sendText$(phoneNumber, message).toPromise();
    }
}
AgentService.ɵfac = function AgentService_Factory(t) { return new (t || AgentService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(NavigationService), i0.ɵɵinject(AgentHttpService), i0.ɵɵinject(SiteService), i0.ɵɵinject(SpinnerService), i0.ɵɵinject(MemberSessionHttpService), i0.ɵɵinject(FileDownloadUtilityService), i0.ɵɵinject(LocaleService), i0.ɵɵinject(PhoneUtilityService), i0.ɵɵinject(PasswordResetService), i0.ɵɵinject(PlanYearResourceService), i0.ɵɵinject(EnrollmentFunctionService), i0.ɵɵinject(ExternalErrorLoggingService), i0.ɵɵinject(EmailService), i0.ɵɵinject(WeglotService), i0.ɵɵinject(MessagesService), i0.ɵɵinject(CacheContext)); };
AgentService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AgentService, factory: AgentService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }, { type: ConfigResourceService }, { type: NavigationService }, { type: AgentHttpService }, { type: SiteService }, { type: SpinnerService }, { type: MemberSessionHttpService }, { type: FileDownloadUtilityService }, { type: LocaleService }, { type: PhoneUtilityService }, { type: PasswordResetService }, { type: PlanYearResourceService }, { type: EnrollmentFunctionService }, { type: ExternalErrorLoggingService }, { type: EmailService }, { type: WeglotService }, { type: MessagesService }, { type: CacheContext }]; }, null); })();

class AccountOverviewService {
    constructor(store, agentService) {
        this.store = store;
        this.agentService = agentService;
    }
    isAccountOverviewPage(pageTags) {
        return !!pageTags && pageTags.includes(PageTags.AGENT_ACCOUNT_OVERVIEW);
    }
    isViewOtherAgentPage(pageTags) {
        return !!pageTags && pageTags.includes(PageTags.AGENT_VIEW_PROFILE);
    }
    isCreateAgentPage(pageTags) {
        return !!pageTags && pageTags.includes(PageTags.ADD_NEW_AGENT);
    }
    isAccountOverviewPageAndRequiresAgentData(pageTags) {
        return this.isAccountOverviewPage(pageTags) || this.isViewOtherAgentPage(pageTags);
    }
    getSelectedAgentGuid() {
        return this.store.selectSnapshot(AgentState.selectedAgentGuid);
    }
    fetchAgent$(agentGuid) {
        const loggedInAgentGuid = this.agentService.getAgentInContextGuid();
        return this.agentService.fetchAgent$(agentGuid, loggedInAgentGuid).pipe(tap(agentData => {
            if (agentGuid && loggedInAgentGuid && agentGuid === loggedInAgentGuid) {
                this.agentService.updateAgentState(agentData);
            }
        }), map(agentData => agentData?.data), catchError(() => of(null)));
    }
}
AccountOverviewService.ɵfac = function AccountOverviewService_Factory(t) { return new (t || AccountOverviewService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(AgentService)); };
AccountOverviewService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AccountOverviewService, factory: AccountOverviewService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AccountOverviewService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.Store }, { type: AgentService }]; }, null); })();

class AccountOverviewResolver {
    constructor(navigationUtilityService, accountOverviewService, agentService) {
        this.navigationUtilityService = navigationUtilityService;
        this.accountOverviewService = accountOverviewService;
        this.agentService = agentService;
    }
    resolve(route, state) {
        const page = this.navigationUtilityService.getPage(state.url);
        const pageTags = page?.tags;
        const defaultAgent = null;
        const defaultAgencies = [];
        const defaultAgencyInfoData = {
            agent: defaultAgent,
            agencies: defaultAgencies
        };
        if (this.accountOverviewService.isAccountOverviewPageAndRequiresAgentData(pageTags)) {
            const selectedAgentGuid = this.accountOverviewService.getSelectedAgentGuid();
            if (selectedAgentGuid === this.agentService.getAgentInContextGuid() &&
                this.accountOverviewService.isAccountOverviewPage(pageTags) &&
                this.agentService.areAgentSellingPermissionsLoaded()) {
                return of(defaultAgencyInfoData);
            }
            if (selectedAgentGuid) {
                return combineLatest([
                    this.accountOverviewService.fetchAgent$(selectedAgentGuid),
                    this.agentService.fetchAgenciesForSelectedUser$(selectedAgentGuid)
                ]).pipe(map(([agent, agencies]) => ({
                    agent,
                    agencies
                })));
            }
        }
        return of(defaultAgencyInfoData);
    }
}
AccountOverviewResolver.ɵfac = function AccountOverviewResolver_Factory(t) { return new (t || AccountOverviewResolver)(i0.ɵɵinject(NavigationUtilityService), i0.ɵɵinject(AccountOverviewService), i0.ɵɵinject(AgentService)); };
AccountOverviewResolver.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AccountOverviewResolver, factory: AccountOverviewResolver.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AccountOverviewResolver, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: NavigationUtilityService }, { type: AccountOverviewService }, { type: AgentService }]; }, null); })();

class AddressHttpService {
    constructor(http) {
        this.http = http;
    }
    getAddresses$(partial, zip, selected) {
        let url = `${EnvironmentService.getEnvironment().WEB_SERVICE_BASE_URL}/v1/address/autocomplete?search=${partial}`;
        if (zip) {
            url += `&zipcode=${zip}`;
        }
        if (selected) {
            url += `&selected=${selected}`;
        }
        return this.http
            .get(url, {
            responseType: 'json'
        })
            .pipe(catchError(err => of([])));
    }
}
AddressHttpService.ɵfac = function AddressHttpService_Factory(t) { return new (t || AddressHttpService)(i0.ɵɵinject(i1$2.HttpClient)); };
AddressHttpService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AddressHttpService, factory: AddressHttpService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddressHttpService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1$2.HttpClient }]; }, null); })();

class AddressObject {
}
class AddressParameters {
}

class AutoCompleteService {
    constructor() {
        this.autoComplete$ = (debounceDuration, selector) => source$ => source$.pipe(debounceTime(debounceDuration), switchMap((...args) => selector(...args).pipe(takeUntil(source$.pipe(skip(1))))));
    }
    scrollItemIntoView(typeahead) {
        if (typeahead.isPopupOpen()) {
            const popup = document.getElementById(typeahead.popupId);
            const activeElements = popup.getElementsByClassName('active');
            if (activeElements.length === 1) {
                const elem = activeElements[0];
                elem.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest'
                });
            }
        }
    }
}
AutoCompleteService.ɵfac = function AutoCompleteService_Factory(t) { return new (t || AutoCompleteService)(); };
AutoCompleteService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AutoCompleteService, factory: AutoCompleteService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AutoCompleteService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return []; }, null); })();

class AddressService {
    constructor(autoCompleteService, addressHttpService) {
        this.autoCompleteService = autoCompleteService;
        this.addressHttpService = addressHttpService;
    }
    getAddresses$(addressParameters$, debounceTime = 300) {
        return addressParameters$.pipe(this.autoCompleteService.autoComplete$(debounceTime, (address) => this.callAPIForData$(address.partialAddress, address.zip, address.selected)));
    }
    callAPIForData$(partialAddress, zipCode, selected) {
        if (partialAddress.length <= 2) {
            return of([]);
        }
        return this.addressHttpService.getAddresses$(partialAddress, zipCode, selected);
    }
    async callAPIForData(partialAddress, zipCode, selected) {
        return await this.callAPIForData$(partialAddress, zipCode, selected).toPromise();
    }
}
AddressService.ɵfac = function AddressService_Factory(t) { return new (t || AddressService)(i0.ɵɵinject(AutoCompleteService), i0.ɵɵinject(AddressHttpService)); };
AddressService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AddressService, factory: AddressService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddressService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: AutoCompleteService }, { type: AddressHttpService }]; }, null); })();

class AgentCallRecordingHttpService {
    constructor(http, store) {
        this.http = http;
        this.store = store;
        this.environment = EnvironmentService.getEnvironment();
    }
    getAuthToken$(sessionId, phoneNumber) {
        const headers = new HttpHeaders({ Accept: 'application/json' });
        const options = { headers, params: null };
        const request = {
            agentGuid: this.getAgentGuid(),
            phoneNumber
        };
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Session/${sessionId}/CallRecording/Initialize`, request, options);
    }
    getPhoneNumber$() {
        const headers = new HttpHeaders({ Accept: 'application/json' });
        const options = { headers, params: null };
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Agent/${this.getAgentGuid()}/RegisterExternalPhoneNumber`, null, options);
    }
    getCallRecording$(recordingId) {
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v1/CallTracking/Recording/${recordingId}`, {
            responseType: 'arraybuffer'
        });
    }
    associateCallRecordToEnrollment$(sessionId, transactionGuid, callRecordingCode) {
        const request = {
            agentGuid: this.getAgentGuid(),
            transactionGuid,
            callRecordingCode
        };
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Session/${sessionId}/CallRecording/AssociateCallRecord`, request);
    }
    getAgentGuid() {
        return this.store.selectSnapshot(AgentState.agentGuid);
    }
}
AgentCallRecordingHttpService.ɵfac = function AgentCallRecordingHttpService_Factory(t) { return new (t || AgentCallRecordingHttpService)(i0.ɵɵinject(i1$2.HttpClient), i0.ɵɵinject(i1.Store)); };
AgentCallRecordingHttpService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AgentCallRecordingHttpService, factory: AgentCallRecordingHttpService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentCallRecordingHttpService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1$2.HttpClient }, { type: i1.Store }]; }, null); })();

class AuthenticationInfo {
}
class PINAuthenticationInfo {
}
class SSOAuthenticationInfo {
}
var AuthPageErrorTitle;
(function (AuthPageErrorTitle) {
    AuthPageErrorTitle["INVALID_AUTH_CODE"] = "Unable to create PIN Authentication user";
    AuthPageErrorTitle["INVALID_DOB"] = "Profile Birthdate is required";
})(AuthPageErrorTitle || (AuthPageErrorTitle = {}));

class AccountCreationModel {
}
class AuthorizedRepData {
}
// All these properties could be optional now during multi-factor authentication.
class RetrieveMemberLoginTokenModel {
}
class SSOSessionResponse {
}
class EstimateHealthCostUpdateResponse {
}
class HRAExternalResponse {
}
class CreateQuoteSessionOptions {
}
class MemberLoginOptions {
    static createDefaultOptions(loginOverrides) {
        const defaults = {
            firstTimeLogin: false,
            fetchCreatingAgent: true,
            includePlanData: true,
            includeEnrollmentHistory: false,
            includeSOA: false
        };
        if (loginOverrides) {
            Object.keys(loginOverrides).forEach(key => {
                const option = loginOverrides[key];
                if (option !== null && option !== undefined) {
                    defaults[key] = option;
                }
            });
        }
        return defaults;
    }
}
class LoginAuthOptions {
    static createDefaultOptions(authOverrides) {
        const defaults = {
            authType: "login" /* AuthType.LOGIN */
        };
        if (authOverrides) {
            Object.keys(authOverrides).forEach(key => {
                const option = authOverrides[key];
                if (option !== null && option !== undefined) {
                    defaults[key] = option;
                }
            });
        }
        return defaults;
    }
}
const ELIGIBILITY_CHECK_REQUIRED_FIELDS = ['dob', 'firstName', 'lastName', 'mbi', 'partAEffectiveDate', 'partBEffectiveDate'];
var MemberNotificationStatus;
(function (MemberNotificationStatus) {
    MemberNotificationStatus["OPEN"] = "Open";
    MemberNotificationStatus["DISMISSED"] = "Dismissed";
    MemberNotificationStatus["CLOSED"] = "Closed";
    MemberNotificationStatus["COMPLETED"] = "Completed";
})(MemberNotificationStatus || (MemberNotificationStatus = {}));
var MemberNotificationType;
(function (MemberNotificationType) {
    MemberNotificationType[MemberNotificationType["QUICKQUOTE"] = 1] = "QUICKQUOTE";
    MemberNotificationType[MemberNotificationType["SENDTOBENEFICIARY"] = 2] = "SENDTOBENEFICIARY";
    MemberNotificationType[MemberNotificationType["SIGNANDSUBMIT"] = 3] = "SIGNANDSUBMIT";
    MemberNotificationType[MemberNotificationType["SOA"] = 4] = "SOA";
})(MemberNotificationType || (MemberNotificationType = {}));
var MemberNotificationSource;
(function (MemberNotificationSource) {
    MemberNotificationSource["QUICKQUOTE"] = "QUICKQUOTE";
    MemberNotificationSource["SENDTOBENEFICIARY"] = "SENDTOBENEFICIARY";
    MemberNotificationSource["SIGNANDSUBMIT"] = "SIGNANDSUBMIT";
    MemberNotificationSource["SOA"] = "SOA";
})(MemberNotificationSource || (MemberNotificationSource = {}));

var PreferenceType;
(function (PreferenceType) {
    PreferenceType["BENEFITS"] = "Benefits";
    PreferenceType["MEDSUP"] = "MedSup";
    PreferenceType["CHRONIC"] = "Chronic";
    PreferenceType["PROVIDER"] = "Provider";
    PreferenceType["DRUG"] = "Drug";
    PreferenceType["PHARMACY"] = "Pharmacy";
})(PreferenceType || (PreferenceType = {}));
var PreferencesQuestionLocationStatus;
(function (PreferencesQuestionLocationStatus) {
    PreferencesQuestionLocationStatus["VALID"] = "valid";
    PreferencesQuestionLocationStatus["INVALID"] = "invalid";
})(PreferencesQuestionLocationStatus || (PreferencesQuestionLocationStatus = {}));
var PreferenceSelectAmount;
(function (PreferenceSelectAmount) {
    PreferenceSelectAmount["SINGLE"] = "single";
    PreferenceSelectAmount["MULTI"] = "multi";
})(PreferenceSelectAmount || (PreferenceSelectAmount = {}));
var PreferenceCoverageType;
(function (PreferenceCoverageType) {
    PreferenceCoverageType[PreferenceCoverageType["MEDICAL_ONLY"] = 1] = "MEDICAL_ONLY";
    PreferenceCoverageType[PreferenceCoverageType["PRESCRIPTION_DRUG"] = 2] = "PRESCRIPTION_DRUG";
    PreferenceCoverageType[PreferenceCoverageType["MEDICAL_AND_PRESCRIPTION_DRUG"] = 3] = "MEDICAL_AND_PRESCRIPTION_DRUG";
    PreferenceCoverageType[PreferenceCoverageType["I_DONT_KNOW"] = 4] = "I_DONT_KNOW";
    PreferenceCoverageType[PreferenceCoverageType["ALL"] = 5] = "ALL";
})(PreferenceCoverageType || (PreferenceCoverageType = {}));
var PreferenceDirection;
(function (PreferenceDirection) {
    PreferenceDirection["LEFT"] = "left";
    PreferenceDirection["RIGHT"] = "right";
})(PreferenceDirection || (PreferenceDirection = {}));
var PreferenceViewType;
(function (PreferenceViewType) {
    PreferenceViewType[PreferenceViewType["MOBILE"] = 0] = "MOBILE";
    PreferenceViewType[PreferenceViewType["TABLET"] = 1] = "TABLET";
    PreferenceViewType[PreferenceViewType["DESKTOP"] = 2] = "DESKTOP";
})(PreferenceViewType || (PreferenceViewType = {}));
class PreferenceQuestionItem {
}
class PreferenceQuestionOption {
}
class PreferenceQuestion {
    constructor() {
        this.selectedValues = [];
    }
}
class PreferenceBenefits {
}
class PreferenceBenefit {
}
class PreferenceQuestionPage {
}
class APIPreferencesItem {
}
class APIPreferencesModel {
}
class PreferencesAnswer {
}
class PreferenceIdWithType {
}

class MedSupUtilitiesService {
    static filterEmptyAnswers(answers) {
        return Object.entries(answers)
            .filter(([_questionName, answer]) => answer)
            .reduce((answersMap, [questionName, answer]) => {
            answersMap[questionName] = answer;
            return answersMap;
        }, {});
    }
    static mergeMedigapAnswers(baseAnswers, ...additionalAnswers) {
        return additionalAnswers.reduce((mergedAnswers, answers) => ({ ...mergedAnswers, ...MedSupUtilitiesService.filterEmptyAnswers(answers) }), baseAnswers);
    }
}
MedSupUtilitiesService.ɵfac = function MedSupUtilitiesService_Factory(t) { return new (t || MedSupUtilitiesService)(); };
MedSupUtilitiesService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MedSupUtilitiesService, factory: MedSupUtilitiesService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedSupUtilitiesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

class RidersService {
    constructor(store) {
        this.store = store;
    }
    getRiderMedicalPremium(rider) {
        return rider.calculatedMedicalPremium !== undefined && rider.calculatedMedicalPremium !== null
            ? rider.calculatedMedicalPremium
            : rider.medicalPremium;
    }
    selectedPlanRiderIds(planId) {
        return this.store.selectSnapshot(ShoppingCartState.selectedPlanRiderIds(planId));
    }
}
RidersService.ɵfac = function RidersService_Factory(t) { return new (t || RidersService)(i0.ɵɵinject(i1.Store)); };
RidersService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: RidersService, factory: RidersService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RidersService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }]; }, null); })();

class DateService {
    /*  Service class for calculating derived dates. */
    constructor(store) {
        this.store = store;
    }
    // This is for getting the total cost effective date. Used for passing total cost effective date
    // to the plans call and for the providers and preferences calls.
    getTotalCostEffectiveDate() {
        const totalCostEffectiveDate = this.store.selectSnapshot(MemberState.totalCostEffectiveDate);
        let effectiveDate;
        if (this.store.selectSnapshot(MemberState.costByEffectiveDate) && totalCostEffectiveDate) {
            effectiveDate = totalCostEffectiveDate;
        }
        else {
            effectiveDate = DateUtilities.getFormattedFirstOfNextMonth(DateUtilities.defaultFormat);
        }
        return effectiveDate;
    }
    // This is for setting the plan effective date. Plan effective date is for medsup plans only
    // as medicare plans look at PlanYear rather than effective date.
    getPlanEffectiveDate() {
        let effectiveDate;
        const medSupEffectiveDate = this.store.selectSnapshot(MedSupState.answers).EffectiveDate;
        if (this.isValidMedSupEffectiveDate(medSupEffectiveDate)) {
            effectiveDate = medSupEffectiveDate;
        }
        else {
            effectiveDate = DateUtilities.getFormattedFirstOfNextMonth(DateUtilities.defaultFormat);
        }
        return effectiveDate;
    }
    isValidMedSupEffectiveDate(medSupEffectiveDate) {
        /**
         * If we have a MedSup effective date and it is greater than or equal to
         * the first day of the current month (the default case), then we have valid date.
         * We must additionally take into account date time formats such as "6/1/2020 12:00:00 AM"
         * as well as the default MM/DD/YYYY format, i.e. 06/01/2020.
         */
        if (medSupEffectiveDate) {
            const firstOfThisMonth = DateUtilities.getFirstOfThisMonth();
            if (medSupEffectiveDate instanceof Date) {
                return DateUtilities.dateIsSameOrInFuture(medSupEffectiveDate, firstOfThisMonth);
            }
            if (typeof medSupEffectiveDate === 'string' || medSupEffectiveDate instanceof String) {
                const newDate = new Date(medSupEffectiveDate.split(' ')[0]);
                return DateUtilities.dateIsSameOrInFuture(newDate, firstOfThisMonth);
            }
        }
        return false;
    }
}
DateService.ɵfac = function DateService_Factory(t) { return new (t || DateService)(i0.ɵɵinject(i1.Store)); };
DateService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DateService, factory: DateService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DateService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.Store }]; }, null); })();

class ProviderHttpService {
    constructor(http) {
        this.http = http;
        this.environment = EnvironmentService.getEnvironment();
    }
    getVBCVideoInfo$(vbcVideoPayload) {
        const options = {
            headers: new HttpHeaders({ Accept: 'application/json' })
        };
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Providers/VBCVideo`, vbcVideoPayload, options);
    }
    getValueBasedCareProviders$(vbcPayload, currentLocale) {
        const options = {
            headers: new HttpHeaders({ Accept: 'application/json' })
        };
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Providers/ValueBasedCareProviders?cultureCode=${currentLocale}`, vbcPayload, options);
    }
    // Zelis Integration
    // This is only for maps, leave this
    nextGenRetrieveProviderFromLocation$(payload) {
        const options = {
            headers: new HttpHeaders({ Accept: 'application/json' }),
            // In Helpful Tools, plan will be an object of type PlanProviderRequest.
            // In Guided Help/Preferences banner, plan will be null.
            // We only require extended provider data (groups) for Helpful Tools.
            params: new HttpParams().set('IncludeExtendedProviderData', !!payload?.plan)
        };
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v2/Providers/FindProviders`, payload, options);
    }
    // On Zelis, the Networks response won't include out-of-network addresses
    nextGenFetchProvidersDetails$(providerDetailsRequest, includeExtendedProviderData) {
        const environment = EnvironmentService.getEnvironment();
        const options = {
            headers: new HttpHeaders({ Accept: 'application/json' })
        };
        return this.http.post(`${environment.WEB_SERVICE_BASE_URL}/v2/Providers/Networks?IncludeExtendedProviderData=${includeExtendedProviderData}`, providerDetailsRequest, options);
    }
    // On Zelis, the Networks response won't include out-of-network addresses
    async nextGenFetchProvidersDetails(providerDetailsRequest, includeExtendedProviderData) {
        return await firstValueFrom(this.nextGenFetchProvidersDetails$(providerDetailsRequest, includeExtendedProviderData), {
            defaultValue: null
        }).catch(() => null);
    }
    nextGenPlanPrimaryCareProvider$(providerPcpForPlanRequest) {
        const options = {
            headers: new HttpHeaders({ Accept: 'application/json' })
        };
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v2/Providers/PCP`, providerPcpForPlanRequest, options);
    }
    // Cabinet
    saveOrUpdateProvider$(sessionId, userProvider, providerId) {
        const options = {
            headers: new HttpHeaders({ Accept: 'application/json' })
        };
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Session/${sessionId}/Providers/${providerId}`, userProvider, options);
    }
    async saveOrUpdateProvider(sessionId, userProvider, providerId) {
        return await firstValueFrom(this.saveOrUpdateProvider$(sessionId, userProvider, providerId), { defaultValue: null });
    }
    getProvidersFromMember$(sessionId) {
        const options = {
            headers: new HttpHeaders({ Accept: 'application/json' })
        };
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Session/${sessionId}/Providers`, options);
    }
    async getProvidersFromMember(sessionId) {
        return await firstValueFrom(this.getProvidersFromMember$(sessionId), { defaultValue: null }).catch(() => null);
    }
    removeProvider$(sessionId, addressId, externalNPI, externalProviderId) {
        const options = {
            headers: new HttpHeaders({
                Accept: 'application/json'
            }),
            body: {
                addressId,
                ...(externalNPI && { externalNPI }),
                ...(externalProviderId !== null && externalProviderId !== undefined && { externalProviderId })
            }
        };
        return this.http.delete(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Session/${sessionId}/Providers`, options);
    }
    saveVbcAttestationConfirmation$(sessionId, vbcAttestationPayload, optIn) {
        const options = {
            headers: new HttpHeaders({ Accept: 'application/json' })
        };
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Session/${sessionId}/ValueBasedCareAttestation?optin=${!!optIn}`, vbcAttestationPayload, options);
    }
    getVbcAttestationConfirmation$(sessionId, confirmationNumber) {
        const options = {
            headers: new HttpHeaders({ Accept: 'application/json' })
        };
        return this.http.get(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Session/${sessionId}/ValueBasedCareAttestation?ConfirmationNumber=${confirmationNumber}`, options);
    }
}
ProviderHttpService.ɵfac = function ProviderHttpService_Factory(t) { return new (t || ProviderHttpService)(i0.ɵɵinject(i1$2.HttpClient)); };
ProviderHttpService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ProviderHttpService, factory: ProviderHttpService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProviderHttpService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$2.HttpClient }]; }, null); })();

class ProviderService {
    constructor(store, providerHttpService, configResourceService, dateService, externalErrorLoggingService) {
        this.store = store;
        this.providerHttpService = providerHttpService;
        this.configResourceService = configResourceService;
        this.dateService = dateService;
        this.externalErrorLoggingService = externalErrorLoggingService;
        this.isProvidersEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_Providers_Enabled', null, false);
        this._showProviderLoading$ = new BehaviorSubject(false);
    }
    isZelisIntegrationEnabled() {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_ZelisIntegration_Enabled', null, true);
    }
    getSelectedPCP() {
        return this.store.selectSnapshot(ProviderState.selectedPCP);
    }
    hasSelectedPCP() {
        return this.store.selectSnapshot(ProviderState.hasSelectedPCP);
    }
    getSelectedProvidersId() {
        return this.store.selectSnapshot(ProviderState.selectedProvidersId);
    }
    getSelectedProvidersNpi() {
        return this.store.selectSnapshot(ProviderState.selectedProvidersNpi);
    }
    async addProviders(providers) {
        if (providers?.length) {
            try {
                await this.saveOrUpdateProvider(providers);
                this.store.dispatch([new AddProviders(providers), new SetPlansDirty(true, ALL_MEDICARE_PLUS_MEDIGAP_PLAN_TYPE_VALUES)]);
            }
            catch (error) {
                console.error(error);
                this.externalErrorLoggingService.log(error);
            }
        }
    }
    async updateSelectedProviders(providers) {
        if (providers?.length) {
            try {
                await this.saveOrUpdateProvider(providers);
                this.store.dispatch([new UpdateSelectedProviders(providers), new SetPlansDirty(true, ALL_MEDICARE_PLUS_MEDIGAP_PLAN_TYPE_VALUES)]);
            }
            catch (error) {
                console.error(error);
                this.externalErrorLoggingService.log(error);
            }
        }
    }
    getSelectedProviders() {
        return this.store.selectSnapshot(ProviderState.selectedProviders);
    }
    getSelectedProviders$() {
        return this.store.select(ProviderState.selectedProviders);
    }
    hasSelectedProviders() {
        return this.store.selectSnapshot(ProviderState.hasSelectedProviders);
    }
    removeProviders$(provider) {
        if (provider?.addressId) {
            const sessionId = this.store.selectSnapshot(MemberState.sessionId);
            let externalProviderId;
            if (this.isZelisIntegrationEnabled()) {
                externalProviderId = provider.providerID ?? provider.id;
            }
            return this.providerHttpService
                .removeProvider$(sessionId, provider.addressId.toString(), provider.npis?.[0]?.toString(), externalProviderId)
                .pipe(take(1), tap(() => {
                this.store.dispatch(new RemoveProvider(provider));
                this.store.dispatch(new SetPlansDirty(true, ALL_MEDICARE_PLUS_MEDIGAP_PLAN_TYPE_VALUES));
            }), map(providerUpdateResponse => providerUpdateResponse.status));
        }
        return of(null);
    }
    getProviderDetails$() {
        return this.store.select(ProviderState.providerDetails);
    }
    getProviderDetails() {
        return this.store.selectSnapshot(ProviderState.providerDetails);
    }
    getProviders$() {
        return this.store.select(ProviderState.providers);
    }
    getProviders() {
        return this.store.selectSnapshot(ProviderState.providers);
    }
    hasProviders() {
        return this.store.selectSnapshot(ProviderState.hasProviders);
    }
    getFilteredProviders$(providersFilterCheckBoxes, vbcWhitelistedId, INDIVIDUAL_PROVIDER_FILTER_LABEL, FACILITIES_PROVIDER_FILTER_LABEL, VALUE_BASED_CARE_PROVIDER_FILTER_LABEL) {
        const providerFilterStates = this.getProviderFilterStates(providersFilterCheckBoxes);
        return this.store.select(ProviderState.filteredProviders(providerFilterStates, vbcWhitelistedId, INDIVIDUAL_PROVIDER_FILTER_LABEL, FACILITIES_PROVIDER_FILTER_LABEL, VALUE_BASED_CARE_PROVIDER_FILTER_LABEL));
    }
    getFilteredProviders(providersFilterCheckBoxes, vbcWhitelistedId, INDIVIDUAL_PROVIDER_FILTER_LABEL, FACILITIES_PROVIDER_FILTER_LABEL, VALUE_BASED_CARE_PROVIDER_FILTER_LABEL) {
        const providerFilterStates = this.getProviderFilterStates(providersFilterCheckBoxes);
        return this.store.selectSnapshot(ProviderState.filteredProviders(providerFilterStates, vbcWhitelistedId, INDIVIDUAL_PROVIDER_FILTER_LABEL, FACILITIES_PROVIDER_FILTER_LABEL, VALUE_BASED_CARE_PROVIDER_FILTER_LABEL));
    }
    isProviderSearchLoaded$() {
        return this.store.select(ProviderState.isProviderSearchLoaded);
    }
    isProviderSearchLoaded() {
        return this.store.selectSnapshot(ProviderState.isProviderSearchLoaded);
    }
    getSelectedPrimaryCareProvider() {
        return this.store.selectSnapshot(ProviderState.selectedPrimaryCareProvider);
    }
    async getProvidersFromMember() {
        let result;
        if (this.isProvidersEnabled) {
            result = this.providerHttpService.getProvidersFromMember(this.store.selectSnapshot(MemberState.sessionId));
        }
        else {
            result = Promise.resolve([]);
        }
        return await result;
    }
    fetchProvidersDetails$(providerDetailsRequest, includeExtendedProviderData = false) {
        this.showProviderLoading(true);
        return this.providerHttpService.nextGenFetchProvidersDetails$(providerDetailsRequest, includeExtendedProviderData).pipe(tap(() => {
            this.showProviderLoading(false);
        }));
    }
    async fetchProvidersDetails(providerDetailsRequest, includeExtendedProviderData) {
        return await this.providerHttpService.nextGenFetchProvidersDetails(providerDetailsRequest, includeExtendedProviderData);
    }
    async fetchProvidersDetailsBasedOnAvailablePlans(availablePlans, includeExtendedProviderData) {
        const planProvidersRequest = this.getProviderDetailsRequest(availablePlans);
        if (!planProvidersRequest) {
            return {};
        }
        const providerDetails = await this.fetchProvidersDetails(planProvidersRequest, includeExtendedProviderData);
        return providerDetails;
    }
    fetchProvidersDetailsBasedOnAvailablePlans$(availablePlans, includeExtendedProviderData) {
        const planProvidersRequest = this.getProviderDetailsRequest(availablePlans);
        if (!planProvidersRequest) {
            return of({});
        }
        return this.fetchProvidersDetails$(planProvidersRequest, includeExtendedProviderData);
    }
    planTypeSupportsProviders(planTypeAbbreviation) {
        return planTypeAbbreviation === PlanTypeAbbreviation.MAPD || planTypeAbbreviation === PlanTypeAbbreviation.MA;
    }
    getProviderDetailsRequest(availablePlans, cabinetProviders) {
        const selectedProviders = cabinetProviders ?? this.getSelectedProviders();
        if (availablePlans?.length && selectedProviders?.length) {
            const zip = this.store.selectSnapshot(DemographicState.selectedZipCode);
            const fips = this.store.selectSnapshot(DemographicState.selectedFipsCode);
            if (zip && fips) {
                const plans = this.getPlansProviderRequest(availablePlans);
                if (plans.length) {
                    const providers = selectedProviders.reduce((providerDetails, selectedProvider) => {
                        const addressId = selectedProvider.addressId;
                        if (this.isZelisIntegrationEnabled()) {
                            providerDetails.push({
                                addressId,
                                // On Zelis, it is recommended to use the provider ID over the NPI due to some inconsistencies with the results
                                providerId: selectedProvider.providerID ?? selectedProvider.id
                            });
                        }
                        else {
                            providerDetails.push({ addressId, npi: selectedProvider.npis?.[0]?.toString() });
                        }
                        return providerDetails;
                    }, []);
                    const effectiveDate = DateUtilities.getFormattedDateTime(new Date(this.dateService.getTotalCostEffectiveDate()), 'DD/MM/YYYY');
                    const providersDetailsRequest = {
                        zip,
                        fips,
                        effectiveDate,
                        plans,
                        providers
                    };
                    return providersDetailsRequest;
                }
            }
        }
        return null;
    }
    getNpiAndAddressOfSelectedProviders() {
        const selectedProviders = this.getSelectedProviders();
        return (selectedProviders?.reduce((providers, selectedProvider) => {
            if (selectedProvider.npis?.length && selectedProvider.addressId) {
                providers.push({ npi: selectedProvider.npis[0].toString(), addressId: selectedProvider.addressId });
            }
            return providers;
        }, []) ?? []);
    }
    findProviderSearchLinkType(providerURL, isProvidersEnabled, showProviderSearch, isBothCarrierAndInternalProvidersDirectoryLinksEnabled = false) {
        if (isBothCarrierAndInternalProvidersDirectoryLinksEnabled && isProvidersEnabled && showProviderSearch && providerURL) {
            return ProvidersLinkType.INTERNAL_AND_EXTERNAL;
        }
        if (isProvidersEnabled && showProviderSearch) {
            return ProvidersLinkType.INTERNAL;
        }
        if (providerURL && !(isProvidersEnabled && showProviderSearch)) {
            return ProvidersLinkType.EXTERNAL;
        }
        return ProvidersLinkType.NO_LINK;
    }
    nextGenPlanPrimaryCareProvider$(providerPcpForPlanRequest) {
        return this.providerHttpService.nextGenPlanPrimaryCareProvider$(providerPcpForPlanRequest);
    }
    getProviderDetailInfo(planId, planProviderDetails) {
        if (planId) {
            const plan = planProviderDetails?.plans?.find(planProvidersDetail => planProvidersDetail.id === planId);
            if (plan) {
                return plan.providers;
            }
        }
        return [];
    }
    showProviderLoading(show) {
        this._showProviderLoading$.next(show);
    }
    getProviderLoading$() {
        return this._showProviderLoading$.asObservable();
    }
    getProviderAddresses(providers = [], npi, providerId) {
        const foundProviders = providers?.filter(provider => provider.npi === `${npi}` || provider.providerId === providerId);
        return (foundProviders?.map(provider => ({
            addressId: provider.addressId,
            inNetwork: provider.inNetwork,
            addressLine1: provider.addressLine1,
            addressLine2: provider.addressLine2,
            city: provider.city,
            latitude: provider.latitude,
            longitude: provider.longitude,
            state: provider.state,
            zip: provider.zip,
            acceptingNewPatients: provider.acceptingNewPatients,
            ...(provider.phoneNumber && { phoneNumber: provider.phoneNumber }),
            ...(provider.languages?.length && { languages: provider.languages }),
            ...(provider.specialty && { specialty: provider.specialty })
        })) ?? []);
    }
    getProviderNetworkStatus(planIds) {
        const providerPlans = this.getProviderDetailsPlansByIds(planIds);
        const locationStatus = providerPlans?.some((plan) => plan?.providers?.some((provider) => {
            if (provider.inNetwork) {
                const addresses = this.getProviderAddresses(plan.providers, provider.npi, provider.providerId);
                return addresses?.some((address) => address.inNetwork);
            }
            return false;
        })) ?? false;
        return locationStatus;
    }
    getProviderLocationStatus(planIds) {
        const providerPlans = this.getProviderDetailsPlansByIds(planIds);
        const locationStatus = providerPlans?.some((plan) => plan?.providers?.some((provider) => {
            if (!provider.inNetwork) {
                const addresses = this.getProviderAddresses(plan.providers, provider.npi, provider.providerId);
                return addresses?.some((address) => address.inNetwork);
            }
            return false;
        })) ?? false;
        return locationStatus
            ? ProviderLocationStatus.ADDITIONAL_LOCATION_INNETWORK_EXISTS
            : ProviderLocationStatus.ADDITIONAL_LOCATION_INNETWORK_NOT_EXISTS;
    }
    getProviderFilterStates(providersFilterCheckBoxes) {
        return (providersFilterCheckBoxes?.reduce((providerFilterStates, elementRef) => {
            const filterState = this.getProviderFilterState(elementRef?.nativeElement);
            if (filterState) {
                providerFilterStates.push(filterState);
            }
            return providerFilterStates;
        }, []) ?? []);
    }
    getProviderFilterState(providersFilterCheckBox) {
        return providersFilterCheckBox
            ? { checked: providersFilterCheckBox.checked, defaultValue: providersFilterCheckBox.defaultValue }
            : null;
    }
    getProviderDetailsPlansByIds(planIds) {
        const providerDetails = this.getProviderDetails();
        return providerDetails?.plans?.filter((provider) => planIds.includes(provider.id)) ?? [];
    }
    getPlansProviderRequest(availablePlans) {
        return (availablePlans?.reduce((selectedPlans, plan) => {
            if (plan.contractId &&
                plan.segmentId &&
                plan.showProviderSearch &&
                this.planTypeSupportsProviders(plan.planTypeAbbreviation) &&
                PlansUtilityService.canSellPlan(plan)) {
                selectedPlans.push({
                    id: plan.id,
                    contractId: plan.contractId,
                    planId: plan.planId,
                    segmentId: plan.segmentId
                });
            }
            return selectedPlans;
        }, []) ?? []);
    }
    async saveOrUpdateProvider(providers) {
        if (providers?.length) {
            const sessionId = this.store.selectSnapshot(MemberState.sessionId);
            return await Promise.all(providers.map(async (provider) => await this.providerHttpService.saveOrUpdateProvider(sessionId, {
                AddressID: provider.addressId,
                NPI: provider.npis[0],
                street1: provider.address1,
                street2: provider.address2,
                city: provider.city,
                state: provider.state,
                zipCode: provider.zip,
                latitude: provider.latitude,
                longitude: provider.longitude,
                phoneNumber: provider.phoneNumber,
                isPrimary: provider.isPrimary,
                isNewPatient: provider.isNewPatient,
                isIndividual: provider.isIndividual
            }, provider.id)));
        }
    }
}
ProviderService.ɵfac = function ProviderService_Factory(t) { return new (t || ProviderService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(ProviderHttpService), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(DateService), i0.ɵɵinject(ExternalErrorLoggingService)); };
ProviderService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ProviderService, factory: ProviderService.ɵfac, providedIn: 'root' });
__decorate([
    Memoize()
], ProviderService.prototype, "planTypeSupportsProviders", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProviderService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }, { type: ProviderHttpService }, { type: ConfigResourceService }, { type: DateService }, { type: ExternalErrorLoggingService }]; }, { planTypeSupportsProviders: [] }); })();

class IPUtilityService {
    constructor(http) {
        this.http = http;
        this.environment = EnvironmentService.getEnvironment();
    }
    async getClientIP() {
        const headers = new HttpHeaders({ noAuthToken: 'true' });
        const ipData = await this.http
            .get(`${this.environment.WEB_SERVICE_BASE_URL}/v1/utility/ip`, { headers })
            .toPromise();
        return ipData ? ipData.ip : '';
    }
}
IPUtilityService.ɵfac = function IPUtilityService_Factory(t) { return new (t || IPUtilityService)(i0.ɵɵinject(i1$2.HttpClient)); };
IPUtilityService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: IPUtilityService, factory: IPUtilityService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IPUtilityService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$2.HttpClient }]; }, null); })();

class SNPService {
    constructor(store, configResourceService) {
        this.store = store;
        this.configResourceService = configResourceService;
        this.snpToolsEnabled = true;
        this.snpToolsEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_SNPTools_Enabled', null, true);
    }
    /**
     * Not currently used anywhere in vnext-widgets, but it is used in vnext-core
     */
    initializeSNPTypeVisibility(show) {
        if (!this.snpToolsEnabled) {
            this.setAllSNPTypesVisibility(true);
        }
        else {
            const currentVisibility = this.store.selectSnapshot(PlansState.snpVisibility);
            let anyVisibilityIsNull = false;
            Object.keys(currentVisibility).forEach(key => {
                if (currentVisibility[key] === null) {
                    anyVisibilityIsNull = true;
                }
            });
            if (anyVisibilityIsNull) {
                this.setAllSNPTypesVisibility(show);
            }
        }
    }
    setAllSNPTypesVisibility(show) {
        this.store.dispatch(new SetAllSNPTypesVisibility(this.snpToolsEnabled ? show : true));
    }
    setCSNPTypesVisibility(show) {
        this.store.dispatch(new SetCSNPVisibility(this.snpToolsEnabled ? show : true));
    }
    setDSNPTypesVisibility(show) {
        this.store.dispatch(new SetDSNPVisibility(this.snpToolsEnabled ? show : true));
    }
    setISNPTypesVisibility(show) {
        this.store.dispatch(new SetISNPVisibility(this.snpToolsEnabled ? show : true));
    }
    moveSNPPlansToTop(plans) {
        if (!this.snpToolsEnabled) {
            return plans;
        }
        const SNPPlans = plans.filter(plan => plan.snpType !== undefined);
        const nonSNPPlans = plans.filter(plan => plan.snpType === undefined);
        return SNPPlans.concat(nonSNPPlans);
    }
    idIsCSNP(id) {
        const idAsNumber = parseInt(`${id}`);
        return Object.values(cSNPTypes).includes(idAsNumber);
    }
    idIsISNP(id) {
        const idAsNumber = parseInt(`${id}`);
        return Object.values(iSNPTypes).includes(idAsNumber);
    }
    getSNPVisibility() {
        return this.store.selectSnapshot(PlansState.snpVisibility);
    }
    getSNPAbbreviation(snpValue, widgetId) {
        switch (snpValue) {
            case SNPBaseType.cSNP:
                return this.configResourceService.getProcessedResourceValue('Spa_Site_CSNPAbbreviation_Label', widgetId, 'CSNP');
            case SNPBaseType.dSNP:
                return this.configResourceService.getProcessedResourceValue('Spa_Site_DSNPAbbreviation_Label', widgetId, 'DSNP');
            case SNPBaseType.iSNP:
                return this.configResourceService.getProcessedResourceValue('Spa_Site_ISNPAbbreviation_Label', widgetId, 'ISNP');
            default:
                return '';
        }
    }
    /*
     * If the plans state gets reset, the visibilities will get set back to null, which will act as false.
     * Calling this function will update any nulls according to our resources.
     * Some may be null but not all if you had gone to guided help after the reset.
     */
    updateNullVisibilities() {
        const showPlansDefault = this.configResourceService.getProcessedResourceValue('Spa_Site_ShowSNPPlansDefault_Flag', null, false);
        const snpVisibility = this.getSNPVisibility();
        if (snpVisibility.cSNP === null) {
            this.setCSNPTypesVisibility(showPlansDefault);
        }
        if (snpVisibility.dSNP === null) {
            this.setDSNPTypesVisibility(showPlansDefault);
        }
        if (snpVisibility.iSNP === null) {
            this.setISNPTypesVisibility(showPlansDefault);
        }
    }
    setDSNPTypesVisibilityOnMedicaidSubsidy(enableDSNPDisplay) {
        if (enableDSNPDisplay) {
            const subsidySelected = this.store.selectSnapshot(DemographicState.subsidySelected);
            if (subsidySelected === SubsidySelected.MEDICAID) {
                const snpVisibility = this.getSNPVisibility();
                if (!snpVisibility?.dSNP) {
                    this.setDSNPTypesVisibility(true);
                }
            }
        }
    }
}
SNPService.ɵfac = function SNPService_Factory(t) { return new (t || SNPService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(ConfigResourceService)); };
SNPService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SNPService, factory: SNPService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SNPService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }, { type: ConfigResourceService }]; }, null); })();

class DrugFrequencyFacade {
    constructor(configResourceService) {
        this.configResourceService = configResourceService;
        this.sortByProperty = 'value';
    }
    getFilteredFrequencyOptions(frequencyOptions, widgetName) {
        const defaultList = frequencyOptions ? frequencyOptions : this.getDefaultFrequencyOptions(widgetName);
        if (this.isSixMonthsFrequencySettingEnabled(widgetName)) {
            return _sortBy(defaultList, this.sortByProperty);
        }
        return _sortBy(defaultList.filter(frequencyItem => frequencyItem.value !== 180 /* FrequencyValue.SixMonths */), this.sortByProperty);
    }
    getFrequencyLabel(drugFrequencyList, frequencyLabel) {
        return drugFrequencyList?.find(freq => freq.label === frequencyLabel)?.value;
    }
    getDefaultFrequencyOptions(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_DrugSearch_Frequency_List', widgetName, [
            { label: "per month" /* FrequencyLabel.Month */, value: 30 /* FrequencyValue.Month */ },
            { label: "per two months" /* FrequencyLabel.TwoMonths */, value: 60 /* FrequencyValue.TwoMonths */ },
            { label: "per three months" /* FrequencyLabel.ThreeMonths */, value: 90 /* FrequencyValue.ThreeMonths */ },
            { label: "per six months" /* FrequencyLabel.SixMonths */, value: 180 /* FrequencyValue.SixMonths */ },
            { label: "per year" /* FrequencyLabel.PerYear */, value: 365 /* FrequencyValue.PerYear */ }
        ]);
    }
    isSixMonthsFrequencySettingEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Show_Six_Months_Frequency', widgetName, false);
    }
}
DrugFrequencyFacade.ɵfac = function DrugFrequencyFacade_Factory(t) { return new (t || DrugFrequencyFacade)(i0.ɵɵinject(ConfigResourceService)); };
DrugFrequencyFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DrugFrequencyFacade, factory: DrugFrequencyFacade.ɵfac, providedIn: 'root' });
__decorate([
    Memoize()
], DrugFrequencyFacade.prototype, "getFrequencyLabel", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DrugFrequencyFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ConfigResourceService }]; }, { getFrequencyLabel: [] }); })();

class PharmacyService {
    constructor(store) {
        this.store = store;
    }
    getIsMailOrderSelected$() {
        return this.store.select(PharmacyState.isMailOrderSelected);
    }
    getIsMailOrderSelected() {
        return this.store.selectSnapshot(PharmacyState.isMailOrderSelected);
    }
    getPharmacyData() {
        return this.store.selectSnapshot(PlansState.pharmacies);
    }
    getPharmacyData$() {
        return this.store.select(PlansState.pharmacies);
    }
    getAPIPharmacyInfoForPlan(planId) {
        return this.store.selectSnapshot(PlansState.getAPIPharmacyInfoForPlan(planId));
    }
    getAPIPharmacyInfoForPlan$(planId) {
        return this.store.select(PlansState.getAPIPharmacyInfoForPlan(planId));
    }
    isPharmacyInNetworkForDrugAlternatives(pharmacy) {
        return !pharmacy?.pharmacyId || pharmacy?.isInNetwork;
    }
}
PharmacyService.ɵfac = function PharmacyService_Factory(t) { return new (t || PharmacyService)(i0.ɵɵinject(i1.Store)); };
PharmacyService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PharmacyService, factory: PharmacyService.ɵfac, providedIn: 'root' });
__decorate([
    MemoizeObservable()
], PharmacyService.prototype, "getIsMailOrderSelected$", null);
__decorate([
    MemoizeObservable()
], PharmacyService.prototype, "getPharmacyData$", null);
__decorate([
    MemoizeObservable()
], PharmacyService.prototype, "getAPIPharmacyInfoForPlan$", null);
__decorate([
    Memoize()
], PharmacyService.prototype, "isPharmacyInNetworkForDrugAlternatives", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PharmacyService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.Store }]; }, { getIsMailOrderSelected$: [], getPharmacyData$: [], getAPIPharmacyInfoForPlan$: [], isPharmacyInNetworkForDrugAlternatives: [] }); })();

class PreferencesService {
    constructor(store, localeService, preferencesHttpService, configResourceService, providerService, ipUtilityService, dateService, snpService, drugFrequencyFacade, phoneService, pharmacyService, enrollmentFunctionService) {
        this.store = store;
        this.localeService = localeService;
        this.preferencesHttpService = preferencesHttpService;
        this.configResourceService = configResourceService;
        this.providerService = providerService;
        this.ipUtilityService = ipUtilityService;
        this.dateService = dateService;
        this.snpService = snpService;
        this.drugFrequencyFacade = drugFrequencyFacade;
        this.phoneService = phoneService;
        this.pharmacyService = pharmacyService;
        this.enrollmentFunctionService = enrollmentFunctionService;
    }
    /**
     * Returns if a question should stack all questions on top of each other, or stay side by side.
     * We grow vertically if any question has a length longer than 30 characters, or if there are more than 4 items.
     */
    questionShouldGrowVertically(toggleItemsText) {
        if (toggleItemsText === undefined || toggleItemsText.length === 0) {
            return false;
        }
        if (toggleItemsText.length >= 5) {
            return true;
        }
        return toggleItemsText.sort((a, b) => b.length - a.length)[0].length > 30;
    }
    /**
     * Sorts the options within each question by their order property. options missing the property should appear at the end, in whatever
     * order they were in from the resource.
     */
    sortQuestionOptions(questions) {
        if (!questions.length) {
            return [];
        }
        const sortedQuestions = questions;
        sortedQuestions.map(question => ({
            ...question,
            options: this.getQuestionOptions(question)
        }));
        return sortedQuestions;
    }
    /**
     * Creates an array of question arrays ordered by page. The first array in the list will be whatever was the first page with questions.
     * I.E. If there were no questions for page 1 or 2, and two for page 3, the first item in this array will be the two page 3 questions.
     */
    groupQuestionsByPage(questions) {
        if (!questions.length) {
            return [];
        }
        const sortedByPage = questions.sort((a, b) => a.page - b.page);
        const lastPossiblePage = sortedByPage[sortedByPage.length - 1].page;
        const pages = [];
        for (let i = 1; i <= lastPossiblePage; i++) {
            const questionsForPage = sortedByPage.filter(question => question.page === i);
            if (questionsForPage.length) {
                const sortedQuestions = questionsForPage.sort((a, b) => a.order - b.order);
                pages.push({ questions: sortedQuestions });
            }
        }
        return this.updateQuestionPageNumbers(pages);
    }
    getPreferenceWeights() {
        const preferenceWeightProvider = this.configResourceService.getProcessedResourceValue('Spa_Site_Preferences_Weight_Provider', null, 0);
        const preferenceWeightDrug = this.configResourceService.getProcessedResourceValue('Spa_Site_Preferences_Weight_Drug', null, 0);
        const preferenceWeightPharmacy = this.configResourceService.getProcessedResourceValue('Spa_Site_Preferences_Weight_Pharmacy', null, 0);
        const preferenceWeightChronic = this.configResourceService.getProcessedResourceValue('Spa_Site_Preferences_Weight_Chronic', null, 0);
        const preferenceWeightBenefits = this.configResourceService.getProcessedResourceValue('Spa_Site_Preferences_Weight_Benefits', null, 0);
        const preferenceWeightMedsup = this.configResourceService.getProcessedResourceValue('Spa_Site_Preferences_Weight_Medsup', null, 0);
        const totalWeight = preferenceWeightProvider +
            preferenceWeightDrug +
            preferenceWeightPharmacy +
            preferenceWeightChronic +
            preferenceWeightBenefits +
            preferenceWeightMedsup;
        const defaultWeight = 20;
        if (totalWeight === 0) {
            return [
                {
                    key: PreferenceType.PROVIDER,
                    weight: defaultWeight
                },
                {
                    key: PreferenceType.DRUG,
                    weight: defaultWeight
                },
                {
                    key: PreferenceType.PHARMACY,
                    weight: defaultWeight
                },
                {
                    key: PreferenceType.CHRONIC,
                    weight: defaultWeight
                },
                {
                    key: PreferenceType.BENEFITS,
                    weight: defaultWeight
                },
                {
                    key: PreferenceType.MEDSUP,
                    weight: 0
                }
            ];
        }
        if (totalWeight === 100) {
            return [
                {
                    key: PreferenceType.PROVIDER,
                    weight: preferenceWeightProvider
                },
                {
                    key: PreferenceType.DRUG,
                    weight: preferenceWeightDrug
                },
                {
                    key: PreferenceType.PHARMACY,
                    weight: preferenceWeightPharmacy
                },
                {
                    key: PreferenceType.CHRONIC,
                    weight: preferenceWeightChronic
                },
                {
                    key: PreferenceType.BENEFITS,
                    weight: preferenceWeightBenefits
                },
                {
                    key: PreferenceType.MEDSUP,
                    weight: preferenceWeightMedsup
                }
            ];
        }
        return [
            {
                key: PreferenceType.PROVIDER,
                weight: Math.round((preferenceWeightProvider / totalWeight) * 100)
            },
            {
                key: PreferenceType.DRUG,
                weight: Math.round((preferenceWeightDrug / totalWeight) * 100)
            },
            {
                key: PreferenceType.PHARMACY,
                weight: Math.round((preferenceWeightPharmacy / totalWeight) * 100)
            },
            {
                key: PreferenceType.CHRONIC,
                weight: Math.round((preferenceWeightChronic / totalWeight) * 100)
            },
            {
                key: PreferenceType.BENEFITS,
                weight: Math.round((preferenceWeightBenefits / totalWeight) * 100)
            },
            {
                key: PreferenceType.MEDSUP,
                weight: Math.round((preferenceWeightMedsup / totalWeight) * 100)
            }
        ];
    }
    getPersonalizedBenefits(planYear) {
        return this.preferencesHttpService.getPersonalizedBenefits$(planYear);
    }
    /**
     * Saves which ids have been selected to the API. Note that we cannot track which question an id was answered on, so duplicate
     * instances of an id will all effectively be selected at once.
     */
    async savePreferenceQuestionAnswers(preferences) {
        const sessionId = this.store.selectSnapshot(MemberState.sessionId);
        const categories = {
            [PreferenceType.BENEFITS]: [],
            [PreferenceType.CHRONIC]: [],
            [PreferenceType.MEDSUP]: []
        };
        preferences.forEach(preference => {
            categories[preference.category].push(preference.value);
        });
        const preferenceItems = [
            { key: PreferenceType.BENEFITS, values: categories[PreferenceType.BENEFITS] },
            { key: PreferenceType.MEDSUP, values: categories[PreferenceType.MEDSUP] },
            { key: PreferenceType.CHRONIC, values: categories[PreferenceType.CHRONIC] }
        ];
        this.setMemberPreferences(preferenceItems);
        return await this.preferencesHttpService.savePreferenceQuestionAnswers(sessionId, preferenceItems);
    }
    setMemberPreferences(preferences) {
        this.store.dispatch(new SetPreferences(preferences));
    }
    saveMemberPreferencesToAPI(sessionId, preferences) {
        this.preferencesHttpService.savePreferenceQuestionAnswers(sessionId, preferences);
    }
    getMemberPreferences() {
        return this.store.selectSnapshot(PreferencesState.preferences);
    }
    hasMemberPreferences() {
        return this.store.selectSnapshot(PreferencesState.hasPreferences);
    }
    /**
     * Loads ids from the API that were previously saved. If any questions share an id that is loaded, all of them will have that
     * option selected.
     */
    getPreferenceQuestionAnswers() {
        const preferenceAnswers = this.getMemberPreferences();
        if (preferenceAnswers) {
            return preferenceAnswers;
        }
        return [];
    }
    /**
     * Takes a list of available benefit ids, and removes any options for a question that are not included in those results.
     * It then removes any empty questions, or empty pages.
     */
    removeUnavailableBenefits(availableBenefits, pages) {
        if (pages?.length) {
            pages.forEach(page => {
                if (page.questions?.length) {
                    page.questions.forEach(question => {
                        if (question.options?.length) {
                            question.options = question.options.filter(option => {
                                if (parseInt(option.id, 10) <= 0) {
                                    return true;
                                }
                                const benefitCategory = question.category === PreferenceType.BENEFITS ? MedBenefitsType.BENEFITS : MedBenefitsType.SNP;
                                return availableBenefits.some(benefit => benefit.category === benefitCategory && `${benefit.benefitID}` === option.id);
                            });
                        }
                    });
                    page.questions = this.removeEmptyQuestions(page.questions);
                }
            });
            // remove any pages that have no questions
            const filteredPages = pages.filter(page => page.questions.length);
            return this.updateQuestionPageNumbers(filteredPages);
        }
        return [];
    }
    /**
     * Takes the results of a medBenefits call, and strips out the ids to more easily remove conflicting options
     * via @removeUnavailableBenefits
     */
    filterQuestionsByBenefits(medBenefits) {
        const originalPages = this.getPreferenceQuestionPagesByResource();
        const modifiedPages = this.removeUnavailableBenefits(medBenefits, originalPages);
        return modifiedPages;
    }
    /**
     * Assuming that MedSup questions have been answered we must filter preference questions based upon
     * availability of plan benefits and rate factor answers. If we have answered MedSup (rate factor) questions
     * we must filter out benefits id for medsup plans that do not have rates (i.e. medsup plans without rates given
     * rate factor questions means this plan isn't available)
     * If MedSup rate factor questions are not answered we display all questions.
     */
    filterMedsupQuestions(pages) {
        const plans = this.store.selectSnapshot(PlansState.plans);
        const hasAnswers = this.store.selectSnapshot(MedSupState.hasAnswers());
        if (hasAnswers) {
            const medSupPlans = plans ? plans.filter(plan => plan.planType === PlanType.MEDIGAP && !!plan.annualPlanPremium) : [];
            const benefitIds = medSupPlans.reduce((planDataBenefitIds, medSupPlan) => {
                const benefits = this.getFilteredMedSupBenefitIds(medSupPlan);
                return planDataBenefitIds.concat(benefits);
            }, []);
            return this.getUpdatedMedSupPreferencePages(pages, benefitIds);
        }
        return pages;
    }
    filterForCoverageTypes(pages, coverageType) {
        const coverageTypeEnabled = this.configResourceService.getProcessedResourceValue('Spa_GuidedHelp_GettingStarted_Coverage_Enabled', null, true);
        const inputPages = pages;
        if (inputPages?.length) {
            inputPages.forEach(page => {
                if (page.questions.length) {
                    page.questions = page.questions.filter(question => {
                        const questionCoverageType = question.coverageType;
                        return (!coverageTypeEnabled ||
                            !coverageType ||
                            !questionCoverageType ||
                            questionCoverageType.includes(PreferenceCoverageType.ALL) ||
                            (questionCoverageType.includes(PreferenceCoverageType.MEDICAL_ONLY) && coverageType === CoverageType.MEDICAL_ONLY) ||
                            (questionCoverageType.includes(PreferenceCoverageType.MEDICAL_AND_PRESCRIPTION_DRUG) &&
                                coverageType === CoverageType.MEDICAL_AND_PRESCRIPTION_DRUG) ||
                            (questionCoverageType.includes(PreferenceCoverageType.PRESCRIPTION_DRUG) &&
                                coverageType === CoverageType.PRESCRIPTION_DRUG) ||
                            (questionCoverageType.includes(PreferenceCoverageType.I_DONT_KNOW) && coverageType === CoverageType.I_DONT_KNOW));
                    });
                }
            });
            const filteredPages = inputPages.filter(page => page.questions.length);
            return this.updateQuestionPageNumbers(filteredPages);
        }
        return [];
    }
    filterQuestionsByCoverageType(modifiedPagesforBenefit, coverageType) {
        const modifiedPages = this.filterForCoverageTypes(modifiedPagesforBenefit, coverageType);
        return modifiedPages;
    }
    /**
     * Checks location data contained in each question, and removes any listed as unavailable in the currently selected location.
     */
    filterQuestionsByLocation(questions) {
        const filteredQuestions = [];
        const zip = parseInt(this.store.selectSnapshot(DemographicState.selectedZipCode), 10);
        if (questions?.length && zip) {
            const fips = this.store.selectSnapshot(DemographicState.selectedFipsCode);
            let state = '';
            if (fips) {
                const counties = this.store.selectSnapshot(DemographicState.counties);
                if (counties?.length) {
                    const matchingCounty = counties.find(county => county.countyFIPS === fips);
                    if (matchingCounty) {
                        state = matchingCounty.state;
                    }
                }
            }
            questions.forEach(question => {
                if (this.isValidQuestionByStateAndZipFiltering(question, state, zip)) {
                    filteredQuestions.push(question);
                }
            });
        }
        return filteredQuestions;
    }
    /**
     * Removes any questions that only have a 'none of these' option left, or no options at all left.
     * 'none of these' options are indicated via a negative id
     */
    removeEmptyQuestions(questions) {
        let filteredQuestions = questions;
        // remove 'none of these options' if length is 1, leaving an empty question
        filteredQuestions.forEach(question => {
            if (question.options.length === 1 && this.optionIsNoneType(question.options[0])) {
                question.options = [];
            }
        });
        // now remove all questions with options length of zero
        filteredQuestions = filteredQuestions.filter(question => question.options?.length);
        return filteredQuestions;
    }
    /**
     * An unofficial option would be a 'no' option in a yes or no question, a 'none of these' in a multi select, or something similar
     * that does not match with any official option with a real id.
     */
    optionIsNoneType(option) {
        // if id ends up configured as not a number, NaN < 0 is always false, and thus will always get through
        return parseInt(option.id, 10) < 0;
    }
    /**
     * Returns an array of questions from the site's configuration resources.
     */
    getPreferenceQuestionsResource() {
        return this.configResourceService.getProcessedResourceValue('Spa_GuidedHelp_Preference_Questions', null, []);
    }
    /**
     * Gets the questions from the site's configuration resources, then sorts and optionally filters, returning them in page format.
     */
    getPreferenceQuestionPagesByResource(filterByLocation = true) {
        const sortedQuestions = this.getSortedQuestions(filterByLocation);
        return this.groupQuestionsByPage(sortedQuestions);
    }
    getSortedQuestions(filterByLocation) {
        const questionsResource = this.getPreferenceQuestionsResource();
        let sortedQuestions = this.sortQuestionOptions(questionsResource);
        if (filterByLocation) {
            sortedQuestions = this.filterQuestionsByLocation(sortedQuestions);
        }
        return sortedQuestions;
    }
    async createPreferencesJSON(planId, isHRA = false) {
        const preferences = await this.getPreferences(planId, isHRA);
        const preferencesJson = {
            root: preferences
        };
        return JSON.stringify(preferencesJson);
    }
    async getPreferences(planId, isHRA = false) {
        const additionalInformationSection = await this.getAdditionalInformationSections(planId, isHRA);
        return {
            preferences: additionalInformationSection,
            memberSummary: this.getMemberEnrollmentSummary(),
            agentSummary: this.getAgentEnrollmentSummary()
        };
    }
    async getAdditionalInformationSections(planId, isHRA = false) {
        const sections = [];
        const generalPreferences = this.getGeneralPreferences();
        if (generalPreferences) {
            sections.push(generalPreferences);
        }
        const drugPreferences = this.getDrugPreferences();
        if (drugPreferences) {
            sections.push(drugPreferences);
        }
        const pharmacyPreferences = this.getPharmacyPreferences(planId);
        if (pharmacyPreferences) {
            sections.push(pharmacyPreferences);
        }
        const isTrackingSectionEnabled = this.isTrackingSectionEnabled();
        const preferencesEnrollmentSectionRequests = [this.getProviderPreferences(isHRA)];
        if (isTrackingSectionEnabled) {
            preferencesEnrollmentSectionRequests.push(this.getAgentIpTrackingInformation());
        }
        // performance: resolve the preferences requests in parallel, but keep the same sections order
        const [providerPreferences, trackingInformation] = await Promise.all(preferencesEnrollmentSectionRequests);
        if (providerPreferences) {
            sections.push(providerPreferences);
        }
        const otherPreferences = this.getOtherPreferences(planId);
        if (otherPreferences) {
            sections.push(otherPreferences);
        }
        if (isTrackingSectionEnabled && trackingInformation) {
            sections.push(trackingInformation);
        }
        const locale = this.localeService.getCurrentLocale();
        const additionalInformationText = this.getAdditionalInformationText();
        const additionalInformation = {
            _label: additionalInformationText,
            _lang: locale,
            sections
        };
        return additionalInformation;
    }
    getGeneralPreferences() {
        const items = [];
        const generalQuestions = [];
        const coverageType = this.store.selectSnapshot(GuidedHelpState.selectedCoverageType);
        const ageRange = this.store.selectSnapshot(DemographicState.ageRange);
        const subsidy = this.store.selectSnapshot(DemographicState.subsidySelected);
        const subsidyPercentage = this.store.selectSnapshot(DemographicState.subsidyPercent);
        const coverageTypeSelection = this.getCoverageTypeSelection(coverageType);
        const subsidySelected = this.getSubsidy(subsidy);
        const subsidyPercent = this.getSubsidyPercent(subsidyPercentage);
        const age = this.getAgeRange(ageRange);
        if (coverageType) {
            generalQuestions.push(coverageTypeSelection);
        }
        if (subsidy) {
            generalQuestions.push(subsidySelected);
        }
        if (subsidyPercentage) {
            generalQuestions.push(subsidyPercent);
        }
        if (ageRange) {
            generalQuestions.push(age);
        }
        if (generalQuestions.length) {
            items.push({ item: generalQuestions });
        }
        return this.getReturnValue(this.getGeneralText(), items, PreferenceSectionFormKey.GENERAL);
    }
    getDrugPreferences() {
        const cabinetEntries = this.store.selectSnapshot(MedicineCabinetState.medicineCabinet);
        const items = cabinetEntries.reduce((drugPreferenceItems, drug, index) => {
            const drugItems = [];
            const drugLabel = this.getDrugLabel(index);
            const drugName = this.getDrugName(drug);
            const drugType = this.getDrugType(drug);
            const drugDoseAndForm = this.getDosageAndForm(drug);
            const drugQuantityAndFrequency = this.getDrugQuantityAndFrequency(drug);
            const drugPackageSelection = this.getDrugPackageSelection(drug);
            const drugTierDescriptions = this.getDrugTierDescriptions(drug);
            drugItems.push(drugLabel);
            drugItems.push(drugName);
            drugItems.push(drugType);
            drugItems.push(drugDoseAndForm);
            drugItems.push(drugQuantityAndFrequency);
            const hasPackages = drug?.dosage && !!drug.dosage.selectedPackageId;
            if (hasPackages) {
                drugItems.push(drugPackageSelection);
            }
            drugItems.push(drugTierDescriptions);
            drugPreferenceItems.push({ item: drugItems });
            return drugPreferenceItems;
        }, []);
        return this.getReturnValue(this.getDrugsText(), items, PreferenceSectionFormKey.PRESCRIPTIONS);
    }
    getPharmacyPreferences(planId) {
        const selectedPharmacies = this.store.selectSnapshot(PharmacyState.selectedPharmacies);
        const pharmacies = this.pharmacyService.getAPIPharmacyInfoForPlan(planId);
        const items = selectedPharmacies.reduce((pharmacyPreferenceItems, pharmacy, index) => {
            let planPharmacyDetails = pharmacies?.find(planPharmacy => planPharmacy.nabp === pharmacy.nabp);
            if (!planPharmacyDetails) {
                planPharmacyDetails = pharmacy;
            }
            const pharmacyItems = [];
            const pharmacyLabel = this.getPharmacyLabel(index, planPharmacyDetails);
            const pharmacyName = this.getPharmacyName(planPharmacyDetails);
            const pharmacyAddress = this.getPharmacyAddress(planPharmacyDetails);
            const pharmacyAddress2 = this.getPharmacyAddress2(planPharmacyDetails);
            const pharmacyCityStateZip = this.getPharmacyCityStateZip(planPharmacyDetails);
            const pharmacyStatus = this.getPharmacyStatus(planPharmacyDetails);
            pharmacyItems.push(pharmacyLabel);
            pharmacyItems.push(pharmacyName);
            pharmacyItems.push(pharmacyAddress);
            pharmacyItems.push(pharmacyAddress2);
            pharmacyItems.push(pharmacyCityStateZip);
            pharmacyItems.push(pharmacyStatus);
            pharmacyPreferenceItems.push({ item: pharmacyItems });
            return pharmacyPreferenceItems;
        }, []);
        return this.getReturnValue(this.getPharmacyText(), items, PreferenceSectionFormKey.PHARMACIES);
    }
    getCostsPreferences() {
        const items = [];
        const selectedPharmacy = this.store.selectSnapshot(PharmacyState.selectedPharmacy);
        const selectedPlan = this.getSelectedPlan();
        const costSummary = this.getAnnualCostSummary(selectedPlan, selectedPharmacy);
        const costSections = [];
        if (costSummary) {
            if (costSummary.totalAnnualDrugCostShare) {
                const estimatedDrugCost = this.getFormattedCurrencyValue(costSummary.totalAnnualDrugCostShare, selectedPlan);
                const drugCosts = {
                    _label: this.getEstimatedDrugCostText(selectedPharmacy),
                    Value: estimatedDrugCost
                };
                costSections.push(drugCosts);
            }
            if (costSummary.totalAnnualMedicalCostShare) {
                const healthCost = this.getFormattedCurrencyValue(costSummary.totalAnnualMedicalCostShare, selectedPlan);
                const healthCosts = {
                    _label: this.getEstimatedHealthCostText(),
                    Value: healthCost
                };
                costSections.push(healthCosts);
            }
            if (costSummary.totalEstimatedCost) {
                const totalEstimatedCost = this.getFormattedCurrencyValue(costSummary.totalEstimatedCost, selectedPlan);
                const totalCost = {
                    _label: this.getTotalEstimatedAnnualCost(),
                    Value: totalEstimatedCost
                };
                costSections.push(totalCost);
            }
        }
        if (costSections.length) {
            items.push({ item: costSections });
        }
        return this.getReturnValue(this.getCostsText(), items);
    }
    async getProviderPreferences(isHRA = false) {
        const selectedProviders = this.providerService.getSelectedProviders();
        let items = [];
        if (selectedProviders?.length) {
            const selectedPlan = this.getSelectedPlan(undefined, isHRA);
            const providersDetailsRequest = this.providerService.getProviderDetailsRequest([selectedPlan], selectedProviders);
            if (providersDetailsRequest) {
                const includeExtendedProviderData = this.configResourceService.getProcessedResourceValue('Spa_Site_Provider_ShowAllInNetworkLocations_Enabled', null, true);
                const providersDetails = await this.providerService.fetchProvidersDetails(providersDetailsRequest, includeExtendedProviderData);
                if (providersDetails?.plans?.length) {
                    const updatedProviders = selectedProviders.map(provider => {
                        const phoneNumberFormatted = this.phoneService.parsePhoneNumber(provider.phoneNumber);
                        const updatedProvider = { ...provider, phoneNumberFormatted };
                        const matchedProvider = ProviderUtilityService.matchProviderDetailInfo({
                            providerDetails: providersDetails.plans[0].providers,
                            selectedProvider: provider,
                            checkIfSameAddress: true
                        });
                        if (matchedProvider) {
                            updatedProvider.inNetwork = matchedProvider.inNetwork;
                        }
                        return updatedProvider;
                    });
                    items = this.getProviderItems(updatedProviders);
                }
            }
        }
        return this.getReturnValue(this.getProviderPreferencesText(), items, PreferenceSectionFormKey.PROVIDERS);
    }
    getOtherPreferences(planId) {
        const items = [];
        const preferenceAnswers = this.getPreferenceAnswerIdsAsArray();
        const selectedPlan = this.store.selectSnapshot(ShoppingCartState.selectedPlanById(planId));
        const planBenefitsIds = this.getPlanBenefitIds(selectedPlan); // filter specific to plan
        const selectedBenefitIds = planBenefitsIds.filter(benefitId => preferenceAnswers.includes(benefitId));
        const questions = this.getSortedQuestions();
        const preferences = questions.reduce((preferencesData, question) => {
            const questionOptions = question.options;
            const selectedValues = questionOptions.reduce((questionOptionData, option) => {
                const isAnswerIncluded = this.isAnswerToBeIncluded(option, preferenceAnswers);
                const optionsText = this.getOptionsText(option, selectedBenefitIds);
                if (isAnswerIncluded) {
                    questionOptionData.push(optionsText);
                }
                return questionOptionData;
            }, []);
            if (selectedValues.length) {
                const preferenceItem = {
                    _label: question.questionText,
                    Value: selectedValues.join(', ')
                };
                preferencesData.push(preferenceItem);
            }
            return preferencesData;
        }, []);
        if (preferences.length) {
            items.push({ item: preferences });
        }
        return this.getReturnValue(this.getOtherPreferencesText(), items);
    }
    async getAgentIpTrackingInformation() {
        const items = [];
        const ipPreferences = [];
        const hasAgent = !!this.store.selectSnapshot(AgentState.agentGuid);
        const startedBy = await this.getIpAddressTrackingSection();
        ipPreferences.push(startedBy);
        if (hasAgent) {
            const submittedBy = this.getSubmittedByAgentTrackingSection();
            ipPreferences.push(submittedBy);
        }
        items.push({ item: ipPreferences });
        return this.getReturnValue(this.getIpText(), items, PreferenceSectionFormKey.IP_ADDRESS);
    }
    getPreferenceAnswerIdsAsArray() {
        const preferenceItems = this.getPreferenceQuestionAnswers();
        return preferenceItems.reduce((idsAsArray, questionType) => idsAsArray.concat(questionType.values), []);
    }
    getPreferenceAnswerIdsWithType() {
        const preferenceItems = this.getPreferenceQuestionAnswers();
        let idsWithTypes = [];
        preferenceItems.forEach(questionTypeBucket => {
            idsWithTypes = idsWithTypes.concat(questionTypeBucket.values.map(value => ({ id: value, type: questionTypeBucket.key })));
        });
        return idsWithTypes;
    }
    updateDisplayLabel(options, displayLabel) {
        return options.reduce((updatedOptions, option) => {
            updatedOptions.push({
                ...option,
                displayLabel
            });
            return updatedOptions;
        }, []);
    }
    getPlanPreferenceBenefits(plan) {
        // list of objects with id and type, for ALL other preference questions answered, not just chronic or benefits
        const memberPreferences = this.getPreferenceAnswerIdsWithType();
        const questions = this.getSortedQuestions(false);
        const questionOptions = questions.reduce((options, question) => {
            const questionOptions = question.options.map(questionOption => ({ ...questionOption, parentType: question.category }));
            if (question.displayLabel && question.selectAmount === PreferenceSelectAmount.SINGLE) {
                // Add question display label to options for single / radio selections
                // Multi selections should have displayLabel set at option level by default.
                const updatedOptions = this.updateDisplayLabel(questionOptions, question.displayLabel);
                return options.concat(updatedOptions);
            }
            return options.concat(questionOptions);
        }, []);
        return questionOptions.reduce((preferenceBenefits, option) => {
            const newBenefit = {
                displayLabel: option.displayLabel ? option.displayLabel : option.text,
                isCovered: this.isBenefitCovered(memberPreferences, plan, option.id, option.parentType),
                id: option.id
            };
            // filter out unanswered questions,
            const isAnsweredQuestion = this.isQuestionAnswered(option, memberPreferences);
            if (isAnsweredQuestion) {
                // and the edge case of possible overlapping benenfits, e.g. SNF with id of 6 or 15
                const hasDuplicates = preferenceBenefits.some(benefit => benefit.id === newBenefit.id);
                if (!hasDuplicates) {
                    preferenceBenefits.push(newBenefit);
                }
            }
            return preferenceBenefits;
        }, []);
    }
    /**
     * Due to either configuration error (ie questions for page 1, 2, and 4) or an update from benefits checking, a question's page value
     * Can end up changing. This function resets all page values by their position, ignoring that original configuration, which is only
     * needed for the init process
     */
    updateQuestionPageNumbers(pages) {
        for (let i = 0; i < pages.length; i++) {
            pages[i].questions.forEach(question => {
                question.page = i + 1;
            });
        }
        return pages;
    }
    isDrugCoveredByPlan(dosage, plan) {
        const availableTiers = this.getCoveredPlanTiers(plan);
        const formularyInfo = this.getPlanRetailDrugCoverage(plan);
        return this.isDrugCovered(availableTiers, formularyInfo, dosage);
    }
    getDefaultBenefits(allBenefits) {
        const customizeDefaultBenefits = this.configResourceService.getProcessedResourceValue('Spa_CustomizeBenefits_DefaultBenefits_JSON', null, []);
        if (allBenefits?.length && customizeDefaultBenefits?.length) {
            const defaultMedCategoryIds = customizeDefaultBenefits
                ?.sort((a, b) => a.ordinal - b.ordinal)
                .reduce((medCategoryIds, defaultItem) => {
                if (defaultItem?.display) {
                    medCategoryIds.push(defaultItem.medCategoryId);
                }
                return medCategoryIds;
            }, []);
            return defaultMedCategoryIds.reduce((selectedBenefits, benefitId) => {
                const foundBenefit = allBenefits?.find(benefit => Number(benefit.benefitId) === benefitId);
                if (foundBenefit) {
                    selectedBenefits.push(foundBenefit);
                }
                return selectedBenefits;
            }, []);
        }
        return [];
    }
    setSNPVisibilityBySavedAnswers(savedAnswers) {
        const showSNPOnChronicSelection = this.configResourceService.getProcessedResourceValue('Spa_Preferences_SetSNPVisbilityOnSave_Enabled', null, true);
        const chronicIds = savedAnswers.filter(answer => answer.category === PreferenceType.CHRONIC).map(answer => answer.value);
        if (chronicIds.length && showSNPOnChronicSelection) {
            if (chronicIds.some(id => this.snpService.idIsISNP(id))) {
                this.snpService.setISNPTypesVisibility(true);
            }
            if (chronicIds.some(id => this.snpService.idIsCSNP(id))) {
                this.snpService.setCSNPTypesVisibility(true);
            }
        }
    }
    getMemberEnrollmentSummary() {
        return {
            firstName: this.store.selectSnapshot(ProfileState.firstName),
            lastName: this.store.selectSnapshot(ProfileState.lastName),
            addresses: this.store.selectSnapshot(ProfileState.addresses),
            subsidySelected: this.store.selectSnapshot(DemographicState.subsidySelected),
            subsidyPercent: this.store.selectSnapshot(DemographicState.subsidyPercent),
            effectiveDate: this.enrollmentFunctionService.getEnrollmentAnswer('ApplicantEffectiveDate')
        };
    }
    getAgentEnrollmentSummary() {
        const agentPhoneNumber = this.store.selectSnapshot(AgentState.phoneNumber);
        const formattedPhone = this.phoneService.formatPhoneNumberWithExtension(agentPhoneNumber, this.store.selectSnapshot(AgentState.extension));
        return {
            agentGuid: this.store.selectSnapshot(AgentState.agentGuid),
            firstName: this.store.selectSnapshot(AgentState.firstName),
            lastName: this.store.selectSnapshot(AgentState.lastName),
            emailAddress: this.store.selectSnapshot(AgentState.emailAddress),
            phoneNumber: formattedPhone
        };
    }
    getOptionsText(option, selectedBenefitIds) {
        let optionsText = '';
        if (option) {
            optionsText = `${option.text}`;
            if (selectedBenefitIds.includes(option.id)) {
                optionsText = `${option.text} (${this.getCoveredText()})`;
            }
            else {
                if (parseInt(option.id, 10) > 0) {
                    optionsText = `${option.text} (${this.getNotCoveredText()})`;
                }
            }
        }
        return optionsText;
    }
    /**
     * Include answer if preferences includes the selected id
     */
    isAnswerToBeIncluded(option, preferenceAnswers) {
        return option && preferenceAnswers && preferenceAnswers.includes(option.id);
    }
    getFilteredMedSupBenefitIds(medSupPlan) {
        return medSupPlan?.planDataFields?.length
            ? medSupPlan.planDataFields.filter(benefit => benefit.isCovered).map(planBenefit => planBenefit.benefitID.toString())
            : [];
    }
    getUpdatedMedSupPreferencePages(pages, benefitIds) {
        return pages
            ? pages.reduce((pageData, page) => {
                const newPage = {
                    questions: this.getFilteredMedSupQuestions(page, benefitIds)
                };
                if (newPage.questions.length) {
                    pageData.push(newPage);
                }
                return pageData;
            }, [])
            : [];
    }
    isBenefitCovered(selectedOtherPreferences, plan, id, type) {
        if (!selectedOtherPreferences.length) {
            return false;
        }
        const idByTypeIsIncluded = this.selectedPreferencesIncludesIdByType(selectedOtherPreferences, id, type);
        if (type === PreferenceType.BENEFITS) {
            let planPossibleBenefitIds = [];
            if (plan.planDataFields.length) {
                planPossibleBenefitIds = plan.planDataFields
                    .filter(planBenefit => planBenefit.isCovered)
                    .map(planBenefit => planBenefit.benefitID.toString());
            }
            return idByTypeIsIncluded && planPossibleBenefitIds.includes(id);
        }
        else if (type === PreferenceType.CHRONIC) {
            let planPossibleChronicIds = [];
            if (plan.planSNPCategories?.length) {
                planPossibleChronicIds = plan.planSNPCategories.map(snpCategory => snpCategory.categoryId.toString());
            }
            return idByTypeIsIncluded && planPossibleChronicIds.includes(id);
        }
        else {
            return idByTypeIsIncluded;
        }
    }
    selectedPreferencesIncludesIdByType(selectedOtherPreferences, id, type) {
        return selectedOtherPreferences
            .filter(selectedBenefit => selectedBenefit.type === type)
            .map(selectedBenefit => selectedBenefit.id)
            .includes(id);
    }
    getFilteredMedSupQuestions(page, benefitIds) {
        if (page?.questions) {
            return page.questions.reduce((questionData, question) => {
                if (question.category === PreferenceType.MEDSUP) {
                    const questionOptions = question.options;
                    const optionIds = this.getQuestionOptionIds(questionOptions);
                    const showMedSupQuestion = optionIds.some(id => benefitIds.includes(id));
                    if (showMedSupQuestion) {
                        const filteredQuestion = {
                            ...question,
                            options: this.getFilteredQuestionOptions(questionOptions, benefitIds)
                        };
                        questionData.push(filteredQuestion);
                    }
                }
                else {
                    questionData.push(question);
                }
                return questionData;
            }, []);
        }
        return [];
    }
    getFilteredQuestionOptions(questionOptions, benefitIds) {
        return questionOptions ? questionOptions.filter(option => benefitIds.includes(option.id) || parseInt(option.id, 10) <= 0) : [];
    }
    getQuestionOptionIds(questionOptions) {
        return questionOptions ? questionOptions.map(option => option.id).filter(id => parseInt(id, 10) > 0) : [];
    }
    getReturnValue(label, items, formKey) {
        if (items?.length) {
            return { _label: label, items, ...(formKey && { _formKey: formKey }) };
        }
        return null;
    }
    async getIpAddressTrackingSection() {
        const ipAddress = await this.ipUtilityService.getClientIP();
        return {
            _label: this.getStartedByText(),
            Value: ipAddress,
            _formKey: PreferencesFieldFormKey.IP_ADDRESS
        };
    }
    getSubmittedByAgentTrackingSection() {
        const agentFullName = this.store.selectSnapshot(AgentState.fullName);
        const submittedBy = {
            _label: this.getSubmittedByText(),
            Value: `${agentFullName}`,
            _formKey: PreferencesFieldFormKey.SUBMITTED_BY
        };
        return submittedBy;
    }
    getAnnualCostSummary(selectedPlan, primaryPharmacy) {
        const isMultiPharmacyEnabled = this.isMultiPharmacyEnabled();
        let costSummary = null;
        if (isMultiPharmacyEnabled && selectedPlan) {
            if (primaryPharmacy && selectedPlan.planAnnualCost?.annualCostMultiPharmacy?.length) {
                costSummary = selectedPlan.planAnnualCost.annualCostMultiPharmacy.find(annualCostInfo => annualCostInfo.pharmacyNABP === primaryPharmacy.nabp);
            }
        }
        else if (selectedPlan.planAnnualCost?.annualCost?.totalEstimatedCost) {
            costSummary = selectedPlan.planAnnualCost.annualCost;
        }
        return costSummary;
    }
    formatAsCurrency(amount) {
        return `$${amount.toFixed(2)}`;
    }
    isMultiPharmacyEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Multi_Pharmacy_Enabled', widgetName, false);
    }
    getFormattedCurrencyValue(amount, plan) {
        const isMedigap = plan && plan.planType === PlanType.MEDIGAP;
        const isTotalEstimatedCostAnnually = this.store.selectSnapshot(PlansState.isTotalEstimatedCostAnnually);
        return isMedigap || isTotalEstimatedCostAnnually
            ? `${this.formatAsCurrency(amount)}/${this.getAnnuallyText()}`
            : `${this.formatAsCurrency(amount)}/${this.getPartialAnnuallyText()}`;
    }
    getCoverageTypeSelection(coverageType) {
        return {
            _label: this.getCoverateTypeQuestionText(),
            Value: coverageType,
            _formKey: PreferencesFieldFormKey.COVERAGE_TYPE
        };
    }
    getAgeRange(ageRange) {
        return {
            _label: this.getAgeQuestionText(),
            Value: this.getAgeRangeText(ageRange),
            _formKey: PreferencesFieldFormKey.AGE_RANGE
        };
    }
    getSubsidyPercent(subsidyPercentage) {
        return {
            _label: this.getSubsidyPercentQuestionText(),
            Value: this.getSubsidyPercentage(subsidyPercentage)
        };
    }
    getSubsidy(subsidy) {
        return {
            _label: this.getSubsidySelectedQuestionText(),
            Value: this.getSubsidySelectedText(subsidy),
            _formKey: PreferencesFieldFormKey.EXTRA_HELP
        };
    }
    getDrugTierDescriptions(drug) {
        return {
            _label: this.getTierDescriptionText(),
            Value: this.getTierStatus(drug),
            _formKey: PreferencesFieldFormKey.TIER_DESCRIPTION
        };
    }
    getDrugQuantityAndFrequency(drug) {
        return {
            _label: this.getQuantityAndFrequencyText(),
            Value: this.getQuantityFrequency(drug),
            _formKey: PreferencesFieldFormKey.QUANTITY_AND_FREQUENCY
        };
    }
    getTierStatus(drug) {
        const dosage = drug ? drug.dosage : null;
        const selectedPlan = this.getSelectedPlan();
        if (this.isDrugCoveredByPlan(dosage, selectedPlan)) {
            const planFormularyData = selectedPlan ? selectedPlan.planRetailDrugCoverageMultiPharmacy : [];
            return dosage ? this.getCoveredDrugTierDescription(dosage, planFormularyData) : '';
        }
        return this.getNonCoveredPrescriptionText();
    }
    getSelectedPlan(selectedPlanId, isHRA = false) {
        if (isHRA) {
            return this.store.selectSnapshot(EnrollmentState.hraPlan);
        }
        const planId = selectedPlanId || this.getSelectedPlanId();
        return this.store.selectSnapshot(ShoppingCartState.selectedPlanById(planId));
    }
    getSelectedPlanId() {
        return this.store.selectSnapshot(EnrollmentState.activePlanId);
    }
    isDrugCovered(availableTiers, formularyInfo, dosage) {
        if (availableTiers?.length) {
            return availableTiers.some(tier => {
                const dosagesInTier = formularyInfo ? formularyInfo.filter((status) => status.tierNumber === tier.tierNumber) : [];
                return dosagesInTier.map(p => p.ndc).includes(dosage.ndc);
            });
        }
        return false;
    }
    getPlanRetailDrugCoverage(plan) {
        const selectedPharmacy = this.store.selectSnapshot(PharmacyState.selectedPharmacy);
        let planRetailDrugCoverages = plan ? plan.planRetailDrugCoverageMultiPharmacy : [];
        if (selectedPharmacy && planRetailDrugCoverages?.length) {
            planRetailDrugCoverages = planRetailDrugCoverages.filter(retailDrugCoverage => retailDrugCoverage.pharmacyNABP === selectedPharmacy.nabp);
        }
        return planRetailDrugCoverages;
    }
    getQuantityFrequency(drug) {
        const drugSelection = drug ? drug.dosage : null;
        return drugSelection ? `${drugSelection.userQuantity} ${this.getDrugFrequency(drugSelection.daysOfSupply)}` : '';
    }
    getDrugFrequency(daysOfSupply) {
        const frequencyList = this.getDrugSearchFrequencyList();
        const foundFrequency = frequencyList.find(frequency => daysOfSupply <= frequency.value);
        return foundFrequency ? foundFrequency.label : '';
    }
    getDrugSearchFrequencyList(widgetName) {
        return this.drugFrequencyFacade.getFilteredFrequencyOptions(null, widgetName);
    }
    getDrugPackageSelection(drug) {
        return {
            _label: this.getDrugPackageSelectionText(),
            Value: this.getPackageDisplayText(drug),
            _formKey: PreferencesFieldFormKey.PACKAGE
        };
    }
    getPackageDisplayText(drug) {
        const drugSelection = drug ? drug.dosage : null;
        const packageSelection = drugSelection?.packages
            ? drugSelection.packages.find(entry => entry.packageId === drugSelection.selectedPackageId)
            : null;
        return packageSelection ? packageSelection.packageDisplayText : '';
    }
    getDosageAndForm(drug) {
        return drug?.dosage
            ? {
                _label: this.getDoseAndFormText(),
                Value: drug?.dosage ? drug.dosage.labelName : '',
                _formKey: PreferencesFieldFormKey.DOSE_AND_FORM
            }
            : null;
    }
    getDrugType(drug) {
        return drug?.dosage
            ? {
                _label: this.getBrandOrGenericText(),
                Value: drug.dosage.drugType,
                _formKey: PreferencesFieldFormKey.BRAND_OR_GENERIC
            }
            : null;
    }
    getDrugName(drug) {
        return drug?.dosage
            ? {
                _label: this.getDrugNameText(),
                Value: drug.dosage.drugName,
                _formKey: PreferencesFieldFormKey.DRUG_NAME
            }
            : null;
    }
    getDrugLabel(index) {
        return {
            _label: `${this.getPrescriptionText()} ${index + 1}`
        };
    }
    getPharmacyStatus(pharmacy) {
        return pharmacy
            ? {
                _label: this.getPharmacyStatusText(),
                Value: this.getPharmacyStatusValue(pharmacy),
                _formKey: PreferencesFieldFormKey.PHARMACY_STATUS
            }
            : null;
    }
    getPharmacyStatusValue(pharmacy) {
        if (pharmacy.isInNetwork) {
            return pharmacy.isPreferred ? this.getInNetworkPreferredPricingText() : this.getInNetworkStandardPricingText();
        }
        return this.getOutOfNetworkStandardPricingText();
    }
    getPharmacyCityStateZip(pharmacy) {
        return pharmacy
            ? {
                _label: this.getPharmacyCityStateZipText(),
                Value: `${pharmacy.city} ${pharmacy.state} ${pharmacy.zip}`,
                _formKey: PreferencesFieldFormKey.PHARMACY_CITY_STATE_ZIP
            }
            : null;
    }
    getPharmacyAddress(pharmacy) {
        return pharmacy
            ? {
                _label: this.getPharmacyAddressText(),
                Value: pharmacy.address1,
                _formKey: PreferencesFieldFormKey.PHARMACY_ADDRESS
            }
            : null;
    }
    getPharmacyAddress2(pharmacy) {
        return pharmacy
            ? {
                _label: this.getPharmacyAddress2Text(),
                Value: pharmacy.address2,
                _formKey: PreferencesFieldFormKey.PHARMACY_ADDRESS2
            }
            : null;
    }
    getPharmacyName(pharmacy) {
        return pharmacy
            ? {
                _label: this.getPharmacyNameText(),
                Value: pharmacy.name,
                _formKey: PreferencesFieldFormKey.PHARMACY_NAME
            }
            : null;
    }
    getPharmacyLabel(index, pharmacy) {
        return pharmacy.isPrimaryPharmacy
            ? {
                _label: `${this.getPharmacyText()} ${index + 1} (${this.getPrimaryPharmacyText()})`
            }
            : {
                _label: `${this.getPharmacyText()} ${index + 1}`
            };
    }
    isQuestionAnswered(option, memberPreferences) {
        // If option id is 0 (not selected) or negative (no option in yes/no question), then we treat it as not answered.
        if (!option || parseInt(option.id) <= 0) {
            return false;
        }
        let isAnswered = false;
        memberPreferences.forEach(memberPreference => {
            if (memberPreference.id === option.id && memberPreference.type === option.parentType) {
                isAnswered = true;
            }
        });
        return isAnswered;
    }
    getCoveredPlanTiers(plan) {
        const planTier = plan?.planTiers?.find(t => t.pharmacyType === PharmacyType$1.Retail);
        if (planTier) {
            return planTier.tierInformation;
        }
        return [];
    }
    getCoveredDrugTierDescription(dosage, formularyData) {
        if (formularyData?.length) {
            const drugFormularyInfo = dosage.dosageId
                ? formularyData.find(formularyInfo => formularyInfo.drugDosageID === dosage.dosageId)
                : null;
            return drugFormularyInfo ? drugFormularyInfo.tierDescription : '';
        }
        return '';
    }
    getPlanBenefitIds(selectedPlan) {
        if (selectedPlan) {
            return selectedPlan.planDataFields.map(benefit => benefit.benefitID.toString());
        }
        return [];
    }
    hasValidQuestionZipFormat(question) {
        return (question?.zipCodes &&
            !!question.zipCodes.status &&
            Object.values(PreferencesQuestionLocationStatus).includes(question.zipCodes.status) &&
            !!question.zipCodes.list &&
            !!question.zipCodes.list.length);
    }
    hasValidQuestionStateFormat(question) {
        return (question?.states &&
            !!question.states.status &&
            Object.values(PreferencesQuestionLocationStatus).includes(question.states.status) &&
            !!question.states.list &&
            !!question.states.list.length);
    }
    isValidQuestionByStateAndZipFiltering(question, state, zip) {
        const zipIsValid = this.hasValidQuestionZipFormat(question);
        const stateIsValid = this.hasValidQuestionStateFormat(question);
        if (zipIsValid) {
            if (stateIsValid) {
                // We have valid state and zip data, so things can get a little more complex.
                return this.validZipAndStateForQuestionFiltering(question, state, zip);
            }
            else {
                // If we have valid zip data, and invalid state data, just return zip validity
                const zipStatus = question.zipCodes.status;
                const zipIncluded = question.zipCodes.list.includes(zip);
                return ((zipStatus === PreferencesQuestionLocationStatus.VALID && zipIncluded) ||
                    (zipStatus === PreferencesQuestionLocationStatus.INVALID && !zipIncluded));
            }
        }
        else {
            if (stateIsValid) {
                // if we have valid state data, and invalid zip data, just return state validity
                const stateStatus = question.states.status;
                const stateIncluded = question.states.list.includes(state);
                return ((stateStatus === PreferencesQuestionLocationStatus.VALID && stateIncluded) ||
                    (stateStatus === PreferencesQuestionLocationStatus.INVALID && !stateIncluded));
            }
            else {
                // if we have invalid state and zip data, just show the question
                return true;
            }
        }
    }
    /*
     * Assumes that all data coming from the question JSON for zip and state is valid
     */
    validZipAndStateForQuestionFiltering(question, state, zip) {
        const zipIsIncluded = question.zipCodes.list.includes(zip);
        const stateIsIncluded = question.states.list.includes(state);
        const zipStatus = question.zipCodes.status;
        const stateStatus = question.states.status;
        if (zipStatus === PreferencesQuestionLocationStatus.VALID) {
            if (stateStatus === PreferencesQuestionLocationStatus.VALID) {
                // zip and state statuses are both valid, so directly compare both
                return zipIsIncluded && stateIsIncluded;
            }
            else {
                // state status is invalid, zip status is valid, so use state unless zip succeeds, which then over rides state
                return zipIsIncluded ? true : !stateIsIncluded;
            }
        }
        else {
            if (stateStatus === PreferencesQuestionLocationStatus.VALID) {
                // zip status is invalid, state status is valid, so use state unless zip fails, which then over rides state
                return !zipIsIncluded ? stateIsIncluded : false;
            }
            else {
                // zip and state statuses are both invalid, so directly compare both
                return !zipIsIncluded && !stateIsIncluded;
            }
        }
    }
    getAdditionalInformationText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Additional_Information_Text', widgetName, 'Additional Information');
    }
    isTrackingSectionEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Preferences_IP_Address_Section_Enabled', widgetName, false);
    }
    getIpText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_IP_Text', widgetName, 'IP');
    }
    getGeneralText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_General_Text', widgetName, 'General');
    }
    getDrugsText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Prescriptions_Text', widgetName, 'Prescriptions');
    }
    getCostsText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Costs_Text', widgetName, 'Costs');
    }
    getOtherPreferencesText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_OtherPreferences_Text', widgetName, 'Other Preferences');
    }
    getAgeQuestionText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_GuidedHelp_Health_AgeQuestion_Text ', widgetName, 'How old are you?');
    }
    getCoverateTypeQuestionText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_GuidedHelp_GettingStarted_CoverageText_Question', widgetName, 'What coverage type are you interested in?');
    }
    getSubsidySelectedQuestionText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_GettingStarted_SubsidyHeader_Text', widgetName, 'Do you receive extra help with paying for your prescription drugs?');
    }
    getSubsidyPercentQuestionText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_GettingStarted_SubsidyPercentDetails_HTML', widgetName, 'I receive the following percentage to help pay my drug plan premium');
    }
    getCoveredText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_PlanDetails_Covered_Text', widgetName, 'covered').toLowerCase();
    }
    getNotCoveredText(widgetName) {
        return this.configResourceService
            .getProcessedResourceValue('Spa_PlanDetails_Non_Covered_Text', widgetName, 'not covered')
            .toLowerCase();
    }
    getPharmacyText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Pharmacy_Text', widgetName, 'Pharmacy');
    }
    getPrimaryPharmacyText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Primary_Pharmacy_Text', widgetName, 'Primary Pharmacy');
    }
    getPharmacyNameText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_PharmacyName_Text', widgetName, 'Pharmacy name');
    }
    getPharmacyAddressText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Pharmacy_Address_Text', widgetName, 'Pharmacy Address');
    }
    getPharmacyAddress2Text(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Pharmacy_Address2_Text', widgetName, 'Pharmacy Address 2');
    }
    getPharmacyCityStateZipText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Pharmacy_City_State_Zip_Text', widgetName, 'Pharmacy city state and zip');
    }
    getPharmacyStatusText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_PharmacyStatus_Text', widgetName, 'Pharmacy Status');
    }
    getInNetworkPreferredPricingText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Pharmacy_InNetwork_Preferred_Pricing_Text', widgetName, 'In-network pharmacy with preferred pricing');
    }
    getInNetworkStandardPricingText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Pharmacy_InNetwork_Standard_Pricing_Text', widgetName, 'In-network pharmacy with standard pricing');
    }
    getOutOfNetworkStandardPricingText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Pharmacy_OutOfNetwork_Pricing_Text', widgetName, 'Out-of-network pharmacy');
    }
    getEstimatedDrugCostText(pharmacy, widgetName) {
        return this.configResourceService
            .getProcessedResourceValue('Spa_Preferences_EstimatedDrugCost_Text', widgetName, 'Estimated Drug Cost (for <pharmacy>)')
            .replace('<pharmacy>', pharmacy?.name || this.getPrimaryPharmacyText());
    }
    getEstimatedHealthCostText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Preferences_EstimatedHealthCost_Text', widgetName, 'Estimated Health Cost');
    }
    getTotalEstimatedAnnualCost(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Preferences_TotalEstimatedAnnualCost_Text', widgetName, 'Total Estimated Annual Cost');
    }
    getAnnuallyText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Preferences_Costs_Annually_Text', widgetName, 'annually');
    }
    getPartialAnnuallyText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Preferences_Costs_Partial_Annually_Text', widgetName, 'partial annually');
    }
    getPrescriptionText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Preferences_Prescription_Text', widgetName, 'Prescription');
    }
    getDrugNameText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Preferences_DrugName_Text', widgetName, 'Drug Name');
    }
    getBrandOrGenericText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_BrandGeneric_Text', widgetName, 'Brand or Generic?');
    }
    getDoseAndFormText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_DoseAndForm_Text', widgetName, 'Dose and Form');
    }
    getQuantityAndFrequencyText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_QuantityFrequency_Text', widgetName, 'Quantity and Frequency');
    }
    getDrugPackageSelectionText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_PackageSelection_Text', widgetName, 'Drug Package Selection');
    }
    getTierDescriptionText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_TierDescription_Text', widgetName, 'Tier Description');
    }
    getNonCoveredPrescriptionText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_PrescriptionsTab_NonCovered_Text', widgetName, 'Non-covered prescriptions');
    }
    getCoveredPrescriptionText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_PrescriptionsTab_Covered_Text', widgetName, 'Covered prescriptions');
    }
    getStartedByText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_StartedBy_Text', widgetName, 'Started by');
    }
    getSubmittedByText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_SubmittedBy_Text', widgetName, 'Submitted by');
    }
    getQuestionOptions(question) {
        return question.options ? question.options.sort((a, b) => a.order - b.order).filter(option => option.display !== false) : [];
    }
    getProviderPreferencesText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Providers_Text', widgetName, 'Providers');
    }
    getProviderText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Plan_Details_Preferences_Provider_Text', widgetName, 'Provider');
    }
    getInNetworkText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Provider_InNetwork_Text', widgetName, 'In-network');
    }
    getOutNetworkText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Provider_OutOfNetwork_Text', widgetName, 'Out-of-network');
    }
    getPrimaryCareProviderText(widgetName) {
        const primaryCareProviderText = this.configResourceService.getProcessedResourceValue('Spa_Provider_Primary_Care_Provider_Text', widgetName, 'Primary care provider');
        return `(${primaryCareProviderText})`;
    }
    getProviderItems(items) {
        return items
            ? items.map((item, index) => ({
                item: this.getProviderItem(item, index)
            }))
            : [];
    }
    getProviderItem(item, index) {
        return item
            ? [
                {
                    _label: `${this.getProviderText()} ${index + 1} ${item.isPrimary && item.isPrimary === true ? this.getPrimaryCareProviderText() : ''}`
                },
                {
                    _label: this.configResourceService.getProcessedResourceValue('Spa_ProviderName_Text', null, 'Provider Name'),
                    Value: `${item.displayName}${item.title ? `, ${item.title}` : ''}`,
                    _formKey: PreferencesFieldFormKey.PROVIDER_NAME
                },
                {
                    _label: this.configResourceService.getProcessedResourceValue('Spa_ProviderSpecialty_Text', null, 'Provider Specialty'),
                    Value: item.specialtyDisplayName,
                    _formKey: PreferencesFieldFormKey.PROVIDER_SPECIALTY
                },
                {
                    _label: this.configResourceService.getProcessedResourceValue('Spa_ProviderPhoneNumber_Text', null, 'Provider Phone Number'),
                    Value: item.phoneNumberFormatted,
                    _formKey: PreferencesFieldFormKey.PROVIDER_PHONE_NUMBER
                },
                {
                    _label: this.configResourceService.getProcessedResourceValue('Spa_ProviderAddress_Text', null, 'Provider Address'),
                    Value: item.address1,
                    _formKey: PreferencesFieldFormKey.PROVIDER_ADDRESS
                },
                {
                    _label: this.configResourceService.getProcessedResourceValue('Spa_ProviderAddress2_Text', null, 'Provider Address 2'),
                    Value: item.address2,
                    _formKey: PreferencesFieldFormKey.PROVIDER_ADDRESS2
                },
                {
                    _label: this.configResourceService.getProcessedResourceValue('Spa_Provider_City_State_Zip_Text', null, 'Provider city state and zip'),
                    Value: `${item.city}, ${item.state} ${item.zip}`,
                    _formKey: PreferencesFieldFormKey.PROVIDER_CITY_STATE_ZIP
                },
                {
                    _label: this.configResourceService.getProcessedResourceValue('Spa_ProviderNetworkStatus_Text', null, 'Provider network status'),
                    Value: item.inNetwork ? this.getInNetworkText() : this.getOutNetworkText(),
                    _formKey: PreferencesFieldFormKey.PROVIDER_NETWORK_STATUS
                }
            ]
            : [];
    }
    getSubsidyPercentage(subsidyPercent) {
        return subsidyPercent ? `${subsidyPercent}%` : this.getNoSubsidyText();
    }
    getNoSubsidyText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Preferences_No_Subsidy_Text', widgetName, 'No subsidy');
    }
    getSubsidySelectedText(subsidySelected, widgetName) {
        switch (subsidySelected) {
            case SubsidySelected.MEDICAID:
                return this.configResourceService.getProcessedResourceValue('Spa_GettingStarted_SubsidyMedicaid_Text', widgetName, 'I receive help from Medicaid');
            case SubsidySelected.SSI:
                return this.configResourceService.getProcessedResourceValue('Spa_GettingStarted_SubsidySSI_Text', widgetName, 'I get supplemental security income');
            case SubsidySelected.MSP:
                return this.configResourceService.getProcessedResourceValue('Spa_GettingStarted_SubsidyMSP_Text', widgetName, 'I belong to a Medicare Savings Program (MSP)');
            case SubsidySelected.FULL:
                return this.configResourceService.getProcessedResourceValue('Spa_GettingStarted_SubsidyFull_Text', widgetName, 'I applied and got full help through social security');
            case SubsidySelected.PARTIAL:
                return this.configResourceService.getProcessedResourceValue('Spa_GettingStarted_SubsidyPartial_Text', widgetName, 'I applied for and got partial help through social security');
            case SubsidySelected.NONE:
                return this.configResourceService.getProcessedResourceValue('Spa_GettingStarted_SubsidyNone_Text', widgetName, 'No, I am not eligible for special assistance');
            case SubsidySelected.DONT_KNOW:
                return this.configResourceService.getProcessedResourceValue('Spa_GettingStarted_SubsidyDontKnow_Text', widgetName, `I don't know`);
            default:
                break;
        }
    }
    getAgeRangeText(ageRange, widgetName) {
        switch (ageRange) {
            case GuidedHelpAgeSelection.MEMBER_AGE_UNDER_65:
                return this.configResourceService.getProcessedResourceValue('Spa_GuidedHelp_Health_AgeValue1_Text', widgetName, 'Under 65');
            case GuidedHelpAgeSelection.MEMBER_AGE_65_69:
                return this.configResourceService.getProcessedResourceValue('Spa_GuidedHelp_Health_AgeValue2_Text', widgetName, '65-69');
            case GuidedHelpAgeSelection.MEMBER_AGE_70_74:
                return this.configResourceService.getProcessedResourceValue('Spa_GuidedHelp_Health_AgeValue3_Text', widgetName, '70-74');
            case GuidedHelpAgeSelection.MEMBER_AGE_75_79:
                return this.configResourceService.getProcessedResourceValue('Spa_GuidedHelp_Health_AgeValue4_Text', widgetName, '75-79');
            case GuidedHelpAgeSelection.MEMBER_AGE_80_84:
                return this.configResourceService.getProcessedResourceValue('Spa_GuidedHelp_Health_AgeValue5_Text', widgetName, '80-84');
            case GuidedHelpAgeSelection.MEMBER_AGE_85_OVER:
                return this.configResourceService.getProcessedResourceValue('Spa_GuidedHelp_Health_AgeValue6_Text', widgetName, '85+');
            default:
                break;
        }
    }
}
PreferencesService.ɵfac = function PreferencesService_Factory(t) { return new (t || PreferencesService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(LocaleService), i0.ɵɵinject(PreferencesHttpService), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(ProviderService), i0.ɵɵinject(IPUtilityService), i0.ɵɵinject(DateService), i0.ɵɵinject(SNPService), i0.ɵɵinject(DrugFrequencyFacade), i0.ɵɵinject(PhoneUtilityService), i0.ɵɵinject(PharmacyService), i0.ɵɵinject(EnrollmentFunctionService)); };
PreferencesService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PreferencesService, factory: PreferencesService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PreferencesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.Store }, { type: LocaleService }, { type: PreferencesHttpService }, { type: ConfigResourceService }, { type: ProviderService }, { type: IPUtilityService }, { type: DateService }, { type: SNPService }, { type: DrugFrequencyFacade }, { type: PhoneUtilityService }, { type: PharmacyService }, { type: EnrollmentFunctionService }]; }, null); })();

var PharmacyType;
(function (PharmacyType) {
    PharmacyType[PharmacyType["Retail"] = 0] = "Retail";
    PharmacyType[PharmacyType["MailOrder"] = 1] = "MailOrder";
})(PharmacyType || (PharmacyType = {}));

class DrugsService {
    constructor(store, drugsHttpService, drugFrequencyFacade, resourceService) {
        this.store = store;
        this.drugsHttpService = drugsHttpService;
        this.drugFrequencyFacade = drugFrequencyFacade;
        this.resourceService = resourceService;
        this.isUseCMSDrugFlagEnabled = this.resourceService.getProcessedResourceValue('Spa_Drugs_UseCMSDrugFlag_Enabled', null, true);
        this._editEvent$ = new Subject();
        this.editEvent$ = from(this._editEvent$);
        this.getQuantityAndFrequency = (dosage, packageId) => {
            const frequency = this.getFrequency(dosage.daysOfSupply);
            const dosePackageOptions = {
                dosage,
                frequency,
                drugForm: this.getForm(dosage.labelName),
                dosePackage: dosage.packages?.find((pack) => pack.packageId === packageId)
            };
            this.frequency = frequency;
            this.dosePackage = this.getDosePackageText(dosePackageOptions);
            return this.dosePackage;
        };
        // Simple routine to get the frequency labeling from the days of supply
        this.getFrequency = (daysOfSupply) => {
            const frequencyList = this.drugFrequencyFacade.getFilteredFrequencyOptions();
            const foundFrequency = frequencyList.find(frequency => daysOfSupply <= frequency.value);
            return foundFrequency ? foundFrequency.label : '';
        };
    }
    publishEditEvent(drugId) {
        this._editEvent$.next(drugId);
    }
    addDrug(cabinetEntry) {
        this.store.dispatch(new AddDrugToMedicineCabinet(cabinetEntry));
        this.store.dispatch(new AddDrugToMemberState(cabinetEntry));
        this.store.dispatch(new SetGuidedHelpDirty(true));
    }
    editDrug(dosageId, cabinetEntry) {
        this.store.dispatch(new EditDrugInMedicineCabinet(dosageId, cabinetEntry));
        this.store.dispatch(new SetGuidedHelpDirty(true));
    }
    removeDrug(dosageId) {
        this.store.dispatch(new RemoveDrugFromMedicineCabinet(dosageId));
        this.store.dispatch(new RemoveDrugFromMemberState(dosageId));
        this.store.dispatch(new SetGuidedHelpDirty(true));
    }
    getMedicineCabinetConditionId$(dosageId) {
        return this.store.select(MedicineCabinetState.medicineCabinetConditionId(dosageId));
    }
    getMedicineCabinetConditionId(dosageId) {
        return this.store.selectSnapshot(MedicineCabinetState.medicineCabinetConditionId(dosageId));
    }
    getMedicalCondition(drugCoverage, dosageID, conditionId) {
        const medicalConditions = this.getMedicalConditions(drugCoverage, dosageID);
        let medicalCondition;
        if (!conditionId || conditionId === 0) {
            medicalCondition = this.getDefaultMedicalCondition(medicalConditions);
        }
        else {
            medicalCondition = medicalConditions.find(condition => condition.conditionID === conditionId);
        }
        return medicalCondition;
    }
    getMedicalConditions(drugCoverage, dosageID) {
        return (drugCoverage?.find(retailDrugCoverageMultiPharmacy => retailDrugCoverageMultiPharmacy.drugDosageID === dosageID)?.conditions ?? []);
    }
    getDefaultMedicalCondition(conditions) {
        return conditions?.find(condition => condition.isDefaultCondition);
    }
    async updateDrugs(sessionId, cabinetDosages) {
        await this.drugsHttpService.updateDrugs(sessionId, cabinetDosages);
    }
    saveDrugList() {
        const hasUpdates = this.store.selectSnapshot(MedicineCabinetState.hasUpdates);
        const sessionId = this.store.selectSnapshot(MemberState.sessionId);
        const cabinetDosages = this.getCabinetDosages();
        if (hasUpdates) {
            this.setPlansDirtyForPricing();
            this.updateDrugs(sessionId, cabinetDosages);
            this.resetEditStatus();
        }
        if (cabinetDosages.length < 8) {
            const memberAgentTasks = this.store.selectSnapshot(MemberState.memberAgentTasks);
            const selectRxTask = memberAgentTasks.find(agentNote => agentNote.agentNoteActionType === NoteActionType.SelectRx && !agentNote.completedWhen);
            if (selectRxTask) {
                this.store.dispatch(new DeleteSelectRxTask(sessionId, selectRxTask));
            }
        }
    }
    saveMedicalCondition(conditionId, dosageId) {
        const dosage = this.getCabinetDosages().find(cabinetDosage => cabinetDosage?.dosageId === dosageId);
        const cabinetDosage = { ...dosage, conditionId };
        const sessionId = this.store.selectSnapshot(MemberState.sessionId);
        this.store.dispatch(new SaveAndUpdateMemberDosage(sessionId, cabinetDosage));
    }
    /**
     * For saving the current state of drug list data to the API without checks for
     * updates or resetting edit status. Need to save off the state in order to later
     * rehydrate it for consumer accounts.
     */
    saveDrugListToAPI(sessionId) {
        const cabinetDosages = this.getCabinetDosages();
        this.updateDrugs(sessionId, cabinetDosages);
    }
    getForm(labelName, dosePackageDescription) {
        for (const [dosageFormKey, dosageFormValue] of Object.entries(DosageForm)) {
            if (labelName.includes(dosageFormValue)) {
                return DosageFormDisplayText[dosageFormKey];
            }
        }
        return dosePackageDescription ?? DosageFormDisplayText.Default;
    }
    getDosePackageText(dosePackageOptions) {
        const { dosage, drugForm, frequency, dosePackage } = dosePackageOptions;
        // If we have a selected package we display quantity x package + frequency
        // else we display the quantity (days of supply) per frequency.
        // Populate with user quantity
        return dosePackage
            ? `<span class="no-translate-block">${dosage.userQuantity} X ${dosePackage.packageDisplayText}</span> ${frequency}`
            : `<span class="no-translate-block">${dosage.userQuantity} ${drugForm}</span> ${frequency}`;
    }
    getCalculatedDosePackageOptions(dosage, packageId, drugFrequencyList, defaultFrequencyLabel, drugForm, isMailOrder = false) {
        const dosePackageOptions = {
            dosage,
            drugForm,
            frequency: defaultFrequencyLabel,
            dosePackage: dosage.packages?.find(dosagePackage => dosagePackage.packageId === packageId)
        };
        if (isMailOrder) {
            const drugSearchFrequencyDays = {
                [30 /* FrequencyValue.Month */]: this.getFrequencyDays('Spa_DrugSearch_Frequency_30Days', "per month" /* FrequencyLabel.Month */),
                [60 /* FrequencyValue.TwoMonths */]: this.getFrequencyDays('Spa_DrugSearch_Frequency_60Days', "per two months" /* FrequencyLabel.TwoMonths */),
                [90 /* FrequencyValue.ThreeMonths */]: this.getFrequencyDays('Spa_DrugSearch_Frequency_90Days', "per three months" /* FrequencyLabel.ThreeMonths */)
            };
            const { frequency, quantity } = this.getMailOrderDrugDosage(dosage, drugFrequencyList, defaultFrequencyLabel, drugSearchFrequencyDays);
            dosePackageOptions.dosage = { ...dosage, userQuantity: quantity };
            dosePackageOptions.frequency = frequency;
        }
        return dosePackageOptions;
    }
    getDrugNameForAnalytics(cabinetEntry, isMailOrder = false) {
        const dosePackageOptions = this.getCalculatedDosePackageOptions(cabinetEntry.dosage, cabinetEntry.packageId, this.getDrugSearchFrequencyList(), this.getFrequency(cabinetEntry.dosage.daysOfSupply), this.getForm(cabinetEntry.dosage.labelName), isMailOrder);
        const dosePackageText = this.getDosePackageText(dosePackageOptions);
        const dosageForm = this.getForm(cabinetEntry.dosage.labelName, dosePackageOptions.dosePackage?.packageDescription);
        return `${cabinetEntry.labelName}|${dosageForm}|${dosePackageText}`;
    }
    getDrugTypeForAnalytics(cabinetEntry) {
        return cabinetEntry.isGenericAlternative ? BRAND_SWAPPED_TO_GENERIC : cabinetEntry.drugDetails.drugType;
    }
    fetchDrugs$(searchTerm, autocomplete, maxCount) {
        return this.drugsHttpService.retrieveDrugs$(searchTerm, autocomplete, maxCount);
    }
    async fetchDrugs(searchTerm, autocomplete, maxCount) {
        try {
            return await this.fetchDrugs$(searchTerm, autocomplete, maxCount).toPromise();
        }
        catch {
            return [];
        }
    }
    fetchDrugDetails$(drugId, showCommonConditions) {
        return this.drugsHttpService.retrieveDrugDetails$(drugId, showCommonConditions).pipe(catchError(() => of({})));
    }
    async fetchDrugDetails(drugId, showCommonConditions) {
        try {
            return await this.drugsHttpService.retrieveDrugDetails$(drugId, showCommonConditions).toPromise();
        }
        catch {
            return {};
        }
    }
    createCabinetEntry(selectedDosage, drugId, drugDetails, isGenericAlternative) {
        const dosage = {
            ...selectedDosage
        };
        if (this.isUseCMSDrugFlagEnabled) {
            if (isGenericAlternative && drugDetails.genericDrug?.drugFlag) {
                dosage.drugFlag = drugDetails.genericDrug.drugFlag;
            }
            else if (drugDetails.drugFlag) {
                dosage.drugFlag = drugDetails.drugFlag;
            }
        }
        return {
            dosageID: selectedDosage.dosageId,
            drugId,
            dosage,
            labelName: selectedDosage.labelName,
            packageId: selectedDosage.selectedPackageId,
            drugDetails,
            isGenericAlternative,
            conditions: selectedDosage.conditions
        };
    }
    mapCabinetToDosage(cabinetToDosageOptions = {}) {
        const { cabinet, conditionId } = cabinetToDosageOptions;
        const selectedCabinet = cabinet ?? this.store.selectSnapshot(MedicineCabinetState.medicineCabinet);
        return !selectedCabinet?.length
            ? []
            : selectedCabinet.map(drug => ({
                dosageId: drug.dosageID,
                ndc: drug.dosage.ndc,
                metricQuantity: drug.dosage.metricQuantity,
                userQuantity: drug.dosage.userQuantity,
                daysOfSupply: drug.dosage.daysOfSupply,
                selectedPackageId: drug.dosage.selectedPackageId,
                ...(conditionId ? { conditionId } : {})
            }));
    }
    getFrequencyDays(drugSearchFrequencyResource, defaultDrugSearchFrequencyValue, widgetName) {
        return this.resourceService.getProcessedResourceValue(drugSearchFrequencyResource, widgetName, defaultDrugSearchFrequencyValue);
    }
    filterDrugAlternativesByPharmacy(drugAlternatives, pharmacy, isMailOrder) {
        if (pharmacy && !isMailOrder) {
            return drugAlternatives.filter(drugAlternative => drugAlternative.drugCostDetails.formularyStatus.pharmacyNABP === pharmacy.nabp);
        }
        return drugAlternatives.filter((drugAlternative) => {
            if (isMailOrder) {
                return drugAlternative.drugCostDetails.formularyStatus.pharmacyType === PharmacyType.MailOrder;
            }
            return drugAlternative.drugCostDetails.formularyStatus.pharmacyType === PharmacyType.Retail;
        });
    }
    getMailOrderDrugDosage(dosage, drugFrequencyList, defaultFrequencyLabel, { [30 /* FrequencyValue.Month */]: frequencyLabelOneMonth, [60 /* FrequencyValue.TwoMonths */]: frequencyLabelTwoMonth, [90 /* FrequencyValue.ThreeMonths */]: frequencyLabelThreeMonths }) {
        const drugDosage = {
            frequency: defaultFrequencyLabel,
            quantity: dosage?.userQuantity ?? 0
        };
        if (dosage.daysOfSupply === this.drugFrequencyFacade.getFrequencyLabel(drugFrequencyList, frequencyLabelOneMonth)) {
            drugDosage.frequency = frequencyLabelThreeMonths;
            drugDosage.quantity *= 3;
        }
        else if (dosage.daysOfSupply === this.drugFrequencyFacade.getFrequencyLabel(drugFrequencyList, frequencyLabelTwoMonth)) {
            drugDosage.frequency = frequencyLabelThreeMonths;
            drugDosage.quantity *= 1.5;
        }
        return drugDosage;
    }
    getDrugSearchFrequencyList(drugSearchFrequencyList) {
        return drugSearchFrequencyList
            ? this.drugFrequencyFacade.getFilteredFrequencyOptions(drugSearchFrequencyList)
            : this.drugFrequencyFacade.getDefaultFrequencyOptions();
    }
    resetEditStatus() {
        this.store.dispatch(new ResetCabinetUpdatedStatus());
    }
    setPlansDirtyForPricing() {
        this.store.dispatch(new SetPlansDirty(true, ALL_MEDICARE_PLUS_MEDIGAP_PLAN_TYPE_VALUES));
    }
    getCabinetDosages() {
        const medicineCabinet = this.store.selectSnapshot(MedicineCabinetState.medicineCabinet);
        const cabinetDosages = medicineCabinet.map(entry => entry.dosage);
        return cabinetDosages;
    }
}
DrugsService.ɵfac = function DrugsService_Factory(t) { return new (t || DrugsService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(DrugsHttpService), i0.ɵɵinject(DrugFrequencyFacade), i0.ɵɵinject(ConfigResourceService)); };
DrugsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DrugsService, factory: DrugsService.ɵfac, providedIn: 'root' });
__decorate([
    Memoize()
], DrugsService.prototype, "getMedicalCondition", null);
__decorate([
    Memoize()
], DrugsService.prototype, "getMedicalConditions", null);
__decorate([
    Memoize()
], DrugsService.prototype, "getDefaultMedicalCondition", null);
__decorate([
    Memoize()
], DrugsService.prototype, "getMailOrderDrugDosage", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DrugsService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }, { type: DrugsHttpService }, { type: DrugFrequencyFacade }, { type: ConfigResourceService }]; }, { getMedicalCondition: [], getMedicalConditions: [], getDefaultMedicalCondition: [], getMailOrderDrugDosage: [] }); })();

class QuoteService {
    constructor(store, memberSessionHttpService, emailService, quoteHttpService, configResourceService) {
        this.store = store;
        this.memberSessionHttpService = memberSessionHttpService;
        this.emailService = emailService;
        this.quoteHttpService = quoteHttpService;
        this.configResourceService = configResourceService;
    }
    setQuoteGroup(quoteGroup) {
        this.store.dispatch(new SetQuoteGroup(quoteGroup));
    }
    addPlanToQuoteGroup(quoteGroupIdentifier, plan) {
        this.store.dispatch(new AddPlanToQuoteGroup(quoteGroupIdentifier, plan));
    }
    updateFirstPlanInQuoteGroup(quoteGroupIdentifier, plan) {
        this.store.dispatch(new UpdateFirstPlanInQuoteGroup(quoteGroupIdentifier, plan));
    }
    removePlanFromQuoteGroup(quoteGroupIdentifier, plan) {
        this.store.dispatch(new RemovePlanFromQuoteGroup(quoteGroupIdentifier, plan));
    }
    removePlanFromQuoteGroups(plan) {
        this.store.dispatch(new RemovePlanFromQuoteGroups(plan));
    }
    setQuotePlanIds(planIds) {
        this.store.dispatch(new SetQuotePlanIds(planIds));
    }
    setBeneficiaryQuoteDetails(ssoName, agentGuid, quoteId, quickQuoteGuid, showMeetAgent, showAgentProfilePicture, hidePdfAgentData, sourceSiteId) {
        this.store.dispatch(new SetBeneficiaryQuoteDetails(ssoName, agentGuid, quoteId, quickQuoteGuid, sourceSiteId));
        this.store.dispatch(new SetMeetAgent(showMeetAgent));
        this.store.dispatch(new SetAgentPictureDisplay(showAgentProfilePicture));
        this.store.dispatch(new SetHidePdfAgentData(hidePdfAgentData));
    }
    resetBeneficiaryQuoteDetails() {
        this.store.dispatch(new ResetBeneficiaryQuoteDetails());
    }
    setBeneficiaryAgent(agentGuid) {
        this.store.dispatch(new SetBeneficiaryAgent(agentGuid));
    }
    updateQuoteVideoURL(videoURL) {
        this.store.dispatch(new SetQuoteVideoURL(videoURL));
    }
    updateSelectedFormType(enrollmentFormType, planId) {
        this.store.dispatch(new UpdateSelectedFormType(enrollmentFormType, planId));
    }
    updateSelectedFormType$(enrollmentFormType, planId) {
        return this.store.dispatch(new UpdateSelectedFormType(enrollmentFormType, planId));
    }
    setActiveTab(tabType) {
        this.store.dispatch(new SetActiveTab(tabType));
    }
    clearBeneficiaryAgent() {
        this.setBeneficiaryAgent();
    }
    getQuotePlanIds() {
        return this.store.selectSnapshot(QuoteBeneficiaryState.getPlanIds);
    }
    getQuotePlanIds$() {
        return this.store.select(QuoteBeneficiaryState.getPlanIds);
    }
    getBeneficiaryQuoteId() {
        return this.store.selectSnapshot(QuoteBeneficiaryState.getQuoteId);
    }
    getQuoteInfos() {
        return this.store.selectSnapshot(QuoteBeneficiaryState.getQuoteInfos);
    }
    getQuoteInfo$() {
        return this.store.select(QuoteBeneficiaryState.getQuoteInfo);
    }
    getQuoteInfo() {
        return this.store.selectSnapshot(QuoteBeneficiaryState.getQuoteInfo);
    }
    getQuoteTypeFromInfo() {
        return this.store.selectSnapshot(QuoteBeneficiaryState.getQuoteType);
    }
    getAgentGuid() {
        return this.store.selectSnapshot(QuoteBeneficiaryState.getAgentGuid);
    }
    getSsoName() {
        return this.store.selectSnapshot(QuoteBeneficiaryState.getSsoName);
    }
    getQuickQuoteGuid() {
        return this.store.selectSnapshot(QuoteBeneficiaryState.getQuickQuoteGuid);
    }
    getSourceSiteId() {
        return this.store.selectSnapshot(QuoteBeneficiaryState.getSourceSiteId);
    }
    getOriginalAppId() {
        return this.store.selectSnapshot(QuoteBeneficiaryState.getOriginalAppId);
    }
    getQuoteVideoURL() {
        return this.store.selectSnapshot(QuoteBeneficiaryState.getQuoteVideoURL);
    }
    getBrokerData$() {
        return this.store.select(AgentState.agentData);
    }
    getDisplayQuoteLabelBadge() {
        return this.store.selectSnapshot(QuoteBeneficiaryState.getDisplayQuoteLabel);
    }
    getDisplayQuoteLabelBadge$() {
        return this.store.select(QuoteBeneficiaryState.getDisplayQuoteLabel);
    }
    createQuote$(sessionId, quote) {
        return this.memberSessionHttpService.createQuote$(sessionId, quote);
    }
    updateMemberProgress$(sessionId, memberProgressEvent) {
        return this.memberSessionHttpService.updateMemberProgress$(sessionId, memberProgressEvent);
    }
    getPlanDocumentsHtml(planDocuments) {
        const documents = planDocuments.map(document => ({ name: document.linkName, url: document.url }));
        return this.emailService.getDocumentHtml(documents);
    }
    setSourceSiteId(sourceSiteId) {
        this.store.dispatch(new SetSourceSiteId(sourceSiteId));
    }
    setOriginalAppId(originalAppId) {
        this.store.dispatch(new SetOriginalAppId(originalAppId));
    }
    /** Fetches quote info from api without checking store */
    async fetchQuoteInfo(quoteId, agentGuid, quoteType) {
        await firstValueFrom(this.store.dispatch(new FetchQuoteInfo(quoteId, agentGuid, quoteType)));
        return this.getQuoteInfo();
    }
    /** First checks store for existing quote info. If not available, fetches from api */
    async getInfoForQuote(quoteId, agentGuid, quoteType) {
        const quoteInfo = this.getQuoteInfo();
        return quoteInfo && quoteInfo.quoteId === quoteId ? quoteInfo : await this.fetchQuoteInfo(quoteId, agentGuid, quoteType);
    }
    updateQuoteAccessedDate$(quoteId, memberId) {
        return this.quoteHttpService.updateQuoteAccessedDate$(quoteId, memberId);
    }
    setDisplayQuoteLabel(display) {
        this.store.dispatch(new SetDisplayQuoteLabel(display));
    }
    getDisplayQuoteLabel() {
        const isRedirectToPlanListEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_QuotingAndRetention_RedirectToPlanList_Enabled', null, false);
        const displayQuoteLabelBadge = this.getDisplayQuoteLabelBadge();
        return displayQuoteLabelBadge && isRedirectToPlanListEnabled;
    }
}
QuoteService.ɵfac = function QuoteService_Factory(t) { return new (t || QuoteService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(MemberSessionHttpService), i0.ɵɵinject(EmailService), i0.ɵɵinject(QuoteHttpService), i0.ɵɵinject(ConfigResourceService)); };
QuoteService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: QuoteService, factory: QuoteService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(QuoteService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }, { type: MemberSessionHttpService }, { type: EmailService }, { type: QuoteHttpService }, { type: ConfigResourceService }]; }, null); })();

class PlansService {
    constructor(store, plansHttpService, configResource, ridersService, siteService, dateService, providerService, preferencesService, drugsService, planYearResourceService, currencyUtilityService, localeService, stringFormatUtilityService, modalService, navigationService, quoteService) {
        this.store = store;
        this.plansHttpService = plansHttpService;
        this.configResource = configResource;
        this.ridersService = ridersService;
        this.siteService = siteService;
        this.dateService = dateService;
        this.providerService = providerService;
        this.preferencesService = preferencesService;
        this.drugsService = drugsService;
        this.planYearResourceService = planYearResourceService;
        this.currencyUtilityService = currencyUtilityService;
        this.localeService = localeService;
        this.stringFormatUtilityService = stringFormatUtilityService;
        this.modalService = modalService;
        this.navigationService = navigationService;
        this.quoteService = quoteService;
        this.isDentalEnabled = this.configResource.getProcessedResourceValue('Spa_PlanList_Tab_Show_DENTAL', null, false);
        this.isVisionEnabled = this.configResource.getProcessedResourceValue('Spa_PlanList_Tab_Show_VISION', null, false);
        this.isHospitalIndemnityEnabled = this.configResource.getProcessedResourceValue('Spa_PlanList_Tab_Show_HIP', null, false);
        this.medigapTabEnabled = this.configResource.getProcessedResourceValue('Spa_PlanList_Tab_Show_MEDIGAP', null, false);
        this.preferenceScoreEnabled = this.configResource.getProcessedResourceValue('Spa_Site_Preferences_Score_Enabled', null, false);
        this.providersEnabled = this.configResource.getProcessedResourceValue('Spa_Site_Providers_Enabled', null, false);
        this.includeExtendedProviderData = this.configResource.getProcessedResourceValue('Spa_Site_Provider_ShowAllInNetworkLocations_Enabled', null, true);
        this.isNonCommissionableFlagCheckEnabled = this.configResource.getProcessedResourceValue('Spa_PlanDetails_NonCommissionable_FlagCheck_Enabled', null, false);
        this.planFeesEnabled = this.configResource.getProcessedResourceValue('Spa_Site_PlanFees_Enabled', null, false);
        // Used to activate/deactivate the automatic tab selection based on plan coverage.
        // When enabled, we check if the selected tab has coverage. If so, we will keep it, otherwise we select the default tab based on coverage
        // When disabled, we keep the selected tab by the user (if any), otherwise we select the default tab based on coverage
        // The default tab selection based on coverage is determined as follow:
        // 1. Select the current tab if it has coverage
        // 2. If the current tab has no coverage, select the default tab if it has coverage (configured by "Spa_PlanList_Tab_Default_XXX")
        // 3. If the default tab has no coverage, select the secondary default tab by coverage (configured by "Spa_PlanList_Tab_SecondaryDefault_XXX")
        // 4. If the secondary default has no coverage, select the next tab that has coverage. Otherwise, select the default tab regardless of coverage (configured by "Spa_PlanList_Tab_Default_XXX")
        this.activeTabPlanCountCheckEnabled$ = new BehaviorSubject(true);
    }
    getActiveTabPlanCountCheckEnabled$() {
        return this.activeTabPlanCountCheckEnabled$.asObservable();
    }
    setActiveTabPlanCountCheckEnabled(enabled) {
        this.activeTabPlanCountCheckEnabled$.next(enabled);
    }
    fetchPlanQuestions() {
        const fipsCode = this.store.selectSnapshot(DemographicState.selectedFipsCode);
        const zipCode = this.store.selectSnapshot(DemographicState.selectedZipCode);
        const year = this.planYearResourceService.getSelectedPlanYear();
        const effectiveDate = DateUtilities.getFormattedCurrentDate(); // TODO: get effectiveDate
        this.store.dispatch(new FetchPlanQuestions(zipCode, fipsCode, year, effectiveDate));
    }
    getLoadingMedSupQuestions$() {
        return this.store.select(MedSupState.loading);
    }
    getMedSupQuestions$() {
        return this.store.select(MedSupState.questions);
    }
    getMedSupQuestions() {
        return this.store.selectSnapshot(MedSupState.questions);
    }
    getMedSupQuestion(id) {
        return this.store.selectSnapshot(MedSupState.getQuestionById(id));
    }
    getHasMedSupQuestions$() {
        return this.store.select(MedSupState.hasQuestions);
    }
    getMedSupAnswers$() {
        return this.store.select(MedSupState.answers);
    }
    getMedSupAnswers() {
        return this.store.selectSnapshot(MedSupState.answers);
    }
    getMedicareGroupPlanConfiguration() {
        return this.store.selectSnapshot(PlansState.medicareGroupPlanConfiguration);
    }
    getLoadingAncillaryQuestions$() {
        return this.store.select(PlansState.loadingAncillaryQuestions);
    }
    getAncillaryPlanQuestions$() {
        return this.store.select(PlansState.ancillaryQuestions);
    }
    getAncillaryPlanQuestions() {
        return this.store.selectSnapshot(PlansState.ancillaryQuestions);
    }
    getLoadingHospitalIndemnityQuestions$() {
        return this.store.select(PlansState.loadingHospitalIndemnityQuestions);
    }
    getHasAncillaryPlanQuestions$() {
        return this.store.select(PlansState.hasAncillaryQuestions);
    }
    getHasVisionPlanQuestions$() {
        return this.store.select(PlansState.hasAncillaryQuestions);
    }
    getAncillaryPlanAnswers$() {
        return this.store.select(PlansState.ancillaryAnswers);
    }
    getAncillaryPlanAnswers() {
        return this.store.selectSnapshot(PlansState.ancillaryAnswers);
    }
    getHasMedSupAnswers$() {
        return this.store.select(MedSupState.hasAnswers());
    }
    getHasMedSupAnswers() {
        return this.store.selectSnapshot(MedSupState.hasAnswers());
    }
    getHasAncillaryPlanAnswers$() {
        return this.store.select(PlansState.hasAncillaryAnswers());
    }
    getHasAncillaryPlanAnswers() {
        return this.store.selectSnapshot(PlansState.hasAncillaryAnswers());
    }
    getHospitalIndemnityQuestions$() {
        return this.store.select(PlansState.hospitalIndemnityQuestions);
    }
    getHospitalIndemnityQuestions() {
        return this.store.selectSnapshot(PlansState.hospitalIndemnityQuestions);
    }
    getHospitalIndemnityAnswers$() {
        return this.store.select(PlansState.hospitalIndemnityAnswers);
    }
    getHospitalIndemnityAnswers() {
        return this.store.selectSnapshot(PlansState.hospitalIndemnityAnswers);
    }
    getHasHospitalIndemnityQuestions$() {
        return this.store.select(PlansState.hasHospitalIndemnityQuestions);
    }
    getHasHospitalIndemnityQuestions() {
        return this.store.selectSnapshot(PlansState.hasHospitalIndemnityQuestions);
    }
    getHasHospitalIndemnityAnswers$() {
        return this.store.select(PlansState.hasHospitalIndemnityAnswers());
    }
    getHasHospitalIndemnityAnswers() {
        return this.store.selectSnapshot(PlansState.hasHospitalIndemnityAnswers());
    }
    getAreAllMedSupQuestionsAnswered$() {
        return this.store.select(MedSupState.areAllMedSupQuestionsAnswered);
    }
    getAreAllMedSupQuestionsAnswered() {
        return this.store.selectSnapshot(MedSupState.areAllMedSupQuestionsAnswered);
    }
    getAreAllAncillaryQuestionsAnswered$() {
        return this.store.select(PlansState.areAllAncillaryQuestionsAnswered);
    }
    getAreAllAncillaryQuestionsAnswered() {
        return this.store.selectSnapshot(PlansState.areAllAncillaryQuestionsAnswered);
    }
    getAreAllHospitalIndemnityQuestionsAnswered$() {
        return this.store.select(PlansState.areAllHospitalIndemnityQuestionsAnswered(this.getHospitalIndemnityQuestionMetaData()));
    }
    getAreAllHospitalIndemnityQuestionsAnswered() {
        return this.store.selectSnapshot(PlansState.areAllHospitalIndemnityQuestionsAnswered(this.getHospitalIndemnityQuestionMetaData()));
    }
    // TODO: just use these? Can refactor to have one path through here if we want to
    getPlansStateIsDirty$(planType) {
        return this.store.select(PlansState.dirty(planType));
    }
    getPlansStateIsLoading$(planType) {
        return this.store.select(PlansState.loading(planType));
    }
    getPlansStateIsLoaded$(planType) {
        return this.store.select(PlansState.loaded(planType));
    }
    getPlanCounts$() {
        return this.store.select(PlansState.planCounts());
    }
    getPlanCount$(planType) {
        return this.store.select(PlansState.planCountByType(planType));
    }
    getPlansLength(planType) {
        const plans = this.store.selectSnapshot(PlansState.plansByPlanTypeAbbreviation(planType));
        return plans?.length ?? 0;
    }
    getPlansLength$(planType) {
        return this.store.select(PlansState.plansByPlanTypeAbbreviation(planType)).pipe(map(plans => plans?.length ?? 0));
    }
    arePlanCountsLoaded() {
        return this.store.selectSnapshot(PlansState.arePlanCountsLoaded);
    }
    bestMatchTabTypesLoaded(planTypesLoaded) {
        return ALL_MEDICARE_PLUS_MEDIGAP_PLAN_TYPE_VALUES.every(bestMatchPlanType => planTypesLoaded.includes(bestMatchPlanType));
    }
    bestMatchTabTypesDirty(planTypesDirty) {
        return ALL_MEDICARE_PLUS_MEDIGAP_PLAN_TYPE_VALUES.every(bestMatchPlanType => planTypesDirty.includes(bestMatchPlanType));
    }
    getLoadedPlanTypes$() {
        return this.store.select(PlansState.planTypesLoaded());
    }
    getDirtyPlanTypes$() {
        return this.store.select(PlansState.planTypesDirty());
    }
    getPlansStateIsLoaded(planType) {
        return this.store.selectSnapshot(PlansState.loaded(planType));
    }
    getPlansMapByIds$(planIds) {
        return this.store.select(PlansState.getPlansMapByIds(planIds));
    }
    getPlansByIds(planIds) {
        return this.store.selectSnapshot(PlansState.plansByIds(planIds));
    }
    getPlan(id) {
        return this.store.selectSnapshot(PlansState.plan(id));
    }
    getRateFactorPlan() {
        return this.store.selectSnapshot(PlansState.activeRateFactorPlan);
    }
    getPlansRiderBenefitCategories() {
        return this.store.selectSnapshot(PlansState.plansRiderBenefitCategories);
    }
    getSelectedPlansRiderBenefitCategoryIds() {
        return this.store.selectSnapshot(PlansState.selectedPlansRiderBenefitCategoryIds);
    }
    getArePlansDirty(planType) {
        return this.store.selectSnapshot(PlansState.dirty(planType));
    }
    getArePlanTypesDirty$(planTypes) {
        return this.store.select(PlansState.arePlanTypesDirty(planTypes));
    }
    getArePlanTypesDirty(planTypes) {
        return this.store.selectSnapshot(PlansState.arePlanTypesDirty(planTypes));
    }
    getCurrentPlanShort$() {
        return this.store.select(PlansState.currentPlanShort);
    }
    getCurrentPlanShort() {
        return this.store.selectSnapshot(PlansState.currentPlanShort);
    }
    getCurrentPlans$() {
        return this.store.select(PlansState.currentPlans);
    }
    getCurrentPlans() {
        return this.store.selectSnapshot(PlansState.currentPlans);
    }
    getCurrentPlansFilteredByActiveTab$() {
        return this.store.select(PlansState.currentPlansFilteredByActiveTab);
    }
    getCurrentPlansFilteredByActiveTab() {
        return this.store.selectSnapshot(PlansState.currentPlansFilteredByActiveTab);
    }
    getIsDentalEnabled() {
        return this.isDentalEnabled;
    }
    getIsVisionEnabled() {
        return this.isVisionEnabled;
    }
    getIsHospitalIndemnityEnabled() {
        return this.isHospitalIndemnityEnabled;
    }
    getIsPlanFeesEnabled() {
        return this.planFeesEnabled;
    }
    getActivePlanTypeAbbreviation(activeTabType, tabs) {
        if (activeTabType) {
            return activeTabType;
        }
        const defaultActiveTab = tabs.find(tab => tab.defaultActive);
        return defaultActiveTab ? defaultActiveTab?.tabTypes?.[0] : undefined;
    }
    getActivePlanType(activeTabType, tabs) {
        const activeTabAbbreviation = this.getActivePlanTypeAbbreviation(activeTabType, tabs);
        return this.getPlanType(activeTabAbbreviation);
    }
    getSearchPlanTypes(planType, tabChanged = false) {
        if (this.preferenceScoreEnabled &&
            this.medigapTabEnabled &&
            !tabChanged &&
            (PlansUtilityService.isSingleMedicareType(planType) ||
                PlansUtilityService.isAllMedicareType(planType) ||
                planType === PlanType.MEDIGAP)) {
            return ALL_MEDICARE_PLUS_MEDIGAP_PLAN_TYPE_VALUES;
        }
        return [planType];
    }
    showAllMedigapEnabled() {
        return this.configResource.getProcessedResourceValue('Spa_PlanList_ShowAllMedigap_Enabled', null, false);
    }
    isMedigapEnabled() {
        return this.medigapTabEnabled;
    }
    getHospitalIndemnityQuestionMetaData(widgetName) {
        return this.configResource.getProcessedResourceValue('Spa_PlanList_HospitalIndemnityQuestion_Data', widgetName, [
            { key: MedSupQuestionNames.DateOfBirth, defaultValue: '', ordinal: 1, required: true },
            { key: MedSupQuestionNames.EffectiveDate, defaultValue: '', ordinal: 2, required: true },
            { key: MedSupQuestionNames.Gender, defaultValue: '', ordinal: 3, required: true },
            { key: MedSupQuestionNames.Tobacco, defaultValue: '', ordinal: 4, required: true },
            { key: MedSupQuestionNames.Household, defaultValue: '', ordinal: 5, required: true },
            { key: MedSupQuestionNames.HCDaysCovered, defaultValue: '', ordinal: 6, required: true },
            { key: MedSupQuestionNames.BenefitAmount, defaultValue: '', ordinal: 7, required: true }
        ]);
    }
    getArePlansLoading(planType) {
        return this.store.selectSnapshot(PlansState.loading(planType));
    }
    getArePlanTypesLoading$(planTypes) {
        return this.store.select(PlansState.planTypesLoading(planTypes));
    }
    getArePlanTypesLoading(planTypes) {
        return this.store.selectSnapshot(PlansState.planTypesLoading(planTypes));
    }
    getArePlansLoaded(planType) {
        return this.store.selectSnapshot(PlansState.loaded(planType));
    }
    getArePlanTypesLoaded$(planTypes) {
        return this.store.select(PlansState.arePlanTypesLoaded(planTypes));
    }
    getArePlanTypesLoaded(planTypes) {
        return this.store.selectSnapshot(PlansState.arePlanTypesLoaded(planTypes));
    }
    getAreShortPlansLoading$() {
        return this.store.select(PlansState.planShortLoading);
    }
    getPUFPlanSetting() {
        return this.store.selectSnapshot(PlansState.includePUFPlans);
    }
    getPreferences() {
        return this.preferences;
    }
    getPlanType(planTypeAbbreviation) {
        const planType = PlansUtilityService.convertToPlanType(planTypeAbbreviation);
        return planType || this.getPlansSearchPlanType();
    }
    getPlansSearchPlanTypes(planType) {
        if (planType) {
            if (PlansUtilityService.isMedicarePlanType(planType)) {
                return [
                    MEDICARE_PLAN_TYPE_VALUES.reduce((aggregateMedicarePlanType, medicarePlanTypeValue) => aggregateMedicarePlanType + medicarePlanTypeValue, 0)
                ].map(planTypeValue => planTypeValue);
            }
            switch (planType) {
                case PlanTypeAbbreviation.MEDIGAP:
                    return [PlanType.MEDIGAP];
                case PlanTypeAbbreviation.DENTAL:
                    return [PlanType.DENTAL];
                case PlanTypeAbbreviation.VISION:
                    return [PlanType.VISION];
                case PlanTypeAbbreviation.HC:
                    return [PlanType.HC];
                default:
                    return this.getAllPlansSearchPlanTypes();
            }
        }
        return this.getAllPlansSearchPlanTypes();
    }
    getAllPlansSearchPlanTypes() {
        const planTypes = [];
        const medicarePlanType = PlanType.MA + PlanType.MAPD + PlanType.PDP;
        planTypes.push(medicarePlanType);
        if (this.includeMedSupInPlansCall()) {
            planTypes.push(PlanType.MEDIGAP);
        }
        if (this.isDentalEnabled) {
            planTypes.push(PlanType.DENTAL);
        }
        if (this.isVisionEnabled) {
            planTypes.push(PlanType.VISION);
        }
        if (this.isHospitalIndemnityEnabled) {
            planTypes.push(PlanType.HC);
        }
        return planTypes;
    }
    getPlansSearchPlanType() {
        let planType = PlanType.MA + PlanType.MAPD + PlanType.PDP;
        if (this.includeMedSupInPlansCall()) {
            planType += PlanType.MEDIGAP;
        }
        if (this.isDentalEnabled) {
            planType += PlanType.DENTAL;
        }
        if (this.isVisionEnabled) {
            planType += PlanType.VISION;
        }
        if (this.isHospitalIndemnityEnabled) {
            planType += PlanType.HC;
        }
        return planType;
    }
    hasMedSupPlans() {
        const areMedSupPlansLoaded = this.store.selectSnapshot(PlansState.loaded(PlanType.MEDIGAP));
        return areMedSupPlansLoaded
            ? this.store.selectSnapshot(PlansState.hasPlanType(PlanTypeAbbreviation.MEDIGAP))
            : !!this.getPlanCount(PlanType.MEDIGAP);
    }
    hasPDPPlans() {
        const areMedicarePlansLoaded = this.store.selectSnapshot(PlansState.loaded(ALL_MEDICARE_PLAN_TYPE_VALUE));
        return areMedicarePlansLoaded
            ? this.store.selectSnapshot(PlansState.hasPlanType(PlanTypeAbbreviation.PDP))
            : !!this.getPlanCount(PlanType.PDP);
    }
    // returns the plan count from the plan short api
    getPlanCount(planType) {
        return this.store.selectSnapshot(PlansState.planCountByType(planType));
    }
    setPlansDirty(dirty, planTypes) {
        this.store.dispatch(new SetPlansDirty(dirty, planTypes));
    }
    setAllPlansDirty(dirty) {
        const allPlanTypes = this.store.selectSnapshot(PlansState.storePlanTypes);
        this.setPlansDirty(dirty, allPlanTypes);
    }
    setRateFactorPlan(plan) {
        if (plan) {
            this.store.dispatch(new SetActiveRateFactorPlanId(plan.id));
        }
    }
    removeRateFactorPlan() {
        this.store.dispatch(new RemoveActiveRateFactorPlanId());
    }
    isAncillaryQuestion(questionId) {
        return this.store.selectSnapshot(PlansState.isAncillaryQuestion(questionId));
    }
    isHospitalIndemnityQuestion(questionId) {
        return this.store.selectSnapshot(PlansState.isHospitalIndemnityQuestion(questionId));
    }
    isMedSupQuestion(questionId) {
        return this.store.selectSnapshot(MedSupState.isMedSupQuestion(questionId));
    }
    setCurrentPlanShort(currentPlanShort, currentPlanInfo = false) {
        this.store.dispatch(new SetCurrentPlanShort(currentPlanShort));
        if (currentPlanInfo) {
            this.getCurrentPlanInfo(currentPlanShort);
        }
    }
    getPlanTypesUpdated(questions) {
        const currentAnswers = this.getMedSupAnswers();
        const questionIdsUpdated = questions?.reduce((updatedQuestions, question) => {
            const currentAnswer = currentAnswers[question.name];
            if (currentAnswer === undefined || currentAnswer !== question.value) {
                updatedQuestions.push(question.questionId);
            }
            return updatedQuestions;
        }, []) ?? [];
        const hasAncillaryUpdates = questionIdsUpdated.some(questionId => this.isAncillaryQuestion(questionId));
        const hasHospitalIndemnityUpdates = questionIdsUpdated.some(questionId => this.isHospitalIndemnityQuestion(questionId));
        const hasMedSupUpdates = questionIdsUpdated.some(questionId => this.isMedSupQuestion(questionId));
        return [
            ...(hasAncillaryUpdates ? [PlanType.DENTAL, PlanType.VISION] : []),
            ...(hasHospitalIndemnityUpdates ? [PlanType.HC] : []),
            ...(hasMedSupUpdates ? [PlanType.MEDIGAP] : [])
        ];
    }
    async selectPlanQuestions(sessionId, year, questions, productType) {
        const effectiveDateQuestion = questions.find(question => question.questionId === MedSupPlanQuestionIds.EffectiveDate);
        let effectiveDate = DateUtilities.getFormattedCurrentDate();
        if (effectiveDateQuestion?.value) {
            effectiveDate = `${effectiveDateQuestion.value}`;
        }
        const planTypesUpdated = this.getPlanTypesUpdated(questions);
        await this.store
            .dispatch([
            new SetPlansDirty(true, planTypesUpdated),
            new SelectPlanQuestions(sessionId, year, effectiveDate, productType, questions)
        ])
            .toPromise();
    }
    getProductTypeFromPlanTypeAbbreviation(planTypeAbbreviation) {
        const productTypesByPlanTypeAbbr = {
            [PlanTypeAbbreviation.DENTAL]: ProductType.DENTAL,
            [PlanTypeAbbreviation.VISION]: ProductType.VISION,
            [PlanTypeAbbreviation.HC]: ProductType.HC,
            default: ProductType.DENTAL
        };
        return productTypesByPlanTypeAbbr[planTypeAbbreviation] ?? productTypesByPlanTypeAbbr.default;
    }
    validPlansCallData(demographicsOptions, searchOptions) {
        const demographicOptionsWithDefaults = this.createPlansDemographicsOptionsWithDefaults(demographicsOptions);
        const searchOptionsWithDefaults = this.createPlansSearchOptionsWithDefaults(searchOptions);
        // TODO: Continue adding validation and getting data from correct locations
        // as we figure out where/how to handle year/effective date/plan type
        return (demographicOptionsWithDefaults.zip &&
            demographicOptionsWithDefaults.fips &&
            !!searchOptionsWithDefaults.year &&
            !!searchOptionsWithDefaults.effectiveDate &&
            !!searchOptionsWithDefaults.cultureCode &&
            !!searchOptionsWithDefaults.planType);
    }
    getMergedMedigapAnswers(rateFactorAnswersOptions = {}) {
        const { medSupAnswers, ancillaryAnswers, hospitalIndemnityAnswers } = rateFactorAnswersOptions;
        return MedSupUtilitiesService.mergeMedigapAnswers(ancillaryAnswers ?? this.getAncillaryPlanAnswers(), hospitalIndemnityAnswers ?? this.getHospitalIndemnityAnswers(), medSupAnswers ?? this.getMedSupAnswers());
    }
    fetchPlansDetails$(planIds, planType, demographicsOptions, searchOptions, medicineCabinet, medSupAnswers, currentYearPlanId, hideLoading, getExternallyRatedPlanData = true) {
        const demographicOptionsWithDefaults = this.createPlansDemographicsOptionsWithDefaults(demographicsOptions);
        const searchOptionsWithDefaults = this.createPlansSearchOptionsWithDefaults({
            ...searchOptions,
            planType
        });
        const cabinet = medicineCabinet ?? this.getMedicineCabinet();
        const drugs = this.drugsService.mapCabinetToDosage({ cabinet });
        const pharmacies = this.getSelectedAPIPharmacyInfo();
        const sendPreferencesFlag = this.setSendPreferencesFlag(pharmacies, cabinet, this.preferenceScoreEnabled);
        const providers = this.providerService.getNpiAndAddressOfSelectedProviders();
        const agentGuid = this.store.selectSnapshot(AgentState.agentGuid);
        const externallyRatedDataFetchType = getExternallyRatedPlanData
            ? ExternallyRatedDataFetchType.SEQUENTIAL // Plan Details can come back with additional riders that will need rating
            : ExternallyRatedDataFetchType.SKIP;
        let memberCurrentYearPlanId = '';
        if (this.siteService.isRetentionView()) {
            memberCurrentYearPlanId = currentYearPlanId ?? this.getCurrentYearPlanId();
        }
        return this.fetchPlansByOptions$({
            demographicsOptions: demographicOptionsWithDefaults,
            searchOptions: searchOptionsWithDefaults,
            medigapAnswers: this.getMergedMedigapAnswers({ medSupAnswers }),
            drugs,
            pharmacies,
            currentYearPlanId: memberCurrentYearPlanId,
            ids: planIds,
            providers,
            hideLoading,
            agentGuid,
            ...(sendPreferencesFlag && { preferences: this.preferences }),
            externallyRatedDataFetchType
        }).pipe(
        // This switch map handles ERS in the case of it being done sequentially, which Plan Details now requires.
        // The details call can come back with new riders needing rating, when the original plan is already rated
        switchMap((detailedPlans) => {
            const idsForExternalRating = this.getIdsForExternallyRatedData(detailedPlans, true);
            // this call returns an empty array if there are no ids, and the following update returns the plan if there is no data
            // so there is no need for extra checks at this level
            return this.getExternallyRatedPlanData$(idsForExternalRating).pipe(map((externalRatingData) => {
                const showPremiumAsAnnual = this.configResource.getProcessedResourceValue('Spa_Site_ShowPremiumAsAnnual', null, false);
                return (detailedPlans?.map((detailedPlan) => this.updatePlanWithExternallyRatedPlanData(externalRatingData, detailedPlan, showPremiumAsAnnual)) ?? []);
            }));
        }));
    }
    async fetchPlanDetails(plan, demographicsOptions, searchOptions, medicineCabinet, medSupAnswers, currentYearPlanId, hideLoading, getExternallyRatedPlanData) {
        const planIds = [plan.id];
        const planType = `${plan.planType}`;
        const planSearchOptions = this.getUpdatedSearchOptionsIfCurrentPlanShortRequest(plan, searchOptions);
        return await this.fetchPlansDetails$(planIds, planType, demographicsOptions, planSearchOptions, medicineCabinet, medSupAnswers, currentYearPlanId, hideLoading, getExternallyRatedPlanData)
            .toPromise()
            .then(detailedPlans => detailedPlans?.[0]);
    }
    fetchPlansDetailsWithFees$(fetchPlans$, planIds, defaultPlanIdsForExternalRating) {
        const planIdsForExternalRating = defaultPlanIdsForExternalRating ?? this.getIdsForExternallyRatedDataById(planIds, true);
        if (planIdsForExternalRating.length > 0) {
            const planIdsForFeeRetrieval = planIds.filter(planId => !planIdsForExternalRating.includes(planId));
            // Fetch selected plans and retrieve their fees in parallel (non-externally rated plans only)
            if (planIdsForFeeRetrieval.length > 0) {
                return forkJoin([fetchPlans$, this.getPlansFees$(planIdsForFeeRetrieval)]).pipe(map(([plans, plansFeesData]) => this.updatePlansWithPlansFeesData(plans, plansFeesData)));
            }
            // Fetch selected plans without retrieving their fees when they are all externally rated plans
            // Their fees will be retrieved along with their external rating data at a later step
            return fetchPlans$;
        }
        // Fetch selected plans and retrieve their fees in parallel
        return forkJoin([fetchPlans$, this.getPlansFees$(planIds)]).pipe(map(([plans, plansFeesData]) => this.updatePlansWithPlansFeesData(plans, plansFeesData)));
    }
    setSendPreferencesFlag(pharmacies, medicineCabinet, preferenceScoreEnabled) {
        let sendFlag = false;
        if (preferenceScoreEnabled) {
            if (pharmacies?.length) {
                sendFlag = true;
            }
            if (!sendFlag) {
                // performance: fetch the providers info from the store
                const hasProviders = this.providerService.hasProviders();
                const hasSelectedProviders = this.providerService.hasSelectedProviders();
                if (hasProviders || hasSelectedProviders) {
                    sendFlag = true;
                }
            }
            if (!sendFlag) {
                const hasDrugs = medicineCabinet && Object.keys(medicineCabinet).length > 0;
                if (preferenceScoreEnabled && hasDrugs) {
                    sendFlag = true;
                }
            }
            this.preferences = this.preferencesService.getPreferenceWeights();
            const preferenceQuestionsAndAnswers = this.preferencesService.getPreferenceQuestionAnswers();
            if (preferenceQuestionsAndAnswers && preferenceQuestionsAndAnswers.length > 0) {
                this.preferences.forEach(preference => {
                    const preferenceQA = preferenceQuestionsAndAnswers.find(answer => answer.key === preference.key);
                    if (preferenceQA) {
                        preference.values = preferenceQA.values;
                        if (!sendFlag && preferenceQA.values.length > 0) {
                            sendFlag = true;
                        }
                    }
                });
            }
            else {
                this.preferences.forEach(preference => {
                    if (preference.key === PreferenceType.BENEFITS ||
                        preference.key === PreferenceType.CHRONIC ||
                        preference.key === PreferenceType.MEDSUP) {
                        preference.values = [];
                    }
                });
            }
        }
        return sendFlag;
    }
    async fetchAndUpdatePlansDetails(planIds, planType, demographicsOptions, searchOptions, medicineCabinet, medSupAnswers, currentYearPlanId, hideLoading, getExternallyRatedPlanData) {
        return await this.fetchPlansDetails$(planIds, planType, demographicsOptions, searchOptions, medicineCabinet, medSupAnswers, currentYearPlanId, hideLoading, getExternallyRatedPlanData)
            .pipe(switchMap((detailedPlans) => {
            const planUpdates = detailedPlans?.map(detailedPlan => this.store.dispatch([new SelectPlanDetails(detailedPlan), new UpdatePlan(detailedPlan)])) ??
                [];
            return forkJoin(planUpdates).pipe(map(() => detailedPlans));
        }))
            .toPromise();
    }
    async fetchAndUpdatePlanDetails(plan, demographicsOptions, searchOptions, medicineCabinet, medSupAnswers, currentYearPlanId, hideLoading, getExternallyRatedPlanData) {
        const planWithDetails = await this.fetchPlanDetails(plan, demographicsOptions, searchOptions, medicineCabinet, medSupAnswers, currentYearPlanId, hideLoading, getExternallyRatedPlanData);
        if (planWithDetails) {
            this.store.dispatch(new SelectPlanDetails(planWithDetails));
            this.store.dispatch(new UpdatePlan(planWithDetails));
            return planWithDetails;
        }
    }
    riderRatesDiffer(currentPlan, detailedPlan) {
        if (currentPlan.planTypeAbbreviation === PlanTypeAbbreviation.HC) {
            // HIP can have vastly different riders between a normal and detailed plan call. We cannot account for that here.
            return false;
        }
        // check if both have riders
        const plan1Riders = currentPlan.riders;
        const plan2Riders = detailedPlan.riders;
        if ((plan1Riders && !plan2Riders) || (!plan1Riders && plan2Riders)) {
            return true;
        }
        // check if the number of riders differ
        if (plan1Riders.length !== plan2Riders.length) {
            return true;
        }
        const sortedPlan1Riders = _sortBy(plan1Riders, 'planID');
        const sortedPlan2Riders = _sortBy(plan2Riders, 'planID');
        for (let i = 0; i < sortedPlan1Riders.length; i++) {
            const rider1 = sortedPlan1Riders[i];
            const rider2 = sortedPlan2Riders[i];
            // if the list differs in the riders it returns or regarding an individual premium then we
            // consider the set of rider rates to have changed
            if (rider1.planID !== rider2.planID || rider1.medicalPremium !== rider2.medicalPremium) {
                return true;
            }
        }
        return false;
    }
    getCurrentYearPlanId() {
        return this.store.selectSnapshot(MemberState.currentYearPlanId) || '';
    }
    async validatePlans(plansToValidate, fips, zip, year, cultureCode, medigapAnswers, ignorePremiumCheck = false
    // ignorePremiumCheck is for when we purposely know premium between cart and plan list are different
    // (ex: Milliman changed cart premium due to pre-existing health conditions)
    ) {
        try {
            // TODO: SPA-10380 was caused by a missing pharmacies entry here, after there were some updates to the plans call (~early Feb 2022)
            // So we need to figure out if there are any other issues that this validate call can create now.
            const fetchedPlans = await this.fetchPlansByOptions({
                ids: plansToValidate.map(plan => plan.id),
                demographicsOptions: { zip, fips },
                searchOptions: { year, cultureCode },
                medigapAnswers,
                pharmacies: this.getSelectedAPIPharmacyInfo(),
                externallyRatedDataFetchType: ExternallyRatedDataFetchType.PARALLEL
            });
            const invalidPlans = [];
            plansToValidate.forEach(planToValidate => {
                const matchingPlan = fetchedPlans.find(fetchedPlan => fetchedPlan.id === planToValidate.id);
                if (!matchingPlan) {
                    invalidPlans.push({ plan: planToValidate, message: PlanErrorMessage.NOT_AVAILABLE });
                }
                else {
                    if (!ignorePremiumCheck &&
                        (matchingPlan.drugPremium !== planToValidate.drugPremium ||
                            matchingPlan.medicalPremium !== planToValidate.medicalPremium ||
                            matchingPlan.medicalDeductible !== planToValidate.medicalDeductible ||
                            matchingPlan.annualPlanPremium !== planToValidate.annualPlanPremium ||
                            this.riderRatesDiffer(planToValidate, matchingPlan))) {
                        invalidPlans.push({ plan: planToValidate, message: PlanErrorMessage.RATES_CHANGED });
                    }
                }
            });
            return { isValid: invalidPlans.length === 0, invalidPlans };
        }
        catch (error) {
            return { isValid: false, invalidPlans: plansToValidate.map(plan => ({ plan, message: error })) };
        }
    }
    async fetchPlansByOptions(planFetchOptions) {
        return await this.fetchPlansByOptions$(planFetchOptions).toPromise();
    }
    /**
     * fetches plans with the given parameters, but does not update the store with the result
     */
    fetchPlansByOptions$(planFetchOptions) {
        const isPlanFeesEnabled = this.getIsPlanFeesEnabled();
        const medicarePlanTypeValues = [...MEDICARE_PLAN_TYPE_VALUES, ALL_MEDICARE_PLAN_TYPE_VALUE];
        const shouldFetchPlansWithFees = isPlanFeesEnabled && !medicarePlanTypeValues.includes(+planFetchOptions.searchOptions?.planType);
        const agentASPSetting = this.store.selectSnapshot(AgentState.aspRequired);
        if (planFetchOptions.externallyRatedDataFetchType !== ExternallyRatedDataFetchType.PARALLEL) {
            return this.finalizeFetchPlans$(planFetchOptions, agentASPSetting, shouldFetchPlansWithFees);
            // If ExternallyRatedDataFetchType === SEQUENTIAL, we'll handle it at a later step
        }
        const idsForExternalRating = this.getIdsForExternallyRatedDataById(planFetchOptions.ids, true);
        return forkJoin([
            this.finalizeFetchPlans$(planFetchOptions, agentASPSetting, shouldFetchPlansWithFees, idsForExternalRating),
            this.getExternallyRatedPlanData$(idsForExternalRating, planFetchOptions.shortDataOnly)
        ]).pipe(map(([plans, externalRatingData]) => {
            const showPremiumAsAnnual = this.configResource.getProcessedResourceValue('Spa_Site_ShowPremiumAsAnnual', null, false);
            return plans.map(plan => this.updatePlanWithExternallyRatedPlanData(externalRatingData, plan, showPremiumAsAnnual));
        }));
    }
    // TODO: considerations here include that we need to ignore HIP possibly
    // Also anything that includes all plans we may need to make sure no plans are loading
    // Definitely going to need an allPlansLoaded/allBestMatchPlans method?
    // removing best plan id/active tab logic
    /**
     * fetches plans with the given parameters, then returns them after updating the store with the result
     */
    async fetchPlansByOptionsAndSave(planFetchOptions) {
        this.setPlansLoading(this.getAllPlansSearchPlanTypes(), true);
        const fetchedPlans = this.fetchPlansByOptions(planFetchOptions);
        if (!planFetchOptions.shortDataOnly) {
            return await fetchedPlans.then(plans => {
                const searchOptionsWithDefaults = this.createPlansSearchOptionsWithDefaults(planFetchOptions.searchOptions);
                const planTypes = this.getPlanTypesArray(searchOptionsWithDefaults?.planType);
                let extendedPlans = plans;
                if (this.isHospitalIndemnityEnabled) {
                    extendedPlans = extendedPlans.map((plan) => plan.planTypeAbbreviation === PlanTypeAbbreviation.HC ? this.extendHospitalIndemnityPlanWithNumberOfDaysCovered(plan) : plan);
                }
                this.store.dispatch(new UpdatePlans(extendedPlans, planTypes));
                this.setPlansLoading(this.getAllPlansSearchPlanTypes(), false);
                if (planFetchOptions.externallyRatedDataFetchType === ExternallyRatedDataFetchType.SEQUENTIAL) {
                    this.updatePlansWithExternallyRatedPlanData(extendedPlans, planTypes);
                }
                return extendedPlans;
            });
        }
        this.setPlansLoading(this.getAllPlansSearchPlanTypes(), false);
        return await EMPTY.toPromise();
    }
    async trackPlanListInfo(plans, filters, sortSelection, userActionType, coverageTypeAbbreviation) {
        this.updatePlanQueuePositionInStore(plans);
        if (this.isPlanListInfoTrackingEnabled()) {
            const planTypeAbbreviation = this.store.selectSnapshot(PlansState.activeTabType);
            const planType = PlansUtilityService.convertToPlanType(planTypeAbbreviation);
            const planTypeLoaded = this.store.selectSnapshot(PlansState.loaded(planType));
            const planCount = planTypeLoaded ? plans?.length ?? 0 : this.store.selectSnapshot(PlansState.planCountByType(planType));
            const session = this.store.selectSnapshot(MemberState.session);
            const topTenPlanIds = planCount > 0
                ? plans
                    .slice(0, 10)
                    .map(plan => plan.id)
                    .join(',')
                : '';
            const agentGuid = this.store.selectSnapshot(AgentState.agentGuid);
            return await this.plansHttpService.trackPlanListInfo(session ? session.sessionId : null, this.store.selectSnapshot(MemberState.memberID), this.siteService.getSiteId(), agentGuid ?? '', this.store.selectSnapshot(DemographicState.selectedZipCode), this.store.selectSnapshot(DemographicState.selectedFipsCode), planTypeAbbreviation, planCount, topTenPlanIds, filters, sortSelection, userActionType, this.getBestMatchPlanIdForAnalytics(coverageTypeAbbreviation), this.getBestMatchCoverageForAnalytics(coverageTypeAbbreviation));
        }
    }
    getPlanData$(planId, planDataKey, cultureCode) {
        return this.plansHttpService.getPlanData$(planId, planDataKey, cultureCode);
    }
    getBestMatchPlanIdForAnalytics(coverageTypeAbbreviation) {
        if (this.hasBestMatchPlanEnabled()) {
            return this.store.selectSnapshot(PlansState.bestMatchPlanId(coverageTypeAbbreviation)) ?? GOOGLE_ANALYTICS_NONE;
        }
        return GOOGLE_ANALYTICS_NOT_APPLICABLE;
    }
    getBestMatchCoverageForAnalytics(coverageTypeAbbreviation) {
        if (this.hasBestCoverageTypeEnabled()) {
            return this.store.selectSnapshot(PlansState.bestCoverageTabAbbreviation(coverageTypeAbbreviation)) ?? GOOGLE_ANALYTICS_NONE;
        }
        return GOOGLE_ANALYTICS_NOT_APPLICABLE;
    }
    hasBestMatchPlanEnabled() {
        return this.configResource.getProcessedResourceValue('Spa_PlanList_BestMatchPlan_Enabled', null, false);
    }
    hasBestCoverageTypeEnabled() {
        return this.configResource.getProcessedResourceValue('Spa_PlanList_BestCoverageType_Enabled', null, false);
    }
    updatePlanQueuePositionInStore(plans) {
        const planQueuePosition = plans
            ? plans.map((plan, index) => ({ id: plan.id, queuePosition: index + 1 }))
            : [];
        this.store.dispatch(new UpdatePlansQueuePosition(planQueuePosition));
    }
    /**
     * creates a new demographics object for the plans API call with default values for any fields not provided, allowing you to override
     * everything or nothing, depending on what is needed at the time
     */
    createPlansDemographicsOptionsWithDefaults(demographicsOptions) {
        const defaults = {
            zip: this.store.selectSnapshot(DemographicState.selectedZipCode),
            fips: this.store.selectSnapshot(DemographicState.selectedFipsCode),
            subsidySelected: this.store.selectSnapshot(DemographicState.subsidySelected),
            subsidyPercent: this.store.selectSnapshot(DemographicState.subsidyPercent),
            ageRange: this.store.selectSnapshot(DemographicState.ageRange),
            healthStatus: this.store.selectSnapshot(DemographicState.healthStatus),
            estimateHealthCost: this.store.selectSnapshot(DemographicState.healthCostEstimate)
        };
        if (demographicsOptions) {
            Object.keys(demographicsOptions).forEach(key => {
                const demographicsItem = demographicsOptions[key];
                if (demographicsItem !== null && demographicsItem !== undefined) {
                    defaults[key] = demographicsItem;
                }
            });
        }
        return defaults;
    }
    includeMedSupInPlansCall() {
        if (this.medigapTabEnabled) {
            const showAllMedigapPlans = this.showAllMedigapEnabled();
            return showAllMedigapPlans ? this.getHasMedSupAnswers() : true;
        }
        return false;
    }
    /**
     * creates a new search object for the plans API call with default values for any fields not provided, allowing you to override
     * everything or nothing, depending on what is needed at the time
     */
    createPlansSearchOptionsWithDefaults(searchOptions) {
        const isPPCSite = this.siteService.isPPCSite();
        const showAllMedigapPlans = this.showAllMedigapEnabled();
        const includePUFPlans = this.getPUFPlanSetting();
        const includeNonLicensedPlans = isPPCSite && this.getIncludeNonLicensedPlanSetting();
        const effectiveDate = this.dateService.getPlanEffectiveDate();
        const planSubType = this.store.selectSnapshot(PlansState.selectedPlanSubType);
        const showDrugAlternatives = this.configResource.getProcessedResourceValue('Spa_Site_ShowDrugAlternatives_Enabled', null, false);
        const includeMCCCustomization = this.configResource.getProcessedResourceValue('Spa_Site_HealthCosts_Customization_Enabled', null, false);
        const defaults = {
            planType: this.getPlansSearchPlanType().toString(),
            year: this.planYearResourceService.getSelectedPlanYear(),
            effectiveDate,
            cultureCode: this.localeService.getCurrentLocale(),
            includePUFPlans,
            includeNonLicensedPlans,
            showAllMedigapPlans,
            planSubType,
            checkAlternatives: showDrugAlternatives,
            includeMCCCustomization
        };
        if (searchOptions) {
            Object.keys(searchOptions).forEach(key => {
                const searchItem = searchOptions[key];
                if (searchItem !== null && searchItem !== undefined) {
                    defaults[key] = searchItem;
                }
            });
        }
        return defaults;
    }
    getIncludeNonLicensedPlanSetting(widgetName) {
        const resource = this.configResource.getProcessedResourceValue('Spa_PlanList_Include_NonLicensed_Plans', widgetName, false);
        const store = this.store.selectSnapshot(PlansState.includeNonLicensedPlans);
        return store || resource;
    }
    updatePUFPlanSetting(includePUFPlans) {
        this.store.dispatch(new UpdatePUFPlanSetting(includePUFPlans));
    }
    updateNonLicensedPlanSetting(includeNonLicensedPlans) {
        this.store.dispatch(new UpdateNonLicensedPlanSetting(includeNonLicensedPlans));
    }
    setOverrideActiveTab(overrideActiveTab) {
        this.store.dispatch(new SetOverrideActiveTab(overrideActiveTab));
    }
    setIsSelectedEffectiveDate(isSelectedEffectiveDate) {
        this.store.dispatch(new SetIsSelectedEffectiveDate(isSelectedEffectiveDate));
    }
    calculateTotalMonthlyPremium(plans, riders = [], medSupPaymentMethod) {
        let totalPremium = 0;
        if (plans?.length) {
            totalPremium = plans.reduce((total, plan) => total + ((plan.planType !== PlanType.MEDIGAP ? plan.drugPremium || 0 : 0) + (plan.medicalPremium || 0)), 0);
            plans.forEach(plan => {
                if (plan.riders?.length) {
                    if (plan.planType === PlanType.HC) {
                        let selectedBenefits = riders;
                        if (!selectedBenefits?.length) {
                            const selectedHIPBenefits = this.getPlansRiderBenefitCategories();
                            const selectedBenefitIds = selectedHIPBenefits[plan?.id]?.map((benefit) => benefit.selectedRiderId);
                            if (selectedBenefitIds?.length) {
                                selectedBenefits = plan?.riders?.filter((rider) => selectedBenefitIds.includes(rider.planID));
                            }
                        }
                        if (selectedBenefits?.length) {
                            selectedBenefits?.forEach(selectedBenefit => (totalPremium += this.ridersService.getRiderMedicalPremium(selectedBenefit)));
                        }
                        else {
                            totalPremium += this.getRidersMedicalPremium(riders);
                        }
                    }
                    else {
                        totalPremium += this.getRidersMedicalPremium(riders);
                    }
                }
                if (plan.planType === PlanType.MEDIGAP && this.hasPaymentMethodRateFactors(plan.rateFactors)) {
                    switch (medSupPaymentMethod) {
                        case MedSupPaymentMethod.BI_MONTHLY:
                            totalPremium /= 2;
                            break;
                        case MedSupPaymentMethod.QUARTERLY:
                            totalPremium /= 3;
                            break;
                        case MedSupPaymentMethod.SEMI_ANNUALLY:
                            totalPremium /= 6;
                            break;
                        case MedSupPaymentMethod.ANNUALLY:
                        case MedSupPaymentMethod.LUMP_SUM:
                            totalPremium /= 12;
                            break;
                        default:
                            break;
                    }
                }
            });
        }
        return totalPremium;
    }
    hasPaymentMethodRateFactors(rateFactors) {
        return rateFactors?.length && rateFactors.includes(PAYMENT_METHOD_RATE_FACTOR_IDENTIFIER);
    }
    getTotalPremium(plans, riders, showPremiumAsAnnual) {
        let totalPremium = 0;
        if (showPremiumAsAnnual) {
            totalPremium = plans.reduce((total, plan) => total + plan.annualPlanPremium, 0);
        }
        else {
            totalPremium = this.calculateTotalMonthlyPremium(plans, riders, this.getMedSupPaymentMethod());
        }
        return totalPremium;
    }
    getMedSupPaymentMethod() {
        let medSupPaymentMethod;
        const answers = this.getMedSupAnswers();
        if (answers?.PaymentMethod) {
            medSupPaymentMethod = answers.PaymentMethod.toLowerCase();
        }
        return medSupPaymentMethod;
    }
    getDrugAlternatives$(planId, dosageId, conditionId, cabinet, demographicsOptions) {
        return this.fetchDrugAlternatives$(planId, dosageId, conditionId, cabinet, demographicsOptions);
    }
    getSelectedAPIPharmacyInfo() {
        return this.store.selectSnapshot(PharmacyState.selectedAPIPharmacyInfo);
    }
    getPlanEnrollmentSettings$(planId, requestParams) {
        return this.store.dispatch(new FetchEnrollmentPlanSettings(planId, requestParams)).pipe(switchMap(() => this.store.select(MemberState.enrollmentPlanSettings)), take(1));
    }
    getPlanShortFormSettings$(planId) {
        const siteType = this.siteService.getSiteType();
        const userType = this.siteService.getSiteUserType(siteType);
        const isPPCSite = this.siteService.isPPCSite(siteType);
        const showUAT = this.getPlanNetworkShowUATSetting();
        // For consumer sites perform the standard operation
        if (!isPPCSite) {
            const requestParams = { userType, formType: EnrollmentFormType.SHORT, showUAT };
            return this.getPlanEnrollmentSettings$(planId, requestParams);
        }
        // If we have a current user type selected, we can check for it's short form equivalent.
        const currentUserFormType = this.store.selectSnapshot(EnrollmentState.selectedUserFormType(planId));
        if (currentUserFormType) {
            const requestParams = {
                userType: currentUserFormType,
                formType: EnrollmentFormType.SHORT,
                showUAT
            };
            return this.getPlanEnrollmentSettings$(planId, requestParams);
        }
        // Else we need to fetch all enrollment plan settings.
        return this.fetchAllPlanEnrollmentSettings$(planId, EnrollmentFormType.SHORT);
    }
    async getPlanShortFormSettings(planId) {
        return await this.getPlanShortFormSettings$(planId).toPromise();
    }
    fetchPlanEnrollmentSettings$(planId, requestParams) {
        return this.plansHttpService.getPlanEnrollmentSettings$(planId, requestParams);
    }
    fetchPlanShortFormSettings$(planId) {
        const showUAT = this.getPlanNetworkShowUATSetting();
        // If we have a current user type selected, we can check for it's short form equivalent.
        const currentUserFormType = this.store.selectSnapshot(EnrollmentState.selectedUserFormType(planId));
        if (currentUserFormType) {
            const requestParams = {
                userType: currentUserFormType,
                formType: EnrollmentFormType.SHORT,
                showUAT
            };
            return this.fetchPlanEnrollmentSettings$(planId, requestParams);
        }
        return of([]);
    }
    async fetchPlanShortFormSettings(planId) {
        return await this.fetchPlanShortFormSettings$(planId).toPromise();
    }
    fetchPlanEnrollmentSettingsForAllPlans$(planIds) {
        const enrollmentSettingsQueue = planIds && planIds.length > 0 ? planIds.map(planId => this.fetchAllPlanEnrollmentSettingsForCrossSell$(planId)) : [];
        return enrollmentSettingsQueue.length > 0
            ? forkJoin(enrollmentSettingsQueue).pipe(map((plansEnrollmentSettings) => plansEnrollmentSettings.reduce((flattenSettings, planSettings) => flattenSettings.concat(planSettings), [])))
            : of([]);
    }
    fetchAllPlanEnrollmentSettingsForCrossSell$(planId, formType) {
        // This is a clone of fetchAllPlanEnrollmentSettings$, but will return enrollmentsettings even when there is no formId.
        // This is required for cross-sell to determine whether a plan is Internal/External/MessageOnly.
        // We may have consumer/all form settings, check broker user type.
        if (this.siteService.isPPCSite()) {
            // we were previously filtering out different form types mapped to the same formId like so:
            // setting.formId === settingValue.formId && setting.foamFormType !== settingValue.foamFormType
            // filtering of some sort should already happen in the matchesCompositeKey method of the member
            // state when these are set and even if we get the same mapped to different form types we would
            // like the ability to look up long or short form settings on the basis of form type
            return this.getFormSettings$(planId, null, formType);
        }
        return this.getFormSettings$(planId, UserTypeKeys.CONSUMER, formType);
    }
    fetchAllPlanEnrollmentSettings$(planId, formType) {
        // We may have consumer/all form settings, check broker user type.
        if (this.siteService.isPPCSite()) {
            return this.getUserTypeFormSettings$(planId, null, formType).pipe(map(settings => settings.reduce((allUniqueSettings, settingValue) => {
                if (!allUniqueSettings.some(setting => setting.formId === settingValue.formId && setting.foamFormType !== settingValue.foamFormType)) {
                    return [...allUniqueSettings, settingValue];
                }
                return allUniqueSettings;
            }, [])));
        }
        return this.getUserTypeFormSettings$(planId, UserTypeKeys.CONSUMER, formType);
    }
    async fetchAllPlanEnrollmentSettingsForCrossSell(planId) {
        return await this.fetchAllPlanEnrollmentSettingsForCrossSell$(planId).toPromise();
    }
    canSellPlan(plan) {
        return PlansUtilityService.canSellPlan(plan);
    }
    isPlanCommissionable(plan) {
        return PlansUtilityService.isPlanCommissionable(plan, this.isNonCommissionableFlagCheckEnabled);
    }
    getNonLicensedPlansCount(plans) {
        return plans?.filter(plan => !this.canSellPlan(plan)).length ?? 0;
    }
    getPlanNetworkShowUATSetting(widgetName) {
        return this.configResource.getProcessedResourceValue('PlanNetwork_ShowUAT', widgetName, false);
    }
    showAddNonLicensedPlans() {
        return this.isPUFSettingEnabled() && !this.getPUFPlanSetting();
    }
    async getMedBenefits(currentYearPlanId) {
        const demographicOptionsWithDefaults = this.createPlansDemographicsOptionsWithDefaults();
        const searchOptionsWithDefaults = this.createPlansSearchOptionsWithDefaults({});
        const agentGuid = this.store.selectSnapshot(AgentState.agentGuid);
        const drugs = this.drugsService.mapCabinetToDosage();
        const pharmacies = this.getSelectedAPIPharmacyInfo();
        let memberCurrentYearPlanId = '';
        if (this.siteService.isRetentionView()) {
            memberCurrentYearPlanId = currentYearPlanId || this.getCurrentYearPlanId();
        }
        return await this.plansHttpService.getMedBenefits(demographicOptionsWithDefaults, searchOptionsWithDefaults, this.getMergedMedigapAnswers(), agentGuid, drugs, pharmacies, memberCurrentYearPlanId);
    }
    moveNonLicensedPlansToBottom(plans) {
        if (plans && this.getIncludeNonLicensedPlanSetting() && this.isIncludeNonLicensedPlansEnabled()) {
            const licensedAndPUFPlans = plans.filter(plan => !plan.isNonPermissionedPlan || (plan.isNonPermissionedPlan && plan.isPUF));
            const nonLicensedNonPUFPlans = plans.filter(plan => plan.isNonPermissionedPlan && !plan.isPUF);
            return licensedAndPUFPlans.concat(nonLicensedNonPUFPlans);
        }
        return plans;
    }
    isNotLicensedToSell(plan) {
        return plan && this.isNonPermissionedAndNotPUF(plan) && this.isIncludeNonLicensedPlansEnabled() && this.siteService.isPPCSite();
    }
    getDefaultSortOption(existingSortList) {
        let defaultSort = existingSortList.find(sort => sort.isDefault);
        if (!defaultSort) {
            defaultSort = existingSortList.sort(sortData => sortData.order).find(sort => sort.display);
        }
        return defaultSort;
    }
    getAllTabTypeAbbreviations() {
        return [
            PlanTypeAbbreviation.MAPD,
            PlanTypeAbbreviation.MA,
            PlanTypeAbbreviation.PDP,
            PlanTypeAbbreviation.MEDIGAP,
            PlanTypeAbbreviation.DENTAL,
            PlanTypeAbbreviation.VISION,
            PlanTypeAbbreviation.HC
        ];
    }
    getAllVisibleTabTypeAbbreviations() {
        const abbreviations = [];
        if (this.configResource.getProcessedResourceValue('Spa_PlanList_Tab_Show_MAPD', null, false)) {
            abbreviations.push(PlanTypeAbbreviation.MAPD);
        }
        if (this.configResource.getProcessedResourceValue('Spa_PlanList_Tab_Show_MA', null, false)) {
            abbreviations.push(PlanTypeAbbreviation.MA);
        }
        if (this.configResource.getProcessedResourceValue('Spa_PlanList_Tab_Show_PDP', null, false)) {
            abbreviations.push(PlanTypeAbbreviation.PDP);
        }
        if (this.configResource.getProcessedResourceValue('Spa_PlanList_Tab_Show_MEDIGAP', null, false)) {
            abbreviations.push(PlanTypeAbbreviation.MEDIGAP);
        }
        if (this.configResource.getProcessedResourceValue('Spa_PlanList_Tab_Show_DENTAL', null, false)) {
            abbreviations.push(PlanTypeAbbreviation.DENTAL);
        }
        if (this.configResource.getProcessedResourceValue('Spa_PlanList_Tab_Show_VISION', null, false)) {
            abbreviations.push(PlanTypeAbbreviation.VISION);
        }
        return abbreviations;
    }
    updateNextYearPlanOrdinal(plansFromAPI) {
        const clientDefinedPlanOptionsEnabled = this.configResource.getProcessedResourceValue('Spa_Retention_ClientDefinedPlanOptions_Enabled', null, false);
        if (!clientDefinedPlanOptionsEnabled) {
            return plansFromAPI;
        }
        const sortedNextYearPlanOrdinals = plansFromAPI
            .filter(plan => plan.nextYearPlanOrdinal >= 1)
            .sort((a, b) => a.nextYearPlanOrdinal - b.nextYearPlanOrdinal);
        const newPlans = [];
        plansFromAPI.forEach(plan => {
            if (plan.nextYearPlanOrdinal === 0) {
                // I'm not 100% sure if we need this for the current year plan, but it's better to include it anyway.
                newPlans.push({ ...plan, modifiedNextYearPlanOrdinal: 0 });
            }
            else if (plan.nextYearPlanOrdinal >= 1) {
                // This makes it so that the lowest found value gets recorded as 1, the next as 2, etc.
                // If a set of data only has an option = 2, it should be treated as option = 1.
                const modifiedNextYearPlanOrdinal = sortedNextYearPlanOrdinals.findIndex(sortedPlan => sortedPlan.id === plan.id) + 1;
                newPlans.push({ ...plan, modifiedNextYearPlanOrdinal, planLabelCategory: PlanLabelCategory.PLAN_OPTION });
            }
            else {
                newPlans.push({ ...plan });
            }
        });
        return newPlans;
    }
    getExternallyRatedPlanData$(planIdsToUpdate, shortDataOnly) {
        if (!shortDataOnly && planIdsToUpdate?.length) {
            const selectedRateFactorAnswers = this.getExternallyRatedDataRateFactorAnswers();
            if (selectedRateFactorAnswers?.length) {
                return this.plansHttpService.getExternallyRatedPlanData$(selectedRateFactorAnswers, planIdsToUpdate);
            }
        }
        return of([]);
    }
    createPayloadWithExternallyRatedData(externalData, planTypes) {
        const payload = this.store.selectSnapshot(PlansState.plansByType(planTypes));
        const showPremiumAsAnnual = this.configResource.getProcessedResourceValue('Spa_Site_ShowPremiumAsAnnual', null, false);
        if (externalData?.length) {
            const mappedIdsFromExternalData = externalData.map(data => data.planID);
            const newPayload = payload.map(payloadItem => {
                if (mappedIdsFromExternalData.includes(payloadItem.id)) {
                    return this.updatePlanWithExternallyRatedPlanData(externalData, payloadItem, showPremiumAsAnnual);
                }
                return payloadItem;
            });
            return newPayload;
        }
        return payload;
    }
    updatePlanWithPlanFeesData(plan, plansFeesDataMap) {
        const matchingPlanFees = plansFeesDataMap?.[plan.id];
        const dataToUpdateWith = {
            fees: matchingPlanFees?.fees ?? []
        };
        const updatedPlan = { ...plan, ...dataToUpdateWith };
        return updatedPlan;
    }
    updatePlansWithPlansFeesData(plans, plansFeesData) {
        if (plans?.length) {
            const plansFeesDataMap = plansFeesData?.planFees?.reduce((plansFeesMap, planFees) => {
                plansFeesMap[planFees.planId] = planFees;
                return plansFeesMap;
            }, {});
            return plans.map(plan => this.updatePlanWithPlanFeesData(plan, plansFeesDataMap));
        }
        return [];
    }
    updatePlanWithExternallyRatedPlanData(externallyRatedData, plan, showPremiumAsAnnual) {
        const matchingRatingData = externallyRatedData.find(data => data.planID === plan.id);
        if (matchingRatingData) {
            const dataToUpdateWith = {
                quarterlyPremium: matchingRatingData.quarterlyPremium,
                monthlyPremium: matchingRatingData.monthlyPremium,
                annualPlanPremium: matchingRatingData.annualPremium,
                medicalPremium: showPremiumAsAnnual ? matchingRatingData.annualPremium : matchingRatingData.monthlyPremium,
                hasBeenExternallyRated: true,
                annualCalculatedPlanPremium: matchingRatingData.annualPremium,
                fees: matchingRatingData.fees ?? []
            };
            const newPlanRiders = [];
            plan.riders?.forEach(rider => {
                const matchingRiderData = externallyRatedData.find(data => data.planID === rider.planID);
                if (matchingRiderData) {
                    const newRiderPremiumValue = showPremiumAsAnnual ? matchingRiderData.annualPremium : matchingRiderData.monthlyPremium;
                    newPlanRiders.push({
                        ...rider,
                        calculatedMedicalPremium: newRiderPremiumValue,
                        hasCalculatedMedicalPremium: !!newRiderPremiumValue,
                        medicalPremium: newRiderPremiumValue,
                        fees: matchingRiderData.fees ?? []
                    });
                }
                else {
                    newPlanRiders.push({ ...rider, medicalPremium: 0, calculatedMedicalPremium: 0 });
                }
            });
            let updatedPlan = { ...plan, ...dataToUpdateWith, riders: newPlanRiders };
            if (plan.planType === PlanType.HC) {
                updatedPlan = this.getHospitalCarePlanWithCalculatedBasePremium(updatedPlan);
            }
            return updatedPlan;
        }
        return plan;
    }
    updatePlansWithExternallyRatedPlanData(plans, planTypes) {
        const ids = this.getIdsForExternallyRatedData(plans);
        if (ids?.length) {
            // This is an http observable, so it automatically unsubscribes after a data value is gotten
            this.getExternallyRatedPlanData$(ids).subscribe({
                next: (dataResult) => {
                    if (dataResult?.length) {
                        const newPayload = this.createPayloadWithExternallyRatedData(dataResult, planTypes);
                        this.store.dispatch(new UpdatePlans(newPayload, planTypes));
                    }
                }
            });
        }
    }
    // skipFlagCheck is for when we only care if we can do the call, not if it's already happened
    // For cases like plan details where we may need to just redo the call due to other data updates
    getIdsForExternallyRatedData(plans, skipFlagCheck) {
        const planIds = [];
        plans?.forEach(plan => {
            if (this.planRequiresExternalRating(plan, skipFlagCheck)) {
                planIds.push(plan.id);
                if (plan.riders?.length) {
                    plan.riders.forEach(rider => {
                        planIds.push(rider.planID);
                    });
                }
            }
        });
        return planIds;
    }
    // Sometimes we may already only have the plan ids, so need to compare those to the payload to get the plans
    getIdsForExternallyRatedDataById(planIds, skipFlagCheck) {
        const plans = this.getPlansByIds(planIds);
        return this.getIdsForExternallyRatedData(plans, skipFlagCheck);
    }
    planRequiresExternalRating(plan, skipFlagCheck) {
        return PlansUtilityService.planRequiresExternalRating(plan?.extraData, plan?.hasBeenExternallyRated, skipFlagCheck);
    }
    getUnloadedPlanTypes(loadingPlanTypes) {
        const allPlanTypes = this.getAllPlansSearchPlanTypes();
        // Edge case: when we have a small set of plans available and the default/main tab is a non-medicare plan type (example: MEDIGAP), and we select a new zip code,
        // We won't reduce the source of possible plan types to load when they represents all available plan types.
        // Otherwise, we could end up with no plan types to load when we select a new Zip code. That could lead to an out-of-sync data, displaying plans and plan count from the previous Zip code.
        let unloadedPlanTypes = _isEqual(loadingPlanTypes, allPlanTypes)
            ? loadingPlanTypes
            : allPlanTypes.filter(planType => !loadingPlanTypes.includes(planType));
        // TODO: check this logic... add not loading as well? will this situation happen in actuality
        unloadedPlanTypes = unloadedPlanTypes.filter(planType => !this.getArePlansLoaded(planType) || this.getArePlansDirty(planType));
        return unloadedPlanTypes;
    }
    getPlanTypesArray(searchOptionsPlanType) {
        if (searchOptionsPlanType) {
            const planTypeValues = PlansUtilityService.splitBitWise(+searchOptionsPlanType);
            const allPlanTypes = planTypeValues.reduce((validPlanTypes, planTypeValue) => {
                if (this.planTypeValueExists(planTypeValue)) {
                    validPlanTypes.push(planTypeValue);
                }
                return validPlanTypes;
            }, []);
            return this.mergeMedicareTypes(allPlanTypes);
        }
        return [];
    }
    resetPlans() {
        this.store.dispatch(new ResetPlanTypes());
    }
    getActiveTabTypes() {
        const planListTabs = this.configResource.getProcessedResourceValue('Spa_PlanList_Tabs_Data');
        return Array.from(new Set(planListTabs.map(tab => tab.tabTypes[0])));
    }
    loaded$(planType) {
        return this.store.select(PlansState.loaded(planType));
    }
    dirty$() {
        return this.store.select(PlansState.dirty());
    }
    extendHospitalIndemnityPlanWithNumberOfDaysCovered(plan) {
        const numberOfDaysCovered = this.getExtraDataValueByName(plan, PlanExtraDataKey.HC_NUMBER_OF_DAYS_COVERED) ?? '';
        return { ...plan, numberOfDaysCovered };
    }
    getExtraDataValueByName(plan, name, defaultValue) {
        return PlansUtilityService.getExtraDataValueByName(plan?.extraData, name, defaultValue);
    }
    setPlanShortLoading(loading) {
        this.store.dispatch(new SetPlanShortLoading(loading));
    }
    // determines if this planType contains a bitwise planType that we calculate scores for
    isScoredPlanType(planType) {
        const planTypes = PlansUtilityService.splitBitWise(planType);
        return planTypes?.some(bitWisePlanType => PlansUtilityService.isSingleMedicareType(bitWisePlanType) ||
            PlansUtilityService.isAllMedicareType(bitWisePlanType) ||
            bitWisePlanType === PlanType.MEDIGAP);
    }
    fetchPlanShortData(demographicOptionsWithDefaults, searchOptionsWithDefaults, miscFields, planFetchOptions, includeExtendedProviderData) {
        this.setPlanShortLoading(true);
        this.plansHttpService
            .retrievePlanShortData$(demographicOptionsWithDefaults, this.updateSearchOptionsPlanType(searchOptionsWithDefaults, 
        // we will only get counts for the types we pass in and we will only get scores
        // if we pass in medicare and medigap. Jack recommended making two seperate calls
        // to plan short if we want to narrow down the calls on plan type but this would
        // mitigate the performance gains we are looking to gain with this change so we will
        // just always call for all planTypes
        this.getAllPlansSearchPlanTypes().reduce((sum, number) => (sum += number), 0)), miscFields, includeExtendedProviderData, planFetchOptions.includeBenefits)
            .pipe(take(1), finalize(() => {
            this.setPlanShortLoading(false);
        }))
            .subscribe({
            next: (response) => {
                this.store.dispatch(new UpdatePlanShortData(response, searchOptionsWithDefaults?.planCount, searchOptionsWithDefaults?.scorePlans));
            }
        });
    }
    // if we are scoring plans we need to make sure that its only done in planShort rather than in planShort
    // AND the plans call so we need to unset it here if it is true
    removePreferenceScoring(miscOptions) {
        return { ...miscOptions, preferences: [] };
    }
    getPlansByType$(planTypes) {
        return this.store.select(PlansState.plansByType(planTypes));
    }
    getAllPlans$() {
        return this.store.select(PlansState.plans);
    }
    getAllPlans() {
        return this.store.selectSnapshot(PlansState.plans);
    }
    getFilteredPlansBySNPVisibility$() {
        return this.store.select(PlansState.plansFilteredBySNPVisibility);
    }
    getFilteredPlansBySNPVisibility() {
        return this.store.selectSnapshot(PlansState.plansFilteredBySNPVisibility);
    }
    updateSearchOptionsPlanType(searchOptionsWithDefaults, planType) {
        return { ...searchOptionsWithDefaults, planType: planType.toString() };
    }
    isConsumerBrokerSelectionAllowedForPlanType(plan) {
        const planTypesNotAllowedToDisplayConsumerBrokerSelection = [
            PlanTypeAbbreviation.DENTAL,
            PlanTypeAbbreviation.VISION,
            PlanTypeAbbreviation.HC
        ];
        return !planTypesNotAllowedToDisplayConsumerBrokerSelection.includes(plan?.planTypeAbbreviation);
    }
    getMedicalCostInputs(searchOptionsWithDefaults, demographicOptionsWithDefaults) {
        return searchOptionsWithDefaults?.includeMCCCustomization &&
            demographicOptionsWithDefaults?.estimateHealthCost === EstimateHealthCostFlag.Edited
            ? this.store.selectSnapshot(MemberState.medicalCostInputs)
            : [];
    }
    shouldScorePlans(planType, hasQuestionsIfRequired) {
        const medicineCabinet = this.getMedicineCabinet();
        const pharmacies = this.getSelectedAPIPharmacyInfo();
        const sendPreferencesFlag = this.setSendPreferencesFlag(pharmacies, medicineCabinet, this.preferenceScoreEnabled);
        return sendPreferencesFlag && (this.providersEnabled || (this.isScoredPlanType(planType) && hasQuestionsIfRequired));
    }
    updateHIPCalculatedPremium(plans) {
        return plans.map(plan => plan.planTypeAbbreviation === PlanTypeAbbreviation.HC ? this.getHospitalCarePlanWithCalculatedBasePremium(plan) : plan);
    }
    getHospitalCarePlanWithCalculatedBasePremium(plan) {
        let hospitalCarePlanWithCalculatedBasePremium = { ...plan };
        const hospitalIndemnityBasePlanRiders = this.getHospitalIndemnityBasePlanRiders(plan);
        const riders = hospitalIndemnityBasePlanRiders?.length ? [hospitalIndemnityBasePlanRiders[0]] : [];
        const calculatedBasePlanPremium = this.getTotalPremium([plan], riders);
        hospitalCarePlanWithCalculatedBasePremium = { ...plan, calculatedBasePlanPremium };
        return hospitalCarePlanWithCalculatedBasePremium;
    }
    initiatePlanSmart$(agentGuid, planYear) {
        return this.plansHttpService.initiatePlanSmart$({ agentGuid, planYear });
    }
    fetchPlanSmartStatus$(agentGuid, planYear) {
        return this.plansHttpService.fetchPlanSmartState$(agentGuid, planYear).pipe(switchMap((planSmartState) => {
            if (Object.keys(planSmartState).length > 0) {
                return planSmartState.isCompleted ? of(PlanSmartStatus.COMPLETED) : of(PlanSmartStatus.IN_PROGRESS);
            }
            return of(PlanSmartStatus.INITIATE);
        }));
    }
    fetchPlanSmartReports(agentGuid, planYear) {
        this.store.dispatch(new FetchPlanSmartReports(agentGuid, planYear));
    }
    getPlanSmartReportData(planYear) {
        const planSmartReport = this.store.selectSnapshot(PlansState.planSmartReports);
        return planSmartReport?.[planYear]?.data ?? [];
    }
    getPlanSmartReports$() {
        return this.store.select(PlansState.planSmartReports);
    }
    resetPlanSmart() {
        this.store.dispatch(new ResetPlanSmart());
    }
    getHospitalIndemnityBasePlanRiders(plan) {
        const riderSortProperty = 'calculatedMedicalPremium';
        return this.sortRiders(this.getHospitalIndemnityBasePlan(plan), riderSortProperty);
    }
    sortRiders(riders, sortParam) {
        return riders?.sort((riderA, riderB) => (riderA[sortParam] < riderB[sortParam] ? -1 : 1)) ?? [];
    }
    getHospitalIndemnityBasePlanSectionDetails(basePlanOptions) {
        return basePlanOptions[0]?.extendedPlanDetails[0]?.sectionDetails?.find(sectionDetail => sectionDetail.name === BenefitType.BENEFIT_AMOUNT);
    }
    getHospitalIndemnityBasePlan(plan) {
        const [primaryBasePlanName, secondaryBasePlanName] = BASE_PLAN_HC_OPTION_NAMES;
        let basePlanRiders = plan.riders?.filter(rider => rider.planTypeDescription === primaryBasePlanName) ?? [];
        if (basePlanRiders.length === 0) {
            basePlanRiders = plan.riders?.filter(rider => rider.planTypeDescription === secondaryBasePlanName) ?? [];
        }
        return basePlanRiders;
    }
    setPlansLoading(planTypes, isLoading = false) {
        this.store.dispatch(new SetPlansLoading(isLoading, planTypes));
    }
    resetTotalCostEffectiveDate() {
        this.store.dispatch(new ResetTotalCostEffectiveDate());
    }
    getLogoBaseUrl() {
        // get content server logo resources
        let contentServerUrl = this.configResource.getProcessedResourceValue('ContentServerUrl', null, 'https://contentserver.destinationrx.com/ContentServer/DRxProductContent');
        const contentServerPlanLogoPath = this.configResource.getProcessedResourceValue('ContentServerPlanLogoPath', null, 'PlanLogo');
        // prep the base log url
        if (!contentServerUrl.endsWith('/')) {
            contentServerUrl = contentServerUrl.concat('/');
        }
        // form the base logo URL from ContentServerUrl and PlanLogo image path
        let logoBaseUrl = new URL(contentServerPlanLogoPath, contentServerUrl).toString();
        // need base URL to end with a whack so javascript URL constructor will use entire base path
        if (!logoBaseUrl.endsWith('/')) {
            logoBaseUrl = logoBaseUrl.concat('/');
        }
        return logoBaseUrl;
    }
    getCurrency(premium) {
        return this.currencyUtilityService.getCurrency(premium);
    }
    getPlansFees$(planIds) {
        return this.plansHttpService.getPlansFees$(planIds);
    }
    getNonMedicarePlanIds(plans, includeExternalRatingPlanIds = false) {
        return (plans?.reduce((nonMedicarePlanIds, plan) => {
            if (!MEDICARE_PLAN_TYPES.includes(plan.planTypeAbbreviation) &&
                (includeExternalRatingPlanIds || !this.planRequiresExternalRating(plan))) {
                nonMedicarePlanIds.push(plan.id);
            }
            return nonMedicarePlanIds;
        }, []) ?? []);
    }
    isDualPlanYear(selectedPlanYear) {
        return this.planYearResourceService.isDualPlanYear(selectedPlanYear);
    }
    getPlanTypeDescription(planTypeAbbreviation, widgetName) {
        const planTypeNameResource = planTypeAbbreviation === PlanTypeAbbreviation.HC
            ? 'Spa_Site_HIP_Description'
            : `Spa_Site_${this.stringFormatUtilityService.capitalizeFirstLetter(planTypeAbbreviation.toLowerCase())}_Description`;
        return this.configResource.getProcessedResourceValue(planTypeNameResource, widgetName, planTypeAbbreviation);
    }
    isPlanDetailedById(planId) {
        const plan = this.getPlan(planId);
        return this.isPlanDetailed(plan);
    }
    // TODO: Probably a better way of figuring this out.
    isPlanDetailed(plan) {
        return !!plan?.extendedPlanDetails?.length || !!plan?.documents?.length;
    }
    openBackToPlansModal(title, prompt, cancelText, confirmText, cancelAction, confirmAction) {
        const confirmationModal = this.modalService.open(ConfirmationModalComponent, { centered: true, backdrop: 'static', keyboard: false });
        confirmationModal.componentInstance.title = title;
        confirmationModal.componentInstance.prompt = prompt;
        confirmationModal.componentInstance.cancelButton = cancelText;
        confirmationModal.componentInstance.confirmButton = confirmText;
        if (cancelAction) {
            confirmationModal.componentInstance.cancelAction = cancelAction;
        }
        if (confirmAction) {
            confirmationModal.componentInstance.confirmAction = confirmAction;
        }
        else {
            confirmationModal.componentInstance.confirmAction = () => {
                this.navigationService.navigateByPageTag(PageTags.PLAN_LIST);
            };
        }
        return confirmationModal;
    }
    getCurrentPlanDetailsWithFilterGroup$() {
        return this.getCurrentPlanShort$().pipe(switchMap((currentPlanShort) => {
            if (currentPlanShort) {
                return this.getCurrentPlanFilterGroup$(currentPlanShort.zip, currentPlanShort.countyFips, currentPlanShort.planYear, currentPlanShort.planType).pipe(map((currentPlanFilterGroup) => {
                    return [
                        currentPlanShort,
                        currentPlanFilterGroup
                            ? {
                                ...currentPlanFilterGroup,
                                zip: currentPlanShort.zip,
                                countyFips: currentPlanShort.countyFips,
                                planYear: currentPlanShort.planYear,
                                planType: currentPlanShort.planType
                            }
                            : null
                    ];
                }));
            }
            return of([null, null]);
        }));
    }
    getCurrentPlanFilterGroup$(zip, countyFips, planYear, planType) {
        return this.plansHttpService.getCurrentPlanFilterGroup$(zip, countyFips, planYear, planType);
    }
    updateCurrentPlanShort$(sessionID, currentPlanShort) {
        this.updateCurrentPlanShortDetails();
        return this.plansHttpService.updateCurrentPlanShort$(sessionID, currentPlanShort);
    }
    async fetchCurrentPlanShort$(SessionID) {
        return await firstValueFrom(this.plansHttpService.getCurrentPlanShort$(SessionID), { defaultValue: null });
    }
    getMedicineCabinet() {
        return this.store.selectSnapshot(MedicineCabinetState.medicineCabinet);
    }
    getMedicineCabinet$() {
        return this.store.select(MedicineCabinetState.medicineCabinet);
    }
    updateNextYearPlanShort$(sessionID, nextYearPlanShort) {
        return this.plansHttpService.updateNextYearPlanShort$(sessionID, nextYearPlanShort);
    }
    getNextYearPlanShortFromPlan(plan, zip, countyFips, isSelected, isClientDefined, source) {
        const nextYearPlanShort = {
            planId: plan.id,
            planYear: plan.planYear,
            planName: plan.planName,
            planType: plan.planType,
            orgName: plan.organizationName,
            planMarketingName: plan.planMarketingName,
            carrierName: plan.carrierName,
            carrierId: plan.carrierId,
            zip,
            countyFips,
            isSelected: isSelected ?? false,
            isClientDefined: isClientDefined ?? false,
            source
        };
        return nextYearPlanShort;
    }
    updateCurrentPlanShortDetails() {
        const currentPlans = this.getCurrentPlans();
        const previousCurrentPlanShort = this.getCurrentPlanShort();
        if (previousCurrentPlanShort && currentPlans?.length) {
            const matchedPlan = currentPlans.find(plan => plan.id === previousCurrentPlanShort.planId);
            if (matchedPlan) {
                const updatedPlan = {
                    ...matchedPlan,
                    planLabelCategory: PlanLabelCategory.NONE // Reset it to Default NONE
                };
                this.store.dispatch(new SelectPlanDetails(updatedPlan));
            }
            if (previousCurrentPlanShort.nextYearPlanId) {
                const allPlans = this.getAllPlans();
                const nextYearPlan = allPlans.find(plan => plan.id === previousCurrentPlanShort.nextYearPlanId);
                if (nextYearPlan) {
                    const updatedNextYearPlan = {
                        ...nextYearPlan,
                        planLabelCategory: PlanLabelCategory.NONE // Reset it to Default NONE
                    };
                    this.store.dispatch(new SelectPlanDetails(updatedNextYearPlan));
                }
            }
        }
    }
    getQuotePlans(plans) {
        const quotedPlanIds = this.quoteService.getQuotePlanIds();
        if (!quotedPlanIds?.length) {
            return [];
        }
        return plans.filter(plan => quotedPlanIds.includes(plan.id));
    }
    updateQuotedPlanLabels(quotedPlanIds) {
        if (quotedPlanIds?.length) {
            const allPlans = this.getAllPlans();
            const quotedPlanIdSet = new Set(quotedPlanIds);
            // Reset plans that are no longer quoted
            allPlans
                .filter(plan => plan.planLabelCategory === PlanLabelCategory.QUOTED_PLAN && !quotedPlanIdSet.has(plan.id))
                .forEach(plan => {
                const resetPlan = {
                    ...plan,
                    planLabelCategory: PlanLabelCategory.NONE,
                    planLabelCategoryOrdinal: null
                };
                this.store.dispatch(new SelectPlanDetails(resetPlan));
            });
            // Set plan label and ordinal based on order in quotedPlanIds
            quotedPlanIds.forEach((planId, index) => {
                const plan = allPlans.find(p => p.id === planId);
                if (plan) {
                    const quotedPlan = {
                        ...plan,
                        planLabelCategory: PlanLabelCategory.QUOTED_PLAN,
                        planLabelCategoryOrdinal: index + 1
                    };
                    this.store.dispatch(new SelectPlanDetails(quotedPlan));
                }
            });
        }
    }
    setDefaultPlanLabelCategory(plans) {
        return plans.map(plan => ({
            ...plan,
            planLabelCategory: PlanLabelCategory.NONE
        }));
    }
    updateQuotePlanOrdinal(plans) {
        const quotedPlanIds = this.quoteService.getQuotePlanIds();
        if (!quotedPlanIds?.length) {
            return plans;
        }
        const quotePlans = plans.reduce((selectedPlans, plan) => {
            const quoteIndex = quotedPlanIds.indexOf(plan.id);
            if (quoteIndex !== -1) {
                selectedPlans.push({
                    ...plan,
                    planLabelCategory: PlanLabelCategory.QUOTED_PLAN,
                    planLabelCategoryOrdinal: quoteIndex + 1
                });
            }
            return selectedPlans;
        }, []);
        const nonQuotePlans = plans.filter(plan => !quotedPlanIds.includes(plan.id));
        return [...quotePlans, ...nonQuotePlans];
    }
    updateCurrentPlanLabelCategory(plans) {
        const currentPlanEnabled = this.configResource.getProcessedResourceValue('Spa_Site_CurrentPlan_Enabled', null, false);
        const currentPlanShort = this.getCurrentPlanShort();
        if (!currentPlanShort || !currentPlanEnabled) {
            return plans;
        }
        const currentPlan = plans
            .filter(plan => plan.id === currentPlanShort.planId)
            .map(plan => ({
            ...plan,
            planLabelCategory: PlanLabelCategory.CURRENT_PLAN
        }));
        const nextYearPlan = plans
            .filter(plan => plan.id === currentPlanShort.nextYearPlanId || plan.isNextYearPlan === true)
            .map(plan => ({
            ...plan,
            planLabelCategory: PlanLabelCategory.NEXT_YEAR_PLAN
        }));
        const nonCurrentPlans = plans.filter(plan => plan.id !== currentPlanShort.planId && plan.id !== currentPlanShort.nextYearPlanId && plan.isNextYearPlan !== true);
        return [...currentPlan, ...nextYearPlan, ...nonCurrentPlans];
    }
    /**
     * Due to AARP, we need to always send zip/fips regardless of if they were part of the questions or not.
     * So we use this to check if they are already existing, and add them to whatever we already have if needed.
     */
    getExternallyRatedDataRateFactorAnswers() {
        if (!this.getHasMedSupAnswers()) {
            // We now pre-fill the med sup answers with zip/fips, but we still need to have gone to the form to enable external rating
            return [];
        }
        const allAnswers = this.getMergedMedigapAnswers();
        const mappedAnswers = [];
        Object.keys(allAnswers).forEach(questionKey => {
            const value = allAnswers[questionKey];
            if (value !== undefined) {
                mappedAnswers.push({ questionID: MedSupPlanQuestionIds[questionKey], value });
            }
        });
        // Despite the form now being pre-populated with this data, we still leave these checks to help with edge cases
        const existingZipAnswer = mappedAnswers?.find(answer => answer.questionID === MedSupPlanQuestionIds.ZipCode);
        const existingFipsAnswer = mappedAnswers?.find(answer => answer.questionID === MedSupPlanQuestionIds.County_FIPS);
        if (!existingZipAnswer) {
            const zipValue = this.store.selectSnapshot(DemographicState.selectedZipCode);
            mappedAnswers.push({ questionID: MedSupPlanQuestionIds.ZipCode, value: zipValue });
        }
        if (!existingFipsAnswer) {
            const fipsValue = this.store.selectSnapshot(DemographicState.selectedFipsCode);
            mappedAnswers.push({ questionID: MedSupPlanQuestionIds.County_FIPS, value: fipsValue });
        }
        return mappedAnswers;
    }
    getRidersMedicalPremium(riders) {
        return riders?.reduce((total, rider) => total + (this.ridersService.getRiderMedicalPremium(rider) || 0), 0) ?? 0;
    }
    getCurrentPlanInfo(currentPlanShort) {
        const costByEffectiveDate = this.store.selectSnapshot(MemberState.costByEffectiveDate);
        const demographicOptionsWithDefaults = this.createPlansDemographicsOptionsWithDefaults({
            zip: currentPlanShort.zip,
            fips: currentPlanShort.countyFips
        });
        const searchOptionsWithDefaults = this.createPlansSearchOptionsWithDefaults({
            planType: currentPlanShort.planType.toString(),
            year: currentPlanShort.planYear.toString()
        });
        const medicalCostCabinetUpdatePayload = this.getMedicalCostInputs(searchOptionsWithDefaults, demographicOptionsWithDefaults);
        // since client defined plan options requires member id,
        // we fetch this on the off chance the given option doesnt include it for some reason
        const memberId = searchOptionsWithDefaults.getClientDefinedPlans ? this.store.selectSnapshot(MemberState.memberID) : '';
        const agentGuid = this.store.selectSnapshot(AgentState.agentGuid);
        const currentYearPlanID = '';
        const includeBenefits = this.configResource.getProcessedResourceValue('Spa_Filter_PlanBenefitsGroup_Enabled', null, false);
        const drugs = this.drugsService.mapCabinetToDosage();
        const pharmacies = this.getSelectedAPIPharmacyInfo();
        const medigapAnswers = this.getMergedMedigapAnswers();
        const providers = this.providerService.getNpiAndAddressOfSelectedProviders();
        const miscFields = {
            currentYearPlanID,
            costByEffectiveDate,
            preferences: [],
            healthCostsEnabled: this.configResource.getProcessedResourceValue('Spa_Site_HealthCosts_Enabled', null, true),
            filterPlanMarketingNameEnabled: this.configResource.getProcessedResourceValue('Spa_Filter_Plan_Marketing_Name_Enabled', null, false),
            showPremiumAsAnnual: this.configResource.getProcessedResourceValue('Spa_Site_ShowPremiumAsAnnual', null, false),
            medigapAnswers,
            drugs,
            pharmacies,
            providers,
            agentGuid,
            memberId
        };
        this.plansHttpService
            .retrieveCurrentPlanInfo$(demographicOptionsWithDefaults, searchOptionsWithDefaults, miscFields, currentPlanShort.planId, medicalCostCabinetUpdatePayload, includeBenefits)
            .pipe(take(1))
            .subscribe({
            next: response => {
                this.setCurrentPlanInfo(response, currentPlanShort);
            }
        });
    }
    setCurrentPlanInfo(plansHttpResponse, currentPlanShort) {
        let plansWithDetails = plansHttpResponse?.data;
        if (plansWithDetails?.length) {
            plansWithDetails = plansWithDetails.map(plan => ({
                ...plan,
                planLabelCategory: PlanLabelCategory.CURRENT_PLAN
            }));
            const actions = [
                new UpdateCurrentPlans(plansWithDetails),
                ...plansWithDetails.map(plan => new SelectPlanDetails(plan)),
                new UpdateCurrentPlanPharmacies(plansHttpResponse.planPharmacyData)
            ];
            if (currentPlanShort?.nextYearPlanId) {
                const allPlans = this.getAllPlans();
                const nextYearPlan = allPlans.find(plan => plan.id === currentPlanShort.nextYearPlanId);
                if (nextYearPlan) {
                    const updatedNextYearPlan = {
                        ...nextYearPlan,
                        planLabelCategory: PlanLabelCategory.NEXT_YEAR_PLAN
                    };
                    actions.push(new SelectPlanDetails(updatedNextYearPlan));
                }
            }
            this.store.dispatch(actions);
        }
    }
    finalizeFetchPlans$(planFetchOptions, agentASPSetting, shouldFetchPlansWithFees, defaultPlanIdsForExternalRating) {
        const costByEffectiveDate = this.store.selectSnapshot(MemberState.costByEffectiveDate);
        const totalCostEffectiveDate = this.store.selectSnapshot(MemberState.totalCostEffectiveDate);
        const demographicOptionsWithDefaults = this.createPlansDemographicsOptionsWithDefaults(planFetchOptions.demographicsOptions);
        const searchOptionsWithDefaults = this.createPlansSearchOptionsWithDefaults(planFetchOptions.searchOptions);
        const medicalCostCabinetUpdatePayload = this.getMedicalCostInputs(searchOptionsWithDefaults, demographicOptionsWithDefaults);
        searchOptionsWithDefaults.aspRequired = agentASPSetting;
        searchOptionsWithDefaults.drugMedTocEffectiveDate = totalCostEffectiveDate;
        const planTypes = this.getPlanTypesArray(searchOptionsWithDefaults?.planType);
        this.setPlansLoading(planTypes, !planFetchOptions.hideLoading);
        searchOptionsWithDefaults.getClientDefinedPlans = this.configResource.getProcessedResourceValue('Spa_Retention_ClientDefinedPlanOptions_Enabled', null, false);
        let memberId = planFetchOptions.memberID;
        if (searchOptionsWithDefaults.getClientDefinedPlans && !memberId) {
            // since client defined plan options requires member id,
            // we fetch this on the off chance the given option doesnt include it for some reason
            memberId = this.store.selectSnapshot(MemberState.memberID);
        }
        const miscFields = {
            currentYearPlanID: this.siteService.isRetentionView() ? planFetchOptions.currentYearPlanId : '',
            costByEffectiveDate,
            preferences: planFetchOptions.preferences ? planFetchOptions.preferences : [],
            healthCostsEnabled: this.configResource.getProcessedResourceValue('Spa_Site_HealthCosts_Enabled', null, true),
            filterPlanMarketingNameEnabled: this.configResource.getProcessedResourceValue('Spa_Filter_Plan_Marketing_Name_Enabled', null, false),
            showPremiumAsAnnual: this.configResource.getProcessedResourceValue('Spa_Site_ShowPremiumAsAnnual', null, false),
            medigapAnswers: planFetchOptions.medigapAnswers,
            drugs: planFetchOptions.drugs,
            pharmacies: planFetchOptions.pharmacies,
            providers: planFetchOptions.providers,
            agentGuid: planFetchOptions.agentGuid,
            memberId
        };
        if (searchOptionsWithDefaults.planType === PlanType.HC.toString()) {
            const selectedPlansRiderBenefitCategoryIds = this.getSelectedPlansRiderBenefitCategoryIds();
            if (selectedPlansRiderBenefitCategoryIds.length > 0) {
                miscFields.riderIds = selectedPlansRiderBenefitCategoryIds;
            }
        }
        // right now we are only using this when getting plan counts and when scorePlans is true
        // providers and coveredpreferences are only returned when score plans is true so no need to
        // call for short data if we haven't set either of these to true
        // TODO: IF this changes then we will have to update this accordingly
        if (searchOptionsWithDefaults?.planCount || searchOptionsWithDefaults?.scorePlans) {
            this.fetchPlanShortData(demographicOptionsWithDefaults, searchOptionsWithDefaults, miscFields, planFetchOptions, this.includeExtendedProviderData);
        }
        const currentPlanEnabled = this.configResource.getProcessedResourceValue('Spa_Site_CurrentPlan_Enabled', null, false);
        const currentPlanShort = this.getCurrentPlanShort();
        if (currentPlanEnabled && currentPlanShort) {
            this.getCurrentPlanInfo(currentPlanShort);
        }
        let fetchPlans$;
        // there are possible, but rare cases where we want to just get short data to get counts
        // in that case we cannot call and return plans
        if (planFetchOptions.shortDataOnly) {
            this.setPlansLoading(planTypes, false);
            fetchPlans$ = of([]);
        }
        else {
            fetchPlans$ = this.getPlans$(demographicOptionsWithDefaults, searchOptionsWithDefaults, miscFields, planFetchOptions, medicalCostCabinetUpdatePayload).pipe(tap({
                next: response => {
                    this.store.dispatch(new UpdatePlanPharmacies(response?.planPharmacyData, planTypes, planFetchOptions?.ids));
                }
            }), map(val => val.data), map(plans => this.setDefaultPlanLabelCategory(plans)), // Set default planLabelCategory NONE
            map(plans => this.updateNextYearPlanOrdinal(plans)), map(plans => this.updateQuotePlanOrdinal(plans)), map(plans => this.updateCurrentPlanLabelCategory(plans)), map(plans => (this.getIsHospitalIndemnityEnabled() ? this.updateHIPCalculatedPremium(plans) : plans)), tap({
                next: () => {
                    this.setPlansLoading(planTypes, false);
                },
                error: error => {
                    if (PlansUtilityService.isAgentSellingPermissionError(error)) {
                        const plans = [];
                        const pharmacies = [];
                        this.store.dispatch(new UpdatePlans(plans, planTypes));
                        this.store.dispatch(new UpdatePlanPharmacies(pharmacies, planTypes));
                    }
                    this.store.dispatch(new FetchPlansError(error, planTypes));
                }
            }));
        }
        if (shouldFetchPlansWithFees) {
            // Plan Details
            if (planFetchOptions.ids?.length) {
                return this.fetchPlansDetailsWithFees$(fetchPlans$, planFetchOptions.ids, defaultPlanIdsForExternalRating);
            }
            // Fetch plans and retrieve their fees in sequence
            // For externally rated plans, their fees will be retrieved along with their external rating data at a later step
            return fetchPlans$.pipe(switchMap(plans => {
                const planIdsForFeeRetrieval = this.getNonMedicarePlanIds(plans);
                if (planIdsForFeeRetrieval.length > 0) {
                    return this.getPlansFees$(planIdsForFeeRetrieval).pipe(map(plansFeesData => this.updatePlansWithPlansFeesData(plans, plansFeesData)));
                }
                return of(plans);
            }));
        }
        return fetchPlans$;
    }
    getPlans$(demographicOptionsWithDefaults, searchOptionsWithDefaults, miscFields, planFetchOptions, medicalCostCabinetUpdatePayload) {
        // if we have already pared down the plans call by id we don't need to run multiple plans calls in parallel
        // as performance is already going to be improved by virtue of narrowed scope of the request
        if (planFetchOptions?.ids?.length) {
            return this.plansHttpService.retrievePlans$(demographicOptionsWithDefaults, searchOptionsWithDefaults, miscFields, planFetchOptions.ids, medicalCostCabinetUpdatePayload, planFetchOptions.includeBenefits);
        }
        const uniquePlanTypes = new Set(this.getPlanTypesArray(searchOptionsWithDefaults?.planType));
        return forkJoin(Array.from(uniquePlanTypes).map(planType => this.plansHttpService.retrievePlans$(demographicOptionsWithDefaults, this.updateSearchOptionsPlanType(searchOptionsWithDefaults, planType), this.removePreferenceScoring(miscFields), planFetchOptions.ids, medicalCostCabinetUpdatePayload, planFetchOptions.includeBenefits))).pipe(map(responseArray => this.mergeResponseArray(responseArray)));
    }
    mergeMedicareTypes(allPlanTypes) {
        let mergedPlanTypes = allPlanTypes;
        if (PlansUtilityService.includesMedicarePlans(allPlanTypes)) {
            // need to make a single request for medicare plan types as making seperate requests doesn't improve performance
            mergedPlanTypes = allPlanTypes.filter(planType => !MEDICARE_PLAN_TYPE_VALUES.includes(planType));
            const allMedicarePlanType = MEDICARE_PLAN_TYPE_VALUES.reduce((planTypeValue1, planTypeValue2) => planTypeValue1 + planTypeValue2);
            mergedPlanTypes.unshift(allMedicarePlanType);
        }
        return mergedPlanTypes;
    }
    mergePlanPharmacyData(targetPlanPharmacyInfo = [], sourcePharmacyInfo = []) {
        if (sourcePharmacyInfo.length > 0) {
            return sourcePharmacyInfo.reduce((updatedPlanPharmacyInfo, sourcePlanPharmacy) => {
                const existingPharmacy = updatedPlanPharmacyInfo.find(updatedPlanPharmacy => updatedPlanPharmacy.pharmacyId === sourcePlanPharmacy.pharmacyId);
                if (existingPharmacy) {
                    const isRetail = (existingPharmacy.isRetail ? existingPharmacy.isRetail : []).concat(sourcePlanPharmacy.isRetail);
                    const isInNetwork = (existingPharmacy.isInNetwork ? existingPharmacy.isInNetwork : []).concat(sourcePlanPharmacy.isInNetwork);
                    const isPreferred = (existingPharmacy.isPreferred ? existingPharmacy.isPreferred : []).concat(sourcePlanPharmacy.isPreferred);
                    const isMailOrder = (existingPharmacy.isMailOrder ? existingPharmacy.isMailOrder : []).concat(sourcePlanPharmacy.isMailOrder);
                    updatedPlanPharmacyInfo.push({
                        ...existingPharmacy,
                        isRetail,
                        isInNetwork,
                        isPreferred,
                        isMailOrder
                    });
                }
                else {
                    updatedPlanPharmacyInfo.push(sourcePlanPharmacy);
                }
                return updatedPlanPharmacyInfo;
            }, targetPlanPharmacyInfo);
        }
        return targetPlanPharmacyInfo;
    }
    mergeResponseArray(responseArray) {
        return responseArray.reduce((mergedResponse, response) => ({
            data: response?.data ? mergedResponse.data.concat(response.data) : mergedResponse.data,
            medicalBenefits: response?.medicalBenefits
                ? mergedResponse.medicalBenefits.concat(response.medicalBenefits)
                : mergedResponse.medicalBenefits,
            // technically this can only come in via medicare types but we will need to merge as to not overwrite this
            // when we are calling for medicare and non-medicare types in parallel
            planPharmacyData: this.mergePlanPharmacyData(mergedResponse.planPharmacyData, response.planPharmacyData),
            totalCount: (mergedResponse.totalCount += response?.totalCount ?? 0)
        }), { data: [], medicalBenefits: [], planPharmacyData: [], totalCount: 0 });
    }
    planTypeValueExists(planTypeValue) {
        return !!Object.keys(PlanType).find(planTypeKey => PlanType[planTypeKey] === planTypeValue);
    }
    fetchDrugAlternatives$(planId, dosageId, conditionId, cabinet, demographicsOptions) {
        const demographicsOptionsWithDefaults = this.createPlansDemographicsOptionsWithDefaults(demographicsOptions);
        const drug = this.drugsService.mapCabinetToDosage({ cabinet, conditionId }).find(dosage => dosage.dosageId === dosageId);
        const pharmacies = this.getSelectedAPIPharmacyInfo();
        return this.plansHttpService.retrieveDrugAlternatives$(planId, demographicsOptionsWithDefaults, [drug], pharmacies);
    }
    isNonPermissionedAndNotPUF(plan) {
        return plan.isNonPermissionedPlan && !plan.isPUF;
    }
    isIncludeNonLicensedPlansEnabled(widgetName) {
        return this.configResource.getProcessedResourceValue('Spa_PlanList_Include_NonLicensed_Plans', widgetName, false);
    }
    isPlanListInfoTrackingEnabled(widgetName) {
        return this.configResource.getProcessedResourceValue('Spa_PlanListInfo_Tracking_Enabled', widgetName, true);
    }
    isPUFSettingEnabled(widgetName) {
        return this.getPlanUseGlobalPUFSetting(widgetName) || this.getPlanUseWBEPUFSetting(widgetName);
    }
    getPlanUseGlobalPUFSetting(widgetName) {
        return this.configResource.getProcessedResourceValue('nova_useGlobalPUF', widgetName, false);
    }
    getPlanUseWBEPUFSetting(widgetName) {
        return this.configResource.getProcessedResourceValue('nova_useWBEpuf', widgetName, false);
    }
    getUserTypeFormSettings$(planId, userType, formType) {
        const showUAT = this.getPlanNetworkShowUATSetting();
        const requestParams = { userType, formType, showUAT };
        return this.getPlanEnrollmentSettings$(planId, requestParams).pipe(map(settings => settings.filter(setting => !!setting.formId)));
    }
    getFormSettings$(planId, userType, formType) {
        // This is a clone of getUserTypeFormSettings$, but will return enrollmentsettings even when there is no formId.
        // This is required for cross-sell to determine whether a plan is Internal/External/MessageOnly.
        const showUAT = this.getPlanNetworkShowUATSetting();
        const requestParams = { userType, formType, showUAT };
        return this.getPlanEnrollmentSettings$(planId, requestParams);
    }
    getUpdatedSearchOptionsIfCurrentPlanShortRequest(plan, searchOptions) {
        const currentPlanShort = this.getCurrentPlanShort();
        const searchOptionsWithBeneficiaryPreferences = plan.id === currentPlanShort?.planId
            ? {
                isBeneficiaryPreferences: true,
                ...searchOptions
            }
            : searchOptions;
        return searchOptionsWithBeneficiaryPreferences;
    }
}
PlansService.ɵfac = function PlansService_Factory(t) { return new (t || PlansService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(PlansHttpService), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(RidersService), i0.ɵɵinject(SiteService), i0.ɵɵinject(DateService), i0.ɵɵinject(ProviderService), i0.ɵɵinject(PreferencesService), i0.ɵɵinject(DrugsService), i0.ɵɵinject(PlanYearResourceService), i0.ɵɵinject(CurrencyUtilityService), i0.ɵɵinject(LocaleService), i0.ɵɵinject(StringFormatUtilityService), i0.ɵɵinject(i1$1.NgbModal), i0.ɵɵinject(NavigationService), i0.ɵɵinject(QuoteService)); };
PlansService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PlansService, factory: PlansService.ɵfac, providedIn: 'root' });
__decorate([
    MemoizeObservable()
], PlansService.prototype, "getLoadingMedSupQuestions$", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "getMedSupQuestions$", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "getHasMedSupQuestions$", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "getMedSupAnswers$", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "getLoadingAncillaryQuestions$", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "getAncillaryPlanQuestions$", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "getLoadingHospitalIndemnityQuestions$", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "getHasAncillaryPlanQuestions$", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "getHasVisionPlanQuestions$", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "getAncillaryPlanAnswers$", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "getHasMedSupAnswers$", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "getHasAncillaryPlanAnswers$", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "getHospitalIndemnityQuestions$", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "getHospitalIndemnityAnswers$", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "getHasHospitalIndemnityQuestions$", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "getHasHospitalIndemnityAnswers$", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "getAreAllMedSupQuestionsAnswered$", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "getAreAllAncillaryQuestionsAnswered$", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "getAreAllHospitalIndemnityQuestionsAnswered$", null);
__decorate([
    MemoizeObservable()
    // TODO: just use these? Can refactor to have one path through here if we want to
], PlansService.prototype, "getPlansStateIsDirty$", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "getPlansStateIsLoading$", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "getPlansStateIsLoaded$", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "getPlanCounts$", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "getPlanCount$", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "getPlansLength$", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "getLoadedPlanTypes$", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "getDirtyPlanTypes$", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "getPlansMapByIds$", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "getArePlanTypesDirty$", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "getArePlanTypesLoading$", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "getArePlanTypesLoaded$", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "getAreShortPlansLoading$", null);
__decorate([
    Memoize()
], PlansService.prototype, "getPlanTypesArray", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "loaded$", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "dirty$", null);
__decorate([
    Memoize()
], PlansService.prototype, "isScoredPlanType", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "getPlansByType$", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "getAllPlans$", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "getFilteredPlansBySNPVisibility$", null);
__decorate([
    MemoizeObservable()
], PlansService.prototype, "getPlanSmartReports$", null);
__decorate([
    Memoize()
], PlansService.prototype, "getHospitalIndemnityBasePlan", null);
__decorate([
    Memoize()
], PlansService.prototype, "mergeMedicareTypes", null);
__decorate([
    Memoize()
], PlansService.prototype, "mergeResponseArray", null);
__decorate([
    Memoize()
], PlansService.prototype, "planTypeValueExists", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlansService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }, { type: PlansHttpService }, { type: ConfigResourceService }, { type: RidersService }, { type: SiteService }, { type: DateService }, { type: ProviderService }, { type: PreferencesService }, { type: DrugsService }, { type: PlanYearResourceService }, { type: CurrencyUtilityService }, { type: LocaleService }, { type: StringFormatUtilityService }, { type: i1$1.NgbModal }, { type: NavigationService }, { type: QuoteService }]; }, { getLoadingMedSupQuestions$: [], getMedSupQuestions$: [], getHasMedSupQuestions$: [], getMedSupAnswers$: [], getLoadingAncillaryQuestions$: [], getAncillaryPlanQuestions$: [], getLoadingHospitalIndemnityQuestions$: [], getHasAncillaryPlanQuestions$: [], getHasVisionPlanQuestions$: [], getAncillaryPlanAnswers$: [], getHasMedSupAnswers$: [], getHasAncillaryPlanAnswers$: [], getHospitalIndemnityQuestions$: [], getHospitalIndemnityAnswers$: [], getHasHospitalIndemnityQuestions$: [], getHasHospitalIndemnityAnswers$: [], getAreAllMedSupQuestionsAnswered$: [], getAreAllAncillaryQuestionsAnswered$: [], getAreAllHospitalIndemnityQuestionsAnswered$: [], 
    // TODO: just use these? Can refactor to have one path through here if we want to
    getPlansStateIsDirty$: [], getPlansStateIsLoading$: [], getPlansStateIsLoaded$: [], getPlanCounts$: [], getPlanCount$: [], getPlansLength$: [], getLoadedPlanTypes$: [], getDirtyPlanTypes$: [], getPlansMapByIds$: [], getArePlanTypesDirty$: [], getArePlanTypesLoading$: [], getArePlanTypesLoaded$: [], getAreShortPlansLoading$: [], getPlanTypesArray: [], loaded$: [], dirty$: [], isScoredPlanType: [], getPlansByType$: [], getAllPlans$: [], getFilteredPlansBySNPVisibility$: [], getPlanSmartReports$: [], getHospitalIndemnityBasePlan: [], mergeMedicareTypes: [], mergeResponseArray: [], planTypeValueExists: [] }); })();

// Plan Types product IDs, DELETE with any other product Id, will remove all plans in cart
// Major Medical Product type
// MEDICAL = 1,
// Dental Product Type
// DENTAL = 2,
// Vision Product Type
// VISION = 3,
// Hospital Confinement Product Type
// HC = 8,
const CART_ALL_TYPES_PRODUCT_ID = 0;
class ShoppingCartHttpService {
    constructor(http) {
        this.http = http;
        this.environment = EnvironmentService.getEnvironment();
    }
    savePlanToAPI$(sessionId, planId, crossSellPlanTypes) {
        let params = new HttpParams();
        if (crossSellPlanTypes?.length) {
            const strCrossSellPlanTypes = [];
            crossSellPlanTypes.forEach(typeId => {
                strCrossSellPlanTypes.push(PlanType[typeId]);
            });
            params = params.append('allowedCrossSellPlanTypes', strCrossSellPlanTypes.toString());
        }
        const options = { headers: new HttpHeaders({ Accept: 'application/json' }), params };
        return this.http.post(`${this.environment.MEMBER_SESSION_BASE_URL}/${sessionId}/ShoppingCart/Plan/${planId}`, {}, options);
    }
    async savePlanToAPI(sessionId, planId, crossSellPlanTypes) {
        return this.savePlanToAPI$(sessionId, planId, crossSellPlanTypes).toPromise();
    }
    saveRiderToAPI$(sessionId, riderId, planId) {
        const options = { headers: new HttpHeaders({ Accept: 'application/json' }) };
        return this.http.post(`${this.environment.MEMBER_SESSION_BASE_URL}/${sessionId}/ShoppingCart/Rider/${riderId}?PlanId=${planId}`, {}, options);
    }
    async saveRiderToAPI(sessionId, riderId, planId) {
        return this.saveRiderToAPI$(sessionId, riderId, planId).toPromise();
    }
    removePlanFromAPI$(sessionId, planId) {
        return this.http.delete(`${this.environment.MEMBER_SESSION_BASE_URL}/${sessionId}/ShoppingCart/Plan/${planId}`, {});
    }
    async removePlanFromAPI(sessionId, planId) {
        return this.removePlanFromAPI$(sessionId, planId).toPromise();
    }
    removeRiderFromAPI$(sessionId, riderId, planId) {
        return this.http.delete(`${this.environment.MEMBER_SESSION_BASE_URL}/${sessionId}/ShoppingCart/Rider/${riderId}?PlanId=${planId}`, {});
    }
    async removeRiderFromAPI(sessionId, riderId, planId) {
        return this.removeRiderFromAPI$(sessionId, riderId, planId).toPromise();
    }
    removeAllPlansAndRidersFromAPI$(sessionId) {
        return this.http.delete(`${this.environment.MEMBER_SESSION_BASE_URL}/${sessionId}/ShoppingCart?productID=${CART_ALL_TYPES_PRODUCT_ID}`, {});
    }
    async removeAllPlansAndRidersFromAPI(sessionId) {
        return this.removeAllPlansAndRidersFromAPI$(sessionId).toPromise();
    }
}
ShoppingCartHttpService.ɵfac = function ShoppingCartHttpService_Factory(t) { return new (t || ShoppingCartHttpService)(i0.ɵɵinject(i1$2.HttpClient)); };
ShoppingCartHttpService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ShoppingCartHttpService, factory: ShoppingCartHttpService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ShoppingCartHttpService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1$2.HttpClient }]; }, null); })();

class ShoppingCartService {
    constructor(store, shoppingCartHttpService, plansService, configResourceService, externalErrorLoggingService) {
        this.store = store;
        this.shoppingCartHttpService = shoppingCartHttpService;
        this.plansService = plansService;
        this.configResourceService = configResourceService;
        this.externalErrorLoggingService = externalErrorLoggingService;
    }
    getLoadingStatus$(planType) {
        return this.store.select(PlansState.loading(planType));
    }
    getPlan$(planId) {
        return this.store.select(ShoppingCartState.selectedPlanById(planId));
    }
    getPlan(planId) {
        return this.store.selectSnapshot(ShoppingCartState.selectedPlanById(planId));
    }
    getSelectedPlan() {
        return this.store.selectSnapshot(ShoppingCartState.selectedPlan);
    }
    getSelectedPlan$() {
        return this.store.select(ShoppingCartState.selectedPlan);
    }
    getPlanExtraDataById(planId, extraDataKey) {
        const allPlans = this.plansService.getAllPlans();
        const foundPlan = allPlans.find(plan => plan.id === planId);
        return this.plansService.getExtraDataValueByName(foundPlan, extraDataKey);
    }
    getSelectedPlans() {
        return this.store.selectSnapshot(ShoppingCartState.selectedPlans);
    }
    areAllSelectedExternallyRatedPlansExternallyRated$() {
        return this.getSelectedPlans$().pipe(map((selectedPlans) => {
            return (!!selectedPlans?.every(selectedPlan => {
                return !this.plansService.planRequiresExternalRating(selectedPlan) || selectedPlan.hasBeenExternallyRated;
            }) ?? true);
        }));
    }
    getShoppingCartPlans() {
        return this.store.selectSnapshot(ShoppingCartState.selectCartAPIState);
    }
    getSelectedPlanCount() {
        return this.getSelectedPlans()?.length ?? 0;
    }
    getEnrollmentPlanCount() {
        const enrollmentPlanCount = this.store.selectSnapshot(EnrollmentState.enrollmentPlanCount);
        if (enrollmentPlanCount === -1) {
            return this.getSelectedPlanCount();
        }
        return enrollmentPlanCount;
    }
    getSelectedPlans$() {
        return this.store.select(ShoppingCartState.selectedPlans);
    }
    getSelectedPlanIds() {
        return this.store.selectSnapshot(ShoppingCartState.selectedPlanIds);
    }
    getSelectedPlanIds$() {
        return this.store.select(ShoppingCartState.selectedPlanIds);
    }
    getSelectedPlanRiders(planId) {
        return this.store.selectSnapshot(ShoppingCartState.selectedPlanRiders(planId));
    }
    getSelectedRiders$() {
        return this.store.select(ShoppingCartState.selectedRiders);
    }
    getSelectedRiderIds() {
        return this.store.selectSnapshot(ShoppingCartState.selectedRiderIds);
    }
    getSelectedRiderIds$() {
        return this.store.select(ShoppingCartState.selectedRiderIds);
    }
    getEffectiveDate$() {
        // a null date allows new Date(date) to provide the current date, while undefined or '' would result in invalid date
        return this.plansService.getMedSupAnswers$().pipe(map(answers => (answers.EffectiveDate ? answers.EffectiveDate : null)));
    }
    getShoppingCartPlanIds() {
        return this.store.selectSnapshot(ShoppingCartState.shoppingCartPlanIds);
    }
    getShoppingCartPlanTypeAbbreviations() {
        return this.store.selectSnapshot(ShoppingCartState.shoppingCartPlanTypeAbbreviations);
    }
    getShoppingCartPlanTypes() {
        const shoppingCartPlanTypeAbbreviations = this.getShoppingCartPlanTypeAbbreviations();
        return (shoppingCartPlanTypeAbbreviations?.map(cartPlanTypeAbbreviation => this.plansService.getPlanType(cartPlanTypeAbbreviation)) ?? []);
    }
    hasPlansInCart() {
        return !!this.getShoppingCartPlanTypes()?.length;
    }
    async selectPlan(plan) {
        const sessionId = this.store.selectSnapshot(MemberState.sessionId);
        this.store.dispatch(new SelectPlan(plan));
        try {
            await this.shoppingCartHttpService.savePlanToAPI(sessionId, plan.id);
        }
        catch (error) {
            // PC API STB: Most common error is "Status 400: INVALID_REQUEST_PLAN_ALREADY_IN_CART"
            this.externalErrorLoggingService.log(error);
        }
    }
    async selectPlanWithBundle(plan) {
        const sessionId = this.store.selectSnapshot(MemberState.sessionId);
        const selectedPlans = this.getSelectedPlans();
        const plansSelectedRiders = this.getPlanSelectedRiders(plan);
        const riders = PlansUtilityService.getRiderData(plan);
        const newItem = PlansUtilityService.createShoppingCartEntry(plan, riders);
        const crossSellPlanTypes = [PlanType.PDP, PlanType.MEDIGAP];
        // If current plan is in cart.
        const isPlanCrossSell = crossSellPlanTypes.includes(plan.planType);
        const isCartEmpty = selectedPlans.length === 0;
        if (isCartEmpty) {
            this.store.dispatch(new SelectPlanWithBundle(plan, newItem, plansSelectedRiders));
            await this.shoppingCartHttpService.savePlanToAPI(sessionId, plan.id);
        }
        else {
            await this.updateBundlePlan(plan, selectedPlans, isPlanCrossSell, newItem, plansSelectedRiders, sessionId, crossSellPlanTypes);
        }
    }
    async selectRider(riderId, planId) {
        const sessionId = this.store.selectSnapshot(MemberState.sessionId);
        this.store.dispatch(new SelectRider(riderId));
        await this.shoppingCartHttpService.saveRiderToAPI(sessionId, riderId, planId);
    }
    removePlan(planId) {
        const sessionId = this.store.selectSnapshot(MemberState.sessionId);
        this.store.dispatch(new RemovePlan(planId));
        this.shoppingCartHttpService.removePlanFromAPI(sessionId, planId);
    }
    removeRider(riderId, planId) {
        const sessionId = this.store.selectSnapshot(MemberState.sessionId);
        this.store.dispatch(new RemoveRider(riderId));
        this.removeRiderFromPlanAndUpdateEnrollment(planId, riderId);
        this.shoppingCartHttpService.removeRiderFromAPI(sessionId, riderId, planId);
    }
    removePlanFromAPI(planId) {
        const sessionId = this.store.selectSnapshot(MemberState.sessionId);
        this.shoppingCartHttpService.removePlanFromAPI(sessionId, planId);
    }
    removeAllPlansFromApi() {
        const sessionId = this.store.selectSnapshot(MemberState.sessionId);
        this.shoppingCartHttpService.removeAllPlansAndRidersFromAPI(sessionId);
    }
    getShoppingCartPremium(plan, riders, showAsAnnual = false) {
        const selectedPlan = plan ?? this.getSelectedPlan();
        if (selectedPlan) {
            const selectedRiders = riders ?? this.getSelectedPlanRiders(selectedPlan.id);
            return this.plansService.getTotalPremium([selectedPlan], selectedRiders, showAsAnnual);
        }
        return null;
    }
    updateCartPlanPremium(planId, medicalPremium, drugPremium) {
        this.store.dispatch(new UpdateShoppingCartPlanPremium(planId, medicalPremium, drugPremium));
    }
    rehydrateCartPlanInfo() {
        const shoppingCartPlan = this.getSelectedPlan();
        if (shoppingCartPlan) {
            this.plansService.fetchAndUpdatePlanDetails(shoppingCartPlan);
        }
    }
    resetEnrollmentState(overrideDefaults) {
        this.store.dispatch(new ResetEnrollmentState(overrideDefaults));
    }
    clearShoppingCart() {
        this.store.dispatch(new RemovePlans());
        this.removeAllPlansFromApi();
    }
    getPlanSelectedRiders(plan) {
        return plan?.riders?.filter(rider => rider.isRequiredRider) ?? [];
    }
    getBothPlansExternalModalTitle(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_CrossSell_BothPlansExternalModal_Title', widgetName, 'Attention!');
    }
    getBothPlansExternalModalCloseText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_CrossSell_BothPlansExternalModal_Close', widgetName, 'Close');
    }
    getBothPlansExternalModalMessage(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_CrossSell_BothPlansExternalModal_Message', widgetName, 'Both plans in your cart require enrollment in an external site.  ' +
            'After you enroll in your first plan, you may need to return to your cart on this site to enroll in the next plan.');
    }
    getEnrollmentTypeFlag(crossSellPlanEnrollmentAttributes) {
        // Set the appropriate value based on the enrollment types of the plans selected for cross-sell enrollment
        // This will be used to determine which plan will be selected for enrollment first
        if (this.getEnrollmentAttributesByType(crossSellPlanEnrollmentAttributes, EnrollmentType.INTERNAL).length === 2) {
            return CrossSellEnrollmentTypes.BOTH_INTERNAL;
        }
        if (this.getEnrollmentAttributesByType(crossSellPlanEnrollmentAttributes, EnrollmentType.EXTERNAL).length === 2) {
            return CrossSellEnrollmentTypes.BOTH_EXTERNAL;
        }
        if (this.getEnrollmentAttributesByType(crossSellPlanEnrollmentAttributes, EnrollmentType.MESSAGE_ONLY).length === 2) {
            return CrossSellEnrollmentTypes.BOTH_MESSAGE;
        }
        if (this.getEnrollmentAttributesByType(crossSellPlanEnrollmentAttributes, EnrollmentType.INTERNAL).length === 1) {
            return CrossSellEnrollmentTypes.ONE_INTERNAL;
        }
        if (this.getEnrollmentAttributesByType(crossSellPlanEnrollmentAttributes, EnrollmentType.EXTERNAL).length === 1 &&
            this.getEnrollmentAttributesByType(crossSellPlanEnrollmentAttributes, EnrollmentType.MESSAGE_ONLY).length === 1) {
            return CrossSellEnrollmentTypes.EXTERNAL_AND_MESSAGE;
        }
    }
    getUserFormTypeFlag(crossSellPlanEnrollmentAttributes) {
        // Set the appropriate value based on the User form types of the plans selected for cross-sell enrollment
        // This will be used to determine which plan will be selected for enrollment first
        if (crossSellPlanEnrollmentAttributes.filter(planEnrollmentAttributes => planEnrollmentAttributes.userFormType === UserTypeKeys.CONSUMER)
            .length === 2) {
            return CrossSellSendToBeneficiaryOptions.BOTH_SENDTOBENE;
        }
        if (crossSellPlanEnrollmentAttributes.filter(planEnrollmentAttributes => planEnrollmentAttributes.userFormType === UserTypeKeys.CONSUMER)
            .length === 1) {
            return CrossSellSendToBeneficiaryOptions.ONE_SENDTOBENE;
        }
        return CrossSellSendToBeneficiaryOptions.NO_SENDTOBENE;
    }
    isMedicarePlan(plan) {
        return plan.planType === PlanType.MA || plan.planType === PlanType.MAPD || plan.planType === PlanType.PDP;
    }
    isMultiCarrierSite(widgetName) {
        return !this.configResourceService.getProcessedResourceValue('Spa_Site_SingleCarrier', widgetName, true);
    }
    allowsCallRecordingOnMultiCarrier(planId) {
        return this.getPlanExtraDataById(planId, PlanExtraDataKey.ALLOW_CALL_RECORDING_MC) === SITE_YES_VALUE;
    }
    isCartEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_ShoppingCart_Enabled', widgetName, true);
    }
    isDeepLinkingEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_IsDeepLinking_Enabled', widgetName, false);
    }
    getMedSupUnavailableMessage(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_ShoppingCart_MedSupUnavailable_Message', widgetName, 'Enrollment in Medicare Supplemental plans is not currently available.  Please come back soon to enroll in your plan.');
    }
    getEnrollmentUnavailableMessage(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_ShoppingCart_EnrollmentUnavailable_Message', widgetName, 'The annual enrollment period opens on October 15th. Please come back at that time to apply for coverage.');
    }
    isPDPCrossSell(plan, cartPlans, cartSettings) {
        return (cartSettings.isAddToCartEnabled &&
            cartSettings.isCrossSellingEnabled && // Note: MedSupEnrollment already enabled
            this.isPlanMedSup(plan) &&
            this.plansService.hasPDPPlans() && // We only show the modal if we have PDP plans
            this.isPDPNotAlreadyInCart(cartPlans) && // and there is already no PDP in the cart
            this.isMedSupNotAlreadyInCart(cartPlans) && // and if the current MedSup plan is not in the cart.
            this.hasMedSupAndPartDTabs() // and we currently are showing both MedSup and Part D tabs.
        );
    }
    isMedSupCrossSell(plan, cartPlans, cartSettings) {
        return (cartSettings.isAddToCartEnabled &&
            cartSettings.isCrossSellingEnabled &&
            cartSettings.isMedSupEnrollmentEnabled &&
            this.isPlanPDP(plan) && // If current selection is PDP and cross sell enabled,
            this.plansService.hasMedSupPlans() && // show MedSup cross sell modal if we have Medsup plans,
            this.isMedSupNotAlreadyInCart(cartPlans) && // assuming no MedSup plans in cart
            this.isPDPNotAlreadyInCart(cartPlans) && // if no current PDP selection in cart
            this.hasMedSupAndPartDTabs() // and if currently showing both MedSup and Part D tabs.
        );
    }
    isShoppingCartCrossSellEnrollment(shoppingCartPlanTypes) {
        return (this.isCrossSellingEnabled() &&
            this.isMedSupEnrollmentEnabled() &&
            this.isMedSupAndPDPInCart(shoppingCartPlanTypes) &&
            this.hasMedSupAndPartDTabs());
    }
    isMedSupAndPDPInCart(shoppingCartPlanTypes) {
        const planTypesInCart = shoppingCartPlanTypes.map(({ planType }) => planType);
        const isPDPInCart = planTypesInCart.includes(PlanTypeAbbreviation.PDP);
        const isMedSupInCart = planTypesInCart.includes(PlanTypeAbbreviation.MEDIGAP);
        return isPDPInCart && isMedSupInCart;
    }
    isPDPNotAlreadyInCart(cartPlans) {
        return !this.isPDPInCart(cartPlans);
    }
    isMedSupNotAlreadyInCart(cartPlans) {
        return !this.isMedSupInCart(cartPlans);
    }
    getCrossSellPlanInCart(cartPlans) {
        return cartPlans.find(plan => CROSS_SELL_PLANS.includes(plan.planType));
    }
    hasMedSupAndPartDTabs() {
        const tabTypes = this.plansService.getActiveTabTypes();
        return tabTypes.includes(PlanTypeAbbreviation.MEDIGAP) && tabTypes.includes(PlanTypeAbbreviation.PDP);
    }
    isPlanPDP(plan) {
        return plan?.planType === PlanType.PDP;
    }
    isPlanAncillary(plan) {
        return ANCILLARY_PLAN_TYPES.includes(plan.planType);
    }
    isPlanMedSup(plan) {
        return plan?.planType === PlanType.MEDIGAP;
    }
    isPlanMAPD(plan) {
        return plan?.planType === PlanType.MAPD;
    }
    isPlanMA(plan) {
        return plan?.planType === PlanType.MA;
    }
    isPDPInCart(cartPlans) {
        return cartPlans.some(plan => this.isPlanPDP(plan));
    }
    isMedSupInCart(cartPlans) {
        return cartPlans.some(plan => this.isPlanMedSup(plan));
    }
    isSelectedPlanInCart(selectedPlan, cartPlans) {
        return cartPlans.some(plan => plan.id === selectedPlan.id);
    }
    arePlansInCartAncillary(cartPlans) {
        return cartPlans?.every(plan => ANCILLARY_PLAN_SUBTYPES.includes(plan.planSubType));
    }
    getPlansInCartNotAncillary(cartPlans) {
        return cartPlans?.filter(plan => !ANCILLARY_PLAN_SUBTYPES.includes(plan.planSubType)) ?? [];
    }
    isEnrollmentEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Enrollment_Enabled', widgetName, true);
    }
    isMedSupEnrollmentEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_MedSupEnrollment_Enabled', widgetName, true);
    }
    isDentalEnrollmentEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_DentalEnrollment_Enabled', widgetName, false);
    }
    isVisionEnrollmentEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_VisionEnrollment_Enabled', widgetName, false);
    }
    isHIPEnrollmentEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_HIPEnrollment_Enabled', widgetName, false);
    }
    isEnrollmentEnabledByPlanType(planType, widgetName) {
        switch (planType) {
            case PlanType.MA:
            case PlanType.MAPD:
            case PlanType.PDP:
                return this.isEnrollmentEnabled(widgetName);
            case PlanType.MEDIGAP:
                return this.isMedSupEnrollmentEnabled(widgetName);
            case PlanType.DENTAL:
                return this.isDentalEnrollmentEnabled(widgetName);
            case PlanType.VISION:
                return this.isVisionEnrollmentEnabled(widgetName);
            case PlanType.HC:
                return this.isHIPEnrollmentEnabled(widgetName);
            default:
                return false;
        }
    }
    isCrossSellingEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_CrossSell_Enabled', widgetName, false);
    }
    async addPlan(selectedPlans, plan) {
        // Avoid setting plan (calling Update Plan action) if plan already set in cart to avoid 400 error
        const isAlreadySelected = selectedPlans.some(cartPlan => cartPlan.id === plan.id && cartPlan.annualPlanPremium === plan.annualPlanPremium);
        if (!isAlreadySelected) {
            if (this.isCrossSellingEnabled()) {
                await this.selectPlanWithBundle(plan);
            }
            else {
                this.selectPlan(plan);
            }
        }
        this.plansService.fetchAndUpdatePlanDetails(plan, undefined, undefined, undefined, undefined, undefined, this.isCrossSellingEnabled());
    }
    isMedigapInterimPageEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('SPA_Site_Medigap_Enrollment_InterimPage_Enable', widgetName, true);
    }
    getEnrollmentAttributesByType(attributes, type) {
        return attributes.filter(attribute => attribute.enrollmentType === type);
    }
    async updateBundlePlan(plan, selectedPlans, isPlanCrossSell, newItem, plansSelectedRiders, sessionId, crossSellPlanTypes) {
        if (plan) {
            // SPA-13855, cart analytics was firing with wrong selected plans value
            // We are able to have multiple dental or vision plans at once, so we need to account for that when deciding update vs insert
            // Updating somehow eventually ended up with the right data in the end, but with extra steps
            const updatePlan = selectedPlans.some(cartPlan => cartPlan.planType === plan.planType && plan.planType !== PlanType.DENTAL && plan.planType !== PlanType.VISION);
            if (updatePlan) {
                this.store.dispatch(new UpdatePlanWithBundle(plan, newItem, plansSelectedRiders));
            }
            else {
                this.store.dispatch(new InsertPlanWithBundle(plan, newItem, plansSelectedRiders));
            }
            await this.shoppingCartHttpService.savePlanToAPI(sessionId, plan.id, isPlanCrossSell ? crossSellPlanTypes : null);
        }
    }
    // Update enrollment in store with removed Rider
    removeRiderFromPlanAndUpdateEnrollment(planId, riderId) {
        const currentMemberEnrollmentsInStoreRiderRemoved = this.removeRiderFromPlan(this.store.selectSnapshot(MemberState.memberEnrollments), planId, riderId);
        this.store.dispatch(new UpdateMemberEnrollments([...currentMemberEnrollmentsInStoreRiderRemoved]));
    }
    removeRiderFromPlan(memberEnrollments, planId, riderId) {
        return memberEnrollments.map(enrollment => {
            let resultEnrollment = enrollment;
            if (enrollment.planID === planId) {
                const selectedRiderIDs = enrollment.selectedRiderIDs?.filter(selectedRiderID => selectedRiderID !== riderId);
                resultEnrollment = {
                    ...enrollment,
                    selectedRiderIDs
                };
            }
            return resultEnrollment;
        });
    }
}
ShoppingCartService.ɵfac = function ShoppingCartService_Factory(t) { return new (t || ShoppingCartService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(ShoppingCartHttpService), i0.ɵɵinject(PlansService), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(ExternalErrorLoggingService)); };
ShoppingCartService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ShoppingCartService, factory: ShoppingCartService.ɵfac, providedIn: 'root' });
__decorate([
    Memoize()
], ShoppingCartService.prototype, "removeRiderFromPlan", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ShoppingCartService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }, { type: ShoppingCartHttpService }, { type: PlansService }, { type: ConfigResourceService }, { type: ExternalErrorLoggingService }]; }, { removeRiderFromPlan: [] }); })();

// this service holds transient data needed for GI reasons
class GuaranteedIssueReasonsContextService {
    constructor(configResourceService) {
        this.configResourceService = configResourceService;
    }
    getNullReason() {
        return {
            keyName: GIREASONS_NO_REASON_KEY,
            labelText: null,
            selectedValue: 'Y',
            unSelectedValue: 'N',
            category: this.configResourceService.getProcessedResourceValue('Spa_MedSup_GIAdditionalNoneOfThese_Text', null, 'None of these')
        };
    }
    getGuaranteedIssueReasons() {
        const reasons = this.configResourceService.getProcessedResourceValue('Spa_Site_Guaranteed_Issue_Reasons', null, [
            {
                keyName: 'GIReason1',
                labelText: 'You turned age 65 and enrolled in Medicare Part B in the last 6 months. OR You will turn age 65 and enroll in Medicare Part B within the next 6 months, on or before the effective date you selected above.',
                selectedValue: 'Y',
                unSelectedValue: 'N',
                category: 'I am new to medicare',
                ordinal: 1,
                display: true
            },
            {
                keyName: 'GIReason2',
                labelText: "You are losing coverage from a Medicare Advantage plan because your plan is leaving Medicare or stops giving care in your area, or you move out of the plan's service area.",
                selectedValue: 'Y',
                unSelectedValue: 'N',
                category: 'I am moving',
                ordinal: 2,
                display: true
            },
            {
                keyName: 'GIReason3',
                labelText: 'You have Original Medicare and an employer group health plan or union coverage that pays after Medicare pays and that plan is ending.',
                selectedValue: 'Y',
                unSelectedValue: 'N',
                category: 'I am losing coverage',
                ordinal: 3,
                display: true
            },
            {
                keyName: 'GIReason4',
                labelText: "You have Original Medicare and a Medicare SELECT policy. You are moving or have moved out of the Medicare SELECT policy's service area.",
                selectedValue: 'Y',
                unSelectedValue: 'N',
                category: 'I am losing coverage',
                ordinal: 4,
                display: true
            },
            {
                keyName: 'GIReason5',
                labelText: 'You joined a Medicare Advantage Plan or Programs of All-inclusive Care for the Elderly (PACE) when you were first eligible for Medicare Part A at 65, and within the first year of joining, you decided you want to switch to Original Medicare.',
                selectedValue: 'Y',
                unSelectedValue: 'N',
                category: 'I changed my mind',
                ordinal: 5,
                display: true
            },
            {
                keyName: 'GIReason6',
                labelText: 'You dropped a Medicare Supplement policy to join a Medicare Advantage Plan (or to switch to a Medicare SELECT policy) for the first time; you have been in the plan less than a year, and you want to switch back.',
                selectedValue: 'Y',
                unSelectedValue: 'N',
                category: 'I changed my mind',
                ordinal: 6,
                display: true
            },
            {
                keyName: 'GIReason7',
                labelText: 'You are leaving a Medicare Advantage Plan or are dropping a Medicare Supplement policy because the company has not followed the rules, or it misled you.',
                selectedValue: 'Y',
                unSelectedValue: 'N',
                category: 'I changed my mind',
                ordinal: 7,
                display: true
            },
            {
                keyName: 'GIReason8',
                labelText: 'Your Medicare Supplement insurance company has gone or is going bankrupt and you lost or are losing your coverage, or your Medicare Supplement policy otherwise has ended or is ending through no fault of your own.',
                selectedValue: 'Y',
                unSelectedValue: 'N',
                category: 'I changed my mind',
                ordinal: 8,
                display: true
            },
            {
                keyName: 'GIReason9',
                labelText: '',
                selectedValue: 'Y',
                unSelectedValue: 'N',
                category: '',
                ordinal: 9,
                display: false
            },
            {
                keyName: 'GIReason10',
                labelText: '',
                selectedValue: 'Y',
                unSelectedValue: 'N',
                category: '',
                ordinal: 10,
                display: false
            },
            {
                keyName: 'GIReason11',
                labelText: '',
                selectedValue: 'Y',
                unSelectedValue: 'N',
                category: '',
                ordinal: 11,
                display: false
            },
            {
                keyName: 'GIReason12',
                labelText: '',
                selectedValue: 'Y',
                unSelectedValue: 'N',
                category: '',
                ordinal: 12,
                display: false
            },
            {
                keyName: 'GIReason13',
                labelText: '',
                selectedValue: 'Y',
                unSelectedValue: 'N',
                category: '',
                ordinal: 13,
                display: false
            },
            {
                keyName: 'GIReason14',
                labelText: '',
                selectedValue: 'Y',
                unSelectedValue: 'N',
                category: '',
                ordinal: 14,
                display: false
            },
            {
                keyName: 'GIReason15',
                labelText: '',
                selectedValue: 'Y',
                unSelectedValue: 'N',
                category: '',
                ordinal: 15,
                display: false
            }
        ]);
        reasons.push(this.getNullReason());
        return reasons;
    }
}
GuaranteedIssueReasonsContextService.ɵfac = function GuaranteedIssueReasonsContextService_Factory(t) { return new (t || GuaranteedIssueReasonsContextService)(i0.ɵɵinject(ConfigResourceService)); };
GuaranteedIssueReasonsContextService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: GuaranteedIssueReasonsContextService, factory: GuaranteedIssueReasonsContextService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GuaranteedIssueReasonsContextService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ConfigResourceService }]; }, null); })();

class MedSupService {
    constructor(configResource, store, navigationService, giReasonsContextService, shoppingCartService, plansService, planYearResourceService) {
        this.configResource = configResource;
        this.store = store;
        this.navigationService = navigationService;
        this.giReasonsContextService = giReasonsContextService;
        this.shoppingCartService = shoppingCartService;
        this.plansService = plansService;
        this.planYearResourceService = planYearResourceService;
        this.medSupFormOpenSource$ = new BehaviorSubject(false);
        this.dentalVisionFormOpenSource$ = new BehaviorSubject(false);
        this.medSupFormOpen$ = this.medSupFormOpenSource$.asObservable();
        this.dentalVisionFormOpen$ = this.dentalVisionFormOpenSource$.asObservable();
        this.setIsMedSupPlanRestrictedByAge();
        this.setIsPlanRestrictedByEffectiveDateRange();
    }
    getIsMedSupPlanRestrictedByAge(widgetName) {
        return this.configResource.getProcessedResourceValue('Spa_MedSup_RestrictMedSupPlansByAge', widgetName, true);
    }
    getIsPlanRestrictedByEffectiveDateRange(widgetName) {
        return this.configResource.getProcessedResourceValue('Spa_MedSup_EffectiveDate_Restriction_Enabled', widgetName, false);
    }
    getIsTurning65AtEffectiveDateMessagingEnabled(widgetName) {
        return this.configResource.getProcessedResourceValue('Spa_MedSup_ShowTurning65AtEffectiveDateMessage_Enabled', widgetName, false);
    }
    getIsAncillaryPlansEnabled() {
        return this.plansService.getIsDentalEnabled() || this.plansService.getIsVisionEnabled();
    }
    getIsHospitalIndemnityPlansEnabled() {
        return this.plansService.getIsHospitalIndemnityEnabled();
    }
    allowEnrollment$(plan) {
        if (plan === undefined || plan === null) {
            return of(false);
        }
        if (this.isHospitalIndemnityPlan(plan)) {
            return of(this.configResource.getProcessedResourceValue('Spa_Site_HIPEnrollment_Enabled', null, false));
        }
        if (plan.planTypeAbbreviation === PlanTypeAbbreviation.DENTAL) {
            return of(this.configResource.getProcessedResourceValue('Spa_Site_DentalEnrollment_Enabled', null, false));
        }
        if (plan.planTypeAbbreviation === PlanTypeAbbreviation.VISION) {
            return of(this.configResource.getProcessedResourceValue('Spa_Site_VisionEnrollment_Enabled', null, false));
        }
        return this.store.select(MedSupState.formField('DateOfBirth')).pipe(map(dob => 
        // allow enrollment if not a medsup plan, or
        !this.isMedSupPlan(plan) ||
            // if effective date restriction is enabled and we can enroll in MedSup plans, or
            (this.isPlanRestrictedByEffectiveDateRange && this.canEnrollInMedSupPlansByEffectiveDate()) ||
            // if restriction by age enabled and can enroll, or
            (this.isMedSupPlanRestrictedByAge && this.canEnrollInMedSupPlansByAge(dob)) ||
            // if isMedSupPlanRestrictedByAge is false (base site default), and not restricted by effectiveDate
            (!this.isMedSupPlanRestrictedByAge && !this.isPlanRestrictedByEffectiveDateRange)));
    }
    setMedSupFormOpenSource(isOpen) {
        this.medSupFormOpenSource$.next(isOpen);
    }
    showMedSupEffectiveDateRestrictionBanner$() {
        return combineLatest(this.store.select(MedSupState.formField('EffectiveDate')), this.store.select(PlansState.activeTabType), this.getHasMedSupAnswers$(), this.medSupFormOpen$).pipe(map(([effectiveDate, activeTab, hasAnswers, formIsOpen]) => hasAnswers &&
            this.isPlanRestrictedByEffectiveDateRange &&
            activeTab === PlanTypeAbbreviation.MEDIGAP &&
            !this.canEnrollInMedSupPlansByEffectiveDate(effectiveDate) &&
            !formIsOpen));
    }
    showMedSupAgeRestrictionBanner$() {
        return combineLatest(this.store.select(MedSupState.formField('DateOfBirth')), this.store.select(PlansState.activeTabType), this.getHasMedSupAnswers$(), this.medSupFormOpen$).pipe(map(([dob, activeTab, hasAnswers, formIsOpen]) => hasAnswers &&
            this.isMedSupPlanRestrictedByAge &&
            activeTab === PlanTypeAbbreviation.MEDIGAP &&
            !this.canEnrollInMedSupPlansByAge(dob) &&
            !formIsOpen));
    }
    showTurning65AtEffectiveDateMessage$() {
        return combineLatest(this.store.select(MedSupState.formField('DateOfBirth')), this.store.select(MedSupState.formField('EffectiveDate')), this.store.select(PlansState.activeTabType)).pipe(map(([dateOfBirth, effectiveDate, activeTab]) => activeTab === PlanTypeAbbreviation.MEDIGAP && this.showTurning65AtEffectiveDateMessage(dateOfBirth, effectiveDate)));
    }
    fetchMedSupQuestions() {
        if (this.plansService.isMedigapEnabled()) {
            const fipsCode = this.store.selectSnapshot(DemographicState.selectedFipsCode);
            const zipCode = this.store.selectSnapshot(DemographicState.selectedZipCode);
            const year = this.planYearResourceService.getSelectedPlanYear();
            const effectiveDate = DateUtilities.getFormattedCurrentDate(); // TODO: get effectiveDate
            const isPartAEnabled = this.configResource.getProcessedResourceValue('Spa_Site_PartAEnabled') === true;
            this.store.dispatch(new FetchMedSupQuestions(zipCode, fipsCode, year, effectiveDate, isPartAEnabled));
        }
    }
    fetchDentalVisionQuestions() {
        this.plansService.fetchPlanQuestions();
    }
    getLoadingMedSupQuestions$() {
        return this.plansService.getLoadingMedSupQuestions$();
    }
    getMedSupQuestions$() {
        return this.plansService.getMedSupQuestions$();
    }
    getMedSupQuestion(id) {
        return this.plansService.getMedSupQuestion(id);
    }
    getMedSupQuestions() {
        return this.plansService.getMedSupQuestions();
    }
    getHasMedSupQuestions$() {
        return this.plansService.getHasMedSupQuestions$();
    }
    getMedSupAnswers$() {
        return this.plansService.getMedSupAnswers$();
    }
    getMedSupAnswers() {
        return this.plansService.getMedSupAnswers();
    }
    getMemberMedigapAnswers() {
        return this.store.selectSnapshot(MemberState.medigapAnswers);
    }
    getHasMedSupAnswers$() {
        return this.plansService.getHasMedSupAnswers$();
    }
    getHasMedSupAnswers() {
        return this.plansService.getHasMedSupAnswers();
    }
    getAncillaryQuestions$() {
        return this.plansService.getAncillaryPlanQuestions$();
    }
    getAncillaryQuestions() {
        return this.plansService.getAncillaryPlanQuestions();
    }
    getAncillaryAnswers$() {
        return this.plansService.getAncillaryPlanAnswers$();
    }
    getAncillaryAnswers() {
        return this.plansService.getAncillaryPlanAnswers();
    }
    getHasAncillaryQuestions$() {
        return this.plansService.getHasAncillaryPlanQuestions$();
    }
    getHasAncillaryAnswers$() {
        return this.plansService.getHasAncillaryPlanAnswers$();
    }
    getHasAncillaryAnswers() {
        return this.plansService.getHasAncillaryPlanAnswers();
    }
    getHasHospitalIndemnityQuestions$() {
        return this.plansService.getHasHospitalIndemnityQuestions$();
    }
    getHasHospitalIndemnityQuestions() {
        return this.plansService.getHasHospitalIndemnityQuestions();
    }
    getHasHospitalIndemnityAnswers$() {
        return this.plansService.getHasHospitalIndemnityAnswers$();
    }
    getIsGIReasonSelected(reasonName) {
        return this.store.selectSnapshot(MedSupState.isGIReasonSelected(reasonName));
    }
    updateMedSupFormOpen(isOpen) {
        if (isOpen) {
            this.fetchMedSupQuestions();
        }
        this.setMedSupFormOpenSource(isOpen);
    }
    updateDentalVisionFormOpen(isOpen) {
        if (isOpen) {
            this.fetchDentalVisionQuestions();
        }
        this.dentalVisionFormOpenSource$.next(isOpen);
    }
    navigateToMedSupForm() {
        this.updateMedSupFormOpen(true);
        this.store.dispatch(new SetActiveTab(PlanTypeAbbreviation.MEDIGAP));
        // Set override flag to false so we land on the ActiveTab set above (Medigap)
        this.plansService.setOverrideActiveTab(false);
        this.navigationService.navigateByPageTag(PageTags.PLAN_LIST);
    }
    navigateToDentalVisionForm(planTypeAbbreviation) {
        this.updateDentalVisionFormOpen(true);
        this.store.dispatch(new SetActiveTab(planTypeAbbreviation));
        // Set override flag to false so we land on the ActiveTab set above (Dental or Vision)
        this.plansService.setOverrideActiveTab(false);
        this.navigationService.navigateByPageTag(PageTags.PLAN_LIST);
    }
    resetActiveTabToDefault() {
        const defaultTabType = this.store.selectSnapshot(PlansState.defaultTabType);
        this.store.dispatch(new SetActiveTab(defaultTabType));
    }
    isMedSupPlan(plan) {
        return plan.planType === PlanType.MEDIGAP;
    }
    isDentalVisionPlan(plan) {
        return [PlanType.DENTAL, PlanType.VISION].includes(plan.planType);
    }
    isHospitalIndemnityPlan(plan) {
        return plan.planType === PlanType.HC;
    }
    areAllMedSupQuestionsAnswered() {
        return this.store.selectSnapshot(MedSupState.areAllMedSupQuestionsAnswered);
    }
    hasPremium$(plan) {
        if (this.isMedSupPlan(plan)) {
            return this.getHasMedSupAnswers$();
        }
        if (this.isDentalVisionPlan(plan)) {
            return this.getHasAncillaryAnswers$();
        }
        if (this.isHospitalIndemnityPlan(plan)) {
            return this.getHasHospitalIndemnityAnswers$();
        }
        return of(true);
    }
    getEffectiveDate() {
        const effectiveDate = this.store.selectSnapshot(MedSupState.formField('EffectiveDate'));
        return effectiveDate ? effectiveDate : null;
    }
    getDateOfBirth() {
        return this.store.selectSnapshot(MedSupState.formField('DateOfBirth'));
    }
    getSelectedGIReasons(selectedGIReason) {
        const giReasons = this.giReasonsContextService.getGuaranteedIssueReasons();
        return giReasons.map(giReason => {
            const selected = giReason.keyName === selectedGIReason;
            return {
                name: giReason.keyName,
                selected,
                value: selected ? giReason.selectedValue : giReason.unSelectedValue
            };
        });
    }
    saveSelectedGIReasons(selectedGIReasons) {
        this.store.dispatch(new SaveGIReasons(selectedGIReasons));
        // TODO: Verify that GI is only MEDIGAP
        this.store.dispatch(new SetPlansDirty(true, [PlanType.MEDIGAP]));
    }
    hasGIReasons() {
        return this.store.selectSnapshot(MedSupState.hasGIReasons);
    }
    getGIReasons() {
        return this.store.selectSnapshot(MedSupState.giReasons);
    }
    nonNullGIReasonIsSelected() {
        return !(this.hasGIReasons() && this.getIsGIReasonSelected(GIREASONS_NO_REASON_KEY));
    }
    updateSelectedGIReasons() {
        const reasons = this.getGIReasons();
        if (reasons?.length === 0) {
            const medigapAnswers = this.getMemberMedigapAnswers();
            const selectedGIReasons = this.getSelectedGIReasons(medigapAnswers.medigap_GaranteeIssue_AdvancedSetting_SelectedAnswer);
            this.saveSelectedGIReasons(selectedGIReasons);
        }
    }
    async selectMedSupQuestions(sessionId, year, questions, millimanHealthInformation) {
        const effectiveDateQuestion = questions.find(question => question.questionId === MedSupPlanQuestionIds.EffectiveDate);
        let effectiveDate = DateUtilities.getFormattedCurrentDate();
        if (effectiveDateQuestion?.value) {
            effectiveDate = `${effectiveDateQuestion.value}`;
        }
        const planTypesUpdated = this.plansService.getPlanTypesUpdated(questions);
        this.store.dispatch(new SetPlansDirty(true, planTypesUpdated));
        await this.store.dispatch(new SelectMedSupQuestions(sessionId, year, effectiveDate, questions, millimanHealthInformation)).toPromise();
        this.updateSelectedGIReasons();
    }
    async updateMedSupAnswers(questions) {
        const planTypesUpdated = this.plansService.getPlanTypesUpdated(questions);
        await this.store.dispatch(new UpdateMedSupAnswers(questions)).toPromise();
        this.store.dispatch(new SetPlansDirty(true, planTypesUpdated));
    }
    async updateAncillaryPlanAnswers(questions) {
        const planTypesUpdated = this.plansService.getPlanTypesUpdated(questions);
        await this.store.dispatch(new UpdateAncillaryPlanAnswers(questions)).toPromise();
        this.store.dispatch(new SetPlansDirty(true, planTypesUpdated));
    }
    async selectAncillaryQuestions(sessionId, year, questions, productType) {
        return this.plansService.selectPlanQuestions(sessionId, year, questions, productType);
    }
    rehydrateShoppingCartPlan() {
        const shoppingCartPlan = this.shoppingCartService.getSelectedPlan();
        if (shoppingCartPlan &&
            (this.isMedSupPlan(shoppingCartPlan) || this.isDentalVisionPlan(shoppingCartPlan) || this.isHospitalIndemnityPlan(shoppingCartPlan))) {
            this.shoppingCartService.rehydrateCartPlanInfo();
        }
    }
    showTurning65AtEffectiveDateMessage(dateOfBirth = this.getDateOfBirth(), effectiveDate = this.getEffectiveDate()) {
        // If month of effective date <= month user turns 65 then show additional messaging.
        const age = DateUtilities.getAge(dateOfBirth);
        if (age === INITIAL_ENROLLMENT_ELIGIBILITY_AGE) {
            const effectiveDateMonth = effectiveDate ? DateUtilities.getMonth(effectiveDate) : Infinity;
            const dateOfBirthMonth = dateOfBirth ? DateUtilities.getMonth(dateOfBirth) : -Infinity;
            if (effectiveDateMonth <= dateOfBirthMonth) {
                return this.getIsTurning65AtEffectiveDateMessagingEnabled();
            }
        }
        else if (age < INITIAL_ENROLLMENT_ELIGIBILITY_AGE) {
            return this.getIsTurning65AtEffectiveDateMessagingEnabled();
        }
        else {
            return false;
        }
    }
    getPlanSubTypes() {
        return this.configResource.getProcessedResourceValue('Spa_Site_MedSup_PlanTypes', null, []);
    }
    hasQuestionsIfRequired(activeTabType) {
        return this.planTypeHasQuestionsIfRequired(PlansUtilityService.convertToPlanType(activeTabType));
    }
    planTypeHasQuestionsIfRequired(planType) {
        if ([PlanType.DENTAL, PlanType.VISION].includes(planType)) {
            return !!this.getAncillaryQuestions()?.length;
        }
        else if (planType === PlanType.HC) {
            return this.getHasHospitalIndemnityQuestions();
        }
        return true;
    }
    async syncAnswers(sessionId, year, updatedQuestions, productType, millimanHealthInformation, invokeMilliman) {
        if ([ProductType.DENTAL, ProductType.VISION].includes(productType)) {
            await this.getAncillarySelectedQuestions(sessionId, year, updatedQuestions, productType);
            await this.updateMedSupAnswers(updatedQuestions);
        }
        else {
            await this.getMedSupSelectedQuestions(sessionId, year, updatedQuestions, millimanHealthInformation, invokeMilliman);
            if (this.getIsAncillaryPlansEnabled()) {
                await this.updateAncillaryPlanAnswers(updatedQuestions);
            }
        }
    }
    async getMedSupSelectedQuestions(sessionId, year, updatedQuestions, millimanHealthInformation, invokeMilliman) {
        let result;
        if (invokeMilliman && millimanHealthInformation) {
            result = this.selectMedSupQuestions(sessionId, year, updatedQuestions, millimanHealthInformation);
        }
        else {
            result = this.selectMedSupQuestions(sessionId, year, updatedQuestions);
        }
        return result;
    }
    async getAncillarySelectedQuestions(sessionId, year, updatedQuestions, productType) {
        return this.selectAncillaryQuestions(sessionId, year, updatedQuestions, productType);
    }
    setIsPlanRestrictedByEffectiveDateRange() {
        this.isPlanRestrictedByEffectiveDateRange = this.getIsPlanRestrictedByEffectiveDateRange();
    }
    setIsMedSupPlanRestrictedByAge() {
        // Effective date restriction supercedes/dominates med sup plan restriction by age.
        this.isMedSupPlanRestrictedByAge = this.getIsMedSupPlanRestrictedByAge() && !this.getIsPlanRestrictedByEffectiveDateRange();
    }
    canEnrollInMedSupPlansByEffectiveDate(effectiveDate = this.getEffectiveDate(), widgetName) {
        const effectiveDateRange = this.configResource.getProcessedResourceValue('Spa_MedSup_EffectiveDate_Restriction_Range', widgetName, 90);
        // We need to check if current date + 90 > effective date and if so disallow enrollment.
        if (effectiveDate) {
            return DateUtilities.isTargetDateWithinDateRange(effectiveDateRange, effectiveDate);
        }
        return false;
    }
    canEnrollInMedSupPlansByAge(dob) {
        const beneficiaryCutoffByMonth = this.configResource.getProcessedResourceValue('Spa_MedSup_BeneficiaryCutoffByMonth', null, true);
        const age = DateUtilities.getAge(dob);
        const daysUntilBirthDay = DateUtilities.getDaysUntilBirthDay(dob, beneficiaryCutoffByMonth);
        // if they are over 65 OR if they are turning 65 in 90 days, they can enroll in med sup
        return age >= MEDICARE_ELIGIBILITY_AGE || (age === MEDICARE_ELIGIBILITY_AGE - 1 && daysUntilBirthDay <= 90) ? true : false;
    }
}
MedSupService.ɵfac = function MedSupService_Factory(t) { return new (t || MedSupService)(i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(i1.Store), i0.ɵɵinject(NavigationService), i0.ɵɵinject(GuaranteedIssueReasonsContextService), i0.ɵɵinject(ShoppingCartService), i0.ɵɵinject(PlansService), i0.ɵɵinject(PlanYearResourceService)); };
MedSupService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MedSupService, factory: MedSupService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedSupService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ConfigResourceService }, { type: i1.Store }, { type: NavigationService }, { type: GuaranteedIssueReasonsContextService }, { type: ShoppingCartService }, { type: PlansService }, { type: PlanYearResourceService }]; }, null); })();

class MemberSessionService {
    constructor(store, sessionHttpService, pharmacyHttpService, drugsHttpService, plansService, resourceService, siteService, authService, agentService, googleTagManagerService, router, spinnerService, shoppingCartService, quoteService, providerService, medSupService, planYearResourceService, demographicHttpService, cacheContext) {
        this.store = store;
        this.sessionHttpService = sessionHttpService;
        this.pharmacyHttpService = pharmacyHttpService;
        this.drugsHttpService = drugsHttpService;
        this.plansService = plansService;
        this.resourceService = resourceService;
        this.siteService = siteService;
        this.authService = authService;
        this.agentService = agentService;
        this.googleTagManagerService = googleTagManagerService;
        this.router = router;
        this.spinnerService = spinnerService;
        this.shoppingCartService = shoppingCartService;
        this.quoteService = quoteService;
        this.providerService = providerService;
        this.medSupService = medSupService;
        this.planYearResourceService = planYearResourceService;
        this.demographicHttpService = demographicHttpService;
        this.cacheContext = cacheContext;
        this.isOtherPreferencesEnabled = this.resourceService.getProcessedResourceValue('Spa_Site_OtherPreferences_Enabled', null, false);
        this.isUseCMSDrugFlagEnabled = this.resourceService.getProcessedResourceValue('Spa_Drugs_UseCMSDrugFlag_Enabled', null, true);
        this.showUniqueCodeSessionId = this.resourceService.getProcessedResourceValue('Spa_SpeakWithAgent_ShowUniqueCode_SessionID', null, false);
        this.providersEnabled = this.resourceService.getProcessedResourceValue('Spa_Site_Providers_Enabled', null, false);
        this.isVerificationEnabled = this.resourceService.getProcessedResourceValue('Spa_Verification_Enabled', null, false);
        this.multiFactorAuthenticationEnabled = this.resourceService.getProcessedResourceValue('Spa_Site_MFA_Enabled', null, false);
        this.currentPlanEnabled = this.resourceService.getProcessedResourceValue('Spa_Site_CurrentPlan_Enabled', null, false);
        this.loadingEstimateHealthCost$ = new BehaviorSubject(false);
        this.selectedMemberDetailsUpdateStatus$ = new BehaviorSubject({
            updatesInProgress: 0,
            isUpdating: false
        });
        this.currentMemberProfilePageTag$ = new BehaviorSubject(null);
        this.isLiveEdit = EnvironmentService.getEnvironment().liveedit;
    }
    createSession$(agentGuid, sourceSiteId, originalAppId, isPurl) {
        return this.store.dispatch(new CreateSession(agentGuid, originalAppId, sourceSiteId, isPurl)).pipe(tap(() => {
            this.tagToUpdate(agentGuid);
        }));
    }
    createFullSession$(member) {
        return this.store.dispatch(new CreateFullSession(member)).pipe(tap(() => {
            this.tagToUpdate(member.agentGuid);
        }));
    }
    createMemberSession$() {
        const agentGuid = this.store.selectSnapshot(AgentState.agentGuid);
        if (agentGuid) {
            const isPurl = this.agentService.isPurl();
            if (isPurl) {
                return this.createSession$(agentGuid, this.quoteService.getSourceSiteId(), this.quoteService.getOriginalAppId(), isPurl);
            }
            else {
                this.createSession$(agentGuid);
            }
        }
        return this.createSession$();
    }
    createFullMemberSession$(memberState) {
        return this.createFullSession$(memberState);
    }
    async createSessionWithSSO$(sessionId, apiMemberStateModel) {
        return await firstValueFrom(this.sessionHttpService.createSessionWithSSO$(sessionId, apiMemberStateModel), { defaultValue: null });
    }
    getMemberSession() {
        return this.store.selectSnapshot(MemberState.session);
    }
    getMemberDemographic() {
        return this.store.selectSnapshot(MemberState.demographic);
    }
    getMemberDemographicEstimateHealthCost() {
        return this.store.selectSnapshot(MemberState.demographicEstimateHealthCost);
    }
    getMemberHasFullName() {
        return this.store.selectSnapshot(ProfileState.hasFullName);
    }
    getMemberDemographicEstimateHealthCost$() {
        return this.store.select(MemberState.demographicEstimateHealthCost);
    }
    getMemberHasFullName$() {
        return this.store.select(ProfileState.hasFullName);
    }
    getMemberSession$() {
        return this.store.select(MemberState.session);
    }
    getMemberEnrollments$() {
        return this.store.select(MemberState.memberEnrollments);
    }
    getMemberEnrollments() {
        return this.store.selectSnapshot(MemberState.memberEnrollments);
    }
    getMemberPlanEnrollments$(isPPCSite = this.siteService.isPPCSite()) {
        return this.store.select(MemberState.memberPlanEnrollments(isPPCSite));
    }
    getAgentInContextGuid$() {
        return this.agentService.getAgentInContextGuid$();
    }
    getAgentInContextGuid() {
        return this.agentService.getAgentInContextGuid();
    }
    getMemberAgentGuid$() {
        return this.store.select(MemberState.agentGuid);
    }
    getMemberDosages$() {
        return this.store.select(MemberState.dosages);
    }
    getMemberDosages() {
        return this.store.selectSnapshot(MemberState.dosages);
    }
    isEligibleForSelectRxTasks() {
        return this.store.selectSnapshot(MemberState.isEligibleForSelectRxTasks);
    }
    getIsMemberLoggedIn$() {
        return this.store.select(MemberState.isLoggedIn);
    }
    getZipCode$() {
        return this.store.select(DemographicState.selectedZipCode);
    }
    getZipCode() {
        return this.store.selectSnapshot(DemographicState.selectedZipCode);
    }
    getFipsCode$() {
        return this.store.select(DemographicState.selectedFipsCode);
    }
    getFipsCode() {
        return this.store.selectSnapshot(DemographicState.selectedFipsCode);
    }
    getMemberAgentCallRecords$() {
        return this.store.select(MemberState.agentCallRecords).pipe(
        // prevents the following TypeError: Cannot assign to read only property '0' of object
        map(_cloneDeep), map((agentCallRecords) => agentCallRecords.sort((callRecordA, callRecordB) => (callRecordA.timestamp < callRecordB.timestamp ? 1 : -1))));
    }
    getIsEnrollmentHistoryIncluded() {
        return this.store.selectSnapshot(MemberState.isEnrollmentHistoryIncluded);
    }
    getMemberLoginError() {
        return this.store.selectSnapshot(MemberState.loginError);
    }
    getMemberAgentCallRecords() {
        return this.store.selectSnapshot(MemberState.agentCallRecords);
    }
    getMemberSessionId() {
        return this.store.selectSnapshot(MemberState.sessionId);
    }
    getMemberMedigapAnswers() {
        return this.medSupService.getMemberMedigapAnswers();
    }
    getMemberSSO() {
        const session = this.getMemberSession();
        return session ? session.ssoValue : null;
    }
    getAuthType() {
        return this.store.selectSnapshot(RuntimeState.authType);
    }
    async setAuthType(authType) {
        await firstValueFrom(this.store.dispatch(new SetAuthType(authType)), { defaultValue: null });
    }
    resetAuthType() {
        this.setAuthType("anonymous" /* AuthType.ANONYMOUS */);
    }
    getMemberSessionLoadedStatus$() {
        return this.store.select(MemberState.loaded);
    }
    getCurrentMemberProfilePageTag$() {
        return this.currentMemberProfilePageTag$.asObservable();
    }
    getEnrollmentStatuses$(sessionId) {
        return this.sessionHttpService.getEnrollmentStatuses$(sessionId);
    }
    getCompleteEnrollmentsStatuses$(sessionId) {
        return this.sessionHttpService.getCompleteEnrollmentsStatuses$(sessionId);
    }
    setCurrentMemberProfilePageTag(memberPageTag) {
        this.currentMemberProfilePageTag$.next(memberPageTag);
    }
    isExpired(session) {
        // TODO:
        // const expires = session.expires;
        return false;
    }
    get isMultiPharmacyEnabled() {
        return this.resourceService.getProcessedResourceValue('Spa_Site_Multi_Pharmacy_Enabled', null, false);
    }
    // TODO: flesh out when needed
    validateMemberLogin(userName, password, authType = "login" /* AuthType.LOGIN */, authInfo) {
        this.sessionHttpService.retrieveMemberLoginToken$(userName, password, authType, authInfo).subscribe({
            next: sessionData => {
                // valid login information
                this.store.dispatch(new FetchMemberLoginTokenSuccess());
            },
            error: error => {
                // not valid login information
                this.store.dispatch(new FetchMemberLoginTokenError());
                console.error(error);
            }
        });
    }
    isMemberLoading$() {
        return this.store.select(MemberState.loading);
    }
    loggedInMemberId$() {
        return this.store.select(MemberState.memberID);
    }
    isMemberEnrollmentPlanSettingsLoading$() {
        return this.store.select(MemberState.enrollmentPlanSettingsLoading);
    }
    planEnrollmentSettings$(planID) {
        return this.store.select(MemberState.planEnrollmentSettings(planID));
    }
    planEnrollmentSettings(planID) {
        return this.store.selectSnapshot(MemberState.planEnrollmentSettings(planID));
    }
    getPlanEnrollmentSettingsByType(planID, selectedFormType, userType, isFormSignAndSubmitOnly) {
        return this.store.selectSnapshot(MemberState.getPlanEnrollmentSettingsByType(planID, selectedFormType, userType, isFormSignAndSubmitOnly));
    }
    isMemberLoggedIn$() {
        return this.store.select(MemberState.isLoggedIn);
    }
    isMemberLoggedIn() {
        return this.store.selectSnapshot(MemberState.isLoggedIn);
    }
    getBeneficiaryQuoteId() {
        return this.quoteService.getBeneficiaryQuoteId();
    }
    getBeneficiarySourceSiteId() {
        return this.quoteService.getSourceSiteId();
    }
    /**
     * Attempts to log a user in with provided credentials, then rehydrates our store with their data if successful
     * @param userName - user account's username
     * @param password - user account's password
     * @returns a promise that resolves when the entire login process is finished
     */
    // eslint-disable-next-line complexity
    async memberLogin(userName, password, authOptions, loginOptions, newMemberInfo) {
        if (!authOptions) {
            authOptions = LoginAuthOptions.createDefaultOptions();
        }
        if (!loginOptions) {
            loginOptions = MemberLoginOptions.createDefaultOptions();
        }
        const { authType, authInfo } = authOptions;
        const { firstTimeLogin, fetchCreatingAgent, includeEnrollmentHistory, includeSOA, params, totpCode } = loginOptions;
        const isPINAuthentication = authType === "pin" /* AuthType.PIN */;
        let { includePlanData, planTypesToFetch, fetchPlansByPlanId } = loginOptions;
        let shouldUpdateCart = includePlanData;
        let planIdsInCart = [];
        const sessionToken = await this.sessionHttpService
            .retrieveMemberLoginToken(userName, password, authType, authInfo, newMemberInfo, totpCode)
            .catch(async (error) => {
            this.store.dispatch(new FetchMemberLoginTokenError());
            await Promise.reject(error);
        });
        if (sessionToken) {
            // Need to set this ahead of time so that by the time the user logs in and the
            // demographics component responds to the session being loaded we have the proper
            // auth type. Otherwise this will not be logged with the demographics view-Page event.
            await this.setAuthType(authOptions.authType);
            // Ensures to check the active tab's plan count to select a tab with coverage
            // the first time we load the plan list with the member in session
            this.plansService.setActiveTabPlanCountCheckEnabled(true);
            const { sessionId, profile } = sessionToken;
            let memberUserName;
            let memberDateOfBirth;
            if (isPINAuthentication) {
                memberUserName = authInfo.pinInfo.auth1;
                // Setting date of birth in the Member's state during Multi-Factor Authentication.
                // This will ensure we can complete the authentication even if the user refreshes the page in any step
                // Verification flow: Retention Module is not considered for this phase.
                if (this.multiFactorAuthenticationEnabled) {
                    memberDateOfBirth = authInfo.pinInfo.auth2;
                }
            }
            else {
                memberUserName = userName;
            }
            const operations = [
                firstValueFrom(this.store.dispatch(new FetchMemberLoginTokenSuccess()), { defaultValue: null }),
                firstValueFrom(this.store.dispatch(new MemberLogin(memberUserName, sessionToken, memberDateOfBirth)), { defaultValue: null })
            ];
            // Session ID could be optional during multi-factor authentication
            if (sessionId) {
                operations.push(firstValueFrom(this.fetchMemberSession$({ sessionId, isEnrollmentHistoryIncluded: includeEnrollmentHistory, includeSOA }), {
                    defaultValue: null
                }));
            }
            const dispatchReturns = await Promise.all(operations).catch(error => {
                this.store.dispatch(new MemberLoginError(error));
                this.resetAuthType();
            });
            if (dispatchReturns) {
                // During multi-factor authentication/verification, we will receive the obfuscated email address/cellphone instead of a session ID.
                // In that case, we short-circuit here to skip fetching all the data below
                // Verification flow: Retention Module is not considered for this phase.
                if (isPINAuthentication && this.multiFactorAuthenticationEnabled && !sessionId && profile) {
                    return;
                }
                if (!firstTimeLogin) {
                    const promises = [
                        this.updatePharmacy(),
                        this.updateDrugs(),
                        this.updateProviders(),
                        this.updatePreferences(),
                        this.updateMedicalCostInputs()
                    ];
                    if (this.currentPlanEnabled) {
                        promises.push(this.updateCurrentPlanShort());
                    }
                    const updateReturnValues = await Promise.all(promises).catch(error => {
                        this.store.dispatch(new MemberLoginError(error));
                    });
                    if (Array.isArray(updateReturnValues)) {
                        const [hasPharmacyData, hasDrugData, hasProviders, hasPreferences] = updateReturnValues;
                        if (hasPharmacyData || hasDrugData || hasProviders || hasPreferences) {
                            this.store.dispatch(new SetVisited());
                        }
                    }
                }
                this.updateMillimanHealthInformation();
                await this.setInitialMemberDemographics(sessionId);
                if (fetchCreatingAgent) {
                    await this.getAgentGuid();
                }
                if (!params?.PlanType) {
                    const hasPlansInCart = this.shoppingCartService.hasPlansInCart();
                    if (hasPlansInCart) {
                        planTypesToFetch = this.shoppingCartService.getShoppingCartPlanTypes();
                        if (fetchPlansByPlanId) {
                            planIdsInCart = this.shoppingCartService.getShoppingCartPlanIds();
                        }
                        shouldUpdateCart = true;
                    }
                }
                if (shouldUpdateCart) {
                    const planSearchOptions = planTypesToFetch ? { planType: PlansUtilityService.toBitWiseString(planTypesToFetch) } : null;
                    await this.updateCart(fetchPlansByPlanId && planIdsInCart ? planIdsInCart : null, !includePlanData, planSearchOptions).catch(error => {
                        this.store.dispatch(new MemberLoginError(error));
                    });
                }
                return await firstValueFrom(this.store.dispatch(new MemberLoginSuccess()), { defaultValue: null });
            }
        }
        return await Promise.reject();
    }
    updateMillimanHealthInformation() {
        const UWFLAG_KEYNAME = 'uwFlag';
        const UWFLAG_KEYNAME_UPDATED = 'UWFlag';
        const SERVICE_CALLED_NOW = 'serviceCalledNow';
        const GERD_KEYNAME = 'gerdAcidReflux';
        const GERD_KEYNAME_UPDATED = 'GERDAcidReflux';
        const medigapAnswers = this.getMemberMedigapAnswers();
        if (medigapAnswers?.millimanUwTier) {
            this.store.dispatch(new SetMillimanTier(medigapAnswers.millimanUwTier));
        }
        if (medigapAnswers?.millimanHealthInformation) {
            // The FOAM keys are not in camelCase so to match them we must de-camelCase-ify this object and
            // handle case sensitive namings (GERD, UWFlag, serviceCalledNow)
            const updatedMillimanHealthAnswers = Object.entries(medigapAnswers?.millimanHealthInformation).reduce((updatedAnswers, [key, value]) => {
                let keyName = key;
                if (keyName !== UWFLAG_KEYNAME && keyName !== GERD_KEYNAME && keyName !== SERVICE_CALLED_NOW) {
                    keyName = key.charAt(0).toUpperCase() + key.slice(1);
                }
                if (keyName === UWFLAG_KEYNAME) {
                    keyName = UWFLAG_KEYNAME_UPDATED;
                }
                if (keyName === GERD_KEYNAME) {
                    keyName = GERD_KEYNAME_UPDATED;
                }
                if (keyName === SERVICE_CALLED_NOW) {
                    updatedAnswers[keyName] = JSON.parse(value);
                }
                else {
                    updatedAnswers[keyName] = value;
                }
                return updatedAnswers;
            }, {});
            if (updatedMillimanHealthAnswers.TierServiceCalled) {
                this.store.dispatch(new UpdateMillimanServiceCalledBefore(updatedMillimanHealthAnswers.TierServiceCalled === 'True'));
            }
            if (updatedMillimanHealthAnswers.UWFlag) {
                this.store.dispatch(new UpdateMillimanServiceUWFlag(updatedMillimanHealthAnswers.UWFlag));
            }
            this.store.dispatch(new UpdateMillimanServiceCalledNow(updatedMillimanHealthAnswers.serviceCalledNow));
            this.store.dispatch(new UpdateMillimanHealthInformation(updatedMillimanHealthAnswers));
        }
    }
    async getAgentGuid(value) {
        const session = this.getMemberSession();
        if (session?.agentGuid) {
            try {
                const agentData = await firstValueFrom(this.agentService.fetchAgent$(session.agentGuid, session.agentGuid), { defaultValue: null });
                if (agentData) {
                    this.agentService.updateAgentState(agentData);
                }
            }
            catch (error) { }
        }
    }
    async createSOASession(pinInfo, agentGuid, isSecurityDOBEnabled, dateOfBirth) {
        const authInfo = new AuthenticationInfo();
        authInfo.pinInfo = pinInfo;
        const authType = isSecurityDOBEnabled ? "PinAndDOB" /* AuthType.PIN_AND_DOB */ : "pin" /* AuthType.PIN */;
        let loginError = null;
        const sessionToken = await this.sessionHttpService
            .createSOASession(authInfo.pinInfo, authType, agentGuid, isSecurityDOBEnabled, dateOfBirth)
            .catch(error => {
            this.store.dispatch(new MemberLoginError(error));
            loginError = error;
        });
        if (sessionToken && !loginError) {
            return await firstValueFrom(this.store.dispatch(new MemberLoginSuccess()), { defaultValue: null });
        }
        else {
            return await Promise.reject(loginError);
        }
    }
    async createQuoteSession(createQuoteSessionOptions) {
        const { authInfo, authType, quoteId, agentGuid, firstTimeLogin = false, quoteType, isEnrollmentHistoryIncluded = false, showCurrentMonthMedigapQuote = false, omitPlansRequest = false, rehydratePlansFromCart = false, isSecurityDOBEnabled = false, dateOfBirth } = createQuoteSessionOptions;
        let loginError = null;
        const sessionToken = await this.sessionHttpService
            .createQuoteSession(authInfo.pinInfo, authType, quoteId, agentGuid, quoteType, showCurrentMonthMedigapQuote, isSecurityDOBEnabled, dateOfBirth)
            .catch(error => {
            this.store.dispatch(new MemberLoginError(error));
            loginError = error;
        });
        if (sessionToken) {
            const { sessionId } = sessionToken;
            const dispatchReturns = await Promise.all([
                firstValueFrom(this.store.dispatch(new FetchMemberLoginTokenSuccess()), { defaultValue: null }),
                firstValueFrom(this.fetchMemberSession$({ sessionId, isEnrollmentHistoryIncluded }), { defaultValue: null }),
                firstValueFrom(this.store.dispatch(new MemberLogin(authInfo.pinInfo.auth1, sessionToken)), { defaultValue: null })
            ]).catch(error => {
                this.store.dispatch(new MemberLoginError(error));
                loginError = error;
            });
            this.setAuthType(authType);
            if (dispatchReturns) {
                // No quotedPlans from create session response means agent doesn't have permission to the plan
                // Need to remove agent from session in order for consumer to finish enrollment if send to beneficiary
                let quotedPlanIds = sessionToken.quotedPlans;
                if (!quotedPlanIds) {
                    const quoteInfo = await this.quoteService.getInfoForQuote(quoteId, agentGuid);
                    if (quoteInfo.quoteType === QuoteType.ENROLLMENTQUOTE) {
                        this.banAgentFromSession();
                    }
                    quotedPlanIds = quoteInfo.planIds;
                }
                if (!firstTimeLogin) {
                    const promises = [
                        this.updatePharmacy(),
                        this.updateDrugs(),
                        this.updateProviders(),
                        this.updatePreferences(),
                        this.updateMedicalCostInputs()
                    ];
                    if (this.currentPlanEnabled) {
                        promises.push(this.updateCurrentPlanShort());
                    }
                    const updateReturnValues = await Promise.all(promises).catch(error => {
                        this.store.dispatch(new MemberLoginError(error));
                        loginError = error;
                    });
                    if (Array.isArray(updateReturnValues)) {
                        const [hasPharmacyData, hasDrugData, hasProviders, hasPreferences] = updateReturnValues;
                        if (hasPharmacyData || hasDrugData || hasProviders || hasPreferences) {
                            this.store.dispatch(new SetVisited());
                        }
                    }
                }
                this.updateMillimanHealthInformation();
                await this.updateCart(quotedPlanIds, omitPlansRequest, null, rehydratePlansFromCart).catch(error => {
                    this.store.dispatch(new MemberLoginError(error));
                    loginError = error;
                });
                if (!loginError) {
                    return await firstValueFrom(this.store.dispatch(new MemberLoginSuccess()), { defaultValue: null });
                }
            }
        }
        return await Promise.reject(loginError);
    }
    /**
     * Logs the member out then resets our store to a clean slate
     */
    // TODO: need to probably just rename this clear store
    // TODO: may have to wait on all of these?
    memberLogout(options = {}) {
        this.cacheContext.bustCache();
        const { clearAnonymousSession = true, clearMultiFactorAuthenticationSteps = this.multiFactorAuthenticationEnabled, clearVerificationSteps = this.isVerificationEnabled } = options;
        this.store.dispatch(new MemberLogout());
        this.resetSessionState({ clearAnonymousSession, clearMultiFactorAuthenticationSteps, clearVerificationSteps });
        this.spinnerService.reset();
    }
    /**
     * Resets member related session state in our store
     */
    resetSessionState(options = {}) {
        const { clearAnonymousSession = true, clearRuntimeSession = true, clearPlanYearSession = false, clearPlanSmartSession = false, clearMultiFactorAuthenticationSteps = this.multiFactorAuthenticationEnabled, clearVerificationSteps = this.isVerificationEnabled } = options;
        this.clearMemberSessionData({ clearRuntimeSession, clearMultiFactorAuthenticationSteps, clearVerificationSteps });
        if (clearAnonymousSession) {
            this.clearAnonymousSessionData({ clearPlanYearSession, clearPlanSmartSession });
        }
    }
    /**
     * Resets only member related session state in our store except plan and demographic states
     * This is in order to be able to access Viewdetails from Enrollment confirmation.
     */
    clearMemberSessionData(options = {}) {
        const { clearRuntimeSession = true, clearMultiFactorAuthenticationSteps = this.multiFactorAuthenticationEnabled, clearVerificationSteps = this.isVerificationEnabled } = options;
        this.store.dispatch(new ResetMedicineCabinet());
        this.store.dispatch(new ResetGuidedHelpState());
        this.store.dispatch(new ResetEnrollmentState());
        this.store.dispatch(new ResetPharmacy());
        this.store.dispatch(new ResetProfileState());
        this.store.dispatch(new ResetMemberState());
        this.store.dispatch(new ResetMedSupState());
        if (clearRuntimeSession) {
            this.store.dispatch(new ResetRuntimeState({
                resetPurl: !this.agentService.isPurl()
            }));
        }
        this.store.dispatch(new ResetShoppingCartState());
        this.store.dispatch(new ResetHelpfulTools());
        this.store.dispatch(new ResetSOAState());
        this.store.dispatch(new ResetMillimanState());
        this.store.dispatch(new ResetBlueButtonMedicineCabinet());
        this.store.dispatch(new ResetProvider());
        this.store.dispatch(new ResetProviderSearchLoaded());
        this.store.dispatch(new ResetPreferences());
        this.store.dispatch(new ResetDeepLinkingParams());
        this.store.dispatch(new ResetTwilioState());
        this.store.dispatch(new ResetGuidedHelpNavigationLinkStatus());
        this.store.dispatch(new RemovePrimaryCareProvider());
        this.store.dispatch(new ResetQuoteState());
        if (clearMultiFactorAuthenticationSteps) {
            this.store.dispatch(new ResetMultiFactorAuthenticationStep());
        }
        if (clearVerificationSteps) {
            this.store.dispatch(new ResetVerificationStep());
        }
    }
    /**
     * Resets all session states in our store by clearing the plan, demographic states as well
     */
    clearAnonymousSessionData(options = {}) {
        const { clearPlanYearSession, clearPlanSmartSession } = options;
        this.store.dispatch(new ResetDemographicState());
        this.store.dispatch(new ResetPlansState(clearPlanYearSession ? this.planYearResourceService.getCurrentPlanYear() : null));
        if (clearPlanSmartSession) {
            this.store.dispatch(new ResetPlanSmart());
        }
    }
    /**
     * Fetches plan data from saved session data and rehydrates our store's plan information
     */
    async updateCart(planIds, omitPlansRequest, searchOptions, rehydratePlansFromCart, hideLoading = false) {
        try {
            const selectedZip = this.getZipCode();
            const selectedFips = this.getFipsCode();
            const agentGuid = this.store.selectSnapshot(AgentState.agentGuid);
            if (selectedZip && selectedFips) {
                const helpfulToolsData = { zipCode: selectedZip, fipsCode: selectedFips };
                this.rehydrateHelpfulTools(helpfulToolsData);
                const memberData = this.getMemberSession();
                let currentYearPlanId = '';
                let drugs = [];
                if (memberData) {
                    if (memberData.currentYearPlanID && this.isRetentionView()) {
                        currentYearPlanId = memberData.currentYearPlanID;
                    }
                    if (memberData.dosages) {
                        drugs = memberData.dosages.map(drug => ({
                            dosageId: drug.dosageId,
                            ndc: drug.ndc,
                            metricQuantity: drug.metricQuantity,
                            userQuantity: drug.userQuantity,
                            daysOfSupply: drug.daysOfSupply,
                            selectedPackageId: drug.selectedPackageId
                        }));
                    }
                }
                const medicineCabinet = this.store.selectSnapshot(MedicineCabinetState.medicineCabinet);
                const pharmacies = this.plansService.getSelectedAPIPharmacyInfo();
                const isSitePreferencesScoreEnabled = this.resourceService.getProcessedResourceValue('Spa_Site_Preferences_Score_Enabled', null, false);
                const includeExtendedProviderData = this.resourceService.getProcessedResourceValue('Spa_Site_Provider_ShowAllInNetworkLocations_Enabled', null, true);
                const sendPreferencesFlag = this.plansService.setSendPreferencesFlag(pharmacies, medicineCabinet, isSitePreferencesScoreEnabled);
                const providers = this.providerService.getNpiAndAddressOfSelectedProviders();
                let shoppingCartPlanIds = [];
                let fetchPlansInShoppingCartData = false;
                if (rehydratePlansFromCart) {
                    shoppingCartPlanIds = this.store.selectSnapshot(ShoppingCartState.shoppingCartPlanIds);
                    fetchPlansInShoppingCartData = !planIds || shoppingCartPlanIds.some(planId => !planIds?.includes(planId));
                }
                const sendPlanIdsFlag = planIds?.length || shoppingCartPlanIds.length;
                if (!omitPlansRequest || fetchPlansInShoppingCartData) {
                    const plansData = await this.plansService.fetchPlansByOptionsAndSave({
                        medigapAnswers: this.plansService.getMergedMedigapAnswers(),
                        searchOptions: this.updateSearchOptions(searchOptions, sendPreferencesFlag, this.providersEnabled),
                        drugs,
                        pharmacies,
                        currentYearPlanId,
                        agentGuid,
                        providers,
                        ...(sendPreferencesFlag && { preferences: this.plansService.getPreferences() }),
                        ...(sendPlanIdsFlag && { ids: [...new Set([...(planIds ?? []), ...shoppingCartPlanIds])] }),
                        hideLoading
                    });
                    const operations = [this.quotePlans(plansData, planIds)];
                    // If we are not scoring plans we won't be getting providerNetworks but may need them without scores
                    // so we can still make this call if we didn't call for plan scores in the plan short call.
                    if (this.providersEnabled && plansData?.length && !searchOptions?.scorePlans) {
                        operations.push(firstValueFrom(this.providerService.fetchProvidersDetailsBasedOnAvailablePlans$(plansData, includeExtendedProviderData).pipe(take(1)), { defaultValue: null }).then(async (providerDetails) => await firstValueFrom(this.store.dispatch(new SetProvidersDetails(providerDetails)), { defaultValue: null })));
                    }
                    return await Promise.all(operations);
                }
            }
        }
        catch (error) {
            return await Promise.reject(error);
        }
    }
    updateSearchOptions(searchOptions, sendPreferencesFlag, isProvidersEnabled) {
        const shoppingCartPlanTypes = this.shoppingCartService.getShoppingCartPlanTypes();
        const hasPlansInCart = !!shoppingCartPlanTypes?.length;
        const isPlanCountSet = searchOptions?.planCount !== null && searchOptions?.planCount !== undefined;
        const isScorePlansSet = searchOptions?.scorePlans !== null && searchOptions?.scorePlans !== undefined;
        const shouldUpdateSearchOptions = hasPlansInCart || !isPlanCountSet || !isScorePlansSet;
        let updatedSearchOptions = { ...searchOptions };
        if (shouldUpdateSearchOptions) {
            const uniqueShoppingCartPlanTypes = Array.from(new Set(shoppingCartPlanTypes.reduce((planTypes, planType) => {
                planTypes.push(planType);
                return planTypes;
            }, updatedSearchOptions?.planType ? PlansUtilityService.splitBitWise(+updatedSearchOptions?.planType) : [])));
            let uniqueSearchPlanTypes = uniqueShoppingCartPlanTypes;
            if (!isScorePlansSet) {
                // search plans differ from shopping cart plans in that they will include grouped types for calling the API
                // For example: when preferences and scoring is set we need to call medicare/medsup at the same time in case we need
                // to set the active tab on the basis of the plan scores
                uniqueSearchPlanTypes = Array.from(new Set(uniqueShoppingCartPlanTypes.reduce((planTypes, planType) => {
                    const searchPlanTypes = this.plansService.getSearchPlanTypes(planType);
                    planTypes.push(...searchPlanTypes);
                    return planTypes;
                }, [])));
                const scorePlans = sendPreferencesFlag &&
                    uniqueSearchPlanTypes.some(planType => this.plansService.isScoredPlanType(planType) && this.medSupService.planTypeHasQuestionsIfRequired(planType));
                updatedSearchOptions.scorePlans = scorePlans;
            }
            if (hasPlansInCart) {
                const overrideSearchOptions = { ...updatedSearchOptions, planType: PlansUtilityService.toBitWiseString(uniqueSearchPlanTypes) };
                // TODO: do we need to call createPlansSearchOptionsWithDefaults or can we just spread and assign?
                updatedSearchOptions = this.plansService.createPlansSearchOptionsWithDefaults(overrideSearchOptions);
            }
            if (!isPlanCountSet) {
                const hasUnloadedPlanTypes = !!this.plansService.getUnloadedPlanTypes(PlansUtilityService.splitBitWise(updatedSearchOptions?.planType ? +updatedSearchOptions?.planType : 0))?.length;
                updatedSearchOptions.planCount = hasUnloadedPlanTypes;
            }
        }
        return updatedSearchOptions;
    }
    async quotePlans(plansData, planIds, updatePlanDetails) {
        if (planIds?.length) {
            // Sets cart using provided planIds
            return await this.setQuotedPlans(plansData, planIds, updatePlanDetails);
        }
        else {
            // Rehydrates from shopping cart API
            return await this.rehydratePlans(plansData, updatePlanDetails);
        }
    }
    /**
     * Fetches pharmacy data from saved session data and rehydrates our store's pharmacy information
     * @returns a promise that resolves when the pharmacy store is updated, indicating if there was or was not data to load
     */
    async updatePharmacy() {
        this.store.dispatch(new ResetPharmacy());
        return await this.pharmacyHttpService.getPharmacies(this.getMemberSessionId()).then(pharmacyData => {
            if (pharmacyData) {
                if (this.isMultiPharmacyEnabled) {
                    this.store.dispatch(new SetPharmacies(pharmacyData));
                }
                const primaryPharmacy = pharmacyData.find(pharmacy => pharmacy.isPrimaryPharmacy);
                if (primaryPharmacy) {
                    this.store.dispatch(new SetSelectedPharmacy(primaryPharmacy));
                    if (!this.isMultiPharmacyEnabled) {
                        this.store.dispatch(new SetPharmacies([primaryPharmacy]));
                    }
                }
                else {
                    this.store.dispatch(new SetSelectedPharmacy(pharmacyData[0]));
                    if (!this.isMultiPharmacyEnabled) {
                        this.store.dispatch(new SetPharmacies([pharmacyData[0]]));
                    }
                }
            }
            return !!pharmacyData;
        });
    }
    /**
     * Fetches drug data from saved session data and rehydrates our store's drug information
     * @returns a promise that resolves when the drug store is updated, indicating if there was or was not data to load
     */
    async updateDrugs() {
        await firstValueFrom(this.store.dispatch(new ResetMedicineCabinet()), { defaultValue: null });
        await firstValueFrom(this.store.dispatch(new ResetBlueButtonMedicineCabinet()), { defaultValue: null });
        const medicineCabinet = await this.drugsHttpService.getAllDrugsInCabinet(this.getMemberSessionId());
        if (medicineCabinet) {
            if (this.isUseCMSDrugFlagEnabled) {
                medicineCabinet.forEach(medicine => {
                    const { drugDetails } = medicine;
                    if (drugDetails?.drugFlag) {
                        medicine.dosage.drugFlag = drugDetails.drugFlag;
                        drugDetails.dosages?.forEach(dosage => {
                            dosage.drugFlag = drugDetails.drugFlag;
                        });
                    }
                });
            }
            this.store.dispatch(new SetDrugsToMedicineCabinet(medicineCabinet));
        }
        return !!medicineCabinet && !!medicineCabinet.length;
    }
    /**
     * @returns a promise that resolves when the demographics store is updated
     */
    async updateDemographics() {
        await firstValueFrom(combineLatest([this.store.select(DemographicState.ageRange), this.store.select(DemographicState.healthStatus)]).pipe(first(([ageRange, healthStatus]) => ageRange !== null && healthStatus !== null)), { defaultValue: [null, null] }).then(demographicsData => {
            const [ageRange, healthStatus] = demographicsData;
            if (!ageRange && ageRange !== 0) {
                this.store.dispatch(new SetAgeRange(this.resourceService.getProcessedResourceValue('Spa_GuidedHelp_Health_AgeDefault_Number', null, 5)));
            }
            if (!healthStatus && healthStatus !== 0) {
                this.store.dispatch(new SetHealthStatus(this.resourceService.getProcessedResourceValue('Spa_GuidedHelp_Health_DefaultHealthStatus_Number', null, 3)));
            }
        });
    }
    async updatePreferences() {
        if (this.isOtherPreferencesEnabled) {
            const sessionId = this.getMemberSessionId();
            this.store.dispatch(new LoadPreferences(sessionId));
        }
    }
    async updateProviders() {
        const providers = await this.providerService.getProvidersFromMember();
        if (providers) {
            this.store.dispatch(new SetSelectedProviders(providers));
        }
        return !!providers;
    }
    async updateMedicalCostInputs() {
        const medicalCostInputs = await this.sessionHttpService.getMedicalCosts(this.getMemberSessionId());
        this.setHealthMedicalCostInputs(medicalCostInputs);
        return !!medicalCostInputs;
    }
    async updateCurrentPlanShort() {
        const currentPlanShort = await this.plansService.fetchCurrentPlanShort$(this.getMemberSessionId());
        this.plansService.setCurrentPlanShort(currentPlanShort);
        return !!currentPlanShort;
    }
    async registerAccount(accountData) {
        await firstValueFrom(this.sessionHttpService.registerNewAccount$(this.getMemberSessionId(), accountData), { defaultValue: null });
    }
    async updateMemberProfile(apiMemberStateModel) {
        await this.updateSession(this.getMemberSessionId(), apiMemberStateModel);
    }
    updateMemberProfile$(apiMemberStateModel) {
        return this.updateSession$(this.getMemberSessionId(), apiMemberStateModel);
    }
    async updateMemberSession(apiMemberStateModel) {
        await firstValueFrom(this.sessionHttpService.updateSession$(this.getMemberSessionId(), apiMemberStateModel), {
            defaultValue: null
        });
    }
    async addMemberNoteByAgent(memberAgentNote) {
        return await firstValueFrom(this.store.dispatch(new AddMemberAgentNote(this.getMemberSessionId(), memberAgentNote)), {
            defaultValue: null
        });
    }
    /**
     * @param memberAgentNote - memberAgentNote to provide with valid memberAgentNoteID
     */
    async updateMemberTask(memberAgentNote) {
        return await firstValueFrom(this.store.dispatch(new UpdateMemberAgentNote(this.getMemberSessionId(), memberAgentNote.memberAgentNoteID, memberAgentNote)), { defaultValue: null });
    }
    async updateDashBoardMemberTask(sessionID, memberAgentNote) {
        return await firstValueFrom(this.store.dispatch(new UpdateMemberAgentNote(sessionID, memberAgentNote.memberAgentNoteID, memberAgentNote)), { defaultValue: null });
    }
    async createAccountAndLogin(accountData) {
        return await this.registerAccount(accountData).then(async () => await this.memberLogin(accountData.userName, accountData.password, null, { firstTimeLogin: true, includeEnrollmentHistory: true }));
    }
    async updateSelectedMemberDetails(forceUpdateCart) {
        this.updateMillimanHealthInformation();
        const promises = [];
        promises.push(this.updatePharmacy());
        promises.push(this.updateDrugs());
        promises.push(this.updateProviders());
        promises.push(this.updatePreferences());
        promises.push(this.updateMedicalCostInputs());
        if (this.currentPlanEnabled) {
            promises.push(this.updateCurrentPlanShort());
        }
        this.setIsSelectedMemberDetailsUpdating(true);
        return await Promise.all(promises)
            .then(async (updateReturnValues) => {
            const shoppingCart = this.store.selectSnapshot(ShoppingCartState.selectCartAPIState);
            if (Array.isArray(updateReturnValues) && (forceUpdateCart || shoppingCart?.length)) {
                return await this.updateCart();
            }
        })
            .finally(() => {
            this.setIsSelectedMemberDetailsUpdating(false);
        });
    }
    setIsSelectedMemberDetailsUpdating(isUpdating) {
        const { updatesInProgress } = this.selectedMemberDetailsUpdateStatus$.value;
        // When setting "isUpdating", the counter will increase on each enable and decrease on each disable.
        const newCounter = isUpdating ? updatesInProgress + 1 : updatesInProgress - 1;
        const newUpdateStatus = {
            // Resetting the counter if the new value is negative.
            updatesInProgress: newCounter < 0 ? 0 : newCounter,
            isUpdating: newCounter > 0
        };
        this.selectedMemberDetailsUpdateStatus$.next(newUpdateStatus);
    }
    isSelectedMemberDetailsUpdating$() {
        return this.selectedMemberDetailsUpdateStatus$.asObservable().pipe(map(updateStatus => updateStatus.isUpdating));
    }
    fetchMemberSession$(fetchMemberOptions) {
        const isRetentionView = this.isRetentionView();
        const currentYearPlanId = isRetentionView ? this.store.selectSnapshot(MemberState.currentYearPlanId) : '';
        return this.store.dispatch(new FetchSession({ ...fetchMemberOptions, isRetentionView, currentYearPlanId }));
    }
    selectMemberForAgent$(agentGuid, memberId, includeArchived = false, isEnrollmentHistoryIncluded, includeSOA, includeAgentCallHistory, includeLastAccessedHistory) {
        return this.sessionHttpService.createSession$({ agentGuid, includeArchived }, memberId).pipe(switchMap(member => {
            const { sessionId } = member;
            return this.fetchMemberSession$({
                sessionId,
                isEnrollmentHistoryIncluded,
                includeSOA,
                includeAgentCallHistory,
                includeLastAccessedHistory
            });
        }));
    }
    getMemberQuoteHistory$() {
        const agentGuid = this.store.selectSnapshot(AgentState.agentGuid);
        const memberID = this.store.selectSnapshot(MemberState.memberID);
        const planYear = this.planYearResourceService.getSelectedPlanYear();
        const medSupQuoteMonthsLimit = this.resourceService.getProcessedResourceValue('Spa_MedSup_Quote_Months_Limit', null, 6);
        return this.sessionHttpService.getMemberQuoteHistory$(memberID, agentGuid, planYear, medSupQuoteMonthsLimit);
    }
    getMemberQuoteHistoryForAgent$() {
        return this.getMemberQuoteHistory$().pipe(publishLast(), refCount());
    }
    getMemberQuotes$(quoteTypes) {
        const sessionId = this.getMemberSessionId();
        return this.sessionHttpService
            .getMemberQuotes$(sessionId)
            .pipe(quoteTypes?.length
            ? map(memberQuotes => memberQuotes?.filter(memberQuote => quoteTypes.includes(memberQuote.quoteType)) ?? [])
            : identity);
    }
    getMemberNotesHistory$() {
        const agentGuid = this.store.selectSnapshot(AgentState.agentGuid);
        this.store.dispatch(new SetMemberLoading(true));
        if (!this.isLiveEdit && agentGuid) {
            return this.sessionHttpService
                .getMemberDashboardNotes$(agentGuid, true)
                .pipe(tap(() => this.store.dispatch(new SetMemberLoading(false))));
        }
        return this.store.dispatch(new SetMemberLoading(false)).pipe(switchMap(() => of(null)));
    }
    createOrUpdateSessionWithSSOID$(apiMemberStateModel) {
        return this.sessionHttpService.createOrUpdateSessionWithSSOID$(apiMemberStateModel);
    }
    async updateEnrollmentUserType(transactionGuid, userType) {
        const sessionId = this.getMemberSessionId();
        return await this.sessionHttpService.updateEnrollmentUserType(sessionId, transactionGuid, userType);
    }
    updateTotalCostEffectiveDateInSession$(totalCostEffectiveDate) {
        const sessionId = this.getMemberSessionId();
        return this.sessionHttpService.updateTotalCostEffectiveDate$(sessionId, totalCostEffectiveDate);
    }
    async updateTotalCostEffectiveDateInSession(totalCostEffectiveDate) {
        const sessionId = this.getMemberSessionId();
        return await this.sessionHttpService.updateTotalCostEffectiveDate(sessionId, totalCostEffectiveDate);
    }
    getSessionByUniqueCode$(uniqueCode, agentGuid) {
        if (this.showUniqueCodeSessionId) {
            return this.sessionHttpService.getSessionBySessionId$(uniqueCode, agentGuid);
        }
        return this.sessionHttpService.getSessionBySSOCode$(uniqueCode, agentGuid);
    }
    getMedicalCostDefault$(ageRange, healthStatus) {
        return this.sessionHttpService.getMedicalCostDefault$(ageRange, healthStatus);
    }
    getMedicalCosts$() {
        const sessionId = this.getMemberSessionId();
        return this.sessionHttpService.getMedicalCosts$(sessionId);
    }
    saveMedicalCosts$(medicalCost) {
        const sessionId = this.getMemberSessionId();
        return this.sessionHttpService.saveMedicalCosts$(medicalCost, sessionId);
    }
    isLoadingEstimateHealthCost$() {
        return this.loadingEstimateHealthCost$.asObservable();
    }
    saveEstimateHealthCost(estimateHealthCost, requestFeedback) {
        const sessionId = this.getMemberSessionId();
        this.loadingEstimateHealthCost$.next(true);
        this.sessionHttpService.saveEstimateHealthCost$(estimateHealthCost, sessionId).subscribe({
            next: () => {
                this.loadingEstimateHealthCost$.next(false);
                this.store.dispatch(new UpdateDemographics({ estimateHealthCost }));
                if (requestFeedback) {
                    requestFeedback(true);
                }
            },
            error: err => {
                if (requestFeedback) {
                    requestFeedback(false);
                }
                console.error(err);
            }
        });
    }
    getEstimateHealthCost() {
        return this.store.selectSnapshot(DemographicState.healthCostEstimate);
    }
    setHealthMedicalCostInputs(medicalCostCabinetUpdatePayload) {
        this.store.dispatch(new SetMedicalCostInputs(medicalCostCabinetUpdatePayload));
    }
    /**
     * Takes zip and fips geo location data and rehydrates the helpful tools state with
     * valid zip and fips information.
     * @param helpfulToolsData - Zip and fips information as HelpfulToolsData Object.
     */
    rehydrateHelpfulTools(helpfulToolsData) {
        const { zipCode, fipsCode } = helpfulToolsData;
        if (zipCode) {
            this.store.dispatch(new SetZipCode(zipCode));
        }
        if (fipsCode) {
            this.store.dispatch(new SetFipsCode(fipsCode));
        }
    }
    getClientId() {
        return this.authService.getClientId();
    }
    async updateSession(sessionId, memberModel) {
        await firstValueFrom(this.updateSession$(sessionId, memberModel), { defaultValue: null });
    }
    updateSession$(sessionId, memberModel) {
        return this.store.dispatch(new UpdateSession(sessionId, memberModel));
    }
    getUniqueCode(session) {
        const sessionId = session?.sessionId ?? this.getMemberSessionId();
        const ssoCode = session?.ssoValue ?? this.getMemberSSO();
        return this.showUniqueCodeSessionId ? sessionId : ssoCode;
    }
    setPartAEffectiveDate(date) {
        this.store.dispatch(new SetPartAEffectiveDate(date));
    }
    setPartBEffectiveDate(date) {
        this.store.dispatch(new SetPartBEffectiveDate(date));
    }
    isRetentionMemberFromSource$(memberSourceValue = MemberSourceValue.CLAIMS) {
        return this.store.select(ProfileState.isRetentionMemberFromSource(memberSourceValue));
    }
    isRetentionMemberFromSource(memberSourceValue = MemberSourceValue.CLAIMS) {
        return this.store.selectSnapshot(ProfileState.isRetentionMemberFromSource(memberSourceValue));
    }
    getMemberUserName() {
        return this.store.selectSnapshot(MemberState.userName);
    }
    getMemberDateOfBirth() {
        return this.store.selectSnapshot(MemberState.dateOfBirth);
    }
    assignPrimaryAgent$(assigningAgentGuid, assignPrimaryAgentGuid, sessionId = this.getMemberSessionId()) {
        return this.sessionHttpService.assignPrimaryAgent$(assigningAgentGuid, assignPrimaryAgentGuid, sessionId);
    }
    reassignAgentForBeneficiary$(assigningAgentGuid, agentGuid, sessionId = this.getMemberSessionId()) {
        return this.sessionHttpService.reassignAgentForBeneficiary$(assigningAgentGuid, agentGuid, sessionId);
    }
    reassignSelectRxTask$(memberAgentNoteID, userAgentGUID, sessionId = this.getMemberSessionId()) {
        return this.sessionHttpService.reassignSelectRxTask$(memberAgentNoteID, userAgentGUID, sessionId);
    }
    saveVoiceSignatureStatements$(sessionId, transactionGuid, voiceSignatureSections, locale) {
        return this.sessionHttpService.saveVoiceSignatureStatements$(sessionId, transactionGuid, voiceSignatureSections, locale);
    }
    createAuthorizationCode$(sessionId, agentGuid, transactionGuid, deliverySettings) {
        return this.sessionHttpService.createAuthorizationCode$(sessionId, agentGuid, transactionGuid, deliverySettings);
    }
    validateAuthorizationCode$(sessionId, agentGuid, transactionGuid, authCode) {
        return this.sessionHttpService.validateAuthorizationCode$(sessionId, agentGuid, transactionGuid, authCode);
    }
    sendRetireFloSurvey$(sessionId, sendRetireFloSurveyForm) {
        return this.sessionHttpService.sendRetireFloSurvey$(sessionId, sendRetireFloSurveyForm);
    }
    getRetireFloSurvey$(sessionId, agentGuid, memberId, message) {
        return this.sessionHttpService.getRetireFloSurvey$(sessionId, agentGuid, memberId, message);
    }
    authenticateConsumerFromEnrollment$(authInfo, TotpCode) {
        return this.sessionHttpService.pinAuthenticate$(authInfo, "totp" /* AuthType.TOTP */, TotpCode);
    }
    async setInitialMemberDemographics(sessionId) {
        const profileAddress = this.store.selectSnapshot(ProfileState.primaryAddress);
        if (profileAddress) {
            const primaryZip = profileAddress?.zip ?? '';
            const primaryFips = profileAddress?.countyFips ?? '';
            const demographicZipCode = this.getZipCode();
            const demographicFipsCode = this.getFipsCode();
            if (demographicZipCode !== primaryZip) {
                this.store.dispatch(new SelectZipAndFIPS(primaryZip, primaryFips));
            }
            if (primaryFips !== demographicFipsCode) {
                if (!primaryFips) {
                    const counties = await this.demographicHttpService.retrieveCounties(primaryZip);
                    if (counties?.length === 1) {
                        this.store.dispatch(new SelectFIPS(counties[0].countyFIPS));
                    }
                }
                else {
                    this.store.dispatch(new SelectFIPS(primaryFips));
                }
            }
            if (sessionId && (demographicZipCode !== primaryZip || primaryFips !== demographicFipsCode)) {
                this.store.dispatch(new UpdateDemographicSession(sessionId));
            }
        }
    }
    updateMemberArchiveStatus$(isArchived) {
        const sessionId = this.getMemberSessionId();
        const memberID = this.store.selectSnapshot(MemberState.memberID);
        return this.sessionHttpService.updateMemberArchiveStatus$(sessionId, isArchived, memberID);
    }
    getMemberNotifications$(memberNotificationStatuses, widgetName, checkIfActive = true) {
        const sessionId = this.getMemberSessionId();
        return this.sessionHttpService
            .getMemberNotifications$(sessionId)
            .pipe(map(memberNotifications => this.mapMemberNotifications(memberNotifications, memberNotificationStatuses, widgetName, checkIfActive)));
    }
    createMemberNotification$(payload) {
        const sessionId = this.getMemberSessionId();
        return this.sessionHttpService.createMemberNotification$(sessionId, payload);
    }
    updateMemberNotification$(notificationId, payload) {
        const sessionId = this.getMemberSessionId();
        return this.sessionHttpService.updateMemberNotification$(sessionId, notificationId, payload);
    }
    async dismissMemberNotification(notificationId, status, currentDate) {
        const sessionId = this.getMemberSessionId();
        return await firstValueFrom(this.sessionHttpService.dismissMemberNotification$(sessionId, notificationId, status, currentDate), {
            defaultValue: undefined
        });
    }
    filterMemberNotifications(memberNotifications, options) {
        const notificationStatuses = options?.notificationStatuses ?? [];
        const notificationTypes = options?.notificationTypes ?? [];
        const checkIfActive = options?.checkIfActive ?? true;
        return (memberNotifications?.filter(memberNotification => (!checkIfActive || memberNotification.isActive) &&
            (!notificationStatuses?.length || notificationStatuses.includes(memberNotification.status)) &&
            (!notificationTypes?.length || notificationTypes.includes(memberNotification.notificationTypeId))) ?? []);
    }
    mapMemberNotifications(memberNotifications, memberNotificationStatuses, widgetName, checkIfActive = true) {
        return (memberNotifications?.reduce((notifications, memberNotification) => {
            if ((!checkIfActive || memberNotification.isActive) &&
                (!memberNotificationStatuses?.length || memberNotificationStatuses.includes(memberNotification.status))) {
                let actionButtonText = '';
                let actionButtonKeyName = '';
                if (memberNotification.notificationTypeId === MemberNotificationType.QUICKQUOTE) {
                    actionButtonText = this.resourceService.getProcessedResourceValue('Spa_MemberNotification_QuoteActionButton_Text', widgetName, 'View quote');
                    actionButtonKeyName = 'Spa_MemberNotification_QuoteActionButton_Text';
                }
                else if (memberNotification.notificationTypeId === MemberNotificationType.SENDTOBENEFICIARY ||
                    memberNotification.notificationTypeId === MemberNotificationType.SIGNANDSUBMIT) {
                    actionButtonText = this.resourceService.getProcessedResourceValue('Spa_MemberNotification_PartialEnrollmentActionButton_Text', widgetName, 'Continue enrollment');
                    actionButtonKeyName = 'Spa_MemberNotification_PartialEnrollmentActionButton_Text';
                }
                else if (memberNotification.notificationTypeId === MemberNotificationType.SOA) {
                    actionButtonText = this.resourceService.getProcessedResourceValue('Spa_MemberNotification_SOAActionButton_Text', widgetName, 'Complete Scope of Appointment');
                    actionButtonKeyName = 'Spa_MemberNotification_SOAActionButton_Text';
                }
                notifications.push({ ...memberNotification, actionButtonText, actionButtonKeyName });
            }
            return notifications;
        }, []) ?? []);
    }
    /**
     * Takes plans data and rehydrates our store's selected plans and riders
     * @param plans - The array of plans data to rehydrate with
     */
    async rehydratePlans(plans, updatePlanDetails) {
        if (plans?.length) {
            const shoppingCart = this.store.selectSnapshot(ShoppingCartState.selectCartAPIState);
            const operations = shoppingCart.map(async (plan) => {
                const foundPlan = plans.find(planFromList => planFromList.id === plan.planId);
                if (foundPlan) {
                    // direct dispatch instead of calling session function to avoid immediately reupdating api
                    if (shoppingCart.length > 1) {
                        // to update store with bundle plan
                        const plansSelectedRiders = this.shoppingCartService.getPlanSelectedRiders(foundPlan);
                        const riders = PlansUtilityService.getRiderData(foundPlan);
                        const newItem = PlansUtilityService.createShoppingCartEntry(foundPlan, riders);
                        this.store.dispatch(new InsertPlanWithBundle(foundPlan, newItem, plansSelectedRiders));
                    }
                    else {
                        this.store.dispatch(new SelectPlan(foundPlan));
                        const plansSelectedRiderIds = shoppingCart
                            .find(cartPlan => cartPlan.planId === foundPlan.id)
                            .riders.filter(rider => rider.isSelected || rider.isRequired)
                            .map(rider => rider.riderId);
                        plansSelectedRiderIds.forEach(selectedRiderId => this.store.dispatch(new SelectRider(selectedRiderId)));
                    }
                    if (updatePlanDetails) {
                        return await this.plansService.fetchAndUpdatePlanDetails(foundPlan);
                    }
                }
            });
            return await Promise.all(operations);
        }
    }
    async setQuotedPlans(plans, planIds, updatePlanDetails) {
        if (plans && planIds) {
            this.store.dispatch(new SetBeneficiaryPlanIds(planIds));
            const quotedPlans = plans.filter(plan => planIds.includes(plan.id));
            if (quotedPlans?.length) {
                // quoting needs all the plans selected to still display in the cart, so go get and select every plan
                const shoppingCart = this.store.selectSnapshot(ShoppingCartState.selectCartAPIState);
                const plans = [];
                const planIds = shoppingCart.map(apiItem => apiItem.planId);
                planIds.forEach(planId => {
                    const plan = this.plansService.getPlan(planId);
                    if (plan) {
                        plans.push(plan);
                    }
                });
                return await Promise.all([
                    this.rehydratePlans(plans, updatePlanDetails),
                    firstValueFrom(this.store.dispatch(new SetDefaultTab(quotedPlans[0].planTypeAbbreviation)), { defaultValue: null }),
                    firstValueFrom(this.store.dispatch(new SetQuoteGroup({
                        ...new CompareGroup(FilterKeyType.PLAN_TYPE_SHORT, [quotedPlans[0].planTypeAbbreviation]),
                        items: quotedPlans
                    })), { defaultValue: null })
                ]);
            }
        }
    }
    isRetentionView() {
        return this.siteService.isRetentionView();
    }
    tagToUpdate(agentGuid) {
        const sessionId = this.getMemberSessionId();
        const currentPage = this.store.selectSnapshot(AppConfigState.page(this.router.url));
        if (!agentGuid && currentPage && currentPage.tags.includes(PageTags.HOME)) {
            this.googleTagManagerService.setGoogleDataLayerTag(DataLayerGlobalVariable.APP_SESSION_ID, sessionId);
        }
    }
    async banAgentFromSession() {
        await this.agentService.banAgentFromSession();
        this.quoteService.clearBeneficiaryAgent();
    }
}
MemberSessionService.ɵfac = function MemberSessionService_Factory(t) { return new (t || MemberSessionService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(MemberSessionHttpService), i0.ɵɵinject(PharmacyHttpService), i0.ɵɵinject(DrugsHttpService), i0.ɵɵinject(PlansService), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(SiteService), i0.ɵɵinject(AuthService), i0.ɵɵinject(AgentService), i0.ɵɵinject(GoogleTagManagerService), i0.ɵɵinject(i2$1.Router), i0.ɵɵinject(SpinnerService), i0.ɵɵinject(ShoppingCartService), i0.ɵɵinject(QuoteService), i0.ɵɵinject(ProviderService), i0.ɵɵinject(MedSupService), i0.ɵɵinject(PlanYearResourceService), i0.ɵɵinject(DemographicHttpService), i0.ɵɵinject(CacheContext)); };
MemberSessionService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MemberSessionService, factory: MemberSessionService.ɵfac, providedIn: 'root' });
__decorate([
    LiveEditInactive()
], MemberSessionService.prototype, "registerAccount", null);
__decorate([
    LiveEditInactive()
], MemberSessionService.prototype, "updateMemberProfile", null);
__decorate([
    LiveEditInactive()
], MemberSessionService.prototype, "addMemberNoteByAgent", null);
__decorate([
    LiveEditInactive()
], MemberSessionService.prototype, "updateMemberTask", null);
__decorate([
    LiveEditInactive()
], MemberSessionService.prototype, "updateDashBoardMemberTask", null);
__decorate([
    LiveEditInactive()
], MemberSessionService.prototype, "createAccountAndLogin", null);
__decorate([
    LiveEditInactive()
], MemberSessionService.prototype, "updateSelectedMemberDetails", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MemberSessionService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.Store }, { type: MemberSessionHttpService }, { type: PharmacyHttpService }, { type: DrugsHttpService }, { type: PlansService }, { type: ConfigResourceService }, { type: SiteService }, { type: AuthService }, { type: AgentService }, { type: GoogleTagManagerService }, { type: i2$1.Router }, { type: SpinnerService }, { type: ShoppingCartService }, { type: QuoteService }, { type: ProviderService }, { type: MedSupService }, { type: PlanYearResourceService }, { type: DemographicHttpService }, { type: CacheContext }]; }, { registerAccount: [], updateMemberProfile: [], addMemberNoteByAgent: [], updateMemberTask: [], updateDashBoardMemberTask: [], createAccountAndLogin: [], updateSelectedMemberDetails: [] }); })();

class EnrollmentSettingsParams {
}
class HRAExternalLinkRequest {
}
class CustomParamData {
}
class RiderData {
}

var EnrollmentTransactionStatus;
(function (EnrollmentTransactionStatus) {
    EnrollmentTransactionStatus["COMPLETED"] = "COMPLETED";
    EnrollmentTransactionStatus["SUCCESS"] = "SUCCESS";
    EnrollmentTransactionStatus["FORM_NOT_VALID"] = "FORMNOTVALID";
    EnrollmentTransactionStatus["FAIL_COMPLETED"] = "FAILCOMPLETED";
})(EnrollmentTransactionStatus || (EnrollmentTransactionStatus = {}));
// Used when sending/receiving directly from HOPE API
// Do not use unless necessary (e.g. generic form when enrolling with no plan in context and no REST API matches)
// No member enrollment entry will be created since that is done by SPA REST API
// Use EnrollmentTransaction if trying to enroll in a plan.
class Transaction {
}
class ConfirmationSettings {
}
class PDFGeneratorSettings {
}
class ResourceReference {
}
var PlacementArea;
(function (PlacementArea) {
    PlacementArea["NONE"] = "None";
    PlacementArea["HEADER"] = "Header";
    PlacementArea["FOOTER"] = "Footer";
})(PlacementArea || (PlacementArea = {}));

const ABSOLUTE_URL_REGEX = /^https?:\/\/|^\/\//i;
class ImageService {
    constructor(configResourceService) {
        this.configResourceService = configResourceService;
    }
    resolveFullImagePath(src) {
        if (ABSOLUTE_URL_REGEX.test(src)) {
            return src;
        }
        const contentServerUrl = this.configResourceService.getProcessedResourceValue('ContentServerUrl');
        return this.prepend(contentServerUrl, src);
    }
    prepend(prefix, src) {
        if (!prefix) {
            return src;
        }
        let validPrefix = prefix;
        if (!prefix.endsWith('/')) {
            validPrefix = prefix.concat('/');
        }
        return `${validPrefix}${src}`;
    }
}
ImageService.ɵfac = function ImageService_Factory(t) { return new (t || ImageService)(i0.ɵɵinject(ConfigResourceService)); };
ImageService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ImageService, factory: ImageService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImageService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ConfigResourceService }]; }, null); })();

class EnrollmentPostBackService {
    constructor(configResourceService) {
        this.configResourceService = configResourceService;
    }
    getConfirmationPostBackEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_ConfirmationPostBack_Enabled', widgetName, false);
    }
    getConfirmationPostBackUrl(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_ConfirmationPostBack_Url', widgetName);
    }
}
EnrollmentPostBackService.ɵfac = function EnrollmentPostBackService_Factory(t) { return new (t || EnrollmentPostBackService)(i0.ɵɵinject(ConfigResourceService)); };
EnrollmentPostBackService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: EnrollmentPostBackService, factory: EnrollmentPostBackService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnrollmentPostBackService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ConfigResourceService }]; }, null); })();

/* eslint-disable @typescript-eslint/naming-convention */
const PASS_PARAMS_DATE_INPUT_FORMAT = 'MMDDYYYY';
const PASS_PARAMS_DATE_INPUT_REGEX = /^[0-9]{8}$/;
const PASS_PARAMS_DATE_OUTPUT_FORMAT = 'YYYY-MM-DD';
const BROKER_URL = 'BrokerURL';
var PassParameterInputType;
(function (PassParameterInputType) {
    PassParameterInputType["SSO"] = "SSO";
    PassParameterInputType["DEEP_LINKING"] = "DeepLinking";
})(PassParameterInputType || (PassParameterInputType = {}));
class PassParams {
    // eslint-disable-next-line complexity
    static createFromDeepLinking(deepLinkingParams) {
        if (deepLinkingParams && Object.keys(deepLinkingParams).length) {
            const { ZIPCODE: ZipCode, ZIP: Zip, COUNTYFIPS: CountyFips, FIPS: Fips, PLANTYPE: PlanType, PLANID: PlanId, PLAN: Plan, CULTURECODE: CultureCode, SSOVALUE: SSOValue, BENEFIRSTNAME: BeneFirstName, BENELASTNAME: BeneLastName, BENEBIRTHDATE: BeneBirthDate, BENEGENDER: BeneGender, BENECRMID: BeneCRMID, BENEADDR1: BeneAddr1, BENEADDR2: BeneAddr2, BENECITY: BeneCity, BENESTATE: BeneState, BENEPHONE: BenePhone, BENECELLPHONE: BeneCellPhone, BENEEMAIL: BeneEmail, AGENTID: AgentId, AGENCYNAME: AgencyName, AGENCYID: AgencyId, SOURCEID: SourceId, PARTNERID: PartnerId, RETURNURL: ReturnUrl, UTM_SOURCE: UTM_Source, UTM_MEDIUM: UTM_Medium, UTM_CAMPAIGN: UTM_Campaign, UTM_CONTENT: UTM_Content, IS_PURL_REQUEST: IsPurlRequest, TFN, CUSTOMTRACK1: CustomTrack1, CUSTOMTRACK2: CustomTrack2, CUSTOMTRACK3: CustomTrack3, CUSTOMTRACK4: CustomTrack4, CUSTOMTRACK5: CustomTrack5, CUSTOMFMO1: CustomFMO1, CUSTOMFMO2: CustomFMO2, CUSTOMFMO3: CustomFMO3, CUSTOMFMO4: CustomFMO4, CUSTOMFMO5: CustomFMO5, SESSIONID: SessionId, SUBSIDYSELECTED: SubsidySelected, SUBSIDYPERCENT: SubsidyPercent, TRANSACTIONGUID: TransactionGuid, QUOTEID: QuoteId, AGENTGUID: AgentGuid, QUOTETYPE: QuoteType, PURLID: PurlId } = deepLinkingParams;
            return {
                ...(ZipCode && { ZipCode }),
                ...(Zip && { Zip }),
                ...(CountyFips && { CountyFips }),
                ...(Fips && { Fips }),
                ...(PlanType && { PlanType }),
                ...(PlanId && { PlanId }),
                ...(Plan && { Plan }),
                ...(CultureCode && { CultureCode }),
                ...(SSOValue && { SSOValue }),
                ...(BeneFirstName && { BeneFirstName }),
                ...(BeneLastName && { BeneLastName }),
                ...(BeneBirthDate && { BeneBirthDate }),
                ...(BeneGender && { BeneGender }),
                ...(BeneCRMID && { BeneCRMID }),
                ...(BeneAddr1 && { BeneAddr1 }),
                ...(BeneAddr2 && { BeneAddr2 }),
                ...(BeneCity && { BeneCity }),
                ...(BeneState && { BeneState }),
                ...(BenePhone && { BenePhone }),
                ...(BeneCellPhone && { BeneCellPhone }),
                ...(BeneEmail && { BeneEmail }),
                ...(AgentId && { AgentId }),
                ...(AgencyName && { AgencyName }),
                ...(AgencyId && { AgencyId }),
                ...(SourceId && { SourceId }),
                ...(PartnerId && { PartnerId }),
                ...(ReturnUrl && { ReturnUrl }),
                ...(UTM_Source && { UTM_Source }),
                ...(UTM_Medium && { UTM_Medium }),
                ...(UTM_Campaign && { UTM_Campaign }),
                ...(UTM_Content && { UTM_Content }),
                ...(IsPurlRequest && { IsPurlRequest }),
                ...(TFN && { TFN }),
                ...(CustomTrack1 && { CustomTrack1 }),
                ...(CustomTrack2 && { CustomTrack2 }),
                ...(CustomTrack3 && { CustomTrack3 }),
                ...(CustomTrack4 && { CustomTrack4 }),
                ...(CustomTrack5 && { CustomTrack5 }),
                ...(CustomFMO1 && { CustomFMO1 }),
                ...(CustomFMO2 && { CustomFMO2 }),
                ...(CustomFMO3 && { CustomFMO3 }),
                ...(CustomFMO4 && { CustomFMO4 }),
                ...(CustomFMO5 && { CustomFMO5 }),
                ...(SessionId && { SessionId }),
                ...(SubsidySelected && { SubsidySelected }),
                ...(SubsidyPercent && { SubsidyPercent }),
                ...(TransactionGuid && { TransactionGuid }),
                ...(QuoteId && { QuoteId }),
                ...(AgentGuid && { AgentGuid }),
                ...(QuoteType && { QuoteType }),
                ...(PurlId && { PurlId })
            };
        }
        return null;
    }
    static createUTMFromQueryParams(queryParams) {
        if (queryParams && Object.keys(queryParams).length) {
            const { UTM_SOURCE: UTM_Source, UTM_MEDIUM: UTM_Medium, UTM_CAMPAIGN: UTM_Campaign, UTM_CONTENT: UTM_Content } = queryParams;
            return {
                ...(UTM_Source && { UTM_Source }),
                ...(UTM_Medium && { UTM_Medium }),
                ...(UTM_Campaign && { UTM_Campaign }),
                ...(UTM_Content && { UTM_Content })
            };
        }
        return null;
    }
    // eslint-disable-next-line complexity
    static createFromSSO(sso, siteType) {
        let params = null;
        if (sso) {
            params = { sso };
            const state = sso.state;
            const integration = sso.integration;
            if (state) {
                const { usertype: UserType, authCode1: AuthCode1, authCode2: AuthCode2, authCode3: AuthCode3, authCode4: AuthCode4, ssoName: SSOName, ssoValue: SSOValue, ssoZipCode: SSOZipCode, zipCode: ZipCode, zip: Zip, countyFips: CountyFips, fips: Fips, beneFirstName: BeneFirstName, beneLastName: BeneLastName, beneBirthDate: BeneBirthDate, beneGender: BeneGender, beneCRMID: BeneCRMID, beneAddr1: BeneAddr1, beneAddr2: BeneAddr2, beneCity: BeneCity, beneState: BeneState, benePhone: BenePhone, beneCellPhone: BeneCellPhone, beneEmail: BeneEmail, beneUserName: BeneUserName, benePassword: BenePassword, beneMBI: BeneMBI, benePartADate: BenePartADate, benePartBDate: BenePartBDate, reqType: ReqType, agentExternalId: AgentExternalId, agentUsername: AgentUserName, plantype: PlanType, culturecode: CultureCode, planid: PlanId, plan: Plan, militaryRank: MilitaryRank, militaryStatus: MilitaryStatus, militaryBranch: MilitaryBranch, militaryPrefixCode: MilitaryPrefixCode, PopulatedData, PEGI: Pegi, Channel, sessionid: SessionId, agentlogindomain: AgentLoginDomain, sourcesitetype: SourceSiteType, sourcesiteid: SourceSiteId, ptag: PageTag, accountguid: AccountGuid, agentguid: AgentGuid, agentlogin_logindomain: AgentLogin_LoginDomain, quickquoteguid: QuickQuoteGuid, quoteid: quoteId, lang, py: PY, destinationsitetype: DestinationSiteType, quotetype: QuoteType, deliverymethod: DeliveryMethod, originalAppId: OriginalAppId } = state;
                params = {
                    ...params,
                    ...(UserType && { UserType }),
                    ...(AuthCode1 && { AuthCode1 }),
                    ...(AuthCode2 && { AuthCode2 }),
                    ...(AuthCode3 && { AuthCode3 }),
                    ...(AuthCode4 && { AuthCode4 }),
                    ...(SSOName && { SSOName }),
                    ...(SSOValue && { SSOValue }),
                    ...(SSOZipCode && { SSOZipCode }),
                    ...(ZipCode && { ZipCode }),
                    ...(Zip && { Zip }),
                    ...(CountyFips && { CountyFips }),
                    ...(Fips && { Fips }),
                    ...(BeneFirstName && { BeneFirstName }),
                    ...(BeneLastName && { BeneLastName }),
                    ...(BeneBirthDate && { BeneBirthDate }),
                    ...(BeneGender && { BeneGender }),
                    ...(BeneCRMID && { BeneCRMID }),
                    ...(BeneAddr1 && { BeneAddr1 }),
                    ...(BeneAddr2 && { BeneAddr2 }),
                    ...(BeneCity && { BeneCity }),
                    ...(BeneState && { BeneState }),
                    ...(BenePhone && { BenePhone }),
                    ...(BeneCellPhone && { BeneCellPhone }),
                    ...(BeneEmail && { BeneEmail }),
                    ...(BeneUserName && { BeneUserName }),
                    ...(BenePassword && { BenePassword }),
                    ...(BeneMBI && { BeneMBI }),
                    ...(BenePartADate && { BenePartADate }),
                    ...(BenePartBDate && { BenePartBDate }),
                    ...(ReqType && { ReqType }),
                    ...(AgentExternalId && { AgentExternalId }),
                    ...(AgentUserName && { AgentUserName }),
                    ...(PlanType && { PlanType }),
                    ...(CultureCode && { CultureCode }),
                    ...(PlanId && { PlanId }),
                    ...(Plan && { Plan }),
                    ...(MilitaryRank && { MilitaryRank }),
                    ...(Plan && { Plan }),
                    ...(MilitaryStatus && { MilitaryStatus }),
                    ...(MilitaryBranch && { MilitaryBranch }),
                    ...(MilitaryPrefixCode && { MilitaryPrefixCode }),
                    ...(PopulatedData && { PopulatedData }),
                    ...(Pegi && { Pegi }),
                    ...(Channel && { Channel }),
                    ...(SessionId && { SessionId }),
                    ...(AgentLoginDomain && { AgentLoginDomain }),
                    ...(SourceSiteType && { SourceSiteType }),
                    ...(SourceSiteId && { SourceSiteId }),
                    ...(PageTag && { PageTag }),
                    ...(AccountGuid && { AccountGuid }),
                    ...(AgentGuid && { AgentGuid }),
                    ...(AgentLogin_LoginDomain && { AgentLogin_LoginDomain }),
                    ...(QuickQuoteGuid && { QuickQuoteGuid }),
                    ...(quoteId && { quoteId }),
                    ...(lang && { lang }),
                    ...(PY && { PY }),
                    ...(DestinationSiteType && { DestinationSiteType }),
                    ...(QuoteType && { QuoteType }),
                    ...(DeliveryMethod && { DeliveryMethod }),
                    ...(OriginalAppId && { OriginalAppId })
                };
            }
            if (integration) {
                const { CustomTrack1, CustomTrack2, CustomTrack3, CustomTrack4, CustomTrack5, CustomFMO1, CustomFMO2, CustomFMO3, CustomFMO4, CustomFMO5, PartnerID: PartnerId, AgentID: AgentId, AgencyName, AgencyID: AgencyId, SourceID: SourceId, User_Type, AgentLastName: AgentFirstName, ReturnURL: ReturnUrl, FFMSender_UserType, IsBrokerAssistedFlow, MaintenanceTypeCode, ReasonCode, utm_source: UTM_Source, utm_medium: UTM_Medium, utm_campaign: UTM_Campaign, utm_content: UTM_Content, is_purl_request: IsPurlRequest, TFN } = integration;
                params = {
                    ...params,
                    ...(CustomTrack1 && { CustomTrack1 }),
                    ...(CustomTrack2 && { CustomTrack2 }),
                    ...(CustomTrack3 && { CustomTrack3 }),
                    ...(CustomTrack4 && { CustomTrack4 }),
                    ...(CustomTrack5 && { CustomTrack5 }),
                    ...(CustomFMO1 && { CustomFMO1 }),
                    ...(CustomFMO2 && { CustomFMO2 }),
                    ...(CustomFMO3 && { CustomFMO3 }),
                    ...(CustomFMO4 && { CustomFMO4 }),
                    ...(CustomFMO5 && { CustomFMO5 }),
                    ...(PartnerId && { PartnerId }),
                    ...(AgentId && siteType === SiteType.CONSUMER && { AgentId }),
                    ...(AgencyName && siteType === SiteType.CONSUMER && { AgencyName }),
                    ...(AgencyId && siteType === SiteType.CONSUMER && { AgencyId }),
                    ...(SourceId && { SourceId }),
                    ...(User_Type && { User_Type }),
                    ...(AgentFirstName && { AgentFirstName }),
                    ...(ReturnUrl && { ReturnUrl }),
                    ...(FFMSender_UserType && { FFMSender_UserType }),
                    ...(IsBrokerAssistedFlow && { IsBrokerAssistedFlow }),
                    ...(MaintenanceTypeCode && { MaintenanceTypeCode }),
                    ...(ReasonCode && { ReasonCode }),
                    ...(UTM_Source && { UTM_Source }),
                    ...(UTM_Medium && { UTM_Medium }),
                    ...(UTM_Campaign && { UTM_Campaign }),
                    ...(UTM_Content && { UTM_Content }),
                    ...(IsPurlRequest && { IsPurlRequest }),
                    ...(TFN && { TFN })
                };
            }
        }
        return params;
    }
    static createFromAgentPurlInformation(agentPurlInformation) {
        let params = null;
        const { userType: UserType, agentUserName: AgentUserName, agentLoginDomain: AgentLoginDomain, sourceSiteType: SourceSiteType, sourceSiteId: SourceSiteId, accountGuid: AccountGuid, originalAppId: OriginalAppId, ptag: PageTag, lang } = agentPurlInformation;
        params = {
            ...params,
            ...(UserType && { UserType }),
            ...(AgentUserName && { AgentUserName }),
            ...(AgentLoginDomain && { AgentLoginDomain }),
            ...(SourceSiteType && { SourceSiteType }),
            ...(SourceSiteId && { SourceSiteId }),
            ...(AccountGuid && { AccountGuid }),
            ...(lang && { lang }),
            ...(OriginalAppId && { OriginalAppId }),
            ...(PageTag && { PageTag })
        };
        return params;
    }
    // eslint-disable-next-line complexity
    static mapToDeepLinkingParams(params) {
        if (params) {
            const { ZipCode: ZIPCODE, Zip: ZIP, CountyFips: COUNTYFIPS, Fips: FIPS, PlanType: PLANTYPE, PlanId: PLANID, Plan: PLAN, CultureCode: CULTURECODE, SSOValue: SSOVALUE, BeneFirstName: BENEFIRSTNAME, BeneLastName: BENELASTNAME, BeneBirthDate: BENEBIRTHDATE, BeneGender: BENEGENDER, BeneCRMID: BENECRMID, BeneAddr1: BENEADDR1, BeneAddr2: BENEADDR2, BeneCity: BENECITY, BeneState: BENESTATE, BenePhone: BENEPHONE, BeneCellPhone: BENECELLPHONE, BeneEmail: BENEEMAIL, AgentId: AGENTID, AgencyName: AGENCYNAME, AgencyId: AGENCYID, SourceId: SOURCEID, PartnerId: PARTNERID, ReturnUrl: RETURNURL, UTM_Source: UTM_SOURCE, UTM_Medium: UTM_MEDIUM, UTM_Campaign: UTM_CAMPAIGN, UTM_Content: UTM_CONTENT, IsPurlRequest: IS_PURL_REQUEST, TFN, CustomTrack1: CUSTOMTRACK1, CustomTrack2: CUSTOMTRACK2, CustomTrack3: CUSTOMTRACK3, CustomTrack4: CUSTOMTRACK4, CustomTrack5: CUSTOMTRACK5, CustomFMO1: CUSTOMFMO1, CustomFMO2: CUSTOMFMO2, CustomFMO3: CUSTOMFMO3, CustomFMO4: CUSTOMFMO4, CustomFMO5: CUSTOMFMO5, MilitaryBranch: MILITARYBRANCH, MilitaryPrefixCode: MILITARYPREFIXCODE, MilitaryRank: MILITARYRANK, MilitaryStatus: MILITARYSTATUS, PopulatedData: POPULATEDDATA, Pegi: PEGI, Channel: CHANNEL, SessionId: SESSIONID, SubsidySelected: SUBSIDYSELECTED, SubsidyPercent: SUBSIDYPERCENT, TransactionGuid: TRANSACTIONGUID, QuoteId: QUOTEID, AgentGuid: AGENTGUID, QuoteType: QUOTETYPE } = params;
            return {
                ...(ZIPCODE && { ZIPCODE }),
                ...(ZIP && { ZIP }),
                ...(COUNTYFIPS && { COUNTYFIPS }),
                ...(FIPS && { FIPS }),
                ...(PLANTYPE && { PLANTYPE }),
                ...(PLANID && { PLANID }),
                ...(PLAN && { PLAN }),
                ...(CULTURECODE && { CULTURECODE }),
                ...(SSOVALUE && { SSOVALUE }),
                ...(BENEFIRSTNAME && { BENEFIRSTNAME }),
                ...(BENELASTNAME && { BENELASTNAME }),
                ...(BENEBIRTHDATE && { BENEBIRTHDATE }),
                ...(BENEGENDER && { BENEGENDER }),
                ...(BENECRMID && { BENECRMID }),
                ...(BENEADDR1 && { BENEADDR1 }),
                ...(BENEADDR2 && { BENEADDR2 }),
                ...(BENECITY && { BENECITY }),
                ...(BENESTATE && { BENESTATE }),
                ...(BENEPHONE && { BENEPHONE }),
                ...(BENECELLPHONE && { BENECELLPHONE }),
                ...(BENEEMAIL && { BENEEMAIL }),
                ...(AGENTID && { AGENTID }),
                ...(AGENCYNAME && { AGENCYNAME }),
                ...(AGENCYID && { AGENCYID }),
                ...(SOURCEID && { SOURCEID }),
                ...(PARTNERID && { PARTNERID }),
                ...(RETURNURL && { RETURNURL }),
                ...(UTM_SOURCE && { UTM_SOURCE }),
                ...(UTM_MEDIUM && { UTM_MEDIUM }),
                ...(UTM_CAMPAIGN && { UTM_CAMPAIGN }),
                ...(UTM_CONTENT && { UTM_CONTENT }),
                ...(IS_PURL_REQUEST && { IS_PURL_REQUEST }),
                ...(TFN && { TFN }),
                ...(CUSTOMTRACK1 && { CUSTOMTRACK1 }),
                ...(CUSTOMTRACK2 && { CUSTOMTRACK2 }),
                ...(CUSTOMTRACK3 && { CUSTOMTRACK3 }),
                ...(CUSTOMTRACK4 && { CUSTOMTRACK4 }),
                ...(CUSTOMTRACK5 && { CUSTOMTRACK5 }),
                ...(CUSTOMFMO1 && { CUSTOMFMO1 }),
                ...(CUSTOMFMO2 && { CUSTOMFMO2 }),
                ...(CUSTOMFMO3 && { CUSTOMFMO3 }),
                ...(CUSTOMFMO4 && { CUSTOMFMO4 }),
                ...(CUSTOMFMO5 && { CUSTOMFMO5 }),
                ...(MILITARYBRANCH && { MILITARYBRANCH }),
                ...(MILITARYPREFIXCODE && { MILITARYPREFIXCODE }),
                ...(MILITARYRANK && { MILITARYRANK }),
                ...(MILITARYSTATUS && { MILITARYSTATUS }),
                ...(POPULATEDDATA && { POPULATEDDATA }),
                ...(PEGI && { PEGI }),
                ...(CHANNEL && { CHANNEL }),
                ...(SESSIONID && { SESSIONID }),
                ...(SUBSIDYSELECTED && { SUBSIDYSELECTED }),
                ...(SUBSIDYPERCENT && { SUBSIDYPERCENT }),
                ...(TRANSACTIONGUID && { TRANSACTIONGUID }),
                ...(QUOTEID && { QUOTEID }),
                ...(AGENTGUID && { AGENTGUID }),
                ...(QUOTETYPE && { QUOTETYPE })
            };
        }
        return null;
    }
}

class PassParameterUtilities {
    static resolveDate(date, fallbackToDateValue = false, inputFormat = PASS_PARAMS_DATE_INPUT_FORMAT, outputFormat = PASS_PARAMS_DATE_OUTPUT_FORMAT) {
        return PASS_PARAMS_DATE_INPUT_REGEX.test(date)
            ? DateUtilities.getFormattedDateFromString(date, inputFormat, outputFormat)
            : PassParameterUtilities.getFallbackValue(date, fallbackToDateValue);
    }
    static getFallbackValue(date, fallbackToDateValue) {
        return fallbackToDateValue ? date : null;
    }
}

class LoginService {
    constructor(navigationService, sessionService, agentService, configResourceService, siteService, quoteService) {
        this.navigationService = navigationService;
        this.sessionService = sessionService;
        this.agentService = agentService;
        this.configResourceService = configResourceService;
        this.siteService = siteService;
        this.quoteService = quoteService;
    }
    loggedIn$() {
        const siteTypeResourceValue = this.configResourceService.getProcessedResourceValue('Spa_Site_SiteType', null, 'consumer');
        return of(siteTypeResourceValue).pipe(switchMap(siteType => (this.siteService.isPPCSite(siteType) ? this.agentLoggedIn$ : this.memberLoggedIn$)));
    }
    logout(siteType, redirectAfterLogout) {
        const isRetentionView = this.siteService.isRetentionView();
        const isQuotingSite = this.siteService.isQuotingSite();
        if (this.siteService.isPPCSite(siteType)) {
            this.logoutMember(false, isRetentionView, isQuotingSite);
            this.logoutAgent(redirectAfterLogout);
        }
        else {
            this.logoutAgent(false);
            this.logoutMember(redirectAfterLogout, isRetentionView, isQuotingSite);
            if (this.agentService.isPurl()) {
                const purlAgentUsername = this.agentService.getPURLAgentUsername();
                if (purlAgentUsername && purlAgentUsername !== this.agentService.getAgentUserName()) {
                    this.loginAgent$({
                        ssoRequest: true,
                        userName: purlAgentUsername
                    })
                        .pipe(take(1))
                        .subscribe({
                        next: () => { }
                    });
                }
            }
            else {
                this.agentService.resetAgentState();
            }
        }
        this.sessionService.resetAuthType();
    }
    async login(siteType, userName, password, memberLoginOptions) {
        if (this.siteService.isPPCSite(siteType)) {
            return await this.loginAgent({ userName, userPassword: password });
        }
        return await this.loginMember(userName, password, memberLoginOptions);
    }
    async authenticateUserWithPIN(pinInfo, memberLoginOptions) {
        const authInfo = new AuthenticationInfo();
        authInfo.pinInfo = pinInfo;
        const authOptions = LoginAuthOptions.createDefaultOptions({ authType: "pin" /* AuthType.PIN */, authInfo });
        return await this.sessionService.memberLogin(null, null, authOptions, memberLoginOptions);
    }
    async loginSSOMember(ssoInfo, memberLoginOptions, newMemberInfo) {
        const authInfo = new AuthenticationInfo();
        authInfo.ssoInfo = ssoInfo;
        const authOptions = LoginAuthOptions.createDefaultOptions({ authType: "sso" /* AuthType.SSO */, authInfo });
        return await this.sessionService.memberLogin(null, null, authOptions, memberLoginOptions, newMemberInfo);
    }
    loginAgent$(agent) {
        return this.agentService.agentLogin$(agent);
    }
    async loggedIn() {
        return await this.loggedIn$().toPromise();
    }
    async loginMember(userName, password, memberLoginOptions) {
        return await this.sessionService.memberLogin(userName, password, null, memberLoginOptions);
    }
    logoutMember(redirectAfterLogout = true, isRetentionView, isQuotingSite) {
        this.sessionService.memberLogout();
        const isQuoteSummaryEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_EnableQuoteSummary', null, true);
        const medicareEdgeEnabled = this.configResourceService.getProcessedResourceValue('Spa_MedicareEdge_Enabled', null, false);
        if (redirectAfterLogout) {
            if (isRetentionView) {
                // Reset agent state after creating new member session.
                this.sessionService.createMemberSession$().toPromise();
                this.agentService.resetAgentState();
                this.siteService.setConsumerSiteType(ConsumerSiteType.RETENTION);
                this.navigationService.navigateByPageTag(this.configResourceService.getProcessedResourceValue('Spa_Site_Retention_MemberLogout_RedirectPageTag', null, PageTags.RETENTION));
            }
            else if ((isQuotingSite && isQuoteSummaryEnabled) || (medicareEdgeEnabled && this.agentService.getIsAgentInContext())) {
                // Retaining agent state
                this.sessionService.createMemberSession$().toPromise();
                this.siteService.setConsumerSiteType(ConsumerSiteType.QUOTING);
                this.navigationService.navigateByPageTag(this.configResourceService.getProcessedResourceValue('Spa_Site_Quoting_MemberLogout_RedirectPageTag', null, PageTags.BENEFICIARY_LOGIN));
            }
            else {
                this.siteService.setConsumerSiteType(ConsumerSiteType.ANONYMOUS);
                this.quoteService.resetBeneficiaryQuoteDetails();
                this.agentService.resetAgentState();
                // Create member session after resetting agent state.
                this.sessionService.createSession$().toPromise();
                this.navigationService.navigateByPageTag(this.configResourceService.getProcessedResourceValue('Spa_Site_MemberLogout_RedirectPageTag', null, PageTags.HOME));
            }
        }
    }
    logoutAgent(redirectAfterLogout) {
        this.agentService.agentLogout(redirectAfterLogout);
        this.sessionService.resetSessionState({
            clearAnonymousSession: true,
            clearRuntimeSession: true,
            clearPlanYearSession: true,
            clearPlanSmartSession: true
        });
    }
    async loginAgent(agent) {
        return await this.loginAgent$(agent).toPromise();
    }
}
LoginService.ɵfac = function LoginService_Factory(t) { return new (t || LoginService)(i0.ɵɵinject(NavigationService), i0.ɵɵinject(MemberSessionService), i0.ɵɵinject(AgentService), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(SiteService), i0.ɵɵinject(QuoteService)); };
LoginService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LoginService, factory: LoginService.ɵfac, providedIn: 'root' });
__decorate([
    Select(MemberState.isLoggedIn)
], LoginService.prototype, "memberLoggedIn$", void 0);
__decorate([
    Select(AgentState.isLoggedIn)
], LoginService.prototype, "agentLoggedIn$", void 0);
__decorate([
    LiveEditInactive()
], LoginService.prototype, "logout", null);
__decorate([
    LiveEditInactive()
], LoginService.prototype, "login", null);
__decorate([
    LiveEditInactive()
], LoginService.prototype, "authenticateUserWithPIN", null);
__decorate([
    LiveEditInactive()
], LoginService.prototype, "loginSSOMember", null);
__decorate([
    LiveEditInactive()
], LoginService.prototype, "loginAgent$", null);
__decorate([
    LiveEditInactive()
], LoginService.prototype, "loginMember", null);
__decorate([
    LiveEditInactive()
], LoginService.prototype, "logoutMember", null);
__decorate([
    LiveEditInactive()
], LoginService.prototype, "logoutAgent", null);
__decorate([
    LiveEditInactive()
], LoginService.prototype, "loginAgent", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoginService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: NavigationService }, { type: MemberSessionService }, { type: AgentService }, { type: ConfigResourceService }, { type: SiteService }, { type: QuoteService }]; }, { memberLoggedIn$: [], agentLoggedIn$: [], logout: [], login: [], authenticateUserWithPIN: [], loginSSOMember: [], loginAgent$: [], loginMember: [], logoutMember: [], logoutAgent: [], loginAgent: [] }); })();

const WAIVER_STATES = ['MA', 'MN', 'WI'];
const WAIVER_STATES_WITHOUT_RIDER_CATEGORIES = ['MN', 'WI'];

class DemographicService {
    constructor(memberSessionService, store, demographicsHttpService) {
        this.memberSessionService = memberSessionService;
        this.store = store;
        this.demographicsHttpService = demographicsHttpService;
    }
    async updateDemographicSession() {
        let sessionId = this.memberSessionService.getMemberSessionId();
        if (!sessionId) {
            await this.memberSessionService.createMemberSession$().toPromise();
            sessionId = this.memberSessionService.getMemberSessionId();
        }
        this.store.dispatch(new UpdateDemographicSession(sessionId));
    }
    getSessionLoadedStatus$() {
        return this.memberSessionService.getMemberSessionLoadedStatus$();
    }
    hasCountyData(fips) {
        const counties = this.store.selectSnapshot(DemographicState.counties);
        return counties && counties.some(county => county.countyFIPS === fips);
    }
    async selectLocation(fips, zip) {
        if (zip !== this.getSelectedZipCode() || fips !== this.getSelectedFipsCode()) {
            this.store.dispatch(new SelectZipAndFIPS(zip, fips));
            await this.conditionallyFetchCounties(zip, fips);
            this.store.dispatch(new SetLocation(zip, fips)); // update helpful tools location.
            this.store.dispatch(new SetPlansDirty(true));
        }
    }
    async conditionallyFetchCounties(zip, fips) {
        if (zip && !this.hasCountyData(fips)) {
            await this.fetchCountyData(zip);
        }
    }
    fetchCountyData$(zip) {
        return this.store.dispatch(new FetchCountyData(zip));
    }
    async fetchCountyData(zip) {
        return await this.fetchCountyData$(zip).toPromise();
    }
    getSelectedCounty() {
        return this.store.selectSnapshot(DemographicState.selectedCounty);
    }
    getSelectedCounty$() {
        return this.store.select(DemographicState.selectedCounty);
    }
    isWaiverState(state) {
        return WAIVER_STATES.includes(state);
    }
    isWaiverStateWithoutRiderCategories(state) {
        return WAIVER_STATES_WITHOUT_RIDER_CATEGORIES.includes(state);
    }
    getSelectedZipCode() {
        return this.memberSessionService.getZipCode();
    }
    getSelectedZipCode$() {
        return this.memberSessionService.getZipCode$();
    }
    getSelectedFipsCode() {
        return this.memberSessionService.getFipsCode();
    }
    getSelectedFipsCode$() {
        return this.memberSessionService.getFipsCode$();
    }
    setZipCode(zip) {
        this.store.dispatch(new SelectZipCode(zip));
    }
    setFipsCode(fips) {
        this.store.dispatch(new SelectFIPS(fips));
    }
    getSubsidySelected() {
        return this.store.selectSnapshot(DemographicState.subsidySelected);
    }
    getSubsidySelected$() {
        return this.store.select(DemographicState.subsidySelected);
    }
    getSubsidyPercent() {
        return this.store.selectSnapshot(DemographicState.subsidyPercent);
    }
    getAgeRange() {
        return this.store.selectSnapshot(DemographicState.ageRange);
    }
    getEffectiveDate() {
        return this.store.selectSnapshot(DemographicState.effectiveDate);
    }
    getHealthStatus() {
        return this.store.selectSnapshot(DemographicState.healthStatus);
    }
    isWaiverStateAndMedigap(plan) {
        const selectedCounty = this.getSelectedCounty();
        if (selectedCounty && plan) {
            return this.isWaiverStateWithoutRiderCategories(selectedCounty.state) && plan.planType === PlanType.MEDIGAP;
        }
        return false;
    }
    setSubsidySelected(subsidySelected) {
        this.store.dispatch(new SelectSubsidySelected(subsidySelected));
    }
    setSubsidyPercent(subsidyPercent) {
        this.store.dispatch(new SelectSubsidyPercent(subsidyPercent));
    }
    getCountyZipSelection() {
        return this.store.selectSnapshot(DemographicState.countyZipSelection);
    }
    async getCountryCodeForZip(zip) {
        let counties = [];
        const zipSelection = this.getCountyZipSelection();
        if (zipSelection === zip) {
            counties = this.store.selectSnapshot(DemographicState.counties);
        }
        else {
            counties = await this.demographicsHttpService.retrieveCounties$(zip).toPromise();
        }
        return counties?.[0].state === 'PR' ? 'PR' : 'US';
    }
}
DemographicService.ɵfac = function DemographicService_Factory(t) { return new (t || DemographicService)(i0.ɵɵinject(MemberSessionService), i0.ɵɵinject(i1.Store), i0.ɵɵinject(DemographicHttpService)); };
DemographicService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DemographicService, factory: DemographicService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DemographicService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: MemberSessionService }, { type: i1.Store }, { type: DemographicHttpService }]; }, null); })();

class ProfileCryptoService {
    constructor(cryptoUtilityService, store, configResourceService, profileContextService) {
        this.cryptoUtilityService = cryptoUtilityService;
        this.store = store;
        this.configResourceService = configResourceService;
        this.profileContextService = profileContextService;
        this.subscriptions = new Subscription();
        this.subscriptions.add(this.profileContextService.getHICNValue$().subscribe(hicn => this.setEncryptedHICN(hicn)));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    getDecryptedHICN(encryptedHICN, hicnKey) {
        const hicnKeyValue = hicnKey || this.store.selectSnapshot(ProfileState.hicnKeyValue);
        const encryptedHICNData = encryptedHICN || this.store.selectSnapshot(ProfileState.hicn);
        if (encryptedHICNData && hicnKeyValue) {
            const decrypted = this.cryptoUtilityService.decrypt(encryptedHICNData, hicnKeyValue + this.getHICNSecretKey());
            return decrypted.toString(CryptoJS.enc.Utf8);
        }
        return encryptedHICN;
    }
    getEncryptedHICN(hicn) {
        if (hicn) {
            const secretKeyRandomElement = uuid();
            const encrypted = this.encryptHICN(hicn, secretKeyRandomElement);
            return { encryptedHICN: encrypted, hicnKeyValue: secretKeyRandomElement };
        }
        return null;
    }
    getHICNSecretKey() {
        return this.configResourceService.getProcessedResourceValue('Spa_HICN_Secret_Key');
    }
    setEncryptedHICN(hicn) {
        if (hicn) {
            const profileHICNEncrypted = this.getEncryptedHICN(hicn);
            this.store.dispatch(new UpdateProfileEncryptedHICN(profileHICNEncrypted?.encryptedHICN, profileHICNEncrypted?.hicnKeyValue));
        }
    }
    encryptHICN(hicn, secretKeyRandomElement) {
        const encrypted = this.cryptoUtilityService.encrypt(hicn, secretKeyRandomElement + this.getHICNSecretKey());
        return encrypted;
    }
}
ProfileCryptoService.ɵfac = function ProfileCryptoService_Factory(t) { return new (t || ProfileCryptoService)(i0.ɵɵinject(CryptoUtilityService), i0.ɵɵinject(i1.Store), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(ProfileContextService)); };
ProfileCryptoService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ProfileCryptoService, factory: ProfileCryptoService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProfileCryptoService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: CryptoUtilityService }, { type: i1.Store }, { type: ConfigResourceService }, { type: ProfileContextService }]; }, null); })();

class ProfileService {
    constructor(store, sessionService, configResourceService, profileCryptoService, memberSessionService) {
        this.store = store;
        this.sessionService = sessionService;
        this.configResourceService = configResourceService;
        this.profileCryptoService = profileCryptoService;
        this.memberSessionService = memberSessionService;
        this.ADDRESSES = 'addresses';
    }
    getSelectedProfileCounty() {
        return this.store.selectSnapshot(ProfileState.selectedProfileCounty);
    }
    getSelectedProfileCounty$() {
        return this.store.select(ProfileState.selectedProfileCounty);
    }
    updateProfile$(profile) {
        let updatedProfileModel = profile;
        if (profile?.hicn && !profile?.hicnKeyValue) {
            const encryptedHICNModel = this.profileCryptoService.getEncryptedHICN(profile?.hicn);
            updatedProfileModel = {
                ...profile,
                ...(encryptedHICNModel !== null && {
                    hicn: encryptedHICNModel?.encryptedHICN || '',
                    hicnKeyValue: encryptedHICNModel?.hicnKeyValue || ''
                })
            };
        }
        return this.store.dispatch(new UpdateProfile(updatedProfileModel));
    }
    updateProfile(profile) {
        this.updateProfile$(profile).toPromise();
    }
    async updateProfileSession(sessionId, profile) {
        if (profile) {
            await this.updateProfile$(profile).toPromise();
        }
        // probably don't need to await this for enrollment since the update transaction call
        // will update the enrollment form values seperately. can always revist awaiting though
        // in case anything else needs to pull fresh from the session right after calling this.
        const profileStateModel = this.store.selectSnapshot(ProfileState);
        const apiProfileStateModel = new APIProfileStateModel(profileStateModel);
        const updatedProfileModel = this.prepareProfileStateForAPI(apiProfileStateModel);
        this.store.dispatch(new UpdateProfileSession(sessionId, updatedProfileModel));
    }
    prepareProfileStateForAPI(apiProfileStateModel) {
        const decryptedHICN = this.profileCryptoService.getDecryptedHICN(apiProfileStateModel?.hicn, apiProfileStateModel?.hicnKeyValue);
        if (apiProfileStateModel?.hicnKeyValue) {
            delete apiProfileStateModel?.hicnKeyValue;
        }
        return { ...apiProfileStateModel, ...(decryptedHICN && { hicn: decryptedHICN }) };
    }
    /**
     * Update the store member profile email address with API session update.
     */
    async updateEmailAddressInSession(profileEmailAddress) {
        await this.updateProfileSession(this.sessionService.getMemberSessionId(), { emailAddress: profileEmailAddress });
    }
    /**
     *  Update the store member profile email address without corresponding API session update.
     */
    async updateEmailAddress(emailAddress) {
        return await this.updateProfile$({ emailAddress }).toPromise();
    }
    async updateHomePhone(phone) {
        await this.updateProfileSession(this.sessionService.getMemberSessionId(), { homePhone: phone });
    }
    getMemberFullName$() {
        return this.store.select(ProfileState.fullName);
    }
    getMemberFullName() {
        return this.store.selectSnapshot(ProfileState.fullName);
    }
    getFirstName() {
        return this.store.selectSnapshot(ProfileState.firstName);
    }
    getMiddleInitial() {
        return this.store.selectSnapshot(ProfileState.middleInitial);
    }
    getLastName() {
        return this.store.selectSnapshot(ProfileState.lastName);
    }
    getAddresses() {
        return this.store.selectSnapshot(ProfileState.addresses);
    }
    getAddress1() {
        return this.store.selectSnapshot(ProfileState.address1);
    }
    getAddress2() {
        return this.store.selectSnapshot(ProfileState.address2);
    }
    getCity() {
        return this.store.selectSnapshot(ProfileState.city);
    }
    getState() {
        return this.store.selectSnapshot(ProfileState.state);
    }
    getZip() {
        return this.store.selectSnapshot(ProfileState.zip);
    }
    getEmailAddress() {
        return this.store.selectSnapshot(ProfileState.emailAddress);
    }
    getHomePhone$() {
        return this.store.select(ProfileState.homePhone);
    }
    getHomePhone() {
        return this.store.selectSnapshot(ProfileState.homePhone);
    }
    getCellPhone$() {
        return this.store.select(ProfileState.cellPhone);
    }
    getCellPhone() {
        return this.store.selectSnapshot(ProfileState.cellPhone);
    }
    getIsMedicaidEligible() {
        return this.store.selectSnapshot(ProfileState.isMedicaidEligible);
    }
    getMedicaidCarrierName$() {
        return this.store.select(ProfileState.medicaidCarrierName);
    }
    getMedicaidEligibilityLevel() {
        return this.store.selectSnapshot(ProfileState.medicaidEligibilityLevel);
    }
    getMedicaidEligibilityLevel$() {
        return this.store.select(ProfileState.medicaidEligibilityLevel);
    }
    getMedicaidLastCheckedDate() {
        return this.store.selectSnapshot(ProfileState.medicaidLastCheckedDate);
    }
    getMedicaidStateSelection() {
        return this.store.selectSnapshot(ProfileState.medicaidStateSelection);
    }
    getMedicaidStateSelection$() {
        return this.store.select(ProfileState.medicaidStateSelection);
    }
    getAccountGuid() {
        return this.store.selectSnapshot(ProfileState.accountGuid);
    }
    getArePhoneNumbersEqual() {
        return this.getHomePhone() === this.getCellPhone();
    }
    getMemberPhone$() {
        return combineLatest([this.getCellPhone$(), this.getHomePhone$()]).pipe(map$1(([cellPhone, homePhone]) => cellPhone || homePhone));
    }
    getMemberPhone() {
        return this.getCellPhone() || this.getHomePhone();
    }
    getViewLinkText(viewMemberLink, fullName) {
        const split = viewMemberLink.split(' ');
        split.splice(1, 0, fullName);
        return split.join(' ');
    }
    getMemberProfile() {
        return this.store.selectSnapshot(ProfileState);
    }
    getMaritalStatusCode(applicantMaritalStatus) {
        switch (applicantMaritalStatus) {
            case MaritalStatusValue.SINGLE:
                return MaritalStatusCode.SINGLE;
            case MaritalStatusType.SINGLE:
                return MaritalStatusCode.SINGLE;
            case MaritalStatusValue.MARRIED:
                return MaritalStatusCode.MARRIED;
            case MaritalStatusType.MARRIED:
                return MaritalStatusCode.MARRIED;
            case MaritalStatusValue.WIDOWED:
                return MaritalStatusCode.WIDOWED;
            case MaritalStatusType.WIDOWED:
                return MaritalStatusCode.WIDOWED;
            default:
                return MaritalStatusCode.NOT_PROVIDED;
        }
    }
    getGenderCode(applicantGender) {
        switch (applicantGender) {
            case GenderValue.MALE:
                return GenderCode.MALE;
            case GenderValue.FEMALE:
                return GenderCode.FEMALE;
            case GenderType.FEMALE:
                return GenderCode.FEMALE;
            case GenderType.MALE:
                return GenderCode.MALE;
            default:
                return GenderCode.NOT_PROVIDED;
        }
    }
    hasMemberProfile() {
        return this.sessionService.getMemberHasFullName();
    }
    hasMemberProfile$() {
        return this.sessionService.getMemberHasFullName$();
    }
    hasMemberProfileUpdates(profile) {
        const memberProfile = this.getMemberProfile();
        return Object.keys(profile)
            .map(entry => this.hasProfileUpdates(entry, profile, memberProfile))
            .includes(true);
    }
    hasZipOrFipsUpdates() {
        const profileAddress = this.getPrimaryAddress();
        const primaryZip = profileAddress?.zip ?? '';
        const primaryFips = profileAddress?.countyFips ?? '';
        const demographicZipCode = this.memberSessionService.getZipCode();
        const demographicFipsCode = this.memberSessionService.getFipsCode();
        return demographicZipCode !== primaryZip || primaryFips !== demographicFipsCode;
    }
    getShowViewMemberLink() {
        return this.configResourceService.getProcessedResourceValue('Spa_SendQuote_ViewMemberProfile_Link_Enabled', null, false);
    }
    hasProfileUpdates(entry, profile, memberProfile) {
        if (entry === this.ADDRESSES) {
            if (profile.addresses.length && memberProfile.addresses.length === 0) {
                return true;
            }
            else if (profile.addresses.length === 0) {
                return false;
            }
            return !_isEqual(profile.addresses[0], memberProfile.addresses[0]);
        }
        return !_isEqual(profile[entry], memberProfile[entry]);
    }
    setSearchCriteria(member) {
        this.store.dispatch(new SaveSearchedMemberData(member.firstName, member.lastName, member.phoneNumber, member.emailAddress, member.dateOfBirth));
    }
    // Returns cell phone if available, and then home phone if cell is not available.
    getPrimaryPhoneNumber(memberProfileData) {
        let primaryPhone = null;
        if (this.hasMemberProfile()) {
            const profileData = memberProfileData ?? this.sessionService.getMemberSession();
            if (profileData) {
                const cellPhone = profileData.profile.cellPhone;
                const homePhone = profileData.profile.homePhone;
                if (cellPhone) {
                    primaryPhone = cellPhone;
                }
                else if (homePhone) {
                    primaryPhone = homePhone;
                }
            }
        }
        return primaryPhone;
    }
    getPrimaryAddress() {
        return this.store.selectSnapshot(ProfileState.primaryAddress);
    }
    async updateMemberPhoneData(phone, phoneType = PhoneNumberType.BOTH) {
        const apiMemberStateModel = {
            profile: {}
        };
        if (phoneType === PhoneNumberType.BOTH || phoneType === PhoneNumberType.PRIMARY) {
            apiMemberStateModel.profile.homePhone = phone;
        }
        if (phoneType === PhoneNumberType.BOTH || phoneType === PhoneNumberType.MOBILE) {
            apiMemberStateModel.profile.cellPhone = phone;
        }
        await this.memberSessionService.updateMemberProfile(apiMemberStateModel);
    }
}
ProfileService.ɵfac = function ProfileService_Factory(t) { return new (t || ProfileService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(MemberSessionService), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(ProfileCryptoService), i0.ɵɵinject(MemberSessionService)); };
ProfileService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ProfileService, factory: ProfileService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProfileService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }, { type: MemberSessionService }, { type: ConfigResourceService }, { type: ProfileCryptoService }, { type: MemberSessionService }]; }, null); })();

/**
 * Service for handling SSO related functionality. Should mostly be used within the resolver
 * but is abstracted out here in case there are opportunities for reuse and so the resolver
 * doesn't get too large and complicated.
 */
class SSOService {
    constructor(http, store, baseHref) {
        this.http = http;
        this.store = store;
        this.baseHref = baseHref;
        this.environment = EnvironmentService.getEnvironment();
    }
    async hasSSOValues() {
        const checkSSOValuesEndpoint = this.getSSOValuesCheckEndpoint();
        const ssoValuesCheck = await this.http
            .get(checkSSOValuesEndpoint, { withCredentials: true })
            .toPromise()
            .catch(error => {
            if (error) {
                if (error.status === HttpStatusCode.NOT_FOUND) {
                    // If 404, we are most likely in a local environment but
                    // even if we are in a higher environment and the endpoint
                    // is not found we will treat the endpoint as having no values
                    return { available: false };
                }
                else {
                    throw error;
                }
            }
        });
        return !!ssoValuesCheck?.available;
    }
    async getSSOValues() {
        const ssoValuesEndpoint = this.getSSOEndpoint();
        const ssoResult = await this.http
            .get(ssoValuesEndpoint, { withCredentials: true })
            .toPromise()
            .catch(error => {
            if (error) {
                if (error.status === HttpStatusCode.NOT_FOUND) {
                    // If 404, resume normal operations.
                }
                else {
                    throw error;
                }
            }
        });
        if (ssoResult) {
            this.store.dispatch(new SetSSOResult(ssoResult));
            return ssoResult;
        }
        // SPA-19398: When we process a PURL to an AM consumer site, we receive the SSO values, then we redirect the user back to the Home page only with UTM parameters.
        // During that process, sometimes we lose the SSO values. However, they are still stored in the Runtime state.
        return this.getSSOResult();
    }
    getSSOResult() {
        return this.store.selectSnapshot(RuntimeState.ssoResult) ?? null;
    }
    getSSOState() {
        return this.store.selectSnapshot(RuntimeState.ssoState);
    }
    getSSODeliveryMethod() {
        return this.store.selectSnapshot(RuntimeState.ssoDeliveryMethod);
    }
    getSSOEndpoint() {
        return this.environment.localSSO && this.environment.SSO_TESTING_BASE_URL
            ? `${this.environment.SSO_TESTING_BASE_URL}/values`
            : `${this.baseHref}o/saml2/values`;
    }
    getSSOValuesCheckEndpoint() {
        return this.environment.localSSO && this.environment.SSO_TESTING_BASE_URL
            ? `${this.environment.SSO_TESTING_BASE_URL}/values:check`
            : `${this.baseHref}o/saml2/values:check`;
    }
}
SSOService.ɵfac = function SSOService_Factory(t) { return new (t || SSOService)(i0.ɵɵinject(i1$2.HttpClient), i0.ɵɵinject(i1.Store), i0.ɵɵinject(APP_BASE_HREF)); };
SSOService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SSOService, factory: SSOService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SSOService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$2.HttpClient }, { type: i1.Store }, { type: undefined, decorators: [{
                type: Inject,
                args: [APP_BASE_HREF]
            }] }]; }, null); })();

var DeepLinkingParamKey;
(function (DeepLinkingParamKey) {
    DeepLinkingParamKey["ZIPCODE"] = "ZIPCODE";
    DeepLinkingParamKey["ZIP"] = "ZIP";
    DeepLinkingParamKey["COUNTYFIPS"] = "COUNTYFIPS";
    DeepLinkingParamKey["FIPS"] = "FIPS";
    DeepLinkingParamKey["PLANTYPE"] = "PLANTYPE";
    DeepLinkingParamKey["PLANID"] = "PLANID";
    DeepLinkingParamKey["PLAN"] = "PLAN";
    DeepLinkingParamKey["CULTURECODE"] = "CULTURECODE";
    DeepLinkingParamKey["SSOVALUE"] = "SSOVALUE";
    DeepLinkingParamKey["BENEFIRSTNAME"] = "BENEFIRSTNAME";
    DeepLinkingParamKey["BENELASTNAME"] = "BENELASTNAME";
    DeepLinkingParamKey["BENEBIRTHDATE"] = "BENEBIRTHDATE";
    DeepLinkingParamKey["BENEGENDER"] = "BENEGENDER";
    DeepLinkingParamKey["BENECRMID"] = "BENECRMID";
    DeepLinkingParamKey["BENEADDR1"] = "BENEADDR1";
    DeepLinkingParamKey["BENEADDR2"] = "BENEADDR2";
    DeepLinkingParamKey["BENECITY"] = "BENECITY";
    DeepLinkingParamKey["BENESTATE"] = "BENESTATE";
    DeepLinkingParamKey["BENEPHONE"] = "BENEPHONE";
    DeepLinkingParamKey["BENECELLPHONE"] = "BENECELLPHONE";
    DeepLinkingParamKey["BENEEMAIL"] = "BENEEMAIL";
    DeepLinkingParamKey["AGENTID"] = "AGENTID";
    DeepLinkingParamKey["AGENCYNAME"] = "AGENCYNAME";
    DeepLinkingParamKey["AGENCYID"] = "AGENCYID";
    DeepLinkingParamKey["SOURCEID"] = "SOURCEID";
    DeepLinkingParamKey["PARTNERID"] = "PARTNERID";
    DeepLinkingParamKey["RETURNURL"] = "RETURNURL";
    DeepLinkingParamKey["UTM_SOURCE"] = "UTM_SOURCE";
    DeepLinkingParamKey["UTM_MEDIUM"] = "UTM_MEDIUM";
    DeepLinkingParamKey["UTM_CAMPAIGN"] = "UTM_CAMPAIGN";
    DeepLinkingParamKey["UTM_CONTENT"] = "UTM_CONTENT";
    DeepLinkingParamKey["TFN"] = "TFN";
    DeepLinkingParamKey["CUSTOMTRACK1"] = "CUSTOMTRACK1";
    DeepLinkingParamKey["CUSTOMTRACK2"] = "CUSTOMTRACK2";
    DeepLinkingParamKey["CUSTOMTRACK3"] = "CUSTOMTRACK3";
    DeepLinkingParamKey["CUSTOMTRACK4"] = "CUSTOMTRACK4";
    DeepLinkingParamKey["CUSTOMTRACK5"] = "CUSTOMTRACK5";
    DeepLinkingParamKey["CUSTOMFMO1"] = "CUSTOMFMO1";
    DeepLinkingParamKey["CUSTOMFMO2"] = "CUSTOMFMO2";
    DeepLinkingParamKey["CUSTOMFMO3"] = "CUSTOMFMO3";
    DeepLinkingParamKey["CUSTOMFMO4"] = "CUSTOMFMO4";
    DeepLinkingParamKey["CUSTOMFMO5"] = "CUSTOMFMO5";
    DeepLinkingParamKey["MILITARYRANK"] = "MILITARYRANK";
    DeepLinkingParamKey["MILITARYSTATUS"] = "MILITARYSTATUS";
    DeepLinkingParamKey["MILITARYBRANCH"] = "MILITARYBRANCH";
    DeepLinkingParamKey["MILITARYPREFIXCODE"] = "MILITARYPREFIXCODE";
    DeepLinkingParamKey["POPULATEDDATA"] = "POPULATEDDATA";
    DeepLinkingParamKey["PEGI"] = "PEGI";
    DeepLinkingParamKey["CHANNEL"] = "CHANNEL";
    DeepLinkingParamKey["SESSIONID"] = "SESSIONID";
    DeepLinkingParamKey["SUBSIDYSELECTED"] = "SUBSIDYSELECTED";
    DeepLinkingParamKey["SUBSIDYPERCENT"] = "SUBSIDYPERCENT";
    DeepLinkingParamKey["TRANSACTIONGUID"] = "TRANSACTIONGUID";
    DeepLinkingParamKey["QUOTEID"] = "QUOTEID";
    DeepLinkingParamKey["AGENTGUID"] = "AGENTGUID";
    DeepLinkingParamKey["QUOTETYPE"] = "QUOTETYPE";
    DeepLinkingParamKey["PURLID"] = "PURLID";
})(DeepLinkingParamKey || (DeepLinkingParamKey = {}));
class DeepLinkingParams {
}
class NextGenRequestDeepLinkingParams {
}
const PassParameterConsumerPages = [
    PageTags.PLAN_LIST,
    PageTags.PLAN_DETAILS,
    PageTags.PLAN_COMPARISON,
    PageTags.HOME,
    PageTags.GUIDED_HELP_GETTING_STARTED,
    PageTags.GUIDED_HELP_HEALTH,
    PageTags.GUIDED_HELP_PHARMACY_SEARCH,
    PageTags.GUIDED_HELP_PRESCRIPTIONS,
    PageTags.HELPFUL_TOOLS,
    PageTags.HELPFUL_TOOLS_PHARMACYSEARCH,
    PageTags.GUIDED_HELP_PROVIDER_SEARCH,
    PageTags.PIN_HOME,
    PageTags.RETENTION_SUMMARY,
    PageTags.RETENTION,
    PageTags.SHOPPING_CART,
    PageTags.RETIRE_FLO_SURVEY,
    PageTags.BENEFICIARY_AUTHENTICATION,
    PageTags.BENEFICIARY_VERIFICATION,
    PageTags.QUOTE_SUMMARY
];
const PassParameterPPCPages = [
    PageTags.PROFILE_SEARCH,
    PageTags.ADD_NEW_PROFILE,
    PageTags.PLAN_LIST,
    PageTags.HOME,
    PageTags.AGENT_LOGIN,
    PageTags.RETIRE_FLO_SURVEY,
    PageTags.BENEFICIARY_VERIFICATION // Sign and Submit flow
];

class PlanCompareService {
    constructor(store, navigationService) {
        this.store = store;
        this.navigationService = navigationService;
    }
    setPlanComparePlanType(planType) {
        this.store.dispatch(new SetPlanComparePlanType(planType));
    }
    setCompareGroup(compareGroup) {
        this.store.dispatch(new SetCompareGroup(compareGroup));
    }
    addPlanToCompareGroup(compareGroupIdentifier, plan) {
        this.store.dispatch(new AddPlanToCompareGroup(compareGroupIdentifier, plan));
    }
    addPlansToCompareGroup(compareGroupIdentifier, plans) {
        this.store.dispatch(new AddPlansToCompareGroup(compareGroupIdentifier, plans));
    }
    removePlanFromCompareGroup(compareGroupIdentifier, plan) {
        this.store.dispatch(new RemovePlanFromCompareGroup(compareGroupIdentifier, plan));
    }
    removePlanFromCompareGroups(plan) {
        this.store.dispatch(new RemovePlanFromCompareGroups(plan));
    }
    removeAllPlansFromCompareGroup(compareGroupIdentifier) {
        this.store.dispatch(new RemoveAllPlansFromCompareGroup(compareGroupIdentifier));
    }
    updateFirstPlanInCompareGroup(compareGroupIdentifier, plan) {
        this.store.dispatch(new UpdateFirstPlanInCompareGroup(compareGroupIdentifier, plan));
    }
    /**
     * Replaces all the plans in the relevant compare group for the plans provided, and navigates to the compare pages
     */
    replaceAllPlansInCompareGroupAndNavigate(plans) {
        if (plans?.length) {
            const planType = plans[0].planTypeAbbreviation;
            const planCompareGroup = [{ ...new CompareGroup(FilterKeyType.PLAN_TYPE_SHORT, [planType]) }];
            this.setPlanComparePlanType(planType);
            this.removeAllPlansFromCompareGroup(planCompareGroup);
            this.addPlansToCompareGroup(planCompareGroup, plans);
            this.navigationService.navigateByPageTag(PageTags.PLAN_COMPARISON);
        }
    }
}
PlanCompareService.ɵfac = function PlanCompareService_Factory(t) { return new (t || PlanCompareService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(NavigationService)); };
PlanCompareService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PlanCompareService, factory: PlanCompareService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanCompareService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }, { type: NavigationService }]; }, null); })();

class DeepLinkingService {
    constructor(store, plansService, navigationService, planCompareService, memberSessionService, configResourceService, responsiveLayoutService, siteService, agentService, shoppingCartService, demographicService) {
        this.store = store;
        this.plansService = plansService;
        this.navigationService = navigationService;
        this.planCompareService = planCompareService;
        this.memberSessionService = memberSessionService;
        this.configResourceService = configResourceService;
        this.responsiveLayoutService = responsiveLayoutService;
        this.siteService = siteService;
        this.agentService = agentService;
        this.shoppingCartService = shoppingCartService;
        this.demographicService = demographicService;
        this.MINIMUM_PLAN_REQUIRED_TO_COMPARE = 2;
        this.DEFAULT_PLAN_SEGMENT = '000';
        this.forceMedSupFormBeforePlansList = this.configResourceService.getProcessedResourceValue('Spa_Site_ForceMedSupFormBeforePlansList', null, false);
        this.forceDentalVisionFormBeforePlansList = this.configResourceService.getProcessedResourceValue('Spa_Site_ForceDentalVisionFormBeforePlansList', null, false);
        this.overrideSearchOptions = { planType: this.plansService.getPlansSearchPlanType().toString() };
    }
    getDeepLinkingParamsState() {
        return this.store.selectSnapshot(DeepLinkingParamsState.state);
    }
    getDeepLinkingParam$(key) {
        return this.store.select(DeepLinkingParamsState.getDeepLinkingParam(key));
    }
    getAllowablePages(siteType) {
        return this.siteService.isPPCSite(siteType) ? PassParameterPPCPages : PassParameterConsumerPages;
    }
    async processPageSpecificParams(pageTags, passParameters) {
        if (pageTags && passParameters) {
            if (passParameters.PlanType) {
                this.setOverridesPlanTypeAbbreviation(passParameters.PlanType);
            }
            return await this.loadPageSpecificParams(passParameters, pageTags);
        }
        return null;
    }
    setActivePlanTab(planType) {
        if (planType) {
            const planTab = planType.toUpperCase();
            if (planTab &&
                [
                    PlanTypeAbbreviation.MA,
                    PlanTypeAbbreviation.MAPD,
                    PlanTypeAbbreviation.MEDIGAP,
                    PlanTypeAbbreviation.PDP,
                    PlanTypeAbbreviation.DENTAL,
                    PlanTypeAbbreviation.VISION,
                    PlanTypeAbbreviation.HC
                ].includes(planTab)) {
                this.store.dispatch(new SetActiveTab(planTab));
            }
        }
    }
    async redirectToHome(queryParams) {
        return await this.navigationService.constructUrlTreeFromPageTag(PageTags.HOME, { queryParams });
    }
    async redirectToHelpfulToolsPage() {
        return await this.navigationService.constructUrlTreeFromPageTag(PageTags.HELPFUL_TOOLS);
    }
    async redirectToPageTag(pageTag, queryParams) {
        return await this.navigationService.constructUrlTreeFromPageTag(pageTag, { queryParams });
    }
    clearSession() {
        this.memberSessionService.memberLogout({ clearAnonymousSession: true });
    }
    isDestinationPageAllowed(pageTags, siteType, queryParams) {
        // SSO logic
        // Redirect if destination page is not allowed
        const allowedPages = this.getAllowablePages(siteType);
        const hasAllowedPage = allowedPages.some(pageName => pageTags.includes(pageName));
        const ssoResult = this.store.selectSnapshot(RuntimeState.ssoResult);
        if (ssoResult && !hasAllowedPage) {
            return false;
        }
        // Deep linking logic
        // Redirect if consumer site, deep linking is disabled, and has query parameters
        // except retention, pin home, and beneficiary login
        const isDeepLinkingEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_IsDeepLinking_Enabled', null, true);
        if (!this.siteService.isPPCSite(siteType) &&
            !isDeepLinkingEnabled &&
            queryParams &&
            ((pageTags.includes(PageTags.PLAN_DETAILS) && Object.keys(queryParams).length > 1) ||
                (!pageTags.includes(PageTags.PLAN_DETAILS) && !!Object.keys(queryParams).length))) {
            return pageTags.includes(PageTags.RETENTION) || pageTags.includes(PageTags.PIN_HOME) || pageTags.includes(PageTags.BENEFICIARY_LOGIN);
        }
        return true;
    }
    // There are now certain pages that we do not wish to include plan data on since
    // we are loading per plan type. If a plan type is provided then we return plan
    // data because they are explicitly opting in to that planType but otherwise
    // we will defer to the page to load plans if its included in this list. The one
    // exception to this is the member profile page for backwards compatability although
    // we can certainly remove or modify this at some point.
    includePlanData(params, pageTags) {
        if (pageTags?.includes(PageTags.MEMBER_PROFILE_PAGE)) {
            return false;
        }
        if (params?.PlanType) {
            return true;
        }
        if (pageTags?.includes(PageTags.PLAN_LIST)) {
            return false;
        }
        if (pageTags?.includes(PageTags.RETENTION_SUMMARY)) {
            return false;
        }
    }
    setPlansOfParams(planIds) {
        return this.isMedicarePlanIdFormat(planIds) ? this.setMedicarePlansOfParams(planIds) : this.setNonMedicarePlansOfParams(planIds);
    }
    resolvePlanIDs(planIDs) {
        const planIdsArray = planIDs ? planIDs.split(',') : [];
        return planIdsArray.map(planId => planId.trim());
    }
    hasZipAndFipsInSession() {
        return !!this.memberSessionService.getZipCode() && !!this.memberSessionService.getFipsCode();
    }
    setSubsidy(pageParams) {
        if (pageParams.SubsidySelected) {
            const mappedSubsidyValue = this.getMappedSubsidy(pageParams);
            const subsidySelected = mappedSubsidyValue.subsidySelected;
            const subsidyPercent = mappedSubsidyValue.subsidyPercent;
            const isValidSubsidySelected = this.validateSubsidySelected(subsidySelected);
            if (isValidSubsidySelected) {
                if (subsidySelected === SubsidySelected.PARTIAL && subsidyPercent && SUBSIDY_PERCENT.includes(subsidyPercent)) {
                    this.demographicService.setSubsidyPercent(subsidyPercent);
                }
                else if (subsidySelected !== SubsidySelected.PARTIAL) {
                    this.demographicService.setSubsidySelected(subsidySelected);
                }
                else {
                    this.redirectToHomeOrLogin();
                }
            }
            else {
                this.redirectToHomeOrLogin();
            }
        }
    }
    validateSubsidySelected(subsidySelected) {
        return (!isNaN(subsidySelected) &&
            subsidySelected !== null &&
            subsidySelected >= SubsidySelected.DONT_KNOW &&
            subsidySelected <= SubsidySelected.FULL);
    }
    redirectToHomeOrLogin() {
        this.siteService.isPPCSite()
            ? this.navigationService.navigateByPageTag(PageTags.AGENT_LOGIN)
            : this.navigationService.navigateByPageTag(PageTags.HOME);
    }
    setOverridesPlanTypeAbbreviation(planTypeAbbreviation) {
        this.setOverridesPlanTypes(this.plansService.getPlansSearchPlanTypes(planTypeAbbreviation?.toUpperCase()));
    }
    getMappedSubsidy(passParams) {
        const subsidy = {
            subsidySelected: passParams.SubsidySelected ? parseInt(passParams.SubsidySelected, 10) : null,
            subsidyPercent: passParams.SubsidyPercent ? parseInt(passParams.SubsidyPercent, 10) : null
        };
        const carrierSubsidyMapEnabled = this.configResourceService.getProcessedResourceValue('Spa_Carrier_Subsidy_Map_Enabled', null, true);
        const carrierSubsidyMapValue = this.configResourceService.getProcessedResourceValue('Spa_Carrier_Subsidy_Map_Value', null, null);
        if (carrierSubsidyMapEnabled) {
            subsidy.subsidySelected =
                carrierSubsidyMapValue?.SubsidySelected && passParams.SubsidySelected
                    ? parseInt(carrierSubsidyMapValue.SubsidySelected[passParams.SubsidySelected], 10)
                    : null;
            subsidy.subsidyPercent =
                carrierSubsidyMapValue?.SubsidyPercent && passParams.SubsidyPercent
                    ? parseInt(carrierSubsidyMapValue.SubsidyPercent[passParams.SubsidyPercent], 10)
                    : null;
        }
        return subsidy;
    }
    setOverridesPlanTypes(planTypes) {
        const overridePlanTypes = PlansUtilityService.toBitWiseString(planTypes);
        if (overridePlanTypes) {
            this.overrideSearchOptions = {
                planType: overridePlanTypes
            };
        }
    }
    // Returning a URLTree from here should allow us to navigate. Something with the new values:check causing this?
    async loadPageSpecificParams(params, pageTags) {
        if (pageTags && params) {
            if (pageTags.includes(PageTags.PLAN_LIST)) {
                // SPA-12386: awaiting for this operation here causes a conflict with SPA-12365
                // If we await, we would fetch the selected plan type first, await for the response and then navigate to Plan List page where we will fetch the Medicare + MedSup plans again.
                // By not awaiting here, we will fetch the selected plan type first, and while that's in progress, we will start the navigation to Plan List page.
                // We won't fetch the Medicare + MedSup plans because by the time we land on the Plan List page, the plans/short would still be loading.
                // Note: if this finishes before getting to the Plans List page, it will fetch the Medicare + MedSup plans again because of the loading flag being false.
                this.loadPlanListPage(params, pageTags);
            }
            else if (pageTags.includes(PageTags.PLAN_DETAILS)) {
                return await this.loadPlanDetailPage(params.PlanId || params.Plan, params);
            }
            else if (pageTags.includes(PageTags.HELPFUL_TOOLS_PHARMACYSEARCH)) {
                return await this.loadPlanInformationPage(params.PlanId || params.Plan);
            }
            else if (pageTags.includes(PageTags.PLAN_COMPARISON)) {
                return await this.loadPlanComparePage(params.PlanId || params.Plan, params);
            }
            else if (pageTags.includes(PageTags.ADD_NEW_PROFILE)) {
                // TODO: SPA-4260 Edit profile
            }
            else if (pageTags.includes(PageTags.PROFILE_SEARCH)) {
                return await this.redirectToProfileSearch(params);
            }
            else if (pageTags.includes(PageTags.HELPFUL_TOOLS)) {
                this.loadHelpfulToolsPlanListPage();
            }
            else if (pageTags.includes(PageTags.AGENT_ACCOUNT_OVERVIEW) || pageTags.includes(PageTags.AGENT_VIEW_PROFILE)) {
                this.loadAgentAccountOverview();
            }
            else if (pageTags.includes(PageTags.AGENT_LOGIN)) {
                return await this.redirectToAgentLandingPage(params);
            }
            else if (pageTags.includes(PageTags.SHOPPING_CART)) {
                return await this.loadShoppingCart(params);
            }
        }
        return null;
    }
    async redirectToAgentLandingPage(params) {
        // Sign & Submit flow: prevents navigation to Agent Landing Page
        if (!SIGN_AND_SUBMIT_QUOTE_TYPES.includes(params.QuoteType)) {
            const agentLandingPage = this.agentService.getDefaultPageTag();
            return await this.navigationService.constructUrlTreeFromPageTag(agentLandingPage, { state: { ssoParams: params } });
        }
        return null;
    }
    loadAgentAccountOverview() {
        const agentGuid = this.store.selectSnapshot(AgentState.agentGuid);
        if (agentGuid) {
            this.store.dispatch(new SelectedAgentGuid(agentGuid));
        }
    }
    async redirectToProfileSearch(params) {
        return await this.navigationService.constructUrlTreeFromPageTag(PageTags.PROFILE_SEARCH, { state: { ssoParams: params } });
    }
    async loadPlanListPage(params, pageTags) {
        const hasPlansInCart = this.shoppingCartService.hasPlansInCart();
        if (hasPlansInCart) {
            this.setCartPlanTypes(params);
        }
        await this.memberSessionService.updateCart(null, hasPlansInCart || !this.includePlanData(params, [pageTags]), this.overrideSearchOptions);
    }
    // if we don't have an explicit plan type and have cart plans we need to set the override
    // plan types to the cart plans so we only call for those plans in the plans request in
    // updateCart
    setCartPlanTypes(params) {
        if (!params?.PlanType) {
            const shoppingCartPlanTypes = this.shoppingCartService.getShoppingCartPlanTypes();
            this.setOverridesPlanTypes(shoppingCartPlanTypes);
        }
    }
    // if there are plans in the cart we need to include the plan request in the update cart call
    // otherwise we wont have the proper plan to add back to the selected plans
    async loadHelpfulToolsPlanListPage() {
        await this.memberSessionService.updateCart(null, null, this.overrideSearchOptions);
    }
    async loadPlanDetailPage(planId, params) {
        if (!this.hasZipAndFipsInSession()) {
            return;
        }
        // TODO: can possibly update this if we want to only load one tab on deep linking to plans list page
        // Not sure what we would use to decide what planTypes to pass in however as I don't think there is much
        // in session to make this determination right now. It may be that we have enough session data at this point
        // to make that determination but will require a deeper dive in another story.
        await this.memberSessionService.updateCart(null, null, this.overrideSearchOptions);
        const planIds = this.resolvePlanIDs(planId);
        if (planIds.length) {
            const plansInParam = this.setPlansOfParams(planIds);
            if (plansInParam.length) {
                const plan = plansInParam.slice(0, 1);
                this.store.dispatch(new SetPlansDirty(true, [plan[0].planType]));
                this.setActivePlanTab(plan[0].planTypeAbbreviation);
                this.plansService.planDetailPlanID = plan[0].id;
                return await this.redirectNonMedicarePlansToPlanListWhenForcedRateFactorsEnabled(plan[0].planTypeAbbreviation, params);
            }
        }
        return await this.redirectToPageTag(PageTags.PLAN_LIST, params);
    }
    async loadShoppingCart(params) {
        const isPPCSite = this.siteService.isPPCSite();
        // Handle initial checks at initial load of deep linking rest logics are defined on cart facade.
        if (isPPCSite) {
            return await this.redirectToPageTag(PageTags.AGENT_LOGIN);
        }
        if (this.hasZipAndFipsInSession() && !isPPCSite && !!params?.PlanId) {
            await this.memberSessionService.updateCart(null, null, this.overrideSearchOptions);
            return null;
        }
        return await this.redirectToPageTag(PageTags.HOME);
    }
    async redirectNonMedicarePlansToPlanListWhenForcedRateFactorsEnabled(planTypeAbbreviation, params) {
        if ((planTypeAbbreviation === PlanTypeAbbreviation.MEDIGAP && this.forceMedSupFormBeforePlansList) ||
            (ANCILLARY_PLANS.includes(planTypeAbbreviation) && this.forceDentalVisionFormBeforePlansList)) {
            // Set override flag to false so we land on the ActiveTab set
            this.plansService.setOverrideActiveTab(false);
            const planListUrlTree = this.redirectToPageTag(PageTags.PLAN_LIST, params);
            if (planListUrlTree) {
                return await planListUrlTree;
            }
        }
        return null;
    }
    async loadPlanInformationPage(planId) {
        if (!this.hasZipAndFipsInSession()) {
            return;
        }
        await this.memberSessionService.updateCart(null, null, this.overrideSearchOptions);
        const planIds = this.resolvePlanIDs(planId);
        const plansInParam = planIds.length ? this.setPlansOfParams(planIds) : [];
        if (plansInParam.length) {
            this.store.dispatch(new SetPlansDirty(true, [plansInParam[0].planType]));
            this.store.dispatch(new SetPlan(plansInParam[0]));
        }
        else {
            return await this.redirectToHelpfulToolsPage();
        }
    }
    async loadPlanComparePage(planIDs, params) {
        if (!this.hasZipAndFipsInSession()) {
            return;
        }
        await this.memberSessionService.updateCart(null, null, this.overrideSearchOptions);
        const planIds = this.resolvePlanIDs(planIDs);
        if (planIds.length) {
            const plans = this.getMajorityPlanTypePlans(this.setPlansOfParams(planIds));
            if (plans?.length === 1) {
                this.store.dispatch(new SetPlansDirty(true, [plans[0].planType]));
                this.setActivePlanTab(plans[0].planTypeAbbreviation);
                this.plansService.planDetailPlanID = plans[0].id;
                if (!this.redirectNonMedicarePlansToPlanListWhenForcedRateFactorsEnabled(plans[0].planTypeAbbreviation, params)) {
                    return await this.redirectToPageTag(PageTags.PLAN_DETAILS, params);
                }
            }
            else if (plans?.length >= this.MINIMUM_PLAN_REQUIRED_TO_COMPARE) {
                const planType = plans[0]?.planTypeAbbreviation;
                this.addPlansToCompare(plans, planType);
                if (planType) {
                    this.planCompareService.setPlanComparePlanType(planType);
                    this.setActivePlanTab(planType);
                    return await this.redirectNonMedicarePlansToPlanListWhenForcedRateFactorsEnabled(plans[0].planTypeAbbreviation, params);
                }
            }
            else {
                return await this.redirectToPageTag(PageTags.PLAN_LIST, params);
            }
        }
        else {
            return await this.redirectToPageTag(PageTags.PLAN_LIST, params);
        }
    }
    getMajorityPlanTypePlans(plans) {
        const planTypes = plans.map(plan => plan.planTypeAbbreviation);
        const planType = this.getPlanTypeWithMostPlans(planTypes);
        return plans.filter(plan => plan.planTypeAbbreviation === planType);
    }
    addPlansToCompare(plans, planType) {
        const compareGroup = new CompareGroup(FilterKeyType.PLAN_TYPE_SHORT, [planType]);
        combineLatest([this.responsiveLayoutService.isCompact$, this.responsiveLayoutService.isMedium$])
            .pipe(map(([isMobile, isMedium]) => isMobile || isMedium), take(1))
            .subscribe(isMobileOrMediumDevice => {
            const planCompareDesktopLimit = this.configResourceService.getProcessedResourceValue('Spa_PlanCard_CompareLimit_Desktop', null, 3);
            const planCompareMobileLimit = this.configResourceService.getProcessedResourceValue('Spa_PlanCard_CompareLimit_Mobile', null, 2);
            const totalPlansToCompare = isMobileOrMediumDevice ? planCompareMobileLimit : planCompareDesktopLimit;
            const compareGroups = this.store.selectSnapshot(PlansState.compareGroups);
            if (compareGroups.length) {
                this.planCompareService.removeAllPlansFromCompareGroup([compareGroup]);
                const plansToCompare = plans.slice(0, totalPlansToCompare);
                this.planCompareService.addPlansToCompareGroup([compareGroup], plansToCompare);
            }
            else {
                this.planCompareService.setCompareGroup({
                    ...new CompareGroup(FilterKeyType.PLAN_TYPE_SHORT, [plans[0].planTypeAbbreviation]),
                    items: plans.slice(0, totalPlansToCompare)
                });
            }
        });
    }
    setMedicarePlansOfParams(medicarePlanIds) {
        const medicarePlanIdsFragments = medicarePlanIds.map(medicarePlanId => {
            const [contractId, planId, segmentId = this.DEFAULT_PLAN_SEGMENT] = medicarePlanId.split('-');
            return { contractId, planId, segmentId };
        });
        const plansInParam = this.store
            .selectSnapshot(PlansState.plans)
            .filter(plan => MEDICARE_PLAN_TYPES.some(medicarePlanType => plan.planTypeAbbreviation === medicarePlanType) &&
            medicarePlanIdsFragments.some(({ contractId, planId, segmentId }) => plan.contractId === contractId && plan.planId === planId && plan.segmentId === segmentId));
        return plansInParam;
    }
    setNonMedicarePlansOfParams(nonMedicarePlanIds) {
        const plansInParam = this.store
            .selectSnapshot(PlansState.plans)
            .filter(plan => NON_MEDICARE_PLAN_TYPES.some(nonMedicarePlanType => plan.planTypeAbbreviation === nonMedicarePlanType) &&
            nonMedicarePlanIds.some(nonMedicarePlanId => nonMedicarePlanId === plan.id));
        return plansInParam;
    }
    isMedicarePlanIdFormat(planIds) {
        // for deep linking, medicare plan IDs have the following format: H0523-061-000
        // H0523: contract ID
        // 061: plan ID
        // 000: segment ID
        return planIds.some(planId => planId.includes('-'));
    }
    getPlanTypeWithMostPlans(allPlanTypes) {
        return allPlanTypes
            .sort((a, b) => allPlanTypes.filter(element => element === a).length - allPlanTypes.filter(element => element === b).length)
            .pop();
    }
}
DeepLinkingService.ɵfac = function DeepLinkingService_Factory(t) { return new (t || DeepLinkingService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(PlansService), i0.ɵɵinject(NavigationService), i0.ɵɵinject(PlanCompareService), i0.ɵɵinject(MemberSessionService), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(ResponsiveLayoutService), i0.ɵɵinject(SiteService), i0.ɵɵinject(AgentService), i0.ɵɵinject(ShoppingCartService), i0.ɵɵinject(DemographicService)); };
DeepLinkingService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DeepLinkingService, factory: DeepLinkingService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DeepLinkingService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }, { type: PlansService }, { type: NavigationService }, { type: PlanCompareService }, { type: MemberSessionService }, { type: ConfigResourceService }, { type: ResponsiveLayoutService }, { type: SiteService }, { type: AgentService }, { type: ShoppingCartService }, { type: DemographicService }]; }, null); })();

class SSOHttpService {
    constructor(http) {
        this.http = http;
        this.environment = EnvironmentService.getEnvironment();
    }
    encrypt$(encryptionRequest) {
        const options = { headers: new HttpHeaders({ Accept: 'application/json' }) };
        return this.http.post(`${this.environment.SSO_BASE_URL}/Encrypt`, encryptionRequest, options);
    }
    decrypt$(decryptionRequest) {
        const options = { headers: new HttpHeaders({ Accept: 'application/json' }) };
        return this.http.post(`${this.environment.SSO_BASE_URL}/Decrypt`, decryptionRequest, options);
    }
}
SSOHttpService.ɵfac = function SSOHttpService_Factory(t) { return new (t || SSOHttpService)(i0.ɵɵinject(i1$2.HttpClient)); };
SSOHttpService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SSOHttpService, factory: SSOHttpService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SSOHttpService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1$2.HttpClient }]; }, null); })();

// This service is used to process deep linking query parameters and sso values before page loads
class PassParameterService {
    constructor(siteService, configResourceService, loginService, agentService, demographicService, demographicHttpService, memberSessionService, profileService, localeService, store, ssoService, deepLinkingService, ssoHttpService, plansService, base64UtilityService, profileCryptoService, quoteService, externalErrorLoggingService) {
        this.siteService = siteService;
        this.configResourceService = configResourceService;
        this.loginService = loginService;
        this.agentService = agentService;
        this.demographicService = demographicService;
        this.demographicHttpService = demographicHttpService;
        this.memberSessionService = memberSessionService;
        this.profileService = profileService;
        this.localeService = localeService;
        this.store = store;
        this.ssoService = ssoService;
        this.deepLinkingService = deepLinkingService;
        this.ssoHttpService = ssoHttpService;
        this.plansService = plansService;
        this.base64UtilityService = base64UtilityService;
        this.profileCryptoService = profileCryptoService;
        this.quoteService = quoteService;
        this.externalErrorLoggingService = externalErrorLoggingService;
        this.ZIP_AND_FIPS_REQUIRED_LENGTH = 5;
        this.MINIMUM_COUNTY_LENGTH = 1;
        this.qsIdentifier = 'qs=';
        this.sigIdIdentifier = 'sigid=';
    }
    createFromSSO(sso) {
        const siteType = this.configResourceService.getProcessedResourceValue('Spa_Site_SiteType', null, 'consumer');
        return PassParams.createFromSSO(sso, siteType);
    }
    createFromDeepLinking(deepLinkingParams) {
        return PassParams.createFromDeepLinking(deepLinkingParams);
    }
    createFromAgentPurlInfo(agentPurlInformation) {
        return PassParams.createFromAgentPurlInformation(agentPurlInformation);
    }
    createUTMFromQueryParams(queryParams) {
        return PassParams.createUTMFromQueryParams(this.convertParamsToUpperCase(queryParams));
    }
    async processParameters(passParametersMap, pageTags) {
        try {
            if ((passParametersMap?.ssoParams && Object.keys(passParametersMap.ssoParams).length) ||
                (passParametersMap?.deepLinkingPassParams && Object.keys(passParametersMap.deepLinkingPassParams).length)) {
                const siteType = this.configResourceService.getProcessedResourceValue('Spa_Site_SiteType', null, 'consumer');
                const memberPortalEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_CustomerMemberPortalIntegration_Enabled', null, false);
                const mergedPassParameters = this.mergePassParameters(passParametersMap);
                const ssoParams = passParametersMap?.ssoParams ?? {};
                const ssoValue = mergedPassParameters.SSOValue;
                let sessionId;
                let apiMemberStateModel = {};
                if (memberPortalEnabled) {
                    if (ssoValue) {
                        apiMemberStateModel = {
                            ssoValue
                        };
                    }
                    // Retrieve session id from PassParams
                    sessionId = await this.retrieveSessionIdFromPassParams(mergedPassParameters, apiMemberStateModel);
                }
                // Save pass parameter fields to deep linking state for custom internal
                this.loadCustomInternalData(mergedPassParameters);
                // Load Agent. PURL agent on consumer site are loaded here.
                const agent = await this.loadAgent(mergedPassParameters, siteType);
                // Load Member. Create session if no member to load
                const memberLoggedIn = await this.loadMember(passParametersMap, pageTags, agent);
                if (!memberPortalEnabled && memberLoggedIn) {
                    sessionId = this.store.selectSnapshot(MemberState.sessionId);
                }
                if (memberPortalEnabled) {
                    // Populate member session
                    await this.populateMemberSession(sessionId, passParametersMap, apiMemberStateModel);
                }
                await this.loadZipFips(mergedPassParameters, pageTags, siteType);
                // Update session/profile with pass parameter values
                if (!sessionId && this.hasZipInSession()) {
                    await this.createMemberSession(ssoParams, agent, memberLoggedIn);
                }
                this.setMedigapAnswers(ssoParams);
                // Set plan type
                this.setActivePlanTab(mergedPassParameters.PlanType);
                // Set culture code
                this.setLocale(mergedPassParameters.CultureCode);
                // Set Subsidy
                this.setSubsidy(mergedPassParameters);
                this.setSourceSiteId(mergedPassParameters);
                // Set the original app if for PURL PCE session creation
                this.setOriginalAppId(mergedPassParameters);
            }
        }
        catch (error) {
            this.deepLinkingService.clearSession();
            throw error;
        }
    }
    mergePassParameters(passParametersMap) {
        // SPA-18269: SSO values take precedence over deep linking query string params
        return { ...passParametersMap?.deepLinkingPassParams, ...passParametersMap?.ssoParams };
    }
    mergeDeepLinkingParameters(passParametersMap, deepLinkingPassParams) {
        return {
            ...passParametersMap,
            deepLinkingPassParams
        };
    }
    mergeSSOParameters(passParametersMap, ssoParams) {
        return {
            ...passParametersMap,
            ssoParams
        };
    }
    canProcessQueryString(pageTags, queryParams, siteType) {
        const isDeepLinkingEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_IsDeepLinking_Enabled', null, true);
        const isVerificationEnabled = this.configResourceService.getProcessedResourceValue('Spa_Verification_Enabled', null, false);
        const isPurlBookmarkingEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_PurlBookmarking_Enabled', null, true);
        const allowablePages = this.deepLinkingService.getAllowablePages(siteType);
        return ((isDeepLinkingEnabled || isPurlBookmarkingEnabled) &&
            // Sign & Submit flow: allows processing deep linking params when Verification feature is enabled
            (siteType === SiteType.CONSUMER || isVerificationEnabled) &&
            (allowablePages.some(pageName => pageTags.includes(pageName)) ||
                (isPurlBookmarkingEnabled && pageTags.includes(PageTags.CONSUMER_ACCOUNT_SUMMARY))) &&
            !!queryParams &&
            ((pageTags.includes(PageTags.PLAN_DETAILS) && Object.keys(queryParams).length > 1) ||
                (!pageTags.includes(PageTags.PLAN_DETAILS) && !!Object.keys(queryParams).length)));
    }
    async resolveParameters(pageTags, queryParams, siteType, clearSession) {
        let passParamsMap = {};
        if (this.canProcessQueryString(pageTags, queryParams, siteType)) {
            const deepLinkingParams = this.convertParamsToUpperCase(queryParams);
            passParamsMap = this.mergeDeepLinkingParameters(passParamsMap, this.createFromDeepLinking(deepLinkingParams));
        }
        const isPurlBookmarkingEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_PurlBookmarking_Enabled', null, true);
        if (isPurlBookmarkingEnabled && passParamsMap.deepLinkingPassParams?.PurlId) {
            // If purl bookmarking is enabled and there is a purlId query string parameter present,
            // then pull the necessary information for the pURL from the API and not rely on the call to SSOValues.
            try {
                const agentPurlInformation = await this.agentService.getAgentPurlInformation(passParamsMap.deepLinkingPassParams?.PurlId);
                if (agentPurlInformation) {
                    const deepLinkingParams = {
                        ...passParamsMap.deepLinkingPassParams,
                        IsPurlRequest: 'true'
                    };
                    const ssoParams = this.createFromAgentPurlInfo(agentPurlInformation);
                    passParamsMap = this.mergeDeepLinkingParameters(passParamsMap, deepLinkingParams);
                    passParamsMap = this.mergeSSOParameters(passParamsMap, ssoParams);
                    this.setRedirectPageTag(agentPurlInformation.ptag);
                    this.setIsPurl(agentPurlInformation.agentUserName);
                }
            }
            catch (error) {
                this.externalErrorLoggingService.log(error);
                this.redirectToHome();
            }
        }
        else {
            const ssoResult = await this.ssoService.getSSOValues();
            if (ssoResult) {
                // if requested we should clear session before getting and applying sso values
                // right now we are doing this everytime our values check shows values because
                // this indicates a fresh sso
                if (clearSession) {
                    // we need to clear our member session but in the case we have set an ssoResult
                    // first we do not want to clear this value as it is looked for on agent logins
                    // with relay states
                    this.memberSessionService.resetSessionState({ clearAnonymousSession: true, clearRuntimeSession: false }); // TODO: verify the necessity of clearing the runtime state
                }
                this.setRedirectPageTag(ssoResult?.state?.ptag);
                if (ssoResult?.source === BROKER_URL && passParamsMap?.deepLinkingPassParams?.IsPurlRequest?.toLowerCase() === 'true') {
                    this.setIsPurl(ssoResult.state?.agentUsername);
                }
                const ssoParams = this.createFromSSO(ssoResult);
                // SPA-18269: Separate data sets from SAML SSO and Deep Link Query String params
                passParamsMap = this.mergeSSOParameters(passParamsMap, ssoParams);
            }
        }
        return passParamsMap;
    }
    getSourceId() {
        return this.store.selectSnapshot(DeepLinkingParamsState.sourceId);
    }
    getPartnerId() {
        return this.store.selectSnapshot(DeepLinkingParamsState.partnerId);
    }
    checkDeepLinkingRequest(params) {
        const deepLinkingParams = this.convertParamsToUpperCase(params);
        const passParam = PassParams.createFromDeepLinking(deepLinkingParams);
        return passParam !== null && !!Object.keys(passParam).length;
    }
    async getDecryptedSessionId(encryptedSession) {
        let qs;
        let sigId;
        if (encryptedSession.includes('&')) {
            encryptedSession?.split('&').forEach(item => {
                if (item.includes(this.qsIdentifier)) {
                    qs = item.split(this.qsIdentifier)[1];
                }
                if (item.includes(this.sigIdIdentifier)) {
                    sigId = item.split(this.sigIdIdentifier)[1];
                }
            });
            if (qs && sigId) {
                const decryptionRequest = {
                    EncryptedQueryString: qs,
                    sigid: sigId
                };
                return await this.ssoHttpService.decrypt$(decryptionRequest).toPromise();
            }
        }
    }
    isUTMOnly(passParameters) {
        if (!passParameters) {
            return false;
        }
        let numberOfUTMParameters = 0;
        if (typeof passParameters.UTM_Campaign !== 'undefined') {
            numberOfUTMParameters++;
        }
        if (typeof passParameters.UTM_Medium !== 'undefined') {
            numberOfUTMParameters++;
        }
        if (typeof passParameters.UTM_Source !== 'undefined') {
            numberOfUTMParameters++;
        }
        return Object.keys(passParameters).length === numberOfUTMParameters;
    }
    async retrieveSessionIdFromPassParams(passParameters, apiMemberStateModel) {
        let sessionId;
        // If sessionId is present then decrypt it
        if (passParameters.SessionId) {
            const decryptedSession = await this.getDecryptedSessionId(passParameters.SessionId);
            if (decryptedSession?.qs) {
                sessionId = decryptedSession.qs;
            }
        }
        // Create session with sso if sso and session exists (it will tie the member with the sso)
        if (passParameters.SSOValue && sessionId) {
            const response = await this.memberSessionService.createSessionWithSSO$(sessionId, apiMemberStateModel);
            if (response?.status === MemberStatus.CREATED) {
                sessionId = response.sessionId;
            }
        }
        return sessionId;
    }
    async populateMemberSession(sessionId, passParametersMap, apiMemberStateModel) {
        if (sessionId) {
            await this.memberSessionService.fetchMemberSession$({ sessionId, isEnrollmentHistoryIncluded: true }).toPromise();
        }
        if (passParametersMap?.deepLinkingPassParams?.SSOValue ?? passParametersMap?.ssoParams?.SSOValue) {
            this.memberSessionService.updateMemberProfile(apiMemberStateModel);
        }
        let profile;
        if (passParametersMap?.ssoParams?.BeneFirstName && passParametersMap?.ssoParams?.BeneLastName) {
            // SPA-18269: Updates to the member profile should only come from the SAML Assertions
            profile = this.createProfileStateModel(passParametersMap?.ssoParams ?? {});
            sessionId = sessionId || this.memberSessionService.getMemberSessionId();
            await this.profileService.updateProfileSession(sessionId, profile);
        }
        if (!passParametersMap?.ssoParams?.BeneFirstName && !passParametersMap?.ssoParams?.BeneLastName) {
            profile = this.profileService.getMemberProfile();
        }
        if (profile) {
            this.profileService.updateProfile$(profile);
        }
        // If session exits then update member details
        if (this.memberSessionService.getMemberSessionId()) {
            await this.memberSessionService.updateSelectedMemberDetails(true);
        }
    }
    convertParamsToUpperCase(params) {
        const queryParams = {};
        Object.entries(params).forEach(([key, value]) => {
            queryParams[key.toUpperCase()] = value;
        });
        return queryParams;
    }
    async setValidZipAndFips(zip, fips) {
        if (zip) {
            if (zip.length !== this.ZIP_AND_FIPS_REQUIRED_LENGTH) {
                this.demographicService.selectLocation('', '');
                return false;
            }
            const counties = await this.demographicHttpService.retrieveCounties(zip).catch(() => {
                this.demographicService.selectLocation('', '');
                return null;
            });
            if (counties) {
                this.setZip(zip);
                // Handle multi-county zip
                if (counties && counties.length > this.MINIMUM_COUNTY_LENGTH) {
                    if (fips && fips.length === this.ZIP_AND_FIPS_REQUIRED_LENGTH && counties.some(county => county.countyFIPS === fips)) {
                        this.demographicService.selectLocation(fips, zip);
                        return true;
                    }
                    this.setFipsCode(null);
                    return false;
                }
                const fetchedFips = counties[0].countyFIPS;
                if (fetchedFips) {
                    this.demographicService.selectLocation(fetchedFips, zip);
                    // SCS-62477 (deep linking): if there is no session available, this call will create a new session.
                    // Awaiting here prevents the creation of a 2nd session within the MemberSessionResolver.resolve().
                    // Otherwise, we could end up losing any data saved in the previous session.
                    await this.demographicService.updateDemographicSession();
                    return true;
                }
            }
        }
        return false;
    }
    setZip(zip) {
        this.store.dispatch(new SelectZipCode(zip)); // For Demographic state
        this.store.dispatch(new SetZipCode(zip)); // For Helpful tools state
    }
    setFipsCode(fipCode) {
        this.store.dispatch(new SelectFIPS(fipCode)); // For Demographic state
        this.store.dispatch(new SetFipsCode(fipCode)); // For Helpful tools state
    }
    async loadMember(passParametersMap, pageTags, agent) {
        if (passParametersMap?.deepLinkingPassParams || passParametersMap?.ssoParams) {
            const params = this.mergePassParameters(passParametersMap);
            try {
                const memberLoginOptions = MemberLoginOptions.createDefaultOptions({
                    fetchCreatingAgent: false,
                    includePlanData: this.deepLinkingService.includePlanData(params, pageTags),
                    params
                });
                if (params.AuthCode1) {
                    await this.loginService.authenticateUserWithPIN(this.createAuthPINInfo(params), memberLoginOptions);
                }
                else if (params.SSOValue) {
                    // SPA-18269: Updates to the member profile should only come from the SAML Assertions
                    const newMemberInfo = this.createSessionStateModel(passParametersMap?.ssoParams ?? {}, agent);
                    await this.loginService.loginSSOMember(this.createSSOAuthInfo(params), memberLoginOptions, newMemberInfo);
                }
                else if (params.BeneUserName && params.BenePassword) {
                    await this.loginService.loginMember(params.BeneUserName, params.BenePassword, memberLoginOptions);
                }
                const loggedIn = this.memberSessionService.isMemberLoggedIn();
                if (loggedIn) {
                    return true;
                }
            }
            catch (error) { }
        }
        return false;
    }
    async loadAgent(params, siteType) {
        const { AgentExternalId: agentExternalId, AgentUserName: agentUsername, AgentLoginDomain: agentLoginDomain } = params;
        const decodedAgentLoginDomain = agentLoginDomain && this.base64UtilityService.decodeText(agentLoginDomain);
        const agencyConsumerDomainSharedEnabled = this.configResourceService.getProcessedResourceValue('Spa_Agency_Consumer_Domain_Sharing_Enabled', null, false);
        let agent = null;
        try {
            const agentLoginRequestBody = {
                ssoRequest: true,
                ...(agencyConsumerDomainSharedEnabled && decodedAgentLoginDomain && { SourceAgentLoginDomain: decodedAgentLoginDomain })
            };
            if (agentExternalId) {
                agent = await this.loginService
                    .loginAgent$({
                    externalUserId: agentExternalId,
                    ...agentLoginRequestBody
                })
                    .toPromise();
            }
            else if (agentUsername) {
                agent = await this.loginService
                    .loginAgent$({
                    userName: agentUsername,
                    ...agentLoginRequestBody
                })
                    .toPromise();
            }
        }
        catch (error) {
            return await Promise.reject(error);
        }
        if (agent) {
            // Broker / Call Center
            if (this.siteService.isPPCSite(siteType)) {
                this.agentService.setAgentContext(AgentContext.LOGGED_IN);
            }
            else {
                // Consumer
                this.agentService.setAgentContext(AgentContext.IN_CONTEXT);
            }
            return await Promise.resolve(agent);
        }
        return await Promise.resolve(null);
    }
    createAuthPINInfo(params) {
        const { AuthCode1: auth1, AuthCode2: auth2, AuthCode3: auth3, AuthCode4: auth4 } = params;
        return {
            ...(auth1 && { auth1 }),
            ...(auth2 && { auth2 }),
            ...(auth3 && { auth3 }),
            ...(auth4 && { auth4 })
        };
    }
    createSSOAuthInfo(params) {
        const { SSOValue: ssoValue, SSOName: ssoName, SSOZipCode: ssoZipCode } = params;
        return {
            ...(ssoName && { ssoName }),
            ...(ssoValue && { ssoValue }),
            ...(ssoZipCode && { demographics: { zip: ssoZipCode } })
        };
    }
    createSessionStateModel(params, agent) {
        const { SSOValue: ssoValue, Zip: zip = params.ZipCode, Fips: fips = params.CountyFips, BeneBirthDate: beneBirthDate } = params;
        const profile = this.createProfileStateModel(params);
        const birthDate = PassParameterUtilities.resolveDate(beneBirthDate);
        return {
            ...(agent?.agentGuid && { agentGuid: agent.agentGuid }),
            ...(ssoValue && { ssoValue }),
            ...((zip || fips || birthDate) && {
                demographic: {
                    ...(zip && { zip }),
                    ...(fips && { fips }),
                    ...(birthDate && { birthDate })
                }
            }),
            ...(profile && Object.keys(profile).length && { profile: this.profileService.prepareProfileStateForAPI(profile) })
        };
    }
    createProfileStateModel(params) {
        const { BeneAddr1, BeneAddr2, BeneCity, BeneEmail, BeneFirstName, BeneLastName, BenePhone, BeneCellPhone, BeneState, ZipCode, BeneBirthDate, BeneGender, BeneCRMID, BeneMBI, Zip } = params;
        const birthDate = PassParameterUtilities.resolveDate(BeneBirthDate);
        const defaultAddress = this.getAddressesDefaultValues();
        const profileHICNEncrypted = BeneMBI && this.profileCryptoService.getEncryptedHICN(BeneMBI);
        return {
            ...(BeneFirstName && { firstName: BeneFirstName }),
            ...(BeneLastName && { lastName: BeneLastName }),
            ...(BeneEmail && { emailAddress: BeneEmail }),
            ...(BenePhone && { homePhone: BenePhone }),
            ...(BeneCellPhone && { cellPhone: BeneCellPhone }),
            ...(birthDate && { birthdate: birthDate }),
            ...(BeneGender && { gender: Number(BeneGender) }),
            ...(BeneCRMID && { crmid: BeneCRMID }),
            ...((BeneAddr1 || BeneAddr2 || BeneCity || BeneState || ZipCode || Zip) && {
                addresses: [
                    {
                        address1: BeneAddr1 || defaultAddress.address1,
                        ...(BeneAddr2 && { address2: BeneAddr2 }),
                        city: BeneCity || defaultAddress.city,
                        state: BeneState || defaultAddress.state,
                        zip: ZipCode || Zip ? ZipCode || Zip : defaultAddress.zip,
                        isPrimaryAddress: true
                    }
                ]
            }),
            ...(BeneMBI && { hicn: profileHICNEncrypted?.encryptedHICN || '', hicnKeyValue: profileHICNEncrypted?.hicnKeyValue || '' })
        };
    }
    async createMemberSession(params, agent, isMemberLoggedIn) {
        const reqType = params.ReqType;
        if (reqType && reqType === 'S') {
            // TODO: Use beneFirstName, beneLastName, benePhone and benePhone to autopopulate and trigger member search, if present
            // TODO: Future story
        }
        else {
            const sessionState = this.createSessionStateModel(params);
            if (sessionState && Object.keys(sessionState).length) {
                // Agent guid is required if sending member id
                const memberId = isMemberLoggedIn && agent?.agentGuid ? this.store.selectSnapshot(MemberState.memberID) : null;
                await this.memberSessionService
                    .createFullMemberSession$({
                    ...sessionState,
                    ...(agent?.agentGuid && { agentGuid: agent.agentGuid }),
                    ...(memberId && { memberID: memberId })
                })
                    .toPromise()
                    .catch(() => { });
                const profile = sessionState.profile;
                if (profile) {
                    this.profileService.updateProfile$(profile);
                }
            }
        }
    }
    setMedigapAnswers(passParameters) {
        const { BenePartADate, BenePartBDate } = passParameters;
        if (BenePartADate || BenePartBDate) {
            if (BenePartADate) {
                this.memberSessionService.setPartAEffectiveDate(PassParameterUtilities.resolveDate(BenePartADate, true));
            }
            if (BenePartBDate) {
                this.memberSessionService.setPartBEffectiveDate(PassParameterUtilities.resolveDate(BenePartBDate, true));
            }
            const sessionId = this.memberSessionService.getMemberSessionId();
            this.store.dispatch(new UpdateMedigapAnswersSession(sessionId));
        }
    }
    async loadZipFips(passParameters, pageTags, siteType) {
        // Set zip/fips
        const validZipAndFips = await this.setValidZipAndFips(passParameters.ZipCode || passParameters.Zip, passParameters.CountyFips || passParameters.Fips);
        if (!validZipAndFips || !this.hasZipAndFipsInSession()) {
            if (pageTags.includes(PageTags.PLAN_DETAILS) || pageTags.includes(PageTags.PLAN_COMPARISON)) {
                return await this.redirectToPageTag(PageTags.PLAN_LIST, passParameters);
            }
        }
        else if (!validZipAndFips &&
            !this.hasZipAndFipsInSession() &&
            !this.siteService.isPPCSite(siteType) &&
            !this.isUTMOnly(passParameters) &&
            !(pageTags.includes(PageTags.HELPFUL_TOOLS) ||
                pageTags.includes(PageTags.PLAN_LIST) ||
                pageTags.includes(PageTags.GUIDED_HELP_GETTING_STARTED))) {
            if (!pageTags.includes(PageTags.HELPFUL_TOOLS_PHARMACYSEARCH)) {
                return await this.redirectToHome();
            }
            return await this.redirectToHelpfulToolsPage();
        }
    }
    hasZipAndFipsInSession() {
        return !!this.memberSessionService.getZipCode() && !!this.memberSessionService.getFipsCode();
    }
    hasZipInSession() {
        return !!this.memberSessionService.getZipCode();
    }
    setLocale(cultureCode) {
        if (cultureCode && this.localeService.isValidLocale(cultureCode)) {
            this.localeService.setLocale(cultureCode);
        }
    }
    setSubsidy(passParameters) {
        this.deepLinkingService.setSubsidy(passParameters);
    }
    setSourceSiteId(passParameters) {
        const sourceSiteId = passParameters?.SourceSiteId;
        if (sourceSiteId) {
            try {
                const decodedSourceSiteId = this.base64UtilityService.decodeText(sourceSiteId);
                this.quoteService.setSourceSiteId(decodedSourceSiteId);
            }
            catch (error) {
                console.error('Unable to decode sourceSiteId: ', sourceSiteId);
                this.externalErrorLoggingService.log(error);
            }
        }
    }
    setOriginalAppId(passParameters) {
        const originalAppId = passParameters?.OriginalAppId;
        if (originalAppId) {
            try {
                const decodedOriginalAppId = this.base64UtilityService.decodeText(originalAppId);
                this.quoteService.setOriginalAppId(decodedOriginalAppId);
            }
            catch (error) {
                console.error('Unable to decode the original app id', originalAppId);
                this.externalErrorLoggingService.log(error);
            }
        }
    }
    loadCustomInternalData(params) {
        this.store.dispatch(new SetDeepLinkingParams(PassParams.mapToDeepLinkingParams(params)));
    }
    getAddressesDefaultValues() {
        const addresses = this.store.selectSnapshot(ProfileState.addresses);
        const address1 = addresses.length ? addresses[0].address1 : '';
        const address2 = addresses.length ? addresses[0].address2 : '';
        const city = addresses.length ? addresses[0].city : '';
        const state = addresses.length ? addresses[0].state : '';
        const zip = addresses.length ? addresses[0].zip : '';
        return { address1, address2, city, state, zip };
    }
    setActivePlanTab(planType) {
        if (planType) {
            this.deepLinkingService.setActivePlanTab(planType);
            // Set override flag to false so we land on the ActiveTab set above
            this.plansService.setOverrideActiveTab(false);
        }
    }
    async redirectToHome() {
        return await this.deepLinkingService.redirectToHome();
    }
    async redirectToHelpfulToolsPage() {
        return await this.deepLinkingService.redirectToHelpfulToolsPage();
    }
    async redirectToPageTag(pageTag, queryParams) {
        return await this.deepLinkingService.redirectToPageTag(pageTag, queryParams);
    }
    setRedirectPageTag(pageTag) {
        if (pageTag) {
            this.store.dispatch(new SetRedirectPageTag(pageTag));
        }
    }
    setIsPurl(agentUsername) {
        this.store.dispatch(new SetIsPurl(true));
        this.store.dispatch(new SetPurlAgentUsername(agentUsername ?? ''));
    }
}
PassParameterService.ɵfac = function PassParameterService_Factory(t) { return new (t || PassParameterService)(i0.ɵɵinject(SiteService), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(LoginService), i0.ɵɵinject(AgentService), i0.ɵɵinject(DemographicService), i0.ɵɵinject(DemographicHttpService), i0.ɵɵinject(MemberSessionService), i0.ɵɵinject(ProfileService), i0.ɵɵinject(LocaleService), i0.ɵɵinject(i1.Store), i0.ɵɵinject(SSOService), i0.ɵɵinject(DeepLinkingService), i0.ɵɵinject(SSOHttpService), i0.ɵɵinject(PlansService), i0.ɵɵinject(Base64UtilityService), i0.ɵɵinject(ProfileCryptoService), i0.ɵɵinject(QuoteService), i0.ɵɵinject(ExternalErrorLoggingService)); };
PassParameterService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PassParameterService, factory: PassParameterService.ɵfac, providedIn: 'root' });
__decorate([
    Memoize()
], PassParameterService.prototype, "mergePassParameters", null);
__decorate([
    Memoize()
], PassParameterService.prototype, "mergeDeepLinkingParameters", null);
__decorate([
    Memoize()
], PassParameterService.prototype, "mergeSSOParameters", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PassParameterService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: SiteService }, { type: ConfigResourceService }, { type: LoginService }, { type: AgentService }, { type: DemographicService }, { type: DemographicHttpService }, { type: MemberSessionService }, { type: ProfileService }, { type: LocaleService }, { type: i1.Store }, { type: SSOService }, { type: DeepLinkingService }, { type: SSOHttpService }, { type: PlansService }, { type: Base64UtilityService }, { type: ProfileCryptoService }, { type: QuoteService }, { type: ExternalErrorLoggingService }]; }, { mergePassParameters: [], mergeDeepLinkingParameters: [], mergeSSOParameters: [] }); })();

class LockedSiteService {
    constructor(configResourceService) {
        this.configResourceService = configResourceService;
        this.reviewSiteIdentifierText = new RegExp(/^(.*review\d+)-.*$/);
    }
    /**
     *  A not live site is NOT the same as a locked, you want review for that
     */
    isSiteLive(widgetName) {
        return this.configResourceService.getProcessedResourceValue('IsSiteLive', widgetName, false);
    }
    /**
     *  A review site is the same as a locked site
     */
    isReviewSite(location) {
        return this.reviewSiteIdentifierText.test(location);
    }
}
LockedSiteService.ɵfac = function LockedSiteService_Factory(t) { return new (t || LockedSiteService)(i0.ɵɵinject(ConfigResourceService)); };
LockedSiteService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LockedSiteService, factory: LockedSiteService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LockedSiteService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ConfigResourceService }]; }, null); })();

/** Indicates fields populated during SSO process that the user should not be allowed to modify */
var SSOPopulatedField;
(function (SSOPopulatedField) {
    SSOPopulatedField["DEMOGRAPHIC_DATE_OF_BIRTH"] = "Demographic.DateOfBirth";
    SSOPopulatedField["EMPLOYMENT_STATUS"] = "Demographic.EmploymentStatus";
    SSOPopulatedField["BIRTHDATE"] = "Profile.Birthdate";
    SSOPopulatedField["CELLPHONE"] = "Profile.CellPhone";
    SSOPopulatedField["WORKPHONE"] = "Profile.WorkPhone";
    SSOPopulatedField["FIRSTNAME"] = "Profile.FirstName";
    SSOPopulatedField["LASTNAME"] = "Profile.LastName";
    SSOPopulatedField["GENDER"] = "Profile.Gender";
    SSOPopulatedField["MARTIAL_STATUS"] = "Profile.MaritalStatus";
    SSOPopulatedField["MIDDLE_INITIAL"] = "Profile.MiddleInitial";
    SSOPopulatedField["PRIMARY_EMAIL_ADDRESS"] = "Profile.PrimaryEmailAddress";
    SSOPopulatedField["HOMEPHONE"] = "Profile.HomePhone";
    SSOPopulatedField["ZIPCODE"] = "Profile.ZipCode";
    SSOPopulatedField["DEMOGRAPHIC_ZIPCODE"] = "Demographic.ZipCode";
    SSOPopulatedField["AGERANGE"] = "Demographic.AgeRange";
    SSOPopulatedField["ADDRESS"] = "Profile.Address";
    SSOPopulatedField["SSN"] = "Profile.SSN";
    SSOPopulatedField["RELATIONSHIP_TYPE"] = "Profile.RelationshipType";
})(SSOPopulatedField || (SSOPopulatedField = {}));

class SSOPopulatedFieldService {
    constructor(store, configResourceService) {
        this.store = store;
        this.configResourceService = configResourceService;
    }
    isReadOnlyEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_SSO_PopulatedFields_ReadOnly_Enabled', widgetName, false);
    }
    getPopulatedData() {
        return this.store.selectSnapshot(DeepLinkingParamsState.populatedData);
    }
    getPopulatedData$() {
        return this.store.select(DeepLinkingParamsState.populatedData);
    }
    getPopulatedFields$() {
        return this.getPopulatedData$().pipe(map(prepopulatedData => prepopulatedData?.split(',') ?? []));
    }
    getPopulatedFields() {
        const prepopulatedData = this.getPopulatedData();
        return prepopulatedData?.split(',') ?? [];
    }
    isFieldReadOnly$(fieldName) {
        return this.getPopulatedFields$().pipe(map(prepopulatedFields => this.isReadOnlyEnabled() && this.isFieldPopulated(prepopulatedFields, fieldName)));
    }
    isFieldPopulated(prepopulatedFields, fieldName) {
        return prepopulatedFields && prepopulatedFields.some(field => field === fieldName) && !!this.getFieldValue(fieldName);
    }
    getFieldValue(fieldName) {
        let address;
        switch (fieldName) {
            case SSOPopulatedField.DEMOGRAPHIC_DATE_OF_BIRTH:
                return this.store.selectSnapshot(DemographicState.birthdate);
            case SSOPopulatedField.BIRTHDATE:
                return this.store.selectSnapshot(ProfileState.birthdate);
            case SSOPopulatedField.CELLPHONE:
                return this.store.selectSnapshot(ProfileState.cellPhone);
            case SSOPopulatedField.WORKPHONE:
                return this.store.selectSnapshot(ProfileState.workPhone);
            case SSOPopulatedField.FIRSTNAME:
                return this.store.selectSnapshot(ProfileState.firstName);
            case SSOPopulatedField.LASTNAME:
                return this.store.selectSnapshot(ProfileState.lastName);
            case SSOPopulatedField.GENDER:
                return this.store.selectSnapshot(ProfileState.genderCode);
            case SSOPopulatedField.MARTIAL_STATUS:
                return this.store.selectSnapshot(ProfileState.maritalStatus);
            case SSOPopulatedField.MIDDLE_INITIAL:
                return this.store.selectSnapshot(ProfileState.middleInitial);
            case SSOPopulatedField.PRIMARY_EMAIL_ADDRESS:
                return this.store.selectSnapshot(ProfileState.emailAddress);
            case SSOPopulatedField.HOMEPHONE:
                return this.store.selectSnapshot(ProfileState.homePhone);
            case SSOPopulatedField.ZIPCODE:
                address = this.getProfileAddress();
                return address ? address.zip : null;
            case SSOPopulatedField.DEMOGRAPHIC_ZIPCODE:
                return this.store.selectSnapshot(DemographicState.selectedZipCode);
            case SSOPopulatedField.ADDRESS:
                address = this.getProfileAddress();
                return address ? address : null;
            case SSOPopulatedField.AGERANGE:
                return this.store.selectSnapshot(DemographicState.ageRange);
            case SSOPopulatedField.EMPLOYMENT_STATUS:
            case SSOPopulatedField.SSN:
            case SSOPopulatedField.RELATIONSHIP_TYPE:
            default:
                return null;
        }
    }
    getProfileAddress() {
        const addresses = this.store.selectSnapshot(ProfileState.addresses);
        if (addresses && addresses.length) {
            const primaryAddress = addresses.find(address => address.isPrimaryAddress);
            return primaryAddress || addresses[0];
        }
        return null;
    }
}
SSOPopulatedFieldService.ɵfac = function SSOPopulatedFieldService_Factory(t) { return new (t || SSOPopulatedFieldService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(ConfigResourceService)); };
SSOPopulatedFieldService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SSOPopulatedFieldService, factory: SSOPopulatedFieldService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SSOPopulatedFieldService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }, { type: ConfigResourceService }]; }, null); })();

/*
  This class is intended for Major errors related to enrollment, such as ones that we cannot recover from, or have an infinite spinner.
  If you are looking for intraform errors, such as a missing required field, you want enrollment-form-errors.context.ts
*/
class EnrollmentTransactionErrorsContext {
    constructor() {
        this._enrollmentFormError$ = new BehaviorSubject(null);
    }
    clearEnrollmentFormError() {
        this._enrollmentFormError$.next(null);
    }
    updateEnrollmentFormError(error) {
        this._enrollmentFormError$.next(error);
    }
    get enrollmentFormError$() {
        return this._enrollmentFormError$.asObservable();
    }
}
EnrollmentTransactionErrorsContext.ɵfac = function EnrollmentTransactionErrorsContext_Factory(t) { return new (t || EnrollmentTransactionErrorsContext)(); };
EnrollmentTransactionErrorsContext.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: EnrollmentTransactionErrorsContext, factory: EnrollmentTransactionErrorsContext.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnrollmentTransactionErrorsContext, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

class MedSupMillimanCryptoService {
    constructor(store, configResourceService, cryptoUtilityService) {
        this.store = store;
        this.configResourceService = configResourceService;
        this.cryptoUtilityService = cryptoUtilityService;
    }
    getMillimanSecretKey() {
        return this.configResourceService.getProcessedResourceValue('Spa_Milliman_Secret_Key');
    }
    getApplicantId() {
        return this.store.selectSnapshot(MillimanState.applicantId);
    }
    getApplicantSecretKeyValue() {
        return this.store.selectSnapshot(MillimanState.keyValue);
    }
    getDecryptedApplicantId() {
        return this.getDecryptedSocialSecurityNumber();
    }
    encrypt(plainText, password) {
        return this.cryptoUtilityService.encrypt(plainText, password);
    }
    decrypt(message, password) {
        return this.cryptoUtilityService.decrypt(message, password);
    }
    getDecryptedApplicantIdFromMemberNotes() {
        const medSupAnswers = this.store.selectSnapshot(MemberState.medigapAnswers);
        if (medSupAnswers?.millimanHealthInformation) {
            const { applicantId, keyValue } = medSupAnswers.millimanHealthInformation;
            if (applicantId && keyValue) {
                const bytes = this.decrypt(applicantId, `${keyValue}${this.getMillimanSecretKey()}`);
                return bytes.toString(CryptoJS.enc.Utf8);
            }
        }
        return null;
    }
    getDecryptedSocialSecurityNumber() {
        const cipherText = this.getApplicantId();
        const secretKeyRandomElement = this.getApplicantSecretKeyValue();
        if (cipherText && secretKeyRandomElement) {
            try {
                const bytes = this.decrypt(cipherText, secretKeyRandomElement + this.getMillimanSecretKey());
                return bytes.toString(CryptoJS.enc.Utf8);
            }
            catch (error) {
                console.error('Decryption failed due to key mismatch or corrupted data', error);
                return '';
            }
        }
        return '';
    }
}
MedSupMillimanCryptoService.ɵfac = function MedSupMillimanCryptoService_Factory(t) { return new (t || MedSupMillimanCryptoService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(CryptoUtilityService)); };
MedSupMillimanCryptoService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MedSupMillimanCryptoService, factory: MedSupMillimanCryptoService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedSupMillimanCryptoService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }, { type: ConfigResourceService }, { type: CryptoUtilityService }]; }, null); })();

class IdleInterruptContext {
    constructor() {
        this._interruptIdle$ = new Subject();
    }
    interruptIdle() {
        this._interruptIdle$.next(null);
    }
    interruptIdle$() {
        return this._interruptIdle$.asObservable();
    }
}
IdleInterruptContext.ɵfac = function IdleInterruptContext_Factory(t) { return new (t || IdleInterruptContext)(); };
IdleInterruptContext.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: IdleInterruptContext, factory: IdleInterruptContext.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IdleInterruptContext, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

const REFRESH_JWT_DURING_TWILIO_CALL_INTERVAL_MS = 1200000;
class TwilioDeviceService {
    constructor(navigationContext, navigationUtilityService, profileService, store, authService, idleInterruptContext) {
        this.navigationContext = navigationContext;
        this.navigationUtilityService = navigationUtilityService;
        this.profileService = profileService;
        this.store = store;
        this.authService = authService;
        this.idleInterruptContext = idleInterruptContext;
        this.DEFAULT_START_TIME = '00:00';
        this.elapsedTimeText$ = new BehaviorSubject(this.DEFAULT_START_TIME);
        this.hasSkippedTheCall$ = new BehaviorSubject(false);
        this.deviceRegistering$ = new BehaviorSubject(null);
        this.deviceRegistered$ = new BehaviorSubject(null);
        this.deviceError$ = new BehaviorSubject(null);
        this.deviceConnect$ = new BehaviorSubject(null);
        this.connectionDisconnect$ = new BehaviorSubject(null);
        this.connectionIncoming$ = new BehaviorSubject(null);
        this.connectionCancel$ = new BehaviorSubject(null);
        this.isShoppingCallRecording = false;
        this.navigationContextSubscription = new Subscription();
    }
    setupConnection(call) {
        call.on('accept', callState => {
            this.deviceConnect$.next(callState);
            this.isPreviousDeviceDestroyed = false;
            this.connectionDisconnect$.next(callState);
            this.startTime = new Date();
            this.endTime = null;
            this.elapsedTimeRef = setInterval(() => {
                const secondsDifference = DateUtilities.getSecondsDifference(this.startTime, new Date());
                this.elapsedTimeText$.next(DateUtilities.getElapsedTime(secondsDifference));
            }, 1000);
            this.setCallRecordingAvailable();
            this.refreshJWTIntervalID = window.setInterval(() => this.refreshSession(), REFRESH_JWT_DURING_TWILIO_CALL_INTERVAL_MS);
        });
        call.on('disconnect', callState => {
            this.stopAuthRefresh();
            this.setShoppingCallRecording(false);
            this.endTime = new Date();
            this.stopTimer();
            this.isPreviousDeviceDestroyed = false;
            const extendedConnection = callState;
            extendedConnection.hasCallManuallyEnded = this.hasCallManuallyEnded;
            this.connectionDisconnect$.next(extendedConnection);
            this.hasCallManuallyEnded = false;
            this.clearCallRecordingAvailable();
        });
        call.on('cancel', callState => {
            this.setShoppingCallRecording(false);
            this.connectionCancel$.next(callState);
        });
        this.connection = call;
    }
    closeConnection() {
        this.connection = null;
        // TODO: do we need to complete this.connection.on event emittiers?
    }
    setCallRecordingAvailable() {
        this.store.dispatch(new SetCallRecordingAvailable());
    }
    clearCallRecordingAvailable() {
        this.store.dispatch(new ClearCallRecordingAvailable());
    }
    ngOnDestroy() {
        this.navigationContextSubscription.unsubscribe();
        this.stopAuthRefresh();
    }
    isConnectionOpen() {
        return this.connection?.status() === Call.State.Open;
    }
    getOpenConnectionCallRecordingCode() {
        return this.isConnectionOpen() ? this.store.selectSnapshot(TwilioState.authCode) : null;
    }
    getElapsedTimeText$() {
        return this.elapsedTimeText$.asObservable();
    }
    getHasSkippedTheCall$() {
        return this.hasSkippedTheCall$.asObservable();
    }
    getDeviceRegistering$() {
        return this.deviceRegistering$.asObservable();
    }
    getDeviceRegistered$() {
        return this.deviceRegistered$.asObservable();
    }
    getDeviceError$() {
        return this.deviceError$.asObservable();
    }
    getDeviceConnect$() {
        return this.deviceConnect$.asObservable();
    }
    getDeviceConnectStatus$() {
        return this.getDeviceConnect$().pipe(map(call => call?.status()));
    }
    getConnectionDisconnect$() {
        return this.connectionDisconnect$.asObservable();
    }
    getConnectionIncoming$() {
        return this.connectionIncoming$.asObservable();
    }
    getConnectionCancel$() {
        return this.connectionCancel$.asObservable();
    }
    async setupDevice(accessToken) {
        this.setModalOpen(true);
        // TODO: https://www.twilio.com/docs/voice/sdks/javascript/migrating-to-js-voice-sdk-20#make-sure-the-accesstoken-is-kept-up-to-date
        const twilioDevice = new Device(accessToken, {
            // Set Opus as our preferred codec. Opus generally performs better, requiring less bandwidth and
            // providing better audio quality in restrained network conditions. Opus will be default in 2.0.
            codecPreferences: [Call.Codec.Opus, Call.Codec.PCMU],
            // Use `enableRingingState` to enable the device to emit the `ringing`
            // state. The TwiML backend also needs to have the attribute
            // `answerOnBridge` also set to true in the `Dial` verb. This option
            // changes the behavior of the SDK to consider a call `ringing` starting
            // from the connection to the TwiML backend to when the recipient of
            // the `Dial` verb answers.
            logLevel: 1
        });
        this.twilioDevice = this.setEvents(twilioDevice);
        await this.twilioDevice.register();
        this.deviceRegistered$.next(this.twilioDevice);
        this.navigationContextSubscription = this.navigationContext.getUrl$().subscribe(url => {
            this.handleDeviceAvailability(url);
        });
    }
    destroyDevice() {
        this.isPreviousDeviceDestroyed = true;
        this.twilioDevice?.disconnectAll();
        this.closeConnection();
        // This also unregisters the twilio device so no need to manually call it
        this.twilioDevice?.destroy();
    }
    /**
     * Finishes a call in progress, if device is destroyed, no more incoming/outgoing calls are allowed
     * @param mustDestroyDevice - should destroy or not
     */
    hangup(mustDestroyDevice, hasCallManuallyEnded) {
        this.stopAuthRefresh();
        this.hasCallManuallyEnded = hasCallManuallyEnded;
        this.stopTimer();
        this.resetConnection();
        if (mustDestroyDevice) {
            this.destroyDevice();
        }
    }
    skipTheCall() {
        this.hasSkippedTheCall$.next(true);
    }
    markAsNotSkipped() {
        this.hasSkippedTheCall$.next(false);
    }
    resetConnection() {
        this.twilioDevice?.disconnectAll();
        this.endTime = new Date();
    }
    getCallDurationInSeconds() {
        return DateUtilities.getSecondsDifference(this.startTime, this.endTime);
    }
    async callPhone(phoneNumber) {
        // Discard previous connections if they exist and create a new one
        this.resetConnection();
        this.elapsedTimeText$.next(this.DEFAULT_START_TIME);
        const params = {
            params: { To: phoneNumber }
        };
        const call = await this.twilioDevice.connect(params);
        this.setupConnection(call);
        return call;
    }
    setModalOpen(isModalOpen) {
        this.isModalOpen = isModalOpen;
    }
    setShoppingCallRecording(isShoppingCallRecording) {
        this.isShoppingCallRecording = isShoppingCallRecording;
    }
    isShoppingCallRecordingInProgress() {
        return this.isShoppingCallRecording;
    }
    handleDeviceAvailability(url) {
        if (this.isShoppingCallRecording) {
            const hasMemberProfile = this.hasMemberProfile();
            if (!hasMemberProfile) {
                this.hangup(true);
            }
        }
        else {
            const isCallRecordingEnabledTag = this.navigationUtilityService.pageTagURLMatch(PageTags.ENROLLMENT, url) ||
                this.navigationUtilityService.pageTagURLMatch(PageTags.ENROLLMENT_CONFIRMATION, url) ||
                this.navigationUtilityService.pageTagURLMatch(PageTags.MEDIGAP_INTERIM, url);
            if (!isCallRecordingEnabledTag && !this.isModalOpen) {
                this.hangup(true);
            }
        }
    }
    setEvents(twilioDevice) {
        twilioDevice.on(Device.State.Registering, device => {
            this.deviceRegistering$.next(device);
        });
        twilioDevice.on(Device.State.Registered, device => {
            this.deviceRegistered$.next(device);
        });
        twilioDevice.on(Device.EventName.Error, error => {
            this.deviceError$.next(error);
            this.hangup(true);
            this.clearCallRecordingAvailable();
            // Error should be handled in the subscriber. Then we need to clear the error from deviceError$ behaviour subject.
            this.deviceError$.next(null);
        });
        /*this.twilioDevice.on(Device.EventName.Connect, connection => {
          this.connection = connection;
          this.deviceConnect$.next(connection);
          this.isPreviousDeviceDestroyed = false;
          this.connectionDisconnect$.next(connection);
          this.startTime = new Date();
          this.endTime = null;
          this.elapsedTimeRef = setInterval(() => {
            const secondsDifference = DateUtilities.getSecondsDifference(this.startTime, new Date());
            this.elapsedTimeText$.next(DateUtilities.getElapsedTime(secondsDifference));
          }, 1000);
          this.setCallRecordingAvailable();
        });*/
        /*this.twilioDevice.on(Device.EventName.Disconnect, (connection: Call) => {
          this.setShoppingCallRecording(false);
          this.connection = connection;
          this.endTime = new Date();
          this.stopTimer();
          this.isPreviousDeviceDestroyed = false;
          const extendedConnection: ExtendedConnection = this.connection;
          extendedConnection.hasCallManuallyEnded = this.hasCallManuallyEnded;
          this.connectionDisconnect$.next(extendedConnection);
          this.hasCallManuallyEnded = false;
          this.clearCallRecordingAvailable();
        });*/
        twilioDevice.on(Device.EventName.Incoming, connection => {
            this.setupConnection(connection);
            this.elapsedTimeText$.next(this.DEFAULT_START_TIME);
            this.connectionIncoming$.next(connection);
        });
        //twilioDevice.on(Device.EventName.TokenWillExpire, stuff => {
        // TODO: possible enhancement to auto refetch the twilio token
        //});
        // TODO: https://www.twilio.com/docs/voice/sdks/javascript/migrating-to-js-voice-sdk-20#cancel-event-no-longer-emitted-by-call-instance-in-response-to-a-local-callignore
        /*this.twilioDevice.on(Device.EventName.Cancel, connection => {
          this.setShoppingCallRecording(false);
          this.connection = connection;
          this.connectionCancel$.next(connection);
        });*/
        return twilioDevice;
    }
    stopTimer() {
        // Clear interval
        if (this.elapsedTimeRef) {
            clearInterval(this.elapsedTimeRef);
            this.elapsedTimeRef = null;
        }
    }
    stopAuthRefresh() {
        if (this.refreshJWTIntervalID) {
            window.clearInterval(this.refreshJWTIntervalID);
            this.refreshJWTIntervalID = null;
        }
    }
    refreshSession() {
        this.idleInterruptContext.interruptIdle();
        this.authService.refreshJWT();
    }
    hasMemberProfile() {
        return this.profileService.hasMemberProfile();
    }
}
TwilioDeviceService.ɵfac = function TwilioDeviceService_Factory(t) { return new (t || TwilioDeviceService)(i0.ɵɵinject(NavigationContext), i0.ɵɵinject(NavigationUtilityService), i0.ɵɵinject(ProfileService), i0.ɵɵinject(i1.Store), i0.ɵɵinject(AuthService), i0.ɵɵinject(IdleInterruptContext)); };
TwilioDeviceService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: TwilioDeviceService, factory: TwilioDeviceService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TwilioDeviceService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: NavigationContext }, { type: NavigationUtilityService }, { type: ProfileService }, { type: i1.Store }, { type: AuthService }, { type: IdleInterruptContext }]; }, null); })();

class EnrollmentHistoryService {
    constructor(store, configResourceService, siteService) {
        this.store = store;
        this.configResourceService = configResourceService;
        this.siteService = siteService;
    }
    isCompletedEnrollment(enrollment, includeSOA) {
        const isEnrollmentCompleted = !!enrollment.completedWhen;
        if (!includeSOA) {
            return isEnrollmentCompleted && !this.isSOAEnrollment(enrollment.coverageTypeEvent);
        }
        return isEnrollmentCompleted;
    }
    /**
     * @returns every enrollment passed in that is in a completed state.
     */
    getCompletedEnrollments(enrollments, includeSOA) {
        return enrollments?.filter(enrollment => this.isCompletedEnrollment(enrollment, includeSOA)) ?? [];
    }
    isPartialEnrollment(enrollment, includeSOA) {
        let partialEnrollments = !enrollment.completedWhen;
        if (!includeSOA) {
            partialEnrollments = partialEnrollments && !this.isSOAEnrollment(enrollment.coverageTypeEvent);
        }
        if (!this.siteService.isPPCSite()) {
            return partialEnrollments && !ANCILLARY_PLAN_TYPES.includes(enrollment.planTypeID);
        }
        return partialEnrollments;
    }
    /**
     * @returns every enrollment passed in that is in an uncompleted state.
     */
    getPartialEnrollments(enrollments, includeSOA) {
        return enrollments?.filter(enrollment => this.isPartialEnrollment(enrollment, includeSOA)) ?? [];
    }
    /**
     * @returns true if every enrollment passed in is completed, false otherwise.
     */
    areAllEnrollmentsComplete(enrollments) {
        return enrollments?.length ? enrollments.every(enrollment => !!enrollment.completedWhen) : false;
    }
    /**
     * @returns true if any of the enrollments passed in are completed, false otherwise.
     */
    areAnyEnrollmentsComplete(enrollments) {
        return enrollments?.length ? enrollments.some(enrollment => !!enrollment.completedWhen) : false;
    }
    /**
     * @fires enrollmentCompleteAction if member has completed enrollment(s) with provided planIds
     * @fires enrollmentNotCompleteAction if member has no enrollments with provided planIds or enrollments are not complete
     */
    async handleCompletedEnrollments(planIds, enrollmentCompleteAction, enrollmentNotCompleteAction) {
        const enrollments = this.getEnrollments(planIds);
        const allowEnrollingInSamePlan = this.configResourceService.getProcessedResourceValue('Spa_Enrollment_Allow_AlreadyEnrolled_Plans', null, false);
        if (allowEnrollingInSamePlan) {
            if (this.areAllEnrollmentsComplete(enrollments)) {
                await enrollmentCompleteAction();
            }
            else {
                await enrollmentNotCompleteAction();
            }
        }
        else {
            if (this.areAnyEnrollmentsComplete(enrollments)) {
                await enrollmentCompleteAction();
            }
            else {
                await enrollmentNotCompleteAction();
            }
        }
    }
    getEnrollments(planIds) {
        return this.store.selectSnapshot(MemberState.memberEnrollmentsByPlanIds(planIds));
    }
    getActiveEnrollmentKey() {
        return this.store.selectSnapshot(EnrollmentState.activeEnrollmentKey);
    }
    isSOAEnrollment(coverageTypeEvent) {
        return SOA_COVERAGE_TYPE_EVENTS.includes(coverageTypeEvent);
    }
}
EnrollmentHistoryService.ɵfac = function EnrollmentHistoryService_Factory(t) { return new (t || EnrollmentHistoryService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(SiteService)); };
EnrollmentHistoryService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: EnrollmentHistoryService, factory: EnrollmentHistoryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnrollmentHistoryService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }, { type: ConfigResourceService }, { type: SiteService }]; }, null); })();

class SOAService {
    constructor(soaHttpService, enrollmentHttpService, configResourceService, ssoHttpService, store, lockedSiteService, localeService, baseHref, planYearResourceService, memberSessionService, sessionHttpService) {
        this.soaHttpService = soaHttpService;
        this.enrollmentHttpService = enrollmentHttpService;
        this.configResourceService = configResourceService;
        this.ssoHttpService = ssoHttpService;
        this.store = store;
        this.lockedSiteService = lockedSiteService;
        this.localeService = localeService;
        this.baseHref = baseHref;
        this.planYearResourceService = planYearResourceService;
        this.memberSessionService = memberSessionService;
        this.sessionHttpService = sessionHttpService;
        this.isSiteLive = this.lockedSiteService.isSiteLive();
    }
    getDefaultBaseUrl() {
        return this.store.selectSnapshot(AppConfigState.defaultUrl);
    }
    getBaseHref() {
        return this.baseHref;
    }
    getPageNameByTag(tag) {
        const page = this.store.selectSnapshot(AppConfigState.hrefByTag(tag));
        return page || tag;
    }
    getSOATransactions$() {
        return this.store.select(SOAState.transactions);
    }
    getSOATransactions() {
        return this.store.selectSnapshot(SOAState.transactions);
    }
    getSOATransaction$(transactionId) {
        return this.store.select(SOAState.transactionById(transactionId));
    }
    getSOATransaction(transactionId) {
        return this.store.selectSnapshot(SOAState.transactionById(transactionId));
    }
    getSOATransactionAnswers$(transactionId) {
        return this.store.select(SOAState.transactionAnswers(transactionId));
    }
    getSOATransactionAnswers(transactionId) {
        return this.store.selectSnapshot(SOAState.transactionAnswers(transactionId));
    }
    getSOATransactionPrefillData$(transactionId) {
        return this.store.select(SOAState.nextGenTransactionPrefillData(transactionId));
    }
    getSOATransactionPrefillData(transactionId) {
        return this.store.selectSnapshot(SOAState.nextGenTransactionPrefillData(transactionId));
    }
    getSOAActivities$(soaPlanTypeUniqueName, soaBeneficiaryConfirmationCodeUniqueName, isAdmin = false) {
        return this.store.select(SOAState.soaActivities(soaPlanTypeUniqueName, soaBeneficiaryConfirmationCodeUniqueName, isAdmin));
    }
    getSOAActivities(soaPlanTypeUniqueName, soaBeneficiaryConfirmationCodeUniqueName, isAdmin = false) {
        return this.store.selectSnapshot(SOAState.soaActivities(soaPlanTypeUniqueName, soaBeneficiaryConfirmationCodeUniqueName, isAdmin));
    }
    getSOAActivity$(transactionId, soaPlanTypeUniqueName, soaBeneficiaryConfirmationCodeUniqueName, isAdmin = false) {
        return this.store.select(SOAState.soaActivity(transactionId, soaPlanTypeUniqueName, soaBeneficiaryConfirmationCodeUniqueName, isAdmin));
    }
    getSOAActivity(transactionId, soaPlanTypeUniqueName, soaBeneficiaryConfirmationCodeUniqueName, isAdmin = false) {
        return this.store.selectSnapshot(SOAState.soaActivity(transactionId, soaPlanTypeUniqueName, soaBeneficiaryConfirmationCodeUniqueName, isAdmin));
    }
    hasValidCompletedSOA() {
        return this.store.selectSnapshot(SOAState.hasValidCompletedSOA);
    }
    startSOATransaction$(config) {
        const { sessionId, soaFormId, agentGuid, clientName, isText = false, isSOAByAgent = false, isSOAByAgentPhone = false } = config;
        const planYear = this.planYearResourceService.getSelectedPlanYear();
        const enrollmentConfig = {
            soaAgentGuid: agentGuid,
            soA_CustomJson: JSON.stringify(this.getSOACustomInternal())
        };
        const isTestingSite = this.configResourceService.isTestingSite();
        const soaEnrollmentRequestBody = {
            isSiteLive: this.isSiteLive,
            isReviewSite: this.lockedSiteService.isReviewSite(window.location.hostname),
            clientName,
            isSOAEnrollment: true,
            config: enrollmentConfig,
            isText,
            isSOAByAgent,
            isSOAByAgentPhone,
            isTestingSite
        };
        return this.soaHttpService
            .startSOATransaction$(sessionId, soaFormId, soaEnrollmentRequestBody, planYear)
            .pipe(switchMap(hopeSOAEnrollmentResponse => this.mapToSOATransactionResponse$({ hopeSOAEnrollmentResponse })));
    }
    mapToSOATransactionResponse$(options) {
        const { hopeSOAEnrollmentResponse, nextGenSOAEnrollmentResponse } = options;
        const newEnrollmentTransactionGuid = nextGenSOAEnrollmentResponse?.transactionGUID ?? hopeSOAEnrollmentResponse?.soaTransaction?.transactionGUID;
        const soaTransactionId = nextGenSOAEnrollmentResponse?.transactionSID ?? hopeSOAEnrollmentResponse?.soaTransaction?.transactionSID;
        const authCode = nextGenSOAEnrollmentResponse?.authCode ?? hopeSOAEnrollmentResponse?.authCode;
        const soaQueryString = nextGenSOAEnrollmentResponse?.soaQueryString ?? hopeSOAEnrollmentResponse?.soaQueryString;
        const memberEnrollments = nextGenSOAEnrollmentResponse?.memberEnrollments ?? hopeSOAEnrollmentResponse?.memberEnrollments;
        const newEnrollment = memberEnrollments?.find(enrollment => enrollment.nativeTransactionID === newEnrollmentTransactionGuid);
        const memberSessionId = this.memberSessionService.getMemberSessionId();
        const currentMemberEnrollmentsInStore = this.memberSessionService.getMemberEnrollments();
        return this.store
            .dispatch([
            new UpdateMemberEnrollments([...currentMemberEnrollmentsInStore, newEnrollment]),
            new AddSOATransaction(memberSessionId, newEnrollment)
        ])
            .pipe(switchMap(() => this.ssoHttpService.encrypt$({
            queryString: soaQueryString,
            responseType: 'string'
        })), map(soaQueryStringEncrypted => {
            const soaTransactionResponse = {
                soaQueryString,
                soaQueryStringEncrypted,
                newEnrollmentTransactionGuid,
                soaTransactionId,
                authCode
            };
            return soaTransactionResponse;
        }));
    }
    fetchSOATransactions$() {
        const memberSessionId = this.memberSessionService.getMemberSessionId();
        const enrollments = this.memberSessionService.getMemberEnrollments();
        const soaEnrollments = enrollments.filter(enrollment => enrollment.isActive && SOA_COVERAGE_TYPE_EVENTS.includes(enrollment.coverageTypeEvent));
        return this.store.dispatch(new FetchSOATransactions(memberSessionId, soaEnrollments));
    }
    fetchFormVersionInfo$(formId) {
        return this.enrollmentHttpService.fetchFormVersionInfo$(formId);
    }
    startNextGenSOATransaction$(payload) {
        return this.enrollmentHttpService.startNextGenTransaction$(payload);
    }
    completeNextGenSOATransaction$(payload, transactionId) {
        return this.store.dispatch(new CompleteNextGenSOATransaction(payload, transactionId));
    }
    async uploadDocument(document, ownerId) {
        return await firstValueFrom(this.store.dispatch(new AddSOADocument(document, ownerId)), { defaultValue: null });
    }
    getDocumentList$(ownerId) {
        const documents = this.store.selectSnapshot(SOAState.documents);
        if (!documents.length) {
            this.store.dispatch(new FetchSOADocuments(ownerId));
        }
        return this.store.select(SOAState.documents);
    }
    async downloadDocument(documentId, ownerId) {
        return await this.soaHttpService.downloadDocument(documentId, ownerId);
    }
    async generateBase64PDF(transactionId, locale) {
        const base64PDFLocale = locale || this.localeService.getCurrentLocale();
        return await firstValueFrom(this.enrollmentHttpService.generatePDF$(transactionId, this.planYearResourceService.getSelectedPlanYear(), base64PDFLocale), { defaultValue: null });
    }
    async generateNextGenBase64PDF(transactionId, locale) {
        const base64PDFLocale = locale || this.localeService.getCurrentLocale();
        const sessionId = this.store.selectSnapshot(MemberState.session).sessionId;
        const hidePdfAgentData = this.store.selectSnapshot(UiState.hidePdfAgentData);
        return await firstValueFrom(this.sessionHttpService.getGeneratedNextGenEnrollmentApplicationPDF$(sessionId, transactionId, base64PDFLocale, hidePdfAgentData), { defaultValue: null });
    }
    isSOATextEnabled(widgetName) {
        const siteType = this.configResourceService.getProcessedResourceValue('Spa_Site_SiteType', widgetName, 'consumer');
        const soaTextEnabled = this.configResourceService.getProcessedResourceValue('Spa_SOA_Text_Enabled', widgetName, 'true');
        return soaTextEnabled && (siteType === SiteType.BROKER || siteType === SiteType.CALL_CENTER);
    }
    hasValidCompletedScopeOfAppointment(transactions) {
        let hasValidCompletedSOA = false;
        const soaValidDays = this.getSOAExpirationDays();
        const completedSOA = transactions?.find(transaction => transaction.confirmationNumber);
        if (completedSOA) {
            const dayCountDifference = DateUtilities.getDaysDifference(DateUtilities.getFormattedDate(new Date(completedSOA.modifiedWhen ?? completedSOA.createdWhen), DateUtilities.defaultDateISOFormat), DateUtilities.getFormattedCurrentDate(DateUtilities.defaultDateISOFormat));
            hasValidCompletedSOA = dayCountDifference <= soaValidDays;
        }
        return hasValidCompletedSOA;
    }
    checkForValidCompletedSOAsAndUpdate() {
        const soaTransactions = this.getSOATransactions() ?? [];
        const hasValidCompletedSOA = this.hasValidCompletedScopeOfAppointment(soaTransactions);
        this.store.dispatch(new SetHasValidCompletedSOA(hasValidCompletedSOA));
    }
    async createSOASession(authInfo, agentGuid, isSecurityDOBEnabled, dateOfBirth) {
        return await this.memberSessionService.createSOASession(authInfo, agentGuid, isSecurityDOBEnabled, dateOfBirth);
    }
    getSOAExpirationDays(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_CheckSOACompleted_ValidDays', widgetName, 60);
    }
    getSOACustomInternal() {
        const customInternalWrapper = new CustomInternalWrapper();
        const soaCustomInternalJson = this.configResourceService.getProcessedResourceValue('Spa_SOA_CustomInternalJson');
        if (soaCustomInternalJson) {
            customInternalWrapper.CustomInternal = soaCustomInternalJson;
        }
        return customInternalWrapper;
    }
}
SOAService.ɵfac = function SOAService_Factory(t) { return new (t || SOAService)(i0.ɵɵinject(SOAHttpService), i0.ɵɵinject(EnrollmentHttpService), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(SSOHttpService), i0.ɵɵinject(i1.Store), i0.ɵɵinject(LockedSiteService), i0.ɵɵinject(LocaleService), i0.ɵɵinject(APP_BASE_HREF), i0.ɵɵinject(PlanYearResourceService), i0.ɵɵinject(MemberSessionService), i0.ɵɵinject(MemberSessionHttpService)); };
SOAService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SOAService, factory: SOAService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SOAService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: SOAHttpService }, { type: EnrollmentHttpService }, { type: ConfigResourceService }, { type: SSOHttpService }, { type: i1.Store }, { type: LockedSiteService }, { type: LocaleService }, { type: undefined, decorators: [{
                type: Inject,
                args: [APP_BASE_HREF]
            }] }, { type: PlanYearResourceService }, { type: MemberSessionService }, { type: MemberSessionHttpService }]; }, null); })();

var PageLevelValidatorType;
(function (PageLevelValidatorType) {
    PageLevelValidatorType["EligibilityCheck"] = "eligibilitycheckvalidator";
    PageLevelValidatorType["StateAndZip"] = "stateandzipvalidator";
    PageLevelValidatorType["Group"] = "groupvalidator";
})(PageLevelValidatorType || (PageLevelValidatorType = {}));
var ValidationType;
(function (ValidationType) {
    ValidationType["StateZipValidation"] = "StateZipValidation";
})(ValidationType || (ValidationType = {}));
class AbstractPageLevelValidator {
    constructor(pageLevelSurveyValidator, config) {
        const { asyncValidation, dispatchEvent } = config;
        this.type = pageLevelSurveyValidator.getType();
        this.errorMessage = pageLevelSurveyValidator.errorMessage;
        this.asyncValidation = asyncValidation;
        if (dispatchEvent) {
            this.dispatchEvent = dispatchEvent;
        }
    }
    getType() {
        return this.type;
    }
    getErrorMessage() {
        return this.errorMessage;
    }
}

const MBI_FIELD_NAME = 'ApplicantHICN';
var MemberEligibilitySource;
(function (MemberEligibilitySource) {
    MemberEligibilitySource["Profile"] = "Profile";
    MemberEligibilitySource["Enrollment"] = "Enrollment";
})(MemberEligibilitySource || (MemberEligibilitySource = {}));
const EligibilityCheckDateFieldNamesMap = {
    ApplicantBirthDate: 'dob',
    PartAEffectiveDate: 'partAEffectiveDate',
    PartBEffectiveDate: 'partBEffectiveDate'
};
const EligibilityCheckAdditionalFieldNamesMap = {
    PlanID: 'PlanID',
    AgentID: 'AgentID'
};
const EligibilityCheckFieldNamesMap = {
    ...EligibilityCheckDateFieldNamesMap,
    ...EligibilityCheckAdditionalFieldNamesMap,
    ApplicantFirstName: 'firstName',
    ApplicantLastName: 'lastName',
    ApplicantHICN: 'mbi',
    InternalMemberID: 'memberId'
};
var EligibilityCheckValidation;
(function (EligibilityCheckValidation) {
    EligibilityCheckValidation["Hard"] = "hard";
    EligibilityCheckValidation["Soft"] = "soft";
})(EligibilityCheckValidation || (EligibilityCheckValidation = {}));
class EligibilityCheckValidator extends AbstractPageLevelValidator {
    constructor(surveyValidator, config) {
        super(surveyValidator, config);
        const { integrationID, authenticationID, validation, includeDSNPCheck } = surveyValidator;
        this.integrationID = integrationID;
        this.authenticationID = authenticationID;
        this.validation = validation;
        this.includeDSNPCheck = includeDSNPCheck ?? false;
    }
    getValidationSeverity() {
        return this.validation;
    }
    async validate(memberEligibilityInfo, isDSNPPlan = false) {
        if (this.integrationID && this.authenticationID) {
            const payload = {
                ...memberEligibilityInfo,
                integrationID: this.integrationID,
                authenticationID: this.authenticationID,
                source: MemberEligibilitySource.Enrollment,
                includeDSNPCheck: this.includeDSNPCheck
            };
            let validationResult;
            try {
                const response = await this.asyncValidation(payload);
                const isHardValidation = this.validation === EligibilityCheckValidation.Hard;
                // If DSNP check is not included or the plan isn't DSNP, we can skip DSNP check.
                // Otherwise, member should be Medicare Eligible and DSNP Eligible when plan is DSNP and DSNP check is included
                const isDSNPCheckValid = !this.includeDSNPCheck || !isDSNPPlan || !!response?.isDSNPEligible;
                // If no errors and member isn't Medicare Eligible, that means the information that was provided does not match external system
                // and we should display clientMessage to the user
                const isValid = !response?.isError && !!response?.isMedicareEligible && isDSNPCheckValid;
                validationResult = {
                    isValid,
                    type: this.type,
                    severity: response?.isError || isHardValidation ? NOTICE_TYPE.ERROR : NOTICE_TYPE.WARN,
                    ...(!isHardValidation && { continueText: this.errorMessage }),
                    ...(response?.clientMessage && { errorMessage: response.clientMessage })
                };
                if (!validationResult.isValid && validationResult.errorMessage) {
                    this.dispatchEvent?.({
                        name: MBI_FIELD_NAME,
                        errorMessage: validationResult.errorMessage
                    });
                }
            }
            catch (errorResponse) {
                validationResult = {
                    isValid: false,
                    type: this.type,
                    severity: NOTICE_TYPE.ERROR,
                    ...(errorResponse?.error?.message && { errorMessage: errorResponse.error.message })
                };
            }
            return validationResult;
        }
        // Skips validation
        return { isValid: true, type: this.type };
    }
}

var GroupValidationSeverity;
(function (GroupValidationSeverity) {
    GroupValidationSeverity["Hard"] = "hard";
    GroupValidationSeverity["Soft"] = "soft";
})(GroupValidationSeverity || (GroupValidationSeverity = {}));
class GroupValidator extends AbstractPageLevelValidator {
    constructor(surveyValidator, config) {
        super(surveyValidator, config);
        const { validationSeverity, errorLocation, condition } = surveyValidator;
        this.validationSeverity = validationSeverity;
        this.errorLocation = errorLocation;
        this.condition = condition;
    }
    getValidationSeverity() {
        return this.validationSeverity;
    }
    async validate() {
        if (this.validationSeverity && this.errorLocation && this.condition) {
            let validationResult;
            try {
                const isValid = await this.asyncValidation(this.condition, this.getErrorMessage());
                const isHardValidation = this.validationSeverity === GroupValidationSeverity.Hard;
                validationResult = {
                    isValid,
                    type: this.type,
                    ...(!isValid && { severity: isHardValidation ? NOTICE_TYPE.ERROR : NOTICE_TYPE.WARN }),
                    ...(!isHardValidation && { continueText: this.errorMessage }),
                    ...(isHardValidation && { errorMessage: this.errorMessage })
                };
                if (!validationResult.isValid) {
                    this.dispatchEvent?.({
                        name: this.errorLocation,
                        errorMessage: validationResult.errorMessage || validationResult.continueText
                    });
                }
            }
            catch (errorResponse) {
                console.error(errorResponse);
                validationResult = {
                    isValid: false,
                    type: this.type,
                    severity: NOTICE_TYPE.ERROR,
                    errorMessage: this.errorMessage
                };
            }
            return validationResult;
        }
        //  Skips validation
        return { isValid: true, type: this.type };
    }
}

class StateAndZipValidator extends AbstractPageLevelValidator {
    constructor(surveyValidator, config) {
        super(surveyValidator, config);
        const { stateField, zipCodeField } = surveyValidator;
        this.stateField = stateField;
        this.zipCodeField = zipCodeField;
    }
    static getSelectedFormAnswers(formAnswers, selectedFieldNames) {
        const formAnswersMap = formAnswers?.reduce((formAnswersAccumulator, answer) => {
            formAnswersAccumulator[answer.name] = answer;
            return formAnswersAccumulator;
        }, {}) ?? {};
        return (selectedFieldNames?.reduce((formAnswersAccumulator, fieldName) => {
            const selectedAnswer = formAnswersMap[fieldName];
            if (selectedAnswer?.value) {
                formAnswersAccumulator.push(selectedAnswer.value);
            }
            return formAnswersAccumulator;
        }, []) ?? []);
    }
    async validate(formAnswers) {
        if (this.stateField && this.zipCodeField && formAnswers?.length) {
            const selectedQuestions = [this.stateField, this.zipCodeField];
            const selectedAnswers = StateAndZipValidator.getSelectedFormAnswers(formAnswers, selectedQuestions);
            // Questions could be optional so we only want to run the validation when both answers have been provided
            if (selectedAnswers?.length === selectedQuestions.length) {
                const payload = {
                    args: selectedAnswers,
                    validateEmpty: 'false'
                };
                let validationResult;
                try {
                    const isValid = await this.asyncValidation(payload, ValidationType.StateZipValidation);
                    validationResult = {
                        isValid,
                        type: this.type,
                        ...(!isValid && { severity: NOTICE_TYPE.ERROR, errorMessage: this.errorMessage })
                    };
                }
                catch (errorResponse) {
                    if (errorResponse?.status === 400) {
                        validationResult = {
                            isValid: false,
                            type: this.type,
                            severity: NOTICE_TYPE.ERROR,
                            errorMessage: this.errorMessage
                        };
                    }
                }
                if (!validationResult.isValid && validationResult.errorMessage) {
                    this.dispatchEvent?.({
                        name: this.stateField,
                        errorMessage: validationResult.errorMessage
                    });
                }
                return validationResult;
            }
        }
        // Skips validation
        return { isValid: true, type: this.type };
    }
}
__decorate([
    Memoize()
], StateAndZipValidator, "getSelectedFormAnswers", null);

class FormPagesMetadataContext {
    constructor() {
        this._formPagesMetadata$ = new BehaviorSubject(null);
        this._formNavigationInitialized$ = new BehaviorSubject(false);
    }
    clearFormPagesMetadata() {
        this._formPagesMetadata$.next(null);
    }
    setFormPagesMetadata(formInfo, validationConfigurations) {
        const formPagesMetadata = this.mapToFormPageMetadata(formInfo, validationConfigurations);
        this._formPagesMetadata$.next(formPagesMetadata);
    }
    getFormPagesMetadata$() {
        return this._formPagesMetadata$.asObservable();
    }
    setFormNavigationInitialized(initialized) {
        this._formNavigationInitialized$.next(initialized);
    }
    getFormNavigationInitialized$() {
        return this._formNavigationInitialized$.asObservable();
    }
    mapToFormPageMetadata(formInfo, validationConfigurations) {
        const formInfoPages = formInfo.pages;
        return {
            pages: formInfoPages.map(page => ({
                index: page.pageIndex,
                pageName: page.pageName,
                visited: page.visited,
                completed: page.completed,
                skipped: page.skipped,
                friendlyName: page.friendlyName,
                active: page.active,
                status: this.getCompletionStatus(page.completed, page.active, page.skipped),
                validators: this.transformSurveyValidatorsToPageLevelValidators(page.validators, validationConfigurations)
            }))
        };
    }
    getCompletionStatus(isComplete, isActive, isSkipped) {
        if (isActive) {
            return 'active';
        }
        if (isComplete) {
            return 'complete';
        }
        if (isSkipped) {
            return 'skipped';
        }
        return '';
    }
    transformSurveyValidatorsToPageLevelValidators(surveyValidators, validationConfigurations) {
        if (surveyValidators?.length && validationConfigurations) {
            return surveyValidators.reduce((transformedValidators, surveyValidator) => {
                if (surveyValidator.getType() === PageLevelValidatorType.EligibilityCheck) {
                    transformedValidators.push(this.transformSurveyValidatorToEligibilityCheckValidator(surveyValidator, validationConfigurations[PageLevelValidatorType.EligibilityCheck]));
                }
                else if (surveyValidator.getType() === PageLevelValidatorType.StateAndZip) {
                    transformedValidators.push(this.transformSurveyValidatorToStateAndZipValidator(surveyValidator, validationConfigurations[PageLevelValidatorType.StateAndZip]));
                }
                else if (surveyValidator.getType() === PageLevelValidatorType.Group) {
                    transformedValidators.push(this.transformSurveyValidatorToGroupValidator(surveyValidator, validationConfigurations[PageLevelValidatorType.Group]));
                }
                return transformedValidators;
            }, []);
        }
        return [];
    }
    transformSurveyValidatorToEligibilityCheckValidator(surveyValidator, validationConfiguration) {
        return new EligibilityCheckValidator(surveyValidator, validationConfiguration);
    }
    transformSurveyValidatorToStateAndZipValidator(surveyValidator, validationConfiguration) {
        return new StateAndZipValidator(surveyValidator, validationConfiguration);
    }
    transformSurveyValidatorToGroupValidator(surveyValidator, validationConfiguration) {
        return new GroupValidator(surveyValidator, validationConfiguration);
    }
}
FormPagesMetadataContext.ɵfac = function FormPagesMetadataContext_Factory(t) { return new (t || FormPagesMetadataContext)(); };
FormPagesMetadataContext.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FormPagesMetadataContext, factory: FormPagesMetadataContext.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormPagesMetadataContext, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

const CUSTOM_INTERNAL_RESOURCE_KEY = 'Spa_CustomInternal_Json';
const CUSTOM_INTERNAL_HRA_RESOURCE_KEY = 'Spa_HRAForm_CustomInternal_Json';
const USER_TYPE_RESOURCE_KEY = 'UserType';
const PLAN_NETWORK_SHOW_UAT_RESOURCE_KEY = 'PlanNetwork_ShowUAT';
const VNEXT_CUSTOM_INTERNAL = 'vnext-custom-internal';
class EnrollmentFormService {
    constructor(configResourceService, router, store, memberSessionService, navigationUtilityService, navigationContext, emailService, shoppingCartService, agentService, imageService, plansService, navigationService, ridersService, siteService, enrollmentPostBackService, medSupService, quoteService, passParamService, ipUtilityService, lockedSiteService, messagesService, preferencesService, ssoPopulatedFieldService, enrollmentTransactionErrorsContext, medSupMillimanCryptoService, twilioService, localeService, drugsService, phoneService, enrollmentHistoryService, profileCryptoService, planYearResourceService, soaService, deepLinkingService, providerService, enrollmentHttpService, profileService, enrollmentFunctionService, utilityFunctionService, spinnerService, formPagesMetadataContext, route, demographicService, externalErrorLoggingService, weglotService) {
        this.configResourceService = configResourceService;
        this.router = router;
        this.store = store;
        this.memberSessionService = memberSessionService;
        this.navigationUtilityService = navigationUtilityService;
        this.navigationContext = navigationContext;
        this.emailService = emailService;
        this.shoppingCartService = shoppingCartService;
        this.agentService = agentService;
        this.imageService = imageService;
        this.plansService = plansService;
        this.navigationService = navigationService;
        this.ridersService = ridersService;
        this.siteService = siteService;
        this.enrollmentPostBackService = enrollmentPostBackService;
        this.medSupService = medSupService;
        this.quoteService = quoteService;
        this.passParamService = passParamService;
        this.ipUtilityService = ipUtilityService;
        this.lockedSiteService = lockedSiteService;
        this.messagesService = messagesService;
        this.preferencesService = preferencesService;
        this.ssoPopulatedFieldService = ssoPopulatedFieldService;
        this.enrollmentTransactionErrorsContext = enrollmentTransactionErrorsContext;
        this.medSupMillimanCryptoService = medSupMillimanCryptoService;
        this.twilioService = twilioService;
        this.localeService = localeService;
        this.drugsService = drugsService;
        this.phoneService = phoneService;
        this.enrollmentHistoryService = enrollmentHistoryService;
        this.profileCryptoService = profileCryptoService;
        this.planYearResourceService = planYearResourceService;
        this.soaService = soaService;
        this.deepLinkingService = deepLinkingService;
        this.providerService = providerService;
        this.enrollmentHttpService = enrollmentHttpService;
        this.profileService = profileService;
        this.enrollmentFunctionService = enrollmentFunctionService;
        this.utilityFunctionService = utilityFunctionService;
        this.spinnerService = spinnerService;
        this.formPagesMetadataContext = formPagesMetadataContext;
        this.route = route;
        this.demographicService = demographicService;
        this.externalErrorLoggingService = externalErrorLoggingService;
        this.weglotService = weglotService;
        this.enrollmentNavigationEvent$ = new BehaviorSubject(null);
        this._enrollmentFormError = null;
        this.postEnrollmentResponse$ = new BehaviorSubject(null);
        this.consumerAccessEmailUrlParameters$ = new BehaviorSubject(null);
        this.formTitle$ = new BehaviorSubject(null);
        this.planPostEnrollmentTextEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_PlanPostEnrollmentText_Enabled', null, true);
    }
    hasFormVersionIdChanged$() {
        return this.store.select(EnrollmentState.hasFormVersionIdChanged);
    }
    async setCurrentFormVersionId(formVersionId) {
        return await firstValueFrom(this.store.dispatch(new SetCurrentFormVersionId(formVersionId)));
    }
    async setPreviousFormVersionId(formVersionId) {
        return await firstValueFrom(this.store.dispatch(new SetPreviousFormVersionId(formVersionId)));
    }
    getCurrentFormVersionId$() {
        return this.store.select(EnrollmentState.currentFormVersionId);
    }
    getPreviousFormVersionId$() {
        return this.store.select(EnrollmentState.previousFormVersionId);
    }
    getCurrentFormVersionId() {
        return this.store.selectSnapshot(EnrollmentState.currentFormVersionId);
    }
    getPreviousFormVersionId() {
        return this.store.selectSnapshot(EnrollmentState.previousFormVersionId);
    }
    fetchFormVersionInfo$(formId) {
        return this.enrollmentHttpService.fetchFormVersionInfo$(formId);
    }
    getIsMemberLoggedIn$() {
        return this.memberSessionService.getIsMemberLoggedIn$();
    }
    getEnrollmentHistorySelectedPlanId() {
        return this.store.selectSnapshot(EnrollmentState.enrollmentHistorySelectedPlan)?.id;
    }
    getTransactionGuid(enrollingPlanId = this.getActiveEnrollmentKey()) {
        return this.store.selectSnapshot(EnrollmentState.transactionGUID(enrollingPlanId));
    }
    getTransactionGuid$(enrollingPlanId = this.getActiveEnrollmentKey()) {
        return this.store.select(EnrollmentState.transactionGUID(enrollingPlanId));
    }
    setEnrollmentHistorySelectedPlan(enrollmentHistorySelectedPlan) {
        this.store.dispatch(new SetEnrollmentHistorySelectedPlan(enrollmentHistorySelectedPlan));
    }
    clearEnrollmentHistorySelectedPlan() {
        this.store.dispatch(new ClearEnrollmentHistorySelectedPlan());
    }
    observeForNavigationEvent$() {
        return this.enrollmentNavigationEvent$.asObservable();
    }
    navigateTo(pageName) {
        this.enrollmentNavigationEvent$.next(pageName);
    }
    formTitleObservable$() {
        return this.formTitle$.asObservable();
    }
    setFormTitle(formTitle) {
        this.formTitle$.next(formTitle);
    }
    getFormattedEmailHeader(widgetName) {
        return this.emailService.getFormattedEmailHeader(widgetName);
    }
    isPPCEnrollmentSite(enrollmentUserType) {
        return (enrollmentUserType &&
            (enrollmentUserType.toLowerCase() === UserTypes.BROKER || enrollmentUserType.toLowerCase() === UserTypes.CALLCENTER));
    }
    async getProcessedEmail(emailFileName, to, subject, inputs) {
        return await firstValueFrom(this.emailService.getProcessedEmail$(emailFileName, to, subject, inputs));
    }
    getAgentData() {
        return this.agentService.getAgentData();
    }
    getCreditedAgentEmailFooterData(agentData) {
        return this.agentService.getCreditedAgentEmailFooterData(agentData);
    }
    async getAgentEmailFooterData() {
        return await this.agentService.getAgentEmailFooterData();
    }
    async getShortUrl(url, clientName) {
        if (url) {
            return await this.messagesService.getShortUrl(url, clientName);
        }
        return '';
    }
    // TODO: refactor to accommodate that IF necessary
    async getNextGenFormTransaction$(planId, 
    // TODO: marked for removal but leaving for diagnostic purposes for SPA-10987
    fetchTransactionFromGuid = false, transactionGuid = '') {
        const createdIPAddress = await this.ipUtilityService.getClientIP();
        const isBLAMSite = this.configResourceService.getProcessedResourceValue('Spa_Site_Is_BLAM', null, false);
        const partnerId = this.configResourceService.getProcessedResourceValue('PartnerID');
        const sourceId = this.configResourceService.getProcessedResourceValue('SourceID');
        const destinationAppId = this.configResourceService.getProcessedResourceValue('AppID');
        const isTestingSite = this.configResourceService.getProcessedResourceValue('Spa_Site_IsTestSite', null, false);
        const allowSamePlanEnrollment = this.configResourceService.getProcessedResourceValue('Spa_Enrollment_Allow_AlreadyEnrolled_Plans', null, false);
        const selectedFormType = this.getSelectedFormType(planId);
        const userFormType = this.getUserFormType(planId);
        const planEnrollmentSettings = this.getPlanEnrollmentSettingsByType(planId, selectedFormType, userFormType);
        // We are disabling these because the backend wants these in this format
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const Spa_SendEnrollment_Retain_Form_Answers = this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_Retain_Form_Answers', null, false);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const Spa_Enrollment_ExpiringPartialMedicareEnrollments_Enabled = this.configResourceService.getProcessedResourceValue('Spa_Enrollment_ExpiringPartialMedicareEnrollments_Enabled', null, false);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const Spa_Site_SiteType = this.configResourceService.getProcessedResourceValue('Spa_Site_SiteType');
        const userType = this.configResourceService.getProcessedResourceValue('UserType', null, '');
        // plan may be null at this point in PC API flow... this is because selectedPlans is used but not set in that flow
        // while the shoppingCart is set... We call selectAndReturnEnrollingPlanPlusRiders later in the flow to get
        // shoppingCart plan details to set into selectedPlans
        let plan = this.shoppingCartService.getPlan(planId);
        const selectedRiders = this.shoppingCartService.getSelectedPlanRiders(planId);
        const riderData = this.getRiderData(selectedRiders);
        const memberSession = this.memberSessionService.getMemberSession();
        const apiProfileStateModel = { ...memberSession.profile };
        const updatedProfileModel = this.profileService.prepareProfileStateForAPI(apiProfileStateModel);
        await this.demographicService.conditionallyFetchCounties(memberSession.demographic.zip, memberSession.demographic.fips);
        const countyName = this.demographicService.getSelectedCounty()?.countyName ?? '';
        const apiMemberStateModel = {
            sessionId: memberSession.sessionId,
            ssoValue: memberSession.ssoValue,
            memberId: memberSession ? memberSession.memberID : '',
            profile: { authRepData: {}, ...updatedProfileModel },
            // getting countyName from counties plus selectedFips
            // this assumes counties is loaded and if its not we will not find a countyName
            demographic: { ...memberSession.demographic, countyName },
            enrollments: memberSession.enrollments
        };
        const providerPCPFormInfo = this.providerService.getSelectedPrimaryCareProvider();
        const deepLinkingParams = this.getNextGenDeepLinkingParams();
        const agent = this.getAgentRequestData();
        const quoteId = this.quoteService.getBeneficiaryQuoteId();
        const quoteType = this.quoteService.getQuoteInfo()?.quoteType;
        const sourceSiteId = this.quoteService.getSourceSiteId();
        const isSiteLive = this.lockedSiteService.isSiteLive();
        const isReviewSite = this.lockedSiteService.isReviewSite(window.location.hostname);
        const canFetchFromTransactionGuid = fetchTransactionFromGuid && transactionGuid;
        const enrollmentUserType = this.getSiteUserType(planId);
        const callRecordingAvailable = this.twilioService.isConnectionOpen();
        const medigapAnswers = this.memberSessionService.getMemberMedigapAnswers();
        const humanaCustomClientPartnerId = this.configResourceService.getProcessedResourceValue('HumanaCustomClientPartnerId');
        const humanaCustomClientPartnerName = this.configResourceService.getProcessedResourceValue('HumanaCustomClientPartnerName');
        const humanaCustomClientPartnerIdentifier = this.configResourceService.getProcessedResourceValue('HumanaCustomClientPartnerIdentifier');
        if (isBLAMSite || canFetchFromTransactionGuid) {
            // reassigning this in case we need to re-fetch it here. this shouldn't happen but something
            // is being dropped in SPA-10987 and we need to re-get this if it's missing
            let populatedTransactionGuid = transactionGuid;
            if (!canFetchFromTransactionGuid) {
                // TODO: marked for removal but added for SPA-10987 and cannot be removed until we have figured out
                // the information needed to diagnose the root cause of this issue
                console.error(`BLAM site lost tid. fetchTransactionFromGuid: ${fetchTransactionFromGuid} tid: ${transactionGuid}`);
                if (!transactionGuid) {
                    populatedTransactionGuid = this.getTransactionGuidFromPartialEnrollment(planId);
                }
            }
            await Promise.all([
                firstValueFrom(this.fetchNextGenTransaction$(memberSession.sessionId, planId, populatedTransactionGuid)),
                this.selectAndReturnEnrollingPlanPlusRiders(planId)
            ]);
            // selectAndReturnEnrollingPlanPlusRiders sets the plan to selectedPlans so we want to call getPlan again
            // here to re-get the selectedPlan which was previously not set
            plan = this.shoppingCartService.getPlan(planId);
            const displaySEPReasons = this.getDisplaySEPReasons(plan);
            if (displaySEPReasons) {
                const { carrierId, planYear, planType } = plan;
                const currentLocale = this.localeService.getCurrentLocale();
                this.fetchNextGenSepReasons$(planId, carrierId, planYear, currentLocale, planType, displaySEPReasons);
            }
            await this.setCurrentFormVersionId(planEnrollmentSettings.formVersionId);
            return await Promise.resolve(this.getNextGenTransaction(planId));
        }
        const calculatedPremium = `${this.plansService.getTotalPremium([plan], selectedRiders)}`;
        if (!MEDICARE_PLAN_TYPES.includes(plan.planTypeAbbreviation)) {
            plan = { ...plan, calculatedPremium };
        }
        // this is from bean provider settings but we need this from plan settings so we will get it from there eventually
        try {
            const medicareGroupPlanConfiguration = this.plansService.getMedicareGroupPlanConfiguration();
            const isPurl = this.agentService.isPurl();
            await this.createNextGenFormTransaction$({
                plan,
                medicareGroupID: medicareGroupPlanConfiguration?.medicareGroupId ?? null,
                medicareGroupName: medicareGroupPlanConfiguration?.medicareGroupName ?? null,
                riderData,
                ...(agent && { agent }),
                coverageEventType: CoverageEventType.FullEnrollment,
                ...(quoteId && { quoteId }),
                enrollmentSettings: {
                    formId: planEnrollmentSettings.formId,
                    formVersion: planEnrollmentSettings.formVersion,
                    formVersionId: planEnrollmentSettings.formVersionId,
                    foamFormType: planEnrollmentSettings.foamFormType,
                    sourceId: planEnrollmentSettings.sourceId,
                    enrollMessage: planEnrollmentSettings.enrollMessage,
                    agentId: planEnrollmentSettings.agentId,
                    agentFirstName: planEnrollmentSettings.agentFirstName,
                    agentLastName: planEnrollmentSettings.agentLastName,
                    agencyId: planEnrollmentSettings.agencyId,
                    agencyName: planEnrollmentSettings.agencyName,
                    customDefaultValue1: planEnrollmentSettings.customDefaultValue1,
                    customDefaultValue2: planEnrollmentSettings.customDefaultValue2,
                    customDefaultValue3: planEnrollmentSettings.customDefaultValue3,
                    customDefaultValue4: planEnrollmentSettings.customDefaultValue4,
                    customDefaultValue5: planEnrollmentSettings.customDefaultValue5,
                    fieldOverrides: planEnrollmentSettings.fieldOverrides,
                    queryId: planEnrollmentSettings.queryId
                },
                enrollmentUserType,
                ...(sourceSiteId && { sourceSiteId }),
                session: { ...apiMemberStateModel, ...(quoteId && { quoteType }), ...(medigapAnswers && { medigapAnswers }) },
                providerPCPFormInfo,
                allowSamePlanEnrollment,
                site: {
                    isSiteLive,
                    isReviewSite,
                    createdIPAddress,
                    partnerId,
                    destinationAppId,
                    isTestingSite
                },
                configurations: {
                    sourceId,
                    Spa_SendEnrollment_Retain_Form_Answers,
                    Spa_Site_SiteType,
                    userType,
                    humanaCustomClientPartnerId,
                    humanaCustomClientPartnerName,
                    humanaCustomClientPartnerIdentifier,
                    Spa_Enrollment_ExpiringPartialMedicareEnrollments_Enabled
                },
                isPurl,
                currentDate: this.utilityFunctionService.getCurrentDate(DateUtilities.defaultFormat),
                hasValidCompletedSOA: this.soaService.hasValidCompletedSOA(),
                medigapAnswers: this.getNextGenRequestMedigapAnswers(),
                ...(Object.keys(deepLinkingParams).length && { deepLinkingParams }),
                isMedigap: plan.planTypeAbbreviation === PlanTypeAbbreviation.MEDIGAP,
                isSignAndSubmit: this.isNextGenFormSignAndSubmitOnly(planId)
            }, callRecordingAvailable);
        }
        catch (error) {
            return await Promise.reject(error);
        }
        const displaySEPReasons = this.getDisplaySEPReasons(plan);
        if (displaySEPReasons) {
            const { carrierId, planYear, planType } = plan;
            const currentLocale = this.localeService.getCurrentLocale();
            this.fetchNextGenSepReasons$(planId, carrierId, planYear, currentLocale, planType, displaySEPReasons);
        }
        await this.setCurrentFormVersionId(planEnrollmentSettings.formVersionId);
        return await Promise.resolve(this.getNextGenTransaction(planId));
    }
    async getNextGenHRAFormTransaction$(hraFormId, originalEnrollmentTransactionId = '', hraParentPlanId = '') {
        const createdIPAddress = await this.ipUtilityService.getClientIP();
        const isBLAMSite = this.configResourceService.getProcessedResourceValue('Spa_Site_Is_BLAM', null, false);
        const partnerId = this.configResourceService.getProcessedResourceValue('PartnerID');
        const sourceId = this.configResourceService.getProcessedResourceValue('SourceID');
        const destinationAppId = this.configResourceService.getProcessedResourceValue('AppID');
        const isTestingSite = this.configResourceService.getProcessedResourceValue('Spa_Site_IsTestSite', null, false);
        const allowSamePlanEnrollment = this.configResourceService.getProcessedResourceValue('Spa_Enrollment_Allow_AlreadyEnrolled_Plans', null, false);
        const planEnrollmentSettings = this.getEnrollmentPlanHRASettings(undefined, hraParentPlanId)?.[0];
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const Spa_SendEnrollment_Retain_Form_Answers = this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_Retain_Form_Answers', null, false);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const Spa_Site_SiteType = this.configResourceService.getProcessedResourceValue('Spa_Site_SiteType');
        const userType = this.configResourceService.getProcessedResourceValue('UserType', null, '');
        // plan may be null at this point in PC API flow... this is because selectedPlans is used but not set in that flow
        // while the shoppingCart is set... We call selectAndReturnEnrollingPlanPlusRiders later in the flow to get
        // shoppingCart plan details to set into selectedPlans
        let plan = this.shoppingCartService.getPlan(hraParentPlanId);
        const selectedRiders = this.shoppingCartService.getSelectedPlanRiders(hraParentPlanId);
        const riderData = this.getRiderData(selectedRiders);
        const memberSession = this.memberSessionService.getMemberSession();
        const apiProfileStateModel = { ...memberSession.profile };
        const updatedProfileModel = this.profileService.prepareProfileStateForAPI(apiProfileStateModel);
        await this.demographicService.conditionallyFetchCounties(memberSession.demographic.zip, memberSession.demographic.fips);
        const countyName = this.demographicService.getSelectedCounty()?.countyName ?? '';
        const apiMemberStateModel = {
            sessionId: memberSession.sessionId,
            ssoValue: memberSession.ssoValue,
            memberId: memberSession ? memberSession.memberID : '',
            profile: { authRepData: {}, ...updatedProfileModel },
            // getting countyName from counties plus selectedFips
            // this assumes counties is loaded and if its not we will not find a countyName
            demographic: { ...memberSession.demographic, countyName },
            enrollments: memberSession.enrollments
        };
        const providerPCPFormInfo = this.providerService.getSelectedPrimaryCareProvider();
        const deepLinkingParams = this.getNextGenDeepLinkingParams();
        const agent = this.getAgentRequestData();
        const sourceSiteId = this.quoteService.getSourceSiteId();
        const isSiteLive = this.lockedSiteService.isSiteLive();
        const isReviewSite = this.lockedSiteService.isReviewSite(window.location.hostname);
        const enrollmentUserType = this.getSiteUserType(hraParentPlanId); // Do we need this for hra? If so we will need to create a getSiteUserTypeForHRA
        const callRecordingAvailable = this.twilioService.isConnectionOpen();
        const medigapAnswers = this.memberSessionService.getMemberMedigapAnswers();
        const humanaCustomClientPartnerId = this.configResourceService.getProcessedResourceValue('HumanaCustomClientPartnerId');
        const humanaCustomClientPartnerName = this.configResourceService.getProcessedResourceValue('HumanaCustomClientPartnerName');
        const humanaCustomClientPartnerIdentifier = this.configResourceService.getProcessedResourceValue('HumanaCustomClientPartnerIdentifier');
        if (isBLAMSite && !plan) {
            await this.selectAndReturnEnrollingPlanPlusRiders(hraParentPlanId);
            // selectAndReturnEnrollingPlanPlusRiders sets the plan to selectedPlans so we want to call getPlan again
            // here to re-get the selectedPlan which was previously not set
            plan = this.shoppingCartService.getPlan(hraParentPlanId);
        }
        const calculatedPremium = `${this.plansService.getTotalPremium([plan], selectedRiders)}`;
        if (!MEDICARE_PLAN_TYPES.includes(plan.planTypeAbbreviation)) {
            plan = { ...plan, calculatedPremium };
        }
        try {
            const medicareGroupPlanConfiguration = this.plansService.getMedicareGroupPlanConfiguration();
            const isPurl = this.agentService.isPurl();
            await this.createNextGenFormTransaction$({
                plan,
                medicareGroupID: medicareGroupPlanConfiguration?.medicareGroupId ?? null,
                medicareGroupName: medicareGroupPlanConfiguration?.medicareGroupName ?? null,
                riderData,
                ...(agent && { agent }),
                coverageEventType: CoverageEventType.HRA,
                enrollmentSettings: {
                    formId: planEnrollmentSettings.formId,
                    formVersion: planEnrollmentSettings.formVersion,
                    formVersionId: planEnrollmentSettings.formVersionId,
                    foamFormType: planEnrollmentSettings.foamFormType,
                    sourceId: planEnrollmentSettings.sourceId,
                    enrollMessage: planEnrollmentSettings.enrollMessage,
                    agentId: planEnrollmentSettings.agentId,
                    agentFirstName: planEnrollmentSettings.agentFirstName,
                    agentLastName: planEnrollmentSettings.agentLastName,
                    agencyId: planEnrollmentSettings.agencyId,
                    agencyName: planEnrollmentSettings.agencyName,
                    customDefaultValue1: planEnrollmentSettings.customDefaultValue1,
                    customDefaultValue2: planEnrollmentSettings.customDefaultValue2,
                    customDefaultValue3: planEnrollmentSettings.customDefaultValue3,
                    customDefaultValue4: planEnrollmentSettings.customDefaultValue4,
                    customDefaultValue5: planEnrollmentSettings.customDefaultValue5,
                    fieldOverrides: planEnrollmentSettings.fieldOverrides,
                    queryId: planEnrollmentSettings.queryId
                },
                enrollmentUserType,
                ...(sourceSiteId && { sourceSiteId }),
                session: { ...apiMemberStateModel, ...(medigapAnswers && { medigapAnswers }) },
                providerPCPFormInfo,
                allowSamePlanEnrollment,
                site: {
                    isSiteLive,
                    isReviewSite,
                    createdIPAddress,
                    partnerId,
                    destinationAppId,
                    isTestingSite
                },
                configurations: {
                    sourceId,
                    Spa_SendEnrollment_Retain_Form_Answers,
                    Spa_Site_SiteType,
                    userType,
                    humanaCustomClientPartnerId,
                    humanaCustomClientPartnerName,
                    humanaCustomClientPartnerIdentifier
                },
                isPurl,
                currentDate: this.utilityFunctionService.getCurrentDate(DateUtilities.defaultFormat),
                hasValidCompletedSOA: this.soaService.hasValidCompletedSOA(),
                medigapAnswers: this.getNextGenRequestMedigapAnswers(),
                ...(Object.keys(deepLinkingParams).length && { deepLinkingParams }),
                isMedigap: false,
                isHRA: true,
                originalTransactionGUID: originalEnrollmentTransactionId
            }, callRecordingAvailable);
        }
        catch (error) {
            return await Promise.reject(error);
        }
        await this.setCurrentFormVersionId(planEnrollmentSettings.formVersionId);
        return await Promise.resolve(this.getNextGenTransaction(hraFormId));
    }
    // TODO: We may want in the future to just make this return the entire agent object instead of these specifics bits
    getAgentRequestData() {
        return {
            agentGuid: this.agentService.getAgentInContextGuid(),
            agentID: this.agentService.getAgentId(),
            firstName: this.agentService.getAgentFirstName(),
            lastName: this.agentService.getAgentLastName(),
            emailAddress: this.agentService.getAgentEmailAddress(),
            npn: this.agentService.getAgentNPN(),
            agencyName: this.agentService.getAgencyName(),
            agencyID: this.agentService.getAgencyId(),
            referringDomain: window.location.origin,
            callRecordingCode: this.twilioService.getOpenConnectionCallRecordingCode(),
            userName: this.agentService.getAgentUserName(),
            state: this.agentService.getAgentState(),
            phoneNumber: this.agentService.getAgentPhone()
            // fsr
            // awn
            // hasAgentContext
        };
    }
    getNextGenDeepLinkingParams() {
        const deepLinkingParams = this.deepLinkingService.getDeepLinkingParamsState();
        // deep linking params will strictly overwrite what is passed in elsewhere so we need
        // to only pass in non empty strings
        return this.removeEmptyStrings({
            zipCode: deepLinkingParams.ZIPCODE,
            countyFips: deepLinkingParams.COUNTYFIPS,
            planType: deepLinkingParams.PLANTYPE,
            planId: deepLinkingParams.PLANID,
            cultureCode: deepLinkingParams.CULTURECODE,
            ssoValue: deepLinkingParams.SSOVALUE,
            beneFirstName: deepLinkingParams.BENEFIRSTNAME,
            beneLastName: deepLinkingParams.BENELASTNAME,
            beneBirthDate: deepLinkingParams.BENEBIRTHDATE,
            beneGender: deepLinkingParams.BENEGENDER,
            beneCRMId: deepLinkingParams.BENECRMID,
            beneAddr1: deepLinkingParams.BENEADDR1,
            beneAddr2: deepLinkingParams.BENEADDR2,
            beneCity: deepLinkingParams.BENECITY,
            beneState: deepLinkingParams.BENESTATE,
            benePhone: deepLinkingParams.BENEPHONE,
            beneCellPhone: deepLinkingParams.BENECELLPHONE,
            beneMail: deepLinkingParams.BENEEMAIL,
            agentId: deepLinkingParams.AGENTID,
            agencyName: deepLinkingParams.AGENCYNAME,
            agencyId: deepLinkingParams.AGENCYID,
            sourceId: deepLinkingParams.SOURCEID,
            partnerId: deepLinkingParams.PARTNERID,
            returnurl: deepLinkingParams.RETURNURL,
            utM_Source: deepLinkingParams.UTM_SOURCE,
            utM_Medium: deepLinkingParams.UTM_MEDIUM,
            utM_Campaign: deepLinkingParams.UTM_CAMPAIGN,
            tfn: deepLinkingParams.TFN,
            customTrack1: deepLinkingParams.CUSTOMTRACK1,
            customTrack2: deepLinkingParams.CUSTOMTRACK2,
            customTrack3: deepLinkingParams.CUSTOMTRACK3,
            customTrack4: deepLinkingParams.CUSTOMTRACK4,
            customTrack5: deepLinkingParams.CUSTOMTRACK5,
            customFMO1: deepLinkingParams.CUSTOMFMO1,
            customFMO2: deepLinkingParams.CUSTOMFMO2,
            customFMO3: deepLinkingParams.CUSTOMFMO3,
            customFMO4: deepLinkingParams.CUSTOMFMO4,
            customFMO5: deepLinkingParams.CUSTOMFMO5,
            militaryRank: deepLinkingParams.MILITARYRANK,
            militaryStatus: deepLinkingParams.MILITARYSTATUS,
            militaryBranch: deepLinkingParams.MILITARYBRANCH,
            militaryPrefixCode: deepLinkingParams.MILITARYPREFIXCODE,
            populateData: deepLinkingParams.POPULATEDDATA,
            pegi: deepLinkingParams.PEGI,
            channel: deepLinkingParams.CHANNEL,
            sessionId: deepLinkingParams.SESSIONID
        });
    }
    async getFormTransaction$(planId, switchForm, enrollmentSettings, 
    // TODO: marked for removal but leaving for diagnostic purposes for SPA-10987
    fetchTransactionFromGuid = false, transactionGuid = '') {
        const currentLocale = this.localeService.getCurrentLocale();
        const isBLAMSite = this.configResourceService.getProcessedResourceValue('Spa_Site_Is_BLAM', null, false);
        const canFetchFromTransactionGuid = fetchTransactionFromGuid && transactionGuid;
        // TODO: may eventually turn this one for next gen forms but trying to isolate initialization of next gen forms on first pass
        if (isBLAMSite || canFetchFromTransactionGuid) {
            // reassigning this in case we need to re-fetch it here. this shouldn't happen but something
            // is being dropped in SPA-10987 and we need to re-get this if it's missing
            let populatedTransactionGuid = transactionGuid;
            if (!canFetchFromTransactionGuid) {
                // TODO: marked for removal but added for SPA-10987 and cannot be removed until we have figured out
                // the information needed to diagnose the root cause of this issue
                console.error(`BLAM site lost tid. fetchTransactionFromGuid: ${fetchTransactionFromGuid} tid: ${transactionGuid}`);
                if (!transactionGuid) {
                    populatedTransactionGuid = this.getTransactionGuidFromPartialEnrollment(planId);
                }
            }
            await Promise.all([
                firstValueFrom(this.fetchTransaction$(planId, populatedTransactionGuid)),
                this.selectAndReturnEnrollingPlanPlusRiders(planId)
            ]);
            return await Promise.resolve(this.getTransaction(planId));
        }
        // TODO: happening in calling method now in order to refactor for nextgen
        // const enrollmentSettings: BeanProviderSettings = await this.fetchAndLoadEnrollmentSettings(fetchEnrollmentSettings, switchForm, planId);
        if (enrollmentSettings) {
            const customInternal = enrollmentSettings.payload?.customInternal
                ? JSON.parse(enrollmentSettings.payload.customInternal)
                : null;
            const enrollmentTransactionRequest = customInternal
                ? EnrollmentTransactionRequest.createInitialTransaction(customInternal)
                : new EnrollmentTransactionRequest();
            enrollmentTransactionRequest.overrideStoredAnswers = true;
            enrollmentTransactionRequest.partnerID =
                this.passParamService.getPartnerId() || this.configResourceService.getProcessedResourceValue('PartnerID');
            enrollmentTransactionRequest.sourceID =
                this.passParamService.getSourceId() || this.configResourceService.getProcessedResourceValue('SourceID');
            enrollmentTransactionRequest.langID = LocaleService.LOCALE_ALIAS_ID[currentLocale];
            enrollmentTransactionRequest.pageIndex = 0;
            enrollmentTransactionRequest.createdIPAddress = await this.ipUtilityService.getClientIP();
            if (switchForm) {
                enrollmentTransactionRequest.transactionSID = this.store.selectSnapshot(EnrollmentState.transactionId(planId));
            }
            // TODO: These are the values from an example request from Anu that ended up working.
            // Why these are different from what we originally had I need to discuss with Josh when possible
            // Leaving the old stuff in to keep things from breaking. But should we just be passing in the
            // Enrollment call payload, plus transactionSID?
            enrollmentTransactionRequest.ssoTag = enrollmentSettings.payload.ssoTag;
            enrollmentTransactionRequest.formTypes = enrollmentSettings.payload.formTypes;
            enrollmentTransactionRequest.currentFormType = enrollmentSettings.payload.currentFormType;
            enrollmentTransactionRequest.usingBEAN = enrollmentSettings.payload.usingBEAN;
            enrollmentTransactionRequest.siteID = enrollmentSettings.payload.siteID;
            enrollmentTransactionRequest.isFormChaining = enrollmentSettings.payload.isFormChaining;
            enrollmentTransactionRequest.groupConfirmationNumber = enrollmentSettings.payload.groupConfirmationNumber;
            enrollmentTransactionRequest.selectedCultureCode = enrollmentSettings.payload.selectedCultureCode;
            enrollmentTransactionRequest.planID = enrollmentSettings.payload.planID;
            enrollmentTransactionRequest.planIDs = enrollmentSettings.payload.planIDs;
            enrollmentTransactionRequest.isMedigap = this.parseStringToBoolean(enrollmentSettings.payload.isMedigap);
            enrollmentTransactionRequest.isTestingSite = this.parseStringToBoolean(enrollmentSettings.payload?.isTestingSite);
            enrollmentTransactionRequest.formType = enrollmentSettings.payload.formType;
            enrollmentTransactionRequest.groupId = enrollmentSettings.payload.groupId;
            enrollmentTransactionRequest.integrationType = enrollmentSettings.payload.integrationType;
            enrollmentTransactionRequest.formID = enrollmentSettings.payload.formID;
            enrollmentTransactionRequest.userType = enrollmentSettings.payload.userType;
            enrollmentTransactionRequest.planYear = enrollmentSettings.payload.planYear;
            enrollmentTransactionRequest.publicFormID = enrollmentSettings.payload.formID;
            enrollmentTransactionRequest.planID = enrollmentSettings.payload.planID;
            enrollmentTransactionRequest.destinationAppID = enrollmentSettings.payload.appID;
            enrollmentTransactionRequest.originalAppID = +enrollmentSettings.payload.appID; // TODO: how does this differ from destination app id
            enrollmentTransactionRequest.sourceSiteID = this.quoteService.getSourceSiteId();
            const siteType = this.configResourceService.getProcessedResourceValue('Spa_Site_SiteType', null, 'consumer');
            const quoteId = !this.siteService.isPPCSite(siteType) ? this.getBeneficiaryQuoteId() : null;
            const isSiteLive = this.lockedSiteService.isSiteLive();
            const isReviewSIte = this.lockedSiteService.isReviewSite(window.location.hostname);
            const callRecordingCode = this.twilioService.getOpenConnectionCallRecordingCode();
            const isPurl = this.agentService.isPurl();
            const plansQueuePosition = this.store.selectSnapshot(PlansState.plansQueuePosition);
            const planQueuePosition = plansQueuePosition?.find(planQueue => planQueue.id === planId);
            const planRanking = planQueuePosition ? planQueuePosition.queuePosition : null;
            await firstValueFrom(this.createFormTransaction$(this.memberSessionService.getMemberSessionId(), planId, enrollmentTransactionRequest, isSiteLive, isReviewSIte, isPurl, quoteId, callRecordingCode, planRanking, this.plansService.getBestMatchPlanIdForAnalytics(), this.plansService.getBestMatchCoverageForAnalytics()).pipe(catchError(err => {
                this.navigationService.navigateByPageTag(PageTags.HOME);
                return of(err);
            })));
            this.clearEnrollmentHistorySelectedPlan();
            this.updateEnrollmentUserType(planId);
            return await Promise.resolve(this.getTransaction(planId));
        }
        else {
            return await Promise.resolve(null);
        }
    }
    async fetchAndLoadEnrollmentSettings(fetchEnrollmentSettings, switchForm, planId) {
        const planHasNextGenForm = this.planHasNextGenForm(planId);
        let enrollmentSettings;
        if (fetchEnrollmentSettings) {
            enrollmentSettings = await this.loadEnrollmentSettings$(switchForm, planHasNextGenForm);
        }
        else {
            const storedEnrollmentSettings = this.getEnrollmentSettings();
            const isValidEnrollmentSettings = this.isValidEnrollmentSettingsForPlan(planId, storedEnrollmentSettings, planHasNextGenForm);
            if (isValidEnrollmentSettings) {
                enrollmentSettings = storedEnrollmentSettings;
            }
            else {
                enrollmentSettings = await this.loadEnrollmentSettings$(switchForm, planHasNextGenForm);
            }
        }
        return enrollmentSettings;
    }
    isValidEnrollmentSettingsForPlan(planId, enrollmentSettings, planHasNextGenForm) {
        if (planHasNextGenForm) {
            return true;
        }
        const customInternal = enrollmentSettings.payload?.customInternal
            ? JSON.parse(enrollmentSettings.payload.customInternal)
            : null;
        const customInternalPlanId = customInternal?.CustomInternal?.StoringData?.PlanID;
        return planId === customInternalPlanId;
    }
    updateEnrollmentUserType(planId) {
        const userType = this.store.selectSnapshot(EnrollmentState.selectedUserFormType(planId));
        const transactionGuid = this.getTransactionGuid(planId);
        const enrollmentStatus = this.store.selectSnapshot(EnrollmentState.status(planId));
        // Update enrollment user type if enrollment status is created, or if minor form validation present
        // (for example, profile address city zip code mismatch)
        if (enrollmentStatus !== EnrollmentTransactionStatus.COMPLETED && enrollmentStatus !== EnrollmentTransactionStatus.FAIL_COMPLETED) {
            this.memberSessionService.updateEnrollmentUserType(transactionGuid, userType);
        }
    }
    /**
     * if index is 0, and we have a previously defined page structure, we will use that and navigate to the first page in the flow
     * otherwise this is a brand new transaction and we will use firstPageName or pageName in order
     * Passing -1 will get the last page
     */
    getEnrollmentPageByIndex(planId, index, transaction) {
        const formPages = this.getFormPages(planId);
        let pageIndex = index;
        if (pageIndex === -1) {
            pageIndex = formPages.length - 1;
        }
        if (formPages?.[pageIndex]?.pageName) {
            return formPages[pageIndex].pageName;
        }
        if (pageIndex === 0 && transaction) {
            return transaction.firstPageName || transaction.pageName;
        }
        return null;
    }
    getEnrollmentPagesLength(planId) {
        return this.getFormPages(planId).length;
    }
    async loadEnrollmentPrerequisites$(planId, transaction, index) {
        await firstValueFrom(this.fetchPageInfo$(planId));
        if (typeof index !== 'undefined' && index !== null) {
            const pageName = this.getEnrollmentPageByIndex(planId, index, transaction);
            return await firstValueFrom(this.fetchPageHtml$(this.getPageIndex(planId, pageName), planId));
        }
    }
    async nextGenEnrollmentStart$(planId, decryptedData, preserveQueryParams = false) {
        const enrollmentRootPage = this.getEnrollmentRootPage();
        const newParams = this.getClientDefinedValuesFromQueryParams();
        const routerOptions = { queryParams: preserveQueryParams ? newParams : {} };
        if (decryptedData) {
            routerOptions.state = { decryptedData };
        }
        return await this.router.navigate([enrollmentRootPage], routerOptions);
    }
    async enrollmentStart$(planId, transaction, skipToPageIndex, preserveQueryParams = false) {
        const enrollmentRootPage = this.getEnrollmentRootPage();
        await this.startLegacyEnrollment(planId, transaction, skipToPageIndex, enrollmentRootPage, preserveQueryParams);
    }
    async initializeEnrollment$(planId, skipToPageIndex, fetchEnrollmentSettings = true, fetchTransactionFromGuid = false, transactionGuid = '', navigateToNextGenOnInit = false, overrideAsShortForm = false, decryptedData) {
        const isEnrollmentExpired = this.isMemberEnrollmentExpired(planId);
        if (isEnrollmentExpired) {
            return await this.navigationService.navigateByPageTag(PageTags.ENROLLMENT_EXPIRED);
        }
        const enrollmentPlanSettingsLoaded = overrideAsShortForm
            ? this.isEnrollmentPlanSettingsLoadedForSelectedFormType(planId, EnrollmentFormType.SHORT)
            : this.getEnrollmentPlanSettingsLoaded(planId);
        const formTypeOverride = overrideAsShortForm ? [EnrollmentFormType.SHORT] : undefined;
        if (!enrollmentPlanSettingsLoaded) {
            // since this is the determinant of if a plan has a next gen form we just have to load it each time to know what form type we have
            await this.fetchEnrollmentPlanSettings(planId, undefined, formTypeOverride);
        }
        const planHasNextGenForm = this.planHasNextGenForm(planId);
        if (!enrollmentPlanSettingsLoaded) {
            await this.loadEnrollmentSettings$(undefined, planHasNextGenForm, formTypeOverride?.[0]);
        }
        // we used to be able to set this in the beneficiary component when we got isShortForm
        // but now that we need to have enrollment settings before setting this so we know which
        // transaction (nextgen or hope) to set
        if (overrideAsShortForm) {
            await firstValueFrom(this.quoteService.updateSelectedFormType$(EnrollmentFormType.SHORT, planId));
        }
        // TODO: will figure this out for nextGenForm eventually
        const switchForm = !planHasNextGenForm && this.getSwitchForm(planId);
        const isRedirectedFromPlanCompareApi = this.isRedirectedFromPlanCompareApi();
        // NG-405: BE confirmed there is no need to fetch BeanProvider settings for PC API because it is handled on the API side
        let enrollmentSettings;
        if (!isRedirectedFromPlanCompareApi && !planHasNextGenForm) {
            // probably have to call this again which may lead to another enrollment settings load
            // this is because there are times we need to force a new fetch or switchForm
            enrollmentSettings = await this.fetchAndLoadEnrollmentSettings(fetchEnrollmentSettings, switchForm, planId);
        }
        if (planHasNextGenForm) {
            try {
                this.formPagesMetadataContext.setFormNavigationInitialized(false);
                if (isRedirectedFromPlanCompareApi && decryptedData) {
                    this.createPCAPINextGenEnrollmentTransaction(decryptedData).then(transaction => {
                        this.setCustomPlanPremium(transaction.customPlanPremium);
                        this.applyCustomPlanPremium(planId, transaction.customPlanPremium);
                        this.addAgentCALicense(transaction.caLicenseNumber);
                    });
                    if (navigateToNextGenOnInit) {
                        this.nextGenEnrollmentStart$(planId, decryptedData);
                    }
                    return;
                }
                else {
                    // when in the send to beneficiary pc api flow we get isRedirectedFromPlanCompareApi as true but not decrypted data...
                    // we do have fetchTransactionFromGuid and transactionGuid in this flow however
                    // this is what is also hit in the normal enrollment flow
                    this.getNextGenFormTransaction$(planId, fetchTransactionFromGuid, transactionGuid);
                    if (navigateToNextGenOnInit) {
                        this.nextGenEnrollmentStart$(planId);
                    }
                    return;
                }
            }
            catch (error) {
                this.externalErrorLoggingService.log(error);
                this.navigationService.navigateByPageTag(PageTags.HOME);
            }
        }
        else {
            const hopeTransaction = await this.getFormTransaction$(planId, switchForm, enrollmentSettings, fetchTransactionFromGuid, transactionGuid);
            if (hopeTransaction) {
                await this.enrollmentStart$(planId, hopeTransaction, skipToPageIndex);
                return;
            }
        }
        this.enrollmentTransactionErrorsContext.updateEnrollmentFormError(this._enrollmentFormError);
    }
    async loadEnrollmentSettings$(switchForm, planHasNextGenForm, formType) {
        const sessionId = this.memberSessionService.getMemberSessionId();
        return await this.checkCartAndFetchEnrollmentSettings(sessionId, switchForm, planHasNextGenForm, formType);
    }
    async createPCAPINextGenEnrollmentTransaction(decryptedExternalEnrollmentQS) {
        const { obfuscatedPlanID: planId } = decryptedExternalEnrollmentQS;
        const isSignAndSubmit = this.isNextGenFormSignAndSubmitOnly(planId);
        const isSiteLive = this.lockedSiteService.isSiteLive();
        const isReviewSite = this.lockedSiteService.isReviewSite(window.location.hostname);
        const createdIPAddress = await this.ipUtilityService.getClientIP();
        const partnerId = this.configResourceService.getProcessedResourceValue('PartnerID');
        const sourceId = this.configResourceService.getProcessedResourceValue('SourceID');
        const destinationAppId = this.configResourceService.getProcessedResourceValue('AppID');
        const isTestingSite = this.configResourceService.getProcessedResourceValue('Spa_Site_IsTestSite', null, false);
        const allowSamePlanEnrollment = this.configResourceService.getProcessedResourceValue('Spa_Enrollment_Allow_AlreadyEnrolled_Plans', null, false);
        // We are disabling these because the backend wants these in this format
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const Spa_SendEnrollment_Retain_Form_Answers = this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_Retain_Form_Answers', null, false);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const Spa_Site_SiteType = this.configResourceService.getProcessedResourceValue('Spa_Site_SiteType');
        const userType = this.configResourceService.getProcessedResourceValue('UserType', null, '');
        const selectedFormType = this.getSelectedFormType(planId);
        const userFormType = this.getUserFormType(planId);
        const planEnrollmentSettings = this.getPlanEnrollmentSettingsByType(planId, selectedFormType, userFormType);
        await this.setCurrentFormVersionId(planEnrollmentSettings.formVersionId);
        let plan = this.shoppingCartService.getPlan(planId);
        const selectedRiders = this.shoppingCartService.getSelectedPlanRiders(planId);
        const riderData = this.getRiderData(selectedRiders);
        const memberSession = this.memberSessionService.getMemberSession();
        const apiProfileStateModel = { ...memberSession.profile };
        const updatedProfileModel = this.profileService.prepareProfileStateForAPI(apiProfileStateModel);
        const apiMemberStateModel = {
            sessionId: memberSession.sessionId,
            ssoValue: memberSession.ssoValue,
            memberId: memberSession ? memberSession.memberID : '',
            profile: { authRepData: {}, ...updatedProfileModel },
            demographic: memberSession.demographic,
            enrollments: memberSession.enrollments
        };
        const quoteId = this.memberSessionService.getBeneficiaryQuoteId();
        const quoteType = this.quoteService.getQuoteInfo()?.quoteType;
        const providerPCPFormInfo = this.providerService.getSelectedPrimaryCareProvider();
        const deepLinkingParams = this.getNextGenDeepLinkingParams();
        const agent = await this.getAgent(memberSession);
        const sourceSiteId = this.memberSessionService.getBeneficiarySourceSiteId();
        const enrollmentUserType = this.getSiteUserType(planId);
        const medicareGroupPlanConfiguration = this.plansService.getMedicareGroupPlanConfiguration();
        const medigapAnswers = this.memberSessionService.getMemberMedigapAnswers();
        const humanaCustomClientPartnerId = this.configResourceService.getProcessedResourceValue('HumanaCustomClientPartnerId');
        const humanaCustomClientPartnerName = this.configResourceService.getProcessedResourceValue('HumanaCustomClientPartnerName');
        const humanaCustomClientPartnerIdentifier = this.configResourceService.getProcessedResourceValue('HumanaCustomClientPartnerIdentifier');
        const isPurl = this.agentService.isPurl();
        const calculatedPremium = `${this.plansService.getTotalPremium([plan], selectedRiders)}`;
        if (!MEDICARE_PLAN_TYPES.includes(plan.planTypeAbbreviation)) {
            plan = { ...plan, calculatedPremium };
        }
        await firstValueFrom(this.store.dispatch(new CreatePlanCompareApiNextGenTransaction({
            plan,
            medicareGroupID: medicareGroupPlanConfiguration?.medicareGroupId ?? null,
            medicareGroupName: medicareGroupPlanConfiguration?.medicareGroupName ?? null,
            riderData,
            ...(agent && { agent }),
            coverageEventType: CoverageEventType.FullEnrollment,
            ...(quoteId && { quoteId }),
            enrollmentSettings: {
                formId: planEnrollmentSettings.formId,
                formVersion: planEnrollmentSettings.formVersion,
                formVersionId: planEnrollmentSettings.formVersionId,
                foamFormType: planEnrollmentSettings.foamFormType,
                sourceId: planEnrollmentSettings.sourceId,
                enrollMessage: planEnrollmentSettings.enrollMessage,
                agentId: planEnrollmentSettings.agentId,
                agentFirstName: planEnrollmentSettings.agentFirstName,
                agentLastName: planEnrollmentSettings.agentLastName,
                agencyId: planEnrollmentSettings.agencyId,
                agencyName: planEnrollmentSettings.agencyName,
                customDefaultValue1: planEnrollmentSettings.customDefaultValue1,
                customDefaultValue2: planEnrollmentSettings.customDefaultValue2,
                customDefaultValue3: planEnrollmentSettings.customDefaultValue3,
                customDefaultValue4: planEnrollmentSettings.customDefaultValue4,
                customDefaultValue5: planEnrollmentSettings.customDefaultValue5,
                fieldOverrides: planEnrollmentSettings.fieldOverrides,
                queryId: planEnrollmentSettings.queryId
            },
            enrollmentUserType,
            ...(sourceSiteId && { sourceSiteId }),
            session: { ...apiMemberStateModel, ...(quoteId && { quoteType }), ...(medigapAnswers && { medigapAnswers }) },
            providerPCPFormInfo,
            allowSamePlanEnrollment,
            site: {
                isSiteLive,
                isReviewSite,
                createdIPAddress,
                partnerId,
                destinationAppId,
                isTestingSite
            },
            configurations: {
                sourceId,
                Spa_SendEnrollment_Retain_Form_Answers,
                Spa_Site_SiteType,
                userType,
                humanaCustomClientPartnerId,
                humanaCustomClientPartnerName,
                humanaCustomClientPartnerIdentifier
            },
            decryptedExternalEnrollmentQS,
            isExternalEnrollment: true,
            currentDate: this.utilityFunctionService.getCurrentDate(DateUtilities.defaultFormat),
            hasValidCompletedSOA: this.soaService.hasValidCompletedSOA(),
            isPurl,
            medigapAnswers: this.getNextGenRequestMedigapAnswers(),
            ...(Object.keys(deepLinkingParams).length && { deepLinkingParams }),
            isMedigap: plan.planTypeAbbreviation === PlanTypeAbbreviation.MEDIGAP,
            isSignAndSubmit
        })));
        const displaySEPReasons = this.getDisplaySEPReasons(plan);
        if (displaySEPReasons) {
            const { carrierId, planYear, planType } = plan;
            const currentLocale = this.localeService.getCurrentLocale();
            this.fetchNextGenSepReasons$(planId, carrierId, planYear, currentLocale, planType, displaySEPReasons);
        }
        return this.store.selectSnapshot(EnrollmentState.nextGenEnrollmentFormTransaction(planId));
    }
    async getAgent(memberSession) {
        const agentGuid = memberSession?.agentGuid ? memberSession.agentGuid : this.store.selectSnapshot(AgentState.agentGuid);
        if (agentGuid && !this.getAgentData()) {
            const agentData = await firstValueFrom(this.agentService.fetchAgent$(agentGuid, agentGuid));
            if (agentData) {
                await firstValueFrom(this.agentService.updateAgent$(agentData));
            }
        }
        const agent = this.getAgentRequestData();
        return agent;
    }
    setCustomPlanPremium(customPlanPremium) {
        this.store.dispatch(new SetPCAPICustomPlanPremium(customPlanPremium));
    }
    // Used when we need to apply the plan premium from the transaction in the case of PC API
    applyCustomPlanPremium(planId, customPlanPremium) {
        if (planId && customPlanPremium !== undefined && customPlanPremium !== null) {
            this.shoppingCartService.updateCartPlanPremium(planId, customPlanPremium, 0);
        }
    }
    addAgentCALicense(caLicenseNumber) {
        if (this.isPlanCompareApiAgentDataEnabled() && caLicenseNumber) {
            const agentLicense = {
                state: 'CA',
                license: caLicenseNumber,
                licenseType: AgentLicenseType.PC_API
            };
            this.addAgentLicense(agentLicense);
        }
    }
    addAgentLicense(agentLicense) {
        this.store.dispatch(new AddAgentLicense(agentLicense));
    }
    getSiteId() {
        return this.siteService.getSiteId();
    }
    /**
     * Selects the enrollingPlan, if not already selected. Will go and fetch the plan if required.
     * @param enrollingPlanId
     * @returns The plan object for the enrolling id
     */
    async selectAndReturnEnrollingPlan(enrollingPlanId) {
        // check if plan is in cart
        let enrollingPlan;
        const planFromSelectedPlans = this.shoppingCartService.getPlan(enrollingPlanId);
        if (planFromSelectedPlans) {
            enrollingPlan = planFromSelectedPlans;
        }
        else {
            // if not, check payload for plan
            const allCurrentPlans = this.plansService.getAllPlans();
            const findEnrollingPlan = allCurrentPlans.find(plan => plan.id === enrollingPlanId);
            if (findEnrollingPlan) {
                enrollingPlan = findEnrollingPlan;
            }
            else {
                // if not, go and fetch that one plan
                enrollingPlan = await this.fetchEnrollingPlan(enrollingPlanId);
            }
            await this.shoppingCartService.selectPlan(enrollingPlan);
        }
        return enrollingPlan;
    }
    /**
     * Selects the riders for the current enrollment, if not already selected. Since rider data is included in plan data,
     * no fetch is required.
     * @param enrollingPlan
     * @returns An array of the selected riders
     */
    async selectAndReturnEnrollingRiders(enrollingPlan) {
        const allEnrollments = this.store.selectSnapshot(MemberState.memberEnrollments);
        const matchingEnrollments = allEnrollments.filter(enrollment => enrollment.planID === enrollingPlan.id && enrollment.isActive);
        let matchingEnrollment;
        if (matchingEnrollments.length) {
            matchingEnrollment = matchingEnrollments[0];
        }
        if (matchingEnrollment?.selectedRiderIDs) {
            matchingEnrollment.selectedRiderIDs.forEach(async (riderId) => {
                const matchingRider = enrollingPlan.riders.find(rider => rider.planID === riderId);
                const currentlySelectedRiders = this.shoppingCartService.getSelectedRiderIds();
                // Check if there is any currentlySelectedRiders or they have all been removed before syncing with enrollments
                if (currentlySelectedRiders?.length && matchingRider && !currentlySelectedRiders.includes(matchingRider.planID)) {
                    await this.shoppingCartService.selectRider(riderId, enrollingPlan.id);
                }
            });
        }
        const selectedRiders = this.shoppingCartService.getSelectedPlanRiders(enrollingPlan.id);
        if (enrollingPlan.planTypeAbbreviation !== PlanTypeAbbreviation.HC) {
            return selectedRiders;
        }
        return this.selectHospitalIndemnityRiders(enrollingPlan, selectedRiders);
    }
    async fetchEnrollingPlan(enrollingPlanId) {
        const demographicsOptions = this.plansService.createPlansDemographicsOptionsWithDefaults();
        const searchOptions = this.plansService.createPlansSearchOptionsWithDefaults();
        const planFetchOptions = {
            demographicsOptions,
            searchOptions,
            ids: [enrollingPlanId],
            drugs: this.drugsService.mapCabinetToDosage(),
            pharmacies: this.plansService.getSelectedAPIPharmacyInfo(),
            medigapAnswers: this.medSupService.getMedSupAnswers(),
            agentGuid: this.store.selectSnapshot(AgentState.agentGuid)
        };
        return (await this.plansService.fetchPlansByOptions(planFetchOptions))[0];
    }
    getEnrollmentSettings() {
        return this.store.selectSnapshot(MemberState.enrollmentSettings);
    }
    getCustomInternalResource(enrollmentFormType) {
        const customInternalWrapper = new CustomInternalWrapper();
        const resourceKey = enrollmentFormType === EnrollmentFormType.HRA ? CUSTOM_INTERNAL_HRA_RESOURCE_KEY : CUSTOM_INTERNAL_RESOURCE_KEY;
        const customInternal = this.configResourceService.getProcessedResourceValue(resourceKey);
        customInternalWrapper.CustomInternal = customInternal;
        return customInternalWrapper;
    }
    createFormTransaction$(sessionId, planId, enrollmentTransactionRequest, isSiteLive, isReviewSite, isPurl, quoteId, callRecordingCode, planRanking, bestMatchPlanId, bestMatchPlanType) {
        if (this.store.selectSnapshot(AgentState.isBannedFromSession)) {
            this.getAgentAnswersToRemove()
                .map(answer => answer.name)
                .forEach(answerKey => {
                if (enrollmentTransactionRequest?.customInternal?.CustomInternal?.DynamicData[answerKey]) {
                    enrollmentTransactionRequest.customInternal.CustomInternal.DynamicData[answerKey] = '';
                }
                if (enrollmentTransactionRequest?.customInternal?.CustomInternal?.StoringData[answerKey]) {
                    enrollmentTransactionRequest.customInternal.CustomInternal.StoringData[answerKey] = '';
                }
            });
        }
        const callRecordingAvailable = this.twilioService.isConnectionOpen();
        return this.store.dispatch(new CreateTransaction(sessionId, planId, enrollmentTransactionRequest, this.planYearResourceService.getSelectedPlanYear(), isSiteLive, isReviewSite, this.configResourceService.getProcessedResourceValue('Spa_Enrollment_Allow_AlreadyEnrolled_Plans', null, false), quoteId, undefined, { isHRA: undefined }, undefined, undefined, callRecordingCode, isPurl, planRanking, bestMatchPlanId, bestMatchPlanType, undefined, callRecordingAvailable, this.configResourceService.getProcessedResourceValue('Spa_Site_IsTestSite', null, false)));
    }
    startNextGenTransaction$(payload) {
        return this.enrollmentHttpService.startNextGenTransaction$(payload);
    }
    async createNextGenFormTransaction$(nextGenRequest, callRecordingAvailable) {
        return await firstValueFrom(this.store.dispatch(new CreateNextGenTransaction(nextGenRequest, callRecordingAvailable)));
    }
    async completeNextGenFormTransaction$(nextGenRequest, transactionId, planCount = this.shoppingCartService.getSelectedPlanCount()) {
        return await firstValueFrom(this.store.dispatch(new CompleteNextGenEnrollment(nextGenRequest, transactionId, planCount)));
    }
    updateFormTransaction$(enrollmentTransactionRequest, enrollmentKey) {
        // need answers and page index here when we call to update transactions
        enrollmentTransactionRequest.planYear = this.planYearResourceService.getSelectedPlanYear();
        return this.store.dispatch(new UpdateTransaction(enrollmentTransactionRequest, enrollmentKey));
    }
    updateNextGenTransaction$(answers, enrollmentKey) {
        return this.store.dispatch(new UpdateNextGenTransaction(this.mapNextGenAnswersToMap(answers), enrollmentKey));
    }
    mapNextGenAnswersToMap(answers) {
        return (answers?.reduce((answersMap, answer) => {
            let answerValue = answer.value;
            if (DateUtilities.isValidFormat(answerValue, DateUtilities.defaultDateISOFormat)) {
                answerValue = DateUtilities.convertDateFormat(answerValue);
            }
            // map arrays to comma-delimited strings because the backend code requires it in the Answers call
            else if (Array.isArray(answerValue)) {
                answerValue = answerValue.join(',');
            }
            answersMap[answer.name] = answerValue;
            return answersMap;
        }, {}) ?? {});
    }
    fetchTransaction$(planId, transactionId) {
        return this.store.dispatch(new FetchTransaction(transactionId, planId));
    }
    fetchNextGenTransaction$(sessionId, planId, transactionId) {
        return this.store.dispatch(new FetchNextGenTransaction(sessionId, transactionId, planId));
    }
    fetchNextGenSepReasons$(planId, carrierId, planYear, language, planType, displaySEPReasons) {
        return this.store.dispatch(new FetchNextGenSepReasons(planId, carrierId, planYear, language, planType, displaySEPReasons));
    }
    setFormPagesDirty$(planId) {
        return this.store.dispatch(new SetFormPagesDirty(planId));
    }
    getPropertyFromTransaction(transaction, key) {
        if (transaction) {
            if (!transaction.answers) {
                return '';
            }
            return this.findAnswer(transaction.answers, key);
        }
        return '';
    }
    findAnswer(answers, key, notFoundDefault = '') {
        // TODO: answers coming back capitalized?
        const answerFound = answers.find(answer => answer.name === key);
        return answerFound !== undefined ? answerFound.value : notFoundDefault;
    }
    getActiveEnrollmentKey$() {
        return this.store.select(EnrollmentState.activeEnrollmentKey);
    }
    getSelectedPlans$() {
        return this.shoppingCartService.getSelectedPlans$();
    }
    getSelectedPlan$(selectedPlanId) {
        return this.shoppingCartService.getPlan$(selectedPlanId);
    }
    getSelectedPlan(selectedPlanId) {
        return this.shoppingCartService.getPlan(selectedPlanId);
    }
    /**
     * @returns A list of plans with the actively enrolled plan at the start, followed by the rest of the currently selected plans
     */
    crossSellSortedPlans$(maxPlans) {
        return combineLatest([this.getSelectedPlans$(), this.getActiveEnrollmentKey$()]).pipe(map(([selectedPlans, activeEnrollmentKey]) => {
            if (!selectedPlans?.length) {
                return [];
            }
            // move the enrolling plan at the beginning of the array
            const sortedPlans = [...selectedPlans].sort((planA, planB) => {
                if (planA.id === activeEnrollmentKey) {
                    return -1;
                }
                if (planB.id === activeEnrollmentKey) {
                    return 1;
                }
                return 0;
            });
            if (maxPlans >= 1) {
                return sortedPlans.slice(0, maxPlans);
            }
            return sortedPlans;
        }));
    }
    getSelectedPlanForEnrollment(planId, isHRA) {
        let selectedPlanForEnrollment = null;
        if (isHRA) {
            selectedPlanForEnrollment = this.getHRAPlan();
        }
        return selectedPlanForEnrollment ?? this.shoppingCartService.getPlan(planId);
    }
    async completeNextGenEnrollment(planId, isHRA = false, formId, formAnswers) {
        const selectedPlan = this.getSelectedPlanForEnrollment(planId, isHRA);
        const transactionKey = isHRA ? formId : planId;
        const carrierId = selectedPlan.carrierId;
        const planType = selectedPlan?.planType;
        const isMedigap = planType === PlanType.MEDIGAP;
        const sessionId = this.memberSessionService.getMemberSessionId();
        const isSiteLive = this.lockedSiteService.isSiteLive();
        const isLockedSite = this.lockedSiteService.isReviewSite(window.location.hostname);
        const preferencesJSON = await this.preferencesService.createPreferencesJSON(planId);
        const partnerId = this.passParamService.getPartnerId() || this.configResourceService.getProcessedResourceValue('PartnerID');
        const sourceId = this.passParamService.getSourceId() || this.configResourceService.getProcessedResourceValue('SourceID');
        const siteId = this.getSiteId();
        // const clientId = this.memberSessionService.getClientId();
        const appId = this.configResourceService.getProcessedResourceValue('AppID', null, 0);
        const isActive = !isLockedSite && isSiteLive; // from generic form transaction... TODO: follow up on if
        const confirmationSettings = this.createConfirmationSettings(planId, isHRA ? EnrollmentFormType.HRA : this.getSelectedFormType(planId));
        const zipCode = this.getNextGenEnrollmentAnswer('ApplicantZip', transactionKey) || this.memberSessionService.getZipCode();
        const countyFIPS = this.getNextGenEnrollmentAnswer('ApplicantCounty', transactionKey) || this.memberSessionService.getFipsCode();
        // this is typically pushed to the profiles primary address when updated in enrollment but we will just
        // grab it from the form itself
        const enrollmentState = this.getNextGenEnrollmentAnswer('ApplicantState', transactionKey);
        const planYear = this.planYearResourceService.getSelectedPlanYear();
        const hideAgentData = this.store.selectSnapshot(UiState.hidePdfAgentData);
        const sourceSiteId = this.quoteService.getSourceSiteId();
        const locale = this.weglotService.getCurrentLocale();
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const Spa_Enrollment_ExpiringPartialMedicareEnrollments_Enabled = this.configResourceService.getProcessedResourceValue('Spa_Enrollment_ExpiringPartialMedicareEnrollments_Enabled', null, false);
        const nextGenEnrollmentRequest = {
            sessionId,
            completeEnrollmentSiteId: siteId,
            completeEnrollmentAppId: appId,
            preferencesJSON,
            zipCode,
            countyFIPS,
            ...(enrollmentState && { state: enrollmentState }),
            planId,
            isMedigap,
            originalAppId: appId,
            destinationAppId: appId,
            sourceId,
            // DRXAgentId: string;
            partnerId,
            // GroupConfirmationNumber: string;
            isActive,
            encryptionTypeId: 0,
            confirmationSettings,
            // effectiveDate: string;
            // isSep: boolean,
            isComplete: true,
            langId: 1,
            planYear,
            hideAgentData,
            // groupConfirmationNumber: string,
            carrierId,
            sourceSiteId,
            ...(planType && { planType }),
            locale,
            ...(isHRA && { isHRA }),
            ...(isHRA && formId && { enrollmentKey: formId }),
            Spa_Enrollment_ExpiringPartialMedicareEnrollments_Enabled
        };
        const promises = [
            this.completeNextGenFormTransaction$(nextGenEnrollmentRequest, this.getNextGenTransactionId(transactionKey))
        ];
        if (this.planPostEnrollmentTextEnabled) {
            promises.unshift(firstValueFrom(this.plansService.getPlanData$(planId, PlanDataKeys.POST_ENROLLMENT_MESSAGES)));
        }
        const asyncOperationsResult = await Promise.all(promises);
        if (this.planPostEnrollmentTextEnabled) {
            this.setPlanPostEnrollmentData(asyncOperationsResult?.[0]);
        }
        const generatedUrlParameters = this.getNextGenTransaction(transactionKey)?.queryStringReturn ?? '';
        this.setConsumerAccessEmailUrlParameters(generatedUrlParameters);
        // performance: don't await for the emails to be sent. These requests take more than 1 second to complete
        if (isHRA) {
            this.sendHRAConfirmationEmails$(formAnswers, formId);
        }
        else {
            this.sendConfirmationEmails(transactionKey, generatedUrlParameters);
        }
    }
    async completeEnrollment(planId, isHRA = false) {
        const salesForceSyncEnabled = this.configResourceService.getProcessedResourceValue('Spa_SF_SyncEnabled', null, false);
        const isSiteLive = this.lockedSiteService.isSiteLive();
        const isReviewSite = this.lockedSiteService.isReviewSite(window.location.hostname);
        const preferencesJSON = await this.preferencesService.createPreferencesJSON(planId);
        const enrollmentSettings = this.getEnrollmentSettings();
        const enrollmentRequest = {
            payload: enrollmentSettings,
            config: this.createEnrollmentConfirmationInfo(planId, this.getSelectedFormType(planId)),
            confirmationPostBackUrl: this.enrollmentPostBackService.getConfirmationPostBackUrl(),
            confirmationPostBackEnable: this.enrollmentPostBackService.getConfirmationPostBackEnabled(),
            sfSyncEnabled: salesForceSyncEnabled,
            removeAgent: this.agentService.isBannedFromSession(),
            isSiteLive,
            isReviewSite,
            preferencesJSON,
            sourceSiteId: this.quoteService.getSourceSiteId(),
            isTestingSite: this.configResourceService.isTestingSite()
        };
        if (!isHRA) {
            enrollmentRequest.externalEnrollment = this.getExternalEnrollmentSettings();
        }
        const promises = [
            firstValueFrom(this.store.dispatch(new CompleteEnrollment(this.memberSessionService.getMemberSessionId(), this.getTransactionId(planId), this.planYearResourceService.getSelectedPlanYear(), enrollmentRequest, planId, this.shoppingCartService.getSelectedPlanCount())))
        ];
        if (this.planPostEnrollmentTextEnabled) {
            promises.unshift(firstValueFrom(this.plansService.getPlanData$(planId, PlanDataKeys.POST_ENROLLMENT_MESSAGES)));
        }
        const asyncOperationsResult = await Promise.all(promises);
        if (this.planPostEnrollmentTextEnabled) {
            this.setPlanPostEnrollmentData(asyncOperationsResult?.[0]);
        }
        const generatedUrlParameters = this.getTransaction(planId)?.queryStringReturn ?? '';
        this.setConsumerAccessEmailUrlParameters(generatedUrlParameters);
        // performance: don't await for the emails to be sent. These requests take more than 1 second to complete
        this.sendConfirmationEmails(planId, generatedUrlParameters);
    }
    getExternalEnrollmentSettings() {
        return {
            humanaAPISubmissionEnabled: this.configResourceService.getProcessedResourceValue('HumanaAPISubmissionEnabled', null, false),
            humanaAPICarrierID: this.configResourceService.getProcessedResourceValue('HumanaAPICarrierID')
        };
    }
    async sendConfirmationEmails(planId, generatedUrlParameters, widgetName) {
        // performance: send emails in parallel
        return await Promise.all([
            this.sendConsumerConfirmationEmail({ planId, generatedUrlParameters, widgetName }),
            this.sendAgentConfirmationEmail(planId, widgetName)
        ]);
    }
    async sendHRAConfirmationEmails$(transactionAnswers, formId, inputs = [], planHasNextGenForm) {
        const planId = this.store.selectSnapshot(EnrollmentState.hraPlanId);
        const transactionId = this.getTransactionId(formId);
        if (planHasNextGenForm) {
            const sessionId = this.memberSessionService.getMemberSessionId();
            await firstValueFrom(this.fetchNextGenTransaction$(sessionId, formId, transactionId));
        }
        else {
            await firstValueFrom(this.fetchTransaction$(formId, transactionId));
        }
        const submissionDate = this.getNextGenEnrollmentAnswer('SubmissionDate', planId);
        const formattedDate = this.formatEnrollmentDate(submissionDate);
        inputs.push({ key: 'enrollmentDate', value: formattedDate });
        let inputsWithCarrierInfo = inputs;
        const plan = this.store.selectSnapshot(PlansState.plan(planId));
        if (plan) {
            const carrierInformation = plan.carrierInformation;
            const planEnrollmentInfo = plan.planEnrollmentInfo;
            inputsWithCarrierInfo = this.addCarrierInputs(inputs, carrierInformation, planEnrollmentInfo?.ttyPhone);
        }
        let consumerEmailAddress = '';
        const consumerEmailMatch = transactionAnswers.find(answer => answer.name === 'ApplicantEmailAddress');
        if (consumerEmailMatch?.value) {
            consumerEmailAddress = consumerEmailMatch.value;
        }
        else {
            const profileEmail = this.store.selectSnapshot(ProfileState.emailAddress);
            if (profileEmail) {
                consumerEmailAddress = profileEmail;
            }
        }
        const agentInContext = this.agentService.getIsAgentInContext();
        if (consumerEmailAddress) {
            const agentPhoneNumberFormatted = this.phoneService.formatPhoneNumberWithExtension(this.agentService.getAgentPhone(), this.agentService.getAgentExtension());
            let agentName;
            let agentNPN;
            let californiaLicenseNumber;
            if (this.agentService.isPlanCompareApiAgentDataEnabled()) {
                const planCompareApiAgentData = this.agentService.getPlanCompareApiAgentData(planId);
                ({ agentName, agentNPN, californiaLicenseNumber } = planCompareApiAgentData);
            }
            else {
                agentName = this.agentService.getBrokerFullName();
                agentNPN = this.agentService.getAgentNPN();
                californiaLicenseNumber = this.agentService.getCaliforniaLicenseNumber();
            }
            inputsWithCarrierInfo.push({ key: 'agentName', value: agentName }, { key: 'agentNPN', value: agentNPN }, { key: 'agentPhoneNumber', value: agentPhoneNumberFormatted }, { key: 'californiaLicenseNumber', value: californiaLicenseNumber }, { key: 'agentInContext', value: agentInContext.toString() });
            const consumerSubject = this.configResourceService.getProcessedResourceValue('Spa_HRAConfirmation_ConsumerEmail_Subject', null);
            this.emailService.sendEmail(EmailNames.HRA_CONSUMER, [consumerEmailAddress], consumerSubject, inputsWithCarrierInfo);
        }
        const agentEmailAddress = this.store.selectSnapshot(AgentState.emailAddress);
        if (this.getIsBrokerConfirmationEmailEnabled() && agentInContext && agentEmailAddress) {
            const agentLoginShortUrl = await this.getAgentLoginShortUrl();
            inputsWithCarrierInfo.push({
                key: 'agentLoginShortUrl',
                value: agentLoginShortUrl
            });
            const brokerSubject = this.configResourceService.getProcessedResourceValue('Spa_HRAConfirmation_BrokerEmail_Subject', null);
            this.emailService.sendEmail(EmailNames.HRA_BROKER, [agentEmailAddress], brokerSubject, inputsWithCarrierInfo);
        }
    }
    addCarrierInputs(inputs, carrierInformation, tty) {
        if (carrierInformation?.organizationName) {
            inputs.push({ key: 'organizationName', value: carrierInformation.organizationName });
        }
        if (carrierInformation?.carrierName) {
            inputs.push({ key: 'carrierName', value: carrierInformation.carrierName });
        }
        if (carrierInformation?.carrierAddress?.address1) {
            inputs.push({ key: 'carrierAddress', value: carrierInformation.carrierAddress?.address1 });
        }
        if (carrierInformation?.carrierAddress?.city) {
            inputs.push({ key: 'carrierCity', value: carrierInformation.carrierAddress?.city });
        }
        if (carrierInformation?.carrierAddress?.state) {
            inputs.push({ key: 'carrierState', value: carrierInformation.carrierAddress?.state });
        }
        if (carrierInformation?.carrierAddress?.zip) {
            inputs.push({ key: 'carrierZip', value: carrierInformation.carrierAddress?.zip });
        }
        if (carrierInformation?.hours) {
            inputs.push({ key: 'carrierHours', value: carrierInformation.hours });
        }
        if (carrierInformation?.websiteURL) {
            inputs.push({ key: 'carrierWebsiteURL', value: carrierInformation.websiteURL });
        }
        if (carrierInformation?.phone) {
            let phoneString = this.phoneService.parsePhoneNumber(carrierInformation.phone);
            if (tty) {
                const ttyPhone = tty || '';
                const ttyResource = this.configResourceService.getProcessedResourceValue('Spa_Enrollment_TTY_Text', null, '');
                if (ttyPhone && ttyResource) {
                    phoneString += ` ${ttyResource} ${ttyPhone}`;
                }
                else if (ttyPhone && !ttyResource) {
                    phoneString += ` ${ttyPhone}`;
                }
            }
            inputs.push({ key: 'carrierPhone', value: phoneString });
        }
        return inputs;
    }
    getIsBrokerConfirmationEmailEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_NotifyAgentOfEnrollment', widgetName, true);
    }
    getBrokerConfirmationEmailInformationalText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_EnrollmentConfirmation_BrokerInformational_Text', widgetName, '');
    }
    getBrokerConfirmationEmailProviderLogo(widgetName) {
        return this.imageService.resolveFullImagePath(this.configResourceService.getProcessedResourceValue('Spa_HeaderFooter_PrimaryClientLogo', widgetName, 'phoenix/assets/images/healthcare_co.png'));
    }
    getIsAgentInContext() {
        return this.agentService.getIsAgentInContext();
    }
    getAgentEmailAddress() {
        return this.agentService.getAgentEmailAddress();
    }
    fetchPageHtml$(pageIndex, planId, locale) {
        const pageHtmlLocale = locale || this.localeService.getCurrentLocale();
        return this.store.dispatch(new FetchFormPageHtml(pageIndex, planId, pageHtmlLocale, this.planYearResourceService.getSelectedPlanYear()));
    }
    fetchPageInfo$(planId) {
        return this.store.dispatch(new FetchFormPageInfo(planId));
    }
    getEnrollmentCustomInternal() {
        const customInternal = sessionStorage.getItem(VNEXT_CUSTOM_INTERNAL);
        return customInternal ? JSON.parse(customInternal) : {};
    }
    updateTagForEnrollmentMethod(dataLayerTag, planId) {
        let tagsToUpdate = dataLayerTag;
        if (this.siteService.isPPCSite()) {
            const userFormType = this.store.selectSnapshot(EnrollmentState.selectedUserFormType(planId));
            tagsToUpdate = {
                ...dataLayerTag,
                [DataLayerGlobalVariable.ENROLLMENT_METHOD]: userFormType === UserTypeKeys.BROKER || userFormType === UserTypeKeys.CALLCENTER
                    ? ENROLLMENT_ON_BEHALF_OF_BENEFICIARY
                    : ENROLLMENT_SEND_TO_BENEFICIARY
            };
        }
        return tagsToUpdate;
    }
    updateTagForCrossSell(dataLayerTag, moreCoverageToEnroll) {
        const updatedTags = {
            ...dataLayerTag,
            [DataLayerGlobalVariable.CROSS_SELL_ENROLLMENT]: this.shoppingCartService.getEnrollmentPlanCount() > 1 ? GOOGLE_ANALYTICS_YES : GOOGLE_ANALYTICS_NO
        };
        if (moreCoverageToEnroll !== undefined) {
            updatedTags[DataLayerGlobalVariable.CROSS_SELL_CONTINUE_ENROLLMENT] = moreCoverageToEnroll
                ? GOOGLE_ANALYTICS_YES
                : GOOGLE_ANALYTICS_NO;
        }
        return updatedTags;
    }
    customInternalSetToSessionStorage() {
        return !!sessionStorage.getItem(VNEXT_CUSTOM_INTERNAL);
    }
    prepareCustomInternalForBean(customInternalWrapper, selectedUserType) {
        const customInternal = customInternalWrapper.CustomInternal;
        const applicantId = this.medSupMillimanCryptoService.getDecryptedApplicantId();
        const decryptedHICN = this.profileCryptoService.getDecryptedHICN();
        const storingData = {
            ...customInternal.StoringData,
            UserType: selectedUserType,
            ...(applicantId && { ApplicantSSN: applicantId }),
            ...(decryptedHICN && { ApplicantHICN: decryptedHICN })
        };
        const dynamicData = {
            ...customInternal.DynamicData,
            UserType: selectedUserType,
            ...(applicantId && { ApplicantSSN: applicantId }),
            ...(decryptedHICN && { ApplicantHICN: decryptedHICN })
        };
        const isProfileStateEligiblityCheckEnabled = this.configResourceService.getProcessedResourceValue('Spa_Profile_StateEligibilityCheck_Enabled', null, false);
        if (!isProfileStateEligiblityCheckEnabled ||
            !storingData.MedicaidEligibilityLevel ||
            !dynamicData.MedicaidEligibilityLevel ||
            storingData.ApplicantState !== storingData.MedicaidStateSelection ||
            dynamicData.ApplicantState !== dynamicData.MedicaidStateSelection) {
            storingData.MedicaidId = '';
            storingData.MedicaidEligibilityLevel = '';
            storingData.MedicaidStateSelection = '';
            storingData.MedicaidLastCheckedDate = '';
            dynamicData.MedicaidId = '';
            dynamicData.MedicaidEligibilityLevel = '';
            dynamicData.MedicaidStateSelection = '';
            dynamicData.MedicaidLastCheckedDate = '';
        }
        const formControlSettings = this.getPreparedFormControlSettings(applicantId, customInternal);
        return {
            CustomInternal: {
                ...customInternal,
                StoringData: storingData,
                DynamicData: dynamicData,
                ...(formControlSettings?.length && { FormControlSettings: formControlSettings })
            }
        };
    }
    fetchEnrollmentSettings$(sessionId, switchForm, selectedPlan, selectedRiders, planHasNextGenForm, formType) {
        this.soaService.checkForValidCompletedSOAsAndUpdate();
        if (planHasNextGenForm) {
            if (selectedPlan) {
                const planId = selectedPlan.id;
                const selectedFormType = formType ?? this.getSelectedFormType(planId);
                const userFormType = this.getUserFormType(planId);
                const planEnrollmentSettings = this.getPlanEnrollmentSettingsByType(planId, selectedFormType, userFormType);
                return of(this.mapPlanEnrollmentSettingsToBeanProviderSettings(planEnrollmentSettings));
            }
        }
        else {
            const enrollmentSettingsParams = this.createEnrollmentSettingsParams(switchForm, selectedPlan, selectedRiders);
            if (enrollmentSettingsParams) {
                // Updating userFormType (userType) value.
                this.updateUserFormType$(this.getUserFormTypeKey(enrollmentSettingsParams.userType), selectedPlan?.id);
                if (!planHasNextGenForm) {
                    this.store.dispatch(new FetchEnrollmentSettings(sessionId, enrollmentSettingsParams));
                }
                else {
                    return of(null);
                }
                return combineLatest([this.store.select(MemberState.enrollmentSettings), this.store.select(MemberState.loading)]).pipe(filter(([enrollmentSettings, loading]) => !loading && !!enrollmentSettings), map(([enrollmentSettings]) => enrollmentSettings), take(1));
            }
        }
        // enrolling plan was not found in the cart, abort enrollment
        this._enrollmentFormError = EnrollmentFormErrors.PLAN_NOT_IN_CART;
        return of(null);
    }
    mapPlanEnrollmentSettingsToBeanProviderSettings(planEnrollmentSettings) {
        const beanProviderSettings = new BeanProviderSettings();
        const enrollUrl = planEnrollmentSettings.enrollUrl;
        beanProviderSettings.beanMessage = planEnrollmentSettings.enrollMessage;
        beanProviderSettings.destinationUrl = enrollUrl;
        beanProviderSettings.isExternal = !!enrollUrl;
        beanProviderSettings.formId = planEnrollmentSettings.formId;
        return beanProviderSettings;
    }
    createEnrollmentSettingsParams(switchForm, selectedPlan, selectedRiders, isHRA = false) {
        const enrollmentSettingsParams = new EnrollmentSettingsParams();
        if (selectedPlan?.id) {
            const applicantProfileZip = this.store.selectSnapshot(ProfileState.zip);
            const demographicZip = this.memberSessionService.getZipCode();
            if (applicantProfileZip?.length && applicantProfileZip !== demographicZip) {
                enrollmentSettingsParams.applyEmptyAddress = true;
            }
            enrollmentSettingsParams.planIds = [selectedPlan.id];
            enrollmentSettingsParams.formType = this.getSelectedFormTypeForEnrollmentSettings(isHRA, selectedPlan.id);
            if (isHRA) {
                enrollmentSettingsParams.confirmationUrl = this.navigationUtilityService.constructAbsoluteUrl(PageTags.HRA_CONFIRMATION);
                enrollmentSettingsParams.destinationUrl = this.navigationUtilityService.constructHref(PageTags.HRA_FORM);
            }
            else {
                enrollmentSettingsParams.confirmationUrl = this.navigationUtilityService.constructAbsoluteUrl(PageTags.ENROLLMENT_CONFIRMATION);
                enrollmentSettingsParams.destinationUrl = this.navigationUtilityService.constructHref(PageTags.ENROLLMENT);
            }
            const isMedigap = selectedPlan.planType === PlanType.MEDIGAP;
            enrollmentSettingsParams.isMedigap = isMedigap;
            enrollmentSettingsParams.isTestingSite = this.configResourceService.isTestingSite();
            const totalPremium = `${this.plansService.getTotalPremium([selectedPlan], selectedRiders)}`;
            if (isMedigap) {
                enrollmentSettingsParams.medigapPremium = totalPremium;
            }
            else {
                enrollmentSettingsParams.calculatedPremium = totalPremium;
            }
            enrollmentSettingsParams.riderData = this.getRiderData(selectedRiders);
            if (switchForm) {
                enrollmentSettingsParams.switchForm = true;
                enrollmentSettingsParams.transactionSID = this.store.selectSnapshot(EnrollmentState.transactionId(selectedPlan.id));
            }
            enrollmentSettingsParams.userType = this.getSiteUserType(selectedPlan.id);
            enrollmentSettingsParams.includeMailingAddress = false;
            const customParamData = new CustomParamData();
            customParamData.planYear = this.planYearResourceService.getSelectedPlanYear();
            enrollmentSettingsParams.customParamData = customParamData;
            // enrollmentSettingsParams.allowCustomParamEmptyData = true;
            enrollmentSettingsParams.planNetwork_ShowUAT = this.configResourceService.getProcessedResourceValue(PLAN_NETWORK_SHOW_UAT_RESOURCE_KEY, null, false);
            // enrollmentSettingsParams.bean_AgentIDLogEnabled = true;
            // enrollmentSettingsParams.isPreviewSite = true;
            enrollmentSettingsParams.referringDomain = window.location.origin;
            const agentGuid = this.agentService.getAgentInContextGuid();
            if (agentGuid) {
                enrollmentSettingsParams.agentGuid = agentGuid;
            }
            const quoteId = this.quoteService.getBeneficiaryQuoteId();
            if (quoteId) {
                enrollmentSettingsParams.quoteId = quoteId;
            }
            if (this.ssoPopulatedFieldService.isReadOnlyEnabled()) {
                const ssoPopulatedFields = this.ssoPopulatedFieldService.getPopulatedData();
                if (ssoPopulatedFields) {
                    enrollmentSettingsParams.ssoPopulatedFields = ssoPopulatedFields;
                }
            }
            if (this.plansService.getIsPlanFeesEnabled() && !MEDICARE_PLAN_TYPES.includes(selectedPlan.planTypeAbbreviation)) {
                enrollmentSettingsParams.planFees = selectedPlan?.fees ?? [];
            }
            enrollmentSettingsParams.sourceSiteID = this.quoteService.getSourceSiteId();
            const customInternalResource = this.getCustomInternalResource();
            const customInternal = this.prepareCustomInternalForBean(customInternalResource, enrollmentSettingsParams.userType);
            enrollmentSettingsParams.Enrollment_CustomJson = customInternal;
            this.setCustomInternalToSessionStorage(customInternal, isMedigap);
            return enrollmentSettingsParams;
        }
        else {
            return null;
        }
    }
    getSiteUserType(activeEnrollmentKey) {
        const selectedUserType = this.getUserFormTypeValue(activeEnrollmentKey, this.getUserFormType(activeEnrollmentKey));
        return selectedUserType || this.siteService.getSiteUserTypeValue();
    }
    rehydrateCustomInternal(activeEnrollmentKey) {
        const selectedPlan = this.shoppingCartService.getPlan(activeEnrollmentKey);
        if (selectedPlan) {
            const isMedigap = selectedPlan.planType === PlanType.MEDIGAP;
            const userType = this.getSiteUserType(activeEnrollmentKey);
            const customInternalResource = this.getCustomInternalResource();
            const customInternal = this.prepareCustomInternalForBean(customInternalResource, userType);
            this.setCustomInternalToSessionStorage(customInternal, isMedigap);
        }
    }
    getAllSelectedRiders(plan) {
        const selectedRiderIds = this.shoppingCartService.getSelectedRiderIds();
        return plan.riders.filter(rider => selectedRiderIds.includes(rider.planID));
    }
    getRiderData(selectedRiders = []) {
        return selectedRiders.reduce((riderData, rider) => {
            const riderMedicalPremium = this.ridersService.getRiderMedicalPremium(rider);
            riderData[rider.planID] = riderMedicalPremium !== undefined && riderMedicalPremium !== null ? `${riderMedicalPremium}` : '0';
            return riderData;
        }, {});
    }
    getActiveEnrollmentKey() {
        return this.store.selectSnapshot(EnrollmentState.activeEnrollmentKey);
    }
    getActivePlanId() {
        return this.store.selectSnapshot(EnrollmentState.activePlanId);
    }
    getCrossSellEnrollmentTypes() {
        return this.store.selectSnapshot(EnrollmentState.crossSellEnrollmentTypes);
    }
    getFormLoading$(enrollmentKey) {
        return this.store.select(EnrollmentState.formLoading(enrollmentKey));
    }
    getFormLoaded$(enrollmentKey) {
        return this.store.select(EnrollmentState.formLoaded(enrollmentKey));
    }
    getNextGenFormLoading$(enrollmentKey) {
        return this.store.select(EnrollmentState.nextGenFormLoading(enrollmentKey));
    }
    getNextGenFormLoaded$(enrollmentKey) {
        return this.store.select(EnrollmentState.nextGenFormLoaded(enrollmentKey));
    }
    getConfirmationDataLoading$(enrollmentKey) {
        return this.store.select(EnrollmentState.confirmationDataLoading(enrollmentKey));
    }
    getIsPCApiEnrollment$(enrollmentKey) {
        return this.store.select(EnrollmentState.isPCApiEnrollment(enrollmentKey));
    }
    isRedirectedFromPlanCompareApi() {
        return this.agentService.isRedirectedFromPlanCompareApi();
    }
    isPlanCompareApiAgentDataEnabled() {
        return this.agentService.isPlanCompareApiAgentDataEnabled();
    }
    getTransaction(enrollmentKey) {
        return enrollmentKey ? this.store.selectSnapshot(EnrollmentState.transaction(enrollmentKey)) : null;
    }
    getNextGenTransaction(enrollmentKey) {
        return enrollmentKey ? this.store.selectSnapshot(EnrollmentState.nextGenEnrollmentFormTransaction(enrollmentKey)) : null;
    }
    getNextGenTransaction$(enrollmentKey) {
        return enrollmentKey ? this.store.select(EnrollmentState.nextGenEnrollmentFormTransaction(enrollmentKey)) : null;
    }
    hasNextGenTransaction$(enrollmentKey) {
        return enrollmentKey && this.store.select(EnrollmentState.hasNextGenEnrollmentFormTransaction(enrollmentKey));
    }
    hasNextGenTransaction(enrollmentKey) {
        return enrollmentKey && this.store.selectSnapshot(EnrollmentState.hasNextGenEnrollmentFormTransaction(enrollmentKey));
    }
    isNextGenEnrollmentStarted$(enrollmentKey) {
        return enrollmentKey && this.store.select(EnrollmentState.isNextGenEnrollmentStarted(enrollmentKey));
    }
    getNextGenTransactionId(enrollmentKey) {
        return enrollmentKey ? this.store.selectSnapshot(EnrollmentState.nextGenTransactionId(enrollmentKey)) : null;
    }
    getNextGenTransactionId$(enrollmentKey) {
        return enrollmentKey ? this.store.select(EnrollmentState.nextGenTransactionId(enrollmentKey)) : null;
    }
    getNextGenPrefillData(enrollmentKey) {
        return enrollmentKey ? this.store.selectSnapshot(EnrollmentState.nextGenEnrollmentPrefillData(enrollmentKey)) : null;
    }
    getNextGenPrefillData$(enrollmentKey) {
        return enrollmentKey ? this.store.select(EnrollmentState.nextGenEnrollmentPrefillData(enrollmentKey)) : null;
    }
    getNextGenEnrollmentSepReasons(enrollmentKey) {
        return enrollmentKey ? this.store.selectSnapshot(EnrollmentState.nextGenEnrollmentSepReasons(enrollmentKey)) : null;
    }
    getNextGenEnrollmentSepReasons$(enrollmentKey) {
        return enrollmentKey ? this.store.select(EnrollmentState.nextGenEnrollmentSepReasons(enrollmentKey)) : null;
    }
    isNextGenFormLoaded$(enrollmentKey) {
        return enrollmentKey ? this.store.select(EnrollmentState.nextGenFormLoaded(enrollmentKey)) : null;
    }
    isNextGenFormLoading$(enrollmentKey) {
        return enrollmentKey ? this.store.select(EnrollmentState.nextGenFormLoading(enrollmentKey)) : null;
    }
    getExternalEnrollmentUserType(enrollmentKey) {
        return this.store.selectSnapshot(EnrollmentState.nextGenTransactionExternalEnrollmentUserType(enrollmentKey));
    }
    getForm(enrollmentKey) {
        return enrollmentKey ? this.store.selectSnapshot(EnrollmentState.form(enrollmentKey)) : null;
    }
    getTransactionId(enrollmentKey) {
        const isNextGenForm = this.planHasNextGenForm(enrollmentKey);
        return isNextGenForm
            ? this.store.selectSnapshot(EnrollmentState.nextGenTransactionId(enrollmentKey))
            : this.store.selectSnapshot(EnrollmentState.transactionId(enrollmentKey));
    }
    getTransactionStatus(enrollmentKey) {
        const isNextGenForm = this.planHasNextGenForm(enrollmentKey);
        return isNextGenForm
            ? this.store.selectSnapshot(EnrollmentState.nextGenEnrollmentFormTransaction(enrollmentKey))?.status
            : this.store.selectSnapshot(EnrollmentState.transaction(enrollmentKey))?.status;
    }
    getFormPage(enrollmentKey, pageName) {
        return this.store.selectSnapshot(EnrollmentState.page(enrollmentKey, pageName));
    }
    getFormPageHtml$(enrollmentKey, pageName) {
        return this.store.select(EnrollmentState.pageHtml(enrollmentKey, pageName));
    }
    getFormPageHtml(enrollmentKey, pageName) {
        return this.store.selectSnapshot(EnrollmentState.pageHtml(enrollmentKey, pageName));
    }
    getFormPageDirty$(enrollmentKey, pageName) {
        return this.store.select(EnrollmentState.pageDirty(enrollmentKey, pageName));
    }
    getFormPageDirty(enrollmentKey, pageName) {
        return this.store.selectSnapshot(EnrollmentState.pageDirty(enrollmentKey, pageName));
    }
    getFormPageLoading$(enrollmentKey, pageName) {
        return this.store.select(EnrollmentState.formPageLoading(enrollmentKey, pageName));
    }
    setFormPageLoading$(loading, loaded, enrollmentKey) {
        return this.store.dispatch(new SetFormLoading(loading, loaded, enrollmentKey));
    }
    setNextGenFormLoading$(enrollmentKey, loading) {
        return this.store.dispatch(new SetNextGenFormLoading(enrollmentKey, loading));
    }
    setNextGenFormLoaded$(enrollmentKey, loaded) {
        return this.store.dispatch(new SetNextGenFormLoaded(enrollmentKey, loaded));
    }
    setConfirmationDataLoading$(loading, enrollmentKey) {
        return this.store.dispatch(new SetConfirmationDataLoading(loading, enrollmentKey));
    }
    setActiveEnrollmentKey(enrollmentKey) {
        this.store.dispatch(new SetActiveEnrollmentKey(enrollmentKey));
    }
    setActiveEnrollmentKey$(enrollmentKey) {
        return this.store.dispatch(new SetActiveEnrollmentKey(enrollmentKey));
    }
    resetActiveEnrollmentKey() {
        this.store.dispatch(new ResetActiveEnrollmentKey());
    }
    setCrossSellEnrollmentTypes(enrollmentTypes) {
        this.store.dispatch(new SetCrossSellEnrollmentTypes(enrollmentTypes));
    }
    resetCrossSellEnrollmentTypes() {
        this.store.dispatch(new ResetCrossSellEnrollmentTypes());
    }
    setGenericFormAsActiveEnrollment() {
        const formId = this.configResourceService.getProcessedResourceValue('Spa_GenericForm_FormId');
        this.setActiveEnrollmentKey(formId);
    }
    getFormPages(enrollmentKey) {
        return this.store.selectSnapshot(EnrollmentState.formPages(enrollmentKey));
    }
    getFormPages$(enrollmentKey) {
        return this.store.select(EnrollmentState.formPages(enrollmentKey));
    }
    getVisitedStatus$(enrollmentKey, pageIndex) {
        return this.getFormPages$(enrollmentKey).pipe(map(formPages => formPages.find(formPage => formPage.pageIndex === pageIndex)), filter(formPage => !!formPage), map(formPage => formPage.visited));
    }
    getPageIndex(enrollmentKey, pageName) {
        const pageIndex = this.store.selectSnapshot(EnrollmentState.pageIndex(enrollmentKey, pageName));
        // default to first page in flow if the pageName is not found in page info
        return !!pageIndex && pageIndex > 0 ? pageIndex : 0;
    }
    getPageInfo$(enrollmentKey) {
        return this.store.select(EnrollmentState.formPageInfo(enrollmentKey));
    }
    getPageInfo(enrollmentKey) {
        return this.store.selectSnapshot(EnrollmentState.formPageInfo(enrollmentKey));
    }
    getPageName(enrollmentKey, index) {
        return this.store.selectSnapshot(EnrollmentState.pageName(enrollmentKey, index));
    }
    getSelectedFormType(enrollmentKey) {
        return this.store.selectSnapshot(EnrollmentState.selectedFormType(enrollmentKey));
    }
    getSelectedFormType$(enrollmentKey) {
        return this.store.select(EnrollmentState.selectedFormType(enrollmentKey));
    }
    getUserFormType(enrollmentKey) {
        return this.store.selectSnapshot(EnrollmentState.selectedUserFormType(enrollmentKey));
    }
    getUserFormType$(enrollmentKey) {
        return this.store.select(EnrollmentState.selectedUserFormType(enrollmentKey));
    }
    isNextGenFormSignAndSubmitOnly(enrollmentKey) {
        return this.store.selectSnapshot(EnrollmentState.isNextGenFormSignAndSubmitOnly(enrollmentKey));
    }
    isMemberEnrollmentExpired(enrollmentKey) {
        return this.store.selectSnapshot(MemberState.isMemberEnrollmentExpired(enrollmentKey));
    }
    planHasNextGenForm(planID) {
        return this.store.selectSnapshot(MemberState.planHasNextGenForm(planID));
    }
    planHasNextGenForm$(planID) {
        return this.store.select(MemberState.planHasNextGenForm(planID));
    }
    planHasNextGenHRAForm(formId, planId) {
        return this.store.selectSnapshot(MemberState.planHasNextGenHRAForm(formId, planId));
    }
    planHasNextGenHRAForm$(formId, planId) {
        return this.store.select(MemberState.planHasNextGenHRAForm(formId, planId));
    }
    hasNextGenEnrollmentFormTransaction$(formId) {
        return this.store.select(EnrollmentState.hasNextGenEnrollmentFormTransaction(formId));
    }
    hasNextGenEnrollmentFormTransaction(formId) {
        return this.store.selectSnapshot(EnrollmentState.hasNextGenEnrollmentFormTransaction(formId));
    }
    getPageIsEnrollment() {
        return this.navigationUtilityService.pageTagURLMatch(PageTags.ENROLLMENT, this.navigationContext.getUrl());
    }
    getCMSApprovalCode$(enrollmentKey = this.getActiveEnrollmentKey()) {
        const isNextGenForm = this.planHasNextGenForm(enrollmentKey);
        return isNextGenForm
            ? this.store.select(EnrollmentState.nextGenFormCMSApprovalCode(enrollmentKey))
            : this.store.select(EnrollmentState.hopeCMSApprovalCode(enrollmentKey));
    }
    getCMSApprovalCode(enrollmentKey = this.getActiveEnrollmentKey()) {
        const isNextGenForm = this.planHasNextGenForm(enrollmentKey);
        return isNextGenForm
            ? this.store.selectSnapshot(EnrollmentState.nextGenFormCMSApprovalCode(enrollmentKey))
            : this.store.selectSnapshot(EnrollmentState.hopeCMSApprovalCode(enrollmentKey));
    }
    getEnrollmentPlanSettingsLoaded(enrollmentKey = this.getActiveEnrollmentKey()) {
        return this.store.selectSnapshot(MemberState.enrollmentPlanSettingsLoaded(enrollmentKey));
    }
    isEnrollmentPlanSettingsLoadedForSelectedFormType(enrollmentKey = this.getActiveEnrollmentKey(), selectedFormType) {
        return this.store.selectSnapshot(MemberState.enrollmentPlanSettingsLoadedByFormType(enrollmentKey, selectedFormType));
    }
    getEnrollmentPlanHRASettingsLoaded(formId, planId) {
        return this.store.selectSnapshot(MemberState.enrollmentPlanHRASettingsLoaded(formId, planId));
    }
    getEnrollmentPlanHRASettingsLoaded$(formId, planId) {
        return this.store.select(MemberState.enrollmentPlanHRASettingsLoaded(formId, planId));
    }
    getEnrollmentPlanHRASettings(formId, planId) {
        return this.store.selectSnapshot(MemberState.enrollmentPlanHRASettings(formId, planId));
    }
    setPageVisited(pageIndex, enrollmentKey) {
        this.store.dispatch(new SetPageVisited(pageIndex, enrollmentKey));
    }
    setPageComplete(pageIndex, enrollmentKey) {
        this.store.dispatch(new SetPageComplete(pageIndex, enrollmentKey));
    }
    setCallRecordingAvailable() {
        this.twilioService.setCallRecordingAvailable();
    }
    setPageSkipped(pageIndex, skipped, enrollmentKey) {
        this.store.dispatch(new SetPageSkipped(pageIndex, skipped, enrollmentKey));
    }
    updateSelectedFormType$(formType, enrollmentKey, planHasNextGenForm) {
        return this.store.dispatch(new UpdateSelectedFormType(formType, enrollmentKey, planHasNextGenForm));
    }
    updateUserFormType$(userFormType, enrollmentKey, isFormSignAndSubmitOnly) {
        return this.store.dispatch(new UpdateUserFormType(userFormType, enrollmentKey, isFormSignAndSubmitOnly));
    }
    updateCMSApprovalCode$(formCMSApprovalCode, enrollmentKey = this.getActiveEnrollmentKey()) {
        return this.store.dispatch(new UpdateCMSApprovalCode(formCMSApprovalCode, enrollmentKey));
    }
    getUserFormTypeValue(enrollmentKey, userType) {
        const userFormType = userType || this.getUserFormType(enrollmentKey);
        switch (userFormType) {
            case UserTypeKeys.BROKER:
                return UserTypes.BROKER;
            case UserTypeKeys.CALLCENTER:
                return UserTypes.CALLCENTER;
            case UserTypeKeys.CONSUMER:
                return UserTypes.CONSUMER;
            case UserTypeKeys.ALL:
                return UserTypes.ALL;
            default:
                return null;
        }
    }
    getUserFormTypeKey(userType) {
        switch (userType) {
            case UserTypes.BROKER:
                return UserTypeKeys.BROKER;
            case UserTypes.CONSUMER:
                return UserTypeKeys.CONSUMER;
            case UserTypes.CALLCENTER:
                return UserTypeKeys.CALLCENTER;
            case UserTypes.ALL:
                return UserTypeKeys.ALL;
            default:
        }
    }
    createConfirmationSettings(planId, formType) {
        const confirmationSettings = new ConfirmationSettings();
        const enrollmentConfig = this.createEnrollmentConfirmationInfo(planId, formType);
        confirmationSettings.characterArray = enrollmentConfig.Enrollment_Confirmation_CharacterArray;
        confirmationSettings.digitArray = enrollmentConfig.Enrollment_Confirmation_DigitArray;
        confirmationSettings.format = enrollmentConfig.Enrollment_Confirmation_Format;
        confirmationSettings.prefix = enrollmentConfig.Enrollment_Confirmation_Prefix;
        confirmationSettings.suffix = enrollmentConfig.Enrollment_Confirmation_Suffix;
        return confirmationSettings;
    }
    createEnrollmentConfirmationInfo(planId, formType) {
        const enrollmentConfirmationInfo = new EnrollmentConfig();
        const selectedPlan = this.shoppingCartService.getPlan(planId);
        enrollmentConfirmationInfo.Enrollment_Confirmation_CharacterArray =
            this.configResourceService.getProcessedResourceValue('Spa_Site_EnrollmentConfirmationIdValidCharacters', null) ||
                this.plansService.getExtraDataValueByName(selectedPlan, PlanExtraDataKey.ENROLLMENT_CONFIRMATION_CHARACTER_ARRAY, '56789');
        enrollmentConfirmationInfo.Enrollment_Confirmation_DigitArray =
            this.configResourceService.getProcessedResourceValue('Spa_Site_EnrollmentConfirmationIdValidDigits', null) ||
                this.plansService.getExtraDataValueByName(selectedPlan, PlanExtraDataKey.ENROLLMENT_CONFIRMATION_DIGIT_ARRAY, '0123456789');
        enrollmentConfirmationInfo.Enrollment_Confirmation_Format =
            this.configResourceService.getProcessedResourceValue('Spa_Site_EnrollmentConfirmationIdFormat', null) ||
                this.plansService.getExtraDataValueByName(selectedPlan, PlanExtraDataKey.ENROLLMENT_CONFIRMATION_FORMAT, '@#############');
        enrollmentConfirmationInfo.Enrollment_Confirmation_Prefix = this.getEnrollmentConfirmationPrefix(planId, formType);
        enrollmentConfirmationInfo.Enrollment_Confirmation_Suffix =
            this.configResourceService.getProcessedResourceValue('Spa_Site_EnrollmentConfirmationIdSuffix', null) ||
                this.plansService.getExtraDataValueByName(selectedPlan, PlanExtraDataKey.ENROLLMENT_CONFIRMATION_SUFFIX);
        return enrollmentConfirmationInfo;
    }
    getEnrollmentConfirmationPrefix(planId, formType) {
        let selectedPlan;
        if (formType === EnrollmentFormType.SHORT) {
            const shortFormSitePrefix = this.configResourceService.getProcessedResourceValue('Spa_Site_ShortForm_EnrollmentConfirmationIdPrefix', null);
            if (shortFormSitePrefix) {
                return shortFormSitePrefix;
            }
            selectedPlan = this.shoppingCartService.getPlan(planId);
            const shortFormPlanPrefix = this.plansService.getExtraDataValueByName(selectedPlan, PlanExtraDataKey.ENROLLMENT_CONFIRMATION_PREFIX_SHORT);
            if (shortFormPlanPrefix) {
                return shortFormPlanPrefix;
            }
        }
        else {
            selectedPlan = this.shoppingCartService.getPlan(planId);
        }
        return (this.configResourceService.getProcessedResourceValue('Spa_Site_EnrollmentConfirmationIdPrefix', null) ||
            this.plansService.getExtraDataValueByName(selectedPlan, PlanExtraDataKey.ENROLLMENT_CONFIRMATION_PREFIX));
    }
    navigateToEnrollmentPage(planId, planTypeID, selectedRiderIDs, userType, planYear, isFormSignAndSubmitOnly = false) {
        this.spinnerService.show(SpinnerEvent.NAVIGATE_TO_ENROLLMENT);
        this.updateEnrollmentPlanYear(planYear);
        const searchOptions = this.plansService.createPlansSearchOptionsWithDefaults({ year: planYear });
        this.plansService
            .fetchPlansDetails$([planId], PlanType[planTypeID], null, searchOptions)
            .pipe(take(1))
            .subscribe({
            next: plansData => {
                if (plansData.length) {
                    this.store.dispatch(new ResetShoppingCartState());
                    this.resetActiveEnrollmentKey();
                    this.store.dispatch(new SelectPlan(plansData[0]));
                    if (userType) {
                        this.updateUserFormType$(this.getUserFormTypeKey(userType.toLowerCase()), planId, isFormSignAndSubmitOnly);
                    }
                    if (selectedRiderIDs) {
                        selectedRiderIDs.forEach(riderId => this.store.dispatch(new SelectRider(riderId)));
                    }
                    this.setActiveEnrollmentKey(planId);
                    this.navigationService.navigateByPageTag(PageTags.ENROLLMENT).then(() => {
                        this.spinnerService.hide(SpinnerEvent.NAVIGATE_TO_ENROLLMENT);
                    });
                }
            },
            error: () => {
                this.spinnerService.hide(SpinnerEvent.NAVIGATE_TO_ENROLLMENT);
            }
        });
    }
    setPlanPostEnrollmentData(postEnrollmentResponse) {
        this.postEnrollmentResponse$.next(postEnrollmentResponse);
    }
    getPlanPostEnrollmentData$() {
        return this.postEnrollmentResponse$.asObservable();
    }
    setConsumerAccessEmailUrlParameters(url) {
        this.consumerAccessEmailUrlParameters$.next(url);
    }
    getConsumerAccessEmailUrlParameters$() {
        return this.consumerAccessEmailUrlParameters$.asObservable();
    }
    async updateFormTransactionAnswers(planId, answers, planHasNextGenForm) {
        if (planHasNextGenForm) {
            await this.updateNextGenFormTransactionAnswers(planId, answers);
        }
        else {
            await this.updateHopeFormTransactionAnswers(planId, answers);
        }
    }
    async updateNextGenFormTransactionAnswers(planId, answers) {
        const transaction = this.getNextGenTransaction(planId);
        if (transaction) {
            return await firstValueFrom(this.updateNextGenTransaction$(answers, planId));
        }
        return null;
    }
    async updateHopeFormTransactionAnswers(planId, answers) {
        const transaction = this.getTransaction(planId);
        if (transaction) {
            const updateTransactionRequest = EnrollmentTransactionRequest.createUpdateTransaction(null, answers, `${this.getSelectedFormType(planId).valueOf()}`);
            return await firstValueFrom(this.updateFormTransaction$(updateTransactionRequest, planId));
        }
        return null;
    }
    async sendConsumerConfirmationEmail(config) {
        const { planId, generatedUrlParameters, email, widgetName } = config;
        if (this.configResourceService.getProcessedResourceValue('Spa_EnrollmentConfirmation_SendConfirmationEmail', widgetName, true)) {
            const planHasNextGenForm = this.planHasNextGenForm(planId);
            const asyncOperations = [
                firstValueFrom(planHasNextGenForm
                    ? this.fetchNextGenTransaction$(this.memberSessionService.getMemberSessionId(), planId, this.store.selectSnapshot(EnrollmentState.nextGenTransactionId(planId)))
                    : this.fetchTransaction$(planId, this.getTransactionId(planId)))
            ];
            if (generatedUrlParameters) {
                asyncOperations.push(this.getEnrollmentDetailUrl(generatedUrlParameters));
            }
            const asyncOperationsResult = await Promise.all(asyncOperations);
            const consumerEmailAddress = email ||
                this.enrollmentFunctionService.getEnrollmentAnswer('ApplicantEmailAddress', planId) ||
                this.store.selectSnapshot(ProfileState.emailAddress);
            if (consumerEmailAddress?.length > 0) {
                const submissionDate = this.enrollmentFunctionService.getEnrollmentAnswer('SubmissionDate', planId);
                const formattedDate = this.formatEnrollmentDate(submissionDate);
                const data = [
                    { key: 'enrollmentDate', value: formattedDate },
                    ...this.getConsumerEnrollmentConfirmationEmailResourceData(planId)
                ];
                const subject = this.configResourceService.getProcessedResourceValue('Spa_EnrollmentConfirmation_Email_Subject', null, 'Application confirmation');
                const isAgentInfoEnabled = this.configResourceService.getProcessedResourceValue('Spa_EnrollmentConfirmation_ShowBroker_Flag', null, false);
                const isPlanCompareApiAgentDataEnabled = this.agentService.isPlanCompareApiAgentDataEnabled();
                const isAgentInContext = this.getIsAgentInContext();
                const showAgentInformation = isAgentInfoEnabled && (isAgentInContext || this.agentService.isAgentLoggedIn() || isPlanCompareApiAgentDataEnabled);
                if (showAgentInformation) {
                    const agentPhoneNumberFormatted = this.phoneService.formatPhoneNumberWithExtension(this.agentService.getAgentPhone(), this.agentService.getAgentExtension());
                    let agentName;
                    let agentNPN;
                    let californiaLicenseNumber;
                    if (isPlanCompareApiAgentDataEnabled) {
                        const planCompareApiAgentData = this.agentService.getPlanCompareApiAgentData(planId);
                        ({ agentName, agentNPN, californiaLicenseNumber } = planCompareApiAgentData);
                    }
                    else {
                        agentName = this.agentService.getBrokerFullName();
                        agentNPN = this.agentService.getAgentNPN();
                        californiaLicenseNumber = this.agentService.getCaliforniaLicenseNumber();
                    }
                    data.push({ key: 'agentName', value: agentName }, { key: 'agentNPN', value: agentNPN }, { key: 'agentPhoneNumber', value: agentPhoneNumberFormatted }, { key: 'showAgentInformation', value: showAgentInformation.toString() }, { key: 'californiaLicenseNumber', value: californiaLicenseNumber });
                }
                const currentLocale = this.localeService.getCurrentLocale();
                this.getPlanPostEnrollmentData$()
                    .pipe(take(1))
                    .subscribe({
                    next: (postEnrollment) => {
                        const postEnrollmentEmailText = postEnrollment?.postEnrollmentMessages?.confirmationEmailText?.[currentLocale] ?? '';
                        data.push({ key: 'postEnrollmentText', value: postEnrollmentEmailText });
                    }
                });
                data.push({ key: 'agentInContext', value: isAgentInContext.toString() });
                if (generatedUrlParameters && asyncOperationsResult?.[1]) {
                    data.push({ key: 'enrollmentDetailUrl', value: asyncOperationsResult[1] });
                }
                await this.emailService.sendEmail(EmailNames.CONFIRMATION_WITH_BROKER, [consumerEmailAddress], subject, data);
            }
        }
    }
    getFormattedDateForConfirmationEmail(transaction) {
        const enrollmentDate = this.getPropertyFromTransaction(transaction, 'SubmissionDate');
        // enrollment date is in format such as "03/31/2020 04:53:00PM" which cannot be parsed by the date constructor
        // taking the first section only allows parsing
        return this.formatEnrollmentDate(enrollmentDate);
    }
    formatEnrollmentDate(enrollmentDate) {
        const utcDate = enrollmentDate ? DateUtilities.getDateFromString(enrollmentDate, 'MM/DD/YYYY hh:mm:ssA') : new Date();
        return DateUtilities.getFormattedPTDate(utcDate, 'LL');
    }
    showAgentFormSelection(planSettings, isMedicareEdge = false) {
        // We should ideally have at least 2 long forms.  However there is the edge case
        // where we would have 1 long broker (all/broker userType) form and 1 short (consumer/all)
        // form.
        if (planSettings) {
            // The consumer or broker selection is only applicable when there is a valid formId(that is, for internal forms).
            // not for External or Message only plans.
            const siteEnrollmentSettings = planSettings.filter(setting => !setting.isConsumerUrlSiteSettings && setting.formId !== null);
            const consumerUrlEnrollmentSettings = planSettings.filter(setting => setting.isConsumerUrlSiteSettings && setting.formId !== null);
            const siteUserTypes = siteEnrollmentSettings?.map(setting => setting.userType.toLowerCase());
            // We won't have consumerUrlEnrollmentSettings on edge sites, so we just use the entire set of settings for the check for all/consumer instead
            const consumerUrlUserTypes = (isMedicareEdge ? siteEnrollmentSettings : consumerUrlEnrollmentSettings)?.map(setting => setting.userType.toLowerCase());
            return (siteUserTypes.some(userType => userType === UserTypes.ALL || userType === UserTypes.BROKER || userType === UserTypes.CALLCENTER) &&
                consumerUrlUserTypes.some(userType => userType === UserTypes.ALL || userType === UserTypes.CONSUMER));
        }
        return false;
    }
    setCustomInternalToSessionStorage(customInternalWrapper, isMedigap = false) {
        sessionStorage.setItem(VNEXT_CUSTOM_INTERNAL, this.processCustomInternal(customInternalWrapper, isMedigap));
    }
    parseStringToBoolean(booleanString) {
        return booleanString?.trim().toLowerCase() === 'true';
    }
    getTransactionGuidFromPartialEnrollment(planId) {
        let transactionGuid = '';
        if (planId) {
            const enrollments = this.enrollmentHistoryService.getEnrollments([planId]);
            const partialEnrollment = enrollments?.find(enrollment => !enrollment.completedWhen && !enrollment.confirmationNumber);
            if (partialEnrollment) {
                transactionGuid = partialEnrollment.nativeTransactionID;
            }
        }
        return transactionGuid;
    }
    async getAgentLoginShortUrl(widgetName) {
        const defaultAgentLoginUrl = 'http://localhost:4200';
        const baseUrl = this.configResourceService.getProcessedResourceValue('Spa_Site_AgentLogin_Url', widgetName, defaultAgentLoginUrl) ||
            defaultAgentLoginUrl;
        const agentLoginUrl = new URL(baseUrl);
        agentLoginUrl.searchParams.set(UTMParameter.UTM_SOURCE, UTMValue.UTM_SOURCE_PLAN_COMPARE);
        agentLoginUrl.searchParams.set(UTMParameter.UTM_MEDIUM, UTMValue.UTM_MEDIUM_EMAIL);
        agentLoginUrl.searchParams.set(UTMParameter.UTM_CAMPAIGN, UTMValue.UTM_CAMPAIGN_APPLICATION_DONE);
        const agentLoginShortUrl = await this.messagesService.getShortUrl(agentLoginUrl.href);
        return agentLoginShortUrl;
    }
    // this is the root route for enrollment. we get forminfo to populate the "virtual routes" for
    // enrollment. landing on the root page really isn't a normal situation as it redirects to the
    // first page returned by form info. We do however have a need to know if we are on the root page
    // so we can respond to that for analytics or form set up
    getEnrollmentRootPage() {
        return this.store.selectSnapshot(AppConfigState.hrefByTag(PageTags.ENROLLMENT));
    }
    getHRAEnrollmentRootPage() {
        return this.store.selectSnapshot(AppConfigState.hrefByTag(PageTags.HRA_FORM));
    }
    validateMatchingShortForm(planId, shortFormSettings) {
        this.validateMatchingForm(planId, shortFormSettings, EnrollmentFormType.SHORT);
    }
    validateMatchingLongForm(planId, longFormSettings) {
        this.validateMatchingForm(planId, longFormSettings, EnrollmentFormType.LONG);
    }
    saveVoiceSignatureStatements$(sessionId, transactionGuid, voiceSignatureSections, locale) {
        return this.memberSessionService.saveVoiceSignatureStatements$(sessionId, transactionGuid, voiceSignatureSections, locale);
    }
    async getEnrollmentDetailUrl(generatedUrlParameters) {
        const authenticationPageTag = PageTags.BENEFICIARY_AUTHENTICATION;
        const baseUrl = this.siteService.getBaseConsumerSiteUrl();
        const url = this.navigationUtilityService.addHrefToUrl(baseUrl, authenticationPageTag, generatedUrlParameters);
        const queryString = new URL(url);
        return await firstValueFrom(this.messagesService.getShortUrl$(queryString.href));
    }
    getPlanEnrollmentSettings$(planID) {
        return this.memberSessionService.planEnrollmentSettings$(planID);
    }
    getPlanEnrollmentSettings(planID) {
        return this.memberSessionService.planEnrollmentSettings(planID);
    }
    getPlanEnrollmentSettingsByType(planID, selectedFormType, userType, isFormSignAndSubmitOnly) {
        return this.memberSessionService.getPlanEnrollmentSettingsByType(planID, selectedFormType, userType, isFormSignAndSubmitOnly);
    }
    nextGenValidateEnrollment$(payload, validationType) {
        return this.enrollmentHttpService.validateEnrollment$(payload, validationType);
    }
    async nextGenValidateEnrollment(payload, validationType) {
        return await this.enrollmentHttpService.validateEnrollment(payload, validationType);
    }
    nextGenCheckMemberEligibility$(payload) {
        return this.enrollmentHttpService.checkMemberEligibility$(payload);
    }
    async nextGenCheckMemberEligibility(payload) {
        return await this.enrollmentHttpService.checkMemberEligibility(payload);
    }
    nextGenUploadFiles$(payload) {
        return this.enrollmentHttpService.uploadFiles$(payload);
    }
    async nextGenUploadFiles(payload) {
        return await this.enrollmentHttpService.uploadFiles(payload);
    }
    nextGenDeleteUploadedFile$(payload) {
        return this.enrollmentHttpService.deleteUploadedFile$(payload);
    }
    async nextGenDeleteUploadedFile(payload) {
        return await this.enrollmentHttpService.deleteUploadedFile(payload);
    }
    nextGenDownloadFile$(transactionGUID, fileId) {
        return this.enrollmentHttpService.downloadFile$(transactionGUID, fileId);
    }
    async nextGenDownloadFile(transactionGUID, fileId) {
        return await this.enrollmentHttpService.downloadFile(transactionGUID, fileId);
    }
    getEnrollmentAnswer$(name, activeEnrollmentKey = this.getActiveEnrollmentKey()) {
        return this.enrollmentFunctionService.getEnrollmentAnswer$(name, activeEnrollmentKey);
    }
    getEnrollmentAnswer(name, activeEnrollmentKey = this.getActiveEnrollmentKey()) {
        return this.enrollmentFunctionService.getEnrollmentAnswer(name, activeEnrollmentKey);
    }
    getNextGenEnrollmentAnswer(name, activeEnrollmentKey = this.getActiveEnrollmentKey()) {
        return this.enrollmentFunctionService.getNextGenEnrollmentAnswer(name, activeEnrollmentKey);
    }
    getFieldsToClearPrefillData(event, childForms) {
        const clearedPrefillDataFields = _get(event, 'detail.clearedPrefillDataFields');
        const preserveTransaction = _get(event, 'detail.preserveTransaction') === true;
        const currentPageAnswers = childForms?.first?.['currentPageAnswers'];
        let transactionFields = [];
        // If we are updating form answers within a page we need to make sure the answers already on the page
        // are persisted as well otherwise they will be overwritten when the /Answers call finishes and updates
        // the transaction on the page. Right now this is happening when we clear out panels but it could happen
        // in a multitude of scenarios.
        if (preserveTransaction && currentPageAnswers) {
            transactionFields = Object.entries(currentPageAnswers).map(entry => ({ name: entry[0], value: entry[1] }));
        }
        const fieldsToClear = clearedPrefillDataFields?.map(name => ({ name, value: '' })) ?? [];
        const mergedAnswers = transactionFields.concat(fieldsToClear).reduce((answers, item) => {
            if (item.name) {
                answers[item.name] = item.value;
            }
            return answers;
        }, {});
        return {
            mergedFieldsToUpdate: Object.entries(mergedAnswers).map(([name, value]) => ({ name, value })),
            transactionFields
        };
    }
    clearPrefillData(enrollmentKey, event, childForms) {
        const { mergedFieldsToUpdate, transactionFields } = this.getFieldsToClearPrefillData(event, childForms);
        if (mergedFieldsToUpdate?.length && !_isEqual(mergedFieldsToUpdate, transactionFields)) {
            this.updateNextGenTransaction$(mergedFieldsToUpdate, enrollmentKey);
        }
    }
    getNextGenRequestMedigapAnswers() {
        return {
            planAnswers: this.store.selectSnapshot(MedSupState.rawAnswers()),
            giReasons: this.medSupService.getGIReasons(),
            millimanAnswers: this.store.selectSnapshot(MillimanState.milliman)
        };
    }
    getHRAPlan() {
        return this.store.selectSnapshot(EnrollmentState.hraPlan);
    }
    getHRAPlanId() {
        return this.store.selectSnapshot(EnrollmentState.hraPlanId);
    }
    updateExpirationDate$(transactionGUID, payload) {
        return this.enrollmentHttpService.updateExpirationDate$(transactionGUID, payload);
    }
    /**
     * Checks the combination of selected riders (which may or may not be relevant due to loading up previous enrollments' selected riders)
     * And the data from plansRiderBenefitCategories so all selected Hospital Indemnity riders can be passed into enrollment.
     */
    selectHospitalIndemnityRiders(enrollingPlan, selectedRiders) {
        const selectedHospitalIndemnityRiders = this.store
            .selectSnapshot(PlansState.plansRiderBenefitCategories)?.[enrollingPlan.id]?.map(item => item.selectedRiderId)
            ?.reduce((selectedPlanRiders, riderId) => {
            const foundRider = enrollingPlan?.riders?.find(rider => rider.planID === riderId);
            if (foundRider) {
                selectedPlanRiders.push(foundRider);
            }
            return selectedPlanRiders;
        }, []) ?? [];
        const uniqueRiderIds = [
            ...new Set([...selectedRiders.map(rider => rider.planID), ...selectedHospitalIndemnityRiders.map(rider => rider.planID)])
        ];
        return uniqueRiderIds.reduce((selectedPlanRiders, riderId) => {
            const selectedRiderMatch = selectedRiders.find(selectedRider => selectedRider.planID === riderId);
            if (selectedRiderMatch) {
                selectedPlanRiders.push(selectedRiderMatch);
            }
            else {
                const selectedHospitalIndemnityRiderMatch = selectedHospitalIndemnityRiders.find(selectedRider => selectedRider.planID === riderId);
                if (selectedHospitalIndemnityRiderMatch) {
                    selectedPlanRiders.push(selectedHospitalIndemnityRiderMatch);
                }
            }
            return selectedPlanRiders;
        }, []);
    }
    getConsumerEnrollmentConfirmationEmailResourceData(planId) {
        const data = [];
        let planTypeAbbreviationResourceFragment = '';
        const planTypeAbbreviation = this.store.selectSnapshot(PlansState.plan(planId))?.planTypeAbbreviation;
        if (planTypeAbbreviation === PlanTypeAbbreviation.DENTAL) {
            planTypeAbbreviationResourceFragment = 'Dental';
        }
        if (planTypeAbbreviation === PlanTypeAbbreviation.VISION) {
            planTypeAbbreviationResourceFragment = 'Vision';
        }
        if (planTypeAbbreviation === PlanTypeAbbreviation.HC) {
            planTypeAbbreviationResourceFragment = 'HIP';
        }
        data.push({
            key: 'applicationSubmittedTitle',
            value: this.configResourceService.getProcessedResourceValue(`Spa_EnrollmentConfirmation_${planTypeAbbreviationResourceFragment}ApplicationSubmitted_Title`, null, '')
        });
        data.push({
            key: 'noticeBoxHeader',
            value: this.configResourceService.getProcessedResourceValue(`Spa_EnrollmentConfirmation_${planTypeAbbreviationResourceFragment}NoticeBox_Header`, null, '')
        });
        data.push({
            key: 'noticeBoxBody',
            value: this.configResourceService.getProcessedResourceValue(`Spa_EnrollmentConfirmation_${planTypeAbbreviationResourceFragment}NoticeBox_Body`, null, '')
        });
        data.push({
            key: 'whatToExpectTitle',
            value: this.configResourceService.getProcessedResourceValue(`Spa_EnrollmentConfirmation_${planTypeAbbreviationResourceFragment}WhatToExpect_Title`, null, '')
        });
        data.push({
            key: 'whatToExpectBody',
            value: this.configResourceService.getProcessedResourceValue(`Spa_EnrollmentConfirmation_${planTypeAbbreviationResourceFragment}WhatToExpect_EmailBody`, null, '')
        });
        data.push({
            key: 'aboveContactHtml',
            value: this.configResourceService.getProcessedResourceValue(`Spa_EnrollmentConfirmation_${planTypeAbbreviationResourceFragment}AboveContactInfo_Html`, null, '')
        });
        data.push({
            key: 'belowContactHtml',
            value: this.configResourceService.getProcessedResourceValue(`Spa_EnrollmentConfirmation_${planTypeAbbreviationResourceFragment}BelowContactInfo_Html`, null, '')
        });
        return data;
    }
    getSwitchForm(planId) {
        const currentTransaction = this.getTransaction(planId);
        return currentTransaction?.formType && !isNaN(currentTransaction.formType)
            ? this.getSelectedFormType(planId) !== currentTransaction.formType
            : false;
    }
    isCrossSellEnrollment() {
        const shoppingCartPlanTypes = this.shoppingCartService.getShoppingCartPlans();
        const isCrossSellEnrollment = this.shoppingCartService.isShoppingCartCrossSellEnrollment(shoppingCartPlanTypes);
        return isCrossSellEnrollment && this.getCrossSellEnrollmentTypes() !== CrossSellEnrollmentTypes.NOT_CROSSSELL;
    }
    getAgentAnswersToRemove(widgetName) {
        // This object was originally for an update transaction call. For simplicitly, we're still re-using it as is to get key names
        // Was last seen in SPA-6336, then now updated for SPA-9624
        return this.configResourceService.getProcessedResourceValue('Spa_Enrollment_Agent_NoPermission_UpdatedAnswers', widgetName, [
            { name: 'AgentID', value: null, ControlType: null },
            { name: 'AgentFirstName', value: null, ControlType: null },
            { name: 'AgentLastName', value: null, ControlType: null },
            { name: 'AgentEmail', value: null, ControlType: null },
            { name: 'AgencyName', value: null, ControlType: null },
            { name: 'AgencyID', value: null, ControlType: null }
        ]);
    }
    getPreparedFormControlSettings(applicantId, customInternal) {
        if (applicantId) {
            if (customInternal?.FormControlSettings?.length) {
                return [...customInternal.FormControlSettings, this.getApplicantIdFormControlSettings()];
            }
            return [this.getApplicantIdFormControlSettings()];
        }
        if (customInternal?.FormControlSettings?.length) {
            return customInternal.FormControlSettings;
        }
        return null;
    }
    getApplicantIdFormControlSettings() {
        const applicantIdFormControlSetting = {
            IsReadOnly: true,
            CustomClass: PREPOPULATED_READONLY_CUSTOM_CLASS
        };
        const applicantIdFormControlSettings = {
            ApplicantSSN: applicantIdFormControlSetting
        };
        return applicantIdFormControlSettings;
    }
    validateMatchingForm(planId, formSettings, formType) {
        const userType = this.getUserFormTypeValue(planId);
        // Check if we have a matching form. If not then,
        const hasMatchingForm = formSettings?.find(form => form.foamFormType === formType &&
            form.userType &&
            (form.userType.toLowerCase() === userType || form.userType.toLowerCase() === UserTypes.ALL));
        if (!hasMatchingForm) {
            const selectedFormType = formType === EnrollmentFormType.LONG ? EnrollmentFormType.SHORT : EnrollmentFormType.LONG;
            // default to the opposite form type
            this.updateSelectedFormType$(selectedFormType, planId);
        }
    }
    async checkCartAndFetchEnrollmentSettings(sessionId, switchForm, planHasNextGenForm, formType) {
        const enrollingPlanId = this.getActiveEnrollmentKey();
        await this.fetchEnrollmentPlanSettings(enrollingPlanId, undefined, [formType]);
        const { enrollingPlan, enrollingRiders } = await this.selectAndReturnEnrollingPlanPlusRiders(enrollingPlanId);
        return await firstValueFrom(this.fetchEnrollmentSettings$(sessionId, switchForm, enrollingPlan, enrollingRiders, planHasNextGenForm, formType));
    }
    async fetchEnrollmentPlanHRASettings(enrollingPlanId, userType) {
        const enrollmentPlanSettingsLoaded = this.getEnrollmentPlanHRASettingsLoaded(enrollingPlanId);
        const fetchPlanEnrollmentSettings$ = enrollmentPlanSettingsLoaded
            ? Promise.resolve()
            : firstValueFrom(this.plansService.getPlanEnrollmentSettings$(enrollingPlanId, {
                userType: this.getUserFormTypeKey(userType?.toLowerCase() ?? this.getSiteUserType(enrollingPlanId)),
                formType: EnrollmentFormType.HRA,
                showUAT: this.plansService.getPlanNetworkShowUATSetting()
            }));
        await fetchPlanEnrollmentSettings$;
    }
    getFormTypesToLoad(formTypes, enrollingPlanId) {
        if (formTypes) {
            return formTypes;
        }
        const selectedFormType = this.getSelectedFormTypeForEnrollmentSettings(false, enrollingPlanId);
        return selectedFormType >= 0 ? [selectedFormType] : [];
    }
    async fetchEnrollmentPlanSettings(enrollingPlanId, userType, formTypes) {
        const enrollmentPlanSettingsLoaded = formTypes
            ? !this.hasUnloadedEnrollmentPlanSettings(enrollingPlanId, formTypes)
            : this.getEnrollmentPlanSettingsLoaded(enrollingPlanId);
        const formTypesToLoad = this.getFormTypesToLoad(formTypes, enrollingPlanId);
        const fetchPlanEnrollmentSettings$ = enrollmentPlanSettingsLoaded
            ? Promise.resolve()
            : Promise.all(formTypesToLoad.map(async (formType) => await firstValueFrom(this.plansService.getPlanEnrollmentSettings$(enrollingPlanId, {
                userType: this.getUserFormTypeKey(userType?.toLowerCase() ?? this.getSiteUserType(enrollingPlanId)),
                formType,
                showUAT: this.plansService.getPlanNetworkShowUATSetting()
            }))));
        await fetchPlanEnrollmentSettings$;
    }
    getUnloadedEnrollmentPlanSettingsFormTypes(enrollingPlanId, formTypes) {
        return formTypes.filter(formType => !this.isEnrollmentPlanSettingsLoadedForSelectedFormType(enrollingPlanId, formType));
    }
    hasUnloadedEnrollmentPlanSettings(enrollingPlanId, formTypes) {
        return !!this.getUnloadedEnrollmentPlanSettingsFormTypes(enrollingPlanId, formTypes).length;
    }
    calculateEnrollmentExpirationDate(planYear) {
        // This method contains a lot of comments to explain and understand the logic behind the calculation of the expiration date.
        // All dates are in PST, which is the timezone of the servers.
        let calculatedExpirationDate = null;
        // Initial calculation of ExpirationDate (when there is no existingExpirationDate)
        // Calculate SEP period dates, which goes from December 8th of previous year to December 1st of current year related to the planYear variable
        const startSEPDate = new Date(planYear - 1, 11, 8, 0, 0, 0);
        const endSEPDate = new Date(planYear, 11, 1, 23, 59, 59);
        // Calculate AEP period dates, which goes from October 1st of previous year to December 7th of previous year related to the planYear variable
        const startAEPDate = new Date(planYear - 1, 9, 1, 0, 0, 0);
        const endAEPDate = new Date(planYear - 1, 11, 7, 23, 59, 59);
        // Current PST date
        const currentDate = DateUtilities.convertToTimeZoneDate(new Date()).toDate();
        // Check if we are in the SEP period
        if (currentDate >= startSEPDate && currentDate <= endSEPDate) {
            // Set the calculatedExpirationDate as the 2nd of the following month
            calculatedExpirationDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 2);
        }
        // Check if we are in the AEP period
        else if (currentDate >= startAEPDate && currentDate <= endAEPDate) {
            // Set the calculatedExpirationDate as December 8th of the previous year related to the planYear variable
            calculatedExpirationDate = new Date(planYear - 1, 11, 8);
        }
        // Return the calculated expiration date
        return calculatedExpirationDate ? DateUtilities.getFormattedDate(calculatedExpirationDate) : null;
    }
    async selectAndReturnEnrollingPlanPlusRiders(enrollingPlanId) {
        const enrollingPlan = await this.selectAndReturnEnrollingPlan(enrollingPlanId);
        const enrollingRiders = await this.selectAndReturnEnrollingRiders(enrollingPlan);
        return { enrollingPlan, enrollingRiders };
    }
    async sendAgentConfirmationEmail(planId, widgetName) {
        const isAgentInContext = this.getIsAgentInContext();
        const emailAddress = this.getAgentEmailAddress();
        if (isAgentInContext && this.getIsBrokerConfirmationEmailEnabled() && emailAddress?.length > 0) {
            const subject = this.configResourceService.getProcessedResourceValue('Spa_EnrollmentConfirmation_BrokerEmail_Subject', widgetName, 'Enrollment Received');
            const agentLoginShortUrl = await this.getAgentLoginShortUrl(widgetName);
            const inputs = [
                { key: 'Spa_EnrollmentConfirmation_BrokerInformational_Text', value: this.getBrokerConfirmationEmailInformationalText() },
                { key: 'Spa_HeaderFooter_PrimaryClientLogo', value: this.getBrokerConfirmationEmailProviderLogo() },
                {
                    key: 'agentLoginShortUrl',
                    value: agentLoginShortUrl
                },
                { key: 'hraAvailableText', value: this.getHraAvailableText(planId, widgetName) }
            ];
            await this.emailService.sendEmail(EmailNames.AGENT_CONFIRMATION, [emailAddress], subject, inputs);
        }
    }
    getHraAvailableText(planId, widgetName) {
        const isHraEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_HRA_Enabled', widgetName, false);
        if (isHraEnabled) {
            const plan = this.shoppingCartService.getPlan(planId);
            const hraAvailablePlans = [PlanTypeAbbreviation.MA, PlanTypeAbbreviation.MAPD];
            if (hraAvailablePlans.includes(plan?.planTypeAbbreviation)) {
                return this.configResourceService.getProcessedResourceValue('Spa_EnrollmentConfirmation_BrokerHraAvailable_Text', widgetName, '');
            }
        }
        return '';
    }
    getBeneficiaryQuoteId() {
        return this.quoteService.getBeneficiaryQuoteId();
    }
    processCustomInternal(customInternal, isMedigap) {
        if (isMedigap) {
            const foamConfig = _get(customInternal, 'CustomInternal.FoamConfig');
            const medsupLockedFieldMapping = foamConfig.DFMedSupLockFields;
            this.medSupService.updateSelectedGIReasons();
            if (medsupLockedFieldMapping) {
                const medSupQuestions = this.medSupService.getMedSupQuestions();
                const updatedMedSupLockFields = medsupLockedFieldMapping.map(lockedFieldMapping => {
                    const medsupQuestionName = lockedFieldMapping.questionName;
                    return {
                        ...lockedFieldMapping,
                        isLocked: medSupQuestions && !!medSupQuestions.find(question => question.name === medsupQuestionName)
                    };
                });
                customInternal.CustomInternal.FoamConfig.DFMedSupLockFields = updatedMedSupLockFields;
            }
        }
        return JSON.stringify(customInternal);
    }
    getSelectedFormTypeForEnrollmentSettings(isHRA, selectedPlanId) {
        return isHRA ? EnrollmentFormType.HRA : this.store.selectSnapshot(EnrollmentState.selectedFormType(selectedPlanId));
    }
    updateEnrollmentPlanYear(planYear) {
        if (planYear) {
            const planYearType = this.planYearResourceService.getPlanYearType(+planYear);
            if (planYearType) {
                this.planYearResourceService.setSelectedPlanYear(planYearType);
            }
            else {
                console.error('Attempting to enroll in invalid plan year for site. ', planYear);
            }
        }
    }
    async startLegacyEnrollment(planId, transaction, skipToPageIndex, enrollmentRootPage, preserveQueryParams = false) {
        this.setFormPageLoading$(true, false, planId);
        await this.loadEnrollmentPrerequisites$(planId, transaction, skipToPageIndex);
        this.setFormPageLoading$(false, true, planId);
        let pageIndex = skipToPageIndex || 0;
        if (pageIndex === -1) {
            pageIndex = this.getEnrollmentPagesLength(planId) - 1;
        }
        const pageNameToStartOn = this.getEnrollmentPageByIndex(planId, pageIndex, transaction);
        for (let i = 0; i <= pageIndex; i++) {
            this.setPageVisited(i, planId);
            this.setPageComplete(i, planId);
        }
        const newParams = this.getClientDefinedValuesFromQueryParams();
        const routerOptions = { queryParams: preserveQueryParams ? newParams : {} };
        this.router.navigate([enrollmentRootPage, pageNameToStartOn], routerOptions);
    }
    removeEmptyStrings(object) {
        return Object.keys(object).reduce((objectWithValues, key) => {
            if (object[key] !== '') {
                objectWithValues[key] = object[key];
            }
            return objectWithValues;
        }, {});
    }
    getClientDefinedValuesFromQueryParams() {
        const params = this.route.snapshot.queryParamMap;
        const keysToKeep = params?.get('qsParam')?.split('|');
        return (keysToKeep?.reduce((newParams, key) => {
            if (params.keys.includes(key)) {
                newParams[key] = params.get(key);
            }
            return newParams;
        }, {}) ?? {});
    }
    getDisplaySEPReasons(plan) {
        return (this.plansService.getExtraDataValueByName(plan, PlanExtraDataKey.DISPLAY_SEP)?.toLowerCase() === 'true' ||
            this.configResourceService.getProcessedResourceValue('Enrollment_Display_SEP', null, false));
    }
}
EnrollmentFormService.ɵfac = function EnrollmentFormService_Factory(t) { return new (t || EnrollmentFormService)(i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(i2$1.Router), i0.ɵɵinject(i1.Store), i0.ɵɵinject(MemberSessionService), i0.ɵɵinject(NavigationUtilityService), i0.ɵɵinject(NavigationContext), i0.ɵɵinject(EmailService), i0.ɵɵinject(ShoppingCartService), i0.ɵɵinject(AgentService), i0.ɵɵinject(ImageService), i0.ɵɵinject(PlansService), i0.ɵɵinject(NavigationService), i0.ɵɵinject(RidersService), i0.ɵɵinject(SiteService), i0.ɵɵinject(EnrollmentPostBackService), i0.ɵɵinject(MedSupService), i0.ɵɵinject(QuoteService), i0.ɵɵinject(PassParameterService), i0.ɵɵinject(IPUtilityService), i0.ɵɵinject(LockedSiteService), i0.ɵɵinject(MessagesService), i0.ɵɵinject(PreferencesService), i0.ɵɵinject(SSOPopulatedFieldService), i0.ɵɵinject(EnrollmentTransactionErrorsContext), i0.ɵɵinject(MedSupMillimanCryptoService), i0.ɵɵinject(TwilioDeviceService), i0.ɵɵinject(LocaleService), i0.ɵɵinject(DrugsService), i0.ɵɵinject(PhoneUtilityService), i0.ɵɵinject(EnrollmentHistoryService), i0.ɵɵinject(ProfileCryptoService), i0.ɵɵinject(PlanYearResourceService), i0.ɵɵinject(SOAService), i0.ɵɵinject(DeepLinkingService), i0.ɵɵinject(ProviderService), i0.ɵɵinject(EnrollmentHttpService), i0.ɵɵinject(ProfileService), i0.ɵɵinject(EnrollmentFunctionService), i0.ɵɵinject(UtilityFunctionService), i0.ɵɵinject(SpinnerService), i0.ɵɵinject(FormPagesMetadataContext), i0.ɵɵinject(i2$1.ActivatedRoute), i0.ɵɵinject(DemographicService), i0.ɵɵinject(ExternalErrorLoggingService), i0.ɵɵinject(WeglotService)); };
EnrollmentFormService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: EnrollmentFormService, factory: EnrollmentFormService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnrollmentFormService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ConfigResourceService }, { type: i2$1.Router }, { type: i1.Store }, { type: MemberSessionService }, { type: NavigationUtilityService }, { type: NavigationContext }, { type: EmailService }, { type: ShoppingCartService }, { type: AgentService }, { type: ImageService }, { type: PlansService }, { type: NavigationService }, { type: RidersService }, { type: SiteService }, { type: EnrollmentPostBackService }, { type: MedSupService }, { type: QuoteService }, { type: PassParameterService }, { type: IPUtilityService }, { type: LockedSiteService }, { type: MessagesService }, { type: PreferencesService }, { type: SSOPopulatedFieldService }, { type: EnrollmentTransactionErrorsContext }, { type: MedSupMillimanCryptoService }, { type: TwilioDeviceService }, { type: LocaleService }, { type: DrugsService }, { type: PhoneUtilityService }, { type: EnrollmentHistoryService }, { type: ProfileCryptoService }, { type: PlanYearResourceService }, { type: SOAService }, { type: DeepLinkingService }, { type: ProviderService }, { type: EnrollmentHttpService }, { type: ProfileService }, { type: EnrollmentFunctionService }, { type: UtilityFunctionService }, { type: SpinnerService }, { type: FormPagesMetadataContext }, { type: i2$1.ActivatedRoute }, { type: DemographicService }, { type: ExternalErrorLoggingService }, { type: WeglotService }]; }, null); })();

class AgentCallRecordingService {
    constructor(memberSessionService, configResourceService, sessionService, agentCallRecordingHttpService, enrollmentFormService, store, profileService) {
        this.memberSessionService = memberSessionService;
        this.configResourceService = configResourceService;
        this.sessionService = sessionService;
        this.agentCallRecordingHttpService = agentCallRecordingHttpService;
        this.enrollmentFormService = enrollmentFormService;
        this.store = store;
        this.profileService = profileService;
    }
    async updateMemberPhoneData(phone, phoneType = PhoneNumberType.BOTH) {
        return this.profileService.updateMemberPhoneData(phone, phoneType);
    }
    async updateMemberEmail(email) {
        const apiMemberStateModel = {
            profile: {
                emailAddress: email
            }
        };
        return this.memberSessionService.updateMemberProfile(apiMemberStateModel);
    }
    storeTwilioPhoneNumber(phoneNumber) {
        this.store.dispatch(new SetTwilioPhoneNumber(phoneNumber));
    }
    storeTwilioAuthCode(authToken) {
        this.store.dispatch(new SetTwilioAuthCode(authToken));
    }
    storeTwilioCallTrackingId(callTrackingId) {
        this.store.dispatch(new SetTwilioCallTrackingId(callTrackingId));
    }
    getTwilioPhoneNumber$() {
        return this.agentCallRecordingHttpService.getPhoneNumber$().pipe(map(agentPhoneNumber => agentPhoneNumber?.phoneNumber));
    }
    getTwilioAuthToken$(phoneNumber) {
        const sessionId = this.memberSessionService.getMemberSessionId();
        return this.agentCallRecordingHttpService.getAuthToken$(sessionId, phoneNumber);
    }
    addCallRecordingInitiatedNote(memberPhoneNumber) {
        const agentGuid = this.store.selectSnapshot(AgentState.agentGuid);
        const agentName = this.store.selectSnapshot(AgentState.fullName);
        this.addCallRecordingSentNote(agentName, agentGuid, memberPhoneNumber);
    }
    addCallInvitationSentNote(memberPhoneNumber, memberEmailAddress) {
        const agentGuid = this.store.selectSnapshot(AgentState.agentGuid);
        const agentName = this.store.selectSnapshot(AgentState.fullName);
        this.addInvitationSentNote(agentName, agentGuid, memberPhoneNumber, memberEmailAddress);
    }
    associateCallRecordToEnrollment$() {
        const sessionId = this.memberSessionService.getMemberSessionId();
        const authCode = this.store.selectSnapshot(TwilioState.authCode);
        return this.agentCallRecordingHttpService.associateCallRecordToEnrollment$(sessionId, this.enrollmentFormService.getTransactionGuid(), authCode);
    }
    addCallRecordingSentNote(agentName, userAgentGuid, memberPhoneNumber) {
        const date = DateUtilities.getFormattedCurrentDate();
        const description = this.getCallrecordingNoteDescription(memberPhoneNumber);
        const note = {
            userAgentGUID: userAgentGuid,
            agentNoteActionType: NoteActionType.Note,
            description,
            agentName,
            createdWhen: date
        };
        this.sessionService.addMemberNoteByAgent(note);
    }
    getCallrecordingNoteDescription(phoneNumber) {
        const description = this.configResourceService.getProcessedResourceValue('Spa_SendCallRecordingInitiated_AgentNotePhone_Text', null, 'Call recording initiated with <phone>');
        return description.replace('<phone>', this.getFormattedPhoneNumber(phoneNumber));
    }
    addInvitationSentNote(agentName, userAgentGuid, memberPhoneNumber, memberEmailAddress) {
        const date = DateUtilities.getFormattedCurrentDate();
        const description = this.getInvitationNoteDescription(memberPhoneNumber, memberEmailAddress);
        const note = {
            userAgentGUID: userAgentGuid,
            agentNoteActionType: NoteActionType.Note,
            description,
            agentName,
            createdWhen: date
        };
        this.sessionService.addMemberNoteByAgent(note);
    }
    getInvitationNoteDescription(phoneNumber, email) {
        if (email && !phoneNumber) {
            return this.getEmailNoteDescription(email);
        }
        return this.getPhoneNoteDescription(phoneNumber);
    }
    getPhoneNoteDescription(phoneNumber) {
        const description = this.configResourceService.getProcessedResourceValue('Spa_SendCallInvitation_AgentNotePhone_Text', null, 'Call recording invite sent to <phone>');
        return description.replace('<phone>', this.getFormattedPhoneNumber(phoneNumber));
    }
    getEmailNoteDescription(email) {
        const description = this.configResourceService.getProcessedResourceValue('Spa_SendCallInvitation_AgentNote_Text', null, 'Call recording invite sent to <email>');
        return description.replace('<email>', email);
    }
    getFormattedPhoneNumber(phone) {
        let formattedPhoneNumber = phone ?? '';
        // Check if the phone number is unformatted before applying the format
        if (!RegexPattern.US_FORMATTED_PHONE_NUMBER.test(phone) && phone.length === 10) {
            formattedPhoneNumber = `(${phone.substring(0, 3)}) ${phone.substring(3, 6)}-${phone.substring(6, 10)}`;
        }
        return formattedPhoneNumber;
    }
}
AgentCallRecordingService.ɵfac = function AgentCallRecordingService_Factory(t) { return new (t || AgentCallRecordingService)(i0.ɵɵinject(MemberSessionService), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(MemberSessionService), i0.ɵɵinject(AgentCallRecordingHttpService), i0.ɵɵinject(EnrollmentFormService), i0.ɵɵinject(i1.Store), i0.ɵɵinject(ProfileService)); };
AgentCallRecordingService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AgentCallRecordingService, factory: AgentCallRecordingService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentCallRecordingService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: MemberSessionService }, { type: ConfigResourceService }, { type: MemberSessionService }, { type: AgentCallRecordingHttpService }, { type: EnrollmentFormService }, { type: i1.Store }, { type: ProfileService }]; }, null); })();

var CallRecordingBeginVia;
(function (CallRecordingBeginVia) {
    CallRecordingBeginVia["INCOMING_CALL"] = "IncomingCall";
    CallRecordingBeginVia["OUTGOING_CALL"] = "OutgoingCall";
})(CallRecordingBeginVia || (CallRecordingBeginVia = {}));
var CallRecordingEndVia;
(function (CallRecordingEndVia) {
    CallRecordingEndVia["END_BUTTON"] = "EndButton";
    CallRecordingEndVia["DISCONNECTED"] = "Disconnected";
})(CallRecordingEndVia || (CallRecordingEndVia = {}));

class AgentInContextGuard {
    constructor(configResourceService, navigationService, agentService, ssoHttpService, store) {
        this.configResourceService = configResourceService;
        this.navigationService = navigationService;
        this.agentService = agentService;
        this.ssoHttpService = ssoHttpService;
        this.store = store;
    }
    async canActivate(route, state) {
        const isMedicareEdgeEnabled = this.configResourceService.getProcessedResourceValue('Spa_MedicareEdge_Enabled', null, false);
        const isPurlBookmarkingEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_PurlBookmarking_Enabled', null, true);
        if (EnvironmentService.getEnvironment().liveedit || !isMedicareEdgeEnabled) {
            return true;
        }
        const queryParams = route.queryParams;
        let isAgentInContext = this.agentService.getIsAgentInContext();
        if (queryParams && Object.keys(queryParams).length > 0) {
            // for SOA
            if (queryParams.qs) {
                await this.isAgentInContext(route).then(agentInContext => {
                    if (agentInContext) {
                        isAgentInContext = true;
                    }
                });
            }
            // AgentGuid is for send to beneficiary, is_purl_request is for PURLs
            const isBookmarkablePurlRequest = queryParams.purlId?.length > 0 && isPurlBookmarkingEnabled;
            if (queryParams.AgentGuid || queryParams.is_purl_request || isBookmarkablePurlRequest) {
                isAgentInContext = true;
            }
        }
        const isLoggedOut = this.store.selectSnapshot(AgentState.isLoggedOut);
        const canActivate = isAgentInContext || isLoggedOut;
        if (!canActivate) {
            this.navigationService.navigateByPageTag(PageTags.PAGE_NOT_FOUND);
        }
        return canActivate;
    }
    async isAgentInContext(route) {
        const encryptedValuesFromURL = {
            EncryptedQueryString: route.queryParams.qs,
            ValidateSignature: true,
            haKeyVer: route.queryParams.haKeyVer,
            tpKeyVer: route.queryParams.tpKeyVer,
            sigid: route.queryParams.sigid,
            sig: route.queryParams.sig,
            bitlen: route.queryParams.bitlen
        };
        const decryptedData = await this.ssoHttpService.decrypt$(encryptedValuesFromURL).toPromise();
        return !!decryptedData?.agentGuid;
    }
}
AgentInContextGuard.ɵfac = function AgentInContextGuard_Factory(t) { return new (t || AgentInContextGuard)(i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(NavigationService), i0.ɵɵinject(AgentService), i0.ɵɵinject(SSOHttpService), i0.ɵɵinject(i1.Store)); };
AgentInContextGuard.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AgentInContextGuard, factory: AgentInContextGuard.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentInContextGuard, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ConfigResourceService }, { type: NavigationService }, { type: AgentService }, { type: SSOHttpService }, { type: i1.Store }]; }, null); })();

class AgentPermissionsService {
    constructor(agentService, agentHttpService) {
        this.agentService = agentService;
        this.agentHttpService = agentHttpService;
    }
    /**
     * Checks if the current agent role is that of Quoter.
     * Note: This returns false if the role is Quoter_Broker or Quoter_Admin.
     * Use hasQuoterRole() to check if current agent is of the Quoter type.
     */
    isQuoter(agentRole = this.getAgentRole()) {
        return agentRole && agentRole === AgentRole.QUOTER;
    }
    /**
     * Checks if the current agent role is that of Quoter_Agency.
     * Note: This returns false if the role is Quoter_Broker or Quoter_Admin.
     * Use hasQuoterRole() to check if current agent is of the Quoter type.
     */
    isQuoterAgency(agentRole = this.getAgentRole()) {
        return agentRole && agentRole === AgentRole.QUOTER_AGENCY;
    }
    /**
     * Checks if the current agent role is that of Quoter_SingleAgency.
     * Note: This returns false if the role is Quoter_Broker or Quoter_Admin.
     * Use hasQuoterRole() to check if current agent is of the Quoter type.
     */
    isQuoterSingleAgency(agentRole = this.getAgentRole()) {
        return agentRole && agentRole === AgentRole.QUOTER_SINGLE_AGENCY;
    }
    /**
     * Checks if the current agent role is that of Enroller. Returns a boolean.
     * Note: This returns false if the role is Enroller_Broker or Enroller_Admin.
     * Use hasEnrollerRole() to check if current agent is of the Enroller type.
     */
    isEnroller(agentRole = this.getAgentRole()) {
        return agentRole && agentRole === AgentRole.ENROLLER;
    }
    /**
     * Checks if the current agent role is that of Enroller_Agency.
     * Use hasEnrollerRole() to check if current agent is of the Enroller type.
     */
    isEnrollerAgency(agentRole = this.getAgentRole()) {
        return agentRole && agentRole === AgentRole.ENROLLER_AGENCY;
    }
    /**
     * Checks if the current agent role is that of Enroller_SingleAgency.
     * Use hasEnrollerRole() to check if current agent is of the Enroller type.
     */
    isEnrollerSingleAgency(agentRole = this.getAgentRole()) {
        return agentRole && agentRole === AgentRole.ENROLLER_SINGLE_AGENCY;
    }
    /**
     * Checks if the current agent role is that of a Enroller_Admin.  Returns a boolean.
     */
    isEnrollerAdmin(agentRole = this.getAgentRole()) {
        return agentRole && agentRole === AgentRole.ENROLLER_ADMIN;
    }
    /**
     * Checks if the current agent role is that of a Broker.  Returns a boolean.
     */
    isBroker(agentRole = this.getAgentRole()) {
        return agentRole && BROKER_ROLES.includes(agentRole);
    }
    /**
     * Checks if the current agent's role is an admin. Returns a boolean.
     */
    isAdmin(agentRole = this.getAgentRole()) {
        return agentRole && ADMIN_ROLES.includes(agentRole);
    }
    /**
     * Checks if the current agent's role is an agency admin.
     */
    isAgencyAdmin(agentRole = this.getAgentRole()) {
        return agentRole && AGENCY_ADMIN_ROLES.includes(agentRole);
    }
    /**
     * Checks if the current agent's role is an admin or an agency admin.
     */
    isAgentAdmin() {
        return this.isAdmin() || this.isAgencyAdmin();
    }
    /**
     * Checks to see if the agent is of the basic Quoter type.
     */
    hasBasicQuoterRole(agentRole = this.getAgentRole()) {
        return agentRole && QUOTER_BASIC_ROLES.includes(agentRole);
    }
    /**
     * Checks to see if the agent is of the Quoter type.
     */
    hasQuoterRole(agentRole = this.getAgentRole()) {
        return agentRole && QUOTER_ROLES.includes(agentRole);
    }
    /**
     * Checks to see if the agent is of the basic Enroller type.
     */
    hasBasicEnrollerRole(agentRole = this.getAgentRole()) {
        return agentRole && ENROLLER_BASIC_ROLES.includes(agentRole);
    }
    /**
     * Checks to see if the agent is of the Enroller type.
     */
    hasEnrollerRole(agentRole = this.getAgentRole()) {
        return agentRole && ENROLLER_ROLES.includes(agentRole);
    }
    /**
     * Checks to see if the agent is of the basic Enroller/Quoter type.
     */
    hasBasicRole(agentRole = this.getAgentRole()) {
        return agentRole && BASIC_ROLES.includes(agentRole);
    }
    /**
     * Checks to see if the set a given set of permissions has the "enroll" permission.
     * Please note that this is not specific to a plan.
     * @param agentPermissions - List of permissions
     */
    hasEnrollPermission(agentPermissions) {
        return agentPermissions.includes(AgentUserPermission.ENROLL);
    }
    /**
     * Checks to see if the agent has the given permissions.  Returns a boolean.
     * @param permissions - as type AgentUserPermission
     */
    hasPermissions(permissions, agentPermissions = this.getAgentUserPermissions()) {
        return agentPermissions && permissions.every(permission => agentPermissions.includes(permission));
    }
    /**
     * Checks if Agent has selling permission for plan, returns a Promise.
     * @param agentGuid  - the current agent's guid
     * @param planId - the plan's plan id, plan.id
     * @param planYear - the plan's plan year
     * @param effectiveDate - effective date of enrollment or default
     * @param fips - the fips code of the zip selection
     * @param checkEnrollerPermission - set to true to check if seller has enroll permission for plan
     *    if set to true, will return false if not an Enroller role
     */
    async hasPlanPermission(agentGuid, planId, planYear, effectiveDate, fips, checkEnrollerPermission) {
        return this.agentHttpService
            .checkAgentPlanPermissions$(agentGuid, planId, planYear, effectiveDate, fips, checkEnrollerPermission)
            .toPromise();
    }
    /**
     * Checks if Agent has selling permissions  for plan, returns a Promise.
     * @param agentGuid  - the current agent's guid
     * @param planId - the plan's plan id, plan.id
     * @param planYear - the plan's plan year
     * @param effectiveDate - effective date of enrollment or default
     * @param fips - the fips code of the zip selection
     */
    async getAgentInContextEnrollPermissions(planId, planYear, effectiveDate, fips) {
        const agentGuid = this.agentService.getAgentInContextGuid();
        let isEnroller = false;
        let hasPlanPermission = false;
        if (agentGuid) {
            const agentPermissions = this.getAgentUserPermissions();
            isEnroller = this.hasEnrollPermission(agentPermissions);
            hasPlanPermission = await this.hasPlanPermission(agentGuid, planId, planYear, effectiveDate, fips, isEnroller);
        }
        return { isEnroller, hasPlanPermission };
    }
    getAgentUserPermissions() {
        return this.agentService.getAgentUserPermissions();
    }
    getAgentRole() {
        return this.agentService.getAgentRole();
    }
    hasAdminPermissions(agentPermissions = this.getAgentUserPermissions()) {
        return this.hasPermissions(ADMIN_PERMISSIONS, agentPermissions) || this.hasPermissions(AGENCY_ADMIN_PERMISSIONS, agentPermissions);
    }
    hasMemberProfilePermissions(agentPermissions = this.getAgentUserPermissions()) {
        return (this.hasPermissions(BROKER_PERMISSIONS, agentPermissions) ||
            this.hasPermissions(SINGLE_AGENCY_PERMISSIONS, agentPermissions) ||
            this.hasAdminPermissions(agentPermissions));
    }
}
AgentPermissionsService.ɵfac = function AgentPermissionsService_Factory(t) { return new (t || AgentPermissionsService)(i0.ɵɵinject(AgentService), i0.ɵɵinject(AgentHttpService)); };
AgentPermissionsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AgentPermissionsService, factory: AgentPermissionsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentPermissionsService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: AgentService }, { type: AgentHttpService }]; }, null); })();

class AgentReportsSummaryGuard {
    constructor(configResourceService, navigationService, agentPermissionsService) {
        this.configResourceService = configResourceService;
        this.navigationService = navigationService;
        this.agentPermissionsService = agentPermissionsService;
    }
    canActivate(route, state) {
        if (EnvironmentService.getEnvironment().liveedit) {
            return true;
        }
        const spaSiteAgentReportsEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_AgentReports_Enabled', null, false);
        const spaSiteAgentReportsAdminOnlyEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_AgentReports_AdminOnly_Enabled', null, false);
        const isAdmin = this.agentPermissionsService.isAdmin();
        let canActivate = false;
        if (spaSiteAgentReportsEnabled) {
            canActivate = spaSiteAgentReportsAdminOnlyEnabled ? isAdmin : true;
        }
        else {
            canActivate = false;
        }
        if (!canActivate) {
            this.navigationService.navigateByPageTag(PageTags.HOME);
        }
        return canActivate;
    }
}
AgentReportsSummaryGuard.ɵfac = function AgentReportsSummaryGuard_Factory(t) { return new (t || AgentReportsSummaryGuard)(i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(NavigationService), i0.ɵɵinject(AgentPermissionsService)); };
AgentReportsSummaryGuard.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AgentReportsSummaryGuard, factory: AgentReportsSummaryGuard.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentReportsSummaryGuard, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ConfigResourceService }, { type: NavigationService }, { type: AgentPermissionsService }]; }, null); })();

class ASPFilterService {
    constructor(store, agentService, snpService, configResourceService, planYearResourceService) {
        this.store = store;
        this.agentService = agentService;
        this.snpService = snpService;
        this.configResourceService = configResourceService;
        this.planYearResourceService = planYearResourceService;
        this.carrierControlName = FilterKeyType.ASP_CARRIER_NAME;
        this.stateControlName = FilterKeyType.ASP_STATE;
        this.planTypeControlName = FilterKeyType.ASP_PLAN_TYPE;
        this.snpTypeControlName = FilterKeyType.ASP_SNP_TYPE;
        this.planYearControlName = FilterKeyType.ASP_PLAN_YEAR;
        this.aspParentFilterKey = 'aspParentFilter';
        this.aspParentFilter = { key: this.aspParentFilterKey, comparator: ComparatorType.EQUAL, values: [] };
    }
    getFilterFormTypes() {
        return {
            [this.carrierControlName]: FilterKeyType.ASP_CARRIER_NAME,
            [this.stateControlName]: FilterKeyType.ASP_STATE,
            [this.planYearControlName]: FilterKeyType.ASP_PLAN_YEAR,
            [this.planTypeControlName]: FilterKeyType.ASP_PLAN_TYPE,
            [this.snpTypeControlName]: FilterKeyType.ASP_SNP_TYPE
        };
    }
    initFilterForm() {
        this.filterForm = this.getNewFilterForm();
    }
    initControls(includeAncillary) {
        this.setASPCarrierFilterControls$(includeAncillary);
        this.setASPStateFilterControls();
        this.setASPPlanTypeFilterControls();
        this.setASPPlanYearFilterControls();
        this.setASPSNPFilterControls();
    }
    getFilterForm() {
        return this.filterForm;
    }
    getNewFilterForm() {
        return new UntypedFormGroup({
            [this.carrierControlName]: new UntypedFormControl(null),
            [this.stateControlName]: new UntypedFormControl(null),
            [this.planYearControlName]: new UntypedFormControl(null),
            [this.planTypeControlName]: new UntypedFormControl(null),
            [this.snpTypeControlName]: new UntypedFormControl(null)
        });
    }
    setASPCarrierFilterControls$(includeAncillary) {
        this.carrierControls$ = this.agentService.fetchCarriers$(includeAncillary).pipe(map(carriers => carriers.map(carrier => {
            const label = carrier.name;
            const value = carrier.carrierID;
            return { label, disabled: false, value };
        })));
    }
    getASPCarrierFilterControls$() {
        return this.carrierControls$;
    }
    getASPCarrierControlName() {
        return this.carrierControlName;
    }
    setASPStateFilterControls() {
        this.stateControls = DemographicStates.map(state => {
            const label = state.StateName;
            const value = state.StateAbbrev;
            return {
                label,
                disabled: false,
                value
            };
        });
    }
    getASPStateFilterControls() {
        return this.stateControls;
    }
    getASPStateFilterControlName() {
        return this.stateControlName;
    }
    getASPPlanTypes() {
        const planTypes = [PlanType.MEDIGAP, PlanType.ALL_ANCILLARY, PlanType.MA, PlanType.PDP, PlanType.MAPD];
        return planTypes;
    }
    setASPPlanTypeFilterControls() {
        this.planTypeControls = this.getASPPlanTypes().map(filterKey => {
            const label = this.getPlanTypeName(filterKey);
            const value = filterKey;
            return {
                label,
                disabled: false,
                value
            };
        });
    }
    getASPPlanTypeFilterControls() {
        return this.planTypeControls;
    }
    getASPPlanTypeFilterControlName() {
        return this.planTypeControlName;
    }
    getASPPlanYears() {
        const years = [];
        const planYear = this.planYearResourceService.getSelectedPlanYear();
        years.push(`${planYear}`);
        years.push(`${parseInt(planYear, 10) + 1}`);
        return years;
    }
    setASPPlanYearFilterControls() {
        this.planYearControls = this.getASPPlanYears().map(filterKey => {
            const label = filterKey;
            const value = filterKey;
            return { label, disabled: false, value };
        });
    }
    getASPPlanYearFilterControls() {
        return this.planYearControls;
    }
    getASPPlanYearFilterControlName() {
        return this.planYearControlName;
    }
    getASPSNPTypes() {
        return [SNPBaseType.cSNP, SNPBaseType.dSNP, SNPBaseType.iSNP];
    }
    setASPSNPFilterControls() {
        this.snpControls = SNP_BASE_VALUES.map(snpValue => {
            const value = snpValue;
            const label = this.snpService.getSNPAbbreviation(snpValue);
            return { label, disabled: false, value };
        });
    }
    getASPSNPFilterControls() {
        return this.snpControls;
    }
    getASPSNPFilterControlName() {
        return this.snpTypeControlName;
    }
    getPlanTypeName(planTypeId) {
        if (planTypeId === PlanType.ALL_ANCILLARY) {
            return this.configResourceService.getProcessedResourceValue('Spa_Site_Ancillary_Text', null, 'Ancillary');
        }
        if (planTypeId === PlanType.PDP) {
            return PlanTypeAbbreviation.PDP;
        }
        if (planTypeId === PlanType.MA) {
            return PlanTypeAbbreviation.MA;
        }
        if (planTypeId === PlanType.MAPD) {
            return PlanTypeAbbreviation.MAPD;
        }
        if (planTypeId === PlanType.MEDIGAP) {
            return this.configResourceService.getProcessedResourceValue('Spa_Site_MedicareSupplement', null, 'Medicare Supplement');
        }
        return '';
    }
    getHasAnyASPFilters$() {
        return this.store.select(AgentState.aspFilterGroups).pipe(map(aspFilters => !!aspFilters[0]?.filters?.length));
    }
    getASPParentFilter() {
        return this.aspParentFilter;
    }
    getASPFiltersByFilterGroup() {
        return this.store.selectSnapshot(AgentState.getFiltersByFilterGroup([this.aspParentFilter]));
    }
    getASPFiltersByFilterGroup$() {
        return this.store.select(AgentState.getFiltersByFilterGroup([this.aspParentFilter]));
    }
    getASPByFilterGroup$() {
        return this.store.select(AgentState.getASPByFilterGroup([this.aspParentFilter]));
    }
    clearASPFilterGroupFilter() {
        this.store.dispatch(new ClearASPFilterGroupFilter([this.aspParentFilter]));
    }
    setASPFilterGroup() {
        const filterGroup = {
            groupKey: new Filter({ ...this.aspParentFilter }),
            filters: []
        };
        this.store.dispatch(new SetASPFilterGroup(filterGroup));
    }
    addFilterToASPFilterGroups(filter) {
        this.store.dispatch(new AddFilterToASPFilterGroups([this.aspParentFilter], filter));
    }
    clearASPFilterWithKey(filterKeyToClear) {
        this.store.dispatch(new ClearASPFilterWithKey([this.aspParentFilter], filterKeyToClear));
    }
}
ASPFilterService.ɵfac = function ASPFilterService_Factory(t) { return new (t || ASPFilterService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(AgentService), i0.ɵɵinject(SNPService), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(PlanYearResourceService)); };
ASPFilterService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ASPFilterService, factory: ASPFilterService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ASPFilterService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }, { type: AgentService }, { type: SNPService }, { type: ConfigResourceService }, { type: PlanYearResourceService }]; }, null); })();

const SESSION_RESET = 'session-reset';
// A resolver for checking if the site has changed within the same domain. We need to make
// sure we reset the users session if the site changes as sessionId is no longer valid
// in a new site
class MarkSessionForCheckResolver {
    constructor(store, configResourceService, sessionService, siteService, navigationUtilityService, planYearResourceService) {
        this.store = store;
        this.configResourceService = configResourceService;
        this.sessionService = sessionService;
        this.siteService = siteService;
        this.navigationUtilityService = navigationUtilityService;
        this.planYearResourceService = planYearResourceService;
    }
    async resolve(route) {
        const environment = EnvironmentService.getEnvironment();
        const markSessionForCheck = !environment.liveedit && this.store.selectSnapshot(SiteState.markSessionForCheck);
        if (markSessionForCheck && !this.siteService.isPPCSite()) {
            this.planYearResourceService.setSelectedPlanYear(PlanYearType.CURRENT);
            const path = this.navigationUtilityService.getPath(route);
            const resetSessionOnSiteChange = this.configResourceService.getProcessedResourceValue('Spa_Site_Reset_Session_On_Site_Change', null, true, undefined, path);
            this.store.dispatch(new SetMarkSessionForCheck(false));
            if (resetSessionOnSiteChange) {
                this.sessionService.memberLogout();
                return true;
            }
        }
        return false;
    }
}
MarkSessionForCheckResolver.ɵfac = function MarkSessionForCheckResolver_Factory(t) { return new (t || MarkSessionForCheckResolver)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(MemberSessionService), i0.ɵɵinject(SiteService), i0.ɵɵinject(NavigationUtilityService), i0.ɵɵinject(PlanYearResourceService)); };
MarkSessionForCheckResolver.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MarkSessionForCheckResolver, factory: MarkSessionForCheckResolver.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MarkSessionForCheckResolver, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }, { type: ConfigResourceService }, { type: MemberSessionService }, { type: SiteService }, { type: NavigationUtilityService }, { type: PlanYearResourceService }]; }, null); })();

const AGENT_SESSION_DATA = 'agentSessionData';
class AgentSessionResolver {
    constructor(store, agentService, memberSessionService) {
        this.store = store;
        this.agentService = agentService;
        this.memberSessionService = memberSessionService;
    }
    async resolve(route) {
        const isRedirectedFromPlanCompareApi = this.agentService.isRedirectedFromPlanCompareApi();
        if (!isRedirectedFromPlanCompareApi) {
            const isAgentBanned = this.agentService.isBannedFromSession();
            if (!isAgentBanned && this.agentService.keepAgentInContext(route.queryParams)) {
                const session = this.memberSessionService.getMemberSession();
                let agentGuid = session?.agentGuid ? session.agentGuid : this.store.selectSnapshot(AgentState.agentGuid);
                if (!agentGuid) {
                    if (route.queryParams?.AgentGuid) {
                        agentGuid = route.queryParams.AgentGuid;
                        this.setAgentDisplay(route.queryParams);
                    }
                    else {
                        agentGuid = this.store.selectSnapshot(QuoteBeneficiaryState.getAgentGuid);
                    }
                }
                if (agentGuid && !this.store.selectSnapshot(AgentState.agentData)) {
                    try {
                        const agentData = await this.agentService.fetchAgent$(agentGuid, agentGuid).toPromise();
                        if (agentData) {
                            this.agentService.updateAgent$(agentData);
                            return await Promise.resolve(agentGuid);
                        }
                    }
                    catch (error) {
                        this.store.dispatch(new ResetAgentState());
                        Promise.resolve('agent does not have permission');
                    }
                    return await Promise.resolve('agent does not have permission');
                }
                return await Promise.resolve('agent data does not exist');
            }
            else {
                return await Promise.resolve('agent is banned from user session');
            }
        }
        return await Promise.resolve('redirected from plan compare api');
    }
    setAgentDisplay(params) {
        this.store.dispatch([
            new SetAgentHeader(params.showAgentHeader !== 'false'),
            new SetAgentMiniCart(params.showAgentMiniCart !== 'false')
        ]);
    }
}
AgentSessionResolver.ɵfac = function AgentSessionResolver_Factory(t) { return new (t || AgentSessionResolver)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(AgentService), i0.ɵɵinject(MemberSessionService)); };
AgentSessionResolver.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AgentSessionResolver, factory: AgentSessionResolver.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentSessionResolver, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }, { type: AgentService }, { type: MemberSessionService }]; }, null); })();

const MEMBER_SESSION_ID = 'memberSessionId';
class MemberSessionResolver {
    constructor(memberSessionService, siteService, agentService) {
        this.memberSessionService = memberSessionService;
        this.siteService = siteService;
        this.agentService = agentService;
    }
    async resolve(route) {
        const session = this.memberSessionService.getMemberSession();
        if (session?.sessionId && !this.memberSessionService.isExpired(session)) {
            return await Promise.resolve(session.sessionId);
        }
        else {
            if (!this.siteService.isPPCSite() || this.agentService.isAgentLoggedIn()) {
                await this.memberSessionService.createMemberSession$().toPromise();
                const memberModel = this.memberSessionService.getMemberSession();
                if (memberModel) {
                    return await Promise.resolve(memberModel.sessionId);
                }
                return await Promise.reject('Unable to retrieve member session.');
            }
            return await Promise.resolve('');
        }
    }
}
MemberSessionResolver.ɵfac = function MemberSessionResolver_Factory(t) { return new (t || MemberSessionResolver)(i0.ɵɵinject(MemberSessionService), i0.ɵɵinject(SiteService), i0.ɵɵinject(AgentService)); };
MemberSessionResolver.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MemberSessionResolver, factory: MemberSessionResolver.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MemberSessionResolver, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: MemberSessionService }, { type: SiteService }, { type: AgentService }]; }, null); })();

// Checks if we are authenticated for api calls and if not gets the auth code. The call to
// retrieve the auth code should 302 redirect us to the application root and we should get
// the JWT token at this point
class ApiAuthResolver {
    constructor(authService, store) {
        this.authService = authService;
        this.store = store;
    }
    async resolve(route) {
        if (this.authService.isAuthenticatedForApiCalls()) {
            const currentAuthStatus = this.store.selectSnapshot(RuntimeState.authStatus);
            if (currentAuthStatus !== AUTH_STATUS_CODES.JWT_LOADED) {
                await this.store.dispatch(new SetAuthStatus(AUTH_STATUS_CODES.JWT_LOADED)).toPromise();
            }
            return await Promise.resolve(AUTH_STATUS_CODES.JWT_LOADED);
        }
        else {
            this.store.dispatch(new SetAuthStatus(AUTH_STATUS_CODES.JWT_LOADING));
            const success = await this.authService.loadJWT();
            return success ? await Promise.resolve(AUTH_STATUS_CODES.JWT_SAVED) : await Promise.resolve(AUTH_STATUS_CODES.JWT_ERROR);
        }
    }
}
ApiAuthResolver.ɵfac = function ApiAuthResolver_Factory(t) { return new (t || ApiAuthResolver)(i0.ɵɵinject(AuthService), i0.ɵɵinject(i1.Store)); };
ApiAuthResolver.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiAuthResolver, factory: ApiAuthResolver.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiAuthResolver, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: AuthService }, { type: i1.Store }]; }, null); })();

const APP_SESSION_DATA = 'application-session-data';
// Everything needed in order to start the app and interact with the API will be resolved here
// The resolvers must be aggregated as MemberSessionResolver depends on ApiAuthResolver
class ApplicationSessionResolver {
    constructor(memberSessionResolver, apiAuthResolver, agentSessionResolver) {
        this.memberSessionResolver = memberSessionResolver;
        this.apiAuthResolver = apiAuthResolver;
        this.agentSessionResolver = agentSessionResolver;
    }
    async resolve(route, state) {
        // need to get this first as the jwt allows us to call login methods in sso if we are logging in a user
        const apiAuthResult = await this.apiAuthResolver.resolve(route);
        const agentSessionResult = await this.agentSessionResolver.resolve(route);
        // acquire the members sessionId or create an anonymous session for the user
        const memberSessionResult = await this.memberSessionResolver.resolve(route);
        return { [API_AUTH_STATUS]: apiAuthResult, [MEMBER_SESSION_ID]: memberSessionResult, [AGENT_SESSION_DATA]: agentSessionResult };
    }
}
ApplicationSessionResolver.ɵfac = function ApplicationSessionResolver_Factory(t) { return new (t || ApplicationSessionResolver)(i0.ɵɵinject(MemberSessionResolver), i0.ɵɵinject(ApiAuthResolver), i0.ɵɵinject(AgentSessionResolver)); };
ApplicationSessionResolver.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApplicationSessionResolver, factory: ApplicationSessionResolver.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApplicationSessionResolver, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: MemberSessionResolver }, { type: ApiAuthResolver }, { type: AgentSessionResolver }]; }, null); })();

class SharedResourceService {
    constructor(configResourceService, store) {
        this.configResourceService = configResourceService;
        this.store = store;
    }
    getIsAgencyContactResourceSharingEnabled() {
        return this.configResourceService.getProcessedResourceValue('Spa_AgencyContact_Consumer_Resource_Sharing_Enabled', null, false);
    }
    getIsAgencyConsumerResourceSharingEnabled() {
        return this.configResourceService.getProcessedResourceValue('Spa_Agency_Consumer_Resource_Sharing_Enabled', null, false);
    }
    isAgencyResourceSharingEnabled() {
        return this.getIsAgencyConsumerResourceSharingEnabled() && this.getIsAgencyContactResourceSharingEnabled();
    }
    isSharedResourcesUpdated() {
        return this.store.selectSnapshot(SiteState.isSharedResourcesUpdated);
    }
    async fetchAndSetContactResources() {
        if (this.isAgencyResourceSharingEnabled()) {
            const sourceSiteId = this.store.selectSnapshot(QuoteBeneficiaryState.getSourceSiteId);
            if (sourceSiteId) {
                const sharedResources = await firstValueFrom(this.configResourceService.fetchContactResource$(sourceSiteId));
                if (sharedResources) {
                    this.configResourceService.updateConfigResource(sharedResources.resourceBundle);
                    this.configResourceService.setContactInfoConfig(sharedResources);
                }
            }
        }
    }
}
SharedResourceService.ɵfac = function SharedResourceService_Factory(t) { return new (t || SharedResourceService)(i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(i1.Store)); };
SharedResourceService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SharedResourceService, factory: SharedResourceService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SharedResourceService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ConfigResourceService }, { type: i1.Store }]; }, null); })();

const SET_SHARED_RESOURCES = 'set-shared-resources';
const SharedResourcesResolver = async (route, state, siteService = inject(SiteService), sharedResourceService = inject(SharedResourceService)) => {
    const isConsumerSite = !siteService.isPPCSite();
    if (isConsumerSite) {
        const isUpdated = sharedResourceService.isSharedResourcesUpdated();
        if (!isUpdated) {
            await sharedResourceService.fetchAndSetContactResources();
        }
    }
};

// checks for a valid auth token and if available adds the token to the header of http requests
class AuthRequestInterceptor {
    constructor(authService) {
        this.authService = authService;
    }
    // like middleware but just for an outgoing request
    intercept(req, next) {
        if (req.headers.get('noAuthToken')) {
            const updatedRequest = req.clone({
                headers: req.headers.delete('noAuthToken')
            });
            return next.handle(updatedRequest);
        }
        // if we don't have an auth token the token has never been acquired or is expired and we
        // have previously loaded a jwt then we need to refresh the token before sending the request
        if (!this.authService.isJWTLoading() && !this.authService.isCurrentTokenValid()) {
            return of(this.authService.loadJWT()).pipe(switchMap(jwtLoaded => {
                if (jwtLoaded) {
                    return this.handleWithAuth(this.authService.getToken(), req, next);
                }
                // Since version 10 any resolver which returns EMPTY will cancel navigation
                // TODO: test that is OK in regression testing. this may be fine since this
                // is not a resolver
                return EMPTY;
            }), take(1));
        }
        return this.handleWithAuth(this.authService.getToken(), req, next);
    }
    handleWithAuth(authToken, req, next) {
        if (authToken) {
            const authRequest = req.clone({
                headers: req.headers.set('Authorization', `Bearer ${authToken}`)
            }); // need to copy the request to prevent issues
            // allow the request to continue its journey
            return next.handle(authRequest);
        }
        // no token to set in the authorization header so move along
        return next.handle(req);
    }
}
AuthRequestInterceptor.ɵfac = function AuthRequestInterceptor_Factory(t) { return new (t || AuthRequestInterceptor)(i0.ɵɵinject(AuthService)); };
AuthRequestInterceptor.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AuthRequestInterceptor, factory: AuthRequestInterceptor.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthRequestInterceptor, [{
        type: Injectable
    }], function () { return [{ type: AuthService }]; }, null); })();

class AuthResponseInterceptor {
    constructor(authService, store) {
        this.authService = authService;
        this.store = store;
    }
    intercept(req, next) {
        return next.handle(req).pipe(tap((event) => {
            if (event instanceof HttpResponse) {
                const accessToken = event.headers.get('Set-Authorization');
                const expiresIn = event.headers.get('Set-Authorization-Expires-In');
                if (accessToken && expiresIn) {
                    this.authService.saveJWT({ access_token: accessToken, expires_in: +expiresIn, token_type: 'Bearer' });
                }
            }
        }));
    }
}
AuthResponseInterceptor.ɵfac = function AuthResponseInterceptor_Factory(t) { return new (t || AuthResponseInterceptor)(i0.ɵɵinject(AuthService), i0.ɵɵinject(i1.Store)); };
AuthResponseInterceptor.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AuthResponseInterceptor, factory: AuthResponseInterceptor.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthResponseInterceptor, [{
        type: Injectable
    }], function () { return [{ type: AuthService }, { type: i1.Store }]; }, null); })();

class PlanCompareApiParams {
    static mapToPlanCompareApiEnrollmentModel(params) {
        if (params) {
            const { qs, sig, sigid, bitlen, haKeyVer, tpKeyVer, tagName, SSOValue, EnrollmentReturnURL, sendToBeneficiary, TFN, signAndSubmit } = params;
            const sendToBeneficiaryFlag = sendToBeneficiary === 'true';
            const signAndSubmitFlag = signAndSubmit === 'true';
            if (qs && sigid && bitlen && haKeyVer && tpKeyVer && tagName) {
                return {
                    qs,
                    sig,
                    sigid,
                    bitlen,
                    haKeyVer,
                    tpKeyVer,
                    tagName,
                    SSOValue,
                    EnrollmentReturnURL,
                    ...(sendToBeneficiaryFlag && { sendToBeneficiary: sendToBeneficiaryFlag }),
                    ...(TFN && { TFN }),
                    ...(signAndSubmitFlag && { signAndSubmit: signAndSubmitFlag })
                };
            }
            return null;
        }
    }
}
class DecryptedPlanCompareEnrollment {
}

class RouteAuthorizationService {
    constructor(router, store, agentService, siteService, navigationService, configResourceService, memberSessionService, agentPermissionsService, base64UtilityService) {
        this.router = router;
        this.store = store;
        this.agentService = agentService;
        this.siteService = siteService;
        this.navigationService = navigationService;
        this.configResourceService = configResourceService;
        this.memberSessionService = memberSessionService;
        this.agentPermissionsService = agentPermissionsService;
        this.base64UtilityService = base64UtilityService;
        this.AUTH_REQUIRED_PAGES = Object.values(PageTags).filter(page => page !== PageTags.AGENT_LOGIN &&
            page !== PageTags.FORGOT_PASSWORD &&
            page !== PageTags.FORGOT_USERNAME &&
            page !== PageTags.RESET_PASSWORD &&
            page !== PageTags.SOA_FORM &&
            page !== PageTags.SHARE_PRESCRIPTIONS &&
            page !== PageTags.BROWSER_DENIED &&
            page !== PageTags.AGENT_SUBSCRIPTION &&
            page !== PageTags.SUBSCRIPTION_CONFIRMATION);
        this.AGENT_PAGES = [
            PageTags.PROFILE_SEARCH,
            PageTags.AGENT_ACCOUNT_OVERVIEW,
            PageTags.AGENT_VIEW_PROFILE,
            PageTags.ADD_NEW_PROFILE,
            PageTags.ADD_NEW_AGENT,
            PageTags.AGENT_SEARCH,
            PageTags.MEMBER_PROFILE_PAGE,
            PageTags.AGENT_DASHBOARD,
            PageTags.AGENT_ENROLLINFO,
            PageTags.AGENT_SOA,
            PageTags.SOA,
            PageTags.MEMBER_RECORDINGS
        ];
        // These are pages that enrollment confirmation should not reset the session when navigating to
        // Plan Details is kind of an exception, but is handled after we check this, in checkAndResetLoginStatus
        this.CONFIRMATION_RESET_EXCEPTIONS = [
            PageTags.ENROLLMENT_CONFIRMATION,
            PageTags.STANDALONE_CONFIRMATION,
            PageTags.DENTAL_CONFIRMATION,
            PageTags.ENROLLMENT_EXPIRED,
            PageTags.ANCILLARY_CONFIRMATION,
            PageTags.CONSUMER_ACCOUNT_SUMMARY,
            PageTags.HRA_FORM
        ];
        this.SIGN_AND_SUBMIT_PAGES = [
            PageTags.BENEFICIARY_LOGIN,
            PageTags.ENROLLMENT,
            PageTags.ENROLLMENT_EXPIRED,
            PageTags.ENROLLMENT_CONFIRMATION,
            PageTags.HRA_FORM,
            PageTags.HRA_CONFIRMATION
        ];
        this.MEMBER_PAGES = [PageTags.RETENTION_SUMMARY, PageTags.QUOTE_SUMMARY];
        this.agentCreateLockDown = this.configResourceService.getProcessedResourceValue('Spa_Agent_Create_Lock_Down', null, false);
        this.siteType = this.configResourceService.getProcessedResourceValue('Spa_Site_SiteType', null, SiteType.CONSUMER);
        this.isMFAEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_MFA_Enabled', null, false);
        this.isMedicareEdgeEnabled = this.configResourceService.getProcessedResourceValue('Spa_MedicareEdge_Enabled', null, false);
        this.isProfileSearchEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_Profile_Enabled', null, true);
        this.isPlanSmartEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_PlanSmart_Enabled', null, true);
        this.isAgentLoginRequired = true;
    }
    async checkAndResetLoginStatus(url) {
        const selectedPage = this.getSelectedPage(url);
        const isForceLogoutRequired = selectedPage &&
            !selectedPage.tags.some(pageTag => this.CONFIRMATION_RESET_EXCEPTIONS.includes(pageTag)) &&
            this.store.selectSnapshot(ConfirmationState.hasVisited) &&
            (this.isPPCSite() || !this.isMemberLoggedIn());
        if (isForceLogoutRequired) {
            const clearDemographics = selectedPage.tags.includes(PageTags.PLAN_DETAILS);
            if (clearDemographics) {
                this.forceLogout(false, false);
            }
            else {
                this.forceLogout(true);
            }
        }
    }
    forceLogout(clearAnonymousSession, resetConfirmation = true) {
        if (resetConfirmation) {
            this.store.dispatch(new ResetConfirmationState());
        }
        if (!this.isPPCSite()) {
            this.memberSessionService.memberLogout({ clearAnonymousSession });
            this.memberSessionService.resetAuthType();
            this.agentService.resetAgentState();
        }
    }
    agentCanAccess(url, passParametersMap) {
        const selectedPage = this.getSelectedPage(url);
        if (!selectedPage) {
            // if the look up doesn't find a matching page we know this page is not require for authentication so return true
            return true;
        }
        const isPPCSite = this.isPPCSite();
        const isMemberLoggedIn = this.isMemberLoggedIn();
        const isVerificationEnabled = this.configResourceService.getProcessedResourceValue('Spa_Verification_Enabled', null, false);
        if (isPPCSite &&
            isVerificationEnabled &&
            // When the Verification flow is enabled, the URL generated for Quote/STB/PURL+ will contain UTM deep linking params.
            // If the redirect page tag is the Home page, the Google Tag Manager resolver will add those UTM params back to the URL.
            // In consequence, when we process the pass parameters again (SSO + Deep Linking), they won't be null this time.
            // By checking if the user is not logged in, it prevents redirecting the user back to the Verification page after authentication.
            !isMemberLoggedIn &&
            this.isRedirectWithAccountGuid(passParametersMap) &&
            !this.selectedPageHasAnyUTMParameter(selectedPage.tags, PageTags.BENEFICIARY_VERIFICATION, passParametersMap?.deepLinkingPassParams)) {
            const utmQueryParams = this.getUTMParameters();
            const queryParams = {
                ...utmQueryParams,
                accountGuid: this.base64UtilityService.decodeText(passParametersMap.ssoParams.AccountGuid)
            };
            this.navigationService.navigateByPageTag(PageTags.BENEFICIARY_VERIFICATION, { queryParams });
            return false;
        }
        const isAgentLoginOnConsumerSite = !isPPCSite && selectedPage.tags.includes(PageTags.AGENT_LOGIN);
        const agentTags = selectedPage.tags.filter((tag) => this.AGENT_PAGES.includes(tag));
        const authTags = selectedPage.tags.filter((tag) => this.AUTH_REQUIRED_PAGES.includes(tag));
        const signAndSubmitTags = selectedPage.tags.filter((tag) => this.SIGN_AND_SUBMIT_PAGES.includes(tag));
        // NG-2055: we need to allow consumer to access Authorization page on broker site
        if (signAndSubmitTags.length !== 0 && isPPCSite) {
            this.isAgentLoginRequired = false; // agent login is not required for sign and submit flow on broker sites
            return true;
        }
        else {
            this.isAgentLoginRequired = true;
        }
        // If not Auth required page or consumer and not agent page then return true.
        if ((authTags.length === 0 || !isPPCSite) && agentTags.length === 0) {
            // return true;
            if (!isAgentLoginOnConsumerSite) {
                return true;
            }
        }
        // if agent is not logged in, navigate to the agent login page and return false (if PPC site)
        // NG-2055: agent login is not required when we have consumer navigating to broker site for sign and submit enrollment
        if (isPPCSite && this.isAgentLoginRequired && !this.isAgentLoggedIn()) {
            this.navigateToSpecificPage(PageTags.AGENT_LOGIN);
            return false;
        }
        // assuming agent is logged in, check if route should be activated
        const isRouteActivated = this.getCanActivateRoute(selectedPage, agentTags);
        if (!isRouteActivated) {
            this.navigationService.navigateTo404();
            return false;
        }
        return true;
    }
    // eslint-disable-next-line complexity
    memberCanAccess(url, passParametersMap) {
        if (this.isPPCSite()) {
            return true;
        }
        const selectedPage = this.getSelectedPage(url);
        if (!selectedPage) {
            // if the look up doesn't find a matching page we know this page is not require for authentication so return true
            return true;
        }
        const isMemberLoggedIn = this.isMemberLoggedIn();
        const memberTags = selectedPage.tags.find((tag) => this.MEMBER_PAGES.includes(tag));
        const isVerificationEnabled = this.configResourceService.getProcessedResourceValue('Spa_Verification_Enabled', null, false);
        if (memberTags && !isMemberLoggedIn) {
            this.forceLogout(true);
            if (memberTags === PageTags.QUOTE_SUMMARY) {
                this.navigateToSpecificPage(PageTags.HOME);
            }
            if (memberTags === PageTags.RETENTION_SUMMARY) {
                let queryParams = {};
                const params = url.includes('?') ? url.split('?')[1] : '';
                if (params) {
                    // create queryParams object from querystring parameters
                    queryParams = JSON.parse(`{"${decodeURI(params.replace(/&/g, '","').replace(/=/g, '":"'))}"}`);
                }
                this.navigationService.navigateByPageTag(PageTags.RETENTION, { state: queryParams });
            }
            return false;
        }
        else if (this.isMedicareEdgeEnabled && !this.agentService.getIsAgentInContext()) {
            const medicareMemberTag = selectedPage.tags.find((tag) => tag === PageTags.BENEFICIARY_LOGIN || tag === PageTags.HOME);
            if (!medicareMemberTag) {
                this.navigationService.navigateTo404();
                return false;
            }
        }
        else if (this.isMFAEnabled &&
            this.siteService.consumerSiteTypeSnapshot() !== ConsumerSiteType.RETENTION &&
            (this.isPurlRedirectWithAccountGuid(passParametersMap) || this.isBookmarkablePurlRedirectWithAccountGuid(passParametersMap)) &&
            !this.selectedPageHasAnyUTMParameter(selectedPage.tags, PageTags.BENEFICIARY_AUTHENTICATION, passParametersMap?.deepLinkingPassParams)) {
            const utmQueryParams = this.getUTMParameters();
            const queryParams = {
                ...utmQueryParams,
                accountGuid: this.base64UtilityService.decodeText(passParametersMap.ssoParams.AccountGuid)
            };
            this.navigationService.navigateByPageTag(PageTags.BENEFICIARY_AUTHENTICATION, { queryParams });
            return false;
        }
        else if (isVerificationEnabled &&
            // When the Verification flow is enabled, the URL generated for Quote/STB/PURL+ will contain UTM deep linking params.
            // If the redirect page tag is the Home page, the Google Tag Manager resolver will add those UTM params back to the URL.
            // In consequence, when we process the pass parameters again (SSO + Deep Linking), they won't be null this time.
            // By checking if the user is not logged in, it prevents redirecting the user back to the Verification page after authentication.
            !isMemberLoggedIn &&
            this.siteService.consumerSiteTypeSnapshot() !== ConsumerSiteType.RETENTION &&
            (this.isRedirectWithAccountGuid(passParametersMap) || this.isBookmarkablePurlRedirectWithAccountGuid(passParametersMap)) &&
            !this.selectedPageHasAnyUTMParameter(selectedPage.tags, PageTags.BENEFICIARY_VERIFICATION, passParametersMap?.deepLinkingPassParams)) {
            const utmQueryParams = this.getUTMParameters();
            const queryParams = {
                ...utmQueryParams,
                accountGuid: this.base64UtilityService.decodeText(passParametersMap.ssoParams.AccountGuid)
            };
            this.navigationService.navigateByPageTag(PageTags.BENEFICIARY_VERIFICATION, { queryParams });
            return false;
        }
        else if (this.isRetireFloPurlRedirect(passParametersMap)) {
            this.navigationService.navigateByPageTag(PageTags.RETIRE_FLO_SURVEY);
            return false;
        }
        return true;
    }
    isAgentLoggedIn() {
        return this.store.selectSnapshot(AgentState.isLoggedIn);
    }
    isMemberLoggedIn() {
        return this.store.selectSnapshot(MemberState.isLoggedIn);
    }
    // TODO: copy from RouteBuilder... refactor after AEP
    includesFormPageTag(pageTags) {
        return (pageTags.includes(PageTags.ENROLLMENT) ||
            pageTags.includes(PageTags.STANDALONE_FORM) ||
            pageTags.includes(PageTags.STANDALONE_ANCILLARY_FORM) ||
            pageTags.includes(PageTags.GENERIC_FORM) ||
            pageTags.includes(PageTags.HRA_FORM) ||
            pageTags.includes(PageTags.ANCILLARY_FORM));
    }
    getSelectedPage(url) {
        const pages = this.store.selectSnapshot(AppConfigState.pages);
        const selectedPage = pages.find(page => {
            const pageTags = page.tags;
            if (this.includesFormPageTag(pageTags)) {
                return RoutesUtilityService.pageNameURLStartWith(page.pageName, url);
            }
            return RoutesUtilityService.pageNameURLMatch(page.pageName, url);
        });
        return selectedPage;
    }
    navigateToSpecificPage(pageTag) {
        const tagHref = this.store.selectSnapshot(AppConfigState.hrefByTag(pageTag));
        this.router.navigate([tagHref]);
    }
    isPPCSite() {
        return this.siteService.isPPCSite(this.siteType);
    }
    hasAgentAdminPermissions() {
        return this.agentPermissionsService.hasAdminPermissions();
    }
    hasMemberProfileAgentPermissions() {
        return this.agentPermissionsService.hasMemberProfilePermissions();
    }
    isRedirectWithAccountGuid(passParametersMap) {
        return !!(passParametersMap?.ssoParams?.PageTag && passParametersMap?.ssoParams?.AccountGuid);
    }
    isBookmarkablePurlRedirectWithAccountGuid(passParametersMap) {
        return !!(passParametersMap?.deepLinkingPassParams?.PurlId && passParametersMap?.ssoParams?.AccountGuid);
    }
    isPurlRedirectWithAccountGuid(passParametersMap) {
        return !!(this.isRedirectWithAccountGuid(passParametersMap) && passParametersMap?.deepLinkingPassParams?.IsPurlRequest === 'true');
    }
    isRetireFloPurlRedirect(passParametersMap) {
        return !!(passParametersMap?.deepLinkingPassParams?.IsPurlRequest === 'true' &&
            passParametersMap?.ssoParams?.PageTag === PageTags.RETIRE_FLO_SURVEY);
    }
    getCanActivateRoute(selectedPage, agentTags, isPPCSite = this.isPPCSite()) {
        if (selectedPage.tags) {
            const isCurrentPageAgentLogin = selectedPage.tags.includes(PageTags.AGENT_LOGIN);
            const isAgentPage = agentTags.length !== 0;
            // Guard against access to Agent pages on consumer sites, regardless of agent in context.
            // Agent pages should be inaccessible on consumer sites, including agent login page.
            if ((isAgentPage || isCurrentPageAgentLogin) && !isPPCSite) {
                return false;
            }
            // Guard against access to profile search page if feature is disabled, regardless of permission.
            if (selectedPage.tags.includes(PageTags.PROFILE_SEARCH)) {
                return this.isProfileSearchEnabled;
            }
            if (selectedPage.tags.includes(PageTags.PLAN_SMART)) {
                return this.isPlanSmartEnabled;
            }
            // Users with View_All/Edit_All, View_Under/Edit_Under and View_Assigned/Edit_Assigned permission
            // combos may have access to Member profile page. If profile search is disabled, we do not allow access to the Add New Profile Page.
            if (selectedPage.tags.includes(PageTags.ADD_NEW_PROFILE)) {
                return this.isProfileSearchEnabled && this.hasMemberProfileAgentPermissions();
            }
            // Enroller_Admin and Quoter_Admin permission sets may access AgentSearch and AddAgent pages
            // (Note: AddAgent is not the account overview page).
            if (selectedPage.tags.includes(PageTags.AGENT_SEARCH) || selectedPage.tags.includes(PageTags.ADD_NEW_AGENT)) {
                if (this.agentCreateLockDown && selectedPage.tags.includes(PageTags.ADD_NEW_AGENT)) {
                    return false;
                }
                return this.hasAgentAdminPermissions();
            }
            if (selectedPage.tags.includes(PageTags.REPORTS_SUMMARY) && this.agentPermissionsService.hasBasicRole()) {
                return false;
            }
            // Guard against access to member records page if the agent is not an admin.
            if (selectedPage.tags.includes(PageTags.MEMBER_RECORDINGS)) {
                return this.agentPermissionsService.isAgentAdmin();
            }
            // Guard against access to retention summary page if the retention view is not available.
            // Possible reasons could be:
            // - The consumer site is not a retention site
            // - The resource "Spa_RetentionSummary_Profile_Enabled" is disabled (broker)
            // - The member in context is not a retention member or the source of that member is not of type "Claims" (broker)
            if (selectedPage.tags.includes(PageTags.RETENTION_SUMMARY)) {
                return this.siteService.isRetentionView();
            }
        }
        return true;
    }
    getUTMParameters() {
        const utmSource = this.store.selectSnapshot(DeepLinkingParamsState.utmSource);
        const utmMedium = this.store.selectSnapshot(DeepLinkingParamsState.utmMedium);
        const utmCampaign = this.store.selectSnapshot(DeepLinkingParamsState.utmCampaign);
        const utmContent = this.store.selectSnapshot(DeepLinkingParamsState.utmContent);
        return {
            ...(utmSource && { [UTMParameter.UTM_SOURCE]: utmSource }),
            ...(utmMedium && { [UTMParameter.UTM_MEDIUM]: utmMedium }),
            ...(utmCampaign && { [UTMParameter.UTM_CAMPAIGN]: utmCampaign }),
            ...(utmContent && { [UTMParameter.UTM_CONTENT]: utmContent })
        };
    }
    selectedPageHasAnyUTMParameter(selectedPageTags, pageTag, deepLinkingPassParams) {
        return (!!deepLinkingPassParams &&
            selectedPageTags.includes(pageTag) &&
            Object.keys(deepLinkingPassParams).some(deepLinkingParam => UTM_PARAMETER_KEYS.includes(deepLinkingParam?.toLowerCase())));
    }
}
RouteAuthorizationService.ɵfac = function RouteAuthorizationService_Factory(t) { return new (t || RouteAuthorizationService)(i0.ɵɵinject(i2$1.Router), i0.ɵɵinject(i1.Store), i0.ɵɵinject(AgentService), i0.ɵɵinject(SiteService), i0.ɵɵinject(NavigationService), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(MemberSessionService), i0.ɵɵinject(AgentPermissionsService), i0.ɵɵinject(Base64UtilityService)); };
RouteAuthorizationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: RouteAuthorizationService, factory: RouteAuthorizationService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RouteAuthorizationService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i2$1.Router }, { type: i1.Store }, { type: AgentService }, { type: SiteService }, { type: NavigationService }, { type: ConfigResourceService }, { type: MemberSessionService }, { type: AgentPermissionsService }, { type: Base64UtilityService }]; }, null); })();

class GenericFormService {
    constructor(enrollmentFormService, store, memberSessionService, configResourceService, emailService, navigationUtilityService, lockedSiteService, shoppingCartService, phoneService, agentService, navigationContext, preferencesService, planYearResourceService, localeService) {
        this.enrollmentFormService = enrollmentFormService;
        this.store = store;
        this.memberSessionService = memberSessionService;
        this.configResourceService = configResourceService;
        this.emailService = emailService;
        this.navigationUtilityService = navigationUtilityService;
        this.lockedSiteService = lockedSiteService;
        this.shoppingCartService = shoppingCartService;
        this.phoneService = phoneService;
        this.agentService = agentService;
        this.navigationContext = navigationContext;
        this.preferencesService = preferencesService;
        this.planYearResourceService = planYearResourceService;
        this.localeService = localeService;
    }
    getTransactionId(formId) {
        return this.enrollmentFormService.getTransactionId(formId);
    }
    getPageHtml$(pageIndex, formId, locale) {
        return this.enrollmentFormService.fetchPageHtml$(pageIndex, formId, locale);
    }
    getPageIndex(formId, pageName) {
        return this.enrollmentFormService.getPageIndex(formId, pageName);
    }
    getPageInfos(formId) {
        return this.enrollmentFormService.getFormPages(formId);
    }
    getFirstPageName(formId) {
        const formPages = this.getPageInfos(formId);
        if (formPages && formPages[0] && formPages[0].pageName) {
            return formPages[0].pageName;
        }
    }
    getPageName(formId, pageIndex) {
        return this.enrollmentFormService.getPageName(formId, pageIndex);
    }
    getGenericFormBaseUrl(path) {
        // We need to determine if this is the ancillar form page or generic form page because we may have both
        // and it matter for analytics purposes. Could have also added a new resolver and service but looking
        // to reuse as much as possible here.
        const genericFormPageTag = this.isAncillaryFormPage(path) ? PageTags.ANCILLARY_FORM : PageTags.GENERIC_FORM;
        return this.store.selectSnapshot(AppConfigState.hrefByTag(genericFormPageTag));
    }
    isAncillaryFormPage(path) {
        const currentPath = path ?? this.navigationContext.getUrl();
        const ancillaryPageRoot = this.getAncillaryFormBaseUrl();
        return (!!ancillaryPageRoot &&
            !!this.navigationUtilityService.normalizePath(currentPath).startsWith(this.navigationUtilityService.normalizePath(ancillaryPageRoot)));
    }
    isAncillaryConfirmationPage() {
        return this.navigationUtilityService.pageTagURLMatch(PageTags.ANCILLARY_CONFIRMATION, this.navigationContext.getUrl());
    }
    getAncillaryFormBaseUrl() {
        return this.store.selectSnapshot(AppConfigState.hrefByTag(PageTags.ANCILLARY_FORM));
    }
    fetchPageInfo$(formId) {
        return this.enrollmentFormService.fetchPageInfo$(formId);
    }
    fetchPageHtml$(pageIndex, formId, locale) {
        return this.enrollmentFormService.fetchPageHtml$(pageIndex, formId, locale);
    }
    fetchPageHtmlByName$(formId, pageName, locale) {
        const pageIndex = this.getPageIndex(formId, pageName);
        return this.fetchPageHtml$(pageIndex, formId, locale);
    }
    initializeFormAndTransaction$(formId, customInternalDefinition, isAncillaryForm) {
        this.enrollmentFormService.resetActiveEnrollmentKey();
        this.enrollmentFormService.setActiveEnrollmentKey(formId);
        return this.createTransaction$(formId, customInternalDefinition, isAncillaryForm).pipe(switchMap(() => this.fetchPageInfo$(formId)));
    }
    getCustomInternalWrapper(customInternal) {
        const customInternalWrapper = new CustomInternalWrapper();
        customInternalWrapper.CustomInternal = customInternal;
        return customInternalWrapper;
    }
    populateCustomInternal(customInternalDefinition, userType) {
        const customInternalWrapper = this.getCustomInternalWrapper(customInternalDefinition);
        return this.prepareAndStoreCustomInternalWrapper(customInternalWrapper, userType);
    }
    prepareAndStoreCustomInternalWrapper(customInternalWrapper, userType) {
        const preparedCustomInternal = this.enrollmentFormService.prepareCustomInternalForBean(customInternalWrapper, userType);
        this.enrollmentFormService.setCustomInternalToSessionStorage(preparedCustomInternal);
        return preparedCustomInternal;
    }
    createTransaction$(formId, customInternalDefinition, isAncillaryForm = false) {
        const currentLocale = this.localeService.getCurrentLocale();
        const siteId = this.enrollmentFormService.getSiteId();
        const userType = this.configResourceService.getProcessedResourceValue('UserType', null, '');
        const planYear = this.planYearResourceService.getSelectedPlanYear();
        const appId = this.configResourceService.getProcessedResourceValue('AppID');
        const partnerId = this.configResourceService.getProcessedResourceValue('PartnerID');
        const sourceId = this.configResourceService.getProcessedResourceValue('SourceID');
        const isSiteLive = this.lockedSiteService.isSiteLive();
        const isLockedSite = this.lockedSiteService.isReviewSite(window.location.hostname);
        const transactionRequest = new Transaction();
        transactionRequest.transactionGUID = uuid();
        transactionRequest.tid = 0;
        transactionRequest.encryptionTypeId = 0;
        transactionRequest.formType = EnrollmentFormType.LONG;
        transactionRequest.langID = LocaleService.LOCALE_ALIAS_ID[currentLocale];
        transactionRequest.overrideStoredAnswers = true;
        transactionRequest.publicFormId = formId;
        transactionRequest.isMedigap = false;
        transactionRequest.isTestingSite = this.configResourceService.isTestingSite();
        transactionRequest.planYear = planYear;
        transactionRequest.partnerID = partnerId;
        transactionRequest.isActive = !isLockedSite && isSiteLive;
        transactionRequest.isPreview = !isSiteLive;
        transactionRequest.sourceID = sourceId;
        transactionRequest.originalAppID = appId;
        transactionRequest.destinationAppID = appId;
        transactionRequest.sourceID = appId;
        transactionRequest.userType = userType;
        transactionRequest.siteID = siteId;
        if (isAncillaryForm) {
            transactionRequest.isAncillary = isAncillaryForm;
        }
        if (customInternalDefinition) {
            transactionRequest.customInternalJson = this.populateCustomInternal(customInternalDefinition, userType);
        }
        return this.store.dispatch(new CreateHopeTransactions([transactionRequest], formId));
    }
    updateTransaction$(updateTransactionRequest, formId) {
        return this.enrollmentFormService.updateFormTransaction$(updateTransactionRequest, formId);
    }
    async completeEnrollment(transactionAnswers, formId, isHRA = false, widgetName) {
        const inputs = [];
        const sessionId = this.memberSessionService.getMemberSessionId();
        const transactionId = this.getTransactionId(formId);
        const enrollmentConfig = this.createConfirmationInfo(isHRA, widgetName);
        const planYear = this.planYearResourceService.getSelectedPlanYear();
        const isPostBackEnabled = false;
        const postBackUrl = null;
        const salesForceSyncEnabled = this.configResourceService.getProcessedResourceValue('Spa_SF_SyncEnabled', null, false);
        const isSiteLive = this.lockedSiteService.isSiteLive();
        const isReviewSite = this.lockedSiteService.isReviewSite(window.location.hostname);
        const enrollmentRequest = {
            payload: this.getEnrollmentSettings(isHRA),
            config: enrollmentConfig,
            confirmationPostBackUrl: postBackUrl,
            confirmationPostBackEnable: isPostBackEnabled,
            sfSyncEnabled: salesForceSyncEnabled,
            isSiteLive,
            isReviewSite,
            isTestingSite: this.configResourceService.isTestingSite()
        };
        if (!isHRA) {
            enrollmentRequest.externalEnrollment = this.enrollmentFormService.getExternalEnrollmentSettings();
        }
        else {
            const planId = this.store.selectSnapshot(EnrollmentState.hraPlanId);
            const preferencesJSON = await this.preferencesService.createPreferencesJSON(planId, isHRA);
            enrollmentRequest.preferencesJSON = preferencesJSON;
        }
        return await this.store
            .dispatch(new CompleteEnrollment(sessionId, transactionId, planYear, enrollmentRequest, formId, -1))
            .pipe(switchMap(() => this.sendConfirmationEmails$(transactionAnswers, inputs, formId, isHRA)))
            .toPromise();
    }
    getEnrollmentSettings(isHRA = false) {
        const destinationPageTag = this.getDestinationPageTag(isHRA);
        const formId = this.getFormIdByFormType(isHRA);
        const siteId = this.enrollmentFormService.getSiteId();
        const userType = this.configResourceService.getProcessedResourceValue('UserType', null, '');
        const formType = this.store.selectSnapshot(EnrollmentState.selectedFormType(formId));
        const enrollmentSettings = new BeanProviderSettings();
        enrollmentSettings.destinationUrl = this.navigationUtilityService.constructHref(destinationPageTag);
        enrollmentSettings.integrationType = IntegrationType.INLINE;
        enrollmentSettings.isPost = false;
        enrollmentSettings.isExternal = false;
        enrollmentSettings.planIds = this.getPlanIdsForEnrollmentSettings(isHRA);
        enrollmentSettings.formId = formId;
        enrollmentSettings.userType = userType;
        enrollmentSettings.formType = formType;
        enrollmentSettings.siteID = siteId;
        return enrollmentSettings;
    }
    createConfirmationInfo(isHRA = false, widgetName) {
        if (isHRA) {
            return this.createHRAConfirmationInfo(widgetName);
        }
        return this.createGenericFormConfirmationInfo(widgetName);
    }
    createGenericFormConfirmationInfo(widgetName) {
        const enrollmentConfirmationInfo = new EnrollmentConfig();
        enrollmentConfirmationInfo.Enrollment_Confirmation_CharacterArray = this.configResourceService.getProcessedResourceValue('Spa_Site_EnrollmentConfirmationIdValidCharacters', widgetName, '56789');
        enrollmentConfirmationInfo.Enrollment_Confirmation_DigitArray = this.configResourceService.getProcessedResourceValue('Spa_Site_EnrollmentConfirmationIdValidDigits', widgetName, '0123456789');
        enrollmentConfirmationInfo.Enrollment_Confirmation_Format = this.configResourceService.getProcessedResourceValue('Spa_Site_EnrollmentConfirmationIdFormat', widgetName, '@#############');
        enrollmentConfirmationInfo.Enrollment_Confirmation_Prefix = this.configResourceService.getProcessedResourceValue('Spa_Site_EnrollmentConfirmationIdPrefix', widgetName, '');
        enrollmentConfirmationInfo.Enrollment_Confirmation_Suffix = this.configResourceService.getProcessedResourceValue('Spa_Site_EnrollmentConfirmationIdSuffix', widgetName, '');
        return enrollmentConfirmationInfo;
    }
    createHRAConfirmationInfo(widgetName) {
        const enrollmentConfirmationInfo = new EnrollmentConfig();
        const hraPlanId = this.store.selectSnapshot(EnrollmentState.hraPlanId);
        enrollmentConfirmationInfo.Enrollment_Confirmation_CharacterArray =
            this.configResourceService.getProcessedResourceValue('Spa_HRA_EnrollmentConfirmationIdValidCharacters', widgetName) ||
                this.shoppingCartService.getPlanExtraDataById(hraPlanId, PlanExtraDataKey.HRA_ENROLLMENT_CONFIRMATION_CHARACTER_ARRAY) ||
                '56789';
        enrollmentConfirmationInfo.Enrollment_Confirmation_DigitArray =
            this.configResourceService.getProcessedResourceValue('Spa_HRA_EnrollmentConfirmationIdValidDigits', widgetName) ||
                this.shoppingCartService.getPlanExtraDataById(hraPlanId, PlanExtraDataKey.HRA_ENROLLMENT_CONFIRMATION_DIGIT_ARRAY) ||
                '0123456789';
        enrollmentConfirmationInfo.Enrollment_Confirmation_Format =
            this.configResourceService.getProcessedResourceValue('Spa_HRA_EnrollmentConfirmationIdFormat', widgetName) ||
                this.shoppingCartService.getPlanExtraDataById(hraPlanId, PlanExtraDataKey.HRA_ENROLLMENT_CONFIRMATION_FORMAT) ||
                '@#############';
        enrollmentConfirmationInfo.Enrollment_Confirmation_Prefix =
            this.configResourceService.getProcessedResourceValue('Spa_HRA_EnrollmentConfirmationIdPrefix', widgetName) ||
                this.shoppingCartService.getPlanExtraDataById(hraPlanId, PlanExtraDataKey.HRA_ENROLLMENT_CONFIRMATION_PREFIX) ||
                '';
        enrollmentConfirmationInfo.Enrollment_Confirmation_Suffix =
            this.configResourceService.getProcessedResourceValue('Spa_HRA_EnrollmentConfirmationIdSuffix', widgetName) ||
                this.shoppingCartService.getPlanExtraDataById(hraPlanId, PlanExtraDataKey.HRA_ENROLLMENT_CONFIRMATION_SUFFIX) ||
                '';
        return enrollmentConfirmationInfo;
    }
    async sendConfirmationEmails$(transactionAnswers, inputs, formId, isHRA = false) {
        if (isHRA) {
            await this.sendHRAConfirmationEmails$(transactionAnswers, formId, inputs);
        }
        else {
            await this.sendGenericConfirmationEmails$(transactionAnswers, inputs);
        }
        return await Promise.resolve(null);
    }
    async sendHRAConfirmationEmails$(transactionAnswers, formId, inputs = []) {
        const planId = this.store.selectSnapshot(EnrollmentState.hraPlanId);
        await this.fetchTransaction$(formId).toPromise();
        const transaction = this.getTransaction(planId);
        const enrollmentDate = this.enrollmentFormService.getFormattedDateForConfirmationEmail(transaction);
        inputs.push({ key: 'enrollmentDate', value: enrollmentDate });
        let inputsWithCarrierInfo = inputs;
        const plan = this.store.selectSnapshot(PlansState.plan(planId));
        if (plan) {
            const carrierInformation = plan.carrierInformation;
            const planEnrollmentInfo = plan.planEnrollmentInfo;
            inputsWithCarrierInfo = this.addCarrierInputs(inputs, carrierInformation, planEnrollmentInfo?.ttyPhone);
        }
        let consumerEmailAddress = '';
        const consumerEmailMatch = transactionAnswers.find(answer => answer.name === 'ApplicantEmailAddress');
        if (consumerEmailMatch && consumerEmailMatch.value) {
            consumerEmailAddress = consumerEmailMatch.value;
        }
        else {
            const profileEmail = this.store.selectSnapshot(ProfileState.emailAddress);
            if (profileEmail) {
                consumerEmailAddress = profileEmail;
            }
        }
        const agentInContext = this.agentService.getIsAgentInContext();
        if (consumerEmailAddress) {
            const agentPhoneNumberFormatted = this.phoneService.formatPhoneNumberWithExtension(this.agentService.getAgentPhone(), this.agentService.getAgentExtension());
            let agentName;
            let agentNPN;
            let californiaLicenseNumber;
            if (this.agentService.isPlanCompareApiAgentDataEnabled()) {
                const planCompareApiAgentData = this.agentService.getPlanCompareApiAgentData(planId);
                ({ agentName, agentNPN, californiaLicenseNumber } = planCompareApiAgentData);
            }
            else {
                agentName = this.agentService.getBrokerFullName();
                agentNPN = this.agentService.getAgentNPN();
                californiaLicenseNumber = this.agentService.getCaliforniaLicenseNumber();
            }
            inputsWithCarrierInfo.push({ key: 'agentName', value: agentName }, { key: 'agentNPN', value: agentNPN }, { key: 'agentPhoneNumber', value: agentPhoneNumberFormatted }, { key: 'californiaLicenseNumber', value: californiaLicenseNumber }, { key: 'agentInContext', value: agentInContext.toString() });
            const consumerSubject = this.configResourceService.getProcessedResourceValue('Spa_HRAConfirmation_ConsumerEmail_Subject', null);
            this.emailService.sendEmail(EmailNames.HRA_CONSUMER, [consumerEmailAddress], consumerSubject, inputsWithCarrierInfo);
        }
        const agentEmailAddress = this.store.selectSnapshot(AgentState.emailAddress);
        if (this.enrollmentFormService.getIsBrokerConfirmationEmailEnabled() && agentInContext && agentEmailAddress) {
            const agentLoginShortUrl = await this.enrollmentFormService.getAgentLoginShortUrl();
            inputsWithCarrierInfo.push({
                key: 'agentLoginShortUrl',
                value: agentLoginShortUrl
            });
            const brokerSubject = this.configResourceService.getProcessedResourceValue('Spa_HRAConfirmation_BrokerEmail_Subject', null);
            this.emailService.sendEmail(EmailNames.HRA_BROKER, [agentEmailAddress], brokerSubject, inputsWithCarrierInfo);
        }
    }
    addCarrierInputs(inputs, carrierInformation, tty) {
        if (carrierInformation?.organizationName) {
            inputs.push({ key: 'organizationName', value: carrierInformation.organizationName });
        }
        if (carrierInformation?.carrierName) {
            inputs.push({ key: 'carrierName', value: carrierInformation.carrierName });
        }
        if (carrierInformation?.carrierAddress?.address1) {
            inputs.push({ key: 'carrierAddress', value: carrierInformation.carrierAddress?.address1 });
        }
        if (carrierInformation?.carrierAddress?.city) {
            inputs.push({ key: 'carrierCity', value: carrierInformation.carrierAddress?.city });
        }
        if (carrierInformation?.carrierAddress?.state) {
            inputs.push({ key: 'carrierState', value: carrierInformation.carrierAddress?.state });
        }
        if (carrierInformation?.carrierAddress?.zip) {
            inputs.push({ key: 'carrierZip', value: carrierInformation.carrierAddress?.zip });
        }
        if (carrierInformation?.hours) {
            inputs.push({ key: 'carrierHours', value: carrierInformation.hours });
        }
        if (carrierInformation?.websiteURL) {
            inputs.push({ key: 'carrierWebsiteURL', value: carrierInformation.websiteURL });
        }
        if (carrierInformation?.phone) {
            let phoneString = this.phoneService.parsePhoneNumber(carrierInformation.phone);
            if (tty) {
                const ttyPhone = tty ? tty : '';
                const ttyResource = this.configResourceService.getProcessedResourceValue('Spa_Enrollment_TTY_Text', null, '');
                if (ttyPhone && ttyResource) {
                    phoneString += ` ${ttyResource} ${ttyPhone}`;
                }
                else if (ttyPhone && !ttyResource) {
                    phoneString += ` ${ttyPhone}`;
                }
            }
            inputs.push({ key: 'carrierPhone', value: phoneString });
        }
        return inputs;
    }
    async sendGenericConfirmationEmails$(transactionAnswers, inputs) {
        const emailAgent = this.configResourceService.getProcessedResourceValue('Spa_GenericForm_CompletionEmailToAgentActive', null, true);
        const subject = this.configResourceService.getProcessedResourceValue('Spa_GenericForm_CompletionEmailToAgentSubject', null);
        const agentEmailAddress = this.store.selectSnapshot(AgentState.emailAddress);
        const emailAddresses = [];
        if (agentEmailAddress && emailAgent) {
            emailAddresses.push(agentEmailAddress);
        }
        const consumerEmailMatch = transactionAnswers.find(answer => answer.name === 'ApplicantEmailAddress');
        if (consumerEmailMatch && consumerEmailMatch.value) {
            emailAddresses.push(consumerEmailMatch.value);
        }
        if (emailAddresses.length) {
            return await this.emailService.sendEmail(EmailNames.GENERIC_FORM_CONFIRMATION, emailAddresses, subject, inputs);
        }
        return await Promise.resolve(null);
    }
    fetchTransaction$(formId) {
        return this.enrollmentFormService.fetchTransaction$(formId, this.getTransactionId(formId));
    }
    getDestinationPageTag(isHRA = false) {
        if (isHRA) {
            return PageTags.HRA_CONFIRMATION;
        }
        return this.configResourceService.getProcessedResourceValue('Spa_GenericForm_RedirectTag');
    }
    getFormIdByFormType(isHRA = false) {
        // Currently the active enrollment key for HRA is the formId.
        // If this ever needs to update, we'll need to change this as well.
        if (isHRA) {
            return this.enrollmentFormService.getActiveEnrollmentKey();
        }
        return this.configResourceService.getProcessedResourceValue('Spa_GenericForm_FormId');
    }
    getConfirmationNumber(activeEnrollmentKey) {
        return this.store.selectSnapshot(EnrollmentState.confirmationNumber(activeEnrollmentKey));
    }
    getPlanIdsForEnrollmentSettings(isHRA = false) {
        if (!isHRA) {
            return [];
        }
        const customInternal = this.enrollmentFormService.getEnrollmentCustomInternal();
        const planId = _get(customInternal, 'CustomInternal.DynamicData.PlanID');
        return planId ? [planId] : [];
    }
    getTransaction(planId) {
        return planId ? this.store.selectSnapshot(EnrollmentState.transaction(planId)) : null;
    }
}
GenericFormService.ɵfac = function GenericFormService_Factory(t) { return new (t || GenericFormService)(i0.ɵɵinject(EnrollmentFormService), i0.ɵɵinject(i1.Store), i0.ɵɵinject(MemberSessionService), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(EmailService), i0.ɵɵinject(NavigationUtilityService), i0.ɵɵinject(LockedSiteService), i0.ɵɵinject(ShoppingCartService), i0.ɵɵinject(PhoneUtilityService), i0.ɵɵinject(AgentService), i0.ɵɵinject(NavigationContext), i0.ɵɵinject(PreferencesService), i0.ɵɵinject(PlanYearResourceService), i0.ɵɵinject(LocaleService)); };
GenericFormService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: GenericFormService, factory: GenericFormService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GenericFormService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: EnrollmentFormService }, { type: i1.Store }, { type: MemberSessionService }, { type: ConfigResourceService }, { type: EmailService }, { type: NavigationUtilityService }, { type: LockedSiteService }, { type: ShoppingCartService }, { type: PhoneUtilityService }, { type: AgentService }, { type: NavigationContext }, { type: PreferencesService }, { type: PlanYearResourceService }, { type: LocaleService }]; }, null); })();

class HRAService {
    constructor(enrollmentFormService, store, memberSessionService, configResourceService, navigationUtilityService, lockedSiteService, plansService, sessionHttpService, siteService, shoppingCartService, ipUtilityService, twilioService, agentService, planYearResourceService, localeService, genericFormService, spinnerService, navigationService, modalService, formPagesMetadataContext, externalErrorLoggingService) {
        this.enrollmentFormService = enrollmentFormService;
        this.store = store;
        this.memberSessionService = memberSessionService;
        this.configResourceService = configResourceService;
        this.navigationUtilityService = navigationUtilityService;
        this.lockedSiteService = lockedSiteService;
        this.plansService = plansService;
        this.sessionHttpService = sessionHttpService;
        this.siteService = siteService;
        this.shoppingCartService = shoppingCartService;
        this.ipUtilityService = ipUtilityService;
        this.twilioService = twilioService;
        this.agentService = agentService;
        this.planYearResourceService = planYearResourceService;
        this.localeService = localeService;
        this.genericFormService = genericFormService;
        this.spinnerService = spinnerService;
        this.navigationService = navigationService;
        this.modalService = modalService;
        this.formPagesMetadataContext = formPagesMetadataContext;
        this.externalErrorLoggingService = externalErrorLoggingService;
    }
    // All of this was moved from generic form service
    getHRAFormBaseUrl() {
        return this.store.selectSnapshot(AppConfigState.hrefByTag(PageTags.HRA_FORM));
    }
    async initializeHRATransaction$(formId, customInternalDefinition, transactionId, isDirectAPIEnrollment, hraUserType, storageId) {
        this.enrollmentFormService.resetActiveEnrollmentKey();
        this.enrollmentFormService.setActiveEnrollmentKey(formId);
        await this.prepareHRAMemberTransaction$(formId, customInternalDefinition, transactionId, isDirectAPIEnrollment, hraUserType, storageId).then(async () => {
            await this.genericFormService.fetchPageInfo$(formId).toPromise();
        });
    }
    getHRAEnrollmentSettings() {
        return this.store.selectSnapshot(MemberState.enrollmentSettings);
    }
    async initializeNextGenHRATransaction$(hraFormId, hraParentPlanId, skipToPageIndex, originalEnrollmentTransactionId = '', isDirectAPIEnrollment) {
        const enrollmentPlanSettingsLoaded = this.enrollmentFormService.getEnrollmentPlanHRASettingsLoaded(undefined, hraParentPlanId);
        if (!enrollmentPlanSettingsLoaded) {
            // since this is the determinant of if a plan has a next gen form we just have to load it each time to know what form type we have
            await this.enrollmentFormService.fetchEnrollmentPlanHRASettings(hraParentPlanId);
        }
        try {
            this.formPagesMetadataContext.setFormNavigationInitialized(false);
            await this.enrollmentFormService.getNextGenHRAFormTransaction$(hraFormId, originalEnrollmentTransactionId, hraParentPlanId);
        }
        catch (error) {
            this.externalErrorLoggingService.log(error);
            this.navigationService.navigateByPageTag(PageTags.HOME);
        }
    }
    async prepareHRAMemberTransaction$(formId, customInternalDefinition, originalEnrollmentTransactionId, isDirectAPIEnrollment, hraUserType, storageId) {
        const selectedPlanId = this.shoppingCartService.getSelectedPlan()?.id ?? this.enrollmentFormService.getEnrollmentHistorySelectedPlanId();
        const partnerId = this.configResourceService.getProcessedResourceValue('PartnerID');
        const beanProviderSettings = this.getHRAEnrollmentSettings();
        const payload = !isDirectAPIEnrollment ? beanProviderSettings?.payload : {};
        // Should be using the bean provider custom internal but getting the resource as a fallback
        // as this was added last minute for a hotfix. If using the custom internal resource here proves
        // to be useless we can remove it eventually.
        // SPA-14898: We dont have a payload for API HRA enrollments, and this part before that ticket required a payload
        // Unlike every other part of this function. We may end up needing more data in this for those API HRA cases,
        // And wil need to figure out what exactly to do if that happens, when it happens.
        const customInternalWrapper = payload?.customInternal
            ? JSON.parse(beanProviderSettings.payload.customInternal)
            : this.genericFormService.getCustomInternalWrapper(customInternalDefinition);
        const preparedCustomInternal = this.genericFormService.prepareAndStoreCustomInternalWrapper(customInternalWrapper, isDirectAPIEnrollment ? hraUserType : payload?.userType);
        const sourceId = this.configResourceService.getProcessedResourceValue('SourceID');
        const currentLocale = this.localeService.getCurrentLocale();
        const enrollmentTransactionRequest = EnrollmentTransactionRequest.createInitialTransaction(preparedCustomInternal);
        enrollmentTransactionRequest.overrideStoredAnswers = true;
        enrollmentTransactionRequest.partnerID = partnerId;
        enrollmentTransactionRequest.sourceID = sourceId;
        enrollmentTransactionRequest.langID = LocaleService.LOCALE_ALIAS_ID[currentLocale];
        enrollmentTransactionRequest.pageIndex = 0;
        enrollmentTransactionRequest.createdIPAddress = await this.ipUtilityService.getClientIP();
        enrollmentTransactionRequest.formID = formId;
        enrollmentTransactionRequest.ssoTag = payload?.ssoTag;
        enrollmentTransactionRequest.formTypes = payload?.formTypes;
        enrollmentTransactionRequest.currentFormType = payload?.currentFormType;
        enrollmentTransactionRequest.usingBEAN = payload?.usingBEAN;
        enrollmentTransactionRequest.siteID = payload?.siteID;
        enrollmentTransactionRequest.isFormChaining = payload?.isFormChaining;
        enrollmentTransactionRequest.groupConfirmationNumber = payload?.groupConfirmationNumber;
        enrollmentTransactionRequest.selectedCultureCode = payload?.selectedCultureCode;
        enrollmentTransactionRequest.planID = payload?.planID;
        enrollmentTransactionRequest.planIDs = payload?.planIDs;
        enrollmentTransactionRequest.isMedigap = this.enrollmentFormService.parseStringToBoolean(beanProviderSettings.payload?.isMedigap);
        enrollmentTransactionRequest.isTestingSite = this.enrollmentFormService.parseStringToBoolean(beanProviderSettings.payload?.isTestingSite);
        enrollmentTransactionRequest.formType = payload?.formType;
        enrollmentTransactionRequest.groupId = payload?.groupId;
        enrollmentTransactionRequest.integrationType = payload?.integrationType;
        enrollmentTransactionRequest.formID = payload?.formID;
        enrollmentTransactionRequest.userType = payload?.userType;
        enrollmentTransactionRequest.planYear = payload?.planYear;
        enrollmentTransactionRequest.publicFormID = payload?.formID;
        enrollmentTransactionRequest.destinationAppID = payload?.appID;
        enrollmentTransactionRequest.originalAppID = +payload?.appID;
        const isSiteLive = this.lockedSiteService.isSiteLive();
        const isReviewSite = this.lockedSiteService.isReviewSite(window.location.hostname);
        await this.createHRAMemberTransaction$(this.memberSessionService.getMemberSessionId(), selectedPlanId, enrollmentTransactionRequest, isSiteLive, isReviewSite, formId, { isHRA: true, isDirectAPIEnrollment, storageId, hraType: EnrollmentType.INTERNAL }, payload?.formType, originalEnrollmentTransactionId).toPromise();
        return await Promise.resolve(this.getTransaction(selectedPlanId));
    }
    fetchEnrollmentSettingsForHRA$() {
        const sessionId = this.memberSessionService.getMemberSessionId();
        const enrollingPlan = this.shoppingCartService.getSelectedPlan();
        const enrollingRiders = this.shoppingCartService.getSelectedPlanRiders(enrollingPlan.id);
        const params = this.enrollmentFormService.createEnrollmentSettingsParams(false, enrollingPlan, enrollingRiders, true);
        this.store.dispatch(new UpdateUserFormType(this.enrollmentFormService.getUserFormTypeKey(params.userType), enrollingPlan.id));
        return this.store.dispatch(new FetchEnrollmentSettings(sessionId, params));
    }
    fetchHRAEnrollmentSettings$(sessionId, selectedPlan, selectedRiders, isPCAPIEnrollment, originalEnrollmentTransactionGuid) {
        const enrollmentSettingsParams = new EnrollmentSettingsParams();
        enrollmentSettingsParams.confirmationUrl = this.navigationUtilityService.constructAbsoluteUrl(PageTags.HRA_CONFIRMATION);
        enrollmentSettingsParams.destinationUrl = this.navigationUtilityService.constructHref(PageTags.HRA_FORM);
        enrollmentSettingsParams.planIds = [selectedPlan.id];
        enrollmentSettingsParams.formType = EnrollmentFormType.HRA;
        enrollmentSettingsParams.includeMailingAddress = false;
        enrollmentSettingsParams.riderData = this.enrollmentFormService.getRiderData(selectedRiders);
        enrollmentSettingsParams.userType = this.siteService.getSiteUserTypeValue();
        const agentGuid = this.agentService.getAgentInContextGuid();
        if (agentGuid) {
            enrollmentSettingsParams.agentGuid = agentGuid;
        }
        if (isPCAPIEnrollment) {
            enrollmentSettingsParams.isPCAPIHRAEnrollment = true;
        }
        if (originalEnrollmentTransactionGuid) {
            enrollmentSettingsParams.OriginalTransactionGUID = originalEnrollmentTransactionGuid;
        }
        if (this.plansService.getIsPlanFeesEnabled() && !MEDICARE_PLAN_TYPES.includes(selectedPlan.planTypeAbbreviation)) {
            enrollmentSettingsParams.planFees = selectedPlan?.fees ?? [];
        }
        const isMedigap = selectedPlan.planType === PlanType.MEDIGAP;
        enrollmentSettingsParams.isMedigap = isMedigap;
        enrollmentSettingsParams.isTestingSite = this.configResourceService.isTestingSite();
        const totalPremium = `${this.plansService.getTotalPremium([selectedPlan], selectedRiders)}`;
        if (isMedigap) {
            enrollmentSettingsParams.medigapPremium = totalPremium;
        }
        else {
            enrollmentSettingsParams.calculatedPremium = totalPremium;
        }
        enrollmentSettingsParams.planNetwork_ShowUAT = this.configResourceService.getProcessedResourceValue(PLAN_NETWORK_SHOW_UAT_RESOURCE_KEY, null, false);
        const customInternalResource = this.enrollmentFormService.getCustomInternalResource(EnrollmentFormType.HRA);
        const customInternal = this.enrollmentFormService.prepareCustomInternalForBean(customInternalResource, enrollmentSettingsParams.userType);
        this.enrollmentFormService.setCustomInternalToSessionStorage(customInternal, isMedigap);
        enrollmentSettingsParams.Enrollment_CustomJson = customInternal;
        return this.sessionHttpService.fetchBeanProviderSettings$(sessionId, enrollmentSettingsParams);
    }
    fetchHRAExternalLink$(sessionId, planID, originalEnrollmentTransactionGuid, HRAExternalURL, effectiveDate) {
        const externalHRALinkParams = {
            planID,
            originalEnrollmentTransactionGuid,
            effectiveDate,
            HRAExternalURL
        };
        return this.sessionHttpService.fetchExternalHRALink$(sessionId, externalHRALinkParams);
    }
    createHRAMemberTransaction$(sessionId, planId, enrollmentTransactionRequest, isSiteLive, isReviewSite, formId, hraData, formType, originalEnrollmentTransactionId) {
        const callRecordingAvailable = this.twilioService.isConnectionOpen();
        return this.store.dispatch(new CreateTransaction(sessionId, planId, enrollmentTransactionRequest, this.planYearResourceService.getSelectedPlanYear(), isSiteLive, isReviewSite, true, null, formId, hraData, formType, originalEnrollmentTransactionId, undefined, undefined, undefined, undefined, undefined, undefined, callRecordingAvailable, this.configResourceService.getProcessedResourceValue('Spa_Site_IsTestSite', null, false)));
    }
    getTransaction(planId) {
        return planId ? this.store.selectSnapshot(EnrollmentState.transaction(planId)) : null;
    }
    // Moved from hra facade
    async fetchFormIdAndNavigateToInternalHRA(enrollmentPlan, originalEnrollmentConfirmationNumber, sessionId, isPCApiEnrollment, nativeTransactionId, formId, hraUserType, storageId) {
        if (originalEnrollmentConfirmationNumber) {
            this.store.dispatch(new UpdateHRAParentInfo(enrollmentPlan, originalEnrollmentConfirmationNumber));
        }
        this.enrollmentFormService.setActiveEnrollmentKey(enrollmentPlan.id);
        const isDirectAPIEnrollment = !!formId;
        const hasEnrollmentPlanHRASettings = this.enrollmentFormService.getEnrollmentPlanHRASettingsLoaded(enrollmentPlan.id);
        if (!hasEnrollmentPlanHRASettings) {
            await this.enrollmentFormService.fetchEnrollmentPlanHRASettings(enrollmentPlan.id);
        }
        const enrollmentPlanHRASettings = this.enrollmentFormService.getEnrollmentPlanHRASettings(undefined, enrollmentPlan.id)?.[0];
        const planHasNextGenForm = enrollmentPlanHRASettings?.enrollSystemType === EnrollSystemType.NextGen;
        if (planHasNextGenForm) {
            this.enrollmentFormService.setActiveEnrollmentKey(enrollmentPlanHRASettings.formId);
            await this.enrollmentFormService.setCurrentFormVersionId(enrollmentPlanHRASettings.formVersionId);
            this.enrollmentFormService.updateSelectedFormType$(EnrollmentFormType.HRA, enrollmentPlanHRASettings.formId, planHasNextGenForm);
            this.navigationService.navigateByPageTag(PageTags.HRA_FORM, {
                state: { originalEnrollmentTransactionId: nativeTransactionId, isDirectAPIEnrollment, hraUserType, storageId }
            });
        }
        else {
            // If we have a formId, we can skip the actual bean provider settings, as we only care about the formId from it here.
            const beanProviderSettings$ = isDirectAPIEnrollment
                ? of([
                    {
                        formId,
                        planIds: [enrollmentPlan.id],
                        isExternal: isPCApiEnrollment,
                        destinationUrl: '',
                        integrationType: null,
                        beanMessage: '',
                        hasError: false,
                        errorMessage: '',
                        payload: null,
                        status: null
                    }
                ])
                : this.fetchHRAEnrollmentSettings$(sessionId, enrollmentPlan, undefined, isPCApiEnrollment, nativeTransactionId);
            beanProviderSettings$.pipe(take(1)).subscribe({
                next: enrollmentSettings => {
                    if (enrollmentSettings[0]?.formId) {
                        // SPA-14894 this part could potentially be a problem for our API HRA flow, as it will push the dummy object above instead
                        // Of an actual call (which we need to avoid for that flow). Whatever may go wrong with this would require the API to start
                        // Giving us more data to have at this point, so it will require a lot more discussion and cooperation.
                        this.store.dispatch(new UpdateEnrollmentSettings(enrollmentSettings[0]));
                        // we may need an HRAEnrollmentGuard in the future, but for the moment it does not seem required
                        this.enrollmentFormService.setActiveEnrollmentKey(enrollmentSettings[0].formId);
                        this.enrollmentFormService.updateSelectedFormType$(EnrollmentFormType.HRA, enrollmentSettings[0].formId, planHasNextGenForm);
                        this.navigationService.navigateByPageTag(PageTags.HRA_FORM, {
                            state: { originalEnrollmentTransactionId: nativeTransactionId, isDirectAPIEnrollment, hraUserType, storageId }
                        });
                    }
                }
            });
        }
    }
    // Start of items moved from member-enrollment-card
    fetchHRAExternalLinkOrNavigateToInternal(planHRAType, memberEnrollment, redirectUrl, openExternalInNewTab, formId, internalNavigationCallback, externalNavigationCallback, skipModal = false, storageId) {
        const sessionId = this.memberSessionService.getMemberSessionId();
        if (planHRAType === PlanHRAType.EXTERNAL) {
            this.spinnerService.show(SpinnerEvent.EXTERNAL_HRA_LOADING);
            // doesn't require unsubscribe() because it is an HttpClient observable, it will be completed after the request is resolved
            this.fetchHRAExternalLink$(sessionId, memberEnrollment.planID, memberEnrollment.nativeTransactionID, memberEnrollment.hraExternalUrl).subscribe({
                next: (hraExternalResponse) => {
                    redirectUrl = hraExternalResponse?.redirectUrl ?? hraExternalResponse;
                    if (redirectUrl) {
                        this.openExternalHRAConfirmationModal(redirectUrl, memberEnrollment, openExternalInNewTab, externalNavigationCallback, skipModal);
                    }
                    else {
                        this.navigateToInternalHRA(sessionId, memberEnrollment, internalNavigationCallback, formId, storageId);
                    }
                    this.spinnerService.hide(SpinnerEvent.EXTERNAL_HRA_LOADING);
                },
                error: () => {
                    this.spinnerService.hide(SpinnerEvent.EXTERNAL_HRA_LOADING);
                }
            });
        }
        else if (planHRAType === PlanHRAType.INTERNAL) {
            this.navigateToInternalHRA(sessionId, memberEnrollment, internalNavigationCallback, formId, storageId);
        }
    }
    openExternalHRAConfirmationModal(redirectUrl, memberEnrollment, openExternalInNewTab, externalNavigationCallback, skipModal = false) {
        if (!skipModal) {
            const confirmationModal = this.modalService.open(ConfirmationModalComponent, { centered: true });
            confirmationModal.componentInstance.title = this.configResourceService.getProcessedResourceValue('Spa_EnrollmentConfirmation_ExternalHRATitle_Text', null, 'You are about to leave the site');
            confirmationModal.componentInstance.prompt = this.configResourceService.getProcessedResourceValue('Spa_EnrollmentConfirmation_ExternalHRABody_Text', null, 'You will now be directed to an external site to complete the Health Risk Assessment.');
            confirmationModal.componentInstance.cancelButton = this.configResourceService.getProcessedResourceValue('Spa_Site_Cancel', null, 'cancel');
            confirmationModal.componentInstance.confirmButton = this.configResourceService.getProcessedResourceValue('Spa_Site_Continue', null, 'continue');
            confirmationModal.componentInstance.confirmAction = () => {
                this.navigateToExternalHRA(redirectUrl, memberEnrollment, openExternalInNewTab, externalNavigationCallback);
            };
        }
        else {
            this.navigateToExternalHRA(redirectUrl, memberEnrollment, openExternalInNewTab, externalNavigationCallback);
        }
    }
    navigateToInternalHRA(sessionId, memberEnrollment, internalNavigationCallback, formId, storageId) {
        forkJoin([
            from(this.enrollmentFormService.fetchEnrollingPlan(memberEnrollment.planID)),
            this.enrollmentFormService.getIsPCApiEnrollment$(memberEnrollment.planID).pipe(take(1))
        ]).subscribe({
            next: ([enrollmentPlan, isPCApiEnrollment]) => {
                this.enrollmentFormService.setEnrollmentHistorySelectedPlan(enrollmentPlan);
                internalNavigationCallback();
                this.fetchFormIdAndNavigateToInternalHRA(enrollmentPlan, memberEnrollment.confirmationNumber, sessionId, isPCApiEnrollment, memberEnrollment.nativeTransactionID, formId, memberEnrollment.hraUserType, storageId);
            }
        });
    }
    navigateToExternalHRA(redirectUrl, memberEnrollment, openExternalInNewTab, externalNavigationCallback) {
        const link = {
            title: memberEnrollment?.planName,
            href: redirectUrl || memberEnrollment.hraExternalUrl,
            type: LinkType.EXTERNAL,
            target: openExternalInNewTab ? TargetType.BLANK : TargetType.SELF
        };
        externalNavigationCallback();
        this.navigationService.navigate(link);
    }
}
HRAService.ɵfac = function HRAService_Factory(t) { return new (t || HRAService)(i0.ɵɵinject(EnrollmentFormService), i0.ɵɵinject(i1.Store), i0.ɵɵinject(MemberSessionService), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(NavigationUtilityService), i0.ɵɵinject(LockedSiteService), i0.ɵɵinject(PlansService), i0.ɵɵinject(MemberSessionHttpService), i0.ɵɵinject(SiteService), i0.ɵɵinject(ShoppingCartService), i0.ɵɵinject(IPUtilityService), i0.ɵɵinject(TwilioDeviceService), i0.ɵɵinject(AgentService), i0.ɵɵinject(PlanYearResourceService), i0.ɵɵinject(LocaleService), i0.ɵɵinject(GenericFormService), i0.ɵɵinject(SpinnerService), i0.ɵɵinject(NavigationService), i0.ɵɵinject(i1$1.NgbModal), i0.ɵɵinject(FormPagesMetadataContext), i0.ɵɵinject(ExternalErrorLoggingService)); };
HRAService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: HRAService, factory: HRAService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HRAService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: EnrollmentFormService }, { type: i1.Store }, { type: MemberSessionService }, { type: ConfigResourceService }, { type: NavigationUtilityService }, { type: LockedSiteService }, { type: PlansService }, { type: MemberSessionHttpService }, { type: SiteService }, { type: ShoppingCartService }, { type: IPUtilityService }, { type: TwilioDeviceService }, { type: AgentService }, { type: PlanYearResourceService }, { type: LocaleService }, { type: GenericFormService }, { type: SpinnerService }, { type: NavigationService }, { type: i1$1.NgbModal }, { type: FormPagesMetadataContext }, { type: ExternalErrorLoggingService }]; }, null); })();

class PlanCompareApiService {
    constructor(ssoHttpService, loginService, memberSessionService, store, enrollmentFormService, plansService, shoppingCartService, configResourceService, modalService, lockedSiteService, ipUtilityService, enrollmentHistoryService, navigationService, planYearResourceService, hraService, formPagesMetadataContext) {
        this.ssoHttpService = ssoHttpService;
        this.loginService = loginService;
        this.memberSessionService = memberSessionService;
        this.store = store;
        this.enrollmentFormService = enrollmentFormService;
        this.plansService = plansService;
        this.shoppingCartService = shoppingCartService;
        this.configResourceService = configResourceService;
        this.modalService = modalService;
        this.lockedSiteService = lockedSiteService;
        this.ipUtilityService = ipUtilityService;
        this.enrollmentHistoryService = enrollmentHistoryService;
        this.navigationService = navigationService;
        this.planYearResourceService = planYearResourceService;
        this.hraService = hraService;
        this.formPagesMetadataContext = formPagesMetadataContext;
    }
    async processApiData(apiData) {
        this.markAsRedirectedFromPlanCompareApi();
        if (apiData) {
            try {
                // Decrypt data
                const encryptedValuesFromURL = {
                    EncryptedQueryString: apiData.qs,
                    ValidateSignature: true,
                    haKeyVer: apiData.haKeyVer,
                    tpKeyVer: apiData.tpKeyVer,
                    sigid: apiData.sigid,
                    sig: apiData.sig,
                    bitlen: apiData.bitlen
                };
                const decryptedData = await this.ssoHttpService.decrypt$(encryptedValuesFromURL).toPromise();
                this.setSendToBeneficiaryWithoutAgentForPlanCompareApi(!!apiData?.sendToBeneficiary);
                this.setSignAndSubmitWithoutAgentForPlanCompareApi(!!apiData?.signAndSubmit);
                this.setTFN(apiData?.TFN);
                if (decryptedData.tempStorageID) {
                    this.setStorageId(decryptedData.tempStorageID);
                }
                if (apiData.SSOValue) {
                    const memberLoginOptions = {
                        includePlanData: false,
                        tagName: apiData.tagName,
                        includeEnrollmentHistory: !!decryptedData.hraFormID
                    };
                    await this.loginService.loginSSOMember({ ssoValue: apiData.SSOValue }, memberLoginOptions);
                }
                else {
                    // Create anonymous session
                    await this.memberSessionService.createMemberSession$().toPromise();
                }
                // Process and redirect based off pagetag
                switch (apiData.tagName) {
                    case PageTags.ENROLLMENT:
                        await this.processApiEnrollment(decryptedData);
                        break;
                    default:
                }
            }
            catch (error) {
                this.showErrorModal(apiData.tagName);
            }
        }
        else {
            this.showErrorModal();
        }
    }
    async startEnrollment(decryptedData, goToLastPage) {
        if (decryptedData.enrollSystemType === EnrollSystemType.NextGen.toString()) {
            await this.startNextGenEnrollment(decryptedData, true);
        }
        else {
            await this.startHopeEnrollment(decryptedData, goToLastPage, true);
        }
    }
    rehydrateCustomPlanPremium(planId) {
        const customPlanPremium = this.getCustomPlanPremium();
        this.shoppingCartService.updateCartPlanPremium(planId, customPlanPremium, 0);
    }
    markAsRedirectedFromPlanCompareApi() {
        this.store.dispatch(new SetRedirectedFromPlanCompareApi(true));
    }
    setSendToBeneficiaryWithoutAgentForPlanCompareApi(planCompareApiSendToBeneficiary) {
        this.store.dispatch(new SetSendToBeneficiaryWithoutAgentForPlanCompareApi(planCompareApiSendToBeneficiary));
    }
    setTFN(tfn) {
        if (tfn) {
            this.store.dispatch(new SetTFN(tfn));
        }
    }
    setStorageId(storageId) {
        this.store.dispatch(new SetStorageId(storageId));
    }
    setSignAndSubmitWithoutAgentForPlanCompareApi(planCompareApiSignAndSubmit) {
        this.store.dispatch(new SetSignAndSubmitWithoutAgentForPlanCompareApi(planCompareApiSignAndSubmit));
    }
    async processApiEnrollment(decryptedData) {
        if (decryptedData?.obfuscatedPlanID && decryptedData?.tempStorageID) {
            const enrolledPlanIds = decryptedData.obfuscatedPlanID.split(',');
            // Clear existing plan from cart and only retrieve/add enrolled plan to cart
            this.shoppingCartService.clearShoppingCart();
            const selectedPlans = await this.retrievePlans(enrolledPlanIds);
            if (selectedPlans?.length) {
                // TODO: Need to update once multiple plans is supported
                selectedPlans.forEach(async (plan) => {
                    await this.shoppingCartService.selectPlan(plan);
                    if (decryptedData.riderIDs) {
                        // riderIDs will be a string that looks something like "0KW6DYQNP5,KTW43JCY9M,1JZP3TKQ91"
                        const riderIds = decryptedData.riderIDs.split(',');
                        riderIds
                            .filter(riderId => plan.riders.map(rider => rider.planID).includes(riderId))
                            .forEach(async (riderId) => {
                            await this.shoppingCartService.selectRider(riderId, plan.id);
                        });
                    }
                });
            }
            // Redirect to enrollment form or confirmation page
            if (decryptedData.hraType) {
                await this.redirectToHRAEnrollments(decryptedData);
            }
            else {
                await this.redirectToEnrollments(decryptedData);
            }
        }
        else {
            // We could get an external HRA flow without a tempStorageID, so we should still handle that.
            if (decryptedData?.hraType === PlanHRAType.EXTERNAL) {
                await this.redirectToHRAEnrollments(decryptedData);
            }
        }
    }
    async redirectToEnrollments(decryptedData) {
        const { obfuscatedPlanID: planId } = decryptedData;
        this.enrollmentFormService.resetActiveEnrollmentKey();
        this.enrollmentFormService.setActiveEnrollmentKey(planId);
        await this.enrollmentHistoryService.handleCompletedEnrollments([planId], this.navigationService.navigateByPageTag.bind(this.navigationService, PageTags.ENROLLMENT_CONFIRMATION), this.startEnrollment.bind(this, decryptedData));
    }
    async redirectToHRAEnrollments(decryptedData) {
        const matchingEnrollment = this.store.selectSnapshot(MemberState.memberEnrollmentByNativeTransactionId(decryptedData.originalTransactionGUID));
        if (matchingEnrollment?.hraConfirmationNumber) {
            const enrollingPlan = await this.enrollmentFormService.fetchEnrollingPlan(decryptedData.obfuscatedPlanID);
            this.store.dispatch(new SetActiveEnrollmentKey(decryptedData.obfuscatedPlanID));
            this.store.dispatch(new UpdateHRAParentInfo(enrollingPlan, matchingEnrollment.confirmationNumber));
            this.store.dispatch(new UpdateHRAAPINativeTransactionID(decryptedData.originalTransactionGUID));
            this.navigationService.navigateByPageTag(PageTags.HRA_CONFIRMATION);
        }
        else {
            // Opening in a new tab is a little awkward in this scenario, and we want to just override instead of using the resource we would
            // normally do here (Spa_EnrollmentConfirmation_OpenExternalHRAInNewTab_Enabled)
            const openExternalInNewTab = false;
            const partialMemberEnrollment = {
                planID: decryptedData.obfuscatedPlanID,
                nativeTransactionID: decryptedData.originalTransactionGUID,
                hraExternalUrl: decryptedData.hraExternalURL,
                hraUserType: decryptedData.hraUserType
                // We will possibly want confirmation in here, but it's not currently available
            };
            // TODO: We want to hook up analytics to this, but have no way of doing so right now. Later we'll have to do something to enable
            // analytics calls in service layer code, and then use that for the prenavigation call backs here.
            this.hraService.fetchHRAExternalLinkOrNavigateToInternal(decryptedData.hraType, partialMemberEnrollment, decryptedData.hraExternalURL, openExternalInNewTab, decryptedData.hraFormID, () => { }, () => { }, true, decryptedData.tempStorageID);
        }
    }
    getCustomPlanPremium() {
        return this.store.selectSnapshot(EnrollmentState.customPlanPremium);
    }
    async retrievePlans(planIds) {
        const pharmacies = this.plansService.getSelectedAPIPharmacyInfo();
        const drugs = this.store.selectSnapshot(MemberState.dosages);
        const fetchPlansOption = { ids: planIds, ...(drugs && { drugs }), ...(pharmacies && { pharmacies }) };
        return await this.plansService.fetchPlansByOptionsAndSave(fetchPlansOption);
    }
    async startHopeEnrollment(decryptedData, goToLastPage, preserveQueryParams = false) {
        const { obfuscatedPlanID: planId, tempStorageID: storageId } = decryptedData;
        const transaction = await this.createEnrollmentTransaction(planId, storageId);
        if (transaction) {
            const skipToPageIndex = goToLastPage ? -1 : 0;
            this.enrollmentFormService.setCustomPlanPremium(transaction.customPlanPremium);
            this.enrollmentFormService.applyCustomPlanPremium(planId, transaction.customPlanPremium);
            this.enrollmentFormService.addAgentCALicense(transaction.caLicenseNumber);
            await this.enrollmentFormService.enrollmentStart$(planId, transaction, skipToPageIndex, preserveQueryParams);
        }
    }
    async startNextGenEnrollment(decryptedData, preserveQueryParams = false) {
        const { obfuscatedPlanID: planId, userType } = decryptedData;
        // NG-405: For PC API flow, we run this logic before the transaction resolver.
        // Therefore, we require the enrollment plan settings before creating the NG enrollment transaction
        await this.enrollmentFormService.fetchEnrollmentPlanSettings(planId, userType);
        this.formPagesMetadataContext.setFormNavigationInitialized(false);
        this.enrollmentFormService.nextGenEnrollmentStart$(planId, decryptedData, preserveQueryParams);
    }
    async createEnrollmentTransaction(planId, storageId) {
        const sessionId = this.memberSessionService.getMemberSessionId();
        const planYear = this.planYearResourceService.getSelectedPlanYear();
        const isSiteLive = this.lockedSiteService.isSiteLive();
        const isReviewSite = this.lockedSiteService.isReviewSite(window.location.hostname);
        const createdIPAddress = await this.ipUtilityService.getClientIP();
        const partnerID = this.configResourceService.getProcessedResourceValue('PartnerID');
        const sourceID = this.configResourceService.getProcessedResourceValue('SourceID');
        const destinationAppID = this.configResourceService.getProcessedResourceValue('AppID');
        await this.store
            .dispatch(new CreatePlanCompareApiTransaction(sessionId, planId, storageId, planYear, isSiteLive, isReviewSite, createdIPAddress, partnerID, sourceID, destinationAppID))
            .toPromise();
        return this.store.selectSnapshot(EnrollmentState.transaction(planId));
    }
    showErrorModal(tagName) {
        const confirmationModal = this.modalService.open(MessageOnlyModalComponent, { centered: true, backdrop: 'static', keyboard: false });
        confirmationModal.componentInstance.title = this.getErrorTitle(tagName);
        confirmationModal.componentInstance.prompt = this.getErrorPrompt(tagName);
        confirmationModal.componentInstance.hideCloseButton = true;
    }
    getErrorTitle(tagName) {
        // At the moment, just return enrollment error title
        // Can use tagName in the future to get different error title based off feature
        return this.getEnrollmentErrorTitle();
    }
    getErrorPrompt(tagName) {
        // At the moment, just return enrollment error title
        // Can use tagName in the future to get different error title based off feature
        return this.getEnrollmentErrorMessage();
    }
    getEnrollmentErrorTitle(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_PlanCompareApi_EnrollmentError_Title', widgetName, 'Enrollment issue has occurred');
    }
    getEnrollmentErrorMessage(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_PlanCompareApi_EnrollmentError_Prompt', widgetName, 'Enrollment process was unable to be completed. Please contact your agent for assistance.');
    }
}
PlanCompareApiService.ɵfac = function PlanCompareApiService_Factory(t) { return new (t || PlanCompareApiService)(i0.ɵɵinject(SSOHttpService), i0.ɵɵinject(LoginService), i0.ɵɵinject(MemberSessionService), i0.ɵɵinject(i1.Store), i0.ɵɵinject(EnrollmentFormService), i0.ɵɵinject(PlansService), i0.ɵɵinject(ShoppingCartService), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(i1$1.NgbModal), i0.ɵɵinject(LockedSiteService), i0.ɵɵinject(IPUtilityService), i0.ɵɵinject(EnrollmentHistoryService), i0.ɵɵinject(NavigationService), i0.ɵɵinject(PlanYearResourceService), i0.ɵɵinject(HRAService), i0.ɵɵinject(FormPagesMetadataContext)); };
PlanCompareApiService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PlanCompareApiService, factory: PlanCompareApiService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanCompareApiService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: SSOHttpService }, { type: LoginService }, { type: MemberSessionService }, { type: i1.Store }, { type: EnrollmentFormService }, { type: PlansService }, { type: ShoppingCartService }, { type: ConfigResourceService }, { type: i1$1.NgbModal }, { type: LockedSiteService }, { type: IPUtilityService }, { type: EnrollmentHistoryService }, { type: NavigationService }, { type: PlanYearResourceService }, { type: HRAService }, { type: FormPagesMetadataContext }]; }, null); })();

// Checks if a user is authorized to access a certain site resource
class AuthGuard {
    constructor(authService, routeAuthorizationService, apiAuthResolver, navigationUtilityService, passParameterService, configResourceService, deepLinkingService, spinnerService, planCompareApiService, siteService, ssoService, markSessionForCheckResolver, enrollmentFormService) {
        this.authService = authService;
        this.routeAuthorizationService = routeAuthorizationService;
        this.apiAuthResolver = apiAuthResolver;
        this.navigationUtilityService = navigationUtilityService;
        this.passParameterService = passParameterService;
        this.configResourceService = configResourceService;
        this.deepLinkingService = deepLinkingService;
        this.spinnerService = spinnerService;
        this.planCompareApiService = planCompareApiService;
        this.siteService = siteService;
        this.ssoService = ssoService;
        this.markSessionForCheckResolver = markSessionForCheckResolver;
        this.enrollmentFormService = enrollmentFormService;
    }
    // eslint-disable-next-line complexity
    async canActivate(route, state) {
        if (EnvironmentService.getEnvironment().liveedit) {
            return true;
        }
        // We need to make sure the auth resolver has run to completion before processing the sso values
        // check as we are running into a scenario where the page reload forced by the initial token
        // acquisition causes the ssovalues check to occur before we can finish processing the auth
        // guard leaving it returning invalid content due to the interrupt
        if (!this.authService.isAuthenticatedForApiCalls()) {
            await this.apiAuthResolver.resolve(route);
        }
        // we need to make sure we clear the previous session if we are going to a new plan year site
        // within the same domain. if we don't wait we run the risk of the store being clobbered after
        // the user sso's in to the site
        await this.markSessionForCheckResolver.resolve(route);
        const hasSSOValues = await this.ssoService.hasSSOValues();
        const routeContainsDeepLinkingKey = this.passParameterService.checkDeepLinkingRequest(route.queryParams);
        let passParametersMap = null;
        if (hasSSOValues || routeContainsDeepLinkingKey) {
            if (this.authService.isAuthenticatedForApiCalls()) {
                this.spinnerService.show(SpinnerEvent.AUTHENTICATION_LOADING);
                const queryParams = route.queryParams;
                const siteType = this.configResourceService.getProcessedResourceValue('Spa_Site_SiteType', null, 'consumer');
                const page = this.navigationUtilityService.getPage(state.url);
                const pageTags = page.tags;
                this.setConsumerSiteType(pageTags);
                const planCompareApiData = PlanCompareApiParams.mapToPlanCompareApiEnrollmentModel(queryParams);
                if ((planCompareApiData || this.enrollmentFormService.isRedirectedFromPlanCompareApi()) && !this.siteService.isPPCSite(siteType)) {
                    if (this.navigationUtilityService.isHomePage(state.url)) {
                        await this.planCompareApiService.processApiData(planCompareApiData);
                    }
                }
                else {
                    // Resolve parameters (sso + deep linking)
                    passParametersMap = await this.passParameterService.resolveParameters(pageTags, queryParams, siteType, hasSSOValues);
                    // Check if destination page is allowed. Redirect to home if not.
                    if (!this.deepLinkingService.isDestinationPageAllowed(pageTags, siteType, queryParams) &&
                        !this.passParameterService.isUTMOnly(queryParams) &&
                        // Sign & Submit flow: prevents a 404 when passing SSO + Deep Linking params
                        !this.siteService.isPPCSite(siteType)) {
                        const utmParameters = this.passParameterService.createUTMFromQueryParams(queryParams);
                        const redirectToHomeUrlTree = await this.deepLinkingService.redirectToHome(utmParameters);
                        if (redirectToHomeUrlTree) {
                            this.spinnerService.hide(SpinnerEvent.AUTHENTICATION_LOADING);
                            return this.navigationUtilityService.areRoutesEqual(redirectToHomeUrlTree, route) || redirectToHomeUrlTree;
                        }
                    }
                    let processParameterErrors = false;
                    try {
                        await this.passParameterService.processParameters(passParametersMap, pageTags);
                    }
                    catch (error) {
                        if (error instanceof HttpErrorResponse) {
                            if (error.status === HttpStatusCode.INTERNAL_SERVER_ERROR || error.status === HttpStatusCode.UNAUTHORIZED) {
                                processParameterErrors = true;
                            }
                        }
                    }
                    if (!processParameterErrors) {
                        const urlTree = await this.deepLinkingService.processPageSpecificParams(pageTags.toString(), this.passParameterService.mergePassParameters(passParametersMap));
                        if (urlTree) {
                            this.spinnerService.hide(SpinnerEvent.AUTHENTICATION_LOADING);
                            return this.navigationUtilityService.areRoutesEqual(urlTree, route) || urlTree;
                        }
                    }
                }
                this.spinnerService.hide(SpinnerEvent.AUTHENTICATION_LOADING);
            }
            else {
                return false;
            }
        }
        // return a boolean letting us know if the route we are accessing is accessible
        const canActivate = this.routeAuthorizationService.agentCanAccess(state.url, passParametersMap) &&
            this.routeAuthorizationService.memberCanAccess(state.url, passParametersMap);
        return canActivate;
    }
    setConsumerSiteType(pageTags) {
        if (pageTags?.length) {
            // if we are sso'ing in to retention we need to set the site type before processing as the
            // consumer site type impacts some of the calls we make during the sso process
            if (pageTags.includes(PageTags.RETENTION) || pageTags.includes(PageTags.RETENTION_SUMMARY)) {
                this.siteService.setConsumerSiteType(ConsumerSiteType.RETENTION);
            }
        }
    }
}
AuthGuard.ɵfac = function AuthGuard_Factory(t) { return new (t || AuthGuard)(i0.ɵɵinject(AuthService), i0.ɵɵinject(RouteAuthorizationService), i0.ɵɵinject(ApiAuthResolver), i0.ɵɵinject(NavigationUtilityService), i0.ɵɵinject(PassParameterService), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(DeepLinkingService), i0.ɵɵinject(SpinnerService), i0.ɵɵinject(PlanCompareApiService), i0.ɵɵinject(SiteService), i0.ɵɵinject(SSOService), i0.ɵɵinject(MarkSessionForCheckResolver), i0.ɵɵinject(EnrollmentFormService)); };
AuthGuard.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AuthGuard, factory: AuthGuard.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthGuard, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: AuthService }, { type: RouteAuthorizationService }, { type: ApiAuthResolver }, { type: NavigationUtilityService }, { type: PassParameterService }, { type: ConfigResourceService }, { type: DeepLinkingService }, { type: SpinnerService }, { type: PlanCompareApiService }, { type: SiteService }, { type: SSOService }, { type: MarkSessionForCheckResolver }, { type: EnrollmentFormService }]; }, null); })();

var BlueButtonStatus;
(function (BlueButtonStatus) {
    BlueButtonStatus["SUCCESS"] = "Success";
    BlueButtonStatus["ERROR"] = "Error";
    BlueButtonStatus["DENIED"] = "Denied";
    BlueButtonStatus["NEW"] = "New";
})(BlueButtonStatus || (BlueButtonStatus = {}));
var BlueButtonReturnStatus;
(function (BlueButtonReturnStatus) {
    BlueButtonReturnStatus["ALLOWED"] = "Allowed";
    BlueButtonReturnStatus["ERROR"] = "Error";
    BlueButtonReturnStatus["DECLINED"] = "Declined";
})(BlueButtonReturnStatus || (BlueButtonReturnStatus = {}));
class FetchBlueButtonDrugOptions {
}

class BlueButtonHttpService {
    constructor(http) {
        this.http = http;
        this.environment = EnvironmentService.getEnvironment();
    }
    fetchSharedDrugsAndAddToCabinet$(sessionId, code, recommendedCutOffDays, optionalCutOffMonths) {
        const headers = new HttpHeaders({ Accept: 'application/json' });
        const options = { headers, params: null };
        const request = {
            code,
            recommendedCutOffDays,
            optionalCutOffMonths
        };
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Session/${sessionId}/BlueButton`, request, options);
    }
}
BlueButtonHttpService.ɵfac = function BlueButtonHttpService_Factory(t) { return new (t || BlueButtonHttpService)(i0.ɵɵinject(i1$2.HttpClient)); };
BlueButtonHttpService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: BlueButtonHttpService, factory: BlueButtonHttpService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BlueButtonHttpService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1$2.HttpClient }]; }, null); })();

class BlueButtonService {
    constructor(store, blueButtonPrescriptionsHttpService, drugsHttpService, memberSessionService, configResourceService, siteService, emailService, agentService, messagesService) {
        this.store = store;
        this.blueButtonPrescriptionsHttpService = blueButtonPrescriptionsHttpService;
        this.drugsHttpService = drugsHttpService;
        this.memberSessionService = memberSessionService;
        this.configResourceService = configResourceService;
        this.siteService = siteService;
        this.emailService = emailService;
        this.agentService = agentService;
        this.messagesService = messagesService;
        this.cabinets = [];
    }
    fetchSharedDrugsAndAddToCabinet(sessionId, options) {
        this.cabinets = [];
        const memberSession = this.memberSessionService.getMemberSession();
        this.blueButtonPrescriptionsHttpService
            .fetchSharedDrugsAndAddToCabinet$(sessionId, options ? options.code : '', options.recommendedCutOffDays, options.optionalCutOffMonths)
            .pipe(tap({
            error: (err) => {
                if (err instanceof HttpErrorResponse) {
                    this.updateProfile();
                    this.store.dispatch(new SetPrescriptionError(err));
                }
            }
        }), map(async (drugData) => {
            if (drugData?.length) {
                const medicineCabinet = this.store.selectSnapshot(MedicineCabinetState.medicineCabinet);
                await this.setCabinetLimitAndSaveDrugs(drugData, medicineCabinet, memberSession.sessionId);
                await this.fetchDrugDetailsAndCreateCabinetEntry(medicineCabinet);
                this.store.dispatch(new AddDrugsToMedicineCabinet(this.cabinets));
                this.store.dispatch(new AddDrugsToBlueButtonMedicineCabinet(this.cabinets));
            }
            if (this.isPPCSite()) {
                await this.fetchMemberSession(sessionId);
                const description = this.configResourceService.getProcessedResourceValue('Spa_BlueButton_SharedPrescription_Successfully_Note', null, `System notification: {{[member.profile.firstName]}} successfully shared prescriptions from MyMedicare.gov. Initiated by:`);
                this.addProfileNoteAndSendMailToAgent(BlueButtonStatus.SUCCESS, description);
            }
            this.store.dispatch(new SetPrescriptionSuccess());
            this.cabinets = [];
        }))
            .toPromise();
    }
    addProfileNoteAndSendMailToAgent(status, description) {
        if (this.agentService.isAgentLoggedIn()) {
            let agentNote = '';
            agentNote = this.getAgentNote(status);
            this.addBlueButtonSharedPrescriptionNote(agentNote);
        }
        else {
            this.addBlueButtonSharedPrescriptionNote(description);
            this.sendEmailToAgent();
        }
    }
    addBlueButtonSharedPrescriptionNote(description) {
        const agentGuid = this.store.selectSnapshot(AgentState.agentGuid);
        const note = {
            userAgentGUID: agentGuid,
            agentNoteActionType: NoteActionType.Note,
            description,
            agentName: '',
            createdWhen: '' // API will generates this
        };
        this.memberSessionService.addMemberNoteByAgent(note);
    }
    isPPCSite() {
        return this.siteService.isPPCSite(this.configResourceService.getProcessedResourceValue('Spa_Site_SiteType', null, SiteType.CONSUMER));
    }
    async fetchMemberSession(sessionId) {
        await this.memberSessionService.fetchMemberSession$({ sessionId }).toPromise();
    }
    async sendEmailToAgent(widgetName) {
        const agentEmailAddress = this.store.selectSnapshot(AgentState.emailAddress);
        if (agentEmailAddress) {
            const emailSubject = this.configResourceService.getProcessedResourceValue('Spa_BlueButton_Agent_EmailSubject_Text', widgetName, 'Blue Button Process Completed');
            const baseUrl = this.configResourceService.getProcessedResourceValue('Spa_Site_AgentLogin_Url', widgetName, 'http://localhost:4200');
            const blueButtonAgentLoginUrl = new URL(baseUrl);
            blueButtonAgentLoginUrl.searchParams.set(UTMParameter.UTM_SOURCE, UTMValue.UTM_SOURCE_PLAN_COMPARE);
            blueButtonAgentLoginUrl.searchParams.set(UTMParameter.UTM_MEDIUM, UTMValue.UTM_MEDIUM_EMAIL);
            blueButtonAgentLoginUrl.searchParams.set(UTMParameter.UTM_CAMPAIGN, UTMValue.UTM_CAMPAIGN_BLUEBUTTON_DONE);
            const blueButtonAgentLoginShortUrl = await this.messagesService.getShortUrl(blueButtonAgentLoginUrl.href);
            const inputs = [
                {
                    key: 'blueButtonAgentLoginShortUrl',
                    value: blueButtonAgentLoginShortUrl
                }
            ];
            await this.emailService.sendEmail(EmailNames.BLUE_BUTTON_AGENT, [agentEmailAddress], emailSubject, inputs);
        }
    }
    async updateProfile() {
        const apiMemberStateModel = {
            blueButtonInfo: {
                status: BlueButtonStatus.ERROR,
                updateDate: DateUtilities.getFormattedPTDate(new Date(), DateUtilities.defaultDateTimeISOFormat) // Send Pacific Time (PT) to API
            }
        };
        await this.memberSessionService.updateMemberProfile(apiMemberStateModel);
        if (this.isPPCSite()) {
            const description = this.configResourceService.getProcessedResourceValue('Spa_BlueButton_SharedPrescription_Error_Note', null, `System notification: {{[member.profile.firstName]}} had an issue and was unable to share prescriptions from MyMedicare.gov. Initiated by:`);
            this.addProfileNoteAndSendMailToAgent(BlueButtonStatus.ERROR, description);
        }
    }
    getAgentNote(status) {
        let note = '';
        if (status === BlueButtonStatus.SUCCESS) {
            note = this.configResourceService.getProcessedResourceValue('Spa_BlueButton_SharedPrescription_Import_Success_Note', null, 'Imported new claims from MyMedicare.gov');
        }
        else if (status === BlueButtonStatus.ERROR) {
            note = this.configResourceService.getProcessedResourceValue('Spa_BlueButton_SharedPrescription_Import_Error_Note', null, 'Unable to import new claims from MyMedicare.gov');
        }
        return note;
    }
    async setCabinetLimitAndSaveDrugs(drugData, medicineCabinet, sessionId) {
        const cabinetLimit = this.configResourceService.getProcessedResourceValue('Spa_DrugSearch_Cabinet_Limit', null, 8);
        const dosagesToBeAdded = drugData.filter(dosage => !medicineCabinet.some(dosageDetail => dosageDetail.dosageID === dosage.dosageId));
        const existingDosages = drugData.filter(dosage => medicineCabinet.some(dosageDetail => dosageDetail.dosageID === dosage.dosageId));
        let limit = null;
        if (medicineCabinet) {
            limit = cabinetLimit - medicineCabinet.length;
        }
        const dosages = dosagesToBeAdded.slice(0, limit);
        dosages.forEach(dosage => {
            existingDosages.push(dosage);
        });
        await this.drugsHttpService.saveDrugs(sessionId, existingDosages);
        return existingDosages;
    }
    async fetchDrugDetailsAndCreateCabinetEntry(medicineCabinet) {
        const savedDrugCabinet = await this.drugsHttpService.getAllDrugsInCabinet(this.memberSessionService.getMemberSessionId());
        if (savedDrugCabinet) {
            for (const cabinetEntry of savedDrugCabinet) {
                const duplicateDrugEntry = medicineCabinet.find(dosage => dosage.dosageID === cabinetEntry.dosageID);
                if (!duplicateDrugEntry) {
                    this.cabinets.push(cabinetEntry);
                }
            }
        }
    }
}
BlueButtonService.ɵfac = function BlueButtonService_Factory(t) { return new (t || BlueButtonService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(BlueButtonHttpService), i0.ɵɵinject(DrugsHttpService), i0.ɵɵinject(MemberSessionService), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(SiteService), i0.ɵɵinject(EmailService), i0.ɵɵinject(AgentService), i0.ɵɵinject(MessagesService)); };
BlueButtonService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: BlueButtonService, factory: BlueButtonService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BlueButtonService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }, { type: BlueButtonHttpService }, { type: DrugsHttpService }, { type: MemberSessionService }, { type: ConfigResourceService }, { type: SiteService }, { type: EmailService }, { type: AgentService }, { type: MessagesService }]; }, null); })();

// Checks the user's browser against no longer supported browers, and redirects them if needed.
class BrowserSupportGuard {
    constructor(configResourceService, navigationService, browserSupportService) {
        this.configResourceService = configResourceService;
        this.navigationService = navigationService;
        this.browserSupportService = browserSupportService;
    }
    async canActivate(route, state) {
        if (EnvironmentService.getEnvironment().liveedit) {
            return true;
        }
        return this.browserCanAccess(state.url, route);
    }
    async browserCanAccess(url, route) {
        if (url.includes(PageTags.BROWSER_DENIED)) {
            return true;
        }
        if (this.browserIsUnsupported()) {
            const urlTree = await this.navigationService.constructUrlTreeFromPageTag(PageTags.BROWSER_DENIED, { queryParams: route.queryParams });
            return urlTree;
        }
        return true;
    }
    browserIsUnsupported() {
        // TODO: eventually add more checks than just IE11
        return this.blockIE11();
    }
    blockIE11() {
        const internetExplorerEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_InternetExplorer_Enabled', null, false);
        return !internetExplorerEnabled && this.browserSupportService.browserIsIE11();
    }
}
BrowserSupportGuard.ɵfac = function BrowserSupportGuard_Factory(t) { return new (t || BrowserSupportGuard)(i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(NavigationService), i0.ɵɵinject(BrowserSupportService)); };
BrowserSupportGuard.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: BrowserSupportGuard, factory: BrowserSupportGuard.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BrowserSupportGuard, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ConfigResourceService }, { type: NavigationService }, { type: BrowserSupportService }]; }, null); })();

class TotalSiteCounts {
}

class CarriersService {
    constructor(store, configResourceService, localeService) {
        this.store = store;
        this.configResourceService = configResourceService;
        this.localeService = localeService;
        this.planYear = this.configResourceService.getProcessedResourceValue('PlanYear');
        this.dualPlanYear = this.configResourceService.getProcessedResourceValue('DualPlanYear');
        this.totalCountsResource$ = combineLatest([
            this.store.select(AgentState.agentGuid),
            this.store.select(DemographicState.selectedFipsCode)
        ]).pipe(distinctUntilChanged(_isEqual), withLatestFrom(this.store.select(DemographicState.selectedZipCode)), switchMap(([[agentGuid, fips], zip]) => this.store.dispatch(new FetchCarrierCounts(agentGuid, zip, fips, this.planYear, this.dualPlanYear))), switchMap(() => combineLatest([
            this.store.select(PlansState.totalSiteCarrierCount),
            this.store.select(PlansState.totalSitePlanCount),
            this.localeService.getCurrentLocale$()
        ])), distinctUntilChanged(_isEqual), shareReplay(1));
    }
    // Resource name is a parameter so the header footer disclaimer can be updated when the total counts text would update
    getTotalCountsResource(resourceName = 'Spa_Site_TotalSiteCounts_Text', carrierCount = this.store.selectSnapshot(PlansState.totalSiteCarrierCount), planCount = this.store.selectSnapshot(PlansState.totalSitePlanCount), alwaysReturnResource = false) {
        if ((carrierCount === null || planCount === null) && !alwaysReturnResource) {
            return '';
        }
        else {
            const resource = this.configResourceService.getProcessedResourceValue(resourceName, null, '');
            return resource;
        }
    }
    getTotalCountsResource$(resourceName, alwaysReturnResource = false) {
        return this.totalCountsResource$.pipe(map(([carrierCount, planCount, locale]) => this.getTotalCountsResource(resourceName, carrierCount, planCount, alwaysReturnResource)));
    }
}
CarriersService.ɵfac = function CarriersService_Factory(t) { return new (t || CarriersService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(LocaleService)); };
CarriersService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CarriersService, factory: CarriersService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CarriersService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }, { type: ConfigResourceService }, { type: LocaleService }]; }, null); })();

class AppThemeService {
    constructor(resourceService) {
        this.resourceService = resourceService;
    }
    getFont() {
        const siteFont = this.resourceService.getProcessedResourceValue('Spa_Style_Font') || Fonts.DEFAULT;
        return siteFont;
    }
    assignAttributesToClasses(resource) {
        const classes = {
            [resource.className]: []
        };
        for (const [attribute, value] of Object.entries(resource.styling)) {
            if ((typeof value === 'string' && value) || typeof value === 'number' || typeof value === 'boolean') {
                classes[resource.className].push(`${attribute}: ${value};`);
            }
            else if (_isObjectLike(value)) {
                for (const [selector, pseudoValue] of Object.entries(value)) {
                    let classSelector = '';
                    if (selector === 'default') {
                        classSelector = resource.className;
                    }
                    else if (!classes.hasOwnProperty(selector)) {
                        classSelector = `${resource.className}:${selector}`;
                        if (!Array.isArray(classes[classSelector])) {
                            classes[classSelector] = [];
                        }
                    }
                    classes[`${classSelector}`].push(`${attribute}: ${pseudoValue};`);
                }
            }
        }
        return classes;
    }
    createClassFromColorResource(color) {
        // eh probably makes sense to have these support only text color and background color, more can be added later, but I
        // don't think we will need more.
        return ['Background', 'Color', 'Border']
            .map(attribute => `.${color.resourceKey}_${attribute} {${attribute.toLowerCase()}: ${color.value};}`)
            .join(' ');
    }
    createClassFromFontSize(fontSize, compact) {
        return `.${fontSize}_Font{${FontHelper.getFontSize(fontSize, compact)}}`;
    }
    createClassFromFontWeight(weight) {
        // our default font weight is controlled by the font family. This method will need to be updated
        // when adding new fonts
        return `.${weight}{ ${`font-family: ${FontHelper.DEFAULT_FONT_WEIGHT[weight]};`}}`;
    }
    // by default our buttons will use common colors from the palette however, clients can override just buttons (primary and secondary)
    // with a single string key.
    getOverridesForButtons(resource) {
        const forcedColorByConfig = this.resourceService.getProcessedResourceValue('Spa_Site_ForceColor_Value', null, '');
        let buttonColor = this.resourceService.getProcessedResourceValue(resource.resourceKey);
        if (buttonColor) {
            buttonColor = buttonColor.startsWith('#') ? buttonColor : `#${buttonColor}`;
            buttonColor = !!forcedColorByConfig ? forcedColorByConfig : buttonColor;
            resource.styling = {
                ...resource.styling,
                'background-color': {
                    default: buttonColor,
                    hover: AppThemeConfig.adjustColor(buttonColor, -30, true)
                },
                'border-color': {
                    default: AppThemeConfig.adjustColor(buttonColor, -50, true),
                    hover: AppThemeConfig.adjustColor(buttonColor, -50, true)
                }
            };
        }
        return resource;
    }
    createClassFromResource(resource) {
        // grabs all the styling resources
        const classes = this.assignAttributesToClasses(resource);
        // grabs the font size/family
        classes[resource.className] = [FontHelper.getFontFamily(resource), ...classes[resource.className]];
        if (resource.fontSize) {
            classes[resource.className] = [FontHelper.getFontForResourceSizes(resource, AppThemeConfig.compact), ...classes[resource.className]];
        }
        const createdClasses = [];
        for (const [className, value] of Object.entries(classes)) {
            const createdClass = `.${className} { ${value.join(' ')} }`;
            createdClasses.push(createdClass);
        }
        return createdClasses.join(' ');
    }
    getOverridesForClasses(defaults, compact = false) {
        return defaults.map(resource => {
            const desktopOverride = this.resourceService.getProcessedResourceValue(resource.resourceKey);
            let override = compact ? this.resourceService.getProcessedResourceValue(`${resource.resourceKey}_Mobile`) : desktopOverride;
            override = compact && !override ? desktopOverride : override;
            resource.styling = { ...resource.styling, ...override };
            return resource;
        });
    }
    getOverridesForColorResources(colorResources) {
        const forcedColorByConfig = this.resourceService.getProcessedResourceValue('Spa_Site_ForceColor_Value', null, '');
        const ret = colorResources.map(color => {
            let colorValue = this.resourceService.getProcessedResourceValue(color.resourceKey, null, color.value);
            colorValue = !!forcedColorByConfig ? forcedColorByConfig : colorValue;
            return {
                ...color,
                value: colorValue.startsWith('#') ? colorValue : `#${colorValue}`
            };
        });
        return ret;
    }
    initCreateAppTheme(compact = false) {
        AppThemeConfig.compact = compact;
        AppThemeConfig.font = this.getFont();
        // create a style document if it doesn't exist already, otherwise update the one in use.
        let applicationStyles = document.getElementById('Spa_Styles');
        AppThemeConfig.setStaticVariables();
        AppThemeConfig.colorResources = this.getOverridesForColorResources(AppThemeConfig.colorResources);
        AppThemeConfig.resources = AppThemeConfig.setResources();
        // check to see if we have any overrides in our config
        const resourceOverrides = this.getOverridesForClasses(AppThemeConfig.resources.filter(resource => !resource.isButton), compact);
        const buttonOverrides = AppThemeConfig.resources
            .filter(resource => resource.isButton)
            .map(button => this.getOverridesForButtons(button));
        AppThemeConfig.resources = [...resourceOverrides, ...buttonOverrides];
        if (!applicationStyles) {
            applicationStyles = document.createElement('style');
            applicationStyles.id = 'Spa_Styles';
            document.getElementsByTagName('body')[0].prepend(applicationStyles);
        }
        const configuredFontClasses = Object.values(FontSizeResourceKeys).map(size => this.createClassFromFontSize(size, compact));
        const configuredWeightClasses = Object.values(FontWeightResourceKeys).map(weight => this.createClassFromFontWeight(weight));
        const configuredColorClasses = AppThemeConfig.colorResources.map(color => this.createClassFromColorResource(color));
        const configuredClasses = AppThemeConfig.resources.map(resource => this.createClassFromResource(resource));
        const appThemeCSS = [...configuredClasses, ...configuredColorClasses, ...configuredFontClasses, ...configuredWeightClasses].join(' ');
        const customCSS = this.resourceService.getProcessedResourceValue('CustomCSS', null, '');
        applicationStyles.innerHTML = `${appThemeCSS} ${customCSS}`;
    }
}
AppThemeService.ɵfac = function AppThemeService_Factory(t) { return new (t || AppThemeService)(i0.ɵɵinject(ConfigResourceService)); };
AppThemeService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AppThemeService, factory: AppThemeService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AppThemeService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ConfigResourceService }]; }, null); })();

/**
 * Loads the app config from a REST endpoint or the file system depending on
 * on the build environment. In live edit we will load this from a service
 * the gives us the latest config from the platform DB. This will also be used
 * to POST config changes to live edit.
 */
class ConfigLoaderService {
    constructor(http, navigationContext, store) {
        this.http = http;
        this.navigationContext = navigationContext;
        this.store = store;
    }
    // should only be called during live edit
    loadDynamicConfig$() {
        // TODO: eventually add an action for this? We may actually just need the observer here given how we have to use this with auth
        const urlParams = this.navigationContext.getUrlParams();
        const environment = EnvironmentService.getEnvironment();
        if (environment.liveedit) {
            return this.http.get(`${environment.LIVE_EDIT_CONFIG_URL}/${urlParams.shortSiteId}/package?showPending=true&&includeTestData=true`);
        }
        else {
            return null;
        }
    }
    // TODO: probably need to get other resource information in order to accomplish this
    // wrap this up in a class so the method signature doesn't get too large
    updateResource(shortSiteId, changeSetId, liveEditUpdate) {
        this.store.dispatch(new UpdatePlatformResource(shortSiteId, changeSetId, liveEditUpdate));
    }
}
ConfigLoaderService.ɵfac = function ConfigLoaderService_Factory(t) { return new (t || ConfigLoaderService)(i0.ɵɵinject(i1$2.HttpClient), i0.ɵɵinject(NavigationContext), i0.ɵɵinject(i1.Store)); };
ConfigLoaderService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ConfigLoaderService, factory: ConfigLoaderService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfigLoaderService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$2.HttpClient }, { type: NavigationContext }, { type: i1.Store }]; }, null); })();

class RouteOptionsService {
    constructor(configResourceService) {
        this.configResourceService = configResourceService;
    }
    get disabledRoutes() {
        const guidedHelpEnabled = this.configResourceService.getProcessedResourceValue('Spa_GuidedHelp_Enabled', null, true);
        const routes = [];
        if (guidedHelpEnabled) {
            if (this.configResourceService.getProcessedResourceValue('Spa_Site_GetStarted_Enabled', null, true) === false) {
                routes.push(PageTags.GUIDED_HELP_GETTING_STARTED);
            }
            if (this.configResourceService.getProcessedResourceValue('Spa_Site_TotalEstimatedCost_Enabled', null, true) === false ||
                this.configResourceService.getProcessedResourceValue('Spa_Site_Health_Enabled', null, true) === false) {
                routes.push(PageTags.GUIDED_HELP_HEALTH);
            }
            if (this.configResourceService.getProcessedResourceValue('Spa_Site_Prescriptions_Enabled', null, true) === false) {
                routes.push(PageTags.GUIDED_HELP_PRESCRIPTIONS);
            }
            if (this.configResourceService.getProcessedResourceValue('Spa_Site_Pharmacy_Enabled', null, true) === false) {
                routes.push(PageTags.GUIDED_HELP_PHARMACY_SEARCH);
            }
            if (this.configResourceService.getProcessedResourceValue('Spa_Site_OtherPreferences_Enabled', null, false) === false) {
                routes.push(PageTags.GUIDED_HELP_OTHER_PREFERENCES);
            }
        }
        else {
            routes.push(PageTags.GUIDED_HELP_GETTING_STARTED, PageTags.GUIDED_HELP_HEALTH, PageTags.GUIDED_HELP_PRESCRIPTIONS, PageTags.GUIDED_HELP_PHARMACY_SEARCH, PageTags.GUIDED_HELP_OTHER_PREFERENCES);
        }
        if (this.configResourceService.getProcessedResourceValue('Spa_Site_AgentLogin_Enabled', null, true) === false) {
            routes.push(PageTags.AGENT_LOGIN);
        }
        if (this.configResourceService.getProcessedResourceValue('Spa_Site_Agent_AccountOverview_Enabled', null, true) === false) {
            routes.push(PageTags.AGENT_ACCOUNT_OVERVIEW);
        }
        if (this.configResourceService.getProcessedResourceValue('Spa_Site_SOA_Enabled', null, true) === false) {
            routes.push(PageTags.SOA, PageTags.AGENT_SOA);
        }
        if (this.configResourceService.getProcessedResourceValue('Spa_Site_AgentSearch_Enabled', null, true) === false) {
            routes.push(PageTags.PROFILE_SEARCH);
        }
        return routes;
    }
}
RouteOptionsService.ɵfac = function RouteOptionsService_Factory(t) { return new (t || RouteOptionsService)(i0.ɵɵinject(ConfigResourceService)); };
RouteOptionsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: RouteOptionsService, factory: RouteOptionsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RouteOptionsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ConfigResourceService }]; }, null); })();

var ScriptingValidParameters;
(function (ScriptingValidParameters) {
    ScriptingValidParameters["FIRST_NAME_SCRIPT"] = "{{[member.profile.firstName]}}";
    ScriptingValidParameters["MIDDLE_INITIAL_SCRIPT"] = "{{[member.profile.middleInitial]}}";
    ScriptingValidParameters["LAST_NAME_SCRIPT"] = "{{[member.profile.lastName]}}";
    ScriptingValidParameters["ADDRESS1_SCRIPT"] = "{{[member.profile.addresses[0].address1]}}";
    ScriptingValidParameters["ADDRESS2_SCRIPT"] = "{{[member.profile.addresses[0].address2]}}";
    ScriptingValidParameters["CITY_SCRIPT"] = "{{[member.profile.addresses[0].city]}}";
    ScriptingValidParameters["STATE_SCRIPT"] = "{{[member.profile.addresses[0].state]}}";
    ScriptingValidParameters["ZIP_SCRIPT"] = "{{[member.profile.addresses[0].zip]}}";
    ScriptingValidParameters["EMAIL_ADDRESS_SCRIPT"] = "{{[member.profile.emailAddress]}}";
    ScriptingValidParameters["HOME_PHONE_SCRIPT"] = "{{[member.profile.homePhone]}}";
    ScriptingValidParameters["ENROLLMENT_CONFIRMATION_SCRIPT"] = "{{[_enrollmentAnswer_.|activeEnrollmentKey|.ConfirmationNumber.value]}}";
    ScriptingValidParameters["ENROLLMENT_DATE_SCRIPT"] = "{{[member.questions.answers.EffectiveDate]}}";
    ScriptingValidParameters["PLAN_NAME_SCRIPT"] = "{{[_selectedPlans_.|activeEnrollmentKey|.planName]}}";
    ScriptingValidParameters["CARRIER_NAME_SCRIPT"] = "{{[_selectedPlans_.|activeEnrollmentKey|.carrierName]}}";
    ScriptingValidParameters["CUSTOM_FIELD1_SCRIPT"] = "{{[member.profile.customField1]}}";
    ScriptingValidParameters["CUSTOM_FIELD2_SCRIPT"] = "{{[member.profile.customField2]}}";
    ScriptingValidParameters["CUSTOM_FIELD3_SCRIPT"] = "{{[member.profile.customField3]}}";
    ScriptingValidParameters["CUSTOM_FIELD4_SCRIPT"] = "{{[member.profile.customField4]}}";
    ScriptingValidParameters["CUSTOM_FIELD5_SCRIPT"] = "{{[member.profile.customField5]}}";
    ScriptingValidParameters["BIRTH_DATE_SCRIPT"] = "{{[member.profile.birthdate]}}";
    ScriptingValidParameters["WORK_PHONE_SCRIPT"] = "{{[member.profile.workPhone]}}";
    ScriptingValidParameters["CELL_PHONE_SCRIPT"] = "{{[member.profile.cellPhone]}}";
    ScriptingValidParameters["GENDER_SCRIPT"] = "{{[member.profile.gender]}}";
    ScriptingValidParameters["MARITAL_STATUS_SCRIPT"] = "{{[member.profile.maritalStatus]}}";
    ScriptingValidParameters["FIPS_SCRIPT"] = "{{[member.demographic.fips]}}";
    ScriptingValidParameters["COUNTY_NAME_SCRIPT"] = "{{[member.profile.addresses[0].county]}}";
    ScriptingValidParameters["EFFECTIVE_DATE_SCRIPT"] = "{{[member.demographic.effectiveDate]}}";
    ScriptingValidParameters["CLIENT_NAME_SCRIPT"] = "[[ClientName]]";
    ScriptingValidParameters["PREMIUM_SCRIPT"] = "{{[_selectedPlans_.|activeEnrollmentKey|.annualPlanPremium]}}";
    ScriptingValidParameters["FIRST_NAME"] = "first name";
    ScriptingValidParameters["MIDDLE_INITIAL"] = "middle initial";
    ScriptingValidParameters["LAST_NAME"] = "last name";
    ScriptingValidParameters["ADDRESS1"] = "address 1";
    ScriptingValidParameters["ADDRESS2"] = "address 2";
    ScriptingValidParameters["CITY"] = "city";
    ScriptingValidParameters["STATE"] = "state";
    ScriptingValidParameters["ZIP"] = "zip";
    ScriptingValidParameters["EMAIL_ADDRESS"] = "email address";
    ScriptingValidParameters["HOME_PHONE"] = "home phone";
    ScriptingValidParameters["ENROLLMENT_CONFIRMATION_NUMBER"] = "enrollment confirmation number";
    ScriptingValidParameters["ENROLLMENT_DATE"] = "enrollment date";
    ScriptingValidParameters["PLAN_NAME"] = "plan name";
    ScriptingValidParameters["CARRIER_NAME"] = "carrier name";
    ScriptingValidParameters["CUSTOM_FIELD1"] = "custom field1";
    ScriptingValidParameters["CUSTOM_FIELD2"] = "custom field2";
    ScriptingValidParameters["CUSTOM_FIELD3"] = "custom field3";
    ScriptingValidParameters["CUSTOM_FIELD4"] = "custom field4";
    ScriptingValidParameters["CUSTOM_FIELD5"] = "custom field5";
    ScriptingValidParameters["BIRTH_DATE"] = "birthdate";
    ScriptingValidParameters["WORK_PHONE"] = "work phone";
    ScriptingValidParameters["CELL_PHONE"] = "cell phone";
    ScriptingValidParameters["GENDER"] = "gender";
    ScriptingValidParameters["MARITAL_STATUS"] = "marital status";
    ScriptingValidParameters["FIPS"] = "fips";
    ScriptingValidParameters["COUNTY_NAME"] = "county name";
    ScriptingValidParameters["EFFECTIVE_DATE"] = "effective date";
    ScriptingValidParameters["CLIENT_NAME"] = "client name";
    ScriptingValidParameters["PREMIUM"] = "premium";
})(ScriptingValidParameters || (ScriptingValidParameters = {}));
class ScriptResourceService {
    constructor(configResourceService) {
        this.configResourceService = configResourceService;
    }
    getProcessedResourceValue(resourceKey, resourceValue, returnSelector, widgetName) {
        let value = this.configResourceService.getProcessedResourceValue(resourceKey, widgetName, resourceValue, returnSelector);
        if (value) {
            value = this.replaceValues(value);
        }
        return value;
    }
    replaceValues(value) {
        this.scriptValues = value
            .replace(ScriptingValidParameters.FIRST_NAME_SCRIPT, ScriptingValidParameters.FIRST_NAME)
            .replace(ScriptingValidParameters.MIDDLE_INITIAL_SCRIPT, ScriptingValidParameters.MIDDLE_INITIAL)
            .replace(ScriptingValidParameters.LAST_NAME_SCRIPT, ScriptingValidParameters.LAST_NAME)
            .replace(ScriptingValidParameters.ADDRESS1_SCRIPT, ScriptingValidParameters.ADDRESS1)
            .replace(ScriptingValidParameters.ADDRESS2_SCRIPT, ScriptingValidParameters.ADDRESS2)
            .replace(ScriptingValidParameters.CITY_SCRIPT, ScriptingValidParameters.CITY)
            .replace(ScriptingValidParameters.STATE_SCRIPT, ScriptingValidParameters.STATE)
            .replace(ScriptingValidParameters.ZIP_SCRIPT, ScriptingValidParameters.ZIP)
            .replace(ScriptingValidParameters.EMAIL_ADDRESS_SCRIPT, ScriptingValidParameters.EMAIL_ADDRESS)
            .replace(ScriptingValidParameters.HOME_PHONE_SCRIPT, ScriptingValidParameters.HOME_PHONE)
            .replace(ScriptingValidParameters.ENROLLMENT_CONFIRMATION_SCRIPT, ScriptingValidParameters.ENROLLMENT_CONFIRMATION_NUMBER)
            .replace(ScriptingValidParameters.ENROLLMENT_DATE_SCRIPT, ScriptingValidParameters.ENROLLMENT_DATE)
            .replace(ScriptingValidParameters.PLAN_NAME_SCRIPT, ScriptingValidParameters.PLAN_NAME)
            .replace(ScriptingValidParameters.CARRIER_NAME_SCRIPT, ScriptingValidParameters.CARRIER_NAME)
            .replace(ScriptingValidParameters.CUSTOM_FIELD1_SCRIPT, ScriptingValidParameters.CUSTOM_FIELD1)
            .replace(ScriptingValidParameters.CUSTOM_FIELD2_SCRIPT, ScriptingValidParameters.CUSTOM_FIELD2)
            .replace(ScriptingValidParameters.CUSTOM_FIELD3_SCRIPT, ScriptingValidParameters.CUSTOM_FIELD3)
            .replace(ScriptingValidParameters.CUSTOM_FIELD4_SCRIPT, ScriptingValidParameters.CUSTOM_FIELD4)
            .replace(ScriptingValidParameters.CUSTOM_FIELD5_SCRIPT, ScriptingValidParameters.CUSTOM_FIELD5)
            .replace(ScriptingValidParameters.BIRTH_DATE_SCRIPT, ScriptingValidParameters.BIRTH_DATE)
            .replace(ScriptingValidParameters.WORK_PHONE_SCRIPT, ScriptingValidParameters.WORK_PHONE)
            .replace(ScriptingValidParameters.CELL_PHONE_SCRIPT, ScriptingValidParameters.CELL_PHONE)
            .replace(ScriptingValidParameters.GENDER_SCRIPT, ScriptingValidParameters.GENDER)
            .replace(ScriptingValidParameters.MARITAL_STATUS_SCRIPT, ScriptingValidParameters.MARITAL_STATUS)
            .replace(ScriptingValidParameters.FIPS_SCRIPT, ScriptingValidParameters.FIPS)
            .replace(ScriptingValidParameters.COUNTY_NAME_SCRIPT, ScriptingValidParameters.COUNTY_NAME)
            .replace(ScriptingValidParameters.EFFECTIVE_DATE_SCRIPT, ScriptingValidParameters.EFFECTIVE_DATE)
            .replace(ScriptingValidParameters.CLIENT_NAME_SCRIPT, ScriptingValidParameters.CLIENT_NAME)
            .replace(ScriptingValidParameters.PREMIUM_SCRIPT, ScriptingValidParameters.PREMIUM);
        return this.scriptValues;
    }
}
ScriptResourceService.ɵfac = function ScriptResourceService_Factory(t) { return new (t || ScriptResourceService)(i0.ɵɵinject(ConfigResourceService)); };
ScriptResourceService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ScriptResourceService, factory: ScriptResourceService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ScriptResourceService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ConfigResourceService }]; }, null); })();

class ContactUsContextService {
    constructor() {
        this._openContactUsModal$ = new Subject();
    }
    openContactUsModal() {
        this._openContactUsModal$.next(null);
    }
    onOpenContactUsModal$() {
        return this._openContactUsModal$.asObservable();
    }
}
ContactUsContextService.ɵfac = function ContactUsContextService_Factory(t) { return new (t || ContactUsContextService)(); };
ContactUsContextService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ContactUsContextService, factory: ContactUsContextService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ContactUsContextService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

class County {
    constructor(countyFIPS, countyName, state) {
        this.countyFIPS = countyFIPS;
        this.countyName = countyName;
        this.state = state;
    }
}

class MedicineCabinetEntry {
}
var DrugPhaseIds;
(function (DrugPhaseIds) {
    DrugPhaseIds["CATASTROPHIC"] = "CATASTROPHIC";
    DrugPhaseIds["COPAY"] = "COPAY";
    DrugPhaseIds["DEDUCTIBLE"] = "DEDUCTIBLE";
    DrugPhaseIds["GAP"] = "GAP";
})(DrugPhaseIds || (DrugPhaseIds = {}));
class DrugInfo {
}
class DrugDetails {
}
class DrugCostDetails {
}
class CoveredDrugPlanTier {
}
class DrugCostsByCoverage {
}
var DrugType;
(function (DrugType) {
    DrugType["Generic"] = "Generic";
    DrugType["Brand"] = "Brand";
    DrugType["BrandedGeneric"] = "Branded Generic";
})(DrugType || (DrugType = {}));
var DrugFlag;
(function (DrugFlag) {
    DrugFlag["Generic"] = "G";
    DrugFlag["Brand"] = "B";
})(DrugFlag || (DrugFlag = {}));
class DrugCondition {
}

class PasswordResetEmailService {
    constructor(configResourceService, navigationUtilityService, store, emailService) {
        this.configResourceService = configResourceService;
        this.navigationUtilityService = navigationUtilityService;
        this.store = store;
        this.emailService = emailService;
    }
    async sendPasswordResetEmail(resetHash, to, username) {
        const subject = this.configResourceService.getProcessedResourceValue('Spa_Agent_ForgotPassword_Subject', null, 'Reset Password');
        const baseUrlValue = this.store.selectSnapshot(AppConfigState.defaultUrl);
        const resetPasswordUrl = `${baseUrlValue}/${this.navigationUtilityService.constructHref(PageTags.RESET_PASSWORD)}`;
        const buttonColorValue = this.getPrimaryButtonColor();
        const data = [
            {
                key: 'primaryButtonColor',
                value: buttonColorValue
            },
            {
                key: 'baseUrl',
                value: baseUrlValue
            },
            {
                key: 'loginLink',
                value: `${baseUrlValue}/${this.navigationUtilityService.constructHref(PageTags.AGENT_LOGIN)}`
            },
            {
                key: 'buttonColorStroke',
                value: AppThemeConfig.adjustColor(buttonColorValue, -50, true)
            }
        ];
        const agentLoginDomain = this.configResourceService.getProcessedResourceValue('Spa_Site_AgentDomain', null, 'drx');
        const resetHashValidityTime = this.configResourceService.getProcessedResourceValue('Spa_Agent_HashValidity_Time', null, 60);
        const resetRequest = {
            userName: username,
            // TODO: this won't work for multiple emails so we will take the first as the API would need to be changed to accomodate multiples
            emailAddress: to[0],
            resetHash,
            agentLoginDomain,
            resetHashValidityTime,
            userType: PasswordResetUserType.AGENT,
            requestType: ResetHashRequestType.USER_NAME
        };
        return this.emailService.recoverPassword(ResetType.AGENT, to, subject, resetRequest, resetPasswordUrl, data);
    }
    getPrimaryButtonColor() {
        const colorValue = this.configResourceService.getProcessedResourceValue('Spa_Style_PrimaryButton', null, AppThemeConfig.getColorValueByKey(ColorResourceKeys.ACCENT4));
        return colorValue.startsWith('#') ? colorValue : `#${colorValue}`;
    }
}
PasswordResetEmailService.ɵfac = function PasswordResetEmailService_Factory(t) { return new (t || PasswordResetEmailService)(i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(NavigationUtilityService), i0.ɵɵinject(i1.Store), i0.ɵɵinject(EmailService)); };
PasswordResetEmailService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PasswordResetEmailService, factory: PasswordResetEmailService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PasswordResetEmailService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ConfigResourceService }, { type: NavigationUtilityService }, { type: i1.Store }, { type: EmailService }]; }, null); })();

const DEFAULT_ERROR_NOTICE = { messages: [] };
/*
  This class is intended for intraform errors, such as a missing required field.
  If you are looking for Major errors related to enrollment, such as ones that we cannot recover from, or have an infinite spinner,
  you want enrollment-transaction-errors.context.ts
*/
class EnrollmentFormErrorsContext {
    constructor() {
        this.formErrorsSubject$ = new BehaviorSubject(DEFAULT_ERROR_NOTICE);
        this.formErrors$ = this.formErrorsSubject$.asObservable();
        this.scrollTo$ = new Subject();
    }
    observeForFormErrors$() {
        return this.formErrors$;
    }
    observeForScrollTo$() {
        return this.scrollTo$.asObservable();
    }
    addErrors(errors) {
        this.formErrorsSubject$.next(errors);
    }
    clearFormErrors() {
        this.formErrorsSubject$.pipe(take(1)).subscribe({
            next: formErrors => {
                if (formErrors.title || formErrors.messages?.length) {
                    this.formErrorsSubject$.next(DEFAULT_ERROR_NOTICE);
                }
            }
        });
    }
    scrollToErrors() {
        this.scrollTo$.next(null);
    }
}
EnrollmentFormErrorsContext.ɵfac = function EnrollmentFormErrorsContext_Factory(t) { return new (t || EnrollmentFormErrorsContext)(); };
EnrollmentFormErrorsContext.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: EnrollmentFormErrorsContext, factory: EnrollmentFormErrorsContext.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnrollmentFormErrorsContext, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

var ExternalEnrollmentModalEventTypes;
(function (ExternalEnrollmentModalEventTypes) {
    ExternalEnrollmentModalEventTypes[ExternalEnrollmentModalEventTypes["OPEN"] = 0] = "OPEN";
    ExternalEnrollmentModalEventTypes[ExternalEnrollmentModalEventTypes["CLOSE"] = 1] = "CLOSE";
})(ExternalEnrollmentModalEventTypes || (ExternalEnrollmentModalEventTypes = {}));
var ExternalEnrollmentNonModalEventTypes;
(function (ExternalEnrollmentNonModalEventTypes) {
    ExternalEnrollmentNonModalEventTypes[ExternalEnrollmentNonModalEventTypes["NORMAL"] = 0] = "NORMAL";
    ExternalEnrollmentNonModalEventTypes[ExternalEnrollmentNonModalEventTypes["SSO"] = 1] = "SSO";
    ExternalEnrollmentNonModalEventTypes[ExternalEnrollmentNonModalEventTypes["POST"] = 2] = "POST";
})(ExternalEnrollmentNonModalEventTypes || (ExternalEnrollmentNonModalEventTypes = {}));

class ExternalEnrollmentContext {
    constructor() {
        this._modalEvent$ = new Subject();
        this._nonModalEvent$ = new Subject();
    }
    observeExternalModalEvent$() {
        return this._modalEvent$.asObservable();
    }
    observeExternalNonModalEvent$() {
        return this._nonModalEvent$.asObservable();
    }
    close(modalRef) {
        this._modalEvent$.next({
            modalRef,
            type: ExternalEnrollmentModalEventTypes.CLOSE
        });
    }
    open(modalRef) {
        this._modalEvent$.next({
            modalRef,
            type: ExternalEnrollmentModalEventTypes.OPEN
        });
    }
    // We have a method to detach the CDR for external enrollments that have a message, and thus a popup
    // We need this for when we do not have a message/popup, to prevent us from seeing the empty cart page as we remove the plan
    // For a moment before navigation happens
    dispatchNonModalEvent(type) {
        this._nonModalEvent$.next({
            type
        });
    }
}
ExternalEnrollmentContext.ɵfac = function ExternalEnrollmentContext_Factory(t) { return new (t || ExternalEnrollmentContext)(); };
ExternalEnrollmentContext.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ExternalEnrollmentContext, factory: ExternalEnrollmentContext.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExternalEnrollmentContext, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

const CUSTOM_URL_REGEX = /^(event:\/\/.*\;)((?:ht|f)tp(?:s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(?::(0-9)*)*(?:\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&%\$#_=\<\>]*)?)$/g;
const EXTERNAL_ENROLLMENT_RELAY_STATE_FIELD_NAME = 'RelayState';
class EnrollmentSettingsService {
    constructor(enrollmentFormService, modalService, configResourceService, analyticsService, navigationService, navigationUtilityService, shoppingCartService, spinnerService, agentCallRecordingNavigationService, externalEnrollmentContext) {
        this.enrollmentFormService = enrollmentFormService;
        this.modalService = modalService;
        this.configResourceService = configResourceService;
        this.analyticsService = analyticsService;
        this.navigationService = navigationService;
        this.navigationUtilityService = navigationUtilityService;
        this.shoppingCartService = shoppingCartService;
        this.spinnerService = spinnerService;
        this.agentCallRecordingNavigationService = agentCallRecordingNavigationService;
        this.externalEnrollmentContext = externalEnrollmentContext;
    }
    async getEnrollmentSettings$(widgetName) {
        const planId = this.enrollmentFormService.getActiveEnrollmentKey();
        const planHasNextGenForm = this.enrollmentFormService.planHasNextGenForm(planId);
        let enrollmentSettings = await this.enrollmentFormService.loadEnrollmentSettings$(undefined, planHasNextGenForm);
        if (enrollmentSettings) {
            enrollmentSettings = {
                ...enrollmentSettings,
                beanMessage: this.configResourceService.processValueProviders(enrollmentSettings.beanMessage, widgetName)
            };
        }
        const enrollmentType = this.getEnrollmentType(enrollmentSettings, planHasNextGenForm);
        return enrollmentType;
    }
    async processEnrollmentSettings(redirectPageTag, widgetName, crossSellModalCloseAction) {
        const planId = this.enrollmentFormService.getActiveEnrollmentKey();
        const planHasNextGenForm = this.enrollmentFormService.planHasNextGenForm(planId);
        let enrollmentSettings = await this.enrollmentFormService.loadEnrollmentSettings$(undefined, planHasNextGenForm);
        if (enrollmentSettings) {
            enrollmentSettings = {
                ...enrollmentSettings,
                beanMessage: this.configResourceService.processValueProviders(enrollmentSettings.beanMessage, widgetName)
            };
        }
        const enrollmentType = this.getEnrollmentType(enrollmentSettings, planHasNextGenForm);
        if (enrollmentType) {
            switch (enrollmentType) {
                case EnrollmentType.MESSAGE_ONLY:
                    this.processMessageOnly(enrollmentSettings, crossSellModalCloseAction);
                    break;
                case EnrollmentType.INTERNAL:
                    this.processInternal(enrollmentSettings, redirectPageTag);
                    break;
                case EnrollmentType.EXTERNAL:
                    this.processExternal(enrollmentSettings);
                    break;
                default:
                    // Do nothing if invalid bean config
                    break;
            }
        }
    }
    getEnrollmentType(enrollmentSetting, planHasNextGenForm) {
        if (!enrollmentSetting) {
            if (planHasNextGenForm) {
                return EnrollmentType.INTERNAL;
            }
            return null;
        }
        const { beanMessage, isExternal, hasError, destinationUrl, formId } = enrollmentSetting;
        // Plan set is misconfigured if no message, external url, or internal formId to proceed with
        if (hasError || (!beanMessage && !destinationUrl && !formId)) {
            return null;
        }
        // Still show bean message for internal and external
        if (formId && !isExternal) {
            return EnrollmentType.INTERNAL;
        }
        else if (!formId && isExternal && destinationUrl) {
            return EnrollmentType.EXTERNAL;
        }
        else if (!formId && !isExternal && beanMessage) {
            return EnrollmentType.MESSAGE_ONLY;
        }
        return null;
    }
    processInternal(enrollmentSettings, redirectPageTag) {
        const { beanMessage } = enrollmentSettings ?? {};
        this.spinnerService.hide(SpinnerEvent.SHOPPING_CART_PLANS_ENROLLMENT_SETTINGS_LOADING);
        if (beanMessage) {
            this.showMessageAndContinueModal(beanMessage, () => {
                this.spinnerService.show(SpinnerEvent.NAVIGATE_TO_ENROLLMENT);
                this.navigationService.navigateByPageTag(redirectPageTag, { state: { fetchEnrollmentSettings: false } }).then(() => {
                    this.spinnerService.hide(SpinnerEvent.NAVIGATE_TO_ENROLLMENT);
                });
            });
        }
        else {
            this.spinnerService.show(SpinnerEvent.NAVIGATE_TO_ENROLLMENT);
            this.navigationService.navigateByPageTag(redirectPageTag, { state: { fetchEnrollmentSettings: false } }).then(() => {
                this.spinnerService.hide(SpinnerEvent.NAVIGATE_TO_ENROLLMENT);
            });
        }
    }
    processExternal(enrollmentSettings) {
        const { beanMessage, destinationUrl, payload } = enrollmentSettings;
        const processedDestinationUrl = this.processCustomExternalUrl(destinationUrl);
        this.spinnerService.hide(SpinnerEvent.SHOPPING_CART_PLANS_ENROLLMENT_SETTINGS_LOADING);
        if (destinationUrl && this.navigationUtilityService.isValidUrl(processedDestinationUrl)) {
            if (!beanMessage) {
                this.externalEnroll(enrollmentSettings, processedDestinationUrl, payload);
            }
            else {
                const confirmAction = () => {
                    this.tagsToUpdate(DataLayerEvent.CLICK_EXTERNAL_ENROLL_NOTIFICATION_CONTINUE);
                    this.externalEnroll(enrollmentSettings, processedDestinationUrl, payload);
                };
                const cancelAction = () => {
                    this.tagsToUpdate(DataLayerEvent.CLICK_EXTERNAL_ENROLL_NOTIFICATION_CANCEL);
                };
                const checkCallRecordingInProgress = enrollmentSettings.integrationType === IntegrationType.INLINE;
                // Case: when the external enrollment opens in the same browser tab, check if there is a call recording in progress
                // to prompt the user with the End call recording modal before continuing
                if (checkCallRecordingInProgress) {
                    this.agentCallRecordingNavigationService.handleExternalNavigationForCallRecordingInProgress().then(displayNavigateModal => {
                        if (displayNavigateModal) {
                            this.showExternalEnrollmentModal(beanMessage, confirmAction, cancelAction);
                        }
                    });
                }
                else {
                    this.showExternalEnrollmentModal(beanMessage, confirmAction, cancelAction);
                }
            }
        }
        else {
            this.navigationService.navigateTo404();
        }
    }
    processCustomExternalUrl(url) {
        const matches = CUSTOM_URL_REGEX.exec(url);
        if (matches?.length) {
            // Sample custom url: event://Drx:Platform:Enrollment:USAAEnrollment;https://rwww.usaa.com/inet/health_apply/HealthApplication?quoteid=<quoteid>&flowState=reset
            // matches[1] = event://Drx:Platform:Enrollment:USAAEnrollment;
            // matches[2] = https://rwww.usaa.com:4200/inet/health_apply/HealthApplication?quoteid=<quoteid>&flowState=reset
            const customUrlEvent = matches[1];
            const url = matches[2];
            return this.lookupCustomUrl(customUrlEvent, url);
        }
        return url;
    }
    lookupCustomUrl(customUrlEvent, url) {
        let processedUrl;
        switch (customUrlEvent) {
            case CustomUrlEvent.USAA_ENROLLMENT: {
                // TODO: Future feature tp call REST API endpoint to get USAA quoteId/memberId and update url
                // Remove replace "<", ">". It is to temporarily pass RegexPattern.URL validation until actual development is in place
                processedUrl = url.replace(/\</g, '').replace(/\>/g, '');
                break;
            }
            default:
                processedUrl = url;
        }
        return processedUrl;
    }
    createExternalUrl(destinationUrl, payload) {
        const urlHasExistingQueryString = destinationUrl?.includes('?');
        return `${destinationUrl}${urlHasExistingQueryString ? '&' : '?'}${this.createQueryString(payload)}`;
    }
    createQueryString(payload) {
        return Object.keys(payload)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(payload[key])}`)
            .join('&');
    }
    processMessageOnly(enrollmentSettings, crossSellModalCloseAction) {
        const { beanMessage } = enrollmentSettings ?? {};
        const crossSellEnrollmentTypes = this.enrollmentFormService.getCrossSellEnrollmentTypes();
        this.spinnerService.hide(SpinnerEvent.SHOPPING_CART_PLANS_ENROLLMENT_SETTINGS_LOADING);
        if (crossSellEnrollmentTypes && crossSellModalCloseAction) {
            // If we need to go back to the next enrollment in case of cross sell cases
            // send the action to continue to next enrollment
            this.showMessageOnlyModal(beanMessage, () => {
                crossSellModalCloseAction();
            });
        }
        else {
            this.showMessageOnlyModal(beanMessage, () => {
                this.tagsToUpdate(DataLayerEvent.CLICK_MESSAGEONLY_ENROLL_NOTIFICATION_CLOSE);
            });
        }
    }
    tagsToUpdate(event) {
        const plan = this.shoppingCartService.getSelectedPlan();
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: event,
            [DataLayerGlobalVariable.PLAN_ID]: plan?.id ?? GOOGLE_ANALYTICS_NOT_APPLICABLE,
            [DataLayerGlobalVariable.PLAN_TYPE]: plan?.planTypeAbbreviation ?? GOOGLE_ANALYTICS_NOT_APPLICABLE,
            [DataLayerGlobalVariable.REMOVED_PLAN_PROVIDER_VBC_STATUS]: !!plan?.providers?.some(provider => provider.hasAgreement)
                ? GOOGLE_ANALYTICS_YES
                : GOOGLE_ANALYTICS_NO
        };
    }
    getEnrollmentModalCloseText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_EnrollMessageEnrollmentModal_Close', widgetName, 'Close');
    }
    getEnrollmentModalConfirmText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_EnrollMessageEnrollmentModal_Continue', widgetName, 'Continue');
    }
    getEnrollmentModalTitle(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_EnrollMessageEnrollmentModal_Title', widgetName, 'Enrollment information');
    }
    showMessageOnlyModal(message, closeAction) {
        const title = this.configResourceService.getProcessedResourceValue('Spa_MessageOnlyEnrollmentModal_Title', null, 'Enrollment information');
        const cancelButtonText = this.configResourceService.getProcessedResourceValue('Spa_MessageOnlyEnrollmentModal_Close', null, 'Close');
        this.tagsToUpdate(DataLayerEvent.CLICK_MESSAGEONLY_ENROLL_NOTIFICATION_OPEN);
        const confirmationModal = this.modalService.open(ConfirmationModalComponent, { centered: true, backdrop: 'static', keyboard: false });
        confirmationModal.componentInstance.title = title;
        confirmationModal.componentInstance.prompt = message || '';
        confirmationModal.componentInstance.cancelButton = cancelButtonText;
        if (closeAction) {
            confirmationModal.componentInstance.cancelAction = closeAction;
        }
        confirmationModal.componentInstance.singleButtonOnCenter = true;
    }
    showMessageAndContinueModal(message, confirmAction) {
        const title = this.getEnrollmentModalTitle();
        const cancelButtonText = this.getEnrollmentModalCloseText();
        const confirmButtonText = this.getEnrollmentModalConfirmText();
        const confirmationModal = this.modalService.open(ConfirmationModalComponent, { centered: true, backdrop: 'static', keyboard: false });
        confirmationModal.componentInstance.title = title;
        confirmationModal.componentInstance.prompt = message || '';
        confirmationModal.componentInstance.cancelButton = cancelButtonText;
        confirmationModal.componentInstance.confirmButton = confirmButtonText;
        confirmationModal.componentInstance.confirmAction = confirmAction;
    }
    showExternalEnrollmentModal(message, confirmAction, cancelAction) {
        this.tagsToUpdate(DataLayerEvent.CLICK_EXTERNAL_ENROLL_NOTIFICATION_OPEN);
        const title = this.getEnrollmentModalTitle();
        const cancelButtonText = this.getEnrollmentModalCloseText();
        const confirmButtonText = this.getEnrollmentModalConfirmText();
        const externalEnrollmentModal = this.modalService.open(ConfirmationModalComponent, {
            centered: true,
            backdrop: 'static',
            keyboard: false
        });
        this.externalEnrollmentContext.open(externalEnrollmentModal);
        externalEnrollmentModal.componentInstance.title = title;
        externalEnrollmentModal.componentInstance.prompt = message || '';
        externalEnrollmentModal.componentInstance.cancelButton = cancelButtonText;
        externalEnrollmentModal.componentInstance.confirmButton = confirmButtonText;
        externalEnrollmentModal.componentInstance.confirmAction = confirmAction;
        externalEnrollmentModal.componentInstance.cancelAction = () => {
            this.externalEnrollmentContext.close(externalEnrollmentModal);
            cancelAction();
        };
    }
    externalEnroll(enrollmentSettings, processedDestinationUrl, payload) {
        const planId = this.enrollmentFormService.getActiveEnrollmentKey();
        const integrationType = enrollmentSettings.integrationType;
        this.externalEnrollmentContext.dispatchNonModalEvent(this.getExternallEnrollmentType(enrollmentSettings));
        if (!this.configResourceService.getProcessedResourceValue('Spa_ShoppingCart_IndividualEnrollmentButtons_Enabled', null, false)) {
            this.shoppingCartService.removePlan(planId);
        }
        if (enrollmentSettings.isPost) {
            this.postExternalEnrollment(processedDestinationUrl, payload, integrationType === IntegrationType.POPUP);
        }
        else if (enrollmentSettings.isSSO) {
            this.postExternalSSOEnrollment(processedDestinationUrl, payload, integrationType === IntegrationType.POPUP);
        }
        else {
            this.spinnerService.show(SpinnerEvent.NAVIGATE_TO_ENROLLMENT); // Show spinner before moving to external website.
            const externalUrl = this.createExternalUrl(processedDestinationUrl, payload);
            this.navigationService.navigateToExternalEnrollment(externalUrl, integrationType).then(() => {
                this.spinnerService.hide(SpinnerEvent.NAVIGATE_TO_ENROLLMENT);
            });
        }
    }
    postExternalSSOEnrollment(action, payload, isNewWindow) {
        const enrollForm = this.initializeForm(action, isNewWindow);
        this.setSamlFormData(payload.samlResponse, enrollForm, payload.relayState);
        this.submitForm(enrollForm);
    }
    postExternalEnrollment(action, payload, isNewWindow) {
        const enrollForm = this.initializeForm(action, isNewWindow);
        this.setFormData(payload, enrollForm);
        this.submitForm(enrollForm);
    }
    submitForm(enrollForm) {
        document.body.appendChild(enrollForm);
        try {
            enrollForm.submit();
        }
        finally {
            document.body.removeChild(enrollForm);
        }
    }
    setSamlFormData(samlResponse, enrollForm, relayState) {
        const field = document.createElement('input');
        // id and name both attribute must be SAMLResponse
        const samlIdentifier = 'SAMLResponse';
        field.setAttribute('id', samlIdentifier);
        field.setAttribute('name', samlIdentifier);
        field.setAttribute('type', 'hidden');
        field.setAttribute('value', samlResponse);
        enrollForm.appendChild(field);
        if (relayState) {
            this.setRelayState(relayState, enrollForm);
        }
    }
    setRelayState(relayState, enrollForm) {
        this.setFormField(EXTERNAL_ENROLLMENT_RELAY_STATE_FIELD_NAME, relayState, enrollForm);
    }
    setFormData(payload, enrollForm) {
        for (const property in payload) {
            if (Object.prototype.hasOwnProperty.call(payload, property)) {
                this.setFormField(property, payload[property], enrollForm);
            }
        }
    }
    setFormField(name, value, enrollForm) {
        const field = document.createElement('input');
        field.setAttribute('type', 'hidden');
        field.setAttribute('name', name);
        field.setAttribute('value', value);
        enrollForm.appendChild(field);
    }
    initializeForm(action, isNewWindow) {
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = action;
        if (isNewWindow) {
            form.target = '_blank';
        }
        return form;
    }
    getExternallEnrollmentType(enrollmentSettings) {
        let externalEnrollmentType = ExternalEnrollmentNonModalEventTypes.NORMAL;
        if (enrollmentSettings.isPost) {
            externalEnrollmentType = ExternalEnrollmentNonModalEventTypes.POST;
        }
        else if (enrollmentSettings.isSSO) {
            externalEnrollmentType = ExternalEnrollmentNonModalEventTypes.SSO;
        }
        return externalEnrollmentType;
    }
}
EnrollmentSettingsService.ɵfac = function EnrollmentSettingsService_Factory(t) { return new (t || EnrollmentSettingsService)(i0.ɵɵinject(EnrollmentFormService), i0.ɵɵinject(i1$1.NgbModal), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(GoogleTagManagerService), i0.ɵɵinject(NavigationService), i0.ɵɵinject(NavigationUtilityService), i0.ɵɵinject(ShoppingCartService), i0.ɵɵinject(SpinnerService), i0.ɵɵinject(AgentCallRecordingNavigationService), i0.ɵɵinject(ExternalEnrollmentContext)); };
EnrollmentSettingsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: EnrollmentSettingsService, factory: EnrollmentSettingsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnrollmentSettingsService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: EnrollmentFormService }, { type: i1$1.NgbModal }, { type: ConfigResourceService }, { type: GoogleTagManagerService }, { type: NavigationService }, { type: NavigationUtilityService }, { type: ShoppingCartService }, { type: SpinnerService }, { type: AgentCallRecordingNavigationService }, { type: ExternalEnrollmentContext }]; }, null); })();

class EnrollmentUtilityService {
    static getPlanTypeName(planTypeId) {
        return PlansUtilityService.getPlanTypeName(planTypeId);
    }
    static sortMemberEnrollmentByCreatedWhen(memberEnrollment1, memberEnrollment2) {
        return SortUtilities.sortByDate(memberEnrollment1.createdWhen, memberEnrollment2.createdWhen);
    }
}
EnrollmentUtilityService.ɵfac = function EnrollmentUtilityService_Factory(t) { return new (t || EnrollmentUtilityService)(); };
EnrollmentUtilityService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: EnrollmentUtilityService, factory: EnrollmentUtilityService.ɵfac, providedIn: 'root' });
__decorate([
    Memoize()
], EnrollmentUtilityService, "getPlanTypeName", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnrollmentUtilityService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

class EnrollmentGuard {
    constructor(enrollmentFormService, location, router) {
        this.enrollmentFormService = enrollmentFormService;
        this.location = location;
        this.router = router;
    }
    canActivate(route, state) {
        const activeEnrollmentKey = this.enrollmentFormService.getActiveEnrollmentKey();
        const transactionStatus = this.enrollmentFormService.getTransactionStatus(activeEnrollmentKey);
        // if there is no transaction we will let them proceed because the enrollment is not in a completed state
        // and the resolver is responsible for getting the initial transaction when it is not available
        const canActivateEnrollment = !transactionStatus || transactionStatus !== EnrollmentTransactionStatus.COMPLETED;
        // if we are navigating back using browser back and cannot access enrollment then we need to make sure the
        // browser history stack is in alignment with the angular router history. when the back button is used to navigate
        // the browser history is updated, we hit this route guard and the angular router does not activate it but we now
        // have a situation where the browser history needs to essentially be rolled back. this is what that does
        if (!canActivateEnrollment && this.router.getCurrentNavigation().trigger === 'popstate') {
            this.location.go(state.url);
        }
        return canActivateEnrollment;
    }
}
EnrollmentGuard.ɵfac = function EnrollmentGuard_Factory(t) { return new (t || EnrollmentGuard)(i0.ɵɵinject(EnrollmentFormService), i0.ɵɵinject(i3.Location), i0.ɵɵinject(i2$1.Router)); };
EnrollmentGuard.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: EnrollmentGuard, factory: EnrollmentGuard.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnrollmentGuard, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: EnrollmentFormService }, { type: i3.Location }, { type: i2$1.Router }]; }, null); })();

const GENERIC_FORM_TRANSACTION_ID = 'genericFormTransactionId';
// Checks for a transactionId... if one exists we use that otherwise create a transaction and return an observable
class GenericFormTransactionResolver {
    constructor(genericFormService, enrollmentFormService, configResourceService, localeService, router, spinnerService) {
        this.genericFormService = genericFormService;
        this.enrollmentFormService = enrollmentFormService;
        this.configResourceService = configResourceService;
        this.localeService = localeService;
        this.router = router;
        this.spinnerService = spinnerService;
    }
    resolve(route) {
        // get the path of the route we are about to activate. navigationContext.getUrl will not work here
        // as it will get the previous route since this value is set on NavigationEnd
        const path = route?.url?.map(router => router.path).join('/');
        const isAncillaryForm = this.genericFormService.isAncillaryFormPage(path);
        // Adding this so we can process our form resources for ancillary pages without a larger architectural change.
        // We could perhaps eventually change the resource acquisition logic to look for parent routes at some point
        // for the routes that use uri params but that will require a larger discussion and much riskier, widespread changes.
        const resourcePageName = this.genericFormService.isAncillaryFormPage(path)
            ? this.genericFormService.getAncillaryFormBaseUrl()
            : undefined;
        const formId = this.configResourceService.getProcessedResourceValue('Spa_GenericForm_FormId', undefined, undefined, false, resourcePageName);
        const activeEnrollmentKey = this.enrollmentFormService.getActiveEnrollmentKey();
        if (activeEnrollmentKey !== formId) {
            this.enrollmentFormService.setActiveEnrollmentKey(formId);
        }
        const transaction = this.enrollmentFormService.getTransaction(formId);
        const pageName = route.params.pageName;
        const environment = EnvironmentService.getEnvironment();
        if (environment.liveedit) {
            // Don't initialize transaction and don't redirect to 1st page of FOAM form
            // Since version 10 any resolver which returns EMPTY will cancel navigation
            // TODO: test that is OK in regression testing
            return EMPTY;
        }
        // Do nothing if changing pages in middle of enrollment
        // Generic formType should always be long form
        if (transaction && transaction.transactionSID && pageName) {
            return of(transaction.transactionSID);
        }
        const customInternalDefinition = this.configResourceService.getProcessedResourceValue('Spa_GenericForm_CustomInternal_Json', undefined, undefined, false, resourcePageName);
        // Not ideal to put spinner here, but initialize transaction was slow (30secs+) on some instances in DEV
        this.spinnerService.show(SpinnerEvent.GENERIC_FORM_INIT_TRANSACTION);
        return this.genericFormService.initializeFormAndTransaction$(formId, customInternalDefinition, isAncillaryForm).pipe(switchMap(() => this.localeService.getCurrentLocale$()), switchMap(locale => this.genericFormService.fetchPageHtml$(0, formId, locale)), switchMap(() => of(this.genericFormService.getTransactionId(formId))), tap(() => {
            const baseUrl = this.genericFormService.getGenericFormBaseUrl(path);
            const firstPage = this.genericFormService.getFirstPageName(formId);
            this.router.navigateByUrl(`${baseUrl}/${firstPage}`);
            this.spinnerService.hide(SpinnerEvent.GENERIC_FORM_INIT_TRANSACTION);
        }));
    }
}
GenericFormTransactionResolver.ɵfac = function GenericFormTransactionResolver_Factory(t) { return new (t || GenericFormTransactionResolver)(i0.ɵɵinject(GenericFormService), i0.ɵɵinject(EnrollmentFormService), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(LocaleService), i0.ɵɵinject(i2$1.Router), i0.ɵɵinject(SpinnerService)); };
GenericFormTransactionResolver.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: GenericFormTransactionResolver, factory: GenericFormTransactionResolver.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GenericFormTransactionResolver, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: GenericFormService }, { type: EnrollmentFormService }, { type: ConfigResourceService }, { type: LocaleService }, { type: i2$1.Router }, { type: SpinnerService }]; }, null); })();

// Checks for a transactionId... if one exists we use that otherwise create a transaction and return an observable
class HRAFormTransactionResolver {
    constructor(genericFormService, enrollmentFormService, localeService, router, spinnerService, navigationService, configResourceService, hraService) {
        this.genericFormService = genericFormService;
        this.enrollmentFormService = enrollmentFormService;
        this.localeService = localeService;
        this.router = router;
        this.spinnerService = spinnerService;
        this.navigationService = navigationService;
        this.configResourceService = configResourceService;
        this.hraService = hraService;
    }
    resolve(route) {
        const formId = this.enrollmentFormService.getActiveEnrollmentKey();
        const hraParentPlanId = this.enrollmentFormService.getHRAPlanId();
        return this.enrollmentFormService.getEnrollmentPlanHRASettingsLoaded$(undefined, hraParentPlanId).pipe(switchMap(isSettingsLoaded => isSettingsLoaded
            ? of(this.enrollmentFormService.getEnrollmentPlanHRASettings(undefined, hraParentPlanId))
            : from(this.enrollmentFormService.fetchEnrollmentPlanHRASettings(hraParentPlanId))), combineLatestWith(this.enrollmentFormService.hasFormVersionIdChanged$()), switchMap(([enrollmentSettings, hasFormVersionIdChanged]) => {
            if (!hasFormVersionIdChanged) {
                const originalEnrollmentTransactionId = this.navigationService.getNavigationExtrasStateValue('originalEnrollmentTransactionId');
                const isDirectAPIEnrollment = this.navigationService.getNavigationExtrasStateValue('isDirectAPIEnrollment');
                const hraUserType = this.navigationService.getNavigationExtrasStateValue('hraUserType');
                const storageId = this.navigationService.getNavigationExtrasStateValue('storageId');
                const planHasNextGenHRAForm = this.enrollmentFormService.planHasNextGenHRAForm(undefined, hraParentPlanId);
                if (planHasNextGenHRAForm) {
                    const transaction = this.enrollmentFormService.getNextGenTransaction(formId);
                    const pageName = route.params.pageName;
                    const defaultPageIndex = pageName ? 0 : null;
                    if (transaction?.transactionGUID) {
                        // Do nothing if we already have a transaction
                        return of(transaction.transactionGUID);
                    }
                    const skipToEnd = route?.queryParams && `${route.queryParams.goToLastPage}`.toLowerCase() === 'true';
                    return from(this.hraService.initializeNextGenHRATransaction$(formId, hraParentPlanId, skipToEnd ? -1 : defaultPageIndex, originalEnrollmentTransactionId, isDirectAPIEnrollment));
                }
                else {
                    const transaction = this.enrollmentFormService.getTransaction(formId);
                    const pageName = route.params.pageName;
                    const environment = EnvironmentService.getEnvironment();
                    if (environment.liveedit || !formId) {
                        // Don't initialize transaction and don't redirect to 1st page of FOAM form
                        // Since version 10 any resolver which returns EMPTY will cancel navigation
                        // TODO: test that is OK in regression testing
                        return EMPTY;
                    }
                    // Do nothing if changing pages in middle of enrollment
                    if (transaction?.transactionSID && pageName) {
                        return of(transaction.transactionSID);
                    }
                    const hraCustomInternal = this.configResourceService.getProcessedResourceValue('Spa_HRAForm_CustomInternal_Json');
                    // Not ideal to put spinner here, but initialize transaction was slow (30secs+) on some instances in DEV
                    this.spinnerService.show(SpinnerEvent.HRA_FORM_LOADING);
                    return from(this.hraService.initializeHRATransaction$(formId, hraCustomInternal, originalEnrollmentTransactionId, isDirectAPIEnrollment, hraUserType, storageId)).pipe(switchMap(() => this.localeService.getCurrentLocale$()), switchMap(locale => this.genericFormService.fetchPageHtml$(0, formId, locale)), switchMap(() => of(this.genericFormService.getTransactionId(formId))), tap(() => {
                        const baseUrl = this.hraService.getHRAFormBaseUrl();
                        const firstPage = this.genericFormService.getFirstPageName(formId);
                        this.router.navigateByUrl(`${baseUrl}/${firstPage}`);
                        this.spinnerService.hide(SpinnerEvent.HRA_FORM_LOADING);
                    }));
                }
            }
            else {
                return of('');
            }
        }));
    }
}
HRAFormTransactionResolver.ɵfac = function HRAFormTransactionResolver_Factory(t) { return new (t || HRAFormTransactionResolver)(i0.ɵɵinject(GenericFormService), i0.ɵɵinject(EnrollmentFormService), i0.ɵɵinject(LocaleService), i0.ɵɵinject(i2$1.Router), i0.ɵɵinject(SpinnerService), i0.ɵɵinject(NavigationService), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(HRAService)); };
HRAFormTransactionResolver.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: HRAFormTransactionResolver, factory: HRAFormTransactionResolver.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HRAFormTransactionResolver, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: GenericFormService }, { type: EnrollmentFormService }, { type: LocaleService }, { type: i2$1.Router }, { type: SpinnerService }, { type: NavigationService }, { type: ConfigResourceService }, { type: HRAService }]; }, null); })();

class PageInfo {
    constructor(index, name) {
        this.index = index;
        this.name = name;
    }
}

class EligibilityCheckValidatorContextService {
    constructor() {
        this.eligibilityCheckFieldNames = Object.keys(EligibilityCheckFieldNamesMap);
        this.hasAnyEligibilityCheckFieldValueChanged = false;
    }
    verifyIfAnyEligibilityCheckFieldValueChanged(name, value) {
        if (!this.hasAnyEligibilityCheckFieldValueChanged) {
            if (typeof value === 'object') {
                for (const questionName of Object.keys(value)) {
                    this.hasAnyEligibilityCheckFieldValueChanged = this.eligibilityCheckFieldNames.some(fieldName => fieldName === questionName);
                    if (this.hasAnyEligibilityCheckFieldValueChanged) {
                        break;
                    }
                }
            }
            else {
                this.hasAnyEligibilityCheckFieldValueChanged = this.eligibilityCheckFieldNames.some(fieldName => fieldName === name);
            }
        }
    }
    async runEligibilityCheckValidator(validator, memberEligibilityInfo, isDSNPPlan = false) {
        if (validator.getValidationSeverity() === EligibilityCheckValidation.Hard || this.hasAnyEligibilityCheckFieldValueChanged) {
            const result = await validator.validate(memberEligibilityInfo, isDSNPPlan);
            this.resetState();
            return result;
        }
        // Skips validation
        return await Promise.resolve({ isValid: true, type: PageLevelValidatorType.EligibilityCheck });
    }
    resetState() {
        this.hasAnyEligibilityCheckFieldValueChanged = false;
    }
}
EligibilityCheckValidatorContextService.ɵfac = function EligibilityCheckValidatorContextService_Factory(t) { return new (t || EligibilityCheckValidatorContextService)(); };
EligibilityCheckValidatorContextService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: EligibilityCheckValidatorContextService, factory: EligibilityCheckValidatorContextService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EligibilityCheckValidatorContextService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

class GroupValidatorContextService {
    constructor() {
        this.hasRunGroupValidationFirstTime = false;
    }
    async runGroupValidator(validator) {
        if (validator.getValidationSeverity() === GroupValidationSeverity.Hard || !this.hasRunGroupValidationFirstTime) {
            const result = await validator.validate();
            this.hasRunGroupValidationFirstTime = true;
            return result;
        }
        return await Promise.resolve({ isValid: true, type: PageLevelValidatorType.Group });
    }
    async nextGenValidateGroup(conditionExpression, element, responseEventType, dispatchGroupValidationEvent) {
        return await new Promise((resolve, reject) => {
            const timeout = setTimeout(() => {
                element.removeEventListener(responseEventType, handleValidatorResultListener);
                const error = new Error('Group validator timed out.');
                console.error(error);
                reject(error);
            }, 5000);
            const handleValidatorResultListener = (event) => {
                if (event?.detail) {
                    try {
                        const { expression, triggerValidationError } = event.detail;
                        if (expression === conditionExpression) {
                            element.removeEventListener(responseEventType, handleValidatorResultListener);
                            clearTimeout(timeout);
                            resolve(!triggerValidationError);
                        }
                    }
                    catch (error) {
                        element.removeEventListener(responseEventType, handleValidatorResultListener);
                        clearTimeout(timeout);
                        console.error(error);
                        reject(error);
                    }
                }
            };
            element.addEventListener(responseEventType, handleValidatorResultListener, {
                once: true
            });
            dispatchGroupValidationEvent();
        });
    }
}
GroupValidatorContextService.ɵfac = function GroupValidatorContextService_Factory(t) { return new (t || GroupValidatorContextService)(); };
GroupValidatorContextService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: GroupValidatorContextService, factory: GroupValidatorContextService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GroupValidatorContextService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

class StandaloneFormService {
    constructor(enrollmentFormService, store, memberSessionService, configResourceService, emailService, navigationUtilityService, lockedSiteService, shoppingCartService, phoneService, agentService, navigationContext, preferencesService, planYearResourceService, quoteService, passParamService, profileService, demographicService, twilioService, utilityFunctionService, ipUtilityService, soaService, weglotService) {
        this.enrollmentFormService = enrollmentFormService;
        this.store = store;
        this.memberSessionService = memberSessionService;
        this.configResourceService = configResourceService;
        this.emailService = emailService;
        this.navigationUtilityService = navigationUtilityService;
        this.lockedSiteService = lockedSiteService;
        this.shoppingCartService = shoppingCartService;
        this.phoneService = phoneService;
        this.agentService = agentService;
        this.navigationContext = navigationContext;
        this.preferencesService = preferencesService;
        this.planYearResourceService = planYearResourceService;
        this.quoteService = quoteService;
        this.passParamService = passParamService;
        this.profileService = profileService;
        this.demographicService = demographicService;
        this.twilioService = twilioService;
        this.utilityFunctionService = utilityFunctionService;
        this.ipUtilityService = ipUtilityService;
        this.soaService = soaService;
        this.weglotService = weglotService;
    }
    getActiveEnrollmentKey() {
        return this.enrollmentFormService.getActiveEnrollmentKey();
    }
    getTransactionId(formId) {
        return this.enrollmentFormService.getNextGenTransactionId(formId);
    }
    getTransaction$(formId) {
        return this.enrollmentFormService.getNextGenTransaction$(formId);
    }
    getTransaction(formId) {
        return this.enrollmentFormService.getNextGenTransaction(formId);
    }
    getFormLoading$(formId) {
        return this.enrollmentFormService.getNextGenFormLoading$(formId);
    }
    setFormLoading$(formId, loading) {
        return this.enrollmentFormService.setNextGenFormLoading$(formId, loading);
    }
    setFormTitle(formTitle) {
        this.enrollmentFormService.setFormTitle(formTitle);
    }
    getFormType(formId) {
        return this.enrollmentFormService.getSelectedFormType(formId).valueOf();
    }
    getStandaloneFormBaseUrl(path) {
        // We need to determine if this is the ancillary form page or generic form page because we may have both
        // and it matter for analytics purposes. Could have also added a new resolver and service but looking
        // to reuse as much as possible here.
        const genericFormPageTag = this.isAncillaryFormPage(path) ? PageTags.STANDALONE_ANCILLARY_FORM : PageTags.STANDALONE_FORM;
        return this.store.selectSnapshot(AppConfigState.hrefByTag(genericFormPageTag));
    }
    isAncillaryFormPage(path) {
        const currentPath = path ?? this.navigationContext.getUrl();
        const ancillaryPageRoot = this.getAncillaryFormBaseUrl();
        return (!!ancillaryPageRoot &&
            !!this.navigationUtilityService.normalizePath(currentPath).startsWith(this.navigationUtilityService.normalizePath(ancillaryPageRoot)));
    }
    isAncillaryConfirmationPage() {
        return this.navigationUtilityService.pageTagURLMatch(PageTags.STANDALONE_CONFIRMATION, this.navigationContext.getUrl());
    }
    getAncillaryFormBaseUrl() {
        return this.store.selectSnapshot(AppConfigState.hrefByTag(PageTags.STANDALONE_ANCILLARY_FORM));
    }
    fetchFormVersionInfo$(formId = this.getActiveEnrollmentKey()) {
        return this.enrollmentFormService.fetchFormVersionInfo$(formId);
    }
    async initializeFormAndTransaction(formId, formVersion, formVersionId, isAncillaryForm) {
        this.enrollmentFormService.resetActiveEnrollmentKey();
        this.enrollmentFormService.setActiveEnrollmentKey(formId);
        return await this.createTransaction(formId, formVersion, formVersionId, isAncillaryForm);
    }
    getCustomInternalWrapper(customInternal) {
        const customInternalWrapper = new CustomInternalWrapper();
        customInternalWrapper.CustomInternal = customInternal;
        return customInternalWrapper;
    }
    populateCustomInternal(customInternalDefinition, userType) {
        const customInternalWrapper = this.getCustomInternalWrapper(customInternalDefinition);
        return this.prepareAndStoreCustomInternalWrapper(customInternalWrapper, userType);
    }
    // This MAY be able to be removed but more research is needed. It still isn't clear if we might use this for some PC API edge case.
    prepareAndStoreCustomInternalWrapper(customInternalWrapper, userType) {
        const preparedCustomInternal = this.enrollmentFormService.prepareCustomInternalForBean(customInternalWrapper, userType);
        this.enrollmentFormService.setCustomInternalToSessionStorage(preparedCustomInternal);
        return preparedCustomInternal;
    }
    async createTransaction(formId, formVersion, formVersionId, isAncillaryForm = false) {
        const partnerId = this.passParamService.getPartnerId() || this.configResourceService.getProcessedResourceValue('PartnerID');
        const sourceId = this.passParamService.getSourceId() || this.configResourceService.getProcessedResourceValue('SourceID');
        const destinationAppId = this.configResourceService.getProcessedResourceValue('AppID');
        const isTestingSite = this.configResourceService.getProcessedResourceValue('Spa_Site_IsTestSite', null, false);
        // We are disabling these because the backend wants these in this format
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const Spa_SendEnrollment_Retain_Form_Answers = this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_Retain_Form_Answers', null, false);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const Spa_Site_SiteType = this.configResourceService.getProcessedResourceValue('Spa_Site_SiteType', null, SiteType.CONSUMER);
        const userType = this.configResourceService.getProcessedResourceValue('UserType', null, '');
        const memberSession = this.memberSessionService.getMemberSession();
        const apiProfileStateModel = { ...memberSession.profile };
        const updatedProfileModel = this.profileService.prepareProfileStateForAPI(apiProfileStateModel);
        const [createdIPAddress] = await Promise.all([
            this.ipUtilityService.getClientIP(),
            this.demographicService.conditionallyFetchCounties(memberSession.demographic.zip, memberSession.demographic.fips)
        ]);
        const countyName = this.demographicService.getSelectedCounty()?.countyName ?? '';
        const apiMemberStateModel = {
            sessionId: memberSession.sessionId,
            ssoValue: memberSession.ssoValue,
            memberId: memberSession.memberID,
            profile: { authRepData: {}, ...updatedProfileModel },
            // getting countyName from counties plus selectedFips
            // this assumes counties is loaded and if its not we will not find a countyName
            demographic: { ...memberSession.demographic, countyName },
            enrollments: memberSession.enrollments
        };
        const deepLinkingParams = this.enrollmentFormService.getNextGenDeepLinkingParams();
        const agent = this.enrollmentFormService.getAgentRequestData();
        const quoteId = this.quoteService.getBeneficiaryQuoteId();
        const quoteType = this.quoteService.getQuoteInfo()?.quoteType;
        const sourceSiteId = this.quoteService.getSourceSiteId();
        const isSiteLive = this.lockedSiteService.isSiteLive();
        const isReviewSite = this.lockedSiteService.isReviewSite(window.location.hostname);
        const callRecordingAvailable = this.twilioService.isConnectionOpen();
        const medigapAnswers = this.memberSessionService.getMemberMedigapAnswers();
        const humanaCustomClientPartnerId = this.configResourceService.getProcessedResourceValue('HumanaCustomClientPartnerId');
        const humanaCustomClientPartnerName = this.configResourceService.getProcessedResourceValue('HumanaCustomClientPartnerName');
        const humanaCustomClientPartnerIdentifier = this.configResourceService.getProcessedResourceValue('HumanaCustomClientPartnerIdentifier');
        // this is from bean provider settings but we need this from plan settings so we will get it from there eventually
        try {
            const isPurl = this.agentService.isPurl();
            await this.enrollmentFormService.createNextGenFormTransaction$({
                ...(agent && { agent }),
                standaloneEnrollmentData: {
                    isStandaloneRequest: true,
                    isAncillary: isAncillaryForm,
                    formId,
                    formVersion,
                    formVersionId
                },
                enrollmentSettings: {},
                coverageEventType: isAncillaryForm ? CoverageEventType.AncillaryGeneric : CoverageEventType.Generic,
                ...(sourceSiteId && { sourceSiteId }),
                session: { ...apiMemberStateModel, ...(quoteId && { quoteType }), ...(medigapAnswers && { medigapAnswers }) },
                site: {
                    isSiteLive,
                    isReviewSite,
                    createdIPAddress,
                    partnerId,
                    destinationAppId,
                    isTestingSite
                },
                configurations: {
                    sourceId,
                    Spa_SendEnrollment_Retain_Form_Answers,
                    Spa_Site_SiteType,
                    userType,
                    humanaCustomClientPartnerId,
                    humanaCustomClientPartnerName,
                    humanaCustomClientPartnerIdentifier
                },
                isPurl,
                currentDate: this.utilityFunctionService.getCurrentDate(DateUtilities.defaultFormat),
                hasValidCompletedSOA: this.soaService.hasValidCompletedSOA(),
                medigapAnswers: this.enrollmentFormService.getNextGenRequestMedigapAnswers(),
                ...(Object.keys(deepLinkingParams).length && { deepLinkingParams }),
                isMedigap: false
            }, callRecordingAvailable);
        }
        catch (error) {
            return await Promise.reject(error);
        }
        await this.enrollmentFormService.setCurrentFormVersionId(formVersionId);
        return await Promise.resolve(this.getTransaction(formId));
    }
    updateTransaction$(answers, formId) {
        return this.enrollmentFormService.updateNextGenTransaction$(answers, formId);
    }
    async completeEnrollment(transactionAnswers, formId, isHRA = false, widgetName) {
        const inputs = [];
        let planEnrollmentRequest;
        if (isHRA) {
            const planId = this.store.selectSnapshot(EnrollmentState.hraPlanId);
            const selectedPlan = this.shoppingCartService.getPlan(planId);
            const carrierId = selectedPlan?.carrierId;
            const planType = selectedPlan?.planType;
            const preferencesJSON = await this.preferencesService.createPreferencesJSON(planId);
            const confirmationSettings = this.enrollmentFormService.createConfirmationSettings(planId, this.enrollmentFormService.getSelectedFormType(planId));
            planEnrollmentRequest = {
                ...(planId && { planId }),
                ...(carrierId && { carrierId }),
                ...(planType && { planType }),
                ...(preferencesJSON && { preferencesJSON }),
                ...(confirmationSettings && { confirmationSettings })
            };
        }
        const sessionId = this.memberSessionService.getMemberSessionId();
        const isSiteLive = this.lockedSiteService.isSiteLive();
        const isLockedSite = this.lockedSiteService.isReviewSite(window.location.hostname);
        const partnerId = this.passParamService.getPartnerId() || this.configResourceService.getProcessedResourceValue('PartnerID');
        const sourceId = this.passParamService.getSourceId() || this.configResourceService.getProcessedResourceValue('SourceID');
        const siteId = this.enrollmentFormService.getSiteId();
        // const clientId = this.memberSessionService.getClientId();
        const appId = this.configResourceService.getProcessedResourceValue('AppID', null, 0);
        const isActive = !isLockedSite && isSiteLive; // from generic form transaction... TODO: follow up on if
        const zipCode = this.enrollmentFormService.getNextGenEnrollmentAnswer('ApplicantZip', formId) ||
            this.store.selectSnapshot(DemographicState.selectedZipCode);
        const countyFIPS = this.enrollmentFormService.getNextGenEnrollmentAnswer('ApplicantCounty', formId) ||
            this.store.selectSnapshot(DemographicState.selectedFipsCode);
        // this is typically pushed to the profiles primary address when updated in enrollment but we will just
        // grab it from the form itself
        const enrollmentState = this.enrollmentFormService.getNextGenEnrollmentAnswer('ApplicantState', formId);
        const planYear = this.planYearResourceService.getSelectedPlanYear();
        const hideAgentData = this.store.selectSnapshot(UiState.hidePdfAgentData);
        const sourceSiteId = this.quoteService.getSourceSiteId();
        const locale = this.weglotService.getCurrentLocale();
        const nextGenEnrollmentRequest = {
            isStandaloneEnrollment: true,
            planId: null,
            enrollmentKey: formId,
            sessionId,
            completeEnrollmentSiteId: siteId,
            completeEnrollmentAppId: appId,
            zipCode,
            countyFIPS,
            ...(enrollmentState && { state: enrollmentState }),
            ...planEnrollmentRequest,
            isMedigap: false,
            originalAppId: appId,
            destinationAppId: appId,
            sourceId,
            // DRXAgentId: string;
            partnerId,
            // GroupConfirmationNumber: string;
            isActive,
            encryptionTypeId: 0,
            // effectiveDate: string;
            // isSep: boolean,
            isComplete: true,
            langId: 1,
            planYear,
            hideAgentData,
            // groupConfirmationNumber: string,
            sourceSiteId,
            locale
        };
        await this.enrollmentFormService.completeNextGenFormTransaction$(nextGenEnrollmentRequest, this.getTransactionId(formId));
        this.sendConfirmationEmails$(transactionAnswers, inputs, formId, isHRA, true); // TODO: need to update this to actually check for next gen?
    }
    async sendConfirmationEmails$(transactionAnswers, inputs, formId, isHRA = false, planHasNextGenForm) {
        if (isHRA) {
            await this.enrollmentFormService.sendHRAConfirmationEmails$(transactionAnswers, formId, inputs, planHasNextGenForm);
        }
        else {
            await this.sendStandaloneConfirmationEmails$(transactionAnswers, inputs);
        }
        return await Promise.resolve(null);
    }
    async sendStandaloneConfirmationEmails$(transactionAnswers, inputs) {
        const emailAgent = this.configResourceService.getProcessedResourceValue('Spa_GenericForm_CompletionEmailToAgentActive', null, true);
        const subject = this.configResourceService.getProcessedResourceValue('Spa_GenericForm_CompletionEmailToAgentSubject', null);
        const agentEmailAddress = this.store.selectSnapshot(AgentState.emailAddress);
        const emailAddresses = [];
        if (agentEmailAddress && emailAgent) {
            emailAddresses.push(agentEmailAddress);
        }
        const consumerEmailMatch = transactionAnswers.find(answer => answer.name === 'ApplicantEmailAddress');
        if (consumerEmailMatch?.value) {
            emailAddresses.push(consumerEmailMatch.value);
        }
        if (emailAddresses.length) {
            return await this.emailService.sendEmail(EmailNames.GENERIC_FORM_CONFIRMATION, emailAddresses, subject, inputs);
        }
        return await Promise.resolve(null);
    }
    getDestinationPageTag(isHRA = false) {
        if (isHRA) {
            return PageTags.HRA_CONFIRMATION;
        }
        return this.configResourceService.getProcessedResourceValue('Spa_StandaloneForm_RedirectTag');
    }
    getFormIdByFormType(isHRA = false) {
        // Currently the active enrollment key for HRA is the formId.
        // If this ever needs to update, we'll need to change this as well.
        if (isHRA) {
            return this.enrollmentFormService.getActiveEnrollmentKey();
        }
        return this.configResourceService.getProcessedResourceValue('Spa_StandaloneForm_FormId');
    }
    getConfirmationNumber(activeEnrollmentKey) {
        return this.store.selectSnapshot(EnrollmentState.nextGenConfirmationNumber(activeEnrollmentKey));
    }
}
StandaloneFormService.ɵfac = function StandaloneFormService_Factory(t) { return new (t || StandaloneFormService)(i0.ɵɵinject(EnrollmentFormService), i0.ɵɵinject(i1.Store), i0.ɵɵinject(MemberSessionService), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(EmailService), i0.ɵɵinject(NavigationUtilityService), i0.ɵɵinject(LockedSiteService), i0.ɵɵinject(ShoppingCartService), i0.ɵɵinject(PhoneUtilityService), i0.ɵɵinject(AgentService), i0.ɵɵinject(NavigationContext), i0.ɵɵinject(PreferencesService), i0.ɵɵinject(PlanYearResourceService), i0.ɵɵinject(QuoteService), i0.ɵɵinject(PassParameterService), i0.ɵɵinject(ProfileService), i0.ɵɵinject(DemographicService), i0.ɵɵinject(TwilioDeviceService), i0.ɵɵinject(UtilityFunctionService), i0.ɵɵinject(IPUtilityService), i0.ɵɵinject(SOAService), i0.ɵɵinject(WeglotService)); };
StandaloneFormService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: StandaloneFormService, factory: StandaloneFormService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StandaloneFormService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: EnrollmentFormService }, { type: i1.Store }, { type: MemberSessionService }, { type: ConfigResourceService }, { type: EmailService }, { type: NavigationUtilityService }, { type: LockedSiteService }, { type: ShoppingCartService }, { type: PhoneUtilityService }, { type: AgentService }, { type: NavigationContext }, { type: PreferencesService }, { type: PlanYearResourceService }, { type: QuoteService }, { type: PassParameterService }, { type: ProfileService }, { type: DemographicService }, { type: TwilioDeviceService }, { type: UtilityFunctionService }, { type: IPUtilityService }, { type: SOAService }, { type: WeglotService }]; }, null); })();

const STANDALONE_FORM_TRANSACTION_ID = 'standaloneFormTransactionId';
const StandaloneFormTransactionResolver = (route, state, standaloneFormService = inject(StandaloneFormService), enrollmentFormService = inject(EnrollmentFormService), configResourceService = inject(ConfigResourceService), spinnerService = inject(SpinnerService)) => {
    // get the path of the route we are about to activate. navigationContext.getUrl will not work here
    // as it will get the previous route since this value is set on NavigationEnd
    const path = route?.url?.map(router => router.path).join('/');
    const isAncillaryForm = standaloneFormService.isAncillaryFormPage(path);
    // Adding this so we can process our form resources for ancillary pages without a larger architectural change.
    // We could perhaps eventually change the resource acquisition logic to look for parent routes at some point
    // for the routes that use uri params but that will require a larger discussion and much riskier, widespread changes.
    const resourcePageName = isAncillaryForm
        ? standaloneFormService.getAncillaryFormBaseUrl()
        : standaloneFormService.getStandaloneFormBaseUrl();
    const standaloneFormId = configResourceService.getProcessedResourceValue('Spa_StandaloneForm_FormId', undefined, undefined, false, resourcePageName);
    const currentEnrollmentKey = enrollmentFormService.getActiveEnrollmentKey();
    const setActiveEnrollmentKey$ = currentEnrollmentKey !== standaloneFormId
        ? enrollmentFormService.setActiveEnrollmentKey$(standaloneFormId).pipe(take(1))
        : from(currentEnrollmentKey);
    return setActiveEnrollmentKey$.pipe(switchMap(() => {
        return enrollmentFormService.getActiveEnrollmentKey$().pipe(take(1));
    }), switchMap(activeEnrollmentKey => combineLatest([
        standaloneFormService.fetchFormVersionInfo$(activeEnrollmentKey),
        enrollmentFormService.hasFormVersionIdChanged$()
    ]).pipe(switchMap(([formVersionInfo, hasFormVersionIdChanged]) => {
        if (formVersionInfo && !hasFormVersionIdChanged) {
            const { formVersion, formVersionId } = formVersionInfo;
            const transaction = enrollmentFormService.getNextGenTransaction(standaloneFormId);
            const pageName = route.params.pageName;
            const environment = EnvironmentService.getEnvironment();
            if (environment.liveedit) {
                // Don't initialize transaction and don't redirect to 1st form page
                // Since version 10 any resolver which returns EMPTY will cancel navigation
                // TODO: test that is OK in regression testing
                return EMPTY;
            }
            // Do nothing if changing pages in middle of enrollment
            // Standalone formType should always be long form
            if (transaction?.transactionGUID && pageName) {
                return of(transaction.transactionGUID);
            }
            // Not ideal to put spinner here, but initialize transaction was slow (30secs+) on some instances in DEV
            spinnerService.show(SpinnerEvent.STANDALONE_FORM_INIT_TRANSACTION);
            return from(standaloneFormService.initializeFormAndTransaction(standaloneFormId, formVersion, formVersionId, isAncillaryForm)).pipe(map(transaction => transaction?.transactionGUID), finalize(() => {
                spinnerService.hide(SpinnerEvent.STANDALONE_FORM_INIT_TRANSACTION);
            }));
        }
        else {
            return of('');
        }
    }))));
};

const ENROLLMENT_TRANSACTION_ID = 'enrollmentTransactionId';
// Checks for a transactionId... if one exists we use that otherwise create a transaction and return an observable
class EnrollmentTransactionResolver {
    constructor(enrollmentFormService, navigationService) {
        this.enrollmentFormService = enrollmentFormService;
        this.navigationService = navigationService;
    }
    resolve(route) {
        const activeEnrollmentKey = this.enrollmentFormService.getActiveEnrollmentKey();
        const overrideAsShortForm = this.navigationService.getNavigationExtrasStateValue('overrideAsShortForm');
        return combineLatest([
            from(this.enrollmentFormService.fetchEnrollmentPlanSettings(activeEnrollmentKey, undefined, overrideAsShortForm ? [EnrollmentFormType.SHORT] : undefined)),
            this.enrollmentFormService.hasFormVersionIdChanged$()
        ]).pipe(switchMap(([enrollmentSettings, hasFormVersionIdChanged]) => {
            if (!hasFormVersionIdChanged) {
                const planHasNextGenForm = this.enrollmentFormService.planHasNextGenForm(activeEnrollmentKey);
                const decryptedData = this.navigationService.getNavigationExtrasStateValue('decryptedData');
                const fetchEnrollmentSettings = this.navigationService.getNavigationExtrasStateValue('fetchEnrollmentSettings');
                const fetchTransactionFromGuid = this.navigationService.getNavigationExtrasStateValue('fetchTransactionFromGuid');
                const transactionGuid = this.navigationService.getNavigationExtrasStateValue('transactionGuid');
                let defaultPageIndex = null;
                if (!planHasNextGenForm) {
                    const transaction = this.enrollmentFormService.getTransaction(activeEnrollmentKey);
                    const hasFormTypeChanged = transaction?.formType && transaction.formType !== this.enrollmentFormService.getSelectedFormType(activeEnrollmentKey);
                    const pageName = route.params.pageName;
                    // default to null if there is no page name so that the initial page is not loaded twice (once here and once upon navigation)
                    // but still default to 0 if there is a page name in case Enrollment/page is directly accessed
                    defaultPageIndex = pageName ? 0 : null;
                    if (transaction?.transactionSID && !hasFormTypeChanged && pageName) {
                        // if no custom internal set we need to get it and set it
                        // in certain circumstances with pc api/deeplinking we get the transaction ahead of time
                        // and forego the chain of calls which normally sets this
                        if (!this.enrollmentFormService.customInternalSetToSessionStorage()) {
                            this.enrollmentFormService.rehydrateCustomInternal(activeEnrollmentKey);
                        }
                        // Do nothing if changing pages in middle of enrollment
                        return of(transaction.transactionSID);
                    }
                }
                else {
                    const transaction = this.enrollmentFormService.getNextGenTransaction(activeEnrollmentKey);
                    const hasFormTypeChanged = transaction?.formType && transaction.formType !== this.enrollmentFormService.getSelectedFormType(activeEnrollmentKey);
                    const pageName = route.params.pageName;
                    if (transaction?.transactionGUID && !hasFormTypeChanged && pageName) {
                        // Do nothing if changing pages in middle of enrollment
                        return of(transaction.transactionGUID);
                    }
                }
                const skipToEnd = route?.queryParams && `${route.queryParams.goToLastPage}`.toLowerCase() === 'true';
                // Initialize enrollment even if resuming partial enrollment or form changes.
                // If partial enrollment, need to re-send custom internal to update enrollment answers with session data
                // (e.g. premium changed between enrollment creation and now)
                // If form type change, need to include transactionSID in enrollment request body
                // (do not include transactionSID in any other scenario)
                this.enrollmentFormService.initializeEnrollment$(activeEnrollmentKey, skipToEnd ? -1 : defaultPageIndex, fetchEnrollmentSettings, fetchTransactionFromGuid, transactionGuid, undefined, overrideAsShortForm, decryptedData);
                return of(this.enrollmentFormService.getTransactionId(activeEnrollmentKey));
            }
            else {
                return of('');
            }
        }));
    }
}
EnrollmentTransactionResolver.ɵfac = function EnrollmentTransactionResolver_Factory(t) { return new (t || EnrollmentTransactionResolver)(i0.ɵɵinject(EnrollmentFormService), i0.ɵɵinject(NavigationService)); };
EnrollmentTransactionResolver.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: EnrollmentTransactionResolver, factory: EnrollmentTransactionResolver.ɵfac, providedIn: 'root' });
__decorate([
    LiveEditInactive(null)
], EnrollmentTransactionResolver.prototype, "resolve", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnrollmentTransactionResolver, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: EnrollmentFormService }, { type: NavigationService }]; }, { resolve: [] }); })();

var FilterContextNames;
(function (FilterContextNames) {
    FilterContextNames["DSNP"] = "DSNP";
})(FilterContextNames || (FilterContextNames = {}));
class FilterValues {
}
class FilterContextService {
    constructor() {
        this._filterHighlight$ = new BehaviorSubject(null);
        this._filterValues$ = new BehaviorSubject(null);
    }
    setFilterHighlights(filterHighlights) {
        this._filterHighlight$.next(filterHighlights);
    }
    getFilterHighlights$() {
        return this._filterHighlight$.asObservable();
    }
    setFilterValues(filterValues) {
        this._filterValues$.next(filterValues);
    }
    getFilterValues$() {
        return this._filterValues$.asObservable();
    }
}
FilterContextService.ɵfac = function FilterContextService_Factory(t) { return new (t || FilterContextService)(); };
FilterContextService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FilterContextService, factory: FilterContextService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FilterContextService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return []; }, null); })();

// a service for mediating interactions with the underlying store
class FilterService {
    constructor(store, configResourceService) {
        this.store = store;
        this.configResourceService = configResourceService;
        this.forceMedSupFormBeforePlansList = this.configResourceService.getProcessedResourceValue('Spa_Site_ForceMedSupFormBeforePlansList', null, false);
    }
    /**
     * Applies filters from a list to a subset of all plans.
     * Useful when we want to apply specific filters without including filters from a filter group
     */
    getPlansByFilterList$(filterGroupIdentifier, skipAdditionalFiltering = false) {
        return this.store.select(PlansState.getFilteredAdditionalPlansByFilterList(filterGroupIdentifier, this.forceMedSupFormBeforePlansList, skipAdditionalFiltering));
    }
    /**
     * Applies filters to a subset of all plans, currently only SNP categories being toggled on/off
     */
    getPlansByFilterGroup$(filterGroupIdentifier, skipAdditionalFiltering = false) {
        return this.store.select(PlansState.getFilteredAdditionalPlansByFilterGroup(filterGroupIdentifier, this.forceMedSupFormBeforePlansList, skipAdditionalFiltering));
    }
    /**
     * Filters all possible plans via the payload, instead of subsets like SNP
     */
    getPayloadByFilterGroup$(filterGroupIdentifier, skipAdditionalFiltering = false) {
        return this.store.select(PlansState.getFilteredAdditionalPayloadByFilterGroup(filterGroupIdentifier, this.forceMedSupFormBeforePlansList, skipAdditionalFiltering));
    }
    getPlansByFilterAndSortGroup$(filterGroupIdentifier, sortGroupIdentifier, sortTransformerBindFn, skipAdditionalFiltering = false) {
        return this.store.select(PlansState.getFilteredAdditionalPlansByFilterAndSortGroup(filterGroupIdentifier, sortGroupIdentifier, this.forceMedSupFormBeforePlansList, sortTransformerBindFn, skipAdditionalFiltering));
    }
    getPlansByFilterGroupSnapshot(filterGroupIdentifier, skipAdditionalFiltering = false) {
        return this.store.selectSnapshot(PlansState.getFilteredAdditionalPlansByFilterGroup(filterGroupIdentifier, this.forceMedSupFormBeforePlansList, skipAdditionalFiltering));
    }
    getPlanTypePlanCountMapByFilterGroupSnapshot(tabs, skipAdditionalFiltering = false) {
        return this.store.selectSnapshot(PlansState.getPlanTypePlanCountMapByFilterGroup(tabs, this.forceMedSupFormBeforePlansList, skipAdditionalFiltering));
    }
    hasSelectedFilters$(filterGroupIdentifier, includeFilterGroup = true) {
        return this.store.select(PlansState.hasSelectedFilters(filterGroupIdentifier, includeFilterGroup));
    }
    getFiltersByFilterGroup$(filterGroupIdentifier) {
        return this.store.select(PlansState.getFiltersByFilterGroup(filterGroupIdentifier));
    }
    getFiltersByFilterGroupSnapshot(filterGroupIdentifier) {
        return this.store.selectSnapshot(PlansState.getFiltersByFilterGroup(filterGroupIdentifier));
    }
    setFilterGroup(filterGroup) {
        this.store.dispatch(new SetFilterGroup(filterGroup));
    }
    /**
     * Takes a filter group as the first parameter, and adds the filter in the second parameter to that group
     */
    addFilterToFilterGroups(filterGroupIdentifier, filter) {
        this.store.dispatch(new AddFilterToFilterGroups(filterGroupIdentifier, filter));
    }
    clearFilterGroupFilter(filterGroupIdentifier, filterKeyToClear) {
        this.store.dispatch(new ClearFilterGroupFilter(filterGroupIdentifier, filterKeyToClear));
    }
    clearFilterGroupFilters(filterGroupIdentifier) {
        this.store.dispatch(new ClearFilterGroupFilters(filterGroupIdentifier));
    }
    updateFilterGroupFilters(filterGroupIdentifier, filters) {
        this.store.dispatch(new UpdateFilterGroupFilters(filterGroupIdentifier, filters));
    }
    filterKeys$(filterKey) {
        return this.store.select(PlansState.filterKeys(filterKey));
    }
    getPharmacyFiltersByFilterGroup$(filterGroupIdentifier) {
        return this.store.select(PharmacyState.getFiltersByFilterGroup(filterGroupIdentifier));
    }
    getPharmacyFiltersByFilterGroup(filterGroupIdentifier) {
        return this.store.selectSnapshot(PharmacyState.getFiltersByFilterGroup(filterGroupIdentifier));
    }
    getPharmacyByFilterGroup$(filterGroupIdentifier) {
        return this.store.select(PharmacyState.getPharmacyByFilterGroup(filterGroupIdentifier));
    }
    clearPharmacyFilterGroupFilter(filterGroupIdentifier) {
        this.store.dispatch(new ClearPharmacyFilterGroupFilter(filterGroupIdentifier));
    }
    setPharmacyFilterGroup(filterGroup) {
        this.store.dispatch(new SetPharmacyFilterGroup(filterGroup));
    }
    addFilterToPharmacyFilterGroups(filterGroupIdentifier, filter) {
        this.store.dispatch(new AddFilterToPharmacyFilterGroups(filterGroupIdentifier, filter));
    }
    clearPharmacyFilterWithKey(filterGroupIdentifier, filterKeyToClear) {
        this.store.dispatch(new ClearPharmacyFilterWithKey(filterGroupIdentifier, filterKeyToClear));
    }
    addFilterToPlanSmartFilterGroups(filter, planYear) {
        this.store.dispatch(new AddFilterToPlanSmartFilterGroups(filter, planYear));
    }
    clearPlanSmartFilterGroupFilters(planYear) {
        this.store.dispatch(new ClearPlanSmartFilterGroupFilters(planYear));
    }
    clearPlanSmartFilterGroupWithKey(planYear, filterKeyToClear) {
        this.store.dispatch(new ClearPlanSmartFilterGroupWithKey(planYear, filterKeyToClear));
    }
    getPlanSmartFilterGroupFilters(planYear) {
        return this.store.selectSnapshot(PlansState.planSmartFilterGroup)?.[planYear]?.planSmartFilters || [];
    }
}
FilterService.ɵfac = function FilterService_Factory(t) { return new (t || FilterService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(ConfigResourceService)); };
FilterService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FilterService, factory: FilterService.ɵfac, providedIn: 'root' });
__decorate([
    MemoizeObservable()
], FilterService.prototype, "getPlansByFilterList$", null);
__decorate([
    MemoizeObservable()
], FilterService.prototype, "getPlansByFilterGroup$", null);
__decorate([
    MemoizeObservable()
], FilterService.prototype, "getPayloadByFilterGroup$", null);
__decorate([
    MemoizeObservable()
], FilterService.prototype, "getPlansByFilterAndSortGroup$", null);
__decorate([
    MemoizeObservable()
], FilterService.prototype, "hasSelectedFilters$", null);
__decorate([
    MemoizeObservable()
], FilterService.prototype, "getFiltersByFilterGroup$", null);
__decorate([
    MemoizeObservable()
], FilterService.prototype, "filterKeys$", null);
__decorate([
    MemoizeObservable()
], FilterService.prototype, "getPharmacyFiltersByFilterGroup$", null);
__decorate([
    MemoizeObservable()
], FilterService.prototype, "getPharmacyByFilterGroup$", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FilterService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }, { type: ConfigResourceService }]; }, { getPlansByFilterList$: [], getPlansByFilterGroup$: [], getPayloadByFilterGroup$: [], getPlansByFilterAndSortGroup$: [], hasSelectedFilters$: [], getFiltersByFilterGroup$: [], filterKeys$: [], getPharmacyFiltersByFilterGroup$: [], getPharmacyByFilterGroup$: [] }); })();

let FilterTab = class FilterTab {
    constructor(tabData, index) {
        this.title = tabData.title;
        this.showFilters = tabData.showFilters ?? true;
        this.defaultActive = tabData.defaultActive;
        this.secondaryDefaultActive = tabData.secondaryDefaultActive;
        this.tabError = {
            heading: tabData.errorHeading,
            body: tabData.errorBody
        };
        this.tabTypes = tabData.tabTypes;
        this.tabIndex = index;
        this.filters = [new Filter({ key: FilterKeyType.PLAN_TYPE_SHORT, values: tabData.tabTypes })];
        if (tabData.filters?.length > 0) {
            this.filters.push(...tabData.filters.map(filter => new Filter({ ...filter })));
        }
        if (tabData.sortList?.length > 0) {
            this.sortGroup = [
                {
                    groupKey: new Filter({ key: FilterKeyType.PLAN_TYPE_SHORT, values: tabData.tabTypes }),
                    sort: tabData.sortList[0],
                    isDirty: false
                }
            ];
            this.sortList = tabData.sortList;
        }
        else {
            this.sortGroup = [];
            this.sortList = [];
        }
        this.planTabEducationalText = tabData.planTabEducationalText;
        this.compareGroup = [
            {
                // Consider the tab's first type value as the main type
                groupKey: new Filter({ key: FilterKeyType.PLAN_TYPE_SHORT, values: [tabData.tabTypes[0]] }),
                items: []
            }
        ];
        this.quoteGroups = [
            {
                groupKey: new Filter({ key: FilterKeyType.PLAN_TYPE_SHORT, values: tabData.tabTypes }),
                items: []
            }
        ];
        if (tabData.benefits) {
            this.benefits = tabData.benefits;
        }
        if (tabData.benefitPreferences) {
            this.benefitPreferences = tabData.benefitPreferences;
        }
    }
};
FilterTab = __decorate([
    PlatformType
], FilterTab);

const AGENT_USERNAME_MAX_LENGTH = 50;
const AGENT_USERNAME_MIN_LENGTH = 6;
const AGENT_PASSWORD_MAX_LENGTH = 100;
const AGENT_PASSWORD_MIN_LENGTH = 8;
const CONSUMER_USERNAME_MAX_LENGTH = 20;
const CONSUMER_USERNAME_MIN_LENGTH = 6;
const CONSUMER_PASSWORD_MAX_LENGTH = 100;
const CONSUMER_PASSWORD_MIN_LENGTH = 8;
const API_FIELD_MAX_LENGTH = 255;
class FormValidationService {
    constructor(store, configResourceService) {
        this.store = store;
        this.configResourceService = configResourceService;
        this.alphaNumericPasswordPattern = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,100}$/;
        this.errorMessages = {
            requiredFirstName: () => this.configResourceService.getProcessedResourceValue('Spa_Form_RequiredError_FirstName', null, 'Please provide first name'),
            requiredEmail: () => this.configResourceService.getProcessedResourceValue('Spa_Form_RequiredError_Email', null, 'Please provide email address'),
            invalidEmail: () => this.configResourceService.getProcessedResourceValue('Spa_Form_InvalidError_Email', null, 'Please provide a valid email'),
            alreadyExistEmail: () => this.configResourceService.getProcessedResourceValue('Spa_Form_AlreadyExistError_Email', null, 'Email exists, please provide another'),
            requiredPassword: () => this.configResourceService.getProcessedResourceValue('Spa_Form_RequiredError_Password', null, 'Please provide a password'),
            minLengthPassword: () => this.configResourceService.getProcessedResourceValue('Spa_Form_MinLengthError_Password', null, 'Please provide a valid password'),
            requiredZipCode: () => this.configResourceService.getProcessedResourceValue('Spa_Form_RequiredError_ZipCode', null, 'Please provide a valid ZIP Code'),
            requiredPhone: () => this.configResourceService.getProcessedResourceValue('Spa_Form_RequiredError_Phone', null, 'Please provide phone number'),
            requiredCellPhone: () => this.configResourceService.getProcessedResourceValue('Spa_Form_RequiredError_CellPhone', null, 'Please provide phone number'),
            requiredPhoneExtension: () => this.configResourceService.getProcessedResourceValue('Spa_Form_RequiredError_Phone_Extension', null, 'Please provide Ext'),
            invalidPhone: () => this.configResourceService.getProcessedResourceValue('Spa_Form_InvalidError_Phone', null, 'Format is invalid. Re-enter phone number.'),
            invalidCellPhone: () => this.configResourceService.getProcessedResourceValue('Spa_Form_InvalidError_CellPhone', null, 'Format is invalid. Re-enter mobile phone number.'),
            minPhone: () => this.configResourceService.getProcessedResourceValue('Spa_Form_MinLengthError_Phone', null, 'Please provide 10 digits'),
            alreadyExistUsername: () => this.configResourceService.getProcessedResourceValue('Spa_Form_AlreadyExistError_Username', null, 'Username exist, please provide another'),
            requiredUsername: () => this.configResourceService.getProcessedResourceValue('Spa_Form_RequiredError_Username', null, 'Please provide username'),
            maxLengthNPN: () => this.configResourceService.getProcessedResourceValue('Spa_Form_MaxLengthError_NPN', null, 'Please provide valid NPN'),
            maxLengthAgentID: () => this.configResourceService.getProcessedResourceValue('Spa_Form_MaxLengthError_AgentID', null, 'Please provide valid AgentID'),
            requiredExpiryDate: () => this.configResourceService.getProcessedResourceValue('Spa_Form_RequiredError_ExpiryDate', null, 'Please provide expiry date'),
            invalidDate: () => this.configResourceService.getProcessedResourceValue('Spa_Form_RequiredError_Date', null, 'Please provide a valid date'),
            invalidDateOfBirth: () => this.configResourceService.getProcessedResourceValue('Spa_Member_Profile_NoBirthDateError_Text', null, 'Please provide a valid date of birth'),
            maxExpiryDate: () => this.configResourceService.getProcessedResourceValue('Spa_Form_MaxDateError_ExpiryDate', null, 'Please provide valid expiry date'),
            requiredState: () => this.configResourceService.getProcessedResourceValue('Spa_Form_RequiredError_State', null, 'Please specify state'),
            requiredCity: () => this.configResourceService.getProcessedResourceValue('Spa_Form_RequiredError_City', null, 'Please provide city'),
            requiredRole: () => this.configResourceService.getProcessedResourceValue('Spa_Form_RequiredError_Role', null, 'Role is not selected'),
            requiredAddress: () => this.configResourceService.getProcessedResourceValue('Spa_Form_RequiredError_Address', null, 'Please provide address'),
            minCharacters2: () => this.configResourceService.getProcessedResourceValue('Spa_Form_MinError_2Characters', null, 'Please provide minimum 2 characters'),
            minCharacters3: () => this.configResourceService.getProcessedResourceValue('Spa_Form_MinError_3Characters', null, 'Please provide minimum 3 characters'),
            noSpecialCharacters: () => this.configResourceService.getProcessedResourceValue('Spa_Form_PatternError_Input', null, 'Special characters are not allowed'),
            requiredLastName: () => this.configResourceService.getProcessedResourceValue('Spa_Form_RequiredError_lastName', null, 'Please provide last name'),
            soaFileSize: () => this.configResourceService.getProcessedResourceValue('Spa_Site_FileSize_Error', null, 'Please provide a file 5MB or smaller'),
            soaFileType: () => this.configResourceService.getProcessedResourceValue('Spa_SOA_FileType_Error', null, 'Please provide a file in pdf, jpg, gif, or png format.'),
            maxLengthFsr: () => this.configResourceService.getProcessedResourceValue('Spa_Form_FSR_Error', null, 'Please provide valid FSR'),
            maxLengthAgencyID: () => this.configResourceService.getProcessedResourceValue('Spa_Form_MaxLengthError_AgencyID', null, 'Please provide valid AgencyID'),
            maxLengthAgencyName: () => this.configResourceService.getProcessedResourceValue('Spa_Form_MaxLengthError_AgencyName', null, 'Please provide valid AgencyName'),
            agentPictureFileType: () => this.configResourceService.getProcessedResourceValue('Spa_Agent_Picture_FileType_Error', null, 'Please provide a file in jpg, gif, or png format.'),
            requiredASP: () => this.configResourceService.getProcessedResourceValue('Spa_Form_RequiredError_ASPRequired', null, 'Please specify selling permissions'),
            aspAllowAccessToAllPlanYearsRequired: () => this.configResourceService.getProcessedResourceValue('Spa_Form_RequiredError_AllowAccessToAllPlanYears', null, 'Field is required and not selected'),
            aspAgentPlanYearsRequired: () => this.configResourceService.getProcessedResourceValue('Spa_Form_RequiredError_AgentPlanYears', null, 'Field is required and not selected'),
            licenseNumber: () => this.configResourceService.getProcessedResourceValue('Spa_Form_RequiredError_LicenseNumber', null, 'Please provide a license number')
        };
    }
    static validateOnSubmit(wrappedValidatorFn, component, 
    // Skips the initial validation check during ngOnInit(). At that point, the ViewChild "ngFormInstance" isn't captured yet.
    skipInitialCheck = false) {
        const validatorFn = Array.isArray(wrappedValidatorFn) ? Validators.compose(wrappedValidatorFn) : wrappedValidatorFn;
        return (control) => {
            if ((!skipInitialCheck && !component.ngFormInstance) || component.ngFormInstance?.submitted) {
                // We check if validatorFn is defined before calling it because Validators.compose() could return null if the array of ValidatorFn is empty
                return validatorFn?.(control);
            }
            return null;
        };
    }
    /**
     * Creates a validation function to attach to your form that compares the two controls,
     * and adds a 'valueMismatch' error to the second field if they are not equal
     * @param controlName1 name of the first control to be compared
     * @param controlName2 name of the second control to be compared
     *
     * @returns the validator function to attach to your form
     */
    getMatchFieldsValidator(controlName1, controlName2) {
        return (control) => {
            if (!control.get(controlName1) || !control.get(controlName2)) {
                // This will only happen if a developer gives incorrect input names, either through a typo or incorrect dynamic generation
                // Because we cannot properly run the validator, the form will be considered valid and continue as such.
                return {};
            }
            if (control.get(controlName1).value !== control.get(controlName2).value) {
                control.get(controlName2).setErrors({ valueMismatch: true });
                return { invalid: true };
            }
        };
    }
    // logging in and validation are tied together because of this we need to grab the value from the store to validate.
    validAgentLogin() {
        return (control) => {
            const loginError = this.store.selectSnapshot(AgentState.loginError);
            if (loginError === AgentError.INVALID_CREDENTIALS) {
                return { invalidLogin: true };
            }
            if (loginError === AgentError.MAX_ATTEMPTS) {
                return { maxAttempts: true };
            }
            return null;
        };
    }
    validDate() {
        return (control) => {
            if (control.value && control.dirty && !DateUtilities.isValidDate(control.value)) {
                return { invalidDate: true };
            }
            return null;
        };
    }
    minDate(options) {
        return (control) => {
            const { minDate, dateControl } = options;
            const dates = [dateControl?.value, minDate].filter(date => date && DateUtilities.isValidDate(date));
            let result = null;
            if (control.value && control.dirty && DateUtilities.isDateBeforeSome(control.value, dates)) {
                result = { minDate: true };
            }
            return result;
        };
    }
    maxDate(options) {
        return (control) => {
            const { maxDate, dateControl } = options;
            const dates = [dateControl?.value, maxDate].filter(date => date && DateUtilities.isValidDate(date));
            let result = null;
            if (control.value && control.dirty && DateUtilities.isDateAfterSome(control.value, dates)) {
                result = { maxDate: true };
            }
            return result;
        };
    }
    dateRange(options) {
        return (control) => {
            const { maxAllowedDays, dateControl, order = 'asc' } = options;
            const pastDateControl = order === 'asc' ? control : dateControl;
            const futureDateControl = order === 'asc' ? dateControl : control;
            let result = null;
            if (pastDateControl.value &&
                pastDateControl.dirty &&
                DateUtilities.isValidDate(pastDateControl.value) &&
                futureDateControl.value &&
                futureDateControl.dirty &&
                DateUtilities.isValidDate(futureDateControl.value) &&
                // We evaluate if it's equal because we should take into account the first day of the range that results in a difference of 0.
                // For example: the result of the difference for the range 07/01/2021 and 07/01/2021 is 0, but it counts as 1 day selected.
                DateUtilities.getDaysDifference(pastDateControl.value, futureDateControl.value) >= maxAllowedDays) {
                result = { dateOutOfRange: true };
            }
            return result;
        };
    }
}
FormValidationService.phoneMask = '(000) 000-0000';
FormValidationService.phoneExtensionMask = '000000000';
FormValidationService.dateMask = '00/00/0000';
FormValidationService.socialSecurityNumberMask = '000-00-0000';
FormValidationService.emailPattern = new RegExp(RegexPattern.EMAIL);
FormValidationService.nonWhiteSpacePattern = /\S+/;
FormValidationService.alphaNumericPattern = /^[a-zA-Z0-9]*$/;
FormValidationService.nonAlphaNumericPattern = /[^a-zA-Z0-9]+/;
FormValidationService.nonAlphaNumericPatternWithSpace = /[^a-zA-Z0-9 ]+/;
FormValidationService.phoneNumberPattern = /^[0-9]{10}$/;
FormValidationService.ɵfac = function FormValidationService_Factory(t) { return new (t || FormValidationService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(ConfigResourceService)); };
FormValidationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FormValidationService, factory: FormValidationService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormValidationService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }, { type: ConfigResourceService }]; }, null); })();

const GOOGLE_TAG_MANAGER = 'googleTagManager';
class GoogleTagManagerResolver {
    constructor(navigationService, store, navigationUtilityService) {
        this.navigationService = navigationService;
        this.store = store;
        this.navigationUtilityService = navigationUtilityService;
    }
    // This resolve function will add the google tag manager campaign tags to the url if it is the home page, the
    // url does not contain any query params, and there are campaign tags saved in the deep linking state.
    async resolve(route) {
        const path = this.navigationUtilityService.getPath(route);
        const page = this.store.selectSnapshot(AppConfigState.page(path));
        if (page?.tags?.includes(PageTags.HOME)) {
            const utmSource = this.store.selectSnapshot(DeepLinkingParamsState.utmSource);
            const utmMedium = this.store.selectSnapshot(DeepLinkingParamsState.utmMedium);
            const utmCampaign = this.store.selectSnapshot(DeepLinkingParamsState.utmCampaign);
            const utmContent = this.store.selectSnapshot(DeepLinkingParamsState.utmContent);
            if (Object.keys(route.queryParams).length === 0 && (utmSource || utmMedium || utmCampaign || utmContent)) {
                this.navigationService.navigateByPageTag(PageTags.HOME, {
                    queryParams: {
                        ...(utmSource && { [UTMParameter.UTM_SOURCE]: utmSource }),
                        ...(utmMedium && { [UTMParameter.UTM_MEDIUM]: utmMedium }),
                        ...(utmCampaign && { [UTMParameter.UTM_CAMPAIGN]: utmCampaign }),
                        ...(utmContent && { [UTMParameter.UTM_CONTENT]: utmContent })
                    }
                });
            }
        }
    }
}
GoogleTagManagerResolver.ɵfac = function GoogleTagManagerResolver_Factory(t) { return new (t || GoogleTagManagerResolver)(i0.ɵɵinject(NavigationService), i0.ɵɵinject(i1.Store), i0.ɵɵinject(NavigationUtilityService)); };
GoogleTagManagerResolver.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: GoogleTagManagerResolver, factory: GoogleTagManagerResolver.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GoogleTagManagerResolver, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: NavigationService }, { type: i1.Store }, { type: NavigationUtilityService }]; }, null); })();

class GuidedHelpModalContextService {
    constructor() {
        this._openModal$ = new Subject();
    }
    openGuidedHelpModal$() {
        return this._openModal$.asObservable();
    }
    openGuidedHelpModal(pageTag) {
        this._openModal$.next(pageTag);
    }
}
GuidedHelpModalContextService.ɵfac = function GuidedHelpModalContextService_Factory(t) { return new (t || GuidedHelpModalContextService)(); };
GuidedHelpModalContextService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: GuidedHelpModalContextService, factory: GuidedHelpModalContextService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GuidedHelpModalContextService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

var SSODeliveryMethod;
(function (SSODeliveryMethod) {
    SSODeliveryMethod["NONE"] = "0";
    SSODeliveryMethod["EMAIL"] = "1";
    SSODeliveryMethod["PHONE"] = "2";
    SSODeliveryMethod["EMAIL_AND_PHONE"] = "3";
})(SSODeliveryMethod || (SSODeliveryMethod = {}));

class AgentPlanPermissionsRequest {
}

class SetDefaultApplicationState {
    constructor(state) {
        this.state = state;
    }
}
SetDefaultApplicationState.type = '[Live Edit] Set Default Application State';
class SelectLiveEditState {
    constructor(selectedState) {
        this.selectedState = selectedState;
    }
}
SelectLiveEditState.type = '[Live Edit] Select State';

class LiveEditStateValue {
}
class LiveEditApplicationState {
}
class LiveEditStoreOverride {
}
class LiveEditPageState {
}

class LiveEditStateModel {
}
const LIVE_EDIT_DEFAULTS = {
    defaultApplicationState: null,
    selectedState: null
};
const LIVE_EDIT_STORE_NAME = 'liveEdit';
let LiveEditState = class LiveEditState {
    static defaultApplicationState(state) {
        return state.defaultApplicationState;
    }
    static selectedLiveEditState(state) {
        return state.selectedState;
    }
    setDefaultApplicationState(ctx, { state }) {
        ctx.patchState({ defaultApplicationState: state });
    }
    selectLiveEditState(ctx, { selectedState }) {
        ctx.patchState({ selectedState });
    }
};
LiveEditState.ɵfac = function LiveEditState_Factory(t) { return new (t || LiveEditState)(); };
LiveEditState.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LiveEditState, factory: LiveEditState.ɵfac });
__decorate([
    Action(SetDefaultApplicationState)
], LiveEditState.prototype, "setDefaultApplicationState", null);
__decorate([
    Action(SelectLiveEditState)
], LiveEditState.prototype, "selectLiveEditState", null);
__decorate([
    Selector()
], LiveEditState, "defaultApplicationState", null);
__decorate([
    Selector()
], LiveEditState, "selectedLiveEditState", null);
LiveEditState = __decorate([
    State({
        name: LIVE_EDIT_STORE_NAME,
        defaults: LIVE_EDIT_DEFAULTS
    })
], LiveEditState);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LiveEditState, [{
        type: Injectable
    }], null, { setDefaultApplicationState: [], selectLiveEditState: [] }); })();

class ConsumerSiteUrl {
}
class SiteStateModel {
}

class UserPreferences {
}

class GuidedHelpService {
    constructor(navigationService, configResourceService, store, responsiveLayoutService, router, demographicService, drugFrequencyFacade, googleTagManagerService, siteService) {
        this.navigationService = navigationService;
        this.configResourceService = configResourceService;
        this.store = store;
        this.responsiveLayoutService = responsiveLayoutService;
        this.router = router;
        this.demographicService = demographicService;
        this.drugFrequencyFacade = drugFrequencyFacade;
        this.googleTagManagerService = googleTagManagerService;
        this.siteService = siteService;
        this.guidedHelpEnabled = this.configResourceService.getProcessedResourceValue('Spa_GuidedHelp_Enabled', null, true);
        this.coverageTypeEnabled = this.getProcessedResourceValue('Spa_GuidedHelp_GettingStarted_Coverage_Enabled', true);
        this.tabs = this.getProcessedResourceValue('Spa_PlanList_Tabs_Data', null);
        this.otherPreferencesEnabled = this.getProcessedResourceValue('Spa_Site_OtherPreferences_Enabled', false);
        this.preferencesTitle = this.configResourceService.getProcessedResourceValue('Spa_Site_OtherPreferences_Text', null, 'Other preferences');
        this.GUIDED_HELP_DEFAULTS = [
            {
                enabled: this.configResourceService.getProcessedResourceValue('Spa_Site_GetStarted_Enabled', null, true),
                resourceKeyName: 'Spa_Site_GetStarted_Text',
                title: this.configResourceService.getProcessedResourceValue('Spa_Site_GetStarted_Text', null, 'Get started'),
                class: 'Spa_Style_Note',
                status: GuidedHelpLinkStatus.CLEAN,
                iconClass: 'Spa_Style_GettingStartedIcon',
                pageTag: PageTags.GUIDED_HELP_GETTING_STARTED,
                selectedIconColor: 'Spa_Style_Accent1_Color'
            },
            {
                enabled: this.configResourceService.getProcessedResourceValue('Spa_Site_Health_Enabled', null, true),
                resourceKeyName: 'Spa_Site_Health_Text',
                title: this.configResourceService.getProcessedResourceValue('Spa_Site_Health_Text', null, 'Health'),
                bodyText: this.configResourceService.getProcessedResourceValue('Spa_Site_Health_Body_Text', null, 'This will be used to calculate your estimated costs and will not affect your premiums'),
                class: 'Spa_Style_Note',
                status: GuidedHelpLinkStatus.CLEAN,
                pageTag: PageTags.GUIDED_HELP_HEALTH,
                iconClass: 'Spa_Style_HealthIcon',
                selectedIconColor: 'Spa_Style_Accent2_Color'
            },
            {
                enabled: this.configResourceService.getProcessedResourceValue('Spa_Site_Providers_Enabled', null, false),
                resourceKeyName: 'Spa_Site_Providers_Text',
                title: this.configResourceService.getProcessedResourceValue('Spa_Site_Providers_Text', null, 'Providers'),
                bodyText: this.configResourceService.getProcessedResourceValue('Spa_Site_Providers_Body_Text', null, `See which plans cover your doctor, specialist, urgent care or hospital. Reference the plan's Medical Provider Directory to see up-to-date network information.`),
                class: 'Spa_Style_Note',
                status: GuidedHelpLinkStatus.CLEAN,
                pageTag: PageTags.GUIDED_HELP_PROVIDER_SEARCH,
                iconClass: 'Spa_Style_ProvidersIcon',
                selectedIconColor: 'Spa_Style_Accent3_Color '
            },
            {
                enabled: this.configResourceService.getProcessedResourceValue('Spa_Site_Prescriptions_Enabled', null, true),
                resourceKeyName: 'Spa_Site_Prescriptions_Text',
                title: this.configResourceService.getProcessedResourceValue('Spa_Site_Prescriptions_Text', null, 'Prescriptions'),
                class: 'Spa_Style_Note',
                status: GuidedHelpLinkStatus.CLEAN,
                pageTag: PageTags.GUIDED_HELP_PRESCRIPTIONS,
                iconClass: 'Spa_Style_PrescriptionsIcon',
                selectedIconColor: 'Spa_Style_Accent4_Color'
            },
            {
                enabled: this.configResourceService.getProcessedResourceValue('Spa_Site_Pharmacy_Enabled', null, true),
                resourceKeyName: 'Spa_Site_Pharmacy_Text',
                title: this.configResourceService.getProcessedResourceValue('Spa_Site_Pharmacy_Text', null, 'Pharmacy'),
                class: 'Spa_Style_Note',
                status: GuidedHelpLinkStatus.CLEAN,
                pageTag: PageTags.GUIDED_HELP_PHARMACY_SEARCH,
                iconClass: 'Spa_Style_PharmacyIcon',
                selectedIconColor: 'Spa_Style_Accent5_Color'
            },
            {
                enabled: this.configResourceService.getProcessedResourceValue('Spa_Site_OtherPreferences_Enabled', null, false),
                resourceKeyName: 'Spa_Site_OtherPreferences_Text',
                title: this.configResourceService.getProcessedResourceValue('Spa_Site_OtherPreferences_Text', null, 'Other preferences'),
                class: 'Spa_Style_Note',
                status: GuidedHelpLinkStatus.CLEAN,
                iconClass: 'Spa_Style_OtherPreferencesIcon',
                pageTag: PageTags.GUIDED_HELP_OTHER_PREFERENCES,
                selectedIconColor: 'Spa_Style_Accent7_Color'
            }
        ];
        this.setDefaultValuesForNavigationLinks();
    }
    get isMobile$() {
        return this.responsiveLayoutService.isCompact$;
    }
    get isMedium$() {
        return this.responsiveLayoutService.isMedium$;
    }
    get links() {
        return this.store.selectSnapshot(UiState.guidedHelpLinks);
    }
    get isLastMedicalNavigationLink() {
        const linksBasedOnCoverage = this.otherPreferencesEnabled
            ? this.links.filter(link => this.medicalOnlyPages(link))
            : this.links.filter(link => this.medicalOnlyPages(link) && link.title !== this.preferencesTitle);
        const lastLink = linksBasedOnCoverage[linksBasedOnCoverage.length - 1];
        const selectedLink = linksBasedOnCoverage.find(link => link.status === GuidedHelpLinkStatus.SELECTED);
        return selectedLink && lastLink.title === selectedLink.title;
    }
    get isLastNavigationLink() {
        const linksBasedOnCoverage = this.otherPreferencesEnabled
            ? this.links
            : this.links.filter(link => link.title !== this.preferencesTitle);
        const lastLink = linksBasedOnCoverage[linksBasedOnCoverage.length - 1];
        const selectedLink = linksBasedOnCoverage.find(link => link.status === GuidedHelpLinkStatus.SELECTED);
        return selectedLink && lastLink.title === selectedLink.title;
    }
    get isLastPhysicalLink() {
        const linksBasedOnCoverage = this.links;
        const lastLink = linksBasedOnCoverage[linksBasedOnCoverage.length - 1];
        const selectedLink = linksBasedOnCoverage.find(link => link.status === GuidedHelpLinkStatus.SELECTED);
        return selectedLink && lastLink.title === selectedLink.title;
    }
    get ageGroups() {
        return [
            {
                display: null,
                value: GuidedHelpAgeSelection.MEMBER_AGE_UNDER_65,
                selected: false,
                ageRange: [0, 64],
                label: this.getProcessedResourceValue('Spa_GuidedHelp_Health_AgeValue1_Text', 'Under 65')
            },
            {
                display: null,
                value: GuidedHelpAgeSelection.MEMBER_AGE_65_69,
                selected: false,
                ageRange: [65, 69],
                label: this.getProcessedResourceValue('Spa_GuidedHelp_Health_AgeValue2_Text', '65-69')
            },
            {
                display: null,
                value: GuidedHelpAgeSelection.MEMBER_AGE_70_74,
                selected: false,
                ageRange: [70, 74],
                label: this.getProcessedResourceValue('Spa_GuidedHelp_Health_AgeValue3_Text', '70-74')
            },
            {
                display: null,
                value: GuidedHelpAgeSelection.MEMBER_AGE_75_79,
                selected: false,
                ageRange: [75, 79],
                label: this.getProcessedResourceValue('Spa_GuidedHelp_Health_AgeValue4_Text', '75-79')
            },
            {
                display: null,
                value: GuidedHelpAgeSelection.MEMBER_AGE_80_84,
                selected: false,
                ageRange: [80, 84],
                label: this.getProcessedResourceValue('Spa_GuidedHelp_Health_AgeValue5_Text', '80-84')
            },
            {
                display: null,
                value: GuidedHelpAgeSelection.MEMBER_AGE_85_OVER,
                selected: false,
                ageRange: [85, 200],
                label: this.getProcessedResourceValue('Spa_GuidedHelp_Health_AgeValue6_Text', '85+')
            }
        ];
    }
    get healthStatusGroup() {
        return [
            {
                value: GuidedHelpHealthStatus.MEMBER_HEALTH_GOOD,
                text: this.getProcessedResourceValue('Spa_GuidedHelp_Health_SliderHeader1_Text', 'Generally healthy')
            },
            {
                value: GuidedHelpHealthStatus.MEMBER_HEALTH_FAIR,
                text: this.getProcessedResourceValue('Spa_GuidedHelp_Health_SliderHeader2_Text', 'Some health needs')
            },
            {
                value: GuidedHelpHealthStatus.MEMBER_HEALTH_POOR,
                text: this.getProcessedResourceValue('Spa_GuidedHelp_Health_SliderHeader3_Text', 'Significant health needs')
            }
        ];
    }
    get subsidyItems() {
        return [
            {
                title: this.getProcessedResourceValue('Spa_GettingStarted_SubsidyMedicaid_Text', 'I receive help from Medicaid'),
                id: SubsidySelected.MEDICAID
            },
            {
                title: this.getProcessedResourceValue('Spa_GettingStarted_SubsidySSI_Text', 'I get supplemental security income'),
                id: SubsidySelected.SSI
            },
            {
                title: this.getProcessedResourceValue('Spa_GettingStarted_SubsidyMSP_Text', 'I belong to a Medicare Savings Program (MSP)'),
                id: SubsidySelected.MSP
            },
            {
                title: this.getProcessedResourceValue('Spa_GettingStarted_SubsidyFull_Text', 'I applied and got full help through social security'),
                id: SubsidySelected.FULL
            },
            {
                title: this.getProcessedResourceValue('Spa_GettingStarted_SubsidyPartial_Text', 'I applied for and got partial help through social security'),
                id: SubsidySelected.PARTIAL
            },
            {
                title: this.getProcessedResourceValue('Spa_GettingStarted_SubsidyNone_Text', 'No, I am not eligible for special assistance'),
                id: SubsidySelected.NONE
            },
            {
                title: this.getProcessedResourceValue('Spa_GettingStarted_SubsidyDontKnow_Text', `I don't know`),
                id: SubsidySelected.DONT_KNOW
            }
        ];
    }
    getLinks$() {
        return this.store.select(UiState.guidedHelpLinks);
    }
    getAgeRangeByDateOfBirth(birthdate) {
        if (birthdate) {
            const age = DateUtilities.getAge(birthdate);
            const ageRangeFromDOB = this.ageGroups.find(group => this.isBetween(age, group.ageRange[0], group.ageRange[1]));
            // only return a value if its a valid age range.
            if (ageRangeFromDOB) {
                this.setAgeRange(ageRangeFromDOB.value);
                return ageRangeFromDOB.value;
            }
        }
    }
    getAgeRangeDefault() {
        // if health is enabled, use the value the key value for the default, if not use 6 always.
        const healthEnabled = this.getProcessedResourceValue('Spa_Site_Health_Enabled', true);
        let ageRange;
        if (healthEnabled) {
            ageRange = this.getProcessedResourceValue('Spa_GuidedHelp_Health_AgeDefault_Number', GuidedHelpAgeSelection.MEMBER_AGE_65_69);
            this.setAgeRange(ageRange);
            return ageRange;
        }
        ageRange = GuidedHelpAgeSelection.MEMBER_AGE_UNDER_65;
        this.setAgeRange(ageRange);
        return ageRange;
    }
    setDefaultValuesForNavigationLinks() {
        const enabledStoreLinkNames = this.links.filter(navigationLink => navigationLink.enabled).map(link => link.resourceKeyName);
        const enabledResourceLinkNames = this.GUIDED_HELP_DEFAULTS.filter(navigationLink => navigationLink.enabled).map(link => link.resourceKeyName);
        // if store is empty or resource values changed, update store
        const updateStore = enabledStoreLinkNames.length !== enabledResourceLinkNames.length ||
            !enabledResourceLinkNames.every(resourceLink => enabledStoreLinkNames.includes(resourceLink));
        if (updateStore) {
            const enabledLinks = this.GUIDED_HELP_DEFAULTS.filter(navigationLink => navigationLink.enabled);
            this.store.dispatch(new SetGuidedHelpNavigationLinks(enabledLinks));
        }
    }
    setAgeRange(ageRange) {
        this.store.dispatch(new SetAgeRange(ageRange));
        this.store.dispatch(new SetPlansDirty(true));
        this.updateMemberPreferenceAgeAnalytics(ageRange);
    }
    dirtyGuidedHelpPlanTypes() {
        this.store.dispatch(new SetPlansDirty(true, ALL_MEDICARE_PLUS_MEDIGAP_PLAN_TYPE_VALUES));
    }
    updateMemberPreferenceAgeAnalytics(ageRange) {
        const memberPreferenceAgeAnalyticsValue = this.getMemberPreferenceAgeAnalyticsValue(ageRange);
        this.googleTagManagerService.setGoogleDataLayerTag(DataLayerGlobalVariable.MEMBER_PREF_AGE, memberPreferenceAgeAnalyticsValue);
    }
    getMemberPreferenceAgeAnalyticsValue(ageRange) {
        switch (ageRange) {
            case 6:
                return '1';
            case 5:
                return '2';
            case 4:
                return '3';
            case 3:
                return '4';
            case 2:
                return '5';
            case 1:
                return '6';
            default:
                return null;
        }
    }
    updateGuidedHelpLink(selectedLink) {
        const updatedLinks = this.links.map(link => {
            if (link.status === GuidedHelpLinkStatus.SELECTED && selectedLink.title !== link.title) {
                return { ...link, status: GuidedHelpLinkStatus.DIRTY };
            }
            if (selectedLink.title === link.title) {
                return { ...link, status: GuidedHelpLinkStatus.SELECTED };
            }
            return link;
        });
        this.store.dispatch(new SetGuidedHelpNavigationLinks(updatedLinks));
        this.navigateByPageTag(selectedLink.pageTag);
    }
    navigateByPageTag(pageTag) {
        this.navigationService.navigateByPageTag(pageTag);
    }
    setNavigationLinks(helpNavigationLinks) {
        this.store.dispatch(new SetGuidedHelpNavigationLinks(helpNavigationLinks));
    }
    onPageLoad() {
        this.setDefaultValuesForNavigationLinks();
        const currentPage = this.getCurrentPage(this.router.url);
        const currentTag = currentPage.tags[0];
        const updatedGuidedHelpLinks = this.links.map(link => {
            if (link.pageTag === currentTag) {
                return { ...link, status: GuidedHelpLinkStatus.SELECTED };
            }
            if (link.status === GuidedHelpLinkStatus.SELECTED) {
                return { ...link, status: GuidedHelpLinkStatus.DIRTY };
            }
            return link;
        });
        let modifiedLinks;
        if (!this.getProcessedResourceValue('Spa_Site_TotalEstimatedCost_Enabled', true)) {
            modifiedLinks = updatedGuidedHelpLinks.filter(link => link.title !== GuidedHelpSections.HEALTH);
        }
        else {
            modifiedLinks = updatedGuidedHelpLinks.filter(link => link.enabled);
        }
        this.store.dispatch(new SetGuidedHelpNavigationLinks(modifiedLinks));
        this.store.dispatch(new SetVisited());
    }
    goToFirstLink() {
        const firstLink = this.links[0];
        if (firstLink) {
            this.navigateByPageTag(firstLink.pageTag);
        }
        else {
            this.navigateByPageTag(PageTags.PLAN_LIST);
        }
    }
    goToNextLink(useMedicalLinks = true, checkForPreferenceQuestions = true) {
        let nextLinks;
        if (useMedicalLinks) {
            nextLinks = this.links.filter(link => this.medicalOnlyPages(link));
        }
        else {
            nextLinks = this.links;
        }
        const prescriptionDrug = CoverageType.PRESCRIPTION_DRUG;
        if (this.coverageType() === prescriptionDrug) {
            nextLinks = nextLinks.filter(link => link.pageTag !== PageTags.GUIDED_HELP_HEALTH && link.pageTag !== PageTags.GUIDED_HELP_PROVIDER_SEARCH);
        }
        if (checkForPreferenceQuestions) {
            nextLinks = this.otherPreferencesEnabled ? nextLinks : nextLinks.filter(link => link.title !== this.preferencesTitle);
        }
        let selectedIndex = nextLinks.findIndex(link => link.status === GuidedHelpLinkStatus.SELECTED);
        if (selectedIndex === -1) {
            nextLinks = this.links;
            selectedIndex = nextLinks.findIndex(link => link.status === GuidedHelpLinkStatus.SELECTED);
        }
        const tag = nextLinks[selectedIndex + 1]
            ? nextLinks[selectedIndex + 1].pageTag
            : this.siteService.isRetentionView()
                ? this.getRetentionDefaultPageTag()
                : this.siteService.isQuotingSite()
                    ? this.siteService.getQuoteSummaryRedirectPage()
                    : PageTags.PLAN_LIST;
        this.navigateByPageTag(tag);
    }
    // all the different conditions determine what pages the next or skip button should be allowed to choose from
    medicalOnlyPages(link) {
        return this._medicalOnlyPages(link.pageTag, this.coverageTypeEnabled, this.coverageType());
    }
    goToPreviousLink() {
        this.navigationService.backToPrevious();
    }
    getProcessedResourceValue(resourceName, defaultValue, widgetName = null) {
        return this.configResourceService.getProcessedResourceValue(resourceName, widgetName, defaultValue);
    }
    selectCoverageType(coverageType, medicalOnlyDefault) {
        this.store.dispatch(new SetCoverageType(coverageType));
        this.updateMemberPreferenceCoverageAnalytics(coverageType);
        this.dirtyGuidedHelpPlanTypes();
        const tabToSelect = this.coverageTypeToTab(coverageType, medicalOnlyDefault);
        if (tabToSelect) {
            this.store.dispatch(new SetActiveTab(tabToSelect));
        }
    }
    updateMemberPreferenceCoverageAnalytics(coverageType) {
        const memberPreferenceCoverageAnalyticsValue = this.getMemberPreferenceCoverageAnalyticsValue(coverageType);
        this.googleTagManagerService.setGoogleDataLayerTag(DataLayerGlobalVariable.MEMBER_PREF_COVERAGE, memberPreferenceCoverageAnalyticsValue);
        if (memberPreferenceCoverageAnalyticsValue === 'MA' &&
            !!this.googleTagManagerService.googleDataLayerTags[DataLayerGlobalVariable.MEMBER_PREF_SUBSIDY]) {
            this.googleTagManagerService.setGoogleDataLayerTag(DataLayerGlobalVariable.MEMBER_PREF_SUBSIDY, '');
        }
    }
    getMemberPreferenceCoverageAnalyticsValue(coverageType) {
        switch (coverageType) {
            case CoverageType.MEDICAL_ONLY:
                return 'MA';
            case CoverageType.PRESCRIPTION_DRUG:
                return 'PDP';
            case CoverageType.MEDICAL_AND_PRESCRIPTION_DRUG:
                return 'MAPD';
            case CoverageType.I_DONT_KNOW:
                return 'IDK';
            default:
                return null;
        }
    }
    updateMemberPreferencesHealthAnalytics(healthStatus) {
        const memberPreferencesHealthAnalyticsValue = this.getMemberPreferencesHealthAnalyticsValue(healthStatus);
        this.googleTagManagerService.setGoogleDataLayerTag(DataLayerGlobalVariable.MEMBER_PREF_HEALTH, memberPreferencesHealthAnalyticsValue);
    }
    getMemberPreferencesHealthAnalyticsValue(healthStatus) {
        switch (healthStatus) {
            case GuidedHelpHealthStatus.MEMBER_HEALTH_GOOD:
                return '1';
            case GuidedHelpHealthStatus.MEMBER_HEALTH_FAIR:
                return '2';
            case GuidedHelpHealthStatus.MEMBER_HEALTH_POOR:
                return '3';
            default:
                return null;
        }
    }
    updateMemberPreferenceSubsidyAnalytics(id) {
        const memberPreferenceSubsidyAnalyticsValue = this.getMemberPreferenceSubsidyAnalyticsValue(id);
        this.googleTagManagerService.setGoogleDataLayerTag(DataLayerGlobalVariable.MEMBER_PREF_SUBSIDY, memberPreferenceSubsidyAnalyticsValue);
    }
    getMemberPreferenceSubsidyAnalyticsValue(id) {
        if (id === undefined || id === null) {
            return null;
        }
        switch (id) {
            case SubsidySelected.MEDICAID:
                return 'Medicaid';
            case SubsidySelected.SSI:
                return 'SuppIncome';
            case SubsidySelected.MSP:
                return 'MSP';
            case SubsidySelected.FULL:
                return 'SS-Full';
            case SubsidySelected.DONT_KNOW:
                return 'IDK';
            case SubsidySelected.NONE:
                return 'NotEligible';
            case SubsidySelected.PARTIAL:
                return 'SS-Partial';
            default:
                return `SS-${id}`;
        }
    }
    selectZip(fips, zip) {
        this.demographicService.selectLocation(fips, zip);
    }
    updateDemographicSession() {
        this.demographicService.updateDemographicSession();
    }
    getAgeRangeText() {
        const ageGroup = this.ageGroups.find(range => range.value === this.store.selectSnapshot(DemographicState.ageRange));
        return ageGroup ? ageGroup.label : null;
    }
    getHealthStatusText() {
        const healthStatusText = this.healthStatusGroup.find(health => health.value === this.getHealthStatus());
        return healthStatusText ? healthStatusText.text : null;
    }
    getSubsidyAndPercentText(subsidyLabel) {
        const subsidyText = this.subsidyItems.find(item => item.id === this.getSubsidySelected());
        if (subsidyText) {
            if (this.getSubsidySelected() === SubsidySelected.PARTIAL) {
                const subsidyPercent = this.getSubsidyPercent();
                return `${subsidyLabel} ${subsidyText.title}: ${subsidyPercent}%`;
            }
            return `${subsidyLabel} ${subsidyText.title}`;
        }
    }
    getSubsidySelected() {
        return this.store.selectSnapshot(DemographicState.subsidySelected);
    }
    getSubsidyPercent() {
        return this.store.selectSnapshot(DemographicState.subsidyPercent);
    }
    getHealthStatus() {
        return this.store.selectSnapshot(DemographicState.healthStatus);
    }
    coverageType$() {
        if (EnvironmentService.getEnvironment().liveedit) {
            return of(CoverageType.MEDICAL_AND_PRESCRIPTION_DRUG);
        }
        return this.store.select(GuidedHelpState.selectedCoverageType);
    }
    coverageType() {
        return this.store.selectSnapshot(GuidedHelpState.selectedCoverageType);
    }
    getSelectedZipCode() {
        return this.demographicService.getSelectedZipCode();
    }
    getSelectedFipsCode() {
        return this.demographicService.getSelectedFipsCode();
    }
    getMedicineCabinet() {
        return this.store.selectSnapshot(MedicineCabinetState.medicineCabinet);
    }
    getMedicineCabinet$() {
        return this.store.select(MedicineCabinetState.medicineCabinet);
    }
    getSelectedPharmacy() {
        return this.store.selectSnapshot(PharmacyState.selectedPharmacy);
    }
    getSelectedPharmacy$() {
        return this.store.select(PharmacyState.selectedPharmacy);
    }
    getSelectedPharmacies$() {
        return this.store.select(PharmacyState.selectedPharmacies);
    }
    getPrimaryPharmacy$() {
        return this.store.select(PharmacyState.primaryPharmacy);
    }
    getHasVisited() {
        return this.store.selectSnapshot(GuidedHelpState.hasVisited);
    }
    getHasVisited$() {
        return this.store.select(GuidedHelpState.hasVisited);
    }
    getDOBFromMedSup() {
        return this.store.selectSnapshot(MedSupState.formField('DateOfBirth'));
    }
    getDOBFromAccount() {
        return this.store.selectSnapshot(DemographicState.birthdate);
    }
    getSelectedProviders$() {
        return this.store.select(ProviderState.selectedProviders);
    }
    getSelectedProviders() {
        return this.store.selectSnapshot(ProviderState.selectedProviders);
    }
    isGuidedHelpDirty() {
        return this.store.selectSnapshot(GuidedHelpState.isDirty);
    }
    setGuidedHelpDirty(dirty) {
        this.store.dispatch(new SetGuidedHelpDirty(dirty));
    }
    rehydrateGuidedHelpVisitedStatus() {
        // Check if it appears we have visited guided help in a prior session.
        // Note: Guided help visitation is not stored in session on the backend.
        if (!this.getHasVisited() && this.getGuidedHelpHasValues()) {
            this.store.dispatch(new SetVisited());
        }
    }
    getGuidedHelpHasValues() {
        return (!!this.getHealthStatus() ||
            !!this.coverageType() ||
            this.getMedicineCabinet().length > 0 ||
            !!this.getSelectedPharmacy() ||
            this.getSelectedProviders().length > 0);
    }
    updateZipAndFipsForGuidedHelp() {
        const zip = this.getSelectedZipCode();
        const fips = this.getSelectedFipsCode();
        if (zip && fips) {
            this.selectZip(fips, zip);
            this.updateDemographicSession();
        }
    }
    getRetentionDefaultPageTag() {
        return this.siteService.getRetentionSummaryRedirectPage();
    }
    getSelectedLink() {
        const currentPage = this.getCurrentPage(this.router.url);
        const currentTag = currentPage?.tags?.length ? currentPage.tags[0] : '';
        return this.links.find(link => link && link.pageTag === currentTag);
    }
    getMapDefaultColorAccent(isBackground) {
        return isBackground ? GuidedHelpMapStyleEnum.Spa_Style_Accent3_Background : GuidedHelpMapStyleEnum.Spa_Style_Accent3_Color;
    }
    getMapSelectedColorAccent(isBackground) {
        return isBackground ? GuidedHelpMapStyleEnum.Spa_Style_Accent2_Background : GuidedHelpMapStyleEnum.Spa_Style_Accent2_Color;
    }
    getMapPreferredColorAccent(isBackground) {
        return isBackground ? GuidedHelpMapStyleEnum.Spa_Style_Accent5_Background : GuidedHelpMapStyleEnum.Spa_Style_Accent5_Color;
    }
    getPrimaryPinIcon() {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Primary_Pin_Icon', null, 'fas fa-star');
    }
    getPrimaryPinIconColor() {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Primary_Pin_Icon_Color', null, '#b07d0f');
    }
    setIsHealthCostEstimateSelected(isSelected) {
        this.store.dispatch(new SetHealthCostEstimate(isSelected));
        this.store.dispatch(new SetPlansDirty(true, MEDICARE_PLAN_TYPE_VALUES));
        this.setGuidedHelpDirty(true);
    }
    getHasHealthCostEstimateSelected() {
        return this.store.selectSnapshot(GuidedHelpState.isHealthCostEstimated);
    }
    getHasHealthCostEstimateSelected$() {
        return this.store.select(GuidedHelpState.isHealthCostEstimated);
    }
    coverageTypeToTab(coverageType, medicalOnlyDefault) {
        let tabToDirectTo = PlanTypeAbbreviation.MA;
        // if they select Medical Coverage type in guided help, check to see if its included in the
        // plan tabs. If true direct to MA plans in plan list
        // if false direct to Med Sup (MediGap) in plan list
        if (this.tabs && this.tabs.length > 0) {
            const firstActiveTab = this.getFirstActiveTab();
            const isMedSupEnabled = this.tabs.some(tab => tab.tabTypes.includes(PlanTypeAbbreviation.MEDIGAP));
            const isMedicareAdvantageEnabled = this.tabs.some(tab => tab.tabTypes.includes(PlanTypeAbbreviation.MA));
            if (medicalOnlyDefault) {
                if (isMedicareAdvantageEnabled && medicalOnlyDefault === PlanTypeAbbreviation.MA) {
                    tabToDirectTo = PlanTypeAbbreviation.MA;
                }
                else {
                    if (isMedSupEnabled) {
                        tabToDirectTo = PlanTypeAbbreviation.MEDIGAP;
                    }
                    else {
                        tabToDirectTo = firstActiveTab;
                    }
                }
            }
            else {
                tabToDirectTo = isMedicareAdvantageEnabled ? PlanTypeAbbreviation.MA : PlanTypeAbbreviation.MEDIGAP;
            }
        }
        return {
            [CoverageType.MEDICAL_ONLY]: tabToDirectTo,
            [CoverageType.PRESCRIPTION_DRUG]: PlanTypeAbbreviation.PDP,
            [CoverageType.MEDICAL_AND_PRESCRIPTION_DRUG]: PlanTypeAbbreviation.MAPD
        }[coverageType];
    }
    getFilteredFrequencyOptions(frequencyOptions) {
        return this.drugFrequencyFacade.getFilteredFrequencyOptions(frequencyOptions);
    }
    setDrugsToMedicineCabinet$(medicineCabinetEntry) {
        return this.store.dispatch(new SetDrugsToMedicineCabinet(medicineCabinetEntry));
    }
    getPreferenceBannerResources(widgetName) {
        return {
            Spa_PreferenceBanner_Enabled: this.getProcessedResourceValue('Spa_PreferenceBanner_Enabled', true),
            Spa_PreferenceBanner_Header_Text: this.getProcessedResourceValue('Spa_PreferenceBanner_Header_Text', 'Add details to help decide which plan is best.'),
            Spa_PreferenceBanner_View_ButtonText: this.getProcessedResourceValue('Spa_PreferenceBanner_View_ButtonText', 'View the preferences bar'),
            Spa_PreferenceBanner_Hide_ButtonText: this.getProcessedResourceValue('Spa_PreferenceBanner_Hide_ButtonText', 'Hide the preferences bar'),
            Spa_Site_IsRequired_Text: this.getProcessedResourceValue('Spa_Site_IsRequired_Text', 'is required'),
            Spa_Site_InvalidSelection_Text: this.getProcessedResourceValue('Spa_Site_InvalidSelection_Text', 'Invalid selection for'),
            Spa_PreferenceBanner_DisplayButtons_JSON: this.getProcessedResourceValue('Spa_PreferenceBanner_DisplayButtons_JSON', [
                {
                    sectionType: PreferenceBannerSectionType.PROVIDERS,
                    sectionTitle: 'Providers',
                    display: false,
                    buttonText: 'Add providers',
                    order: 1
                },
                {
                    sectionType: PreferenceBannerSectionType.PHARMACY,
                    sectionTitle: 'Pharmacies',
                    display: false,
                    buttonText: 'Add pharmacies',
                    order: 2
                },
                {
                    sectionType: PreferenceBannerSectionType.PRESCRIPTIONS,
                    sectionTitle: 'Prescriptions',
                    display: false,
                    buttonText: 'Add prescriptions',
                    order: 3
                },
                {
                    sectionType: PreferenceBannerSectionType.ELIGIBILITY,
                    sectionTitle: 'Eligibility',
                    display: false,
                    buttonText: 'Add eligibility',
                    order: 4
                },
                {
                    sectionType: PreferenceBannerSectionType.HEALTH,
                    sectionTitle: 'Health',
                    display: false,
                    buttonText: 'Add health',
                    order: 5
                },
                {
                    sectionType: PreferenceBannerSectionType.CURRENT_PLAN,
                    sectionTitle: 'Current plan',
                    display: false,
                    buttonText: 'Add Current plan',
                    order: 6
                },
                {
                    sectionType: PreferenceBannerSectionType.SUPPLEMENTAL_BENEFITS,
                    sectionTitle: 'Customize supplemental benefits',
                    display: false,
                    buttonText: 'Customize supplemental benefits',
                    order: 7
                }
            ]),
            Spa_Site_View: this.getProcessedResourceValue('Spa_Site_View', 'View'),
            Spa_PreferenceBanner_Added_ButtonText: this.getProcessedResourceValue('Spa_PreferenceBanner_Added_ButtonText', 'Added'),
            Spa_Site_Prescriptions_Text: this.getProcessedResourceValue('Spa_Site_Prescriptions_Text', 'Prescriptions', widgetName),
            Spa_Site_Eligibility_Text: this.getProcessedResourceValue('Spa_Site_Eligibility_Text', 'Eligibility', widgetName),
            Spa_Site_Health_Text: this.getProcessedResourceValue('Spa_Site_Health_Text', 'Health', widgetName),
            Spa_Site_Providers_Text: this.getProcessedResourceValue('Spa_Site_Providers_Text', 'Providers', widgetName),
            Spa_Site_Pharmacy_Text: this.getProcessedResourceValue('Spa_Site_Pharmacy_Text', 'Pharmacy', widgetName),
            Spa_Site_Close_Modal: this.getProcessedResourceValue('Spa_Site_Close_Modal', 'Close'),
            Spa_Site_HealthCosts_Benefits_JSON: this.getProcessedResourceValue('Spa_Site_HealthCosts_Benefits_JSON', undefined),
            Spa_HealthCosts_Body_Text: this.getProcessedResourceValue('Spa_HealthCosts_Body_Text', 'Would you like to estimate your medical costs?', widgetName),
            Spa_HealthCosts_Benefits_Body_Text: this.getProcessedResourceValue('Spa_HealthCosts_Benefits_Body_Text', 'Decide how often you might use these benefits annually to help estimate medical costs for each plan. test', widgetName),
            Spa_Site_HealthCosts_Benefits_Table_Header: this.getProcessedResourceValue('Spa_Site_HealthCosts_Benefits_Table_Header', 'Benefit', widgetName),
            Spa_Site_HealthCosts_Usage_Table_Header: this.getProcessedResourceValue('Spa_Site_HealthCosts_Usage_Table_Header', 'Visits/Uses', widgetName),
            Spa_Site_HealthCosts_Days_Table_Header: this.getProcessedResourceValue('Spa_Site_HealthCosts_Days_Table_Header', 'Total days', widgetName),
            Spa_Site_HealthCosts_Restore_Defaults_Text: this.getProcessedResourceValue('Spa_Site_HealthCosts_Restore_Defaults_Text', 'Restore defaults'),
            Spa_Site_HealthCosts_Update_Answers_Text: this.getProcessedResourceValue('Spa_Site_HealthCosts_Update_Answers_Text', 'Update answers'),
            Spa_Site_HealthCosts_Save_Answers_Text: this.getProcessedResourceValue('Spa_Site_HealthCosts_Save_Answers_Text', 'Save'),
            Spa_Site_HealthCosts_Save_Failed_Text: this.getProcessedResourceValue('Spa_Site_HealthCosts_Save_Failed_Text', 'Server error. Please try again.'),
            Spa_Site_HealthCosts_Save_Success_Text: this.getProcessedResourceValue('Spa_Site_HealthCosts_Save_Success_Text', 'Saved'),
            Spa_GuidedHelp_Health_AgeQuestion_Text: this.getProcessedResourceValue('Spa_GuidedHelp_Health_AgeQuestion_Text', 'How old are you?', widgetName),
            Spa_Site_HealthCosts_Customization_Enabled: this.getProcessedResourceValue('Spa_Site_HealthCosts_Customization_Enabled', true),
            Spa_GuidedHelp_Health_SliderHeader1_Text: this.getProcessedResourceValue('Spa_GuidedHelp_Health_SliderHeader1_Text', 'Generally healthy test', widgetName),
            Spa_GuidedHelp_Health_SliderHeader2_Text: this.getProcessedResourceValue('Spa_GuidedHelp_Health_SliderHeader2_Text', 'Some health needs', widgetName),
            Spa_GuidedHelp_Health_SliderHeader3_Text: this.getProcessedResourceValue('Spa_GuidedHelp_Health_SliderHeader3_Text', 'Significant health needs', widgetName),
            Spa_GuidedHelp_Health_SliderBody1: this.getProcessedResourceValue('Spa_GuidedHelp_Health_SliderBody1', 'No major illnesses <br /> Less than 2 prescriptions for an illness <br /> Less than 2 visits to primary care', widgetName),
            Spa_GuidedHelp_Health_SliderBody2: this.getProcessedResourceValue('Spa_GuidedHelp_Health_SliderBody2', 'Ongoing condition like diabetes <br /> Regular prescription needs <br /> 1 or more visits to a specialist', widgetName),
            Spa_GuidedHelp_Health_SliderBody3: this.getProcessedResourceValue('Spa_GuidedHelp_Health_SliderBody3', 'Multiple prescriptions <br /> Managing a serious condition <br /> Multiple visits to specialists', widgetName),
            Spa_Site_Health_Slider_Label_Text: this.getProcessedResourceValue('Spa_Site_Health_Slider_Label_Text', 'Select health status range'),
            Spa_AddHealth_ModalView1_HeadingText: this.getProcessedResourceValue('Spa_AddHealth_ModalView1_HeadingText', 'Estimate health costs'),
            Spa_AddHealth_ModalView1_IntroText: this.getProcessedResourceValue('Spa_AddHealth_ModalView1_IntroText', 'Your health status helps calculate your estimated cost. It will not affect your premiums.'),
            Spa_Site_SiteType: this.getProcessedResourceValue('Spa_Site_SiteType', SiteType.CONSUMER),
            Spa_GettingStarted_ShowSubsidyAccordion_Flag: this.getProcessedResourceValue('Spa_GettingStarted_ShowSubsidyAccordion_Flag', true),
            Spa_GuidedHelp_OptionalLabel_Text: this.getProcessedResourceValue('Spa_GuidedHelp_OptionalLabel_Text', '(Optional)', widgetName),
            Spa_GettingStarted_SubsidyHeader_Text: this.getProcessedResourceValue('Spa_GettingStarted_SubsidyHeader_Text', 'Do you receive extra help with paying for your prescription drugs?'),
            Spa_AddEligibility_ModalView1_HeadingText: this.getProcessedResourceValue('Spa_AddEligibility_ModalView1_HeadingText', 'Eligibility information'),
            Spa_AddEligibility_ModalView1_IntroText: this.getProcessedResourceValue('Spa_AddEligibility_ModalView1_IntroText', 'Add your subsidy to see if you qualify for special needs plans which typically provide benefits not otherwise available in traditional Medicare and generally do not charge a premium.'),
            Spa_Site_CurrentPlan_Text: this.getProcessedResourceValue('Spa_Site_CurrentPlan_Text', 'Current plan'),
            Spa_GuidedHelp_CurrentPlan_Button_Text: this.getProcessedResourceValue('Spa_GuidedHelp_CurrentPlan_Button_Text', 'Update current plan'),
            Spa_Site_Medicare_Text: this.getProcessedResourceValue('Spa_Site_Medicare_Text', 'Medicare'),
            Spa_CustomizeBenefits_SelectBenefit_HeaderText: this.getProcessedResourceValue('Spa_CustomizeBenefits_SelectBenefit_HeaderText', 'Search and select up to [[Spa_CustomizeBenefits_NumberOfBenefits_Count]] benefit(s)'),
            Spa_Site_CustomizeSupplementalBenefits_Text: this.getProcessedResourceValue('Spa_Site_CustomizeSupplementalBenefits_Text', 'Customize supplemental benefits'),
            Spa_CustomizeSupplementalBenefits_ModalSearchFavoritesView_HeadingText: this.getProcessedResourceValue('Spa_CustomizeSupplementalBenefits_ModalSearchFavoritesView_HeadingText', 'Customize supplemental benefits to display for medical coverage.'),
            Spa_CustomizeSupplementalBenefits_ModalSearchFavoritesView_IntroText: this.getProcessedResourceValue('Spa_CustomizeSupplementalBenefits_ModalSearchFavoritesView_IntroText', 'Add your favorite supplemental benefits and compare them across plans so you can find the plan that best suits your needs.'),
            Spa_Site_UpdatePlanBenefits_Text: this.getProcessedResourceValue('Spa_Site_UpdatePlanBenefits_Text', 'Update plan benefits'),
            Spa_PreferenceBanner_Updated_ButtonText: this.getProcessedResourceValue('Spa_PreferenceBanner_Updated_ButtonText', 'Updated (Medical)'),
            Spa_Site_ZipCodeInput_ZipCodeLabel: this.getProcessedResourceValue('Spa_Site_ZipCodeInput_ZipCodeLabel', 'Zip code'),
            Spa_Site_ZipCodeInput_EditCounty: this.getProcessedResourceValue('Spa_Site_ZipCodeInput_EditCounty', 'Edit'),
            Spa_Site_ZipCodeInput_SelectCounty: this.getProcessedResourceValue('Spa_Site_ZipCodeInput_SelectCounty', 'Select county'),
            Spa_Site_ZipCodeInput_CountyError: this.getProcessedResourceValue('Spa_Site_ZipCodeInput_CountyError', 'Please select your county'),
            Spa_Site_ZipCodeInput_ZipCodeError: this.getProcessedResourceValue('Spa_Site_ZipCodeInput_ZipCodeError', 'Zip code is invalid'),
            Spa_Site_ZipCodeInput_SelectedCountyEnabled: this.getProcessedResourceValue('Spa_Site_ZipCodeInput_SelectedCountyEnabled', true),
            Spa_Site_ErrorKeyword_Text: this.getProcessedResourceValue('Spa_Site_ErrorKeyword_Text', 'Error:'),
            Spa_ZipCodeInput_CountyLabel_Text: this.getProcessedResourceValue('Spa_ZipCodeInput_CountyLabel_Text', 'County'),
            Spa_ZipCodeInput_CountyLabel_Enabled: this.getProcessedResourceValue('Spa_ZipCodeInput_CountyLabel_Enabled', false),
            Spa_Site_Carrier_Text: this.getProcessedResourceValue('Spa_Site_Carrier_Text', 'Carrier'),
            Spa_GuidedHelp_CurrentPlan_Plan_Text: this.getProcessedResourceValue('Spa_GuidedHelp_CurrentPlan_Plan_Text', 'Plan'),
            Spa_Site_Search_Text: this.getProcessedResourceValue('Spa_Site_Search_Text', 'Search Text'),
            Spa_Site_Carrier_SelectText: this.getProcessedResourceValue('Spa_Site_Carrier_SelectText', 'Select carrier'),
            Spa_Site_Plan_SelectText: this.getProcessedResourceValue('Spa_Site_Plan_SelectText', 'Select plan'),
            Spa_Site_PlanType_SelectText: this.getProcessedResourceValue('Spa_Site_PlanType_SelectText', 'Select plan type'),
            Spa_GuidedHelp_CurrentPlan_SearchFor_Text: this.getProcessedResourceValue('Spa_GuidedHelp_CurrentPlan_SearchFor_Text', 'Search for a'),
            Spa_GuidedHelp_CurrentPlan_ModalDescription_Text: this.getProcessedResourceValue('Spa_GuidedHelp_CurrentPlan_ModalDescription_Text', 'You may compare your current Medicare plan to all offerings available in your area. This information may be found on your current carrier insurance card. To find your current plan, enter the information below'),
            Spa_Site_PlanType_Text: this.getProcessedResourceValue('Spa_Site_PlanType_Text', 'Plan type'),
            Spa_Site_PlanYear_Text: this.getProcessedResourceValue('Spa_Site_PlanYear_Text', 'Plan year'),
            Spa_CustomizeBenefits_MaxLimitError: this.getProcessedResourceValue('Spa_CustomizeBenefits_MaxLimitError', 'You cannot add more than [[Spa_CustomizeBenefits_NumberOfBenefits_Count]] benefit(s)'),
            Spa_CustomizeBenefits_SelectBenefit_ErrorText: this.getProcessedResourceValue('Spa_CustomizeBenefits_SelectBenefit_ErrorText', 'This benefits already exists your list'),
            Spa_CustomizeBenefits_ListIntro_Text: this.getProcessedResourceValue('Spa_CustomizeBenefits_ListIntro_Text', 'We started a list of the most common benefits, but you may add or remove any you would like.'),
            Spa_CustomizeBenefits_ListHeader_Text: this.getProcessedResourceValue('Spa_CustomizeBenefits_ListHeader_Text', 'Your favorite supplemental benefits'),
            Spa_CustomizeBenefits_NumberOfBenefits_Count: this.getProcessedResourceValue('Spa_CustomizeBenefits_NumberOfBenefits_Count', 6)
        };
    }
    getProviderInputProps(widgetName) {
        return {
            providersText: this.getProcessedResourceValue('Spa_Site_Providers_Text', 'Providers', widgetName),
            providersBodyText: this.getProcessedResourceValue('Spa_Site_Providers_Body_Text', `See which plans cover your doctor, specialist, urgent care or hospital. Reference the plan's Medical Provider Directory to see up-to-date network information.`, widgetName),
            providersMultiBodyText: this.getProcessedResourceValue('Spa_Multi_Providers_Body_Text', `Add your providers to see which plans cover your doctor, specialist, urgent care or hospital. Choose the exact location for your provider because network status can vary for a provider based on the location.`, widgetName),
            errorKeywordText: this.getProcessedResourceValue('Spa_Site_ErrorKeyword_Text', 'Error:'),
            zipLabel: this.getProcessedResourceValue('Spa_Site_ZipCodeInput_ZipCodeLabel', 'Zip code'),
            zipErrorText: this.getProcessedResourceValue('Spa_Site_ZipCodeInput_ZipCodeError', 'Zip code is invalid'),
            providerNameText: this.getProcessedResourceValue('Spa_ProviderName_Text', 'Provider name', widgetName),
            providerNameHintText: this.getProcessedResourceValue('Spa_ProviderName_HintText', 'Provider name', widgetName),
            providerSearchButtonText: this.getProcessedResourceValue('Spa_Site_SearchButton_Text', 'Search'),
            providerLimit: this.getProcessedResourceValue('Spa_Provider_Limit', 25),
            itemsPerPage: this.getProcessedResourceValue('Spa_ProviderSearch_Pagination_ItemsPerPage', 10),
            providerPaginationEnabled: this.getProcessedResourceValue('Spa_ProviderSearch_Pagination_Enabled', false),
            viewNotFoundHeaderText: this.getProcessedResourceValue('Spa_Provider_Alt_View_Not_Found_Header_Text', 'No provider results'),
            viewNotFoundBodyText: this.getProcessedResourceValue('Spa_Provider_Alt_View_Not_Found_Body_Text', 'There are no providers available in this location. Try zooming out or entering a new ZIP code.'),
            paginationText: this.getProcessedResourceValue('Spa_ProviderSearch_Pagination_View_Text', 'Viewing <startPageItem> - <endPageItem> of <totalPages>'),
            maxZoom: this.getProcessedResourceValue('Spa_ProviderMap_Max_Zoom', 28),
            minZoom: this.getProcessedResourceValue('Spa_ProviderMap_Min_Zoom', 4),
            providerMapDefaultZoom: this.getProcessedResourceValue('Spa_ProviderMap_Default_Zoom', 11),
            addProviderText: this.getProcessedResourceValue('Spa_Provider_Add_Text', 'Add Provider'),
            providerAddedText: this.getProcessedResourceValue('Spa_Provider_Added_Text', 'Provider added'),
            yourProviderText: this.getProcessedResourceValue('Spa_Provider_YourProvider_Text', 'My providers', widgetName),
            removeProviderText: this.getProcessedResourceValue('Spa_Provider_RemoveProvider_Text', 'Remove provider'),
            setPrimaryCareProviderText: this.getProcessedResourceValue('Spa_Provider_Set_Primary_Care_Provider_Text', 'Set as primary care provider', widgetName),
            primaryCareProviderText: this.getProcessedResourceValue('Spa_Provider_Primary_Care_Provider_Text', 'Primary care provider'),
            providerFiltersEnabled: this.getProcessedResourceValue('Spa_Providers_Filter_Enabled', false),
            providerGroupAddedLabelText: this.getProcessedResourceValue('Spa_Group_Provider_Added_Text', 'Added'),
            providerGroupAddLabelText: this.getProcessedResourceValue('Spa_Group_Provider_Add_Text', 'Add'),
            countyLabel: this.getProcessedResourceValue('Spa_ZipCodeInput_CountyLabel_Text', 'County'),
            showCountyLabel: this.getProcessedResourceValue('Spa_ZipCodeInput_CountyLabel_Enabled', false),
            addLinkText: this.getProcessedResourceValue('Spa_Site_Add', 'Add'),
            cancelProvidersLabel: this.getProcessedResourceValue('Spa_Site_Cancel', 'Cancel'),
            providerSingleSelectEnabled: this.getProcessedResourceValue('Spa_Select_Single_Provider_For_Multi_Address_Enabled', false),
            selectProviderLabelText: this.getProcessedResourceValue('Spa_Select_Provider_Location_Text', 'Select the provider location'),
            providerExistsTooltipText: this.getProcessedResourceValue('Spa_Provider_Exists_Text', 'You may only select one location for each provider'),
            providerMultiLocationText: this.getProcessedResourceValue('Spa_Provider_Multiple_Location_Text', 'This provider has multiple locations which may give different insurance information.'),
            providerLocationsText: this.getProcessedResourceValue('Spa_Plan_Providers_Locations_Link_Text', 'locations'),
            valueBasedCareEnabled: this.getProcessedResourceValue('Spa_Site_ValueBasedCare_Enabled', true),
            valueBasedCareIcon: this.getProcessedResourceValue('Spa_Site_ValueBasedCare_Icon', 'fas fa-briefcase-medical'),
            valueBasedCareText: this.getProcessedResourceValue('Spa_Site_ValueBasedCare_Text', 'Value based care'),
            generalPracticeOptions: this.getProcessedResourceValue('Spa_Provider_Search_Filter_General_Practice_Options', [
                { display: 'Yes', value: true },
                { display: 'No', value: false }
            ]),
            generalPracticeToolTipText: this.getProcessedResourceValue('Spa_Provider_Search_General_Practice_Tooltip_Text', 'General practitioners treat patients of all ages, but do not typically specialize in a particular area. They may treat your medical condition or refer you to a specialist.'),
            generalPracticeLabel: this.getProcessedResourceValue('Spa_Provider_Search_General_Practice_Label_Text', 'General practice'),
            generalPracticeFilterOptionEnabled: this.getProcessedResourceValue('Spa_Provider_Search_Filter_General_Practice_Option_Enabled', false),
            singleProviderInListEnabled: this.getProcessedResourceValue('Spa_Provider_Search_ShowSingleProviderInList_Enabled', false),
            updateLinkText: this.getProcessedResourceValue('Spa_Site_Update_Text', 'Update'),
            editLinkText: this.getProcessedResourceValue('Spa_Site_Edit_Text', 'Edit'),
            showEditLinkEnabled: this.getProcessedResourceValue('Spa_Provider_ShowEditLink_Enabled', false),
            valueBasedCareAvailableText: this.getProcessedResourceValue('Spa_ValueBasedCare_Available_Text', '<i class="fas fa-solid fa-info-circle"></i> Value Based Care providers may be available in your area'),
            valueBasedCareLearnMoreLink: this.getProcessedResourceValue('Spa_ValueBasedCare_LearnMore_Link', 'https://www.cms.gov/priorities/innovation-center/value-based-care-spotlight'),
            valueBasedCareLearnMoreText: this.getProcessedResourceValue('Spa_ValueBasedCare_LearnMore_Text', 'Learn more'),
            isValueBasedCareLearnMoreLink2Enabled: this.getProcessedResourceValue('Spa_ValueBasedCare_LearnMoreLink2_Enabled', false),
            valueBasedCareToggleLabel: this.getProcessedResourceValue('Spa_ValueBasedCare_Toggle_Label', 'Search Value Based Providers'),
            valueBasedCareToggleToolTipText: this.getProcessedResourceValue('Spa_ValueBasedCare_Toggle_ToolTip_Text', ''),
            valueBasedCareToggleEnabled: this.getProcessedResourceValue('Spa_ValueBasedCare_Toggle_Enabled', false),
            valueBasedCareToggleOptions: this.getProcessedResourceValue('Spa_Provider_Search_Filter_ValueBasedCare_Options', [
                { display: 'Yes', value: true },
                { display: 'No', value: false }
            ]),
            pcpToggleEnabled: this.getProcessedResourceValue('Spa_Primary_Care_Provider_Toggle_Enabled', false),
            newPatientToggleOptions: this.getProcessedResourceValue('Spa_Provider_New_Patient_Options', [
                { display: 'Yes', value: 'yes' },
                { display: 'No', value: 'no' }
            ]),
            newPatientToggleLabel: this.getProcessedResourceValue('Spa_Provider_New_Patient_Toggle_Label', 'Are you a new patient for this provider?'),
            pcpToggleLabel: this.getProcessedResourceValue('Spa_Primary_Care_Provider_Toggle_Label', 'Is this your primary care physician'),
            pcpToggleOptions: this.getProcessedResourceValue('Spa_Primary_Care_Provider_Options', [
                { display: 'Yes', value: 'yes' },
                { display: 'No', value: 'no' }
            ]),
            newPatientText: this.getProcessedResourceValue('Spa_New_Patient_For_Provider_Text', 'New Patient'),
            existingPatientText: this.getProcessedResourceValue('Spa_Existing_Patient_For_Provider_Text', 'Existing patient'),
            vbcNameFilterEnabled: this.getProcessedResourceValue('Spa_Provider_ValueBasedCare_Name_Filter_Enabled', false),
            vbcNameFilterLabel: this.getProcessedResourceValue('Spa_Provider_ValueBasedCare_Name_Filter_Label', 'Participating Value Based Care organizations in this area'),
            selectedProviderOptionsEnabled: this.getProcessedResourceValue('Spa_Selected_Provider_Options_Enabled', false),
            removeText: this.getProcessedResourceValue('Spa_Site_Remove_Text', 'Remove'),
            selectAllText: this.getProcessedResourceValue('Spa_Site_SelectAll_Text', 'Select all'),
            newPatientToggleEnabled: this.getProcessedResourceValue('Spa_Provider_New_Patient_Toggle_Enabled', false),
            providerAddMaxLimitMessage: this.getProcessedResourceValue('Spa_Provider_Add_Maximum_Limit_Message', 'You can only add up to <maxCount> providers'),
            providerFilterIndividualText: this.getProcessedResourceValue('Spa_Providers_Filter_Individuals_Text', 'Doctors and other professionals'),
            providerFacilitiesText: this.getProcessedResourceValue('Spa_Providers_Filter_Facilties_Text', 'Facilities (hospitals, clinics and urgent care)'),
            valueBasedCareFilterText: this.getProcessedResourceValue('Spa_ValueBasedCare_Filter_Text', 'Only show Value Based Care providers'),
            valueBasedCareFilterEnabled: this.getProcessedResourceValue('Spa_Site_ValueBasedCare_Filter_Enabled', true),
            valueBasedCareFilterChecked: this.getProcessedResourceValue('Spa_ValueBasedCare_Filter_Checked', false),
            valueBasedCareLearnMoreLinkEnabled: this.getProcessedResourceValue('Spa_ValueBasedCare_LearnMoreLink_Enabled', true),
            backButtonText: this.getProcessedResourceValue('Spa_Providers_Back_Button', 'Back'),
            modalProviderSearchViewHeadingText: this.getProcessedResourceValue('Spa_AddProviders_ModalProviderSearchView_HeadingText', 'Add providers'),
            modalProviderSearchViewIntroText: this.getProcessedResourceValue('Spa_AddProviders_ModalProviderSearchView_IntroText', 'See which plans cover your doctor, specialist, urgent care or hospital.'),
            modalProviderMapViewHeadingText: this.getProcessedResourceValue('Spa_AddProviders_ModalProviderMapView_HeadingText', ''),
            modalProviderMapViewIntroText: this.getProcessedResourceValue('Spa_AddProviders_ModalProviderMapView_IntroText', 'Choose the exact location for your provider. Network status can vary for a provider based on the location.'),
            modalProviderLocationViewHeadingText: this.getProcessedResourceValue('Spa_AddProviders_ModalProviderLocationView_HeadingText', ''),
            modalProviderLocationViewIntroText: this.getProcessedResourceValue('Spa_AddProviders_ModalProviderLocationView_IntroText', 'If you see your provider at multiple locations, add all the locations at which you see them. Network status can vary for a provider based on the location.'),
            isZelisIntegrationEnabled: this.getProcessedResourceValue('Spa_Site_ZelisIntegration_Enabled', true)
        };
    }
    getPrescriptionInputProps(widgetName) {
        const medicineCabinetLimit = this.getProcessedResourceValue('Spa_DrugSearch_Cabinet_Limit', 25);
        const quantityMaxLimit = this.getProcessedResourceValue('Spa_DrugSearch_Quantity_Max_Limit', 1000);
        return {
            contentSectionText: this.getProcessedResourceValue('Spa_DrugSearch_Content_Section_Text', 'We defaulted the most common dosage so you have a better idea of what you might take.'),
            dosageHeader: this.getProcessedResourceValue('Spa_DrugSearch_Dosage_Header', 'Select dose and form'),
            quantityAndFrequencyHeader: this.getProcessedResourceValue('Spa_DrugSearch_Frequency_Header', 'Enter quantity and frequency'),
            packageHeader: this.getProcessedResourceValue('Spa_DrugSearch_Package_Header', 'Select package'),
            addButtonText: this.getProcessedResourceValue('Spa_DrugSearch_Add_Button', 'Add'),
            cancelButtonText: this.getProcessedResourceValue('Spa_DrugSearch_Cancel_Button', 'Cancel'),
            backButtonText: this.getProcessedResourceValue('Spa_DrugSearch_Back_Button', 'Back'),
            quantityMaxLimit,
            medicineCabinetLimit,
            cabinetLimitErrorMessage: this.getProcessedResourceValue('Spa_DrugSearch_MaxCount_Error_Message', `You can only add up to ${medicineCabinetLimit} drugs`),
            quantityErrorMessage: this.getProcessedResourceValue('Spa_DrugSearch_Quantity_Error_Message', `\n  Please provide a number between 0 and ${quantityMaxLimit}`),
            placeholder: this.getProcessedResourceValue('Spa_DrugSearch_Hint_Text', 'search for prescription', widgetName),
            drugSearchText: this.getProcessedResourceValue('Spa_DrugSearch_Label_Text', 'Drug Search'),
            drugsImage: this.getProcessedResourceValue('Spa_DrugSearch_Drugs_Image', undefined),
            inCabinetErrorMessage: this.getProcessedResourceValue('Spa_DrugSearch_InCabinetError_Text', 'This drug and dosage already exists in your list.'),
            medCabinetHeader: this.getProcessedResourceValue('Spa_DrugSearch_Medicine_Header', 'Your prescriptions'),
            genericOptionIcon: this.getProcessedResourceValue('Spa_DrugSearch_GenericOption_Icon', 'fas fa-tag'),
            showGenericOption: this.getProcessedResourceValue('Spa_Site_Show_GenericDrugOption', true),
            genericOptionQuestion: this.getProcessedResourceValue('Spa_DrugSearch_GenericOption_Question', 'Would you like to use a Generic (<genericDrugName>) for <brandName>'),
            genericOptionInfo: this.getProcessedResourceValue('Spa_DrugSearch_GenericOption_Info', `\n    According to the FDA, this generic drug has the same quality, strength, safety and active ingredient as the brand name drug.\n    Generic drugs are usually covered by part D plans and are generally a lower price.`),
            genericOptions: this.getProcessedResourceValue('Spa_DrugSearch_GenericOptions', [
                { label: 'Yes', value: true },
                { label: 'No', value: false }
            ]),
            checkDrugCoverageButtonText: this.getProcessedResourceValue('Spa_DrugSearch_CheckDrugCoverageButton_Text', 'See if this drug is covered'),
            genericOptionDefaultSelection: this.getProcessedResourceValue('Spa_DrugSearch_GenericOption_Default_Selection', false),
            showCosts: this.getProcessedResourceValue('Spa_DrugListCard_HideCosts_Flag', false),
            drugSearchIntroText: this.getProcessedResourceValue('Spa_AddPrescriptions_ModalView1_IntroText', 'Add your prescriptions to see how each plan provides coverage.'),
            drugSearchPageHeaderText: this.getProcessedResourceValue('Spa_DrugSearch_PageHeader_Text', 'Prescriptions'),
            errorKeywordText: this.getProcessedResourceValue('Spa_Site_ErrorKeyword_Text', 'Error:'),
            drugSearchFrequencyListBoxLabel: this.getProcessedResourceValue('Spa_DrugSearch_Frequency_ListBox_Label', 'Choose any one the frequency from list of options available'),
            drugSearchFrequencyList: this.getProcessedResourceValue('Spa_DrugSearch_Frequency_List', [
                { label: "per month" /* FrequencyLabel.Month */, value: 30 /* FrequencyValue.Month */ },
                { label: "per two months" /* FrequencyLabel.TwoMonths */, value: 60 /* FrequencyValue.TwoMonths */ },
                { label: "per three months" /* FrequencyLabel.ThreeMonths */, value: 90 /* FrequencyValue.ThreeMonths */ },
                { label: "per six months" /* FrequencyLabel.SixMonths */, value: 180 /* FrequencyValue.SixMonths */ },
                { label: "per year" /* FrequencyLabel.PerYear */, value: 365 /* FrequencyValue.PerYear */ }
            ]),
            prescriptionsText: this.getProcessedResourceValue('Spa_AddPrescriptions_ModalView1_HeadingText', 'Add prescriptions'),
            isBlueButtonEnabled: this.getProcessedResourceValue('Spa_Site_Enable_BlueButton', true),
            blueButtonStartAddingDrugText: this.getProcessedResourceValue('Spa_BlueButton_StartAddDrug_Text', 'Start adding drugs', widgetName),
            orText: this.getProcessedResourceValue('Spa_Site_OrText', 'OR'),
            blueButtonConnectToMyMedicareText: this.getProcessedResourceValue('Spa_BlueButton_MyMedicare_Connect_Text', `<div class="Spa_Style_H4 mb-1">Download your prescription list from myMedicare.gov.</div>
    <p class="Spa_Style_Primary_Color Spa_Style_Paragraph mb-0">The easy and secure way to download all current prescriptions.</p>`, widgetName),
            blueButtonMyMedicareButtonText: this.getProcessedResourceValue('Spa_BlueButton_MyMedicare_Button', 'MyMedicare.gov', widgetName),
            emailLabelText: this.getProcessedResourceValue('Spa_Site_EmailAddress_Text', 'Email address'),
            emailRequiredErrorText: this.getProcessedResourceValue('Spa_Profile_EmailRequired_Error', 'Please provide email address'),
            emailInvalidErrorText: this.getProcessedResourceValue('Spa_Profile_EmailInvalid_Error', 'Please provide a valid email address'),
            sendEmailButtonText: this.getProcessedResourceValue('Spa_Site_SendEmailButton_Text', 'Send email', widgetName),
            blueButtonModalHeaderText: this.getProcessedResourceValue('Spa_BlueButton_Modal_Header', 'You are leaving site', widgetName),
            blueButtonModalContent: this.getProcessedResourceValue('Spa_BlueButton_Modal_Content', `<p class="Spa_Style_Paragraph">Are you sure you want to continue to login to Mymedicare.gov?</p>
    <p class="Spa_Style_Paragraph">Connecture,Inc. is a trusted entity of Healthcare co. By allowing Connecture, Inc access to
    your drug list, you will be able to download your drugs to our site and be able to find a plan that covers them that
    much quicker.</p><p class="Spa_Style_Paragraph">Review Connecture's <a class="Spa_Style_Link" href="">privacy policy</a>
    and <a class="Spa_Style_Link" href="">terms and conditions</a> relating to the download of the prescriptions.</p>`, widgetName),
            blueButtonSuccessText: this.getProcessedResourceValue('Spa_BlueButton_Success_Text', 'Prescriptions shared successully'),
            blueButtonDownloadText: this.getProcessedResourceValue('Spa_BlueButton_Download_Text', 'Prescriptions last downloaded on '),
            blueButtonSuccessMessage: this.getProcessedResourceValue('Spa_BlueButton_Success_Message', ' Prescriptions last downloaded on'),
            blueButtonEmailSendText: this.getProcessedResourceValue('Spa_BlueButton_EmailSentToStatus_Text', `Email sent to {{[member.profile.emailAddress]}} on {{[member.blueButtonInfo.updateDate]}} `, widgetName),
            blueButtonIssueLoadingText: this.getProcessedResourceValue('Spa_BlueButton_Issue_Loading_Text', 'Issue loading prescriptions. Please try again.', widgetName),
            blueButtonBeneficiaryDeniedText: this.getProcessedResourceValue('Spa_BlueButton_Beneficiary_Denied_Text', 'Beneficiary denied access.', widgetName),
            blueButtonErrorLoadingText: this.getProcessedResourceValue('Spa_BlueButton_Error_Loading_Text', 'Unable to load latest prescriptions.'),
            blueButtonBeneficiaryEmailDetails: this.getProcessedResourceValue('Spa_BlueButton_Beneficiary_Email_Details', 'You may need to email the beneficiary again to update their login information.'),
            blueButtonImportLatestPrescriptionButtonText: this.getProcessedResourceValue('Spa_BlueButton_ImportLatestPrescription_Button_Text', 'Import latest prescriptions', widgetName),
            blueButtonImportLatestPrescriptionErrorText: this.getProcessedResourceValue('Spa_BlueButton_ImportLatestPrescription_Error_Text', 'Unable to import latest prescriptions. Try again.', widgetName),
            blueButtonAccessDeniedText: this.getProcessedResourceValue('Spa_BlueButton_AccessDenied_Error_Text', 'Access denied. We are unable to load prescriptions', widgetName),
            blueButtonClaimDataLoadingErrorText: this.getProcessedResourceValue('Spa_BlueButton_ClaimData_Loading_Error_Text', 'There was an issue loading your prescriptions. Please try again later', widgetName),
            editDrugText: this.getProcessedResourceValue('Spa_DrugSearch_EditDrug_Button', 'Edit Drug'),
            isUseCMSDrugFlagEnabled: this.getProcessedResourceValue('Spa_Drugs_UseCMSDrugFlag_Enabled', true),
            modalView2HeaderText: this.getProcessedResourceValue('Spa_AddPrescriptions_ModalView2_HeadingText', ''),
            modalView2IntroText: this.getProcessedResourceValue('Spa_AddPrescriptions_ModalView2_IntroText', ''),
            drugSearchInputLabelText: this.getProcessedResourceValue('Spa_DrugSearch_Text', 'Search for a prescription'),
            showCommonConditions: this.getProcessedResourceValue('Spa_DrugSearch_ShowCommonConditions_Enabled', false)
        };
    }
    getPharmacyInputProps(widgetName) {
        const multiPharmacyEnabled = this.getProcessedResourceValue('Spa_Site_Multi_Pharmacy_Enabled', false);
        const Spa_Site_AddPharmacy_YourMultiPharmacyText = this.getProcessedResourceValue('Spa_Site_AddPharmacy_YourMultiPharmacyText', 'Your Pharmacies', widgetName);
        const Spa_AddPharmacy_YourPharmacyText = this.getProcessedResourceValue('Spa_AddPharmacy_YourPharmacyText', 'Your Pharmacy', widgetName);
        const Spa_PharmacySearch_MultiPharmacy_Intro_Text = this.getProcessedResourceValue('Spa_PharmacySearch_MultiPharmacy_Intro_Text', 'Add one or more pharmacies to help us estimate costs and show you which plans include in-network pharmacy discounts.');
        const Spa_PharmacySearch_Intro_Text = this.getProcessedResourceValue('Spa_PharmacySearch_Intro_Text', 'Find your pharmacy to help us estimate costs and show you which plans include in-network pharmacy discounts.', widgetName);
        const filterHeaderText = this.getProcessedResourceValue('Spa_Filter_Header_Text', 'Filters');
        return {
            addPharmacyButtonText: this.getProcessedResourceValue('Spa_Add_Pharmacy_Button', 'Add pharmacy'),
            zipLabel: this.getProcessedResourceValue('Spa_Site_ZipCodeInput_ZipCodeLabel', 'Zip code'),
            pharmacyNameText: this.getProcessedResourceValue('Spa_PharmacyName_Text', 'Pharmacy name', widgetName),
            pharmacyNameHintText: this.getProcessedResourceValue('Spa_PharmacyName_HintText', 'Pharmacy name', widgetName),
            pharmacyLimit: this.getProcessedResourceValue('Spa_Pharmacy_Limit', 25),
            pharmacyMapDefaultZoom: this.getProcessedResourceValue('Spa_PharmacyMap_Default_Zoom', 11),
            maxZoom: this.getProcessedResourceValue('Spa_PharmacyMap_Max_Zoom', 28),
            minZoom: this.getProcessedResourceValue('Spa_PharmacyMap_Min_Zoom', 4),
            currentPharmacyText: multiPharmacyEnabled ? Spa_Site_AddPharmacy_YourMultiPharmacyText : Spa_AddPharmacy_YourPharmacyText,
            pharmacyAddedLabel: this.getProcessedResourceValue('Spa_Pharmacy_Added_Label', 'Pharmacy Added'),
            electronicPrescriptionTooltipHeader: this.getProcessedResourceValue('Spa_Site_ElectronicPrescription_ToolTipHeader', 'Electronic prescribing'),
            electronicPrescriptionTooltipBody: this.getProcessedResourceValue('Spa_Site_ElectronicPrescription_ToolTipBody', 'Prescriptions can be written and sent to the pharmacy electronically.'),
            pharmacyPaginationEnabled: this.getProcessedResourceValue('Spa_PharmacySearch_Pagination_Enabled', false),
            paginationText: this.getProcessedResourceValue('Spa_PharmacySearch_Pagination_View_Text', 'Viewing <startPageItem> - <endPageItem> of <totalPages>'),
            viewNotFoundHeaderText: this.getProcessedResourceValue('Spa_Pharmacy_Alt_View_Not_Found_Header_Text', 'No pharmacy results'),
            viewNotFoundBodyText: this.getProcessedResourceValue('Spa_Pharmacy_Alt_View_Not_Found_Body_Text', 'There are no pharmacies available in this location. Try zooming out or entering a new ZIP code.'),
            preferredInNetworkText: this.getProcessedResourceValue('Spa_Site_Preferred_In_Network_Text', 'Preferred In-network'),
            standardInNetworkText: this.getProcessedResourceValue('Spa_Site_Standard_In_Network_Text', 'Standard In-network'),
            preferredInNetworkTooltipContent: this.getProcessedResourceValue('Spa_PharmacySearch_Preferred_In_Network_Tooltip_Text', 'Pharmacies that are willing to give the plans a larger discount than other pharmacies.'),
            standardInNetworkTooltipContent: this.getProcessedResourceValue('Spa_PharmacySearch_Standard_In_Network_Tooltip_Text', 'These pharmacies may charge a higher copayment or co-insurance for filling your prescription.'),
            pharmacySearchIntroText: multiPharmacyEnabled ? Spa_PharmacySearch_MultiPharmacy_Intro_Text : Spa_PharmacySearch_Intro_Text,
            pharmacySearchHeaderText: this.getProcessedResourceValue('Spa_PharmacySearch_PageHeader_Text', 'Pharmacy', widgetName),
            addedPharmacyText: this.getProcessedResourceValue('Spa_Site_Pharmacy_Added_Text', 'has been added'),
            addPharmacyText: this.getProcessedResourceValue('Spa_Site_Pharmacy_Add_Text', 'Press Enter to add this Pharmacy'),
            pharmacyText: this.getProcessedResourceValue('Spa_Site_Pharmacy_Text', 'Pharmacy', widgetName),
            ePrescribingAltText: this.getProcessedResourceValue('Spa_Site_EPrescribing_Alt_Text', 'This pharmacy supports e-prescribing.'),
            Spa_Site_Tooltip_Text: this.getProcessedResourceValue('Spa_Site_Tooltip_Text', 'Tooltip:'),
            zipErrorText: this.getProcessedResourceValue('Spa_Site_ZipCodeInput_ZipCodeError', 'Zip code is invalid'),
            pharmacySearchButtonText: this.getProcessedResourceValue('Spa_Site_SearchButton_Text', 'Search'),
            multiPharmacyEnabled: this.getProcessedResourceValue('Spa_Site_Multi_Pharmacy_Enabled', false),
            setAsPrimaryLinkText: this.getProcessedResourceValue('Spa_Site_Set_Primary_Pharmacy_Link_Text', 'Set as primary pharmacy'),
            primaryPharmacyText: this.getProcessedResourceValue('Spa_Site_Primary_Pharmacy_Text', 'Primary Pharmacy'),
            pharmacyFilterText: filterHeaderText,
            isPharmacyFilterEnabled: this.getProcessedResourceValue('Spa_Site_Pharmacy_Filter_Enabled', true),
            isPharmacyInNetworkFilterEnabled: this.getProcessedResourceValue('Spa_Site_Pharmacy_In_Network_Filter_Enabled', true),
            isPharmacyOtherFilterEnabled: this.getProcessedResourceValue('Spa_Site_Pharmacy_Other_Filter_Enabled', false),
            pharmacyFilterClearText: this.getProcessedResourceValue('Spa_Filter_Clear_All', 'Clear all'),
            pharmacyFilterData: this.getProcessedResourceValue('Spa_Pharmacy_Filters', [], widgetName),
            defaultFilterText: this.getProcessedResourceValue('Spa_Filter_Default_Filter_Text', 'No filters available'),
            clearAllText: this.getProcessedResourceValue('Spa_Filter_Clear_All', 'Clear all'),
            filterHeaderText,
            modalCancelButtonText: this.getProcessedResourceValue('Spa_PlanFilters_Modal_Cancel_Button', 'Cancel'),
            modalApplyButtonText: this.getProcessedResourceValue('Spa_PlanFilters_Modal_Apply_Button', 'Apply'),
            countyLabel: this.getProcessedResourceValue('Spa_ZipCodeInput_CountyLabel_Text', 'County'),
            showCountyLabel: this.getProcessedResourceValue('Spa_ZipCodeInput_CountyLabel_Enabled', false),
            pharmacyInNetworkFilters: this.getProcessedResourceValue('Spa_Pharmacy_In_Network_Filters', [
                {
                    dataKey: 'isStandard',
                    displayName: '[[Spa_Site_Standard_In_Network_Text]] ([[Spa_PharmacySearch_Standard_In_Network_Tooltip_Text]])'
                },
                {
                    dataKey: 'isPreferred',
                    displayName: '[[Spa_Site_Preferred_In_Network_Text]] ([[Spa_PharmacySearch_Preferred_In_Network_Tooltip_Text]])'
                }
            ]),
            digitalPharmacyEnabled: this.getProcessedResourceValue('Spa_Site_Digital_Pharmacy_Enabled', false),
            retailTabText: this.getProcessedResourceValue('Spa_Pharmacy_Retail_Tab_Text', 'Retail'),
            digitalTabText: this.getProcessedResourceValue('Spa_Pharmacy_Digital_Tab_Text', 'Digital'),
            digitalTabIntroText: this.getProcessedResourceValue('Spa_Pharmacy_Digital_Tab_Intro_Text', 'Many retail pharmacies have online options for ordering prescriptions. Similar to mail order pharmacies associated with your health plan, digital pharmacies allow you to order prescriptions online and have them delivered to your home. Inclusion in this list does not guarantee delivery to your service area.'),
            itemsPerPage: this.getProcessedResourceValue('Spa_PharmacySearch_Pagination_ItemsPerPage', 10),
            pharmacyLimitErrorMessage: this.getProcessedResourceValue('Spa_Site_Pharmacy_Limit_Error_Message', 'You can only add up to <maxPharmacyCount> pharmacies'),
            pharmacySearchBackButton: this.getProcessedResourceValue('Spa_ModalView_Back_Button', 'Back'),
            pharmacyModalView1HeadingText: this.getProcessedResourceValue('Spa_AddPharmacy_ModalView1_HeadingText', 'Add Pharmacies'),
            pharmacyModalView1IntroText: this.getProcessedResourceValue('Spa_AddPharmacy_ModalView1_IntroText', 'Add your pharmacy to get an estimated drug cost and compare across plans.'),
            pharmacyModalView2HeadingText: this.getProcessedResourceValue('Spa_AddPharmacy_ModalView2_HeadingText', ''),
            pharmacyModalView2IntroText: this.getProcessedResourceValue('Spa_AddPharmacy_ModalView2_IntroText', 'Drug costs vary based on the pharmacy you choose. Select multiple pharmacies to compare estimated drug costs for all available plans.'),
            errorKeywordText: this.getProcessedResourceValue('Spa_Site_ErrorKeyword_Text', 'Error:'),
            isHelpfulToolsView: false,
            isPPCSite: this.siteService.isPPCSite(this.getProcessedResourceValue('Spa_Site_SiteType', SiteType.CONSUMER)),
            pharmacyModalDropdownLabel: this.getProcessedResourceValue('Spa_Site_CostBasedOn_DropdownLabel_Text', 'I want my drug costs based on'),
            planListMailOrderText: this.getProcessedResourceValue('Spa_PlanList_MailOrder_Text', 'Mail order', widgetName),
            selectedPharmacies: []
        };
    }
    _medicalOnlyPages(pageTag, coverageTypeEnabled, coverageType) {
        if (!coverageTypeEnabled) {
            return true;
        }
        if (coverageType !== CoverageType.MEDICAL_ONLY) {
            return true;
        }
        if (pageTag !== PageTags.GUIDED_HELP_PRESCRIPTIONS && pageTag !== PageTags.GUIDED_HELP_PHARMACY_SEARCH) {
            return true;
        }
        return false;
    }
    getFirstActiveTab() {
        // Assuming both MA and Medigap tabs do not exist, we need to select an option so that the
        // plan list page does not error out.  Get the default first active tab if there is one.
        const defaultActive = this.getDefaultActiveTab();
        let tabType = this.getTabType(defaultActive);
        // If there is not one check to see if there is a secondary active default.
        if (!tabType) {
            const defaultSecondaryActive = this.getDefaultSecondaryActive();
            tabType = this.getTabType(defaultSecondaryActive);
            if (!tabType) {
                // otherwise grab the first tab.
                const firstTab = this.tabs[0];
                tabType = this.getTabType(firstTab);
            }
        }
        return this.getTabPlanTypeAbbreviation(tabType);
    }
    getDefaultActiveTab() {
        return this.tabs.filter(tab => tab.defaultActive === true)[0];
    }
    getDefaultSecondaryActive() {
        return this.tabs.filter(tab => tab.secondaryDefaultActive === true)[0];
    }
    getTabType(tab) {
        return tab?.tabTypes ? tab.tabTypes[0] : undefined;
    }
    getCurrentPage(pageName) {
        return this.store.selectSnapshot(AppConfigState.page(pageName));
    }
    isBetween(age, minAge, maxAge) {
        return age >= minAge && age <= maxAge;
    }
    getTabPlanTypeAbbreviation(tabType) {
        switch (tabType) {
            case 'MAPD':
                return PlanTypeAbbreviation.MAPD;
            case 'MA':
                return PlanTypeAbbreviation.MA;
            case 'PDP':
                return PlanTypeAbbreviation.PDP;
            case 'MEDIGAP':
                return PlanTypeAbbreviation.MEDIGAP;
            default:
                return PlanTypeAbbreviation.MAPD;
        }
    }
}
GuidedHelpService.ɵfac = function GuidedHelpService_Factory(t) { return new (t || GuidedHelpService)(i0.ɵɵinject(NavigationService), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(i1.Store), i0.ɵɵinject(ResponsiveLayoutService), i0.ɵɵinject(i2$1.Router), i0.ɵɵinject(DemographicService), i0.ɵɵinject(DrugFrequencyFacade), i0.ɵɵinject(GoogleTagManagerService), i0.ɵɵinject(SiteService)); };
GuidedHelpService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: GuidedHelpService, factory: GuidedHelpService.ɵfac, providedIn: 'root' });
__decorate([
    Memoize()
], GuidedHelpService.prototype, "getMemberPreferenceAgeAnalyticsValue", null);
__decorate([
    Memoize()
], GuidedHelpService.prototype, "getMemberPreferenceCoverageAnalyticsValue", null);
__decorate([
    Memoize()
], GuidedHelpService.prototype, "getMemberPreferencesHealthAnalyticsValue", null);
__decorate([
    Memoize()
], GuidedHelpService.prototype, "getMemberPreferenceSubsidyAnalyticsValue", null);
__decorate([
    Memoize()
], GuidedHelpService.prototype, "_medicalOnlyPages", null);
__decorate([
    Memoize()
], GuidedHelpService.prototype, "getTabPlanTypeAbbreviation", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GuidedHelpService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: NavigationService }, { type: ConfigResourceService }, { type: i1.Store }, { type: ResponsiveLayoutService }, { type: i2$1.Router }, { type: DemographicService }, { type: DrugFrequencyFacade }, { type: GoogleTagManagerService }, { type: SiteService }]; }, { getMemberPreferenceAgeAnalyticsValue: [], getMemberPreferenceCoverageAnalyticsValue: [], getMemberPreferencesHealthAnalyticsValue: [], getMemberPreferenceSubsidyAnalyticsValue: [], _medicalOnlyPages: [], getTabPlanTypeAbbreviation: [] }); })();

class PreferencesContextService {
    constructor(preferencesService) {
        this.preferencesService = preferencesService;
        this._continue$ = new Subject();
        this.preferenceQuestionsPages = this.preferencesService.getPreferenceQuestionPagesByResource();
    }
    continue$() {
        return this._continue$.asObservable();
    }
    continue() {
        this._continue$.next(null);
    }
    updateQuestionPages(pages) {
        this.preferenceQuestionsPages = pages;
    }
}
PreferencesContextService.ɵfac = function PreferencesContextService_Factory(t) { return new (t || PreferencesContextService)(i0.ɵɵinject(PreferencesService)); };
PreferencesContextService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PreferencesContextService, factory: PreferencesContextService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PreferencesContextService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: PreferencesService }]; }, null); })();

// Providing this at the root should be fine as inputs should have unique ids.
// We can still inject this on a per widget basis if needed but shouldn't be
// necessary if care is taken to use unique ids for inputs.
class InputResetContextService {
    constructor() {
        this._clearInput$ = new BehaviorSubject('');
    }
    get clearInput$() {
        return this._clearInput$.asObservable();
    }
    clearInputById(id) {
        this._clearInput$.next(id);
    }
}
InputResetContextService.ɵfac = function InputResetContextService_Factory(t) { return new (t || InputResetContextService)(); };
InputResetContextService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: InputResetContextService, factory: InputResetContextService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InputResetContextService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

class JsonAnalyticsService {
    constructor(store) {
        this.store = store;
        const jsonAnalyticsDataTag = this.store.selectSnapshot(JsonAnalyticsTagManagerState.jsonAnalyticsDataLayerTag);
        if (jsonAnalyticsDataTag) {
            this.tags = {
                [JsonAnalyticsGlobalVariable.AGE_RANGE]: jsonAnalyticsDataTag[JsonAnalyticsGlobalVariable.AGE_RANGE]
                    ? jsonAnalyticsDataTag[JsonAnalyticsGlobalVariable.AGE_RANGE]
                    : null,
                [JsonAnalyticsGlobalVariable.APPLICATION_DATE]: jsonAnalyticsDataTag[JsonAnalyticsGlobalVariable.APPLICATION_DATE]
                    ? jsonAnalyticsDataTag[JsonAnalyticsGlobalVariable.APPLICATION_DATE]
                    : null,
                [JsonAnalyticsGlobalVariable.CONFIRMATION_ID]: jsonAnalyticsDataTag[JsonAnalyticsGlobalVariable.CONFIRMATION_ID]
                    ? jsonAnalyticsDataTag[JsonAnalyticsGlobalVariable.CONFIRMATION_ID]
                    : null,
                [JsonAnalyticsGlobalVariable.DOSAGES_COUNT]: jsonAnalyticsDataTag[JsonAnalyticsGlobalVariable.DOSAGES_COUNT]
                    ? jsonAnalyticsDataTag[JsonAnalyticsGlobalVariable.DOSAGES_COUNT]
                    : null,
                [JsonAnalyticsGlobalVariable.REQUESTED_EFFECTIVE_DATE]: jsonAnalyticsDataTag[JsonAnalyticsGlobalVariable.REQUESTED_EFFECTIVE_DATE]
                    ? jsonAnalyticsDataTag[JsonAnalyticsGlobalVariable.REQUESTED_EFFECTIVE_DATE]
                    : null,
                [JsonAnalyticsGlobalVariable.MONTHLY_PREMIUM]: jsonAnalyticsDataTag[JsonAnalyticsGlobalVariable.MONTHLY_PREMIUM]
                    ? jsonAnalyticsDataTag[JsonAnalyticsGlobalVariable.MONTHLY_PREMIUM]
                    : null,
                [JsonAnalyticsGlobalVariable.PLAN_NAME]: jsonAnalyticsDataTag[JsonAnalyticsGlobalVariable.PLAN_NAME]
                    ? jsonAnalyticsDataTag[JsonAnalyticsGlobalVariable.PLAN_NAME]
                    : null,
                [JsonAnalyticsGlobalVariable.PLAN_TYPE]: jsonAnalyticsDataTag[JsonAnalyticsGlobalVariable.PLAN_TYPE]
                    ? jsonAnalyticsDataTag[JsonAnalyticsGlobalVariable.PLAN_TYPE]
                    : null,
                [JsonAnalyticsGlobalVariable.PLAN_STARS]: jsonAnalyticsDataTag[JsonAnalyticsGlobalVariable.PLAN_STARS]
                    ? jsonAnalyticsDataTag[JsonAnalyticsGlobalVariable.PLAN_STARS]
                    : null,
                [JsonAnalyticsGlobalVariable.ZIP_CODE]: jsonAnalyticsDataTag[JsonAnalyticsGlobalVariable.ZIP_CODE]
                    ? jsonAnalyticsDataTag[JsonAnalyticsGlobalVariable.ZIP_CODE]
                    : null
            };
        }
        else {
            this.tags = {
                [JsonAnalyticsGlobalVariable.AGE_RANGE]: null,
                [JsonAnalyticsGlobalVariable.APPLICATION_DATE]: null,
                [JsonAnalyticsGlobalVariable.CONFIRMATION_ID]: null,
                [JsonAnalyticsGlobalVariable.DOSAGES_COUNT]: null,
                [JsonAnalyticsGlobalVariable.REQUESTED_EFFECTIVE_DATE]: null,
                [JsonAnalyticsGlobalVariable.MONTHLY_PREMIUM]: null,
                [JsonAnalyticsGlobalVariable.PLAN_NAME]: null,
                [JsonAnalyticsGlobalVariable.PLAN_TYPE]: null,
                [JsonAnalyticsGlobalVariable.PLAN_STARS]: null,
                [JsonAnalyticsGlobalVariable.ZIP_CODE]: null
            };
        }
    }
    set jsonAnalyticsTags(dataTag) {
        Object.keys(JsonAnalyticsGlobalVariable)
            .map(key => JsonAnalyticsGlobalVariable[key])
            .forEach(key => {
            if (dataTag[key]) {
                this.tags[key] = dataTag[key];
            }
        });
        this.addToDataLayer();
    }
    get jsonAnalyticsTags() {
        return this.tags;
    }
    setJsonAnalyticsTag(key, value) {
        this.tags[key] = value;
    }
    addToDataLayer() {
        const globalDataLayer = (window['Drx'] = { Web: { JsonAnalytics: { Payload: {} } } });
        if (globalDataLayer) {
            globalDataLayer.Web.JsonAnalytics.Payload = {
                ...this.tags
            };
            this.store.dispatch(new SetJsonAnalyticsDataLayerTag(this.tags));
        }
    }
}
JsonAnalyticsService.ɵfac = function JsonAnalyticsService_Factory(t) { return new (t || JsonAnalyticsService)(i0.ɵɵinject(i1.Store)); };
JsonAnalyticsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: JsonAnalyticsService, factory: JsonAnalyticsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JsonAnalyticsService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }]; }, null); })();

class LiveEditStateContext {
    constructor(store) {
        this.store = store;
    }
    get currentLiveEditState$() {
        return this.store.select(LiveEditState.selectedLiveEditState);
    }
    get currentLiveEditState() {
        return this.store.selectSnapshot(LiveEditState.selectedLiveEditState);
    }
    setLiveEditState(state) {
        this.store.dispatch(new SelectLiveEditState(state));
    }
}
LiveEditStateContext.ɵfac = function LiveEditStateContext_Factory(t) { return new (t || LiveEditStateContext)(i0.ɵɵinject(i1.Store)); };
LiveEditStateContext.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LiveEditStateContext, factory: LiveEditStateContext.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LiveEditStateContext, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }]; }, null); })();

const RESOURCE_REPLACEMENT_SELECTOR = '_resource_';
const RESOURCE_REPLACEMENT_REGEX = /_resource_\.(.*)/;
class LiveEditStateSelectorService {
    constructor(store, liveEditStateContext) {
        this.store = store;
        this.liveEditStateContext = liveEditStateContext;
    }
    applyState(state) {
        this.liveEditStateContext.setLiveEditState(state);
        // Update store
        this.processStoreOverrides(state);
    }
    getDefaultApplicationState() {
        return this.store.selectSnapshot(LiveEditState.defaultApplicationState);
    }
    processStoreOverrides(state) {
        // Set Store Overrides when the user selects a different state or when the default state overrides some properties
        if (state.name !== 'Default' || state.storeDataOverrides?.length > 0) {
            // Deep clone because application state properties are readonly and lodash set won't override
            let newApplicationState = _cloneDeep(this.getDefaultApplicationState());
            const storeDataOverrides = state.storeDataOverrides;
            if (storeDataOverrides) {
                newApplicationState = this.applyStoreOverrides(newApplicationState, state.storeDataOverrides);
            }
            this.setStoreOverrides(newApplicationState);
        }
        else {
            this.resetApplicationState();
        }
    }
    applyStoreOverrides(applicationState, overrides) {
        if (overrides) {
            overrides.forEach(override => {
                const overridePath = override.path;
                if (overridePath.startsWith(RESOURCE_REPLACEMENT_SELECTOR)) {
                    const resourceBundle = _get(applicationState, 'appConfig.resourceBundle');
                    // TODO: can enhance this for locale in the future. right now just grabbing the universal bundle
                    // as it should cover the vast majority of scenarios
                    const localeIndex = resourceBundle.findIndex(bundle => bundle.lang === null);
                    const appConfigResourcesPath = `appConfig.resourceBundle[${localeIndex}].resources`;
                    const resources = _get(applicationState, appConfigResourcesPath);
                    if (resources) {
                        const resourceMatch = RESOURCE_REPLACEMENT_REGEX.exec(overridePath);
                        if (resourceMatch) {
                            const resourceName = resourceMatch[1];
                            const resourceIndex = resources.findIndex(resource => resource.name === resourceName);
                            const appConfigResourcePath = `${appConfigResourcesPath}[${resourceIndex !== -1 ? resourceIndex : resources.length}].value`;
                            _set(applicationState, appConfigResourcePath, override.value);
                        }
                    }
                }
                else {
                    _set(applicationState, overridePath, override.value);
                }
            });
            return applicationState;
        }
    }
    async setStoreOverrides(state) {
        this.store.dispatch(new SetApplicationState(state));
    }
    resetApplicationState() {
        this.setStoreOverrides(this.getDefaultApplicationState());
    }
}
LiveEditStateSelectorService.ɵfac = function LiveEditStateSelectorService_Factory(t) { return new (t || LiveEditStateSelectorService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(LiveEditStateContext)); };
LiveEditStateSelectorService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LiveEditStateSelectorService, factory: LiveEditStateSelectorService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LiveEditStateSelectorService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }, { type: LiveEditStateContext }]; }, null); })();

const LIVE_EDIT_AGENT_DASHBOARD_STATES = {
    pageTag: PageTags.AGENT_DASHBOARD,
    states: [
        {
            name: 'Default',
            friendlyName: 'Agent Dashboard (Default)'
        }
    ]
};

const LIVE_EDIT_ENROLLMENT_CONFIRMATION_STATES = {
    pageTag: PageTags.ENROLLMENT_CONFIRMATION,
    states: [
        {
            name: 'Default',
            friendlyName: 'Enrollment Confirmation (Default)'
        },
        {
            name: 'Cross Sell Enrollment Confirmation',
            friendlyName: 'Cross Sell Enrollment Confirmation'
        },
        {
            name: 'Enrollment Unavailable',
            friendlyName: 'Enrollment Unavailable',
            storeDataOverrides: [
                {
                    path: '_resource_.Spa_Site_Enrollment_Enabled',
                    value: false
                },
                {
                    path: '_resource_.Spa_Site_MedSupEnrollment_Enabled',
                    value: false
                },
                {
                    path: '_resource_.Spa_Site_DentalEnrollment_Enabled',
                    value: false
                },
                {
                    path: '_resource_.Spa_Site_VisionEnrollment_Enabled',
                    value: false
                },
                {
                    path: '_resource_.Spa_Site_HIPEnrollment_Enabled',
                    value: false
                }
            ]
        }
    ]
};

var RiderSubTypes;
(function (RiderSubTypes) {
    RiderSubTypes["Dental"] = "Dental";
    RiderSubTypes["Hearing"] = "Hearing";
    RiderSubTypes["Vision"] = "Vision";
    RiderSubTypes["DentalRider"] = "Dental Rider";
    RiderSubTypes["VisionRider"] = "Vision Rider";
    RiderSubTypes["HearingRider"] = "Hearing Rider";
    RiderSubTypes["PediatricDentalRider"] = "Pediatric Dental Rider";
    RiderSubTypes["DentalVision"] = "Dental/Vision";
    RiderSubTypes["DentalHearing"] = "Dental/Hearing";
    RiderSubTypes["VisionHearing"] = "Vision/Hearing";
    RiderSubTypes["All"] = "Dental/Vision/Hearing";
    RiderSubTypes["CombinedRider"] = "Combined Rider";
    RiderSubTypes["CombinedAncillaryRider"] = "Combined Ancillary Rider";
    RiderSubTypes["CombinedAncillary"] = "Combined Ancillary";
})(RiderSubTypes || (RiderSubTypes = {}));
const DENTAL_RIDERS = [
    RiderSubTypes.Dental,
    RiderSubTypes.DentalRider,
    RiderSubTypes.DentalVision,
    RiderSubTypes.DentalHearing,
    RiderSubTypes.All,
    RiderSubTypes.CombinedAncillaryRider,
    RiderSubTypes.CombinedRider,
    RiderSubTypes.CombinedAncillary,
    RiderSubTypes.PediatricDentalRider
];
const VISION_RIDERS = [
    RiderSubTypes.Vision,
    RiderSubTypes.VisionRider,
    RiderSubTypes.DentalVision,
    RiderSubTypes.VisionHearing,
    RiderSubTypes.All,
    RiderSubTypes.CombinedAncillaryRider,
    RiderSubTypes.CombinedRider,
    RiderSubTypes.CombinedAncillary
];
const HEARING_RIDERS = [
    RiderSubTypes.Hearing,
    RiderSubTypes.HearingRider,
    RiderSubTypes.DentalHearing,
    RiderSubTypes.VisionHearing,
    RiderSubTypes.All,
    RiderSubTypes.CombinedAncillaryRider,
    RiderSubTypes.CombinedRider,
    RiderSubTypes.CombinedAncillary
];
class RiderCategory {
}
class RiderCompatibility {
}
class RiderBuckets {
    constructor() {
        this.dental = [];
        this.hearing = [];
        this.vision = [];
    }
}
var ExtendedPlanDetailsName;
(function (ExtendedPlanDetailsName) {
    ExtendedPlanDetailsName["RIDER_BENEFITS"] = "Rider Benefits";
    ExtendedPlanDetailsName["DENTAL_BENEFITS"] = "Dental Benefits";
    ExtendedPlanDetailsName["VISION_BENEFITS"] = "Vision Benefits";
    ExtendedPlanDetailsName["COMBINED_BENEFITS"] = "Combined Benefits";
})(ExtendedPlanDetailsName || (ExtendedPlanDetailsName = {}));

const MEDICARE_HIP_QUOTE_PLANS = [
    {
        id: '0KM7VVZRL8',
        contractId: 'H9999',
        planId: '003',
        segmentId: '257',
        planType: 4,
        planSubType: 'HMO',
        planYear: 2023,
        planName: 'Flexcare MA Plan 1',
        planEnrollmentInfo: {
            name: 'Flexcare MA Plan 1',
            address1: '123 Main Street',
            address2: null,
            city: 'Los Angeles',
            state: 'CA',
            zip: '90010',
            fax: null,
            businessPhone: '8001234567',
            ttyPhone: '711',
            hours: '8:00 a.m. to 8:00 p.m. Member time',
            chargedCreditCardOn: false,
            automatedTransferOn: true,
            automatedPremiumOn: true,
            monthlyBillOn: true
        },
        carrierId: 257,
        carrierName: 'DRX Demo',
        planRating: 4,
        planRatingValueDescription: '4 out of 5',
        medicalRating: 0,
        drugRating: 0,
        annualPlanPremium: 0,
        drugDeductible: null,
        drugPremium: 0,
        maximumOutOfPocketCost: 6700,
        maxOutOfPocketOutOfNetwork: 0,
        medicalDeductible: 0,
        medicalPremium: 0,
        initialCoverageLimit: null,
        planDataFields: [
            {
                benefitID: 4,
                name: 'Inpatient Hospital Care (In Network)',
                description: 'In-Network: $1460 copay per admission.',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 5,
                name: 'Inpatient Mental Health Care (In Network)',
                description: 'In-Network: $1260 copay per admission.',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 6,
                name: 'Skilled Nursing Facility (SNF) (In Network)',
                description: 'In-Network: $0 copay for days 1-20, $178 copay for days 21-100.',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 7,
                name: 'Home Health Care (In Network)',
                description: 'In-Network: $0 copay per visit',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 9,
                name: 'Doctor Office Visits (In Network)',
                description: 'In-Network: $20 copay per visit',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 10,
                name: 'Chiropractic Services (In Network)',
                description: 'In-Network: 20% coinsurance per visit for Medicare-covered Chiropractic Services',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 11,
                name: 'Podiatry Services (In Network)',
                description: 'In-Network: $50 copay for Medicare-covered Podiatry Services.',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 12,
                name: 'Outpatient Mental Health Care (In Network)',
                description: 'In-Network: 20% coinsurance per individual session.',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 13,
                name: 'Outpatient Substance Abuse (In Network)',
                description: 'In-Network: 20% coinsurance per individual session.',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 14,
                name: 'Outpatient Services/Surgery (In Network)',
                description: 'In-Network: $50 copay 20% coinsurance for Outpatient Hospital visits.',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 15,
                name: 'Ambulance Services (In Network)',
                description: 'In-Network: $265 copay per trip',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 16,
                name: 'Emergency Care (In Network)',
                description: 'In-Network: $90 copay per visit',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 17,
                name: 'Urgently Needed Care (In Network)',
                description: 'In-Network: $20-50 copay for Medicare-covered urgently-needed-care visits. Cost share may vary depending on where the service is provided.',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 19,
                name: 'Durable Medical Equipment (In Network)',
                description: 'In-Network: 20% coinsurance',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 20,
                name: 'Prosthetic Devices (In Network)',
                description: 'In-Network: 20% coinsurance for Medicare-covered Prosthetic Devices.',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 21,
                name: 'Diabetes Supplies and Services (In Network)',
                description: 'In-Network: $0 copay 10% coinsurance for Medicare-covered Diabetes Monitoring Supplies and Services',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 22,
                name: 'Diagnostic Tests, Lab and Radiology Services, and X-Rays (In Network)',
                description: 'In-Network: $0-50 copay 20% coinsurance for Medicare-covered diagnostic procedures and tests.In-Network: $0-15 copay for Medicare-covered lab services.In-Network: $0-150 copay for Medicare-covered diagnostic radiology services (not including x-rays).In-Network: $0 copay for Medicare-covered X-rays. Cost share may vary depending on where the service is provided.',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 31,
                name: 'Dental Services (In Network)',
                description: 'In-Network: $50 copay for Medicare-covered Dental Services',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 32,
                name: 'Hearing Services (In Network)',
                description: 'In-Network: $50 copay for Medicare-covered Hearing Services',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 33,
                name: 'Vision Services (In Network)',
                description: 'In-Network: $0-50 copay for Medicare-covered Vision Services. Cost share may vary depending on where the service is provided.',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 34,
                name: 'Physical Exams (In Network)',
                description: 'In-Network: $0 copay per visit',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 37,
                name: 'Acupuncture (In Network)',
                description: 'In-Network: $50 copay per visit',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 40,
                name: 'Doctor Specialty Visit (In Network)',
                description: 'In-Network: $50 copay per visit',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 41,
                name: 'Ambulatory Surgery Center (In Network)',
                description: 'In-Network: 20% coinsurance per visit',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 46,
                name: 'Medicare-covered diagnostic radiology services (not including x-rays) (In Network)',
                description: 'In-Network: $0-150 copay for Medicare-covered diagnostic radiology services (not including x-rays). Cost share may vary depending on where the service is provided.',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 48,
                name: 'Medicare-covered lab services (In Network)',
                description: 'In-Network: $0-15 copay for Medicare-covered lab services. Cost share may vary depending on where the service is provided.',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 49,
                name: 'Medicare-covered X-rays (In Network)',
                description: 'In-Network: $0 copay for Medicare-covered X-rays.',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 50,
                name: 'Medicare-Covered diagnostic procedures and tests (In Network)',
                description: 'In-Network: $0-50 copay 20% coinsurance for Medicare-covered diagnostic procedures and tests.',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 54,
                name: 'Renal Dialysis (In Network)',
                description: 'In-Network: 20% coinsurance for Renal Dialysis.',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 55,
                name: 'Over-the-Counter Items (In Network)',
                description: '$50.00 maximum benefit coverage amount every three months. Unused OTC amounts roll over to the next three months. This does not cover all of the OTC list which may be found in Chapter 4 of the Medicare Managed Care Manual.',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 150,
                name: 'Contact Lenses (In Network)',
                description: 'In-Network: $0 copay',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 319,
                name: 'Fitness Benefit (In Network)',
                description: "See the plan's Summary of Benefits",
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 333,
                name: 'Additional Telehealth (In Network)',
                description: 'In-Network: $0-50 copay per visit. Cost share may vary depending on where the service is provided.',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 375,
                name: 'Meal Benefit (In Network)',
                description: 'In-Network: $0 copay',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 378,
                name: 'Oral Exams (In Network)',
                description: 'In-Network: 0% coinsurance per visit',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 379,
                name: 'Eyeglasses (lenses and frames) (In Network)',
                description: 'In-Network: $0 copay',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 380,
                name: 'Medicare-covered Eyewear (In Network)',
                description: 'In-Network: $0 copay<br>$100.00 annual benefit maximum for eyewear.',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 381,
                name: 'Hearing Aids (all types) (In Network)',
                description: 'In-Network: $499-799 copay. Cost share may vary depending on where the service is provided.',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 382,
                name: 'Routine Hearing Exams (In Network)',
                description: 'In-Network: $0 copay per visit',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 383,
                name: 'Psychiatric Services (In Network)',
                description: 'In-Network: 20% coinsurance per visit',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 384,
                name: 'Chemotherapy/Radiation Drugs (In Network)',
                description: 'In-Network: 20% coinsurance',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 388,
                name: 'Part B Giveback (In Network)',
                description: 'While you are enrolled in this plan, DRX Demo will pay up to  $75.00 of your Medicare Part B premium. As a result, your monthly Social Security check will increase by this amount.',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 391,
                name: 'Dental Cleaning (In Network)',
                description: 'In-Network: 0-70% coinsurance. Cost share may vary depending on where the service is provided.',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 392,
                name: 'Dental X-rays (In Network)',
                description: 'In-Network: 0% coinsurance',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 393,
                name: 'Dental Fluoride Treatment (In Network)',
                description: 'In-Network: 0% coinsurance',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 395,
                name: 'Dental Restorative Services (In Network)',
                description: 'In-Network: 50-70% coinsurance. Cost share may vary depending on where the service is provided.',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 396,
                name: 'Dental Endodontics (In Network)',
                description: 'In-Network: 70% coinsurance',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 397,
                name: 'Dental Periodontics (In Network)',
                description: 'In-Network: 70% coinsurance',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 398,
                name: 'Dental Extractions (In Network)',
                description: 'In-Network: 50% coinsurance',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 399,
                name: 'Dental Prosthodontics (In Network)',
                description: 'In-Network: 70% coinsurance',
                type: 'In Network',
                isCovered: true
            },
            {
                benefitID: 404,
                name: 'Routine Eye Exams (In Network)',
                description: 'In-Network: $0 copay',
                type: 'In Network',
                isCovered: true
            }
        ],
        planTiers: [],
        documents: [],
        catastrophicLimit: 7400,
        riders: [],
        extendedPlanDetails: [
            {
                headerType: 1,
                ordinal: 1,
                name: 'Medical Coverage',
                toolTip: 'Indicates your medical costs for this plan, excluding your monthly premium',
                sectionDetails: [
                    {
                        description: 'Medical Deductible',
                        isEnrollLink: false,
                        isExternalLink: false,
                        isOutOfNetwork: false,
                        linkName: '',
                        value: '$0.00',
                        valueTypeID: 2,
                        ordinal: 1,
                        name: 'Medical Deductible'
                    },
                    {
                        description: 'In-Network Maximum Out Of Pocket',
                        isEnrollLink: false,
                        isExternalLink: false,
                        isOutOfNetwork: false,
                        linkName: '',
                        value: '$6,700.00',
                        valueTypeID: 2,
                        ordinal: 2,
                        name: 'In-Network Maximum Out Of Pocket'
                    },
                    {
                        description: 'Doctor Office Visits',
                        isEnrollLink: false,
                        isExternalLink: false,
                        isOutOfNetwork: false,
                        linkName: '',
                        value: 'In-Network: $20 copay per visit',
                        valueTypeID: 2,
                        ordinal: 3,
                        name: 'Doctor Office Visits'
                    },
                    {
                        description: 'Specialist Office Visit',
                        isEnrollLink: false,
                        isExternalLink: false,
                        isOutOfNetwork: false,
                        linkName: '',
                        value: 'In-Network: $50 copay per visit',
                        valueTypeID: 2,
                        ordinal: 4,
                        name: 'Specialist Office Visit'
                    },
                    {
                        description: 'Inpatient Hospital Care',
                        isEnrollLink: false,
                        isExternalLink: false,
                        isOutOfNetwork: false,
                        linkName: '',
                        value: 'In-Network: $1460 copay per admission.',
                        valueTypeID: 2,
                        ordinal: 5,
                        name: 'Inpatient Hospital Care'
                    },
                    {
                        description: 'Skilled Nursing Facility (SNF)',
                        isEnrollLink: false,
                        isExternalLink: false,
                        isOutOfNetwork: false,
                        linkName: '',
                        value: 'In-Network: $0 copay for days 1-20, $178 copay for days 21-100.',
                        valueTypeID: 2,
                        ordinal: 6,
                        name: 'Skilled Nursing Facility (SNF)'
                    },
                    {
                        description: 'Home Health Care',
                        isEnrollLink: false,
                        isExternalLink: false,
                        isOutOfNetwork: false,
                        linkName: '',
                        value: 'In-Network: $0 copay per visit',
                        valueTypeID: 2,
                        ordinal: 7,
                        name: 'Home Health Care'
                    },
                    {
                        description: 'Outpatient Mental Health Care',
                        isEnrollLink: false,
                        isExternalLink: false,
                        isOutOfNetwork: false,
                        linkName: '',
                        value: 'In-Network: 20% coinsurance per individual session.',
                        valueTypeID: 2,
                        ordinal: 9,
                        name: 'Outpatient Mental Health Care'
                    },
                    {
                        description: 'Outpatient Substance Abuse',
                        isEnrollLink: false,
                        isExternalLink: false,
                        isOutOfNetwork: false,
                        linkName: '',
                        value: 'In-Network: 20% coinsurance per individual session.',
                        valueTypeID: 2,
                        ordinal: 10,
                        name: 'Outpatient Substance Abuse'
                    },
                    {
                        description: 'Outpatient Services/Surgery',
                        isEnrollLink: false,
                        isExternalLink: false,
                        isOutOfNetwork: false,
                        linkName: '',
                        value: 'In-Network: $50 copay 20% coinsurance for Outpatient Hospital visits.',
                        valueTypeID: 2,
                        ordinal: 11,
                        name: 'Outpatient Services/Surgery'
                    },
                    {
                        description: 'Emergency Room',
                        isEnrollLink: false,
                        isExternalLink: false,
                        isOutOfNetwork: false,
                        linkName: '',
                        value: 'In-Network: $90 copay per visit',
                        valueTypeID: 2,
                        ordinal: 12,
                        name: 'Emergency Room'
                    },
                    {
                        description: 'Diabetes Supplies and Services',
                        isEnrollLink: false,
                        isExternalLink: false,
                        isOutOfNetwork: false,
                        linkName: '',
                        value: 'In-Network: $0 copay 10% coinsurance for Medicare-covered Diabetes Monitoring Supplies and Services',
                        valueTypeID: 2,
                        ordinal: 13,
                        name: 'Diabetes Supplies and Services'
                    },
                    {
                        description: 'Ambulance Services',
                        isEnrollLink: false,
                        isExternalLink: false,
                        isOutOfNetwork: false,
                        linkName: '',
                        value: 'In-Network: $265 copay per trip',
                        valueTypeID: 2,
                        ordinal: 14,
                        name: 'Ambulance Services'
                    },
                    {
                        description: 'Over-the-Counter Items',
                        isEnrollLink: false,
                        isExternalLink: false,
                        isOutOfNetwork: false,
                        linkName: '',
                        value: '$50.00 maximum benefit coverage amount every three months. Unused OTC amounts roll over to the next three months. This does not cover all of the OTC list which may be found in Chapter 4 of the Medicare Managed Care Manual.',
                        valueTypeID: 2,
                        ordinal: 15,
                        name: 'Over-the-Counter Items'
                    },
                    {
                        description: 'Chiropractic Services',
                        isEnrollLink: false,
                        isExternalLink: false,
                        isOutOfNetwork: false,
                        linkName: '',
                        value: 'In-Network: 20% coinsurance per visit for Medicare-covered Chiropractic Services',
                        valueTypeID: 2,
                        ordinal: 16,
                        name: 'Chiropractic Services'
                    },
                    {
                        description: 'Podiatry Services',
                        isEnrollLink: false,
                        isExternalLink: false,
                        isOutOfNetwork: false,
                        linkName: '',
                        value: 'In-Network: $50 copay for Medicare-covered Podiatry Services.',
                        valueTypeID: 2,
                        ordinal: 17,
                        name: 'Podiatry Services'
                    },
                    {
                        description: 'Meal Benefit',
                        isEnrollLink: false,
                        isExternalLink: false,
                        isOutOfNetwork: false,
                        linkName: '',
                        value: 'In-Network: $0 copay',
                        valueTypeID: 2,
                        ordinal: 18,
                        name: 'Meal Benefit'
                    },
                    {
                        description: 'Oral Exams',
                        isEnrollLink: false,
                        isExternalLink: false,
                        isOutOfNetwork: false,
                        linkName: '',
                        value: 'In-Network: 0% coinsurance per visit',
                        valueTypeID: 2,
                        ordinal: 21,
                        name: 'Oral Exams'
                    },
                    {
                        description: 'Eyeglasses (lenses and frames)',
                        isEnrollLink: false,
                        isExternalLink: false,
                        isOutOfNetwork: false,
                        linkName: '',
                        value: 'In-Network: $0 copay',
                        valueTypeID: 2,
                        ordinal: 22,
                        name: 'Eyeglasses (lenses and frames)'
                    },
                    {
                        description: 'Medicare-covered Eyewear',
                        isEnrollLink: false,
                        isExternalLink: false,
                        isOutOfNetwork: false,
                        linkName: '',
                        value: 'In-Network: $0 copay<br>$100.00 annual benefit maximum for eyewear.',
                        valueTypeID: 2,
                        ordinal: 23,
                        name: 'Medicare-covered Eyewear'
                    },
                    {
                        description: 'Hearing Aids (all types)',
                        isEnrollLink: false,
                        isExternalLink: false,
                        isOutOfNetwork: false,
                        linkName: '',
                        value: 'In-Network: $499-799 copay. Cost share may vary depending on where the service is provided.',
                        valueTypeID: 2,
                        ordinal: 24,
                        name: 'Hearing Aids (all types)'
                    },
                    {
                        description: 'Routine Hearing Exams',
                        isEnrollLink: false,
                        isExternalLink: false,
                        isOutOfNetwork: false,
                        linkName: '',
                        value: 'In-Network: $0 copay per visit',
                        valueTypeID: 2,
                        ordinal: 25,
                        name: 'Routine Hearing Exams'
                    },
                    {
                        description: 'Psychiatric Services',
                        isEnrollLink: false,
                        isExternalLink: false,
                        isOutOfNetwork: false,
                        linkName: '',
                        value: 'In-Network: 20% coinsurance per visit',
                        valueTypeID: 2,
                        ordinal: 26,
                        name: 'Psychiatric Services'
                    },
                    {
                        description: 'Chemotherapy/Radiation Drugs',
                        isEnrollLink: false,
                        isExternalLink: false,
                        isOutOfNetwork: false,
                        linkName: '',
                        value: 'In-Network: 20% coinsurance',
                        valueTypeID: 2,
                        ordinal: 27,
                        name: 'Chemotherapy/Radiation Drugs'
                    },
                    {
                        description: 'Part B Giveback',
                        isEnrollLink: false,
                        isExternalLink: false,
                        isOutOfNetwork: false,
                        linkName: '',
                        value: 'While you are enrolled in this plan, DRX Demo will pay up to  $75.00 of your Medicare Part B premium. As a result, your monthly Social Security check will increase by this amount.',
                        valueTypeID: 2,
                        ordinal: 28,
                        name: 'Part B Giveback'
                    }
                ]
            },
            {
                headerType: 1,
                ordinal: 2,
                name: 'Medical Coverage (Out-of-Network)',
                toolTip: 'Indicates your out-of-network medical costs for this plan.',
                sectionDetails: [
                    {
                        description: 'Combined In and Out of Network Maximum Out of Pocket',
                        isEnrollLink: false,
                        isExternalLink: false,
                        isOutOfNetwork: false,
                        linkName: '',
                        value: '$0.00',
                        valueTypeID: 2,
                        ordinal: 2,
                        name: 'Combined In and Out of Network Maximum Out of Pocket'
                    }
                ]
            }
        ],
        extraData: [
            {
                name: 'AllowCallRecordingMC',
                value: 'No'
            },
            {
                name: 'DisplaySEP',
                value: 'True'
            },
            {
                name: 'Enrollment_Confirmation_CharacterArray',
                value: '56789'
            },
            {
                name: 'Enrollment_Confirmation_DigitArray',
                value: '123456789'
            },
            {
                name: 'Enrollment_Confirmation_Format',
                value: '@#############'
            },
            {
                name: 'Enrollment_Confirmation_Prefix',
                value: 'A'
            },
            {
                name: 'Enrollment_Confirmation_Suffix',
                value: 'M'
            },
            {
                name: 'HRA',
                value: 'Internal'
            },
            {
                name: 'HRA_Enrollment_Confirmation_CharacterArray',
                value: '56789'
            },
            {
                name: 'HRA_Enrollment_Confirmation_DigitArray',
                value: '0123456789'
            },
            {
                name: 'HRA_Enrollment_Confirmation_Format',
                value: '@#############'
            },
            {
                name: 'HRA_Enrollment_Confirmation_Prefix',
                value: ''
            },
            {
                name: 'HRA_Enrollment_Confirmation_Suffix',
                value: ''
            },
            {
                name: 'HRACompleteWithinDays',
                value: '7'
            },
            {
                name: 'HRAUserType',
                value: '7'
            },
            {
                name: 'ModelDrugProgram',
                value: 'False'
            },
            {
                name: 'ProfessionalOnly',
                value: 'False'
            }
        ],
        hasDrugCoverage: false,
        hasMailDrugBenefits: false,
        hasPreferredMailPharmacyNetwork: false,
        hasPreferredPharmacyNetwork: true,
        hasPreferredRetailPharmacyNetwork: true,
        organizationName: 'DRX Demo',
        planTypeAbbreviation: PlanTypeAbbreviation.MA,
        providerURL: 'https://www.connecture.com',
        formularyExternalId: '',
        formularyVersion: '',
        planRetailDrugCoverageMultiPharmacy: [],
        planMailOrderDrugCoverage: [],
        isLowPerformingPlan: false,
        logoUrl: 'Flexcare_Logo150x50.jpg',
        carrierInformation: {
            carrierName: 'DRX Demo',
            organizationName: 'DRX Demo',
            carrierAddress: {
                address1: '123 Main Street',
                address2: null,
                city: 'Los Angeles',
                state: 'CA',
                zip: '90010'
            },
            phone: '8001234567',
            hours: '8:00 a.m. to 8:00 p.m. Member time',
            fax: '',
            phoneMemberTTY: '',
            phoneNonMemberTTY: '',
            websiteURL: 'https://www.connecture.com'
        },
        planAnnualCost: {
            annualCost: {
                pharmacyNABP: '4L9D4',
                totalEstimatedCost: 0
            },
            annualCostMultiPharmacy: [
                {
                    pharmacyNABP: '4L9D4',
                    totalEstimatedCost: 0
                }
            ]
        },
        planAnnualMailOrderCost: {
            annualCost: {}
        },
        isPUF: false,
        isNonPermissionedPlan: false,
        isBlacklistedPlan: false,
        showProviderSearch: false,
        planSNPCategories: [],
        planMarketingName: 'DRX Demo',
        planCarrierFilter: 'DRX Demo',
        rateFactors: []
    }
];
const HIP_QUOTE_PLANS = [
    {
        id: '1JNCP070QS',
        planType: 33554432,
        planSubType: 'HC',
        planName: 'Flexcare Group Hospital Indemnity 1',
        carrierId: 257,
        carrierName: 'DRX Demo',
        annualPlanPremium: 0,
        annualCalculatedPlanPremium: 500.52,
        drugDeductible: null,
        maxOutOfPocketOutOfNetwork: null,
        medicalDeductible: 0,
        medicalPremium: 41.71,
        initialCoverageLimit: null,
        planDataFields: [
            {
                benefitID: 298,
                name: 'Plan Highlights (In Network)',
                description: 'This is some additional information text used for testing the plan highlights feature.',
                type: 'In Network',
                isCovered: true
            }
        ],
        documents: [],
        riders: [
            {
                planID: 'KTZPT9WP8J',
                planName: 'Hospital Confinement Benefits',
                planType: 512,
                planSubType: 'Hospital Confinement Benefits',
                applicationFee: 0,
                hasCalculatedMedicalPremium: false,
                partnerRiders: null,
                extendedPlanDetails: [
                    {
                        headerType: 1,
                        ordinal: 1,
                        name: ExtendedPlanDetailsName.COMBINED_BENEFITS,
                        toolTip: '',
                        sectionDetails: [
                            {
                                description: 'Benefit Notes',
                                isEnrollLink: false,
                                isExternalLink: true,
                                isOutOfNetwork: false,
                                linkName: '',
                                value: '365 Day Lifetime Max',
                                valueTypeID: 2,
                                ordinal: 1,
                                name: 'Benefit Notes',
                            }
                        ]
                    }
                ],
                planTypeAbbreviation: 'RIDER',
                planTypeDescription: 'Hospital Confinement Benefits',
                isRequiredRider: false,
                isPlanOptionsRider: true,
                isWaiverStateRider: false,
                medicalPremium: 0,
                mergedRiderIDs: []
            },
            {
                planID: '1JVW4RNRLV',
                planName: 'Ambulance Benefits/Emergency Room Visit',
                planType: 512,
                planSubType: 'Ambulance Service or Emergency Room Visit',
                calculatedMedicalPremium: 9.24,
                applicationFee: 0,
                hasCalculatedMedicalPremium: true,
                partnerRiders: null,
                extendedPlanDetails: [
                    {
                        headerType: 1,
                        ordinal: 1,
                        name: ExtendedPlanDetailsName.COMBINED_BENEFITS,
                        toolTip: '',
                        sectionDetails: [
                            {
                                description: 'Benefit Amount',
                                isEnrollLink: false,
                                isExternalLink: true,
                                isOutOfNetwork: false,
                                linkName: '',
                                value: '$200 per Occurrence',
                                valueTypeID: 2,
                                ordinal: 1,
                                name: 'Benefit Amount'
                            },
                            {
                                description: 'Benefit Notes',
                                isEnrollLink: false,
                                isExternalLink: true,
                                isOutOfNetwork: false,
                                linkName: '',
                                value: 'Cannot Use Ambulance Service and Emergency Room Benefits on same day.  2 Occurrence Yearly Max',
                                valueTypeID: 2,
                                ordinal: 1,
                                name: 'Benefit Notes'
                            }
                        ]
                    }
                ],
                planTypeAbbreviation: 'RIDER',
                planTypeDescription: 'Ambulance Service or Emergency Room Visit',
                isRequiredRider: false,
                isPlanOptionsRider: true,
                isWaiverStateRider: false,
                medicalPremium: 0,
                mergedRiderIDs: []
            },
            {
                planID: '1K8BJB6LLJ',
                planName: 'Lump Sum Cancer Benefits',
                planType: 512,
                planSubType: 'Lump Sum Cancer Benefits',
                calculatedMedicalPremium: 31.67,
                applicationFee: 0,
                hasCalculatedMedicalPremium: true,
                partnerRiders: null,
                extendedPlanDetails: [
                    {
                        headerType: 1,
                        ordinal: 1,
                        name: ExtendedPlanDetailsName.COMBINED_BENEFITS,
                        toolTip: '',
                        sectionDetails: [
                            {
                                description: 'Benefit Amount',
                                isEnrollLink: false,
                                isExternalLink: true,
                                isOutOfNetwork: false,
                                linkName: '',
                                value: '$10000 per Lifetime',
                                valueTypeID: 2,
                                ordinal: 1,
                                name: 'Benefit Amount'
                            },
                            {
                                description: 'Benefit Notes',
                                isEnrollLink: false,
                                isExternalLink: true,
                                isOutOfNetwork: false,
                                linkName: '',
                                value: 'Physical Therapy',
                                valueTypeID: 2,
                                ordinal: 1,
                                name: 'Benefit Notes'
                            }
                        ]
                    }
                ],
                planTypeAbbreviation: 'RIDER',
                planTypeDescription: 'Lump Sum Cancer Benefits',
                isRequiredRider: false,
                isPlanOptionsRider: true,
                isWaiverStateRider: false,
                medicalPremium: 0,
                mergedRiderIDs: []
            },
            {
                planID: '181TCMDDBM',
                planName: 'Lump Sum Cancer Benefits',
                planType: 512,
                planSubType: 'Lump Sum Cancer Benefits',
                calculatedMedicalPremium: 7.92,
                applicationFee: 0,
                partnerRiders: null,
                hasCalculatedMedicalPremium: true,
                extendedPlanDetails: [
                    {
                        headerType: 1,
                        ordinal: 1,
                        name: ExtendedPlanDetailsName.COMBINED_BENEFITS,
                        toolTip: '',
                        sectionDetails: [
                            {
                                description: 'Benefit Amount',
                                isEnrollLink: false,
                                isExternalLink: true,
                                isOutOfNetwork: false,
                                linkName: '',
                                value: '$2500 per Lifetime',
                                valueTypeID: 2,
                                ordinal: 1,
                                name: 'Benefit Amount'
                            },
                            {
                                description: 'Benefit Notes',
                                isEnrollLink: false,
                                isExternalLink: true,
                                isOutOfNetwork: false,
                                linkName: '',
                                value: 'Physical Therapy',
                                valueTypeID: 2,
                                ordinal: 1,
                                name: 'Benefit Notes'
                            }
                        ]
                    }
                ],
                planTypeAbbreviation: 'RIDER',
                planTypeDescription: 'Lump Sum Cancer Benefits',
                isRequiredRider: false,
                isPlanOptionsRider: true,
                isWaiverStateRider: false,
                medicalPremium: 0,
                mergedRiderIDs: []
            }
        ],
        extendedPlanDetails: [],
        extraData: [
            {
                name: 'AllowCallRecordingMC',
                value: 'No'
            },
            {
                name: 'Enrollment_Confirmation_CharacterArray',
                value: '56789'
            },
            {
                name: 'Enrollment_Confirmation_DigitArray',
                value: '123456789'
            },
            {
                name: 'Enrollment_Confirmation_Format',
                value: '@#############'
            },
            {
                name: 'Enrollment_Confirmation_Prefix',
                value: 'H'
            },
            {
                name: 'Enrollment_Confirmation_Suffix',
                value: ''
            }
        ],
        planAnnualCost: null,
        organizationName: 'DRX Demo',
        planTypeAbbreviation: PlanTypeAbbreviation.HC,
        isLowPerformingPlan: false,
        carrierInformation: {
            carrierName: 'DRX Demo',
            organizationName: 'DRX Demo',
            carrierAddress: {
                address1: null,
                address2: null,
                city: null,
                state: null,
                zip: null
            },
            phone: '',
            hours: '',
            fax: '',
            phoneMemberTTY: '',
            phoneNonMemberTTY: '',
            websiteURL: 'https://www.connecture.com'
        },
        isPUF: false,
        isNonPermissionedPlan: false,
        isBlacklistedPlan: false,
        showProviderSearch: false,
        planCarrierFilter: 'DRX Demo',
        rateFactors: ['[2, Age]', '[30, BenefitAmount]', '[31, HCDaysCovered]']
    },
    {
        id: '0JLDT868B9',
        planType: 33554432,
        planSubType: 'HC',
        planName: 'Group Hospital Indemnity 1',
        carrierId: 13,
        carrierName: 'ACME',
        annualPlanPremium: 0,
        annualCalculatedPlanPremium: 500.52,
        drugDeductible: null,
        maxOutOfPocketOutOfNetwork: null,
        medicalDeductible: 0,
        medicalPremium: 41.71,
        initialCoverageLimit: null,
        planDataFields: [],
        documents: [],
        riders: [
            {
                planID: 'KTZPT9WP8J',
                planName: 'Hospital Confinement Benefits',
                planType: 512,
                planSubType: 'Hospital Confinement Benefits',
                applicationFee: 0,
                hasCalculatedMedicalPremium: false,
                partnerRiders: null,
                extendedPlanDetails: [
                    {
                        headerType: 1,
                        ordinal: 1,
                        name: ExtendedPlanDetailsName.COMBINED_BENEFITS,
                        toolTip: '',
                        sectionDetails: [
                            {
                                description: 'Benefit Notes',
                                isEnrollLink: false,
                                isExternalLink: true,
                                isOutOfNetwork: false,
                                linkName: '',
                                value: '365 Day Lifetime Max',
                                valueTypeID: 2,
                                ordinal: 1,
                                name: 'Benefit Notes'
                            }
                        ]
                    }
                ],
                planTypeAbbreviation: 'RIDER',
                planTypeDescription: 'Hospital Confinement Benefits',
                isRequiredRider: false,
                isPlanOptionsRider: true,
                isWaiverStateRider: false,
                medicalPremium: 0,
                mergedRiderIDs: []
            },
            {
                planID: '1JVW4RNRLV',
                planName: 'Ambulance Benefits/Emergency Room Visit',
                planType: 512,
                planSubType: 'Ambulance Service or Emergency Room Visit',
                calculatedMedicalPremium: 9.24,
                applicationFee: 0,
                partnerRiders: null,
                hasCalculatedMedicalPremium: true,
                extendedPlanDetails: [
                    {
                        headerType: 1,
                        ordinal: 1,
                        name: ExtendedPlanDetailsName.COMBINED_BENEFITS,
                        toolTip: '',
                        sectionDetails: [
                            {
                                description: 'Benefit Amount',
                                isEnrollLink: false,
                                isExternalLink: true,
                                isOutOfNetwork: false,
                                linkName: '',
                                value: '$200 per Occurrence',
                                valueTypeID: 2,
                                ordinal: 1,
                                name: 'Benefit Amount'
                            },
                            {
                                description: 'Benefit Notes',
                                isEnrollLink: false,
                                isExternalLink: true,
                                isOutOfNetwork: false,
                                linkName: '',
                                value: 'Cannot Use Ambulance Service and Emergency Room Benefits on same day.  2 Occurrence Yearly Max',
                                valueTypeID: 2,
                                ordinal: 1,
                                name: 'Benefit Notes'
                            }
                        ]
                    }
                ],
                planTypeAbbreviation: 'RIDER',
                planTypeDescription: 'Ambulance Service or Emergency Room Visit',
                isRequiredRider: false,
                isPlanOptionsRider: true,
                isWaiverStateRider: false,
                medicalPremium: 0,
                mergedRiderIDs: []
            },
            {
                planID: '1K8BJB6LLJ',
                planName: 'Lump Sum Cancer Benefits',
                planType: 512,
                planSubType: 'Lump Sum Cancer Benefits',
                calculatedMedicalPremium: 31.67,
                applicationFee: 0,
                partnerRiders: null,
                hasCalculatedMedicalPremium: true,
                extendedPlanDetails: [
                    {
                        headerType: 1,
                        ordinal: 1,
                        name: ExtendedPlanDetailsName.COMBINED_BENEFITS,
                        toolTip: '',
                        sectionDetails: [
                            {
                                description: 'Benefit Amount',
                                isEnrollLink: false,
                                isExternalLink: true,
                                isOutOfNetwork: false,
                                linkName: '',
                                value: '$10000 per Lifetime',
                                valueTypeID: 2,
                                ordinal: 1,
                                name: 'Benefit Amount'
                            },
                            {
                                description: 'Benefit Notes',
                                isEnrollLink: false,
                                isExternalLink: true,
                                isOutOfNetwork: false,
                                linkName: '',
                                value: 'Physical Therapy',
                                valueTypeID: 2,
                                ordinal: 1,
                                name: 'Benefit Notes'
                            }
                        ]
                    }
                ],
                planTypeAbbreviation: 'RIDER',
                planTypeDescription: 'Lump Sum Cancer Benefits',
                isRequiredRider: false,
                isPlanOptionsRider: true,
                isWaiverStateRider: false,
                medicalPremium: 0,
                mergedRiderIDs: []
            },
            {
                planID: '181TCMDDBM',
                planName: 'Lump Sum Cancer Benefits',
                planType: 512,
                planSubType: 'Lump Sum Cancer Benefits',
                calculatedMedicalPremium: 7.92,
                applicationFee: 0,
                partnerRiders: null,
                hasCalculatedMedicalPremium: true,
                extendedPlanDetails: [
                    {
                        headerType: 1,
                        ordinal: 1,
                        name: ExtendedPlanDetailsName.COMBINED_BENEFITS,
                        toolTip: '',
                        sectionDetails: [
                            {
                                description: 'Benefit Amount',
                                isEnrollLink: false,
                                isExternalLink: true,
                                isOutOfNetwork: false,
                                linkName: '',
                                value: '$2500 per Lifetime',
                                valueTypeID: 2,
                                ordinal: 1,
                                name: 'Benefit Amount'
                            },
                            {
                                description: 'Benefit Notes',
                                isEnrollLink: false,
                                isExternalLink: true,
                                isOutOfNetwork: false,
                                linkName: '',
                                value: 'Physical Therapy',
                                valueTypeID: 2,
                                ordinal: 1,
                                name: 'Benefit Notes'
                            }
                        ]
                    }
                ],
                planTypeAbbreviation: 'RIDER',
                planTypeDescription: 'Lump Sum Cancer Benefits',
                isRequiredRider: false,
                isPlanOptionsRider: true,
                isWaiverStateRider: false,
                medicalPremium: 0,
                mergedRiderIDs: []
            }
        ],
        extendedPlanDetails: [],
        extraData: [
            {
                name: 'AllowCallRecordingMC',
                value: 'No'
            },
            {
                name: 'Enrollment_Confirmation_CharacterArray',
                value: '56789'
            },
            {
                name: 'Enrollment_Confirmation_DigitArray',
                value: '123456789'
            },
            {
                name: 'Enrollment_Confirmation_Format',
                value: '@#############'
            },
            {
                name: 'Enrollment_Confirmation_Prefix',
                value: 'H'
            },
            {
                name: 'Enrollment_Confirmation_Suffix',
                value: ''
            }
        ],
        planAnnualCost: null,
        organizationName: 'ACME',
        planTypeAbbreviation: PlanTypeAbbreviation.HC,
        isLowPerformingPlan: false,
        carrierInformation: {
            carrierName: 'ACME',
            organizationName: 'ACME',
            carrierAddress: {
                address1: null,
                address2: null,
                city: null,
                state: null,
                zip: null
            },
            phone: '',
            hours: '',
            fax: '',
            phoneMemberTTY: '',
            phoneNonMemberTTY: '',
            websiteURL: ''
        },
        isPUF: false,
        isNonPermissionedPlan: false,
        isBlacklistedPlan: false,
        showProviderSearch: false,
        planCarrierFilter: 'ACME',
        rateFactors: ['[2, Age]', '[30, BenefitAmount]', '[31, HCDaysCovered]']
    }
];

function getPlansState() {
    return {
        [PlanType.MEDICARE]: {
            loading: false,
            loaded: true,
            dirty: false,
            pharmacies: [],
            payload: MEDICARE_HIP_QUOTE_PLANS.reduce((plansMap, plan) => {
                plansMap[plan.id] = plan;
                return plansMap;
            }, {})
        },
        [PlanType.HC]: {
            loading: false,
            loaded: true,
            dirty: false,
            pharmacies: [],
            payload: HIP_QUOTE_PLANS.reduce((plansMap, plan) => {
                plansMap[plan.id] = plan;
                return plansMap;
            }, {})
        }
    };
}
const LIVE_EDIT_HIP_QUOTE_SUMMARY_STATES = {
    pageTag: PageTags.HOSPITAL_INDEMNITY_VIEW_QUOTE,
    states: [
        {
            name: 'Default',
            friendlyName: 'Quote 1 Medicare and 2 HI plans (Default)',
            storeDataOverrides: [
                { path: 'plans.planTypeDataMap', value: getPlansState() },
                { path: 'plans.activePlansTabType', value: PlanTypeAbbreviation.HC }
            ]
        }
    ]
};

const LIVE_EDIT_HOME_STATES = {
    pageTag: PageTags.HOME,
    states: [
        {
            name: 'Default',
            friendlyName: 'Default (Default)'
        },
        {
            name: 'Logged In',
            friendlyName: 'Logged In',
            storeDataOverrides: [
                {
                    path: '_resource_.Spa_Site_Consumer_AccountOverview_Enabled',
                    value: true
                },
                {
                    path: '_resource_.Spa_Site_Login_Widget_Enabled',
                    value: true
                },
                {
                    path: 'member.isLoggedIn',
                    value: true
                },
                {
                    path: 'member.profile.firstName',
                    value: 'Test'
                },
                {
                    path: 'member.profile.lastName',
                    value: 'User'
                }
            ]
        }
    ]
};

// TODO: test and clean up when general no plans state bug is fixed.
// currently the page doesn't load
function getNoPlansState() {
    const defaultPlanTypeDataMap = PlansState.getDefaultPlanTypeDataMap();
    return Object.keys(defaultPlanTypeDataMap).reduce((dataMap, key) => {
        dataMap[key].loaded = true;
        dataMap[key].loading = false;
        dataMap[key].dirty = false;
        return dataMap;
    }, defaultPlanTypeDataMap);
}
const LIVE_EDIT_PLANLIST_STATES = {
    pageTag: PageTags.PLAN_LIST,
    states: [
        {
            name: 'Default',
            friendlyName: 'Show Plans (Default)'
        },
        {
            name: 'No plans',
            friendlyName: 'No plans',
            storeDataOverrides: [{ path: 'plans.planTypeDataMap', value: getNoPlansState() }]
        },
        {
            name: 'Show medsup form',
            friendlyName: 'Show medsup form'
        }
    ]
};

const LIVE_EDIT_PROFILE_SEARCH_STATES = {
    pageTag: PageTags.PROFILE_SEARCH,
    states: [
        {
            name: 'No profile found',
            friendlyName: 'No profile found',
            storeDataOverrides: [{ path: 'agent.memberSearch', value: [] }]
        }
    ]
};

const LIVE_EDIT_SHOPPING_CART_STATES = {
    pageTag: PageTags.SHOPPING_CART,
    states: [
        {
            name: 'Default',
            friendlyName: 'Shopping Cart (Default)'
        },
        {
            name: 'Enrollment Unavailable',
            friendlyName: 'Enrollment Unavailable',
            storeDataOverrides: [
                {
                    path: '_resource_.Spa_Site_Enrollment_Enabled',
                    value: false
                },
                {
                    path: '_resource_.Spa_Site_MedSupEnrollment_Enabled',
                    value: false
                },
                {
                    path: '_resource_.Spa_Site_DentalEnrollment_Enabled',
                    value: false
                },
                {
                    path: '_resource_.Spa_Site_VisionEnrollment_Enabled',
                    value: false
                },
                {
                    path: '_resource_.Spa_Site_HIPEnrollment_Enabled',
                    value: false
                }
            ]
        }
    ]
};

class LiveEditStateLookUpService {
    constructor() {
        this.states = [
            LIVE_EDIT_PROFILE_SEARCH_STATES,
            LIVE_EDIT_PLANLIST_STATES,
            LIVE_EDIT_ENROLLMENT_CONFIRMATION_STATES,
            LIVE_EDIT_SHOPPING_CART_STATES,
            LIVE_EDIT_HOME_STATES,
            LIVE_EDIT_AGENT_DASHBOARD_STATES,
            LIVE_EDIT_HIP_QUOTE_SUMMARY_STATES
        ];
    }
    getStates(pageTags) {
        if (pageTags && pageTags.length) {
            const states = pageTags.reduce((foundStates, pageTag) => {
                const foundPageState = this.states.find(state => state.pageTag === pageTag);
                if (foundPageState && foundPageState.states && foundPageState.states.length) {
                    foundStates = [...foundStates, ...foundPageState.states];
                }
                return foundStates;
            }, []);
            // Apply default state if not defined in page specific states
            if (!states.some(state => state.name === 'Default')) {
                states.push(this.getDefaultState());
            }
            if (states.length) {
                return this.sortStatesByName(states);
            }
            console.log(`Unable to find live edit state for: ${pageTags.join(',')}`);
        }
        return null;
    }
    getDefaultState() {
        return { name: 'Default', friendlyName: 'Default' };
    }
    sortStatesByName(states) {
        return states.sort((a, b) => {
            if (a.name < b.name) {
                return -1;
            }
            if (a.name > b.name) {
                return 1;
            }
            return 0;
        });
    }
}
LiveEditStateLookUpService.ɵfac = function LiveEditStateLookUpService_Factory(t) { return new (t || LiveEditStateLookUpService)(); };
LiveEditStateLookUpService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LiveEditStateLookUpService, factory: LiveEditStateLookUpService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LiveEditStateLookUpService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

const LOGIN_STATUS = 'login-status';
class LoginStatusResolver {
    constructor(routeAuthorizationService) {
        this.routeAuthorizationService = routeAuthorizationService;
    }
    async resolve(route) {
        const url = route.url.join('/');
        await this.routeAuthorizationService.checkAndResetLoginStatus(url);
    }
}
LoginStatusResolver.ɵfac = function LoginStatusResolver_Factory(t) { return new (t || LoginStatusResolver)(i0.ɵɵinject(RouteAuthorizationService)); };
LoginStatusResolver.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LoginStatusResolver, factory: LoginStatusResolver.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoginStatusResolver, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: RouteAuthorizationService }]; }, null); })();

class ConsumerAccountSummaryGuard {
    constructor(store, configResourceService, navigationService, siteService) {
        this.store = store;
        this.configResourceService = configResourceService;
        this.navigationService = navigationService;
        this.siteService = siteService;
    }
    canActivate(route, state) {
        if (EnvironmentService.getEnvironment().liveedit) {
            return true;
        }
        const consumerAccountOverviewEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_Consumer_AccountOverview_Enabled', null, false);
        const memberLoggedIn = !this.siteService.isPPCSite() && this.store.selectSnapshot(MemberState.isLoggedIn);
        const canActivate = consumerAccountOverviewEnabled && memberLoggedIn;
        if (!canActivate) {
            this.navigationService.navigateByPageTag(PageTags.HOME);
        }
        return canActivate;
    }
}
ConsumerAccountSummaryGuard.ɵfac = function ConsumerAccountSummaryGuard_Factory(t) { return new (t || ConsumerAccountSummaryGuard)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(NavigationService), i0.ɵɵinject(SiteService)); };
ConsumerAccountSummaryGuard.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ConsumerAccountSummaryGuard, factory: ConsumerAccountSummaryGuard.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConsumerAccountSummaryGuard, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }, { type: ConfigResourceService }, { type: NavigationService }, { type: SiteService }]; }, null); })();

class MedicareGroupGuard {
    constructor(store, configResourceService, navigationService, siteService) {
        this.store = store;
        this.configResourceService = configResourceService;
        this.navigationService = navigationService;
        this.siteService = siteService;
    }
    canActivate(route, state) {
        if (EnvironmentService.getEnvironment().liveedit) {
            return true;
        }
        const medicareGroupEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_MedicareGroup_Enabled', null, false);
        if (medicareGroupEnabled) {
            const hasMedicareGroupParam = !!route?.queryParams?.MedicareGroupID;
            const medicareGroupPlanConfiguration = this.store.selectSnapshot(PlansState.medicareGroupPlanConfiguration);
            let canActivate = !this.siteService.isPPCSite() && hasMedicareGroupParam;
            if (canActivate) {
                const medicareGroupId = route?.queryParams?.MedicareGroupID;
                const medicareGroupPlanConfig = this.getMedicareGroupPlanConfiguration(medicareGroupId);
                if (medicareGroupPlanConfig) {
                    this.store.dispatch(new SetMedicareGroupPlanConfiguration(medicareGroupPlanConfig));
                }
                else {
                    canActivate = false;
                }
            }
            else if (medicareGroupPlanConfiguration?.medicareGroupId) {
                const medicareGroupPlanConfig = this.getMedicareGroupPlanConfiguration(medicareGroupPlanConfiguration.medicareGroupId);
                if (medicareGroupPlanConfig) {
                    canActivate = true;
                }
            }
            if (!canActivate) {
                this.redirect();
            }
            return canActivate;
        }
        else {
            return true;
        }
    }
    getMedicareGroupPlanConfiguration(medicareGroupId) {
        const medicareGroupPlanConfigurations = this.configResourceService.getProcessedResourceValue('Spa_MedicareGroup_PlanConfiguration_Json', null, null);
        return medicareGroupPlanConfigurations?.find(config => config.medicareGroupId === medicareGroupId);
    }
    redirect() {
        this.navigationService.navigateByPageTag(PageTags.GROUP_MESSAGE);
    }
}
MedicareGroupGuard.ɵfac = function MedicareGroupGuard_Factory(t) { return new (t || MedicareGroupGuard)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(NavigationService), i0.ɵɵinject(SiteService)); };
MedicareGroupGuard.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MedicareGroupGuard, factory: MedicareGroupGuard.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedicareGroupGuard, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }, { type: ConfigResourceService }, { type: NavigationService }, { type: SiteService }]; }, null); })();

class TextMessageHttpRequest {
}
class TextMessageHttpResponse {
}
class ShortUrlHttpRequest {
}
class ShortUrlHttpResponse {
}

class MillimanService {
    constructor(shoppingCartService, configResource, store, medSupService, modalService, planYearResourceService, stringFormatUtilityService) {
        this.shoppingCartService = shoppingCartService;
        this.configResource = configResource;
        this.store = store;
        this.medSupService = medSupService;
        this.modalService = modalService;
        this.planYearResourceService = planYearResourceService;
        this.stringFormatUtilityService = stringFormatUtilityService;
        this.parametersDictionary = this.configResource.getProcessedResourceValue('Spa_MillimanService_ParametersDictionary', null, "<dictionary><key name='ApplicantSSN'>SSN</key><key name='ApplicantLastName'>LastName</key><key name='ApplicantFirstName'>FirstName</key><key name='ApplicantGender'>Gender</key><key name='ApplicantBirthDate'>DOB</key><key name='ApplicantState'>State</key><key name='ApplicantZip'>ZipCode</key><key name='Relationship'>Relationship</key><key name='ApplicantMiddleInitial'>MiddleName</key><key name='ApplicantAddress1' isAdditionalAttribute='true'>Address1</key><key name='ApplicantAddress2' isAdditionalAttribute='true'>Address2</key><key name='Angina' isAdditionalAttribute='true'>Angina</key><key name='HeartAttack' isAdditionalAttribute='true'>HeartAttack</key><key name='AtrialFibrillation' isAdditionalAttribute='true'>AFib</key><key name='Flutter' isAdditionalAttribute='true'>AFib</key><key name='CoronaryDisease' isAdditionalAttribute='true'>CardiacDisease</key><key name='CarotidArteryDisease' isAdditionalAttribute='true'>CardiacDisease</key><key name='congestiveHeartFailure' isAdditionalAttribute='true'>CHF</key><key name='LungOrRespiratoryConditions' isAdditionalAttribute='true'>RespiratoryCOPDOther</key><key name='CancersOrTumors' isAdditionalAttribute='true'>Cancer</key><key name='AlzheimersDisease' isAdditionalAttribute='true'>Dementia</key><key name='Dementia' isAdditionalAttribute='true'>Dementia</key><key name='multipleSclerosis' isAdditionalAttribute='true'>MS</key><key name='parkinsonsDisease' isAdditionalAttribute='true'>Parkinsons</key><key name='Diabetes' isAdditionalAttribute='true'>DiabetesComplications</key><key name='KidneyConditions' isAdditionalAttribute='true'>Kidney</key><key name='LiverConditions' isAdditionalAttribute='true'>Liver</key><key name='CrohnsDisease' isAdditionalAttribute='true'>Crohns</key><key name='UlcerativeColitis' isAdditionalAttribute='true'>UlcerativeColitis</key><key name='Lupus' isAdditionalAttribute='true'>Lupus</key><key name='rhuematoidArthritis' isAdditionalAttribute='true'>RA</key><key name='otherImmuneDeficiency' isAdditionalAttribute='true'>ImmuneDeficiency</key><key name='Bipolar' isAdditionalAttribute='true'>Bipolar</key><key name='Schizophrenia' isAdditionalAttribute='true'>Schizophrenia</key><key name='MajorDepression' isAdditionalAttribute='true'>Depression</key><key name='Anxiety' isAdditionalAttribute='true'>Anxiety</key><key name='MildDepression' isAdditionalAttribute='true'>Anxiety</key><key name='athritisHipKnee' isAdditionalAttribute='true'>Osteoarthritis</key><key name='asthma' isAdditionalAttribute='true'>RespiratoryOther</key><key name='diabetesNoComplications' isAdditionalAttribute='true'>Diabetes</key><key name='enlargedProstate' isAdditionalAttribute='true'>BPH</key><key name='fibromyalgia' isAdditionalAttribute='true'>Fibromyalgia</key><key name='GERDAcidReflux' isAdditionalAttribute='true'>Gastrointestinal</key><key name='Glaucoma' isAdditionalAttribute='true'>Glaucoma</key><key name='MacularDegeneration' isAdditionalAttribute='true'>MacularDegeneration</key><key name='highBloodPressure' isAdditionalAttribute='true'>Hypertension</key><key name='highCholesterol' isAdditionalAttribute='true'>Hyperlipidemia</key><key name='Hypothyroidism' isAdditionalAttribute='true'>Hypothyroidism</key><key name='Hyperthyroidism' isAdditionalAttribute='true'>Hyperthyroidism</key><key name='migraines' isAdditionalAttribute='true'>Migraine</key><key name='myastheniaGravis' isAdditionalAttribute='true'>MyastheniaGravis</key><key name='osteoporosis' isAdditionalAttribute='true'>Osteoporosis</key><key name='psoriasis' isAdditionalAttribute='true'>Psoriasis</key><key name='HeightFtIn' isAdditionalAttribute='true'>Height</key><key name='WeightLbs' isAdditionalAttribute='true'>Weight</key></dictionary>");
        this.medigapAnswersUniqueNames = this.getMedigapAnswersUniqueNames();
        this.uniqueNamesForStaticValue = this.configResource.getProcessedResourceValue('Spa_MillimanService_UniqueNamesForStaticValue', null, 'MedicalQuestionDialysis,MedicalConditionPastTwoYears');
        this.orderReference = this.configResource.getProcessedResourceValue('Spa_MillimanService_OrderReference', null, '1');
        this.gpiPriorityList = this.configResource.getProcessedResourceValue('Spa_MillimanService_GPIPriorityList', null, 'MEDIGAPPPO');
        this.maxRetries = this.configResource.getProcessedResourceValue('Spa_MillimanService_MaximumRetries_Number', null, 12);
        this.requestType = this.configResource.getProcessedResourceValue('Spa_MillimanService_RequestType', null, 'INDIVIDUAL');
        this.premiumUniqueName = this.configResource.getProcessedResourceValue('Spa_MillimanService_PremiumUniqueName', null, 'MedigapPremium');
    }
    isMedSupMillimanEnabled() {
        return this.configResource.getProcessedResourceValue('Spa_MedSup_Milliman_Enabled', null, false);
    }
    isMillimanServiceEnabled() {
        return this.configResource.getProcessedResourceValue('Spa_MillimanService_Enabled', null, false);
    }
    initializeMilliman() {
        this.store.dispatch(new InitializeMilliman());
    }
    clearAndSetMillimanTier(millimanTier, retainHealthInformation) {
        const millimanUpdates = {
            serviceCalledNow: false,
            serviceCalledBefore: false,
            currentTier: millimanTier,
            newTier: millimanTier,
            uwFlag: '',
            error: null
        };
        const milliman = retainHealthInformation
            ? millimanUpdates
            : {
                healthInformation: null,
                ...millimanUpdates
            };
        this.store.dispatch(new UpdateMilliman(milliman));
    }
    setMillimanTier(millimanTier) {
        this.store.dispatch(new SetMillimanTier(millimanTier));
    }
    async invokeMedSupMillimanService(sessionId) {
        const millimanRequest = this.createDefaultMillimanRequest();
        return await this.store.dispatch(new InvokeMillimanService(sessionId, null, millimanRequest)).toPromise();
    }
    syncWithMedSupAnswers() {
        const milliman = this.store.selectSnapshot(MillimanState.milliman);
        const updateAnswers = [
            {
                ...this.medSupService.getMedSupQuestion(MedSupPlanQuestionIds.NBDIndicator),
                value: this.stringFormatUtilityService.capitalizeFirstLetter(`${milliman?.nbdIndicator}`)
            },
            { ...this.medSupService.getMedSupQuestion(MedSupPlanQuestionIds.MillimanUWTier), value: milliman?.newTier }
        ];
        this.medSupService.updateMedSupAnswers(updateAnswers);
    }
    async invokeMillimanService(sessionId, transactionId, millimanRequest) {
        return await this.store
            .dispatch(new InvokeMillimanService(sessionId, transactionId, millimanRequest || this.createDefaultMillimanRequest()))
            .toPromise();
    }
    getMillimanServiceInvokePageName() {
        return this.configResource.getProcessedResourceValue('Spa_MillimanService_PageControlName', null, 'YourHealthInformation2');
    }
    hasMillimanRateChanged() {
        const millimanPremiumChanged = this.store.selectSnapshot(MillimanState.premiumChanged);
        if (millimanPremiumChanged !== null && millimanPremiumChanged !== undefined) {
            return millimanPremiumChanged;
        }
        const millimanPremium = this.getMillimanNewPremium();
        return millimanPremium ? millimanPremium !== this.shoppingCartService.getShoppingCartPremium() : false;
    }
    hasMillimanTierChanged() {
        const newTier = this.getMillimanNewTier();
        return newTier && this.getMillimanCurrentTier() !== newTier;
    }
    hasMillimanServiceBeenCalled() {
        return this.store.selectSnapshot(MillimanState.hasMillimanServiceBeenCalled);
    }
    getMillimanInvokedPlanId() {
        return this.store.selectSnapshot(MillimanState.invokedPlanId);
    }
    getMillimanNewPremium() {
        return this.store.selectSnapshot(MillimanState.newPremium);
    }
    getMillimanCurrentPremium() {
        return this.store.selectSnapshot(MillimanState.currentPremium);
    }
    getMillimanServiceError$() {
        return this.store.select(MillimanState.error);
    }
    getMillimanServiceError() {
        return this.store.selectSnapshot(MillimanState.error);
    }
    getMillimanLoading$() {
        return this.store.select(MillimanState.loading);
    }
    getMillimanCurrentTier() {
        return this.store.selectSnapshot(MillimanState.currentTier);
    }
    getMillimanNewTier() {
        return this.store.selectSnapshot(MillimanState.newTier);
    }
    getMemberMedigapAnswers() {
        return this.medSupService.getMemberMedigapAnswers();
    }
    setInvokedPlanId(invokedPlanId) {
        this.store.dispatch(new UpdateMilliman({ invokedPlanId }));
    }
    hasMillimanServiceBeenCalledForPlan(plans) {
        return plans?.some(plan => plan.id === this.getMillimanInvokedPlanId()) ? this.hasMillimanServiceBeenCalled() : false;
    }
    async invokeAndProcessMillimanService(sessionId, confirmAction) {
        await this.invokeMedSupMillimanService(sessionId);
        this.syncWithMedSupAnswers();
        if (this.getMillimanServiceError() !== null) {
            this.openMillimanErrorModal(confirmAction);
            return false;
        }
        return true;
    }
    updateMillimanUWTierMedigapAnswer(newTier) {
        if (newTier && MillimanTier[newTier]) {
            const sessionId = this.store.selectSnapshot(MemberState.sessionId);
            const year = this.planYearResourceService.getSelectedPlanYear();
            const questions = this.medSupService.getMedSupQuestions();
            const updatedQuestions = questions.map(question => {
                if (question.name === MedSupQuestionNames.MillimanUWTier) {
                    return {
                        ...question,
                        value: newTier
                    };
                }
                return { ...question };
            });
            if (this.isMedSupMillimanEnabled()) {
                const millimanHealthInformation = this.store.selectSnapshot(MillimanState.healthInformation);
                this.medSupService.selectMedSupQuestions(sessionId, year, updatedQuestions, millimanHealthInformation);
            }
            else {
                this.medSupService.selectMedSupQuestions(sessionId, year, updatedQuestions);
            }
        }
    }
    openMillimanErrorModal(confirmAction, widgetName) {
        const title = this.getMillimanErrorTitleText(widgetName);
        const closeText = this.getCloseText(widgetName);
        const confirmText = this.getMillimanConfirmText(widgetName);
        const prompt = this.getMillimanFailedPrompt(widgetName);
        const confirmationModal = this.modalService.open(ConfirmationModalComponent, { centered: true });
        confirmationModal.componentInstance.title = title;
        confirmationModal.componentInstance.prompt = prompt;
        confirmationModal.componentInstance.cancelButton = closeText;
        if (confirmAction) {
            confirmationModal.componentInstance.confirmButton = confirmText;
            confirmationModal.componentInstance.confirmAction = confirmAction;
        }
        return confirmationModal;
    }
    updateMillimanHealthInformation(healthInformation) {
        const currentHealthInformation = this.store.selectSnapshot(MillimanState.healthInformation);
        this.store.dispatch(new UpdateMillimanHealthInformation({ ...currentHealthInformation, ...healthInformation }));
    }
    getHealthInformation() {
        return this.store.selectSnapshot(MillimanState.healthInformation);
    }
    getMedigapAnswersUniqueNames() {
        return this.configResource.getProcessedResourceValue('Spa_MillimanService_MedigapAnswersUniqueNames', null, 'MedicalQuestionDialysis,MedicalConditionPastTwoYears,anginaOrHeartAttack,atrialFibrillationOrFlutter,coronaryOrCarotidArteryDisease,congestiveHeartFailure,LungOrRespiratoryConditions,CancersOrTumors,alzheimersDiseaseOrDementia,multipleSclerosis,parkinsonsDisease,Diabetes,KidneyConditions,LiverConditions,chronsDiseaseOrUlcerativeColitis,Lupus,rhuematoidArthritis,otherImmuneDeficiency,BipolarOrSchizophrenia,MajorDepression,noConditionApplyC,anxietyOrMildDepression,athritisHipKnee,asthma,diabetesNoComplications,enlargedProstate,fibromyalgia,GERDAcidReflux,glaucomaOrMacularDegeneration,highBloodPressure,highCholesterol,hypothyroidismOrHyperthyroidism,migraines,myastheniaGravis,osteoporosis,psoriasis,noneOfTheseApply,HeightFt,HeightIn,HeightFtIn,WeightLbs,ApplicantTobaccoUse,administeredDrugsInd,Drug1,Drug2,Drug3,Drug4,Drug5,Drug6,Rx1,Rx2,Rx3,Rx4,Rx5,Rx6,Rx7,Rx8,Rx9,Rx10,Rx11,Rx12,authPrintedName,authSignDate,authSignature,Height,Weight,NoneOfTheseApplyQA,NoneOfTheseApplyQB,noconditionApplyC');
    }
    getMillimanErrorTitleText(widgetName) {
        return this.configResource.getProcessedResourceValue('Spa_Milliman_Failed_Title', widgetName, 'Unable to complete transaction');
    }
    getCloseText(widgetName) {
        return this.configResource.getProcessedResourceValue('Spa_Milliman_Failed_Close', widgetName, 'Close');
    }
    getMillimanConfirmText(widgetName) {
        return this.configResource.getProcessedResourceValue('Spa_Site_ReturnToPlans_Text', widgetName, 'Return to plans');
    }
    getMillimanFailedPrompt(widgetName) {
        return this.configResource.getProcessedResourceValue('Spa_Milliman_Failed_Prompt', widgetName, 'We are unable to complete the transaction at this time. Please try again later.');
    }
    createDefaultMillimanRequest() {
        return {
            ParametersDictionary: this.parametersDictionary,
            MedigapAnswersUniqueNames: this.medigapAnswersUniqueNames,
            UniqueNamesForStaticValue: this.uniqueNamesForStaticValue,
            PlanPremium: this.isMedSupMillimanEnabled() ? 0 : this.shoppingCartService.getShoppingCartPremium(),
            OrderReference: this.orderReference,
            GPIPriorityList: this.gpiPriorityList,
            RequestType: this.requestType,
            ServiceCalledBefore: this.isMedSupMillimanEnabled() ? false : this.store.selectSnapshot(MedSupState.millimanTierServiceCalled),
            MaxRetries: this.maxRetries,
            PremiumUniqueName: this.premiumUniqueName,
            ReturnAdditionalInfoFlag: true
        };
    }
}
MillimanService.ɵfac = function MillimanService_Factory(t) { return new (t || MillimanService)(i0.ɵɵinject(ShoppingCartService), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(i1.Store), i0.ɵɵinject(MedSupService), i0.ɵɵinject(i1$1.NgbModal), i0.ɵɵinject(PlanYearResourceService), i0.ɵɵinject(StringFormatUtilityService)); };
MillimanService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MillimanService, factory: MillimanService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MillimanService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ShoppingCartService }, { type: ConfigResourceService }, { type: i1.Store }, { type: MedSupService }, { type: i1$1.NgbModal }, { type: PlanYearResourceService }, { type: StringFormatUtilityService }]; }, null); })();

class UnsavedModalContext {
    constructor() {
        this.unsavedChangesModalContext$ = new BehaviorSubject(false);
    }
    displayModal() {
        this.unsavedChangesModalContext$.next(true);
    }
    getUnsavedChangesModalContext$() {
        return this.unsavedChangesModalContext$.asObservable();
    }
}
UnsavedModalContext.ɵfac = function UnsavedModalContext_Factory(t) { return new (t || UnsavedModalContext)(); };
UnsavedModalContext.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: UnsavedModalContext, factory: UnsavedModalContext.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UnsavedModalContext, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

class MultiFactorAuthenticationHttpService {
    constructor(http) {
        this.http = http;
        this.environment = EnvironmentService.getEnvironment();
    }
    sendVerificationCode$(contactType, messageTemplate, authString, // Can be memberPIN if logging in from retention site, or accountGuid if logging in from enrollment email
    emailSubject, fromAddress) {
        const body = {
            AuthMethod: contactType,
            AuthCode: authString,
            MfaMessageTemplate: messageTemplate,
            MfaEmailFrom: fromAddress,
            MfaEmailSubject: emailSubject
        };
        const headers = new HttpHeaders({ Accept: 'application/json' });
        return this.http.post(`${this.environment.WEB_SERVICE_BASE_URL}/v1/Messages/SendMFA`, body, { headers, params: null });
    }
}
MultiFactorAuthenticationHttpService.ɵfac = function MultiFactorAuthenticationHttpService_Factory(t) { return new (t || MultiFactorAuthenticationHttpService)(i0.ɵɵinject(i1$2.HttpClient)); };
MultiFactorAuthenticationHttpService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MultiFactorAuthenticationHttpService, factory: MultiFactorAuthenticationHttpService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MultiFactorAuthenticationHttpService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1$2.HttpClient }]; }, null); })();

class MultiFactorAuthenticationService {
    constructor(store, mfaHttpService, emailService, memberService, configResourceService, loginService) {
        this.store = store;
        this.mfaHttpService = mfaHttpService;
        this.emailService = emailService;
        this.memberService = memberService;
        this.configResourceService = configResourceService;
        this.loginService = loginService;
    }
    sendVerificationCode$(contactType, messageTemplate, emailSubject, authenticationString) {
        const authString = authenticationString || this.memberService.getMemberUserName();
        const fromAddress = this.configResourceService.getProcessedResourceValue('Spa_Site_Email_FromAddress', null, 'Do.Not.Reply@drx.com');
        return this.mfaHttpService.sendVerificationCode$(contactType, messageTemplate, authString, emailSubject, fromAddress);
    }
    async validateTOTPCode(totpCode, validateFromEnrollmentEmail, authenticationCode) {
        const memberLoginOptions = {
            ...MemberLoginOptions.createDefaultOptions(),
            totpCode
        };
        let authInfo;
        if (validateFromEnrollmentEmail) {
            authInfo = {
                auth1: authenticationCode
            };
        }
        else {
            const userPIN = this.memberService.getMemberUserName();
            const userDOB = this.memberService.getMemberDateOfBirth();
            authInfo = {
                auth1: userPIN,
                auth2: userDOB
            };
            memberLoginOptions.planTypesToFetch = ALL_MEDICARE_PLUS_MEDIGAP_PLAN_TYPE_VALUES;
        }
        return await this.loginService
            .authenticateUserWithPIN(authInfo, memberLoginOptions)
            .then(() => this.memberService.getMemberLoginError())
            .catch(error => {
            const loginError = true;
            if (error?.status === HttpStatusCode.TOO_MANY_REQUESTS) {
                this.setCurrentAuthenticationStep(MultiFactorAuthenticationStep.PIN_LOCKED);
            }
            // Returning "loginError = true" to be consistent with the flag "MemberState.loginError" which is set to true when there is a login error
            return loginError;
        });
    }
    getMFAEmailTemplate$() {
        return this.emailService.getProcessedEmailTemplate$(EmailNames.MFA_ACCESS_CODE, []);
    }
    getCurrentAuthenticationStep$() {
        return this.store.select(UiState.currentAuthenticationStep);
    }
    getSelectedContactMethod$() {
        return this.store.select(UiState.selectedContactMethod);
    }
    setSelectedContactMethod(selectedContactMethod) {
        this.store.dispatch(new SetSelectedContactMethod(selectedContactMethod));
    }
    setCurrentAuthenticationStep(currentAuthenticationStep) {
        this.store.dispatch(new SetCurrentAuthenticationStep(currentAuthenticationStep));
    }
    resetCurrentAuthenticationStep() {
        this.store.dispatch(new ResetCurrentAuthenticationStep());
    }
    resetMultiFactorAuthenticationStep() {
        this.store.dispatch(new ResetMultiFactorAuthenticationStep());
    }
    isCurrentAuthenticationStep(authenticationStep) {
        return this.store.selectSnapshot(UiState.isCurrentAuthenticationStep(authenticationStep));
    }
}
MultiFactorAuthenticationService.ɵfac = function MultiFactorAuthenticationService_Factory(t) { return new (t || MultiFactorAuthenticationService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(MultiFactorAuthenticationHttpService), i0.ɵɵinject(EmailService), i0.ɵɵinject(MemberSessionService), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(LoginService)); };
MultiFactorAuthenticationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MultiFactorAuthenticationService, factory: MultiFactorAuthenticationService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MultiFactorAuthenticationService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }, { type: MultiFactorAuthenticationHttpService }, { type: EmailService }, { type: MemberSessionService }, { type: ConfigResourceService }, { type: LoginService }]; }, null); })();

var SmartVXEventType;
(function (SmartVXEventType) {
    SmartVXEventType["VIEW_DETAILS"] = "view-details";
    SmartVXEventType["GUIDED_HELP"] = "edit-guided-help";
    SmartVXEventType["ADD_TO_CART"] = "customer-enrolled";
    SmartVXEventType["CONTACT_US"] = "contact-us";
})(SmartVXEventType || (SmartVXEventType = {}));
class SmartVXEventData {
}

class AddToCartContextService {
    constructor() {
        this.openAddToCartModal$ = new BehaviorSubject('');
    }
    getOpenAddToCartModal$() {
        return this.openAddToCartModal$.asObservable();
    }
    openAddToCartModal(planId) {
        this.openAddToCartModal$.next(planId);
    }
    onOpenAddToCartModal$() {
        return this.openAddToCartModal$.asObservable();
    }
}
AddToCartContextService.ɵfac = function AddToCartContextService_Factory(t) { return new (t || AddToCartContextService)(); };
AddToCartContextService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AddToCartContextService, factory: AddToCartContextService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddToCartContextService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

class PersonalizedVideoService {
    constructor(navigationService, plansService, quoteService, planCompareService, addToCartContextService, contactUsContextService) {
        this.navigationService = navigationService;
        this.plansService = plansService;
        this.quoteService = quoteService;
        this.planCompareService = planCompareService;
        this.addToCartContextService = addToCartContextService;
        this.contactUsContextService = contactUsContextService;
        this.smartVxRegex = /https:\/\/.*.smartvx.com/;
    }
    async handleVideoEvent(event) {
        const originMatched = !!event?.origin?.match(this.smartVxRegex);
        if (originMatched) {
            this.handleSmartVXEvent(event);
        }
        // TODO: add more regex and handle other vendors' unique event names as new vendors are added
        return originMatched;
    }
    handleSmartVXEvent(event) {
        const eventData = JSON.parse(event?.data) || {};
        if (eventData.event === SmartVXEventType.ADD_TO_CART) {
            this.addPlanToCart(eventData);
        }
        else if (eventData.event === SmartVXEventType.GUIDED_HELP) {
            this.viewGuidedHelp();
        }
        else if (eventData.event === SmartVXEventType.VIEW_DETAILS) {
            this.viewPlanDetails();
        }
        else if (eventData.event === SmartVXEventType.CONTACT_US) {
            this.viewContactUs();
        }
    }
    addPlanToCart(eventData) {
        // The add to cart modal needs to exist in widgets, so this service can only push to the context service
        // And then let the personalized video component handle the listening + launching of the actual modal
        this.addToCartContextService.openAddToCartModal(eventData.id);
    }
    viewPlanDetails() {
        // We don't actually need details from the event for this.
        // If we have one plan, go to plan details. If we have two or three, go to plan compare with all the plans
        // Thus we can just work the plan ids from the quote
        const quotePlanIds = this.quoteService.getQuotePlanIds();
        if (quotePlanIds.length === 1) {
            this.navigationService.navigateByPageTag(PageTags.PLAN_DETAILS, { queryParams: { id: quotePlanIds[0] } });
        }
        else {
            const quotedPlans = this.plansService.getPlansByIds(quotePlanIds);
            this.planCompareService.replaceAllPlansInCompareGroupAndNavigate(quotedPlans);
        }
    }
    viewGuidedHelp() {
        this.navigationService.navigateByPageTag(PageTags.GUIDED_HELP_GETTING_STARTED);
    }
    viewContactUs() {
        this.contactUsContextService.openContactUsModal();
    }
}
PersonalizedVideoService.ɵfac = function PersonalizedVideoService_Factory(t) { return new (t || PersonalizedVideoService)(i0.ɵɵinject(NavigationService), i0.ɵɵinject(PlansService), i0.ɵɵinject(QuoteService), i0.ɵɵinject(PlanCompareService), i0.ɵɵinject(AddToCartContextService), i0.ɵɵinject(ContactUsContextService)); };
PersonalizedVideoService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PersonalizedVideoService, factory: PersonalizedVideoService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PersonalizedVideoService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: NavigationService }, { type: PlansService }, { type: QuoteService }, { type: PlanCompareService }, { type: AddToCartContextService }, { type: ContactUsContextService }]; }, null); })();

class DSNPService {
    constructor(plansService) {
        this.plansService = plansService;
    }
    getDSNPCodesRawValue(plan) {
        return this.plansService.getExtraDataValueByName(plan, PlanExtraDataKey.DSNP_COVERAGE_CODES, '');
    }
    getDSNPCodesAsRawArray(plan) {
        const rawValue = this.getDSNPCodesRawValue(plan);
        return this.convertRawDSNPCodesToArray(rawValue);
    }
    getDSNPCodesAsTranslatedString(plan) {
        const rawValue = this.getDSNPCodesRawValue(plan);
        return this.convertRawDSNPCodesToTranslatedString(rawValue);
    }
    getDSNPCodesAsTranslatedArray(plan) {
        const rawValue = this.getDSNPCodesRawValue(plan);
        return this.convertRawDSNPCodesToTranslatedArray(rawValue);
    }
    convertRawDSNPCodesToArray(dsnpCodes) {
        return dsnpCodes?.length ? dsnpCodes.split(',') : [];
    }
    convertRawDSNPCodesToTranslatedArray(dsnpCodes) {
        const codesAsArray = this.convertRawDSNPCodesToArray(dsnpCodes);
        return codesAsArray.map(value => DSNPCodes[value]);
    }
    convertRawDSNPCodesToTranslatedString(dsnpCodes) {
        const codesAsTranslatedArray = this.convertRawDSNPCodesToTranslatedArray(dsnpCodes);
        return codesAsTranslatedArray.toString().replace(/,/g, ', ');
    }
}
DSNPService.ɵfac = function DSNPService_Factory(t) { return new (t || DSNPService)(i0.ɵɵinject(PlansService)); };
DSNPService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DSNPService, factory: DSNPService.ɵfac, providedIn: 'root' });
__decorate([
    Memoize()
], DSNPService.prototype, "convertRawDSNPCodesToArray", null);
__decorate([
    Memoize()
], DSNPService.prototype, "convertRawDSNPCodesToTranslatedArray", null);
__decorate([
    Memoize()
], DSNPService.prototype, "convertRawDSNPCodesToTranslatedString", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DSNPService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: PlansService }]; }, { convertRawDSNPCodesToArray: [], convertRawDSNPCodesToTranslatedArray: [], convertRawDSNPCodesToTranslatedString: [] }); })();

class PlanYearInterceptor {
    constructor(planYearResourceService) {
        this.planYearResourceService = planYearResourceService;
    }
    intercept(req, next) {
        const isDualPlanYearSite = this.planYearResourceService.getIsDualPlanYearSite();
        if (isDualPlanYearSite) {
            const selectedPlanYear = this.planYearResourceService.getSelectedPlanYear();
            if (selectedPlanYear) {
                return next.handle(req.clone({
                    headers: req.headers.set('PlanYear', `${selectedPlanYear}`)
                }));
            }
        }
        return next.handle(req);
    }
}
PlanYearInterceptor.ɵfac = function PlanYearInterceptor_Factory(t) { return new (t || PlanYearInterceptor)(i0.ɵɵinject(PlanYearResourceService)); };
PlanYearInterceptor.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PlanYearInterceptor, factory: PlanYearInterceptor.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanYearInterceptor, [{
        type: Injectable
    }], function () { return [{ type: PlanYearResourceService }]; }, null); })();

/**
 * For dealing with operations resulting from plan year changes.
 */
class PlanYearService {
    constructor(store, shoppingCartService, planCompareService, quoteService, planYearContextService) {
        this.store = store;
        this.shoppingCartService = shoppingCartService;
        this.planCompareService = planCompareService;
        this.quoteService = quoteService;
        this.planYearContextService = planYearContextService;
        this.subscriptions = new Subscription();
        this.subscriptions.add(
        // mediates setting hasPlanYearPermissionError for hard reloads since we can't just set
        // the state from the http service without getting a circular reference
        this.planYearContextService
            .getPlanYearPermissionMediatorError$()
            .pipe(filter(hasPlanYearPermissionError => hasPlanYearPermissionError !== null))
            .subscribe({
            next: hasPlanYearPermissionError => {
                this.setHasPlanYearPermissionError(hasPlanYearPermissionError);
            }
        }));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    hasRemovableMedicarePlansInCart() {
        const shoppingCartPlans = this.shoppingCartService.getShoppingCartPlans();
        const medicarePlanIds = this.getMedicarePlanIds(shoppingCartPlans);
        return !!medicarePlanIds?.length;
    }
    hasRemovableMedicarePlansInQuoteGroups() {
        const quoteGroups = this.store.selectSnapshot(PlansState.quoteGroups);
        const plans = this.getMedicarePlansInQuoteGroups(quoteGroups);
        return !!plans?.length;
    }
    removeMedicarePlansFromCart() {
        const shoppingCartPlans = this.shoppingCartService.getShoppingCartPlans();
        const medicarePlans = this.getMedicarePlans(shoppingCartPlans);
        medicarePlans.forEach(plan => {
            this.shoppingCartService.removePlan(plan.planId);
            this.planCompareService.removePlanFromCompareGroups(this.convertToMinimalPlan(plan));
            this.quoteService.removePlanFromQuoteGroups(this.convertToMinimalPlan(plan));
        });
    }
    removeMedicarePlansFromQuoteGroups() {
        const quoteGroups = this.store.selectSnapshot(PlansState.quoteGroups);
        const medicarePlansInQuote = this.getMedicarePlansInQuoteGroups(quoteGroups);
        medicarePlansInQuote.forEach(plan => {
            this.quoteService.removePlanFromQuoteGroups(plan);
        });
    }
    clearPlanYearSessionData() {
        // TODO: is there anything here we should not be doing in helpful tools?
        this.removeMedicarePlansFromCart();
        this.removeMedicarePlansFromQuoteGroups();
        this.shoppingCartService.resetEnrollmentState();
        this.store.dispatch(new ResetConfirmationState());
        this.store.dispatch(new ResetAgentSellingPermissions());
        this.store.dispatch(new ResetBeneficiaryQuoteDetails());
        this.store.dispatch(new ResetPlanYearState());
        // this.store.dispatch(new ResetSOAState());
        this.store.dispatch(new ResetMillimanState());
    }
    showEnrollmentPlanYearBadgeByPlanType(planTypeId) {
        return ![PlanType.MEDIGAP, PlanType.DENTAL, PlanType.VISION, PlanType.HC].includes(planTypeId);
    }
    showEnrollmentPlanYearBadgeByPlanTypeAbbreviation(planTypeId) {
        return ![PlanTypeAbbreviation.MEDIGAP, PlanTypeAbbreviation.DENTAL, PlanTypeAbbreviation.VISION, PlanTypeAbbreviation.HC].includes(planTypeId);
    }
    initializePlanYearPermissionMediator() {
        const persistedPlanYearPermissionError = this.getHasPlanYearPermissionError();
        this.planYearContextService.setPlanYearPermissionMediatorError(persistedPlanYearPermissionError);
    }
    getHasPlanYearPermissionError() {
        return this.store.selectSnapshot(PlansState.hasPlanYearPermissionError);
    }
    getHasPlanYearPermissionError$() {
        return this.store.select(PlansState.hasPlanYearPermissionError);
    }
    setHasPlanYearPermissionError(hasPlanYearPermissionError) {
        this.store.dispatch(new SetPlanYearPermissionError(hasPlanYearPermissionError));
    }
    convertToMinimalPlan(apiPlan) {
        return {
            id: apiPlan.planId,
            planTypeAbbreviation: apiPlan.planType
        };
    }
    getMedicarePlans(plans) {
        return plans.filter(plan => PlansUtilityService.isMedicarePlanType(plan?.planType));
    }
    getMedicarePlanIds(plans) {
        return this.getMedicarePlans(plans).map(plan => plan.planId);
    }
    getMedicarePlansInQuoteGroups(quoteGroups) {
        return quoteGroups.reduce((plans, quoteGroup) => {
            const filteredPlans = quoteGroup.items.filter((plan) => PlansUtilityService.isMedicarePlanType(plan.planTypeAbbreviation));
            return plans.concat(filteredPlans);
        }, []);
    }
}
PlanYearService.ɵfac = function PlanYearService_Factory(t) { return new (t || PlanYearService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(ShoppingCartService), i0.ɵɵinject(PlanCompareService), i0.ɵɵinject(QuoteService), i0.ɵɵinject(PlanYearContextService)); };
PlanYearService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PlanYearService, factory: PlanYearService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanYearService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }, { type: ShoppingCartService }, { type: PlanCompareService }, { type: QuoteService }, { type: PlanYearContextService }]; }, null); })();

class QuoteSessionService {
    constructor(memberSessionService) {
        this.memberSessionService = memberSessionService;
    }
    async createQuoteSession(pinInfo, quoteId, agentGuid, quoteType, showCurrentMonthMedigapQuote, omitPlansRequest, rehydratePlansFromCart, isSecurityDOBEnabled, dateOfBirth) {
        const authInfo = new AuthenticationInfo();
        authInfo.pinInfo = pinInfo;
        const authType = isSecurityDOBEnabled ? "PinAndDOB" /* AuthType.PIN_AND_DOB */ : "pin" /* AuthType.PIN */;
        const isEnrollmentHistoryIncluded = true;
        return await this.memberSessionService.createQuoteSession({
            authInfo,
            authType,
            quoteId,
            agentGuid,
            quoteType,
            isEnrollmentHistoryIncluded,
            showCurrentMonthMedigapQuote,
            omitPlansRequest,
            rehydratePlansFromCart,
            isSecurityDOBEnabled,
            dateOfBirth
        });
    }
}
QuoteSessionService.ɵfac = function QuoteSessionService_Factory(t) { return new (t || QuoteSessionService)(i0.ɵɵinject(MemberSessionService)); };
QuoteSessionService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: QuoteSessionService, factory: QuoteSessionService.ɵfac, providedIn: 'root' });
__decorate([
    LiveEditInactive()
], QuoteSessionService.prototype, "createQuoteSession", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(QuoteSessionService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: MemberSessionService }]; }, { createQuoteSession: [] }); })();

class QuoteUtilityService {
    static getSortedPlansWithMaximumPlansToDisplay(plans, medigapSort, sort, maximumPlanCountToDisplay) {
        const defaultSort = plans?.[0]?.planTypeAbbreviation === PlanTypeAbbreviation.MEDIGAP ? medigapSort : sort;
        const sortedPlans = SortUtilities.sort(plans, defaultSort);
        return sortedPlans.slice(0, maximumPlanCountToDisplay);
    }
    static getQuotedPlansName(quotedPlanInfo) {
        return (quotedPlanInfo?.reduce((quotedPlans, planInfo, index) => {
            if (index === 0) {
                return planInfo.planName;
            }
            else if (index === quotedPlanInfo.length - 1) {
                return `${quotedPlans} and ${planInfo.planName}`;
            }
            else {
                return `${quotedPlans}, ${planInfo.planName}`;
            }
        }, '') ?? '');
    }
    static replaceTextReplacementVariables(message, sentDate, agentFullName) {
        if (message) {
            const quoteSentDateInMMddyyyy = sentDate ? DateUtilities.getFormattedPTDate(new Date(sentDate), DateUtilities.defaultFormat) : ''; // Convert quoteSentDate from UTC to Pacific Time (PT)
            return message.replace('<sentDate>', quoteSentDateInMMddyyyy).replace('<agentFullName>', agentFullName);
        }
        return '';
    }
    static sortQuoteBySentDate(quote1, quote2) {
        return SortUtilities.sortByDate(quote1.sentDate, quote2.sentDate);
    }
}
QuoteUtilityService.ɵfac = function QuoteUtilityService_Factory(t) { return new (t || QuoteUtilityService)(); };
QuoteUtilityService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: QuoteUtilityService, factory: QuoteUtilityService.ɵfac, providedIn: 'root' });
__decorate([
    Memoize()
], QuoteUtilityService, "getQuotedPlansName", null);
__decorate([
    Memoize()
], QuoteUtilityService, "replaceTextReplacementVariables", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(QuoteUtilityService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

var BeneficiaryRedirectTypes;
(function (BeneficiaryRedirectTypes) {
    BeneficiaryRedirectTypes["ENROLLMENT"] = "enrollment";
})(BeneficiaryRedirectTypes || (BeneficiaryRedirectTypes = {}));
class SendEnrollmentService {
    constructor(configResourceService, emailService, sessionService, quoteService, store, agentService, analyticsService, navigationUtilityService, profileService, messagesService, phoneUtilityService, planYearResourceService, siteService, enrollmentFunctionService, weglotService, enrollmentFormService) {
        this.configResourceService = configResourceService;
        this.emailService = emailService;
        this.sessionService = sessionService;
        this.quoteService = quoteService;
        this.store = store;
        this.agentService = agentService;
        this.analyticsService = analyticsService;
        this.navigationUtilityService = navigationUtilityService;
        this.profileService = profileService;
        this.messagesService = messagesService;
        this.phoneUtilityService = phoneUtilityService;
        this.planYearResourceService = planYearResourceService;
        this.siteService = siteService;
        this.enrollmentFunctionService = enrollmentFunctionService;
        this.weglotService = weglotService;
        this.enrollmentFormService = enrollmentFormService;
    }
    async createQuoteAndSendApplication(planId, email, phone, planDocuments, isRedirectedFromPlanCompareApi, isSendToBeneficiaryWithoutAgentForPlanCompareApi, isSendToBeneficiarySignAndSubmit, storageId, transactionGuid) {
        if (!email && !phone) {
            return null;
        }
        // Update profile
        this.updateProfileSession(phone, email);
        // Get quote info
        const quote = await this.createQuote(planId, isRedirectedFromPlanCompareApi, isSendToBeneficiaryWithoutAgentForPlanCompareApi, isSendToBeneficiarySignAndSubmit, email, phone);
        const planHasNextGenForm = this.enrollmentFormService.planHasNextGenForm(planId);
        // we seem to already have the transaction data for next gen forms so adding a check here to prevent NG-1089
        if (!planHasNextGenForm && this.agentService.isPlanCompareApiAgentDataEnabled()) {
            // We don't have all the enrollment answers saved in the transaction until we complete it.
            // For PC API enrollments (send to beneficiary flow): in order to grab the agent's name and NPN sent by the clients that do not have agents in our system,
            // we've to fetch the transaction to obtain all the answers saved so far during the enrollment.
            await firstValueFrom(this.enrollmentFunctionService.fetchTransaction$(planId));
        }
        const isVerificationEnabled = this.configResourceService.getProcessedResourceValue('Spa_Verification_Enabled', null, false);
        // TODO: SPA-4970 consumer/agent enrollment
        if (quote?.authCode && quote?.queryString && quote?.quoteId) {
            const sendApplicationPromises = [];
            const isVerificationFlow = isVerificationEnabled && !!quote.url && !isSendToBeneficiaryWithoutAgentForPlanCompareApi;
            // Send Email
            if (email) {
                sendApplicationPromises.push(this.sendAccessApplicationEmail(planId, email, quote, planDocuments, transactionGuid, isSendToBeneficiarySignAndSubmit, isRedirectedFromPlanCompareApi, isVerificationFlow));
            }
            // Send Text
            if (phone) {
                sendApplicationPromises.push(this.sendAccessApplicationTextMessage(planId, phone, quote, transactionGuid, isSendToBeneficiarySignAndSubmit, isRedirectedFromPlanCompareApi, isVerificationFlow));
            }
            if (!isRedirectedFromPlanCompareApi || (!isSendToBeneficiaryWithoutAgentForPlanCompareApi && !isSendToBeneficiarySignAndSubmit)) {
                this.addSentEnrollmentNote(phone, quote.authCode, email);
            }
            this.analyticsService.googleDataLayerTags = {
                [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_ENROLLMENT_SEND_APP,
                [DataLayerGlobalVariable.SEND_APP_VIA]: this.getSendAppViaAnalyticsValue(email, phone),
                [DataLayerGlobalVariable.SEND_APP_ID]: transactionGuid
            };
            // Return authcode to show on success modal
            return quote.authCode;
        }
        return null;
    }
    async createQuote(planId, isRedirectedFromPlanCompareApi, isSendToBeneficiaryWithoutAgentForPlanCompareApi, isSendToBeneficiarySignAndSubmit, emailAddress, phoneNumber, widgetName) {
        const sessionId = this.sessionService.getMemberSessionId();
        const agentGuid = this.store.selectSnapshot(AgentState.agentGuid);
        const planYear = this.planYearResourceService.getSelectedPlanYear();
        const siteType = this.configResourceService.getProcessedResourceValue('Spa_Site_SiteType', null, 'consumer');
        const agentLoginDomain = this.configResourceService.getProcessedResourceValue('Spa_Site_AgentDomain', widgetName, 'drx');
        const selectedPlan = this.store.selectSnapshot(ShoppingCartState.selectedPlanById(planId));
        const planIds = selectedPlan ? [selectedPlan.id] : [];
        const isMedigap = selectedPlan ? selectedPlan.planTypeAbbreviation === PlanTypeAbbreviation.MEDIGAP : false;
        const effectiveDate = isMedigap ? this.store.selectSnapshot(MedSupState.formField('EffectiveDate')) : null;
        const phone = phoneNumber ?? '';
        const deliveryMethod = {
            email: emailAddress,
            phone
        };
        let quoteType;
        if (isRedirectedFromPlanCompareApi && isSendToBeneficiaryWithoutAgentForPlanCompareApi) {
            quoteType = QuoteType.PCAPIENROLLMENTQUOTE;
        }
        else if (isSendToBeneficiarySignAndSubmit) {
            if (isRedirectedFromPlanCompareApi) {
                quoteType = QuoteType.SASPCAPIENROLLMENTQUOTE;
            }
            else {
                quoteType = QuoteType.SASENROLLMENTQUOTE;
            }
        }
        else {
            quoteType = QuoteType.ENROLLMENTQUOTE;
        }
        const agencyConsumerSharedResourcesEnabled = this.configResourceService.getProcessedResourceValue('Spa_Agency_Consumer_Resource_Sharing_Enabled', null, false);
        let sourceSiteId;
        if (agencyConsumerSharedResourcesEnabled && siteType === SiteType.BROKER) {
            sourceSiteId = this.siteService.getSiteId();
        }
        const accountGuid = this.profileService.getAccountGuid();
        const selectedStaticPurlYear = this.planYearResourceService.getSelectedStaticPlanYear();
        const quote = {
            quotedPlans: planIds,
            agentGuid,
            planYear,
            agentLoginDomain,
            quoteType,
            isMedigap,
            deliveryMethod,
            phone,
            sourceSiteId,
            language: this.weglotService.getCurrentWeglotLocaleOrDefault(),
            agentUsername: this.agentService.getAgentUserName(),
            ...(effectiveDate && { effectiveDate }),
            ...(emailAddress && { emailAddress }),
            ...(accountGuid && { accountGuid }),
            ...(selectedStaticPurlYear !== null && selectedStaticPurlYear !== undefined && { PY: selectedStaticPurlYear })
        };
        return await firstValueFrom(this.quoteService.createQuote$(sessionId, quote));
    }
    async sendAccessApplicationEmail(planId, email, quote, planDocuments, transactionGuid, isSendToBeneficiarySignAndSubmit, isRedirectedFromPlanCompareApi, isVerificationFlow, widgetName) {
        if (email) {
            const showAgentHeader = this.configResourceService.getProcessedResourceValue('Spa_Site_Broker_Info_Enabled', widgetName, true);
            const showAgentMiniCart = this.configResourceService.getProcessedResourceValue('Spa_Site_Show_Agent_MiniCart', widgetName, true);
            const showMeetWithAgent = this.configResourceService.getProcessedResourceValue('Spa_Site_Show_Meet_With_Agent', widgetName, true);
            const hidePdfAgentData = this.configResourceService.getProcessedResourceValue('Spa_Site_Broker_PDF_HideAgentData', widgetName, false);
            const showAgentProfilePicture = this.configResourceService.getProcessedResourceValue('Spa_Agent_Profile_Picture_Upload_Enabled', widgetName, true);
            const agentFooterData = await this.agentService.getAgentEmailFooterData();
            const agentGuid = this.store.selectSnapshot(AgentState.agentGuid);
            let agentName;
            let agentNPN;
            let californiaLicenseNumber;
            if (this.agentService.isPlanCompareApiAgentDataEnabled()) {
                const planCompareApiAgentData = this.agentService.getPlanCompareApiAgentData();
                ({ agentName, agentNPN, californiaLicenseNumber } = planCompareApiAgentData);
            }
            else {
                agentName = agentFooterData.agentName;
                agentNPN = this.agentService.getAgentNPN();
                californiaLicenseNumber = this.agentService.getCaliforniaLicenseNumber();
            }
            const inputs = [
                { key: 'agentName', value: agentName },
                { key: 'agencyName', value: agentFooterData.agencyName },
                { key: 'agentEmail', value: agentFooterData.agentEmail },
                { key: 'agentNPN', value: agentNPN },
                { key: 'agentPhoneAndHours', value: agentFooterData.agentPhoneAndHours },
                { key: 'agentPictureURL', value: agentFooterData.agentPictureURL },
                { key: 'planDocumentHeader', value: this.getDocumentHeader(planDocuments) },
                { key: 'planDocuments', value: this.getDocumentHtml(planDocuments) },
                { key: 'californiaLicenseNumber', value: californiaLicenseNumber }
            ];
            const subject = this.getSendEnrollmentEmailSubjectText(isSendToBeneficiarySignAndSubmit, widgetName);
            if (quote?.authCode && quote?.queryString && quote?.quoteId) {
                const enrollmentHref = this.getEnrollmentUrl(planId, quote, SendAppVia.EMAIL, transactionGuid, isSendToBeneficiarySignAndSubmit, isRedirectedFromPlanCompareApi, isVerificationFlow, widgetName);
                const enrollmentQueryString = new URL(enrollmentHref);
                enrollmentQueryString.searchParams.set('showAgentHeader', showAgentHeader);
                enrollmentQueryString.searchParams.set('showAgentMiniCart', showAgentMiniCart);
                enrollmentQueryString.searchParams.set('showMeetWithAgent', showMeetWithAgent);
                enrollmentQueryString.searchParams.set('showAgentProfilePicture', showAgentProfilePicture);
                enrollmentQueryString.searchParams.set('hidePdfAgentData', hidePdfAgentData);
                enrollmentQueryString.searchParams.set('transactionGuid', transactionGuid);
                enrollmentQueryString.searchParams.set('CultureCode', this.weglotService.getCurrentWeglotLocaleOrDefault());
                if (isSendToBeneficiarySignAndSubmit && !isRedirectedFromPlanCompareApi) {
                    const quoteInfo = await this.quoteService.getInfoForQuote(quote.quoteId, agentGuid);
                    const quoteType = quoteInfo.quoteType;
                    enrollmentQueryString.searchParams.set('quoteType', quoteType);
                }
                const enrollmentQueryShortUrl = await this.getShortUrl(enrollmentQueryString.href);
                inputs.push({
                    key: 'buttonUrl',
                    value: `${enrollmentQueryShortUrl}`
                });
                this.emailService.sendEmail(isSendToBeneficiarySignAndSubmit ? EmailNames.SIGN_AND_SUBMIT : EmailNames.APPLICATION, [email], subject, inputs);
                if (!isVerificationFlow &&
                    !this.configResourceService.getProcessedResourceValue('SPA_AuthCode_TextOnly_Enabled', widgetName, true)) {
                    this.agentService.sendAccessCodeEmail(quote.authCode, email, this.configResourceService.getProcessedResourceValue('Spa_AccessCode_Email_Subject', widgetName, 'Your access code'));
                }
            }
        }
    }
    async sendAccessApplicationTextMessage(planId, phone, quote, transactionGuid, isSendToBeneficiarySignAndSubmit, isRedirectedFromPlanCompareApi, isVerificationFlow, widgetName) {
        const e164PhoneNumber = this.phoneUtilityService.getE164PhoneNumber(phone);
        if (e164PhoneNumber) {
            if (quote?.authCode && quote?.queryString && quote?.quoteId) {
                const enrollmentHref = this.getEnrollmentUrl(planId, quote, SendAppVia.TEXT, transactionGuid, isSendToBeneficiarySignAndSubmit, isRedirectedFromPlanCompareApi, isVerificationFlow, widgetName);
                const enrollmentQueryString = new URL(enrollmentHref);
                enrollmentQueryString.searchParams.set('transactionGuid', transactionGuid);
                enrollmentQueryString.searchParams.set('CultureCode', this.weglotService.getCurrentWeglotLocaleOrDefault());
                if (isSendToBeneficiarySignAndSubmit && !isRedirectedFromPlanCompareApi) {
                    const agentGuid = this.store.selectSnapshot(AgentState.agentGuid);
                    const quoteInfo = await this.quoteService.getInfoForQuote(quote.quoteId, agentGuid);
                    const quoteType = quoteInfo.quoteType;
                    enrollmentQueryString.searchParams.set('quoteType', quoteType);
                }
                const shortUrl = await this.getShortUrl(enrollmentQueryString.href);
                const spaQuoteLinkEmailOnlyEnabled = this.configResourceService.getProcessedResourceValue('SPA_QuoteLink_EmailOnly_Enabled', widgetName, true);
                if (!spaQuoteLinkEmailOnlyEnabled) {
                    this.sendCompleteEnrollmentText(e164PhoneNumber, shortUrl, isSendToBeneficiarySignAndSubmit);
                }
                if (!isVerificationFlow) {
                    const message = isSendToBeneficiarySignAndSubmit
                        ? this.configResourceService.getProcessedResourceValue('Spa_SignandSubmit_TextMessage_AuthCodeText', widgetName, 'Use this authorization code to access your enrollment: <authCode>')
                        : this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_TextMessage_AuthCodeText', widgetName, 'Use this authorization code to access your enrollment: <authCode>');
                    this.agentService.sendAuthCodeText(e164PhoneNumber, quote.authCode, message);
                }
            }
        }
    }
    updateProfileSession(phone, email) {
        const isPhoneUpdated = phone && phone !== this.profileService.getHomePhone();
        const isEmailUpdated = email && email !== this.profileService.getEmailAddress();
        if (isPhoneUpdated || isEmailUpdated) {
            const profile = {
                ...(isPhoneUpdated && { homePhone: phone }),
                ...(isEmailUpdated && { emailAddress: email })
            };
            this.profileService.updateProfileSession(this.sessionService.getMemberSessionId(), profile);
        }
    }
    getDocumentHeader(planDocuments, widgetName) {
        return planDocuments?.length
            ? this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_PlanDocument_Header', widgetName, 'List of selected documents')
            : '';
    }
    getDocumentHtml(planDocuments) {
        return this.quoteService.getPlanDocumentsHtml(planDocuments);
    }
    addSentEnrollmentNote(phone, authCode, email) {
        const agentGuid = this.store.selectSnapshot(AgentState.agentGuid);
        const agentName = this.store.selectSnapshot(AgentState.fullName);
        this.addApplicationSentNote(agentName, agentGuid, phone, authCode, email);
    }
    addApplicationSentNote(agentName, userAgentGUID, phoneNumber, authCode, email, widgetName) {
        const date = DateUtilities.getFormattedCurrentDate();
        const description = this.getAgentNoteDescription(email, phoneNumber, authCode, widgetName);
        const note = {
            userAgentGUID,
            agentNoteActionType: NoteActionType.Note,
            description,
            agentName,
            createdWhen: date
        };
        this.sessionService.addMemberNoteByAgent(note);
    }
    async getShortUrl(url) {
        return await firstValueFrom(this.messagesService.getShortUrl$(url));
    }
    getFormattedPhoneNumber(phone) {
        return phone && phone.length === 10 ? `(${phone.substring(0, 3)}) ${phone.substring(3, 6)}-${phone.substring(6, 10)}` : '';
    }
    async sendCompleteEnrollmentText(phoneNumber, url, isSendToBeneficiarySignAndSubmit, widgetName) {
        const weglotMultiLanguageEnabled = this.configResourceService.getProcessedResourceValue('Spa_Weglot_MultiLanguage_Enabled', null, false);
        let message = this.getTextMessageCompleteEnrollmentText(isSendToBeneficiarySignAndSubmit, widgetName);
        if (weglotMultiLanguageEnabled) {
            message = await firstValueFrom(this.weglotService.getTranslatedText$(message, ['<url>']));
        }
        message = message ? message.replace('<url>', url) : '';
        return await firstValueFrom(this.messagesService.sendText$(phoneNumber, message));
    }
    getTextMessageCompleteEnrollmentText(isSendToBeneficiarySignAndSubmit, widgetName) {
        return isSendToBeneficiarySignAndSubmit
            ? this.configResourceService.getProcessedResourceValue('Spa_SignandSubmit_TextMessage_CompleteEnrollmentText', widgetName, 'Sign your enrollment from [[Spa_ClientName]]: <url>\r\n\r\nSingle Use Text. Opt-out not necessary.')
            : this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_TextMessage_CompleteEnrollmentText', widgetName, 'Complete your enrollment from [[Spa_ClientName]]: <url>\r\n\r\nSingle Use Text. Opt-out not necessary.');
    }
    getSendEnrollmentEmailSubjectText(isSendToBeneficiarySignAndSubmit, widgetName) {
        return isSendToBeneficiarySignAndSubmit
            ? this.configResourceService.getProcessedResourceValue('Spa_SignAndSubmit_Email_Subject', widgetName, 'Here is the plan we discussed (sent from licensed sales agent')
            : this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_Email_Subject', widgetName, 'Enrollment application');
    }
    getPhoneNoteDescription(widgetName, phoneNumber, authCode) {
        const description = this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_AgentNotePhone_Text', widgetName, 'Application sent to <phone><br/>Auth Code: <authCode>');
        return description.replace('<phone>', this.getFormattedPhoneNumber(phoneNumber)).replace('<authCode>', authCode);
    }
    getEmailNoteDescription(widgetName, email, authCode) {
        const description = this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_AgentNote_Text', widgetName, 'Application sent to <email><br/>Auth Code: <authCode>');
        return description.replace('<email>', email).replace('<authCode>', authCode);
    }
    getEmailAndPhoneNoteDescription(widgetName, email, phoneNumber, authCode) {
        const description = this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_AgentNotePhoneAndEmail_Text', widgetName, 'Application sent to <email> and <phone>.<br/>Auth Code: <authCode>');
        return description
            .replace('<email>', email)
            .replace('<phone>', this.getFormattedPhoneNumber(phoneNumber))
            .replace('<authCode>', authCode);
    }
    getSendAppViaAnalyticsValue(email, phone) {
        if (email && phone) {
            return `${SendAppVia.EMAIL}${SendAppVia.DELIMITER}${SendAppVia.TEXT}`;
        }
        else if (email) {
            return SendAppVia.EMAIL;
        }
        else if (phone) {
            return SendAppVia.TEXT;
        }
        return null;
    }
    getAgentNoteDescription(email, phoneNumber, authCode, widgetName) {
        if (email && phoneNumber) {
            return this.getEmailAndPhoneNoteDescription(widgetName, email, phoneNumber, authCode);
        }
        if (email && !phoneNumber) {
            return this.getEmailNoteDescription(widgetName, email, authCode);
        }
        return this.getPhoneNoteDescription(widgetName, phoneNumber, authCode);
    }
    getEnrollmentUrl(planId, quote, sendingMedium, transactionGuid, isSendToBeneficiarySignAndSubmit, isRedirectedFromPlanCompareApi, isVerificationFlow, widgetName) {
        // access app, at least for the moment, uses the exact same page as quoting for authCode resolution
        const accessApplicationPageTag = this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_Email_PageTag', widgetName, PageTags.BENEFICIARY_LOGIN);
        let baseUrl = isSendToBeneficiarySignAndSubmit && !isRedirectedFromPlanCompareApi
            ? this.siteService.getSiteBaseUrl()
            : this.siteService.getBaseConsumerSiteUrl(widgetName);
        baseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
        const url = isVerificationFlow
            ? quote.url
            : this.navigationUtilityService.addHrefToUrl(baseUrl, accessApplicationPageTag, quote.queryString);
        const quoteQueryString = new URL(url);
        quoteQueryString.searchParams.set(UTMParameter.UTM_SOURCE, UTMValue.UTM_SOURCE_PLAN_COMPARE);
        quoteQueryString.searchParams.set(UTMParameter.UTM_CAMPAIGN, UTMValue.UTM_CAMPAIGN_APPLICATION);
        quoteQueryString.searchParams.set(UTMParameter.UTM_CONTENT, transactionGuid);
        quoteQueryString.searchParams.set('accessType', BeneficiaryRedirectTypes.ENROLLMENT);
        quoteQueryString.searchParams.set('planId', planId);
        const isShortForm = this.store.selectSnapshot(EnrollmentState.selectedFormType(planId)) === EnrollmentFormType.SHORT;
        if (isShortForm) {
            quoteQueryString.searchParams.set('shortForm', 'true');
        }
        if (sendingMedium === SendAppVia.EMAIL) {
            quoteQueryString.searchParams.set(UTMParameter.UTM_MEDIUM, UTMValue.UTM_MEDIUM_EMAIL);
        }
        else if (sendingMedium === SendAppVia.TEXT) {
            quoteQueryString.searchParams.set(UTMParameter.UTM_MEDIUM, UTMValue.UTM_MEDIUM_SMS);
        }
        return quoteQueryString?.href ?? null;
    }
}
SendEnrollmentService.ɵfac = function SendEnrollmentService_Factory(t) { return new (t || SendEnrollmentService)(i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(EmailService), i0.ɵɵinject(MemberSessionService), i0.ɵɵinject(QuoteService), i0.ɵɵinject(i1.Store), i0.ɵɵinject(AgentService), i0.ɵɵinject(GoogleTagManagerService), i0.ɵɵinject(NavigationUtilityService), i0.ɵɵinject(ProfileService), i0.ɵɵinject(MessagesService), i0.ɵɵinject(PhoneUtilityService), i0.ɵɵinject(PlanYearResourceService), i0.ɵɵinject(SiteService), i0.ɵɵinject(EnrollmentFunctionService), i0.ɵɵinject(WeglotService), i0.ɵɵinject(EnrollmentFormService)); };
SendEnrollmentService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SendEnrollmentService, factory: SendEnrollmentService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SendEnrollmentService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ConfigResourceService }, { type: EmailService }, { type: MemberSessionService }, { type: QuoteService }, { type: i1.Store }, { type: AgentService }, { type: GoogleTagManagerService }, { type: NavigationUtilityService }, { type: ProfileService }, { type: MessagesService }, { type: PhoneUtilityService }, { type: PlanYearResourceService }, { type: SiteService }, { type: EnrollmentFunctionService }, { type: WeglotService }, { type: EnrollmentFormService }]; }, null); })();

class PlanRiderTypeConflictContextService {
    constructor() {
        this.selectedPlans = [];
        this.selectedRiders = [];
        this.conflicts$ = new BehaviorSubject({});
    }
    getConflicts$() {
        return this.conflicts$.asObservable();
    }
    updateSelectedPlans(plans) {
        this.selectedPlans = plans;
        this.updateConflicts();
    }
    updateSelectedRiders(riders) {
        this.selectedRiders = riders;
        this.updateConflicts();
    }
    updateConflicts() {
        const conflicts = {};
        this.selectedPlans.forEach(plan => {
            conflicts[plan.id] =
                this.selectedRiders?.reduce((riderIds, rider) => {
                    if (this.riderTypeMatchesPlanType(plan.planTypeDescription, rider.planTypeDescription) ||
                        this.riderTypeMatchesPlanType(plan.planTypeDescription, rider.planSubType)) {
                        riderIds.push(rider.planID);
                    }
                    return riderIds;
                }, []) ?? [];
        });
        this.conflicts$.next(conflicts);
    }
    riderTypeMatchesPlanType(planTypeString, riderTypeString) {
        const planType = planTypeString;
        const riderType = riderTypeString;
        return ((DENTAL_PLANS.includes(planType) && DENTAL_RIDERS.includes(riderType)) ||
            (VISION_PLANS.includes(planType) && VISION_RIDERS.includes(riderType)) ||
            (HEARING_PLANS.includes(planType) && HEARING_RIDERS.includes(riderType)));
    }
}
PlanRiderTypeConflictContextService.ɵfac = function PlanRiderTypeConflictContextService_Factory(t) { return new (t || PlanRiderTypeConflictContextService)(); };
PlanRiderTypeConflictContextService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PlanRiderTypeConflictContextService, factory: PlanRiderTypeConflictContextService.ɵfac, providedIn: 'root' });
__decorate([
    Memoize()
], PlanRiderTypeConflictContextService.prototype, "riderTypeMatchesPlanType", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanRiderTypeConflictContextService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, { riderTypeMatchesPlanType: [] }); })();

class CrossSellCartAttributes {
}
class CartSettings {
}

const SET_SITE_TYPE = 'setSiteType';
class SiteTypeResolver {
    constructor(store, siteService, configResourceService, navigationUtilityService) {
        this.store = store;
        this.siteService = siteService;
        this.configResourceService = configResourceService;
        this.navigationUtilityService = navigationUtilityService;
    }
    async resolve(route) {
        const siteType = this.configResourceService.getProcessedResourceValue('Spa_Site_SiteType', null, 'consumer');
        if (siteType === SiteType.CONSUMER) {
            if (!route.url?.length || !route.url[0].path || route.url[0].path === '') {
                this.siteService.setConsumerSiteType(ConsumerSiteType.ANONYMOUS);
            }
            else {
                const path = this.navigationUtilityService.getPath(route);
                const page = this.store.selectSnapshot(AppConfigState.page(path));
                if (page && page.tags && page.tags.length) {
                    if (page.tags.includes(PageTags.RETENTION) || page.tags.includes(PageTags.RETENTION_SUMMARY)) {
                        this.siteService.setConsumerSiteType(ConsumerSiteType.RETENTION);
                    }
                    if (page.tags.includes(PageTags.BENEFICIARY_LOGIN)) {
                        this.siteService.setConsumerSiteType(ConsumerSiteType.QUOTING);
                    }
                    if (page.tags.includes(PageTags.HOME)) {
                        this.siteService.setConsumerSiteType(ConsumerSiteType.ANONYMOUS);
                    }
                }
            }
        }
    }
}
SiteTypeResolver.ɵfac = function SiteTypeResolver_Factory(t) { return new (t || SiteTypeResolver)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(SiteService), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(NavigationUtilityService)); };
SiteTypeResolver.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SiteTypeResolver, factory: SiteTypeResolver.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SiteTypeResolver, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }, { type: SiteService }, { type: ConfigResourceService }, { type: NavigationUtilityService }]; }, null); })();

class SortService {
    constructor(store) {
        this.store = store;
    }
    setSortGroup(sortGroup) {
        this.store.dispatch(new SetSortGroup(sortGroup));
    }
    getSortBySortGroup$(sortGroupIdentifier) {
        return this.store.select(PlansState.getSortBySortGroup(sortGroupIdentifier));
    }
    updateSortGroup(sortGroupIdentifier, sort, isDirty) {
        this.store.dispatch(new UpdateSortGroup(sortGroupIdentifier, sort, isDirty));
    }
    clearSortGroupSort(sortGroup) {
        this.store.dispatch(new ClearSortGroupSort(sortGroup));
    }
}
SortService.ɵfac = function SortService_Factory(t) { return new (t || SortService)(i0.ɵɵinject(i1.Store)); };
SortService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SortService, factory: SortService.ɵfac, providedIn: 'root' });
__decorate([
    MemoizeObservable()
], SortService.prototype, "getSortBySortGroup$", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SortService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }]; }, { getSortBySortGroup$: [] }); })();

class SupplementalBenefitsService {
    constructor(store, sessionHttpService, agentHttpService) {
        this.store = store;
        this.sessionHttpService = sessionHttpService;
        this.agentHttpService = agentHttpService;
    }
    getFavoriteSupplementalBenefits$() {
        return this.store.select(MemberState.favoriteBenefits);
    }
    updateFavoriteSupplementalBenefits$(favoriteBenefits) {
        const sessionId = this.getMemberSessionId();
        return this.sessionHttpService.updateFavoriteSupplementalBenefits$(favoriteBenefits, sessionId);
    }
    updateAgentFavoriteSupplementalBenefits$(favoriteBenefits) {
        const agentGuid = this.store.selectSnapshot(AgentState.agentGuid);
        const supplementalBenefit = {
            agentGuid,
            userPreferences: {
                favoriteBenefits
            }
        };
        return this.agentHttpService.updateAgentSession$(supplementalBenefit);
    }
    getMemberSessionId() {
        return this.store.selectSnapshot(MemberState.sessionId);
    }
    setFavoriteBenefits(medicalCostCabinetUpdatePayload) {
        this.store.dispatch(new SetFavoriteBenefits(medicalCostCabinetUpdatePayload));
    }
}
SupplementalBenefitsService.ɵfac = function SupplementalBenefitsService_Factory(t) { return new (t || SupplementalBenefitsService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(MemberSessionHttpService), i0.ɵɵinject(AgentHttpService)); };
SupplementalBenefitsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SupplementalBenefitsService, factory: SupplementalBenefitsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SupplementalBenefitsService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }, { type: MemberSessionHttpService }, { type: AgentHttpService }]; }, null); })();

class HtmlUtilityService {
    convertStringToHtml(textInput) {
        const parser = new DOMParser();
        const documentHtml = parser.parseFromString(textInput, 'text/html');
        const documentHtmlData = documentHtml.querySelector('body');
        return documentHtmlData;
    }
    applyClassToElement(html, className, elementName) {
        html.querySelectorAll(elementName).forEach(element => element.classList.add(className));
        return html;
    }
}
HtmlUtilityService.ɵfac = function HtmlUtilityService_Factory(t) { return new (t || HtmlUtilityService)(); };
HtmlUtilityService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: HtmlUtilityService, factory: HtmlUtilityService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HtmlUtilityService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

class VerificationService {
    constructor(store, mfaHttpService, emailService, memberService, configResourceService, loginService) {
        this.store = store;
        this.mfaHttpService = mfaHttpService;
        this.emailService = emailService;
        this.memberService = memberService;
        this.configResourceService = configResourceService;
        this.loginService = loginService;
    }
    sendVerificationCode$(selectedVerificationMethod, messageTemplate, emailSubject, authenticationString) {
        const authString = authenticationString || this.memberService.getMemberUserName();
        const fromAddress = this.configResourceService.getProcessedResourceValue('Spa_Site_Email_FromAddress', null, 'Do.Not.Reply@drx.com');
        return this.mfaHttpService.sendVerificationCode$(selectedVerificationMethod, messageTemplate, authString, emailSubject, fromAddress);
    }
    async validateTOTPCode(totpCode, accountGuid) {
        const memberLoginOptions = {
            ...MemberLoginOptions.createDefaultOptions(),
            totpCode
        };
        const authInfo = {
            auth1: accountGuid
        };
        return await this.loginService
            .authenticateUserWithPIN(authInfo, memberLoginOptions)
            .then(() => this.memberService.getMemberLoginError())
            .catch(error => {
            const loginError = true;
            if (error?.status === HttpStatusCode.TOO_MANY_REQUESTS) {
                this.setCurrentVerificationStep(VerificationStep.PIN_LOCKED);
            }
            // Returning "loginError = true" to be consistent with the flag "MemberState.loginError" which is set to true when there is a login error
            return loginError;
        });
    }
    getVerificationEmailTemplate$() {
        return this.emailService.getProcessedEmailTemplate$(EmailNames.VERIFICATION_ACCESS_CODE, []);
    }
    getCurrentVerificationStep$() {
        return this.store.select(UiState.currentVerificationStep);
    }
    getSelectedVerificationMethod$() {
        return this.store.select(UiState.selectedVerificationMethod);
    }
    setSelectedVerificationMethod(selectedVerificationMethod) {
        this.store.dispatch(new SetSelectedVerificationMethod(selectedVerificationMethod));
    }
    setCurrentVerificationStep(currentVerificationStep) {
        this.store.dispatch(new SetCurrentVerificationStep(currentVerificationStep));
    }
    resetCurrentVerificationStep() {
        this.store.dispatch(new ResetCurrentVerificationStep());
    }
    resetVerificationStep() {
        this.store.dispatch(new ResetVerificationStep());
    }
    isCurrentVerificationStep(verificationSteps) {
        return this.store.selectSnapshot(UiState.isCurrentVerificationStep(verificationSteps));
    }
    getRedirectPageTag() {
        return this.store.selectSnapshot(RuntimeState.redirectPageTag);
    }
}
VerificationService.ɵfac = function VerificationService_Factory(t) { return new (t || VerificationService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(MultiFactorAuthenticationHttpService), i0.ɵɵinject(EmailService), i0.ɵɵinject(MemberSessionService), i0.ɵɵinject(ConfigResourceService), i0.ɵɵinject(LoginService)); };
VerificationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: VerificationService, factory: VerificationService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VerificationService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }, { type: MultiFactorAuthenticationHttpService }, { type: EmailService }, { type: MemberSessionService }, { type: ConfigResourceService }, { type: LoginService }]; }, null); })();

class CountyValidationStatus {
}
class ZipCodeService {
    constructor(store, demographicsHttpService, medSupService, millimanService, plansService, planYearResourceService) {
        this.store = store;
        this.demographicsHttpService = demographicsHttpService;
        this.medSupService = medSupService;
        this.millimanService = millimanService;
        this.plansService = plansService;
        this.planYearResourceService = planYearResourceService;
    }
    selectLocation(zipCode, fipsCode) {
        this.store.dispatch(new SetLocation(zipCode, fipsCode));
        this.store.dispatch(new SetPlansDirty(true));
        // provider search payload will override each time when zipcode changes
        this.store.dispatch(new ResetProviderSearchLoaded());
    }
    getZipCode() {
        return this.store.selectSnapshot(DemographicState.selectedZipCode);
    }
    getFipsCode() {
        return this.store.selectSnapshot(DemographicState.selectedFipsCode);
    }
    async getCountiesForZip(zipCode) {
        const counties = await this.demographicsHttpService.retrieveCounties(zipCode);
        return counties;
    }
    isValidFipsForZip(counties, fipsCode) {
        const fips = fipsCode && fipsCode.length ? fipsCode : this.getFipsCode();
        return counties && counties.some(county => county.countyFIPS === fips);
    }
    async getCountyValidationStatus(zipCode, fipsCode) {
        const counties = await this.getCountiesForZip(zipCode);
        const isValid = this.isValidFipsForZip(counties, fipsCode);
        return {
            counties,
            isValid
        };
    }
    /**
     * Updates Medsup zipcode and County once the zipcode is changed
     */
    updateZipCountyForMedSupAnswers() {
        const questions = this.medSupService.getMedSupQuestions();
        if (questions.length > 0) {
            const demographicsOptions = this.plansService.createPlansDemographicsOptionsWithDefaults();
            const savedAnswers = this.medSupService.getMedSupAnswers();
            if (demographicsOptions.zip !== savedAnswers.ZipCode && demographicsOptions.fips !== savedAnswers.County_FIPS) {
                const updatedQuestions = this.updateZipCountyAnswers(demographicsOptions, savedAnswers, questions);
                const sessionId = this.store.selectSnapshot(MemberState.sessionId);
                const year = this.planYearResourceService.getSelectedPlanYear();
                if (this.millimanService.isMedSupMillimanEnabled()) {
                    const millimanHealthInformation = this.millimanService.getHealthInformation();
                    this.medSupService.getMedSupSelectedQuestions(sessionId, year, updatedQuestions, millimanHealthInformation);
                }
                else {
                    this.medSupService.getMedSupSelectedQuestions(sessionId, year, updatedQuestions);
                }
            }
        }
    }
    updateZipCountyAnswers(demographicsOptions, savedAnswers, questions) {
        return questions.map(question => {
            const updatedQuestion = { ...question };
            if (question.name === MedSupQuestionNames.ZipCode) {
                updatedQuestion.value = demographicsOptions.zip;
            }
            else if (question.name === MedSupQuestionNames.County_FIPS) {
                updatedQuestion.value = demographicsOptions.fips;
            }
            else {
                updatedQuestion.value = savedAnswers[question.name];
            }
            return updatedQuestion;
        });
    }
}
ZipCodeService.ɵfac = function ZipCodeService_Factory(t) { return new (t || ZipCodeService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(DemographicHttpService), i0.ɵɵinject(MedSupService), i0.ɵɵinject(MillimanService), i0.ɵɵinject(PlansService), i0.ɵɵinject(PlanYearResourceService)); };
ZipCodeService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ZipCodeService, factory: ZipCodeService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ZipCodeService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Store }, { type: DemographicHttpService }, { type: MedSupService }, { type: MillimanService }, { type: PlansService }, { type: PlanYearResourceService }]; }, null); })();

class ModalsModule {
}
ModalsModule.ɵfac = function ModalsModule_Factory(t) { return new (t || ModalsModule)(); };
ModalsModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ModalsModule });
ModalsModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalsModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: VNEXT_MODAL_DECLARATIONS,
                exports: VNEXT_MODAL_EXPORTS
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ModalsModule, { declarations: [ConfirmationModalComponent, MessageOnlyModalComponent], imports: [CommonModule] }); })();

class VnextSharedModule {
    // empty constructor still forces instances of these two required services to be created
    constructor(environmentService, configService) { }
    static loadConfig(environment, config) {
        EnvironmentService.setEnvironment(environment);
        ConfigService.setConfig(config);
    }
}
VnextSharedModule.ɵfac = function VnextSharedModule_Factory(t) { return new (t || VnextSharedModule)(i0.ɵɵinject(EnvironmentService), i0.ɵɵinject(ConfigService)); };
VnextSharedModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: VnextSharedModule });
VnextSharedModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [EnvironmentService, ConfigService], imports: [ModalsModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VnextSharedModule, [{
        type: NgModule,
        args: [{
                imports: [ModalsModule],
                declarations: [],
                exports: [],
                providers: [EnvironmentService, ConfigService]
            }]
    }], function () { return [{ type: EnvironmentService }, { type: ConfigService }]; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(VnextSharedModule, { imports: [ModalsModule] }); })();

class PersonalizedBenefitsInfo {
}

/**
 * Generated bundle index. Do not edit.
 */

export { ACCOUNT_OVERVIEW, ADMIN_PERMISSIONS, ADMIN_ROLES, AGENCY_ADMIN_PERMISSIONS, AGENCY_ADMIN_ROLES, AGENT_PASSWORD_MAX_LENGTH, AGENT_PASSWORD_MIN_LENGTH, AGENT_USERNAME_MAX_LENGTH, AGENT_USERNAME_MIN_LENGTH, ALLOWED_SOA_TILE_ACTIVITY_TYPES, ALL_ENROLLMENT_QUOTE_TYPES, ALL_MEDICARE_PLAN_TYPE_VALUE, ALL_MEDICARE_PLUS_MEDIGAP_PLAN_TYPE_VALUE, ALL_MEDICARE_PLUS_MEDIGAP_PLAN_TYPE_VALUES, ANCILLARY_FORM_TYPE, ANCILLARY_PLANS, ANCILLARY_PLAN_SUBTYPES, ANCILLARY_PLAN_TYPES, ANCILLARY_PRODUCTS, ANSWERED_RATE_FACTOR_STATUSES, APIAgentStateModel, APIBatchAgentSellingPermissions, APIDemographicStateModel, APIGetAgentSellingPermissionResponse, APIMedBenefitsItem, APIMemberStateModel, APIPharmacyInfo, APIPlanPharmacyInfo, APIPreferencesItem, APIPreferencesModel, APIProfileStateModel, APIShoppingCartModel, APITokenGuard, APIUserProvider, API_AUTH_STATUS, API_FIELD_MAX_LENGTH, APP_CONFIG_DEFAULTS, APP_SESSION_DATA, ASPFilterService, AUTHORIZATION_NO_VALUE, AUTHORIZATION_YES_VALUE, AUTH_STATUS_CODES, AbstractPageLevelValidator, AccountAddPermissionsInputs, AccountCreationModel, AccountOverviewResolver, AccountOverviewService, AddAgentLicense, AddAgentSubscriptionInfo, AddDrugToMedicineCabinet, AddDrugToMemberState, AddDrugsToBlueButtonMedicineCabinet, AddDrugsToMedicineCabinet, AddFilterToASPFilterGroups, AddFilterToFilterGroups, AddFilterToPlanSmartFilterGroups, AddMemberAgentNote, AddPlanToCompareGroup, AddPlanToQuoteGroup, AddPlansToCompareGroup, AddPrimaryCareProvider, AddProviders, AddSOADocument, AddSOATransaction, AddToCartContextService, AddressHttpService, AddressObject, AddressParameters, AddressService, Agent, AgentCallRecording, AgentCallRecordingEnrollmentType, AgentCallRecordingHttpService, AgentCallRecordingNavigationService, AgentCallRecordingService, AgentContext, AgentData, AgentEmailFooterData, AgentEnrollmentSummary, AgentError, AgentHttpService, AgentInContextGuard, AgentInfo, AgentLicense, AgentLicenseType, AgentLogin, AgentLogout, AgentOfRecord, AgentPermissionsService, AgentPlanPermissionsRequest, AgentReportsSummaryGuard, AgentRole, AgentSearchResult, AgentSellingPermissionError, AgentService, AgentState, AgentStateModel, AgentStaticPurlYear, AgentSubscriptionPayload, AgentUserPermission, AgentValidData, AgentsData, AnalyticsActionType, Answer, ApiAuthResolver, AppConfigState, AppThemeConfig, AppThemeService, ApplicationSessionResolver, ApplicationState, Attachment, AuthGuard, AuthPageErrorTitle, AuthRequestInterceptor, AuthResponseInterceptor, AuthService, AuthenticationInfo, AuthorizationCodeSignatureModalFieldNames, AuthorizationCodeSignatureModalSectionNames, AuthorizationCodeStatementActions, AuthorizationCodeVerificationStatus, AuthorizedRepData, AutoCompleteService, BASE_PLAN_HC_OPTION_NAMES, BASIC_ROLES, BRAND_SWAPPED_TO_GENERIC, BROKER_PERMISSIONS, BROKER_ROLES, BROKER_URL, Base64UtilityService, BeanProviderSettings, BeneficiaryRedirectTypes, BenefitNetworkStatus, BenefitType, BlueButtonInfo, BlueButtonMedicineCabinetState, BlueButtonMedicineCabinetStateModel, BlueButtonReturnStatus, BlueButtonService, BlueButtonStatus, BreakPoint, BrowserSupportGuard, BrowserSupportService, CASE_EVENT_PREFIX, CIFormInfo, CLICK_EVENT_PREFIX, COMBO_PLANS, COMPLETED_SOA_ACTIVITY_TYPES, CONFIRMATION_STORE_NAME, CONSUMER_PASSWORD_MAX_LENGTH, CONSUMER_PASSWORD_MIN_LENGTH, CONSUMER_STARTED_SOA_ACTIVITY_TYPES, CONSUMER_USERNAME_MAX_LENGTH, CONSUMER_USERNAME_MIN_LENGTH, COST_FILTER_KEYS, CROSS_SELL_PLANS, CacheInterceptor, CallRecordingAvailability, CallRecordingBeginVia, CallRecordingEndVia, CanDeactivateGuard, CarriersHttpService, CarriersService, CartSettings, ClearASPFilterGroupFilter, ClearASPFilterWithKey, ClearActiveTab, ClearAgentMemberSearch, ClearCallRecordingAvailable, ClearCartTransaction, ClearEnrollmentHistorySelectedPlan, ClearFilterGroupFilter, ClearFilterGroupFilters, ClearFormPagesLoading, ClearHRAParentInfo, ClearMillimanPremium, ClearPlanSmartFilterGroupFilters, ClearPlanSmartFilterGroupWithKey, ClearSelectedMember, ClearSelectedPlanSubType, ClearSort, ClearSortGroupSort, ClearTransaction, ClearWidgetErrors, CollectionUtilityService, ColorResourceKeys, ComparatorType, CompareGroup, CompleteEnrollment, CompleteNextGenEnrollment, CompleteNextGenSOATransaction, ConfigLoaderService, ConfigResourceService, ConfigService, ConfigurablePage, ConfirmationModalComponent, ConfirmationState, ConfirmationStateModel, ConsumerAccountSummaryGuard, ConsumerSiteType, ConsumerSiteUrl, ContactUsContextService, County, CountyValidationStatus, CoverageEventType, CoverageType, CoverageTypeEvent, CoveredDrugPlanTier, CreateFullSession, CreateHopeTransactions, CreateNextGenTransaction, CreatePlanCompareApiNextGenTransaction, CreatePlanCompareApiTransaction, CreateQuoteSessionOptions, CreateSession, CreateTransaction, CreateTransactionHRAData, CrossSellCartAttributes, CrossSellEnrollmentTypes, CrossSellPlanEnrollmentAttributes, CrossSellSendToBeneficiaryOptions, CultureCode, CurrencyUtilityService, CustomInternal, CustomInternalWrapper, CustomUrlEvent, DENTAL_COMBO_PLANS, DENTAL_PLANS, DENTAL_RIDERS, DOMEvent, DOMKeyboardCode, DOMKeyboardKeyCode, DSNPCodes, DSNPService, DVHStatus, DVHType, DashboardAgentNotesPayload, DataKeyType, DataLayerEvent, DataLayerGlobalVariable, DatePipeFormats, DateService, DateUtilities, DaysDifferencePrecision, DeactivationGuardService, DeactivationGuardStatus, DecoupledArrayItemsIdentifiers, DecryptedPlanCompareEnrollment, DeepLinkingParamKey, DeepLinkingParamsState, DeepLinkingService, DefaultEffectiveDateOption, DeleteSelectRxTask, DeliveryMethod, DemographicHttpService, DemographicService, DemographicState, DemographicStateModel, DemographicStateType, DemographicStates, DosageForm, DosageFormDisplayText, DrugCondition, DrugCostDetails, DrugCostsByCoverage, DrugDetails, DrugFlag, DrugFrequencyFacade, DrugInfo, DrugPhaseIds, DrugType, DrugsHttpService, DrugsService, DynamicData, ELIGIBILITY_CHECK_REQUIRED_FIELDS, ENROLLER_ADMIN_ROLES, ENROLLER_BASIC_ROLES, ENROLLER_NON_ADMIN_ROLES, ENROLLER_ROLES, ENROLLMENT_ON_BEHALF_OF_BENEFICIARY, ENROLLMENT_SEND_TO_BENEFICIARY, ENROLLMENT_TRANSACTION_ID, EXTERNAL_RATING_SERVICE_IDENTIFIERS, EditDrugInBlueButtonMedicineCabinet, EditDrugInMedicineCabinet, EligibilityCheckAdditionalFieldNamesMap, EligibilityCheckDateFieldNamesMap, EligibilityCheckFieldNamesMap, EligibilityCheckValidation, EligibilityCheckValidator, EligibilityCheckValidatorContextService, Email, EmailComparator, EmailDocument, EmailHttpService, EmailNames, EmailRecoveryRequest, EmailService, EnrollSystemType, EnrollmentForm, EnrollmentFormErrors, EnrollmentFormErrorsContext, EnrollmentFormModel, EnrollmentFormService, EnrollmentFormType, EnrollmentFormTypeDisplayName, EnrollmentFormTypeUtillity, EnrollmentGuard, EnrollmentHistoryService, EnrollmentHttpService, EnrollmentPDFResponse, EnrollmentPostBackService, EnrollmentRequest, EnrollmentRequestConfig, EnrollmentSettingsService, EnrollmentState, EnrollmentStateModel, EnrollmentTransactionErrorsContext, EnrollmentTransactionRequest, EnrollmentTransactionResolver, EnrollmentTransactionStatus, EnrollmentType, EnrollmentUserType, EnrollmentUtilityService, EnvironmentService, EstimateHealthCostFlag, EstimateHealthCostUpdateResponse, ExpirePartialPayload, ExtendedPlanDetailsName, ExternalContactTypes, ExternalEnrollment, ExternalEnrollmentContext, ExternalEnrollmentModalEventTypes, ExternalEnrollmentNonModalEventTypes, ExternalErrorLoggingService, ExternallyRatedDataFetchType, FILTER_ABBREVIATION_DELIMITER, FOAMConfig, FOAMHtmlDirectives, FetchAgentAgencies, FetchCarrierCounts, FetchCounties, FetchCountyData, FetchDefaultMedSupQuestions, FetchDigitalPharmacies, FetchEnrollmentPlanSettings, FetchEnrollmentSettings, FetchFormPageHtml, FetchFormPageInfo, FetchHospitalIndemnityQuestions, FetchHospitalIndemnityQuestionsError, FetchMedSupQuestions, FetchMedSupQuestionsError, FetchMedSupQuestionsSuccess, FetchMemberLoginTokenError, FetchMemberLoginTokenSuccess, FetchMemberProgressInfo, FetchNextGenSepReasons, FetchNextGenTransaction, FetchPlanEnrollmentSettingsParams, FetchPlanQuestions, FetchPlanQuestionsError, FetchPlanSmartReports, FetchPlanSmartReportsError, FetchPlansError, FetchPlansSuccess, FetchProfileCountyData, FetchQuoteInfo, FetchSOADocuments, FetchSOADocumentsError, FetchSOADocumentsSuccess, FetchSOATransactions, FetchSOATransactionsError, FetchSOATransactionsSuccess, FetchSession, FetchTransaction, FileDownloadUtilityService, Filter, FilterContextNames, FilterContextService, FilterGroup, FilterKeyGroupName, FilterKeyType, FilterService, FilterTab, FilterUtilities, FilterValues, FiltersInfo, FormControlSetting, FormControlSettings, FormEvent, FormPagesMetadataContext, FormValidationService, FormVersionIdState, GENERIC_FORM_TRANSACTION_ID, GIREASONS_KEY, GIREASONS_NO_REASON_KEY, GIREASONS_VALUES, GIReason, GLOBAL_RESOURCES_KEY, GOOGLE_ANALYTICS_NO, GOOGLE_ANALYTICS_NONE, GOOGLE_ANALYTICS_NOT_APPLICABLE, GOOGLE_ANALYTICS_YES, GOOGLE_TAG_MANAGER, Gender, GenderCode, GenderType, GenderValue, GenerateResetHashReturnModel, GenericFormService, GenericFormTransactionResolver, GoogleTagManagerResolver, GoogleTagManagerService, GoogleTagManagerState, GroupValidationSeverity, GroupValidator, GroupValidatorContextService, GuaranteedIssueReasonsContextService, GuidedHelpAgeSelection, GuidedHelpHealthStatus, GuidedHelpLinkStatus, GuidedHelpMapStyleEnum, GuidedHelpModalContextService, GuidedHelpSections, GuidedHelpService, GuidedHelpState, HEALTH_INFORMATION_AUTHORIZATION_DOCUMENT_NAME, HEARING_PLANS, HEARING_RIDERS, HELPFUL_TOOLS_STORE_NAME, HRAExternalResponse, HRAFormTransactionResolver, HRAService, HRA_BROKER_TYPES, HRA_CALL_CENTER_TYPES, HRA_CONSUMER_TYPES, HealthCostsDurationValues, HelpfulToolsData, HelpfulToolsSearchTab, HelpfulToolsState, HelpfulToolsStateModel, HelpfulToolsTabs, HtmlUtilityService, HttpSelectedGIReason, HttpStatusCode, IN_PROGRESS_AGENT_SOA_ACTIVITY_TYPES, IPUtilityService, IdleInterruptContext, ImageService, InitializeMedSupAnswers, InitializeMilliman, InitializePlanSmartFilterGroups, InitializePlanTypeDataMap, InputResetContextService, InputTypes, InsertPlan, InsertPlanWithBundle, InvokeMillimanService, JsonAnalyticsGlobalVariable, JsonAnalyticsService, JsonAnalyticsTagManagerState, LIVE_EDIT_ROOT, LOGIN_STATUS, LanguageInterceptor, LanguageLocaleMap, Link, LinkRoles, LinkType, LiveEditApplicationState, LiveEditInactive, LiveEditPageState, LiveEditProp, LiveEditState, LiveEditStateContext, LiveEditStateLookUpService, LiveEditStateModel, LiveEditStateSelectorService, LiveEditStateValue, LiveEditStoreOverride, LiveEditType, LoadPreferences, LocaleService, LockedSiteService, LoginAuthOptions, LoginService, LoginStatusResolver, LogoutMemberAgent, MAP_DEFAULTS, MBI_FIELD_NAME, MEDICARE_PLAN_TYPES, MEDICARE_PLAN_TYPE_VALUES, MEDSUP_NO_VALUE, MEDSUP_SIX_MONTHS_VALUE, MEDSUP_YES_VALUE, MESSAGE_SOURCE, MFA_CONTACT_TYPES, MILLIMAN_INITIAL, MILLIMAN_SPINNER_NAME, MapState, MapStateModel, MaritalStatusCode, MaritalStatusType, MaritalStatusValue, MarkSessionForCheckResolver, MedBenefitsType, MedSupAnswersHttpModel, MedSupAnswersPlansHttpModel, MedSupAnswersSessionModel, MedSupCheckboxModel, MedSupEmitData, MedSupFormErrorTypes, MedSupHttpService, MedSupKeyDefaults, MedSupLockConfiguration, MedSupMillimanCryptoService, MedSupPaymentMethod, MedSupPlanQuestionIds, MedSupPlanRatingMethod, MedSupQuestionHttpModel, MedSupQuestionNames, MedSupQuestionSessionModel, MedSupService, MedSupState, MedSupStateModel, MedSupUtilitiesService, MedicareGroupGuard, MedicineCabinetEntry, MedicineCabinetState, MedicineCabinetStateModel, MemberAgentNotes, MemberAgentTaskStatus, MemberCoverage, MemberEligibilitySource, MemberEnrollmentFile, MemberEnrollmentSummary, MemberLogin, MemberLoginError, MemberLoginOptions, MemberLoginSuccess, MemberLogout, MemberNotificationSource, MemberNotificationStatus, MemberNotificationType, MemberProgressEventType, MemberProgressStatus, MemberQuoteHistory, MemberSessionHttpService, MemberSessionService, MemberSourceValue, MemberState, MemberStateModel, Memoize, MemoizeObservable, MessagesService, MillimanHealthInformation, MillimanRequest, MillimanResponse, MillimanService, MillimanState, MillimanStateModel, MillimanTier, ModalEvent, ModalEventType, MonthCost, MultiFactorAuthenticationHttpService, MultiFactorAuthenticationService, MultiFactorAuthenticationStep, NEW_AGENT_EXCEPTION_DETAIL, NON_BLANK_MEDIGAP_ANSWERS, NON_MEDICARE_PLAN_TYPES, NON_MEDICARE_PLAN_TYPE_VALUES, NON_VIEW_PAGE_EVENT_PREFIXES, NOTICE_TYPE, NO_DRUGS_COUNT, NO_PLANS_COUNT, NavigationContext, NavigationService, NavigationUtilityService, NewPatientToggleValues, NextGenCompleteEnrollmentRequest, NextGenEnrollmentAgent, NextGenEnrollmentConfigurations, NextGenEnrollmentFormTransaction, NextGenEnrollmentMedigapAnswers, NextGenEnrollmentRequest, NextGenEnrollmentSEPReasons, NextGenEnrollmentSession, NextGenEnrollmentSettings, NextGenEnrollmentSite, NextGenMedSupLockConfiguration, NextGenTransactionExternalEnrollmentData, NoteActionType, NoteActionTypeName, Notice, NoticeMessage, NumberOfPharmacies, OUTSIDE_LICENSED_AREA, OperatorType, Organization, PASS_PARAMS_DATE_INPUT_FORMAT, PASS_PARAMS_DATE_INPUT_REGEX, PASS_PARAMS_DATE_OUTPUT_FORMAT, PAYMENT_METHOD_RATE_FACTOR_IDENTIFIER, PINAuthenticationInfo, PINNED_LABEL_CATEGORIES, PLANS_WITH_ALTERNATIVE_DRUGS, PLAN_ABBREVIATION_TYPE_MAP, PLAN_DIFFERENCES, PLATFORM_OVERRIDES_KEY, PREDEFINED_PERMISSION_PLAN, PREFERENCES_STORE_NAME, PREPOPULATED_READONLY_CUSTOM_CLASS, PRE_PROCESS_PROP_KEY, PROFILE_STORE_NAME, PROVIDER_ENABLED_TYPES, PageInfo, PageLevelValidatorType, PageTags, PassParameterInputType, PassParameterService, PassParameterUtilities, PassParams, PasswordResetEmailService, PasswordResetHttpService, PasswordResetService, PasswordResetUserType, PersonalizedBenefitsInfo, PersonalizedVideoService, PharmacyFilterKeyAnalyticsName, PharmacyFilterKeyType, PharmacyHttpService, PharmacyInfo, PharmacyMap, PharmacyService, PharmacyState, PharmacyTabType, PharmacyType$1 as PharmacyType, PhoneNumberType, PhoneUtilityService, Plan, PlanAnswersHttpModel, PlanBenefitFilter, PlanBenefitValueType, PlanBenefitsTableItem, PlanCompareApiParams, PlanCompareApiService, PlanCompareLabels, PlanComparePreferenceStyleOptions, PlanCompareService, PlanCompareStyleOptions, PlanConditionDetails, PlanCountsMap, PlanDataKeys, PlanDetailsCostEquation, PlanDetailsCostLabels, PlanDetailsTabIdentifier, PlanDetailsTabs, PlanEnrollmentSetting, PlanErrorMessage, PlanExtraDataKey, PlanExtraDataRatingType, PlanFetchOptions, PlanFilterAbbreviation, PlanHRAType, PlanHRAUserType, PlanLabelCategory, PlanPharmacyNetworkKeywords, PlanPreferenceLabels, PlanQuestionHttpModel, PlanQuestionSessionModel, PlanQueuePosition, PlanRiderTypeConflictContextService, PlanSNPCategoryItem, PlanShort, PlanSmartFilter, PlanSmartFilterGroup, PlanSmartReports, PlanSmartSort, PlanSmartSortFields, PlanSmartStatus, PlanSource, PlanStatus, PlanSubTypes, PlanType, PlanTypeAbbreviation, PlanTypeMetadata, PlanTypeMetadataMap, PlanTypeOptions, PlanTypePlanCountMap, PlanYearContextService, PlanYearInterceptor, PlanYearResourceNames, PlanYearResourceService, PlanYearService, PlanYearType, PlansDemographicsOptions, PlansHttpResponse, PlansHttpService, PlansMiscOptions, PlansSearchOptions, PlansService, PlansShortHttpResponse, PlansState, PlansStateModel, PlansUtilityService, PlatformType, PreferenceBannerSectionType, PreferenceBenefit, PreferenceBenefits, PreferenceCoverageType, PreferenceDirection, PreferenceIdWithType, PreferenceQuestion, PreferenceQuestionItem, PreferenceQuestionOption, PreferenceQuestionPage, PreferenceSectionFormKey, PreferenceSelectAmount, PreferenceType, PreferenceViewType, PreferencesAnswer, PreferencesContextService, PreferencesEnrollmentItem, PreferencesEnrollmentItems, PreferencesEnrollmentRequest, PreferencesEnrollmentRequestItem, PreferencesEnrollmentSection, PreferencesFieldFormKey, PreferencesHttpService, PreferencesJson, PreferencesQuestionLocationStatus, PreferencesService, PreferencesState, PreferencesStateModel, PrimaryCareProvider, PrimaryCareProviderToggleValues, ProductType, ProfileContextService, ProfileCryptoService, ProfileDisplayValue, ProfileService, ProfileState, ProfileStateModel, PropertyType, ProviderFilterKeyType, ProviderHttpResponse, ProviderHttpService, ProviderLocationStatus, ProviderNpi, ProviderRequestBody, ProviderService, ProviderState, ProviderStateModel, ProviderUtilityService, ProvidersLinkType, QUOTER_ADMIN_ROLES, QUOTER_BASIC_ROLES, QUOTER_NON_ADMIN_ROLES, QUOTER_ROLES, QUOTE_DEFAULTS, QUOTE_TYPES_FROM_SEND_TO_BENEFICIARY_FLOW, QuestionMetaDataModel, Quote, QuoteBeneficiaryState, QuoteExtraData, QuoteHttpRequest, QuoteHttpResponse, QuotePlanPermission, QuotePlanRequestData, QuoteService, QuoteSessionService, QuoteStateModel, QuoteType, QuoteUtilityService, QuoteVideoData, QuotedPlanInfo, RECORDING_AVAILABLE_FORM_ANSWER, RateFactorsStatus, RateFactorsUtilityService, RegexPattern, RemoveActiveRateFactorPlanId, RemoveAllPlansFromCompareGroup, RemoveCoverageType, RemoveDrugFromBlueButtonMedicineCabinet, RemoveDrugFromMedicineCabinet, RemoveDrugFromMemberState, RemoveFilterGroups, RemovePharmacy, RemovePlan, RemovePlanFromCompareGroup, RemovePlanFromCompareGroups, RemovePlanFromQuoteGroup, RemovePlanFromQuoteGroups, RemovePlans, RemovePrimaryCareProvider, RemoveProvider, RemoveRider, RemoveRiders, ResetActiveEnrollmentKey, ResetAgentSellingPermissions, ResetAgentState, ResetAgentSubscriptionInfo, ResetBeneficiaryQuoteDetails, ResetBlueButtonMedicineCabinet, ResetCabinetUpdatedStatus, ResetConfirmationState, ResetCrossSellEnrollmentTypes, ResetDemographicState, ResetEnrollmentState, ResetHRAAPINativeTransactionID, ResetHashRequestType, ResetHelpfulTools, ResetMedSupState, ResetMedicineCabinet, ResetMemberState, ResetMillimanState, ResetOptimalZoom, ResetPharmacy, ResetPlanSmart, ResetPlanTypes, ResetPlanYearState, ResetPlansState, ResetPreferences, ResetPreferencesUpdatedStatus, ResetProfileState, ResetProvider, ResetProviderSearchLoaded, ResetProvidersDetails, ResetQuoteState, ResetSOAState, ResetSelectedPharmacies, ResetSelectedPlanSmartDetails, ResetShoppingCartState, ResetTotalCostEffectiveDate, ResetType, ResourceHttpService, ResponsiveLayout, ResponsiveLayoutService, RetireFloStatus, RetrieveMemberLoginTokenModel, RiderBuckets, RiderCategory, RiderCompatibility, RiderSubTypes, RidersService, RouteAuthorizationService, RouteOptionsService, RoutesUtilityService, RuntimeState, SEPGroup, SEPReason, SESSION_RESET, SET_SHARED_RESOURCES, SET_SITE_TYPE, SIGN_AND_SUBMIT_QUOTE_TYPES, SINGLE_AGENCY_PERMISSIONS, SNPBaseType, SNPService, SNPSubType, SNPTypeOptions, SNP_BASE_VALUES, SNP_CATEGORY_FILTER_TYPES, SOAActivityType, SOAFormPage, SOAHttpService, SOAService, SOAState, SOATransactionEventType, SOAUserType, SOAUtilityService, SOA_COVERAGE_TYPE_EVENTS, SSOAuthenticationInfo, SSODeliveryMethod, SSOHttpService, SSOPopulatedField, SSOPopulatedFieldService, SSOService, SSOSessionResponse, STANDALONE_FORM_TRANSACTION_ID, STARTED_BY_AGENT_PARTIAL_SOA_ACTIVITY_TYPES, STARTED_BY_AGENT_SOA_ACTIVITY_TYPES, SaveAndUpdateMemberDosage, SaveGIReasons, SaveSearchedMemberData, ScriptResourceService, SectionHeaderType, SelectFIPS, SelectLiveEditState, SelectMedSupQuestions, SelectPlan, SelectPlanDetails, SelectPlanQuestions, SelectPlanWithBundle, SelectRider, SelectSubsidyPercent, SelectSubsidySelected, SelectZipAndFIPS, SelectZipCode, SelectedAgentGuid, SelectedFilterTag, SelectedProvider, SelectedProviderIds, SendAppVia, SendEnrollmentService, SendQuoteVia, SendSOAForm, SendSOAResult, SessionExternalEnrollment, SetASPFilterGroup, SetActiveEnrollmentKey, SetActivePlanDetailsTab, SetActiveRateFactorPlanId, SetActiveTab, SetActiveTabPrescription, SetActiveTabTotalCost, SetAgeRange, SetAgentContext, SetAgentData, SetAgentEmailAddress, SetAgentError, SetAgentLoading, SetAgentNotes, SetAgentOfRecordLoading, SetAgentPhoneNumber, SetAllSNPTypesVisibility, SetAppConfigLoaded, SetAppConfigLoading, SetBeneficiaryAgent, SetBeneficiaryPlanIds, SetBeneficiaryQuoteDetails, SetBlueButtonCabinetLoading, SetCSNPVisibility, SetCallRecordingAvailable, SetCompareGroup, SetConfig, SetConfirmationDataLoading, SetConfirmationVisited, SetContactInfoConfig, SetCountiesAndZipSelection, SetCoverageType, SetCoveredPreferences, SetCrossSellEnrollmentTypes, SetCurrentFormVersionId, SetCurrentPlanShort, SetCurrentTab, SetDSNPVisibility, SetDeepLinkingParams, SetDefaultApplicationState, SetDefaultTab, SetDemographicLoading, SetDisplayQuoteLabel, SetDrugsToMedicineCabinet, SetEnrollmentHistorySelectedPlan, SetEnrollmentQuote, SetFavoriteBenefits, SetFilterGroup, SetFipsCode, SetFormLoading, SetFormPagesDirty, SetHasValidCompletedSOA, SetHealthCostEstimate, SetHealthStatus, SetISNPVisibility, SetIsCostByEffectiveDate, SetIsOptimalZoomEnabled, SetIsProviderSearchLoaded, SetLocation, SetMapCenter, SetMarkSessionForCheck, SetMedSupLoading, SetMedicalCostInputs, SetMedicareGroupPlanConfiguration, SetMemberLoading, SetMemberProgressInfo, SetMemberSearch, SetMillimanApplicantId, SetMillimanAuthorizationFields, SetMillimanLoading, SetMillimanTier, SetNextGenFormLoaded, SetNextGenFormLoading, SetNextGenSOAFormLoaded, SetNextGenSOAFormLoading, SetOptimalZoom, SetOriginalAppId, SetPCAPICustomPlanPremium, SetPageComplete, SetPageSkipped, SetPageVisited, SetPartAEffectiveDate, SetPartBEffectiveDate, SetPharmacies, SetPlan, SetPlanComparePlanType, SetPlanCounts, SetPlanScores, SetPlanShortLoading, SetPlanSmartReports, SetPlanYearPermissionError, SetPlansDirty, SetPlansFetched, SetPlansLoading, SetPreferences, SetPrescriptionError, SetPrescriptionSuccess, SetPreviousFormVersionId, SetProviders, SetProvidersDetails, SetPurlAgentUsername, SetQuoteGroup, SetQuotePlanIds, SetQuoteVideoURL, SetRetireFloStatus, SetSOALoading, SetSelectedPharmacy, SetSelectedPlanSmartDetails, SetSelectedPlanYear, SetSelectedProvider, SetSelectedProviders, SetShoppingCartLoading, SetSiteId, SetSortGroup, SetSourceSiteId, SetTalkingPoints, SetTotalEstimatedCostAnnually, SetVisibleSNPTypes, SetVisited, SetZipCode, SharedResourceService, SharedResourcesResolver, ShoppingCartHttpService, ShoppingCartService, ShoppingCartState, ShoppingRecordingContextService, ShortUrlHttpRequest, ShortUrlHttpResponse, SiteAccess, SiteService, SiteState, SiteStateModel, SiteType, SiteTypeResolver, SmartVXEventData, SmartVXEventType, Sort, SortGroup, SortLabels, SortOption, SortPrimaryKey, SortService, SortType, SortUtilities, SpinnerEvent, SpinnerService, StandaloneEnrollmentSettings, StandaloneFormService, StandaloneFormTransactionResolver, StateAbbreviation, StateAndZipValidator, StaticFilterLabel, StoreResourceService, StoringData, StringFormatUtilityService, StripeConstant, StripeSessionStatus, SubscriptionDuration, SubscriptionDurationLabel, SubscriptionMetaData, SubsidyInformation, SubsidySelected, SupplementalBenefitsService, TIMEOUT_ERROR, TalkingPointPageType, TargetType, TextMessageHttpRequest, TextMessageHttpResponse, ThemeStyle, TobaccoUse, TotalSiteCounts, TwilioDeviceService, TwilioState, UTMParameter, UTMValue, UTM_PARAMETER_KEYS, UiState, UiStateModel, UndefinedAgentGuid, UnsavedModalContext, UpdateActivePharmacyTab, UpdateAgent, UpdateAgentAgencies, UpdateAgentGuid, UpdateAgentOfRecord, UpdateAgentProfilePicture, UpdateAgentSellingPermissions, UpdateAgentSellingPermissionsLoaded, UpdateAncillaryPlanAnswers, UpdateAncillaryPlanQuestions, UpdateBlueButtonCabinetClaimStatus, UpdateCMSApprovalCode, UpdateCartSession, UpdateConsumerSiteUrls, UpdateCurrentPlanPharmacies, UpdateCurrentPlans, UpdateDemographicSession, UpdateDemographics, UpdateDigitalPharmacies, UpdateEnrollmentSettings, UpdateFilterGroupFilters, UpdateFirstPlanInCompareGroup, UpdateFirstPlanInQuoteGroup, UpdateHRAAPINativeTransactionID, UpdateHRAParentInfo, UpdateHopeSOATransactionAnswers, UpdateHopeSelectedFormType, UpdateHopeUserFormType, UpdateHospitalIndemnityPlanAnswers, UpdateHospitalIndemnityPlanQuestions, UpdateIsMailOrderSelected, UpdateMedSupAnswers, UpdateMedSupQuestions, UpdateMedSupSession, UpdateMedicineCabinetEntry, UpdateMedigapAnswers, UpdateMedigapAnswersSession, UpdateMemberAgentNote, UpdateMemberEnrollments, UpdateMemberSearchEntries, UpdateMilliman, UpdateMillimanHealthInformation, UpdateMillimanServiceCalledBefore, UpdateMillimanServiceCalledNow, UpdateMillimanServiceUWFlag, UpdateNextGenSOATransactionAnswers, UpdateNextGenSelectedFormType, UpdateNextGenTransaction, UpdateNextGenUserFormType, UpdateNonLicensedPlanSetting, UpdatePUFPlanSetting, UpdatePharmacies, UpdatePlan, UpdatePlanPharmacies, UpdatePlanShortData, UpdatePlanSmartSort, UpdatePlanTypeDataMap, UpdatePlanWithBundle, UpdatePlans, UpdatePlansQueuePosition, UpdatePlansRiderBenefitCategories, UpdatePlatformResource, UpdateProfile, UpdateProfileEncryptedHICN, UpdateProfileIsArchived, UpdateProfileSession, UpdateResource, UpdateSOAState, UpdateSOATransactionAnswers, UpdateSelectedFormType, UpdateSelectedPlanSubType, UpdateSelectedProviders, UpdateSession, UpdateShoppingCartAPIModel, UpdateShoppingCartPlanPremium, UpdateSortGroup, UpdateTotalCostEffectiveDate, UpdateTransaction, UpdateUserFormType, UserPreferences, UserTypeKeys, UserTypeSettings, UserTypes, UtilityFunctionService, VBCAttestation, VBCAttestationPayload, VBCProvider, VBCProviders, VBCRequestPayload, VBCVideoPayload, VBCVideoResponse, VBC_ORG, VISION_COMBO_PLANS, VISION_PLANS, VISION_RIDERS, VNEXT_MODAL_DECLARATIONS, VNEXT_MODAL_ENTRY_COMPONENTS, VNEXT_MODAL_EXPORTS, VNextCustomCacheService, ValidateAgentResponse, ValidateMemberLogin, ValidationType, ValueProviderType, VerificationService, VerificationStep, VnextFormControl, VnextFormGroup, VnextSharedModule, VoiceSignatureSection, VoiceSignatureStatement, WIDGET_VALIDATE_METHOD, WeglotService, WidgetValidationGuard, WidgetValidationService, WordType, ZIP_AND_FIPS_QUESTION_NAMES, ZipCodeService, cSNPTypes, iSNPTypes, widgetCanValidate };
